module.exports = /******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/
  var installedModules = {};
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/
    module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/
  __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/
  __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/
  __webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/
  __webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/
    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/
  __webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/
    if (mode & 8) return value;
    /******/
    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/
    var ns = Object.create(null);
    /******/
    __webpack_require__.r(ns);
    /******/
    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/
    if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    /******/
    return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/
  __webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ? /******/function getDefault() {
      return module['default'];
    } : /******/function getModuleExports() {
      return module;
    };
    /******/
    __webpack_require__.d(getter, 'a', getter);
    /******/
    return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/
  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/
  __webpack_require__.p = "";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/
  return __webpack_require__(__webpack_require__.s = 538);
  /******/
}
/************************************************************************/
/******/([/* 0 */
/***/function (module, exports) {
  module.exports = require("prop-types");

  /***/
}, /* 1 */
/***/function (module, exports) {
  module.exports = require("react");

  /***/
}, /* 2 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "z", function () {
    return (/* reexport */raf
    );
  });
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return (/* binding */FluidValue
    );
  });
  __webpack_require__.d(__webpack_exports__, "b", function () {
    return (/* binding */react_spring_shared_esm_globals
    );
  });
  __webpack_require__.d(__webpack_exports__, "c", function () {
    return (/* binding */addFluidObserver
    );
  });
  __webpack_require__.d(__webpack_exports__, "d", function () {
    return (/* binding */callFluidObservers
    );
  });
  __webpack_require__.d(__webpack_exports__, "e", function () {
    return (/* binding */colors
    );
  });
  __webpack_require__.d(__webpack_exports__, "f", function () {
    return (/* binding */createInterpolator
    );
  });
  __webpack_require__.d(__webpack_exports__, "g", function () {
    return (/* binding */createStringInterpolator
    );
  });
  __webpack_require__.d(__webpack_exports__, "h", function () {
    return (/* binding */defineHidden
    );
  });
  __webpack_require__.d(__webpack_exports__, "i", function () {
    return (/* binding */deprecateDirectCall
    );
  });
  __webpack_require__.d(__webpack_exports__, "j", function () {
    return (/* binding */deprecateInterpolate
    );
  });
  __webpack_require__.d(__webpack_exports__, "k", function () {
    return (/* binding */each
    );
  });
  __webpack_require__.d(__webpack_exports__, "l", function () {
    return (/* binding */eachProp
    );
  });
  __webpack_require__.d(__webpack_exports__, "m", function () {
    return (/* binding */easings
    );
  });
  __webpack_require__.d(__webpack_exports__, "n", function () {
    return (/* binding */flush
    );
  });
  __webpack_require__.d(__webpack_exports__, "o", function () {
    return (/* binding */flushCalls
    );
  });
  __webpack_require__.d(__webpack_exports__, "p", function () {
    return (/* binding */frameLoop
    );
  });
  __webpack_require__.d(__webpack_exports__, "q", function () {
    return (/* binding */getFluidObservers
    );
  });
  __webpack_require__.d(__webpack_exports__, "r", function () {
    return (/* binding */getFluidValue
    );
  });
  __webpack_require__.d(__webpack_exports__, "s", function () {
    return (/* binding */hasFluidValue
    );
  });
  __webpack_require__.d(__webpack_exports__, "t", function () {
    return (/* binding */is
    );
  });
  __webpack_require__.d(__webpack_exports__, "u", function () {
    return (/* binding */isAnimatedString
    );
  });
  __webpack_require__.d(__webpack_exports__, "v", function () {
    return (/* binding */isEqual
    );
  });
  __webpack_require__.d(__webpack_exports__, "w", function () {
    return (/* binding */noop
    );
  });
  __webpack_require__.d(__webpack_exports__, "x", function () {
    return (/* binding */onResize
    );
  });
  __webpack_require__.d(__webpack_exports__, "y", function () {
    return (/* binding */onScroll
    );
  });
  __webpack_require__.d(__webpack_exports__, "A", function () {
    return (/* binding */removeFluidObserver
    );
  });
  __webpack_require__.d(__webpack_exports__, "B", function () {
    return (/* binding */toArray
    );
  });
  __webpack_require__.d(__webpack_exports__, "C", function () {
    return (/* binding */useConstant
    );
  });
  __webpack_require__.d(__webpack_exports__, "D", function () {
    return (/* binding */useForceUpdate
    );
  });
  __webpack_require__.d(__webpack_exports__, "E", function () {
    return (/* binding */useIsomorphicLayoutEffect
    );
  });
  __webpack_require__.d(__webpack_exports__, "F", function () {
    return (/* binding */useMemoOne
    );
  });
  __webpack_require__.d(__webpack_exports__, "G", function () {
    return (/* binding */useOnce
    );
  });
  __webpack_require__.d(__webpack_exports__, "H", function () {
    return (/* binding */usePrev
    );
  });
  __webpack_require__.d(__webpack_exports__, "I", function () {
    return (/* binding */useReducedMotion
    );
  });

  // UNUSED EXPORTS: callFluidObserver, clamp, colorToRgba, hex3, hex4, hex6, hex8, hsl, hsla, isSSR, once, prefix, rgb, rgba, setFluidGetter

  // CONCATENATED MODULE: ./node_modules/@react-spring/rafz/dist/react-spring-rafz.esm.js
  let updateQueue = makeQueue();
  const raf = fn => schedule(fn, updateQueue);
  let writeQueue = makeQueue();
  raf.write = fn => schedule(fn, writeQueue);
  let onStartQueue = makeQueue();
  raf.onStart = fn => schedule(fn, onStartQueue);
  let onFrameQueue = makeQueue();
  raf.onFrame = fn => schedule(fn, onFrameQueue);
  let onFinishQueue = makeQueue();
  raf.onFinish = fn => schedule(fn, onFinishQueue);
  let timeouts = [];
  raf.setTimeout = (handler, ms) => {
    let time = raf.now() + ms;
    let cancel = () => {
      let i = timeouts.findIndex(t => t.cancel == cancel);
      if (~i) timeouts.splice(i, 1);
      pendingCount -= ~i ? 1 : 0;
    };
    let timeout = {
      time,
      handler,
      cancel
    };
    timeouts.splice(findTimeout(time), 0, timeout);
    pendingCount += 1;
    start();
    return timeout;
  };
  let findTimeout = time => ~(~timeouts.findIndex(t => t.time > time) || ~timeouts.length);
  raf.cancel = fn => {
    onStartQueue.delete(fn);
    onFrameQueue.delete(fn);
    onFinishQueue.delete(fn);
    updateQueue.delete(fn);
    writeQueue.delete(fn);
  };
  raf.sync = fn => {
    sync = true;
    raf.batchedUpdates(fn);
    sync = false;
  };
  raf.throttle = fn => {
    let lastArgs;
    function queuedFn() {
      try {
        fn(...lastArgs);
      } finally {
        lastArgs = null;
      }
    }
    function throttled(...args) {
      lastArgs = args;
      raf.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = () => {
      onStartQueue.delete(queuedFn);
      lastArgs = null;
    };
    return throttled;
  };
  let nativeRaf = typeof window != 'undefined' ? window.requestAnimationFrame : () => {};
  raf.use = impl => nativeRaf = impl;
  raf.now = typeof performance != 'undefined' ? () => performance.now() : Date.now;
  raf.batchedUpdates = fn => fn();
  raf.catch = console.error;
  raf.frameLoop = 'always';
  raf.advance = () => {
    if (raf.frameLoop !== 'demand') {
      console.warn('Cannot call the manual advancement of rafz whilst frameLoop is not set as demand');
    } else {
      react_spring_rafz_esm_update();
    }
  };
  let ts = -1;
  let pendingCount = 0;
  let sync = false;
  function schedule(fn, queue) {
    if (sync) {
      queue.delete(fn);
      fn(0);
    } else {
      queue.add(fn);
      start();
    }
  }
  function start() {
    if (ts < 0) {
      ts = 0;
      if (raf.frameLoop !== 'demand') {
        nativeRaf(loop);
      }
    }
  }
  function stop() {
    ts = -1;
  }
  function loop() {
    if (~ts) {
      nativeRaf(loop);
      raf.batchedUpdates(react_spring_rafz_esm_update);
    }
  }
  function react_spring_rafz_esm_update() {
    let prevTs = ts;
    ts = raf.now();
    let count = findTimeout(ts);
    if (count) {
      eachSafely(timeouts.splice(0, count), t => t.handler());
      pendingCount -= count;
    }
    if (!pendingCount) {
      stop();
      return;
    }
    onStartQueue.flush();
    updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
    onFrameQueue.flush();
    writeQueue.flush();
    onFinishQueue.flush();
  }
  function makeQueue() {
    let next = new Set();
    let current = next;
    return {
      add(fn) {
        pendingCount += current == next && !next.has(fn) ? 1 : 0;
        next.add(fn);
      },
      delete(fn) {
        pendingCount -= current == next && next.has(fn) ? 1 : 0;
        return next.delete(fn);
      },
      flush(arg) {
        if (current.size) {
          next = new Set();
          pendingCount -= current.size;
          eachSafely(current, fn => fn(arg) && next.add(fn));
          pendingCount += next.size;
          current = next;
        }
      }
    };
  }
  function eachSafely(values, each) {
    values.forEach(value => {
      try {
        each(value);
      } catch (e) {
        raf.catch(e);
      }
    });
  }
  const __raf = {
    count() {
      return pendingCount;
    },
    isRunning() {
      return ts >= 0;
    },
    clear() {
      ts = -1;
      timeouts = [];
      onStartQueue = makeQueue();
      updateQueue = makeQueue();
      onFrameQueue = makeQueue();
      writeQueue = makeQueue();
      onFinishQueue = makeQueue();
      pendingCount = 0;
    }
  };

  // EXTERNAL MODULE: external "react"
  var external_react_ = __webpack_require__(1);

  // CONCATENATED MODULE: ./node_modules/@react-spring/shared/dist/react-spring-shared.esm.js

  function noop() {}
  const defineHidden = (obj, key, value) => Object.defineProperty(obj, key, {
    value,
    writable: true,
    configurable: true
  });
  const is = {
    arr: Array.isArray,
    obj: a => !!a && a.constructor.name === 'Object',
    fun: a => typeof a === 'function',
    str: a => typeof a === 'string',
    num: a => typeof a === 'number',
    und: a => a === undefined
  };
  function isEqual(a, b) {
    if (is.arr(a)) {
      if (!is.arr(b) || a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    }
    return a === b;
  }
  const each = (obj, fn) => obj.forEach(fn);
  function eachProp(obj, fn, ctx) {
    if (is.arr(obj)) {
      for (let i = 0; i < obj.length; i++) {
        fn.call(ctx, obj[i], `${i}`);
      }
      return;
    }
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        fn.call(ctx, obj[key], key);
      }
    }
  }
  const toArray = a => is.und(a) ? [] : is.arr(a) ? a : [a];
  function flush(queue, iterator) {
    if (queue.size) {
      const items = Array.from(queue);
      queue.clear();
      each(items, iterator);
    }
  }
  const flushCalls = (queue, ...args) => flush(queue, fn => fn(...args));
  const isSSR = () => typeof window === 'undefined' || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
  let createStringInterpolator$1;
  let to;
  let colors$1 = null;
  let skipAnimation = false;
  let willAdvance = noop;
  const react_spring_shared_esm_assign = globals => {
    if (globals.to) to = globals.to;
    if (globals.now) raf.now = globals.now;
    if (globals.colors !== undefined) colors$1 = globals.colors;
    if (globals.skipAnimation != null) skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) createStringInterpolator$1 = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) raf.use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) raf.batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) willAdvance = globals.willAdvance;
    if (globals.frameLoop) raf.frameLoop = globals.frameLoop;
  };
  var react_spring_shared_esm_globals = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get createStringInterpolator() {
      return createStringInterpolator$1;
    },
    get to() {
      return to;
    },
    get colors() {
      return colors$1;
    },
    get skipAnimation() {
      return skipAnimation;
    },
    get willAdvance() {
      return willAdvance;
    },
    assign: react_spring_shared_esm_assign
  });
  const startQueue = new Set();
  let currentFrame = [];
  let prevFrame = [];
  let priority = 0;
  const frameLoop = {
    get idle() {
      return !startQueue.size && !currentFrame.length;
    },
    start(animation) {
      if (priority > animation.priority) {
        startQueue.add(animation);
        raf.onStart(flushStartQueue);
      } else {
        startSafely(animation);
        raf(advance);
      }
    },
    advance,
    sort(animation) {
      if (priority) {
        raf.onFrame(() => frameLoop.sort(animation));
      } else {
        const prevIndex = currentFrame.indexOf(animation);
        if (~prevIndex) {
          currentFrame.splice(prevIndex, 1);
          startUnsafely(animation);
        }
      }
    },
    clear() {
      currentFrame = [];
      startQueue.clear();
    }
  };
  function flushStartQueue() {
    startQueue.forEach(startSafely);
    startQueue.clear();
    raf(advance);
  }
  function startSafely(animation) {
    if (!currentFrame.includes(animation)) startUnsafely(animation);
  }
  function startUnsafely(animation) {
    currentFrame.splice(findIndex(currentFrame, other => other.priority > animation.priority), 0, animation);
  }
  function advance(dt) {
    const nextFrame = prevFrame;
    for (let i = 0; i < currentFrame.length; i++) {
      const animation = currentFrame[i];
      priority = animation.priority;
      if (!animation.idle) {
        willAdvance(animation);
        animation.advance(dt);
        if (!animation.idle) {
          nextFrame.push(animation);
        }
      }
    }
    priority = 0;
    prevFrame = currentFrame;
    prevFrame.length = 0;
    currentFrame = nextFrame;
    return currentFrame.length > 0;
  }
  function findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
  }
  const clamp = (min, max, v) => Math.min(Math.max(v, min), max);
  const colors = {
    transparent: 0x00000000,
    aliceblue: 0xf0f8ffff,
    antiquewhite: 0xfaebd7ff,
    aqua: 0x00ffffff,
    aquamarine: 0x7fffd4ff,
    azure: 0xf0ffffff,
    beige: 0xf5f5dcff,
    bisque: 0xffe4c4ff,
    black: 0x000000ff,
    blanchedalmond: 0xffebcdff,
    blue: 0x0000ffff,
    blueviolet: 0x8a2be2ff,
    brown: 0xa52a2aff,
    burlywood: 0xdeb887ff,
    burntsienna: 0xea7e5dff,
    cadetblue: 0x5f9ea0ff,
    chartreuse: 0x7fff00ff,
    chocolate: 0xd2691eff,
    coral: 0xff7f50ff,
    cornflowerblue: 0x6495edff,
    cornsilk: 0xfff8dcff,
    crimson: 0xdc143cff,
    cyan: 0x00ffffff,
    darkblue: 0x00008bff,
    darkcyan: 0x008b8bff,
    darkgoldenrod: 0xb8860bff,
    darkgray: 0xa9a9a9ff,
    darkgreen: 0x006400ff,
    darkgrey: 0xa9a9a9ff,
    darkkhaki: 0xbdb76bff,
    darkmagenta: 0x8b008bff,
    darkolivegreen: 0x556b2fff,
    darkorange: 0xff8c00ff,
    darkorchid: 0x9932ccff,
    darkred: 0x8b0000ff,
    darksalmon: 0xe9967aff,
    darkseagreen: 0x8fbc8fff,
    darkslateblue: 0x483d8bff,
    darkslategray: 0x2f4f4fff,
    darkslategrey: 0x2f4f4fff,
    darkturquoise: 0x00ced1ff,
    darkviolet: 0x9400d3ff,
    deeppink: 0xff1493ff,
    deepskyblue: 0x00bfffff,
    dimgray: 0x696969ff,
    dimgrey: 0x696969ff,
    dodgerblue: 0x1e90ffff,
    firebrick: 0xb22222ff,
    floralwhite: 0xfffaf0ff,
    forestgreen: 0x228b22ff,
    fuchsia: 0xff00ffff,
    gainsboro: 0xdcdcdcff,
    ghostwhite: 0xf8f8ffff,
    gold: 0xffd700ff,
    goldenrod: 0xdaa520ff,
    gray: 0x808080ff,
    green: 0x008000ff,
    greenyellow: 0xadff2fff,
    grey: 0x808080ff,
    honeydew: 0xf0fff0ff,
    hotpink: 0xff69b4ff,
    indianred: 0xcd5c5cff,
    indigo: 0x4b0082ff,
    ivory: 0xfffff0ff,
    khaki: 0xf0e68cff,
    lavender: 0xe6e6faff,
    lavenderblush: 0xfff0f5ff,
    lawngreen: 0x7cfc00ff,
    lemonchiffon: 0xfffacdff,
    lightblue: 0xadd8e6ff,
    lightcoral: 0xf08080ff,
    lightcyan: 0xe0ffffff,
    lightgoldenrodyellow: 0xfafad2ff,
    lightgray: 0xd3d3d3ff,
    lightgreen: 0x90ee90ff,
    lightgrey: 0xd3d3d3ff,
    lightpink: 0xffb6c1ff,
    lightsalmon: 0xffa07aff,
    lightseagreen: 0x20b2aaff,
    lightskyblue: 0x87cefaff,
    lightslategray: 0x778899ff,
    lightslategrey: 0x778899ff,
    lightsteelblue: 0xb0c4deff,
    lightyellow: 0xffffe0ff,
    lime: 0x00ff00ff,
    limegreen: 0x32cd32ff,
    linen: 0xfaf0e6ff,
    magenta: 0xff00ffff,
    maroon: 0x800000ff,
    mediumaquamarine: 0x66cdaaff,
    mediumblue: 0x0000cdff,
    mediumorchid: 0xba55d3ff,
    mediumpurple: 0x9370dbff,
    mediumseagreen: 0x3cb371ff,
    mediumslateblue: 0x7b68eeff,
    mediumspringgreen: 0x00fa9aff,
    mediumturquoise: 0x48d1ccff,
    mediumvioletred: 0xc71585ff,
    midnightblue: 0x191970ff,
    mintcream: 0xf5fffaff,
    mistyrose: 0xffe4e1ff,
    moccasin: 0xffe4b5ff,
    navajowhite: 0xffdeadff,
    navy: 0x000080ff,
    oldlace: 0xfdf5e6ff,
    olive: 0x808000ff,
    olivedrab: 0x6b8e23ff,
    orange: 0xffa500ff,
    orangered: 0xff4500ff,
    orchid: 0xda70d6ff,
    palegoldenrod: 0xeee8aaff,
    palegreen: 0x98fb98ff,
    paleturquoise: 0xafeeeeff,
    palevioletred: 0xdb7093ff,
    papayawhip: 0xffefd5ff,
    peachpuff: 0xffdab9ff,
    peru: 0xcd853fff,
    pink: 0xffc0cbff,
    plum: 0xdda0ddff,
    powderblue: 0xb0e0e6ff,
    purple: 0x800080ff,
    rebeccapurple: 0x663399ff,
    red: 0xff0000ff,
    rosybrown: 0xbc8f8fff,
    royalblue: 0x4169e1ff,
    saddlebrown: 0x8b4513ff,
    salmon: 0xfa8072ff,
    sandybrown: 0xf4a460ff,
    seagreen: 0x2e8b57ff,
    seashell: 0xfff5eeff,
    sienna: 0xa0522dff,
    silver: 0xc0c0c0ff,
    skyblue: 0x87ceebff,
    slateblue: 0x6a5acdff,
    slategray: 0x708090ff,
    slategrey: 0x708090ff,
    snow: 0xfffafaff,
    springgreen: 0x00ff7fff,
    steelblue: 0x4682b4ff,
    tan: 0xd2b48cff,
    teal: 0x008080ff,
    thistle: 0xd8bfd8ff,
    tomato: 0xff6347ff,
    turquoise: 0x40e0d0ff,
    violet: 0xee82eeff,
    wheat: 0xf5deb3ff,
    white: 0xffffffff,
    whitesmoke: 0xf5f5f5ff,
    yellow: 0xffff00ff,
    yellowgreen: 0x9acd32ff
  };
  const NUMBER = '[-+]?\\d*\\.?\\d+';
  const PERCENTAGE = NUMBER + '%';
  function call(...parts) {
    return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
  }
  const rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
  const rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
  const hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
  const hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
  const hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
  const hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
  const hex6 = /^#([0-9a-fA-F]{6})$/;
  const hex8 = /^#([0-9a-fA-F]{8})$/;
  function normalizeColor(color) {
    let match;
    if (typeof color === 'number') {
      return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
    }
    if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
    if (colors$1 && colors$1[color] !== undefined) {
      return colors$1[color];
    }
    if (match = rgb.exec(color)) {
      return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | 0x000000ff) >>> 0;
    }
    if (match = rgba.exec(color)) {
      return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | parse1(match[4])) >>> 0;
    }
    if (match = hex3.exec(color)) {
      return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + 'ff', 16) >>> 0;
    }
    if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = hex4.exec(color)) {
      return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
    }
    if (match = hsl.exec(color)) {
      return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | 0x000000ff) >>> 0;
    }
    if (match = hsla.exec(color)) {
      return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | parse1(match[4])) >>> 0;
    }
    return null;
  }
  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }
  function hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = hue2rgb(p, q, h + 1 / 3);
    const g = hue2rgb(p, q, h);
    const b = hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
  }
  function parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
  }
  function parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
  }
  function parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
  }
  function parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
  }
  function colorToRgba(input) {
    let int32Color = normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    let r = (int32Color & 0xff000000) >>> 24;
    let g = (int32Color & 0x00ff0000) >>> 16;
    let b = (int32Color & 0x0000ff00) >>> 8;
    let a = (int32Color & 0x000000ff) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
  const createInterpolator = (range, output, extrapolate) => {
    if (is.fun(range)) {
      return range;
    }
    if (is.arr(range)) {
      return createInterpolator({
        range,
        output: output,
        extrapolate
      });
    }
    if (is.str(range.output[0])) {
      return createStringInterpolator$1(range);
    }
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [0, 1];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
    const extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';
    const easing = config.easing || (t => t);
    return input => {
      const range = findRange(input, inputRange);
      return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
  };
  function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
      if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
    }
    if (result > inputMax) {
      if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
    return result;
  }
  function findRange(input, inputRange) {
    for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;
    return i - 1;
  }
  const steps = (steps, direction = 'end') => progress => {
    progress = direction === 'end' ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
    const expanded = progress * steps;
    const rounded = direction === 'end' ? Math.floor(expanded) : Math.ceil(expanded);
    return clamp(0, 1, rounded / steps);
  };
  const c1 = 1.70158;
  const c2 = c1 * 1.525;
  const c3 = c1 + 1;
  const c4 = 2 * Math.PI / 3;
  const c5 = 2 * Math.PI / 4.5;
  const bounceOut = x => {
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) {
      return n1 * x * x;
    } else if (x < 2 / d1) {
      return n1 * (x -= 1.5 / d1) * x + 0.75;
    } else if (x < 2.5 / d1) {
      return n1 * (x -= 2.25 / d1) * x + 0.9375;
    } else {
      return n1 * (x -= 2.625 / d1) * x + 0.984375;
    }
  };
  const easings = {
    linear: x => x,
    easeInQuad: x => x * x,
    easeOutQuad: x => 1 - (1 - x) * (1 - x),
    easeInOutQuad: x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: x => x * x * x,
    easeOutCubic: x => 1 - Math.pow(1 - x, 3),
    easeInOutCubic: x => x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: x => x * x * x * x,
    easeOutQuart: x => 1 - Math.pow(1 - x, 4),
    easeInOutQuart: x => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: x => x * x * x * x * x,
    easeOutQuint: x => 1 - Math.pow(1 - x, 5),
    easeInOutQuint: x => x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: x => 1 - Math.cos(x * Math.PI / 2),
    easeOutSine: x => Math.sin(x * Math.PI / 2),
    easeInOutSine: x => -(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: x => x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: x => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: x => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: x => 1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: x => Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: x => x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: x => c3 * x * x * x - c1 * x * x,
    easeOutBack: x => 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2),
    easeInOutBack: x => x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2,
    easeInElastic: x => x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4),
    easeOutElastic: x => x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1,
    easeInOutElastic: x => x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1,
    easeInBounce: x => 1 - bounceOut(1 - x),
    easeOutBounce: bounceOut,
    easeInOutBounce: x => x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2,
    steps
  };
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  const $get = Symbol.for('FluidValue.get');
  const $observers = Symbol.for('FluidValue.observers');
  const hasFluidValue = arg => Boolean(arg && arg[$get]);
  const getFluidValue = arg => arg && arg[$get] ? arg[$get]() : arg;
  const getFluidObservers = target => target[$observers] || null;
  function callFluidObserver(observer, event) {
    if (observer.eventObserved) {
      observer.eventObserved(event);
    } else {
      observer(event);
    }
  }
  function callFluidObservers(target, event) {
    let observers = target[$observers];
    if (observers) {
      observers.forEach(observer => {
        callFluidObserver(observer, event);
      });
    }
  }
  class FluidValue {
    constructor(get) {
      this[$get] = void 0;
      this[$observers] = void 0;
      if (!get && !(get = this.get)) {
        throw Error('Unknown getter');
      }
      setFluidGetter(this, get);
    }
  }
  const setFluidGetter = (target, get) => setHidden(target, $get, get);
  function addFluidObserver(target, observer) {
    if (target[$get]) {
      let observers = target[$observers];
      if (!observers) {
        setHidden(target, $observers, observers = new Set());
      }
      if (!observers.has(observer)) {
        observers.add(observer);
        if (target.observerAdded) {
          target.observerAdded(observers.size, observer);
        }
      }
    }
    return observer;
  }
  function removeFluidObserver(target, observer) {
    let observers = target[$observers];
    if (observers && observers.has(observer)) {
      const count = observers.size - 1;
      if (count) {
        observers.delete(observer);
      } else {
        target[$observers] = null;
      }
      if (target.observerRemoved) {
        target.observerRemoved(count, observer);
      }
    }
  }
  const setHidden = (target, key, value) => Object.defineProperty(target, key, {
    value,
    writable: true,
    configurable: true
  });
  const numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
  const colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
  const unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, 'i');
  const rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
  const cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
  const variableToRgba = input => {
    const [token, fallback] = parseCSSVariable(input);
    if (!token || isSSR()) {
      return input;
    }
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) {
      return value.trim();
    } else if (fallback && fallback.startsWith('--')) {
      const _value = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
      if (_value) {
        return _value;
      } else {
        return input;
      }
    } else if (fallback && cssVariableRegex.test(fallback)) {
      return variableToRgba(fallback);
    } else if (fallback) {
      return fallback;
    }
    return input;
  };
  const parseCSSVariable = current => {
    const match = cssVariableRegex.exec(current);
    if (!match) return [,];
    const [, token, fallback] = match;
    return [token, fallback];
  };
  let namedColorRegex;
  const rgbaRound = (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
  const createStringInterpolator = config => {
    if (!namedColorRegex) namedColorRegex = colors$1 ? new RegExp(`(${Object.keys(colors$1).join('|')})(?!\\w)`, 'g') : /^\b$/;
    const output = config.output.map(value => {
      return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
    });
    const keyframes = output.map(value => value.match(numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i) => keyframes.map(values => {
      if (!(i in values)) {
        throw Error('The arity of each "output" value must be equal');
      }
      return values[i];
    }));
    const interpolators = outputRanges.map(output => createInterpolator(_extends({}, config, {
      output
    })));
    return input => {
      var _output$find;
      const missingUnit = !unitRegex.test(output[0]) && ((_output$find = output.find(value => unitRegex.test(value))) == null ? void 0 : _output$find.replace(numberRegex, ''));
      let i = 0;
      return output[0].replace(numberRegex, () => `${interpolators[i++](input)}${missingUnit || ''}`).replace(rgbaRegex, rgbaRound);
    };
  };
  const prefix = 'react-spring: ';
  const once = fn => {
    const func = fn;
    let called = false;
    if (typeof func != 'function') {
      throw new TypeError(`${prefix}once requires a function parameter`);
    }
    return (...args) => {
      if (!called) {
        func(...args);
        called = true;
      }
    };
  };
  const warnInterpolate = once(console.warn);
  function deprecateInterpolate() {
    warnInterpolate(`${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`);
  }
  const warnDirectCall = once(console.warn);
  function deprecateDirectCall() {
    warnDirectCall(`${prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
  }
  function isAnimatedString(value) {
    return is.str(value) && (value[0] == '#' || /\d/.test(value) || !isSSR() && cssVariableRegex.test(value) || value in (colors$1 || {}));
  }
  let observer;
  const resizeHandlers = new WeakMap();
  const handleObservation = entries => entries.forEach(({
    target,
    contentRect
  }) => {
    var _resizeHandlers$get;
    return (_resizeHandlers$get = resizeHandlers.get(target)) == null ? void 0 : _resizeHandlers$get.forEach(handler => handler(contentRect));
  });
  function resizeElement(handler, target) {
    if (!observer) {
      if (typeof ResizeObserver !== 'undefined') {
        observer = new ResizeObserver(handleObservation);
      }
    }
    let elementHandlers = resizeHandlers.get(target);
    if (!elementHandlers) {
      elementHandlers = new Set();
      resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if (observer) {
      observer.observe(target);
    }
    return () => {
      const elementHandlers = resizeHandlers.get(target);
      if (!elementHandlers) return;
      elementHandlers.delete(handler);
      if (!elementHandlers.size && observer) {
        observer.unobserve(target);
      }
    };
  }
  const listeners = new Set();
  let cleanupWindowResizeHandler;
  const createResizeHandler = () => {
    const handleResize = () => {
      listeners.forEach(callback => callback({
        width: window.innerWidth,
        height: window.innerHeight
      }));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  };
  const resizeWindow = callback => {
    listeners.add(callback);
    if (!cleanupWindowResizeHandler) {
      cleanupWindowResizeHandler = createResizeHandler();
    }
    return () => {
      listeners.delete(callback);
      if (!listeners.size && cleanupWindowResizeHandler) {
        cleanupWindowResizeHandler();
        cleanupWindowResizeHandler = undefined;
      }
    };
  };
  const onResize = (callback, {
    container: _container = document.documentElement
  } = {}) => {
    if (_container === document.documentElement) {
      return resizeWindow(callback);
    } else {
      return resizeElement(callback, _container);
    }
  };
  const progress = (min, max, value) => max - min === 0 ? 1 : (value - min) / (max - min);
  const SCROLL_KEYS = {
    x: {
      length: 'Width',
      position: 'Left'
    },
    y: {
      length: 'Height',
      position: 'Top'
    }
  };
  class ScrollHandler {
    constructor(callback, container) {
      this.callback = void 0;
      this.container = void 0;
      this.info = void 0;
      this.createAxis = () => ({
        current: 0,
        progress: 0,
        scrollLength: 0
      });
      this.updateAxis = axisName => {
        const axis = this.info[axisName];
        const {
          length,
          position
        } = SCROLL_KEYS[axisName];
        axis.current = this.container[`scroll${position}`];
        axis.scrollLength = this.container['scroll' + length] - this.container['client' + length];
        axis.progress = progress(0, axis.scrollLength, axis.current);
      };
      this.update = () => {
        this.updateAxis('x');
        this.updateAxis('y');
      };
      this.sendEvent = () => {
        this.callback(this.info);
      };
      this.advance = () => {
        this.update();
        this.sendEvent();
      };
      this.callback = callback;
      this.container = container;
      this.info = {
        time: 0,
        x: this.createAxis(),
        y: this.createAxis()
      };
    }
  }
  const scrollListeners = new WeakMap();
  const resizeListeners = new WeakMap();
  const onScrollHandlers = new WeakMap();
  const getTarget = container => container === document.documentElement ? window : container;
  const onScroll = (callback, {
    container: _container = document.documentElement
  } = {}) => {
    let containerHandlers = onScrollHandlers.get(_container);
    if (!containerHandlers) {
      containerHandlers = new Set();
      onScrollHandlers.set(_container, containerHandlers);
    }
    const containerHandler = new ScrollHandler(callback, _container);
    containerHandlers.add(containerHandler);
    if (!scrollListeners.has(_container)) {
      const listener = () => {
        var _containerHandlers;
        (_containerHandlers = containerHandlers) == null ? void 0 : _containerHandlers.forEach(handler => handler.advance());
        return true;
      };
      scrollListeners.set(_container, listener);
      const target = getTarget(_container);
      window.addEventListener('resize', listener, {
        passive: true
      });
      if (_container !== document.documentElement) {
        resizeListeners.set(_container, onResize(listener, {
          container: _container
        }));
      }
      target.addEventListener('scroll', listener, {
        passive: true
      });
    }
    const animateScroll = scrollListeners.get(_container);
    raf(animateScroll);
    return () => {
      raf.cancel(animateScroll);
      const containerHandlers = onScrollHandlers.get(_container);
      if (!containerHandlers) return;
      containerHandlers.delete(containerHandler);
      if (containerHandlers.size) return;
      const listener = scrollListeners.get(_container);
      scrollListeners.delete(_container);
      if (listener) {
        var _resizeListeners$get;
        getTarget(_container).removeEventListener('scroll', listener);
        window.removeEventListener('resize', listener);
        (_resizeListeners$get = resizeListeners.get(_container)) == null ? void 0 : _resizeListeners$get();
      }
    };
  };
  function useConstant(init) {
    const ref = Object(external_react_["useRef"])(null);
    if (ref.current === null) {
      ref.current = init();
    }
    return ref.current;
  }
  const useIsomorphicLayoutEffect = isSSR() ? external_react_["useEffect"] : external_react_["useLayoutEffect"];
  const useIsMounted = () => {
    const isMounted = Object(external_react_["useRef"])(false);
    useIsomorphicLayoutEffect(() => {
      isMounted.current = true;
      return () => {
        isMounted.current = false;
      };
    }, []);
    return isMounted;
  };
  function useForceUpdate() {
    const update = Object(external_react_["useState"])()[1];
    const isMounted = useIsMounted();
    return () => {
      if (isMounted.current) {
        update(Math.random());
      }
    };
  }
  function useMemoOne(getResult, inputs) {
    const [initial] = Object(external_react_["useState"])(() => ({
      inputs,
      result: getResult()
    }));
    const committed = Object(external_react_["useRef"])();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
      const useCache = Boolean(inputs && cache.inputs && areInputsEqual(inputs, cache.inputs));
      if (!useCache) {
        cache = {
          inputs,
          result: getResult()
        };
      }
    } else {
      cache = initial;
    }
    Object(external_react_["useEffect"])(() => {
      committed.current = cache;
      if (prevCache == initial) {
        initial.inputs = initial.result = undefined;
      }
    }, [cache]);
    return cache.result;
  }
  function areInputsEqual(next, prev) {
    if (next.length !== prev.length) {
      return false;
    }
    for (let i = 0; i < next.length; i++) {
      if (next[i] !== prev[i]) {
        return false;
      }
    }
    return true;
  }
  const useOnce = effect => Object(external_react_["useEffect"])(effect, emptyDeps);
  const emptyDeps = [];
  function usePrev(value) {
    const prevRef = Object(external_react_["useRef"])();
    Object(external_react_["useEffect"])(() => {
      prevRef.current = value;
    });
    return prevRef.current;
  }
  const useReducedMotion = () => {
    const [reducedMotion, setReducedMotion] = Object(external_react_["useState"])(null);
    useIsomorphicLayoutEffect(() => {
      const mql = window.matchMedia('(prefers-reduced-motion)');
      const handleMediaChange = e => {
        setReducedMotion(e.matches);
        react_spring_shared_esm_assign({
          skipAnimation: e.matches
        });
      };
      handleMediaChange(mql);
      mql.addEventListener('change', handleMediaChange);
      return () => {
        mql.removeEventListener('change', handleMediaChange);
      };
    }, []);
    return reducedMotion;
  };

  /***/
}, /* 3 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return (/* reexport */CacheProvider
    );
  });
  __webpack_require__.d(__webpack_exports__, "b", function () {
    return (/* binding */ClassNames
    );
  });
  __webpack_require__.d(__webpack_exports__, "c", function () {
    return (/* binding */core_browser_esm_jsx
    );
  });
  __webpack_require__.d(__webpack_exports__, "d", function () {
    return (/* binding */core_browser_esm_keyframes
    );
  });

  // UNUSED EXPORTS: ThemeContext, withEmotionCache, css, Global, createElement

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
  var setPrototypeOf = __webpack_require__(51);

  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    Object(setPrototypeOf["a" /* default */])(subClass, superClass);
  }
  // EXTERNAL MODULE: external "react"
  var external_react_ = __webpack_require__(1);

  // EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/cache.browser.esm.js + 2 modules
  var cache_browser_esm = __webpack_require__(41);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/inheritsLoose.js
  var inheritsLoose = __webpack_require__(45);

  // CONCATENATED MODULE: ./node_modules/@emotion/utils/dist/utils.browser.esm.js
  var isBrowser = "object" !== 'undefined';
  function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (registered[className] !== undefined) {
        registeredStyles.push(registered[className]);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }
  var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false ||
    // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
      cache.registered[className] = serialized.styles;
    }
    if (cache.inserted[serialized.name] === undefined) {
      var current = serialized;
      do {
        var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
        current = current.next;
      } while (current !== undefined);
    }
  };

  // EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/serialize.browser.esm.js + 3 modules
  var serialize_browser_esm = __webpack_require__(32);

  // CONCATENATED MODULE: ./node_modules/@emotion/core/dist/emotion-element-04d85134.browser.esm.js

  var emotion_element_04d85134_browser_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
  var EmotionCacheContext = /*#__PURE__*/Object(external_react_["createContext"])(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== 'undefined' ? Object(cache_browser_esm["a" /* default */])() : null);
  var ThemeContext = /*#__PURE__*/Object(external_react_["createContext"])({});
  var CacheProvider = EmotionCacheContext.Provider;
  var emotion_element_04d85134_browser_esm_withEmotionCache = function withEmotionCache(func) {
    var render = function render(props, ref) {
      return /*#__PURE__*/Object(external_react_["createElement"])(EmotionCacheContext.Consumer, null, function (cache) {
        return func(props, cache, ref);
      });
    }; // $FlowFixMe

    return /*#__PURE__*/Object(external_react_["forwardRef"])(render);
  };

  // thus we only need to replace what is a valid character for JS, but not for CSS

  var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
  };
  var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
  var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
  var createEmotionProps = function createEmotionProps(type, props) {
    if (false) {}
    var newProps = {};
    for (var key in props) {
      if (emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, key)) {
        newProps[key] = props[key];
      }
    }
    newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

    if (false) {
      var match, error;
    }
    return newProps;
  };
  var Noop = function Noop() {
    return null;
  };
  var emotion_element_04d85134_browser_esm_render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible

    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
      cssProp = cache.registered[cssProp];
    }
    var type = props[typePropName];
    var registeredStyles = [cssProp];
    var className = '';
    if (typeof props.className === 'string') {
      className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
    } else if (props.className != null) {
      className = props.className + " ";
    }
    var serialized = Object(serialize_browser_esm["a" /* serializeStyles */])(registeredStyles);
    if (false) {
      var labelFromStack;
    }
    var rules = insertStyles(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for (var key in props) {
      if (emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (true || false)) {
        newProps[key] = props[key];
      }
    }
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/Object(external_react_["createElement"])(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/Object(external_react_["createElement"])(Noop, null);
    return /*#__PURE__*/Object(external_react_["createElement"])(external_react_["Fragment"], null, possiblyStyleElement, ele);
  }; // eslint-disable-next-line no-undef

  var Emotion = /* #__PURE__ */emotion_element_04d85134_browser_esm_withEmotionCache(function (props, cache, ref) {
    if (typeof props.css === 'function') {
      return /*#__PURE__*/Object(external_react_["createElement"])(ThemeContext.Consumer, null, function (theme) {
        return emotion_element_04d85134_browser_esm_render(cache, props, theme, ref);
      });
    }
    return emotion_element_04d85134_browser_esm_render(cache, props, null, ref);
  });
  if (false) {}

  // EXTERNAL MODULE: ./node_modules/@emotion/sheet/dist/sheet.browser.esm.js
  var sheet_browser_esm = __webpack_require__(52);

  // EXTERNAL MODULE: ./node_modules/@emotion/css/dist/css.browser.esm.js
  var css_browser_esm = __webpack_require__(20);

  // CONCATENATED MODULE: ./node_modules/@emotion/core/dist/core.browser.esm.js

  var core_browser_esm_jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, 'css')) {
      // $FlowFixMe
      return external_react_["createElement"].apply(undefined, args);
    }
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = Emotion;
    createElementArgArray[1] = createEmotionProps(type, props);
    for (var i = 2; i < argsLength; i++) {
      createElementArgArray[i] = args[i];
    } // $FlowFixMe

    return external_react_["createElement"].apply(null, createElementArgArray);
  };
  var warnedAboutCssPropForGlobal = false;
  var Global = /* #__PURE__ */emotion_element_04d85134_browser_esm_withEmotionCache(function (props, cache) {
    if (false) {}
    var styles = props.styles;
    if (typeof styles === 'function') {
      return /*#__PURE__*/Object(external_react_["createElement"])(ThemeContext.Consumer, null, function (theme) {
        var serialized = Object(serialize_browser_esm["a" /* serializeStyles */])([styles(theme)]);
        return /*#__PURE__*/Object(external_react_["createElement"])(core_browser_esm_InnerGlobal, {
          serialized: serialized,
          cache: cache
        });
      });
    }
    var serialized = Object(serialize_browser_esm["a" /* serializeStyles */])([styles]);
    return /*#__PURE__*/Object(external_react_["createElement"])(core_browser_esm_InnerGlobal, {
      serialized: serialized,
      cache: cache
    });
  });

  // maintain place over rerenders.
  // initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
  // initial client-side render from SSR, use place of hydrating tag
  var core_browser_esm_InnerGlobal = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
      return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
      this.sheet = new sheet_browser_esm["a" /* StyleSheet */]({
        key: this.props.cache.key + "-global",
        nonce: this.props.cache.sheet.nonce,
        container: this.props.cache.sheet.container
      }); // $FlowFixMe

      var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
      if (node !== null) {
        this.sheet.tags.push(node);
      }
      if (this.props.cache.sheet.tags.length) {
        this.sheet.before = this.props.cache.sheet.tags[0];
      }
      this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (prevProps.serialized.name !== this.props.serialized.name) {
        this.insertStyles();
      }
    };
    _proto.insertStyles = function insertStyles$1() {
      if (this.props.serialized.next !== undefined) {
        // insert keyframes
        insertStyles(this.props.cache, this.props.serialized.next, true);
      }
      if (this.sheet.tags.length) {
        // if this doesn't exist then it will be null so the style element will be appended
        var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
        this.sheet.before = element;
        this.sheet.flush();
      }
      this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.sheet.flush();
    };
    _proto.render = function render() {
      return null;
    };
    return InnerGlobal;
  }(external_react_["Component"]);
  var core_browser_esm_keyframes = function keyframes() {
    var insertable = css_browser_esm["a" /* default */].apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe

    return {
      name: name,
      styles: "@keyframes " + name + "{" + insertable.styles + "}",
      anim: 1,
      toString: function toString() {
        return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
      }
    };
  };
  var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for (; i < len; i++) {
      var arg = args[i];
      if (arg == null) continue;
      var toAdd = void 0;
      switch (typeof arg) {
        case 'boolean':
          break;
        case 'object':
          {
            if (Array.isArray(arg)) {
              toAdd = classnames(arg);
            } else {
              toAdd = '';
              for (var k in arg) {
                if (arg[k] && k) {
                  toAdd && (toAdd += ' ');
                  toAdd += k;
                }
              }
            }
            break;
          }
        default:
          {
            toAdd = arg;
          }
      }
      if (toAdd) {
        cls && (cls += ' ');
        cls += toAdd;
      }
    }
    return cls;
  };
  function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
    if (registeredStyles.length < 2) {
      return className;
    }
    return rawClassName + css(registeredStyles);
  }
  var core_browser_esm_Noop = function Noop() {
    return null;
  };
  var ClassNames = emotion_element_04d85134_browser_esm_withEmotionCache(function (props, context) {
    return /*#__PURE__*/Object(external_react_["createElement"])(ThemeContext.Consumer, null, function (theme) {
      var hasRendered = false;
      var css = function css() {
        if (hasRendered && "production" !== 'production') {
          throw new Error('css can only be used during render');
        }
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var serialized = Object(serialize_browser_esm["a" /* serializeStyles */])(args, context.registered);
        {
          insertStyles(context, serialized, false);
        }
        return context.key + "-" + serialized.name;
      };
      var cx = function cx() {
        if (hasRendered && "production" !== 'production') {
          throw new Error('cx can only be used during render');
        }
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return merge(context.registered, css, classnames(args));
      };
      var content = {
        css: css,
        cx: cx,
        theme: theme
      };
      var ele = props.children(content);
      hasRendered = true;
      var possiblyStyleElement = /*#__PURE__*/Object(external_react_["createElement"])(core_browser_esm_Noop, null);
      return /*#__PURE__*/Object(external_react_["createElement"])(external_react_["Fragment"], null, possiblyStyleElement, ele);
    });
  });

  /***/
}, /* 4 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _extends;
  });
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }

  /***/
}, /* 5 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return (/* binding */isDocumentElement
    );
  });
  __webpack_require__.d(__webpack_exports__, "b", function () {
    return (/* binding */exportedEqual
    );
  });
  __webpack_require__.d(__webpack_exports__, "c", function () {
    return (/* binding */index_75b02bac_browser_esm_cleanValue
    );
  });
  __webpack_require__.d(__webpack_exports__, "d", function () {
    return (/* binding */scrollIntoView
    );
  });
  __webpack_require__.d(__webpack_exports__, "e", function () {
    return (/* binding */noop
    );
  });
  __webpack_require__.d(__webpack_exports__, "f", function () {
    return (/* binding */index_75b02bac_browser_esm_components
    );
  });
  __webpack_require__.d(__webpack_exports__, "g", function () {
    return (/* binding */handleInputChange
    );
  });
  __webpack_require__.d(__webpack_exports__, "h", function () {
    return (/* binding */index_75b02bac_browser_esm_MenuPlacer
    );
  });
  __webpack_require__.d(__webpack_exports__, "i", function () {
    return (/* binding */containerCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "j", function () {
    return (/* binding */index_75b02bac_browser_esm_css
    );
  });
  __webpack_require__.d(__webpack_exports__, "k", function () {
    return (/* binding */clearIndicatorCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "l", function () {
    return (/* binding */dropdownIndicatorCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "m", function () {
    return (/* binding */groupHeadingCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "n", function () {
    return (/* binding */indicatorSeparatorCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "o", function () {
    return (/* binding */groupCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "p", function () {
    return (/* binding */inputCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "q", function () {
    return (/* binding */indicatorsContainerCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "r", function () {
    return (/* binding */loadingMessageCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "s", function () {
    return (/* binding */menuListCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "t", function () {
    return (/* binding */loadingIndicatorCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "u", function () {
    return (/* binding */index_75b02bac_browser_esm_menuCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "v", function () {
    return (/* binding */menuPortalCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "w", function () {
    return (/* binding */multiValueCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "x", function () {
    return (/* binding */multiValueLabelCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "y", function () {
    return (/* binding */multiValueRemoveCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "z", function () {
    return (/* binding */noOptionsMessageCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "A", function () {
    return (/* binding */optionCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "B", function () {
    return (/* binding */placeholderCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "C", function () {
    return (/* binding */css$1
    );
  });
  __webpack_require__.d(__webpack_exports__, "D", function () {
    return (/* binding */valueContainerCSS
    );
  });
  __webpack_require__.d(__webpack_exports__, "E", function () {
    return (/* binding */isTouchCapable
    );
  });
  __webpack_require__.d(__webpack_exports__, "F", function () {
    return (/* binding */isMobileDevice
    );
  });
  __webpack_require__.d(__webpack_exports__, "G", function () {
    return (/* binding */defaultComponents
    );
  });
  __webpack_require__.d(__webpack_exports__, "H", function () {
    return (/* binding */classNames
    );
  });

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
  var objectWithoutProperties = __webpack_require__(22);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
  var esm_extends = __webpack_require__(4);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
  var defineProperty = __webpack_require__(10);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
  var classCallCheck = __webpack_require__(12);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
  var createClass = __webpack_require__(13);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
  var inherits = __webpack_require__(14);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
  var possibleConstructorReturn = __webpack_require__(16);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
  var getPrototypeOf = __webpack_require__(9);

  // EXTERNAL MODULE: external "react"
  var external_react_ = __webpack_require__(1);

  // EXTERNAL MODULE: ./node_modules/@emotion/core/dist/core.browser.esm.js + 3 modules
  var core_browser_esm = __webpack_require__(3);

  // EXTERNAL MODULE: external "react-dom"
  var external_react_dom_ = __webpack_require__(15);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
  var esm_typeof = __webpack_require__(25);

  // EXTERNAL MODULE: ./node_modules/@emotion/css/dist/css.browser.esm.js
  var css_browser_esm = __webpack_require__(20);

  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }
  // EXTERNAL MODULE: ./node_modules/react-select/node_modules/react-input-autosize/lib/AutosizeInput.js
  var AutosizeInput = __webpack_require__(38);
  var AutosizeInput_default = /*#__PURE__*/__webpack_require__.n(AutosizeInput);

  // CONCATENATED MODULE: ./node_modules/react-select/dist/index-75b02bac.browser.esm.js

  // ==============================
  // NO OP
  // ==============================
  var noop = function noop() {};
  // Class Name Prefixer
  // ==============================

  /**
   String representation of component state for styling with class names.
  
   Expects an array of strings OR a string/object pair:
   - className(['comp', 'comp-arg', 'comp-arg-2'])
     @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
   - className('comp', { some: true, state: false })
     @returns 'react-select__comp react-select__comp--some'
  */

  function applyPrefixToName(prefix, name) {
    if (!name) {
      return prefix;
    } else if (name[0] === '-') {
      return prefix + name;
    } else {
      return prefix + '__' + name;
    }
  }
  function classNames(prefix, state, className) {
    var arr = [className];
    if (state && prefix) {
      for (var key in state) {
        if (state.hasOwnProperty(key) && state[key]) {
          arr.push("".concat(applyPrefixToName(prefix, key)));
        }
      }
    }
    return arr.filter(function (i) {
      return i;
    }).map(function (i) {
      return String(i).trim();
    }).join(' ');
  } // ==============================
  // Clean Value
  // ==============================

  var index_75b02bac_browser_esm_cleanValue = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (Object(esm_typeof["a" /* default */])(value) === 'object' && value !== null) return [value];
    return [];
  }; // ==============================
  // Handle Input Change
  // ==============================

  function handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
      var newValue = onInputChange(inputValue, actionMeta);
      if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
  } // ==============================
  // Scroll Helpers
  // ==============================

  function isDocumentElement(el) {
    return [document.documentElement, document.body, window].indexOf(el) > -1;
  } // Normalized Scroll Top
  // ------------------------------

  function getScrollTop(el) {
    if (isDocumentElement(el)) {
      return window.pageYOffset;
    }
    return el.scrollTop;
  }
  function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
      window.scrollTo(0, top);
      return;
    }
    el.scrollTop = top;
  } // Get Scroll Parent
  // ------------------------------

  function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    var docEl = document.documentElement; // suck it, flow...

    if (style.position === 'fixed') return docEl;
    for (var parent = element; parent = parent.parentElement;) {
      style = getComputedStyle(parent);
      if (excludeStaticParent && style.position === 'static') {
        continue;
      }
      if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
        return parent;
      }
    }
    return docEl;
  } // Animated Scroll To
  // ------------------------------

  /**
    @param t: time (elapsed)
    @param b: initial value
    @param c: amount of change
    @param d: duration
  */

  function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  }
  function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
      currentTime += increment;
      var val = easeOutCubic(currentTime, start, change, duration);
      scrollTo(element, val);
      if (currentTime < duration) {
        window.requestAnimationFrame(animateScroll);
      } else {
        callback(element);
      }
    }
    animateScroll();
  } // Scroll Into View
  // ------------------------------

  function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) {
      scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    } else if (focusedRect.top - overScroll < menuRect.top) {
      scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
  } // ==============================
  // Get bounding client object
  // ==============================
  // cannot get keys using array notation with DOMRect

  function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
      bottom: rect.bottom,
      height: rect.height,
      left: rect.left,
      right: rect.right,
      top: rect.top,
      width: rect.width
    };
  }
  // Touch Capability Detector
  // ==============================

  function isTouchCapable() {
    try {
      document.createEvent('TouchEvent');
      return true;
    } catch (e) {
      return false;
    }
  } // ==============================
  // Mobile Device Detector
  // ==============================

  function isMobileDevice() {
    try {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
      return false;
    }
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          Object(defineProperty["a" /* default */])(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return Object(possibleConstructorReturn["a" /* default */])(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
      placement: 'bottom',
      maxHeight: maxHeight
    }; // something went wrong, return default state

    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered

    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;
    var viewHeight = window.innerHeight;
    var scrollTop = getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch (placement) {
      case 'auto':
      case 'bottom':
        // 1: the menu will fit, do nothing
        if (viewSpaceBelow >= menuHeight) {
          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        } // 2: the menu will fit, if scrolled

        if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollDown, scrollDuration);
          }
          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        } // 3: the menu will fit, if constrained

        if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollDown, scrollDuration);
          } // we want to provide as much of the menu as possible to the user,
          // so give them whatever is available below rather than the minHeight.

          var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
          return {
            placement: 'bottom',
            maxHeight: constrainedHeight
          };
        } // 4. Forked beviour when there isn't enough space below
        // AUTO: flip the menu, render above

        if (placement === 'auto' || isFixedPosition) {
          // may need to be constrained after flipping
          var _constrainedHeight = maxHeight;
          var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
          if (spaceAbove >= minHeight) {
            _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
          }
          return {
            placement: 'top',
            maxHeight: _constrainedHeight
          };
        } // BOTTOM: allow browser to increase scrollable area and immediately set scroll

        if (placement === 'bottom') {
          scrollTo(scrollParent, scrollDown);
          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        }
        break;
      case 'top':
        // 1: the menu will fit, do nothing
        if (viewSpaceAbove >= menuHeight) {
          return {
            placement: 'top',
            maxHeight: maxHeight
          };
        } // 2: the menu will fit, if scrolled

        if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollUp, scrollDuration);
          }
          return {
            placement: 'top',
            maxHeight: maxHeight
          };
        } // 3: the menu will fit, if constrained

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
          // so give them whatever is available below rather than the minHeight.

          if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
            _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
          }
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollUp, scrollDuration);
          }
          return {
            placement: 'top',
            maxHeight: _constrainedHeight2
          };
        } // 4. not enough space, the browser WILL NOT increase scrollable area when
        // absolutely positioned element rendered above the viewport (only below).
        // Flip the menu, render below

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      default:
        throw new Error("Invalid placement provided \"".concat(placement, "\"."));
    } // fulfil contract with flow: implicit return value of undefined

    return defaultState;
  } // Menu Component
  // ------------------------------

  function alignToControl(placement) {
    var placementToCSSProp = {
      bottom: 'top',
      top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
  }
  var coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
  };
  var index_75b02bac_browser_esm_menuCSS = function menuCSS(_ref2) {
    var _ref3;
    var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
    return _ref3 = {
      label: 'menu'
    }, Object(defineProperty["a" /* default */])(_ref3, alignToControl(placement), '100%'), Object(defineProperty["a" /* default */])(_ref3, "backgroundColor", colors.neutral0), Object(defineProperty["a" /* default */])(_ref3, "borderRadius", borderRadius), Object(defineProperty["a" /* default */])(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), Object(defineProperty["a" /* default */])(_ref3, "marginBottom", spacing.menuGutter), Object(defineProperty["a" /* default */])(_ref3, "marginTop", spacing.menuGutter), Object(defineProperty["a" /* default */])(_ref3, "position", 'absolute'), Object(defineProperty["a" /* default */])(_ref3, "width", '100%'), Object(defineProperty["a" /* default */])(_ref3, "zIndex", 1), _ref3;
  };
  var PortalPlacementContext = /*#__PURE__*/Object(external_react_["createContext"])({
    getPortalPlacement: null
  }); // NOTE: internal only

  var index_75b02bac_browser_esm_MenuPlacer = /*#__PURE__*/function (_Component) {
    Object(inherits["a" /* default */])(MenuPlacer, _Component);
    var _super = _createSuper(MenuPlacer);
    function MenuPlacer() {
      var _this;
      Object(classCallCheck["a" /* default */])(this, MenuPlacer);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        maxHeight: _this.props.maxMenuHeight,
        placement: null
      };
      _this.getPlacement = function (ref) {
        var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
        if (!ref) return; // DO NOT scroll if position is fixed

        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = getMenuPlacement({
          maxHeight: maxMenuHeight,
          menuEl: ref,
          minHeight: minMenuHeight,
          placement: menuPlacement,
          shouldScroll: shouldScroll,
          isFixedPosition: isFixedPosition,
          theme: theme
        });
        var getPortalPlacement = _this.context.getPortalPlacement;
        if (getPortalPlacement) getPortalPlacement(state);
        _this.setState(state);
      };
      _this.getUpdatedProps = function () {
        var menuPlacement = _this.props.menuPlacement;
        var placement = _this.state.placement || coercePlacement(menuPlacement);
        return _objectSpread(_objectSpread({}, _this.props), {}, {
          placement: placement,
          maxHeight: _this.state.maxHeight
        });
      };
      return _this;
    }
    Object(createClass["a" /* default */])(MenuPlacer, [{
      key: "render",
      value: function render() {
        var children = this.props.children;
        return children({
          ref: this.getPlacement,
          placerProps: this.getUpdatedProps()
        });
      }
    }]);
    return MenuPlacer;
  }(external_react_["Component"]);
  index_75b02bac_browser_esm_MenuPlacer.contextType = PortalPlacementContext;
  var index_75b02bac_browser_esm_Menu = function Menu(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({
      css: getStyles('menu', props),
      className: cx({
        menu: true
      }, className)
    }, innerProps, {
      ref: innerRef
    }), children);
  };
  // Menu List
  // ==============================

  var menuListCSS = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
    return {
      maxHeight: maxHeight,
      overflowY: 'auto',
      paddingBottom: baseUnit,
      paddingTop: baseUnit,
      position: 'relative',
      // required for offset[Height, Top] > keyboard scroll
      WebkitOverflowScrolling: 'touch'
    };
  };
  var index_75b02bac_browser_esm_MenuList = function MenuList(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({
      css: getStyles('menuList', props),
      className: cx({
        'menu-list': true,
        'menu-list--is-multi': isMulti
      }, className),
      ref: innerRef
    }, innerProps), children);
  }; // ==============================
  // Menu Notices
  // ==============================

  var noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
    return {
      color: colors.neutral40,
      padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
      textAlign: 'center'
    };
  };
  var noOptionsMessageCSS = noticeCSS;
  var loadingMessageCSS = noticeCSS;
  var index_75b02bac_browser_esm_NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({
      css: getStyles('noOptionsMessage', props),
      className: cx({
        'menu-notice': true,
        'menu-notice--no-options': true
      }, className)
    }, innerProps), children);
  };
  index_75b02bac_browser_esm_NoOptionsMessage.defaultProps = {
    children: 'No options'
  };
  var index_75b02bac_browser_esm_LoadingMessage = function LoadingMessage(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({
      css: getStyles('loadingMessage', props),
      className: cx({
        'menu-notice': true,
        'menu-notice--loading': true
      }, className)
    }, innerProps), children);
  };
  index_75b02bac_browser_esm_LoadingMessage.defaultProps = {
    children: 'Loading...'
  }; // ==============================
  // Menu Portal
  // ==============================

  var menuPortalCSS = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
    return {
      left: rect.left,
      position: position,
      top: offset,
      width: rect.width,
      zIndex: 1
    };
  };
  var index_75b02bac_browser_esm_MenuPortal = /*#__PURE__*/function (_Component2) {
    Object(inherits["a" /* default */])(MenuPortal, _Component2);
    var _super2 = _createSuper(MenuPortal);
    function MenuPortal() {
      var _this2;
      Object(classCallCheck["a" /* default */])(this, MenuPortal);
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      _this2 = _super2.call.apply(_super2, [this].concat(args));
      _this2.state = {
        placement: null
      };
      _this2.getPortalPlacement = function (_ref7) {
        var placement = _ref7.placement;
        var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

        if (placement !== initialPlacement) {
          _this2.setState({
            placement: placement
          });
        }
      };
      return _this2;
    }
    Object(createClass["a" /* default */])(MenuPortal, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
        var isFixed = position === 'fixed'; // bail early if required elements aren't present

        if (!appendTo && !isFixed || !controlElement) {
          return null;
        }
        var placement = this.state.placement || coercePlacement(menuPlacement);
        var rect = getBoundingClientObj(controlElement);
        var scrollDistance = isFixed ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        var state = {
          offset: offset,
          position: position,
          rect: rect
        }; // same wrapper element whether fixed or portalled

        var menuWrapper = Object(core_browser_esm["c" /* jsx */])("div", {
          css: getStyles('menuPortal', state)
        }, children);
        return Object(core_browser_esm["c" /* jsx */])(PortalPlacementContext.Provider, {
          value: {
            getPortalPlacement: this.getPortalPlacement
          }
        }, appendTo ? /*#__PURE__*/Object(external_react_dom_["createPortal"])(menuWrapper, appendTo) : menuWrapper);
      }
    }]);
    return MenuPortal;
  }(external_react_["Component"]);
  var isArray = Array.isArray;
  var keyList = Object.keys;
  var hasProp = Object.prototype.hasOwnProperty;
  function equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && Object(esm_typeof["a" /* default */])(a) == 'object' && Object(esm_typeof["a" /* default */])(b) == 'object') {
      var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;
      if (arrA && arrB) {
        length = a.length;
        if (length != b.length) return false;
        for (i = length; i-- !== 0;) {
          if (!equal(a[i], b[i])) return false;
        }
        return true;
      }
      if (arrA != arrB) return false;
      var dateA = a instanceof Date,
        dateB = b instanceof Date;
      if (dateA != dateB) return false;
      if (dateA && dateB) return a.getTime() == b.getTime();
      var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
      if (regexpA != regexpB) return false;
      if (regexpA && regexpB) return a.toString() == b.toString();
      var keys = keyList(a);
      length = keys.length;
      if (length !== keyList(b).length) {
        return false;
      }
      for (i = length; i-- !== 0;) {
        if (!hasProp.call(b, keys[i])) return false;
      } // end fast-deep-equal
      // Custom handling for React

      for (i = length; i-- !== 0;) {
        key = keys[i];
        if (key === '_owner' && a.$$typeof) {
          // React-specific: avoid traversing React elements' _owner.
          //  _owner contains circular references
          // and is not needed when comparing the actual elements (and not their owners)
          // .$$typeof and ._store on just reasonable markers of a react element
          continue;
        } else {
          // all other properties should be traversed as usual
          if (!equal(a[key], b[key])) return false;
        }
      } // fast-deep-equal index.js 2.0.1

      return true;
    }
    return a !== a && b !== b;
  } // end fast-deep-equal

  function exportedEqual(a, b) {
    try {
      return equal(a, b);
    } catch (error) {
      if (error.message && error.message.match(/stack|recursion/i)) {
        // warn on circular references, don't crash
        // browsers give this different errors name and messages:
        // chrome/safari: "RangeError", "Maximum call stack size exceeded"
        // firefox: "InternalError", too much recursion"
        // edge: "Error", "Out of stack space"
        console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
        return false;
      } // some other error. we should definitely know about these

      throw error;
    }
  }
  var containerCSS = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
    return {
      label: 'container',
      direction: isRtl ? 'rtl' : null,
      pointerEvents: isDisabled ? 'none' : null,
      // cancel mouse events when disabled
      position: 'relative'
    };
  };
  var index_75b02bac_browser_esm_SelectContainer = function SelectContainer(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({
      css: getStyles('container', props),
      className: cx({
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
      }, className)
    }, innerProps), children);
  }; // ==============================
  // Value Container
  // ==============================

  var valueContainerCSS = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
      WebkitOverflowScrolling: 'touch',
      position: 'relative',
      overflow: 'hidden'
    };
  };
  var index_75b02bac_browser_esm_ValueContainer = function ValueContainer(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      isMulti = props.isMulti,
      getStyles = props.getStyles,
      hasValue = props.hasValue;
    return Object(core_browser_esm["c" /* jsx */])("div", {
      css: getStyles('valueContainer', props),
      className: cx({
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
      }, className)
    }, children);
  }; // ==============================
  // Indicator Container
  // ==============================

  var indicatorsContainerCSS = function indicatorsContainerCSS() {
    return {
      alignItems: 'center',
      alignSelf: 'stretch',
      display: 'flex',
      flexShrink: 0
    };
  };
  var index_75b02bac_browser_esm_IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
    return Object(core_browser_esm["c" /* jsx */])("div", {
      css: getStyles('indicatorsContainer', props),
      className: cx({
        indicators: true
      }, className)
    }, children);
  };
  function _templateObject() {
    var data = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);
    _templateObject = function _templateObject() {
      return data;
    };
    return data;
  }
  function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  }
  var index_75b02bac_browser_esm_ref2 = true ? {
    name: "19bqh2r",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
  } : undefined;

  // ==============================
  // Dropdown & Clear Icons
  // ==============================
  var index_75b02bac_browser_esm_Svg = function Svg(_ref) {
    var size = _ref.size,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["size"]);
    return Object(core_browser_esm["c" /* jsx */])("svg", Object(esm_extends["a" /* default */])({
      height: size,
      width: size,
      viewBox: "0 0 20 20",
      "aria-hidden": "true",
      focusable: "false",
      css: index_75b02bac_browser_esm_ref2
    }, props));
  };
  var index_75b02bac_browser_esm_CrossIcon = function CrossIcon(props) {
    return Object(core_browser_esm["c" /* jsx */])(index_75b02bac_browser_esm_Svg, Object(esm_extends["a" /* default */])({
      size: 20
    }, props), Object(core_browser_esm["c" /* jsx */])("path", {
      d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
  };
  var index_75b02bac_browser_esm_DownChevron = function DownChevron(props) {
    return Object(core_browser_esm["c" /* jsx */])(index_75b02bac_browser_esm_Svg, Object(esm_extends["a" /* default */])({
      size: 20
    }, props), Object(core_browser_esm["c" /* jsx */])("path", {
      d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
  }; // ==============================
  // Dropdown & Clear Buttons
  // ==============================

  var baseCSS = function baseCSS(_ref3) {
    var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
    return {
      label: 'indicatorContainer',
      color: isFocused ? colors.neutral60 : colors.neutral20,
      display: 'flex',
      padding: baseUnit * 2,
      transition: 'color 150ms',
      ':hover': {
        color: isFocused ? colors.neutral80 : colors.neutral40
      }
    };
  };
  var dropdownIndicatorCSS = baseCSS;
  var index_75b02bac_browser_esm_DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({}, innerProps, {
      css: getStyles('dropdownIndicator', props),
      className: cx({
        indicator: true,
        'dropdown-indicator': true
      }, className)
    }), children || Object(core_browser_esm["c" /* jsx */])(index_75b02bac_browser_esm_DownChevron, null));
  };
  var clearIndicatorCSS = baseCSS;
  var index_75b02bac_browser_esm_ClearIndicator = function ClearIndicator(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({}, innerProps, {
      css: getStyles('clearIndicator', props),
      className: cx({
        indicator: true,
        'clear-indicator': true
      }, className)
    }), children || Object(core_browser_esm["c" /* jsx */])(index_75b02bac_browser_esm_CrossIcon, null));
  }; // ==============================
  // Separator
  // ==============================

  var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
    var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
    return {
      label: 'indicatorSeparator',
      alignSelf: 'stretch',
      backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
      marginBottom: baseUnit * 2,
      marginTop: baseUnit * 2,
      width: 1
    };
  };
  var index_75b02bac_browser_esm_IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("span", Object(esm_extends["a" /* default */])({}, innerProps, {
      css: getStyles('indicatorSeparator', props),
      className: cx({
        'indicator-separator': true
      }, className)
    }));
  }; // ==============================
  // Loading
  // ==============================

  var loadingDotAnimations = Object(core_browser_esm["d" /* keyframes */])(_templateObject());
  var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
    var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
    return {
      label: 'loadingIndicator',
      color: isFocused ? colors.neutral60 : colors.neutral20,
      display: 'flex',
      padding: baseUnit * 2,
      transition: 'color 150ms',
      alignSelf: 'center',
      fontSize: size,
      lineHeight: 1,
      marginRight: size,
      textAlign: 'center',
      verticalAlign: 'middle'
    };
  };
  var index_75b02bac_browser_esm_LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay,
      offset = _ref6.offset;
    return Object(core_browser_esm["c" /* jsx */])("span", {
      css: /*#__PURE__*/Object(css_browser_esm["a" /* default */])({
        animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
        backgroundColor: 'currentColor',
        borderRadius: '1em',
        display: 'inline-block',
        marginLeft: offset ? '1em' : null,
        height: '1em',
        verticalAlign: 'top',
        width: '1em'
      }, true ? "" : undefined)
    });
  };
  var index_75b02bac_browser_esm_LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({}, innerProps, {
      css: getStyles('loadingIndicator', props),
      className: cx({
        indicator: true,
        'loading-indicator': true
      }, className)
    }), Object(core_browser_esm["c" /* jsx */])(index_75b02bac_browser_esm_LoadingDot, {
      delay: 0,
      offset: isRtl
    }), Object(core_browser_esm["c" /* jsx */])(index_75b02bac_browser_esm_LoadingDot, {
      delay: 160,
      offset: true
    }), Object(core_browser_esm["c" /* jsx */])(index_75b02bac_browser_esm_LoadingDot, {
      delay: 320,
      offset: !isRtl
    }));
  };
  index_75b02bac_browser_esm_LoadingIndicator.defaultProps = {
    size: 4
  };
  var index_75b02bac_browser_esm_css = function css(_ref) {
    var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
    return {
      label: 'control',
      alignItems: 'center',
      backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
      borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
      borderRadius: borderRadius,
      borderStyle: 'solid',
      borderWidth: 1,
      boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
      cursor: 'default',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: spacing.controlHeight,
      outline: '0 !important',
      position: 'relative',
      transition: 'all 100ms',
      '&:hover': {
        borderColor: isFocused ? colors.primary : colors.neutral30
      }
    };
  };
  var index_75b02bac_browser_esm_Control = function Control(props) {
    var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({
      ref: innerRef,
      css: getStyles('control', props),
      className: cx({
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
      }, className)
    }, innerProps), children);
  };
  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys$1(Object(source), true).forEach(function (key) {
          Object(defineProperty["a" /* default */])(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var groupCSS = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
      paddingBottom: spacing.baseUnit * 2,
      paddingTop: spacing.baseUnit * 2
    };
  };
  var index_75b02bac_browser_esm_Group = function Group(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
    return Object(core_browser_esm["c" /* jsx */])("div", {
      css: getStyles('group', props),
      className: cx({
        group: true
      }, className)
    }, Object(core_browser_esm["c" /* jsx */])(Heading, Object(esm_extends["a" /* default */])({}, headingProps, {
      selectProps: selectProps,
      theme: theme,
      getStyles: getStyles,
      cx: cx
    }), label), Object(core_browser_esm["c" /* jsx */])("div", null, children));
  };
  var groupHeadingCSS = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
      label: 'group',
      color: '#999',
      cursor: 'default',
      display: 'block',
      fontSize: '75%',
      fontWeight: '500',
      marginBottom: '0.25em',
      paddingLeft: spacing.baseUnit * 3,
      paddingRight: spacing.baseUnit * 3,
      textTransform: 'uppercase'
    };
  };
  var index_75b02bac_browser_esm_GroupHeading = function GroupHeading(props) {
    var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      selectProps = props.selectProps,
      cleanProps = Object(objectWithoutProperties["a" /* default */])(props, ["className", "cx", "getStyles", "theme", "selectProps"]);
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({
      css: getStyles('groupHeading', _objectSpread$1({
        theme: theme
      }, cleanProps)),
      className: cx({
        'group-heading': true
      }, className)
    }, cleanProps));
  };
  function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys$2(Object(source), true).forEach(function (key) {
          Object(defineProperty["a" /* default */])(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$2(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var inputCSS = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
    return {
      margin: spacing.baseUnit / 2,
      paddingBottom: spacing.baseUnit / 2,
      paddingTop: spacing.baseUnit / 2,
      visibility: isDisabled ? 'hidden' : 'visible',
      color: colors.neutral80
    };
  };
  var inputStyle = function inputStyle(isHidden) {
    return {
      label: 'input',
      background: 0,
      border: 0,
      fontSize: 'inherit',
      opacity: isHidden ? 0 : 1,
      outline: 0,
      padding: 0,
      color: 'inherit'
    };
  };
  var index_75b02bac_browser_esm_Input = function Input(_ref2) {
    var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      selectProps = _ref2.selectProps,
      props = Object(objectWithoutProperties["a" /* default */])(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);
    return Object(core_browser_esm["c" /* jsx */])("div", {
      css: getStyles('input', _objectSpread$2({
        theme: theme
      }, props))
    }, Object(core_browser_esm["c" /* jsx */])(AutosizeInput_default.a, Object(esm_extends["a" /* default */])({
      className: cx({
        input: true
      }, className),
      inputRef: innerRef,
      inputStyle: inputStyle(isHidden),
      disabled: isDisabled
    }, props)));
  };
  function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys$3(Object(source), true).forEach(function (key) {
          Object(defineProperty["a" /* default */])(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$3(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var multiValueCSS = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
    return {
      label: 'multiValue',
      backgroundColor: colors.neutral10,
      borderRadius: borderRadius / 2,
      display: 'flex',
      margin: spacing.baseUnit / 2,
      minWidth: 0 // resolves flex/text-overflow bug
    };
  };

  var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
      borderRadius: borderRadius / 2,
      color: colors.neutral80,
      fontSize: '85%',
      overflow: 'hidden',
      padding: 3,
      paddingLeft: 6,
      textOverflow: cropWithEllipsis ? 'ellipsis' : null,
      whiteSpace: 'nowrap'
    };
  };
  var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
    return {
      alignItems: 'center',
      borderRadius: borderRadius / 2,
      backgroundColor: isFocused && colors.dangerLight,
      display: 'flex',
      paddingLeft: spacing.baseUnit,
      paddingRight: spacing.baseUnit,
      ':hover': {
        backgroundColor: colors.dangerLight,
        color: colors.danger
      }
    };
  };
  var index_75b02bac_browser_esm_MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children,
      innerProps = _ref4.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("div", innerProps, children);
  };
  var MultiValueContainer = index_75b02bac_browser_esm_MultiValueGeneric;
  var MultiValueLabel = index_75b02bac_browser_esm_MultiValueGeneric;
  function MultiValueRemove(_ref5) {
    var children = _ref5.children,
      innerProps = _ref5.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("div", innerProps, children || Object(core_browser_esm["c" /* jsx */])(index_75b02bac_browser_esm_CrossIcon, {
      size: 14
    }));
  }
  var index_75b02bac_browser_esm_MultiValue = function MultiValue(props) {
    var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      data = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
    var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;
    return Object(core_browser_esm["c" /* jsx */])(core_browser_esm["b" /* ClassNames */], null, function (_ref6) {
      var css = _ref6.css,
        emotionCx = _ref6.cx;
      return Object(core_browser_esm["c" /* jsx */])(Container, {
        data: data,
        innerProps: _objectSpread$3(_objectSpread$3({}, innerProps), {}, {
          className: emotionCx(css(getStyles('multiValue', props)), cx({
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
          }, className))
        }),
        selectProps: selectProps
      }, Object(core_browser_esm["c" /* jsx */])(Label, {
        data: data,
        innerProps: {
          className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
            'multi-value__label': true
          }, className))
        },
        selectProps: selectProps
      }, children), Object(core_browser_esm["c" /* jsx */])(Remove, {
        data: data,
        innerProps: _objectSpread$3({
          className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
            'multi-value__remove': true
          }, className))
        }, removeProps),
        selectProps: selectProps
      }));
    });
  };
  index_75b02bac_browser_esm_MultiValue.defaultProps = {
    cropWithEllipsis: true
  };
  var optionCSS = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
    return {
      label: 'option',
      backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
      color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
      cursor: 'default',
      display: 'block',
      fontSize: 'inherit',
      padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
      width: '100%',
      userSelect: 'none',
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
      // provide some affordance on touch devices
      ':active': {
        backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
      }
    };
  };
  var index_75b02bac_browser_esm_Option = function Option(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({
      css: getStyles('option', props),
      className: cx({
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
      }, className),
      ref: innerRef
    }, innerProps), children);
  };
  var placeholderCSS = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
    return {
      label: 'placeholder',
      color: colors.neutral50,
      marginLeft: spacing.baseUnit / 2,
      marginRight: spacing.baseUnit / 2,
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)'
    };
  };
  var index_75b02bac_browser_esm_Placeholder = function Placeholder(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({
      css: getStyles('placeholder', props),
      className: cx({
        placeholder: true
      }, className)
    }, innerProps), children);
  };
  var css$1 = function css(_ref) {
    var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
    return {
      label: 'singleValue',
      color: isDisabled ? colors.neutral40 : colors.neutral80,
      marginLeft: spacing.baseUnit / 2,
      marginRight: spacing.baseUnit / 2,
      maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
      overflow: 'hidden',
      position: 'absolute',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      top: '50%',
      transform: 'translateY(-50%)'
    };
  };
  var index_75b02bac_browser_esm_SingleValue = function SingleValue(props) {
    var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
    return Object(core_browser_esm["c" /* jsx */])("div", Object(esm_extends["a" /* default */])({
      css: getStyles('singleValue', props),
      className: cx({
        'single-value': true,
        'single-value--is-disabled': isDisabled
      }, className)
    }, innerProps), children);
  };
  function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$4(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys$4(Object(source), true).forEach(function (key) {
          Object(defineProperty["a" /* default */])(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$4(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var index_75b02bac_browser_esm_components = {
    ClearIndicator: index_75b02bac_browser_esm_ClearIndicator,
    Control: index_75b02bac_browser_esm_Control,
    DropdownIndicator: index_75b02bac_browser_esm_DropdownIndicator,
    DownChevron: index_75b02bac_browser_esm_DownChevron,
    CrossIcon: index_75b02bac_browser_esm_CrossIcon,
    Group: index_75b02bac_browser_esm_Group,
    GroupHeading: index_75b02bac_browser_esm_GroupHeading,
    IndicatorsContainer: index_75b02bac_browser_esm_IndicatorsContainer,
    IndicatorSeparator: index_75b02bac_browser_esm_IndicatorSeparator,
    Input: index_75b02bac_browser_esm_Input,
    LoadingIndicator: index_75b02bac_browser_esm_LoadingIndicator,
    Menu: index_75b02bac_browser_esm_Menu,
    MenuList: index_75b02bac_browser_esm_MenuList,
    MenuPortal: index_75b02bac_browser_esm_MenuPortal,
    LoadingMessage: index_75b02bac_browser_esm_LoadingMessage,
    NoOptionsMessage: index_75b02bac_browser_esm_NoOptionsMessage,
    MultiValue: index_75b02bac_browser_esm_MultiValue,
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    Option: index_75b02bac_browser_esm_Option,
    Placeholder: index_75b02bac_browser_esm_Placeholder,
    SelectContainer: index_75b02bac_browser_esm_SelectContainer,
    SingleValue: index_75b02bac_browser_esm_SingleValue,
    ValueContainer: index_75b02bac_browser_esm_ValueContainer
  };
  var defaultComponents = function defaultComponents(props) {
    return _objectSpread$4(_objectSpread$4({}, index_75b02bac_browser_esm_components), props.components);
  };

  /***/
}, /* 6 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                   Copyright (c) 2018 Jed Watson.
                                                                   Licensed under the MIT License (MIT), see
                                                                   http://jedwatson.github.io/classnames
                                                                   */
  /* global define */

  (function () {
    'use strict';

    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = '[native code]';
    function classNames() {
      var classes = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;
        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);
            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
            classes.push(arg.toString());
            continue;
          }
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }
      return classes.join(' ');
    }
    if (true && module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else if (true) {
      // register as 'classnames', consistent with npm package name
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        return classNames;
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
  })();

  /***/
}, /* 7 */
/***/function (module, exports) {
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 8 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = Icon;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _Icons = _interopRequireWildcard(__webpack_require__(34));
  var _excluded = ["className", "name", "iconStyle"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function Icon(props) {
    var className = props.className,
      name = props.name,
      iconStyle = props.iconStyle,
      opts = _objectWithoutProperties(props, _excluded),
      clss = ["ft-ic", className];
    if (_Icons["default"][name]) {
      clss = [].concat(clss, _Icons["default"][name]);
    } else {
      clss.push(name);
    }
    if (iconStyle) {
      clss.push(iconStyle);
      clss = clss.filter(function (v) {
        if (iconStyle === _Icons.S) {
          return !(v === _Icons.R || v === _Icons.L || v === _Icons.B || v === _Icons.D);
        }
        if (iconStyle === _Icons.R) {
          return !(v === _Icons.S || v === _Icons.L || v === _Icons.B || v === _Icons.D);
        }
        if (iconStyle === _Icons.L) {
          return !(v === _Icons.R || v === _Icons.S || v === _Icons.B || v === _Icons.D);
        }
        if (iconStyle === _Icons.B) {
          return !(v === _Icons.R || v === _Icons.S || v === _Icons.L || v === _Icons.D);
        }
        if (iconStyle === _Icons.D) {
          return !(v === _Icons.R || v === _Icons.S || v === _Icons.L || v === _Icons.B);
        }
      });
    }
    return /*#__PURE__*/_react["default"].createElement("i", _extends({}, opts, {
      className: (0, _classnames["default"])(clss)
    }));
  }
  Icon.defaultProps = {
    className: "",
    name: "",
    title: "",
    iconStyle: null
  };
  Icon.propTypes = {
    /* The Name of the Icon to use
    	This can be a mapping to `Icons.js`, or a full string to a not yet mapped FontAwesome Icon
    * */
    name: _propTypes["default"].string.isRequired,
    /* Extra custom class to include */
    className: _propTypes["default"].string,
    /* HTML title text to show */
    title: _propTypes["default"].string,
    /* Function to be called when clicked on the Icon */
    onClick: _propTypes["default"].func,
    /* One of the standard FontAwesome style types to render for the Icon with */
    iconStyle: _propTypes["default"].oneOf([_Icons.S, _Icons.R, _Icons.L, _Icons.B, _Icons.D])
  };

  /***/
}, /* 9 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _getPrototypeOf;
  });
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  /***/
}, /* 10 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _defineProperty;
  });
  /* harmony import */
  var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54);
  function _defineProperty(obj, key, value) {
    key = Object(_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"])(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }

  /***/
}, /* 11 */
/***/function (module, exports, __webpack_require__) {
  var toPropertyKey = __webpack_require__(78);
  function _defineProperty(obj, key, value) {
    key = toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 12 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _classCallCheck;
  });
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  /***/
}, /* 13 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _createClass;
  });
  /* harmony import */
  var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54);
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, Object(_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"])(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  /***/
}, /* 14 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _inherits;
  });
  /* harmony import */
  var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51);
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) Object(_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"])(subClass, superClass);
  }

  /***/
}, /* 15 */
/***/function (module, exports) {
  module.exports = require("react-dom");

  /***/
}, /* 16 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _possibleConstructorReturn;
  });
  /* harmony import */
  var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25);
  /* harmony import */
  var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42);
  function _possibleConstructorReturn(self, call) {
    if (call && (Object(_typeof_js__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"])(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return Object(_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__[/* default */"a"])(self);
  }

  /***/
}, /* 17 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  module.exports = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };

  /***/
}, /* 18 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "boundMethod", function () {
    return boundMethod;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "boundClass", function () {
    return boundClass;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "default", function () {
    return autobind;
  });
  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof(obj);
  }

  /**
   * Return a descriptor removing the value and returning a getter
   * The getter will return a .bind version of the function
   * and memoize the result against a symbol on the instance
   */
  function boundMethod(target, key, descriptor) {
    var fn = descriptor.value;
    if (typeof fn !== 'function') {
      throw new TypeError("@boundMethod decorator can only be applied to methods not: ".concat(_typeof(fn)));
    } // In IE11 calling Object.defineProperty has a side-effect of evaluating the
    // getter for the property which is being replaced. This causes infinite
    // recursion and an "Out of stack space" error.

    var definingProperty = false;
    return {
      configurable: true,
      get: function get() {
        // eslint-disable-next-line no-prototype-builtins
        if (definingProperty || this === target.prototype || this.hasOwnProperty(key) || typeof fn !== 'function') {
          return fn;
        }
        var boundFn = fn.bind(this);
        definingProperty = true;
        Object.defineProperty(this, key, {
          configurable: true,
          get: function get() {
            return boundFn;
          },
          set: function set(value) {
            fn = value;
            delete this[key];
          }
        });
        definingProperty = false;
        return boundFn;
      },
      set: function set(value) {
        fn = value;
      }
    };
  }
  /**
   * Use boundMethod to bind all methods on the target.prototype
   */

  function boundClass(target) {
    // (Using reflect to get all keys including symbols)
    var keys; // Use Reflect if exists

    if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
      keys = Reflect.ownKeys(target.prototype);
    } else {
      keys = Object.getOwnPropertyNames(target.prototype); // Use symbols if support is provided

      if (typeof Object.getOwnPropertySymbols === 'function') {
        keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
      }
    }
    keys.forEach(function (key) {
      // Ignore special case target method
      if (key === 'constructor') {
        return;
      }
      var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key); // Only methods need binding

      if (typeof descriptor.value === 'function') {
        Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
      }
    });
    return target;
  }
  function autobind() {
    if (arguments.length === 1) {
      return boundClass.apply(void 0, arguments);
    }
    return boundMethod.apply(void 0, arguments);
  }

  /***/
}, /* 19 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = MissingMedia;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function MissingMedia(_ref) {
    var message = _ref.message,
      className = _ref.className;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "preview-missing-media ".concat(className ? className : "")
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "far fa-frown"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "error-message"
    }, message));
  }
  MissingMedia.displayName = "MissingMedia";
  MissingMedia.defaultProps = {
    message: "Missing Image"
  };
  MissingMedia.propTypes = {
    message: _propTypes["default"].string
  };

  /***/
}, /* 20 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony import */
  var _emotion_serialize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32);
  function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return Object(_emotion_serialize__WEBPACK_IMPORTED_MODULE_0__[/* serializeStyles */"a"])(args);
  }

  /* harmony default export */
  __webpack_exports__["a"] = css;

  /***/
}, /* 21 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return (/* binding */Select_e1cf49ae_browser_esm_Select
    );
  });
  __webpack_require__.d(__webpack_exports__, "b", function () {
    return (/* binding */defaultTheme
    );
  });
  __webpack_require__.d(__webpack_exports__, "c", function () {
    return (/* binding */createFilter
    );
  });
  __webpack_require__.d(__webpack_exports__, "d", function () {
    return (/* binding */mergeStyles
    );
  });

  // UNUSED EXPORTS: d

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
  var objectWithoutProperties = __webpack_require__(22);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
  var esm_extends = __webpack_require__(4);

  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
  var unsupportedIterableToArray = __webpack_require__(53);

  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || Object(unsupportedIterableToArray["a" /* default */])(arr, i) || _nonIterableRest();
  }
  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
  var toConsumableArray = __webpack_require__(39);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
  var defineProperty = __webpack_require__(10);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
  var classCallCheck = __webpack_require__(12);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
  var createClass = __webpack_require__(13);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
  var assertThisInitialized = __webpack_require__(42);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
  var inherits = __webpack_require__(14);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
  var possibleConstructorReturn = __webpack_require__(16);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
  var getPrototypeOf = __webpack_require__(9);

  // EXTERNAL MODULE: external "react"
  var external_react_ = __webpack_require__(1);
  var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

  // EXTERNAL MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
  var memoize_one_esm = __webpack_require__(30);

  // EXTERNAL MODULE: ./node_modules/@emotion/core/dist/core.browser.esm.js + 3 modules
  var core_browser_esm = __webpack_require__(3);

  // EXTERNAL MODULE: external "react-dom"
  var external_react_dom_ = __webpack_require__(15);

  // EXTERNAL MODULE: ./node_modules/react-select/dist/index-75b02bac.browser.esm.js + 1 modules
  var index_75b02bac_browser_esm = __webpack_require__(5);

  // EXTERNAL MODULE: ./node_modules/@emotion/css/dist/css.browser.esm.js
  var css_browser_esm = __webpack_require__(20);

  // CONCATENATED MODULE: ./node_modules/react-select/dist/Select-e1cf49ae.browser.esm.js

  var diacritics = [{
    base: 'A',
    letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
  }, {
    base: 'AA',
    letters: "\uA732"
  }, {
    base: 'AE',
    letters: "\xC6\u01FC\u01E2"
  }, {
    base: 'AO',
    letters: "\uA734"
  }, {
    base: 'AU',
    letters: "\uA736"
  }, {
    base: 'AV',
    letters: "\uA738\uA73A"
  }, {
    base: 'AY',
    letters: "\uA73C"
  }, {
    base: 'B',
    letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
  }, {
    base: 'C',
    letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
  }, {
    base: 'D',
    letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
  }, {
    base: 'DZ',
    letters: "\u01F1\u01C4"
  }, {
    base: 'Dz',
    letters: "\u01F2\u01C5"
  }, {
    base: 'E',
    letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
  }, {
    base: 'F',
    letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
  }, {
    base: 'G',
    letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
  }, {
    base: 'H',
    letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
  }, {
    base: 'I',
    letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
  }, {
    base: 'J',
    letters: "J\u24BF\uFF2A\u0134\u0248"
  }, {
    base: 'K',
    letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
  }, {
    base: 'L',
    letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
  }, {
    base: 'LJ',
    letters: "\u01C7"
  }, {
    base: 'Lj',
    letters: "\u01C8"
  }, {
    base: 'M',
    letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
  }, {
    base: 'N',
    letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
  }, {
    base: 'NJ',
    letters: "\u01CA"
  }, {
    base: 'Nj',
    letters: "\u01CB"
  }, {
    base: 'O',
    letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
  }, {
    base: 'OI',
    letters: "\u01A2"
  }, {
    base: 'OO',
    letters: "\uA74E"
  }, {
    base: 'OU',
    letters: "\u0222"
  }, {
    base: 'P',
    letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
  }, {
    base: 'Q',
    letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
  }, {
    base: 'R',
    letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
  }, {
    base: 'S',
    letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
  }, {
    base: 'T',
    letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
  }, {
    base: 'TZ',
    letters: "\uA728"
  }, {
    base: 'U',
    letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
  }, {
    base: 'V',
    letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
  }, {
    base: 'VY',
    letters: "\uA760"
  }, {
    base: 'W',
    letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
  }, {
    base: 'X',
    letters: "X\u24CD\uFF38\u1E8A\u1E8C"
  }, {
    base: 'Y',
    letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
  }, {
    base: 'Z',
    letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
  }, {
    base: 'a',
    letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
  }, {
    base: 'aa',
    letters: "\uA733"
  }, {
    base: 'ae',
    letters: "\xE6\u01FD\u01E3"
  }, {
    base: 'ao',
    letters: "\uA735"
  }, {
    base: 'au',
    letters: "\uA737"
  }, {
    base: 'av',
    letters: "\uA739\uA73B"
  }, {
    base: 'ay',
    letters: "\uA73D"
  }, {
    base: 'b',
    letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
  }, {
    base: 'c',
    letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
  }, {
    base: 'd',
    letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
  }, {
    base: 'dz',
    letters: "\u01F3\u01C6"
  }, {
    base: 'e',
    letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
  }, {
    base: 'f',
    letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
  }, {
    base: 'g',
    letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
  }, {
    base: 'h',
    letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
  }, {
    base: 'hv',
    letters: "\u0195"
  }, {
    base: 'i',
    letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
  }, {
    base: 'j',
    letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
  }, {
    base: 'k',
    letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
  }, {
    base: 'l',
    letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
  }, {
    base: 'lj',
    letters: "\u01C9"
  }, {
    base: 'm',
    letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
  }, {
    base: 'n',
    letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
  }, {
    base: 'nj',
    letters: "\u01CC"
  }, {
    base: 'o',
    letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
  }, {
    base: 'oi',
    letters: "\u01A3"
  }, {
    base: 'ou',
    letters: "\u0223"
  }, {
    base: 'oo',
    letters: "\uA74F"
  }, {
    base: 'p',
    letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
  }, {
    base: 'q',
    letters: "q\u24E0\uFF51\u024B\uA757\uA759"
  }, {
    base: 'r',
    letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
  }, {
    base: 's',
    letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
  }, {
    base: 't',
    letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
  }, {
    base: 'tz',
    letters: "\uA729"
  }, {
    base: 'u',
    letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
  }, {
    base: 'v',
    letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
  }, {
    base: 'vy',
    letters: "\uA761"
  }, {
    base: 'w',
    letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
  }, {
    base: 'x',
    letters: "x\u24E7\uFF58\u1E8B\u1E8D"
  }, {
    base: 'y',
    letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
  }, {
    base: 'z',
    letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
  }];
  var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
    return d.letters;
  }).join('') + ']', 'g');
  var diacriticToBase = {};
  for (var Select_e1cf49ae_browser_esm_i = 0; Select_e1cf49ae_browser_esm_i < diacritics.length; Select_e1cf49ae_browser_esm_i++) {
    var diacritic = diacritics[Select_e1cf49ae_browser_esm_i];
    for (var j = 0; j < diacritic.letters.length; j++) {
      diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
  }
  var stripDiacritics = function stripDiacritics(str) {
    return str.replace(anyDiacritic, function (match) {
      return diacriticToBase[match];
    });
  };
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          Object(defineProperty["a" /* default */])(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
  };
  var defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
  };
  var createFilter = function createFilter(config) {
    return function (option, rawInput) {
      var _ignoreCase$ignoreAcc = _objectSpread({
          ignoreCase: true,
          ignoreAccents: true,
          stringify: defaultStringify,
          trim: true,
          matchFrom: 'any'
        }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;
      var input = trim ? trimString(rawInput) : rawInput;
      var candidate = trim ? trimString(stringify(option)) : stringify(option);
      if (ignoreCase) {
        input = input.toLowerCase();
        candidate = candidate.toLowerCase();
      }
      if (ignoreAccents) {
        input = stripDiacritics(input);
        candidate = stripDiacritics(candidate);
      }
      return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
  };
  function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  }
  var Select_e1cf49ae_browser_esm_ref = true ? {
    name: "1laao21-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
  } : undefined;
  var Select_e1cf49ae_browser_esm_A11yText = function A11yText(props) {
    return Object(core_browser_esm["c" /* jsx */])("span", Object(esm_extends["a" /* default */])({
      css: Select_e1cf49ae_browser_esm_ref
    }, props));
  };
  function DummyInput(_ref) {
    var inProp = _ref.in,
      out = _ref.out,
      onExited = _ref.onExited,
      appear = _ref.appear,
      enter = _ref.enter,
      exit = _ref.exit,
      innerRef = _ref.innerRef,
      emotion = _ref.emotion,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
    return Object(core_browser_esm["c" /* jsx */])("input", Object(esm_extends["a" /* default */])({
      ref: innerRef
    }, props, {
      css: /*#__PURE__*/Object(css_browser_esm["a" /* default */])({
        label: 'dummyInput',
        // get rid of any default styles
        background: 0,
        border: 0,
        fontSize: 'inherit',
        outline: 0,
        padding: 0,
        // important! without `width` browsers won't allow focus
        width: 1,
        // remove cursor on desktop
        color: 'transparent',
        // remove cursor on mobile whilst maintaining "scroll into view" behaviour
        left: -100,
        opacity: 0,
        position: 'relative',
        transform: 'scale(0)'
      }, true ? "" : undefined)
    }));
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return Object(possibleConstructorReturn["a" /* default */])(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var Select_e1cf49ae_browser_esm_NodeResolver = /*#__PURE__*/function (_Component) {
    Object(inherits["a" /* default */])(NodeResolver, _Component);
    var _super = _createSuper(NodeResolver);
    function NodeResolver() {
      Object(classCallCheck["a" /* default */])(this, NodeResolver);
      return _super.apply(this, arguments);
    }
    Object(createClass["a" /* default */])(NodeResolver, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.innerRef(Object(external_react_dom_["findDOMNode"])(this));
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.props.innerRef(null);
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children;
      }
    }]);
    return NodeResolver;
  }(external_react_["Component"]);
  var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
  var LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
  };
  function preventTouchMove(e) {
    e.preventDefault();
  }
  function allowTouchMove(e) {
    e.stopPropagation();
  }
  function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) {
      this.scrollTop = 1;
    } else if (currentScroll === totalScroll) {
      this.scrollTop = top - 1;
    }
  } // `ontouchstart` check works on most browsers
  // `maxTouchPoints` works on IE10/11 and Surface

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }
  function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
      var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return Object(possibleConstructorReturn["a" /* default */])(this, result);
    };
  }
  function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var canUseDOM = !!(window.document && window.document.createElement);
  var activeScrollLocks = 0;
  var Select_e1cf49ae_browser_esm_ScrollLock = /*#__PURE__*/function (_Component) {
    Object(inherits["a" /* default */])(ScrollLock, _Component);
    var _super = _createSuper$1(ScrollLock);
    function ScrollLock() {
      var _this;
      Object(classCallCheck["a" /* default */])(this, ScrollLock);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.originalStyles = {};
      _this.listenerOptions = {
        capture: false,
        passive: false
      };
      return _this;
    }
    Object(createClass["a" /* default */])(ScrollLock, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;
        if (!canUseDOM) return;
        var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) {
          // store any styles already applied to the body
          STYLE_KEYS.forEach(function (key) {
            var val = targetStyle && targetStyle[key];
            _this2.originalStyles[key] = val;
          });
        } // apply the lock styles and padding if this is the first scroll lock

        if (accountForScrollbars && activeScrollLocks < 1) {
          var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
          var clientWidth = document.body ? document.body.clientWidth : 0;
          var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
          Object.keys(LOCK_STYLES).forEach(function (key) {
            var val = LOCK_STYLES[key];
            if (targetStyle) {
              targetStyle[key] = val;
            }
          });
          if (targetStyle) {
            targetStyle.paddingRight = "".concat(adjustedPadding, "px");
          }
        } // account for touch devices

        if (target && isTouchDevice()) {
          // Mobile Safari ignores { overflow: hidden } declaration on the body.
          target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

          if (touchScrollTarget) {
            touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
          }
        } // increment active scroll locks

        activeScrollLocks += 1;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this3 = this;
        if (!canUseDOM) return;
        var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
        var target = document.body;
        var targetStyle = target && target.style; // safely decrement active scroll locks

        activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

        if (accountForScrollbars && activeScrollLocks < 1) {
          STYLE_KEYS.forEach(function (key) {
            var val = _this3.originalStyles[key];
            if (targetStyle) {
              targetStyle[key] = val;
            }
          });
        } // remove touch listeners

        if (target && isTouchDevice()) {
          target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);
          if (touchScrollTarget) {
            touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        return null;
      }
    }]);
    return ScrollLock;
  }(external_react_["Component"]);
  Select_e1cf49ae_browser_esm_ScrollLock.defaultProps = {
    accountForScrollbars: true
  };
  function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  }
  function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
      var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return Object(possibleConstructorReturn["a" /* default */])(this, result);
    };
  }
  function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var _ref$1 = true ? {
    name: "1dsbpcp",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
  } : undefined;

  // NOTE:
  // We shouldn't need this after updating to React v16.3.0, which introduces:
  // - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
  // - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
  var Select_e1cf49ae_browser_esm_ScrollBlock = /*#__PURE__*/function (_PureComponent) {
    Object(inherits["a" /* default */])(ScrollBlock, _PureComponent);
    var _super = _createSuper$2(ScrollBlock);
    function ScrollBlock() {
      var _this;
      Object(classCallCheck["a" /* default */])(this, ScrollBlock);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        touchScrollTarget: null
      };
      _this.getScrollTarget = function (ref) {
        if (ref === _this.state.touchScrollTarget) return;
        _this.setState({
          touchScrollTarget: ref
        });
      };
      _this.blurSelectInput = function () {
        if (document.activeElement) {
          document.activeElement.blur();
        }
      };
      return _this;
    }
    Object(createClass["a" /* default */])(ScrollBlock, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
        var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

        if (!isEnabled) return children;
        /*
         * Div
         * ------------------------------
         * blocks scrolling on non-body elements behind the menu
          * NodeResolver
         * ------------------------------
         * we need a reference to the scrollable element to "unlock" scroll on
         * mobile devices
          * ScrollLock
         * ------------------------------
         * actually does the scroll locking
         */

        return Object(core_browser_esm["c" /* jsx */])("div", null, Object(core_browser_esm["c" /* jsx */])("div", {
          onClick: this.blurSelectInput,
          css: _ref$1
        }), Object(core_browser_esm["c" /* jsx */])(Select_e1cf49ae_browser_esm_NodeResolver, {
          innerRef: this.getScrollTarget
        }, children), touchScrollTarget ? Object(core_browser_esm["c" /* jsx */])(Select_e1cf49ae_browser_esm_ScrollLock, {
          touchScrollTarget: touchScrollTarget
        }) : null);
      }
    }]);
    return ScrollBlock;
  }(external_react_["PureComponent"]);
  function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
      var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return Object(possibleConstructorReturn["a" /* default */])(this, result);
    };
  }
  function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var Select_e1cf49ae_browser_esm_ScrollCaptor = /*#__PURE__*/function (_Component) {
    Object(inherits["a" /* default */])(ScrollCaptor, _Component);
    var _super = _createSuper$3(ScrollCaptor);
    function ScrollCaptor() {
      var _this;
      Object(classCallCheck["a" /* default */])(this, ScrollCaptor);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.isBottom = false;
      _this.isTop = false;
      _this.scrollTarget = void 0;
      _this.touchStart = void 0;
      _this.cancelScroll = function (event) {
        event.preventDefault();
        event.stopPropagation();
      };
      _this.handleEventDelta = function (event, delta) {
        var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
        var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
        var target = _this.scrollTarget;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false; // reset bottom/top flags

        if (availableScroll > delta && _this.isBottom) {
          if (onBottomLeave) onBottomLeave(event);
          _this.isBottom = false;
        }
        if (isDeltaPositive && _this.isTop) {
          if (onTopLeave) onTopLeave(event);
          _this.isTop = false;
        } // bottom limit

        if (isDeltaPositive && delta > availableScroll) {
          if (onBottomArrive && !_this.isBottom) {
            onBottomArrive(event);
          }
          target.scrollTop = scrollHeight;
          shouldCancelScroll = true;
          _this.isBottom = true; // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
          if (onTopArrive && !_this.isTop) {
            onTopArrive(event);
          }
          target.scrollTop = 0;
          shouldCancelScroll = true;
          _this.isTop = true;
        } // cancel scroll

        if (shouldCancelScroll) {
          _this.cancelScroll(event);
        }
      };
      _this.onWheel = function (event) {
        _this.handleEventDelta(event, event.deltaY);
      };
      _this.onTouchStart = function (event) {
        // set touch start so we can calculate touchmove delta
        _this.touchStart = event.changedTouches[0].clientY;
      };
      _this.onTouchMove = function (event) {
        var deltaY = _this.touchStart - event.changedTouches[0].clientY;
        _this.handleEventDelta(event, deltaY);
      };
      _this.getScrollTarget = function (ref) {
        _this.scrollTarget = ref;
      };
      return _this;
    }
    Object(createClass["a" /* default */])(ScrollCaptor, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.startListening(this.scrollTarget);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.stopListening(this.scrollTarget);
      }
    }, {
      key: "startListening",
      value: function startListening(el) {
        // bail early if no element is available to attach to
        if (!el) return; // all the if statements are to appease Flow 😢

        if (typeof el.addEventListener === 'function') {
          el.addEventListener('wheel', this.onWheel, false);
        }
        if (typeof el.addEventListener === 'function') {
          el.addEventListener('touchstart', this.onTouchStart, false);
        }
        if (typeof el.addEventListener === 'function') {
          el.addEventListener('touchmove', this.onTouchMove, false);
        }
      }
    }, {
      key: "stopListening",
      value: function stopListening(el) {
        if (!el) return; // all the if statements are to appease Flow 😢

        if (typeof el.removeEventListener === 'function') {
          el.removeEventListener('wheel', this.onWheel, false);
        }
        if (typeof el.removeEventListener === 'function') {
          el.removeEventListener('touchstart', this.onTouchStart, false);
        }
        if (typeof el.removeEventListener === 'function') {
          el.removeEventListener('touchmove', this.onTouchMove, false);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/external_react_default.a.createElement(Select_e1cf49ae_browser_esm_NodeResolver, {
          innerRef: this.getScrollTarget
        }, this.props.children);
      }
    }]);
    return ScrollCaptor;
  }(external_react_["Component"]);
  function ScrollCaptorSwitch(_ref) {
    var _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["isEnabled"]);
    return isEnabled ? /*#__PURE__*/external_react_default.a.createElement(Select_e1cf49ae_browser_esm_ScrollCaptor, props) : props.children;
  }
  var instructionsAriaMessage = function instructionsAriaMessage(event) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label,
      isDisabled = context.isDisabled,
      tabSelectsValue = context.tabSelectsValue;
    switch (event) {
      case 'menu':
        return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
      case 'input':
        return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
    }
  };
  var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
    var value = context.value,
      isDisabled = context.isDisabled;
    if (!value) return;
    switch (event) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(value, ", deselected.");
      case 'select-option':
        return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
    }
  };
  var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
    var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
    return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
  };
  var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
    var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
    return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
  };
  var resultsAriaMessage = function resultsAriaMessage(_ref3) {
    var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
    return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  };
  var formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
  };
  var getOptionLabel = function getOptionLabel(option) {
    return option.label;
  };
  var getOptionValue = function getOptionValue(option) {
    return option.value;
  };
  var isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
  };
  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys$1(Object(source), true).forEach(function (key) {
          Object(defineProperty["a" /* default */])(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var defaultStyles = {
    clearIndicator: index_75b02bac_browser_esm["k" /* c */],
    container: index_75b02bac_browser_esm["i" /* a */],
    control: index_75b02bac_browser_esm["j" /* b */],
    dropdownIndicator: index_75b02bac_browser_esm["l" /* d */],
    group: index_75b02bac_browser_esm["o" /* g */],
    groupHeading: index_75b02bac_browser_esm["m" /* e */],
    indicatorsContainer: index_75b02bac_browser_esm["q" /* i */],
    indicatorSeparator: index_75b02bac_browser_esm["n" /* f */],
    input: index_75b02bac_browser_esm["p" /* h */],
    loadingIndicator: index_75b02bac_browser_esm["t" /* l */],
    loadingMessage: index_75b02bac_browser_esm["r" /* j */],
    menu: index_75b02bac_browser_esm["u" /* m */],
    menuList: index_75b02bac_browser_esm["s" /* k */],
    menuPortal: index_75b02bac_browser_esm["v" /* n */],
    multiValue: index_75b02bac_browser_esm["w" /* o */],
    multiValueLabel: index_75b02bac_browser_esm["x" /* p */],
    multiValueRemove: index_75b02bac_browser_esm["y" /* q */],
    noOptionsMessage: index_75b02bac_browser_esm["z" /* r */],
    option: index_75b02bac_browser_esm["A" /* s */],
    placeholder: index_75b02bac_browser_esm["B" /* t */],
    singleValue: index_75b02bac_browser_esm["C" /* u */],
    valueContainer: index_75b02bac_browser_esm["D" /* v */]
  }; // Merge Utility
  // Allows consumers to extend a base Select with additional styles

  function mergeStyles(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // initialize with source styles
    var styles = _objectSpread$1({}, source); // massage in target styles

    Object.keys(target).forEach(function (key) {
      if (source[key]) {
        styles[key] = function (rsCss, props) {
          return target[key](source[key](rsCss, props), props);
        };
      } else {
        styles[key] = target[key];
      }
    });
    return styles;
  }
  var colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
  };
  var borderRadius = 4; // Used to calculate consistent margin/padding on elements

  var baseUnit = 4; // The minimum height of the control

  var controlHeight = 38; // The amount of space between the control and menu */

  var menuGutter = baseUnit * 2;
  var spacing = {
    baseUnit: baseUnit,
    controlHeight: controlHeight,
    menuGutter: menuGutter
  };
  var defaultTheme = {
    borderRadius: borderRadius,
    colors: colors,
    spacing: spacing
  };
  function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys$2(Object(source), true).forEach(function (key) {
          Object(defineProperty["a" /* default */])(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$2(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _createSuper$4(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
    return function _createSuperInternal() {
      var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return Object(possibleConstructorReturn["a" /* default */])(this, result);
    };
  }
  function _isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var defaultProps = {
    backspaceRemovesValue: true,
    blurInputOnSelect: Object(index_75b02bac_browser_esm["E" /* w */])(),
    captureMenuScroll: !Object(index_75b02bac_browser_esm["E" /* w */])(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: createFilter(),
    formatGroupLabel: formatGroupLabel,
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: isOptionDisabled,
    loadingMessage: function loadingMessage() {
      return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !Object(index_75b02bac_browser_esm["F" /* x */])(),
    noOptionsMessage: function noOptionsMessage() {
      return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
      var count = _ref.count;
      return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: '0',
    tabSelectsValue: true
  };
  var instanceId = 1;
  var Select_e1cf49ae_browser_esm_Select = /*#__PURE__*/function (_Component) {
    Object(inherits["a" /* default */])(Select, _Component);
    var _super = _createSuper$4(Select);

    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
      var _this;
      Object(classCallCheck["a" /* default */])(this, Select);
      _this = _super.call(this, _props);
      _this.state = {
        ariaLiveSelection: '',
        ariaLiveContext: '',
        focusedOption: null,
        focusedValue: null,
        inputIsHidden: false,
        isFocused: false,
        menuOptions: {
          render: [],
          focusable: []
        },
        selectValue: []
      };
      _this.blockOptionHover = false;
      _this.isComposing = false;
      _this.clearFocusValueOnUpdate = false;
      _this.commonProps = void 0;
      _this.components = void 0;
      _this.hasGroups = false;
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
      _this.inputIsHiddenAfterUpdate = void 0;
      _this.instancePrefix = '';
      _this.openAfterFocus = false;
      _this.scrollToFocusedOptionOnUpdate = false;
      _this.userIsDragging = void 0;
      _this.controlRef = null;
      _this.getControlRef = function (ref) {
        _this.controlRef = ref;
      };
      _this.focusedOptionRef = null;
      _this.getFocusedOptionRef = function (ref) {
        _this.focusedOptionRef = ref;
      };
      _this.menuListRef = null;
      _this.getMenuListRef = function (ref) {
        _this.menuListRef = ref;
      };
      _this.inputRef = null;
      _this.getInputRef = function (ref) {
        _this.inputRef = ref;
      };
      _this.cacheComponents = function (components) {
        _this.components = Object(index_75b02bac_browser_esm["G" /* y */])({
          components: components
        });
      };
      _this.focus = _this.focusInput;
      _this.blur = _this.blurInput;
      _this.onChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
        onChange(newValue, _objectSpread$2(_objectSpread$2({}, actionMeta), {}, {
          name: name
        }));
      };
      _this.setValue = function (newValue) {
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
        var option = arguments.length > 2 ? arguments[2] : undefined;
        var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;
        _this.onInputChange('', {
          action: 'set-value'
        });
        if (closeMenuOnSelect) {
          _this.inputIsHiddenAfterUpdate = !isMulti;
          _this.onMenuClose();
        } // when the select value should change, we should reset focusedValue

        _this.clearFocusValueOnUpdate = true;
        _this.onChange(newValue, {
          action: action,
          option: option
        });
      };
      _this.selectOption = function (newValue) {
        var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;
        var selectValue = _this.state.selectValue;
        if (isMulti) {
          if (_this.isOptionSelected(newValue, selectValue)) {
            var candidate = _this.getOptionValue(newValue);
            _this.setValue(selectValue.filter(function (i) {
              return _this.getOptionValue(i) !== candidate;
            }), 'deselect-option', newValue);
            _this.announceAriaLiveSelection({
              event: 'deselect-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            if (!_this.isOptionDisabled(newValue, selectValue)) {
              _this.setValue([].concat(Object(toConsumableArray["a" /* default */])(selectValue), [newValue]), 'select-option', newValue);
              _this.announceAriaLiveSelection({
                event: 'select-option',
                context: {
                  value: _this.getOptionLabel(newValue)
                }
              });
            } else {
              // announce that option is disabled
              _this.announceAriaLiveSelection({
                event: 'select-option',
                context: {
                  value: _this.getOptionLabel(newValue),
                  isDisabled: true
                }
              });
            }
          }
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue(newValue, 'select-option');
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
        if (blurInputOnSelect) {
          _this.blurInput();
        }
      };
      _this.removeValue = function (removedValue) {
        var selectValue = _this.state.selectValue;
        var candidate = _this.getOptionValue(removedValue);
        var newValue = selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        });
        _this.onChange(newValue.length ? newValue : null, {
          action: 'remove-value',
          removedValue: removedValue
        });
        _this.announceAriaLiveSelection({
          event: 'remove-value',
          context: {
            value: removedValue ? _this.getOptionLabel(removedValue) : ''
          }
        });
        _this.focusInput();
      };
      _this.clearValue = function () {
        _this.onChange(null, {
          action: 'clear'
        });
      };
      _this.popValue = function () {
        var selectValue = _this.state.selectValue;
        var lastSelectedValue = selectValue[selectValue.length - 1];
        var newValue = selectValue.slice(0, selectValue.length - 1);
        _this.announceAriaLiveSelection({
          event: 'pop-value',
          context: {
            value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
          }
        });
        _this.onChange(newValue.length ? newValue : null, {
          action: 'pop-value',
          removedValue: lastSelectedValue
        });
      };
      _this.getValue = function () {
        return _this.state.selectValue;
      };
      _this.cx = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return index_75b02bac_browser_esm["H" /* z */].apply(void 0, [_this.props.classNamePrefix].concat(args));
      };
      _this.getOptionLabel = function (data) {
        return _this.props.getOptionLabel(data);
      };
      _this.getOptionValue = function (data) {
        return _this.props.getOptionValue(data);
      };
      _this.getStyles = function (key, props) {
        var base = defaultStyles[key](props);
        base.boxSizing = 'border-box';
        var custom = _this.props.styles[key];
        return custom ? custom(base, props) : base;
      };
      _this.getElementId = function (element) {
        return "".concat(_this.instancePrefix, "-").concat(element);
      };
      _this.getActiveDescendentId = function () {
        var menuIsOpen = _this.props.menuIsOpen;
        var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
        if (!focusedOption || !menuIsOpen) return undefined;
        var index = menuOptions.focusable.indexOf(focusedOption);
        var option = menuOptions.render[index];
        return option && option.key;
      };
      _this.announceAriaLiveSelection = function (_ref2) {
        var event = _ref2.event,
          context = _ref2.context;
        _this.setState({
          ariaLiveSelection: valueEventAriaMessage(event, context)
        });
      };
      _this.announceAriaLiveContext = function (_ref3) {
        var event = _ref3.event,
          context = _ref3.context;
        _this.setState({
          ariaLiveContext: instructionsAriaMessage(event, _objectSpread$2(_objectSpread$2({}, context), {}, {
            label: _this.props['aria-label']
          }))
        });
      };
      _this.onMenuMouseDown = function (event) {
        if (event.button !== 0) {
          return;
        }
        event.stopPropagation();
        event.preventDefault();
        _this.focusInput();
      };
      _this.onMenuMouseMove = function (event) {
        _this.blockOptionHover = false;
      };
      _this.onControlMouseDown = function (event) {
        var openMenuOnClick = _this.props.openMenuOnClick;
        if (!_this.state.isFocused) {
          if (openMenuOnClick) {
            _this.openAfterFocus = true;
          }
          _this.focusInput();
        } else if (!_this.props.menuIsOpen) {
          if (openMenuOnClick) {
            _this.openMenu('first');
          }
        } else {
          if (
          // $FlowFixMe
          event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
            _this.onMenuClose();
          }
        }
        if (
        // $FlowFixMe
        event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          event.preventDefault();
        }
      };
      _this.onDropdownIndicatorMouseDown = function (event) {
        // ignore mouse events that weren't triggered by the primary button
        if (event && event.type === 'mousedown' && event.button !== 0) {
          return;
        }
        if (_this.props.isDisabled) return;
        var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;
        _this.focusInput();
        if (menuIsOpen) {
          _this.inputIsHiddenAfterUpdate = !isMulti;
          _this.onMenuClose();
        } else {
          _this.openMenu('first');
        }
        event.preventDefault();
        event.stopPropagation();
      };
      _this.onClearIndicatorMouseDown = function (event) {
        // ignore mouse events that weren't triggered by the primary button
        if (event && event.type === 'mousedown' && event.button !== 0) {
          return;
        }
        _this.clearValue();
        event.stopPropagation();
        _this.openAfterFocus = false;
        if (event.type === 'touchend') {
          _this.focusInput();
        } else {
          setTimeout(function () {
            return _this.focusInput();
          });
        }
      };
      _this.onScroll = function (event) {
        if (typeof _this.props.closeMenuOnScroll === 'boolean') {
          if (event.target instanceof HTMLElement && Object(index_75b02bac_browser_esm["a" /* A */])(event.target)) {
            _this.props.onMenuClose();
          }
        } else if (typeof _this.props.closeMenuOnScroll === 'function') {
          if (_this.props.closeMenuOnScroll(event)) {
            _this.props.onMenuClose();
          }
        }
      };
      _this.onCompositionStart = function () {
        _this.isComposing = true;
      };
      _this.onCompositionEnd = function () {
        _this.isComposing = false;
      };
      _this.onTouchStart = function (_ref4) {
        var touches = _ref4.touches;
        var touch = touches && touches.item(0);
        if (!touch) {
          return;
        }
        _this.initialTouchX = touch.clientX;
        _this.initialTouchY = touch.clientY;
        _this.userIsDragging = false;
      };
      _this.onTouchMove = function (_ref5) {
        var touches = _ref5.touches;
        var touch = touches && touches.item(0);
        if (!touch) {
          return;
        }
        var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
        var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
        var moveThreshold = 5;
        _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
      };
      _this.onTouchEnd = function (event) {
        if (_this.userIsDragging) return; // close the menu if the user taps outside
        // we're checking on event.target here instead of event.currentTarget, because we want to assert information
        // on events on child elements, not the document (which we've attached this handler to).

        if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
          _this.blurInput();
        } // reset move vars

        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
      };
      _this.onControlTouchEnd = function (event) {
        if (_this.userIsDragging) return;
        _this.onControlMouseDown(event);
      };
      _this.onClearIndicatorTouchEnd = function (event) {
        if (_this.userIsDragging) return;
        _this.onClearIndicatorMouseDown(event);
      };
      _this.onDropdownIndicatorTouchEnd = function (event) {
        if (_this.userIsDragging) return;
        _this.onDropdownIndicatorMouseDown(event);
      };
      _this.handleInputChange = function (event) {
        var inputValue = event.currentTarget.value;
        _this.inputIsHiddenAfterUpdate = false;
        _this.onInputChange(inputValue, {
          action: 'input-change'
        });
        if (!_this.props.menuIsOpen) {
          _this.onMenuOpen();
        }
      };
      _this.onInputFocus = function (event) {
        var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;
        if (_this.props.onFocus) {
          _this.props.onFocus(event);
        }
        _this.inputIsHiddenAfterUpdate = false;
        _this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
        _this.setState({
          isFocused: true
        });
        if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
          _this.openMenu('first');
        }
        _this.openAfterFocus = false;
      };
      _this.onInputBlur = function (event) {
        if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
          _this.inputRef.focus();
          return;
        }
        if (_this.props.onBlur) {
          _this.props.onBlur(event);
        }
        _this.onInputChange('', {
          action: 'input-blur'
        });
        _this.onMenuClose();
        _this.setState({
          focusedValue: null,
          isFocused: false
        });
      };
      _this.onOptionHover = function (focusedOption) {
        if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
          return;
        }
        _this.setState({
          focusedOption: focusedOption
        });
      };
      _this.shouldHideSelectedOptions = function () {
        var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
      };
      _this.onKeyDown = function (event) {
        var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
        var _this$state2 = _this.state,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
        if (isDisabled) return;
        if (typeof onKeyDown === 'function') {
          onKeyDown(event);
          if (event.defaultPrevented) {
            return;
          }
        } // Block option hover events when the user has just pressed a key

        _this.blockOptionHover = true;
        switch (event.key) {
          case 'ArrowLeft':
            if (!isMulti || inputValue) return;
            _this.focusValue('previous');
            break;
          case 'ArrowRight':
            if (!isMulti || inputValue) return;
            _this.focusValue('next');
            break;
          case 'Delete':
          case 'Backspace':
            if (inputValue) return;
            if (focusedValue) {
              _this.removeValue(focusedValue);
            } else {
              if (!backspaceRemovesValue) return;
              if (isMulti) {
                _this.popValue();
              } else if (isClearable) {
                _this.clearValue();
              }
            }
            break;
          case 'Tab':
            if (_this.isComposing) return;
            if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
            // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
              return;
            }
            _this.selectOption(focusedOption);
            break;
          case 'Enter':
            if (event.keyCode === 229) {
              // ignore the keydown event from an Input Method Editor(IME)
              // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
              break;
            }
            if (menuIsOpen) {
              if (!focusedOption) return;
              if (_this.isComposing) return;
              _this.selectOption(focusedOption);
              break;
            }
            return;
          case 'Escape':
            if (menuIsOpen) {
              _this.inputIsHiddenAfterUpdate = false;
              _this.onInputChange('', {
                action: 'menu-close'
              });
              _this.onMenuClose();
            } else if (isClearable && escapeClearsValue) {
              _this.clearValue();
            }
            break;
          case ' ':
            // space
            if (inputValue) {
              return;
            }
            if (!menuIsOpen) {
              _this.openMenu('first');
              break;
            }
            if (!focusedOption) return;
            _this.selectOption(focusedOption);
            break;
          case 'ArrowUp':
            if (menuIsOpen) {
              _this.focusOption('up');
            } else {
              _this.openMenu('last');
            }
            break;
          case 'ArrowDown':
            if (menuIsOpen) {
              _this.focusOption('down');
            } else {
              _this.openMenu('first');
            }
            break;
          case 'PageUp':
            if (!menuIsOpen) return;
            _this.focusOption('pageup');
            break;
          case 'PageDown':
            if (!menuIsOpen) return;
            _this.focusOption('pagedown');
            break;
          case 'Home':
            if (!menuIsOpen) return;
            _this.focusOption('first');
            break;
          case 'End':
            if (!menuIsOpen) return;
            _this.focusOption('last');
            break;
          default:
            return;
        }
        event.preventDefault();
      };
      _this.buildMenuOptions = function (props, selectValue) {
        var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;
        var toOption = function toOption(option, id) {
          var isDisabled = _this.isOptionDisabled(option, selectValue);
          var isSelected = _this.isOptionSelected(option, selectValue);
          var label = _this.getOptionLabel(option);
          var value = _this.getOptionValue(option);
          if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
            label: label,
            value: value,
            data: option
          }, inputValue)) {
            return;
          }
          var onHover = isDisabled ? undefined : function () {
            return _this.onOptionHover(option);
          };
          var onSelect = isDisabled ? undefined : function () {
            return _this.selectOption(option);
          };
          var optionId = "".concat(_this.getElementId('option'), "-").concat(id);
          return {
            innerProps: {
              id: optionId,
              onClick: onSelect,
              onMouseMove: onHover,
              onMouseOver: onHover,
              tabIndex: -1
            },
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            key: optionId,
            label: label,
            type: 'option',
            value: value
          };
        };
        return options.reduce(function (acc, item, itemIndex) {
          if (item.options) {
            // TODO needs a tidier implementation
            if (!_this.hasGroups) _this.hasGroups = true;
            var items = item.options;
            var children = items.map(function (child, i) {
              var option = toOption(child, "".concat(itemIndex, "-").concat(i));
              if (option) acc.focusable.push(child);
              return option;
            }).filter(Boolean);
            if (children.length) {
              var groupId = "".concat(_this.getElementId('group'), "-").concat(itemIndex);
              acc.render.push({
                type: 'group',
                key: groupId,
                data: item,
                options: children
              });
            }
          } else {
            var option = toOption(item, "".concat(itemIndex));
            if (option) {
              acc.render.push(option);
              acc.focusable.push(item);
            }
          }
          return acc;
        }, {
          render: [],
          focusable: []
        });
      };
      var _value = _props.value;
      _this.cacheComponents = Object(memoize_one_esm["a" /* default */])(_this.cacheComponents, index_75b02bac_browser_esm["b" /* B */]).bind(Object(assertThisInitialized["a" /* default */])(_this));
      _this.cacheComponents(_props.components);
      _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
      var _selectValue = Object(index_75b02bac_browser_esm["c" /* C */])(_value);
      _this.buildMenuOptions = Object(memoize_one_esm["a" /* default */])(_this.buildMenuOptions, function (newArgs, lastArgs) {
        var _ref6 = newArgs,
          _ref7 = _slicedToArray(_ref6, 2),
          newProps = _ref7[0],
          newSelectValue = _ref7[1];
        var _ref8 = lastArgs,
          _ref9 = _slicedToArray(_ref8, 2),
          lastProps = _ref9[0],
          lastSelectValue = _ref9[1];
        return newSelectValue === lastSelectValue && newProps.inputValue === lastProps.inputValue && newProps.options === lastProps.options;
      }).bind(Object(assertThisInitialized["a" /* default */])(_this));
      var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
        render: [],
        focusable: []
      };
      _this.state.menuOptions = _menuOptions;
      _this.state.selectValue = _selectValue;
      return _this;
    }
    Object(createClass["a" /* default */])(Select, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) {
          // Listen to all scroll events, and filter them out inside of 'onScroll'
          document.addEventListener('scroll', this.onScroll, true);
        }
        if (this.props.autoFocus) {
          this.focusInput();
        }
      }
    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          menuIsOpen = _this$props8.menuIsOpen,
          inputValue = _this$props8.inputValue; // re-cache custom components

        this.cacheComponents(nextProps.components); // rebuild the menu options

        if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
          var selectValue = Object(index_75b02bac_browser_esm["c" /* C */])(nextProps.value);
          var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
            render: [],
            focusable: []
          };
          var focusedValue = this.getNextFocusedValue(selectValue);
          var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
          this.setState({
            menuOptions: menuOptions,
            selectValue: selectValue,
            focusedOption: focusedOption,
            focusedValue: focusedValue
          });
        } // some updates should toggle the state of the input visibility

        if (this.inputIsHiddenAfterUpdate != null) {
          this.setState({
            inputIsHidden: this.inputIsHiddenAfterUpdate
          });
          delete this.inputIsHiddenAfterUpdate;
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
        var isFocused = this.state.isFocused;
        if (
        // ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled ||
        // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) {
          this.focusInput();
        }
        if (isFocused && isDisabled && !prevProps.isDisabled) {
          // ensure select state gets blurred in case Select is programatically disabled while focused
          this.setState({
            isFocused: false
          }, this.onMenuClose);
        } // scroll the focused option into view if necessary

        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
          Object(index_75b02bac_browser_esm["d" /* D */])(this.menuListRef, this.focusedOptionRef);
          this.scrollToFocusedOptionOnUpdate = false;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        document.removeEventListener('scroll', this.onScroll, true);
      }
    }, {
      key: "onMenuOpen",
      // ==============================
      // Consumer Handlers
      // ==============================
      value: function onMenuOpen() {
        this.props.onMenuOpen();
      }
    }, {
      key: "onMenuClose",
      value: function onMenuClose() {
        var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
        this.onInputChange('', {
          action: 'menu-close'
        });
        this.props.onMenuClose();
      }
    }, {
      key: "onInputChange",
      value: function onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
      } // ==============================
      // Methods
      // ==============================
    }, {
      key: "focusInput",
      value: function focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
      }
    }, {
      key: "blurInput",
      value: function blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
      } // aliased for consumers
    }, {
      key: "openMenu",
      value: function openMenu(focusOption) {
        var _this2 = this;
        var _this$state3 = this.state,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
        var menuOptions = this.buildMenuOptions(this.props, selectValue);
        var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          tabSelectsValue = _this$props11.tabSelectsValue;
        var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;
        if (!isMulti) {
          var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
          if (selectedIndex > -1) {
            openAtIndex = selectedIndex;
          }
        } // only scroll if the menu isn't already open

        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.inputIsHiddenAfterUpdate = false;
        this.setState({
          menuOptions: menuOptions,
          focusedValue: null,
          focusedOption: menuOptions.focusable[openAtIndex]
        }, function () {
          _this2.onMenuOpen();
          _this2.announceAriaLiveContext({
            event: 'menu',
            context: {
              tabSelectsValue: tabSelectsValue
            }
          });
        });
      }
    }, {
      key: "focusValue",
      value: function focusValue(direction) {
        var _this$props12 = this.props,
          isMulti = _this$props12.isMulti,
          isSearchable = _this$props12.isSearchable;
        var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

        if (!isMulti) return;
        this.setState({
          focusedOption: null
        });
        var focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) {
          focusedIndex = -1;
          this.announceAriaLiveContext({
            event: 'value'
          });
        }
        var lastIndex = selectValue.length - 1;
        var nextFocus = -1;
        if (!selectValue.length) return;
        switch (direction) {
          case 'previous':
            if (focusedIndex === 0) {
              // don't cycle from the start to the end
              nextFocus = 0;
            } else if (focusedIndex === -1) {
              // if nothing is focused, focus the last value first
              nextFocus = lastIndex;
            } else {
              nextFocus = focusedIndex - 1;
            }
            break;
          case 'next':
            if (focusedIndex > -1 && focusedIndex < lastIndex) {
              nextFocus = focusedIndex + 1;
            }
            break;
        }
        if (nextFocus === -1) {
          this.announceAriaLiveContext({
            event: 'input',
            context: {
              isSearchable: isSearchable,
              isMulti: isMulti
            }
          });
        }
        this.setState({
          inputIsHidden: nextFocus !== -1,
          focusedValue: selectValue[nextFocus]
        });
      }
    }, {
      key: "focusOption",
      value: function focusOption() {
        var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
        var _this$props13 = this.props,
          pageSize = _this$props13.pageSize,
          tabSelectsValue = _this$props13.tabSelectsValue;
        var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
        var options = menuOptions.focusable;
        if (!options.length) return;
        var nextFocus = 0; // handles 'first'

        var focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) {
          focusedIndex = -1;
          this.announceAriaLiveContext({
            event: 'menu',
            context: {
              tabSelectsValue: tabSelectsValue
            }
          });
        }
        if (direction === 'up') {
          nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        } else if (direction === 'down') {
          nextFocus = (focusedIndex + 1) % options.length;
        } else if (direction === 'pageup') {
          nextFocus = focusedIndex - pageSize;
          if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
          nextFocus = focusedIndex + pageSize;
          if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') {
          nextFocus = options.length - 1;
        }
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
          focusedOption: options[nextFocus],
          focusedValue: null
        });
        this.announceAriaLiveContext({
          event: 'menu',
          context: {
            isDisabled: isOptionDisabled(options[nextFocus]),
            tabSelectsValue: tabSelectsValue
          }
        });
      }
    }, {
      key: "getTheme",
      // ==============================
      // Getters
      // ==============================
      value: function getTheme() {
        // Use the default theme if there are no customizations.
        if (!this.props.theme) {
          return defaultTheme;
        } // If the theme prop is a function, assume the function
        // knows how to merge the passed-in default theme with
        // its own modifications.

        if (typeof this.props.theme === 'function') {
          return this.props.theme(defaultTheme);
        } // Otherwise, if a plain theme object was passed in,
        // overlay it with the default theme.

        return _objectSpread$2(_objectSpread$2({}, defaultTheme), this.props.theme);
      }
    }, {
      key: "getCommonProps",
      value: function getCommonProps() {
        var clearValue = this.clearValue,
          cx = this.cx,
          getStyles = this.getStyles,
          getValue = this.getValue,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
        var isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
        var hasValue = this.hasValue();
        return {
          cx: cx,
          clearValue: clearValue,
          getStyles: getStyles,
          getValue: getValue,
          hasValue: hasValue,
          isMulti: isMulti,
          isRtl: isRtl,
          options: options,
          selectOption: selectOption,
          setValue: setValue,
          selectProps: props,
          theme: this.getTheme()
        };
      }
    }, {
      key: "getNextFocusedValue",
      value: function getNextFocusedValue(nextSelectValue) {
        if (this.clearFocusValueOnUpdate) {
          this.clearFocusValueOnUpdate = false;
          return null;
        }
        var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
        var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
          var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
          if (nextFocusedIndex > -1) {
            // the focused value is still in the selectValue, return it
            return focusedValue;
          } else if (lastFocusedIndex < nextSelectValue.length) {
            // the focusedValue is not present in the next selectValue array by
            // reference, so return the new value at the same index
            return nextSelectValue[lastFocusedIndex];
          }
        }
        return null;
      }
    }, {
      key: "getNextFocusedOption",
      value: function getNextFocusedOption(options) {
        var lastFocusedOption = this.state.focusedOption;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
      }
    }, {
      key: "hasValue",
      value: function hasValue() {
        var selectValue = this.state.selectValue;
        return selectValue.length > 0;
      }
    }, {
      key: "hasOptions",
      value: function hasOptions() {
        return !!this.state.menuOptions.render.length;
      }
    }, {
      key: "countOptions",
      value: function countOptions() {
        return this.state.menuOptions.focusable.length;
      }
    }, {
      key: "isClearable",
      value: function isClearable() {
        var _this$props14 = this.props,
          isClearable = _this$props14.isClearable,
          isMulti = _this$props14.isMulti; // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable

        if (isClearable === undefined) return isMulti;
        return isClearable;
      }
    }, {
      key: "isOptionDisabled",
      value: function isOptionDisabled(option, selectValue) {
        return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
      }
    }, {
      key: "isOptionSelected",
      value: function isOptionSelected(option, selectValue) {
        var _this3 = this;
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof this.props.isOptionSelected === 'function') {
          return this.props.isOptionSelected(option, selectValue);
        }
        var candidate = this.getOptionValue(option);
        return selectValue.some(function (i) {
          return _this3.getOptionValue(i) === candidate;
        });
      }
    }, {
      key: "filterOption",
      value: function filterOption(option, inputValue) {
        return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
      }
    }, {
      key: "formatOptionLabel",
      value: function formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
          var inputValue = this.props.inputValue;
          var selectValue = this.state.selectValue;
          return this.props.formatOptionLabel(data, {
            context: context,
            inputValue: inputValue,
            selectValue: selectValue
          });
        } else {
          return this.getOptionLabel(data);
        }
      }
    }, {
      key: "formatGroupLabel",
      value: function formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
      } // ==============================
      // Mouse Handlers
      // ==============================
    }, {
      key: "startListeningComposition",
      // ==============================
      // Composition Handlers
      // ==============================
      value: function startListeningComposition() {
        if (document && document.addEventListener) {
          document.addEventListener('compositionstart', this.onCompositionStart, false);
          document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
      }
    }, {
      key: "stopListeningComposition",
      value: function stopListeningComposition() {
        if (document && document.removeEventListener) {
          document.removeEventListener('compositionstart', this.onCompositionStart);
          document.removeEventListener('compositionend', this.onCompositionEnd);
        }
      }
    }, {
      key: "startListeningToTouch",
      // ==============================
      // Touch Handlers
      // ==============================
      value: function startListeningToTouch() {
        if (document && document.addEventListener) {
          document.addEventListener('touchstart', this.onTouchStart, false);
          document.addEventListener('touchmove', this.onTouchMove, false);
          document.addEventListener('touchend', this.onTouchEnd, false);
        }
      }
    }, {
      key: "stopListeningToTouch",
      value: function stopListeningToTouch() {
        if (document && document.removeEventListener) {
          document.removeEventListener('touchstart', this.onTouchStart);
          document.removeEventListener('touchmove', this.onTouchMove);
          document.removeEventListener('touchend', this.onTouchEnd);
        }
      }
    }, {
      key: "constructAriaLiveMessage",
      // ==============================
      // Renderers
      // ==============================
      value: function constructAriaLiveMessage() {
        var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
        var _this$props15 = this.props,
          options = _this$props15.options,
          menuIsOpen = _this$props15.menuIsOpen,
          inputValue = _this$props15.inputValue,
          screenReaderStatus = _this$props15.screenReaderStatus; // An aria live message representing the currently focused value in the select.

        var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
          focusedValue: focusedValue,
          getOptionLabel: this.getOptionLabel,
          selectValue: selectValue
        }) : ''; // An aria live message representing the currently focused option in the select.

        var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
          focusedOption: focusedOption,
          getOptionLabel: this.getOptionLabel,
          options: options
        }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

        var resultsMsg = resultsAriaMessage({
          inputValue: inputValue,
          screenReaderMessage: screenReaderStatus({
            count: this.countOptions()
          })
        });
        return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
      }
    }, {
      key: "renderInput",
      value: function renderInput() {
        var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isSearchable = _this$props16.isSearchable,
          inputId = _this$props16.inputId,
          inputValue = _this$props16.inputValue,
          tabIndex = _this$props16.tabIndex,
          form = _this$props16.form;
        var Input = this.components.Input;
        var inputIsHidden = this.state.inputIsHidden;
        var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

        var ariaAttributes = {
          'aria-autocomplete': 'list',
          'aria-label': this.props['aria-label'],
          'aria-labelledby': this.props['aria-labelledby']
        };
        if (!isSearchable) {
          // use a dummy input to maintain focus/blur functionality
          return /*#__PURE__*/external_react_default.a.createElement(DummyInput, Object(esm_extends["a" /* default */])({
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: index_75b02bac_browser_esm["e" /* E */],
            onFocus: this.onInputFocus,
            readOnly: true,
            disabled: isDisabled,
            tabIndex: tabIndex,
            form: form,
            value: ""
          }, ariaAttributes));
        }
        var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
        return /*#__PURE__*/external_react_default.a.createElement(Input, Object(esm_extends["a" /* default */])({
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          cx: cx,
          getStyles: this.getStyles,
          id: id,
          innerRef: this.getInputRef,
          isDisabled: isDisabled,
          isHidden: inputIsHidden,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          selectProps: selectProps,
          spellCheck: "false",
          tabIndex: tabIndex,
          form: form,
          theme: theme,
          type: "text",
          value: inputValue
        }, ariaAttributes));
      }
    }, {
      key: "renderPlaceholderOrValue",
      value: function renderPlaceholderOrValue() {
        var _this4 = this;
        var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
        var commonProps = this.commonProps;
        var _this$props17 = this.props,
          controlShouldRenderValue = _this$props17.controlShouldRenderValue,
          isDisabled = _this$props17.isDisabled,
          isMulti = _this$props17.isMulti,
          inputValue = _this$props17.inputValue,
          placeholder = _this$props17.placeholder;
        var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;
        if (!this.hasValue() || !controlShouldRenderValue) {
          return inputValue ? null : /*#__PURE__*/external_react_default.a.createElement(Placeholder, Object(esm_extends["a" /* default */])({}, commonProps, {
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused
          }), placeholder);
        }
        if (isMulti) {
          var selectValues = selectValue.map(function (opt, index) {
            var isOptionFocused = opt === focusedValue;
            return /*#__PURE__*/external_react_default.a.createElement(MultiValue, Object(esm_extends["a" /* default */])({}, commonProps, {
              components: {
                Container: MultiValueContainer,
                Label: MultiValueLabel,
                Remove: MultiValueRemove
              },
              isFocused: isOptionFocused,
              isDisabled: isDisabled,
              key: "".concat(_this4.getOptionValue(opt)).concat(index),
              index: index,
              removeProps: {
                onClick: function onClick() {
                  return _this4.removeValue(opt);
                },
                onTouchEnd: function onTouchEnd() {
                  return _this4.removeValue(opt);
                },
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              },
              data: opt
            }), _this4.formatOptionLabel(opt, 'value'));
          });
          return selectValues;
        }
        if (inputValue) {
          return null;
        }
        var singleValue = selectValue[0];
        return /*#__PURE__*/external_react_default.a.createElement(SingleValue, Object(esm_extends["a" /* default */])({}, commonProps, {
          data: singleValue,
          isDisabled: isDisabled
        }), this.formatOptionLabel(singleValue, 'value'));
      }
    }, {
      key: "renderClearIndicator",
      value: function renderClearIndicator() {
        var ClearIndicator = this.components.ClearIndicator;
        var commonProps = this.commonProps;
        var _this$props18 = this.props,
          isDisabled = _this$props18.isDisabled,
          isLoading = _this$props18.isLoading;
        var isFocused = this.state.isFocused;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
          return null;
        }
        var innerProps = {
          onMouseDown: this.onClearIndicatorMouseDown,
          onTouchEnd: this.onClearIndicatorTouchEnd,
          'aria-hidden': 'true'
        };
        return /*#__PURE__*/external_react_default.a.createElement(ClearIndicator, Object(esm_extends["a" /* default */])({}, commonProps, {
          innerProps: innerProps,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderLoadingIndicator",
      value: function renderLoadingIndicator() {
        var LoadingIndicator = this.components.LoadingIndicator;
        var commonProps = this.commonProps;
        var _this$props19 = this.props,
          isDisabled = _this$props19.isDisabled,
          isLoading = _this$props19.isLoading;
        var isFocused = this.state.isFocused;
        if (!LoadingIndicator || !isLoading) return null;
        var innerProps = {
          'aria-hidden': 'true'
        };
        return /*#__PURE__*/external_react_default.a.createElement(LoadingIndicator, Object(esm_extends["a" /* default */])({}, commonProps, {
          innerProps: innerProps,
          isDisabled: isDisabled,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderIndicatorSeparator",
      value: function renderIndicatorSeparator() {
        var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

        if (!DropdownIndicator || !IndicatorSeparator) return null;
        var commonProps = this.commonProps;
        var isDisabled = this.props.isDisabled;
        var isFocused = this.state.isFocused;
        return /*#__PURE__*/external_react_default.a.createElement(IndicatorSeparator, Object(esm_extends["a" /* default */])({}, commonProps, {
          isDisabled: isDisabled,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderDropdownIndicator",
      value: function renderDropdownIndicator() {
        var DropdownIndicator = this.components.DropdownIndicator;
        if (!DropdownIndicator) return null;
        var commonProps = this.commonProps;
        var isDisabled = this.props.isDisabled;
        var isFocused = this.state.isFocused;
        var innerProps = {
          onMouseDown: this.onDropdownIndicatorMouseDown,
          onTouchEnd: this.onDropdownIndicatorTouchEnd,
          'aria-hidden': 'true'
        };
        return /*#__PURE__*/external_react_default.a.createElement(DropdownIndicator, Object(esm_extends["a" /* default */])({}, commonProps, {
          innerProps: innerProps,
          isDisabled: isDisabled,
          isFocused: isFocused
        }));
      }
    }, {
      key: "renderMenu",
      value: function renderMenu() {
        var _this5 = this;
        var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu = _this$components3.Menu,
          MenuList = _this$components3.MenuList,
          MenuPortal = _this$components3.MenuPortal,
          LoadingMessage = _this$components3.LoadingMessage,
          NoOptionsMessage = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
        var commonProps = this.commonProps;
        var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
        var _this$props20 = this.props,
          captureMenuScroll = _this$props20.captureMenuScroll,
          inputValue = _this$props20.inputValue,
          isLoading = _this$props20.isLoading,
          loadingMessage = _this$props20.loadingMessage,
          minMenuHeight = _this$props20.minMenuHeight,
          maxMenuHeight = _this$props20.maxMenuHeight,
          menuIsOpen = _this$props20.menuIsOpen,
          menuPlacement = _this$props20.menuPlacement,
          menuPosition = _this$props20.menuPosition,
          menuPortalTarget = _this$props20.menuPortalTarget,
          menuShouldBlockScroll = _this$props20.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props20.menuShouldScrollIntoView,
          noOptionsMessage = _this$props20.noOptionsMessage,
          onMenuScrollToTop = _this$props20.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props20.onMenuScrollToBottom;
        if (!menuIsOpen) return null; // TODO: Internal Option Type here

        var render = function render(props) {
          // for performance, the menu options in state aren't changed when the
          // focused option changes so we calculate additional props based on that
          var isFocused = focusedOption === props.data;
          props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
          return /*#__PURE__*/external_react_default.a.createElement(Option, Object(esm_extends["a" /* default */])({}, commonProps, props, {
            isFocused: isFocused
          }), _this5.formatOptionLabel(props.data, 'menu'));
        };
        var menuUI;
        if (this.hasOptions()) {
          menuUI = menuOptions.render.map(function (item) {
            if (item.type === 'group') {
              var type = item.type,
                group = Object(objectWithoutProperties["a" /* default */])(item, ["type"]);
              var headingId = "".concat(item.key, "-heading");
              return /*#__PURE__*/external_react_default.a.createElement(Group, Object(esm_extends["a" /* default */])({}, commonProps, group, {
                Heading: GroupHeading,
                headingProps: {
                  id: headingId,
                  data: item.data
                },
                label: _this5.formatGroupLabel(item.data)
              }), item.options.map(function (option) {
                return render(option);
              }));
            } else if (item.type === 'option') {
              return render(item);
            }
          });
        } else if (isLoading) {
          var message = loadingMessage({
            inputValue: inputValue
          });
          if (message === null) return null;
          menuUI = /*#__PURE__*/external_react_default.a.createElement(LoadingMessage, commonProps, message);
        } else {
          var _message = noOptionsMessage({
            inputValue: inputValue
          });
          if (_message === null) return null;
          menuUI = /*#__PURE__*/external_react_default.a.createElement(NoOptionsMessage, commonProps, _message);
        }
        var menuPlacementProps = {
          minMenuHeight: minMenuHeight,
          maxMenuHeight: maxMenuHeight,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition,
          menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        var menuElement = /*#__PURE__*/external_react_default.a.createElement(index_75b02bac_browser_esm["h" /* M */], Object(esm_extends["a" /* default */])({}, commonProps, menuPlacementProps), function (_ref10) {
          var ref = _ref10.ref,
            _ref10$placerProps = _ref10.placerProps,
            placement = _ref10$placerProps.placement,
            maxHeight = _ref10$placerProps.maxHeight;
          return /*#__PURE__*/external_react_default.a.createElement(Menu, Object(esm_extends["a" /* default */])({}, commonProps, menuPlacementProps, {
            innerRef: ref,
            innerProps: {
              onMouseDown: _this5.onMenuMouseDown,
              onMouseMove: _this5.onMenuMouseMove
            },
            isLoading: isLoading,
            placement: placement
          }), /*#__PURE__*/external_react_default.a.createElement(ScrollCaptorSwitch, {
            isEnabled: captureMenuScroll,
            onTopArrive: onMenuScrollToTop,
            onBottomArrive: onMenuScrollToBottom
          }, /*#__PURE__*/external_react_default.a.createElement(Select_e1cf49ae_browser_esm_ScrollBlock, {
            isEnabled: menuShouldBlockScroll
          }, /*#__PURE__*/external_react_default.a.createElement(MenuList, Object(esm_extends["a" /* default */])({}, commonProps, {
            innerRef: _this5.getMenuListRef,
            isLoading: isLoading,
            maxHeight: maxHeight
          }), menuUI))));
        }); // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`

        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/external_react_default.a.createElement(MenuPortal, Object(esm_extends["a" /* default */])({}, commonProps, {
          appendTo: menuPortalTarget,
          controlElement: this.controlRef,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition
        }), menuElement) : menuElement;
      }
    }, {
      key: "renderFormField",
      value: function renderFormField() {
        var _this6 = this;
        var _this$props21 = this.props,
          delimiter = _this$props21.delimiter,
          isDisabled = _this$props21.isDisabled,
          isMulti = _this$props21.isMulti,
          name = _this$props21.name;
        var selectValue = this.state.selectValue;
        if (!name || isDisabled) return;
        if (isMulti) {
          if (delimiter) {
            var value = selectValue.map(function (opt) {
              return _this6.getOptionValue(opt);
            }).join(delimiter);
            return /*#__PURE__*/external_react_default.a.createElement("input", {
              name: name,
              type: "hidden",
              value: value
            });
          } else {
            var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
              return /*#__PURE__*/external_react_default.a.createElement("input", {
                key: "i-".concat(i),
                name: name,
                type: "hidden",
                value: _this6.getOptionValue(opt)
              });
            }) : /*#__PURE__*/external_react_default.a.createElement("input", {
              name: name,
              type: "hidden"
            });
            return /*#__PURE__*/external_react_default.a.createElement("div", null, input);
          }
        } else {
          var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
          return /*#__PURE__*/external_react_default.a.createElement("input", {
            name: name,
            type: "hidden",
            value: _value2
          });
        }
      }
    }, {
      key: "renderLiveRegion",
      value: function renderLiveRegion() {
        if (!this.state.isFocused) return null;
        return /*#__PURE__*/external_react_default.a.createElement(Select_e1cf49ae_browser_esm_A11yText, {
          "aria-live": "polite"
        }, /*#__PURE__*/external_react_default.a.createElement("span", {
          id: "aria-selection-event"
        }, "\xA0", this.state.ariaLiveSelection), /*#__PURE__*/external_react_default.a.createElement("span", {
          id: "aria-context"
        }, "\xA0", this.constructAriaLiveMessage()));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
        var _this$props22 = this.props,
          className = _this$props22.className,
          id = _this$props22.id,
          isDisabled = _this$props22.isDisabled,
          menuIsOpen = _this$props22.menuIsOpen;
        var isFocused = this.state.isFocused;
        var commonProps = this.commonProps = this.getCommonProps();
        return /*#__PURE__*/external_react_default.a.createElement(SelectContainer, Object(esm_extends["a" /* default */])({}, commonProps, {
          className: className,
          innerProps: {
            id: id,
            onKeyDown: this.onKeyDown
          },
          isDisabled: isDisabled,
          isFocused: isFocused
        }), this.renderLiveRegion(), /*#__PURE__*/external_react_default.a.createElement(Control, Object(esm_extends["a" /* default */])({}, commonProps, {
          innerRef: this.getControlRef,
          innerProps: {
            onMouseDown: this.onControlMouseDown,
            onTouchEnd: this.onControlTouchEnd
          },
          isDisabled: isDisabled,
          isFocused: isFocused,
          menuIsOpen: menuIsOpen
        }), /*#__PURE__*/external_react_default.a.createElement(ValueContainer, Object(esm_extends["a" /* default */])({}, commonProps, {
          isDisabled: isDisabled
        }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/external_react_default.a.createElement(IndicatorsContainer, Object(esm_extends["a" /* default */])({}, commonProps, {
          isDisabled: isDisabled
        }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
      }
    }]);
    return Select;
  }(external_react_["Component"]);
  Select_e1cf49ae_browser_esm_Select.defaultProps = defaultProps;

  /***/
}, /* 22 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return (/* binding */_objectWithoutProperties
    );
  });

  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }

  /***/
}, /* 23 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /*
    MIT License http://www.opensource.org/licenses/mit-license.php
    Author Tobias Koppers @sokra
  */
  // css base code, injected by the css-loader
  module.exports = function (useSourceMap) {
    var list = []; // return the list of modules as css string

    list.toString = function toString() {
      return this.map(function (item) {
        var content = cssWithMappingToString(item, useSourceMap);
        if (item[2]) {
          return '@media ' + item[2] + '{' + content + '}';
        } else {
          return content;
        }
      }).join('');
    }; // import a list of modules into the list

    list.i = function (modules, mediaQuery) {
      if (typeof modules === 'string') {
        modules = [[null, modules, '']];
      }
      var alreadyImportedModules = {};
      for (var i = 0; i < this.length; i++) {
        var id = this[i][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
      for (i = 0; i < modules.length; i++) {
        var item = modules[i]; // skip already imported module
        // this implementation is not 100% perfect for weird media query combinations
        // when a module is imported multiple times with different media queries.
        // I hope this will never occur (Hey this way we have smaller bundles)

        if (item[0] == null || !alreadyImportedModules[item[0]]) {
          if (mediaQuery && !item[2]) {
            item[2] = mediaQuery;
          } else if (mediaQuery) {
            item[2] = '(' + item[2] + ') and (' + mediaQuery + ')';
          }
          list.push(item);
        }
      }
    };
    return list;
  };
  function cssWithMappingToString(item, useSourceMap) {
    var content = item[1] || '';
    var cssMapping = item[3];
    if (!cssMapping) {
      return content;
    }
    if (useSourceMap && typeof btoa === 'function') {
      var sourceMapping = toComment(cssMapping);
      var sourceURLs = cssMapping.sources.map(function (source) {
        return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
      });
      return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
    }
    return [content].join('\n');
  } // Adapted from convert-source-map (MIT)

  function toComment(sourceMap) {
    // eslint-disable-next-line no-undef
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
    var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
    return '/*# ' + data + ' */';
  }

  /***/
}, /* 24 */
/***/function (module, exports) {
  /*
  	MIT License http://www.opensource.org/licenses/mit-license.php
  	Author Tobias Koppers @sokra
  */
  var stylesInDom = {},
    memoize = function (fn) {
      var memo;
      return function () {
        if (typeof memo === "undefined") memo = fn.apply(this, arguments);
        return memo;
      };
    },
    isIE9 = memoize(function () {
      return /msie 9\b/.test(window.navigator.userAgent.toLowerCase());
    }),
    getHeadElement = memoize(function () {
      return document.head || document.getElementsByTagName("head")[0];
    }),
    singletonElement = null,
    singletonCounter = 0;
  module.exports = function (list, options) {
    if (typeof DEBUG !== "undefined" && DEBUG) {
      if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
    }
    options = options || {};
    // Force single-tag solution on IE9, which has a hard limit on the # of <style>
    // tags it will allow on a page
    if (typeof options.singleton === "undefined") options.singleton = isIE9();
    var styles = listToStyles(list);
    addStylesToDom(styles, options);
    return function update(newList) {
      var mayRemove = [];
      for (var i = 0; i < styles.length; i++) {
        var item = styles[i];
        var domStyle = stylesInDom[item.id];
        domStyle.refs--;
        mayRemove.push(domStyle);
      }
      if (newList) {
        var newStyles = listToStyles(newList);
        addStylesToDom(newStyles, options);
      }
      for (var i = 0; i < mayRemove.length; i++) {
        var domStyle = mayRemove[i];
        if (domStyle.refs === 0) {
          for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
          delete stylesInDom[domStyle.id];
        }
      }
    };
  };
  function addStylesToDom(styles, options) {
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i];
      var domStyle = stylesInDom[item.id];
      if (domStyle) {
        domStyle.refs++;
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j](item.parts[j]);
        }
        for (; j < item.parts.length; j++) {
          domStyle.parts.push(addStyle(item.parts[j], options));
        }
      } else {
        var parts = [];
        for (var j = 0; j < item.parts.length; j++) {
          parts.push(addStyle(item.parts[j], options));
        }
        stylesInDom[item.id] = {
          id: item.id,
          refs: 1,
          parts: parts
        };
      }
    }
  }
  function listToStyles(list) {
    var styles = [];
    var newStyles = {};
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      var id = item[0];
      var css = item[1];
      var media = item[2];
      var sourceMap = item[3];
      var part = {
        css: css,
        media: media,
        sourceMap: sourceMap
      };
      if (!newStyles[id]) styles.push(newStyles[id] = {
        id: id,
        parts: [part]
      });else newStyles[id].parts.push(part);
    }
    return styles;
  }
  function createStyleElement() {
    var styleElement = document.createElement("style");
    var head = getHeadElement();
    styleElement.type = "text/css";
    head.appendChild(styleElement);
    return styleElement;
  }
  function addStyle(obj, options) {
    var styleElement, update, remove;
    if (options.singleton) {
      var styleIndex = singletonCounter++;
      styleElement = singletonElement || (singletonElement = createStyleElement());
      update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
      remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
    } else {
      styleElement = createStyleElement();
      update = applyToTag.bind(null, styleElement);
      remove = function () {
        styleElement.parentNode.removeChild(styleElement);
      };
    }
    update(obj);
    return function updateStyle(newObj) {
      if (newObj) {
        if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
        update(obj = newObj);
      } else {
        remove();
      }
    };
  }
  function replaceText(source, id, replacement) {
    var boundaries = ["/** >>" + id + " **/", "/** " + id + "<< **/"];
    var start = source.lastIndexOf(boundaries[0]);
    var wrappedReplacement = replacement ? boundaries[0] + replacement + boundaries[1] : "";
    if (source.lastIndexOf(boundaries[0]) >= 0) {
      var end = source.lastIndexOf(boundaries[1]) + boundaries[1].length;
      return source.slice(0, start) + wrappedReplacement + source.slice(end);
    } else {
      return source + wrappedReplacement;
    }
  }
  function applyToSingletonTag(styleElement, index, remove, obj) {
    var css = remove ? "" : obj.css;
    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = replaceText(styleElement.styleSheet.cssText, index, css);
    } else {
      var cssNode = document.createTextNode(css);
      var childNodes = styleElement.childNodes;
      if (childNodes[index]) styleElement.removeChild(childNodes[index]);
      if (childNodes.length) {
        styleElement.insertBefore(cssNode, childNodes[index]);
      } else {
        styleElement.appendChild(cssNode);
      }
    }
  }
  function applyToTag(styleElement, obj) {
    var css = obj.css;
    var media = obj.media;
    var sourceMap = obj.sourceMap;
    if (sourceMap && typeof btoa === "function") {
      try {
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(JSON.stringify(sourceMap)) + " */";
        css = "@import url(\"data:text/css;base64," + btoa(css) + "\")";
      } catch (e) {}
    }
    if (media) {
      styleElement.setAttribute("media", media);
    }
    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = css;
    } else {
      while (styleElement.firstChild) {
        styleElement.removeChild(styleElement.firstChild);
      }
      styleElement.appendChild(document.createTextNode(css));
    }
  }

  /***/
}, /* 25 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _typeof;
  });
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  /***/
}, /* 26 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* unused harmony export Animated */
  /* unused harmony export AnimatedArray */
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return AnimatedObject;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "b", function () {
    return AnimatedString;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "c", function () {
    return AnimatedValue;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "d", function () {
    return createHost;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "e", function () {
    return getAnimated;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "f", function () {
    return getAnimatedType;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "g", function () {
    return getPayload;
  });
  /* unused harmony export isAnimated */
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "h", function () {
    return setAnimated;
  });
  /* harmony import */
  var _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
  const $node = Symbol.for('Animated:node');
  const isAnimated = value => !!value && value[$node] === value;
  const getAnimated = owner => owner && owner[$node];
  const setAnimated = (owner, node) => Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* defineHidden */"h"])(owner, $node, node);
  const getPayload = owner => owner && owner[$node] && owner[$node].getPayload();
  class Animated {
    constructor() {
      this.payload = void 0;
      setAnimated(this, this);
    }
    getPayload() {
      return this.payload || [];
    }
  }
  class AnimatedValue extends Animated {
    constructor(_value) {
      super();
      this.done = true;
      this.elapsedTime = void 0;
      this.lastPosition = void 0;
      this.lastVelocity = void 0;
      this.v0 = void 0;
      this.durationProgress = 0;
      this._value = _value;
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].num(this._value)) {
        this.lastPosition = this._value;
      }
    }
    static create(value) {
      return new AnimatedValue(value);
    }
    getPayload() {
      return [this];
    }
    getValue() {
      return this._value;
    }
    setValue(value, step) {
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].num(value)) {
        this.lastPosition = value;
        if (step) {
          value = Math.round(value / step) * step;
          if (this.done) {
            this.lastPosition = value;
          }
        }
      }
      if (this._value === value) {
        return false;
      }
      this._value = value;
      return true;
    }
    reset() {
      const {
        done
      } = this;
      this.done = false;
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].num(this._value)) {
        this.elapsedTime = 0;
        this.durationProgress = 0;
        this.lastPosition = this._value;
        if (done) this.lastVelocity = null;
        this.v0 = null;
      }
    }
  }
  class AnimatedString extends AnimatedValue {
    constructor(value) {
      super(0);
      this._string = null;
      this._toString = void 0;
      this._toString = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* createInterpolator */"f"])({
        output: [value, value]
      });
    }
    static create(value) {
      return new AnimatedString(value);
    }
    getValue() {
      let value = this._string;
      return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].str(value)) {
        if (value == this._string) {
          return false;
        }
        this._string = value;
        this._value = 1;
      } else if (super.setValue(value)) {
        this._string = null;
      } else {
        return false;
      }
      return true;
    }
    reset(goal) {
      if (goal) {
        this._toString = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* createInterpolator */"f"])({
          output: [this.getValue(), goal]
        });
      }
      this._value = 0;
      super.reset();
    }
  }
  const TreeContext = {
    dependencies: null
  };
  class AnimatedObject extends Animated {
    constructor(source) {
      super();
      this.source = source;
      this.setValue(source);
    }
    getValue(animated) {
      const values = {};
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* eachProp */"l"])(this.source, (source, key) => {
        if (isAnimated(source)) {
          values[key] = source.getValue(animated);
        } else if (Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* hasFluidValue */"s"])(source)) {
          values[key] = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidValue */"r"])(source);
        } else if (!animated) {
          values[key] = source;
        }
      });
      return values;
    }
    setValue(source) {
      this.source = source;
      this.payload = this._makePayload(source);
    }
    reset() {
      if (this.payload) {
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(this.payload, node => node.reset());
      }
    }
    _makePayload(source) {
      if (source) {
        const payload = new Set();
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* eachProp */"l"])(source, this._addToPayload, payload);
        return Array.from(payload);
      }
    }
    _addToPayload(source) {
      if (TreeContext.dependencies && Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* hasFluidValue */"s"])(source)) {
        TreeContext.dependencies.add(source);
      }
      const payload = getPayload(source);
      if (payload) {
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(payload, node => this.add(node));
      }
    }
  }
  class AnimatedArray extends AnimatedObject {
    constructor(source) {
      super(source);
    }
    static create(source) {
      return new AnimatedArray(source);
    }
    getValue() {
      return this.source.map(node => node.getValue());
    }
    setValue(source) {
      const payload = this.getPayload();
      if (source.length == payload.length) {
        return payload.map((node, i) => node.setValue(source[i])).some(Boolean);
      }
      super.setValue(source.map(makeAnimated));
      return true;
    }
  }
  function makeAnimated(value) {
    const nodeType = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isAnimatedString */"u"])(value) ? AnimatedString : AnimatedValue;
    return nodeType.create(value);
  }
  function getAnimatedType(value) {
    const parentNode = getAnimated(value);
    return parentNode ? parentNode.constructor : _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].arr(value) ? AnimatedArray : Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isAnimatedString */"u"])(value) ? AnimatedString : AnimatedValue;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  const withAnimated = (Component, host) => {
    const hasInstance = !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return Object(react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"])((givenProps, givenRef) => {
      const instanceRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])(null);
      const ref = hasInstance && Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(value => {
        instanceRef.current = updateRef(givenRef, value);
      }, [givenRef]);
      const [props, deps] = getAnimatedState(givenProps, host);
      const forceUpdate = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useForceUpdate */"D"])();
      const callback = () => {
        const instance = instanceRef.current;
        if (hasInstance && !instance) {
          return;
        }
        const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
        if (didUpdate === false) {
          forceUpdate();
        }
      };
      const observer = new PropsObserver(callback, deps);
      const observerRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])();
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useIsomorphicLayoutEffect */"E"])(() => {
        observerRef.current = observer;
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(deps, dep => Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* addFluidObserver */"c"])(dep, observer));
        return () => {
          if (observerRef.current) {
            Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(observerRef.current.deps, dep => Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* removeFluidObserver */"A"])(dep, observerRef.current));
            _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].cancel(observerRef.current.update);
          }
        };
      });
      Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(callback, []);
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useOnce */"G"])(() => () => {
        const observer = observerRef.current;
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(observer.deps, dep => Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* removeFluidObserver */"A"])(dep, observer));
      });
      const usedProps = host.getComponentProps(props.getValue());
      return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Component, _extends({}, usedProps, {
        ref: ref
      }));
    });
  };
  class PropsObserver {
    constructor(update, deps) {
      this.update = update;
      this.deps = deps;
    }
    eventObserved(event) {
      if (event.type == 'change') {
        _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].write(this.update);
      }
    }
  }
  function getAnimatedState(props, host) {
    const dependencies = new Set();
    TreeContext.dependencies = dependencies;
    if (props.style) props = _extends({}, props, {
      style: host.createAnimatedStyle(props.style)
    });
    props = new AnimatedObject(props);
    TreeContext.dependencies = null;
    return [props, dependencies];
  }
  function updateRef(ref, value) {
    if (ref) {
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(ref)) ref(value);else ref.current = value;
    }
    return value;
  }
  const cacheKey = Symbol.for('AnimatedComponent');
  const createHost = (components, {
    applyAnimatedValues: _applyAnimatedValues = () => false,
    createAnimatedStyle: _createAnimatedStyle = style => new AnimatedObject(style),
    getComponentProps: _getComponentProps = props => props
  } = {}) => {
    const hostConfig = {
      applyAnimatedValues: _applyAnimatedValues,
      createAnimatedStyle: _createAnimatedStyle,
      getComponentProps: _getComponentProps
    };
    const animated = Component => {
      const displayName = getDisplayName(Component) || 'Anonymous';
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].str(Component)) {
        Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
      } else {
        Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
      }
      Component.displayName = `Animated(${displayName})`;
      return Component;
    };
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* eachProp */"l"])(components, (Component, key) => {
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].arr(components)) {
        key = getDisplayName(Component);
      }
      animated[key] = animated(Component);
    });
    return {
      animated
    };
  };
  const getDisplayName = arg => _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].str(arg) ? arg : arg && _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].str(arg.displayName) ? arg.displayName : _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(arg) && arg.name || null;

  /***/
}, /* 27 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.PROPTYPE_THEME = void 0;
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  var PROPTYPE_THEME = _propTypes["default"].oneOf(['default', 'primary', 'white', 'blue', 'purple', 'pink', 'orange', 'green', 'red', 'grey', 'yellow', 'teal']);

  /* isNumeric -- ensures that we check for what we are actually expecting (a number, 123, or a numeric string, "123")
   * use when declaring propTypes like { id:isNumeric }
   * the API sometimes returns ids in string form even if they're numeric (ie "123")
   * PropTypes.number returns an error in that case, but this is valid for our purposes
   */
  exports.PROPTYPE_THEME = PROPTYPE_THEME;
  var NUM_PATTERN = /^[+-]?\d+(\.\d+)?$/;
  var isNumeric = function isNumeric(props, propName, componentName) {
    var val = props[propName];
    if (typeof val === "boolean" || val && !NUM_PATTERN.test(val)) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ", expected number."));
    }
  };
  var isNumericRequired = function isNumericRequired(props, propName, componentName) {
    var val = props[propName];
    if (!val || typeof val === "boolean" || val && !NUM_PATTERN.test(val)) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ", expected number."));
    }
  };
  var PROP_VALIDATORS = {
    isNumeric: isNumeric,
    isNumericRequired: isNumericRequired
  };
  var _default = PROP_VALIDATORS;
  exports["default"] = _default;

  /***/
}, /* 28 */
/***/function (module, exports) {
  module.exports = require("moment");

  /***/
}, /* 29 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getValueLength = exports.getHideCharCountRedux = exports["default"] = exports.MULTIPLE_ENTRIES = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _lodash = __webpack_require__(57);
  var _SharedPropTypes = __webpack_require__(27);
  var _generateUnique = _interopRequireDefault(__webpack_require__(56));
  var _Tooltip = _interopRequireDefault(__webpack_require__(40));
  var _EnhancedTooltip = _interopRequireDefault(__webpack_require__(58));
  var _excluded = ["label", "required", "meta", "showPristineErrors", "tooltipVersion"];
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var MULTIPLE_ENTRIES = '[Multiple Entries]';
  exports.MULTIPLE_ENTRIES = MULTIPLE_ENTRIES;
  var getValueLength = function getValueLength() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var inputValue = arguments.length > 1 ? arguments[1] : undefined;
    if (typeof inputValue === 'string') {
      if (inputValue.length) {
        return inputValue.length;
      } else {
        var selectedValue = (0, _lodash.get)(value, 'value', '');
        if (!isNaN(selectedValue)) {
          var labelVal = (0, _lodash.get)(value, 'label', '');
          if (isNaN(labelVal)) {
            return 0;
          }
          return labelVal.length;
        }
        return selectedValue.length;
      }
    }
    var valLen = (0, _lodash.get)(value, "length", 0);
    return valLen;
  };
  exports.getValueLength = getValueLength;
  var getHideCharCountRedux = function getHideCharCountRedux(_ref, inputValue) {
    var active = _ref.active,
      invalid = _ref.invalid,
      visited = _ref.visited;
    if (!visited) {
      return true;
    }
    if (!active && !invalid) {
      return true;
    }
    if (inputValue !== undefined && !inputValue) {
      return true;
    }
    return false;
  };
  exports.getHideCharCountRedux = getHideCharCountRedux;
  var isMultipleValues = function isMultipleValues(_ref2) {
    var meta = _ref2.meta,
      value = _ref2.value;
    if (!value || !meta || !meta.initial) {
      return false;
    }
    var initial = meta.initial;
    if (initial.hasOwnProperty('startDate') && initial.hasOwnProperty('endDate')) {
      var multipleValues = [];
      ['startDate', 'endDate'].forEach(function (range) {
        if (initial[range] === MULTIPLE_ENTRIES && value[range] === MULTIPLE_ENTRIES) {
          multipleValues.push(range);
        }
      });
      // Return boolean true if both ranges are multi - otherwise specify which
      if (multipleValues.length === 1) {
        return multipleValues[0];
      } else {
        return !!multipleValues.length;
      }
    } else {
      return initial === MULTIPLE_ENTRIES && value === MULTIPLE_ENTRIES;
    }
  };
  function tipPropValidator(props, propName, componentName) {
    if (!props.tip) {
      return null;
    }
    var shape;
    if (props.tooltipVersion === 1) {
      shape = {
        description: _propTypes["default"].string,
        inline: _propTypes["default"].bool,
        direction: _propTypes["default"].oneOf(['left', 'right', 'top', 'bottom']),
        size: _propTypes["default"].oneOf(['small', 'medium', 'large', 'xlarge', 'fit']),
        iconSize: _propTypes["default"].oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge'])
      };
    } else if (props.tooltipVersion === 2) {
      shape = {
        place: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left']).isRequired,
        type: _propTypes["default"].oneOf(['dark', 'success', 'warning', 'error', 'info', 'light']),
        effect: _propTypes["default"].oneOf(['float', 'solid']),
        html: _propTypes["default"].bool
      };
    }
    _propTypes["default"].checkPropTypes(shape, props.tip, "props", componentName);
  }
  function ControlWrapper(Composed) {
    var _class, _class2;
    return _class = (_class2 = /*#__PURE__*/function (_React$Component) {
      _inherits(Wrapper, _React$Component);
      var _super = _createSuper(Wrapper);
      function Wrapper(props, context) {
        var _this;
        _classCallCheck(this, Wrapper);
        _this = _super.call(this, props, context);
        _this.UID = (0, _generateUnique["default"])(props);
        _this.noLabel = Composed.displayName === "Checkbox" && !props.hasHeader || Composed.displayName === "TagGroup";
        _this.state = {};
        return _this;
      }
      _createClass(Wrapper, [{
        key: "getChildContext",
        value: function getChildContext() {
          return {
            iconClassPrefix: "e-form__control--icon e-form__control--icon-".concat(this.props.iconPos)
          };
        }

        /* handleInputChange(string, { action: oneOf['set-value', 'input-change', 'input-blur', 'menu-close']})
         *	this function is here instead of Select.jsx so that charCount will work
         *  this function also handles onSelectResetsInput, which was handled in react-select v1 but removed in v2+
         */
      }, {
        key: "handleInputChange",
        value: function handleInputChange(inputValue, obj) {
          var _this$props = this.props,
            onInputChange = _this$props.onInputChange,
            allowCreate = _this$props.allowCreate,
            onSelectResetsInput = _this$props.onSelectResetsInput,
            allowReset = _typeof(onSelectResetsInput) && !onSelectResetsInput && obj && obj.action !== "set-value";
          !!onInputChange && onInputChange(inputValue, obj);
          if (allowCreate || allowReset) {
            this.setState({
              inputValue: inputValue
            });
            return inputValue;
          }
        }

        /* eslint-disable */
      }, {
        key: "getLabel",
        value: function getLabel() {
          var label = this.props.label;
          return !this.noLabel && !!label ? /*#__PURE__*/_react["default"].createElement("label", {
            htmlFor: this.UID,
            className: "e-form__control-label"
          }, label) : null;
        }
        /* eslint-enable */

        /*eslint-disable*/
      }, {
        key: "getToolTip",
        value: function getToolTip() {
          var _this$props2 = this.props,
            tip = _this$props2.tip,
            tooltipVersion = _this$props2.tooltipVersion;
          if (!(0, _lodash.get)(tip, 'description')) {
            return null;
          }
          if (tooltipVersion === 1) {
            return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], _extends({}, tip, {
              className: "e-form__control-description"
            }));
          }
          if (tooltipVersion === 2) {
            return /*#__PURE__*/_react["default"].createElement("span", {
              className: "u-form__help",
              "aria-label": tip.description.trim()
            }, /*#__PURE__*/_react["default"].createElement("i", {
              className: "fa fa-info-circle",
              "data-tip": true,
              "data-for": this.UID,
              "data-html": tip.html,
              "aria-label": "Get Info"
            }), /*#__PURE__*/_react["default"].createElement(_EnhancedTooltip["default"], _extends({}, tip, {
              id: this.UID,
              content: tip.description
            })));
          }
        }
        /* eslint-enable */
      }, {
        key: "_renderCharCount",
        value: function _renderCharCount() {
          var _this$props3 = this.props,
            charMax = _this$props3.charMax,
            name = _this$props3.name,
            required = _this$props3.required,
            value = _this$props3.value,
            meta = _this$props3.meta;
          var inputValue = this.state.inputValue;
          if (!charMax) {
            console.warn("props.showCharCount set to true on input[name=".concat(name, "] but props.charMax is not set"));
            return null;
          }
          var length = getValueLength(value, inputValue);
          var classes = (0, _classnames["default"])('char-count', {
            valid: length <= charMax && (!required || required && length > 0),
            invalid: length > charMax || required && length < 1,
            hidden: !!meta ? getHideCharCountRedux(meta, inputValue) : false
          });
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: classes
          }, "".concat(length, "/").concat(charMax));
        }
      }, {
        key: "_renderHeader",
        value: function _renderHeader() {
          var showCharCount = this.props.showCharCount;
          var label = this.getLabel();
          var toolTip = this.getToolTip();
          if (showCharCount || !!label || !!toolTip) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: "e-form__control-header"
            }, label, toolTip, showCharCount && this._renderCharCount());
          }
        }
      }, {
        key: "_renderMessage",
        value: function _renderMessage() {
          var _this$props4 = this.props,
            meta = _this$props4.meta,
            showPristineErrors = _this$props4.showPristineErrors,
            classes = {
              "warning-message": true
            },
            $message = null,
            useDirty = Composed.displayName === "TagGroup";
          if (!meta || !showPristineErrors && !useDirty && !meta.touched || !showPristineErrors && useDirty && !meta.dirty) {
            return null;
          }
          if (meta) {
            if (meta.warning) {
              classes["has-warning"] = true;
              $message = meta.warning;
            } else if (meta.error) {
              classes["has-error"] = true;
              $message = meta.error;
            }
          }

          // if we haven't set a $message, return nothing, this prevents minute height changes
          return $message ? /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _classnames["default"])(classes)
          }, $message) : null;
        }
      }, {
        key: "render",
        value: function render() {
          var _wrapperClasses,
            _this2 = this;
          var _this$props5 = this.props,
            label = _this$props5.label,
            required = _this$props5.required,
            meta = _this$props5.meta,
            showPristineErrors = _this$props5.showPristineErrors,
            tooltipVersion = _this$props5.tooltipVersion,
            remainderProps = _objectWithoutProperties(_this$props5, _excluded),
            multipleValues = isMultipleValues(this.props),
            isCheckboxComponent = /checkbox/gi.test(Composed.displayName),
            isCheckboxList = isCheckboxComponent && /list/gi.test(Composed.displayName),
            wrapperClasses = (_wrapperClasses = {}, _defineProperty(_wrapperClasses, this.props.className, true), _defineProperty(_wrapperClasses, "required", !!required), _defineProperty(_wrapperClasses, "has-tooltip", !!this.getToolTip()), _defineProperty(_wrapperClasses, "empty-label", !label), _defineProperty(_wrapperClasses, "e-form__control-wrapper", true), _defineProperty(_wrapperClasses, "checkbox-component", isCheckboxComponent && !isCheckboxList), _defineProperty(_wrapperClasses, "has-label", !this.noLabel), _defineProperty(_wrapperClasses, "no-label", this.noLabel), _defineProperty(_wrapperClasses, "text-area-control", remainderProps.type && remainderProps.type === "textarea"), _defineProperty(_wrapperClasses, "multiple-values", !!multipleValues), _wrapperClasses),
            $message = this._renderMessage(),
            mixedProps = Object.assign({}, remainderProps);
          if (meta) {
            wrapperClasses = _objectSpread(_objectSpread({}, wrapperClasses), {}, {
              "e-form--pristine": meta.pristine,
              "e-form--valid": meta.valid && (meta.initial || meta.dirty),
              "e-form--warn": meta.warning && (meta.touched || meta.visited || showPristineErrors),
              "e-form--has-message": !!$message
            });
            if (!meta.active) {
              wrapperClasses["e-form--error"] = (meta.invalid || meta.error) && (meta.touched || meta.visited || showPristineErrors);
            }
          }
          if (Composed.displayName === "Input") {
            mixedProps.required = required;
          }
          if (Composed.displayName === "Select") {
            mixedProps.onInputChange = this.handleInputChange;
            // onSelectResetsInput was removed from react-select in 2.x and inputValue should be used instead
            if (typeof remainderProps.onSelectResetsInput === "boolean" && !remainderProps.onSelectResetsInput && this.state.inputValue) {
              mixedProps.inputValue = this.state.inputValue;
            }
          }
          if (Composed.displayName === "Dates") {
            mixedProps.multipleValues = multipleValues;
          }
          if (Composed.displayName === "Checkbox") {
            mixedProps.tooltipVersion = tooltipVersion;
          }
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _classnames["default"])(wrapperClasses)
          }, this._renderHeader(), /*#__PURE__*/_react["default"].createElement(Composed, _extends({
            UID: this.UID,
            label: label,
            ref: function ref(cmp) {
              return _this2.composedComponent = cmp;
            }
          }, mixedProps)), $message);
        }
      }]);
      return Wrapper;
    }(_react["default"].Component), _defineProperty(_class2, "displayName", "".concat(Composed.displayName, "-Control-Wrapper")), _defineProperty(_class2, "propTypes", {
      /** Label to display on the given control */
      label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].node]).isRequired,
      /** Is this field required in the form */
      required: _propTypes["default"].bool,
      /** Tooltip to display after the label*/
      tip: tipPropValidator,
      /** Class name for the control */
      className: _propTypes["default"].string,
      /** */
      showPristineErrors: _propTypes["default"].bool,
      /** v1 uses <Tooltip />, v2 uses <EnhancedTooltip /> */
      tooltipVersion: _propTypes["default"].oneOf([1, 2]) // eslint-disable-line no-magic-numbers
      /*
      	Version 1 uses css tooltips
      	Version 2 uses javascript tooltips
      */
    }), _defineProperty(_class2, "contextTypes", {
      rhombusTheme: _SharedPropTypes.PROPTYPE_THEME
    }), _defineProperty(_class2, "childContextTypes", {
      iconClassPrefix: _propTypes["default"].string
    }), _defineProperty(_class2, "defaultProps", {
      label: "",
      className: "",
      required: false,
      tip: {
        description: "",
        inline: false,
        direction: 'left',
        size: 'fit',
        iconSize: 'small'
      },
      showPristineErrors: false,
      tooltipVersion: 1
    }), _class2), _applyDecoratedDescriptor(_class.prototype, "handleInputChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "handleInputChange"), _class.prototype), _class;
  }
  var _default = ControlWrapper;
  exports["default"] = _default;

  /***/
}, /* 30 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
  };
  function isEqual(first, second) {
    if (first === second) {
      return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
      return true;
    }
    return false;
  }
  function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
      return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
      if (!isEqual(newInputs[i], lastInputs[i])) {
        return false;
      }
    }
    return true;
  }
  function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) {
      isEqual = areInputsEqual;
    }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
      var newArgs = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        newArgs[_i] = arguments[_i];
      }
      if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
        return lastResult;
      }
      lastResult = resultFn.apply(this, newArgs);
      calledOnce = true;
      lastThis = this;
      lastArgs = newArgs;
      return lastResult;
    }
    return memoized;
  }

  /* harmony default export */
  __webpack_exports__["a"] = memoizeOne;

  /***/
}, /* 31 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return manageState;
  });
  /* harmony import */
  var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22);
  /* harmony import */
  var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
  /* harmony import */
  var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
  /* harmony import */
  var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13);
  /* harmony import */
  var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14);
  /* harmony import */
  var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16);
  /* harmony import */
  var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */"a"])(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */"a"])(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__[/* default */"a"])(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
  };
  var manageState = function manageState(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/function (_Component) {
      Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__[/* default */"a"])(StateManager, _Component);
      var _super = _createSuper(StateManager);
      function StateManager() {
        var _this;
        Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__[/* default */"a"])(this, StateManager);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _this.select = void 0;
        _this.state = {
          inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
          menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
          value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
        };
        _this.onChange = function (value, actionMeta) {
          _this.callProp('onChange', value, actionMeta);
          _this.setState({
            value: value
          });
        };
        _this.onInputChange = function (value, actionMeta) {
          // TODO: for backwards compatibility, we allow the prop to return a new
          // value, but now inputValue is a controllable prop we probably shouldn't
          var newValue = _this.callProp('onInputChange', value, actionMeta);
          _this.setState({
            inputValue: newValue !== undefined ? newValue : value
          });
        };
        _this.onMenuOpen = function () {
          _this.callProp('onMenuOpen');
          _this.setState({
            menuIsOpen: true
          });
        };
        _this.onMenuClose = function () {
          _this.callProp('onMenuClose');
          _this.setState({
            menuIsOpen: false
          });
        };
        return _this;
      }
      Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__[/* default */"a"])(StateManager, [{
        key: "focus",
        value: function focus() {
          this.select.focus();
        }
      }, {
        key: "blur",
        value: function blur() {
          this.select.blur();
        } // FIXME: untyped flow code, return any
      }, {
        key: "getProp",
        value: function getProp(key) {
          return this.props[key] !== undefined ? this.props[key] : this.state[key];
        } // FIXME: untyped flow code, return any
      }, {
        key: "callProp",
        value: function callProp(name) {
          if (typeof this.props[name] === 'function') {
            var _this$props;
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            return (_this$props = this.props)[name].apply(_this$props, args);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;
          var _this$props2 = this.props,
            defaultInputValue = _this$props2.defaultInputValue,
            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
            defaultValue = _this$props2.defaultValue,
            props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"])(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(SelectComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */"a"])({}, props, {
            ref: function ref(_ref) {
              _this2.select = _ref;
            },
            inputValue: this.getProp('inputValue'),
            menuIsOpen: this.getProp('menuIsOpen'),
            onChange: this.onChange,
            onInputChange: this.onInputChange,
            onMenuClose: this.onMenuClose,
            onMenuOpen: this.onMenuOpen,
            value: this.getProp('value')
          }));
        }
      }]);
      return StateManager;
    }(react__WEBPACK_IMPORTED_MODULE_7__["Component"]), _class.defaultProps = defaultProps, _temp;
  };

  /***/
}, /* 32 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return (/* binding */serialize_browser_esm_serializeStyles
    );
  });

  // CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/hash.browser.esm.js
  /* eslint-disable */
  // Inspired by https://github.com/garycourt/murmurhash-js
  // Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
  function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash

    var k,
      i = 0,
      len = str.length;
    for (; len >= 4; ++i, len -= 4) {
      k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
      k = /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
      k ^= /* k >>> r: */
      k >>> 24;
      h = /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array

    switch (len) {
      case 3:
        h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
      case 2:
        h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
      case 1:
        h ^= str.charCodeAt(i) & 0xff;
        h = /* Math.imul(h, m): */
        (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.

    h ^= h >>> 13;
    h = /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
  }

  /* harmony default export */
  var hash_browser_esm = murmur2;

  // CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
  var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };

  /* harmony default export */
  var unitless_browser_esm = unitlessKeys;

  // CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
  function memoize(fn) {
    var cache = {};
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  /* harmony default export */
  var memoize_browser_esm = memoize;

  // CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/serialize.browser.esm.js

  var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
  var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
  var hyphenateRegex = /[A-Z]|^ms/g;
  var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
  var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
  };
  var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
  };
  var processStyleName = memoize_browser_esm(function (styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
  });
  var serialize_browser_esm_processStyleValue = function processStyleValue(key, value) {
    switch (key) {
      case 'animation':
      case 'animationName':
        {
          if (typeof value === 'string') {
            return value.replace(animationRegex, function (match, p1, p2) {
              cursor = {
                name: p1,
                styles: p2,
                next: cursor
              };
              return p1;
            });
          }
        }
    }
    if (unitless_browser_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
      return value + 'px';
    }
    return value;
  };
  if (false) {
    var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern;
  }
  var shouldWarnAboutInterpolatingClassNameFromCss = true;
  function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }
    if (interpolation.__emotion_styles !== undefined) {
      if (false) {}
      return interpolation;
    }
    switch (typeof interpolation) {
      case 'boolean':
        {
          return '';
        }
      case 'object':
        {
          if (interpolation.anim === 1) {
            cursor = {
              name: interpolation.name,
              styles: interpolation.styles,
              next: cursor
            };
            return interpolation.name;
          }
          if (interpolation.styles !== undefined) {
            var next = interpolation.next;
            if (next !== undefined) {
              // not the most efficient thing ever but this is a pretty rare case
              // and there will be very few iterations of this generally
              while (next !== undefined) {
                cursor = {
                  name: next.name,
                  styles: next.styles,
                  next: cursor
                };
                next = next.next;
              }
            }
            var styles = interpolation.styles + ";";
            if (false) {}
            return styles;
          }
          return createStringFromObject(mergedProps, registered, interpolation);
        }
      case 'function':
        {
          if (mergedProps !== undefined) {
            var previousCursor = cursor;
            var result = interpolation(mergedProps);
            cursor = previousCursor;
            return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
          } else if (false) {}
          break;
        }
      case 'string':
        if (false) {
          var replaced, matched;
        }
        break;
    } // finalize string values (regular strings and functions interpolated into css calls)

    if (registered == null) {
      return interpolation;
    }
    var cached = registered[interpolation];
    if (false) {}
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
  }
  function createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
        string += handleInterpolation(mergedProps, registered, obj[i], false);
      }
    } else {
      for (var _key in obj) {
        var value = obj[_key];
        if (typeof value !== 'object') {
          if (registered != null && registered[value] !== undefined) {
            string += _key + "{" + registered[value] + "}";
          } else if (isProcessableValue(value)) {
            string += processStyleName(_key) + ":" + serialize_browser_esm_processStyleValue(_key, value) + ";";
          }
        } else {
          if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }
          if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for (var _i = 0; _i < value.length; _i++) {
              if (isProcessableValue(value[_i])) {
                string += processStyleName(_key) + ":" + serialize_browser_esm_processStyleValue(_key, value[_i]) + ";";
              }
            }
          } else {
            var interpolated = handleInterpolation(mergedProps, registered, value, false);
            switch (_key) {
              case 'animation':
              case 'animationName':
                {
                  string += processStyleName(_key) + ":" + interpolated + ";";
                  break;
                }
              default:
                {
                  if (false) {}
                  string += _key + "{" + interpolated + "}";
                }
            }
          }
        }
      }
    }
    return string;
  }
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
  var sourceMapPattern;
  if (false) {} // this is the cursor for keyframes
  // keyframes are stored on the SerializedStyles object as a linked list

  var cursor;
  var serialize_browser_esm_serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
      return args[0];
    }
    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation(mergedProps, registered, strings, false);
    } else {
      if (false) {}
      styles += strings[0];
    } // we start at 1 since we've already handled the first arg

    for (var i = 1; i < args.length; i++) {
      styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
      if (stringMode) {
        if (false) {}
        styles += strings[i];
      }
    }
    var sourceMap;
    if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time

    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

    while ((match = labelPattern.exec(styles)) !== null) {
      identifierName += '-' +
      // $FlowFixMe we know it's not null
      match[1];
    }
    var name = hash_browser_esm(styles) + identifierName;
    if (false) {}
    return {
      name: name,
      styles: styles,
      next: cursor
    };
  };

  /***/
}, /* 33 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.findParent = findParent;
  exports.formatBytes = formatBytes;
  exports.genSelectOpts = genSelectOpts;
  exports.getDomainFromUrl = getDomainFromUrl;
  exports.getEnvironmentName = getEnvironmentName;
  exports.navigateBack = navigateBack;
  exports.noop = noop;
  exports.normalizeNumbers = normalizeNumbers;
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  /**
   * Base Helper functions
   */
  function noop() {}
  function getEnvironmentName(env) {
    var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['dev', 'qa', 'stg'];
    var test = env.toLowerCase();
    if (display.includes(test)) {
      if (test === 'dev') {
        return test;
      }
      return test.toUpperCase();
    }
    return null;
  }
  function defaultGenerator(val) {
    if (_typeof(val) === 'object') {
      return val[Object.keys(val)[0]];
    } else {
      return val;
    }
  }
  var defaultKeys = ['name', 'label', 'id', 'value'];
  function genSelectOpts(values) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultKeys;
    var generator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultGenerator;
    if (!Array.isArray(values)) {
      console.warn('genSelectOpts(values) expected an array of option values.');
      return [];
    }
    if (!Array.isArray(keys)) {
      console.warn('genSelectOpts(values, ?keys) received an optional parameter of `keys` of non-array type, falling back to default keys.');
      keys = defaultKeys;
    }
    if (typeof generator !== 'function') {
      console.warn('genSelectOpts(values, ?keys, ?generator) received an optional parameter of `generator` of non-function type, falling back to default generator.');
      generator = defaultGenerator;
    }
    return values.map(function (value) {
      var opt = _typeof(value) === 'object' ? _objectSpread({}, value) : {};
      keys.forEach(function (key) {
        if (!opt.hasOwnProperty(key)) {
          /***
          ** Optionally allow a user to pass a custom value generator function
          ** Example:
          ** const customGenerator = (val, key) => key === 'id' ? val.toLowerCase() : val;
          ***/
          opt[key] = generator(value, key);
        }
      });
      return opt;
    });
  }

  /* ensure entered value is within the bounds set on the input
   * solves for an issue with <input/> where using the arrow works with min/max, but typing disregards min/max
   */
  function normalizeNumbers(value, min, max) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "int";
    var val = type === "int" ? parseInt(value) : parseFloat(value);
    if (!isNaN(min) && val < min) {
      return min;
    }
    if (!isNaN(max) && val > max) {
      return max;
    }
    if (!isNaN(val)) {
      return val.toString();
    }
    return value;
  }

  /**
   * Converts bytes to KB/MB
   * Function from:
   * 	https://stackoverflow.com/a/18650828
   */
  var KILO = 1024,
    SIZES = ["Bytes", "KB", "MB", "GB", "TB"],
    DIM_PLACES = 2;
  function formatBytes(value) {
    var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIM_PLACES;
    var bytes = parseFloat(value),
      logPower = 0,
      kibs = 0,
      size = null;
    if (bytes === 0) {
      return "0 Bytes";
    }
    if (isNaN(bytes)) {
      return "--";
    }
    logPower = Math.floor(Math.log(bytes) / Math.log(KILO));
    kibs = parseFloat((bytes / Math.pow(KILO, logPower)).toFixed(places));
    size = SIZES[logPower];
    return "".concat(kibs, " ").concat(size);
  }

  /**
   * findParent()	Given the element, find the given parent node based on the querySelector
   * 	If the loop reaches the document, then we end the loop and return null
   * 	Code example provided by:
   * 		https://gomakethings.com/climbing-up-and-down-the-dom-tree-with-vanilla-javascript/
   *
   * @param  {DOM Node} elem          DOM node of item we've selected in some fashion
   * @param  {string} querySelector 	Valid QuerySelector of the parent Node we're looking for
   * @return {null|DOM Node}          Found DOM Node, or null if not found
   */
  function findParent(elem, querySelector) {
    if (!querySelector || querySelector === "") {
      throw "Missing parent selector, exiting";
    }
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (elem.matches(querySelector)) {
        return elem;
      }
    }
    return null;
  }
  var NEW_TAB_LENGTH = 1;
  /**
   * [navigateBack description]
   * 		- Tries to navigate back in the browser's history
   * 			If there is only 1 entry in the history, that means that we likely came from a new tab
   * 			In that case, return false, and let our original function handle it
   *
   * @return {void|false}
   */
  function navigateBack() {
    if (window.history && window.history.length > NEW_TAB_LENGTH) {
      try {
        window.history.back();
        return true;
      } catch (err) {
        console.error("Couldn't Use window.history!");
      }
    }
    return false;
  }
  function getDomainFromUrl(url) {
    //get domain name from url
    try {
      return new URL(url).host;
    } catch (error) {
      console.error("Invalid URL: ", url);
      return "";
    }
  }

  /***/
}, /* 34 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.S = exports.R = exports.L = exports.D = exports.B = void 0;
  var _ICON_MAP;
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  /**
   * Icons
   * This is the mapping of all icons that should be used within FT applications
   * It's meant to be organized based around groupings of the icon types
   *
   * 	@1. App Icons
   * 		- Some of these are likely to change with raw SVG
   * 	@2. Business Objects
   * 	@3. Creative Types
   * 		- Some of these are deprecated/should be consolidated
   * 	@4. Actions
   * 	@5. Filters
   * 	@6. General
   */

  /*eslint-disable id-length*/
  var S = "fas";
  exports.S = S;
  var R = "far";
  exports.R = R;
  var L = "fal";
  exports.L = L;
  var B = "fab";
  exports.B = B;
  var D = "fad";
  exports.D = D;
  var ICON_MAP = (_ICON_MAP = {
    mediaBuyer: [S, "fa-city"],
    advertiser: [S, "fa-building"],
    campaign: [S, "fa-rocket"],
    site: [R, "fa-window-maximize"],
    placement: [R, "fa-newspaper"],
    creative: [R, "fa-image"],
    dtree: [S, "fa-sitemap"],
    modern_dtree: [S, "fa-sitemap"],
    hedge: [L, "fa-table"],
    creativeLibrary: [S, "fa-image"],
    addLibrary: [S, "fa-images"],
    summary: [S, "fa-gift"],
    dashboard: [S, "fa-tachometer-alt"],
    adStudio: [S, "fa-palette"],
    // Creative Types
    altgif: [R, "fa-file-image"],
    altimage: [R, "fa-file-image"],
    creativeimage: [R, "fa-file-image"],
    native_image: [R, "fa-file-image"],
    nativeimage: [R, "fa-file-image"],
    expand: [S, "fa-file-code"],
    "html onpage": [S, "fa-file-code"],
    html_expand: [S, "fa-file-code"],
    html_onpage: [S, "fa-file-code"],
    html_standard: [S, "fa-file-code"],
    onpage: [S, "fa-file-code"],
    onpage_standard: [S, "fa-file-code"],
    "onpage standard": [S, "fa-file-code"],
    standard_onpage: [S, "fa-file-code"],
    display_html_tag: [S, "fa-file-code"],
    dynamic_preroll: [S, "fa-file-video"],
    dynamicprefoll: [S, "fa-file-video"],
    jsvpaid: [S, "fa-file-video"],
    preroll: [S, "fa-file-video"],
    vpaid: [S, "fa-file-video"],
    vpaid_linear: [S, "fa-file-video"],
    vpaid_nonlinear: [S, "fa-file-video"],
    vast_tag: [S, "fa-file-video"],
    vastAudio: [S, "fa-file-audio"],
    vastaudio: [S, "fa-file-audio"],
    Audio: [S, "fa-file-audio"],
    audio: [S, "fa-file-audio"],
    //Social Creatives
    meta: [B, "fa-meta meta-logo"],
    facebook: [B, "fa-facebook facebook-logo"],
    facebookImage: [B, "fa-facebook facebook-logo"],
    facebookimage: [B, "fa-facebook facebook-logo"],
    facebookVideo: [B, "fa-facebook facebook-logo"],
    facebookvideo: [B, "fa-facebook facebook-logo"],
    facebookCarousel: [B, "fa-facebook facebook-logo"],
    facebookcarousel: [B, "fa-facebook facebook-logo"],
    facebookImageMO: [B, "fa-meta meta-logo"],
    facebookimagemo: [B, "fa-meta meta-logo"],
    facebookVideoMO: [B, "fa-meta meta-logo"],
    facebookvideomo: [B, "fa-meta meta-logo"],
    facebookcarouselmo: [B, "fa-meta meta-logo"],
    facebookCarouselMO: [B, "fa-meta meta-logo"],
    instagram: [B, "fa-instagram instagram-logo"],
    instagramImage: [B, "fa-instagram instagram-logo"],
    instagramimage: [B, "fa-instagram instagram-logo"],
    instagramVideo: [B, "fa-instagram instagram-logo"],
    instagramvideo: [B, "fa-instagram instagram-logo"],
    youtube: [B, "fa-youtube youtube-logo"],
    youtubeImage: [B, "fa-youtube youtube-logo"],
    youtubeimage: [B, "fa-youtube youtube-logo"],
    youtubeVideo: [B, "fa-youtube youtube-logo"],
    youtubevideo: [B, "fa-youtube youtube-logo"],
    youTubeInStream: [B, "fa-youtube youtube-logo"],
    youtubeinstream: [B, "fa-youtube youtube-logo"],
    youTubeDiscovery: [B, "fa-youtube youtube-logo"],
    youtubediscovery: [B, "fa-youtube youtube-logo"],
    pinterest: [B, "fa-pinterest pinterest-logo"],
    pinterestImage: [B, "fa-pinterest pinterest-logo"],
    pinterestimage: [B, "fa-pinterest pinterest-logo"],
    pinterestVideo: [B, "fa-pinterest pinterest-logo"],
    pinterestvideo: [B, "fa-pinterest pinterest-logo"],
    pinterestMaxWVideo: [B, "fa-pinterest pinterest-logo"],
    pinterestmaxwvideo: [B, "fa-pinterest pinterest-logo"],
    pinterestCarousel: [B, "fa-pinterest pinterest-logo"],
    pinterestcarousel: [B, "fa-pinterest pinterest-logo"],
    snapchat: [B, "fa-snapchat snapchat-logo"],
    snapchatImage: [B, "fa-snapchat snapchat-logo"],
    snapchatimage: [B, "fa-snapchat snapchat-logo"],
    snapchatVideo: [B, "fa-snapchat snapchat-logo"],
    snapchatvideo: [B, "fa-snapchat snapchat-logo"],
    snap: [B, "fa-snapchat snapchat-logo"],
    snapImage: [B, "fa-snapchat snapchat-logo"],
    snapimage: [B, "fa-snapchat snapchat-logo"],
    snapVideo: [B, "fa-snapchat snapchat-logo"],
    snapvideo: [B, "fa-snapchat snapchat-logo"],
    twitter: [B, "fa-x-twitter x-twitter-logo"],
    twitterImage: [B, "fa-x-twitter x-twitter-logo"],
    twitterimage: [B, "fa-x-twitter x-twitter-logo"],
    twitterVideo: [B, "fa-x-twitter x-twitter-logo"],
    twittervideo: [B, "fa-x-twitter x-twitter-logo"],
    twitterCarousel: [B, "fa-x-twitter x-twitter-logo"],
    twittercarousel: [B, "fa-x-twitter x-twitter-logo"],
    linkedIn: [B, "fa-linkedin linkedin-logo"],
    linkedin: [B, "fa-linkedin linkedin-logo"],
    linkedInImage: [B, "fa-linkedin linkedin-logo"],
    linkedinimage: [B, "fa-linkedin linkedin-logo"],
    linkedInVideo: [B, "fa-linkedin linkedin-logo"],
    linkedinvideo: [B, "fa-linkedin linkedin-logo"],
    linkedInCarousel: [B, "fa-linkedin linkedin-logo"],
    linkedincarousel: [B, "fa-linkedin linkedin-logo"],
    tiktok: [B, "fa-tiktok tiktok-logo"],
    tiktokImage: [B, "fa-tiktok tiktok-logo"],
    tiktokimage: [B, "fa-tiktok tiktok-logo"],
    tiktokVideo: [B, "fa-tiktok tiktok-logo"],
    tiktokvideo: [B, "fa-tiktok tiktok-logo"],
    pixel: [S, "fa-square-full"],
    track: [S, "fa-square-full"],
    unknown: [S, "fa-thumbtack"],
    all: [S, "fa-folder"],
    recent: [S, "fa-clock"],
    closed: [S, "fa-archive"],
    add: [S, "fa-plus"],
    addNew: [S, "fa-plus"],
    alert: [R, "fa-bell"],
    alertAlt: [S, "fa-bell"],
    clear: [S, "fa-times"],
    clearCircle: [S, "fa-times-circle"],
    copy: [S, "fa-clone"],
    "delete": [S, "fa-trash-alt"],
    download: [S, "fa-download"]
  }, _defineProperty(_ICON_MAP, "import", [S, "fa-server"]), _defineProperty(_ICON_MAP, "duplicate", [R, "fa-clone"]), _defineProperty(_ICON_MAP, "edit", [S, "fa-pencil-alt"]), _defineProperty(_ICON_MAP, "email", [R, "fa-envelope"]), _defineProperty(_ICON_MAP, "externalLink", [S, "fa-external-link-alt"]), _defineProperty(_ICON_MAP, "favorite", [S, "fa-star"]), _defineProperty(_ICON_MAP, "filter", [S, "fa-filter"]), _defineProperty(_ICON_MAP, "group", [S, "fa-object-group"]), _defineProperty(_ICON_MAP, "history", [S, "fa-history"]), _defineProperty(_ICON_MAP, "info", [S, "fa-info"]), _defineProperty(_ICON_MAP, "infoC", [S, "fa-info-circle"]), _defineProperty(_ICON_MAP, "success", [S, "fa-check-circle"]), _defineProperty(_ICON_MAP, "link", [S, "fa-link"]), _defineProperty(_ICON_MAP, "moreHorizontal", [S, "fa-ellipsis-h"]), _defineProperty(_ICON_MAP, "moreVertical", [S, "fa-ellipsis-v"]), _defineProperty(_ICON_MAP, "notFavorite", [R, "fa-star"]), _defineProperty(_ICON_MAP, "preview", [S, "fa-eye"]), _defineProperty(_ICON_MAP, "profile", [S, "fa-user-circle"]), _defineProperty(_ICON_MAP, "refresh", [S, "fa-sync"]), _defineProperty(_ICON_MAP, "remove", [S, "fa-trash-alt"]), _defineProperty(_ICON_MAP, "save", [R, "fa-save"]), _defineProperty(_ICON_MAP, "search", [S, "fa-search"]), _defineProperty(_ICON_MAP, "stop", [S, "fa-ban"]), _defineProperty(_ICON_MAP, "upload", [S, "fa-upload"]), _defineProperty(_ICON_MAP, "cloudUpload", [S, "fa-cloud-upload-alt"]), _defineProperty(_ICON_MAP, "user", [S, "fa-user"]), _defineProperty(_ICON_MAP, "hidden", [S, "fa-eye-slash"]), _defineProperty(_ICON_MAP, "notHidden", [S, "fa-eye"]), _defineProperty(_ICON_MAP, "assetImage", [R, "fa-image-polaroid"]), _defineProperty(_ICON_MAP, "assetRichload", [S, "fa-code"]), _defineProperty(_ICON_MAP, "assetVideo", [S, "fa-video"]), _defineProperty(_ICON_MAP, "assetText", [S, "fa-font-case"]), _defineProperty(_ICON_MAP, "assetAudio", [S, "fa-volume"]), _defineProperty(_ICON_MAP, "assetsAfterEffects", [S, "fa-file-zipper"]), _defineProperty(_ICON_MAP, "assetsAftereffects", [S, "fa-file-zipper"]), _defineProperty(_ICON_MAP, "assetsaftereffects", [S, "fa-file-zipper"]), _defineProperty(_ICON_MAP, "assetsAfterEffect", [S, "fa-file-zipper"]), _defineProperty(_ICON_MAP, "assetsAftereffect", [S, "fa-file-zipper"]), _defineProperty(_ICON_MAP, "assetsaftereffect", [S, "fa-file-zipper"]), _defineProperty(_ICON_MAP, "draft", [S, "fa-dot-circle"]), _defineProperty(_ICON_MAP, "in-queue", [S, "fa-sync-alt"]), _defineProperty(_ICON_MAP, "generating", [S, "fa-sync-alt"]), _defineProperty(_ICON_MAP, "available", [S, "fa-dot-circle"]), _defineProperty(_ICON_MAP, "live", [S, "fa-circle"]), _defineProperty(_ICON_MAP, "stopped", [S, "fa-circle"]), _defineProperty(_ICON_MAP, "deleted", [S, "fa-minus-circle"]), _defineProperty(_ICON_MAP, "error", [S, "fa-exclamation-circle"]), _defineProperty(_ICON_MAP, "errorT", [S, "fa-exclamation-triangle"]), _defineProperty(_ICON_MAP, "rejected", [S, "fa-exclamation-circle"]), _defineProperty(_ICON_MAP, "approved", [S, "fa-check-circle"]), _defineProperty(_ICON_MAP, "active", [S, "fa-check-circle"]), _defineProperty(_ICON_MAP, "is-closed", [S, "fa-circle"]), _defineProperty(_ICON_MAP, "start-item", [R, "fa-flag"]), _defineProperty(_ICON_MAP, "stop-item", [S, "fa-stop-circle"]), _defineProperty(_ICON_MAP, "file-error", [L, "fa-file-exclamation"]), _defineProperty(_ICON_MAP, "file-success", [L, "fa-file-check"]), _defineProperty(_ICON_MAP, "users", [S, "fa-users"]), _defineProperty(_ICON_MAP, "spots", [S, "fa-binoculars"]), _defineProperty(_ICON_MAP, "changeDown", [S, "fa-arrow-down"]), _defineProperty(_ICON_MAP, "changeUp", [S, "fa-arrow-up"]), _defineProperty(_ICON_MAP, "creatives", [R, "fa-images"]), _defineProperty(_ICON_MAP, "editAlt", [R, "fa-edit"]), _defineProperty(_ICON_MAP, "package", [S, "fa-box"]), _defineProperty(_ICON_MAP, "calendar", [S, "fa-calendar"]), _defineProperty(_ICON_MAP, "processors", [S, "fa-code"]), _defineProperty(_ICON_MAP, "dTreeLogo", [S, "fa-tree"]), _defineProperty(_ICON_MAP, "fullScreen", [S, "fa-expand-arrows-alt"]), _defineProperty(_ICON_MAP, "expandAll", [R, "fa-expand-alt"]), _defineProperty(_ICON_MAP, "collapseAll", [R, "fa-compress-alt"]), _defineProperty(_ICON_MAP, "zoomOut", [S, "fa-search-minus"]), _defineProperty(_ICON_MAP, "zoomIn", [S, "fa-search-plus"]), _defineProperty(_ICON_MAP, "left", [S, "fa-arrow-left"]), _defineProperty(_ICON_MAP, "right", [S, "fa-arrow-right"]), _defineProperty(_ICON_MAP, "cut", [S, "fa-cut"]), _defineProperty(_ICON_MAP, "copyAlt", [S, "fa-copy"]), _defineProperty(_ICON_MAP, "paste", [S, "fa-paste"]), _defineProperty(_ICON_MAP, "treeVideo", [L, "fa-video"]), _defineProperty(_ICON_MAP, "treeDisplay", [L, "fa-image"]), _defineProperty(_ICON_MAP, "treeNative", [L, "fa-ballot"]), _defineProperty(_ICON_MAP, "th", [S, "fa-th"]), _defineProperty(_ICON_MAP, "decision_set", [S, "fa-tasks"]), _defineProperty(_ICON_MAP, "browserAndDevice", [L, "fa-desktop-alt"]), _defineProperty(_ICON_MAP, "connection", [L, "fa-wifi"]), _defineProperty(_ICON_MAP, "contextual", [L, "fa-memo-circle-check"]), _defineProperty(_ICON_MAP, "dayOfWeek", [L, "fa-calendar"]), _defineProperty(_ICON_MAP, "dmp", [L, "fa-users"]), _defineProperty(_ICON_MAP, "DMP", [L, "fa-users"]), _defineProperty(_ICON_MAP, "grapeshot", [L, "fa-file-alt"]), _defineProperty(_ICON_MAP, "isp", [L, "fa-broadcast-tower"]), _defineProperty(_ICON_MAP, "keyword", [L, "fa-key"]), _defineProperty(_ICON_MAP, "language", [L, "fa-comments"]), _defineProperty(_ICON_MAP, "languages", [L, "fa-comments"]), _defineProperty(_ICON_MAP, "geo", [L, "fa-globe-americas"]), _defineProperty(_ICON_MAP, "geoProximity", [L, "fa-map-marker-alt"]), _defineProperty(_ICON_MAP, "zipCodeGroup", [L, "fa-map-marked-alt"]), _defineProperty(_ICON_MAP, "mobileCarrier", [L, "fa-mobile-android-alt"]), _defineProperty(_ICON_MAP, "retargeting", [L, "fa-bullseye-pointer"]), _defineProperty(_ICON_MAP, "scheduling", [L, "fa-calendar-alt"]), _defineProperty(_ICON_MAP, "timeOfDay", [L, "fa-clock"]), _defineProperty(_ICON_MAP, "weather", [L, "fa-cloud-sun"]), _defineProperty(_ICON_MAP, "yahoo", [B, "fa-yahoo"]), _defineProperty(_ICON_MAP, "abTest", [L, "fa-vials"]), _defineProperty(_ICON_MAP, "autoOptimization", [L, "fa-chart-line"]), _defineProperty(_ICON_MAP, "sequence", [L, "fa-list-ol"]), _defineProperty(_ICON_MAP, "rotation", [L, "fa-balance-scale"]), _defineProperty(_ICON_MAP, "addCircle", [L, "fa-plus-circle"]), _defineProperty(_ICON_MAP, "addCircleSolid", [S, "fa-plus-circle"]), _defineProperty(_ICON_MAP, "removeCircle", [R, "fa-times-circle"]), _defineProperty(_ICON_MAP, "expandNode", [R, "fa-plus"]), _defineProperty(_ICON_MAP, "collapseNode", [R, "fa-minus"]), _defineProperty(_ICON_MAP, "checked", [L, "fa-check-square"]), _defineProperty(_ICON_MAP, "partialCheck", [L, "fa-minus-square"]), _defineProperty(_ICON_MAP, "unchecked", [L, "fa-square"]), _defineProperty(_ICON_MAP, "question", [S, "fa-question-circle"]), _defineProperty(_ICON_MAP, "dataSources", [S, "fa-table"]), _defineProperty(_ICON_MAP, "productSets", [S, "fa-shopping-cart"]), _defineProperty(_ICON_MAP, "rss", [S, "fa-rss"]), _defineProperty(_ICON_MAP, "chevronLeft", [S, "fa-chevron-left"]), _defineProperty(_ICON_MAP, "chevronRight", [S, "fa-chevron-right"]), _defineProperty(_ICON_MAP, "loading", [S, "fa-circle-notch"]), _defineProperty(_ICON_MAP, "pause", [S, "fa-pause"]), _defineProperty(_ICON_MAP, "settings", [S, "fa-sliders-v"]), _defineProperty(_ICON_MAP, "checkMark", [S, "fa-check"]), _defineProperty(_ICON_MAP, "spinner", [S, "fa-spinner"]), _defineProperty(_ICON_MAP, "list", [S, "fa-list"]), _defineProperty(_ICON_MAP, "userSettings", [S, "fa-user-cog"]), _defineProperty(_ICON_MAP, "logOut", [S, "fa-sign-out-alt"]), _defineProperty(_ICON_MAP, "handPointer", [S, "fa-hand-pointer"]), _defineProperty(_ICON_MAP, "caretDown", [S, "fa-caret-down"]), _defineProperty(_ICON_MAP, "caretUp", [S, "fa-caret-up"]), _defineProperty(_ICON_MAP, "locked", [R, "fa-lock-alt"]), _defineProperty(_ICON_MAP, "oops", [R, "fa-frown-open"]), _defineProperty(_ICON_MAP, "expired", [R, "fa-clock"]), _defineProperty(_ICON_MAP, "exchange", [S, "fa-exchange"]), _defineProperty(_ICON_MAP, "reportingLabels", [S, "fa-analytics"]), _defineProperty(_ICON_MAP, "contentTags", [S, "fa-tags"]), _ICON_MAP);
  var _default = ICON_MAP;
  /*eslint-enable id-length*/
  exports["default"] = _default;

  /***/
}, /* 35 */
/***/function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
  }
  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 36 */
/***/function (module, exports) {
  var g;

  // This works in non-strict mode
  g = function () {
    return this;
  }();
  try {
    // This works if eval is allowed (see CSP)
    g = g || new Function("return this")();
  } catch (e) {
    // This works if the window reference is available
    if (typeof window === "object") g = window;
  }

  // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}

  module.exports = g;

  /***/
}, /* 37 */
/***/function (module, exports) {
  function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
  }
  module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 38 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react = __webpack_require__(1);
  var _react2 = _interopRequireDefault(_react);
  var _propTypes = __webpack_require__(0);
  var _propTypes2 = _interopRequireDefault(_propTypes);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _objectWithoutProperties(obj, keys) {
    var target = {};
    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var sizerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    visibility: 'hidden',
    height: 0,
    overflow: 'scroll',
    whiteSpace: 'pre'
  };
  var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
  var cleanInputProps = function cleanInputProps(inputProps) {
    INPUT_PROPS_BLACKLIST.forEach(function (field) {
      return delete inputProps[field];
    });
    return inputProps;
  };
  var copyStyles = function copyStyles(styles, node) {
    node.style.fontSize = styles.fontSize;
    node.style.fontFamily = styles.fontFamily;
    node.style.fontWeight = styles.fontWeight;
    node.style.fontStyle = styles.fontStyle;
    node.style.letterSpacing = styles.letterSpacing;
    node.style.textTransform = styles.textTransform;
  };
  var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
  var generateId = function generateId() {
    // we only need an auto-generated ID for stylesheet injection, which is only
    // used for IE. so if the browser is not IE, this should return undefined.
    return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
  };
  var AutosizeInput = function (_Component) {
    _inherits(AutosizeInput, _Component);
    _createClass(AutosizeInput, null, [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(props, state) {
        var id = props.id;
        return id !== state.prevId ? {
          inputId: id || generateId(),
          prevId: id
        } : null;
      }
    }]);
    function AutosizeInput(props) {
      _classCallCheck(this, AutosizeInput);
      var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
      _this.inputRef = function (el) {
        _this.input = el;
        if (typeof _this.props.inputRef === 'function') {
          _this.props.inputRef(el);
        }
      };
      _this.placeHolderSizerRef = function (el) {
        _this.placeHolderSizer = el;
      };
      _this.sizerRef = function (el) {
        _this.sizer = el;
      };
      _this.state = {
        inputWidth: props.minWidth,
        inputId: props.id || generateId(),
        prevId: props.id
      };
      return _this;
    }
    _createClass(AutosizeInput, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.mounted = true;
        this.copyInputStyles();
        this.updateInputWidth();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (prevState.inputWidth !== this.state.inputWidth) {
          if (typeof this.props.onAutosize === 'function') {
            this.props.onAutosize(this.state.inputWidth);
          }
        }
        this.updateInputWidth();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: 'copyInputStyles',
      value: function copyInputStyles() {
        if (!this.mounted || !window.getComputedStyle) {
          return;
        }
        var inputStyles = this.input && window.getComputedStyle(this.input);
        if (!inputStyles) {
          return;
        }
        copyStyles(inputStyles, this.sizer);
        if (this.placeHolderSizer) {
          copyStyles(inputStyles, this.placeHolderSizer);
        }
      }
    }, {
      key: 'updateInputWidth',
      value: function updateInputWidth() {
        if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
          return;
        }
        var newInputWidth = void 0;
        if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
          newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
        } else {
          newInputWidth = this.sizer.scrollWidth + 2;
        }
        // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
        var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
        newInputWidth += extraWidth;
        if (newInputWidth < this.props.minWidth) {
          newInputWidth = this.props.minWidth;
        }
        if (newInputWidth !== this.state.inputWidth) {
          this.setState({
            inputWidth: newInputWidth
          });
        }
      }
    }, {
      key: 'getInput',
      value: function getInput() {
        return this.input;
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.input.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.input.blur();
      }
    }, {
      key: 'select',
      value: function select() {
        this.input.select();
      }
    }, {
      key: 'renderStyles',
      value: function renderStyles() {
        // this method injects styles to hide IE's clear indicator, which messes
        // with input size detection. the stylesheet is only injected when the
        // browser is IE, and can also be disabled by the `injectStyles` prop.
        var injectStyles = this.props.injectStyles;
        return isIE && injectStyles ? _react2.default.createElement('style', {
          dangerouslySetInnerHTML: {
            __html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
          }
        }) : null;
      }
    }, {
      key: 'render',
      value: function render() {
        var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
          if (previousValue !== null && previousValue !== undefined) {
            return previousValue;
          }
          return currentValue;
        });
        var wrapperStyle = _extends({}, this.props.style);
        if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
        var inputStyle = _extends({
          boxSizing: 'content-box',
          width: this.state.inputWidth + 'px'
        }, this.props.inputStyle);
        var inputProps = _objectWithoutProperties(this.props, []);
        cleanInputProps(inputProps);
        inputProps.className = this.props.inputClassName;
        inputProps.id = this.state.inputId;
        inputProps.style = inputStyle;
        return _react2.default.createElement('div', {
          className: this.props.className,
          style: wrapperStyle
        }, this.renderStyles(), _react2.default.createElement('input', _extends({}, inputProps, {
          ref: this.inputRef
        })), _react2.default.createElement('div', {
          ref: this.sizerRef,
          style: sizerStyle
        }, sizerValue), this.props.placeholder ? _react2.default.createElement('div', {
          ref: this.placeHolderSizerRef,
          style: sizerStyle
        }, this.props.placeholder) : null);
      }
    }]);
    return AutosizeInput;
  }(_react.Component);
  AutosizeInput.propTypes = {
    className: _propTypes2.default.string,
    // className for the outer element
    defaultValue: _propTypes2.default.any,
    // default field value
    extraWidth: _propTypes2.default.oneOfType([
    // additional width for input element
    _propTypes2.default.number, _propTypes2.default.string]),
    id: _propTypes2.default.string,
    // id to use for the input, can be set for consistent snapshots
    injectStyles: _propTypes2.default.bool,
    // inject the custom stylesheet to hide clear UI, defaults to true
    inputClassName: _propTypes2.default.string,
    // className for the input element
    inputRef: _propTypes2.default.func,
    // ref callback for the input element
    inputStyle: _propTypes2.default.object,
    // css styles for the input element
    minWidth: _propTypes2.default.oneOfType([
    // minimum width for input element
    _propTypes2.default.number, _propTypes2.default.string]),
    onAutosize: _propTypes2.default.func,
    // onAutosize handler: function(newWidth) {}
    onChange: _propTypes2.default.func,
    // onChange handler: function(event) {}
    placeholder: _propTypes2.default.string,
    // placeholder text
    placeholderIsMinWidth: _propTypes2.default.bool,
    // don't collapse size to less than the placeholder
    style: _propTypes2.default.object,
    // css styles for the outer element
    value: _propTypes2.default.any // field value
  };

  AutosizeInput.defaultProps = {
    minWidth: 1,
    injectStyles: true
  };
  exports.default = AutosizeInput;

  /***/
}, /* 39 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return (/* binding */_toConsumableArray
    );
  });

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
  var arrayLikeToArray = __webpack_require__(43);

  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Object(arrayLikeToArray["a" /* default */])(arr);
  }
  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
  var unsupportedIterableToArray = __webpack_require__(53);

  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || Object(unsupportedIterableToArray["a" /* default */])(arr) || _nonIterableSpread();
  }

  /***/
}, /* 40 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _SharedPropTypes = __webpack_require__(27);
  __webpack_require__(70);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var Tooltip = /*#__PURE__*/function (_React$Component) {
    _inherits(Tooltip, _React$Component);
    var _super = _createSuper(Tooltip);
    function Tooltip() {
      _classCallCheck(this, Tooltip);
      return _super.apply(this, arguments);
    }
    _createClass(Tooltip, [{
      key: "render",
      value: function render() {
        var $tip = null,
          _this$props = this.props,
          description = _this$props.description,
          inline = _this$props.inline,
          direction = _this$props.direction,
          size = _this$props.size,
          isVisible = _this$props.isVisible,
          showOnHover = _this$props.showOnHover,
          theme = _this$props.theme,
          isVisisbleClass = "",
          desc = description.trim();
        if (isVisible) {
          isVisisbleClass = "c-tooltip--is-visible";
        }
        if (!isVisible && !showOnHover) {
          isVisisbleClass = "c-tooltip--is-hidden";
        }
        if (desc.length) {
          if (this.props.children) {
            $tip = /*#__PURE__*/_react["default"].createElement("span", {
              className: "u-form__help c-tooltip c-tooltip--".concat(direction, " c-tooltip--").concat(size, " ").concat(isVisisbleClass, " t-tooltip--").concat(theme),
              "aria-label": desc
            }, this.props.children);
          } else {
            if (inline) {
              desc += ' ';
              $tip = /*#__PURE__*/_react["default"].createElement("span", {
                className: "u-form__help"
              }, desc, /*#__PURE__*/_react["default"].createElement("i", {
                className: "fa fa-info-circle",
                "aria-label": "Get Info"
              }));
            } else {
              $tip = /*#__PURE__*/_react["default"].createElement("span", {
                className: "u-form__help c-tooltip c-tooltip--".concat(direction, " c-tooltip--").concat(size, " ").concat(isVisisbleClass, " t-tooltip--").concat(theme),
                "aria-label": desc
              }, /*#__PURE__*/_react["default"].createElement("i", {
                className: "fa fa-info-circle",
                "aria-label": "Get Info"
              }));
            }
          }
        }
        return $tip;
      }
    }]);
    return Tooltip;
  }(_react["default"].Component);
  exports["default"] = Tooltip;
  _defineProperty(Tooltip, "propTypes", {
    /** contents of the tooltip */
    description: _propTypes["default"].string,
    /** is the tooltip inline (displayed before the tip icon) or not (displayed on hover of the tip icon)*/
    inline: _propTypes["default"].bool,
    /** what direction should the tooltip go in? (if inline:false) */
    direction: _propTypes["default"].oneOf(['left', 'right', 'top', 'bottom']),
    /** what size should the tooltip be? (if inline:false) */
    size: _propTypes["default"].oneOf(['', 'fit', 'small', 'medium', 'large', 'xlarge']),
    /** what size should the tooltip icon be? */
    iconSize: _propTypes["default"].oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
    /** programatically force the tooltip to be visible */
    isVisible: _propTypes["default"].bool,
    /** disable displaying tooltip on hover */
    showOnHover: _propTypes["default"].bool,
    /** Sets the theme/colour of the tooltip */
    theme: _SharedPropTypes.PROPTYPE_THEME
  });
  _defineProperty(Tooltip, "defaultProps", {
    description: "",
    inline: false,
    direction: 'left',
    size: "",
    iconSize: 'small',
    isVisible: false,
    showOnHover: true,
    theme: "default"
  });

  /***/
}, /* 41 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // EXTERNAL MODULE: ./node_modules/@emotion/sheet/dist/sheet.browser.esm.js
  var sheet_browser_esm = __webpack_require__(52);

  // CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
  function stylis_min(W) {
    function M(d, c, e, h, a) {
      for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
        g = e.charCodeAt(l);
        l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
        if (0 === b + n + v + m) {
          if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
            switch (g) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;
              default:
                f += e.charAt(l);
            }
            g = 59;
          }
          switch (g) {
            case 123:
              f = f.trim();
              q = f.charCodeAt(0);
              k = 1;
              for (t = ++l; l < B;) {
                switch (g = e.charCodeAt(l)) {
                  case 123:
                    k++;
                    break;
                  case 125:
                    k--;
                    break;
                  case 47:
                    switch (g = e.charCodeAt(l + 1)) {
                      case 42:
                      case 47:
                        a: {
                          for (u = l + 1; u < J; ++u) {
                            switch (e.charCodeAt(u)) {
                              case 47:
                                if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                  l = u + 1;
                                  break a;
                                }
                                break;
                              case 10:
                                if (47 === g) {
                                  l = u + 1;
                                  break a;
                                }
                            }
                          }
                          l = u;
                        }
                    }
                    break;
                  case 91:
                    g++;
                  case 40:
                    g++;
                  case 34:
                  case 39:
                    for (; l++ < J && e.charCodeAt(l) !== g;) {}
                }
                if (0 === k) break;
                l++;
              }
              k = e.substring(t, l);
              0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
              switch (q) {
                case 64:
                  0 < r && (f = f.replace(N, ''));
                  g = f.charCodeAt(1);
                  switch (g) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      r = c;
                      break;
                    default:
                      r = O;
                  }
                  k = M(c, r, k, g, a + 1);
                  t = k.length;
                  0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                  if (0 < t) switch (g) {
                    case 115:
                      f = f.replace(da, ea);
                    case 100:
                    case 109:
                    case 45:
                      k = f + '{' + k + '}';
                      break;
                    case 107:
                      f = f.replace(fa, '$1 $2');
                      k = f + '{' + k + '}';
                      k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                      break;
                    default:
                      k = f + k, 112 === h && (k = (p += k, ''));
                  } else k = '';
                  break;
                default:
                  k = M(c, X(c, f, I), k, h, a + 1);
              }
              F += k;
              k = I = r = u = q = 0;
              f = '';
              g = e.charCodeAt(++l);
              break;
            case 125:
            case 59:
              f = (0 < r ? f.replace(N, '') : f).trim();
              if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
                case 0:
                  break;
                case 64:
                  if (105 === g || 99 === g) {
                    G += f + e.charAt(l);
                    break;
                  }
                default:
                  58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
              }
              I = r = u = q = 0;
              f = '';
              g = e.charCodeAt(++l);
          }
        }
        switch (g) {
          case 13:
          case 10:
            47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
            0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
            z = 1;
            D++;
            break;
          case 59:
          case 125:
            if (0 === b + n + v + m) {
              z++;
              break;
            }
          default:
            z++;
            y = e.charAt(l);
            switch (g) {
              case 9:
              case 32:
                if (0 === n + m + b) switch (x) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y = '';
                    break;
                  default:
                    32 !== g && (y = ' ');
                }
                break;
              case 0:
                y = '\\0';
                break;
              case 12:
                y = '\\f';
                break;
              case 11:
                y = '\\v';
                break;
              case 38:
                0 === n + b + m && (r = I = 1, y = '\f' + y);
                break;
              case 108:
                if (0 === n + b + m + E && 0 < u) switch (l - u) {
                  case 2:
                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                  case 8:
                    111 === K && (E = K);
                }
                break;
              case 58:
                0 === n + b + m && (u = l);
                break;
              case 44:
                0 === b + v + n + m && (r = 1, y += '\r');
                break;
              case 34:
              case 39:
                0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                break;
              case 91:
                0 === n + b + v && m++;
                break;
              case 93:
                0 === n + b + v && m--;
                break;
              case 41:
                0 === n + b + m && v--;
                break;
              case 40:
                if (0 === n + b + m) {
                  if (0 === q) switch (2 * x + 3 * K) {
                    case 533:
                      break;
                    default:
                      q = 1;
                  }
                  v++;
                }
                break;
              case 64:
                0 === b + v + n + m + u + k && (k = 1);
                break;
              case 42:
              case 47:
                if (!(0 < n + m + v)) switch (b) {
                  case 0:
                    switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                      case 235:
                        b = 47;
                        break;
                      case 220:
                        t = l, b = 42;
                    }
                    break;
                  case 42:
                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                }
            }
            0 === b && (f += y);
        }
        K = x;
        x = g;
        l++;
      }
      t = p.length;
      if (0 < t) {
        r = c;
        if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
        p = r.join(',') + '{' + p + '}';
        if (0 !== w * E) {
          2 !== w || L(p, 2) || (E = 0);
          switch (E) {
            case 111:
              p = p.replace(ha, ':-moz-$1') + p;
              break;
            case 112:
              p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
          }
          E = 0;
        }
      }
      return G + p + F;
    }
    function X(d, c, e) {
      var h = c.trim().split(ia);
      c = h;
      var a = h.length,
        m = d.length;
      switch (m) {
        case 0:
        case 1:
          var b = 0;
          for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
            c[b] = Z(d, c[b], e).trim();
          }
          break;
        default:
          var v = b = 0;
          for (c = []; b < a; ++b) {
            for (var n = 0; n < m; ++n) {
              c[v++] = Z(d[n] + ' ', h[b], e).trim();
            }
          }
      }
      return c;
    }
    function Z(d, c, e) {
      var h = c.charCodeAt(0);
      33 > h && (h = (c = c.trim()).charCodeAt(0));
      switch (h) {
        case 38:
          return c.replace(F, '$1' + d.trim());
        case 58:
          return d.trim() + c.replace(F, '$1' + d.trim());
        default:
          if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
      }
      return d + c;
    }
    function P(d, c, e, h) {
      var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;
      if (944 === m) {
        d = a.indexOf(':', 9) + 1;
        var b = a.substring(d, a.length - 1).trim();
        b = a.substring(0, d).trim() + b + ';';
        return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
      }
      if (0 === w || 2 === w && !L(a, 1)) return a;
      switch (m) {
        case 1015:
          return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
        case 951:
          return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
        case 963:
          return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
        case 1009:
          if (100 !== a.charCodeAt(4)) break;
        case 969:
        case 942:
          return '-webkit-' + a + a;
        case 978:
          return '-webkit-' + a + '-moz-' + a + a;
        case 1019:
        case 983:
          return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
        case 883:
          if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
          if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
          break;
        case 932:
          if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
            case 103:
              return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
            case 115:
              return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
            case 98:
              return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
          }
          return '-webkit-' + a + '-ms-' + a + a;
        case 964:
          return '-webkit-' + a + '-ms-flex-' + a + a;
        case 1023:
          if (99 !== a.charCodeAt(8)) break;
          b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
          return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
        case 1005:
          return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
        case 1e3:
          b = a.substring(13).trim();
          c = b.indexOf('-') + 1;
          switch (b.charCodeAt(0) + b.charCodeAt(c)) {
            case 226:
              b = a.replace(G, 'tb');
              break;
            case 232:
              b = a.replace(G, 'tb-rl');
              break;
            case 220:
              b = a.replace(G, 'lr');
              break;
            default:
              return a;
          }
          return '-webkit-' + a + '-ms-' + b + a;
        case 1017:
          if (-1 === a.indexOf('sticky', 9)) break;
        case 975:
          c = (a = d).length - 10;
          b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
          switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
            case 203:
              if (111 > b.charCodeAt(8)) break;
            case 115:
              a = a.replace(b, '-webkit-' + b) + ';' + a;
              break;
            case 207:
            case 102:
              a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
          }
          return a + ';';
        case 938:
          if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
            case 105:
              return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
            case 115:
              return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
            default:
              return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
          }
          break;
        case 973:
        case 989:
          if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
        case 931:
        case 953:
          if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
          break;
        case 962:
          if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
      }
      return a;
    }
    function L(d, c) {
      var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
      e = d.substring(e + 1, d.length - 1);
      return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
      var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
      return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
      for (var g = 0, x = c, w; g < A; ++g) {
        switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
          case void 0:
          case !1:
          case !0:
          case null:
            break;
          default:
            x = w;
        }
      }
      if (x !== c) return x;
    }
    function T(d) {
      switch (d) {
        case void 0:
        case null:
          A = S.length = 0;
          break;
        default:
          if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
            T(d[c]);
          } else Y = !!d | 0;
      }
      return T;
    }
    function U(d) {
      d = d.prefix;
      void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
      return U;
    }
    function B(d, c) {
      var e = d;
      33 > e.charCodeAt(0) && (e = e.trim());
      V = e;
      e = [V];
      if (0 < A) {
        var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
        void 0 !== h && 'string' === typeof h && (c = h);
      }
      var a = M(O, e, c, 0, 0);
      0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
      V = '';
      E = 0;
      z = D = 1;
      return a;
    }
    var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
  }

  /* harmony default export */
  var stylis_browser_esm = stylis_min;

  // CONCATENATED MODULE: ./node_modules/@emotion/weak-memoize/dist/weak-memoize.browser.esm.js
  var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function (arg) {
      if (cache.has(arg)) {
        // $FlowFixMe
        return cache.get(arg);
      }
      var ret = func(arg);
      cache.set(arg, ret);
      return ret;
    };
  };

  /* harmony default export */
  var weak_memoize_browser_esm = weakMemoize;

  // CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/cache.browser.esm.js

  // https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
  // inlined to avoid umd wrapper and peerDep warnings/installing stylis
  // since we use stylis after closure compiler
  var delimiter = '/*|*/';
  var needle = delimiter + '}';
  function toSheet(block) {
    if (block) {
      Sheet.current.insert(block + '}');
    }
  }
  var Sheet = {
    current: null
  };
  var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch (context) {
      // property
      case 1:
        {
          switch (content.charCodeAt(0)) {
            case 64:
              {
                // @import
                Sheet.current.insert(content + ';');
                return '';
              }
            // charcode for l

            case 108:
              {
                // charcode for b
                // this ignores label
                if (content.charCodeAt(2) === 98) {
                  return '';
                }
              }
          }
          break;
        }
      // selector

      case 2:
        {
          if (ns === 0) return content + delimiter;
          break;
        }
      // at-rule

      case 3:
        {
          switch (ns) {
            // @font-face, @page
            case 102:
            case 112:
              {
                Sheet.current.insert(selectors[0] + content);
                return '';
              }
            default:
              {
                return content + (at === 0 ? delimiter : '');
              }
          }
        }
      case -2:
        {
          content.split(needle).forEach(toSheet);
        }
    }
  };
  var cache_browser_esm_createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) {
      stylisOptions = {
        prefix: options.prefix
      };
    }
    var stylis = new stylis_browser_esm(stylisOptions);
    if (false) {}
    var inserted = {}; // $FlowFixMe

    var container;
    {
      container = options.container || document.head;
      var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
      Array.prototype.forEach.call(nodes, function (node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

        attrib.split(' ').forEach(function (id) {
          inserted[id] = true;
        });
        if (node.parentNode !== container) {
          container.appendChild(node);
        }
      });
    }
    var _insert;
    {
      stylis.use(options.stylisPlugins)(ruleSheet);
      _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        Sheet.current = sheet;
        if (false) {
          var map;
        }
        stylis(selector, serialized.styles);
        if (shouldCache) {
          cache.inserted[name] = true;
        }
      };
    }
    if (false) {
      var commentEnd, commentStart;
    }
    var cache = {
      key: key,
      sheet: new sheet_browser_esm["a" /* StyleSheet */]({
        key: key,
        container: container,
        nonce: options.nonce,
        speedy: options.speedy
      }),
      nonce: options.nonce,
      inserted: inserted,
      registered: {},
      insert: _insert
    };
    return cache;
  };

  /* harmony default export */
  var cache_browser_esm = __webpack_exports__["a"] = cache_browser_esm_createCache;

  /***/
}, /* 42 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _assertThisInitialized;
  });
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }

  /***/
}, /* 43 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _arrayLikeToArray;
  });
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }

  /***/
}, /* 44 */
/***/function (module, exports) {
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;
  module.exports = isArray;

  /***/
}, /* 45 */
/***/function (module, exports, __webpack_require__) {
  var setPrototypeOf = __webpack_require__(79);
  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    setPrototypeOf(subClass, superClass);
  }
  module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 46 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MIN_CAROUSEL_CARDS_LENGTH = exports.GOOGLE_DISC_CAROUSEL_ASPECT_RATIOS = exports.FT_ASPECT_RATIOS = exports.FB_MIN_ASPECT = exports.FB_MAX_ASPECT = exports.FB_LOOP_LENGTH = exports.FB_LOOP_CUTOFF = exports.FACEBOOK_WIDTH_VERTICAL = exports.FACEBOOK_WIDTH = exports.FACEBOOK_MIN_HEIGHT = exports.FACEBOOK_MAX_HEIGHT = exports.CAROUSEL_CARD_INCREMENT = void 0;
  exports.buildFullyQualifiedUrls = buildFullyQualifiedUrls;
  exports.getAspectRatio = getAspectRatio;
  exports.getFBAdjustedHeight = getFBAdjustedHeight;
  exports.getPlacementInfo = getPlacementInfo;
  exports.getRandomArrayItem = getRandomArrayItem;
  exports.getVideoDuration = getVideoDuration;
  exports.isAdstudioCreative = isAdstudioCreative;
  exports.isAfterEffectsCreative = isAfterEffectsCreative;
  exports.isConceptDynamic = isConceptDynamic;
  exports.isDVAST = void 0;
  exports.isDVASTTranscoding = isDVASTTranscoding;
  exports.isDVASTTranscodingError = isDVASTTranscodingError;
  exports.isDisplayCreative = isDisplayCreative;
  exports.isDisplayHTMLTagCreative = isDisplayHTMLTagCreative;
  exports.isDynamic = isDynamic;
  exports.isFacebookCreative = isFacebookCreative;
  exports.isImposiumCreative = isImposiumCreative;
  exports.isIncomplete = isIncomplete;
  exports.isMaxDynamicSocialVersions = isMaxDynamicSocialVersions;
  exports.isNativeImageCreative = isNativeImageCreative;
  exports.isOpenWebDisplayCreative = isOpenWebDisplayCreative;
  exports.isSocialCarouselCreative = isSocialCarouselCreative;
  exports.isSocialCreative = isSocialCreative;
  exports.isVASTAudioCreative = isVASTAudioCreative;
  exports.isVASTCreative = isVASTCreative;
  exports.isVASTTranscoded = isVASTTranscoded;
  exports.isVASTTranscoding = isVASTTranscoding;
  exports.isVASTTranscodingError = isVASTTranscodingError;
  exports.isVASTVideoCreative = isVASTVideoCreative;
  exports.isVideoBuilderCreative = isVideoBuilderCreative;
  exports.placementTypeClass = placementTypeClass;
  exports.playVideo = playVideo;
  var _constants = __webpack_require__(59);
  var _Dictionaries = __webpack_require__(138);
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var FB_MIN_ASPECT = 1.0;
  exports.FB_MIN_ASPECT = FB_MIN_ASPECT;
  var FB_MAX_ASPECT = 1.91;
  exports.FB_MAX_ASPECT = FB_MAX_ASPECT;
  var FACEBOOK_WIDTH = 453;
  exports.FACEBOOK_WIDTH = FACEBOOK_WIDTH;
  var FACEBOOK_WIDTH_VERTICAL = 375;
  exports.FACEBOOK_WIDTH_VERTICAL = FACEBOOK_WIDTH_VERTICAL;
  var FACEBOOK_MIN_HEIGHT = 237;
  exports.FACEBOOK_MIN_HEIGHT = FACEBOOK_MIN_HEIGHT;
  var FACEBOOK_MAX_HEIGHT = 453;
  exports.FACEBOOK_MAX_HEIGHT = FACEBOOK_MAX_HEIGHT;
  var MIN_CAROUSEL_CARDS_LENGTH = 2;
  exports.MIN_CAROUSEL_CARDS_LENGTH = MIN_CAROUSEL_CARDS_LENGTH;
  var CAROUSEL_CARD_INCREMENT = 320;
  exports.CAROUSEL_CARD_INCREMENT = CAROUSEL_CARD_INCREMENT;
  var FB_LOOP_CUTOFF = 30;
  exports.FB_LOOP_CUTOFF = FB_LOOP_CUTOFF;
  var FB_LOOP_LENGTH = 90;
  exports.FB_LOOP_LENGTH = FB_LOOP_LENGTH;
  var FT_ASPECT_RATIOS = {
    VERTICAL: "ft_aspect_vertical",
    SQUARE: "ft_aspect_square",
    HORIZONTAL: "ft_aspect_horizontal",
    DEFAULT: "ft_aspect_default",
    REEL: "ft_aspect_reel",
    STORY: "ft_aspect_story" //!STORY TYPE ASPECT RATIO TBD
  };

  exports.FT_ASPECT_RATIOS = FT_ASPECT_RATIOS;
  var GOOGLE_DISC_CAROUSEL_ASPECT_RATIOS = {
    YOUTUBE_MOBILE: {
      SQUARE: "square",
      HORIZONTAL: "horizontal"
    },
    VERTICAL: "vertical"
  };
  exports.GOOGLE_DISC_CAROUSEL_ASPECT_RATIOS = GOOGLE_DISC_CAROUSEL_ASPECT_RATIOS;
  function getAspectRatio(width, height) {
    if (!width || !height || typeof width !== 'number' || typeof height !== 'number') {
      return 0; //to prevent divide-by-zero errors
    }

    return width / height;
  }

  //params are the width and height of the original image or video file
  function getFBAdjustedHeight() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FACEBOOK_WIDTH;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FACEBOOK_WIDTH;
    var aspectRatio = getAspectRatio(width, height);
    if (aspectRatio < FB_MIN_ASPECT) {
      //too narrow
      return FACEBOOK_MAX_HEIGHT;
    } else if (aspectRatio > FB_MAX_ASPECT) {
      //too wide
      return FACEBOOK_MIN_HEIGHT;
    }
    return Math.round(FACEBOOK_WIDTH / aspectRatio);
  }
  function getVideoDuration(node) {
    if (!node || !node.duration) {
      return 0;
    }
    return node.duration;
  }
  function playVideo(node) {
    try {
      node.play();
    } catch (err) {
      console.error("Could not play");
    }
  }
  function isQualified() {
    var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return /^https?:\/\//.test(src);
  }
  /*
  	if the source for
  		socVals[ image | video | thumbnail ] or
  		socVals[ logos[x] | images[x] ] or
  		socVals.cards[x][ image | video ] or
  		socVals.cards[x][ logos[x] | images[x] ]
  	exists and does not start with `http://` or `https://`,
  	it is updated to include the passed domain
   */
  function buildFullyQualifiedUrls(socVals) {
    var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    if (!socVals) {
      return socVals;
    }
    var socialValues = Object.assign({}, socVals);
    function updateObjSrc(obj) {
      return _objectSpread(_objectSpread({}, obj), {}, {
        src: "".concat(domain).concat(obj.src)
      });
    }

    /*
    { image: { src: "whatever" } } 			-> { image: { src: "[domain]whatever" } }
    { image: { src: "http://whatever" } } 	-> does not change
    */
    // thumbnail is unique to youtube discovery
    ["image", "video", "thumbnail", "logo"].forEach(function (type) {
      var obj = socialValues[type];
      if (obj && !isQualified(obj === null || obj === void 0 ? void 0 : obj.src)) {
        socialValues = _objectSpread(_objectSpread({}, socialValues), {}, _defineProperty({}, type, updateObjSrc(obj)));
      }
    });
    /* logos and images are arrays & unique to GoogleDiscovery
    	{ logos: [{ src: "whatever" }, { src: { "http://whatever" } }] } -> { logos: [{ src: "[domain]whatever" }, { src: { "http://whatever" } }] }
     */
    ["logos", "images"].forEach(function (type) {
      if (socialValues[type]) {
        var arr = socialValues[type].map(function (obj) {
          if (obj && !isQualified(obj === null || obj === void 0 ? void 0 : obj.src)) {
            return updateObjSrc(obj);
          }
          return obj;
        });
        socialValues = _objectSpread(_objectSpread({}, socialValues), {}, _defineProperty({}, type, arr));
      }
    });

    //cards are unique to carousels
    if (socialValues.cards) {
      var updatedCards = socialValues.cards.map(function (card) {
        var newCard = _objectSpread({}, card);
        ["image", "video"].forEach(function (type) {
          var obj = card[type];
          if (obj && !isQualified(obj === null || obj === void 0 ? void 0 : obj.src)) {
            newCard = _objectSpread(_objectSpread({}, newCard), {}, _defineProperty({}, type, updateObjSrc(obj)));
          }
        });
        if (newCard.images) {
          var arr = newCard.images.map(function (obj) {
            if (obj && !isQualified(obj === null || obj === void 0 ? void 0 : obj.src)) {
              return updateObjSrc(obj);
            }
            return obj;
          });
          newCard = _objectSpread(_objectSpread({}, newCard), {}, {
            images: arr
          });
        }
        return newCard;
      });
      socialValues = _objectSpread(_objectSpread({}, socialValues), {}, {
        cards: updatedCards
      });
    }
    return socialValues;
  }
  function getPlacementInfo(placements, placementType) {
    return placements === null || placements === void 0 ? void 0 : placements.find(function (placement) {
      return placement.type.externalId === placementType;
    });
  }
  function getRandomArrayItem(array) {
    if (!array) {
      return null;
    }
    return array[Math.floor(Math.random() * array.length)];
  }
  function placementTypeClass(placementType) {
    if (!placementType) {
      return "";
    }
    return placementType.replace("ft_aspect_", "");
  }

  /** ADTYPE HELPERS */

  /**
   * [isSocialCreative description]
   * 		- Used to determine actions in the Creative Grid
   * @param {Object} dependentValues
   * @return {Boolean} Is the given AdType of a social type?
   */
  function isSocialCreative(dependentValues) {
    var adType = dependentValues.adType;
    return _constants.SOCIAL_AD_TYPE_LIST.includes(adType);
  }

  /**
   * Determines if we are at the limit of dynamic social versions allowed within a creative
   * @param {Number} length the amount of versions within a creative
   * @param {Object} dependentValues the creative details' values
   * @returns {Boolean} is length greater than max dynamic social versions length and is creative dynamic, and is adType dynamic
   */
  function isMaxDynamicSocialVersions(length) {
    var dependentValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var adType = dependentValues.adType,
      isDynamic = dependentValues.isDynamic;
    return length >= _constants.MAX_DYNAMIC_SOCIAL_VERSIONS && _constants.DYNAMIC_SOCIAL_AD_TYPES.includes(adType) && isDynamic;
  }
  function isFacebookCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var adType = dependentValues.adType;
    return !!(adType && (adType === _constants.SOCIAL_AD_TYPES.FACEBOOK_IMAGE || adType === _constants.SOCIAL_AD_TYPES.FACEBOOK_VIDEO));
  }
  function isSocialCarouselCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var adType = dependentValues.adType;
    return isSocialCreative(dependentValues) && /carousel/gi.test(adType);
  }
  function isNativeImageCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var adType = dependentValues.adType;
    return adType === _constants.NATIVE_IMAGE;
  }
  function isAdstudioCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var origin = dependentValues.origin;
    return origin === _constants.ADSTUDIO_TYPE;
  }
  function isImposiumCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var origin = dependentValues.origin;
    return origin === _constants.IMPOSIUM_TYPE;
  }
  function isVideoBuilderCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var origin = dependentValues.origin,
      html5Meta = dependentValues.html5Meta,
      adType = dependentValues.adType;
    return !origin && (html5Meta === null || html5Meta === void 0 ? void 0 : html5Meta.apiVersion) === "2.8" && adType === _constants.DYNAMIC_PREROLL;
  }
  function isDisplayHTMLTagCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var adType = dependentValues.adType;
    return adType === _constants.DISPLAY_HTML_TAG;
  }
  function isVASTVideoCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var adType = dependentValues.adType;
    if (!adType) {
      return false;
    }
    return adType === _constants.PREROLL;
  }
  function isVASTAudioCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var adType = dependentValues.adType;
    if (!adType) {
      return false;
    }
    return adType === _constants.VAST_AUDIO;
  }
  function isVASTCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return isVASTVideoCreative(dependentValues) || isVASTAudioCreative(dependentValues);
  }
  function isVASTTranscoding() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!isVASTCreative(dependentValues)) {
      return false;
    }
    return (0, _Dictionaries.isTranscoding)(dependentValues.approval);
  }
  function isVASTTranscoded() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!isVASTCreative(dependentValues)) {
      return false;
    }
    return !((0, _Dictionaries.isTranscoding)(dependentValues.approval) || (0, _Dictionaries.isTranscodingError)(dependentValues.approval));
  }
  function isVASTTranscodingError() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!isVASTCreative(dependentValues)) {
      return false;
    }
    return (0, _Dictionaries.isTranscodingError)(dependentValues.approval);
  }
  var isDVAST = function isDVAST(adType) {
    return adType === 'dynamic_preroll' || adType === 'dynamicPreRoll';
  };
  exports.isDVAST = isDVAST;
  function isDVASTTranscoding() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!isDVAST(dependentValues.adType)) {
      return false;
    }
    return (0, _Dictionaries.isTranscoding)(dependentValues.approval);
  }
  function isDVASTTranscodingError() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!isDVAST(dependentValues.adType)) {
      return false;
    }
    return (0, _Dictionaries.isTranscodingError)(dependentValues.approval);
  }
  function isIncomplete() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var approval = dependentValues.approval;
    return _constants.INCOMPLETE_STATUS.includes(approval);
  }
  function isDynamic() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var dynamicTarget = dependentValues.dynamicTarget,
      isDynamic = dependentValues.isDynamic;
    return dynamicTarget && !/non-dynamic/gi.test(dynamicTarget) || isDynamic;
  }
  function isConceptDynamic() {
    var concept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // A Concept is dynamic if any of its child Creatives are dynamic.
    var _concept$creatives = concept.creatives,
      creatives = _concept$creatives === void 0 ? [] : _concept$creatives;
    return creatives.some(function (creative) {
      return isDynamic(creative);
    });
  }
  function isDisplayCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return /HTML_onpage|HTML_standard|altimage|display_html_tag/gi.test(dependentValues === null || dependentValues === void 0 ? void 0 : dependentValues.adType);
  }
  function isOpenWebDisplayCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return /HTML_onpage|HTML_standard/i.test(dependentValues === null || dependentValues === void 0 ? void 0 : dependentValues.adType);
  }
  function isAfterEffectsCreative() {
    var dependentValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return /after_effects/gi.test(dependentValues === null || dependentValues === void 0 ? void 0 : dependentValues.origin);
  }

  /** END ADTYPE HELPERS */

  /***/
}, /* 47 */
/***/function (module, exports) {
  module.exports = function (module) {
    if (!module.webpackPolyfill) {
      module.deprecate = function () {};
      module.paths = [];
      // module.parent = undefined by default
      if (!module.children) module.children = [];
      Object.defineProperty(module, "loaded", {
        enumerable: true,
        get: function () {
          return module.l;
        }
      });
      Object.defineProperty(module, "id", {
        enumerable: true,
        get: function () {
          return module.i;
        }
      });
      module.webpackPolyfill = 1;
    }
    return module;
  };

  /***/
}, /* 48 */
/***/function (module, exports, __webpack_require__) {
  var arrayWithHoles = __webpack_require__(117);
  var iterableToArrayLimit = __webpack_require__(118);
  var unsupportedIterableToArray = __webpack_require__(84);
  var nonIterableRest = __webpack_require__(119);
  function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
  }
  module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 49 */
/***/function (module, exports) {
  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }
  module.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 50 */
/***/function (module, exports, __webpack_require__) {
  var freeGlobal = __webpack_require__(188);

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();
  module.exports = root;

  /***/
}, /* 51 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _setPrototypeOf;
  });
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  /***/
}, /* 52 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return StyleSheet;
  });
  /*
  
  Based off glamor's StyleSheet, thanks Sunil ❤️
  
  high performance StyleSheet for css-in-js systems
  
  - uses multiple style tags behind the scenes for millions of rules
  - uses `insertRule` for appending in production for *much* faster performance
  
  // usage
  
  import { StyleSheet } from '@emotion/sheet'
  
  let styleSheet = new StyleSheet({ key: '', container: document.head })
  
  styleSheet.insert('#box { border: 1px solid red; }')
  - appends a css rule into the stylesheet
  
  styleSheet.flush()
  - empties the stylesheet of all its contents
  
  */
  // $FlowFixMe
  function sheetForTag(tag) {
    if (tag.sheet) {
      // $FlowFixMe
      return tag.sheet;
    } // this weirdness brought to you by firefox

    /* istanbul ignore next */

    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        // $FlowFixMe
        return document.styleSheets[i];
      }
    }
  }
  function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) {
      tag.setAttribute('nonce', options.nonce);
    }
    tag.appendChild(document.createTextNode(''));
    return tag;
  }
  var StyleSheet = /*#__PURE__*/
  function () {
    function StyleSheet(options) {
      this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
      this.tags = [];
      this.ctr = 0;
      this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

      this.key = options.key;
      this.container = options.container;
      this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
      // the max length is how many rules we have per style tag, it's 65000 in speedy mode
      // it's 1 in dev because we insert source maps that map a single rule to a location
      // and you can only have one source map per style tag
      if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
        var _tag = createStyleElement(this);
        var before;
        if (this.tags.length === 0) {
          before = this.before;
        } else {
          before = this.tags[this.tags.length - 1].nextSibling;
        }
        this.container.insertBefore(_tag, before);
        this.tags.push(_tag);
      }
      var tag = this.tags[this.tags.length - 1];
      if (this.isSpeedy) {
        var sheet = sheetForTag(tag);
        try {
          // this is a really hot path
          // we check the second character first because having "i"
          // as the second character will happen less often than
          // having "@" as the first character
          var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
          // the big drawback is that the css won't be editable in devtools

          sheet.insertRule(rule,
          // we need to insert @import rules before anything else
          // otherwise there will be an error
          // technically this means that the @import rules will
          // _usually_(not always since there could be multiple style tags)
          // be the first ones in prod and generally later in dev
          // this shouldn't really matter in the real world though
          // @import is generally only used for font faces from google fonts and etc.
          // so while this could be technically correct then it would be slower and larger
          // for a tiny bit of correctness that won't matter in the real world
          isImportRule ? 0 : sheet.cssRules.length);
        } catch (e) {
          if (false) {}
        }
      } else {
        tag.appendChild(document.createTextNode(rule));
      }
      this.ctr++;
    };
    _proto.flush = function flush() {
      // $FlowFixMe
      this.tags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.ctr = 0;
    };
    return StyleSheet;
  }();

  /***/
}, /* 53 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return _unsupportedIterableToArray;
  });
  /* harmony import */
  var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43);
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Object(_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"])(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"])(o, minLen);
  }

  /***/
}, /* 54 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return (/* binding */_toPropertyKey
    );
  });

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
  var esm_typeof = __webpack_require__(25);

  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

  function _toPrimitive(input, hint) {
    if (Object(esm_typeof["a" /* default */])(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (Object(esm_typeof["a" /* default */])(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js

  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return Object(esm_typeof["a" /* default */])(key) === "symbol" ? key : String(key);
  }

  /***/
}, /* 55 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(98);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 56 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = generateUnique;
  /**
   * UniqueID Generator
   * This function will create a simple Unique Identifier for the application
   * It uses a single variable and increments it each time the function is called
   *
   * Note: While this will result in a unique ID for the runtime of the application, opening it in a differnt browser tab, or for a second time will result in different IDs.
   */

  var UID = 0;
  function generateUnique(_ref) {
    var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "UID" : _ref$name;
    // Increment the UID prior to everything
    UID = UID + 1;
    return "".concat(name, "--").concat(UID);
  }

  /***/
}, /* 57 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global, module) {
    var __WEBPACK_AMD_DEFINE_RESULT__; /**
                                       * @license
                                       * Lodash <https://lodash.com/>
                                       * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
                                       * Released under MIT license <https://lodash.com/license>
                                       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
                                       * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
                                       */
    ;
    (function () {
      /** Used as a safe reference for `undefined` in pre-ES5 environments. */
      var undefined;

      /** Used as the semantic version number. */
      var VERSION = '4.17.21';

      /** Used as the size to enable large array optimizations. */
      var LARGE_ARRAY_SIZE = 200;

      /** Error message constants. */
      var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
        FUNC_ERROR_TEXT = 'Expected a function',
        INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

      /** Used to stand-in for `undefined` hash values. */
      var HASH_UNDEFINED = '__lodash_hash_undefined__';

      /** Used as the maximum memoize cache size. */
      var MAX_MEMOIZE_SIZE = 500;

      /** Used as the internal argument placeholder. */
      var PLACEHOLDER = '__lodash_placeholder__';

      /** Used to compose bitmasks for cloning. */
      var CLONE_DEEP_FLAG = 1,
        CLONE_FLAT_FLAG = 2,
        CLONE_SYMBOLS_FLAG = 4;

      /** Used to compose bitmasks for value comparisons. */
      var COMPARE_PARTIAL_FLAG = 1,
        COMPARE_UNORDERED_FLAG = 2;

      /** Used to compose bitmasks for function metadata. */
      var WRAP_BIND_FLAG = 1,
        WRAP_BIND_KEY_FLAG = 2,
        WRAP_CURRY_BOUND_FLAG = 4,
        WRAP_CURRY_FLAG = 8,
        WRAP_CURRY_RIGHT_FLAG = 16,
        WRAP_PARTIAL_FLAG = 32,
        WRAP_PARTIAL_RIGHT_FLAG = 64,
        WRAP_ARY_FLAG = 128,
        WRAP_REARG_FLAG = 256,
        WRAP_FLIP_FLAG = 512;

      /** Used as default options for `_.truncate`. */
      var DEFAULT_TRUNC_LENGTH = 30,
        DEFAULT_TRUNC_OMISSION = '...';

      /** Used to detect hot functions by number of calls within a span of milliseconds. */
      var HOT_COUNT = 800,
        HOT_SPAN = 16;

      /** Used to indicate the type of lazy iteratees. */
      var LAZY_FILTER_FLAG = 1,
        LAZY_MAP_FLAG = 2,
        LAZY_WHILE_FLAG = 3;

      /** Used as references for various `Number` constants. */
      var INFINITY = 1 / 0,
        MAX_SAFE_INTEGER = 9007199254740991,
        MAX_INTEGER = 1.7976931348623157e+308,
        NAN = 0 / 0;

      /** Used as references for the maximum length and index of an array. */
      var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

      /** Used to associate wrap methods with their bit flags. */
      var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];

      /** `Object#toString` result references. */
      var argsTag = '[object Arguments]',
        arrayTag = '[object Array]',
        asyncTag = '[object AsyncFunction]',
        boolTag = '[object Boolean]',
        dateTag = '[object Date]',
        domExcTag = '[object DOMException]',
        errorTag = '[object Error]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        mapTag = '[object Map]',
        numberTag = '[object Number]',
        nullTag = '[object Null]',
        objectTag = '[object Object]',
        promiseTag = '[object Promise]',
        proxyTag = '[object Proxy]',
        regexpTag = '[object RegExp]',
        setTag = '[object Set]',
        stringTag = '[object String]',
        symbolTag = '[object Symbol]',
        undefinedTag = '[object Undefined]',
        weakMapTag = '[object WeakMap]',
        weakSetTag = '[object WeakSet]';
      var arrayBufferTag = '[object ArrayBuffer]',
        dataViewTag = '[object DataView]',
        float32Tag = '[object Float32Array]',
        float64Tag = '[object Float64Array]',
        int8Tag = '[object Int8Array]',
        int16Tag = '[object Int16Array]',
        int32Tag = '[object Int32Array]',
        uint8Tag = '[object Uint8Array]',
        uint8ClampedTag = '[object Uint8ClampedArray]',
        uint16Tag = '[object Uint16Array]',
        uint32Tag = '[object Uint32Array]';

      /** Used to match empty string literals in compiled template source. */
      var reEmptyStringLeading = /\b__p \+= '';/g,
        reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
        reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

      /** Used to match HTML entities and HTML characters. */
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
        reUnescapedHtml = /[&<>"']/g,
        reHasEscapedHtml = RegExp(reEscapedHtml.source),
        reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

      /** Used to match template delimiters. */
      var reEscape = /<%-([\s\S]+?)%>/g,
        reEvaluate = /<%([\s\S]+?)%>/g,
        reInterpolate = /<%=([\s\S]+?)%>/g;

      /** Used to match property names within property paths. */
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        reIsPlainProp = /^\w*$/,
        rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

      /**
       * Used to match `RegExp`
       * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
       */
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
        reHasRegExpChar = RegExp(reRegExpChar.source);

      /** Used to match leading whitespace. */
      var reTrimStart = /^\s+/;

      /** Used to match a single whitespace character. */
      var reWhitespace = /\s/;

      /** Used to match wrap detail comments. */
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
        reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
        reSplitDetails = /,? & /;

      /** Used to match words composed of alphanumeric characters. */
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

      /**
       * Used to validate the `validate` option in `_.template` variable.
       *
       * Forbids characters which could potentially change the meaning of the function argument definition:
       * - "()," (modification of function parameters)
       * - "=" (default value)
       * - "[]{}" (destructuring of function parameters)
       * - "/" (beginning of a comment)
       * - whitespace
       */
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

      /** Used to match backslashes in property paths. */
      var reEscapeChar = /\\(\\)?/g;

      /**
       * Used to match
       * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
       */
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

      /** Used to match `RegExp` flags from their coerced string values. */
      var reFlags = /\w*$/;

      /** Used to detect bad signed hexadecimal string values. */
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

      /** Used to detect binary string values. */
      var reIsBinary = /^0b[01]+$/i;

      /** Used to detect host constructors (Safari). */
      var reIsHostCtor = /^\[object .+?Constructor\]$/;

      /** Used to detect octal string values. */
      var reIsOctal = /^0o[0-7]+$/i;

      /** Used to detect unsigned integer values. */
      var reIsUint = /^(?:0|[1-9]\d*)$/;

      /** Used to match Latin Unicode letters (excluding mathematical operators). */
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

      /** Used to ensure capturing order of template delimiters. */
      var reNoMatch = /($^)/;

      /** Used to match unescaped characters in compiled string literals. */
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

      /** Used to compose unicode character classes. */
      var rsAstralRange = '\\ud800-\\udfff',
        rsComboMarksRange = '\\u0300-\\u036f',
        reComboHalfMarksRange = '\\ufe20-\\ufe2f',
        rsComboSymbolsRange = '\\u20d0-\\u20ff',
        rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
        rsDingbatRange = '\\u2700-\\u27bf',
        rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
        rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
        rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
        rsPunctuationRange = '\\u2000-\\u206f',
        rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
        rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
        rsVarRange = '\\ufe0e\\ufe0f',
        rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

      /** Used to compose unicode capture groups. */
      var rsApos = "['\u2019]",
        rsAstral = '[' + rsAstralRange + ']',
        rsBreak = '[' + rsBreakRange + ']',
        rsCombo = '[' + rsComboRange + ']',
        rsDigits = '\\d+',
        rsDingbat = '[' + rsDingbatRange + ']',
        rsLower = '[' + rsLowerRange + ']',
        rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
        rsFitz = '\\ud83c[\\udffb-\\udfff]',
        rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
        rsNonAstral = '[^' + rsAstralRange + ']',
        rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
        rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
        rsUpper = '[' + rsUpperRange + ']',
        rsZWJ = '\\u200d';

      /** Used to compose unicode regexes. */
      var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
        rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
        rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
        rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
        reOptMod = rsModifier + '?',
        rsOptVar = '[' + rsVarRange + ']?',
        rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
        rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
        rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
        rsSeq = rsOptVar + reOptMod + rsOptJoin,
        rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
        rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

      /** Used to match apostrophes. */
      var reApos = RegExp(rsApos, 'g');

      /**
       * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
       * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
       */
      var reComboMark = RegExp(rsCombo, 'g');

      /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
      var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

      /** Used to match complex or compound words. */
      var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');

      /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
      var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

      /** Used to detect strings that need a more robust regexp to match words. */
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

      /** Used to assign default `context` object properties. */
      var contextProps = ['Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array', 'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object', 'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'];

      /** Used to make template sourceURLs easier to identify. */
      var templateCounter = -1;

      /** Used to identify `toStringTag` values of typed arrays. */
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

      /** Used to identify `toStringTag` values supported by `_.clone`. */
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

      /** Used to map Latin Unicode letters to basic Latin letters. */
      var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
      };

      /** Used to map characters to HTML entities. */
      var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      };

      /** Used to map HTML entities to characters. */
      var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
      };

      /** Used to escape characters for inclusion in compiled string literals. */
      var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
      };

      /** Built-in method references without a dependency on `root`. */
      var freeParseFloat = parseFloat,
        freeParseInt = parseInt;

      /** Detect free variable `global` from Node.js. */
      var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

      /** Detect free variable `self`. */
      var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

      /** Used as a reference to the global object. */
      var root = freeGlobal || freeSelf || Function('return this')();

      /** Detect free variable `exports`. */
      var freeExports = true && exports && !exports.nodeType && exports;

      /** Detect free variable `module`. */
      var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

      /** Detect the popular CommonJS extension `module.exports`. */
      var moduleExports = freeModule && freeModule.exports === freeExports;

      /** Detect free variable `process` from Node.js. */
      var freeProcess = moduleExports && freeGlobal.process;

      /** Used to access faster Node.js helpers. */
      var nodeUtil = function () {
        try {
          // Use `util.types` for Node.js 10+.
          var types = freeModule && freeModule.require && freeModule.require('util').types;
          if (types) {
            return types;
          }

          // Legacy `process.binding('util')` for Node.js < 10.
          return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
      }();

      /* Node.js helper references. */
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
        nodeIsDate = nodeUtil && nodeUtil.isDate,
        nodeIsMap = nodeUtil && nodeUtil.isMap,
        nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
        nodeIsSet = nodeUtil && nodeUtil.isSet,
        nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

      /*--------------------------------------------------------------------------*/

      /**
       * A faster alternative to `Function#apply`, this function invokes `func`
       * with the `this` binding of `thisArg` and the arguments of `args`.
       *
       * @private
       * @param {Function} func The function to invoke.
       * @param {*} thisArg The `this` binding of `func`.
       * @param {Array} args The arguments to invoke `func` with.
       * @returns {*} Returns the result of `func`.
       */
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }

      /**
       * A specialized version of `baseAggregator` for arrays.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} setter The function to set `accumulator` values.
       * @param {Function} iteratee The iteratee to transform keys.
       * @param {Object} accumulator The initial aggregated object.
       * @returns {Function} Returns `accumulator`.
       */
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1,
          length = array == null ? 0 : array.length;
        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }

      /**
       * A specialized version of `_.forEach` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns `array`.
       */
      function arrayEach(array, iteratee) {
        var index = -1,
          length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }

      /**
       * A specialized version of `_.forEachRight` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns `array`.
       */
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }

      /**
       * A specialized version of `_.every` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {boolean} Returns `true` if all elements pass the predicate check,
       *  else `false`.
       */
      function arrayEvery(array, predicate) {
        var index = -1,
          length = array == null ? 0 : array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }

      /**
       * A specialized version of `_.filter` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       */
      function arrayFilter(array, predicate) {
        var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }

      /**
       * A specialized version of `_.includes` for arrays without support for
       * specifying an index to search from.
       *
       * @private
       * @param {Array} [array] The array to inspect.
       * @param {*} target The value to search for.
       * @returns {boolean} Returns `true` if `target` is found, else `false`.
       */
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }

      /**
       * This function is like `arrayIncludes` except that it accepts a comparator.
       *
       * @private
       * @param {Array} [array] The array to inspect.
       * @param {*} target The value to search for.
       * @param {Function} comparator The comparator invoked per element.
       * @returns {boolean} Returns `true` if `target` is found, else `false`.
       */
      function arrayIncludesWith(array, value, comparator) {
        var index = -1,
          length = array == null ? 0 : array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }

      /**
       * A specialized version of `_.map` for arrays without support for iteratee
       * shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the new mapped array.
       */
      function arrayMap(array, iteratee) {
        var index = -1,
          length = array == null ? 0 : array.length,
          result = Array(length);
        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }

      /**
       * Appends the elements of `values` to `array`.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {Array} values The values to append.
       * @returns {Array} Returns `array`.
       */
      function arrayPush(array, values) {
        var index = -1,
          length = values.length,
          offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }

      /**
       * A specialized version of `_.reduce` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @param {boolean} [initAccum] Specify using the first element of `array` as
       *  the initial value.
       * @returns {*} Returns the accumulated value.
       */
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1,
          length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }

      /**
       * A specialized version of `_.reduceRight` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @param {boolean} [initAccum] Specify using the last element of `array` as
       *  the initial value.
       * @returns {*} Returns the accumulated value.
       */
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }

      /**
       * A specialized version of `_.some` for arrays without support for iteratee
       * shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {boolean} Returns `true` if any element passes the predicate check,
       *  else `false`.
       */
      function arraySome(array, predicate) {
        var index = -1,
          length = array == null ? 0 : array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }

      /**
       * Gets the size of an ASCII `string`.
       *
       * @private
       * @param {string} string The string inspect.
       * @returns {number} Returns the string size.
       */
      var asciiSize = baseProperty('length');

      /**
       * Converts an ASCII `string` to an array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the converted array.
       */
      function asciiToArray(string) {
        return string.split('');
      }

      /**
       * Splits an ASCII `string` into an array of its words.
       *
       * @private
       * @param {string} The string to inspect.
       * @returns {Array} Returns the words of `string`.
       */
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }

      /**
       * The base implementation of methods like `_.findKey` and `_.findLastKey`,
       * without support for iteratee shorthands, which iterates over `collection`
       * using `eachFunc`.
       *
       * @private
       * @param {Array|Object} collection The collection to inspect.
       * @param {Function} predicate The function invoked per iteration.
       * @param {Function} eachFunc The function to iterate over `collection`.
       * @returns {*} Returns the found element or its key, else `undefined`.
       */
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function (value, key, collection) {
          if (predicate(value, key, collection)) {
            result = key;
            return false;
          }
        });
        return result;
      }

      /**
       * The base implementation of `_.findIndex` and `_.findLastIndex` without
       * support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Function} predicate The function invoked per iteration.
       * @param {number} fromIndex The index to search from.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length,
          index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }

      /**
       * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }

      /**
       * This function is like `baseIndexOf` except that it accepts a comparator.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @param {Function} comparator The comparator invoked per element.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1,
          length = array.length;
        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }
        return -1;
      }

      /**
       * The base implementation of `_.isNaN` without support for number objects.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
       */
      function baseIsNaN(value) {
        return value !== value;
      }

      /**
       * The base implementation of `_.mean` and `_.meanBy` without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {number} Returns the mean.
       */
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }

      /**
       * The base implementation of `_.property` without support for deep paths.
       *
       * @private
       * @param {string} key The key of the property to get.
       * @returns {Function} Returns the new accessor function.
       */
      function baseProperty(key) {
        return function (object) {
          return object == null ? undefined : object[key];
        };
      }

      /**
       * The base implementation of `_.propertyOf` without support for deep paths.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Function} Returns the new accessor function.
       */
      function basePropertyOf(object) {
        return function (key) {
          return object == null ? undefined : object[key];
        };
      }

      /**
       * The base implementation of `_.reduce` and `_.reduceRight`, without support
       * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {*} accumulator The initial value.
       * @param {boolean} initAccum Specify using the first or last element of
       *  `collection` as the initial value.
       * @param {Function} eachFunc The function to iterate over `collection`.
       * @returns {*} Returns the accumulated value.
       */
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function (value, index, collection) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
      }

      /**
       * The base implementation of `_.sortBy` which uses `comparer` to define the
       * sort order of `array` and replaces criteria objects with their corresponding
       * values.
       *
       * @private
       * @param {Array} array The array to sort.
       * @param {Function} comparer The function to define sort order.
       * @returns {Array} Returns `array`.
       */
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }

      /**
       * The base implementation of `_.sum` and `_.sumBy` without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {number} Returns the sum.
       */
      function baseSum(array, iteratee) {
        var result,
          index = -1,
          length = array.length;
        while (++index < length) {
          var current = iteratee(array[index]);
          if (current !== undefined) {
            result = result === undefined ? current : result + current;
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.times` without support for iteratee shorthands
       * or max array length checks.
       *
       * @private
       * @param {number} n The number of times to invoke `iteratee`.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the array of results.
       */
      function baseTimes(n, iteratee) {
        var index = -1,
          result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }

      /**
       * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
       * of key-value pairs for `object` corresponding to the property names of `props`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} props The property names to get values for.
       * @returns {Object} Returns the key-value pairs.
       */
      function baseToPairs(object, props) {
        return arrayMap(props, function (key) {
          return [key, object[key]];
        });
      }

      /**
       * The base implementation of `_.trim`.
       *
       * @private
       * @param {string} string The string to trim.
       * @returns {string} Returns the trimmed string.
       */
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
      }

      /**
       * The base implementation of `_.unary` without support for storing metadata.
       *
       * @private
       * @param {Function} func The function to cap arguments for.
       * @returns {Function} Returns the new capped function.
       */
      function baseUnary(func) {
        return function (value) {
          return func(value);
        };
      }

      /**
       * The base implementation of `_.values` and `_.valuesIn` which creates an
       * array of `object` property values corresponding to the property names
       * of `props`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} props The property names to get values for.
       * @returns {Object} Returns the array of property values.
       */
      function baseValues(object, props) {
        return arrayMap(props, function (key) {
          return object[key];
        });
      }

      /**
       * Checks if a `cache` value for `key` exists.
       *
       * @private
       * @param {Object} cache The cache to query.
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function cacheHas(cache, key) {
        return cache.has(key);
      }

      /**
       * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
       * that is not found in the character symbols.
       *
       * @private
       * @param {Array} strSymbols The string symbols to inspect.
       * @param {Array} chrSymbols The character symbols to find.
       * @returns {number} Returns the index of the first unmatched string symbol.
       */
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1,
          length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
        return index;
      }

      /**
       * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
       * that is not found in the character symbols.
       *
       * @private
       * @param {Array} strSymbols The string symbols to inspect.
       * @param {Array} chrSymbols The character symbols to find.
       * @returns {number} Returns the index of the last unmatched string symbol.
       */
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
        return index;
      }

      /**
       * Gets the number of `placeholder` occurrences in `array`.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} placeholder The placeholder to search for.
       * @returns {number} Returns the placeholder count.
       */
      function countHolders(array, placeholder) {
        var length = array.length,
          result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }

      /**
       * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
       * letters to basic Latin letters.
       *
       * @private
       * @param {string} letter The matched letter to deburr.
       * @returns {string} Returns the deburred letter.
       */
      var deburrLetter = basePropertyOf(deburredLetters);

      /**
       * Used by `_.escape` to convert characters to HTML entities.
       *
       * @private
       * @param {string} chr The matched character to escape.
       * @returns {string} Returns the escaped character.
       */
      var escapeHtmlChar = basePropertyOf(htmlEscapes);

      /**
       * Used by `_.template` to escape characters for inclusion in compiled string literals.
       *
       * @private
       * @param {string} chr The matched character to escape.
       * @returns {string} Returns the escaped character.
       */
      function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
      }

      /**
       * Gets the value at `key` of `object`.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {string} key The key of the property to get.
       * @returns {*} Returns the property value.
       */
      function getValue(object, key) {
        return object == null ? undefined : object[key];
      }

      /**
       * Checks if `string` contains Unicode symbols.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {boolean} Returns `true` if a symbol is found, else `false`.
       */
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }

      /**
       * Checks if `string` contains a word composed of Unicode symbols.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {boolean} Returns `true` if a word is found, else `false`.
       */
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }

      /**
       * Converts `iterator` to an array.
       *
       * @private
       * @param {Object} iterator The iterator to convert.
       * @returns {Array} Returns the converted array.
       */
      function iteratorToArray(iterator) {
        var data,
          result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }

      /**
       * Converts `map` to its key-value pairs.
       *
       * @private
       * @param {Object} map The map to convert.
       * @returns {Array} Returns the key-value pairs.
       */
      function mapToArray(map) {
        var index = -1,
          result = Array(map.size);
        map.forEach(function (value, key) {
          result[++index] = [key, value];
        });
        return result;
      }

      /**
       * Creates a unary function that invokes `func` with its argument transformed.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {Function} transform The argument transform.
       * @returns {Function} Returns the new function.
       */
      function overArg(func, transform) {
        return function (arg) {
          return func(transform(arg));
        };
      }

      /**
       * Replaces all `placeholder` elements in `array` with an internal placeholder
       * and returns an array of their indexes.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {*} placeholder The placeholder to replace.
       * @returns {Array} Returns the new array of placeholder indexes.
       */
      function replaceHolders(array, placeholder) {
        var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];
        while (++index < length) {
          var value = array[index];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
          }
        }
        return result;
      }

      /**
       * Converts `set` to an array of its values.
       *
       * @private
       * @param {Object} set The set to convert.
       * @returns {Array} Returns the values.
       */
      function setToArray(set) {
        var index = -1,
          result = Array(set.size);
        set.forEach(function (value) {
          result[++index] = value;
        });
        return result;
      }

      /**
       * Converts `set` to its value-value pairs.
       *
       * @private
       * @param {Object} set The set to convert.
       * @returns {Array} Returns the value-value pairs.
       */
      function setToPairs(set) {
        var index = -1,
          result = Array(set.size);
        set.forEach(function (value) {
          result[++index] = [value, value];
        });
        return result;
      }

      /**
       * A specialized version of `_.indexOf` which performs strict equality
       * comparisons of values, i.e. `===`.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1,
          length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }

      /**
       * A specialized version of `_.lastIndexOf` which performs strict equality
       * comparisons of values, i.e. `===`.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }
        return index;
      }

      /**
       * Gets the number of symbols in `string`.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {number} Returns the string size.
       */
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }

      /**
       * Converts `string` to an array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the converted array.
       */
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }

      /**
       * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
       * character of `string`.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {number} Returns the index of the last non-whitespace character.
       */
      function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) {}
        return index;
      }

      /**
       * Used by `_.unescape` to convert HTML entities to characters.
       *
       * @private
       * @param {string} chr The matched character to unescape.
       * @returns {string} Returns the unescaped character.
       */
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

      /**
       * Gets the size of a Unicode `string`.
       *
       * @private
       * @param {string} string The string inspect.
       * @returns {number} Returns the string size.
       */
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }

      /**
       * Converts a Unicode `string` to an array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the converted array.
       */
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }

      /**
       * Splits a Unicode `string` into an array of its words.
       *
       * @private
       * @param {string} The string to inspect.
       * @returns {Array} Returns the words of `string`.
       */
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }

      /*--------------------------------------------------------------------------*/

      /**
       * Create a new pristine `lodash` function using the `context` object.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category Util
       * @param {Object} [context=root] The context object.
       * @returns {Function} Returns a new `lodash` function.
       * @example
       *
       * _.mixin({ 'foo': _.constant('foo') });
       *
       * var lodash = _.runInContext();
       * lodash.mixin({ 'bar': lodash.constant('bar') });
       *
       * _.isFunction(_.foo);
       * // => true
       * _.isFunction(_.bar);
       * // => false
       *
       * lodash.isFunction(lodash.foo);
       * // => false
       * lodash.isFunction(lodash.bar);
       * // => true
       *
       * // Create a suped-up `defer` in Node.js.
       * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
       */
      var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

        /** Built-in constructor references. */
        var Array = context.Array,
          Date = context.Date,
          Error = context.Error,
          Function = context.Function,
          Math = context.Math,
          Object = context.Object,
          RegExp = context.RegExp,
          String = context.String,
          TypeError = context.TypeError;

        /** Used for built-in method references. */
        var arrayProto = Array.prototype,
          funcProto = Function.prototype,
          objectProto = Object.prototype;

        /** Used to detect overreaching core-js shims. */
        var coreJsData = context['__core-js_shared__'];

        /** Used to resolve the decompiled source of functions. */
        var funcToString = funcProto.toString;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /** Used to generate unique IDs. */
        var idCounter = 0;

        /** Used to detect methods masquerading as native. */
        var maskSrcKey = function () {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
          return uid ? 'Symbol(src)_1.' + uid : '';
        }();

        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */
        var nativeObjectToString = objectProto.toString;

        /** Used to infer the `Object` constructor. */
        var objectCtorString = funcToString.call(Object);

        /** Used to restore the original `_` reference in `_.noConflict`. */
        var oldDash = root._;

        /** Used to detect if a method is native. */
        var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

        /** Built-in value references. */
        var Buffer = moduleExports ? context.Buffer : undefined,
          Symbol = context.Symbol,
          Uint8Array = context.Uint8Array,
          allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
          getPrototype = overArg(Object.getPrototypeOf, Object),
          objectCreate = Object.create,
          propertyIsEnumerable = objectProto.propertyIsEnumerable,
          splice = arrayProto.splice,
          spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
          symIterator = Symbol ? Symbol.iterator : undefined,
          symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function () {
          try {
            var func = getNative(Object, 'defineProperty');
            func({}, '', {});
            return func;
          } catch (e) {}
        }();

        /** Mocked built-ins. */
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
          ctxNow = Date && Date.now !== root.Date.now && Date.now,
          ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeCeil = Math.ceil,
          nativeFloor = Math.floor,
          nativeGetSymbols = Object.getOwnPropertySymbols,
          nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
          nativeIsFinite = context.isFinite,
          nativeJoin = arrayProto.join,
          nativeKeys = overArg(Object.keys, Object),
          nativeMax = Math.max,
          nativeMin = Math.min,
          nativeNow = Date.now,
          nativeParseInt = context.parseInt,
          nativeRandom = Math.random,
          nativeReverse = arrayProto.reverse;

        /* Built-in method references that are verified to be native. */
        var DataView = getNative(context, 'DataView'),
          Map = getNative(context, 'Map'),
          Promise = getNative(context, 'Promise'),
          Set = getNative(context, 'Set'),
          WeakMap = getNative(context, 'WeakMap'),
          nativeCreate = getNative(Object, 'create');

        /** Used to store function metadata. */
        var metaMap = WeakMap && new WeakMap();

        /** Used to lookup unminified function names. */
        var realNames = {};

        /** Used to detect maps, sets, and weakmaps. */
        var dataViewCtorString = toSource(DataView),
          mapCtorString = toSource(Map),
          promiseCtorString = toSource(Promise),
          setCtorString = toSource(Set),
          weakMapCtorString = toSource(WeakMap);

        /** Used to convert symbols to primitives and strings. */
        var symbolProto = Symbol ? Symbol.prototype : undefined,
          symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
          symbolToString = symbolProto ? symbolProto.toString : undefined;

        /*------------------------------------------------------------------------*/

        /**
         * Creates a `lodash` object which wraps `value` to enable implicit method
         * chain sequences. Methods that operate on and return arrays, collections,
         * and functions can be chained together. Methods that retrieve a single value
         * or may return a primitive value will automatically end the chain sequence
         * and return the unwrapped value. Otherwise, the value must be unwrapped
         * with `_#value`.
         *
         * Explicit chain sequences, which must be unwrapped with `_#value`, may be
         * enabled using `_.chain`.
         *
         * The execution of chained methods is lazy, that is, it's deferred until
         * `_#value` is implicitly or explicitly called.
         *
         * Lazy evaluation allows several methods to support shortcut fusion.
         * Shortcut fusion is an optimization to merge iteratee calls; this avoids
         * the creation of intermediate arrays and can greatly reduce the number of
         * iteratee executions. Sections of a chain sequence qualify for shortcut
         * fusion if the section is applied to an array and iteratees accept only
         * one argument. The heuristic for whether a section qualifies for shortcut
         * fusion is subject to change.
         *
         * Chaining is supported in custom builds as long as the `_#value` method is
         * directly or indirectly included in the build.
         *
         * In addition to lodash methods, wrappers have `Array` and `String` methods.
         *
         * The wrapper `Array` methods are:
         * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
         *
         * The wrapper `String` methods are:
         * `replace` and `split`
         *
         * The wrapper methods that support shortcut fusion are:
         * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
         * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
         * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
         *
         * The chainable wrapper methods are:
         * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
         * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
         * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
         * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
         * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
         * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
         * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
         * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
         * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
         * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
         * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
         * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
         * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
         * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
         * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
         * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
         * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
         * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
         * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
         * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
         * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
         * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
         * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
         * `zipObject`, `zipObjectDeep`, and `zipWith`
         *
         * The wrapper methods that are **not** chainable by default are:
         * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
         * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
         * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
         * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
         * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
         * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
         * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
         * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
         * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
         * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
         * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
         * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
         * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
         * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
         * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
         * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
         * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
         * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
         * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
         * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
         * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
         * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
         * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
         * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
         * `upperFirst`, `value`, and `words`
         *
         * @name _
         * @constructor
         * @category Seq
         * @param {*} value The value to wrap in a `lodash` instance.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var wrapped = _([1, 2, 3]);
         *
         * // Returns an unwrapped value.
         * wrapped.reduce(_.add);
         * // => 6
         *
         * // Returns a wrapped value.
         * var squares = wrapped.map(square);
         *
         * _.isArray(squares);
         * // => false
         *
         * _.isArray(squares.value());
         * // => true
         */
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, '__wrapped__')) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }

        /**
         * The base implementation of `_.create` without support for assigning
         * properties to the created object.
         *
         * @private
         * @param {Object} proto The object to inherit from.
         * @returns {Object} Returns the new object.
         */
        var baseCreate = function () {
          function object() {}
          return function (proto) {
            if (!isObject(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result = new object();
            object.prototype = undefined;
            return result;
          };
        }();

        /**
         * The function whose prototype chain sequence wrappers inherit from.
         *
         * @private
         */
        function baseLodash() {
          // No operation performed.
        }

        /**
         * The base constructor for creating `lodash` wrapper objects.
         *
         * @private
         * @param {*} value The value to wrap.
         * @param {boolean} [chainAll] Enable explicit method chain sequences.
         */
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined;
        }

        /**
         * By default, the template delimiters used by lodash are like those in
         * embedded Ruby (ERB) as well as ES2015 template strings. Change the
         * following template settings to use alternative delimiters.
         *
         * @static
         * @memberOf _
         * @type {Object}
         */
        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          'escape': reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          'evaluate': reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          'interpolate': reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          'variable': '',
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          'imports': {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            '_': lodash
          }
        };

        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;

        /*------------------------------------------------------------------------*/

        /**
         * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
         *
         * @private
         * @constructor
         * @param {*} value The value to wrap.
         */
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }

        /**
         * Creates a clone of the lazy wrapper object.
         *
         * @private
         * @name clone
         * @memberOf LazyWrapper
         * @returns {Object} Returns the cloned `LazyWrapper` object.
         */
        function lazyClone() {
          var result = new LazyWrapper(this.__wrapped__);
          result.__actions__ = copyArray(this.__actions__);
          result.__dir__ = this.__dir__;
          result.__filtered__ = this.__filtered__;
          result.__iteratees__ = copyArray(this.__iteratees__);
          result.__takeCount__ = this.__takeCount__;
          result.__views__ = copyArray(this.__views__);
          return result;
        }

        /**
         * Reverses the direction of lazy iteration.
         *
         * @private
         * @name reverse
         * @memberOf LazyWrapper
         * @returns {Object} Returns the new reversed `LazyWrapper` object.
         */
        function lazyReverse() {
          if (this.__filtered__) {
            var result = new LazyWrapper(this);
            result.__dir__ = -1;
            result.__filtered__ = true;
          } else {
            result = this.clone();
            result.__dir__ *= -1;
          }
          return result;
        }

        /**
         * Extracts the unwrapped value from its lazy wrapper.
         *
         * @private
         * @name value
         * @memberOf LazyWrapper
         * @returns {*} Returns the unwrapped value.
         */
        function lazyValue() {
          var array = this.__wrapped__.value(),
            dir = this.__dir__,
            isArr = isArray(array),
            isRight = dir < 0,
            arrLength = isArr ? array.length : 0,
            view = getView(0, arrLength, this.__views__),
            start = view.start,
            end = view.end,
            length = end - start,
            index = isRight ? end : start - 1,
            iteratees = this.__iteratees__,
            iterLength = iteratees.length,
            resIndex = 0,
            takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result = [];
          outer: while (length-- && resIndex < takeCount) {
            index += dir;
            var iterIndex = -1,
              value = array[index];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex],
                iteratee = data.iteratee,
                type = data.type,
                computed = iteratee(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result[resIndex++] = value;
          }
          return result;
        }

        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;

        /*------------------------------------------------------------------------*/

        /**
         * Creates a hash object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function Hash(entries) {
          var index = -1,
            length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }

        /**
         * Removes all key-value entries from the hash.
         *
         * @private
         * @name clear
         * @memberOf Hash
         */
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }

        /**
         * Removes `key` and its value from the hash.
         *
         * @private
         * @name delete
         * @memberOf Hash
         * @param {Object} hash The hash to modify.
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function hashDelete(key) {
          var result = this.has(key) && delete this.__data__[key];
          this.size -= result ? 1 : 0;
          return result;
        }

        /**
         * Gets the hash value for `key`.
         *
         * @private
         * @name get
         * @memberOf Hash
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }

        /**
         * Checks if a hash value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Hash
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }

        /**
         * Sets the hash `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Hash
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the hash instance.
         */
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
          return this;
        }

        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;

        /*------------------------------------------------------------------------*/

        /**
         * Creates an list cache object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function ListCache(entries) {
          var index = -1,
            length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }

        /**
         * Removes all key-value entries from the list cache.
         *
         * @private
         * @name clear
         * @memberOf ListCache
         */
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }

        /**
         * Removes `key` and its value from the list cache.
         *
         * @private
         * @name delete
         * @memberOf ListCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function listCacheDelete(key) {
          var data = this.__data__,
            index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }

        /**
         * Gets the list cache value for `key`.
         *
         * @private
         * @name get
         * @memberOf ListCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function listCacheGet(key) {
          var data = this.__data__,
            index = assocIndexOf(data, key);
          return index < 0 ? undefined : data[index][1];
        }

        /**
         * Checks if a list cache value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf ListCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }

        /**
         * Sets the list cache `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf ListCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the list cache instance.
         */
        function listCacheSet(key, value) {
          var data = this.__data__,
            index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }
          return this;
        }

        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;

        /*------------------------------------------------------------------------*/

        /**
         * Creates a map cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function MapCache(entries) {
          var index = -1,
            length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }

        /**
         * Removes all key-value entries from the map.
         *
         * @private
         * @name clear
         * @memberOf MapCache
         */
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            'hash': new Hash(),
            'map': new (Map || ListCache)(),
            'string': new Hash()
          };
        }

        /**
         * Removes `key` and its value from the map.
         *
         * @private
         * @name delete
         * @memberOf MapCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function mapCacheDelete(key) {
          var result = getMapData(this, key)['delete'](key);
          this.size -= result ? 1 : 0;
          return result;
        }

        /**
         * Gets the map value for `key`.
         *
         * @private
         * @name get
         * @memberOf MapCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }

        /**
         * Checks if a map value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf MapCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }

        /**
         * Sets the map `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf MapCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the map cache instance.
         */
        function mapCacheSet(key, value) {
          var data = getMapData(this, key),
            size = data.size;
          data.set(key, value);
          this.size += data.size == size ? 0 : 1;
          return this;
        }

        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;

        /*------------------------------------------------------------------------*/

        /**
         *
         * Creates an array cache object to store unique values.
         *
         * @private
         * @constructor
         * @param {Array} [values] The values to cache.
         */
        function SetCache(values) {
          var index = -1,
            length = values == null ? 0 : values.length;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.add(values[index]);
          }
        }

        /**
         * Adds `value` to the array cache.
         *
         * @private
         * @name add
         * @memberOf SetCache
         * @alias push
         * @param {*} value The value to cache.
         * @returns {Object} Returns the cache instance.
         */
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }

        /**
         * Checks if `value` is in the array cache.
         *
         * @private
         * @name has
         * @memberOf SetCache
         * @param {*} value The value to search for.
         * @returns {number} Returns `true` if `value` is found, else `false`.
         */
        function setCacheHas(value) {
          return this.__data__.has(value);
        }

        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;

        /*------------------------------------------------------------------------*/

        /**
         * Creates a stack cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }

        /**
         * Removes all key-value entries from the stack.
         *
         * @private
         * @name clear
         * @memberOf Stack
         */
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }

        /**
         * Removes `key` and its value from the stack.
         *
         * @private
         * @name delete
         * @memberOf Stack
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function stackDelete(key) {
          var data = this.__data__,
            result = data['delete'](key);
          this.size = data.size;
          return result;
        }

        /**
         * Gets the stack value for `key`.
         *
         * @private
         * @name get
         * @memberOf Stack
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function stackGet(key) {
          return this.__data__.get(key);
        }

        /**
         * Checks if a stack value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Stack
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function stackHas(key) {
          return this.__data__.has(key);
        }

        /**
         * Sets the stack `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Stack
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the stack cache instance.
         */
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }

        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;

        /*------------------------------------------------------------------------*/

        /**
         * Creates an array of the enumerable property names of the array-like `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @param {boolean} inherited Specify returning inherited property names.
         * @returns {Array} Returns the array of property names.
         */
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value),
            isArg = !isArr && isArguments(value),
            isBuff = !isArr && !isArg && isBuffer(value),
            isType = !isArr && !isArg && !isBuff && isTypedArray(value),
            skipIndexes = isArr || isArg || isBuff || isType,
            result = skipIndexes ? baseTimes(value.length, String) : [],
            length = result.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
            // Safari 9 has enumerable `arguments.length` in strict mode.
            key == 'length' ||
            // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') ||
            // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
            // Skip index properties.
            isIndex(key, length)))) {
              result.push(key);
            }
          }
          return result;
        }

        /**
         * A specialized version of `_.sample` for arrays.
         *
         * @private
         * @param {Array} array The array to sample.
         * @returns {*} Returns the random element.
         */
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined;
        }

        /**
         * A specialized version of `_.sampleSize` for arrays.
         *
         * @private
         * @param {Array} array The array to sample.
         * @param {number} n The number of elements to sample.
         * @returns {Array} Returns the random elements.
         */
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }

        /**
         * A specialized version of `_.shuffle` for arrays.
         *
         * @private
         * @param {Array} array The array to shuffle.
         * @returns {Array} Returns the new shuffled array.
         */
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }

        /**
         * This function is like `assignValue` except that it doesn't assign
         * `undefined` values.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */
        function assignMergeValue(object, key, value) {
          if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }

        /**
         * Assigns `value` to `key` of `object` if the existing value is not equivalent
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }

        /**
         * Gets the index at which the `key` is found in `array` of key-value pairs.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {*} key The key to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }

        /**
         * Aggregates elements of `collection` on `accumulator` with keys transformed
         * by `iteratee` and values set by `setter`.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} setter The function to set `accumulator` values.
         * @param {Function} iteratee The iteratee to transform keys.
         * @param {Object} accumulator The initial aggregated object.
         * @returns {Function} Returns `accumulator`.
         */
        function baseAggregator(collection, setter, iteratee, accumulator) {
          baseEach(collection, function (value, key, collection) {
            setter(accumulator, value, iteratee(value), collection);
          });
          return accumulator;
        }

        /**
         * The base implementation of `_.assign` without support for multiple sources
         * or `customizer` functions.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @returns {Object} Returns `object`.
         */
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }

        /**
         * The base implementation of `_.assignIn` without support for multiple sources
         * or `customizer` functions.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @returns {Object} Returns `object`.
         */
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }

        /**
         * The base implementation of `assignValue` and `assignMergeValue` without
         * value checks.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */
        function baseAssignValue(object, key, value) {
          if (key == '__proto__' && defineProperty) {
            defineProperty(object, key, {
              'configurable': true,
              'enumerable': true,
              'value': value,
              'writable': true
            });
          } else {
            object[key] = value;
          }
        }

        /**
         * The base implementation of `_.at` without support for individual paths.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {string[]} paths The property paths to pick.
         * @returns {Array} Returns the picked elements.
         */
        function baseAt(object, paths) {
          var index = -1,
            length = paths.length,
            result = Array(length),
            skip = object == null;
          while (++index < length) {
            result[index] = skip ? undefined : get(object, paths[index]);
          }
          return result;
        }

        /**
         * The base implementation of `_.clamp` which doesn't coerce arguments.
         *
         * @private
         * @param {number} number The number to clamp.
         * @param {number} [lower] The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the clamped number.
         */
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }

        /**
         * The base implementation of `_.clone` and `_.cloneDeep` which tracks
         * traversed objects.
         *
         * @private
         * @param {*} value The value to clone.
         * @param {boolean} bitmask The bitmask flags.
         *  1 - Deep clone
         *  2 - Flatten inherited properties
         *  4 - Clone symbols
         * @param {Function} [customizer] The function to customize cloning.
         * @param {string} [key] The key of `value`.
         * @param {Object} [object] The parent object of `value`.
         * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
         * @returns {*} Returns the cloned value.
         */
        function baseClone(value, bitmask, customizer, key, object, stack) {
          var result,
            isDeep = bitmask & CLONE_DEEP_FLAG,
            isFlat = bitmask & CLONE_FLAT_FLAG,
            isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result = object ? customizer(value, key, object, stack) : customizer(value);
          }
          if (result !== undefined) {
            return result;
          }
          if (!isObject(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result);
            }
          } else {
            var tag = getTag(value),
              isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }
              result = initCloneByTag(value, tag, isDeep);
            }
          }
          // Check for circular references and return its corresponding clone.
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result);
          if (isSet(value)) {
            value.forEach(function (subValue) {
              result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function (subValue, key) {
              result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined : keysFunc(value);
          arrayEach(props || value, function (subValue, key) {
            if (props) {
              key = subValue;
              subValue = value[key];
            }
            // Recursively populate clone (susceptible to call stack limits).
            assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
          });
          return result;
        }

        /**
         * The base implementation of `_.conforms` which doesn't clone `source`.
         *
         * @private
         * @param {Object} source The object of property predicates to conform to.
         * @returns {Function} Returns the new spec function.
         */
        function baseConforms(source) {
          var props = keys(source);
          return function (object) {
            return baseConformsTo(object, source, props);
          };
        }

        /**
         * The base implementation of `_.conformsTo` which accepts `props` to check.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property predicates to conform to.
         * @returns {boolean} Returns `true` if `object` conforms, else `false`.
         */
        function baseConformsTo(object, source, props) {
          var length = props.length;
          if (object == null) {
            return !length;
          }
          object = Object(object);
          while (length--) {
            var key = props[length],
              predicate = source[key],
              value = object[key];
            if (value === undefined && !(key in object) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }

        /**
         * The base implementation of `_.delay` and `_.defer` which accepts `args`
         * to provide to `func`.
         *
         * @private
         * @param {Function} func The function to delay.
         * @param {number} wait The number of milliseconds to delay invocation.
         * @param {Array} args The arguments to provide to `func`.
         * @returns {number|Object} Returns the timer id or timeout object.
         */
        function baseDelay(func, wait, args) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          return setTimeout(function () {
            func.apply(undefined, args);
          }, wait);
        }

        /**
         * The base implementation of methods like `_.difference` without support
         * for excluding multiple arrays or iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Array} values The values to exclude.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         */
        function baseDifference(array, values, iteratee, comparator) {
          var index = -1,
            includes = arrayIncludes,
            isCommon = true,
            length = array.length,
            result = [],
            valuesLength = values.length;
          if (!length) {
            return result;
          }
          if (iteratee) {
            values = arrayMap(values, baseUnary(iteratee));
          }
          if (comparator) {
            includes = arrayIncludesWith;
            isCommon = false;
          } else if (values.length >= LARGE_ARRAY_SIZE) {
            includes = cacheHas;
            isCommon = false;
            values = new SetCache(values);
          }
          outer: while (++index < length) {
            var value = array[index],
              computed = iteratee == null ? value : iteratee(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result.push(value);
            } else if (!includes(values, computed, comparator)) {
              result.push(value);
            }
          }
          return result;
        }

        /**
         * The base implementation of `_.forEach` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         */
        var baseEach = createBaseEach(baseForOwn);

        /**
         * The base implementation of `_.forEachRight` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         */
        var baseEachRight = createBaseEach(baseForOwnRight, true);

        /**
         * The base implementation of `_.every` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {boolean} Returns `true` if all elements pass the predicate check,
         *  else `false`
         */
        function baseEvery(collection, predicate) {
          var result = true;
          baseEach(collection, function (value, index, collection) {
            result = !!predicate(value, index, collection);
            return result;
          });
          return result;
        }

        /**
         * The base implementation of methods like `_.max` and `_.min` which accepts a
         * `comparator` to determine the extremum value.
         *
         * @private
         * @param {Array} array The array to iterate over.
         * @param {Function} iteratee The iteratee invoked per iteration.
         * @param {Function} comparator The comparator used to compare values.
         * @returns {*} Returns the extremum value.
         */
        function baseExtremum(array, iteratee, comparator) {
          var index = -1,
            length = array.length;
          while (++index < length) {
            var value = array[index],
              current = iteratee(value);
            if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current,
                result = value;
            }
          }
          return result;
        }

        /**
         * The base implementation of `_.fill` without an iteratee call guard.
         *
         * @private
         * @param {Array} array The array to fill.
         * @param {*} value The value to fill `array` with.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns `array`.
         */
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }

        /**
         * The base implementation of `_.filter` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         */
        function baseFilter(collection, predicate) {
          var result = [];
          baseEach(collection, function (value, index, collection) {
            if (predicate(value, index, collection)) {
              result.push(value);
            }
          });
          return result;
        }

        /**
         * The base implementation of `_.flatten` with support for restricting flattening.
         *
         * @private
         * @param {Array} array The array to flatten.
         * @param {number} depth The maximum recursion depth.
         * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
         * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
         * @param {Array} [result=[]] The initial result value.
         * @returns {Array} Returns the new flattened array.
         */
        function baseFlatten(array, depth, predicate, isStrict, result) {
          var index = -1,
            length = array.length;
          predicate || (predicate = isFlattenable);
          result || (result = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                // Recursively flatten arrays (susceptible to call stack limits).
                baseFlatten(value, depth - 1, predicate, isStrict, result);
              } else {
                arrayPush(result, value);
              }
            } else if (!isStrict) {
              result[result.length] = value;
            }
          }
          return result;
        }

        /**
         * The base implementation of `baseForOwn` which iterates over `object`
         * properties returned by `keysFunc` and invokes `iteratee` for each property.
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @returns {Object} Returns `object`.
         */
        var baseFor = createBaseFor();

        /**
         * This function is like `baseFor` except that it iterates over properties
         * in the opposite order.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @returns {Object} Returns `object`.
         */
        var baseForRight = createBaseFor(true);

        /**
         * The base implementation of `_.forOwn` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Object} Returns `object`.
         */
        function baseForOwn(object, iteratee) {
          return object && baseFor(object, iteratee, keys);
        }

        /**
         * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Object} Returns `object`.
         */
        function baseForOwnRight(object, iteratee) {
          return object && baseForRight(object, iteratee, keys);
        }

        /**
         * The base implementation of `_.functions` which creates an array of
         * `object` function property names filtered from `props`.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Array} props The property names to filter.
         * @returns {Array} Returns the function names.
         */
        function baseFunctions(object, props) {
          return arrayFilter(props, function (key) {
            return isFunction(object[key]);
          });
        }

        /**
         * The base implementation of `_.get` without support for default values.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @returns {*} Returns the resolved value.
         */
        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0,
            length = path.length;
          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }
          return index && index == length ? object : undefined;
        }

        /**
         * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
         * `keysFunc` and `symbolsFunc` to get the enumerable property names and
         * symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @param {Function} symbolsFunc The function to get the symbols of `object`.
         * @returns {Array} Returns the array of property names and symbols.
         */
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result = keysFunc(object);
          return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }

        /**
         * The base implementation of `getTag` without fallbacks for buggy environments.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
        }

        /**
         * The base implementation of `_.gt` which doesn't coerce arguments.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than `other`,
         *  else `false`.
         */
        function baseGt(value, other) {
          return value > other;
        }

        /**
         * The base implementation of `_.has` without support for deep paths.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {Array|string} key The key to check.
         * @returns {boolean} Returns `true` if `key` exists, else `false`.
         */
        function baseHas(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }

        /**
         * The base implementation of `_.hasIn` without support for deep paths.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {Array|string} key The key to check.
         * @returns {boolean} Returns `true` if `key` exists, else `false`.
         */
        function baseHasIn(object, key) {
          return object != null && key in Object(object);
        }

        /**
         * The base implementation of `_.inRange` which doesn't coerce arguments.
         *
         * @private
         * @param {number} number The number to check.
         * @param {number} start The start of the range.
         * @param {number} end The end of the range.
         * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
         */
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }

        /**
         * The base implementation of methods like `_.intersection`, without support
         * for iteratee shorthands, that accepts an array of arrays to inspect.
         *
         * @private
         * @param {Array} arrays The arrays to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of shared values.
         */
        function baseIntersection(arrays, iteratee, comparator) {
          var includes = comparator ? arrayIncludesWith : arrayIncludes,
            length = arrays[0].length,
            othLength = arrays.length,
            othIndex = othLength,
            caches = Array(othLength),
            maxLength = Infinity,
            result = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee) {
              array = arrayMap(array, baseUnary(iteratee));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
          }
          array = arrays[0];
          var index = -1,
            seen = caches[0];
          outer: while (++index < length && result.length < maxLength) {
            var value = array[index],
              computed = iteratee ? iteratee(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result.push(value);
            }
          }
          return result;
        }

        /**
         * The base implementation of `_.invert` and `_.invertBy` which inverts
         * `object` with values transformed by `iteratee` and set by `setter`.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} setter The function to set `accumulator` values.
         * @param {Function} iteratee The iteratee to transform values.
         * @param {Object} accumulator The initial inverted object.
         * @returns {Function} Returns `accumulator`.
         */
        function baseInverter(object, setter, iteratee, accumulator) {
          baseForOwn(object, function (value, key, object) {
            setter(accumulator, iteratee(value), key, object);
          });
          return accumulator;
        }

        /**
         * The base implementation of `_.invoke` without support for individual
         * method arguments.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the method to invoke.
         * @param {Array} args The arguments to invoke the method with.
         * @returns {*} Returns the result of the invoked method.
         */
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined : apply(func, object, args);
        }

        /**
         * The base implementation of `_.isArguments`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         */
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }

        /**
         * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
         */
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }

        /**
         * The base implementation of `_.isDate` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
         */
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }

        /**
         * The base implementation of `_.isEqual` which supports partial comparisons
         * and tracks traversed objects.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @param {boolean} bitmask The bitmask flags.
         *  1 - Unordered comparison
         *  2 - Partial comparison
         * @param {Function} [customizer] The function to customize comparisons.
         * @param {Object} [stack] Tracks traversed `value` and `other` objects.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         */
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }

        /**
         * A specialized version of `baseIsEqual` for arrays and objects which performs
         * deep comparisons and tracks traversed objects enabling objects with circular
         * references to be compared.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} [stack] Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object),
            othIsArr = isArray(other),
            objTag = objIsArr ? arrayTag : getTag(object),
            othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag,
            othIsObj = othTag == objectTag,
            isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
              othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object,
                othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }

        /**
         * The base implementation of `_.isMap` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a map, else `false`.
         */
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }

        /**
         * The base implementation of `_.isMatch` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @param {Array} matchData The property names, values, and compare flags to match.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         */
        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length,
            length = index,
            noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object(object);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0],
              objValue = object[key],
              srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
                return false;
              }
            }
          }
          return true;
        }

        /**
         * The base implementation of `_.isNative` without bad shim checks.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a native function,
         *  else `false`.
         */
        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }

        /**
         * The base implementation of `_.isRegExp` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
         */
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }

        /**
         * The base implementation of `_.isSet` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a set, else `false`.
         */
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }

        /**
         * The base implementation of `_.isTypedArray` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         */
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }

        /**
         * The base implementation of `_.iteratee`.
         *
         * @private
         * @param {*} [value=_.identity] The value to convert to an iteratee.
         * @returns {Function} Returns the iteratee.
         */
        function baseIteratee(value) {
          // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
          // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
          if (typeof value == 'function') {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == 'object') {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }

        /**
         * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result = [];
          for (var key in Object(object)) {
            if (hasOwnProperty.call(object, key) && key != 'constructor') {
              result.push(key);
            }
          }
          return result;
        }

        /**
         * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */
        function baseKeysIn(object) {
          if (!isObject(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object),
            result = [];
          for (var key in object) {
            if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
              result.push(key);
            }
          }
          return result;
        }

        /**
         * The base implementation of `_.lt` which doesn't coerce arguments.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than `other`,
         *  else `false`.
         */
        function baseLt(value, other) {
          return value < other;
        }

        /**
         * The base implementation of `_.map` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the new mapped array.
         */
        function baseMap(collection, iteratee) {
          var index = -1,
            result = isArrayLike(collection) ? Array(collection.length) : [];
          baseEach(collection, function (value, key, collection) {
            result[++index] = iteratee(value, key, collection);
          });
          return result;
        }

        /**
         * The base implementation of `_.matches` which doesn't clone `source`.
         *
         * @private
         * @param {Object} source The object of property values to match.
         * @returns {Function} Returns the new spec function.
         */
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function (object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }

        /**
         * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
         *
         * @private
         * @param {string} path The path of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function (object) {
            var objValue = get(object, path);
            return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }

        /**
         * The base implementation of `_.merge` without support for multiple sources.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @param {number} srcIndex The index of `source`.
         * @param {Function} [customizer] The function to customize merged values.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         */
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function (srcValue, key) {
            stack || (stack = new Stack());
            if (isObject(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
              if (newValue === undefined) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }

        /**
         * A specialized version of `baseMerge` for arrays and objects which performs
         * deep merges and tracks traversed objects enabling objects with circular
         * references to be merged.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @param {string} key The key of the value to merge.
         * @param {number} srcIndex The index of `source`.
         * @param {Function} mergeFunc The function to merge values.
         * @param {Function} [customizer] The function to customize assigned values.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         */
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key),
            srcValue = safeGet(source, key),
            stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
          var isCommon = newValue === undefined;
          if (isCommon) {
            var isArr = isArray(srcValue),
              isBuff = !isArr && isBuffer(srcValue),
              isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            // Recursively merge objects and arrays (susceptible to call stack limits).
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack['delete'](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }

        /**
         * The base implementation of `_.nth` which doesn't coerce arguments.
         *
         * @private
         * @param {Array} array The array to query.
         * @param {number} n The index of the element to return.
         * @returns {*} Returns the nth element of `array`.
         */
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined;
        }

        /**
         * The base implementation of `_.orderBy` without param guards.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
         * @param {string[]} orders The sort orders of `iteratees`.
         * @returns {Array} Returns the new sorted array.
         */
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function (iteratee) {
              if (isArray(iteratee)) {
                return function (value) {
                  return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
              }
              return iteratee;
            });
          } else {
            iteratees = [identity];
          }
          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result = baseMap(collection, function (value, key, collection) {
            var criteria = arrayMap(iteratees, function (iteratee) {
              return iteratee(value);
            });
            return {
              'criteria': criteria,
              'index': ++index,
              'value': value
            };
          });
          return baseSortBy(result, function (object, other) {
            return compareMultiple(object, other, orders);
          });
        }

        /**
         * The base implementation of `_.pick` without support for individual
         * property identifiers.
         *
         * @private
         * @param {Object} object The source object.
         * @param {string[]} paths The property paths to pick.
         * @returns {Object} Returns the new object.
         */
        function basePick(object, paths) {
          return basePickBy(object, paths, function (value, path) {
            return hasIn(object, path);
          });
        }

        /**
         * The base implementation of  `_.pickBy` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The source object.
         * @param {string[]} paths The property paths to pick.
         * @param {Function} predicate The function invoked per property.
         * @returns {Object} Returns the new object.
         */
        function basePickBy(object, paths, predicate) {
          var index = -1,
            length = paths.length,
            result = {};
          while (++index < length) {
            var path = paths[index],
              value = baseGet(object, path);
            if (predicate(value, path)) {
              baseSet(result, castPath(path, object), value);
            }
          }
          return result;
        }

        /**
         * A specialized version of `baseProperty` which supports deep paths.
         *
         * @private
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         */
        function basePropertyDeep(path) {
          return function (object) {
            return baseGet(object, path);
          };
        }

        /**
         * The base implementation of `_.pullAllBy` without support for iteratee
         * shorthands.
         *
         * @private
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns `array`.
         */
        function basePullAll(array, values, iteratee, comparator) {
          var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
            index = -1,
            length = values.length,
            seen = array;
          if (array === values) {
            values = copyArray(values);
          }
          if (iteratee) {
            seen = arrayMap(array, baseUnary(iteratee));
          }
          while (++index < length) {
            var fromIndex = 0,
              value = values[index],
              computed = iteratee ? iteratee(value) : value;
            while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }

        /**
         * The base implementation of `_.pullAt` without support for individual
         * indexes or capturing the removed elements.
         *
         * @private
         * @param {Array} array The array to modify.
         * @param {number[]} indexes The indexes of elements to remove.
         * @returns {Array} Returns `array`.
         */
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0,
            lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (length == lastIndex || index !== previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }
          return array;
        }

        /**
         * The base implementation of `_.random` without support for returning
         * floating-point numbers.
         *
         * @private
         * @param {number} lower The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the random number.
         */
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }

        /**
         * The base implementation of `_.range` and `_.rangeRight` which doesn't
         * coerce arguments.
         *
         * @private
         * @param {number} start The start of the range.
         * @param {number} end The end of the range.
         * @param {number} step The value to increment or decrement by.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Array} Returns the range of numbers.
         */
        function baseRange(start, end, step, fromRight) {
          var index = -1,
            length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
            result = Array(length);
          while (length--) {
            result[fromRight ? length : ++index] = start;
            start += step;
          }
          return result;
        }

        /**
         * The base implementation of `_.repeat` which doesn't coerce arguments.
         *
         * @private
         * @param {string} string The string to repeat.
         * @param {number} n The number of times to repeat the string.
         * @returns {string} Returns the repeated string.
         */
        function baseRepeat(string, n) {
          var result = '';
          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result;
          }
          // Leverage the exponentiation by squaring algorithm for a faster repeat.
          // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
          do {
            if (n % 2) {
              result += string;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string += string;
            }
          } while (n);
          return result;
        }

        /**
         * The base implementation of `_.rest` which doesn't validate or coerce arguments.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         */
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + '');
        }

        /**
         * The base implementation of `_.sample`.
         *
         * @private
         * @param {Array|Object} collection The collection to sample.
         * @returns {*} Returns the random element.
         */
        function baseSample(collection) {
          return arraySample(values(collection));
        }

        /**
         * The base implementation of `_.sampleSize` without param guards.
         *
         * @private
         * @param {Array|Object} collection The collection to sample.
         * @param {number} n The number of elements to sample.
         * @returns {Array} Returns the random elements.
         */
        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }

        /**
         * The base implementation of `_.set`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @param {Function} [customizer] The function to customize path creation.
         * @returns {Object} Returns `object`.
         */
        function baseSet(object, path, value, customizer) {
          if (!isObject(object)) {
            return object;
          }
          path = castPath(path, object);
          var index = -1,
            length = path.length,
            lastIndex = length - 1,
            nested = object;
          while (nested != null && ++index < length) {
            var key = toKey(path[index]),
              newValue = value;
            if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
              return object;
            }
            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined;
              if (newValue === undefined) {
                newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }

        /**
         * The base implementation of `setData` without support for hot loop shorting.
         *
         * @private
         * @param {Function} func The function to associate metadata with.
         * @param {*} data The metadata.
         * @returns {Function} Returns `func`.
         */
        var baseSetData = !metaMap ? identity : function (func, data) {
          metaMap.set(func, data);
          return func;
        };

        /**
         * The base implementation of `setToString` without support for hot loop shorting.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */
        var baseSetToString = !defineProperty ? identity : function (func, string) {
          return defineProperty(func, 'toString', {
            'configurable': true,
            'enumerable': false,
            'value': constant(string),
            'writable': true
          });
        };

        /**
         * The base implementation of `_.shuffle`.
         *
         * @private
         * @param {Array|Object} collection The collection to shuffle.
         * @returns {Array} Returns the new shuffled array.
         */
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }

        /**
         * The base implementation of `_.slice` without an iteratee call guard.
         *
         * @private
         * @param {Array} array The array to slice.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the slice of `array`.
         */
        function baseSlice(array, start, end) {
          var index = -1,
            length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result = Array(length);
          while (++index < length) {
            result[index] = array[index + start];
          }
          return result;
        }

        /**
         * The base implementation of `_.some` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {boolean} Returns `true` if any element passes the predicate check,
         *  else `false`.
         */
        function baseSome(collection, predicate) {
          var result;
          baseEach(collection, function (value, index, collection) {
            result = predicate(value, index, collection);
            return !result;
          });
          return !!result;
        }

        /**
         * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
         * performs a binary search of `array` to determine the index at which `value`
         * should be inserted into `array` in order to maintain its sort order.
         *
         * @private
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {boolean} [retHighest] Specify returning the highest qualified index.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         */
        function baseSortedIndex(array, value, retHighest) {
          var low = 0,
            high = array == null ? low : array.length;
          if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1,
                computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }

        /**
         * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
         * which invokes `iteratee` for `value` and each element of `array` to compute
         * their sort ranking. The iteratee is invoked with one argument; (value).
         *
         * @private
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} iteratee The iteratee invoked per element.
         * @param {boolean} [retHighest] Specify returning the highest qualified index.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         */
        function baseSortedIndexBy(array, value, iteratee, retHighest) {
          var low = 0,
            high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee(value);
          var valIsNaN = value !== value,
            valIsNull = value === null,
            valIsSymbol = isSymbol(value),
            valIsUndefined = value === undefined;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2),
              computed = iteratee(array[mid]),
              othIsDefined = computed !== undefined,
              othIsNull = computed === null,
              othIsReflexive = computed === computed,
              othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }

        /**
         * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
         * support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         */
        function baseSortedUniq(array, iteratee) {
          var index = -1,
            length = array.length,
            resIndex = 0,
            result = [];
          while (++index < length) {
            var value = array[index],
              computed = iteratee ? iteratee(value) : value;
            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result;
        }

        /**
         * The base implementation of `_.toNumber` which doesn't ensure correct
         * conversions of binary, hexadecimal, or octal string values.
         *
         * @private
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         */
        function baseToNumber(value) {
          if (typeof value == 'number') {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }

        /**
         * The base implementation of `_.toString` which doesn't convert nullish
         * values to empty strings.
         *
         * @private
         * @param {*} value The value to process.
         * @returns {string} Returns the string.
         */
        function baseToString(value) {
          // Exit early for strings to avoid a performance hit in some environments.
          if (typeof value == 'string') {
            return value;
          }
          if (isArray(value)) {
            // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : '';
          }
          var result = value + '';
          return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }

        /**
         * The base implementation of `_.uniqBy` without support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         */
        function baseUniq(array, iteratee, comparator) {
          var index = -1,
            includes = arrayIncludes,
            length = array.length,
            isCommon = true,
            result = [],
            seen = result;
          if (comparator) {
            isCommon = false;
            includes = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set = iteratee ? null : createSet(array);
            if (set) {
              return setToArray(set);
            }
            isCommon = false;
            includes = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee ? [] : result;
          }
          outer: while (++index < length) {
            var value = array[index],
              computed = iteratee ? iteratee(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee) {
                seen.push(computed);
              }
              result.push(value);
            } else if (!includes(seen, computed, comparator)) {
              if (seen !== result) {
                seen.push(computed);
              }
              result.push(value);
            }
          }
          return result;
        }

        /**
         * The base implementation of `_.unset`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The property path to unset.
         * @returns {boolean} Returns `true` if the property is deleted, else `false`.
         */
        function baseUnset(object, path) {
          path = castPath(path, object);
          object = parent(object, path);
          return object == null || delete object[toKey(last(path))];
        }

        /**
         * The base implementation of `_.update`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to update.
         * @param {Function} updater The function to produce the updated value.
         * @param {Function} [customizer] The function to customize path creation.
         * @returns {Object} Returns `object`.
         */
        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }

        /**
         * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
         * without support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to query.
         * @param {Function} predicate The function invoked per iteration.
         * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Array} Returns the slice of `array`.
         */
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length,
            index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }

        /**
         * The base implementation of `wrapperValue` which returns the result of
         * performing a sequence of actions on the unwrapped `value`, where each
         * successive action is supplied the return value of the previous.
         *
         * @private
         * @param {*} value The unwrapped value.
         * @param {Array} actions Actions to perform to resolve the unwrapped value.
         * @returns {*} Returns the resolved value.
         */
        function baseWrapperValue(value, actions) {
          var result = value;
          if (result instanceof LazyWrapper) {
            result = result.value();
          }
          return arrayReduce(actions, function (result, action) {
            return action.func.apply(action.thisArg, arrayPush([result], action.args));
          }, result);
        }

        /**
         * The base implementation of methods like `_.xor`, without support for
         * iteratee shorthands, that accepts an array of arrays to inspect.
         *
         * @private
         * @param {Array} arrays The arrays to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of values.
         */
        function baseXor(arrays, iteratee, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1,
            result = Array(length);
          while (++index < length) {
            var array = arrays[index],
              othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }

        /**
         * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
         *
         * @private
         * @param {Array} props The property identifiers.
         * @param {Array} values The property values.
         * @param {Function} assignFunc The function to assign values.
         * @returns {Object} Returns the new object.
         */
        function baseZipObject(props, values, assignFunc) {
          var index = -1,
            length = props.length,
            valsLength = values.length,
            result = {};
          while (++index < length) {
            var value = index < valsLength ? values[index] : undefined;
            assignFunc(result, props[index], value);
          }
          return result;
        }

        /**
         * Casts `value` to an empty array if it's not an array like object.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {Array|Object} Returns the cast array-like object.
         */
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }

        /**
         * Casts `value` to `identity` if it's not a function.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {Function} Returns cast function.
         */
        function castFunction(value) {
          return typeof value == 'function' ? value : identity;
        }

        /**
         * Casts `value` to a path array if it's not one.
         *
         * @private
         * @param {*} value The value to inspect.
         * @param {Object} [object] The object to query keys on.
         * @returns {Array} Returns the cast property path array.
         */
        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }

        /**
         * A `baseRest` alias which can be replaced with `identity` by module
         * replacement plugins.
         *
         * @private
         * @type {Function}
         * @param {Function} func The function to apply a rest parameter to.
         * @returns {Function} Returns the new function.
         */
        var castRest = baseRest;

        /**
         * Casts `array` to a slice if it's needed.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {number} start The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the cast slice.
         */
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }

        /**
         * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
         *
         * @private
         * @param {number|Object} id The timer id or timeout object of the timer to clear.
         */
        var clearTimeout = ctxClearTimeout || function (id) {
          return root.clearTimeout(id);
        };

        /**
         * Creates a clone of  `buffer`.
         *
         * @private
         * @param {Buffer} buffer The buffer to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Buffer} Returns the cloned buffer.
         */
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length,
            result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result);
          return result;
        }

        /**
         * Creates a clone of `arrayBuffer`.
         *
         * @private
         * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
         * @returns {ArrayBuffer} Returns the cloned array buffer.
         */
        function cloneArrayBuffer(arrayBuffer) {
          var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array(result).set(new Uint8Array(arrayBuffer));
          return result;
        }

        /**
         * Creates a clone of `dataView`.
         *
         * @private
         * @param {Object} dataView The data view to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the cloned data view.
         */
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }

        /**
         * Creates a clone of `regexp`.
         *
         * @private
         * @param {Object} regexp The regexp to clone.
         * @returns {Object} Returns the cloned regexp.
         */
        function cloneRegExp(regexp) {
          var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result.lastIndex = regexp.lastIndex;
          return result;
        }

        /**
         * Creates a clone of the `symbol` object.
         *
         * @private
         * @param {Object} symbol The symbol object to clone.
         * @returns {Object} Returns the cloned symbol object.
         */
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
        }

        /**
         * Creates a clone of `typedArray`.
         *
         * @private
         * @param {Object} typedArray The typed array to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the cloned typed array.
         */
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }

        /**
         * Compares values to sort them in ascending order.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {number} Returns the sort order indicator for `value`.
         */
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined,
              valIsNull = value === null,
              valIsReflexive = value === value,
              valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined,
              othIsNull = other === null,
              othIsReflexive = other === other,
              othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }

        /**
         * Used by `_.orderBy` to compare multiple properties of a value to another
         * and stable sort them.
         *
         * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
         * specify an order of "desc" for descending or "asc" for ascending sort order
         * of corresponding values.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {boolean[]|string[]} orders The order to sort by for each property.
         * @returns {number} Returns the sort order indicator for `object`.
         */
        function compareMultiple(object, other, orders) {
          var index = -1,
            objCriteria = object.criteria,
            othCriteria = other.criteria,
            length = objCriteria.length,
            ordersLength = orders.length;
          while (++index < length) {
            var result = compareAscending(objCriteria[index], othCriteria[index]);
            if (result) {
              if (index >= ordersLength) {
                return result;
              }
              var order = orders[index];
              return result * (order == 'desc' ? -1 : 1);
            }
          }
          // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
          // that causes it, under certain circumstances, to provide the same value for
          // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
          // for more details.
          //
          // This also ensures a stable sort in V8 and other engines.
          // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
          return object.index - other.index;
        }

        /**
         * Creates an array that is the composition of partially applied arguments,
         * placeholders, and provided arguments into a single array of arguments.
         *
         * @private
         * @param {Array} args The provided arguments.
         * @param {Array} partials The arguments to prepend to those provided.
         * @param {Array} holders The `partials` placeholder indexes.
         * @params {boolean} [isCurried] Specify composing for a curried function.
         * @returns {Array} Returns the new array of composed arguments.
         */
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1,
            argsLength = args.length,
            holdersLength = holders.length,
            leftIndex = -1,
            leftLength = partials.length,
            rangeLength = nativeMax(argsLength - holdersLength, 0),
            result = Array(leftLength + rangeLength),
            isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result[leftIndex++] = args[argsIndex++];
          }
          return result;
        }

        /**
         * This function is like `composeArgs` except that the arguments composition
         * is tailored for `_.partialRight`.
         *
         * @private
         * @param {Array} args The provided arguments.
         * @param {Array} partials The arguments to append to those provided.
         * @param {Array} holders The `partials` placeholder indexes.
         * @params {boolean} [isCurried] Specify composing for a curried function.
         * @returns {Array} Returns the new array of composed arguments.
         */
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1,
            argsLength = args.length,
            holdersIndex = -1,
            holdersLength = holders.length,
            rightIndex = -1,
            rightLength = partials.length,
            rangeLength = nativeMax(argsLength - holdersLength, 0),
            result = Array(rangeLength + rightLength),
            isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result;
        }

        /**
         * Copies the values of `source` to `array`.
         *
         * @private
         * @param {Array} source The array to copy values from.
         * @param {Array} [array=[]] The array to copy values to.
         * @returns {Array} Returns `array`.
         */
        function copyArray(source, array) {
          var index = -1,
            length = source.length;
          array || (array = Array(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }

        /**
         * Copies properties of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy properties from.
         * @param {Array} props The property identifiers to copy.
         * @param {Object} [object={}] The object to copy properties to.
         * @param {Function} [customizer] The function to customize copied values.
         * @returns {Object} Returns `object`.
         */
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1,
            length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
            if (newValue === undefined) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }

        /**
         * Copies own symbols of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy symbols from.
         * @param {Object} [object={}] The object to copy symbols to.
         * @returns {Object} Returns `object`.
         */
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }

        /**
         * Copies own and inherited symbols of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy symbols from.
         * @param {Object} [object={}] The object to copy symbols to.
         * @returns {Object} Returns `object`.
         */
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }

        /**
         * Creates a function like `_.groupBy`.
         *
         * @private
         * @param {Function} setter The function to set accumulator values.
         * @param {Function} [initializer] The accumulator object initializer.
         * @returns {Function} Returns the new aggregator function.
         */
        function createAggregator(setter, initializer) {
          return function (collection, iteratee) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator,
              accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee, 2), accumulator);
          };
        }

        /**
         * Creates a function like `_.assign`.
         *
         * @private
         * @param {Function} assigner The function to assign values.
         * @returns {Function} Returns the new assigner function.
         */
        function createAssigner(assigner) {
          return baseRest(function (object, sources) {
            var index = -1,
              length = sources.length,
              customizer = length > 1 ? sources[length - 1] : undefined,
              guard = length > 2 ? sources[2] : undefined;
            customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined : customizer;
              length = 1;
            }
            object = Object(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, index, customizer);
              }
            }
            return object;
          });
        }

        /**
         * Creates a `baseEach` or `baseEachRight` function.
         *
         * @private
         * @param {Function} eachFunc The function to iterate over a collection.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */
        function createBaseEach(eachFunc, fromRight) {
          return function (collection, iteratee) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee);
            }
            var length = collection.length,
              index = fromRight ? length : -1,
              iterable = Object(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }

        /**
         * Creates a base function for methods like `_.forIn` and `_.forOwn`.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */
        function createBaseFor(fromRight) {
          return function (object, iteratee, keysFunc) {
            var index = -1,
              iterable = Object(object),
              props = keysFunc(object),
              length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }

        /**
         * Creates a function that wraps `func` to invoke it with the optional `this`
         * binding of `thisArg`.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @returns {Function} Returns the new wrapped function.
         */
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG,
            Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }

        /**
         * Creates a function like `_.lowerFirst`.
         *
         * @private
         * @param {string} methodName The name of the `String` case method to use.
         * @returns {Function} Returns the new case function.
         */
        function createCaseFirst(methodName) {
          return function (string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }

        /**
         * Creates a function like `_.camelCase`.
         *
         * @private
         * @param {Function} callback The function to combine each word.
         * @returns {Function} Returns the new compounder function.
         */
        function createCompounder(callback) {
          return function (string) {
            return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
          };
        }

        /**
         * Creates a function that produces an instance of `Ctor` regardless of
         * whether it was invoked as part of a `new` expression or by `call` or `apply`.
         *
         * @private
         * @param {Function} Ctor The constructor to wrap.
         * @returns {Function} Returns the new wrapped function.
         */
        function createCtor(Ctor) {
          return function () {
            // Use a `switch` statement to work with class constructors. See
            // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
            // for more details.
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype),
              result = Ctor.apply(thisBinding, args);

            // Mimic the constructor's `return` behavior.
            // See https://es5.github.io/#x13.2.2 for more details.
            return isObject(result) ? result : thisBinding;
          };
        }

        /**
         * Creates a function that wraps `func` to enable currying.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {number} arity The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length,
              args = Array(length),
              index = length,
              placeholder = getHolder(wrapper);
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }

        /**
         * Creates a `_.find` or `_.findLast` function.
         *
         * @private
         * @param {Function} findIndexFunc The function to find the collection index.
         * @returns {Function} Returns the new find function.
         */
        function createFind(findIndexFunc) {
          return function (collection, predicate, fromIndex) {
            var iterable = Object(collection);
            if (!isArrayLike(collection)) {
              var iteratee = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function (key) {
                return iteratee(iterable[key], key, iterable);
              };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
          };
        }

        /**
         * Creates a `_.flow` or `_.flowRight` function.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new flow function.
         */
        function createFlow(fromRight) {
          return flatRest(function (funcs) {
            var length = funcs.length,
              index = length,
              prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != 'function') {
                throw new TypeError(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func),
                data = funcName == 'wrapper' ? getData(func) : undefined;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function () {
              var args = arguments,
                value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index = 0,
                result = length ? funcs[index].apply(this, args) : value;
              while (++index < length) {
                result = funcs[index].call(this, result);
              }
              return result;
            };
          });
        }

        /**
         * Creates a function that wraps `func` to invoke it with optional `this`
         * binding of `thisArg`, partial application, and currying.
         *
         * @private
         * @param {Function|string} func The function or method name to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to prepend to those provided to
         *  the new function.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [partialsRight] The arguments to append to those provided
         *  to the new function.
         * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG,
            isBind = bitmask & WRAP_BIND_FLAG,
            isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
            isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
            isFlip = bitmask & WRAP_FLIP_FLAG,
            Ctor = isBindKey ? undefined : createCtor(func);
          function wrapper() {
            var length = arguments.length,
              args = Array(length),
              index = length;
            while (index--) {
              args[index] = arguments[index];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper),
                holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
            }
            var thisBinding = isBind ? thisArg : this,
              fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary < length) {
              args.length = ary;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }

        /**
         * Creates a function like `_.invertBy`.
         *
         * @private
         * @param {Function} setter The function to set accumulator values.
         * @param {Function} toIteratee The function to resolve iteratees.
         * @returns {Function} Returns the new inverter function.
         */
        function createInverter(setter, toIteratee) {
          return function (object, iteratee) {
            return baseInverter(object, setter, toIteratee(iteratee), {});
          };
        }

        /**
         * Creates a function that performs a mathematical operation on two values.
         *
         * @private
         * @param {Function} operator The function to perform the operation.
         * @param {number} [defaultValue] The value used for `undefined` arguments.
         * @returns {Function} Returns the new mathematical operation function.
         */
        function createMathOperation(operator, defaultValue) {
          return function (value, other) {
            var result;
            if (value === undefined && other === undefined) {
              return defaultValue;
            }
            if (value !== undefined) {
              result = value;
            }
            if (other !== undefined) {
              if (result === undefined) {
                return other;
              }
              if (typeof value == 'string' || typeof other == 'string') {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result = operator(value, other);
            }
            return result;
          };
        }

        /**
         * Creates a function like `_.over`.
         *
         * @private
         * @param {Function} arrayFunc The function to iterate over iteratees.
         * @returns {Function} Returns the new over function.
         */
        function createOver(arrayFunc) {
          return flatRest(function (iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function (args) {
              var thisArg = this;
              return arrayFunc(iteratees, function (iteratee) {
                return apply(iteratee, thisArg, args);
              });
            });
          });
        }

        /**
         * Creates the padding for `string` based on `length`. The `chars` string
         * is truncated if the number of characters exceeds `length`.
         *
         * @private
         * @param {number} length The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padding for `string`.
         */
        function createPadding(length, chars) {
          chars = chars === undefined ? ' ' : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }

        /**
         * Creates a function that wraps `func` to invoke it with the `this` binding
         * of `thisArg` and `partials` prepended to the arguments it receives.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {Array} partials The arguments to prepend to those provided to
         *  the new function.
         * @returns {Function} Returns the new wrapped function.
         */
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG,
            Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1,
              argsLength = arguments.length,
              leftIndex = -1,
              leftLength = partials.length,
              args = Array(leftLength + argsLength),
              fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }

        /**
         * Creates a `_.range` or `_.rangeRight` function.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new range function.
         */
        function createRange(fromRight) {
          return function (start, end, step) {
            if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
              end = step = undefined;
            }
            // Ensure the sign of `-0` is preserved.
            start = toFinite(start);
            if (end === undefined) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }

        /**
         * Creates a function that performs a relational operation on two values.
         *
         * @private
         * @param {Function} operator The function to perform the operation.
         * @returns {Function} Returns the new relational operation function.
         */
        function createRelationalOperation(operator) {
          return function (value, other) {
            if (!(typeof value == 'string' && typeof other == 'string')) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }

        /**
         * Creates a function that wraps `func` to continue currying.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {Function} wrapFunc The function to create the `func` wrapper.
         * @param {*} placeholder The placeholder value.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to prepend to those provided to
         *  the new function.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG,
            newHolders = isCurry ? holders : undefined,
            newHoldersRight = isCurry ? undefined : holders,
            newPartials = isCurry ? partials : undefined,
            newPartialsRight = isCurry ? undefined : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];
          var result = wrapFunc.apply(undefined, newData);
          if (isLaziable(func)) {
            setData(result, newData);
          }
          result.placeholder = placeholder;
          return setWrapToString(result, func, bitmask);
        }

        /**
         * Creates a function like `_.round`.
         *
         * @private
         * @param {string} methodName The name of the `Math` method to use when rounding.
         * @returns {Function} Returns the new round function.
         */
        function createRound(methodName) {
          var func = Math[methodName];
          return function (number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              // Shift with exponential notation to avoid floating-point issues.
              // See [MDN](https://mdn.io/round#Examples) for more details.
              var pair = (toString(number) + 'e').split('e'),
                value = func(pair[0] + 'e' + (+pair[1] + precision));
              pair = (toString(value) + 'e').split('e');
              return +(pair[0] + 'e' + (+pair[1] - precision));
            }
            return func(number);
          };
        }

        /**
         * Creates a set object of `values`.
         *
         * @private
         * @param {Array} values The values to add to the set.
         * @returns {Object} Returns the new set.
         */
        var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
          return new Set(values);
        };

        /**
         * Creates a `_.toPairs` or `_.toPairsIn` function.
         *
         * @private
         * @param {Function} keysFunc The function to get the keys of a given object.
         * @returns {Function} Returns the new pairs function.
         */
        function createToPairs(keysFunc) {
          return function (object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }

        /**
         * Creates a function that either curries or invokes `func` with optional
         * `this` binding and partially applied arguments.
         *
         * @private
         * @param {Function|string} func The function or method name to wrap.
         * @param {number} bitmask The bitmask flags.
         *    1 - `_.bind`
         *    2 - `_.bindKey`
         *    4 - `_.curry` or `_.curryRight` of a bound function
         *    8 - `_.curry`
         *   16 - `_.curryRight`
         *   32 - `_.partial`
         *   64 - `_.partialRight`
         *  128 - `_.rearg`
         *  256 - `_.ary`
         *  512 - `_.flip`
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to be partially applied.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined;
          }
          ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
          arity = arity === undefined ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials,
              holdersRight = holders;
            partials = holders = undefined;
          }
          var data = isBindKey ? undefined : getData(func);
          var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result = createPartial(func, bitmask, thisArg, partials);
          } else {
            result = createHybrid.apply(undefined, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result, newData), func, bitmask);
        }

        /**
         * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
         * of source objects to the destination object for all destination properties
         * that resolve to `undefined`.
         *
         * @private
         * @param {*} objValue The destination value.
         * @param {*} srcValue The source value.
         * @param {string} key The key of the property to assign.
         * @param {Object} object The parent object of `objValue`.
         * @returns {*} Returns the value to assign.
         */
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }

        /**
         * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
         * objects into destination objects that are passed thru.
         *
         * @private
         * @param {*} objValue The destination value.
         * @param {*} srcValue The source value.
         * @param {string} key The key of the property to merge.
         * @param {Object} object The parent object of `objValue`.
         * @param {Object} source The parent object of `srcValue`.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         * @returns {*} Returns the value to assign.
         */
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject(objValue) && isObject(srcValue)) {
            // Recursively merge objects and arrays (susceptible to call stack limits).
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
            stack['delete'](srcValue);
          }
          return objValue;
        }

        /**
         * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
         * objects.
         *
         * @private
         * @param {*} value The value to inspect.
         * @param {string} key The key of the property to inspect.
         * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
         */
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined : value;
        }

        /**
         * A specialized version of `baseIsEqualDeep` for arrays with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Array} array The array to compare.
         * @param {Array} other The other array to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `array` and `other` objects.
         * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
         */
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
            arrLength = array.length,
            othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          // Check that cyclic values are equal.
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index = -1,
            result = true,
            seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
          stack.set(array, other);
          stack.set(other, array);

          // Ignore non-index properties.
          while (++index < arrLength) {
            var arrValue = array[index],
              othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined) {
              if (compared) {
                continue;
              }
              result = false;
              break;
            }
            // Recursively compare arrays (susceptible to call stack limits).
            if (seen) {
              if (!arraySome(other, function (othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result = false;
              break;
            }
          }
          stack['delete'](array);
          stack['delete'](other);
          return result;
        }

        /**
         * A specialized version of `baseIsEqualDeep` for comparing objects of
         * the same `toStringTag`.
         *
         * **Note:** This function only supports comparing values with tags of
         * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {string} tag The `toStringTag` of the objects to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              // Coerce booleans to `1` or `0` and dates to milliseconds.
              // Invalid dates are coerced to `NaN`.
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              // Coerce regexes to strings and treat strings, primitives and objects,
              // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
              // for more details.
              return object == other + '';
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              // Assume cyclic values are equal.
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;

              // Recursively compare objects (susceptible to call stack limits).
              stack.set(object, other);
              var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack['delete'](object);
              return result;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }

        /**
         * A specialized version of `baseIsEqualDeep` for objects with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
            objProps = getAllKeys(object),
            objLength = objProps.length,
            othProps = getAllKeys(other),
            othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          // Check that cyclic values are equal.
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key],
              othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            // Recursively compare objects (susceptible to call stack limits).
            if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result = false;
              break;
            }
            skipCtor || (skipCtor = key == 'constructor');
          }
          if (result && !skipCtor) {
            var objCtor = object.constructor,
              othCtor = other.constructor;

            // Non `Object` object instances with different constructors are not equal.
            if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
              result = false;
            }
          }
          stack['delete'](object);
          stack['delete'](other);
          return result;
        }

        /**
         * A specialized version of `baseRest` which flattens the rest array.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @returns {Function} Returns the new function.
         */
        function flatRest(func) {
          return setToString(overRest(func, undefined, flatten), func + '');
        }

        /**
         * Creates an array of own enumerable property names and symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names and symbols.
         */
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }

        /**
         * Creates an array of own and inherited enumerable property names and
         * symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names and symbols.
         */
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }

        /**
         * Gets metadata for `func`.
         *
         * @private
         * @param {Function} func The function to query.
         * @returns {*} Returns the metadata for `func`.
         */
        var getData = !metaMap ? noop : function (func) {
          return metaMap.get(func);
        };

        /**
         * Gets the name of `func`.
         *
         * @private
         * @param {Function} func The function to query.
         * @returns {string} Returns the function name.
         */
        function getFuncName(func) {
          var result = func.name + '',
            array = realNames[result],
            length = hasOwnProperty.call(realNames, result) ? array.length : 0;
          while (length--) {
            var data = array[length],
              otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result;
        }

        /**
         * Gets the argument placeholder value for `func`.
         *
         * @private
         * @param {Function} func The function to inspect.
         * @returns {*} Returns the placeholder value.
         */
        function getHolder(func) {
          var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
          return object.placeholder;
        }

        /**
         * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
         * this function returns the custom method, otherwise it returns `baseIteratee`.
         * If arguments are provided, the chosen function is invoked with them and
         * its result is returned.
         *
         * @private
         * @param {*} [value] The value to convert to an iteratee.
         * @param {number} [arity] The arity of the created iteratee.
         * @returns {Function} Returns the chosen function or its result.
         */
        function getIteratee() {
          var result = lodash.iteratee || iteratee;
          result = result === iteratee ? baseIteratee : result;
          return arguments.length ? result(arguments[0], arguments[1]) : result;
        }

        /**
         * Gets the data for `map`.
         *
         * @private
         * @param {Object} map The map to query.
         * @param {string} key The reference key.
         * @returns {*} Returns the map data.
         */
        function getMapData(map, key) {
          var data = map.__data__;
          return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }

        /**
         * Gets the property names, values, and compare flags of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the match data of `object`.
         */
        function getMatchData(object) {
          var result = keys(object),
            length = result.length;
          while (length--) {
            var key = result[length],
              value = object[key];
            result[length] = [key, value, isStrictComparable(value)];
          }
          return result;
        }

        /**
         * Gets the native function at `key` of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {string} key The key of the method to get.
         * @returns {*} Returns the function if it's native, else `undefined`.
         */
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined;
        }

        /**
         * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the raw `toStringTag`.
         */
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag),
            tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined;
            var unmasked = true;
          } catch (e) {}
          var result = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result;
        }

        /**
         * Creates an array of the own enumerable symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of symbols.
         */
        var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
          if (object == null) {
            return [];
          }
          object = Object(object);
          return arrayFilter(nativeGetSymbols(object), function (symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };

        /**
         * Creates an array of the own and inherited enumerable symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of symbols.
         */
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
          var result = [];
          while (object) {
            arrayPush(result, getSymbols(object));
            object = getPrototype(object);
          }
          return result;
        };

        /**
         * Gets the `toStringTag` of `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */
        var getTag = baseGetTag;

        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
          getTag = function (value) {
            var result = baseGetTag(value),
              Ctor = result == objectTag ? value.constructor : undefined,
              ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result;
          };
        }

        /**
         * Gets the view, applying any `transforms` to the `start` and `end` positions.
         *
         * @private
         * @param {number} start The start of the view.
         * @param {number} end The end of the view.
         * @param {Array} transforms The transformations to apply to the view.
         * @returns {Object} Returns an object containing the `start` and `end`
         *  positions of the view.
         */
        function getView(start, end, transforms) {
          var index = -1,
            length = transforms.length;
          while (++index < length) {
            var data = transforms[index],
              size = data.size;
            switch (data.type) {
              case 'drop':
                start += size;
                break;
              case 'dropRight':
                end -= size;
                break;
              case 'take':
                end = nativeMin(end, start + size);
                break;
              case 'takeRight':
                start = nativeMax(start, end - size);
                break;
            }
          }
          return {
            'start': start,
            'end': end
          };
        }

        /**
         * Extracts wrapper details from the `source` body comment.
         *
         * @private
         * @param {string} source The source to inspect.
         * @returns {Array} Returns the wrapper details.
         */
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }

        /**
         * Checks if `path` exists on `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @param {Function} hasFunc The function to check properties.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         */
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1,
            length = path.length,
            result = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result || ++index != length) {
            return result;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }

        /**
         * Initializes an array clone.
         *
         * @private
         * @param {Array} array The array to clone.
         * @returns {Array} Returns the initialized clone.
         */
        function initCloneArray(array) {
          var length = array.length,
            result = new array.constructor(length);

          // Add properties assigned by `RegExp#exec`.
          if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
            result.index = array.index;
            result.input = array.input;
          }
          return result;
        }

        /**
         * Initializes an object clone.
         *
         * @private
         * @param {Object} object The object to clone.
         * @returns {Object} Returns the initialized clone.
         */
        function initCloneObject(object) {
          return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }

        /**
         * Initializes an object clone based on its `toStringTag`.
         *
         * **Note:** This function only supports cloning values with tags of
         * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
         *
         * @private
         * @param {Object} object The object to clone.
         * @param {string} tag The `toStringTag` of the object to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the initialized clone.
         */
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object);
          }
        }

        /**
         * Inserts wrapper `details` in a comment at the top of the `source` body.
         *
         * @private
         * @param {string} source The source to modify.
         * @returns {Array} details The details to insert.
         * @returns {string} Returns the modified source.
         */
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
          details = details.join(length > 2 ? ', ' : ' ');
          return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }

        /**
         * Checks if `value` is a flattenable `arguments` object or array.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
         */
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }

        /**
         * Checks if `value` is a valid array-like index.
         *
         * @private
         * @param {*} value The value to check.
         * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
         * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
         */
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }

        /**
         * Checks if the given arguments are from an iteratee call.
         *
         * @private
         * @param {*} value The potential iteratee value argument.
         * @param {*} index The potential iteratee index or key argument.
         * @param {*} object The potential iteratee object argument.
         * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
         *  else `false`.
         */
        function isIterateeCall(value, index, object) {
          if (!isObject(object)) {
            return false;
          }
          var type = typeof index;
          if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
            return eq(object[index], value);
          }
          return false;
        }

        /**
         * Checks if `value` is a property name and not a property path.
         *
         * @private
         * @param {*} value The value to check.
         * @param {Object} [object] The object to query keys on.
         * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
         */
        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
        }

        /**
         * Checks if `value` is suitable for use as unique object key.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
         */
        function isKeyable(value) {
          var type = typeof value;
          return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }

        /**
         * Checks if `func` has a lazy counterpart.
         *
         * @private
         * @param {Function} func The function to check.
         * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
         *  else `false`.
         */
        function isLaziable(func) {
          var funcName = getFuncName(func),
            other = lodash[funcName];
          if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }

        /**
         * Checks if `func` has its source masked.
         *
         * @private
         * @param {Function} func The function to check.
         * @returns {boolean} Returns `true` if `func` is masked, else `false`.
         */
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }

        /**
         * Checks if `func` is capable of being masked.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
         */
        var isMaskable = coreJsData ? isFunction : stubFalse;

        /**
         * Checks if `value` is likely a prototype object.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
         */
        function isPrototype(value) {
          var Ctor = value && value.constructor,
            proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
          return value === proto;
        }

        /**
         * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` if suitable for strict
         *  equality comparisons, else `false`.
         */
        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }

        /**
         * A specialized version of `matchesProperty` for source values suitable
         * for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {string} key The key of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */
        function matchesStrictComparable(key, srcValue) {
          return function (object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
          };
        }

        /**
         * A specialized version of `_.memoize` which clears the memoized function's
         * cache when it exceeds `MAX_MEMOIZE_SIZE`.
         *
         * @private
         * @param {Function} func The function to have its output memoized.
         * @returns {Function} Returns the new memoized function.
         */
        function memoizeCapped(func) {
          var result = memoize(func, function (key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result.cache;
          return result;
        }

        /**
         * Merges the function metadata of `source` into `data`.
         *
         * Merging metadata reduces the number of wrappers used to invoke a function.
         * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
         * may be applied regardless of execution order. Methods like `_.ary` and
         * `_.rearg` modify function arguments, making the order in which they are
         * executed important, preventing the merging of metadata. However, we make
         * an exception for a safe combined case where curried functions have `_.ary`
         * and or `_.rearg` applied.
         *
         * @private
         * @param {Array} data The destination metadata.
         * @param {Array} source The source metadata.
         * @returns {Array} Returns `data`.
         */
        function mergeData(data, source) {
          var bitmask = data[1],
            srcBitmask = source[1],
            newBitmask = bitmask | srcBitmask,
            isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;

          // Exit early if metadata can't be merged.
          if (!(isCommon || isCombo)) {
            return data;
          }
          // Use source `thisArg` if available.
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            // Set when currying a bound function.
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          // Compose partial arguments.
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          // Compose partial right arguments.
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          // Use source `argPos` if available.
          value = source[7];
          if (value) {
            data[7] = value;
          }
          // Use source `ary` if it's smaller.
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          // Use source `arity` if one is not provided.
          if (data[9] == null) {
            data[9] = source[9];
          }
          // Use source `func` and merge bitmasks.
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }

        /**
         * This function is like
         * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * except that it includes inherited enumerable properties.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */
        function nativeKeysIn(object) {
          var result = [];
          if (object != null) {
            for (var key in Object(object)) {
              result.push(key);
            }
          }
          return result;
        }

        /**
         * Converts `value` to a string using `Object.prototype.toString`.
         *
         * @private
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         */
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }

        /**
         * A specialized version of `baseRest` which transforms the rest array.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @param {Function} transform The rest array transform.
         * @returns {Function} Returns the new function.
         */
        function overRest(func, start, transform) {
          start = nativeMax(start === undefined ? func.length - 1 : start, 0);
          return function () {
            var args = arguments,
              index = -1,
              length = nativeMax(args.length - start, 0),
              array = Array(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform(array);
            return apply(func, this, otherArgs);
          };
        }

        /**
         * Gets the parent value at `path` of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array} path The path to get the parent value of.
         * @returns {*} Returns the parent value.
         */
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }

        /**
         * Reorder `array` according to the specified indexes where the element at
         * the first index is assigned as the first element, the element at
         * the second index is assigned as the second element, and so on.
         *
         * @private
         * @param {Array} array The array to reorder.
         * @param {Array} indexes The arranged array indexes.
         * @returns {Array} Returns `array`.
         */
        function reorder(array, indexes) {
          var arrLength = array.length,
            length = nativeMin(indexes.length, arrLength),
            oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
          }
          return array;
        }

        /**
         * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
         *
         * @private
         * @param {Object} object The object to query.
         * @param {string} key The key of the property to get.
         * @returns {*} Returns the property value.
         */
        function safeGet(object, key) {
          if (key === 'constructor' && typeof object[key] === 'function') {
            return;
          }
          if (key == '__proto__') {
            return;
          }
          return object[key];
        }

        /**
         * Sets metadata for `func`.
         *
         * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
         * period of time, it will trip its breaker and transition to an identity
         * function to avoid garbage collection pauses in V8. See
         * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
         * for more details.
         *
         * @private
         * @param {Function} func The function to associate metadata with.
         * @param {*} data The metadata.
         * @returns {Function} Returns `func`.
         */
        var setData = shortOut(baseSetData);

        /**
         * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
         *
         * @private
         * @param {Function} func The function to delay.
         * @param {number} wait The number of milliseconds to delay invocation.
         * @returns {number|Object} Returns the timer id or timeout object.
         */
        var setTimeout = ctxSetTimeout || function (func, wait) {
          return root.setTimeout(func, wait);
        };

        /**
         * Sets the `toString` method of `func` to return `string`.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */
        var setToString = shortOut(baseSetToString);

        /**
         * Sets the `toString` method of `wrapper` to mimic the source of `reference`
         * with wrapper details in a comment at the top of the source body.
         *
         * @private
         * @param {Function} wrapper The function to modify.
         * @param {Function} reference The reference function.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @returns {Function} Returns `wrapper`.
         */
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + '';
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }

        /**
         * Creates a function that'll short out and invoke `identity` instead
         * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
         * milliseconds.
         *
         * @private
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new shortable function.
         */
        function shortOut(func) {
          var count = 0,
            lastCalled = 0;
          return function () {
            var stamp = nativeNow(),
              remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined, arguments);
          };
        }

        /**
         * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
         *
         * @private
         * @param {Array} array The array to shuffle.
         * @param {number} [size=array.length] The size of `array`.
         * @returns {Array} Returns `array`.
         */
        function shuffleSelf(array, size) {
          var index = -1,
            length = array.length,
            lastIndex = length - 1;
          size = size === undefined ? length : size;
          while (++index < size) {
            var rand = baseRandom(index, lastIndex),
              value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }
          array.length = size;
          return array;
        }

        /**
         * Converts `string` to a property path array.
         *
         * @private
         * @param {string} string The string to convert.
         * @returns {Array} Returns the property path array.
         */
        var stringToPath = memoizeCapped(function (string) {
          var result = [];
          if (string.charCodeAt(0) === 46 /* . */) {
            result.push('');
          }
          string.replace(rePropName, function (match, number, quote, subString) {
            result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
          });
          return result;
        });

        /**
         * Converts `value` to a string key if it's not a string or symbol.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {string|symbol} Returns the key.
         */
        function toKey(value) {
          if (typeof value == 'string' || isSymbol(value)) {
            return value;
          }
          var result = value + '';
          return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }

        /**
         * Converts `func` to its source code.
         *
         * @private
         * @param {Function} func The function to convert.
         * @returns {string} Returns the source code.
         */
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {}
            try {
              return func + '';
            } catch (e) {}
          }
          return '';
        }

        /**
         * Updates wrapper `details` based on `bitmask` flags.
         *
         * @private
         * @returns {Array} details The details to modify.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @returns {Array} Returns `details`.
         */
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function (pair) {
            var value = '_.' + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }

        /**
         * Creates a clone of `wrapper`.
         *
         * @private
         * @param {Object} wrapper The wrapper to clone.
         * @returns {Object} Returns the cloned wrapper.
         */
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result.__actions__ = copyArray(wrapper.__actions__);
          result.__index__ = wrapper.__index__;
          result.__values__ = wrapper.__values__;
          return result;
        }

        /*------------------------------------------------------------------------*/

        /**
         * Creates an array of elements split into groups the length of `size`.
         * If `array` can't be split evenly, the final chunk will be the remaining
         * elements.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to process.
         * @param {number} [size=1] The length of each chunk
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the new array of chunks.
         * @example
         *
         * _.chunk(['a', 'b', 'c', 'd'], 2);
         * // => [['a', 'b'], ['c', 'd']]
         *
         * _.chunk(['a', 'b', 'c', 'd'], 3);
         * // => [['a', 'b', 'c'], ['d']]
         */
        function chunk(array, size, guard) {
          if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
            size = 1;
          } else {
            size = nativeMax(toInteger(size), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size < 1) {
            return [];
          }
          var index = 0,
            resIndex = 0,
            result = Array(nativeCeil(length / size));
          while (index < length) {
            result[resIndex++] = baseSlice(array, index, index += size);
          }
          return result;
        }

        /**
         * Creates an array with all falsey values removed. The values `false`, `null`,
         * `0`, `""`, `undefined`, and `NaN` are falsey.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to compact.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * _.compact([0, 1, false, 2, '', 3]);
         * // => [1, 2, 3]
         */
        function compact(array) {
          var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result[resIndex++] = value;
            }
          }
          return result;
        }

        /**
         * Creates a new array concatenating `array` with any additional arrays
         * and/or values.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to concatenate.
         * @param {...*} [values] The values to concatenate.
         * @returns {Array} Returns the new concatenated array.
         * @example
         *
         * var array = [1];
         * var other = _.concat(array, 2, [3], [[4]]);
         *
         * console.log(other);
         * // => [1, 2, 3, [4]]
         *
         * console.log(array);
         * // => [1]
         */
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array(length - 1),
            array = arguments[0],
            index = length;
          while (index--) {
            args[index - 1] = arguments[index];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }

        /**
         * Creates an array of `array` values not included in the other given arrays
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. The order and references of result values are
         * determined by the first array.
         *
         * **Note:** Unlike `_.pullAll`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...Array} [values] The values to exclude.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.without, _.xor
         * @example
         *
         * _.difference([2, 1], [2, 3]);
         * // => [1]
         */
        var difference = baseRest(function (array, values) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });

        /**
         * This method is like `_.difference` except that it accepts `iteratee` which
         * is invoked for each element of `array` and `values` to generate the criterion
         * by which they're compared. The order and references of result values are
         * determined by the first array. The iteratee is invoked with one argument:
         * (value).
         *
         * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...Array} [values] The values to exclude.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
         * // => [1.2]
         *
         * // The `_.property` iteratee shorthand.
         * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
         * // => [{ 'x': 2 }]
         */
        var differenceBy = baseRest(function (array, values) {
          var iteratee = last(values);
          if (isArrayLikeObject(iteratee)) {
            iteratee = undefined;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });

        /**
         * This method is like `_.difference` except that it accepts `comparator`
         * which is invoked to compare elements of `array` to `values`. The order and
         * references of result values are determined by the first array. The comparator
         * is invoked with two arguments: (arrVal, othVal).
         *
         * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...Array} [values] The values to exclude.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         *
         * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
         * // => [{ 'x': 2, 'y': 1 }]
         */
        var differenceWith = baseRest(function (array, values) {
          var comparator = last(values);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });

        /**
         * Creates a slice of `array` with `n` elements dropped from the beginning.
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to drop.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.drop([1, 2, 3]);
         * // => [2, 3]
         *
         * _.drop([1, 2, 3], 2);
         * // => [3]
         *
         * _.drop([1, 2, 3], 5);
         * // => []
         *
         * _.drop([1, 2, 3], 0);
         * // => [1, 2, 3]
         */
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }

        /**
         * Creates a slice of `array` with `n` elements dropped from the end.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to drop.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.dropRight([1, 2, 3]);
         * // => [1, 2]
         *
         * _.dropRight([1, 2, 3], 2);
         * // => [1]
         *
         * _.dropRight([1, 2, 3], 5);
         * // => []
         *
         * _.dropRight([1, 2, 3], 0);
         * // => [1, 2, 3]
         */
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }

        /**
         * Creates a slice of `array` excluding elements dropped from the end.
         * Elements are dropped until `predicate` returns falsey. The predicate is
         * invoked with three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.dropRightWhile(users, function(o) { return !o.active; });
         * // => objects for ['barney']
         *
         * // The `_.matches` iteratee shorthand.
         * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
         * // => objects for ['barney', 'fred']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.dropRightWhile(users, ['active', false]);
         * // => objects for ['barney']
         *
         * // The `_.property` iteratee shorthand.
         * _.dropRightWhile(users, 'active');
         * // => objects for ['barney', 'fred', 'pebbles']
         */
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }

        /**
         * Creates a slice of `array` excluding elements dropped from the beginning.
         * Elements are dropped until `predicate` returns falsey. The predicate is
         * invoked with three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.dropWhile(users, function(o) { return !o.active; });
         * // => objects for ['pebbles']
         *
         * // The `_.matches` iteratee shorthand.
         * _.dropWhile(users, { 'user': 'barney', 'active': false });
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.dropWhile(users, ['active', false]);
         * // => objects for ['pebbles']
         *
         * // The `_.property` iteratee shorthand.
         * _.dropWhile(users, 'active');
         * // => objects for ['barney', 'fred', 'pebbles']
         */
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }

        /**
         * Fills elements of `array` with `value` from `start` up to, but not
         * including, `end`.
         *
         * **Note:** This method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Array
         * @param {Array} array The array to fill.
         * @param {*} value The value to fill `array` with.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _.fill(array, 'a');
         * console.log(array);
         * // => ['a', 'a', 'a']
         *
         * _.fill(Array(3), 2);
         * // => [2, 2, 2]
         *
         * _.fill([4, 6, 8, 10], '*', 1, 3);
         * // => [4, '*', '*', 10]
         */
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }

        /**
         * This method is like `_.find` except that it returns the index of the first
         * element `predicate` returns truthy for instead of the element itself.
         *
         * @static
         * @memberOf _
         * @since 1.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {number} Returns the index of the found element, else `-1`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.findIndex(users, function(o) { return o.user == 'barney'; });
         * // => 0
         *
         * // The `_.matches` iteratee shorthand.
         * _.findIndex(users, { 'user': 'fred', 'active': false });
         * // => 1
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findIndex(users, ['active', false]);
         * // => 0
         *
         * // The `_.property` iteratee shorthand.
         * _.findIndex(users, 'active');
         * // => 2
         */
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }

        /**
         * This method is like `_.findIndex` except that it iterates over elements
         * of `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=array.length-1] The index to search from.
         * @returns {number} Returns the index of the found element, else `-1`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
         * // => 2
         *
         * // The `_.matches` iteratee shorthand.
         * _.findLastIndex(users, { 'user': 'barney', 'active': true });
         * // => 0
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findLastIndex(users, ['active', false]);
         * // => 2
         *
         * // The `_.property` iteratee shorthand.
         * _.findLastIndex(users, 'active');
         * // => 0
         */
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length - 1;
          if (fromIndex !== undefined) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }

        /**
         * Flattens `array` a single level deep.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * _.flatten([1, [2, [3, [4]], 5]]);
         * // => [1, 2, [3, [4]], 5]
         */
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }

        /**
         * Recursively flattens `array`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * _.flattenDeep([1, [2, [3, [4]], 5]]);
         * // => [1, 2, 3, 4, 5]
         */
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }

        /**
         * Recursively flatten `array` up to `depth` times.
         *
         * @static
         * @memberOf _
         * @since 4.4.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @param {number} [depth=1] The maximum recursion depth.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * var array = [1, [2, [3, [4]], 5]];
         *
         * _.flattenDepth(array, 1);
         * // => [1, 2, [3, [4]], 5]
         *
         * _.flattenDepth(array, 2);
         * // => [1, 2, 3, [4], 5]
         */
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }

        /**
         * The inverse of `_.toPairs`; this method returns an object composed
         * from key-value `pairs`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} pairs The key-value pairs.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.fromPairs([['a', 1], ['b', 2]]);
         * // => { 'a': 1, 'b': 2 }
         */
        function fromPairs(pairs) {
          var index = -1,
            length = pairs == null ? 0 : pairs.length,
            result = {};
          while (++index < length) {
            var pair = pairs[index];
            result[pair[0]] = pair[1];
          }
          return result;
        }

        /**
         * Gets the first element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @alias first
         * @category Array
         * @param {Array} array The array to query.
         * @returns {*} Returns the first element of `array`.
         * @example
         *
         * _.head([1, 2, 3]);
         * // => 1
         *
         * _.head([]);
         * // => undefined
         */
        function head(array) {
          return array && array.length ? array[0] : undefined;
        }

        /**
         * Gets the index at which the first occurrence of `value` is found in `array`
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. If `fromIndex` is negative, it's used as the
         * offset from the end of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.indexOf([1, 2, 1, 2], 2);
         * // => 1
         *
         * // Search from the `fromIndex`.
         * _.indexOf([1, 2, 1, 2], 2, 2);
         * // => 3
         */
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseIndexOf(array, value, index);
        }

        /**
         * Gets all but the last element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.initial([1, 2, 3]);
         * // => [1, 2]
         */
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }

        /**
         * Creates an array of unique values that are included in all given arrays
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. The order and references of result values are
         * determined by the first array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of intersecting values.
         * @example
         *
         * _.intersection([2, 1], [2, 3]);
         * // => [2]
         */
        var intersection = baseRest(function (arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });

        /**
         * This method is like `_.intersection` except that it accepts `iteratee`
         * which is invoked for each element of each `arrays` to generate the criterion
         * by which they're compared. The order and references of result values are
         * determined by the first array. The iteratee is invoked with one argument:
         * (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of intersecting values.
         * @example
         *
         * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
         * // => [2.1]
         *
         * // The `_.property` iteratee shorthand.
         * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 1 }]
         */
        var intersectionBy = baseRest(function (arrays) {
          var iteratee = last(arrays),
            mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee === last(mapped)) {
            iteratee = undefined;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });

        /**
         * This method is like `_.intersection` except that it accepts `comparator`
         * which is invoked to compare elements of `arrays`. The order and references
         * of result values are determined by the first array. The comparator is
         * invoked with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of intersecting values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.intersectionWith(objects, others, _.isEqual);
         * // => [{ 'x': 1, 'y': 2 }]
         */
        var intersectionWith = baseRest(function (arrays) {
          var comparator = last(arrays),
            mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == 'function' ? comparator : undefined;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });

        /**
         * Converts all elements in `array` into a string separated by `separator`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to convert.
         * @param {string} [separator=','] The element separator.
         * @returns {string} Returns the joined string.
         * @example
         *
         * _.join(['a', 'b', 'c'], '~');
         * // => 'a~b~c'
         */
        function join(array, separator) {
          return array == null ? '' : nativeJoin.call(array, separator);
        }

        /**
         * Gets the last element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {*} Returns the last element of `array`.
         * @example
         *
         * _.last([1, 2, 3]);
         * // => 3
         */
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined;
        }

        /**
         * This method is like `_.indexOf` except that it iterates over elements of
         * `array` from right to left.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=array.length-1] The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.lastIndexOf([1, 2, 1, 2], 2);
         * // => 3
         *
         * // Search from the `fromIndex`.
         * _.lastIndexOf([1, 2, 1, 2], 2, 2);
         * // => 1
         */
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }

        /**
         * Gets the element at index `n` of `array`. If `n` is negative, the nth
         * element from the end is returned.
         *
         * @static
         * @memberOf _
         * @since 4.11.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=0] The index of the element to return.
         * @returns {*} Returns the nth element of `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'd'];
         *
         * _.nth(array, 1);
         * // => 'b'
         *
         * _.nth(array, -2);
         * // => 'c';
         */
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }

        /**
         * Removes all given values from `array` using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
         * to remove elements from an array by predicate.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {...*} [values] The values to remove.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
         *
         * _.pull(array, 'a', 'c');
         * console.log(array);
         * // => ['b', 'b']
         */
        var pull = baseRest(pullAll);

        /**
         * This method is like `_.pull` except that it accepts an array of values to remove.
         *
         * **Note:** Unlike `_.difference`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
         *
         * _.pullAll(array, ['a', 'c']);
         * console.log(array);
         * // => ['b', 'b']
         */
        function pullAll(array, values) {
          return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }

        /**
         * This method is like `_.pullAll` except that it accepts `iteratee` which is
         * invoked for each element of `array` and `values` to generate the criterion
         * by which they're compared. The iteratee is invoked with one argument: (value).
         *
         * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
         *
         * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
         * console.log(array);
         * // => [{ 'x': 2 }]
         */
        function pullAllBy(array, values, iteratee) {
          return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }

        /**
         * This method is like `_.pullAll` except that it accepts `comparator` which
         * is invoked to compare elements of `array` to `values`. The comparator is
         * invoked with two arguments: (arrVal, othVal).
         *
         * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
         *
         * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
         * console.log(array);
         * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
         */
        function pullAllWith(array, values, comparator) {
          return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }

        /**
         * Removes elements from `array` corresponding to `indexes` and returns an
         * array of removed elements.
         *
         * **Note:** Unlike `_.at`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {...(number|number[])} [indexes] The indexes of elements to remove.
         * @returns {Array} Returns the new array of removed elements.
         * @example
         *
         * var array = ['a', 'b', 'c', 'd'];
         * var pulled = _.pullAt(array, [1, 3]);
         *
         * console.log(array);
         * // => ['a', 'c']
         *
         * console.log(pulled);
         * // => ['b', 'd']
         */
        var pullAt = flatRest(function (array, indexes) {
          var length = array == null ? 0 : array.length,
            result = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function (index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result;
        });

        /**
         * Removes all elements from `array` that `predicate` returns truthy for
         * and returns an array of the removed elements. The predicate is invoked
         * with three arguments: (value, index, array).
         *
         * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
         * to pull elements from an array by value.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new array of removed elements.
         * @example
         *
         * var array = [1, 2, 3, 4];
         * var evens = _.remove(array, function(n) {
         *   return n % 2 == 0;
         * });
         *
         * console.log(array);
         * // => [1, 3]
         *
         * console.log(evens);
         * // => [2, 4]
         */
        function remove(array, predicate) {
          var result = [];
          if (!(array && array.length)) {
            return result;
          }
          var index = -1,
            indexes = [],
            length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result;
        }

        /**
         * Reverses `array` so that the first element becomes the last, the second
         * element becomes the second to last, and so on.
         *
         * **Note:** This method mutates `array` and is based on
         * [`Array#reverse`](https://mdn.io/Array/reverse).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _.reverse(array);
         * // => [3, 2, 1]
         *
         * console.log(array);
         * // => [3, 2, 1]
         */
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }

        /**
         * Creates a slice of `array` from `start` up to, but not including, `end`.
         *
         * **Note:** This method is used instead of
         * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
         * returned.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to slice.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the slice of `array`.
         */
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }

        /**
         * Uses a binary search to determine the lowest index at which `value`
         * should be inserted into `array` in order to maintain its sort order.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * _.sortedIndex([30, 50], 40);
         * // => 1
         */
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }

        /**
         * This method is like `_.sortedIndex` except that it accepts `iteratee`
         * which is invoked for `value` and each element of `array` to compute their
         * sort ranking. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * var objects = [{ 'x': 4 }, { 'x': 5 }];
         *
         * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
         * // => 0
         *
         * // The `_.property` iteratee shorthand.
         * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
         * // => 0
         */
        function sortedIndexBy(array, value, iteratee) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }

        /**
         * This method is like `_.indexOf` except that it performs a binary
         * search on a sorted `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
         * // => 1
         */
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }

        /**
         * This method is like `_.sortedIndex` except that it returns the highest
         * index at which `value` should be inserted into `array` in order to
         * maintain its sort order.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
         * // => 4
         */
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }

        /**
         * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
         * which is invoked for `value` and each element of `array` to compute their
         * sort ranking. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * var objects = [{ 'x': 4 }, { 'x': 5 }];
         *
         * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
         * // => 1
         *
         * // The `_.property` iteratee shorthand.
         * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
         * // => 1
         */
        function sortedLastIndexBy(array, value, iteratee) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }

        /**
         * This method is like `_.lastIndexOf` except that it performs a binary
         * search on a sorted `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
         * // => 3
         */
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }

        /**
         * This method is like `_.uniq` except that it's designed and optimized
         * for sorted arrays.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.sortedUniq([1, 1, 2]);
         * // => [1, 2]
         */
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }

        /**
         * This method is like `_.uniqBy` except that it's designed and optimized
         * for sorted arrays.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
         * // => [1.1, 2.3]
         */
        function sortedUniqBy(array, iteratee) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }

        /**
         * Gets all but the first element of `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.tail([1, 2, 3]);
         * // => [2, 3]
         */
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }

        /**
         * Creates a slice of `array` with `n` elements taken from the beginning.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to take.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.take([1, 2, 3]);
         * // => [1]
         *
         * _.take([1, 2, 3], 2);
         * // => [1, 2]
         *
         * _.take([1, 2, 3], 5);
         * // => [1, 2, 3]
         *
         * _.take([1, 2, 3], 0);
         * // => []
         */
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }

        /**
         * Creates a slice of `array` with `n` elements taken from the end.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to take.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.takeRight([1, 2, 3]);
         * // => [3]
         *
         * _.takeRight([1, 2, 3], 2);
         * // => [2, 3]
         *
         * _.takeRight([1, 2, 3], 5);
         * // => [1, 2, 3]
         *
         * _.takeRight([1, 2, 3], 0);
         * // => []
         */
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }

        /**
         * Creates a slice of `array` with elements taken from the end. Elements are
         * taken until `predicate` returns falsey. The predicate is invoked with
         * three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.takeRightWhile(users, function(o) { return !o.active; });
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.matches` iteratee shorthand.
         * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
         * // => objects for ['pebbles']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.takeRightWhile(users, ['active', false]);
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.property` iteratee shorthand.
         * _.takeRightWhile(users, 'active');
         * // => []
         */
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }

        /**
         * Creates a slice of `array` with elements taken from the beginning. Elements
         * are taken until `predicate` returns falsey. The predicate is invoked with
         * three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.takeWhile(users, function(o) { return !o.active; });
         * // => objects for ['barney', 'fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.takeWhile(users, { 'user': 'barney', 'active': false });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.takeWhile(users, ['active', false]);
         * // => objects for ['barney', 'fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.takeWhile(users, 'active');
         * // => []
         */
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }

        /**
         * Creates an array of unique values, in order, from all given arrays using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of combined values.
         * @example
         *
         * _.union([2], [1, 2]);
         * // => [2, 1]
         */
        var union = baseRest(function (arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });

        /**
         * This method is like `_.union` except that it accepts `iteratee` which is
         * invoked for each element of each `arrays` to generate the criterion by
         * which uniqueness is computed. Result values are chosen from the first
         * array in which the value occurs. The iteratee is invoked with one argument:
         * (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of combined values.
         * @example
         *
         * _.unionBy([2.1], [1.2, 2.3], Math.floor);
         * // => [2.1, 1.2]
         *
         * // The `_.property` iteratee shorthand.
         * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 1 }, { 'x': 2 }]
         */
        var unionBy = baseRest(function (arrays) {
          var iteratee = last(arrays);
          if (isArrayLikeObject(iteratee)) {
            iteratee = undefined;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });

        /**
         * This method is like `_.union` except that it accepts `comparator` which
         * is invoked to compare elements of `arrays`. Result values are chosen from
         * the first array in which the value occurs. The comparator is invoked
         * with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of combined values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.unionWith(objects, others, _.isEqual);
         * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
         */
        var unionWith = baseRest(function (arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == 'function' ? comparator : undefined;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });

        /**
         * Creates a duplicate-free version of an array, using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons, in which only the first occurrence of each element
         * is kept. The order of result values is determined by the order they occur
         * in the array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.uniq([2, 1, 2]);
         * // => [2, 1]
         */
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }

        /**
         * This method is like `_.uniq` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * uniqueness is computed. The order of result values is determined by the
         * order they occur in the array. The iteratee is invoked with one argument:
         * (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
         * // => [2.1, 1.2]
         *
         * // The `_.property` iteratee shorthand.
         * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 1 }, { 'x': 2 }]
         */
        function uniqBy(array, iteratee) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }

        /**
         * This method is like `_.uniq` except that it accepts `comparator` which
         * is invoked to compare elements of `array`. The order of result values is
         * determined by the order they occur in the array.The comparator is invoked
         * with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.uniqWith(objects, _.isEqual);
         * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
         */
        function uniqWith(array, comparator) {
          comparator = typeof comparator == 'function' ? comparator : undefined;
          return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }

        /**
         * This method is like `_.zip` except that it accepts an array of grouped
         * elements and creates an array regrouping the elements to their pre-zip
         * configuration.
         *
         * @static
         * @memberOf _
         * @since 1.2.0
         * @category Array
         * @param {Array} array The array of grouped elements to process.
         * @returns {Array} Returns the new array of regrouped elements.
         * @example
         *
         * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
         * // => [['a', 1, true], ['b', 2, false]]
         *
         * _.unzip(zipped);
         * // => [['a', 'b'], [1, 2], [true, false]]
         */
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function (group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function (index) {
            return arrayMap(array, baseProperty(index));
          });
        }

        /**
         * This method is like `_.unzip` except that it accepts `iteratee` to specify
         * how regrouped values should be combined. The iteratee is invoked with the
         * elements of each group: (...group).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Array
         * @param {Array} array The array of grouped elements to process.
         * @param {Function} [iteratee=_.identity] The function to combine
         *  regrouped values.
         * @returns {Array} Returns the new array of regrouped elements.
         * @example
         *
         * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
         * // => [[1, 10, 100], [2, 20, 200]]
         *
         * _.unzipWith(zipped, _.add);
         * // => [3, 30, 300]
         */
        function unzipWith(array, iteratee) {
          if (!(array && array.length)) {
            return [];
          }
          var result = unzip(array);
          if (iteratee == null) {
            return result;
          }
          return arrayMap(result, function (group) {
            return apply(iteratee, undefined, group);
          });
        }

        /**
         * Creates an array excluding all given values using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * **Note:** Unlike `_.pull`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...*} [values] The values to exclude.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.difference, _.xor
         * @example
         *
         * _.without([2, 1, 2, 3], 1, 2);
         * // => [3]
         */
        var without = baseRest(function (array, values) {
          return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });

        /**
         * Creates an array of unique values that is the
         * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
         * of the given arrays. The order of result values is determined by the order
         * they occur in the arrays.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.difference, _.without
         * @example
         *
         * _.xor([2, 1], [2, 3]);
         * // => [1, 3]
         */
        var xor = baseRest(function (arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });

        /**
         * This method is like `_.xor` except that it accepts `iteratee` which is
         * invoked for each element of each `arrays` to generate the criterion by
         * which by which they're compared. The order of result values is determined
         * by the order they occur in the arrays. The iteratee is invoked with one
         * argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
         * // => [1.2, 3.4]
         *
         * // The `_.property` iteratee shorthand.
         * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 2 }]
         */
        var xorBy = baseRest(function (arrays) {
          var iteratee = last(arrays);
          if (isArrayLikeObject(iteratee)) {
            iteratee = undefined;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });

        /**
         * This method is like `_.xor` except that it accepts `comparator` which is
         * invoked to compare elements of `arrays`. The order of result values is
         * determined by the order they occur in the arrays. The comparator is invoked
         * with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
         * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.xorWith(objects, others, _.isEqual);
         * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
         */
        var xorWith = baseRest(function (arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == 'function' ? comparator : undefined;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });

        /**
         * Creates an array of grouped elements, the first of which contains the
         * first elements of the given arrays, the second of which contains the
         * second elements of the given arrays, and so on.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to process.
         * @returns {Array} Returns the new array of grouped elements.
         * @example
         *
         * _.zip(['a', 'b'], [1, 2], [true, false]);
         * // => [['a', 1, true], ['b', 2, false]]
         */
        var zip = baseRest(unzip);

        /**
         * This method is like `_.fromPairs` except that it accepts two arrays,
         * one of property identifiers and one of corresponding values.
         *
         * @static
         * @memberOf _
         * @since 0.4.0
         * @category Array
         * @param {Array} [props=[]] The property identifiers.
         * @param {Array} [values=[]] The property values.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.zipObject(['a', 'b'], [1, 2]);
         * // => { 'a': 1, 'b': 2 }
         */
        function zipObject(props, values) {
          return baseZipObject(props || [], values || [], assignValue);
        }

        /**
         * This method is like `_.zipObject` except that it supports property paths.
         *
         * @static
         * @memberOf _
         * @since 4.1.0
         * @category Array
         * @param {Array} [props=[]] The property identifiers.
         * @param {Array} [values=[]] The property values.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
         * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
         */
        function zipObjectDeep(props, values) {
          return baseZipObject(props || [], values || [], baseSet);
        }

        /**
         * This method is like `_.zip` except that it accepts `iteratee` to specify
         * how grouped values should be combined. The iteratee is invoked with the
         * elements of each group: (...group).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Array
         * @param {...Array} [arrays] The arrays to process.
         * @param {Function} [iteratee=_.identity] The function to combine
         *  grouped values.
         * @returns {Array} Returns the new array of grouped elements.
         * @example
         *
         * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
         *   return a + b + c;
         * });
         * // => [111, 222]
         */
        var zipWith = baseRest(function (arrays) {
          var length = arrays.length,
            iteratee = length > 1 ? arrays[length - 1] : undefined;
          iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
          return unzipWith(arrays, iteratee);
        });

        /*------------------------------------------------------------------------*/

        /**
         * Creates a `lodash` wrapper instance that wraps `value` with explicit method
         * chain sequences enabled. The result of such sequences must be unwrapped
         * with `_#value`.
         *
         * @static
         * @memberOf _
         * @since 1.3.0
         * @category Seq
         * @param {*} value The value to wrap.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'age': 36 },
         *   { 'user': 'fred',    'age': 40 },
         *   { 'user': 'pebbles', 'age': 1 }
         * ];
         *
         * var youngest = _
         *   .chain(users)
         *   .sortBy('age')
         *   .map(function(o) {
         *     return o.user + ' is ' + o.age;
         *   })
         *   .head()
         *   .value();
         * // => 'pebbles is 1'
         */
        function chain(value) {
          var result = lodash(value);
          result.__chain__ = true;
          return result;
        }

        /**
         * This method invokes `interceptor` and returns `value`. The interceptor
         * is invoked with one argument; (value). The purpose of this method is to
         * "tap into" a method chain sequence in order to modify intermediate results.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Seq
         * @param {*} value The value to provide to `interceptor`.
         * @param {Function} interceptor The function to invoke.
         * @returns {*} Returns `value`.
         * @example
         *
         * _([1, 2, 3])
         *  .tap(function(array) {
         *    // Mutate input array.
         *    array.pop();
         *  })
         *  .reverse()
         *  .value();
         * // => [2, 1]
         */
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }

        /**
         * This method is like `_.tap` except that it returns the result of `interceptor`.
         * The purpose of this method is to "pass thru" values replacing intermediate
         * results in a method chain sequence.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Seq
         * @param {*} value The value to provide to `interceptor`.
         * @param {Function} interceptor The function to invoke.
         * @returns {*} Returns the result of `interceptor`.
         * @example
         *
         * _('  abc  ')
         *  .chain()
         *  .trim()
         *  .thru(function(value) {
         *    return [value];
         *  })
         *  .value();
         * // => ['abc']
         */
        function thru(value, interceptor) {
          return interceptor(value);
        }

        /**
         * This method is the wrapper version of `_.at`.
         *
         * @name at
         * @memberOf _
         * @since 1.0.0
         * @category Seq
         * @param {...(string|string[])} [paths] The property paths to pick.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
         *
         * _(object).at(['a[0].b.c', 'a[1]']).value();
         * // => [3, 4]
         */
        var wrapperAt = flatRest(function (paths) {
          var length = paths.length,
            start = length ? paths[0] : 0,
            value = this.__wrapped__,
            interceptor = function (object) {
              return baseAt(object, paths);
            };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            'func': thru,
            'args': [interceptor],
            'thisArg': undefined
          });
          return new LodashWrapper(value, this.__chain__).thru(function (array) {
            if (length && !array.length) {
              array.push(undefined);
            }
            return array;
          });
        });

        /**
         * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
         *
         * @name chain
         * @memberOf _
         * @since 0.1.0
         * @category Seq
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36 },
         *   { 'user': 'fred',   'age': 40 }
         * ];
         *
         * // A sequence without explicit chaining.
         * _(users).head();
         * // => { 'user': 'barney', 'age': 36 }
         *
         * // A sequence with explicit chaining.
         * _(users)
         *   .chain()
         *   .head()
         *   .pick('user')
         *   .value();
         * // => { 'user': 'barney' }
         */
        function wrapperChain() {
          return chain(this);
        }

        /**
         * Executes the chain sequence and returns the wrapped result.
         *
         * @name commit
         * @memberOf _
         * @since 3.2.0
         * @category Seq
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var array = [1, 2];
         * var wrapped = _(array).push(3);
         *
         * console.log(array);
         * // => [1, 2]
         *
         * wrapped = wrapped.commit();
         * console.log(array);
         * // => [1, 2, 3]
         *
         * wrapped.last();
         * // => 3
         *
         * console.log(array);
         * // => [1, 2, 3]
         */
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }

        /**
         * Gets the next value on a wrapped object following the
         * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
         *
         * @name next
         * @memberOf _
         * @since 4.0.0
         * @category Seq
         * @returns {Object} Returns the next iterator value.
         * @example
         *
         * var wrapped = _([1, 2]);
         *
         * wrapped.next();
         * // => { 'done': false, 'value': 1 }
         *
         * wrapped.next();
         * // => { 'done': false, 'value': 2 }
         *
         * wrapped.next();
         * // => { 'done': true, 'value': undefined }
         */
        function wrapperNext() {
          if (this.__values__ === undefined) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length,
            value = done ? undefined : this.__values__[this.__index__++];
          return {
            'done': done,
            'value': value
          };
        }

        /**
         * Enables the wrapper to be iterable.
         *
         * @name Symbol.iterator
         * @memberOf _
         * @since 4.0.0
         * @category Seq
         * @returns {Object} Returns the wrapper object.
         * @example
         *
         * var wrapped = _([1, 2]);
         *
         * wrapped[Symbol.iterator]() === wrapped;
         * // => true
         *
         * Array.from(wrapped);
         * // => [1, 2]
         */
        function wrapperToIterator() {
          return this;
        }

        /**
         * Creates a clone of the chain sequence planting `value` as the wrapped value.
         *
         * @name plant
         * @memberOf _
         * @since 3.2.0
         * @category Seq
         * @param {*} value The value to plant.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var wrapped = _([1, 2]).map(square);
         * var other = wrapped.plant([3, 4]);
         *
         * other.value();
         * // => [9, 16]
         *
         * wrapped.value();
         * // => [1, 4]
         */
        function wrapperPlant(value) {
          var result,
            parent = this;
          while (parent instanceof baseLodash) {
            var clone = wrapperClone(parent);
            clone.__index__ = 0;
            clone.__values__ = undefined;
            if (result) {
              previous.__wrapped__ = clone;
            } else {
              result = clone;
            }
            var previous = clone;
            parent = parent.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result;
        }

        /**
         * This method is the wrapper version of `_.reverse`.
         *
         * **Note:** This method mutates the wrapped array.
         *
         * @name reverse
         * @memberOf _
         * @since 0.1.0
         * @category Seq
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _(array).reverse().value()
         * // => [3, 2, 1]
         *
         * console.log(array);
         * // => [3, 2, 1]
         */
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              'func': thru,
              'args': [reverse],
              'thisArg': undefined
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }

        /**
         * Executes the chain sequence to resolve the unwrapped value.
         *
         * @name value
         * @memberOf _
         * @since 0.1.0
         * @alias toJSON, valueOf
         * @category Seq
         * @returns {*} Returns the resolved unwrapped value.
         * @example
         *
         * _([1, 2, 3]).value();
         * // => [1, 2, 3]
         */
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }

        /*------------------------------------------------------------------------*/

        /**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The corresponding value of
         * each key is the number of times the key was returned by `iteratee`. The
         * iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * _.countBy([6.1, 4.2, 6.3], Math.floor);
         * // => { '4': 1, '6': 2 }
         *
         * // The `_.property` iteratee shorthand.
         * _.countBy(['one', 'two', 'three'], 'length');
         * // => { '3': 2, '5': 1 }
         */
        var countBy = createAggregator(function (result, value, key) {
          if (hasOwnProperty.call(result, key)) {
            ++result[key];
          } else {
            baseAssignValue(result, key, 1);
          }
        });

        /**
         * Checks if `predicate` returns truthy for **all** elements of `collection`.
         * Iteration is stopped once `predicate` returns falsey. The predicate is
         * invoked with three arguments: (value, index|key, collection).
         *
         * **Note:** This method returns `true` for
         * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
         * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
         * elements of empty collections.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {boolean} Returns `true` if all elements pass the predicate check,
         *  else `false`.
         * @example
         *
         * _.every([true, 1, null, 'yes'], Boolean);
         * // => false
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': false },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * // The `_.matches` iteratee shorthand.
         * _.every(users, { 'user': 'barney', 'active': false });
         * // => false
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.every(users, ['active', false]);
         * // => true
         *
         * // The `_.property` iteratee shorthand.
         * _.every(users, 'active');
         * // => false
         */
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined;
          }
          return func(collection, getIteratee(predicate, 3));
        }

        /**
         * Iterates over elements of `collection`, returning an array of all elements
         * `predicate` returns truthy for. The predicate is invoked with three
         * arguments: (value, index|key, collection).
         *
         * **Note:** Unlike `_.remove`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         * @see _.reject
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': true },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * _.filter(users, function(o) { return !o.active; });
         * // => objects for ['fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.filter(users, { 'age': 36, 'active': true });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.filter(users, ['active', false]);
         * // => objects for ['fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.filter(users, 'active');
         * // => objects for ['barney']
         *
         * // Combining several predicates using `_.overEvery` or `_.overSome`.
         * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
         * // => objects for ['fred', 'barney']
         */
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }

        /**
         * Iterates over elements of `collection`, returning the first element
         * `predicate` returns truthy for. The predicate is invoked with three
         * arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {*} Returns the matched element, else `undefined`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'age': 36, 'active': true },
         *   { 'user': 'fred',    'age': 40, 'active': false },
         *   { 'user': 'pebbles', 'age': 1,  'active': true }
         * ];
         *
         * _.find(users, function(o) { return o.age < 40; });
         * // => object for 'barney'
         *
         * // The `_.matches` iteratee shorthand.
         * _.find(users, { 'age': 1, 'active': true });
         * // => object for 'pebbles'
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.find(users, ['active', false]);
         * // => object for 'fred'
         *
         * // The `_.property` iteratee shorthand.
         * _.find(users, 'active');
         * // => object for 'barney'
         */
        var find = createFind(findIndex);

        /**
         * This method is like `_.find` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=collection.length-1] The index to search from.
         * @returns {*} Returns the matched element, else `undefined`.
         * @example
         *
         * _.findLast([1, 2, 3, 4], function(n) {
         *   return n % 2 == 1;
         * });
         * // => 3
         */
        var findLast = createFind(findLastIndex);

        /**
         * Creates a flattened array of values by running each element in `collection`
         * thru `iteratee` and flattening the mapped results. The iteratee is invoked
         * with three arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [n, n];
         * }
         *
         * _.flatMap([1, 2], duplicate);
         * // => [1, 1, 2, 2]
         */
        function flatMap(collection, iteratee) {
          return baseFlatten(map(collection, iteratee), 1);
        }

        /**
         * This method is like `_.flatMap` except that it recursively flattens the
         * mapped results.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [[[n, n]]];
         * }
         *
         * _.flatMapDeep([1, 2], duplicate);
         * // => [1, 1, 2, 2]
         */
        function flatMapDeep(collection, iteratee) {
          return baseFlatten(map(collection, iteratee), INFINITY);
        }

        /**
         * This method is like `_.flatMap` except that it recursively flattens the
         * mapped results up to `depth` times.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {number} [depth=1] The maximum recursion depth.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [[[n, n]]];
         * }
         *
         * _.flatMapDepth([1, 2], duplicate, 2);
         * // => [[1, 1], [2, 2]]
         */
        function flatMapDepth(collection, iteratee, depth) {
          depth = depth === undefined ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee), depth);
        }

        /**
         * Iterates over elements of `collection` and invokes `iteratee` for each element.
         * The iteratee is invoked with three arguments: (value, index|key, collection).
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * **Note:** As with other "Collections" methods, objects with a "length"
         * property are iterated like arrays. To avoid this behavior use `_.forIn`
         * or `_.forOwn` for object iteration.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @alias each
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         * @see _.forEachRight
         * @example
         *
         * _.forEach([1, 2], function(value) {
         *   console.log(value);
         * });
         * // => Logs `1` then `2`.
         *
         * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a' then 'b' (iteration order is not guaranteed).
         */
        function forEach(collection, iteratee) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee, 3));
        }

        /**
         * This method is like `_.forEach` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @alias eachRight
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         * @see _.forEach
         * @example
         *
         * _.forEachRight([1, 2], function(value) {
         *   console.log(value);
         * });
         * // => Logs `2` then `1`.
         */
        function forEachRight(collection, iteratee) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee, 3));
        }

        /**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The order of grouped values
         * is determined by the order they occur in `collection`. The corresponding
         * value of each key is an array of elements responsible for generating the
         * key. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * _.groupBy([6.1, 4.2, 6.3], Math.floor);
         * // => { '4': [4.2], '6': [6.1, 6.3] }
         *
         * // The `_.property` iteratee shorthand.
         * _.groupBy(['one', 'two', 'three'], 'length');
         * // => { '3': ['one', 'two'], '5': ['three'] }
         */
        var groupBy = createAggregator(function (result, value, key) {
          if (hasOwnProperty.call(result, key)) {
            result[key].push(value);
          } else {
            baseAssignValue(result, key, [value]);
          }
        });

        /**
         * Checks if `value` is in `collection`. If `collection` is a string, it's
         * checked for a substring of `value`, otherwise
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * is used for equality comparisons. If `fromIndex` is negative, it's used as
         * the offset from the end of `collection`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object|string} collection The collection to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=0] The index to search from.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
         * @returns {boolean} Returns `true` if `value` is found, else `false`.
         * @example
         *
         * _.includes([1, 2, 3], 1);
         * // => true
         *
         * _.includes([1, 2, 3], 1, 2);
         * // => false
         *
         * _.includes({ 'a': 1, 'b': 2 }, 1);
         * // => true
         *
         * _.includes('abcd', 'bc');
         * // => true
         */
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }

        /**
         * Invokes the method at `path` of each element in `collection`, returning
         * an array of the results of each invoked method. Any additional arguments
         * are provided to each invoked method. If `path` is a function, it's invoked
         * for, and `this` bound to, each element in `collection`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Array|Function|string} path The path of the method to invoke or
         *  the function invoked per iteration.
         * @param {...*} [args] The arguments to invoke each method with.
         * @returns {Array} Returns the array of results.
         * @example
         *
         * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
         * // => [[1, 5, 7], [1, 2, 3]]
         *
         * _.invokeMap([123, 456], String.prototype.split, '');
         * // => [['1', '2', '3'], ['4', '5', '6']]
         */
        var invokeMap = baseRest(function (collection, path, args) {
          var index = -1,
            isFunc = typeof path == 'function',
            result = isArrayLike(collection) ? Array(collection.length) : [];
          baseEach(collection, function (value) {
            result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result;
        });

        /**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The corresponding value of
         * each key is the last element responsible for generating the key. The
         * iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * var array = [
         *   { 'dir': 'left', 'code': 97 },
         *   { 'dir': 'right', 'code': 100 }
         * ];
         *
         * _.keyBy(array, function(o) {
         *   return String.fromCharCode(o.code);
         * });
         * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
         *
         * _.keyBy(array, 'dir');
         * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
         */
        var keyBy = createAggregator(function (result, value, key) {
          baseAssignValue(result, key, value);
        });

        /**
         * Creates an array of values by running each element in `collection` thru
         * `iteratee`. The iteratee is invoked with three arguments:
         * (value, index|key, collection).
         *
         * Many lodash methods are guarded to work as iteratees for methods like
         * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
         *
         * The guarded methods are:
         * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
         * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
         * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
         * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new mapped array.
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * _.map([4, 8], square);
         * // => [16, 64]
         *
         * _.map({ 'a': 4, 'b': 8 }, square);
         * // => [16, 64] (iteration order is not guaranteed)
         *
         * var users = [
         *   { 'user': 'barney' },
         *   { 'user': 'fred' }
         * ];
         *
         * // The `_.property` iteratee shorthand.
         * _.map(users, 'user');
         * // => ['barney', 'fred']
         */
        function map(collection, iteratee) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee, 3));
        }

        /**
         * This method is like `_.sortBy` except that it allows specifying the sort
         * orders of the iteratees to sort by. If `orders` is unspecified, all values
         * are sorted in ascending order. Otherwise, specify an order of "desc" for
         * descending or "asc" for ascending sort order of corresponding values.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
         *  The iteratees to sort by.
         * @param {string[]} [orders] The sort orders of `iteratees`.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
         * @returns {Array} Returns the new sorted array.
         * @example
         *
         * var users = [
         *   { 'user': 'fred',   'age': 48 },
         *   { 'user': 'barney', 'age': 34 },
         *   { 'user': 'fred',   'age': 40 },
         *   { 'user': 'barney', 'age': 36 }
         * ];
         *
         * // Sort by `user` in ascending order and by `age` in descending order.
         * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
         * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
         */
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }

        /**
         * Creates an array of elements split into two groups, the first of which
         * contains elements `predicate` returns truthy for, the second of which
         * contains elements `predicate` returns falsey for. The predicate is
         * invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the array of grouped elements.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'age': 36, 'active': false },
         *   { 'user': 'fred',    'age': 40, 'active': true },
         *   { 'user': 'pebbles', 'age': 1,  'active': false }
         * ];
         *
         * _.partition(users, function(o) { return o.active; });
         * // => objects for [['fred'], ['barney', 'pebbles']]
         *
         * // The `_.matches` iteratee shorthand.
         * _.partition(users, { 'age': 1, 'active': false });
         * // => objects for [['pebbles'], ['barney', 'fred']]
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.partition(users, ['active', false]);
         * // => objects for [['barney', 'pebbles'], ['fred']]
         *
         * // The `_.property` iteratee shorthand.
         * _.partition(users, 'active');
         * // => objects for [['fred'], ['barney', 'pebbles']]
         */
        var partition = createAggregator(function (result, value, key) {
          result[key ? 0 : 1].push(value);
        }, function () {
          return [[], []];
        });

        /**
         * Reduces `collection` to a value which is the accumulated result of running
         * each element in `collection` thru `iteratee`, where each successive
         * invocation is supplied the return value of the previous. If `accumulator`
         * is not given, the first element of `collection` is used as the initial
         * value. The iteratee is invoked with four arguments:
         * (accumulator, value, index|key, collection).
         *
         * Many lodash methods are guarded to work as iteratees for methods like
         * `_.reduce`, `_.reduceRight`, and `_.transform`.
         *
         * The guarded methods are:
         * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
         * and `sortBy`
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {*} [accumulator] The initial value.
         * @returns {*} Returns the accumulated value.
         * @see _.reduceRight
         * @example
         *
         * _.reduce([1, 2], function(sum, n) {
         *   return sum + n;
         * }, 0);
         * // => 3
         *
         * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
         *   (result[value] || (result[value] = [])).push(key);
         *   return result;
         * }, {});
         * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
         */
        function reduce(collection, iteratee, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce,
            initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }

        /**
         * This method is like `_.reduce` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {*} [accumulator] The initial value.
         * @returns {*} Returns the accumulated value.
         * @see _.reduce
         * @example
         *
         * var array = [[0, 1], [2, 3], [4, 5]];
         *
         * _.reduceRight(array, function(flattened, other) {
         *   return flattened.concat(other);
         * }, []);
         * // => [4, 5, 2, 3, 0, 1]
         */
        function reduceRight(collection, iteratee, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce,
            initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }

        /**
         * The opposite of `_.filter`; this method returns the elements of `collection`
         * that `predicate` does **not** return truthy for.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         * @see _.filter
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': false },
         *   { 'user': 'fred',   'age': 40, 'active': true }
         * ];
         *
         * _.reject(users, function(o) { return !o.active; });
         * // => objects for ['fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.reject(users, { 'age': 40, 'active': true });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.reject(users, ['active', false]);
         * // => objects for ['fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.reject(users, 'active');
         * // => objects for ['barney']
         */
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }

        /**
         * Gets a random element from `collection`.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to sample.
         * @returns {*} Returns the random element.
         * @example
         *
         * _.sample([1, 2, 3, 4]);
         * // => 2
         */
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }

        /**
         * Gets `n` random elements at unique keys from `collection` up to the
         * size of `collection`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to sample.
         * @param {number} [n=1] The number of elements to sample.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the random elements.
         * @example
         *
         * _.sampleSize([1, 2, 3], 2);
         * // => [3, 1]
         *
         * _.sampleSize([1, 2, 3], 4);
         * // => [2, 3, 1]
         */
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }

        /**
         * Creates an array of shuffled values, using a version of the
         * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to shuffle.
         * @returns {Array} Returns the new shuffled array.
         * @example
         *
         * _.shuffle([1, 2, 3, 4]);
         * // => [4, 1, 3, 2]
         */
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }

        /**
         * Gets the size of `collection` by returning its length for array-like
         * values or the number of own enumerable string keyed properties for objects.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object|string} collection The collection to inspect.
         * @returns {number} Returns the collection size.
         * @example
         *
         * _.size([1, 2, 3]);
         * // => 3
         *
         * _.size({ 'a': 1, 'b': 2 });
         * // => 2
         *
         * _.size('pebbles');
         * // => 7
         */
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }

        /**
         * Checks if `predicate` returns truthy for **any** element of `collection`.
         * Iteration is stopped once `predicate` returns truthy. The predicate is
         * invoked with three arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {boolean} Returns `true` if any element passes the predicate check,
         *  else `false`.
         * @example
         *
         * _.some([null, 0, 'yes', false], Boolean);
         * // => true
         *
         * var users = [
         *   { 'user': 'barney', 'active': true },
         *   { 'user': 'fred',   'active': false }
         * ];
         *
         * // The `_.matches` iteratee shorthand.
         * _.some(users, { 'user': 'barney', 'active': false });
         * // => false
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.some(users, ['active', false]);
         * // => true
         *
         * // The `_.property` iteratee shorthand.
         * _.some(users, 'active');
         * // => true
         */
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined;
          }
          return func(collection, getIteratee(predicate, 3));
        }

        /**
         * Creates an array of elements, sorted in ascending order by the results of
         * running each element in a collection thru each iteratee. This method
         * performs a stable sort, that is, it preserves the original sort order of
         * equal elements. The iteratees are invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {...(Function|Function[])} [iteratees=[_.identity]]
         *  The iteratees to sort by.
         * @returns {Array} Returns the new sorted array.
         * @example
         *
         * var users = [
         *   { 'user': 'fred',   'age': 48 },
         *   { 'user': 'barney', 'age': 36 },
         *   { 'user': 'fred',   'age': 30 },
         *   { 'user': 'barney', 'age': 34 }
         * ];
         *
         * _.sortBy(users, [function(o) { return o.user; }]);
         * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
         *
         * _.sortBy(users, ['user', 'age']);
         * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
         */
        var sortBy = baseRest(function (collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });

        /*------------------------------------------------------------------------*/

        /**
         * Gets the timestamp of the number of milliseconds that have elapsed since
         * the Unix epoch (1 January 1970 00:00:00 UTC).
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Date
         * @returns {number} Returns the timestamp.
         * @example
         *
         * _.defer(function(stamp) {
         *   console.log(_.now() - stamp);
         * }, _.now());
         * // => Logs the number of milliseconds it took for the deferred invocation.
         */
        var now = ctxNow || function () {
          return root.Date.now();
        };

        /*------------------------------------------------------------------------*/

        /**
         * The opposite of `_.before`; this method creates a function that invokes
         * `func` once it's called `n` or more times.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {number} n The number of calls before `func` is invoked.
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new restricted function.
         * @example
         *
         * var saves = ['profile', 'settings'];
         *
         * var done = _.after(saves.length, function() {
         *   console.log('done saving!');
         * });
         *
         * _.forEach(saves, function(type) {
         *   asyncSave({ 'type': type, 'complete': done });
         * });
         * // => Logs 'done saving!' after the two async saves have completed.
         */
        function after(n, func) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function () {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }

        /**
         * Creates a function that invokes `func`, with up to `n` arguments,
         * ignoring any additional arguments.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} func The function to cap arguments for.
         * @param {number} [n=func.length] The arity cap.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the new capped function.
         * @example
         *
         * _.map(['6', '8', '10'], _.ary(parseInt, 1));
         * // => [6, 8, 10]
         */
        function ary(func, n, guard) {
          n = guard ? undefined : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }

        /**
         * Creates a function that invokes `func`, with the `this` binding and arguments
         * of the created function, while it's called less than `n` times. Subsequent
         * calls to the created function return the result of the last `func` invocation.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {number} n The number of calls at which `func` is no longer invoked.
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new restricted function.
         * @example
         *
         * jQuery(element).on('click', _.before(5, addContactToList));
         * // => Allows adding up to 4 contacts to the list.
         */
        function before(n, func) {
          var result;
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function () {
            if (--n > 0) {
              result = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined;
            }
            return result;
          };
        }

        /**
         * Creates a function that invokes `func` with the `this` binding of `thisArg`
         * and `partials` prepended to the arguments it receives.
         *
         * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
         * may be used as a placeholder for partially applied arguments.
         *
         * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
         * property of bound functions.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to bind.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new bound function.
         * @example
         *
         * function greet(greeting, punctuation) {
         *   return greeting + ' ' + this.user + punctuation;
         * }
         *
         * var object = { 'user': 'fred' };
         *
         * var bound = _.bind(greet, object, 'hi');
         * bound('!');
         * // => 'hi fred!'
         *
         * // Bound with placeholders.
         * var bound = _.bind(greet, object, _, '!');
         * bound('hi');
         * // => 'hi fred!'
         */
        var bind = baseRest(function (func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });

        /**
         * Creates a function that invokes the method at `object[key]` with `partials`
         * prepended to the arguments it receives.
         *
         * This method differs from `_.bind` by allowing bound functions to reference
         * methods that may be redefined or don't yet exist. See
         * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
         * for more details.
         *
         * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for partially applied arguments.
         *
         * @static
         * @memberOf _
         * @since 0.10.0
         * @category Function
         * @param {Object} object The object to invoke the method on.
         * @param {string} key The key of the method.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new bound function.
         * @example
         *
         * var object = {
         *   'user': 'fred',
         *   'greet': function(greeting, punctuation) {
         *     return greeting + ' ' + this.user + punctuation;
         *   }
         * };
         *
         * var bound = _.bindKey(object, 'greet', 'hi');
         * bound('!');
         * // => 'hi fred!'
         *
         * object.greet = function(greeting, punctuation) {
         *   return greeting + 'ya ' + this.user + punctuation;
         * };
         *
         * bound('!');
         * // => 'hiya fred!'
         *
         * // Bound with placeholders.
         * var bound = _.bindKey(object, 'greet', _, '!');
         * bound('hi');
         * // => 'hiya fred!'
         */
        var bindKey = baseRest(function (object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });

        /**
         * Creates a function that accepts arguments of `func` and either invokes
         * `func` returning its result, if at least `arity` number of arguments have
         * been provided, or returns a function that accepts the remaining `func`
         * arguments, and so on. The arity of `func` may be specified if `func.length`
         * is not sufficient.
         *
         * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
         * may be used as a placeholder for provided arguments.
         *
         * **Note:** This method doesn't set the "length" property of curried functions.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Function
         * @param {Function} func The function to curry.
         * @param {number} [arity=func.length] The arity of `func`.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the new curried function.
         * @example
         *
         * var abc = function(a, b, c) {
         *   return [a, b, c];
         * };
         *
         * var curried = _.curry(abc);
         *
         * curried(1)(2)(3);
         * // => [1, 2, 3]
         *
         * curried(1, 2)(3);
         * // => [1, 2, 3]
         *
         * curried(1, 2, 3);
         * // => [1, 2, 3]
         *
         * // Curried with placeholders.
         * curried(1)(_, 3)(2);
         * // => [1, 2, 3]
         */
        function curry(func, arity, guard) {
          arity = guard ? undefined : arity;
          var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
          result.placeholder = curry.placeholder;
          return result;
        }

        /**
         * This method is like `_.curry` except that arguments are applied to `func`
         * in the manner of `_.partialRight` instead of `_.partial`.
         *
         * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for provided arguments.
         *
         * **Note:** This method doesn't set the "length" property of curried functions.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} func The function to curry.
         * @param {number} [arity=func.length] The arity of `func`.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the new curried function.
         * @example
         *
         * var abc = function(a, b, c) {
         *   return [a, b, c];
         * };
         *
         * var curried = _.curryRight(abc);
         *
         * curried(3)(2)(1);
         * // => [1, 2, 3]
         *
         * curried(2, 3)(1);
         * // => [1, 2, 3]
         *
         * curried(1, 2, 3);
         * // => [1, 2, 3]
         *
         * // Curried with placeholders.
         * curried(3)(1, _)(2);
         * // => [1, 2, 3]
         */
        function curryRight(func, arity, guard) {
          arity = guard ? undefined : arity;
          var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
          result.placeholder = curryRight.placeholder;
          return result;
        }

        /**
         * Creates a debounced function that delays invoking `func` until after `wait`
         * milliseconds have elapsed since the last time the debounced function was
         * invoked. The debounced function comes with a `cancel` method to cancel
         * delayed `func` invocations and a `flush` method to immediately invoke them.
         * Provide `options` to indicate whether `func` should be invoked on the
         * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
         * with the last arguments provided to the debounced function. Subsequent
         * calls to the debounced function return the result of the last `func`
         * invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the debounced function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.debounce` and `_.throttle`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to debounce.
         * @param {number} [wait=0] The number of milliseconds to delay.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=false]
         *  Specify invoking on the leading edge of the timeout.
         * @param {number} [options.maxWait]
         *  The maximum time `func` is allowed to be delayed before it's invoked.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new debounced function.
         * @example
         *
         * // Avoid costly calculations while the window size is in flux.
         * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
         *
         * // Invoke `sendMail` when clicked, debouncing subsequent calls.
         * jQuery(element).on('click', _.debounce(sendMail, 300, {
         *   'leading': true,
         *   'trailing': false
         * }));
         *
         * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
         * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
         * var source = new EventSource('/stream');
         * jQuery(source).on('message', debounced);
         *
         * // Cancel the trailing debounced invocation.
         * jQuery(window).on('popstate', debounced.cancel);
         */
        function debounce(func, wait, options) {
          var lastArgs,
            lastThis,
            maxWait,
            result,
            timerId,
            lastCallTime,
            lastInvokeTime = 0,
            leading = false,
            maxing = false,
            trailing = true;
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs,
              thisArg = lastThis;
            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
          }
          function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime,
              timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime;

            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined;

            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined;
            return result;
          }
          function cancel() {
            if (timerId !== undefined) {
              clearTimeout(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
          }
          function flush() {
            return timerId === undefined ? result : trailingEdge(now());
          }
          function debounced() {
            var time = now(),
              isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined) {
              timerId = setTimeout(timerExpired, wait);
            }
            return result;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }

        /**
         * Defers invoking the `func` until the current call stack has cleared. Any
         * additional arguments are provided to `func` when it's invoked.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to defer.
         * @param {...*} [args] The arguments to invoke `func` with.
         * @returns {number} Returns the timer id.
         * @example
         *
         * _.defer(function(text) {
         *   console.log(text);
         * }, 'deferred');
         * // => Logs 'deferred' after one millisecond.
         */
        var defer = baseRest(function (func, args) {
          return baseDelay(func, 1, args);
        });

        /**
         * Invokes `func` after `wait` milliseconds. Any additional arguments are
         * provided to `func` when it's invoked.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to delay.
         * @param {number} wait The number of milliseconds to delay invocation.
         * @param {...*} [args] The arguments to invoke `func` with.
         * @returns {number} Returns the timer id.
         * @example
         *
         * _.delay(function(text) {
         *   console.log(text);
         * }, 1000, 'later');
         * // => Logs 'later' after one second.
         */
        var delay = baseRest(function (func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });

        /**
         * Creates a function that invokes `func` with arguments reversed.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Function
         * @param {Function} func The function to flip arguments for.
         * @returns {Function} Returns the new flipped function.
         * @example
         *
         * var flipped = _.flip(function() {
         *   return _.toArray(arguments);
         * });
         *
         * flipped('a', 'b', 'c', 'd');
         * // => ['d', 'c', 'b', 'a']
         */
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }

        /**
         * Creates a function that memoizes the result of `func`. If `resolver` is
         * provided, it determines the cache key for storing the result based on the
         * arguments provided to the memoized function. By default, the first argument
         * provided to the memoized function is used as the map cache key. The `func`
         * is invoked with the `this` binding of the memoized function.
         *
         * **Note:** The cache is exposed as the `cache` property on the memoized
         * function. Its creation may be customized by replacing the `_.memoize.Cache`
         * constructor with one whose instances implement the
         * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
         * method interface of `clear`, `delete`, `get`, `has`, and `set`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to have its output memoized.
         * @param {Function} [resolver] The function to resolve the cache key.
         * @returns {Function} Returns the new memoized function.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         * var other = { 'c': 3, 'd': 4 };
         *
         * var values = _.memoize(_.values);
         * values(object);
         * // => [1, 2]
         *
         * values(other);
         * // => [3, 4]
         *
         * object.a = 2;
         * values(object);
         * // => [1, 2]
         *
         * // Modify the result cache.
         * values.cache.set(object, ['a', 'b']);
         * values(object);
         * // => ['a', 'b']
         *
         * // Replace `_.memoize.Cache`.
         * _.memoize.Cache = WeakMap;
         */
        function memoize(func, resolver) {
          if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          var memoized = function () {
            var args = arguments,
              key = resolver ? resolver.apply(this, args) : args[0],
              cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result) || cache;
            return result;
          };
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }

        // Expose `MapCache`.
        memoize.Cache = MapCache;

        /**
         * Creates a function that negates the result of the predicate `func`. The
         * `func` predicate is invoked with the `this` binding and arguments of the
         * created function.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} predicate The predicate to negate.
         * @returns {Function} Returns the new negated function.
         * @example
         *
         * function isEven(n) {
         *   return n % 2 == 0;
         * }
         *
         * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
         * // => [1, 3, 5]
         */
        function negate(predicate) {
          if (typeof predicate != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          return function () {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }

        /**
         * Creates a function that is restricted to invoking `func` once. Repeat calls
         * to the function return the value of the first invocation. The `func` is
         * invoked with the `this` binding and arguments of the created function.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new restricted function.
         * @example
         *
         * var initialize = _.once(createApplication);
         * initialize();
         * initialize();
         * // => `createApplication` is invoked once
         */
        function once(func) {
          return before(2, func);
        }

        /**
         * Creates a function that invokes `func` with its arguments transformed.
         *
         * @static
         * @since 4.0.0
         * @memberOf _
         * @category Function
         * @param {Function} func The function to wrap.
         * @param {...(Function|Function[])} [transforms=[_.identity]]
         *  The argument transforms.
         * @returns {Function} Returns the new function.
         * @example
         *
         * function doubled(n) {
         *   return n * 2;
         * }
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var func = _.overArgs(function(x, y) {
         *   return [x, y];
         * }, [square, doubled]);
         *
         * func(9, 3);
         * // => [81, 6]
         *
         * func(10, 5);
         * // => [100, 10]
         */
        var overArgs = castRest(function (func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function (args) {
            var index = -1,
              length = nativeMin(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });

        /**
         * Creates a function that invokes `func` with `partials` prepended to the
         * arguments it receives. This method is like `_.bind` except it does **not**
         * alter the `this` binding.
         *
         * The `_.partial.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for partially applied arguments.
         *
         * **Note:** This method doesn't set the "length" property of partially
         * applied functions.
         *
         * @static
         * @memberOf _
         * @since 0.2.0
         * @category Function
         * @param {Function} func The function to partially apply arguments to.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new partially applied function.
         * @example
         *
         * function greet(greeting, name) {
         *   return greeting + ' ' + name;
         * }
         *
         * var sayHelloTo = _.partial(greet, 'hello');
         * sayHelloTo('fred');
         * // => 'hello fred'
         *
         * // Partially applied with placeholders.
         * var greetFred = _.partial(greet, _, 'fred');
         * greetFred('hi');
         * // => 'hi fred'
         */
        var partial = baseRest(function (func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });

        /**
         * This method is like `_.partial` except that partially applied arguments
         * are appended to the arguments it receives.
         *
         * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for partially applied arguments.
         *
         * **Note:** This method doesn't set the "length" property of partially
         * applied functions.
         *
         * @static
         * @memberOf _
         * @since 1.0.0
         * @category Function
         * @param {Function} func The function to partially apply arguments to.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new partially applied function.
         * @example
         *
         * function greet(greeting, name) {
         *   return greeting + ' ' + name;
         * }
         *
         * var greetFred = _.partialRight(greet, 'fred');
         * greetFred('hi');
         * // => 'hi fred'
         *
         * // Partially applied with placeholders.
         * var sayHelloTo = _.partialRight(greet, 'hello', _);
         * sayHelloTo('fred');
         * // => 'hello fred'
         */
        var partialRight = baseRest(function (func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });

        /**
         * Creates a function that invokes `func` with arguments arranged according
         * to the specified `indexes` where the argument value at the first index is
         * provided as the first argument, the argument value at the second index is
         * provided as the second argument, and so on.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} func The function to rearrange arguments for.
         * @param {...(number|number[])} indexes The arranged argument indexes.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var rearged = _.rearg(function(a, b, c) {
         *   return [a, b, c];
         * }, [2, 0, 1]);
         *
         * rearged('b', 'c', 'a')
         * // => ['a', 'b', 'c']
         */
        var rearg = flatRest(function (func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });

        /**
         * Creates a function that invokes `func` with the `this` binding of the
         * created function and arguments from `start` and beyond provided as
         * an array.
         *
         * **Note:** This method is based on the
         * [rest parameter](https://mdn.io/rest_parameters).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Function
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var say = _.rest(function(what, names) {
         *   return what + ' ' + _.initial(names).join(', ') +
         *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
         * });
         *
         * say('hello', 'fred', 'barney', 'pebbles');
         * // => 'hello fred, barney, & pebbles'
         */
        function rest(func, start) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          start = start === undefined ? start : toInteger(start);
          return baseRest(func, start);
        }

        /**
         * Creates a function that invokes `func` with the `this` binding of the
         * create function and an array of arguments much like
         * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
         *
         * **Note:** This method is based on the
         * [spread operator](https://mdn.io/spread_operator).
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Function
         * @param {Function} func The function to spread arguments over.
         * @param {number} [start=0] The start position of the spread.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var say = _.spread(function(who, what) {
         *   return who + ' says ' + what;
         * });
         *
         * say(['fred', 'hello']);
         * // => 'fred says hello'
         *
         * var numbers = Promise.all([
         *   Promise.resolve(40),
         *   Promise.resolve(36)
         * ]);
         *
         * numbers.then(_.spread(function(x, y) {
         *   return x + y;
         * }));
         * // => a Promise of 76
         */
        function spread(func, start) {
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function (args) {
            var array = args[start],
              otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }

        /**
         * Creates a throttled function that only invokes `func` at most once per
         * every `wait` milliseconds. The throttled function comes with a `cancel`
         * method to cancel delayed `func` invocations and a `flush` method to
         * immediately invoke them. Provide `options` to indicate whether `func`
         * should be invoked on the leading and/or trailing edge of the `wait`
         * timeout. The `func` is invoked with the last arguments provided to the
         * throttled function. Subsequent calls to the throttled function return the
         * result of the last `func` invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the throttled function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.throttle` and `_.debounce`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to throttle.
         * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=true]
         *  Specify invoking on the leading edge of the timeout.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new throttled function.
         * @example
         *
         * // Avoid excessively updating the position while scrolling.
         * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
         *
         * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
         * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
         * jQuery(element).on('click', throttled);
         *
         * // Cancel the trailing throttled invocation.
         * jQuery(window).on('popstate', throttled.cancel);
         */
        function throttle(func, wait, options) {
          var leading = true,
            trailing = true;
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (isObject(options)) {
            leading = 'leading' in options ? !!options.leading : leading;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            'leading': leading,
            'maxWait': wait,
            'trailing': trailing
          });
        }

        /**
         * Creates a function that accepts up to one argument, ignoring any
         * additional arguments.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Function
         * @param {Function} func The function to cap arguments for.
         * @returns {Function} Returns the new capped function.
         * @example
         *
         * _.map(['6', '8', '10'], _.unary(parseInt));
         * // => [6, 8, 10]
         */
        function unary(func) {
          return ary(func, 1);
        }

        /**
         * Creates a function that provides `value` to `wrapper` as its first
         * argument. Any additional arguments provided to the function are appended
         * to those provided to the `wrapper`. The wrapper is invoked with the `this`
         * binding of the created function.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {*} value The value to wrap.
         * @param {Function} [wrapper=identity] The wrapper function.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var p = _.wrap(_.escape, function(func, text) {
         *   return '<p>' + func(text) + '</p>';
         * });
         *
         * p('fred, barney, & pebbles');
         * // => '<p>fred, barney, &amp; pebbles</p>'
         */
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }

        /*------------------------------------------------------------------------*/

        /**
         * Casts `value` as an array if it's not one.
         *
         * @static
         * @memberOf _
         * @since 4.4.0
         * @category Lang
         * @param {*} value The value to inspect.
         * @returns {Array} Returns the cast array.
         * @example
         *
         * _.castArray(1);
         * // => [1]
         *
         * _.castArray({ 'a': 1 });
         * // => [{ 'a': 1 }]
         *
         * _.castArray('abc');
         * // => ['abc']
         *
         * _.castArray(null);
         * // => [null]
         *
         * _.castArray(undefined);
         * // => [undefined]
         *
         * _.castArray();
         * // => []
         *
         * var array = [1, 2, 3];
         * console.log(_.castArray(array) === array);
         * // => true
         */
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }

        /**
         * Creates a shallow clone of `value`.
         *
         * **Note:** This method is loosely based on the
         * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
         * and supports cloning arrays, array buffers, booleans, date objects, maps,
         * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
         * arrays. The own enumerable properties of `arguments` objects are cloned
         * as plain objects. An empty object is returned for uncloneable values such
         * as error objects, functions, DOM nodes, and WeakMaps.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to clone.
         * @returns {*} Returns the cloned value.
         * @see _.cloneDeep
         * @example
         *
         * var objects = [{ 'a': 1 }, { 'b': 2 }];
         *
         * var shallow = _.clone(objects);
         * console.log(shallow[0] === objects[0]);
         * // => true
         */
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }

        /**
         * This method is like `_.clone` except that it accepts `customizer` which
         * is invoked to produce the cloned value. If `customizer` returns `undefined`,
         * cloning is handled by the method instead. The `customizer` is invoked with
         * up to four arguments; (value [, index|key, object, stack]).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to clone.
         * @param {Function} [customizer] The function to customize cloning.
         * @returns {*} Returns the cloned value.
         * @see _.cloneDeepWith
         * @example
         *
         * function customizer(value) {
         *   if (_.isElement(value)) {
         *     return value.cloneNode(false);
         *   }
         * }
         *
         * var el = _.cloneWith(document.body, customizer);
         *
         * console.log(el === document.body);
         * // => false
         * console.log(el.nodeName);
         * // => 'BODY'
         * console.log(el.childNodes.length);
         * // => 0
         */
        function cloneWith(value, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }

        /**
         * This method is like `_.clone` except that it recursively clones `value`.
         *
         * @static
         * @memberOf _
         * @since 1.0.0
         * @category Lang
         * @param {*} value The value to recursively clone.
         * @returns {*} Returns the deep cloned value.
         * @see _.clone
         * @example
         *
         * var objects = [{ 'a': 1 }, { 'b': 2 }];
         *
         * var deep = _.cloneDeep(objects);
         * console.log(deep[0] === objects[0]);
         * // => false
         */
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }

        /**
         * This method is like `_.cloneWith` except that it recursively clones `value`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to recursively clone.
         * @param {Function} [customizer] The function to customize cloning.
         * @returns {*} Returns the deep cloned value.
         * @see _.cloneWith
         * @example
         *
         * function customizer(value) {
         *   if (_.isElement(value)) {
         *     return value.cloneNode(true);
         *   }
         * }
         *
         * var el = _.cloneDeepWith(document.body, customizer);
         *
         * console.log(el === document.body);
         * // => false
         * console.log(el.nodeName);
         * // => 'BODY'
         * console.log(el.childNodes.length);
         * // => 20
         */
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }

        /**
         * Checks if `object` conforms to `source` by invoking the predicate
         * properties of `source` with the corresponding property values of `object`.
         *
         * **Note:** This method is equivalent to `_.conforms` when `source` is
         * partially applied.
         *
         * @static
         * @memberOf _
         * @since 4.14.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property predicates to conform to.
         * @returns {boolean} Returns `true` if `object` conforms, else `false`.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         *
         * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
         * // => true
         *
         * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
         * // => false
         */
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }

        /**
         * Performs a
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * comparison between two values to determine if they are equivalent.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.eq(object, object);
         * // => true
         *
         * _.eq(object, other);
         * // => false
         *
         * _.eq('a', 'a');
         * // => true
         *
         * _.eq('a', Object('a'));
         * // => false
         *
         * _.eq(NaN, NaN);
         * // => true
         */
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }

        /**
         * Checks if `value` is greater than `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than `other`,
         *  else `false`.
         * @see _.lt
         * @example
         *
         * _.gt(3, 1);
         * // => true
         *
         * _.gt(3, 3);
         * // => false
         *
         * _.gt(1, 3);
         * // => false
         */
        var gt = createRelationalOperation(baseGt);

        /**
         * Checks if `value` is greater than or equal to `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than or equal to
         *  `other`, else `false`.
         * @see _.lte
         * @example
         *
         * _.gte(3, 1);
         * // => true
         *
         * _.gte(3, 3);
         * // => true
         *
         * _.gte(1, 3);
         * // => false
         */
        var gte = createRelationalOperation(function (value, other) {
          return value >= other;
        });

        /**
         * Checks if `value` is likely an `arguments` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         *  else `false`.
         * @example
         *
         * _.isArguments(function() { return arguments; }());
         * // => true
         *
         * _.isArguments([1, 2, 3]);
         * // => false
         */
        var isArguments = baseIsArguments(function () {
          return arguments;
        }()) ? baseIsArguments : function (value) {
          return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };

        /**
         * Checks if `value` is classified as an `Array` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array, else `false`.
         * @example
         *
         * _.isArray([1, 2, 3]);
         * // => true
         *
         * _.isArray(document.body.children);
         * // => false
         *
         * _.isArray('abc');
         * // => false
         *
         * _.isArray(_.noop);
         * // => false
         */
        var isArray = Array.isArray;

        /**
         * Checks if `value` is classified as an `ArrayBuffer` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
         * @example
         *
         * _.isArrayBuffer(new ArrayBuffer(2));
         * // => true
         *
         * _.isArrayBuffer(new Array(2));
         * // => false
         */
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

        /**
         * Checks if `value` is array-like. A value is considered array-like if it's
         * not a function and has a `value.length` that's an integer greater than or
         * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
         * @example
         *
         * _.isArrayLike([1, 2, 3]);
         * // => true
         *
         * _.isArrayLike(document.body.children);
         * // => true
         *
         * _.isArrayLike('abc');
         * // => true
         *
         * _.isArrayLike(_.noop);
         * // => false
         */
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }

        /**
         * This method is like `_.isArrayLike` except that it also checks if `value`
         * is an object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array-like object,
         *  else `false`.
         * @example
         *
         * _.isArrayLikeObject([1, 2, 3]);
         * // => true
         *
         * _.isArrayLikeObject(document.body.children);
         * // => true
         *
         * _.isArrayLikeObject('abc');
         * // => false
         *
         * _.isArrayLikeObject(_.noop);
         * // => false
         */
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }

        /**
         * Checks if `value` is classified as a boolean primitive or object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
         * @example
         *
         * _.isBoolean(false);
         * // => true
         *
         * _.isBoolean(null);
         * // => false
         */
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }

        /**
         * Checks if `value` is a buffer.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
         * @example
         *
         * _.isBuffer(new Buffer(2));
         * // => true
         *
         * _.isBuffer(new Uint8Array(2));
         * // => false
         */
        var isBuffer = nativeIsBuffer || stubFalse;

        /**
         * Checks if `value` is classified as a `Date` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
         * @example
         *
         * _.isDate(new Date);
         * // => true
         *
         * _.isDate('Mon April 23 2012');
         * // => false
         */
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

        /**
         * Checks if `value` is likely a DOM element.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
         * @example
         *
         * _.isElement(document.body);
         * // => true
         *
         * _.isElement('<body>');
         * // => false
         */
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }

        /**
         * Checks if `value` is an empty object, collection, map, or set.
         *
         * Objects are considered empty if they have no own enumerable string keyed
         * properties.
         *
         * Array-like values such as `arguments` objects, arrays, buffers, strings, or
         * jQuery-like collections are considered empty if they have a `length` of `0`.
         * Similarly, maps and sets are considered empty if they have a `size` of `0`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is empty, else `false`.
         * @example
         *
         * _.isEmpty(null);
         * // => true
         *
         * _.isEmpty(true);
         * // => true
         *
         * _.isEmpty(1);
         * // => true
         *
         * _.isEmpty([1, 2, 3]);
         * // => false
         *
         * _.isEmpty({ 'a': 1 });
         * // => false
         */
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }

        /**
         * Performs a deep comparison between two values to determine if they are
         * equivalent.
         *
         * **Note:** This method supports comparing arrays, array buffers, booleans,
         * date objects, error objects, maps, numbers, `Object` objects, regexes,
         * sets, strings, symbols, and typed arrays. `Object` objects are compared
         * by their own, not inherited, enumerable properties. Functions and DOM
         * nodes are compared by strict equality, i.e. `===`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.isEqual(object, other);
         * // => true
         *
         * object === other;
         * // => false
         */
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }

        /**
         * This method is like `_.isEqual` except that it accepts `customizer` which
         * is invoked to compare values. If `customizer` returns `undefined`, comparisons
         * are handled by the method instead. The `customizer` is invoked with up to
         * six arguments: (objValue, othValue [, index|key, object, other, stack]).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * function isGreeting(value) {
         *   return /^h(?:i|ello)$/.test(value);
         * }
         *
         * function customizer(objValue, othValue) {
         *   if (isGreeting(objValue) && isGreeting(othValue)) {
         *     return true;
         *   }
         * }
         *
         * var array = ['hello', 'goodbye'];
         * var other = ['hi', 'goodbye'];
         *
         * _.isEqualWith(array, other, customizer);
         * // => true
         */
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined;
          var result = customizer ? customizer(value, other) : undefined;
          return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }

        /**
         * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
         * `SyntaxError`, `TypeError`, or `URIError` object.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
         * @example
         *
         * _.isError(new Error);
         * // => true
         *
         * _.isError(Error);
         * // => false
         */
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }

        /**
         * Checks if `value` is a finite primitive number.
         *
         * **Note:** This method is based on
         * [`Number.isFinite`](https://mdn.io/Number/isFinite).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
         * @example
         *
         * _.isFinite(3);
         * // => true
         *
         * _.isFinite(Number.MIN_VALUE);
         * // => true
         *
         * _.isFinite(Infinity);
         * // => false
         *
         * _.isFinite('3');
         * // => false
         */
        function isFinite(value) {
          return typeof value == 'number' && nativeIsFinite(value);
        }

        /**
         * Checks if `value` is classified as a `Function` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a function, else `false`.
         * @example
         *
         * _.isFunction(_);
         * // => true
         *
         * _.isFunction(/abc/);
         * // => false
         */
        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          }
          // The use of `Object#toString` avoids issues with the `typeof` operator
          // in Safari 9 which returns 'object' for typed arrays and other constructors.
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }

        /**
         * Checks if `value` is an integer.
         *
         * **Note:** This method is based on
         * [`Number.isInteger`](https://mdn.io/Number/isInteger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
         * @example
         *
         * _.isInteger(3);
         * // => true
         *
         * _.isInteger(Number.MIN_VALUE);
         * // => false
         *
         * _.isInteger(Infinity);
         * // => false
         *
         * _.isInteger('3');
         * // => false
         */
        function isInteger(value) {
          return typeof value == 'number' && value == toInteger(value);
        }

        /**
         * Checks if `value` is a valid array-like length.
         *
         * **Note:** This method is loosely based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
         * @example
         *
         * _.isLength(3);
         * // => true
         *
         * _.isLength(Number.MIN_VALUE);
         * // => false
         *
         * _.isLength(Infinity);
         * // => false
         *
         * _.isLength('3');
         * // => false
         */
        function isLength(value) {
          return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }

        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == 'object' || type == 'function');
        }

        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */
        function isObjectLike(value) {
          return value != null && typeof value == 'object';
        }

        /**
         * Checks if `value` is classified as a `Map` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a map, else `false`.
         * @example
         *
         * _.isMap(new Map);
         * // => true
         *
         * _.isMap(new WeakMap);
         * // => false
         */
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

        /**
         * Performs a partial deep comparison between `object` and `source` to
         * determine if `object` contains equivalent property values.
         *
         * **Note:** This method is equivalent to `_.matches` when `source` is
         * partially applied.
         *
         * Partial comparisons will match empty array and empty object `source`
         * values against any array or object value, respectively. See `_.isEqual`
         * for a list of supported value comparisons.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         *
         * _.isMatch(object, { 'b': 2 });
         * // => true
         *
         * _.isMatch(object, { 'b': 1 });
         * // => false
         */
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }

        /**
         * This method is like `_.isMatch` except that it accepts `customizer` which
         * is invoked to compare values. If `customizer` returns `undefined`, comparisons
         * are handled by the method instead. The `customizer` is invoked with five
         * arguments: (objValue, srcValue, index|key, object, source).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         * @example
         *
         * function isGreeting(value) {
         *   return /^h(?:i|ello)$/.test(value);
         * }
         *
         * function customizer(objValue, srcValue) {
         *   if (isGreeting(objValue) && isGreeting(srcValue)) {
         *     return true;
         *   }
         * }
         *
         * var object = { 'greeting': 'hello' };
         * var source = { 'greeting': 'hi' };
         *
         * _.isMatchWith(object, source, customizer);
         * // => true
         */
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }

        /**
         * Checks if `value` is `NaN`.
         *
         * **Note:** This method is based on
         * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
         * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
         * `undefined` and other non-number values.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
         * @example
         *
         * _.isNaN(NaN);
         * // => true
         *
         * _.isNaN(new Number(NaN));
         * // => true
         *
         * isNaN(undefined);
         * // => true
         *
         * _.isNaN(undefined);
         * // => false
         */
        function isNaN(value) {
          // An `NaN` primitive is the only value that is not equal to itself.
          // Perform the `toStringTag` check first to avoid errors with some
          // ActiveX objects in IE.
          return isNumber(value) && value != +value;
        }

        /**
         * Checks if `value` is a pristine native function.
         *
         * **Note:** This method can't reliably detect native functions in the presence
         * of the core-js package because core-js circumvents this kind of detection.
         * Despite multiple requests, the core-js maintainer has made it clear: any
         * attempt to fix the detection will be obstructed. As a result, we're left
         * with little choice but to throw an error. Unfortunately, this also affects
         * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
         * which rely on core-js.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a native function,
         *  else `false`.
         * @example
         *
         * _.isNative(Array.prototype.push);
         * // => true
         *
         * _.isNative(_);
         * // => false
         */
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }

        /**
         * Checks if `value` is `null`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
         * @example
         *
         * _.isNull(null);
         * // => true
         *
         * _.isNull(void 0);
         * // => false
         */
        function isNull(value) {
          return value === null;
        }

        /**
         * Checks if `value` is `null` or `undefined`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
         * @example
         *
         * _.isNil(null);
         * // => true
         *
         * _.isNil(void 0);
         * // => true
         *
         * _.isNil(NaN);
         * // => false
         */
        function isNil(value) {
          return value == null;
        }

        /**
         * Checks if `value` is classified as a `Number` primitive or object.
         *
         * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
         * classified as numbers, use the `_.isFinite` method.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a number, else `false`.
         * @example
         *
         * _.isNumber(3);
         * // => true
         *
         * _.isNumber(Number.MIN_VALUE);
         * // => true
         *
         * _.isNumber(Infinity);
         * // => true
         *
         * _.isNumber('3');
         * // => false
         */
        function isNumber(value) {
          return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }

        /**
         * Checks if `value` is a plain object, that is, an object created by the
         * `Object` constructor or one with a `[[Prototype]]` of `null`.
         *
         * @static
         * @memberOf _
         * @since 0.8.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * _.isPlainObject(new Foo);
         * // => false
         *
         * _.isPlainObject([1, 2, 3]);
         * // => false
         *
         * _.isPlainObject({ 'x': 0, 'y': 0 });
         * // => true
         *
         * _.isPlainObject(Object.create(null));
         * // => true
         */
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
          return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }

        /**
         * Checks if `value` is classified as a `RegExp` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
         * @example
         *
         * _.isRegExp(/abc/);
         * // => true
         *
         * _.isRegExp('/abc/');
         * // => false
         */
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

        /**
         * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
         * double precision number which isn't the result of a rounded unsafe integer.
         *
         * **Note:** This method is based on
         * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
         * @example
         *
         * _.isSafeInteger(3);
         * // => true
         *
         * _.isSafeInteger(Number.MIN_VALUE);
         * // => false
         *
         * _.isSafeInteger(Infinity);
         * // => false
         *
         * _.isSafeInteger('3');
         * // => false
         */
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }

        /**
         * Checks if `value` is classified as a `Set` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a set, else `false`.
         * @example
         *
         * _.isSet(new Set);
         * // => true
         *
         * _.isSet(new WeakSet);
         * // => false
         */
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

        /**
         * Checks if `value` is classified as a `String` primitive or object.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a string, else `false`.
         * @example
         *
         * _.isString('abc');
         * // => true
         *
         * _.isString(1);
         * // => false
         */
        function isString(value) {
          return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }

        /**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */
        function isSymbol(value) {
          return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }

        /**
         * Checks if `value` is classified as a typed array.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         * @example
         *
         * _.isTypedArray(new Uint8Array);
         * // => true
         *
         * _.isTypedArray([]);
         * // => false
         */
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

        /**
         * Checks if `value` is `undefined`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
         * @example
         *
         * _.isUndefined(void 0);
         * // => true
         *
         * _.isUndefined(null);
         * // => false
         */
        function isUndefined(value) {
          return value === undefined;
        }

        /**
         * Checks if `value` is classified as a `WeakMap` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
         * @example
         *
         * _.isWeakMap(new WeakMap);
         * // => true
         *
         * _.isWeakMap(new Map);
         * // => false
         */
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }

        /**
         * Checks if `value` is classified as a `WeakSet` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
         * @example
         *
         * _.isWeakSet(new WeakSet);
         * // => true
         *
         * _.isWeakSet(new Set);
         * // => false
         */
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }

        /**
         * Checks if `value` is less than `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than `other`,
         *  else `false`.
         * @see _.gt
         * @example
         *
         * _.lt(1, 3);
         * // => true
         *
         * _.lt(3, 3);
         * // => false
         *
         * _.lt(3, 1);
         * // => false
         */
        var lt = createRelationalOperation(baseLt);

        /**
         * Checks if `value` is less than or equal to `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than or equal to
         *  `other`, else `false`.
         * @see _.gte
         * @example
         *
         * _.lte(1, 3);
         * // => true
         *
         * _.lte(3, 3);
         * // => true
         *
         * _.lte(3, 1);
         * // => false
         */
        var lte = createRelationalOperation(function (value, other) {
          return value <= other;
        });

        /**
         * Converts `value` to an array.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {Array} Returns the converted array.
         * @example
         *
         * _.toArray({ 'a': 1, 'b': 2 });
         * // => [1, 2]
         *
         * _.toArray('abc');
         * // => ['a', 'b', 'c']
         *
         * _.toArray(1);
         * // => []
         *
         * _.toArray(null);
         * // => []
         */
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value),
            func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }

        /**
         * Converts `value` to a finite number.
         *
         * @static
         * @memberOf _
         * @since 4.12.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted number.
         * @example
         *
         * _.toFinite(3.2);
         * // => 3.2
         *
         * _.toFinite(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toFinite(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toFinite('3.2');
         * // => 3.2
         */
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }

        /**
         * Converts `value` to an integer.
         *
         * **Note:** This method is loosely based on
         * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toInteger(3.2);
         * // => 3
         *
         * _.toInteger(Number.MIN_VALUE);
         * // => 0
         *
         * _.toInteger(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toInteger('3.2');
         * // => 3
         */
        function toInteger(value) {
          var result = toFinite(value),
            remainder = result % 1;
          return result === result ? remainder ? result - remainder : result : 0;
        }

        /**
         * Converts `value` to an integer suitable for use as the length of an
         * array-like object.
         *
         * **Note:** This method is based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toLength(3.2);
         * // => 3
         *
         * _.toLength(Number.MIN_VALUE);
         * // => 0
         *
         * _.toLength(Infinity);
         * // => 4294967295
         *
         * _.toLength('3.2');
         * // => 3
         */
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }

        /**
         * Converts `value` to a number.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         * @example
         *
         * _.toNumber(3.2);
         * // => 3.2
         *
         * _.toNumber(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toNumber(Infinity);
         * // => Infinity
         *
         * _.toNumber('3.2');
         * // => 3.2
         */
        function toNumber(value) {
          if (typeof value == 'number') {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject(value)) {
            var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
            value = isObject(other) ? other + '' : other;
          }
          if (typeof value != 'string') {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }

        /**
         * Converts `value` to a plain object flattening inherited enumerable string
         * keyed properties of `value` to own properties of the plain object.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {Object} Returns the converted plain object.
         * @example
         *
         * function Foo() {
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.assign({ 'a': 1 }, new Foo);
         * // => { 'a': 1, 'b': 2 }
         *
         * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
         * // => { 'a': 1, 'b': 2, 'c': 3 }
         */
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }

        /**
         * Converts `value` to a safe integer. A safe integer can be compared and
         * represented correctly.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toSafeInteger(3.2);
         * // => 3
         *
         * _.toSafeInteger(Number.MIN_VALUE);
         * // => 0
         *
         * _.toSafeInteger(Infinity);
         * // => 9007199254740991
         *
         * _.toSafeInteger('3.2');
         * // => 3
         */
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }

        /**
         * Converts `value` to a string. An empty string is returned for `null`
         * and `undefined` values. The sign of `-0` is preserved.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.toString(null);
         * // => ''
         *
         * _.toString(-0);
         * // => '-0'
         *
         * _.toString([1, 2, 3]);
         * // => '1,2,3'
         */
        function toString(value) {
          return value == null ? '' : baseToString(value);
        }

        /*------------------------------------------------------------------------*/

        /**
         * Assigns own enumerable string keyed properties of source objects to the
         * destination object. Source objects are applied from left to right.
         * Subsequent sources overwrite property assignments of previous sources.
         *
         * **Note:** This method mutates `object` and is loosely based on
         * [`Object.assign`](https://mdn.io/Object/assign).
         *
         * @static
         * @memberOf _
         * @since 0.10.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.assignIn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * function Bar() {
         *   this.c = 3;
         * }
         *
         * Foo.prototype.b = 2;
         * Bar.prototype.d = 4;
         *
         * _.assign({ 'a': 0 }, new Foo, new Bar);
         * // => { 'a': 1, 'c': 3 }
         */
        var assign = createAssigner(function (object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });

        /**
         * This method is like `_.assign` except that it iterates over own and
         * inherited source properties.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias extend
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.assign
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * function Bar() {
         *   this.c = 3;
         * }
         *
         * Foo.prototype.b = 2;
         * Bar.prototype.d = 4;
         *
         * _.assignIn({ 'a': 0 }, new Foo, new Bar);
         * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
         */
        var assignIn = createAssigner(function (object, source) {
          copyObject(source, keysIn(source), object);
        });

        /**
         * This method is like `_.assignIn` except that it accepts `customizer`
         * which is invoked to produce the assigned values. If `customizer` returns
         * `undefined`, assignment is handled by the method instead. The `customizer`
         * is invoked with five arguments: (objValue, srcValue, key, object, source).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias extendWith
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} sources The source objects.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @see _.assignWith
         * @example
         *
         * function customizer(objValue, srcValue) {
         *   return _.isUndefined(objValue) ? srcValue : objValue;
         * }
         *
         * var defaults = _.partialRight(_.assignInWith, customizer);
         *
         * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */
        var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });

        /**
         * This method is like `_.assign` except that it accepts `customizer`
         * which is invoked to produce the assigned values. If `customizer` returns
         * `undefined`, assignment is handled by the method instead. The `customizer`
         * is invoked with five arguments: (objValue, srcValue, key, object, source).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} sources The source objects.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @see _.assignInWith
         * @example
         *
         * function customizer(objValue, srcValue) {
         *   return _.isUndefined(objValue) ? srcValue : objValue;
         * }
         *
         * var defaults = _.partialRight(_.assignWith, customizer);
         *
         * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */
        var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });

        /**
         * Creates an array of values corresponding to `paths` of `object`.
         *
         * @static
         * @memberOf _
         * @since 1.0.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {...(string|string[])} [paths] The property paths to pick.
         * @returns {Array} Returns the picked values.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
         *
         * _.at(object, ['a[0].b.c', 'a[1]']);
         * // => [3, 4]
         */
        var at = flatRest(baseAt);

        /**
         * Creates an object that inherits from the `prototype` object. If a
         * `properties` object is given, its own enumerable string keyed properties
         * are assigned to the created object.
         *
         * @static
         * @memberOf _
         * @since 2.3.0
         * @category Object
         * @param {Object} prototype The object to inherit from.
         * @param {Object} [properties] The properties to assign to the object.
         * @returns {Object} Returns the new object.
         * @example
         *
         * function Shape() {
         *   this.x = 0;
         *   this.y = 0;
         * }
         *
         * function Circle() {
         *   Shape.call(this);
         * }
         *
         * Circle.prototype = _.create(Shape.prototype, {
         *   'constructor': Circle
         * });
         *
         * var circle = new Circle;
         * circle instanceof Circle;
         * // => true
         *
         * circle instanceof Shape;
         * // => true
         */
        function create(prototype, properties) {
          var result = baseCreate(prototype);
          return properties == null ? result : baseAssign(result, properties);
        }

        /**
         * Assigns own and inherited enumerable string keyed properties of source
         * objects to the destination object for all destination properties that
         * resolve to `undefined`. Source objects are applied from left to right.
         * Once a property is set, additional values of the same property are ignored.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.defaultsDeep
         * @example
         *
         * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */
        var defaults = baseRest(function (object, sources) {
          object = Object(object);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];
              if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });

        /**
         * This method is like `_.defaults` except that it recursively assigns
         * default properties.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.defaults
         * @example
         *
         * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
         * // => { 'a': { 'b': 2, 'c': 3 } }
         */
        var defaultsDeep = baseRest(function (args) {
          args.push(undefined, customDefaultsMerge);
          return apply(mergeWith, undefined, args);
        });

        /**
         * This method is like `_.find` except that it returns the key of the first
         * element `predicate` returns truthy for instead of the element itself.
         *
         * @static
         * @memberOf _
         * @since 1.1.0
         * @category Object
         * @param {Object} object The object to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {string|undefined} Returns the key of the matched element,
         *  else `undefined`.
         * @example
         *
         * var users = {
         *   'barney':  { 'age': 36, 'active': true },
         *   'fred':    { 'age': 40, 'active': false },
         *   'pebbles': { 'age': 1,  'active': true }
         * };
         *
         * _.findKey(users, function(o) { return o.age < 40; });
         * // => 'barney' (iteration order is not guaranteed)
         *
         * // The `_.matches` iteratee shorthand.
         * _.findKey(users, { 'age': 1, 'active': true });
         * // => 'pebbles'
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findKey(users, ['active', false]);
         * // => 'fred'
         *
         * // The `_.property` iteratee shorthand.
         * _.findKey(users, 'active');
         * // => 'barney'
         */
        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }

        /**
         * This method is like `_.findKey` except that it iterates over elements of
         * a collection in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {string|undefined} Returns the key of the matched element,
         *  else `undefined`.
         * @example
         *
         * var users = {
         *   'barney':  { 'age': 36, 'active': true },
         *   'fred':    { 'age': 40, 'active': false },
         *   'pebbles': { 'age': 1,  'active': true }
         * };
         *
         * _.findLastKey(users, function(o) { return o.age < 40; });
         * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
         *
         * // The `_.matches` iteratee shorthand.
         * _.findLastKey(users, { 'age': 36, 'active': true });
         * // => 'barney'
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findLastKey(users, ['active', false]);
         * // => 'fred'
         *
         * // The `_.property` iteratee shorthand.
         * _.findLastKey(users, 'active');
         * // => 'pebbles'
         */
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }

        /**
         * Iterates over own and inherited enumerable string keyed properties of an
         * object and invokes `iteratee` for each property. The iteratee is invoked
         * with three arguments: (value, key, object). Iteratee functions may exit
         * iteration early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 0.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forInRight
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forIn(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
         */
        function forIn(object, iteratee) {
          return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }

        /**
         * This method is like `_.forIn` except that it iterates over properties of
         * `object` in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forIn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forInRight(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
         */
        function forInRight(object, iteratee) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }

        /**
         * Iterates over own enumerable string keyed properties of an object and
         * invokes `iteratee` for each property. The iteratee is invoked with three
         * arguments: (value, key, object). Iteratee functions may exit iteration
         * early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 0.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forOwnRight
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forOwn(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a' then 'b' (iteration order is not guaranteed).
         */
        function forOwn(object, iteratee) {
          return object && baseForOwn(object, getIteratee(iteratee, 3));
        }

        /**
         * This method is like `_.forOwn` except that it iterates over properties of
         * `object` in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forOwn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forOwnRight(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
         */
        function forOwnRight(object, iteratee) {
          return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }

        /**
         * Creates an array of function property names from own enumerable properties
         * of `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to inspect.
         * @returns {Array} Returns the function names.
         * @see _.functionsIn
         * @example
         *
         * function Foo() {
         *   this.a = _.constant('a');
         *   this.b = _.constant('b');
         * }
         *
         * Foo.prototype.c = _.constant('c');
         *
         * _.functions(new Foo);
         * // => ['a', 'b']
         */
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }

        /**
         * Creates an array of function property names from own and inherited
         * enumerable properties of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to inspect.
         * @returns {Array} Returns the function names.
         * @see _.functions
         * @example
         *
         * function Foo() {
         *   this.a = _.constant('a');
         *   this.b = _.constant('b');
         * }
         *
         * Foo.prototype.c = _.constant('c');
         *
         * _.functionsIn(new Foo);
         * // => ['a', 'b', 'c']
         */
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }

        /**
         * Gets the value at `path` of `object`. If the resolved value is
         * `undefined`, the `defaultValue` is returned in its place.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @param {*} [defaultValue] The value returned for `undefined` resolved values.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.get(object, 'a[0].b.c');
         * // => 3
         *
         * _.get(object, ['a', '0', 'b', 'c']);
         * // => 3
         *
         * _.get(object, 'a.b.c', 'default');
         * // => 'default'
         */
        function get(object, path, defaultValue) {
          var result = object == null ? undefined : baseGet(object, path);
          return result === undefined ? defaultValue : result;
        }

        /**
         * Checks if `path` is a direct property of `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         * @example
         *
         * var object = { 'a': { 'b': 2 } };
         * var other = _.create({ 'a': _.create({ 'b': 2 }) });
         *
         * _.has(object, 'a');
         * // => true
         *
         * _.has(object, 'a.b');
         * // => true
         *
         * _.has(object, ['a', 'b']);
         * // => true
         *
         * _.has(other, 'a');
         * // => false
         */
        function has(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }

        /**
         * Checks if `path` is a direct or inherited property of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         * @example
         *
         * var object = _.create({ 'a': _.create({ 'b': 2 }) });
         *
         * _.hasIn(object, 'a');
         * // => true
         *
         * _.hasIn(object, 'a.b');
         * // => true
         *
         * _.hasIn(object, ['a', 'b']);
         * // => true
         *
         * _.hasIn(object, 'b');
         * // => false
         */
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }

        /**
         * Creates an object composed of the inverted keys and values of `object`.
         * If `object` contains duplicate values, subsequent values overwrite
         * property assignments of previous values.
         *
         * @static
         * @memberOf _
         * @since 0.7.0
         * @category Object
         * @param {Object} object The object to invert.
         * @returns {Object} Returns the new inverted object.
         * @example
         *
         * var object = { 'a': 1, 'b': 2, 'c': 1 };
         *
         * _.invert(object);
         * // => { '1': 'c', '2': 'b' }
         */
        var invert = createInverter(function (result, value, key) {
          if (value != null && typeof value.toString != 'function') {
            value = nativeObjectToString.call(value);
          }
          result[value] = key;
        }, constant(identity));

        /**
         * This method is like `_.invert` except that the inverted object is generated
         * from the results of running each element of `object` thru `iteratee`. The
         * corresponding inverted value of each inverted key is an array of keys
         * responsible for generating the inverted value. The iteratee is invoked
         * with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.1.0
         * @category Object
         * @param {Object} object The object to invert.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Object} Returns the new inverted object.
         * @example
         *
         * var object = { 'a': 1, 'b': 2, 'c': 1 };
         *
         * _.invertBy(object);
         * // => { '1': ['a', 'c'], '2': ['b'] }
         *
         * _.invertBy(object, function(value) {
         *   return 'group' + value;
         * });
         * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
         */
        var invertBy = createInverter(function (result, value, key) {
          if (value != null && typeof value.toString != 'function') {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }, getIteratee);

        /**
         * Invokes the method at `path` of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the method to invoke.
         * @param {...*} [args] The arguments to invoke the method with.
         * @returns {*} Returns the result of the invoked method.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
         *
         * _.invoke(object, 'a[0].b.c.slice', 1, 3);
         * // => [2, 3]
         */
        var invoke = baseRest(baseInvoke);

        /**
         * Creates an array of the own enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects. See the
         * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * for more details.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keys(new Foo);
         * // => ['a', 'b'] (iteration order is not guaranteed)
         *
         * _.keys('hi');
         * // => ['0', '1']
         */
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }

        /**
         * Creates an array of the own and inherited enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keysIn(new Foo);
         * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
         */
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }

        /**
         * The opposite of `_.mapValues`; this method creates an object with the
         * same values as `object` and keys generated by running each own enumerable
         * string keyed property of `object` thru `iteratee`. The iteratee is invoked
         * with three arguments: (value, key, object).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns the new mapped object.
         * @see _.mapValues
         * @example
         *
         * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
         *   return key + value;
         * });
         * // => { 'a1': 1, 'b2': 2 }
         */
        function mapKeys(object, iteratee) {
          var result = {};
          iteratee = getIteratee(iteratee, 3);
          baseForOwn(object, function (value, key, object) {
            baseAssignValue(result, iteratee(value, key, object), value);
          });
          return result;
        }

        /**
         * Creates an object with the same keys as `object` and values generated
         * by running each own enumerable string keyed property of `object` thru
         * `iteratee`. The iteratee is invoked with three arguments:
         * (value, key, object).
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns the new mapped object.
         * @see _.mapKeys
         * @example
         *
         * var users = {
         *   'fred':    { 'user': 'fred',    'age': 40 },
         *   'pebbles': { 'user': 'pebbles', 'age': 1 }
         * };
         *
         * _.mapValues(users, function(o) { return o.age; });
         * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
         *
         * // The `_.property` iteratee shorthand.
         * _.mapValues(users, 'age');
         * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
         */
        function mapValues(object, iteratee) {
          var result = {};
          iteratee = getIteratee(iteratee, 3);
          baseForOwn(object, function (value, key, object) {
            baseAssignValue(result, key, iteratee(value, key, object));
          });
          return result;
        }

        /**
         * This method is like `_.assign` except that it recursively merges own and
         * inherited enumerable string keyed properties of source objects into the
         * destination object. Source properties that resolve to `undefined` are
         * skipped if a destination value exists. Array and plain object properties
         * are merged recursively. Other objects and value types are overridden by
         * assignment. Source objects are applied from left to right. Subsequent
         * sources overwrite property assignments of previous sources.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {
         *   'a': [{ 'b': 2 }, { 'd': 4 }]
         * };
         *
         * var other = {
         *   'a': [{ 'c': 3 }, { 'e': 5 }]
         * };
         *
         * _.merge(object, other);
         * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
         */
        var merge = createAssigner(function (object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });

        /**
         * This method is like `_.merge` except that it accepts `customizer` which
         * is invoked to produce the merged values of the destination and source
         * properties. If `customizer` returns `undefined`, merging is handled by the
         * method instead. The `customizer` is invoked with six arguments:
         * (objValue, srcValue, key, object, source, stack).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} sources The source objects.
         * @param {Function} customizer The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @example
         *
         * function customizer(objValue, srcValue) {
         *   if (_.isArray(objValue)) {
         *     return objValue.concat(srcValue);
         *   }
         * }
         *
         * var object = { 'a': [1], 'b': [2] };
         * var other = { 'a': [3], 'b': [4] };
         *
         * _.mergeWith(object, other, customizer);
         * // => { 'a': [1, 3], 'b': [2, 4] }
         */
        var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });

        /**
         * The opposite of `_.pick`; this method creates an object composed of the
         * own and inherited enumerable property paths of `object` that are not omitted.
         *
         * **Note:** This method is considerably slower than `_.pick`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The source object.
         * @param {...(string|string[])} [paths] The property paths to omit.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.omit(object, ['a', 'c']);
         * // => { 'b': '2' }
         */
        var omit = flatRest(function (object, paths) {
          var result = {};
          if (object == null) {
            return result;
          }
          var isDeep = false;
          paths = arrayMap(paths, function (path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result);
          if (isDeep) {
            result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result, paths[length]);
          }
          return result;
        });

        /**
         * The opposite of `_.pickBy`; this method creates an object composed of
         * the own and inherited enumerable string keyed properties of `object` that
         * `predicate` doesn't return truthy for. The predicate is invoked with two
         * arguments: (value, key).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The source object.
         * @param {Function} [predicate=_.identity] The function invoked per property.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.omitBy(object, _.isNumber);
         * // => { 'b': '2' }
         */
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }

        /**
         * Creates an object composed of the picked `object` properties.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The source object.
         * @param {...(string|string[])} [paths] The property paths to pick.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.pick(object, ['a', 'c']);
         * // => { 'a': 1, 'c': 3 }
         */
        var pick = flatRest(function (object, paths) {
          return object == null ? {} : basePick(object, paths);
        });

        /**
         * Creates an object composed of the `object` properties `predicate` returns
         * truthy for. The predicate is invoked with two arguments: (value, key).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The source object.
         * @param {Function} [predicate=_.identity] The function invoked per property.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.pickBy(object, _.isNumber);
         * // => { 'a': 1, 'c': 3 }
         */
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function (prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function (value, path) {
            return predicate(value, path[0]);
          });
        }

        /**
         * This method is like `_.get` except that if the resolved value is a
         * function it's invoked with the `this` binding of its parent object and
         * its result is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to resolve.
         * @param {*} [defaultValue] The value returned for `undefined` resolved values.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
         *
         * _.result(object, 'a[0].b.c1');
         * // => 3
         *
         * _.result(object, 'a[0].b.c2');
         * // => 4
         *
         * _.result(object, 'a[0].b.c3', 'default');
         * // => 'default'
         *
         * _.result(object, 'a[0].b.c3', _.constant('default'));
         * // => 'default'
         */
        function result(object, path, defaultValue) {
          path = castPath(path, object);
          var index = -1,
            length = path.length;

          // Ensure the loop is entered when path is empty.
          if (!length) {
            length = 1;
            object = undefined;
          }
          while (++index < length) {
            var value = object == null ? undefined : object[toKey(path[index])];
            if (value === undefined) {
              index = length;
              value = defaultValue;
            }
            object = isFunction(value) ? value.call(object) : value;
          }
          return object;
        }

        /**
         * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
         * it's created. Arrays are created for missing index properties while objects
         * are created for all other missing properties. Use `_.setWith` to customize
         * `path` creation.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.set(object, 'a[0].b.c', 4);
         * console.log(object.a[0].b.c);
         * // => 4
         *
         * _.set(object, ['x', '0', 'y', 'z'], 5);
         * console.log(object.x[0].y.z);
         * // => 5
         */
        function set(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }

        /**
         * This method is like `_.set` except that it accepts `customizer` which is
         * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
         * path creation is handled by the method instead. The `customizer` is invoked
         * with three arguments: (nsValue, key, nsObject).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {};
         *
         * _.setWith(object, '[0][1]', 'a', Object);
         * // => { '0': { '1': 'a' } }
         */
        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined;
          return object == null ? object : baseSet(object, path, value, customizer);
        }

        /**
         * Creates an array of own enumerable string keyed-value pairs for `object`
         * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
         * entries are returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias entries
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the key-value pairs.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.toPairs(new Foo);
         * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
         */
        var toPairs = createToPairs(keys);

        /**
         * Creates an array of own and inherited enumerable string keyed-value pairs
         * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
         * or set, its entries are returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias entriesIn
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the key-value pairs.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.toPairsIn(new Foo);
         * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
         */
        var toPairsIn = createToPairs(keysIn);

        /**
         * An alternative to `_.reduce`; this method transforms `object` to a new
         * `accumulator` object which is the result of running each of its own
         * enumerable string keyed properties thru `iteratee`, with each invocation
         * potentially mutating the `accumulator` object. If `accumulator` is not
         * provided, a new object with the same `[[Prototype]]` will be used. The
         * iteratee is invoked with four arguments: (accumulator, value, key, object).
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 1.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {*} [accumulator] The custom accumulator value.
         * @returns {*} Returns the accumulated value.
         * @example
         *
         * _.transform([2, 3, 4], function(result, n) {
         *   result.push(n *= n);
         *   return n % 2 == 0;
         * }, []);
         * // => [4, 9]
         *
         * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
         *   (result[value] || (result[value] = [])).push(key);
         * }, {});
         * // => { '1': ['a', 'c'], '2': ['b'] }
         */
        function transform(object, iteratee, accumulator) {
          var isArr = isArray(object),
            isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee = getIteratee(iteratee, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
            return iteratee(accumulator, value, index, object);
          });
          return accumulator;
        }

        /**
         * Removes the property at `path` of `object`.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to unset.
         * @returns {boolean} Returns `true` if the property is deleted, else `false`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 7 } }] };
         * _.unset(object, 'a[0].b.c');
         * // => true
         *
         * console.log(object);
         * // => { 'a': [{ 'b': {} }] };
         *
         * _.unset(object, ['a', '0', 'b', 'c']);
         * // => true
         *
         * console.log(object);
         * // => { 'a': [{ 'b': {} }] };
         */
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }

        /**
         * This method is like `_.set` except that accepts `updater` to produce the
         * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
         * is invoked with one argument: (value).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {Function} updater The function to produce the updated value.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.update(object, 'a[0].b.c', function(n) { return n * n; });
         * console.log(object.a[0].b.c);
         * // => 9
         *
         * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
         * console.log(object.x[0].y.z);
         * // => 0
         */
        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }

        /**
         * This method is like `_.update` except that it accepts `customizer` which is
         * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
         * path creation is handled by the method instead. The `customizer` is invoked
         * with three arguments: (nsValue, key, nsObject).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {Function} updater The function to produce the updated value.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {};
         *
         * _.updateWith(object, '[0][1]', _.constant('a'), Object);
         * // => { '0': { '1': 'a' } }
         */
        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == 'function' ? customizer : undefined;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }

        /**
         * Creates an array of the own enumerable string keyed property values of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property values.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.values(new Foo);
         * // => [1, 2] (iteration order is not guaranteed)
         *
         * _.values('hi');
         * // => ['h', 'i']
         */
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }

        /**
         * Creates an array of the own and inherited enumerable string keyed property
         * values of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property values.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.valuesIn(new Foo);
         * // => [1, 2, 3] (iteration order is not guaranteed)
         */
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }

        /*------------------------------------------------------------------------*/

        /**
         * Clamps `number` within the inclusive `lower` and `upper` bounds.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Number
         * @param {number} number The number to clamp.
         * @param {number} [lower] The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the clamped number.
         * @example
         *
         * _.clamp(-10, -5, 5);
         * // => -5
         *
         * _.clamp(10, -5, 5);
         * // => 5
         */
        function clamp(number, lower, upper) {
          if (upper === undefined) {
            upper = lower;
            lower = undefined;
          }
          if (upper !== undefined) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }

        /**
         * Checks if `n` is between `start` and up to, but not including, `end`. If
         * `end` is not specified, it's set to `start` with `start` then set to `0`.
         * If `start` is greater than `end` the params are swapped to support
         * negative ranges.
         *
         * @static
         * @memberOf _
         * @since 3.3.0
         * @category Number
         * @param {number} number The number to check.
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
         * @see _.range, _.rangeRight
         * @example
         *
         * _.inRange(3, 2, 4);
         * // => true
         *
         * _.inRange(4, 8);
         * // => true
         *
         * _.inRange(4, 2);
         * // => false
         *
         * _.inRange(2, 2);
         * // => false
         *
         * _.inRange(1.2, 2);
         * // => true
         *
         * _.inRange(5.2, 4);
         * // => false
         *
         * _.inRange(-3, -2, -6);
         * // => true
         */
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }

        /**
         * Produces a random number between the inclusive `lower` and `upper` bounds.
         * If only one argument is provided a number between `0` and the given number
         * is returned. If `floating` is `true`, or either `lower` or `upper` are
         * floats, a floating-point number is returned instead of an integer.
         *
         * **Note:** JavaScript follows the IEEE-754 standard for resolving
         * floating-point values which can produce unexpected results.
         *
         * @static
         * @memberOf _
         * @since 0.7.0
         * @category Number
         * @param {number} [lower=0] The lower bound.
         * @param {number} [upper=1] The upper bound.
         * @param {boolean} [floating] Specify returning a floating-point number.
         * @returns {number} Returns the random number.
         * @example
         *
         * _.random(0, 5);
         * // => an integer between 0 and 5
         *
         * _.random(5);
         * // => also an integer between 0 and 5
         *
         * _.random(5, true);
         * // => a floating-point number between 0 and 5
         *
         * _.random(1.2, 5.2);
         * // => a floating-point number between 1.2 and 5.2
         */
        function random(lower, upper, floating) {
          if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined;
          }
          if (floating === undefined) {
            if (typeof upper == 'boolean') {
              floating = upper;
              upper = undefined;
            } else if (typeof lower == 'boolean') {
              floating = lower;
              lower = undefined;
            }
          }
          if (lower === undefined && upper === undefined) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }

        /*------------------------------------------------------------------------*/

        /**
         * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the camel cased string.
         * @example
         *
         * _.camelCase('Foo Bar');
         * // => 'fooBar'
         *
         * _.camelCase('--foo-bar--');
         * // => 'fooBar'
         *
         * _.camelCase('__FOO_BAR__');
         * // => 'fooBar'
         */
        var camelCase = createCompounder(function (result, word, index) {
          word = word.toLowerCase();
          return result + (index ? capitalize(word) : word);
        });

        /**
         * Converts the first character of `string` to upper case and the remaining
         * to lower case.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to capitalize.
         * @returns {string} Returns the capitalized string.
         * @example
         *
         * _.capitalize('FRED');
         * // => 'Fred'
         */
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }

        /**
         * Deburrs `string` by converting
         * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
         * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
         * letters to basic Latin letters and removing
         * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to deburr.
         * @returns {string} Returns the deburred string.
         * @example
         *
         * _.deburr('déjà vu');
         * // => 'deja vu'
         */
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }

        /**
         * Checks if `string` ends with the given target string.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {string} [target] The string to search for.
         * @param {number} [position=string.length] The position to search up to.
         * @returns {boolean} Returns `true` if `string` ends with `target`,
         *  else `false`.
         * @example
         *
         * _.endsWith('abc', 'c');
         * // => true
         *
         * _.endsWith('abc', 'b');
         * // => false
         *
         * _.endsWith('abc', 'b', 2);
         * // => true
         */
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }

        /**
         * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
         * corresponding HTML entities.
         *
         * **Note:** No other characters are escaped. To escape additional
         * characters use a third-party library like [_he_](https://mths.be/he).
         *
         * Though the ">" character is escaped for symmetry, characters like
         * ">" and "/" don't need escaping in HTML and have no special meaning
         * unless they're part of a tag or unquoted attribute value. See
         * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
         * (under "semi-related fun fact") for more details.
         *
         * When working with HTML you should always
         * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
         * XSS vectors.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category String
         * @param {string} [string=''] The string to escape.
         * @returns {string} Returns the escaped string.
         * @example
         *
         * _.escape('fred, barney, & pebbles');
         * // => 'fred, barney, &amp; pebbles'
         */
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }

        /**
         * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
         * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to escape.
         * @returns {string} Returns the escaped string.
         * @example
         *
         * _.escapeRegExp('[lodash](https://lodash.com/)');
         * // => '\[lodash\]\(https://lodash\.com/\)'
         */
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }

        /**
         * Converts `string` to
         * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the kebab cased string.
         * @example
         *
         * _.kebabCase('Foo Bar');
         * // => 'foo-bar'
         *
         * _.kebabCase('fooBar');
         * // => 'foo-bar'
         *
         * _.kebabCase('__FOO_BAR__');
         * // => 'foo-bar'
         */
        var kebabCase = createCompounder(function (result, word, index) {
          return result + (index ? '-' : '') + word.toLowerCase();
        });

        /**
         * Converts `string`, as space separated words, to lower case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the lower cased string.
         * @example
         *
         * _.lowerCase('--Foo-Bar--');
         * // => 'foo bar'
         *
         * _.lowerCase('fooBar');
         * // => 'foo bar'
         *
         * _.lowerCase('__FOO_BAR__');
         * // => 'foo bar'
         */
        var lowerCase = createCompounder(function (result, word, index) {
          return result + (index ? ' ' : '') + word.toLowerCase();
        });

        /**
         * Converts the first character of `string` to lower case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.lowerFirst('Fred');
         * // => 'fred'
         *
         * _.lowerFirst('FRED');
         * // => 'fRED'
         */
        var lowerFirst = createCaseFirst('toLowerCase');

        /**
         * Pads `string` on the left and right sides if it's shorter than `length`.
         * Padding characters are truncated if they can't be evenly divided by `length`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.pad('abc', 8);
         * // => '  abc   '
         *
         * _.pad('abc', 8, '_-');
         * // => '_-abc_-_'
         *
         * _.pad('abc', 3);
         * // => 'abc'
         */
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }

        /**
         * Pads `string` on the right side if it's shorter than `length`. Padding
         * characters are truncated if they exceed `length`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.padEnd('abc', 6);
         * // => 'abc   '
         *
         * _.padEnd('abc', 6, '_-');
         * // => 'abc_-_'
         *
         * _.padEnd('abc', 3);
         * // => 'abc'
         */
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }

        /**
         * Pads `string` on the left side if it's shorter than `length`. Padding
         * characters are truncated if they exceed `length`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.padStart('abc', 6);
         * // => '   abc'
         *
         * _.padStart('abc', 6, '_-');
         * // => '_-_abc'
         *
         * _.padStart('abc', 3);
         * // => 'abc'
         */
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }

        /**
         * Converts `string` to an integer of the specified radix. If `radix` is
         * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
         * hexadecimal, in which case a `radix` of `16` is used.
         *
         * **Note:** This method aligns with the
         * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
         *
         * @static
         * @memberOf _
         * @since 1.1.0
         * @category String
         * @param {string} string The string to convert.
         * @param {number} [radix=10] The radix to interpret `value` by.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.parseInt('08');
         * // => 8
         *
         * _.map(['6', '08', '10'], _.parseInt);
         * // => [6, 8, 10]
         */
        function parseInt(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }

        /**
         * Repeats the given string `n` times.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to repeat.
         * @param {number} [n=1] The number of times to repeat the string.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the repeated string.
         * @example
         *
         * _.repeat('*', 3);
         * // => '***'
         *
         * _.repeat('abc', 2);
         * // => 'abcabc'
         *
         * _.repeat('abc', 0);
         * // => ''
         */
        function repeat(string, n, guard) {
          if (guard ? isIterateeCall(string, n, guard) : n === undefined) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString(string), n);
        }

        /**
         * Replaces matches for `pattern` in `string` with `replacement`.
         *
         * **Note:** This method is based on
         * [`String#replace`](https://mdn.io/String/replace).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to modify.
         * @param {RegExp|string} pattern The pattern to replace.
         * @param {Function|string} replacement The match replacement.
         * @returns {string} Returns the modified string.
         * @example
         *
         * _.replace('Hi Fred', 'Fred', 'Barney');
         * // => 'Hi Barney'
         */
        function replace() {
          var args = arguments,
            string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }

        /**
         * Converts `string` to
         * [snake case](https://en.wikipedia.org/wiki/Snake_case).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the snake cased string.
         * @example
         *
         * _.snakeCase('Foo Bar');
         * // => 'foo_bar'
         *
         * _.snakeCase('fooBar');
         * // => 'foo_bar'
         *
         * _.snakeCase('--FOO-BAR--');
         * // => 'foo_bar'
         */
        var snakeCase = createCompounder(function (result, word, index) {
          return result + (index ? '_' : '') + word.toLowerCase();
        });

        /**
         * Splits `string` by `separator`.
         *
         * **Note:** This method is based on
         * [`String#split`](https://mdn.io/String/split).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to split.
         * @param {RegExp|string} separator The separator pattern to split by.
         * @param {number} [limit] The length to truncate results to.
         * @returns {Array} Returns the string segments.
         * @example
         *
         * _.split('a-b-c', '-', 2);
         * // => ['a', 'b']
         */
        function split(string, separator, limit) {
          if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined;
          }
          limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }

        /**
         * Converts `string` to
         * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
         *
         * @static
         * @memberOf _
         * @since 3.1.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the start cased string.
         * @example
         *
         * _.startCase('--foo-bar--');
         * // => 'Foo Bar'
         *
         * _.startCase('fooBar');
         * // => 'Foo Bar'
         *
         * _.startCase('__FOO_BAR__');
         * // => 'FOO BAR'
         */
        var startCase = createCompounder(function (result, word, index) {
          return result + (index ? ' ' : '') + upperFirst(word);
        });

        /**
         * Checks if `string` starts with the given target string.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {string} [target] The string to search for.
         * @param {number} [position=0] The position to search from.
         * @returns {boolean} Returns `true` if `string` starts with `target`,
         *  else `false`.
         * @example
         *
         * _.startsWith('abc', 'a');
         * // => true
         *
         * _.startsWith('abc', 'b');
         * // => false
         *
         * _.startsWith('abc', 'b', 1);
         * // => true
         */
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }

        /**
         * Creates a compiled template function that can interpolate data properties
         * in "interpolate" delimiters, HTML-escape interpolated data properties in
         * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
         * properties may be accessed as free variables in the template. If a setting
         * object is given, it takes precedence over `_.templateSettings` values.
         *
         * **Note:** In the development build `_.template` utilizes
         * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
         * for easier debugging.
         *
         * For more information on precompiling templates see
         * [lodash's custom builds documentation](https://lodash.com/custom-builds).
         *
         * For more information on Chrome extension sandboxes see
         * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category String
         * @param {string} [string=''] The template string.
         * @param {Object} [options={}] The options object.
         * @param {RegExp} [options.escape=_.templateSettings.escape]
         *  The HTML "escape" delimiter.
         * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
         *  The "evaluate" delimiter.
         * @param {Object} [options.imports=_.templateSettings.imports]
         *  An object to import into the template as free variables.
         * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
         *  The "interpolate" delimiter.
         * @param {string} [options.sourceURL='lodash.templateSources[n]']
         *  The sourceURL of the compiled template.
         * @param {string} [options.variable='obj']
         *  The data object variable name.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the compiled template function.
         * @example
         *
         * // Use the "interpolate" delimiter to create a compiled template.
         * var compiled = _.template('hello <%= user %>!');
         * compiled({ 'user': 'fred' });
         * // => 'hello fred!'
         *
         * // Use the HTML "escape" delimiter to escape data property values.
         * var compiled = _.template('<b><%- value %></b>');
         * compiled({ 'value': '<script>' });
         * // => '<b>&lt;script&gt;</b>'
         *
         * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
         * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
         * compiled({ 'users': ['fred', 'barney'] });
         * // => '<li>fred</li><li>barney</li>'
         *
         * // Use the internal `print` function in "evaluate" delimiters.
         * var compiled = _.template('<% print("hello " + user); %>!');
         * compiled({ 'user': 'barney' });
         * // => 'hello barney!'
         *
         * // Use the ES template literal delimiter as an "interpolate" delimiter.
         * // Disable support by replacing the "interpolate" delimiter.
         * var compiled = _.template('hello ${ user }!');
         * compiled({ 'user': 'pebbles' });
         * // => 'hello pebbles!'
         *
         * // Use backslashes to treat delimiters as plain text.
         * var compiled = _.template('<%= "\\<%- value %\\>" %>');
         * compiled({ 'value': 'ignored' });
         * // => '<%- value %>'
         *
         * // Use the `imports` option to import `jQuery` as `jq`.
         * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
         * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
         * compiled({ 'users': ['fred', 'barney'] });
         * // => '<li>fred</li><li>barney</li>'
         *
         * // Use the `sourceURL` option to specify a custom sourceURL for the template.
         * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
         * compiled(data);
         * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
         *
         * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
         * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
         * compiled.source;
         * // => function(data) {
         * //   var __t, __p = '';
         * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
         * //   return __p;
         * // }
         *
         * // Use custom template delimiters.
         * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
         * var compiled = _.template('hello {{ user }}!');
         * compiled({ 'user': 'mustache' });
         * // => 'hello mustache!'
         *
         * // Use the `source` property to inline compiled templates for meaningful
         * // line numbers in error messages and stack traces.
         * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
         *   var JST = {\
         *     "main": ' + _.template(mainText).source + '\
         *   };\
         * ');
         */
        function template(string, options, guard) {
          // Based on John Resig's `tmpl` implementation
          // (http://ejohn.org/blog/javascript-micro-templating/)
          // and Laura Doktorova's doT.js (https://github.com/olado/doT).
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
            importsKeys = keys(imports),
            importsValues = baseValues(imports, importsKeys);
          var isEscaping,
            isEvaluating,
            index = 0,
            interpolate = options.interpolate || reNoMatch,
            source = "__p += '";

          // Compile the regexp to match each delimiter.
          var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

          // Use a sourceURL for easier debugging.
          // The sourceURL gets injected into the source that's eval-ed, so be careful
          // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
          // and escape the comment, thus injecting code that gets evaled.
          var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
          string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);

            // Escape characters that can't be included in string literals.
            source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

            // Replace delimiters with snippets.
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match.length;

            // The JS engine embedded in Adobe products needs `match` returned in
            // order to produce the correct `offset` value.
            return match;
          });
          source += "';\n";

          // If `variable` is not specified wrap a with-statement around the generated
          // code to add the data object to the top of the scope chain.
          var variable = hasOwnProperty.call(options, 'variable') && options.variable;
          if (!variable) {
            source = 'with (obj) {\n' + source + '\n}\n';
          }
          // Throw an error if a forbidden character was found in `variable`, to prevent
          // potential command injection attacks.
          else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
          }

          // Cleanup code by stripping empty strings.
          source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

          // Frame code as the function body.
          source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
          var result = attempt(function () {
            return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
          });

          // Provide the compiled function's source by its `toString` method or
          // the `source` property as a convenience for inlining compiled templates.
          result.source = source;
          if (isError(result)) {
            throw result;
          }
          return result;
        }

        /**
         * Converts `string`, as a whole, to lower case just like
         * [String#toLowerCase](https://mdn.io/toLowerCase).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the lower cased string.
         * @example
         *
         * _.toLower('--Foo-Bar--');
         * // => '--foo-bar--'
         *
         * _.toLower('fooBar');
         * // => 'foobar'
         *
         * _.toLower('__FOO_BAR__');
         * // => '__foo_bar__'
         */
        function toLower(value) {
          return toString(value).toLowerCase();
        }

        /**
         * Converts `string`, as a whole, to upper case just like
         * [String#toUpperCase](https://mdn.io/toUpperCase).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the upper cased string.
         * @example
         *
         * _.toUpper('--foo-bar--');
         * // => '--FOO-BAR--'
         *
         * _.toUpper('fooBar');
         * // => 'FOOBAR'
         *
         * _.toUpper('__foo_bar__');
         * // => '__FOO_BAR__'
         */
        function toUpper(value) {
          return toString(value).toUpperCase();
        }

        /**
         * Removes leading and trailing whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trim('  abc  ');
         * // => 'abc'
         *
         * _.trim('-_-abc-_-', '_-');
         * // => 'abc'
         *
         * _.map(['  foo  ', '  bar  '], _.trim);
         * // => ['foo', 'bar']
         */
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string),
            chrSymbols = stringToArray(chars),
            start = charsStartIndex(strSymbols, chrSymbols),
            end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join('');
        }

        /**
         * Removes trailing whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trimEnd('  abc  ');
         * // => '  abc'
         *
         * _.trimEnd('-_-abc-_-', '_-');
         * // => '-_-abc'
         */
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string),
            end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join('');
        }

        /**
         * Removes leading whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trimStart('  abc  ');
         * // => 'abc  '
         *
         * _.trimStart('-_-abc-_-', '_-');
         * // => 'abc-_-'
         */
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined)) {
            return string.replace(reTrimStart, '');
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string),
            start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join('');
        }

        /**
         * Truncates `string` if it's longer than the given maximum string length.
         * The last characters of the truncated string are replaced with the omission
         * string which defaults to "...".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to truncate.
         * @param {Object} [options={}] The options object.
         * @param {number} [options.length=30] The maximum string length.
         * @param {string} [options.omission='...'] The string to indicate text is omitted.
         * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
         * @returns {string} Returns the truncated string.
         * @example
         *
         * _.truncate('hi-diddly-ho there, neighborino');
         * // => 'hi-diddly-ho there, neighbo...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'length': 24,
         *   'separator': ' '
         * });
         * // => 'hi-diddly-ho there,...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'length': 24,
         *   'separator': /,? +/
         * });
         * // => 'hi-diddly-ho there...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'omission': ' [...]'
         * });
         * // => 'hi-diddly-ho there, neig [...]'
         */
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH,
            omission = DEFAULT_TRUNC_OMISSION;
          if (isObject(options)) {
            var separator = 'separator' in options ? options.separator : separator;
            length = 'length' in options ? toInteger(options.length) : length;
            omission = 'omission' in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
          if (separator === undefined) {
            return result + omission;
          }
          if (strSymbols) {
            end += result.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match,
                substring = result;
              if (!separator.global) {
                separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result = result.slice(0, newEnd === undefined ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index = result.lastIndexOf(separator);
            if (index > -1) {
              result = result.slice(0, index);
            }
          }
          return result + omission;
        }

        /**
         * The inverse of `_.escape`; this method converts the HTML entities
         * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
         * their corresponding characters.
         *
         * **Note:** No other HTML entities are unescaped. To unescape additional
         * HTML entities use a third-party library like [_he_](https://mths.be/he).
         *
         * @static
         * @memberOf _
         * @since 0.6.0
         * @category String
         * @param {string} [string=''] The string to unescape.
         * @returns {string} Returns the unescaped string.
         * @example
         *
         * _.unescape('fred, barney, &amp; pebbles');
         * // => 'fred, barney, & pebbles'
         */
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }

        /**
         * Converts `string`, as space separated words, to upper case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the upper cased string.
         * @example
         *
         * _.upperCase('--foo-bar');
         * // => 'FOO BAR'
         *
         * _.upperCase('fooBar');
         * // => 'FOO BAR'
         *
         * _.upperCase('__foo_bar__');
         * // => 'FOO BAR'
         */
        var upperCase = createCompounder(function (result, word, index) {
          return result + (index ? ' ' : '') + word.toUpperCase();
        });

        /**
         * Converts the first character of `string` to upper case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.upperFirst('fred');
         * // => 'Fred'
         *
         * _.upperFirst('FRED');
         * // => 'FRED'
         */
        var upperFirst = createCaseFirst('toUpperCase');

        /**
         * Splits `string` into an array of its words.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {RegExp|string} [pattern] The pattern to match words.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the words of `string`.
         * @example
         *
         * _.words('fred, barney, & pebbles');
         * // => ['fred', 'barney', 'pebbles']
         *
         * _.words('fred, barney, & pebbles', /[^, ]+/g);
         * // => ['fred', 'barney', '&', 'pebbles']
         */
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined : pattern;
          if (pattern === undefined) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }

        /*------------------------------------------------------------------------*/

        /**
         * Attempts to invoke `func`, returning either the result or the caught error
         * object. Any additional arguments are provided to `func` when it's invoked.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Function} func The function to attempt.
         * @param {...*} [args] The arguments to invoke `func` with.
         * @returns {*} Returns the `func` result or error object.
         * @example
         *
         * // Avoid throwing errors for invalid selectors.
         * var elements = _.attempt(function(selector) {
         *   return document.querySelectorAll(selector);
         * }, '>_>');
         *
         * if (_.isError(elements)) {
         *   elements = [];
         * }
         */
        var attempt = baseRest(function (func, args) {
          try {
            return apply(func, undefined, args);
          } catch (e) {
            return isError(e) ? e : new Error(e);
          }
        });

        /**
         * Binds methods of an object to the object itself, overwriting the existing
         * method.
         *
         * **Note:** This method doesn't set the "length" property of bound functions.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {Object} object The object to bind and assign the bound methods to.
         * @param {...(string|string[])} methodNames The object method names to bind.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var view = {
         *   'label': 'docs',
         *   'click': function() {
         *     console.log('clicked ' + this.label);
         *   }
         * };
         *
         * _.bindAll(view, ['click']);
         * jQuery(element).on('click', view.click);
         * // => Logs 'clicked docs' when clicked.
         */
        var bindAll = flatRest(function (object, methodNames) {
          arrayEach(methodNames, function (key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });

        /**
         * Creates a function that iterates over `pairs` and invokes the corresponding
         * function of the first predicate to return truthy. The predicate-function
         * pairs are invoked with the `this` binding and arguments of the created
         * function.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {Array} pairs The predicate-function pairs.
         * @returns {Function} Returns the new composite function.
         * @example
         *
         * var func = _.cond([
         *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
         *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
         *   [_.stubTrue,                      _.constant('no match')]
         * ]);
         *
         * func({ 'a': 1, 'b': 2 });
         * // => 'matches A'
         *
         * func({ 'a': 0, 'b': 1 });
         * // => 'matches B'
         *
         * func({ 'a': '1', 'b': '2' });
         * // => 'no match'
         */
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length,
            toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function (pair) {
            if (typeof pair[1] != 'function') {
              throw new TypeError(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function (args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }

        /**
         * Creates a function that invokes the predicate properties of `source` with
         * the corresponding property values of a given object, returning `true` if
         * all predicates return truthy, else `false`.
         *
         * **Note:** The created function is equivalent to `_.conformsTo` with
         * `source` partially applied.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {Object} source The object of property predicates to conform to.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 2, 'b': 1 },
         *   { 'a': 1, 'b': 2 }
         * ];
         *
         * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
         * // => [{ 'a': 1, 'b': 2 }]
         */
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }

        /**
         * Creates a function that returns `value`.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {*} value The value to return from the new function.
         * @returns {Function} Returns the new constant function.
         * @example
         *
         * var objects = _.times(2, _.constant({ 'a': 1 }));
         *
         * console.log(objects);
         * // => [{ 'a': 1 }, { 'a': 1 }]
         *
         * console.log(objects[0] === objects[1]);
         * // => true
         */
        function constant(value) {
          return function () {
            return value;
          };
        }

        /**
         * Checks `value` to determine whether a default value should be returned in
         * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
         * or `undefined`.
         *
         * @static
         * @memberOf _
         * @since 4.14.0
         * @category Util
         * @param {*} value The value to check.
         * @param {*} defaultValue The default value.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * _.defaultTo(1, 10);
         * // => 1
         *
         * _.defaultTo(undefined, 10);
         * // => 10
         */
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        /**
         * Creates a function that returns the result of invoking the given functions
         * with the `this` binding of the created function, where each successive
         * invocation is supplied the return value of the previous.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {...(Function|Function[])} [funcs] The functions to invoke.
         * @returns {Function} Returns the new composite function.
         * @see _.flowRight
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var addSquare = _.flow([_.add, square]);
         * addSquare(1, 2);
         * // => 9
         */
        var flow = createFlow();

        /**
         * This method is like `_.flow` except that it creates a function that
         * invokes the given functions from right to left.
         *
         * @static
         * @since 3.0.0
         * @memberOf _
         * @category Util
         * @param {...(Function|Function[])} [funcs] The functions to invoke.
         * @returns {Function} Returns the new composite function.
         * @see _.flow
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var addSquare = _.flowRight([square, _.add]);
         * addSquare(1, 2);
         * // => 9
         */
        var flowRight = createFlow(true);

        /**
         * This method returns the first argument it receives.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {*} value Any value.
         * @returns {*} Returns `value`.
         * @example
         *
         * var object = { 'a': 1 };
         *
         * console.log(_.identity(object) === object);
         * // => true
         */
        function identity(value) {
          return value;
        }

        /**
         * Creates a function that invokes `func` with the arguments of the created
         * function. If `func` is a property name, the created function returns the
         * property value for a given element. If `func` is an array or object, the
         * created function returns `true` for elements that contain the equivalent
         * source properties, otherwise it returns `false`.
         *
         * @static
         * @since 4.0.0
         * @memberOf _
         * @category Util
         * @param {*} [func=_.identity] The value to convert to a callback.
         * @returns {Function} Returns the callback.
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': true },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * // The `_.matches` iteratee shorthand.
         * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
         * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.filter(users, _.iteratee(['user', 'fred']));
         * // => [{ 'user': 'fred', 'age': 40 }]
         *
         * // The `_.property` iteratee shorthand.
         * _.map(users, _.iteratee('user'));
         * // => ['barney', 'fred']
         *
         * // Create custom iteratee shorthands.
         * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
         *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
         *     return func.test(string);
         *   };
         * });
         *
         * _.filter(['abc', 'def'], /ef/);
         * // => ['def']
         */
        function iteratee(func) {
          return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }

        /**
         * Creates a function that performs a partial deep comparison between a given
         * object and `source`, returning `true` if the given object has equivalent
         * property values, else `false`.
         *
         * **Note:** The created function is equivalent to `_.isMatch` with `source`
         * partially applied.
         *
         * Partial comparisons will match empty array and empty object `source`
         * values against any array or object value, respectively. See `_.isEqual`
         * for a list of supported value comparisons.
         *
         * **Note:** Multiple values can be checked by combining several matchers
         * using `_.overSome`
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Object} source The object of property values to match.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 1, 'b': 2, 'c': 3 },
         *   { 'a': 4, 'b': 5, 'c': 6 }
         * ];
         *
         * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
         * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
         *
         * // Checking for several possible values
         * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
         * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
         */
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }

        /**
         * Creates a function that performs a partial deep comparison between the
         * value at `path` of a given object to `srcValue`, returning `true` if the
         * object value is equivalent, else `false`.
         *
         * **Note:** Partial comparisons will match empty array and empty object
         * `srcValue` values against any array or object value, respectively. See
         * `_.isEqual` for a list of supported value comparisons.
         *
         * **Note:** Multiple values can be checked by combining several matchers
         * using `_.overSome`
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Util
         * @param {Array|string} path The path of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 1, 'b': 2, 'c': 3 },
         *   { 'a': 4, 'b': 5, 'c': 6 }
         * ];
         *
         * _.find(objects, _.matchesProperty('a', 4));
         * // => { 'a': 4, 'b': 5, 'c': 6 }
         *
         * // Checking for several possible values
         * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
         * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
         */
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }

        /**
         * Creates a function that invokes the method at `path` of a given object.
         * Any additional arguments are provided to the invoked method.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Util
         * @param {Array|string} path The path of the method to invoke.
         * @param {...*} [args] The arguments to invoke the method with.
         * @returns {Function} Returns the new invoker function.
         * @example
         *
         * var objects = [
         *   { 'a': { 'b': _.constant(2) } },
         *   { 'a': { 'b': _.constant(1) } }
         * ];
         *
         * _.map(objects, _.method('a.b'));
         * // => [2, 1]
         *
         * _.map(objects, _.method(['a', 'b']));
         * // => [2, 1]
         */
        var method = baseRest(function (path, args) {
          return function (object) {
            return baseInvoke(object, path, args);
          };
        });

        /**
         * The opposite of `_.method`; this method creates a function that invokes
         * the method at a given path of `object`. Any additional arguments are
         * provided to the invoked method.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Util
         * @param {Object} object The object to query.
         * @param {...*} [args] The arguments to invoke the method with.
         * @returns {Function} Returns the new invoker function.
         * @example
         *
         * var array = _.times(3, _.constant),
         *     object = { 'a': array, 'b': array, 'c': array };
         *
         * _.map(['a[2]', 'c[0]'], _.methodOf(object));
         * // => [2, 0]
         *
         * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
         * // => [2, 0]
         */
        var methodOf = baseRest(function (object, args) {
          return function (path) {
            return baseInvoke(object, path, args);
          };
        });

        /**
         * Adds all own enumerable string keyed function properties of a source
         * object to the destination object. If `object` is a function, then methods
         * are added to its prototype as well.
         *
         * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
         * avoid conflicts caused by modifying the original.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {Function|Object} [object=lodash] The destination object.
         * @param {Object} source The object of functions to add.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
         * @returns {Function|Object} Returns `object`.
         * @example
         *
         * function vowels(string) {
         *   return _.filter(string, function(v) {
         *     return /[aeiou]/i.test(v);
         *   });
         * }
         *
         * _.mixin({ 'vowels': vowels });
         * _.vowels('fred');
         * // => ['e']
         *
         * _('fred').vowels().value();
         * // => ['e']
         *
         * _.mixin({ 'vowels': vowels }, { 'chain': false });
         * _('fred').vowels();
         * // => ['e']
         */
        function mixin(object, source, options) {
          var props = keys(source),
            methodNames = baseFunctions(source, props);
          if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
            isFunc = isFunction(object);
          arrayEach(methodNames, function (methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function () {
                var chainAll = this.__chain__;
                if (chain || chainAll) {
                  var result = object(this.__wrapped__),
                    actions = result.__actions__ = copyArray(this.__actions__);
                  actions.push({
                    'func': func,
                    'args': arguments,
                    'thisArg': object
                  });
                  result.__chain__ = chainAll;
                  return result;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }

        /**
         * Reverts the `_` variable to its previous value and returns a reference to
         * the `lodash` function.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @returns {Function} Returns the `lodash` function.
         * @example
         *
         * var lodash = _.noConflict();
         */
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }

        /**
         * This method returns `undefined`.
         *
         * @static
         * @memberOf _
         * @since 2.3.0
         * @category Util
         * @example
         *
         * _.times(2, _.noop);
         * // => [undefined, undefined]
         */
        function noop() {
          // No operation performed.
        }

        /**
         * Creates a function that gets the argument at index `n`. If `n` is negative,
         * the nth argument from the end is returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {number} [n=0] The index of the argument to return.
         * @returns {Function} Returns the new pass-thru function.
         * @example
         *
         * var func = _.nthArg(1);
         * func('a', 'b', 'c', 'd');
         * // => 'b'
         *
         * var func = _.nthArg(-2);
         * func('a', 'b', 'c', 'd');
         * // => 'c'
         */
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function (args) {
            return baseNth(args, n);
          });
        }

        /**
         * Creates a function that invokes `iteratees` with the arguments it receives
         * and returns their results.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [iteratees=[_.identity]]
         *  The iteratees to invoke.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.over([Math.max, Math.min]);
         *
         * func(1, 2, 3, 4);
         * // => [4, 1]
         */
        var over = createOver(arrayMap);

        /**
         * Creates a function that checks if **all** of the `predicates` return
         * truthy when invoked with the arguments it receives.
         *
         * Following shorthands are possible for providing predicates.
         * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
         * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [predicates=[_.identity]]
         *  The predicates to check.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.overEvery([Boolean, isFinite]);
         *
         * func('1');
         * // => true
         *
         * func(null);
         * // => false
         *
         * func(NaN);
         * // => false
         */
        var overEvery = createOver(arrayEvery);

        /**
         * Creates a function that checks if **any** of the `predicates` return
         * truthy when invoked with the arguments it receives.
         *
         * Following shorthands are possible for providing predicates.
         * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
         * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [predicates=[_.identity]]
         *  The predicates to check.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.overSome([Boolean, isFinite]);
         *
         * func('1');
         * // => true
         *
         * func(null);
         * // => true
         *
         * func(NaN);
         * // => false
         *
         * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
         * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
         */
        var overSome = createOver(arraySome);

        /**
         * Creates a function that returns the value at `path` of a given object.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         * @example
         *
         * var objects = [
         *   { 'a': { 'b': 2 } },
         *   { 'a': { 'b': 1 } }
         * ];
         *
         * _.map(objects, _.property('a.b'));
         * // => [2, 1]
         *
         * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
         * // => [1, 2]
         */
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }

        /**
         * The opposite of `_.property`; this method creates a function that returns
         * the value at a given path of `object`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Object} object The object to query.
         * @returns {Function} Returns the new accessor function.
         * @example
         *
         * var array = [0, 1, 2],
         *     object = { 'a': array, 'b': array, 'c': array };
         *
         * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
         * // => [2, 0]
         *
         * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
         * // => [2, 0]
         */
        function propertyOf(object) {
          return function (path) {
            return object == null ? undefined : baseGet(object, path);
          };
        }

        /**
         * Creates an array of numbers (positive and/or negative) progressing from
         * `start` up to, but not including, `end`. A step of `-1` is used if a negative
         * `start` is specified without an `end` or `step`. If `end` is not specified,
         * it's set to `start` with `start` then set to `0`.
         *
         * **Note:** JavaScript follows the IEEE-754 standard for resolving
         * floating-point values which can produce unexpected results.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @param {number} [step=1] The value to increment or decrement by.
         * @returns {Array} Returns the range of numbers.
         * @see _.inRange, _.rangeRight
         * @example
         *
         * _.range(4);
         * // => [0, 1, 2, 3]
         *
         * _.range(-4);
         * // => [0, -1, -2, -3]
         *
         * _.range(1, 5);
         * // => [1, 2, 3, 4]
         *
         * _.range(0, 20, 5);
         * // => [0, 5, 10, 15]
         *
         * _.range(0, -4, -1);
         * // => [0, -1, -2, -3]
         *
         * _.range(1, 4, 0);
         * // => [1, 1, 1]
         *
         * _.range(0);
         * // => []
         */
        var range = createRange();

        /**
         * This method is like `_.range` except that it populates values in
         * descending order.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @param {number} [step=1] The value to increment or decrement by.
         * @returns {Array} Returns the range of numbers.
         * @see _.inRange, _.range
         * @example
         *
         * _.rangeRight(4);
         * // => [3, 2, 1, 0]
         *
         * _.rangeRight(-4);
         * // => [-3, -2, -1, 0]
         *
         * _.rangeRight(1, 5);
         * // => [4, 3, 2, 1]
         *
         * _.rangeRight(0, 20, 5);
         * // => [15, 10, 5, 0]
         *
         * _.rangeRight(0, -4, -1);
         * // => [-3, -2, -1, 0]
         *
         * _.rangeRight(1, 4, 0);
         * // => [1, 1, 1]
         *
         * _.rangeRight(0);
         * // => []
         */
        var rangeRight = createRange(true);

        /**
         * This method returns a new empty array.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {Array} Returns the new empty array.
         * @example
         *
         * var arrays = _.times(2, _.stubArray);
         *
         * console.log(arrays);
         * // => [[], []]
         *
         * console.log(arrays[0] === arrays[1]);
         * // => false
         */
        function stubArray() {
          return [];
        }

        /**
         * This method returns `false`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `false`.
         * @example
         *
         * _.times(2, _.stubFalse);
         * // => [false, false]
         */
        function stubFalse() {
          return false;
        }

        /**
         * This method returns a new empty object.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {Object} Returns the new empty object.
         * @example
         *
         * var objects = _.times(2, _.stubObject);
         *
         * console.log(objects);
         * // => [{}, {}]
         *
         * console.log(objects[0] === objects[1]);
         * // => false
         */
        function stubObject() {
          return {};
        }

        /**
         * This method returns an empty string.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {string} Returns the empty string.
         * @example
         *
         * _.times(2, _.stubString);
         * // => ['', '']
         */
        function stubString() {
          return '';
        }

        /**
         * This method returns `true`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `true`.
         * @example
         *
         * _.times(2, _.stubTrue);
         * // => [true, true]
         */
        function stubTrue() {
          return true;
        }

        /**
         * Invokes the iteratee `n` times, returning an array of the results of
         * each invocation. The iteratee is invoked with one argument; (index).
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {number} n The number of times to invoke `iteratee`.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the array of results.
         * @example
         *
         * _.times(3, String);
         * // => ['0', '1', '2']
         *
         *  _.times(4, _.constant(0));
         * // => [0, 0, 0, 0]
         */
        function times(n, iteratee) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH,
            length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee = getIteratee(iteratee);
          n -= MAX_ARRAY_LENGTH;
          var result = baseTimes(length, iteratee);
          while (++index < n) {
            iteratee(index);
          }
          return result;
        }

        /**
         * Converts `value` to a property path array.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {*} value The value to convert.
         * @returns {Array} Returns the new property path array.
         * @example
         *
         * _.toPath('a.b.c');
         * // => ['a', 'b', 'c']
         *
         * _.toPath('a[0].b.c');
         * // => ['a', '0', 'b', 'c']
         */
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }

        /**
         * Generates a unique ID. If `prefix` is given, the ID is appended to it.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {string} [prefix=''] The value to prefix the ID with.
         * @returns {string} Returns the unique ID.
         * @example
         *
         * _.uniqueId('contact_');
         * // => 'contact_104'
         *
         * _.uniqueId();
         * // => '105'
         */
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }

        /*------------------------------------------------------------------------*/

        /**
         * Adds two numbers.
         *
         * @static
         * @memberOf _
         * @since 3.4.0
         * @category Math
         * @param {number} augend The first number in an addition.
         * @param {number} addend The second number in an addition.
         * @returns {number} Returns the total.
         * @example
         *
         * _.add(6, 4);
         * // => 10
         */
        var add = createMathOperation(function (augend, addend) {
          return augend + addend;
        }, 0);

        /**
         * Computes `number` rounded up to `precision`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Math
         * @param {number} number The number to round up.
         * @param {number} [precision=0] The precision to round up to.
         * @returns {number} Returns the rounded up number.
         * @example
         *
         * _.ceil(4.006);
         * // => 5
         *
         * _.ceil(6.004, 2);
         * // => 6.01
         *
         * _.ceil(6040, -2);
         * // => 6100
         */
        var ceil = createRound('ceil');

        /**
         * Divide two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {number} dividend The first number in a division.
         * @param {number} divisor The second number in a division.
         * @returns {number} Returns the quotient.
         * @example
         *
         * _.divide(6, 4);
         * // => 1.5
         */
        var divide = createMathOperation(function (dividend, divisor) {
          return dividend / divisor;
        }, 1);

        /**
         * Computes `number` rounded down to `precision`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Math
         * @param {number} number The number to round down.
         * @param {number} [precision=0] The precision to round down to.
         * @returns {number} Returns the rounded down number.
         * @example
         *
         * _.floor(4.006);
         * // => 4
         *
         * _.floor(0.046, 2);
         * // => 0.04
         *
         * _.floor(4060, -2);
         * // => 4000
         */
        var floor = createRound('floor');

        /**
         * Computes the maximum value of `array`. If `array` is empty or falsey,
         * `undefined` is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {*} Returns the maximum value.
         * @example
         *
         * _.max([4, 2, 8, 6]);
         * // => 8
         *
         * _.max([]);
         * // => undefined
         */
        function max(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }

        /**
         * This method is like `_.max` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * the value is ranked. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {*} Returns the maximum value.
         * @example
         *
         * var objects = [{ 'n': 1 }, { 'n': 2 }];
         *
         * _.maxBy(objects, function(o) { return o.n; });
         * // => { 'n': 2 }
         *
         * // The `_.property` iteratee shorthand.
         * _.maxBy(objects, 'n');
         * // => { 'n': 2 }
         */
        function maxBy(array, iteratee) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }

        /**
         * Computes the mean of the values in `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {number} Returns the mean.
         * @example
         *
         * _.mean([4, 2, 8, 6]);
         * // => 5
         */
        function mean(array) {
          return baseMean(array, identity);
        }

        /**
         * This method is like `_.mean` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the value to be averaged.
         * The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the mean.
         * @example
         *
         * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
         *
         * _.meanBy(objects, function(o) { return o.n; });
         * // => 5
         *
         * // The `_.property` iteratee shorthand.
         * _.meanBy(objects, 'n');
         * // => 5
         */
        function meanBy(array, iteratee) {
          return baseMean(array, getIteratee(iteratee, 2));
        }

        /**
         * Computes the minimum value of `array`. If `array` is empty or falsey,
         * `undefined` is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {*} Returns the minimum value.
         * @example
         *
         * _.min([4, 2, 8, 6]);
         * // => 2
         *
         * _.min([]);
         * // => undefined
         */
        function min(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }

        /**
         * This method is like `_.min` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * the value is ranked. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {*} Returns the minimum value.
         * @example
         *
         * var objects = [{ 'n': 1 }, { 'n': 2 }];
         *
         * _.minBy(objects, function(o) { return o.n; });
         * // => { 'n': 1 }
         *
         * // The `_.property` iteratee shorthand.
         * _.minBy(objects, 'n');
         * // => { 'n': 1 }
         */
        function minBy(array, iteratee) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }

        /**
         * Multiply two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {number} multiplier The first number in a multiplication.
         * @param {number} multiplicand The second number in a multiplication.
         * @returns {number} Returns the product.
         * @example
         *
         * _.multiply(6, 4);
         * // => 24
         */
        var multiply = createMathOperation(function (multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);

        /**
         * Computes `number` rounded to `precision`.
         *
         * @static
         * @memberOf _
         * @since 3.10.0
         * @category Math
         * @param {number} number The number to round.
         * @param {number} [precision=0] The precision to round to.
         * @returns {number} Returns the rounded number.
         * @example
         *
         * _.round(4.006);
         * // => 4
         *
         * _.round(4.006, 2);
         * // => 4.01
         *
         * _.round(4060, -2);
         * // => 4100
         */
        var round = createRound('round');

        /**
         * Subtract two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {number} minuend The first number in a subtraction.
         * @param {number} subtrahend The second number in a subtraction.
         * @returns {number} Returns the difference.
         * @example
         *
         * _.subtract(6, 4);
         * // => 2
         */
        var subtract = createMathOperation(function (minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);

        /**
         * Computes the sum of the values in `array`.
         *
         * @static
         * @memberOf _
         * @since 3.4.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {number} Returns the sum.
         * @example
         *
         * _.sum([4, 2, 8, 6]);
         * // => 20
         */
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }

        /**
         * This method is like `_.sum` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the value to be summed.
         * The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the sum.
         * @example
         *
         * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
         *
         * _.sumBy(objects, function(o) { return o.n; });
         * // => 20
         *
         * // The `_.property` iteratee shorthand.
         * _.sumBy(objects, 'n');
         * // => 20
         */
        function sumBy(array, iteratee) {
          return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }

        /*------------------------------------------------------------------------*/

        // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;

        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;

        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);

        /*------------------------------------------------------------------------*/

        // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;

        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function () {
          var source = {};
          baseForOwn(lodash, function (func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), {
          'chain': false
        });

        /*------------------------------------------------------------------------*/

        /**
         * The semantic version number.
         *
         * @static
         * @memberOf _
         * @type {string}
         */
        lodash.VERSION = VERSION;

        // Assign default placeholders.
        arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
          lodash[methodName].placeholder = lodash;
        });

        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach(['drop', 'take'], function (methodName, index) {
          LazyWrapper.prototype[methodName] = function (n) {
            n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
            var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
            if (result.__filtered__) {
              result.__takeCount__ = nativeMin(n, result.__takeCount__);
            } else {
              result.__views__.push({
                'size': nativeMin(n, MAX_ARRAY_LENGTH),
                'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
              });
            }
            return result;
          };
          LazyWrapper.prototype[methodName + 'Right'] = function (n) {
            return this.reverse()[methodName](n).reverse();
          };
        });

        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
          var type = index + 1,
            isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function (iteratee) {
            var result = this.clone();
            result.__iteratees__.push({
              'iteratee': getIteratee(iteratee, 3),
              'type': type
            });
            result.__filtered__ = result.__filtered__ || isFilter;
            return result;
          };
        });

        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach(['head', 'last'], function (methodName, index) {
          var takeName = 'take' + (index ? 'Right' : '');
          LazyWrapper.prototype[methodName] = function () {
            return this[takeName](1).value()[0];
          };
        });

        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach(['initial', 'tail'], function (methodName, index) {
          var dropName = 'drop' + (index ? '' : 'Right');
          LazyWrapper.prototype[methodName] = function () {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function () {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function (predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function (predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
          if (typeof path == 'function') {
            return new LazyWrapper(this);
          }
          return this.map(function (value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function (predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function (start, end) {
          start = toInteger(start);
          var result = this;
          if (result.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result);
          }
          if (start < 0) {
            result = result.takeRight(-start);
          } else if (start) {
            result = result.drop(start);
          }
          if (end !== undefined) {
            end = toInteger(end);
            result = end < 0 ? result.dropRight(-end) : result.take(end - start);
          }
          return result;
        };
        LazyWrapper.prototype.takeRightWhile = function (predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function () {
          return this.take(MAX_ARRAY_LENGTH);
        };

        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function (func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
            isTaker = /^(?:head|last)$/.test(methodName),
            lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
            retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function () {
            var value = this.__wrapped__,
              args = isTaker ? [1] : arguments,
              isLazy = value instanceof LazyWrapper,
              iteratee = args[0],
              useLazy = isLazy || isArray(value);
            var interceptor = function (value) {
              var result = lodashFunc.apply(lodash, arrayPush([value], args));
              return isTaker && chainAll ? result[0] : result;
            };
            if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
              // Avoid lazy use if the iteratee has a "length" value other than `1`.
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__,
              isHybrid = !!this.__actions__.length,
              isUnwrapped = retUnwrapped && !chainAll,
              onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result = func.apply(value, args);
              result.__actions__.push({
                'func': thru,
                'args': [interceptor],
                'thisArg': undefined
              });
              return new LodashWrapper(result, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
          };
        });

        // Add `Array` methods to `lodash.prototype`.
        arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
          var func = arrayProto[methodName],
            chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
            retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function () {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function (value) {
              return func.apply(isArray(value) ? value : [], args);
            });
          };
        });

        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function (func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + '';
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({
              'name': methodName,
              'func': lodashFunc
            });
          }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
          'name': 'wrapper',
          'func': undefined
        }];

        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;

        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };

      /*--------------------------------------------------------------------------*/

      // Export lodash.
      var _ = runInContext();

      // Some AMD build optimizers, like r.js, check for condition patterns like:
      if (true) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;

        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return _;
        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      }
      // Check for `exports` after `define` in case a build optimizer adds it.
      else {}
    }).call(this);

    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(36), __webpack_require__(47)(module));

  /***/
}, /* 58 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _reactTooltip = _interopRequireDefault(__webpack_require__(60));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var EnhancedTooltip = /*#__PURE__*/function (_React$Component) {
    _inherits(EnhancedTooltip, _React$Component);
    var _super = _createSuper(EnhancedTooltip);
    function EnhancedTooltip() {
      _classCallCheck(this, EnhancedTooltip);
      return _super.apply(this, arguments);
    }
    _createClass(EnhancedTooltip, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          place = _this$props.place,
          type = _this$props.type,
          effect = _this$props.effect,
          content = _this$props.content;
        return /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
          id: id,
          className: className,
          place: place,
          type: type,
          effect: effect
        }, content);
      }
    }]);
    return EnhancedTooltip;
  }(_react["default"].Component);
  exports["default"] = EnhancedTooltip;
  _defineProperty(EnhancedTooltip, "propTypes", {
    /** ID matching the `data-for` attribute of the tooltip linked component */
    id: _propTypes["default"].string.isRequired,
    /** What is the placement of the tooltip */
    place: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left']),
    /** Sets the general theme and style of the tooltip */
    type: _propTypes["default"].oneOf(['dark', 'success', 'warning', 'error', 'info', 'light']),
    /** Tooltip moves with cursor or holds position */
    effect: _propTypes["default"].oneOf(['float', 'solid']),
    /** Text or JSX content rendered inside of the tooltip */
    content: _propTypes["default"].any.isRequired
  });
  _defineProperty(EnhancedTooltip, "defaultProps", {
    place: 'top',
    type: 'dark',
    effect: 'solid'
  });

  /***/
}, /* 59 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.VAST_AUDIO = exports.STATUS_MAP = exports.SOCIAL_AD_TYPE_LIST = exports.SOCIAL_AD_TYPES = exports.QATerritories = exports.PREROLL = exports.PARTNER_VAST = exports.NATIVE_IMAGE = exports.MAX_GROWL = exports.MAX_DYNAMIC_SOCIAL_VERSIONS = exports.INCOMPLETE_STATUS = exports.IMPOSIUM_TYPE = exports.DYNAMIC_SOCIAL_AD_TYPES = exports.DYNAMIC_PREROLL = exports.DISPLAY_HTML_TAG = exports.DATE_FORMAT = exports.CLICK_TAG_NA_NUM = exports.CAROUSEL_AD_TYPES = exports.AD_TYPES_BY_LABEL = exports.AD_TYPES = exports.ADSTUDIO_TYPE = void 0;
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  var DATE_FORMAT = {
    us: "MM/DD/YYYY",
    uk: "DD/MM/YYYY",
    iso: "YYYY-MM-DDTHH:mm:ssZZ",
    endpoint: "YYYY-MM-DD",
    ukMulti: ["DD/MM/YYYY", "D/MM/YYYY", "DD/M/YYYY", "D/M/YYYY"],
    usMulti: ["MM/DD/YYYY", "MM/D/YYYY", "M/DD/YYYY", "M/D/YYYY"]
  };

  /*
   * constants representing creative `adType` value for different social ad types
   * https://flashtalkingus.atlassian.net/wiki/spaces/BLD/pages/2925166593/Social+adTypes+and+properties
  */
  exports.DATE_FORMAT = DATE_FORMAT;
  var SOCIAL_AD_TYPES = {
    FACEBOOK_IMAGE: 'facebookImage',
    FACEBOOK_VIDEO: 'facebookVideo',
    FACEBOOK_IMAGE_MO: 'facebookImageMO',
    FACEBOOK_VIDEO_MO: 'facebookVideoMO',
    FACEBOOK_CAROUSEL: 'facebookCarousel',
    FACEBOOK_CAROUSEL_MO: 'facebookCarouselMO',
    GOOGLE_DEMAND_GEN_IMAGE: 'googleDiscMulti',
    GOOGLE_DEMAND_GEN_VIDEO: 'googleDiscVideo',
    GOOGLE_DEMAND_GEN_CAROUSEL: 'googleDiscCarousel',
    LINKEDIN_IMAGE: 'linkedInImage',
    LINKEDIN_VIDEO: 'linkedInVideo',
    LINKEDIN_CAROUSEL: 'linkedInCarousel',
    PINTEREST_IMAGE: 'pinterestImage',
    PINTEREST_VIDEO: 'pinterestVideo',
    PINTEREST_MAX_W_VIDEO: 'pinterestMaxWVideo',
    PINTEREST_CAROUSEL: 'pinterestCarousel',
    SNAPCHAT_IMAGE: 'snapImage',
    SNAPCHAT_VIDEO: 'snapVideo',
    TIKTOK_VIDEO: 'tiktokVideo',
    TWITTER_IMAGE: 'twitterImage',
    TWITTER_VIDEO: 'twitterVideo',
    YOUTUBE_DISCOVERY: 'youTubeDiscovery',
    YOUTUBE_INSTREAM: 'youTubeInStream'
  };
  exports.SOCIAL_AD_TYPES = SOCIAL_AD_TYPES;
  var SOCIAL_AD_TYPE_LIST = Object.values(SOCIAL_AD_TYPES);
  exports.SOCIAL_AD_TYPE_LIST = SOCIAL_AD_TYPE_LIST;
  var CAROUSEL_AD_TYPES = SOCIAL_AD_TYPE_LIST.filter(function (item) {
    return /carousel/i.test(item);
  });
  exports.CAROUSEL_AD_TYPES = CAROUSEL_AD_TYPES;
  var DYNAMIC_SOCIAL_AD_TYPES = [SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO, SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO, SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO, SOCIAL_AD_TYPES.LINKEDIN_IMAGE, SOCIAL_AD_TYPES.LINKEDIN_VIDEO, SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL, SOCIAL_AD_TYPES.PINTEREST_IMAGE, SOCIAL_AD_TYPES.PINTEREST_VIDEO, SOCIAL_AD_TYPES.PINTEREST_CAROUSEL, SOCIAL_AD_TYPES.PINTEREST_MAX_WIDTH_VIDEO, SOCIAL_AD_TYPES.SNAPCHAT_IMAGE, SOCIAL_AD_TYPES.SNAPCHAT_VIDEO, SOCIAL_AD_TYPES.TIKTOK_VIDEO];
  exports.DYNAMIC_SOCIAL_AD_TYPES = DYNAMIC_SOCIAL_AD_TYPES;
  var MAX_DYNAMIC_SOCIAL_VERSIONS = 500;
  exports.MAX_DYNAMIC_SOCIAL_VERSIONS = MAX_DYNAMIC_SOCIAL_VERSIONS;
  var NATIVE_IMAGE = "native_image";
  exports.NATIVE_IMAGE = NATIVE_IMAGE;
  var ADSTUDIO_TYPE = "adstudio";
  exports.ADSTUDIO_TYPE = ADSTUDIO_TYPE;
  var IMPOSIUM_TYPE = "imposium";
  exports.IMPOSIUM_TYPE = IMPOSIUM_TYPE;
  var DYNAMIC_PREROLL = "dynamic_preroll";
  exports.DYNAMIC_PREROLL = DYNAMIC_PREROLL;
  var DISPLAY_HTML_TAG = "display_html_tag";
  exports.DISPLAY_HTML_TAG = DISPLAY_HTML_TAG;
  var PREROLL = "preroll";
  exports.PREROLL = PREROLL;
  var VAST_AUDIO = "vastAudio";
  exports.VAST_AUDIO = VAST_AUDIO;
  var PARTNER_VAST = "vast_tag";

  /**
   * `AD_TYPES` and `AD_TYPES_BY_LABEL` are for mapping between ad types and associated labels and other values,
   * located in Rhombus so they can be treated more consistently across Flashtalking UI projects.
   *
   * `AD_TYPES_BY_LABEL` just provides a way to find the correct `adType` string when starting from a UI label,
   * which may be useful for constructing API requests, etc.  Its structure is like:
   * 	{
   * 		"Facebook Video": "facebookVideo",
   * 		"YouTube TrueView In-Stream": "youTubeInStream"
   * 	}
   *
   * You may also combine them if needed.  e.g.
   *
   * 	let adType = AD_TYPES_BY_LABEL["Decision Sheet"];
   * 	let { placementType } = AD_TYPES[adType]; // placementType === "hedge"
   *
   * Source: https://flashtalkingus.atlassian.net/wiki/spaces/PM/pages/1177157641/Ad+Type+Mapping
  *
  	MO Types have an extra space, intentionally, just so that they're not identical strings
      to the FT types, and can be used for reverse lookup, but not display differently in the UI.
  */
  exports.PARTNER_VAST = PARTNER_VAST;
  var AD_TYPES = {
    facebookImage: {
      label: "Facebook Image",
      measurementSource: "Provided",
      platform: "Facebook",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Facebook",
      adFormat: "Image"
    },
    facebookVideo: {
      label: "Facebook Video",
      measurementSource: "Provided",
      platform: "Facebook",
      mediaFormat: "Video",
      adChannel: "Social Video",
      placementType: "Facebook",
      adFormat: "Video"
    },
    facebookImageMO: {
      label: "Facebook  Image",
      measurementSource: "Provided",
      platform: "Facebook",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Facebook",
      adFormat: "Image"
    },
    facebookVideoMO: {
      label: "Facebook  Video",
      measurementSource: "Provided",
      platform: "Facebook",
      mediaFormat: "Video",
      adChannel: "Social Video",
      placementType: "Facebook",
      adFormat: "Video"
    },
    facebookCarouselMO: {
      label: "Facebook  Carousel",
      platform: "Facebook",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Facebook",
      adFormat: "facebookCarouselMO"
    },
    facebookCarousel: {
      label: "Facebook Carousel",
      platform: "Facebook",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Facebook",
      adFormat: "facebookCarousel"
    },
    youTubeInStream: {
      label: "YouTube TrueView In-Stream",
      measurementSource: "Provided",
      platform: "YouTube",
      mediaFormat: "Video",
      adChannel: "Social Video",
      placementType: "YouTube TrueView",
      adFormat: "Video"
    },
    youTubeDiscovery: {
      label: "YouTube TrueView Discovery",
      measurementSource: "Provided",
      platform: "YouTube",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "YouTube TrueView",
      adFormat: "Image"
    },
    altimage: {
      label: "Image",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Display",
      adChannel: "Open Display",
      placementType: "HTML",
      adFormat: "Image"
    },
    HTML_onpage: {
      label: "Enhanced",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Display",
      adChannel: "Open Display",
      placementType: "HTML",
      adFormat: "Enhanced"
    },
    HTML_standard: {
      label: "Standard",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Display",
      adChannel: "Open Display",
      placementType: "HTML",
      adFormat: "Standard"
    },
    HTML_expand: {
      label: "Expandable",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Display",
      adChannel: "Open Display",
      placementType: "HTML",
      adFormat: "Expandable"
    },
    display_html_tag: {
      label: "Partner Tag",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Display",
      adChannel: "Open Display",
      placementType: "HTML",
      adFormat: "Partner Tag"
    },
    pixel: {
      label: "Pixel",
      measurementSource: "Measured",
      platform: "Various",
      mediaFormat: "Various",
      adChannel: "Various",
      placementType: "Pixel",
      adFormat: "Pixel"
    },
    track: {
      label: "Tracker",
      measurementSource: "Measured",
      platform: "Various",
      mediaFormat: "Various",
      adChannel: "Various",
      placementType: "Pixel",
      adFormat: "Tracker"
    },
    native_image: {
      label: "Native Image",
      measurementSource: "Measured",
      platform: "Native",
      mediaFormat: "Display",
      adChannel: "Native Display",
      placementType: "Native",
      adFormat: "Image"
    },
    preroll: {
      label: "VAST",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Video",
      adChannel: "Open Video",
      placementType: "VAST",
      adFormat: "VAST"
    },
    dynamic_preroll: {
      label: "Dynamic VAST",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Video",
      adChannel: "Open Video",
      placementType: "VAST",
      adFormat: "VAST"
    },
    JsVPaid: {
      label: "VPAID",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Video",
      adChannel: "Open Video",
      placementType: "VAST",
      adFormat: "VPAID"
    },
    vastAudio: {
      label: "VAST Audio",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Audio",
      adChannel: "Open Audio",
      placementType: "VAST Audio",
      adFormat: "VAST Audio"
    },
    dtree: {
      label: "Decision Tree (Legacy)",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Display/Video",
      adChannel: "Various",
      placementType: "HTML/VAST",
      adFormat: "Various"
    },
    modern_dtree: {
      label: "Decision Tree",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Display/Video",
      adChannel: "Various",
      placementType: "HTML/VAST",
      adFormat: "Various"
    },
    hedge: {
      label: "Decision Sheet",
      measurementSource: "Measured",
      platform: "Open",
      mediaFormat: "Display/Video",
      adChannel: "Various",
      placementType: "HTML/VAST",
      adFormat: "Various"
    },
    tiktokVideo: {
      label: "Tiktok In-Feed Video Ad",
      platform: "TikTok",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "TikTok",
      adFormat: "tiktokVideo"
    },
    pinterestImage: {
      label: "Pinterest Image Pin",
      platform: "Pinterest",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Pinterest",
      adFormat: "pinterestImage"
    },
    pinterestVideo: {
      label: "Pinterest Video Pin",
      platform: "Pinterest",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Pinterest",
      adFormat: "pinterestVideo"
    },
    pinterestMaxWVideo: {
      label: "Pinterest Max Width Video Pin",
      platform: "Pinterest",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Pinterest",
      adFormat: "pinterestMaxWVideo"
    },
    pinterestCarousel: {
      label: "Pinterest Carousel",
      platform: "Pinterest",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Pinterest",
      adFormat: "pinterestCarousel"
    },
    linkedInImage: {
      label: "LinkedIn Sponsored Image",
      platform: "LinkedIn",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "LinkedIn",
      adFormat: "linkedInImage"
    },
    linkedInVideo: {
      label: "LinkedIn Sponsored Video",
      platform: "LinkedIn",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "LinkedIn",
      adFormat: "linkedInVideo"
    },
    linkedInCarousel: {
      label: "LinkedIn Sponsored Carousel",
      platform: "LinkedIn",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "LinkedIn",
      adFormat: "linkedInCarousel"
    },
    twitterImage: {
      label: "Twitter Image Website Card",
      platform: "Twitter",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Twitter",
      adFormat: "twitterImage"
    },
    twitterVideo: {
      label: "Twitter Video Website Card",
      platform: "Twitter",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Twitter",
      adFormat: "twitterVideo"
    },
    twitterCarousel: {
      label: "Twitter Website Carousel",
      platform: "Twitter",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Twitter",
      adFormat: "twitterCarousel"
    },
    snapchatImage: {
      label: "Snapchat Web View Image",
      platform: "Snapchat",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Snapchat",
      adFormat: "snapImage"
    },
    snapchatVideo: {
      label: "Snapchat Web View Video",
      platform: "Snapchat",
      measurementSource: "Provided",
      mediaFormat: "Display",
      adChannel: "Social Display",
      placementType: "Snapchat",
      adFormat: "snapVideo"
    }
  };
  exports.AD_TYPES = AD_TYPES;
  var AD_TYPES_BY_LABEL = Object.entries(AD_TYPES).reduce(function (prev, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    prev[value.label] = key;
    return prev;
  }, {});
  exports.AD_TYPES_BY_LABEL = AD_TYPES_BY_LABEL;
  var MAX_GROWL = 7000000;
  exports.MAX_GROWL = MAX_GROWL;
  var STATUS_MAP = {
    failed: {
      label: "Rejected",
      icon: "rejected",
      labelClass: "in-rejected"
    },
    submitted: {
      label: "QA",
      icon: "fas fa-map-marker-question",
      labelClass: "in-qa"
    },
    unsubmitted: {
      label: "Production",
      icon: "deleted",
      labelClass: "in-production"
    },
    pending_approval: {
      label: "Approving",
      icon: "fas fa-bullseye",
      labelClass: "in-approving"
    },
    approved: {
      label: "Approved",
      icon: "approved",
      labelClass: "in-approved"
    },
    live: {
      label: "live",
      icon: "approved",
      labelClass: "in-approved"
    },
    unknown: {
      label: "unknown",
      icon: "fas fa-thumbtack",
      labelClass: "in-unknown in-production"
    },
    "pending approval": {
      label: "Approving",
      icon: "fas fa-bullseye",
      labelClass: "in-approving"
    },
    transcoding: {
      label: "Processing",
      icon: "fas fa-file-video",
      labelClass: "in-transcoding"
    },
    transcoding_error: {
      label: "Processing Error",
      icon: "video-plus",
      labelClass: "transcoding-error"
    },
    production_incomplete: {
      label: "Production-Incomplete",
      icon: "errorT",
      labelClass: "production-incomplete",
      tooltipLabel: "Some creative assets are missing or invalid"
    },
    rejected_incomplete: {
      label: "Rejected-Incomplete",
      icon: "errorT",
      labelClass: "rejected-incomplete",
      tooltipLabel: "Missing required assets"
    },
    // CreativePreviews Status Map Values
    not_shared: {
      label: "Not Shared",
      labelClass: "production-incomplete"
    },
    available: {
      label: "Available",
      labelClass: "in-approved"
    },
    expired: {
      label: "Expired",
      labelClass: "in-rejected"
    }
  };

  /* Num of Click Tags for filter Dictionary */
  exports.STATUS_MAP = STATUS_MAP;
  var CLICK_TAG_NA_NUM = -1;
  exports.CLICK_TAG_NA_NUM = CLICK_TAG_NA_NUM;
  var QATerritories = [{
    label: "UK",
    value: 1
  }, {
    label: "DE",
    value: 2
  }, {
    label: "US",
    value: 3
  }, {
    label: "AU",
    value: 4
  }, {
    label: "NL",
    value: 5
  }];
  exports.QATerritories = QATerritories;
  var INCOMPLETE_STATUS = ["PRODUCTION_INCOMPLETE", "REJECTED_INCOMPLETE"];
  exports.INCOMPLETE_STATUS = INCOMPLETE_STATUS;

  /***/
}, /* 60 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* WEBPACK VAR INJECTION */
  (function (global) {
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "default", function () {
      return ReactTooltip;
    });
    /* harmony import */
    var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
    /* harmony import */
    var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */
    var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
    /* harmony import */
    var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */
    var uuid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76);
    function ownKeys$2(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function _objectSpread2(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
      return target;
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      Object.defineProperty(Constructor, "prototype", {
        writable: false
      });
      return Constructor;
    }
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function _extends() {
      _extends = Object.assign ? Object.assign.bind() : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
      return _extends.apply(this, arguments);
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      Object.defineProperty(subClass, "prototype", {
        writable: false
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }
    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
      return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;
      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }
    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return self;
    }
    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      } else if (call !== void 0) {
        throw new TypeError("Derived constructors may only return object or undefined");
      }
      return _assertThisInitialized(self);
    }
    function _createSuper(Derived) {
      var hasNativeReflectConstruct = _isNativeReflectConstruct();
      return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
          result;
        if (hasNativeReflectConstruct) {
          var NewTarget = _getPrototypeOf(this).constructor;
          result = Reflect.construct(Super, arguments, NewTarget);
        } else {
          result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
      };
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    function _createForOfIteratorHelper(o, allowArrayLike) {
      var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
      if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
          if (it) o = it;
          var i = 0;
          var F = function () {};
          return {
            s: F,
            n: function () {
              if (i >= o.length) return {
                done: true
              };
              return {
                done: false,
                value: o[i++]
              };
            },
            e: function (e) {
              throw e;
            },
            f: F
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var normalCompletion = true,
        didErr = false,
        err;
      return {
        s: function () {
          it = it.call(o);
        },
        n: function () {
          var step = it.next();
          normalCompletion = step.done;
          return step;
        },
        e: function (e) {
          didErr = true;
          err = e;
        },
        f: function () {
          try {
            if (!normalCompletion && it.return != null) it.return();
          } finally {
            if (didErr) throw err;
          }
        }
      };
    }
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
    var check = function (it) {
      return it && it.Math == Math && it;
    };

    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global$a =
    // eslint-disable-next-line es/no-global-this -- safe
    check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) ||
    // eslint-disable-next-line no-restricted-globals -- safe
    check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
    // eslint-disable-next-line no-new-func -- fallback
    function () {
      return this;
    }() || Function('return this')();
    var objectGetOwnPropertyDescriptor = {};
    var fails$9 = function (exec) {
      try {
        return !!exec();
      } catch (error) {
        return true;
      }
    };
    var fails$8 = fails$9;

    // Detect IE8's incomplete defineProperty implementation
    var descriptors = !fails$8(function () {
      // eslint-disable-next-line es/no-object-defineproperty -- required for testing
      return Object.defineProperty({}, 1, {
        get: function () {
          return 7;
        }
      })[1] != 7;
    });
    var fails$7 = fails$9;
    var functionBindNative = !fails$7(function () {
      // eslint-disable-next-line es/no-function-prototype-bind -- safe
      var test = function () {/* empty */}.bind();
      // eslint-disable-next-line no-prototype-builtins -- safe
      return typeof test != 'function' || test.hasOwnProperty('prototype');
    });
    var NATIVE_BIND$2 = functionBindNative;
    var call$4 = Function.prototype.call;
    var functionCall = NATIVE_BIND$2 ? call$4.bind(call$4) : function () {
      return call$4.apply(call$4, arguments);
    };
    var objectPropertyIsEnumerable = {};
    var $propertyIsEnumerable = {}.propertyIsEnumerable;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

    // Nashorn ~ JDK8 bug
    var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({
      1: 2
    }, 1);

    // `Object.prototype.propertyIsEnumerable` method implementation
    // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
    objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
      var descriptor = getOwnPropertyDescriptor$1(this, V);
      return !!descriptor && descriptor.enumerable;
    } : $propertyIsEnumerable;
    var createPropertyDescriptor$2 = function (bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
      };
    };
    var NATIVE_BIND$1 = functionBindNative;
    var FunctionPrototype$1 = Function.prototype;
    var call$3 = FunctionPrototype$1.call;
    var uncurryThisWithBind = NATIVE_BIND$1 && FunctionPrototype$1.bind.bind(call$3, call$3);
    var functionUncurryThisRaw = function (fn) {
      return NATIVE_BIND$1 ? uncurryThisWithBind(fn) : function () {
        return call$3.apply(fn, arguments);
      };
    };
    var uncurryThisRaw$1 = functionUncurryThisRaw;
    var toString$1 = uncurryThisRaw$1({}.toString);
    var stringSlice = uncurryThisRaw$1(''.slice);
    var classofRaw$2 = function (it) {
      return stringSlice(toString$1(it), 8, -1);
    };
    var classofRaw$1 = classofRaw$2;
    var uncurryThisRaw = functionUncurryThisRaw;
    var functionUncurryThis = function (fn) {
      // Nashorn bug:
      //   https://github.com/zloirock/core-js/issues/1128
      //   https://github.com/zloirock/core-js/issues/1130
      if (classofRaw$1(fn) === 'Function') return uncurryThisRaw(fn);
    };
    var uncurryThis$9 = functionUncurryThis;
    var fails$6 = fails$9;
    var classof$3 = classofRaw$2;
    var $Object$3 = Object;
    var split = uncurryThis$9(''.split);

    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    var indexedObject = fails$6(function () {
      // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
      // eslint-disable-next-line no-prototype-builtins -- safe
      return !$Object$3('z').propertyIsEnumerable(0);
    }) ? function (it) {
      return classof$3(it) == 'String' ? split(it, '') : $Object$3(it);
    } : $Object$3;

    // we can't use just `it == null` since of `document.all` special case
    // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
    var isNullOrUndefined$2 = function (it) {
      return it === null || it === undefined;
    };
    var isNullOrUndefined$1 = isNullOrUndefined$2;
    var $TypeError$5 = TypeError;

    // `RequireObjectCoercible` abstract operation
    // https://tc39.es/ecma262/#sec-requireobjectcoercible
    var requireObjectCoercible$2 = function (it) {
      if (isNullOrUndefined$1(it)) throw $TypeError$5("Can't call method on " + it);
      return it;
    };

    // toObject with fallback for non-array-like ES3 strings
    var IndexedObject$1 = indexedObject;
    var requireObjectCoercible$1 = requireObjectCoercible$2;
    var toIndexedObject$4 = function (it) {
      return IndexedObject$1(requireObjectCoercible$1(it));
    };
    var documentAll$2 = typeof document == 'object' && document.all;

    // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
    var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;
    var documentAll_1 = {
      all: documentAll$2,
      IS_HTMLDDA: IS_HTMLDDA
    };
    var $documentAll$1 = documentAll_1;
    var documentAll$1 = $documentAll$1.all;

    // `IsCallable` abstract operation
    // https://tc39.es/ecma262/#sec-iscallable
    var isCallable$c = $documentAll$1.IS_HTMLDDA ? function (argument) {
      return typeof argument == 'function' || argument === documentAll$1;
    } : function (argument) {
      return typeof argument == 'function';
    };
    var isCallable$b = isCallable$c;
    var $documentAll = documentAll_1;
    var documentAll = $documentAll.all;
    var isObject$6 = $documentAll.IS_HTMLDDA ? function (it) {
      return typeof it == 'object' ? it !== null : isCallable$b(it) || it === documentAll;
    } : function (it) {
      return typeof it == 'object' ? it !== null : isCallable$b(it);
    };
    var global$9 = global$a;
    var isCallable$a = isCallable$c;
    var aFunction = function (argument) {
      return isCallable$a(argument) ? argument : undefined;
    };
    var getBuiltIn$5 = function (namespace, method) {
      return arguments.length < 2 ? aFunction(global$9[namespace]) : global$9[namespace] && global$9[namespace][method];
    };
    var uncurryThis$8 = functionUncurryThis;
    var objectIsPrototypeOf = uncurryThis$8({}.isPrototypeOf);
    var getBuiltIn$4 = getBuiltIn$5;
    var engineUserAgent = getBuiltIn$4('navigator', 'userAgent') || '';
    var global$8 = global$a;
    var userAgent = engineUserAgent;
    var process = global$8.process;
    var Deno = global$8.Deno;
    var versions = process && process.versions || Deno && Deno.version;
    var v8 = versions && versions.v8;
    var match, version;
    if (v8) {
      match = v8.split('.');
      // in old Chrome, versions of V8 isn't V8 = Chrome / 10
      // but their correct versions are not interesting for us
      version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
    }

    // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
    // so check `userAgent` even if `.v8` exists, but 0
    if (!version && userAgent) {
      match = userAgent.match(/Edge\/(\d+)/);
      if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
      }
    }
    var engineV8Version = version;

    /* eslint-disable es/no-symbol -- required for testing */

    var V8_VERSION = engineV8Version;
    var fails$5 = fails$9;

    // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
    var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$5(function () {
      var symbol = Symbol();
      // Chrome 38 Symbol has incorrect toString conversion
      // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
      return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
      // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
      !Symbol.sham && V8_VERSION && V8_VERSION < 41;
    });

    /* eslint-disable es/no-symbol -- required for testing */

    var NATIVE_SYMBOL$1 = symbolConstructorDetection;
    var useSymbolAsUid = NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == 'symbol';
    var getBuiltIn$3 = getBuiltIn$5;
    var isCallable$9 = isCallable$c;
    var isPrototypeOf = objectIsPrototypeOf;
    var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
    var $Object$2 = Object;
    var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
      return typeof it == 'symbol';
    } : function (it) {
      var $Symbol = getBuiltIn$3('Symbol');
      return isCallable$9($Symbol) && isPrototypeOf($Symbol.prototype, $Object$2(it));
    };
    var $String$1 = String;
    var tryToString$1 = function (argument) {
      try {
        return $String$1(argument);
      } catch (error) {
        return 'Object';
      }
    };
    var isCallable$8 = isCallable$c;
    var tryToString = tryToString$1;
    var $TypeError$4 = TypeError;

    // `Assert: IsCallable(argument) is true`
    var aCallable$2 = function (argument) {
      if (isCallable$8(argument)) return argument;
      throw $TypeError$4(tryToString(argument) + ' is not a function');
    };
    var aCallable$1 = aCallable$2;
    var isNullOrUndefined = isNullOrUndefined$2;

    // `GetMethod` abstract operation
    // https://tc39.es/ecma262/#sec-getmethod
    var getMethod$1 = function (V, P) {
      var func = V[P];
      return isNullOrUndefined(func) ? undefined : aCallable$1(func);
    };
    var call$2 = functionCall;
    var isCallable$7 = isCallable$c;
    var isObject$5 = isObject$6;
    var $TypeError$3 = TypeError;

    // `OrdinaryToPrimitive` abstract operation
    // https://tc39.es/ecma262/#sec-ordinarytoprimitive
    var ordinaryToPrimitive$1 = function (input, pref) {
      var fn, val;
      if (pref === 'string' && isCallable$7(fn = input.toString) && !isObject$5(val = call$2(fn, input))) return val;
      if (isCallable$7(fn = input.valueOf) && !isObject$5(val = call$2(fn, input))) return val;
      if (pref !== 'string' && isCallable$7(fn = input.toString) && !isObject$5(val = call$2(fn, input))) return val;
      throw $TypeError$3("Can't convert object to primitive value");
    };
    var shared$3 = {
      exports: {}
    };
    var global$7 = global$a;

    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var defineProperty$2 = Object.defineProperty;
    var defineGlobalProperty$3 = function (key, value) {
      try {
        defineProperty$2(global$7, key, {
          value: value,
          configurable: true,
          writable: true
        });
      } catch (error) {
        global$7[key] = value;
      }
      return value;
    };
    var global$6 = global$a;
    var defineGlobalProperty$2 = defineGlobalProperty$3;
    var SHARED = '__core-js_shared__';
    var store$3 = global$6[SHARED] || defineGlobalProperty$2(SHARED, {});
    var sharedStore = store$3;
    var store$2 = sharedStore;
    (shared$3.exports = function (key, value) {
      return store$2[key] || (store$2[key] = value !== undefined ? value : {});
    })('versions', []).push({
      version: '3.25.5',
      mode: 'global',
      copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
      license: 'https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE',
      source: 'https://github.com/zloirock/core-js'
    });
    var requireObjectCoercible = requireObjectCoercible$2;
    var $Object$1 = Object;

    // `ToObject` abstract operation
    // https://tc39.es/ecma262/#sec-toobject
    var toObject$2 = function (argument) {
      return $Object$1(requireObjectCoercible(argument));
    };
    var uncurryThis$7 = functionUncurryThis;
    var toObject$1 = toObject$2;
    var hasOwnProperty = uncurryThis$7({}.hasOwnProperty);

    // `HasOwnProperty` abstract operation
    // https://tc39.es/ecma262/#sec-hasownproperty
    // eslint-disable-next-line es/no-object-hasown -- safe
    var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
      return hasOwnProperty(toObject$1(it), key);
    };
    var uncurryThis$6 = functionUncurryThis;
    var id = 0;
    var postfix = Math.random();
    var toString = uncurryThis$6(1.0.toString);
    var uid$2 = function (key) {
      return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
    };
    var global$5 = global$a;
    var shared$2 = shared$3.exports;
    var hasOwn$6 = hasOwnProperty_1;
    var uid$1 = uid$2;
    var NATIVE_SYMBOL = symbolConstructorDetection;
    var USE_SYMBOL_AS_UID = useSymbolAsUid;
    var WellKnownSymbolsStore = shared$2('wks');
    var Symbol$1 = global$5.Symbol;
    var symbolFor = Symbol$1 && Symbol$1['for'];
    var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;
    var wellKnownSymbol$5 = function (name) {
      if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
        var description = 'Symbol.' + name;
        if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) {
          WellKnownSymbolsStore[name] = Symbol$1[name];
        } else if (USE_SYMBOL_AS_UID && symbolFor) {
          WellKnownSymbolsStore[name] = symbolFor(description);
        } else {
          WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
        }
      }
      return WellKnownSymbolsStore[name];
    };
    var call$1 = functionCall;
    var isObject$4 = isObject$6;
    var isSymbol$1 = isSymbol$2;
    var getMethod = getMethod$1;
    var ordinaryToPrimitive = ordinaryToPrimitive$1;
    var wellKnownSymbol$4 = wellKnownSymbol$5;
    var $TypeError$2 = TypeError;
    var TO_PRIMITIVE = wellKnownSymbol$4('toPrimitive');

    // `ToPrimitive` abstract operation
    // https://tc39.es/ecma262/#sec-toprimitive
    var toPrimitive$1 = function (input, pref) {
      if (!isObject$4(input) || isSymbol$1(input)) return input;
      var exoticToPrim = getMethod(input, TO_PRIMITIVE);
      var result;
      if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = call$1(exoticToPrim, input, pref);
        if (!isObject$4(result) || isSymbol$1(result)) return result;
        throw $TypeError$2("Can't convert object to primitive value");
      }
      if (pref === undefined) pref = 'number';
      return ordinaryToPrimitive(input, pref);
    };
    var toPrimitive = toPrimitive$1;
    var isSymbol = isSymbol$2;

    // `ToPropertyKey` abstract operation
    // https://tc39.es/ecma262/#sec-topropertykey
    var toPropertyKey$2 = function (argument) {
      var key = toPrimitive(argument, 'string');
      return isSymbol(key) ? key : key + '';
    };
    var global$4 = global$a;
    var isObject$3 = isObject$6;
    var document$1 = global$4.document;
    // typeof document.createElement is 'object' in old IE
    var EXISTS$1 = isObject$3(document$1) && isObject$3(document$1.createElement);
    var documentCreateElement$1 = function (it) {
      return EXISTS$1 ? document$1.createElement(it) : {};
    };
    var DESCRIPTORS$7 = descriptors;
    var fails$4 = fails$9;
    var createElement = documentCreateElement$1;

    // Thanks to IE8 for its funny defineProperty
    var ie8DomDefine = !DESCRIPTORS$7 && !fails$4(function () {
      // eslint-disable-next-line es/no-object-defineproperty -- required for testing
      return Object.defineProperty(createElement('div'), 'a', {
        get: function () {
          return 7;
        }
      }).a != 7;
    });
    var DESCRIPTORS$6 = descriptors;
    var call = functionCall;
    var propertyIsEnumerableModule = objectPropertyIsEnumerable;
    var createPropertyDescriptor$1 = createPropertyDescriptor$2;
    var toIndexedObject$3 = toIndexedObject$4;
    var toPropertyKey$1 = toPropertyKey$2;
    var hasOwn$5 = hasOwnProperty_1;
    var IE8_DOM_DEFINE$1 = ie8DomDefine;

    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
    objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
      O = toIndexedObject$3(O);
      P = toPropertyKey$1(P);
      if (IE8_DOM_DEFINE$1) try {
        return $getOwnPropertyDescriptor$1(O, P);
      } catch (error) {/* empty */}
      if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call(propertyIsEnumerableModule.f, O, P), O[P]);
    };
    var objectDefineProperty = {};
    var DESCRIPTORS$5 = descriptors;
    var fails$3 = fails$9;

    // V8 ~ Chrome 36-
    // https://bugs.chromium.org/p/v8/issues/detail?id=3334
    var v8PrototypeDefineBug = DESCRIPTORS$5 && fails$3(function () {
      // eslint-disable-next-line es/no-object-defineproperty -- required for testing
      return Object.defineProperty(function () {/* empty */}, 'prototype', {
        value: 42,
        writable: false
      }).prototype != 42;
    });
    var isObject$2 = isObject$6;
    var $String = String;
    var $TypeError$1 = TypeError;

    // `Assert: Type(argument) is Object`
    var anObject$4 = function (argument) {
      if (isObject$2(argument)) return argument;
      throw $TypeError$1($String(argument) + ' is not an object');
    };
    var DESCRIPTORS$4 = descriptors;
    var IE8_DOM_DEFINE = ie8DomDefine;
    var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
    var anObject$3 = anObject$4;
    var toPropertyKey = toPropertyKey$2;
    var $TypeError = TypeError;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var $defineProperty = Object.defineProperty;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var ENUMERABLE = 'enumerable';
    var CONFIGURABLE$1 = 'configurable';
    var WRITABLE = 'writable';

    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    objectDefineProperty.f = DESCRIPTORS$4 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
      anObject$3(O);
      P = toPropertyKey(P);
      anObject$3(Attributes);
      if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor(O, P);
        if (current && current[WRITABLE]) {
          O[P] = Attributes.value;
          Attributes = {
            configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
            enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
            writable: false
          };
        }
      }
      return $defineProperty(O, P, Attributes);
    } : $defineProperty : function defineProperty(O, P, Attributes) {
      anObject$3(O);
      P = toPropertyKey(P);
      anObject$3(Attributes);
      if (IE8_DOM_DEFINE) try {
        return $defineProperty(O, P, Attributes);
      } catch (error) {/* empty */}
      if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
      if ('value' in Attributes) O[P] = Attributes.value;
      return O;
    };
    var DESCRIPTORS$3 = descriptors;
    var definePropertyModule$3 = objectDefineProperty;
    var createPropertyDescriptor = createPropertyDescriptor$2;
    var createNonEnumerableProperty$2 = DESCRIPTORS$3 ? function (object, key, value) {
      return definePropertyModule$3.f(object, key, createPropertyDescriptor(1, value));
    } : function (object, key, value) {
      object[key] = value;
      return object;
    };
    var makeBuiltIn$2 = {
      exports: {}
    };
    var DESCRIPTORS$2 = descriptors;
    var hasOwn$4 = hasOwnProperty_1;
    var FunctionPrototype = Function.prototype;
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;
    var EXISTS = hasOwn$4(FunctionPrototype, 'name');
    // additional protection from minified / mangled / dropped function names
    var PROPER = EXISTS && function something() {/* empty */}.name === 'something';
    var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || DESCRIPTORS$2 && getDescriptor(FunctionPrototype, 'name').configurable);
    var functionName = {
      EXISTS: EXISTS,
      PROPER: PROPER,
      CONFIGURABLE: CONFIGURABLE
    };
    var uncurryThis$5 = functionUncurryThis;
    var isCallable$6 = isCallable$c;
    var store$1 = sharedStore;
    var functionToString = uncurryThis$5(Function.toString);

    // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
    if (!isCallable$6(store$1.inspectSource)) {
      store$1.inspectSource = function (it) {
        return functionToString(it);
      };
    }
    var inspectSource$2 = store$1.inspectSource;
    var global$3 = global$a;
    var isCallable$5 = isCallable$c;
    var WeakMap$1 = global$3.WeakMap;
    var weakMapBasicDetection = isCallable$5(WeakMap$1) && /native code/.test(String(WeakMap$1));
    var shared$1 = shared$3.exports;
    var uid = uid$2;
    var keys = shared$1('keys');
    var sharedKey$2 = function (key) {
      return keys[key] || (keys[key] = uid(key));
    };
    var hiddenKeys$4 = {};
    var NATIVE_WEAK_MAP = weakMapBasicDetection;
    var global$2 = global$a;
    var isObject$1 = isObject$6;
    var createNonEnumerableProperty$1 = createNonEnumerableProperty$2;
    var hasOwn$3 = hasOwnProperty_1;
    var shared = sharedStore;
    var sharedKey$1 = sharedKey$2;
    var hiddenKeys$3 = hiddenKeys$4;
    var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
    var TypeError$1 = global$2.TypeError;
    var WeakMap = global$2.WeakMap;
    var set, get, has;
    var enforce = function (it) {
      return has(it) ? get(it) : set(it, {});
    };
    var getterFor = function (TYPE) {
      return function (it) {
        var state;
        if (!isObject$1(it) || (state = get(it)).type !== TYPE) {
          throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
        }
        return state;
      };
    };
    if (NATIVE_WEAK_MAP || shared.state) {
      var store = shared.state || (shared.state = new WeakMap());
      /* eslint-disable no-self-assign -- prototype methods protection */
      store.get = store.get;
      store.has = store.has;
      store.set = store.set;
      /* eslint-enable no-self-assign -- prototype methods protection */
      set = function (it, metadata) {
        if (store.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store.set(it, metadata);
        return metadata;
      };
      get = function (it) {
        return store.get(it) || {};
      };
      has = function (it) {
        return store.has(it);
      };
    } else {
      var STATE = sharedKey$1('state');
      hiddenKeys$3[STATE] = true;
      set = function (it, metadata) {
        if (hasOwn$3(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty$1(it, STATE, metadata);
        return metadata;
      };
      get = function (it) {
        return hasOwn$3(it, STATE) ? it[STATE] : {};
      };
      has = function (it) {
        return hasOwn$3(it, STATE);
      };
    }
    var internalState = {
      set: set,
      get: get,
      has: has,
      enforce: enforce,
      getterFor: getterFor
    };
    var fails$2 = fails$9;
    var isCallable$4 = isCallable$c;
    var hasOwn$2 = hasOwnProperty_1;
    var DESCRIPTORS$1 = descriptors;
    var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
    var inspectSource$1 = inspectSource$2;
    var InternalStateModule = internalState;
    var enforceInternalState = InternalStateModule.enforce;
    var getInternalState = InternalStateModule.get;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var defineProperty$1 = Object.defineProperty;
    var CONFIGURABLE_LENGTH = DESCRIPTORS$1 && !fails$2(function () {
      return defineProperty$1(function () {/* empty */}, 'length', {
        value: 8
      }).length !== 8;
    });
    var TEMPLATE = String(String).split('String');
    var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
      if (String(name).slice(0, 7) === 'Symbol(') {
        name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
      }
      if (options && options.getter) name = 'get ' + name;
      if (options && options.setter) name = 'set ' + name;
      if (!hasOwn$2(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if (DESCRIPTORS$1) defineProperty$1(value, 'name', {
          value: name,
          configurable: true
        });else value.name = name;
      }
      if (CONFIGURABLE_LENGTH && options && hasOwn$2(options, 'arity') && value.length !== options.arity) {
        defineProperty$1(value, 'length', {
          value: options.arity
        });
      }
      try {
        if (options && hasOwn$2(options, 'constructor') && options.constructor) {
          if (DESCRIPTORS$1) defineProperty$1(value, 'prototype', {
            writable: false
          });
          // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
        } else if (value.prototype) value.prototype = undefined;
      } catch (error) {/* empty */}
      var state = enforceInternalState(value);
      if (!hasOwn$2(state, 'source')) {
        state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
      }
      return value;
    };

    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    // eslint-disable-next-line no-extend-native -- required
    Function.prototype.toString = makeBuiltIn$1(function toString() {
      return isCallable$4(this) && getInternalState(this).source || inspectSource$1(this);
    }, 'toString');
    var isCallable$3 = isCallable$c;
    var definePropertyModule$2 = objectDefineProperty;
    var makeBuiltIn = makeBuiltIn$2.exports;
    var defineGlobalProperty$1 = defineGlobalProperty$3;
    var defineBuiltIn$1 = function (O, key, value, options) {
      if (!options) options = {};
      var simple = options.enumerable;
      var name = options.name !== undefined ? options.name : key;
      if (isCallable$3(value)) makeBuiltIn(value, name, options);
      if (options.global) {
        if (simple) O[key] = value;else defineGlobalProperty$1(key, value);
      } else {
        try {
          if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
        } catch (error) {/* empty */}
        if (simple) O[key] = value;else definePropertyModule$2.f(O, key, {
          value: value,
          enumerable: false,
          configurable: !options.nonConfigurable,
          writable: !options.nonWritable
        });
      }
      return O;
    };
    var objectGetOwnPropertyNames = {};
    var ceil = Math.ceil;
    var floor = Math.floor;

    // `Math.trunc` method
    // https://tc39.es/ecma262/#sec-math.trunc
    // eslint-disable-next-line es/no-math-trunc -- safe
    var mathTrunc = Math.trunc || function trunc(x) {
      var n = +x;
      return (n > 0 ? floor : ceil)(n);
    };
    var trunc = mathTrunc;

    // `ToIntegerOrInfinity` abstract operation
    // https://tc39.es/ecma262/#sec-tointegerorinfinity
    var toIntegerOrInfinity$2 = function (argument) {
      var number = +argument;
      // eslint-disable-next-line no-self-compare -- NaN check
      return number !== number || number === 0 ? 0 : trunc(number);
    };
    var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;
    var max = Math.max;
    var min$1 = Math.min;

    // Helper for a popular repeating case of the spec:
    // Let integer be ? ToInteger(index).
    // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
    var toAbsoluteIndex$1 = function (index, length) {
      var integer = toIntegerOrInfinity$1(index);
      return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
    };
    var toIntegerOrInfinity = toIntegerOrInfinity$2;
    var min = Math.min;

    // `ToLength` abstract operation
    // https://tc39.es/ecma262/#sec-tolength
    var toLength$1 = function (argument) {
      return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
    };

    var toLength = toLength$1;

    // `LengthOfArrayLike` abstract operation
    // https://tc39.es/ecma262/#sec-lengthofarraylike
    var lengthOfArrayLike$2 = function (obj) {
      return toLength(obj.length);
    };
    var toIndexedObject$2 = toIndexedObject$4;
    var toAbsoluteIndex = toAbsoluteIndex$1;
    var lengthOfArrayLike$1 = lengthOfArrayLike$2;

    // `Array.prototype.{ indexOf, includes }` methods implementation
    var createMethod$1 = function (IS_INCLUDES) {
      return function ($this, el, fromIndex) {
        var O = toIndexedObject$2($this);
        var length = lengthOfArrayLike$1(O);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while (length > index) {
          value = O[index++];
          // eslint-disable-next-line no-self-compare -- NaN check
          if (value != value) return true;
          // Array#indexOf ignores holes, Array#includes - not
        } else for (; length > index; index++) {
          if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
      };
    };
    var arrayIncludes = {
      // `Array.prototype.includes` method
      // https://tc39.es/ecma262/#sec-array.prototype.includes
      includes: createMethod$1(true),
      // `Array.prototype.indexOf` method
      // https://tc39.es/ecma262/#sec-array.prototype.indexof
      indexOf: createMethod$1(false)
    };
    var uncurryThis$4 = functionUncurryThis;
    var hasOwn$1 = hasOwnProperty_1;
    var toIndexedObject$1 = toIndexedObject$4;
    var indexOf = arrayIncludes.indexOf;
    var hiddenKeys$2 = hiddenKeys$4;
    var push$1 = uncurryThis$4([].push);
    var objectKeysInternal = function (object, names) {
      var O = toIndexedObject$1(object);
      var i = 0;
      var result = [];
      var key;
      for (key in O) !hasOwn$1(hiddenKeys$2, key) && hasOwn$1(O, key) && push$1(result, key);
      // Don't enum bug & hidden keys
      while (names.length > i) if (hasOwn$1(O, key = names[i++])) {
        ~indexOf(result, key) || push$1(result, key);
      }
      return result;
    };

    // IE8- don't enum bug keys
    var enumBugKeys$3 = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
    var internalObjectKeys$1 = objectKeysInternal;
    var enumBugKeys$2 = enumBugKeys$3;
    var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    // eslint-disable-next-line es/no-object-getownpropertynames -- safe
    objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
      return internalObjectKeys$1(O, hiddenKeys$1);
    };
    var objectGetOwnPropertySymbols = {};

    // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
    objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
    var getBuiltIn$2 = getBuiltIn$5;
    var uncurryThis$3 = functionUncurryThis;
    var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
    var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
    var anObject$2 = anObject$4;
    var concat = uncurryThis$3([].concat);

    // all object keys, includes non-enumerable and symbols
    var ownKeys$1 = getBuiltIn$2('Reflect', 'ownKeys') || function ownKeys(it) {
      var keys = getOwnPropertyNamesModule.f(anObject$2(it));
      var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
      return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
    };
    var hasOwn = hasOwnProperty_1;
    var ownKeys = ownKeys$1;
    var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
    var definePropertyModule$1 = objectDefineProperty;
    var copyConstructorProperties$1 = function (target, source, exceptions) {
      var keys = ownKeys(source);
      var defineProperty = definePropertyModule$1.f;
      var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
          defineProperty(target, key, getOwnPropertyDescriptor(source, key));
        }
      }
    };
    var fails$1 = fails$9;
    var isCallable$2 = isCallable$c;
    var replacement = /#|\.prototype\./;
    var isForced$1 = function (feature, detection) {
      var value = data[normalize(feature)];
      return value == POLYFILL ? true : value == NATIVE ? false : isCallable$2(detection) ? fails$1(detection) : !!detection;
    };
    var normalize = isForced$1.normalize = function (string) {
      return String(string).replace(replacement, '.').toLowerCase();
    };
    var data = isForced$1.data = {};
    var NATIVE = isForced$1.NATIVE = 'N';
    var POLYFILL = isForced$1.POLYFILL = 'P';
    var isForced_1 = isForced$1;
    var global$1 = global$a;
    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    var createNonEnumerableProperty = createNonEnumerableProperty$2;
    var defineBuiltIn = defineBuiltIn$1;
    var defineGlobalProperty = defineGlobalProperty$3;
    var copyConstructorProperties = copyConstructorProperties$1;
    var isForced = isForced_1;

    /*
      options.target         - name of the target object
      options.global         - target is the global object
      options.stat           - export as static methods of target
      options.proto          - export as prototype methods of target
      options.real           - real prototype method for the `pure` version
      options.forced         - export even if the native feature is available
      options.bind           - bind methods to the target, required for the `pure` version
      options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
      options.unsafe         - use the simple assignment of property instead of delete + defineProperty
      options.sham           - add a flag to not completely full polyfills
      options.enumerable     - export as enumerable property
      options.dontCallGetSet - prevent calling a getter on target
      options.name           - the .name of the function if it does not match the key
    */
    var _export = function (options, source) {
      var TARGET = options.target;
      var GLOBAL = options.global;
      var STATIC = options.stat;
      var FORCED, target, key, targetProperty, sourceProperty, descriptor;
      if (GLOBAL) {
        target = global$1;
      } else if (STATIC) {
        target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
      } else {
        target = (global$1[TARGET] || {}).prototype;
      }
      if (target) for (key in source) {
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
          descriptor = getOwnPropertyDescriptor(target, key);
          targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
          if (typeof sourceProperty == typeof targetProperty) continue;
          copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) {
          createNonEnumerableProperty(sourceProperty, 'sham', true);
        }
        defineBuiltIn(target, key, sourceProperty, options);
      }
    };
    var uncurryThis$2 = functionUncurryThis;
    var aCallable = aCallable$2;
    var NATIVE_BIND = functionBindNative;
    var bind$1 = uncurryThis$2(uncurryThis$2.bind);

    // optional / simple context binding
    var functionBindContext = function (fn, that) {
      aCallable(fn);
      return that === undefined ? fn : NATIVE_BIND ? bind$1(fn, that) : function /* ...args */
      () {
        return fn.apply(that, arguments);
      };
    };
    var classof$2 = classofRaw$2;

    // `IsArray` abstract operation
    // https://tc39.es/ecma262/#sec-isarray
    // eslint-disable-next-line es/no-array-isarray -- safe
    var isArray$1 = Array.isArray || function isArray(argument) {
      return classof$2(argument) == 'Array';
    };
    var wellKnownSymbol$3 = wellKnownSymbol$5;
    var TO_STRING_TAG$1 = wellKnownSymbol$3('toStringTag');
    var test = {};
    test[TO_STRING_TAG$1] = 'z';
    var toStringTagSupport = String(test) === '[object z]';
    var TO_STRING_TAG_SUPPORT = toStringTagSupport;
    var isCallable$1 = isCallable$c;
    var classofRaw = classofRaw$2;
    var wellKnownSymbol$2 = wellKnownSymbol$5;
    var TO_STRING_TAG = wellKnownSymbol$2('toStringTag');
    var $Object = Object;

    // ES3 wrong here
    var CORRECT_ARGUMENTS = classofRaw(function () {
      return arguments;
    }()) == 'Arguments';

    // fallback for IE11 Script Access Denied error
    var tryGet = function (it, key) {
      try {
        return it[key];
      } catch (error) {/* empty */}
    };

    // getting tag from ES6+ `Object.prototype.toString`
    var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
      var O, tag, result;
      return it === undefined ? 'Undefined' : it === null ? 'Null'
      // @@toStringTag case
      : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
      // builtinTag case
      : CORRECT_ARGUMENTS ? classofRaw(O)
      // ES3 arguments fallback
      : (result = classofRaw(O)) == 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
    };
    var uncurryThis$1 = functionUncurryThis;
    var fails = fails$9;
    var isCallable = isCallable$c;
    var classof = classof$1;
    var getBuiltIn$1 = getBuiltIn$5;
    var inspectSource = inspectSource$2;
    var noop = function () {/* empty */};
    var empty = [];
    var construct = getBuiltIn$1('Reflect', 'construct');
    var constructorRegExp = /^\s*(?:class|function)\b/;
    var exec = uncurryThis$1(constructorRegExp.exec);
    var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
    var isConstructorModern = function isConstructor(argument) {
      if (!isCallable(argument)) return false;
      try {
        construct(noop, empty, argument);
        return true;
      } catch (error) {
        return false;
      }
    };
    var isConstructorLegacy = function isConstructor(argument) {
      if (!isCallable(argument)) return false;
      switch (classof(argument)) {
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
          return false;
      }
      try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
      } catch (error) {
        return true;
      }
    };
    isConstructorLegacy.sham = true;

    // `IsConstructor` abstract operation
    // https://tc39.es/ecma262/#sec-isconstructor
    var isConstructor$1 = !construct || fails(function () {
      var called;
      return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function () {
        called = true;
      }) || called;
    }) ? isConstructorLegacy : isConstructorModern;
    var isArray = isArray$1;
    var isConstructor = isConstructor$1;
    var isObject = isObject$6;
    var wellKnownSymbol$1 = wellKnownSymbol$5;
    var SPECIES = wellKnownSymbol$1('species');
    var $Array = Array;

    // a part of `ArraySpeciesCreate` abstract operation
    // https://tc39.es/ecma262/#sec-arrayspeciescreate
    var arraySpeciesConstructor$1 = function (originalArray) {
      var C;
      if (isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
          C = C[SPECIES];
          if (C === null) C = undefined;
        }
      }
      return C === undefined ? $Array : C;
    };
    var arraySpeciesConstructor = arraySpeciesConstructor$1;

    // `ArraySpeciesCreate` abstract operation
    // https://tc39.es/ecma262/#sec-arrayspeciescreate
    var arraySpeciesCreate$1 = function (originalArray, length) {
      return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
    };
    var bind = functionBindContext;
    var uncurryThis = functionUncurryThis;
    var IndexedObject = indexedObject;
    var toObject = toObject$2;
    var lengthOfArrayLike = lengthOfArrayLike$2;
    var arraySpeciesCreate = arraySpeciesCreate$1;
    var push = uncurryThis([].push);

    // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
    var createMethod = function (TYPE) {
      var IS_MAP = TYPE == 1;
      var IS_FILTER = TYPE == 2;
      var IS_SOME = TYPE == 3;
      var IS_EVERY = TYPE == 4;
      var IS_FIND_INDEX = TYPE == 6;
      var IS_FILTER_REJECT = TYPE == 7;
      var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
      return function ($this, callbackfn, that, specificCreate) {
        var O = toObject($this);
        var self = IndexedObject(O);
        var boundFunction = bind(callbackfn, that);
        var length = lengthOfArrayLike(self);
        var index = 0;
        var create = specificCreate || arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for (; length > index; index++) if (NO_HOLES || index in self) {
          value = self[index];
          result = boundFunction(value, index, O);
          if (TYPE) {
            if (IS_MAP) target[index] = result; // map
            else if (result) switch (TYPE) {
              case 3:
                return true;
              // some
              case 5:
                return value;
              // find
              case 6:
                return index;
              // findIndex
              case 2:
                push(target, value);
              // filter
            } else switch (TYPE) {
              case 4:
                return false;
              // every
              case 7:
                push(target, value);
              // filterReject
            }
          }
        }

        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
      };
    };
    var arrayIteration = {
      // `Array.prototype.forEach` method
      // https://tc39.es/ecma262/#sec-array.prototype.foreach
      forEach: createMethod(0),
      // `Array.prototype.map` method
      // https://tc39.es/ecma262/#sec-array.prototype.map
      map: createMethod(1),
      // `Array.prototype.filter` method
      // https://tc39.es/ecma262/#sec-array.prototype.filter
      filter: createMethod(2),
      // `Array.prototype.some` method
      // https://tc39.es/ecma262/#sec-array.prototype.some
      some: createMethod(3),
      // `Array.prototype.every` method
      // https://tc39.es/ecma262/#sec-array.prototype.every
      every: createMethod(4),
      // `Array.prototype.find` method
      // https://tc39.es/ecma262/#sec-array.prototype.find
      find: createMethod(5),
      // `Array.prototype.findIndex` method
      // https://tc39.es/ecma262/#sec-array.prototype.findIndex
      findIndex: createMethod(6),
      // `Array.prototype.filterReject` method
      // https://github.com/tc39/proposal-array-filtering
      filterReject: createMethod(7)
    };
    var objectDefineProperties = {};
    var internalObjectKeys = objectKeysInternal;
    var enumBugKeys$1 = enumBugKeys$3;

    // `Object.keys` method
    // https://tc39.es/ecma262/#sec-object.keys
    // eslint-disable-next-line es/no-object-keys -- safe
    var objectKeys$1 = Object.keys || function keys(O) {
      return internalObjectKeys(O, enumBugKeys$1);
    };
    var DESCRIPTORS = descriptors;
    var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
    var definePropertyModule = objectDefineProperty;
    var anObject$1 = anObject$4;
    var toIndexedObject = toIndexedObject$4;
    var objectKeys = objectKeys$1;

    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    // eslint-disable-next-line es/no-object-defineproperties -- safe
    objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
      anObject$1(O);
      var props = toIndexedObject(Properties);
      var keys = objectKeys(Properties);
      var length = keys.length;
      var index = 0;
      var key;
      while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
      return O;
    };
    var getBuiltIn = getBuiltIn$5;
    var html$1 = getBuiltIn('document', 'documentElement');

    /* global ActiveXObject -- old IE, WSH */

    var anObject = anObject$4;
    var definePropertiesModule = objectDefineProperties;
    var enumBugKeys = enumBugKeys$3;
    var hiddenKeys = hiddenKeys$4;
    var html = html$1;
    var documentCreateElement = documentCreateElement$1;
    var sharedKey = sharedKey$2;
    var GT = '>';
    var LT = '<';
    var PROTOTYPE = 'prototype';
    var SCRIPT = 'script';
    var IE_PROTO = sharedKey('IE_PROTO');
    var EmptyConstructor = function () {/* empty */};
    var scriptTag = function (content) {
      return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
    };

    // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
    var NullProtoObjectViaActiveX = function (activeXDocument) {
      activeXDocument.write(scriptTag(''));
      activeXDocument.close();
      var temp = activeXDocument.parentWindow.Object;
      activeXDocument = null; // avoid memory leak
      return temp;
    };

    // Create object with fake `null` prototype: use iframe Object with cleared prototype
    var NullProtoObjectViaIFrame = function () {
      // Thrash, waste and sodomy: IE GC bug
      var iframe = documentCreateElement('iframe');
      var JS = 'java' + SCRIPT + ':';
      var iframeDocument;
      iframe.style.display = 'none';
      html.appendChild(iframe);
      // https://github.com/zloirock/core-js/issues/475
      iframe.src = String(JS);
      iframeDocument = iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(scriptTag('document.F=Object'));
      iframeDocument.close();
      return iframeDocument.F;
    };

    // Check for document.domain and active x support
    // No need to use active x approach when document.domain is not set
    // see https://github.com/es-shims/es5-shim/issues/150
    // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
    // avoid IE GC bug
    var activeXDocument;
    var NullProtoObject = function () {
      try {
        activeXDocument = new ActiveXObject('htmlfile');
      } catch (error) {/* ignore */}
      NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
      var length = enumBugKeys.length;
      while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
      return NullProtoObject();
    };
    hiddenKeys[IE_PROTO] = true;

    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    // eslint-disable-next-line es/no-object-create -- safe
    var objectCreate = Object.create || function create(O, Properties) {
      var result;
      if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
      } else result = NullProtoObject();
      return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
    };
    var wellKnownSymbol = wellKnownSymbol$5;
    var create = objectCreate;
    var defineProperty = objectDefineProperty.f;
    var UNSCOPABLES = wellKnownSymbol('unscopables');
    var ArrayPrototype = Array.prototype;

    // Array.prototype[@@unscopables]
    // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
    if (ArrayPrototype[UNSCOPABLES] == undefined) {
      defineProperty(ArrayPrototype, UNSCOPABLES, {
        configurable: true,
        value: create(null)
      });
    }

    // add a key to Array.prototype[@@unscopables]
    var addToUnscopables$1 = function (key) {
      ArrayPrototype[UNSCOPABLES][key] = true;
    };
    var $ = _export;
    var $find = arrayIteration.find;
    var addToUnscopables = addToUnscopables$1;
    var FIND = 'find';
    var SKIPS_HOLES = true;

    // Shouldn't skip holes
    if (FIND in []) Array(1)[FIND](function () {
      SKIPS_HOLES = false;
    });

    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    $({
      target: 'Array',
      proto: true,
      forced: SKIPS_HOLES
    }, {
      find: function find(callbackfn /* , that = undefined */) {
        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
    addToUnscopables(FIND);
    var CONSTANT = {
      GLOBAL: {
        HIDE: '__react_tooltip_hide_event',
        REBUILD: '__react_tooltip_rebuild_event',
        SHOW: '__react_tooltip_show_event'
      }
    };

    /**
     * Static methods for react-tooltip
     */
    var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
      // Compatible with IE
      // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
      // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
      var event;
      if (typeof window.CustomEvent === 'function') {
        event = new window.CustomEvent(eventName, {
          detail: opts
        });
      } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, false, true, opts);
      }
      window.dispatchEvent(event);
    };
    function staticMethods(target) {
      /**
       * Hide all tooltip
       * @trigger ReactTooltip.hide()
       */
      target.hide = function (target) {
        dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
          target: target
        });
      };

      /**
       * Rebuild all tooltip
       * @trigger ReactTooltip.rebuild()
       */
      target.rebuild = function () {
        dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
      };

      /**
       * Show specific tooltip
       * @trigger ReactTooltip.show()
       */
      target.show = function (target) {
        dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
          target: target
        });
      };
      target.prototype.globalRebuild = function () {
        if (this.mount) {
          this.unbindListener();
          this.bindListener();
        }
      };
      target.prototype.globalShow = function (event) {
        if (this.mount) {
          var hasTarget = event && event.detail && event.detail.target && true || false;
          // Create a fake event, specific show will limit the type to `solid`
          // only `float` type cares e.clientX e.clientY
          this.showTooltip({
            currentTarget: hasTarget && event.detail.target
          }, true);
        }
      };
      target.prototype.globalHide = function (event) {
        if (this.mount) {
          var hasTarget = event && event.detail && event.detail.target && true || false;
          this.hideTooltip({
            currentTarget: hasTarget && event.detail.target
          }, hasTarget);
        }
      };
    }

    /**
     * Events that should be bound to the window
     */
    function windowListener(target) {
      target.prototype.bindWindowEvents = function (resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false);

        // ReactTooltip.rebuild
        window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);

        // ReactTooltip.show
        window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false);

        // Resize
        if (resizeHide) {
          window.removeEventListener('resize', this.onWindowResize);
          window.addEventListener('resize', this.onWindowResize, false);
        }
      };
      target.prototype.unbindWindowEvents = function () {
        window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener('resize', this.onWindowResize);
      };

      /**
       * invoked by resize event of window
       */
      target.prototype.onWindowResize = function () {
        if (!this.mount) return;
        this.hideTooltip();
      };
    }

    /**
     * Custom events to control showing and hiding of tooltip
     *
     * @attributes
     * - `event` {String}
     * - `eventOff` {String}
     */

    var checkStatus = function checkStatus(dataEventOff, e) {
      var show = this.state.show;
      var id = this.props.id;
      var isCapture = this.isCapture(e.currentTarget);
      var currentItem = e.currentTarget.getAttribute('currentItem');
      if (!isCapture) e.stopPropagation();
      if (show && currentItem === 'true') {
        if (!dataEventOff) this.hideTooltip(e);
      } else {
        e.currentTarget.setAttribute('currentItem', 'true');
        setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
      }
    };
    var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
      for (var i = 0; i < targetArray.length; i++) {
        if (currentTarget !== targetArray[i]) {
          targetArray[i].setAttribute('currentItem', 'false');
        } else {
          targetArray[i].setAttribute('currentItem', 'true');
        }
      }
    };
    var customListeners = {
      id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
      set: function set(target, event, listener) {
        if (this.id in target) {
          var map = target[this.id];
          map[event] = listener;
        } else {
          // this is workaround for WeakMap, which is not supported in older browsers, such as IE
          Object.defineProperty(target, this.id, {
            configurable: true,
            value: _defineProperty({}, event, listener)
          });
        }
      },
      get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) {
          return map[event];
        }
      }
    };
    function customEvent(target) {
      target.prototype.isCustomEvent = function (ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute('data-event');
      };

      /* Bind listener for custom event */
      target.prototype.customBindListener = function (ele) {
        var _this = this;
        var _this$state = this.state,
          event = _this$state.event,
          eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute('data-event') || event;
        var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
        dataEvent.split(' ').forEach(function (event) {
          ele.removeEventListener(event, customListeners.get(ele, event));
          var customListener = checkStatus.bind(_this, dataEventOff);
          customListeners.set(ele, event, customListener);
          ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) {
          dataEventOff.split(' ').forEach(function (event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
          });
        }
      };

      /* Unbind listener for custom event */
      target.prototype.customUnbindListener = function (ele) {
        var _this$state2 = this.state,
          event = _this$state2.event,
          eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute('data-event');
        var dataEventOff = eventOff || ele.getAttribute('data-event-off');
        ele.removeEventListener(dataEvent, customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
      };
    }

    /**
     * Util method to judge if it should follow capture model
     */

    function isCapture(target) {
      target.prototype.isCapture = function (currentTarget) {
        return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
      };
    }

    /**
     * Util method to get effect
     */

    function getEffect(target) {
      target.prototype.getEffect = function (currentTarget) {
        var dataEffect = currentTarget.getAttribute('data-effect');
        return dataEffect || this.props.effect || 'float';
      };
    }

    /**
     * Util method to get effect
     */
    var makeProxy = function makeProxy(e) {
      var proxy = {};
      for (var key in e) {
        if (typeof e[key] === 'function') {
          proxy[key] = e[key].bind(e);
        } else {
          proxy[key] = e[key];
        }
      }
      return proxy;
    };
    var bodyListener = function bodyListener(callback, options, e) {
      var _options$respectEffec = options.respectEffect,
        respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
        _options$customEvent = options.customEvent,
        customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
      var id = this.props.id;
      var tip = null;
      var forId;
      var target = e.target;
      var lastTarget;
      // walk up parent chain until tip is found
      // there is no match if parent visible area is matched by mouse position, so some corner cases might not work as expected
      while (tip === null && target !== null) {
        lastTarget = target;
        tip = target.getAttribute('data-tip') || null;
        forId = target.getAttribute('data-for') || null;
        target = target.parentElement;
      }
      target = lastTarget || e.target;
      if (this.isCustomEvent(target) && !customEvent) {
        return;
      }
      var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
      if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
        var proxy = makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
      }
    };
    var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
      var events = {};
      targetArray.forEach(function (target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(' ').forEach(function (event) {
          return events[event] = true;
        });
      });
      return events;
    };
    var getBody = function getBody() {
      return document.getElementsByTagName('body')[0];
    };
    function bodyMode(target) {
      target.prototype.isBodyMode = function () {
        return !!this.props.bodyMode;
      };
      target.prototype.bindBodyListener = function (targetArray) {
        var _this = this;
        var _this$state = this.state,
          event = _this$state.event,
          eventOff = _this$state.eventOff,
          possibleCustomEvents = _this$state.possibleCustomEvents,
          possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = getBody();
        var customEvents = findCustomEvents(targetArray, 'data-event');
        var customEventsOff = findCustomEvents(targetArray, 'data-event-off');
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(' ').forEach(function (event) {
          return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(' ').forEach(function (event) {
          return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
          listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
          listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
            respectEffect: true
          });
          listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
        }
        for (var _event in customEvents) {
          listeners[_event] = bodyListener.bind(this, function (e) {
            var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
            checkStatus.call(_this, targetEventOff, e);
          }, {
            customEvent: true
          });
        }
        for (var _event2 in customEventsOff) {
          listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
          });
        }
        for (var _event3 in listeners) {
          body.addEventListener(_event3, listeners[_event3]);
        }
      };
      target.prototype.unbindBodyListener = function (body) {
        body = body || getBody();
        var listeners = this.bodyModeListeners;
        for (var event in listeners) {
          body.removeEventListener(event, listeners[event]);
        }
      };
    }

    /**
     * Tracking target removing from DOM.
     * It's necessary to hide tooltip when it's target disappears.
     * Otherwise, the tooltip would be shown forever until another target
     * is triggered.
     *
     * If MutationObserver is not available, this feature just doesn't work.
     */

    // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
    var getMutationObserverClass = function getMutationObserverClass() {
      return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    };
    function trackRemoval(target) {
      target.prototype.bindRemovalTracker = function () {
        var _this = this;
        var MutationObserver = getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function (mutations) {
          for (var m1 = 0; m1 < mutations.length; m1++) {
            var mutation = mutations[m1];
            for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
              var element = mutation.removedNodes[m2];
              if (element === _this.state.currentTarget) {
                _this.hideTooltip();
                return;
              }
            }
          }
        });
        observer.observe(window.document, {
          childList: true,
          subtree: true
        });
        this.removalTracker = observer;
      };
      target.prototype.unbindRemovalTracker = function () {
        if (this.removalTracker) {
          this.removalTracker.disconnect();
          this.removalTracker = null;
        }
      };
    }

    /**
     * Calculate the position of tooltip
     *
     * @params
     * - `e` {Event} the event of current mouse
     * - `target` {Element} the currentTarget of the event
     * - `node` {DOM} the react-tooltip object
     * - `place` {String} top / right / bottom / left
     * - `effect` {String} float / solid
     * - `offset` {Object} the offset to default position
     *
     * @return {Object}
     * - `isNewState` {Bool} required
     * - `newState` {Object}
     * - `position` {Object} {left: {Number}, top: {Number}}
     */
    function getPosition(e, target, node, place, desiredPlace, effect, offset) {
      var _getDimensions = getDimensions(node),
        tipWidth = _getDimensions.width,
        tipHeight = _getDimensions.height;
      var _getDimensions2 = getDimensions(target),
        targetWidth = _getDimensions2.width,
        targetHeight = _getDimensions2.height;
      var _getCurrentOffset = getCurrentOffset(e, target, effect),
        mouseX = _getCurrentOffset.mouseX,
        mouseY = _getCurrentOffset.mouseY;
      var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
      var _calculateOffset = calculateOffset(offset),
        extraOffsetX = _calculateOffset.extraOffsetX,
        extraOffsetY = _calculateOffset.extraOffsetY;
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var _getParent = getParent(node),
        parentTop = _getParent.parentTop,
        parentLeft = _getParent.parentLeft;

      // Get the edge offset of the tooltip
      var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
      };
      var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
      };
      var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
      };
      var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
      };

      //
      // Functions to test whether the tooltip's sides are inside
      // the client window for a given orientation p
      //
      //  _____________
      // |             | <-- Right side
      // | p = 'left'  |\
      // |             |/  |\
      // |_____________|   |_\  <-- Mouse
      //      / \           |
      //       |
      //       |
      //  Bottom side
      //
      var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
      };
      var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
      };
      var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
      };
      var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
      };

      // Check whether the tooltip with orientation p is completely inside the client window
      var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
      };
      var inside = function inside(p) {
        return !outside(p);
      };
      var placeIsInside = {
        top: inside('top'),
        bottom: inside('bottom'),
        left: inside('left'),
        right: inside('right')
      };
      function choose() {
        var allPlaces = desiredPlace.split(',').concat(place, ['top', 'bottom', 'left', 'right']);
        var _iterator = _createForOfIteratorHelper(allPlaces),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var d = _step.value;
            if (placeIsInside[d]) return d;
          }
          // if nothing is inside, just use the old place.
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return place;
      }
      var chosen = choose();
      var isNewState = false;
      var newPlace;
      if (chosen && chosen !== place) {
        isNewState = true;
        newPlace = chosen;
      }
      if (isNewState) {
        return {
          isNewState: true,
          newState: {
            place: newPlace
          }
        };
      }
      return {
        isNewState: false,
        position: {
          left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
          top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
      };
    }
    var getDimensions = function getDimensions(node) {
      var _node$getBoundingClie = node.getBoundingClientRect(),
        height = _node$getBoundingClie.height,
        width = _node$getBoundingClie.width;
      return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
      };
    };

    // Get current mouse offset
    var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
      var boundingClientRect = currentTarget.getBoundingClientRect();
      var targetTop = boundingClientRect.top;
      var targetLeft = boundingClientRect.left;
      var _getDimensions3 = getDimensions(currentTarget),
        targetWidth = _getDimensions3.width,
        targetHeight = _getDimensions3.height;
      if (effect === 'float') {
        return {
          mouseX: e.clientX,
          mouseY: e.clientY
        };
      }
      return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
      };
    };

    // List all possibility of tooltip final offset
    // This is useful in judging if it is necessary for tooltip to switch position when out of window
    var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
      var top;
      var right;
      var bottom;
      var left;
      var disToMouse = 3;
      var triangleHeight = 2;
      var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

      if (effect === 'float') {
        top = {
          l: -(tipWidth / 2),
          r: tipWidth / 2,
          t: -(tipHeight + disToMouse + triangleHeight),
          b: -disToMouse
        };
        bottom = {
          l: -(tipWidth / 2),
          r: tipWidth / 2,
          t: disToMouse + cursorHeight,
          b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
          l: -(tipWidth + disToMouse + triangleHeight),
          r: -disToMouse,
          t: -(tipHeight / 2),
          b: tipHeight / 2
        };
        right = {
          l: disToMouse,
          r: tipWidth + disToMouse + triangleHeight,
          t: -(tipHeight / 2),
          b: tipHeight / 2
        };
      } else if (effect === 'solid') {
        top = {
          l: -(tipWidth / 2),
          r: tipWidth / 2,
          t: -(targetHeight / 2 + tipHeight + triangleHeight),
          b: -(targetHeight / 2)
        };
        bottom = {
          l: -(tipWidth / 2),
          r: tipWidth / 2,
          t: targetHeight / 2,
          b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
          l: -(tipWidth + targetWidth / 2 + triangleHeight),
          r: -(targetWidth / 2),
          t: -(tipHeight / 2),
          b: tipHeight / 2
        };
        right = {
          l: targetWidth / 2,
          r: tipWidth + targetWidth / 2 + triangleHeight,
          t: -(tipHeight / 2),
          b: tipHeight / 2
        };
      }
      return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
      };
    };

    // Consider additional offset into position calculation
    var calculateOffset = function calculateOffset(offset) {
      var extraOffsetX = 0;
      var extraOffsetY = 0;
      if (Object.prototype.toString.apply(offset) === '[object String]') {
        offset = JSON.parse(offset.toString().replace(/'/g, '"'));
      }
      for (var key in offset) {
        if (key === 'top') {
          extraOffsetY -= parseInt(offset[key], 10);
        } else if (key === 'bottom') {
          extraOffsetY += parseInt(offset[key], 10);
        } else if (key === 'left') {
          extraOffsetX -= parseInt(offset[key], 10);
        } else if (key === 'right') {
          extraOffsetX += parseInt(offset[key], 10);
        }
      }
      return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
      };
    };

    // Get the offset of the parent elements
    var getParent = function getParent(currentTarget) {
      var currentParent = currentTarget;
      while (currentParent) {
        var computedStyle = window.getComputedStyle(currentParent);
        // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform') break;
        currentParent = currentParent.parentElement;
      }
      var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
      var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
      return {
        parentTop: parentTop,
        parentLeft: parentLeft
      };
    };

    /**
     * To get the tooltip content
     * it may comes from data-tip or this.props.children
     * it should support multiline
     *
     * @params
     * - `tip` {String} value of data-tip
     * - `children` {ReactElement} this.props.children
     * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
     *
     * @return
     * - String or react component
     */
    function TipContent(tip, children, getContent, multiline) {
      if (children) return children;
      if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
      if (getContent === null) return null; // Tip not exist and children is null or undefined

      var regexp = /<br\s*\/?>/;
      if (!multiline || multiline === 'false' || !regexp.test(tip)) {
        // No trim(), so that user can keep their input
        return tip;
      }

      // Multiline tooltip content
      return tip.split(regexp).map(function (d, i) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
          key: i,
          className: "multi-line"
        }, d);
      });
    }

    /**
     * Support aria- and role in ReactTooltip
     *
     * @params props {Object}
     * @return {Object}
     */
    function parseAria(props) {
      var ariaObj = {};
      Object.keys(props).filter(function (prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
      }).forEach(function (prop) {
        ariaObj[prop] = props[prop];
      });
      return ariaObj;
    }

    /**
     * Convert nodelist to array
     * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
     * NodeLists are functions in Safari
     */

    function nodeListToArray(nodeList) {
      var length = nodeList.length;
      if (nodeList.hasOwnProperty) {
        return Array.prototype.slice.call(nodeList);
      }
      return new Array(length).fill().map(function (index) {
        return nodeList[index];
      });
    }
    function generateUUID() {
      return 't' + Object(uuid__WEBPACK_IMPORTED_MODULE_2__[/* default */"a"])();
    }
    var baseCss = ".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  bottom: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-bottom::before {\n  top: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-left::before {\n  right: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip.place-right::before {\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}";

    /**
     * Default pop-up style values (text color, background color).
     */
    var defaultColors = {
      dark: {
        text: '#fff',
        background: '#222',
        border: 'transparent',
        arrow: '#222'
      },
      success: {
        text: '#fff',
        background: '#8DC572',
        border: 'transparent',
        arrow: '#8DC572'
      },
      warning: {
        text: '#fff',
        background: '#F0AD4E',
        border: 'transparent',
        arrow: '#F0AD4E'
      },
      error: {
        text: '#fff',
        background: '#BE6464',
        border: 'transparent',
        arrow: '#BE6464'
      },
      info: {
        text: '#fff',
        background: '#337AB7',
        border: 'transparent',
        arrow: '#337AB7'
      },
      light: {
        text: '#222',
        background: '#fff',
        border: 'transparent',
        arrow: '#fff'
      }
    };
    function getDefaultPopupColors(type) {
      return defaultColors[type] ? _objectSpread2({}, defaultColors[type]) : undefined;
    }
    var DEFAULT_PADDING = '8px 21px';
    var DEFAULT_RADIUS = {
      tooltip: 3,
      arrow: 0
    };

    /**
     * Generates the specific tooltip style for use on render.
     */
    function generateTooltipStyle(uuid, customColors, type, hasBorder, padding, radius) {
      return generateStyle(uuid, getPopupColors(customColors, type, hasBorder), padding, radius);
    }

    /**
     * Generates the tooltip style rules based on the element-specified "data-type" property.
     */
    function generateStyle(uuid, colors) {
      var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_PADDING;
      var radius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_RADIUS;
      var textColor = colors.text;
      var backgroundColor = colors.background;
      var borderColor = colors.border;
      var arrowColor = colors.arrow;
      var arrowRadius = radius.arrow;
      var tooltipRadius = radius.tooltip;
      return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n\t    border-radius: ").concat(tooltipRadius, "px;\n\t    padding: ").concat(padding, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 20px;\n        height: 12px;\n    }\n    .").concat(uuid, ".place-top::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(135deg);\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 18px;\n        height: 10px;\n    }\n    .").concat(uuid, ".place-bottom::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        top: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .").concat(uuid, ".place-left::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        right: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .").concat(uuid, ".place-right::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        left: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(-135deg);\n    }\n  ");
    }
    function getPopupColors(customColors, type, hasBorder) {
      var textColor = customColors.text;
      var backgroundColor = customColors.background;
      var borderColor = customColors.border;
      var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
      var colors = getDefaultPopupColors(type);
      if (textColor) {
        colors.text = textColor;
      }
      if (backgroundColor) {
        colors.background = backgroundColor;
      }
      if (hasBorder) {
        if (borderColor) {
          colors.border = borderColor;
        } else {
          colors.border = type === 'light' ? 'black' : 'white';
        }
      }
      if (arrowColor) {
        colors.arrow = arrowColor;
      }
      return colors;
    }
    var _class, _class2;

    /* Polyfill */
    var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
      _inherits(ReactTooltip, _React$Component);
      var _super = _createSuper(ReactTooltip);
      function ReactTooltip(props) {
        var _this;
        _classCallCheck(this, ReactTooltip);
        _this = _super.call(this, props);
        _this.state = {
          uuid: props.uuid || generateUUID(),
          place: props.place || 'top',
          // Direction of tooltip
          desiredPlace: props.place || 'top',
          type: props.type || 'dark',
          // Color theme of tooltip
          effect: props.effect || 'float',
          // float or fixed
          show: false,
          border: false,
          borderClass: 'border',
          customColors: {},
          customRadius: {},
          offset: {},
          padding: props.padding,
          extraClass: '',
          html: false,
          delayHide: 0,
          delayShow: 0,
          event: props.event || null,
          eventOff: props.eventOff || null,
          currentEvent: null,
          // Current mouse event
          currentTarget: null,
          // Current target of mouse event
          ariaProps: parseAria(props),
          // aria- and role attributes
          isEmptyTip: false,
          disable: false,
          possibleCustomEvents: props.possibleCustomEvents || '',
          possibleCustomEventsOff: props.possibleCustomEventsOff || '',
          originTooltip: null,
          isMultiline: false
        };
        _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'hideTooltipOnScroll', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
      }

      /**
       * For unify the bind and unbind listener
       */
      _createClass(ReactTooltip, [{
        key: "bind",
        value: function bind(methodArray) {
          var _this2 = this;
          methodArray.forEach(function (method) {
            _this2[method] = _this2[method].bind(_this2);
          });
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this$props = this.props;
          _this$props.insecure;
          var resizeHide = _this$props.resizeHide,
            disableInternalStyle = _this$props.disableInternalStyle;
          this.mount = true;
          this.bindListener(); // Bind listener for tooltip
          this.bindWindowEvents(resizeHide); // Bind global event for static method

          if (!disableInternalStyle) {
            this.injectStyles(); // Inject styles for each DOM root having tooltip.
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.mount = false;
          this.clearTimer();
          this.unbindListener();
          this.removeScrollListener(this.state.currentTarget);
          this.unbindWindowEvents();
        }

        /* Look for the closest DOM root having tooltip and inject styles. */
      }, {
        key: "injectStyles",
        value: function injectStyles() {
          var tooltipRef = this.tooltipRef;
          if (!tooltipRef) {
            return;
          }
          var parentNode = tooltipRef.parentNode;
          while (parentNode.parentNode) {
            parentNode = parentNode.parentNode;
          }
          var domRoot;
          switch (parentNode.constructor.name) {
            case 'Document':
            case 'HTMLDocument':
            case undefined:
              domRoot = parentNode.head;
              break;
            case 'ShadowRoot':
            default:
              domRoot = parentNode;
              break;
          }

          // Prevent styles duplication.
          if (!domRoot.querySelector('style[data-react-tooltip]')) {
            var style = document.createElement('style');
            style.textContent = baseCss;
            style.setAttribute('data-react-tooltip', 'true');
            domRoot.appendChild(style);
          }
        }

        /**
         * Return if the mouse is on the tooltip.
         * @returns {boolean} true - mouse is on the tooltip
         */
      }, {
        key: "mouseOnToolTip",
        value: function mouseOnToolTip() {
          var show = this.state.show;
          if (show && this.tooltipRef) {
            /* old IE or Firefox work around */
            if (!this.tooltipRef.matches) {
              /* old IE work around */
              if (this.tooltipRef.msMatchesSelector) {
                this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
              } else {
                /* old Firefox work around */
                this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
              }
            }
            return this.tooltipRef.matches(':hover');
          }
          return false;
        }

        /**
         * Pick out corresponded target elements
         */
      }, {
        key: "getTargetArray",
        value: function getTargetArray(id) {
          var targetArray = [];
          var selector;
          if (!id) {
            selector = '[data-tip]:not([data-for])';
          } else {
            var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
            selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
          }

          // Scan document for shadow DOM elements
          nodeListToArray(document.getElementsByTagName('*')).filter(function (element) {
            return element.shadowRoot;
          }).forEach(function (element) {
            targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
          });
          return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
        }

        /**
         * Bind listener to the target elements
         * These listeners used to trigger showing or hiding the tooltip
         */
      }, {
        key: "bindListener",
        value: function bindListener() {
          var _this3 = this;
          var _this$props2 = this.props,
            id = _this$props2.id,
            globalEventOff = _this$props2.globalEventOff,
            isCapture = _this$props2.isCapture;
          var targetArray = this.getTargetArray(id);
          targetArray.forEach(function (target) {
            if (target.getAttribute('currentItem') === null) {
              target.setAttribute('currentItem', 'false');
            }
            _this3.unbindBasicListener(target);
            if (_this3.isCustomEvent(target)) {
              _this3.customUnbindListener(target);
            }
          });
          if (this.isBodyMode()) {
            this.bindBodyListener(targetArray);
          } else {
            targetArray.forEach(function (target) {
              var isCaptureMode = _this3.isCapture(target);
              var effect = _this3.getEffect(target);
              if (_this3.isCustomEvent(target)) {
                _this3.customBindListener(target);
                return;
              }
              target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
              target.addEventListener('focus', _this3.showTooltip, isCaptureMode);
              if (effect === 'float') {
                target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
              }
              target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
              target.addEventListener('blur', _this3.hideTooltip, isCaptureMode);
            });
          }

          // Global event to hide tooltip
          if (globalEventOff) {
            window.removeEventListener(globalEventOff, this.hideTooltip);
            window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
          }

          // Track removal of targetArray elements from DOM
          this.bindRemovalTracker();
        }

        /**
         * Unbind listeners on target elements
         */
      }, {
        key: "unbindListener",
        value: function unbindListener() {
          var _this4 = this;
          var _this$props3 = this.props,
            id = _this$props3.id,
            globalEventOff = _this$props3.globalEventOff;
          if (this.isBodyMode()) {
            this.unbindBodyListener();
          } else {
            var targetArray = this.getTargetArray(id);
            targetArray.forEach(function (target) {
              _this4.unbindBasicListener(target);
              if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
            });
          }
          if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
          this.unbindRemovalTracker();
        }

        /**
         * Invoke this before bind listener and unmount the component
         * it is necessary to invoke this even when binding custom event
         * so that the tooltip can switch between custom and default listener
         */
      }, {
        key: "unbindBasicListener",
        value: function unbindBasicListener(target) {
          var isCaptureMode = this.isCapture(target);
          target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
          target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
          target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
        }
      }, {
        key: "getTooltipContent",
        value: function getTooltipContent() {
          var _this$props4 = this.props,
            getContent = _this$props4.getContent,
            children = _this$props4.children;

          // Generate tooltip content
          var content;
          if (getContent) {
            if (Array.isArray(getContent)) {
              content = getContent[0] && getContent[0](this.state.originTooltip);
            } else {
              content = getContent(this.state.originTooltip);
            }
          }
          return TipContent(this.state.originTooltip, children, content, this.state.isMultiline);
        }
      }, {
        key: "isEmptyTip",
        value: function isEmptyTip(placeholder) {
          return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
        }

        /**
         * When mouse enter, show the tooltip
         */
      }, {
        key: "showTooltip",
        value: function showTooltip(e, isGlobalCall) {
          if (!this.tooltipRef) {
            return;
          }
          if (isGlobalCall) {
            // Don't trigger other elements belongs to other ReactTooltip
            var targetArray = this.getTargetArray(this.props.id);
            var isMyElement = targetArray.some(function (ele) {
              return ele === e.currentTarget;
            });
            if (!isMyElement) return;
          }
          // Get the tooltip content
          // calculate in this phrase so that tip width height can be detected
          var _this$props5 = this.props,
            multiline = _this$props5.multiline,
            getContent = _this$props5.getContent;
          var originTooltip = e.currentTarget.getAttribute('data-tip');
          var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;

          // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
          var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;

          // if it needs to skip adding hide listener to scroll
          var scrollHide = true;
          if (e.currentTarget.getAttribute('data-scroll-hide')) {
            scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
          } else if (this.props.scrollHide != null) {
            scrollHide = this.props.scrollHide;
          }

          // adding aria-describedby to target to make tooltips read by screen readers
          if (e && e.currentTarget && e.currentTarget.setAttribute) {
            e.currentTarget.setAttribute('aria-describedby', this.props.id || this.state.uuid);
          }

          // Make sure the correct place is set
          var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
          var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
          var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
          var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace.split(',')[0], desiredPlace, effect, offset);
          if (result.position && this.props.overridePosition) {
            result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
          }
          var place = result.isNewState ? result.newState.place : desiredPlace.split(',')[0];

          // To prevent previously created timers from triggering
          this.clearTimer();
          var target = e.currentTarget;
          var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
          var self = this;
          var updateState = function updateState() {
            self.setState({
              originTooltip: originTooltip,
              isMultiline: isMultiline,
              desiredPlace: desiredPlace,
              place: place,
              type: target.getAttribute('data-type') || self.props.type || 'dark',
              customColors: {
                text: target.getAttribute('data-text-color') || self.props.textColor || null,
                background: target.getAttribute('data-background-color') || self.props.backgroundColor || null,
                border: target.getAttribute('data-border-color') || self.props.borderColor || null,
                arrow: target.getAttribute('data-arrow-color') || self.props.arrowColor || null
              },
              customRadius: {
                tooltip: target.getAttribute('data-tooltip-radius') || self.props.tooltipRadius || '3',
                arrow: target.getAttribute('data-arrow-radius') || self.props.arrowRadius || '0'
              },
              effect: effect,
              offset: offset,
              padding: target.getAttribute('data-padding') || self.props.padding,
              html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html) || false,
              delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
              delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
              delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
              border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border) || false,
              borderClass: target.getAttribute('data-border-class') || self.props.borderClass || 'border',
              extraClass: target.getAttribute('data-class') || self.props["class"] || self.props.className || '',
              disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable) || false,
              currentTarget: target
            }, function () {
              if (scrollHide) {
                self.addScrollListener(self.state.currentTarget);
              }
              self.updateTooltip(e);
              if (getContent && Array.isArray(getContent)) {
                self.intervalUpdateContent = setInterval(function () {
                  if (self.mount) {
                    var _getContent = self.props.getContent;
                    var placeholder = TipContent(originTooltip, '', _getContent[0](), isMultiline);
                    var isEmptyTip = self.isEmptyTip(placeholder);
                    self.setState({
                      isEmptyTip: isEmptyTip
                    });
                    self.updatePosition();
                  }
                }, getContent[1]);
              }
            });
          };

          // If there is no delay call immediately, don't allow events to get in first.
          if (reshowDelay) {
            this.delayReshow = setTimeout(updateState, reshowDelay);
          } else {
            updateState();
          }
        }

        /**
         * When mouse hover, update tool tip
         */
      }, {
        key: "updateTooltip",
        value: function updateTooltip(e) {
          var _this5 = this;
          var _this$state = this.state,
            delayShow = _this$state.delayShow,
            disable = _this$state.disable;
          var _this$props6 = this.props,
            afterShow = _this$props6.afterShow,
            disableProp = _this$props6.disable;
          var placeholder = this.getTooltipContent();
          var eventTarget = e.currentTarget || e.target;

          // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
          if (this.mouseOnToolTip()) {
            return;
          }

          // if the tooltip is empty, disable the tooltip
          if (this.isEmptyTip(placeholder) || disable || disableProp) {
            return;
          }
          var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
          var updateState = function updateState() {
            if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
              var isInvisible = !_this5.state.show;
              _this5.setState({
                currentEvent: e,
                currentTarget: eventTarget,
                show: true
              }, function () {
                _this5.updatePosition(function () {
                  if (isInvisible && afterShow) {
                    afterShow(e);
                  }
                });
              });
            }
          };
          if (this.delayShowLoop) {
            clearTimeout(this.delayShowLoop);
          }
          if (delayTime) {
            this.delayShowLoop = setTimeout(updateState, delayTime);
          } else {
            this.delayShowLoop = null;
            updateState();
          }
        }

        /*
         * If we're mousing over the tooltip remove it when we leave.
         */
      }, {
        key: "listenForTooltipExit",
        value: function listenForTooltipExit() {
          var show = this.state.show;
          if (show && this.tooltipRef) {
            this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
          }
        }
      }, {
        key: "removeListenerForTooltipExit",
        value: function removeListenerForTooltipExit() {
          var show = this.state.show;
          if (show && this.tooltipRef) {
            this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
          }
        }

        /**
         * When mouse leave, hide tooltip
         */
      }, {
        key: "hideTooltip",
        value: function hideTooltip(e, hasTarget) {
          var _this6 = this;
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            isScroll: false
          };
          var disable = this.state.disable;
          var isScroll = options.isScroll;
          var delayHide = isScroll ? 0 : this.state.delayHide;
          var _this$props7 = this.props,
            afterHide = _this$props7.afterHide,
            disableProp = _this$props7.disable;
          var placeholder = this.getTooltipContent();
          if (!this.mount) return;
          if (this.isEmptyTip(placeholder) || disable || disableProp) return; // if the tooltip is empty, disable the tooltip
          if (hasTarget) {
            // Don't trigger other elements belongs to other ReactTooltip
            var targetArray = this.getTargetArray(this.props.id);
            var isMyElement = targetArray.some(function (ele) {
              return ele === e.currentTarget;
            });
            if (!isMyElement || !this.state.show) return;
          }

          // clean up aria-describedby when hiding tooltip
          if (e && e.currentTarget && e.currentTarget.removeAttribute) {
            e.currentTarget.removeAttribute('aria-describedby');
          }
          var resetState = function resetState() {
            var isVisible = _this6.state.show;
            // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
            if (_this6.mouseOnToolTip()) {
              _this6.listenForTooltipExit();
              return;
            }
            _this6.removeListenerForTooltipExit();
            _this6.setState({
              show: false
            }, function () {
              _this6.removeScrollListener(_this6.state.currentTarget);
              if (isVisible && afterHide) {
                afterHide(e);
              }
            });
          };
          this.clearTimer();
          if (delayHide) {
            this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
          } else {
            resetState();
          }
        }

        /**
         * When scroll, hide tooltip
         */
      }, {
        key: "hideTooltipOnScroll",
        value: function hideTooltipOnScroll(event, hasTarget) {
          this.hideTooltip(event, hasTarget, {
            isScroll: true
          });
        }

        /**
         * Add scroll event listener when tooltip show
         * automatically hide the tooltip when scrolling
         */
      }, {
        key: "addScrollListener",
        value: function addScrollListener(currentTarget) {
          var isCaptureMode = this.isCapture(currentTarget);
          window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
        }
      }, {
        key: "removeScrollListener",
        value: function removeScrollListener(currentTarget) {
          var isCaptureMode = this.isCapture(currentTarget);
          window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
        }

        // Calculation the position
      }, {
        key: "updatePosition",
        value: function updatePosition(callbackAfter) {
          var _this7 = this;
          var _this$state2 = this.state,
            currentEvent = _this$state2.currentEvent,
            currentTarget = _this$state2.currentTarget,
            place = _this$state2.place,
            desiredPlace = _this$state2.desiredPlace,
            effect = _this$state2.effect,
            offset = _this$state2.offset;
          var node = this.tooltipRef;
          var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
          if (result.position && this.props.overridePosition) {
            result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
          }
          if (result.isNewState) {
            // Switch to reverse placement
            return this.setState(result.newState, function () {
              _this7.updatePosition(callbackAfter);
            });
          }
          if (callbackAfter && typeof callbackAfter === 'function') {
            callbackAfter();
          }

          // Set tooltip position
          node.style.left = result.position.left + 'px';
          node.style.top = result.position.top + 'px';
        }

        /**
         * CLear all kinds of timeout of interval
         */
      }, {
        key: "clearTimer",
        value: function clearTimer() {
          if (this.delayShowLoop) {
            clearTimeout(this.delayShowLoop);
            this.delayShowLoop = null;
          }
          if (this.delayHideLoop) {
            clearTimeout(this.delayHideLoop);
            this.delayHideLoop = null;
          }
          if (this.delayReshow) {
            clearTimeout(this.delayReshow);
            this.delayReshow = null;
          }
          if (this.intervalUpdateContent) {
            clearInterval(this.intervalUpdateContent);
            this.intervalUpdateContent = null;
          }
        }
      }, {
        key: "hasCustomColors",
        value: function hasCustomColors() {
          var _this8 = this;
          return Boolean(Object.keys(this.state.customColors).find(function (color) {
            return color !== 'border' && _this8.state.customColors[color];
          }) || this.state.border && this.state.customColors['border']);
        }
      }, {
        key: "render",
        value: function render() {
          var _this9 = this;
          var _this$state3 = this.state,
            extraClass = _this$state3.extraClass,
            html = _this$state3.html,
            ariaProps = _this$state3.ariaProps,
            disable = _this$state3.disable,
            uuid = _this$state3.uuid;
          var content = this.getTooltipContent();
          var isEmptyTip = this.isEmptyTip(content);
          var style = this.props.disableInternalStyle ? '' : generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border, this.state.padding, this.state.customRadius);
          var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' ' + this.state.borderClass : '') + " place-".concat(this.state.place) +
          // top, bottom, left, right
          " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + (
          // dark, success, warning, error, info, light, custom
          this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
          var Wrapper = this.props.wrapper;
          if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
            Wrapper = ReactTooltip.defaultProps.wrapper;
          }
          var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(' ');
          if (html) {
            var htmlContent = "".concat(content).concat(style ? "\n<style aria-hidden=\"true\">".concat(style, "</style>") : '');
            return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Wrapper, _extends({
              className: "".concat(wrapperClassName),
              id: this.props.id || uuid,
              ref: function ref(_ref) {
                return _this9.tooltipRef = _ref;
              }
            }, ariaProps, {
              "data-id": "tooltip",
              dangerouslySetInnerHTML: {
                __html: htmlContent
              }
            }));
          } else {
            return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Wrapper, _extends({
              className: "".concat(wrapperClassName),
              id: this.props.id || uuid
            }, ariaProps, {
              ref: function ref(_ref2) {
                return _this9.tooltipRef = _ref2;
              },
              "data-id": "tooltip"
            }), style && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("style", {
              dangerouslySetInnerHTML: {
                __html: style
              },
              "aria-hidden": "true"
            }), content);
          }
        }
      }], [{
        key: "propTypes",
        get: function get() {
          return {
            uuid: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.any,
            place: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            type: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            effect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            offset: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
            padding: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            multiline: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
            border: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
            borderClass: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            textColor: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            backgroundColor: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            borderColor: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            arrowColor: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            arrowRadius: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            tooltipRadius: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            insecure: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
            "class": prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            html: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
            delayHide: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
            delayUpdate: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
            delayShow: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
            event: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            eventOff: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            isCapture: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
            globalEventOff: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            getContent: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.any,
            afterShow: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
            afterHide: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
            overridePosition: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
            disable: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
            scrollHide: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
            resizeHide: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
            wrapper: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            bodyMode: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
            possibleCustomEvents: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            possibleCustomEventsOff: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            clickable: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
            disableInternalStyle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
          };
        }
      }, {
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(nextProps, prevState) {
          var ariaProps = prevState.ariaProps;
          var newAriaProps = parseAria(nextProps);
          var isChanged = Object.keys(newAriaProps).some(function (props) {
            return newAriaProps[props] !== ariaProps[props];
          });
          if (!isChanged) {
            return null;
          }
          return _objectSpread2(_objectSpread2({}, prevState), {}, {
            ariaProps: newAriaProps
          });
        }
      }]);
      return ReactTooltip;
    }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component), _defineProperty(_class2, "defaultProps", {
      insecure: true,
      resizeHide: true,
      wrapper: 'div',
      clickable: false
    }), _defineProperty(_class2, "supportedWrappers", ['div', 'span']), _defineProperty(_class2, "displayName", 'ReactTooltip'), _class2)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;

    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(36));

  /***/
}, /* 61 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MoreActions = __webpack_require__(111);
  var _SharedPropTypes = __webpack_require__(27);
  __webpack_require__(55);
  __webpack_require__(143);
  var _excluded = ["icon", "title", "disabled", "type", "className", "isSplit", "isDropDown", "isLink", "to", "newTab", "dropDownTitle", "size", "style", "theme"];
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var themeStyles = new Set(['ghost', 'link']);
  /**
   * A Rhombus-styled button with an onClick handler for actions.
   * https://rhombus.flashtalking.net/components/buttons/
   */
  var Button = (_class = (_class2 = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(Button, _React$PureComponent);
    var _super = _createSuper(Button);
    function Button() {
      _classCallCheck(this, Button);
      return _super.apply(this, arguments);
    }
    _createClass(Button, [{
      key: "_renderSplit",
      value: function _renderSplit() {
        var props = this.props,
          actionsList = props.disabled ? [] : props.splitActions,
          disabledClass = props.disabled ? "is-disabled" : "";
        if (!props.isSplit) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "split-side ".concat(disabledClass)
        }, /*#__PURE__*/_react["default"].createElement(_MoreActions.MoreActions, _extends({
          className: "split-actions",
          addClass: false,
          value: props.splitValue,
          actionsList: actionsList
        }, props.splitOptions), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          name: props.splitIcon,
          className: "split-icon"
        })));
      }
    }, {
      key: "_renderDropDown",
      value: function _renderDropDown() {}
    }, {
      key: "render",
      value: function render() {
        var _classList;
        var defaults = this.context.rhombusButtonDefaults || {},
          _this$props = this.props,
          icon = _this$props.icon,
          title = _this$props.title,
          disabled = _this$props.disabled,
          type = _this$props.type,
          className = _this$props.className,
          isSplit = _this$props.isSplit,
          isDropDown = _this$props.isDropDown,
          isLink = _this$props.isLink,
          to = _this$props.to,
          newTab = _this$props.newTab,
          dropDownTitle = _this$props.dropDownTitle,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? defaults.size : _this$props$size,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? defaults.style : _this$props$style,
          _this$props$theme = _this$props.theme,
          theme = _this$props$theme === void 0 ? defaults.theme || 'default' : _this$props$theme,
          props = _objectWithoutProperties(_this$props, _excluded),
          iconTheme = 'white',
          cButton = 'c-button',
          classList = (_classList = {}, _defineProperty(_classList, className, true), _defineProperty(_classList, "is-disabled", disabled), _defineProperty(_classList, "is-loading", props.isLoading), _defineProperty(_classList, "is-split-button", isSplit), _defineProperty(_classList, "is-drop-down-button", isDropDown), _defineProperty(_classList, props.loadingClass, props.isLoading), _defineProperty(_classList, cButton, true), _defineProperty(_classList, "".concat(cButton, "--").concat(size || 'medium'), true), _defineProperty(_classList, "".concat(cButton, "--").concat(style), !!style), _classList),
          $icon = null,
          $buttonText = /*#__PURE__*/_react["default"].createElement("span", {
            className: "button-content flex-center"
          }, this.props.children),
          buttonProps = {
            type: type,
            disabled: disabled,
            title: props.isLoading ? "Please Wait..." : title
          };
        if (props.value) {
          buttonProps.value = props.value;
        }
        if (theme) {
          var variant = themeStyles.has(style) ? "".concat(style, "-") : '';
          classList["t-button--".concat(variant).concat(theme)] = true;
          if (/link|ghost/gi.test(style)) {
            iconTheme = theme;
          } else {
            // If the Rhombus theme we're using is white, then we need to use the default colors for the text
            if (theme === "white") {
              iconTheme = "default";
            }
          }
        } //end if(theme)

        // Set the iconTheme to grey as the last part if needed
        if (disabled) {
          iconTheme = 'grey';
        }
        if (icon) {
          $icon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            name: icon,
            className: "flex-center icon-theme-".concat(iconTheme)
          });
        }

        // Only set up the onClick handler if the button isn't loading or isn't disabled
        if (!props.isLoading && !disabled) {
          buttonProps.onClick = this.props.onClick;
        }
        buttonProps.className = (0, _classnames["default"])(classList);
        if (isDropDown) {
          var actionsList = disabled ? [] : props.splitActions;
          return /*#__PURE__*/_react["default"].createElement(_MoreActions.MoreActions, _extends({
            isDisabled: disabled,
            title: dropDownTitle,
            addClass: false,
            iconOnly: props.dropDownIconOnly,
            value: props.splitValue
          }, props.splitOptions, {
            actionsList: actionsList
          }), /*#__PURE__*/_react["default"].createElement("button", buttonProps, $icon, $buttonText, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            name: props.splitIcon,
            className: "split-icon"
          })));
        }
        if (props.form) {
          buttonProps.form = props.form;
        }
        var $buttonElement = /*#__PURE__*/_react["default"].createElement("button", buttonProps, $icon, $buttonText);
        if (isSplit) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "split-button t-theme--".concat(theme)
          }, $buttonElement, this._renderSplit());
        }
        if (isLink) {
          return /*#__PURE__*/_react["default"].createElement("a", {
            href: to,
            target: newTab ? "_blank" : "",
            className: buttonProps.className
          }, $icon, $buttonText);
        }
        return $buttonElement;
      }
    }]);
    return Button;
  }(_react["default"].PureComponent), _defineProperty(_class2, "displayName", "Button"), _defineProperty(_class2, "contextTypes", {
    rhombusButtonDefaults: _propTypes["default"].shape({
      /** Sets the theme/colour of the button */
      theme: _SharedPropTypes.PROPTYPE_THEME,
      /** Changes the size of the button */
      size: _propTypes["default"].oneOf(['small', 'medium', 'large', 'xlarge']),
      /** Sets the style to rounded, ghost, link, block, or the default. The default should be applied automatically, and almost never needs to be passed in as a prop. */
      style: _propTypes["default"].oneOf(['rounded', 'ghost', 'link', 'block', ''])
    })
  }), _defineProperty(_class2, "propTypes", {
    /**
     * Default Props
     ****************/
    /* Custom CSS class to apply to the button */
    className: _propTypes["default"].string,
    /* HTML Tooltip title text to display*/
    title: _propTypes["default"].string,
    /** Adds a disabled state to the button */
    disabled: _propTypes["default"].bool,
    /** A button can be one of 3 different types, each of which does somehting different */
    type: _propTypes["default"].oneOf(["button", "submit", "reset"]),
    /** Changes the size of the button */
    size: _propTypes["default"].oneOf(['small', 'medium', 'large', 'xlarge']),
    /** Sets the style to rounded, ghost, link, block, or the default. The default should be applied automatically, and almost never needs to be passed in. */
    style: _propTypes["default"].oneOf(['rounded', 'ghost', 'link', 'block', '']),
    /** Icon name to be displayed, if any */
    icon: _propTypes["default"].string,
    /** Sets the theme/colour of the button */
    theme: _SharedPropTypes.PROPTYPE_THEME,
    /**
     * Split Props
     **************/
    /** Turns this button into a split more-actions type button */
    isSplit: _propTypes["default"].bool,
    /** The Icon that should be used for the split action */
    splitIcon: _propTypes["default"].string,
    /** Actions List to pass to the Split Icon */
    splitActions: _propTypes["default"].array,
    /** Value for the Split Actions Component */
    splitValue: _propTypes["default"].string,
    /**
     * Is Loading Props
     *******************/
    /** Set the button to be in a "Loading" state: A default Loading Icon will be added, it will spin, and  the button will be un-clickable. (Also makes the Title text say "Please Wait") */
    isLoading: _propTypes["default"].bool,
    /** The Loading class that should be added to signify the button is in a loading state. */
    loadingClass: _propTypes["default"].string,
    /** The Loading class that should be added to the icon to signify the button is in a loading state. */
    iconLoadingClass: _propTypes["default"].string,
    /**
     * Is Link Props
     ******************/
    /** Set the button to a link <a>*/
    isLink: _propTypes["default"].bool,
    /** This is the link to where the user should go */
    to: _propTypes["default"].string,
    /** Allows user to link to a new tab via target attribute  */
    newTab: _propTypes["default"].bool
  }), _defineProperty(_class2, "defaultProps", {
    type: "button",
    className: "",
    title: null,
    value: null,
    // style:"block",
    theme: "blue",
    isDropDown: false,
    dropDownIconOnly: false,
    dropDownTitle: "Click for More",
    isSplit: false,
    splitIcon: "fas fa-caret-down",
    splitActions: [],
    splitValue: "",
    splitOptions: {},
    isLoading: false,
    loadingClass: "",
    iconLoadingClass: "rotate-y-3d",
    isLink: false,
    to: "",
    newTab: false
  }), _class2), (_applyDecoratedDescriptor(_class.prototype, "_renderSplit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderSplit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderDropDown", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderDropDown"), _class.prototype)), _class);
  exports["default"] = Button;

  /***/
}, /* 62 */
/***/function (module, exports) {
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }
  module.exports = isObjectLike;

  /***/
}, /* 63 */
/***/function (module, exports) {
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }
  module.exports = isObject;

  /***/
}, /* 64 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _reactSelect = _interopRequireWildcard(__webpack_require__(116));
  var _async = _interopRequireDefault(__webpack_require__(67));
  var _creatable = _interopRequireDefault(__webpack_require__(68));
  var _asyncCreatable = _interopRequireDefault(__webpack_require__(123));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _ControlWrapper = _interopRequireDefault(__webpack_require__(29));
  var _excluded = ["className", "allowCreate", "isAsync", "icon"];
  var _class, _class2, _class3;
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var Select = (0, _ControlWrapper["default"])(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
    _inherits(Select, _React$Component);
    var _super = _createSuper(Select);
    // See https://github.com/JedWatson/react-select for additional prop options
    // 		latest react-select docs:	https://react-select.com/props
    // 		v1 -> v2 upgrade guide:		https://react-select.com/upgrade-guide
    // 		v2 -> v3 upgrade guide:		https://github.com/JedWatson/react-select/issues/3585

    function Select(props, context) {
      var _this;
      _classCallCheck(this, Select);
      _this = _super.call(this, props, context);
      var setState = {
        value: null
      };
      if (props.value) {
        if (props.multi || props.isMulti) {
          setState = {
            value: props.value
          };
        } else {
          if (props.value.label || props.value.value) {
            setState = {
              _length: props.value.value,
              value: props.value
            };
          }
        }
      }
      _this.state = setState;
      return _this;
    }
    _createClass(Select, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var props = this.props;
        if (nextProps.value !== props.value && nextProps.value !== this.state.value) {
          if (nextProps.value) {
            if (props.multi || props.isMulti) {
              this.setState({
                value: nextProps.value
              });
            } else {
              if (nextProps.value.label || nextProps.value.value) {
                this.setState({
                  value: nextProps.value
                });
              }
            }
          } else {
            this.setState({
              value: null
            });
          }
        }
      }

      /* optionRenderer was removed in the upgrade from react-select v1.x -> v2.x
       * instead, we need to pass in an Option component
       * convert optionRenderer to an Option component here for backward compatability
       */
    }, {
      key: "_buildOption",
      value: function _buildOption(props) {
        // option props from react-select
        var optionRenderer = this.props.optionRenderer; //this component's props

        return _reactSelect.components.Option && /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, props, optionRenderer(props.data));
      }

      /* valueRenderer was removed in the upgrade from react-select v1.x -> v2.x
       * instead, we need to pass in a SingleValue component
       * convert valueRenderer to a SingleValue component here for backward compatability
       */
    }, {
      key: "_buildSingleValue",
      value: function _buildSingleValue(props) {
        // value props from react-select
        var valueRenderer = this.props.valueRenderer; //this component's props

        return _reactSelect.components.Option && /*#__PURE__*/_react["default"].createElement(_reactSelect.components.SingleValue, props, valueRenderer(props.data));
      }
    }, {
      key: "_buildSelectProps",
      value: function _buildSelectProps(props) {
        var state = this.state,
          selectProps = _objectSpread(_objectSpread({}, props), {}, {
            value: state.value,
            onChange: this.onChange,
            className: "react-select value-color--".concat(props.theme),
            // In order for react-select to work with redux-form, we need to pass in onBlur
            // https://github.com/erikras/redux-form/issues/82#issuecomment-274047138
            onBlur: this.onBlur,
            // react-select v3 components guide: https://react-select.com/components
            components: _objectSpread({
              ClearIndicator: ClearIndicator,
              DropdownIndicator: DropdownIndicator
            }, props.components)
          });

        // some props were renamed after react-select 1.x (using 3.x as of 7/2/19)
        // if they were passed in the old way, assign them here (so we don't have to update old code)
        // NOTE: onSelectResetsInput was removed in 2.x and we now handle it in ControlWrapper.js handleInputChange()
        // NOTE: if breaking changes are encountered, to determine if a prop name has changed or been removed check
        // 		latest react-select docs:	https://react-select.com/props
        // 		v1 -> v2 upgrade guide:		https://react-select.com/upgrade-guide
        // 		v2 -> v3 upgrade guide:		https://github.com/JedWatson/react-select/issues/3585
        if (typeof props.clearable === "boolean") {
          selectProps.isClearable = props.clearable;
        }
        if (typeof props.closeOnSelect === "boolean") {
          selectProps.closeMenuOnSelect = props.closeOnSelect;
        }
        if (typeof props.disabled === "boolean") {
          selectProps.isDisabled = props.disabled;
        }
        if (typeof props.multi === "boolean") {
          selectProps.isMulti = props.multi;
        }
        if (typeof props.onKeyDown === "function") {
          selectProps.onInputKeyDown = props.onKeyDown;
        }
        if (typeof props.searchable === "boolean") {
          selectProps.isSearchable = props.searchable;
        }
        if (typeof props.optionRenderer === "function") {
          selectProps.components.Option = this._buildOption;
        }
        if (typeof props.valueRenderer === "function") {
          selectProps.components.SingleValue = this._buildSingleValue;
        }
        return selectProps;
      }
    }, {
      key: "onChange",
      value: function onChange(value) {
        var props = this.props,
          state = this.state,
          x = null,
          newValue = null;
        if (value !== null) {
          if (!value && props.preserveSubObjects) {
            newValue = {};
            for (x in state.value) {
              if (state.value[x] && _typeof(state.value[x]) === "object") {
                newValue[x] = state.value[x];
              }
            }
          } else {
            newValue = value;
          } //end if(props.perserveSubObjects)
        } //end if(value !== null)

        this.setState({
          _length: value && value.label || 0,
          value: newValue
        }, function () {
          if (props.onChange) {
            props.onChange(value);
          }
        });
      }
    }, {
      key: "onBlur",
      value: function onBlur() {
        var currentValue = this.state.value;
        if (this.props.onBlur) {
          this.props.onBlur(currentValue);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          className = _this$props.className,
          allowCreate = _this$props.allowCreate,
          isAsync = _this$props.isAsync,
          icon = _this$props.icon,
          props = _objectWithoutProperties(_this$props, _excluded),
          selectProps = this._buildSelectProps(props),
          $node = null,
          hasIcon = this.props.showIcon && this.props.icon,
          divClasses = {
            "e-form__control": true,
            "e-form__control-react-select": true,
            "react-select-holder": true,
            "has-icon": hasIcon,
            "has-clear": this.state.value && selectProps.isClearable
          };
        if (props.multi || props.isMulti) {
          var removeItem = function removeItem(event, props) {
            event.stopPropagation();
            props.onRemove(props.value);
          };
          selectProps.valueComponent = function (props) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: "Select-value"
            }, /*#__PURE__*/_react["default"].createElement("span", {
              className: "Select-value-label",
              role: "option",
              "aria-selected": "true"
            }, props.value.label), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
              name: "clearCircle",
              className: "rhombus-multiselect-remove",
              "aria-hidden": "true",
              onClick: function onClick(e) {
                return removeItem(e, props);
              },
              onMouseDown: function onMouseDown(e) {
                return e.stopPropagation();
              }
            }));
          };
        }
        if (allowCreate) {
          if (isAsync) {
            $node = /*#__PURE__*/_react["default"].createElement(_asyncCreatable["default"], selectProps);
          } else {
            $node = /*#__PURE__*/_react["default"].createElement(_creatable["default"], selectProps);
          }
        } else {
          if (isAsync) {
            $node = /*#__PURE__*/_react["default"].createElement(_async["default"], selectProps);
          } else {
            $node = /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], selectProps);
          }
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])(divClasses)
        }, hasIcon ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          className: "e-form__control--icon e-form__control--icon-left search-icon",
          name: icon
        }) : null, $node);
      }
    }]);
    return Select;
  }(_react["default"].Component), _defineProperty(_class3, "displayName", 'Select'), _defineProperty(_class3, "propTypes", {
    /**	Can we clear the value -- [[ may be passed in as clearable in older code, allowed for backward compatibility ]] */
    isClearable: _propTypes["default"].bool,
    /** Is this a multi-value input -- [[ may be passed in as multi in older code, allowed for backward compatibility ]] */
    isMulti: _propTypes["default"].bool,
    /** is this component disabled? -- [[ may be passed in as disabled, allowed for backward compatibility ]] */
    isDisabled: _propTypes["default"].bool,
    /**	Class name to add to the options rendered component */
    optionClassName: _propTypes["default"].string,
    /**	Options that the select should show */
    options: _propTypes["default"].array,
    /** placeholder text */
    placeholder: _propTypes["default"].string,
    /** prefix to use for class names under the main select so we can target those elements */
    classNamePrefix: _propTypes["default"].string,
    /** */
    theme: _propTypes["default"].string,
    /** */
    className: _propTypes["default"].string,
    /**	should this be a Creatable select? */
    allowCreate: _propTypes["default"].bool,
    /** Should we use the Async version of the React.Select */
    isAsync: _propTypes["default"].bool,
    /** :: Not prefaced with "is" because it's native to React-Select */
    autoload: _propTypes["default"].bool,
    /** */
    preserveSubObjects: _propTypes["default"].bool,
    /** this was a prop in react-select 1.x that was removed in react-select 2.x; this is now handled in ControlWrapper.js handleInputChange() */
    onSelectResetsInput: _propTypes["default"].bool,
    // see ControlWrapper.js handleInputChange()
    /** component renderers (see react-select v3 components guide: https://react-select.com/components) */
    components: _propTypes["default"].object,
    /** custom validator to ensure we add onMenuScrollToBottom functions to Selects */onMenuScrollToBottom: function onMenuScrollToBottom(props, propName, componentName) {
      var fieldName = props.label || props.name || props.className,
        fieldInfo = fieldName ? " for ".concat(fieldName, " Field") : null;
      if (!props.onMenuScrollToBottom) {
        return new Error("<".concat(componentName, ">").concat(fieldInfo, " has no ").concat(propName, " function.  This will mean no API calls happen when users scroll.  If this is intentional please pass in noop for onMenuScrollToBottom."));
      }
    }
  }), _defineProperty(_class3, "defaultProps", {
    isClearable: true,
    isMulti: false,
    isDisabled: false,
    optionClassName: "e-form__select-option",
    options: [],
    placeholder: "Select...",
    classNamePrefix: "react-select",
    theme: "primary",
    className: "",
    allowCreate: false,
    isAsync: false,
    autoload: false,
    preserveSubObjects: true,
    onSelectResetsInput: true,
    components: {}
  }), _class3), (_applyDecoratedDescriptor(_class2.prototype, "_buildOption", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "_buildOption"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_buildSingleValue", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "_buildSingleValue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_buildSelectProps", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "_buildSelectProps"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onBlur", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onBlur"), _class2.prototype)), _class2)) || _class;
  exports["default"] = Select;
  var ClearIndicator = function ClearIndicator(props) {
    return _reactSelect.components.ClearIndicator && /*#__PURE__*/_react["default"].createElement(_reactSelect.components.ClearIndicator, props, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "clear"
    }));
  };
  var DropdownIndicator = function DropdownIndicator(props) {
    return _reactSelect.components.DropdownIndicator && /*#__PURE__*/_react["default"].createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: props.selectProps.menuIsOpen ? "caretUp" : "caretDown"
    }));
  };

  /***/
}, /* 65 */
/***/function (module, exports, __webpack_require__) {
  var objectWithoutPropertiesLoose = __webpack_require__(77);
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 66 */
/***/function (module, exports, __webpack_require__) {
  var arrayWithoutHoles = __webpack_require__(120);
  var iterableToArray = __webpack_require__(121);
  var unsupportedIterableToArray = __webpack_require__(84);
  var nonIterableSpread = __webpack_require__(122);
  function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
  }
  module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 67 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "defaultProps", function () {
    return defaultProps;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "makeAsyncSelect", function () {
    return makeAsyncSelect;
  });
  /* harmony import */
  var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22);
  /* harmony import */
  var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
  /* harmony import */
  var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48);
  /* harmony import */
  var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
  /* harmony import */
  var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66);
  /* harmony import */
  var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__);
  /* harmony import */
  var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11);
  /* harmony import */
  var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__);
  /* harmony import */
  var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12);
  /* harmony import */
  var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13);
  /* harmony import */
  var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7);
  /* harmony import */
  var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__);
  /* harmony import */
  var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14);
  /* harmony import */
  var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16);
  /* harmony import */
  var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
  /* harmony import */
  var _emotion_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3);
  /* harmony import */
  var react_dom__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15);
  /* harmony import */
  var react_dom__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_13__);
  /* harmony import */
  var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35);
  /* harmony import */
  var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__);
  /* harmony import */
  var _dist_index_75b02bac_browser_esm_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5);
  /* harmony import */
  var _dist_Select_e1cf49ae_browser_esm_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21);
  /* harmony import */
  var _emotion_css__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(20);
  /* harmony import */
  var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(49);
  /* harmony import */
  var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_18__);
  /* harmony import */
  var react_input_autosize__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(38);
  /* harmony import */
  var react_input_autosize__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(react_input_autosize__WEBPACK_IMPORTED_MODULE_19__);
  /* harmony import */
  var _dist_stateManager_2f2b6f5b_browser_esm_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(31);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__[/* default */"a"])(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__[/* default */"a"])(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__[/* default */"a"])(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var defaultProps = {
    cacheOptions: false,
    defaultOptions: false,
    filterOption: null,
    isLoading: false
  };
  var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/function (_Component) {
      Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_8__[/* default */"a"])(Async, _Component);
      var _super = _createSuper(Async);
      function Async(props) {
        var _this;
        Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */"a"])(this, Async);
        _this = _super.call(this);
        _this.select = void 0;
        _this.lastRequest = void 0;
        _this.mounted = false;
        _this.optionsCache = {};
        _this.handleInputChange = function (newValue, actionMeta) {
          var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange; // TODO

          var inputValue = Object(_dist_index_75b02bac_browser_esm_js__WEBPACK_IMPORTED_MODULE_15__[/* G */"g"])(newValue, actionMeta, onInputChange);
          if (!inputValue) {
            delete _this.lastRequest;
            _this.setState({
              inputValue: '',
              loadedInputValue: '',
              loadedOptions: [],
              isLoading: false,
              passEmptyOptions: false
            });
            return;
          }
          if (cacheOptions && _this.optionsCache[inputValue]) {
            _this.setState({
              inputValue: inputValue,
              loadedInputValue: inputValue,
              loadedOptions: _this.optionsCache[inputValue],
              isLoading: false,
              passEmptyOptions: false
            });
          } else {
            var request = _this.lastRequest = {};
            _this.setState({
              inputValue: inputValue,
              isLoading: true,
              passEmptyOptions: !_this.state.loadedInputValue
            }, function () {
              _this.loadOptions(inputValue, function (options) {
                if (!_this.mounted) return;
                if (options) {
                  _this.optionsCache[inputValue] = options;
                }
                if (request !== _this.lastRequest) return;
                delete _this.lastRequest;
                _this.setState({
                  isLoading: false,
                  loadedInputValue: inputValue,
                  loadedOptions: options || [],
                  passEmptyOptions: false
                });
              });
            });
          }
          return inputValue;
        };
        _this.state = {
          defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
          inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
          isLoading: props.defaultOptions === true,
          loadedOptions: [],
          passEmptyOptions: false
        };
        return _this;
      }
      Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */"a"])(Async, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;
          this.mounted = true;
          var defaultOptions = this.props.defaultOptions;
          var inputValue = this.state.inputValue;
          if (defaultOptions === true) {
            this.loadOptions(inputValue, function (options) {
              if (!_this2.mounted) return;
              var isLoading = !!_this2.lastRequest;
              _this2.setState({
                defaultOptions: options || [],
                isLoading: isLoading
              });
            });
          }
        }
      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
          // if the cacheOptions prop changes, clear the cache
          if (nextProps.cacheOptions !== this.props.cacheOptions) {
            this.optionsCache = {};
          }
          if (nextProps.defaultOptions !== this.props.defaultOptions) {
            this.setState({
              defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.mounted = false;
        }
      }, {
        key: "focus",
        value: function focus() {
          this.select.focus();
        }
      }, {
        key: "blur",
        value: function blur() {
          this.select.blur();
        }
      }, {
        key: "loadOptions",
        value: function loadOptions(inputValue, callback) {
          var loadOptions = this.props.loadOptions;
          if (!loadOptions) return callback();
          var loader = loadOptions(inputValue, callback);
          if (loader && typeof loader.then === 'function') {
            loader.then(callback, function () {
              return callback();
            });
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this3 = this;
          var _this$props2 = this.props,
            loadOptions = _this$props2.loadOptions,
            isLoadingProp = _this$props2.isLoading,
            props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"])(_this$props2, ["loadOptions", "isLoading"]);
          var _this$state = this.state,
            defaultOptions = _this$state.defaultOptions,
            inputValue = _this$state.inputValue,
            isLoading = _this$state.isLoading,
            loadedInputValue = _this$state.loadedInputValue,
            loadedOptions = _this$state.loadedOptions,
            passEmptyOptions = _this$state.passEmptyOptions;
          var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(SelectComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */"a"])({}, props, {
            ref: function ref(_ref) {
              _this3.select = _ref;
            },
            options: options,
            isLoading: isLoading || isLoadingProp,
            onInputChange: this.handleInputChange
          }));
        }
      }]);
      return Async;
    }(react__WEBPACK_IMPORTED_MODULE_11__["Component"]), _class.defaultProps = defaultProps, _temp;
  };
  var SelectState = Object(_dist_stateManager_2f2b6f5b_browser_esm_js__WEBPACK_IMPORTED_MODULE_20__[/* m */"a"])(_dist_Select_e1cf49ae_browser_esm_js__WEBPACK_IMPORTED_MODULE_16__[/* S */"a"]);
  var Async = makeAsyncSelect(SelectState);

  /* harmony default export */
  __webpack_exports__["default"] = Async;

  /***/
}, /* 68 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "defaultProps", function () {
    return defaultProps;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "makeCreatableSelect", function () {
    return makeCreatableSelect;
  });
  /* harmony import */
  var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65);
  /* harmony import */
  var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */
  var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
  /* harmony import */
  var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48);
  /* harmony import */
  var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
  /* harmony import */
  var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39);
  /* harmony import */
  var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10);
  /* harmony import */
  var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12);
  /* harmony import */
  var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13);
  /* harmony import */
  var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7);
  /* harmony import */
  var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__);
  /* harmony import */
  var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14);
  /* harmony import */
  var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16);
  /* harmony import */
  var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
  /* harmony import */
  var _emotion_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3);
  /* harmony import */
  var react_dom__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15);
  /* harmony import */
  var react_dom__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_13__);
  /* harmony import */
  var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35);
  /* harmony import */
  var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__);
  /* harmony import */
  var _dist_index_75b02bac_browser_esm_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5);
  /* harmony import */
  var _dist_Select_e1cf49ae_browser_esm_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21);
  /* harmony import */
  var _emotion_css__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(20);
  /* harmony import */
  var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(49);
  /* harmony import */
  var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_18__);
  /* harmony import */
  var react_input_autosize__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(38);
  /* harmony import */
  var react_input_autosize__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(react_input_autosize__WEBPACK_IMPORTED_MODULE_19__);
  /* harmony import */
  var _dist_stateManager_2f2b6f5b_browser_esm_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(31);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__[/* default */"a"])(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__[/* default */"a"])(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__[/* default */"a"])(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__[/* default */"a"])(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(option.value).toLowerCase();
    var optionLabel = String(option.label).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
  };
  var builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
      return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
      return !(!inputValue || selectValue.some(function (option) {
        return compareOption(inputValue, option);
      }) || selectOptions.some(function (option) {
        return compareOption(inputValue, option);
      }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
      return {
        label: optionLabel,
        value: inputValue,
        __isNew__: true
      };
    }
  };
  var defaultProps = _objectSpread({
    allowCreateWhileLoading: false,
    createOptionPosition: 'last'
  }, builtins);
  var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/function (_Component) {
      Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_8__[/* default */"a"])(Creatable, _Component);
      var _super = _createSuper(Creatable);
      function Creatable(props) {
        var _this;
        Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */"a"])(this, Creatable);
        _this = _super.call(this, props);
        _this.select = void 0;
        _this.onChange = function (newValue, actionMeta) {
          var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value,
            name = _this$props.name;
          if (actionMeta.action !== 'select-option') {
            return onChange(newValue, actionMeta);
          }
          var newOption = _this.state.newOption;
          var valueArray = Array.isArray(newValue) ? newValue : [newValue];
          if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);else {
              var newOptionData = getNewOptionData(inputValue, inputValue);
              var newActionMeta = {
                action: 'create-option',
                name: name
              };
              if (isMulti) {
                onChange([].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__[/* default */"a"])(Object(_dist_index_75b02bac_browser_esm_js__WEBPACK_IMPORTED_MODULE_15__[/* C */"c"])(value)), [newOptionData]), newActionMeta);
              } else {
                onChange(newOptionData, newActionMeta);
              }
            }
            return;
          }
          onChange(newValue, actionMeta);
        };
        var options = props.options || [];
        _this.state = {
          newOption: undefined,
          options: options
        };
        return _this;
      }
      Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */"a"])(Creatable, [{
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
          var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
            createOptionPosition = nextProps.createOptionPosition,
            formatCreateLabel = nextProps.formatCreateLabel,
            getNewOptionData = nextProps.getNewOptionData,
            inputValue = nextProps.inputValue,
            isLoading = nextProps.isLoading,
            isValidNewOption = nextProps.isValidNewOption,
            value = nextProps.value;
          var options = nextProps.options || [];
          var newOption = this.state.newOption;
          if (isValidNewOption(inputValue, Object(_dist_index_75b02bac_browser_esm_js__WEBPACK_IMPORTED_MODULE_15__[/* C */"c"])(value), options)) {
            newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
          } else {
            newOption = undefined;
          }
          this.setState({
            newOption: newOption,
            options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__[/* default */"a"])(options)) : [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__[/* default */"a"])(options), [newOption]) : options
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          this.select.focus();
        }
      }, {
        key: "blur",
        value: function blur() {
          this.select.blur();
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;
          var options = this.state.options;
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(SelectComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */"a"])({}, this.props, {
            ref: function ref(_ref) {
              _this2.select = _ref;
            },
            options: options,
            onChange: this.onChange
          }));
        }
      }]);
      return Creatable;
    }(react__WEBPACK_IMPORTED_MODULE_11__["Component"]), _class.defaultProps = defaultProps, _temp;
  }; // TODO: do this in package entrypoint

  var SelectCreatable = makeCreatableSelect(_dist_Select_e1cf49ae_browser_esm_js__WEBPACK_IMPORTED_MODULE_16__[/* S */"a"]);
  var Creatable = Object(_dist_stateManager_2f2b6f5b_browser_esm_js__WEBPACK_IMPORTED_MODULE_20__[/* m */"a"])(SelectCreatable);

  /* harmony default export */
  __webpack_exports__["default"] = Creatable;

  /***/
}, /* 69 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var _assign = __webpack_require__(551);
  var _assign2 = _interopRequireDefault(_assign);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.default = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };

  /***/
}, /* 70 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(71);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 71 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * Tooltip Styles\n */\n.c-tooltip::after {\n\tbackground-color: #374047;\n\tcolor: #fff;\n\tpadding: 5px;\n\tborder-color:#374047;\n\topacity: 1;\n}\n.c-tooltip--left::before {\n\tborder-left-color: #374047;\n\tborder-left-width: 10px;\n}\n\n.c-tooltip.c-tooltip--is-visible:after, .c-tooltip.c-tooltip--is-visible:before {\n    visibility: visible;\n}\n.c-tooltip.c-tooltip--is-hidden:hover:after, .c-tooltip.c-tooltip--is-hidden:hover:before {\n    visibility: hidden;\n}\n\n\n/* red theme */\n.c-tooltip.c-tooltip--top.t-tooltip--red::before{\n\tborder-top-color: #db6662;\n}\n.c-tooltip.c-tooltip--bottom.t-tooltip--red::before{\n\tborder-bottom-color: #db6662;\n}\n.c-tooltip.c-tooltip--left.t-tooltip--red::before{\n\tborder-left-color: #db6662;\n}\n.c-tooltip.c-tooltip--right.t-tooltip--red::before{\n\tborder-right-color: #db6662;\n}\n.c-tooltip.t-tooltip--red::after {\n\tbackground-color: #db6662;\n\tborder-color: #db6662;\n}", "", {
    "version": 3,
    "sources": ["Tooltip.css"],
    "names": [],
    "mappings": "AAAA;;EAEE;AACF;CACC,yBAAyB;CACzB,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,UAAU;AACX;AACA;CACC,0BAA0B;CAC1B,uBAAuB;AACxB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;;;AAGA,cAAc;AACd;CACC,yBAAyB;AAC1B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,yBAAyB;CACzB,qBAAqB;AACtB",
    "file": "Tooltip.css",
    "sourcesContent": ["/**\n * Tooltip Styles\n */\n.c-tooltip::after {\n\tbackground-color: #374047;\n\tcolor: #fff;\n\tpadding: 5px;\n\tborder-color:#374047;\n\topacity: 1;\n}\n.c-tooltip--left::before {\n\tborder-left-color: #374047;\n\tborder-left-width: 10px;\n}\n\n.c-tooltip.c-tooltip--is-visible:after, .c-tooltip.c-tooltip--is-visible:before {\n    visibility: visible;\n}\n.c-tooltip.c-tooltip--is-hidden:hover:after, .c-tooltip.c-tooltip--is-hidden:hover:before {\n    visibility: hidden;\n}\n\n\n/* red theme */\n.c-tooltip.c-tooltip--top.t-tooltip--red::before{\n\tborder-top-color: #db6662;\n}\n.c-tooltip.c-tooltip--bottom.t-tooltip--red::before{\n\tborder-bottom-color: #db6662;\n}\n.c-tooltip.c-tooltip--left.t-tooltip--red::before{\n\tborder-left-color: #db6662;\n}\n.c-tooltip.c-tooltip--right.t-tooltip--red::before{\n\tborder-right-color: #db6662;\n}\n.c-tooltip.t-tooltip--red::after {\n\tbackground-color: #db6662;\n\tborder-color: #db6662;\n}"]
  }]);

  /***/
}, /* 72 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var keys = __webpack_require__(130);
  var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
  var toStr = Object.prototype.toString;
  var concat = Array.prototype.concat;
  var origDefineProperty = Object.defineProperty;
  var isFunction = function (fn) {
    return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
  };
  var hasPropertyDescriptors = __webpack_require__(223)();
  var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;
  var defineProperty = function (object, name, value, predicate) {
    if (name in object && (!isFunction(predicate) || !predicate())) {
      return;
    }
    if (supportsDescriptors) {
      origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
      });
    } else {
      object[name] = value; // eslint-disable-line no-param-reassign
    }
  };

  var defineProperties = function (object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) {
      props = concat.call(props, Object.getOwnPropertySymbols(map));
    }
    for (var i = 0; i < props.length; i += 1) {
      defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
    }
  };
  defineProperties.supportsDescriptors = !!supportsDescriptors;
  module.exports = defineProperties;

  /***/
}, /* 73 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var _defineProperty = __webpack_require__(523);
  var _defineProperty2 = _interopRequireDefault(_defineProperty);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.default = function (obj, key, value) {
    if (key in obj) {
      (0, _defineProperty2.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  };

  /***/
}, /* 74 */
/***/function (module, exports, __webpack_require__) {
  var arrayLikeKeys = __webpack_require__(187),
    baseKeys = __webpack_require__(261),
    isArrayLike = __webpack_require__(88);

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  module.exports = keys;

  /***/
}, /* 75 */
/***/function (module, exports, __webpack_require__) {
  var baseIsNative = __webpack_require__(276),
    getValue = __webpack_require__(279);

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  module.exports = getNative;

  /***/
}, /* 76 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // CONCATENATED MODULE: ./node_modules/react-tooltip/node_modules/uuid/dist/esm-browser/rng.js
  // Unique ID creation requires a high quality random # generator. In the browser we therefore
  // require the crypto API and do not support built-in fallback to lower quality random number
  // generators (like Math.random()).
  // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
  // find the complete implementation of crypto (msCrypto) on IE11.
  var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  function rng() {
    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
  }
  // CONCATENATED MODULE: ./node_modules/react-tooltip/node_modules/uuid/dist/esm-browser/bytesToUuid.js
  /**
   * Convert array of 16 byte values to UUID string format of the form:
   * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
   */
  var byteToHex = [];
  for (var bytesToUuid_i = 0; bytesToUuid_i < 256; ++bytesToUuid_i) {
    byteToHex[bytesToUuid_i] = (bytesToUuid_i + 0x100).toString(16).substr(1);
  }
  function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

    return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
  }

  /* harmony default export */
  var esm_browser_bytesToUuid = bytesToUuid;
  // CONCATENATED MODULE: ./node_modules/react-tooltip/node_modules/uuid/dist/esm-browser/v4.js

  function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
      buf = options === 'binary' ? new Array(16) : null;
      options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

    if (buf) {
      for (var ii = 0; ii < 16; ++ii) {
        buf[i + ii] = rnds[ii];
      }
    }
    return buf || esm_browser_bytesToUuid(rnds);
  }

  /* harmony default export */
  var esm_browser_v4 = __webpack_exports__["a"] = v4;

  /***/
}, /* 77 */
/***/function (module, exports) {
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 78 */
/***/function (module, exports, __webpack_require__) {
  var _typeof = __webpack_require__(35)["default"];
  var toPrimitive = __webpack_require__(112);
  function _toPropertyKey(arg) {
    var key = toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 79 */
/***/function (module, exports) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _setPrototypeOf(o, p);
  }
  module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 80 */
/***/function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(81),
    getRawTag = __webpack_require__(257),
    objectToString = __webpack_require__(258);

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }
  module.exports = baseGetTag;

  /***/
}, /* 81 */
/***/function (module, exports, __webpack_require__) {
  var root = __webpack_require__(50);

  /** Built-in value references. */
  var Symbol = root.Symbol;
  module.exports = Symbol;

  /***/
}, /* 82 */
/***/function (module, exports, __webpack_require__) {
  var assignValue = __webpack_require__(200),
    baseAssignValue = __webpack_require__(201);

  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1,
      length = props.length;
    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
      if (newValue === undefined) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }
    return object;
  }
  module.exports = copyObject;

  /***/
}, /* 83 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  /**
   * Similar to invariant but only logs a warning if the condition is not met.
   * This can be used to log issues in development environments in critical
   * paths. Removing the logging code for production environments will keep the
   * same logic and follow the same code paths.
   */
  var __DEV__ = "production" !== 'production';
  var warning = function () {};
  if (__DEV__) {
    var printWarning = function printWarning(format, args) {
      var len = arguments.length;
      args = new Array(len > 1 ? len - 1 : 0);
      for (var key = 1; key < len; key++) {
        args[key - 1] = arguments[key];
      }
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
    warning = function (condition, format, args) {
      var len = arguments.length;
      args = new Array(len > 2 ? len - 2 : 0);
      for (var key = 2; key < len; key++) {
        args[key - 2] = arguments[key];
      }
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }
      if (!condition) {
        printWarning.apply(null, [format].concat(args));
      }
    };
  }
  module.exports = warning;

  /***/
}, /* 84 */
/***/function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(85);
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }
  module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 85 */
/***/function (module, exports) {
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 86 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var _typeof2 = __webpack_require__(473);
  var _typeof3 = _interopRequireDefault(_typeof2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.default = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
  };

  /***/
}, /* 87 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.Input = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _SharedPropTypes = __webpack_require__(27);
  var _functions = __webpack_require__(33);
  var _ControlWrapper = _interopRequireDefault(__webpack_require__(29));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  __webpack_require__(178);
  var _excluded = ["icon", "iconPos", "theme", "UID", "className", "showCharCount", "charMax", "defaultValue", "type", "hasError", "normalizeType", "pre", "post"];
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var Input = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    _inherits(Input, _React$Component);
    var _super = _createSuper(Input);
    function Input(props, context) {
      var _this;
      _classCallCheck(this, Input);
      _this = _super.call(this, props, context);
      _this.state = {
        value: props.value || props.defaultValue || ""
      };
      return _this;
    }
    _createClass(Input, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          iconClassPrefix: "e-form__control--icon e-form__control--icon-".concat(this.props.iconPos)
        };
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
          this.setState({
            value: nextProps.value || ""
          });
        }
      }
    }, {
      key: "onChange",
      value: function onChange(e) {
        var value = e.target.value,
          _this$props = this.props,
          normalizeType = _this$props.normalizeType,
          type = _this$props.type,
          min = _this$props.min,
          max = _this$props.max,
          onChange = _this$props.onChange;
        if (type === "number" && normalizeType !== "none") {
          value = (0, _functions.normalizeNumbers)(value, min, max, normalizeType);
        }
        this.setState({
          value: value
        }, function () {
          if (onChange) {
            onChange(value);
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          icon = _this$props2.icon,
          iconPos = _this$props2.iconPos,
          theme = _this$props2.theme,
          UID = _this$props2.UID,
          className = _this$props2.className,
          showCharCount = _this$props2.showCharCount,
          charMax = _this$props2.charMax,
          defaultValue = _this$props2.defaultValue,
          type = _this$props2.type,
          hasError = _this$props2.hasError,
          normalizeType = _this$props2.normalizeType,
          pre = _this$props2.pre,
          post = _this$props2.post,
          remainderProps = _objectWithoutProperties(_this$props2, _excluded),
          wrapperClass = {
            "e-form__control": true,
            "with-icon": !!(icon || pre || post),
            "is-text-area": type === "textarea",
            'e-form--error': hasError
          },
          extraProps = {},
          $node = null;
        if (!theme) {
          theme = this.context.rhombusTheme;
        }
        if (type === "number") {
          // add step="any" to number fields if step is not specified to fix an issue with firefox incorrectly highlighting a field as if it is in error
          if (typeof remainderProps.step === "undefined") {
            remainderProps.step = "any";
          }
          if (normalizeType !== "none") {
            extraProps.normalize = function (value) {
              (0, _functions.normalizeNumbers)(value, remainderProps.min, remainderProps.max, normalizeType);
            };
          }
        }
        if (type === "textarea") {
          $node = /*#__PURE__*/_react["default"].createElement("textarea", _extends({}, extraProps, remainderProps, {
            value: this.state.value,
            onChange: this.onChange,
            id: UID,
            className: "e-form__input text-area ".concat(className)
          }));
        } else {
          $node = /*#__PURE__*/_react["default"].createElement("input", _extends({}, extraProps, remainderProps, {
            type: type,
            value: this.state.value,
            onChange: this.onChange,
            id: UID,
            className: "e-form__input ".concat(className)
          }));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])(wrapperClass)
        }, icon ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          name: icon
        }) : null, pre ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "inline-content pre-content"
        }, pre) : null, $node, post ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "inline-content post-content"
        }, post) : null);
      }
    }]);
    return Input;
  }(_react["default"].Component), _defineProperty(_class2, "displayName", 'Input'), _defineProperty(_class2, "childContextTypes", {
    iconClassPrefix: _propTypes["default"].string
  }), _defineProperty(_class2, "contextTypes", {
    rhombusTheme: _SharedPropTypes.PROPTYPE_THEME
  }), _defineProperty(_class2, "propTypes", {
    UID: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    /** Sets the theme/colour for the input */
    theme: _SharedPropTypes.PROPTYPE_THEME,
    /** The icon to be displayed, if any */
    icon: _propTypes["default"].string,
    /** Position of the icon, either 'left' or 'right', immutable once set */
    iconPos: _propTypes["default"].oneOf(["left", "right"]),
    /** Sets the placeholder text */
    placeholder: _propTypes["default"].string,
    /** Sets the name/url param for this field */
    name: _propTypes["default"].string.isRequired,
    /** Sets the input type */
    type: _propTypes["default"].oneOf(['text', 'password', 'datetime', 'datetime-local', 'date', 'month', 'time', 'week', 'number', 'email', 'url', 'search', 'tel', 'color', 'range', 'textarea']),
    /** should number inputs be normalized */
    normalizeType: _propTypes["default"].oneOf(['none', 'int', 'float']),
    /** Content to display inline with the `input` element, inside the border 
     * similar to the `icon` prop, but more flexible.
     * `pre` is added before the input element.
     * `post` is added after the input element.
    */
    pre: _propTypes["default"].node,
    post: _propTypes["default"].node
  }), _defineProperty(_class2, "defaultProps", {
    name: "",
    placeholder: "",
    icon: null,
    iconPos: 'left',
    type: 'text',
    normalizeType: 'none',
    pre: null,
    post: null
  }), _class2), _applyDecoratedDescriptor(_class.prototype, "onChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class);
  /**
   * Creates a text input box, with optional icon, placeholder, label, help text, required flag.
   */
  exports.Input = Input;
  var _default = (0, _ControlWrapper["default"])(Input);
  exports["default"] = _default;

  /***/
}, /* 88 */
/***/function (module, exports, __webpack_require__) {
  var isFunction = __webpack_require__(191),
    isLength = __webpack_require__(149);

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  module.exports = isArrayLike;

  /***/
}, /* 89 */
/***/function (module, exports, __webpack_require__) {
  var isSymbol = __webpack_require__(163);

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }
  module.exports = toKey;

  /***/
}, /* 90 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.default = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  /***/
}, /* 91 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var _setPrototypeOf = __webpack_require__(580);
  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
  var _create = __webpack_require__(584);
  var _create2 = _interopRequireDefault(_create);
  var _typeof2 = __webpack_require__(473);
  var _typeof3 = _interopRequireDefault(_typeof2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.default = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
    }
    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  };

  /***/
}, /* 92 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var hasSymbols = __webpack_require__(132);
  module.exports = function hasToStringTagShams() {
    return hasSymbols() && !!Symbol.toStringTag;
  };

  /***/
}, /* 93 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var undefined;
  var $SyntaxError = SyntaxError;
  var $Function = Function;
  var $TypeError = TypeError;

  // eslint-disable-next-line consistent-return
  var getEvalledConstructor = function (expressionSyntax) {
    try {
      return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
  };
  var $gOPD = Object.getOwnPropertyDescriptor;
  if ($gOPD) {
    try {
      $gOPD({}, '');
    } catch (e) {
      $gOPD = null; // this is IE 8, which has a broken gOPD
    }
  }

  var throwTypeError = function () {
    throw new $TypeError();
  };
  var ThrowTypeError = $gOPD ? function () {
    try {
      // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
      arguments.callee; // IE 8 does not throw here
      return throwTypeError;
    } catch (calleeThrows) {
      try {
        // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
        return $gOPD(arguments, 'callee').get;
      } catch (gOPDthrows) {
        return throwTypeError;
      }
    }
  }() : throwTypeError;
  var hasSymbols = __webpack_require__(219)();
  var getProto = Object.getPrototypeOf || function (x) {
    return x.__proto__;
  }; // eslint-disable-line no-proto

  var needsEval = {};
  var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
  var INTRINSICS = {
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': needsEval,
    '%AsyncGenerator%': needsEval,
    '%AsyncGeneratorFunction%': needsEval,
    '%AsyncIteratorPrototype%': needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': Error,
    '%eval%': eval,
    // eslint-disable-line no-eval
    '%EvalError%': EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $Function,
    '%GeneratorFunction%': needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': RangeError,
    '%ReferenceError%': ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $SyntaxError,
    '%ThrowTypeError%': ThrowTypeError,
    '%TypedArray%': TypedArray,
    '%TypeError%': $TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
  };
  try {
    null.error; // eslint-disable-line no-unused-expressions
  } catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS['%Error.prototype%'] = errorProto;
  }
  var doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') {
      value = getEvalledConstructor('async function () {}');
    } else if (name === '%GeneratorFunction%') {
      value = getEvalledConstructor('function* () {}');
    } else if (name === '%AsyncGeneratorFunction%') {
      value = getEvalledConstructor('async function* () {}');
    } else if (name === '%AsyncGenerator%') {
      var fn = doEval('%AsyncGeneratorFunction%');
      if (fn) {
        value = fn.prototype;
      }
    } else if (name === '%AsyncIteratorPrototype%') {
      var gen = doEval('%AsyncGenerator%');
      if (gen) {
        value = getProto(gen.prototype);
      }
    }
    INTRINSICS[name] = value;
    return value;
  };
  var LEGACY_ALIASES = {
    '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
    '%ArrayPrototype%': ['Array', 'prototype'],
    '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
    '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
    '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
    '%ArrayProto_values%': ['Array', 'prototype', 'values'],
    '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
    '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
    '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
    '%BooleanPrototype%': ['Boolean', 'prototype'],
    '%DataViewPrototype%': ['DataView', 'prototype'],
    '%DatePrototype%': ['Date', 'prototype'],
    '%ErrorPrototype%': ['Error', 'prototype'],
    '%EvalErrorPrototype%': ['EvalError', 'prototype'],
    '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
    '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
    '%FunctionPrototype%': ['Function', 'prototype'],
    '%Generator%': ['GeneratorFunction', 'prototype'],
    '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
    '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
    '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
    '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
    '%JSONParse%': ['JSON', 'parse'],
    '%JSONStringify%': ['JSON', 'stringify'],
    '%MapPrototype%': ['Map', 'prototype'],
    '%NumberPrototype%': ['Number', 'prototype'],
    '%ObjectPrototype%': ['Object', 'prototype'],
    '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
    '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
    '%PromisePrototype%': ['Promise', 'prototype'],
    '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
    '%Promise_all%': ['Promise', 'all'],
    '%Promise_reject%': ['Promise', 'reject'],
    '%Promise_resolve%': ['Promise', 'resolve'],
    '%RangeErrorPrototype%': ['RangeError', 'prototype'],
    '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
    '%RegExpPrototype%': ['RegExp', 'prototype'],
    '%SetPrototype%': ['Set', 'prototype'],
    '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
    '%StringPrototype%': ['String', 'prototype'],
    '%SymbolPrototype%': ['Symbol', 'prototype'],
    '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
    '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
    '%TypeErrorPrototype%': ['TypeError', 'prototype'],
    '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
    '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
    '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
    '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
    '%URIErrorPrototype%': ['URIError', 'prototype'],
    '%WeakMapPrototype%': ['WeakMap', 'prototype'],
    '%WeakSetPrototype%': ['WeakSet', 'prototype']
  };
  var bind = __webpack_require__(94);
  var hasOwn = __webpack_require__(221);
  var $concat = bind.call(Function.call, Array.prototype.concat);
  var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
  var $replace = bind.call(Function.call, String.prototype.replace);
  var $strSlice = bind.call(Function.call, String.prototype.slice);
  var $exec = bind.call(Function.call, RegExp.prototype.exec);

  /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
  var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
  var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
  var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === '%' && last !== '%') {
      throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
    } else if (last === '%' && first !== '%') {
      throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
    }
    var result = [];
    $replace(string, rePropName, function (match, number, quote, subString) {
      result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
    });
    return result;
  };
  /* end adaptation */

  var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
      alias = LEGACY_ALIASES[intrinsicName];
      intrinsicName = '%' + alias[0] + '%';
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
      var value = INTRINSICS[intrinsicName];
      if (value === needsEval) {
        value = doEval(intrinsicName);
      }
      if (typeof value === 'undefined' && !allowMissing) {
        throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
      }
      return {
        alias: alias,
        name: intrinsicName,
        value: value
      };
    }
    throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
  };
  module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) {
      throw new $TypeError('intrinsic name must be a non-empty string');
    }
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
      throw new $TypeError('"allowMissing" argument must be a boolean');
    }
    if ($exec(/^%?[^%]*%?$/, name) === null) {
      throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    }
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
      intrinsicBaseName = alias[0];
      $spliceApply(parts, $concat([0, 1], alias));
    }
    for (var i = 1, isOwn = true; i < parts.length; i += 1) {
      var part = parts[i];
      var first = $strSlice(part, 0, 1);
      var last = $strSlice(part, -1);
      if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
        throw new $SyntaxError('property names with quotes must have matching quotes');
      }
      if (part === 'constructor' || !isOwn) {
        skipFurtherCaching = true;
      }
      intrinsicBaseName += '.' + part;
      intrinsicRealName = '%' + intrinsicBaseName + '%';
      if (hasOwn(INTRINSICS, intrinsicRealName)) {
        value = INTRINSICS[intrinsicRealName];
      } else if (value != null) {
        if (!(part in value)) {
          if (!allowMissing) {
            throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
          }
          return void undefined;
        }
        if ($gOPD && i + 1 >= parts.length) {
          var desc = $gOPD(value, part);
          isOwn = !!desc;

          // By convention, when a data property is converted to an accessor
          // property to emulate a data property that does not suffer from
          // the override mistake, that accessor's getter is marked with
          // an `originalValue` property. Here, when we detect this, we
          // uphold the illusion by pretending to see that original data
          // property, i.e., returning the value rather than the getter
          // itself.
          if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
            value = desc.get;
          } else {
            value = value[part];
          }
        } else {
          isOwn = hasOwn(value, part);
          value = value[part];
        }
        if (isOwn && !skipFurtherCaching) {
          INTRINSICS[intrinsicRealName] = value;
        }
      }
    }
    return value;
  };

  /***/
}, /* 94 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var implementation = __webpack_require__(220);
  module.exports = Function.prototype.bind || implementation;

  /***/
}, /* 95 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var bind = __webpack_require__(94);
  var GetIntrinsic = __webpack_require__(93);
  var $apply = GetIntrinsic('%Function.prototype.apply%');
  var $call = GetIntrinsic('%Function.prototype.call%');
  var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
  var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
  var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
  var $max = GetIntrinsic('%Math.max%');
  if ($defineProperty) {
    try {
      $defineProperty({}, 'a', {
        value: 1
      });
    } catch (e) {
      // IE 8 has a broken defineProperty
      $defineProperty = null;
    }
  }
  module.exports = function callBind(originalFunction) {
    var func = $reflectApply(bind, $call, arguments);
    if ($gOPD && $defineProperty) {
      var desc = $gOPD(func, 'length');
      if (desc.configurable) {
        // original length, plus the receiver, minus any additional arguments (after the receiver)
        $defineProperty(func, 'length', {
          value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
        });
      }
    }
    return func;
  };
  var applyBind = function applyBind() {
    return $reflectApply(bind, $apply, arguments);
  };
  if ($defineProperty) {
    $defineProperty(module.exports, 'apply', {
      value: applyBind
    });
  } else {
    module.exports.apply = applyBind;
  }

  /***/
}, /* 96 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    /**!
    * @fileOverview Kickass library to create and place poppers near their reference elements.
    * @version 1.16.1
    * @license
    * Copyright (c) 2016 Federico Zivolo and contributors
    *
    * Permission is hereby granted, free of charge, to any person obtaining a copy
    * of this software and associated documentation files (the "Software"), to deal
    * in the Software without restriction, including without limitation the rights
    * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    * copies of the Software, and to permit persons to whom the Software is
    * furnished to do so, subject to the following conditions:
    *
    * The above copyright notice and this permission notice shall be included in all
    * copies or substantial portions of the Software.
    *
    * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    * SOFTWARE.
    */
    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
    var timeoutDuration = function () {
      var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
      for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
        if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
          return 1;
        }
      }
      return 0;
    }();
    function microtaskDebounce(fn) {
      var called = false;
      return function () {
        if (called) {
          return;
        }
        called = true;
        window.Promise.resolve().then(function () {
          called = false;
          fn();
        });
      };
    }
    function taskDebounce(fn) {
      var scheduled = false;
      return function () {
        if (!scheduled) {
          scheduled = true;
          setTimeout(function () {
            scheduled = false;
            fn();
          }, timeoutDuration);
        }
      };
    }
    var supportsMicroTasks = isBrowser && window.Promise;

    /**
    * Create a debounced version of a method, that's asynchronously deferred
    * but called in the minimum time possible.
    *
    * @method
    * @memberof Popper.Utils
    * @argument {Function} fn
    * @returns {Function}
    */
    var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

    /**
     * Check if the given variable is a function
     * @method
     * @memberof Popper.Utils
     * @argument {Any} functionToCheck - variable to check
     * @returns {Boolean} answer to: is a function?
     */
    function isFunction(functionToCheck) {
      var getType = {};
      return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }

    /**
     * Get CSS computed property of the given element
     * @method
     * @memberof Popper.Utils
     * @argument {Eement} element
     * @argument {String} property
     */
    function getStyleComputedProperty(element, property) {
      if (element.nodeType !== 1) {
        return [];
      }
      // NOTE: 1 DOM access here
      var window = element.ownerDocument.defaultView;
      var css = window.getComputedStyle(element, null);
      return property ? css[property] : css;
    }

    /**
     * Returns the parentNode or the host of the element
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @returns {Element} parent
     */
    function getParentNode(element) {
      if (element.nodeName === 'HTML') {
        return element;
      }
      return element.parentNode || element.host;
    }

    /**
     * Returns the scrolling parent of the given element
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @returns {Element} scroll parent
     */
    function getScrollParent(element) {
      // Return body, `getScroll` will take care to get the correct `scrollTop` from it
      if (!element) {
        return document.body;
      }
      switch (element.nodeName) {
        case 'HTML':
        case 'BODY':
          return element.ownerDocument.body;
        case '#document':
          return element.body;
      }

      // Firefox want us to check `-x` and `-y` variations as well

      var _getStyleComputedProp = getStyleComputedProperty(element),
        overflow = _getStyleComputedProp.overflow,
        overflowX = _getStyleComputedProp.overflowX,
        overflowY = _getStyleComputedProp.overflowY;
      if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
        return element;
      }
      return getScrollParent(getParentNode(element));
    }

    /**
     * Returns the reference node of the reference object, or the reference object itself.
     * @method
     * @memberof Popper.Utils
     * @param {Element|Object} reference - the reference element (the popper will be relative to this)
     * @returns {Element} parent
     */
    function getReferenceNode(reference) {
      return reference && reference.referenceNode ? reference.referenceNode : reference;
    }
    var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
    var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

    /**
     * Determines if the browser is Internet Explorer
     * @method
     * @memberof Popper.Utils
     * @param {Number} version to check
     * @returns {Boolean} isIE
     */
    function isIE(version) {
      if (version === 11) {
        return isIE11;
      }
      if (version === 10) {
        return isIE10;
      }
      return isIE11 || isIE10;
    }

    /**
     * Returns the offset parent of the given element
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @returns {Element} offset parent
     */
    function getOffsetParent(element) {
      if (!element) {
        return document.documentElement;
      }
      var noOffsetParent = isIE(10) ? document.body : null;

      // NOTE: 1 DOM access here
      var offsetParent = element.offsetParent || null;
      // Skip hidden elements which don't have an offsetParent
      while (offsetParent === noOffsetParent && element.nextElementSibling) {
        offsetParent = (element = element.nextElementSibling).offsetParent;
      }
      var nodeName = offsetParent && offsetParent.nodeName;
      if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
        return element ? element.ownerDocument.documentElement : document.documentElement;
      }

      // .offsetParent will return the closest TH, TD or TABLE in case
      // no offsetParent is present, I hate this job...
      if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
        return getOffsetParent(offsetParent);
      }
      return offsetParent;
    }
    function isOffsetContainer(element) {
      var nodeName = element.nodeName;
      if (nodeName === 'BODY') {
        return false;
      }
      return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
    }

    /**
     * Finds the root node (document, shadowDOM root) of the given element
     * @method
     * @memberof Popper.Utils
     * @argument {Element} node
     * @returns {Element} root node
     */
    function getRoot(node) {
      if (node.parentNode !== null) {
        return getRoot(node.parentNode);
      }
      return node;
    }

    /**
     * Finds the offset parent common to the two provided nodes
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element1
     * @argument {Element} element2
     * @returns {Element} common offset parent
     */
    function findCommonOffsetParent(element1, element2) {
      // This check is needed to avoid errors in case one of the elements isn't defined for any reason
      if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
        return document.documentElement;
      }

      // Here we make sure to give as "start" the element that comes first in the DOM
      var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
      var start = order ? element1 : element2;
      var end = order ? element2 : element1;

      // Get common ancestor container
      var range = document.createRange();
      range.setStart(start, 0);
      range.setEnd(end, 0);
      var commonAncestorContainer = range.commonAncestorContainer;

      // Both nodes are inside #document

      if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if (isOffsetContainer(commonAncestorContainer)) {
          return commonAncestorContainer;
        }
        return getOffsetParent(commonAncestorContainer);
      }

      // one of the nodes is inside shadowDOM, find which one
      var element1root = getRoot(element1);
      if (element1root.host) {
        return findCommonOffsetParent(element1root.host, element2);
      } else {
        return findCommonOffsetParent(element1, getRoot(element2).host);
      }
    }

    /**
     * Gets the scroll value of the given element in the given side (top and left)
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @argument {String} side `top` or `left`
     * @returns {number} amount of scrolled pixels
     */
    function getScroll(element) {
      var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
      var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
      var nodeName = element.nodeName;
      if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
      }
      return element[upperSide];
    }

    /*
     * Sum or subtract the element scroll values (left and top) from a given rect object
     * @method
     * @memberof Popper.Utils
     * @param {Object} rect - Rect object you want to change
     * @param {HTMLElement} element - The element from the function reads the scroll values
     * @param {Boolean} subtract - set to true if you want to subtract the scroll values
     * @return {Object} rect - The modifier rect object
     */
    function includeScroll(rect, element) {
      var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      var modifier = subtract ? -1 : 1;
      rect.top += scrollTop * modifier;
      rect.bottom += scrollTop * modifier;
      rect.left += scrollLeft * modifier;
      rect.right += scrollLeft * modifier;
      return rect;
    }

    /*
     * Helper to detect borders of a given element
     * @method
     * @memberof Popper.Utils
     * @param {CSSStyleDeclaration} styles
     * Result of `getStyleComputedProperty` on the given element
     * @param {String} axis - `x` or `y`
     * @return {number} borders - The borders size of the given axis
     */

    function getBordersSize(styles, axis) {
      var sideA = axis === 'x' ? 'Left' : 'Top';
      var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
      return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
    }
    function getSize(axis, body, html, computedStyle) {
      return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
    }
    function getWindowSizes(document) {
      var body = document.body;
      var html = document.documentElement;
      var computedStyle = isIE(10) && getComputedStyle(html);
      return {
        height: getSize('Height', body, html, computedStyle),
        width: getSize('Width', body, html, computedStyle)
      };
    }
    var classCallCheck = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };
    var createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var defineProperty = function (obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    };
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };

    /**
     * Given element offsets, generate an output similar to getBoundingClientRect
     * @method
     * @memberof Popper.Utils
     * @argument {Object} offsets
     * @returns {Object} ClientRect like output
     */
    function getClientRect(offsets) {
      return _extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
      });
    }

    /**
     * Get bounding client rect of given element
     * @method
     * @memberof Popper.Utils
     * @param {HTMLElement} element
     * @return {Object} client rect
     */
    function getBoundingClientRect(element) {
      var rect = {};

      // IE10 10 FIX: Please, don't ask, the element isn't
      // considered in DOM in some circumstances...
      // This isn't reproducible in IE10 compatibility mode of IE11
      try {
        if (isIE(10)) {
          rect = element.getBoundingClientRect();
          var scrollTop = getScroll(element, 'top');
          var scrollLeft = getScroll(element, 'left');
          rect.top += scrollTop;
          rect.left += scrollLeft;
          rect.bottom += scrollTop;
          rect.right += scrollLeft;
        } else {
          rect = element.getBoundingClientRect();
        }
      } catch (e) {}
      var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };

      // subtract scrollbar size from sizes
      var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
      var width = sizes.width || element.clientWidth || result.width;
      var height = sizes.height || element.clientHeight || result.height;
      var horizScrollbar = element.offsetWidth - width;
      var vertScrollbar = element.offsetHeight - height;

      // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
      // we make this check conditional for performance reasons
      if (horizScrollbar || vertScrollbar) {
        var styles = getStyleComputedProperty(element);
        horizScrollbar -= getBordersSize(styles, 'x');
        vertScrollbar -= getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
      }
      return getClientRect(result);
    }
    function getOffsetRectRelativeToArbitraryNode(children, parent) {
      var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var isIE10 = isIE(10);
      var isHTML = parent.nodeName === 'HTML';
      var childrenRect = getBoundingClientRect(children);
      var parentRect = getBoundingClientRect(parent);
      var scrollParent = getScrollParent(children);
      var styles = getStyleComputedProperty(parent);
      var borderTopWidth = parseFloat(styles.borderTopWidth);
      var borderLeftWidth = parseFloat(styles.borderLeftWidth);

      // In cases where the parent is fixed, we must ignore negative scroll in offset calc
      if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
      }
      var offsets = getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
      });
      offsets.marginTop = 0;
      offsets.marginLeft = 0;

      // Subtract margins of documentElement in case it's being used as parent
      // we do this only on HTML because it's the only element that behaves
      // differently when margins are applied to it. The margins are included in
      // the box of the documentElement, in the other cases not.
      if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;

        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
      }
      if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
        offsets = includeScroll(offsets, parent);
      }
      return offsets;
    }
    function getViewportOffsetRectRelativeToArtbitraryNode(element) {
      var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var html = element.ownerDocument.documentElement;
      var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
      var width = Math.max(html.clientWidth, window.innerWidth || 0);
      var height = Math.max(html.clientHeight, window.innerHeight || 0);
      var scrollTop = !excludeScroll ? getScroll(html) : 0;
      var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
      var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
      };
      return getClientRect(offset);
    }

    /**
     * Check if the given element is fixed or is inside a fixed parent
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @argument {Element} customContainer
     * @returns {Boolean} answer to "isFixed?"
     */
    function isFixed(element) {
      var nodeName = element.nodeName;
      if (nodeName === 'BODY' || nodeName === 'HTML') {
        return false;
      }
      if (getStyleComputedProperty(element, 'position') === 'fixed') {
        return true;
      }
      var parentNode = getParentNode(element);
      if (!parentNode) {
        return false;
      }
      return isFixed(parentNode);
    }

    /**
     * Finds the first parent of an element that has a transformed property defined
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @returns {Element} first transformed parent or documentElement
     */

    function getFixedPositionOffsetParent(element) {
      // This check is needed to avoid errors in case one of the elements isn't defined for any reason
      if (!element || !element.parentElement || isIE()) {
        return document.documentElement;
      }
      var el = element.parentElement;
      while (el && getStyleComputedProperty(el, 'transform') === 'none') {
        el = el.parentElement;
      }
      return el || document.documentElement;
    }

    /**
     * Computed the boundaries limits and return them
     * @method
     * @memberof Popper.Utils
     * @param {HTMLElement} popper
     * @param {HTMLElement} reference
     * @param {number} padding
     * @param {HTMLElement} boundariesElement - Element used to define the boundaries
     * @param {Boolean} fixedPosition - Is in fixed position mode
     * @returns {Object} Coordinates of the boundaries
     */
    function getBoundaries(popper, reference, padding, boundariesElement) {
      var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      // NOTE: 1 DOM access here

      var boundaries = {
        top: 0,
        left: 0
      };
      var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

      // Handle viewport case
      if (boundariesElement === 'viewport') {
        boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
      } else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
          boundariesNode = getScrollParent(getParentNode(reference));
          if (boundariesNode.nodeName === 'BODY') {
            boundariesNode = popper.ownerDocument.documentElement;
          }
        } else if (boundariesElement === 'window') {
          boundariesNode = popper.ownerDocument.documentElement;
        } else {
          boundariesNode = boundariesElement;
        }
        var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
          var _getWindowSizes = getWindowSizes(popper.ownerDocument),
            height = _getWindowSizes.height,
            width = _getWindowSizes.width;
          boundaries.top += offsets.top - offsets.marginTop;
          boundaries.bottom = height + offsets.top;
          boundaries.left += offsets.left - offsets.marginLeft;
          boundaries.right = width + offsets.left;
        } else {
          // for all the other DOM elements, this one is good
          boundaries = offsets;
        }
      }

      // Add paddings
      padding = padding || 0;
      var isPaddingNumber = typeof padding === 'number';
      boundaries.left += isPaddingNumber ? padding : padding.left || 0;
      boundaries.top += isPaddingNumber ? padding : padding.top || 0;
      boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
      boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
      return boundaries;
    }
    function getArea(_ref) {
      var width = _ref.width,
        height = _ref.height;
      return width * height;
    }

    /**
     * Utility used to transform the `auto` placement to the placement with more
     * available space.
     * @method
     * @memberof Popper.Utils
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */
    function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
      var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
      if (placement.indexOf('auto') === -1) {
        return placement;
      }
      var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
      var rects = {
        top: {
          width: boundaries.width,
          height: refRect.top - boundaries.top
        },
        right: {
          width: boundaries.right - refRect.right,
          height: boundaries.height
        },
        bottom: {
          width: boundaries.width,
          height: boundaries.bottom - refRect.bottom
        },
        left: {
          width: refRect.left - boundaries.left,
          height: boundaries.height
        }
      };
      var sortedAreas = Object.keys(rects).map(function (key) {
        return _extends({
          key: key
        }, rects[key], {
          area: getArea(rects[key])
        });
      }).sort(function (a, b) {
        return b.area - a.area;
      });
      var filteredAreas = sortedAreas.filter(function (_ref2) {
        var width = _ref2.width,
          height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
      });
      var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
      var variation = placement.split('-')[1];
      return computedPlacement + (variation ? '-' + variation : '');
    }

    /**
     * Get offsets to the reference element
     * @method
     * @memberof Popper.Utils
     * @param {Object} state
     * @param {Element} popper - the popper element
     * @param {Element} reference - the reference element (the popper will be relative to this)
     * @param {Element} fixedPosition - is in fixed position mode
     * @returns {Object} An object containing the offsets which will be applied to the popper
     */
    function getReferenceOffsets(state, popper, reference) {
      var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
      return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
    }

    /**
     * Get the outer sizes of the given element (offset size + margins)
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element
     * @returns {Object} object containing width and height properties
     */
    function getOuterSizes(element) {
      var window = element.ownerDocument.defaultView;
      var styles = window.getComputedStyle(element);
      var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
      var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
      var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
      };
      return result;
    }

    /**
     * Get the opposite placement of the given one
     * @method
     * @memberof Popper.Utils
     * @argument {String} placement
     * @returns {String} flipped placement
     */
    function getOppositePlacement(placement) {
      var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
      };
      return placement.replace(/left|right|bottom|top/g, function (matched) {
        return hash[matched];
      });
    }

    /**
     * Get offsets to the popper
     * @method
     * @memberof Popper.Utils
     * @param {Object} position - CSS position the Popper will get applied
     * @param {HTMLElement} popper - the popper element
     * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
     * @param {String} placement - one of the valid placement options
     * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
     */
    function getPopperOffsets(popper, referenceOffsets, placement) {
      placement = placement.split('-')[0];

      // Get popper node sizes
      var popperRect = getOuterSizes(popper);

      // Add position, width and height to our offsets object
      var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
      };

      // depending by the popper placement we have to compute its offsets slightly differently
      var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
      var mainSide = isHoriz ? 'top' : 'left';
      var secondarySide = isHoriz ? 'left' : 'top';
      var measurement = isHoriz ? 'height' : 'width';
      var secondaryMeasurement = !isHoriz ? 'height' : 'width';
      popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
      if (placement === secondarySide) {
        popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
      } else {
        popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
      }
      return popperOffsets;
    }

    /**
     * Mimics the `find` method of Array
     * @method
     * @memberof Popper.Utils
     * @argument {Array} arr
     * @argument prop
     * @argument value
     * @returns index or -1
     */
    function find(arr, check) {
      // use native find if supported
      if (Array.prototype.find) {
        return arr.find(check);
      }

      // use `filter` to obtain the same behavior of `find`
      return arr.filter(check)[0];
    }

    /**
     * Return the index of the matching object
     * @method
     * @memberof Popper.Utils
     * @argument {Array} arr
     * @argument prop
     * @argument value
     * @returns index or -1
     */
    function findIndex(arr, prop, value) {
      // use native findIndex if supported
      if (Array.prototype.findIndex) {
        return arr.findIndex(function (cur) {
          return cur[prop] === value;
        });
      }

      // use `find` + `indexOf` if `findIndex` isn't supported
      var match = find(arr, function (obj) {
        return obj[prop] === value;
      });
      return arr.indexOf(match);
    }

    /**
     * Loop trough the list of modifiers and run them in order,
     * each of them will then edit the data object.
     * @method
     * @memberof Popper.Utils
     * @param {dataObject} data
     * @param {Array} modifiers
     * @param {String} ends - Optional modifier name used as stopper
     * @returns {dataObject}
     */
    function runModifiers(modifiers, data, ends) {
      var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
      modifiersToRun.forEach(function (modifier) {
        if (modifier['function']) {
          // eslint-disable-line dot-notation
          console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        }
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && isFunction(fn)) {
          // Add properties to offsets to make them a complete clientRect object
          // we do this before each modifier to make sure the previous one doesn't
          // mess with these values
          data.offsets.popper = getClientRect(data.offsets.popper);
          data.offsets.reference = getClientRect(data.offsets.reference);
          data = fn(data, modifier);
        }
      });
      return data;
    }

    /**
     * Updates the position of the popper, computing the new offsets and applying
     * the new style.<br />
     * Prefer `scheduleUpdate` over `update` because of performance reasons.
     * @method
     * @memberof Popper
     */
    function update() {
      // if popper is destroyed, don't perform any further update
      if (this.state.isDestroyed) {
        return;
      }
      var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
      };

      // compute reference element offsets
      data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

      // compute auto placement, store placement inside the data object,
      // modifiers will be able to edit `placement` if needed
      // and refer to originalPlacement to know the original value
      data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

      // store the computed placement inside `originalPlacement`
      data.originalPlacement = data.placement;
      data.positionFixed = this.options.positionFixed;

      // compute the popper offsets
      data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
      data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

      // run the modifiers
      data = runModifiers(this.modifiers, data);

      // the first `update` will call `onCreate` callback
      // the other ones will call `onUpdate` callback
      if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
      } else {
        this.options.onUpdate(data);
      }
    }

    /**
     * Helper used to know if the given modifier is enabled.
     * @method
     * @memberof Popper.Utils
     * @returns {Boolean}
     */
    function isModifierEnabled(modifiers, modifierName) {
      return modifiers.some(function (_ref) {
        var name = _ref.name,
          enabled = _ref.enabled;
        return enabled && name === modifierName;
      });
    }

    /**
     * Get the prefixed supported property name
     * @method
     * @memberof Popper.Utils
     * @argument {String} property (camelCase)
     * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
     */
    function getSupportedPropertyName(property) {
      var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
      var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
      for (var i = 0; i < prefixes.length; i++) {
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') {
          return toCheck;
        }
      }
      return null;
    }

    /**
     * Destroys the popper.
     * @method
     * @memberof Popper
     */
    function destroy() {
      this.state.isDestroyed = true;

      // touch DOM only if `applyStyle` modifier is enabled
      if (isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[getSupportedPropertyName('transform')] = '';
      }
      this.disableEventListeners();

      // remove the popper if user explicitly asked for the deletion on destroy
      // do not use `remove` because IE11 doesn't support it
      if (this.options.removeOnDestroy) {
        this.popper.parentNode.removeChild(this.popper);
      }
      return this;
    }

    /**
     * Get the window associated with the element
     * @argument {Element} element
     * @returns {Window}
     */
    function getWindow(element) {
      var ownerDocument = element.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView : window;
    }
    function attachToScrollParents(scrollParent, event, callback, scrollParents) {
      var isBody = scrollParent.nodeName === 'BODY';
      var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
      target.addEventListener(event, callback, {
        passive: true
      });
      if (!isBody) {
        attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
      }
      scrollParents.push(target);
    }

    /**
     * Setup needed event listeners used to update the popper position
     * @method
     * @memberof Popper.Utils
     * @private
     */
    function setupEventListeners(reference, options, state, updateBound) {
      // Resize event listener on window
      state.updateBound = updateBound;
      getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
      });

      // Scroll event listener on scroll parents
      var scrollElement = getScrollParent(reference);
      attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
      state.scrollElement = scrollElement;
      state.eventsEnabled = true;
      return state;
    }

    /**
     * It will add resize/scroll events and start recalculating
     * position of the popper element when they are triggered.
     * @method
     * @memberof Popper
     */
    function enableEventListeners() {
      if (!this.state.eventsEnabled) {
        this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
      }
    }

    /**
     * Remove event listeners used to update the popper position
     * @method
     * @memberof Popper.Utils
     * @private
     */
    function removeEventListeners(reference, state) {
      // Remove resize event listener on window
      getWindow(reference).removeEventListener('resize', state.updateBound);

      // Remove scroll event listener on scroll parents
      state.scrollParents.forEach(function (target) {
        target.removeEventListener('scroll', state.updateBound);
      });

      // Reset state
      state.updateBound = null;
      state.scrollParents = [];
      state.scrollElement = null;
      state.eventsEnabled = false;
      return state;
    }

    /**
     * It will remove resize/scroll events and won't recalculate popper position
     * when they are triggered. It also won't trigger `onUpdate` callback anymore,
     * unless you call `update` method manually.
     * @method
     * @memberof Popper
     */
    function disableEventListeners() {
      if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = removeEventListeners(this.reference, this.state);
      }
    }

    /**
     * Tells if a given input is a number
     * @method
     * @memberof Popper.Utils
     * @param {*} input to check
     * @return {Boolean}
     */
    function isNumeric(n) {
      return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
    }

    /**
     * Set the style to the given popper
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element - Element to apply the style to
     * @argument {Object} styles
     * Object with a list of properties and values which will be applied to the element
     */
    function setStyles(element, styles) {
      Object.keys(styles).forEach(function (prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
          unit = 'px';
        }
        element.style[prop] = styles[prop] + unit;
      });
    }

    /**
     * Set the attributes to the given popper
     * @method
     * @memberof Popper.Utils
     * @argument {Element} element - Element to apply the attributes to
     * @argument {Object} styles
     * Object with a list of properties and values which will be applied to the element
     */
    function setAttributes(element, attributes) {
      Object.keys(attributes).forEach(function (prop) {
        var value = attributes[prop];
        if (value !== false) {
          element.setAttribute(prop, attributes[prop]);
        } else {
          element.removeAttribute(prop);
        }
      });
    }

    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @argument {Object} data.styles - List of style properties - values to apply to popper element
     * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The same data object
     */
    function applyStyle(data) {
      // any property present in `data.styles` will be applied to the popper,
      // in this way we can make the 3rd party modifiers add custom styles to it
      // Be aware, modifiers could override the properties defined in the previous
      // lines of this modifier!
      setStyles(data.instance.popper, data.styles);

      // any property present in `data.attributes` will be applied to the popper,
      // they will be set as HTML attributes of the element
      setAttributes(data.instance.popper, data.attributes);

      // if arrowElement is defined and arrowStyles has some properties
      if (data.arrowElement && Object.keys(data.arrowStyles).length) {
        setStyles(data.arrowElement, data.arrowStyles);
      }
      return data;
    }

    /**
     * Set the x-placement attribute before everything else because it could be used
     * to add margins to the popper margins needs to be calculated to get the
     * correct popper offsets.
     * @method
     * @memberof Popper.modifiers
     * @param {HTMLElement} reference - The reference element used to position the popper
     * @param {HTMLElement} popper - The HTML element used as popper
     * @param {Object} options - Popper.js options
     */
    function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
      // compute reference element offsets
      var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

      // compute auto placement, store placement inside the data object,
      // modifiers will be able to edit `placement` if needed
      // and refer to originalPlacement to know the original value
      var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
      popper.setAttribute('x-placement', placement);

      // Apply `position` to popper before anything else because
      // without the position applied we can't guarantee correct computations
      setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
      });
      return options;
    }

    /**
     * @function
     * @memberof Popper.Utils
     * @argument {Object} data - The data object generated by `update` method
     * @argument {Boolean} shouldRound - If the offsets should be rounded at all
     * @returns {Object} The popper's position offsets rounded
     *
     * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
     * good as it can be within reason.
     * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
     *
     * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
     * as well on High DPI screens).
     *
     * Firefox prefers no rounding for positioning and does not have blurriness on
     * high DPI screens.
     *
     * Only horizontal placement and left/right values need to be considered.
     */
    function getRoundedOffsets(data, shouldRound) {
      var _data$offsets = data.offsets,
        popper = _data$offsets.popper,
        reference = _data$offsets.reference;
      var round = Math.round,
        floor = Math.floor;
      var noRound = function noRound(v) {
        return v;
      };
      var referenceWidth = round(reference.width);
      var popperWidth = round(popper.width);
      var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
      var isVariation = data.placement.indexOf('-') !== -1;
      var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
      var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
      var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
      var verticalToInteger = !shouldRound ? noRound : round;
      return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
      };
    }
    var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */
    function computeStyle(data, options) {
      var x = options.x,
        y = options.y;
      var popper = data.offsets.popper;

      // Remove this legacy support in Popper.js v2

      var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
        return modifier.name === 'applyStyle';
      }).gpuAcceleration;
      if (legacyGpuAccelerationOption !== undefined) {
        console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
      }
      var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
      var offsetParent = getOffsetParent(data.instance.popper);
      var offsetParentRect = getBoundingClientRect(offsetParent);

      // Styles
      var styles = {
        position: popper.position
      };
      var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
      var sideA = x === 'bottom' ? 'top' : 'bottom';
      var sideB = y === 'right' ? 'left' : 'right';

      // if gpuAcceleration is set to `true` and transform is supported,
      //  we use `translate3d` to apply the position to the popper we
      // automatically use the supported prefixed version if needed
      var prefixedProperty = getSupportedPropertyName('transform');

      // now, let's make a step back and look at this code closely (wtf?)
      // If the content of the popper grows once it's been positioned, it
      // may happen that the popper gets misplaced because of the new content
      // overflowing its reference element
      // To avoid this problem, we provide two options (x and y), which allow
      // the consumer to define the offset origin.
      // If we position a popper on top of a reference element, we can set
      // `x` to `top` to make the popper grow towards its top instead of
      // its bottom.
      var left = void 0,
        top = void 0;
      if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') {
          top = -offsetParent.clientHeight + offsets.bottom;
        } else {
          top = -offsetParentRect.height + offsets.bottom;
        }
      } else {
        top = offsets.top;
      }
      if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') {
          left = -offsetParent.clientWidth + offsets.right;
        } else {
          left = -offsetParentRect.width + offsets.right;
        }
      } else {
        left = offsets.left;
      }
      if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
      } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
      }

      // Attributes
      var attributes = {
        'x-placement': data.placement
      };

      // Update `data` attributes, styles and arrowStyles
      data.attributes = _extends({}, attributes, data.attributes);
      data.styles = _extends({}, styles, data.styles);
      data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
      return data;
    }

    /**
     * Helper used to know if the given modifier depends from another one.<br />
     * It checks if the needed modifier is listed and enabled.
     * @method
     * @memberof Popper.Utils
     * @param {Array} modifiers - list of modifiers
     * @param {String} requestingName - name of requesting modifier
     * @param {String} requestedName - name of requested modifier
     * @returns {Boolean}
     */
    function isModifierRequired(modifiers, requestingName, requestedName) {
      var requesting = find(modifiers, function (_ref) {
        var name = _ref.name;
        return name === requestingName;
      });
      var isRequired = !!requesting && modifiers.some(function (modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
      });
      if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
      }
      return isRequired;
    }

    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */
    function arrow(data, options) {
      var _data$offsets$arrow;

      // arrow depends on keepTogether in order to work
      if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
        return data;
      }
      var arrowElement = options.element;

      // if arrowElement is a string, suppose it's a CSS selector
      if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);

        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) {
          return data;
        }
      } else {
        // if the arrowElement isn't a query selector we must check that the
        // provided DOM node is child of its popper node
        if (!data.instance.popper.contains(arrowElement)) {
          console.warn('WARNING: `arrow.element` must be child of its popper element!');
          return data;
        }
      }
      var placement = data.placement.split('-')[0];
      var _data$offsets = data.offsets,
        popper = _data$offsets.popper,
        reference = _data$offsets.reference;
      var isVertical = ['left', 'right'].indexOf(placement) !== -1;
      var len = isVertical ? 'height' : 'width';
      var sideCapitalized = isVertical ? 'Top' : 'Left';
      var side = sideCapitalized.toLowerCase();
      var altSide = isVertical ? 'left' : 'top';
      var opSide = isVertical ? 'bottom' : 'right';
      var arrowElementSize = getOuterSizes(arrowElement)[len];

      //
      // extends keepTogether behavior making sure the popper and its
      // reference have enough pixels in conjunction
      //

      // top/left side
      if (reference[opSide] - arrowElementSize < popper[side]) {
        data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
      }
      // bottom/right side
      if (reference[side] + arrowElementSize > popper[opSide]) {
        data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
      }
      data.offsets.popper = getClientRect(data.offsets.popper);

      // compute center of the popper
      var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

      // Compute the sideValue using the updated popper offsets
      // take popper margin in account because we don't have this info available
      var css = getStyleComputedProperty(data.instance.popper);
      var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
      var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
      var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

      // prevent arrowElement from being placed not contiguously to its popper
      sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
      data.arrowElement = arrowElement;
      data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
      return data;
    }

    /**
     * Get the opposite placement variation of the given one
     * @method
     * @memberof Popper.Utils
     * @argument {String} placement variation
     * @returns {String} flipped placement variation
     */
    function getOppositeVariation(variation) {
      if (variation === 'end') {
        return 'start';
      } else if (variation === 'start') {
        return 'end';
      }
      return variation;
    }

    /**
     * List of accepted placements to use as values of the `placement` option.<br />
     * Valid placements are:
     * - `auto`
     * - `top`
     * - `right`
     * - `bottom`
     * - `left`
     *
     * Each placement can have a variation from this list:
     * - `-start`
     * - `-end`
     *
     * Variations are interpreted easily if you think of them as the left to right
     * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
     * is right.<br />
     * Vertically (`left` and `right`), `start` is top and `end` is bottom.
     *
     * Some valid examples are:
     * - `top-end` (on top of reference, right aligned)
     * - `right-start` (on right of reference, top aligned)
     * - `bottom` (on bottom, centered)
     * - `auto-end` (on the side with more space available, alignment depends by placement)
     *
     * @static
     * @type {Array}
     * @enum {String}
     * @readonly
     * @method placements
     * @memberof Popper
     */
    var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

    // Get rid of `auto` `auto-start` and `auto-end`
    var validPlacements = placements.slice(3);

    /**
     * Given an initial placement, returns all the subsequent placements
     * clockwise (or counter-clockwise).
     *
     * @method
     * @memberof Popper.Utils
     * @argument {String} placement - A valid placement (it accepts variations)
     * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
     * @returns {Array} placements including their variations
     */
    function clockwise(placement) {
      var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var index = validPlacements.indexOf(placement);
      var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
      return counter ? arr.reverse() : arr;
    }
    var BEHAVIORS = {
      FLIP: 'flip',
      CLOCKWISE: 'clockwise',
      COUNTERCLOCKWISE: 'counterclockwise'
    };

    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */
    function flip(data, options) {
      // if `inner` modifier is enabled, we can't use the `flip` modifier
      if (isModifierEnabled(data.instance.modifiers, 'inner')) {
        return data;
      }
      if (data.flipped && data.placement === data.originalPlacement) {
        // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
        return data;
      }
      var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
      var placement = data.placement.split('-')[0];
      var placementOpposite = getOppositePlacement(placement);
      var variation = data.placement.split('-')[1] || '';
      var flipOrder = [];
      switch (options.behavior) {
        case BEHAVIORS.FLIP:
          flipOrder = [placement, placementOpposite];
          break;
        case BEHAVIORS.CLOCKWISE:
          flipOrder = clockwise(placement);
          break;
        case BEHAVIORS.COUNTERCLOCKWISE:
          flipOrder = clockwise(placement, true);
          break;
        default:
          flipOrder = options.behavior;
      }
      flipOrder.forEach(function (step, index) {
        if (placement !== step || flipOrder.length === index + 1) {
          return data;
        }
        placement = data.placement.split('-')[0];
        placementOpposite = getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;

        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

        // flip the variation if required
        var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
          // this boolean to detect any flip loop
          data.flipped = true;
          if (overlapsRef || overflowsBoundaries) {
            placement = flipOrder[index + 1];
          }
          if (flippedVariation) {
            variation = getOppositeVariation(variation);
          }
          data.placement = placement + (variation ? '-' + variation : '');

          // this object contains `position`, we want to preserve it along with
          // any additional property we may add in the future
          data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
          data = runModifiers(data.instance.modifiers, data, 'flip');
        }
      });
      return data;
    }

    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */
    function keepTogether(data) {
      var _data$offsets = data.offsets,
        popper = _data$offsets.popper,
        reference = _data$offsets.reference;
      var placement = data.placement.split('-')[0];
      var floor = Math.floor;
      var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
      var side = isVertical ? 'right' : 'bottom';
      var opSide = isVertical ? 'left' : 'top';
      var measurement = isVertical ? 'width' : 'height';
      if (popper[side] < floor(reference[opSide])) {
        data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
      }
      if (popper[opSide] > floor(reference[side])) {
        data.offsets.popper[opSide] = floor(reference[side]);
      }
      return data;
    }

    /**
     * Converts a string containing value + unit into a px value number
     * @function
     * @memberof {modifiers~offset}
     * @private
     * @argument {String} str - Value + unit string
     * @argument {String} measurement - `height` or `width`
     * @argument {Object} popperOffsets
     * @argument {Object} referenceOffsets
     * @returns {Number|String}
     * Value in pixels, or original string if no values were extracted
     */
    function toValue(str, measurement, popperOffsets, referenceOffsets) {
      // separate value from unit
      var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
      var value = +split[1];
      var unit = split[2];

      // If it's not a number it's an operator, I guess
      if (!value) {
        return str;
      }
      if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch (unit) {
          case '%p':
            element = popperOffsets;
            break;
          case '%':
          case '%r':
          default:
            element = referenceOffsets;
        }
        var rect = getClientRect(element);
        return rect[measurement] / 100 * value;
      } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') {
          size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        } else {
          size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }
        return size / 100 * value;
      } else {
        // if is an explicit pixel unit, we get rid of the unit and keep the value
        // if is an implicit unit, it's px, and we return just the value
        return value;
      }
    }

    /**
     * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
     * @function
     * @memberof {modifiers~offset}
     * @private
     * @argument {String} offset
     * @argument {Object} popperOffsets
     * @argument {Object} referenceOffsets
     * @argument {String} basePlacement
     * @returns {Array} a two cells array with x and y offsets in numbers
     */
    function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
      var offsets = [0, 0];

      // Use height if placement is left or right and index is 0 otherwise use width
      // in this way the first offset will use an axis and the second one
      // will use the other one
      var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

      // Split the offset string to obtain a list of values and operands
      // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
      var fragments = offset.split(/(\+|\-)/).map(function (frag) {
        return frag.trim();
      });

      // Detect if the offset string contains a pair of values or a single one
      // they could be separated by comma or space
      var divider = fragments.indexOf(find(fragments, function (frag) {
        return frag.search(/,|\s/) !== -1;
      }));
      if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
        console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
      }

      // If divider is found, we divide the list of values and operands to divide
      // them by ofset X and Y.
      var splitRegex = /\s*,\s*|\s+/;
      var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

      // Convert the values with units to absolute pixels to allow our computations
      ops = ops.map(function (op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op
        // This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function (a, b) {
          if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
            a[a.length - 1] = b;
            mergeWithPrevious = true;
            return a;
          } else if (mergeWithPrevious) {
            a[a.length - 1] += b;
            mergeWithPrevious = false;
            return a;
          } else {
            return a.concat(b);
          }
        }, [])
        // Here we convert the string values into number values (in px)
        .map(function (str) {
          return toValue(str, measurement, popperOffsets, referenceOffsets);
        });
      });

      // Loop trough the offsets arrays and execute the operations
      ops.forEach(function (op, index) {
        op.forEach(function (frag, index2) {
          if (isNumeric(frag)) {
            offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
          }
        });
      });
      return offsets;
    }

    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @argument {Number|String} options.offset=0
     * The offset value as described in the modifier description
     * @returns {Object} The data object, properly modified
     */
    function offset(data, _ref) {
      var offset = _ref.offset;
      var placement = data.placement,
        _data$offsets = data.offsets,
        popper = _data$offsets.popper,
        reference = _data$offsets.reference;
      var basePlacement = placement.split('-')[0];
      var offsets = void 0;
      if (isNumeric(+offset)) {
        offsets = [+offset, 0];
      } else {
        offsets = parseOffset(offset, popper, reference, basePlacement);
      }
      if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
      } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
      } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
      } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
      }
      data.popper = popper;
      return data;
    }

    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */
    function preventOverflow(data, options) {
      var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

      // If offsetParent is the reference element, we really want to
      // go one step up and use the next offsetParent as reference to
      // avoid to make this modifier completely useless and look like broken
      if (data.instance.reference === boundariesElement) {
        boundariesElement = getOffsetParent(boundariesElement);
      }

      // NOTE: DOM access here
      // resets the popper's position so that the document size can be calculated excluding
      // the size of the popper element itself
      var transformProp = getSupportedPropertyName('transform');
      var popperStyles = data.instance.popper.style; // assignment to help minification
      var top = popperStyles.top,
        left = popperStyles.left,
        transform = popperStyles[transformProp];
      popperStyles.top = '';
      popperStyles.left = '';
      popperStyles[transformProp] = '';
      var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

      // NOTE: DOM access here
      // restores the original style properties after the offsets have been computed
      popperStyles.top = top;
      popperStyles.left = left;
      popperStyles[transformProp] = transform;
      options.boundaries = boundaries;
      var order = options.priority;
      var popper = data.offsets.popper;
      var check = {
        primary: function primary(placement) {
          var value = popper[placement];
          if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
            value = Math.max(popper[placement], boundaries[placement]);
          }
          return defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
          var mainSide = placement === 'right' ? 'left' : 'top';
          var value = popper[mainSide];
          if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
            value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
          }
          return defineProperty({}, mainSide, value);
        }
      };
      order.forEach(function (placement) {
        var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = _extends({}, popper, check[side](placement));
      });
      data.offsets.popper = popper;
      return data;
    }

    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */
    function shift(data) {
      var placement = data.placement;
      var basePlacement = placement.split('-')[0];
      var shiftvariation = placement.split('-')[1];

      // if shift shiftvariation is specified, run the modifier
      if (shiftvariation) {
        var _data$offsets = data.offsets,
          reference = _data$offsets.reference,
          popper = _data$offsets.popper;
        var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
          start: defineProperty({}, side, reference[side]),
          end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
      }
      return data;
    }

    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by update method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */
    function hide(data) {
      if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
        return data;
      }
      var refRect = data.offsets.reference;
      var bound = find(data.instance.modifiers, function (modifier) {
        return modifier.name === 'preventOverflow';
      }).boundaries;
      if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) {
          return data;
        }
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
      } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) {
          return data;
        }
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
      }
      return data;
    }

    /**
     * @function
     * @memberof Modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {Object} The data object, properly modified
     */
    function inner(data) {
      var placement = data.placement;
      var basePlacement = placement.split('-')[0];
      var _data$offsets = data.offsets,
        popper = _data$offsets.popper,
        reference = _data$offsets.reference;
      var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
      var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
      popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
      data.placement = getOppositePlacement(placement);
      data.offsets.popper = getClientRect(popper);
      return data;
    }

    /**
     * Modifier function, each modifier can have a function of this type assigned
     * to its `fn` property.<br />
     * These functions will be called on each update, this means that you must
     * make sure they are performant enough to avoid performance bottlenecks.
     *
     * @function ModifierFn
     * @argument {dataObject} data - The data object generated by `update` method
     * @argument {Object} options - Modifiers configuration and options
     * @returns {dataObject} The data object, properly modified
     */

    /**
     * Modifiers are plugins used to alter the behavior of your poppers.<br />
     * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
     * needed by the library.
     *
     * Usually you don't want to override the `order`, `fn` and `onLoad` props.
     * All the other properties are configurations that could be tweaked.
     * @namespace modifiers
     */
    var modifiers = {
      /**
       * Modifier used to shift the popper on the start or end of its reference
       * element.<br />
       * It will read the variation of the `placement` property.<br />
       * It can be one either `-end` or `-start`.
       * @memberof modifiers
       * @inner
       */
      shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */
        order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: shift
      },
      /**
       * The `offset` modifier can shift your popper on both its axis.
       *
       * It accepts the following units:
       * - `px` or unit-less, interpreted as pixels
       * - `%` or `%r`, percentage relative to the length of the reference element
       * - `%p`, percentage relative to the length of the popper element
       * - `vw`, CSS viewport width unit
       * - `vh`, CSS viewport height unit
       *
       * For length is intended the main axis relative to the placement of the popper.<br />
       * This means that if the placement is `top` or `bottom`, the length will be the
       * `width`. In case of `left` or `right`, it will be the `height`.
       *
       * You can provide a single value (as `Number` or `String`), or a pair of values
       * as `String` divided by a comma or one (or more) white spaces.<br />
       * The latter is a deprecated method because it leads to confusion and will be
       * removed in v2.<br />
       * Additionally, it accepts additions and subtractions between different units.
       * Note that multiplications and divisions aren't supported.
       *
       * Valid examples are:
       * ```
       * 10
       * '10%'
       * '10, 10'
       * '10%, 10'
       * '10 + 10%'
       * '10 - 5vh + 3%'
       * '-10px + 5vh, 5px - 6%'
       * ```
       * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
       * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
       * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
       *
       * @memberof modifiers
       * @inner
       */
      offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */
        order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: offset,
        /** @prop {Number|String} offset=0
         * The offset value as described in the modifier description
         */
        offset: 0
      },
      /**
       * Modifier used to prevent the popper from being positioned outside the boundary.
       *
       * A scenario exists where the reference itself is not within the boundaries.<br />
       * We can say it has "escaped the boundaries" — or just "escaped".<br />
       * In this case we need to decide whether the popper should either:
       *
       * - detach from the reference and remain "trapped" in the boundaries, or
       * - if it should ignore the boundary and "escape with its reference"
       *
       * When `escapeWithReference` is set to`true` and reference is completely
       * outside its boundaries, the popper will overflow (or completely leave)
       * the boundaries in order to remain attached to the edge of the reference.
       *
       * @memberof modifiers
       * @inner
       */
      preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */
        order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: preventOverflow,
        /**
         * @prop {Array} [priority=['left','right','top','bottom']]
         * Popper will try to prevent overflow following these priorities by default,
         * then, it could overflow on the left and on top of the `boundariesElement`
         */
        priority: ['left', 'right', 'top', 'bottom'],
        /**
         * @prop {number} padding=5
         * Amount of pixel used to define a minimum distance between the boundaries
         * and the popper. This makes sure the popper always has a little padding
         * between the edges of its container
         */
        padding: 5,
        /**
         * @prop {String|HTMLElement} boundariesElement='scrollParent'
         * Boundaries used by the modifier. Can be `scrollParent`, `window`,
         * `viewport` or any DOM element.
         */
        boundariesElement: 'scrollParent'
      },
      /**
       * Modifier used to make sure the reference and its popper stay near each other
       * without leaving any gap between the two. Especially useful when the arrow is
       * enabled and you want to ensure that it points to its reference element.
       * It cares only about the first axis. You can still have poppers with margin
       * between the popper and its reference element.
       * @memberof modifiers
       * @inner
       */
      keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */
        order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: keepTogether
      },
      /**
       * This modifier is used to move the `arrowElement` of the popper to make
       * sure it is positioned between the reference element and its popper element.
       * It will read the outer size of the `arrowElement` node to detect how many
       * pixels of conjunction are needed.
       *
       * It has no effect if no `arrowElement` is provided.
       * @memberof modifiers
       * @inner
       */
      arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */
        order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
        element: '[x-arrow]'
      },
      /**
       * Modifier used to flip the popper's placement when it starts to overlap its
       * reference element.
       *
       * Requires the `preventOverflow` modifier before it in order to work.
       *
       * **NOTE:** this modifier will interrupt the current update cycle and will
       * restart it if it detects the need to flip the placement.
       * @memberof modifiers
       * @inner
       */
      flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */
        order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: flip,
        /**
         * @prop {String|Array} behavior='flip'
         * The behavior used to change the popper's placement. It can be one of
         * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
         * placements (with optional variations)
         */
        behavior: 'flip',
        /**
         * @prop {number} padding=5
         * The popper will flip if it hits the edges of the `boundariesElement`
         */
        padding: 5,
        /**
         * @prop {String|HTMLElement} boundariesElement='viewport'
         * The element which will define the boundaries of the popper position.
         * The popper will never be placed outside of the defined boundaries
         * (except if `keepTogether` is enabled)
         */
        boundariesElement: 'viewport',
        /**
         * @prop {Boolean} flipVariations=false
         * The popper will switch placement variation between `-start` and `-end` when
         * the reference element overlaps its boundaries.
         *
         * The original placement should have a set variation.
         */
        flipVariations: false,
        /**
         * @prop {Boolean} flipVariationsByContent=false
         * The popper will switch placement variation between `-start` and `-end` when
         * the popper element overlaps its reference boundaries.
         *
         * The original placement should have a set variation.
         */
        flipVariationsByContent: false
      },
      /**
       * Modifier used to make the popper flow toward the inner of the reference element.
       * By default, when this modifier is disabled, the popper will be placed outside
       * the reference element.
       * @memberof modifiers
       * @inner
       */
      inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */
        order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
        enabled: false,
        /** @prop {ModifierFn} */
        fn: inner
      },
      /**
       * Modifier used to hide the popper when its reference element is outside of the
       * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
       * be used to hide with a CSS selector the popper when its reference is
       * out of boundaries.
       *
       * Requires the `preventOverflow` modifier before it in order to work.
       * @memberof modifiers
       * @inner
       */
      hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */
        order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: hide
      },
      /**
       * Computes the style that will be applied to the popper element to gets
       * properly positioned.
       *
       * Note that this modifier will not touch the DOM, it just prepares the styles
       * so that `applyStyle` modifier can apply it. This separation is useful
       * in case you need to replace `applyStyle` with a custom implementation.
       *
       * This modifier has `850` as `order` value to maintain backward compatibility
       * with previous versions of Popper.js. Expect the modifiers ordering method
       * to change in future major versions of the library.
       *
       * @memberof modifiers
       * @inner
       */
      computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */
        order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: computeStyle,
        /**
         * @prop {Boolean} gpuAcceleration=true
         * If true, it uses the CSS 3D transformation to position the popper.
         * Otherwise, it will use the `top` and `left` properties
         */
        gpuAcceleration: true,
        /**
         * @prop {string} [x='bottom']
         * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
         * Change this if your popper should grow in a direction different from `bottom`
         */
        x: 'bottom',
        /**
         * @prop {string} [x='left']
         * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
         * Change this if your popper should grow in a direction different from `right`
         */
        y: 'right'
      },
      /**
       * Applies the computed styles to the popper element.
       *
       * All the DOM manipulations are limited to this modifier. This is useful in case
       * you want to integrate Popper.js inside a framework or view library and you
       * want to delegate all the DOM manipulations to it.
       *
       * Note that if you disable this modifier, you must make sure the popper element
       * has its position set to `absolute` before Popper.js can do its work!
       *
       * Just disable this modifier and define your own to achieve the desired effect.
       *
       * @memberof modifiers
       * @inner
       */
      applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */
        order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
        enabled: true,
        /** @prop {ModifierFn} */
        fn: applyStyle,
        /** @prop {Function} */
        onLoad: applyStyleOnLoad,
        /**
         * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
         * @prop {Boolean} gpuAcceleration=true
         * If true, it uses the CSS 3D transformation to position the popper.
         * Otherwise, it will use the `top` and `left` properties
         */
        gpuAcceleration: undefined
      }
    };

    /**
     * The `dataObject` is an object containing all the information used by Popper.js.
     * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
     * @name dataObject
     * @property {Object} data.instance The Popper.js instance
     * @property {String} data.placement Placement applied to popper
     * @property {String} data.originalPlacement Placement originally defined on init
     * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
     * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
     * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
     * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
     * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
     * @property {Object} data.boundaries Offsets of the popper boundaries
     * @property {Object} data.offsets The measurements of popper, reference and arrow elements
     * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
     * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
     * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
     */

    /**
     * Default options provided to Popper.js constructor.<br />
     * These can be overridden using the `options` argument of Popper.js.<br />
     * To override an option, simply pass an object with the same
     * structure of the `options` object, as the 3rd argument. For example:
     * ```
     * new Popper(ref, pop, {
     *   modifiers: {
     *     preventOverflow: { enabled: false }
     *   }
     * })
     * ```
     * @type {Object}
     * @static
     * @memberof Popper
     */
    var Defaults = {
      /**
       * Popper's placement.
       * @prop {Popper.placements} placement='bottom'
       */
      placement: 'bottom',
      /**
       * Set this to true if you want popper to position it self in 'fixed' mode
       * @prop {Boolean} positionFixed=false
       */
      positionFixed: false,
      /**
       * Whether events (resize, scroll) are initially enabled.
       * @prop {Boolean} eventsEnabled=true
       */
      eventsEnabled: true,
      /**
       * Set to true if you want to automatically remove the popper when
       * you call the `destroy` method.
       * @prop {Boolean} removeOnDestroy=false
       */
      removeOnDestroy: false,
      /**
       * Callback called when the popper is created.<br />
       * By default, it is set to no-op.<br />
       * Access Popper.js instance with `data.instance`.
       * @prop {onCreate}
       */
      onCreate: function onCreate() {},
      /**
       * Callback called when the popper is updated. This callback is not called
       * on the initialization/creation of the popper, but only on subsequent
       * updates.<br />
       * By default, it is set to no-op.<br />
       * Access Popper.js instance with `data.instance`.
       * @prop {onUpdate}
       */
      onUpdate: function onUpdate() {},
      /**
       * List of modifiers used to modify the offsets before they are applied to the popper.
       * They provide most of the functionalities of Popper.js.
       * @prop {modifiers}
       */
      modifiers: modifiers
    };

    /**
     * @callback onCreate
     * @param {dataObject} data
     */

    /**
     * @callback onUpdate
     * @param {dataObject} data
     */

    // Utils
    // Methods
    var Popper = function () {
      /**
       * Creates a new Popper.js instance.
       * @class Popper
       * @param {Element|referenceObject} reference - The reference element used to position the popper
       * @param {Element} popper - The HTML / XML element used as the popper
       * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
       * @return {Object} instance - The generated Popper.js instance
       */
      function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        classCallCheck(this, Popper);
        this.scheduleUpdate = function () {
          return requestAnimationFrame(_this.update);
        };

        // make update() debounced, so that it only runs at most once-per-tick
        this.update = debounce(this.update.bind(this));

        // with {} we create a new object with the options inside it
        this.options = _extends({}, Popper.Defaults, options);

        // init state
        this.state = {
          isDestroyed: false,
          isCreated: false,
          scrollParents: []
        };

        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;

        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
          _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });

        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
          return _extends({
            name: name
          }, _this.options.modifiers[name]);
        })
        // sort the modifiers by order
        .sort(function (a, b) {
          return a.order - b.order;
        });

        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function (modifierOptions) {
          if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
            modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
          }
        });

        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) {
          // setup event listeners, they will take care of update the position in specific situations
          this.enableEventListeners();
        }
        this.state.eventsEnabled = eventsEnabled;
      }

      // We can't use class properties because they don't get listed in the
      // class prototype and break stuff like Sinon stubs

      createClass(Popper, [{
        key: 'update',
        value: function update$$1() {
          return update.call(this);
        }
      }, {
        key: 'destroy',
        value: function destroy$$1() {
          return destroy.call(this);
        }
      }, {
        key: 'enableEventListeners',
        value: function enableEventListeners$$1() {
          return enableEventListeners.call(this);
        }
      }, {
        key: 'disableEventListeners',
        value: function disableEventListeners$$1() {
          return disableEventListeners.call(this);
        }

        /**
         * Schedules an update. It will run on the next UI update available.
         * @method scheduleUpdate
         * @memberof Popper
         */

        /**
         * Collection of utilities useful when writing custom modifiers.
         * Starting from version 1.7, this method is available only if you
         * include `popper-utils.js` before `popper.js`.
         *
         * **DEPRECATION**: This way to access PopperUtils is deprecated
         * and will be removed in v2! Use the PopperUtils module directly instead.
         * Due to the high instability of the methods contained in Utils, we can't
         * guarantee them to follow semver. Use them at your own risk!
         * @static
         * @private
         * @type {Object}
         * @deprecated since version 1.8
         * @member Utils
         * @memberof Popper
         */
      }]);

      return Popper;
    }();

    /**
     * The `referenceObject` is an object that provides an interface compatible with Popper.js
     * and lets you use it as replacement of a real DOM node.<br />
     * You can use this method to position a popper relatively to a set of coordinates
     * in case you don't have a DOM node to use as reference.
     *
     * ```
     * new Popper(referenceObject, popperNode);
     * ```
     *
     * NB: This feature isn't supported in Internet Explorer 10.
     * @name referenceObject
     * @property {Function} data.getBoundingClientRect
     * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
     * @property {number} data.clientWidth
     * An ES6 getter that will return the width of the virtual reference element.
     * @property {number} data.clientHeight
     * An ES6 getter that will return the height of the virtual reference element.
     */

    Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
    Popper.placements = placements;
    Popper.Defaults = Defaults;

    /* harmony default export */
    __webpack_exports__["a"] = Popper;

    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(36));

  /***/
}, /* 97 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var _react = __webpack_require__(1);
  var _react2 = _interopRequireDefault(_react);
  var _implementation = __webpack_require__(230);
  var _implementation2 = _interopRequireDefault(_implementation);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.default = _react2.default.createContext || _implementation2.default;
  module.exports = exports['default'];

  /***/
}, /* 98 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * General CSS Helpers\n */\n*,\n*::before,\n*::after,\ninput[type=search] { box-sizing: border-box; }\n\n:root {\n\t--grid-border-color:#d6d8da;\n\n\t/**\n\t * Common Colors\n\t */\n\t--app-black: #374047;\n\t--green-success: #52bc68;\n\t--red-fail: #d0021b;\n\t--app-blue: #2d7ebf;\n\n\t--brand-color-meta:#1877f2;\n\t--brand-color-facebook: #1877f2;\n\t--brand-color-instagram: #e1306c;\n\t--brand-color-youtube: #ff0000;\n\t--brand-color-linkedin: #2867b2;\n\t--brand-color-pinterest: #e60023;\n\t--brand-color-snapchat: black;\n\t--brand-color-tiktok: #000;\n\t--brand-color-twitter: #1d9bf0;\n\t--brand-color-x-twitter: #000;\n}\n\n.text-monospace { font-family: monospace; }\n.text-center { text-align: center; }\n\n/** When using this you MUST include a width on the element you want overflow */\n.text-overflow-ellipse {\n\twhite-space: nowrap;\n\toverflow-x: hidden;\n\ttext-overflow: ellipsis\n}\n.flex-only { display: flex; }\n.flex-around {\n\tdisplay: flex;\n\tjustify-content: space-around;\n}\n.flex-center {\n\tdisplay: flex;\n\talign-items: center;\n}\n.flex-between {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n.flex-start {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n}\n\n.text-monospace { font-family: monospace; }\n\n.no-show { display: none; }\n/**\n * Cursor Styles\n */\n.cursor-pointer { cursor: pointer; }\n.cursor-not-allowed { cursor: not-allowed; }\n.cursor-help { cursor: help; }\n.disabled-link { cursor: not-allowed; }\n.disabled-link a { pointer-events: none; }\n.is-a-download { display: none; }\n\n/**\n * Common Actions\n */\n.ft-ic.remove-icon {\n\tfont-size: 16px;\n\tline-height:1.75;\n\tcolor: #858c90;\n\tcursor: pointer;\n\tmargin-left: 3px;\n\ttransition: 0.2s ease color;\n}\n.ft-ic.remove-icon:hover {\n\tcolor: var(--app-black);\n}\n\n/**\n * Firefox Additions\n */\n.is-ff .e-form__select {\n\t-moz-appearance: none;\n\tpadding-top: 5px;\n}\n.e-form__select { -moz-appearance: none; }\n\n/**\n * Hover Actions\n */\n/**\n * @3.1 Circle Hover\n * \tUsed to create a circle that bounces in on hover\n * \tUsed for adding effects to certain icons\n */\n.circle-hover:hover .circle-around::before {\n\tcontent:\"\";\n\tborder-radius: 50%;\n\tcolor: white;\n\tanimation:bounceIn 0.4s linear;\n}\n/* Red */\n.circle-hover.theme-red .circle-around::before { background-color: #d95652; }\n/* Pink */\n.circle-hover.theme-pink .circle-around::before { background-color: #ea8daf; }\n/* Blue */\n.circle-hover.theme-blue .circle-around::before { background-color: #8ab7db; }\n/* Green */\n.circle-hover.theme-green .circle-around::before { background-color: #9fdaab; }\n/* Purple */\n.circle-hover.theme-purple .circle-around::before { background-color: #c6bad9; }\n/* Orange */\n.circle-hover.theme-orange .circle-around::before { background-color: #f8b99d; }\n/* Yellow */\n.circle-hover.theme-yellow .circle-around::before { background-color: #d95652; }\n\n\n/**\n * Blank Loading Stuff\n * This class will add the psudo grey bars over text when it's loading\n * This gives the illusion that there is something there without having to show a spinner\n */\n.blank-load {\n\ttransition: 0.2s ease-in;\n\tline-height: 1.2;\n}\n\n.is-loading .blank-load {\n\tbackground-color: #d6d8da;\n\theight: 14px;\n\twidth: 75px;\n\tcolor: transparent !important;\n}\n\n\n/**\n * Inline Notification Styles\n */\n.inline-notification-section{\n\tborder-radius: 3px;\n\tfont-size: 12px;\n\tpadding: 10px;\n}\n.inline-notification-section:not(td){ display: flex; }\n.inline-notification-section .notification-icon{\n\tfont-size: inherit;\n\tmargin-top: 4px;\n\tmargin-right: 10px;\n}\n.inline-notification-section.info{ background-color: #d8eafa; }\n.inline-notification-section.info .notification-icon{ color: #2d7ebf; }\n.inline-notification-section.error .notification-icon{ color: #db6561; }\n.inline-notification-section.success .notification-icon{ color: #52bc68; }\n.inline-notification-section.warning .notification-icon{ color: #f3824f; }\n\n/**\n * Basic Table styles\n ********************/\n\n.basic-table {\n\tbackground-color: #ffffff;\n\tline-height: 3;\n\tfont-size: 12px;\n\tcolor: #374047;\n\ttext-align: left;\n}\n.basic-table th {\n\tposition: sticky;\n\ttop: 0;\n\tpadding-left: 10px;\n\n\tbackground-color: #fff;\n\tborder: 1px solid #d6d8da;\n\n\t/* collapsed borders behave weirdly with `position: sticky` elements, so sidestep with box-shadow */\n\tborder-top: none;\n\tborder-bottom: none;\n\tbox-shadow: inset 0px 1px #d6d8da, inset 0px -1px #d6d8da;\n}\n\n.basic-table td {\n\tborder: 1px solid #d6d8da;\n\tborder-top: none;\n\tpadding-left: 10px;\n}\n\n/**\n * The 32px padding is to get things aligned within modals\n * Nearly every <BasicTable /> in use is within a modal and the title bar, and content of the modal has this padding\n */\n.c-modal__content .basic-table th:first-child,\n.c-modal__content .basic-table td:first-child {\n\tpadding-left:20px;\n}\n.basic-table th:first-child,\n.basic-table td:first-child {\n\tpadding: 0 32px;\n}\n\n.basic-table th:last-child,\n.basic-table td:last-child {\n\tpadding-right: 20px;\n}\n.basic-table .id-col {\n\twidth: 70px;\n}\n.basic-table .status-col {\n\twidth: 130px;\n}\n", "", {
    "version": 3,
    "sources": ["general.css"],
    "names": [],
    "mappings": "AAAA;;EAEE;AACF;;;qBAGqB,sBAAsB,EAAE;;AAE7C;CACC,2BAA2B;;CAE3B;;GAEE;CACF,oBAAoB;CACpB,wBAAwB;CACxB,mBAAmB;CACnB,mBAAmB;;CAEnB,0BAA0B;CAC1B,+BAA+B;CAC/B,gCAAgC;CAChC,8BAA8B;CAC9B,+BAA+B;CAC/B,gCAAgC;CAChC,6BAA6B;CAC7B,0BAA0B;CAC1B,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA,kBAAkB,sBAAsB,EAAE;AAC1C,eAAe,kBAAkB,EAAE;;AAEnC,+EAA+E;AAC/E;CACC,mBAAmB;CACnB,kBAAkB;CAClB;AACD;AACA,aAAa,aAAa,EAAE;AAC5B;CACC,aAAa;CACb,6BAA6B;AAC9B;AACA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,8BAA8B;AAC/B;AACA;CACC,aAAa;CACb,2BAA2B;AAC5B;;AAEA,kBAAkB,sBAAsB,EAAE;;AAE1C,WAAW,aAAa,EAAE;AAC1B;;EAEE;AACF,kBAAkB,eAAe,EAAE;AACnC,sBAAsB,mBAAmB,EAAE;AAC3C,eAAe,YAAY,EAAE;AAC7B,iBAAiB,mBAAmB,EAAE;AACtC,mBAAmB,oBAAoB,EAAE;AACzC,iBAAiB,aAAa,EAAE;;AAEhC;;EAEE;AACF;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,2BAA2B;AAC5B;AACA;CACC,uBAAuB;AACxB;;AAEA;;EAEE;AACF;CACC,qBAAqB;CACrB,gBAAgB;AACjB;AACA,kBAAkB,qBAAqB,EAAE;;AAEzC;;EAEE;AACF;;;;EAIE;AACF;CACC,UAAU;CACV,kBAAkB;CAClB,YAAY;CACZ,8BAA8B;AAC/B;AACA,QAAQ;AACR,iDAAiD,yBAAyB,EAAE;AAC5E,SAAS;AACT,kDAAkD,yBAAyB,EAAE;AAC7E,SAAS;AACT,kDAAkD,yBAAyB,EAAE;AAC7E,UAAU;AACV,mDAAmD,yBAAyB,EAAE;AAC9E,WAAW;AACX,oDAAoD,yBAAyB,EAAE;AAC/E,WAAW;AACX,oDAAoD,yBAAyB,EAAE;AAC/E,WAAW;AACX,oDAAoD,yBAAyB,EAAE;;;AAG/E;;;;EAIE;AACF;CACC,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,WAAW;CACX,6BAA6B;AAC9B;;;AAGA;;EAEE;AACF;CACC,kBAAkB;CAClB,eAAe;CACf,aAAa;AACd;AACA,sCAAsC,aAAa,EAAE;AACrD;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;AACA,mCAAmC,yBAAyB,EAAE;AAC9D,sDAAsD,cAAc,EAAE;AACtE,uDAAuD,cAAc,EAAE;AACvE,yDAAyD,cAAc,EAAE;AACzE,yDAAyD,cAAc,EAAE;;AAEzE;;qBAEqB;;AAErB;CACC,yBAAyB;CACzB,cAAc;CACd,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,MAAM;CACN,kBAAkB;;CAElB,sBAAsB;CACtB,yBAAyB;;CAEzB,mGAAmG;CACnG,gBAAgB;CAChB,mBAAmB;CACnB,yDAAyD;AAC1D;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;;;EAGE;AACF;;CAEC,iBAAiB;AAClB;AACA;;CAEC,eAAe;AAChB;;AAEA;;CAEC,mBAAmB;AACpB;AACA;CACC,WAAW;AACZ;AACA;CACC,YAAY;AACb",
    "file": "general.css",
    "sourcesContent": ["/**\n * General CSS Helpers\n */\n*,\n*::before,\n*::after,\ninput[type=search] { box-sizing: border-box; }\n\n:root {\n\t--grid-border-color:#d6d8da;\n\n\t/**\n\t * Common Colors\n\t */\n\t--app-black: #374047;\n\t--green-success: #52bc68;\n\t--red-fail: #d0021b;\n\t--app-blue: #2d7ebf;\n\n\t--brand-color-meta:#1877f2;\n\t--brand-color-facebook: #1877f2;\n\t--brand-color-instagram: #e1306c;\n\t--brand-color-youtube: #ff0000;\n\t--brand-color-linkedin: #2867b2;\n\t--brand-color-pinterest: #e60023;\n\t--brand-color-snapchat: black;\n\t--brand-color-tiktok: #000;\n\t--brand-color-twitter: #1d9bf0;\n\t--brand-color-x-twitter: #000;\n}\n\n.text-monospace { font-family: monospace; }\n.text-center { text-align: center; }\n\n/** When using this you MUST include a width on the element you want overflow */\n.text-overflow-ellipse {\n\twhite-space: nowrap;\n\toverflow-x: hidden;\n\ttext-overflow: ellipsis\n}\n.flex-only { display: flex; }\n.flex-around {\n\tdisplay: flex;\n\tjustify-content: space-around;\n}\n.flex-center {\n\tdisplay: flex;\n\talign-items: center;\n}\n.flex-between {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n.flex-start {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n}\n\n.text-monospace { font-family: monospace; }\n\n.no-show { display: none; }\n/**\n * Cursor Styles\n */\n.cursor-pointer { cursor: pointer; }\n.cursor-not-allowed { cursor: not-allowed; }\n.cursor-help { cursor: help; }\n.disabled-link { cursor: not-allowed; }\n.disabled-link a { pointer-events: none; }\n.is-a-download { display: none; }\n\n/**\n * Common Actions\n */\n.ft-ic.remove-icon {\n\tfont-size: 16px;\n\tline-height:1.75;\n\tcolor: #858c90;\n\tcursor: pointer;\n\tmargin-left: 3px;\n\ttransition: 0.2s ease color;\n}\n.ft-ic.remove-icon:hover {\n\tcolor: var(--app-black);\n}\n\n/**\n * Firefox Additions\n */\n.is-ff .e-form__select {\n\t-moz-appearance: none;\n\tpadding-top: 5px;\n}\n.e-form__select { -moz-appearance: none; }\n\n/**\n * Hover Actions\n */\n/**\n * @3.1 Circle Hover\n * \tUsed to create a circle that bounces in on hover\n * \tUsed for adding effects to certain icons\n */\n.circle-hover:hover .circle-around::before {\n\tcontent:\"\";\n\tborder-radius: 50%;\n\tcolor: white;\n\tanimation:bounceIn 0.4s linear;\n}\n/* Red */\n.circle-hover.theme-red .circle-around::before { background-color: #d95652; }\n/* Pink */\n.circle-hover.theme-pink .circle-around::before { background-color: #ea8daf; }\n/* Blue */\n.circle-hover.theme-blue .circle-around::before { background-color: #8ab7db; }\n/* Green */\n.circle-hover.theme-green .circle-around::before { background-color: #9fdaab; }\n/* Purple */\n.circle-hover.theme-purple .circle-around::before { background-color: #c6bad9; }\n/* Orange */\n.circle-hover.theme-orange .circle-around::before { background-color: #f8b99d; }\n/* Yellow */\n.circle-hover.theme-yellow .circle-around::before { background-color: #d95652; }\n\n\n/**\n * Blank Loading Stuff\n * This class will add the psudo grey bars over text when it's loading\n * This gives the illusion that there is something there without having to show a spinner\n */\n.blank-load {\n\ttransition: 0.2s ease-in;\n\tline-height: 1.2;\n}\n\n.is-loading .blank-load {\n\tbackground-color: #d6d8da;\n\theight: 14px;\n\twidth: 75px;\n\tcolor: transparent !important;\n}\n\n\n/**\n * Inline Notification Styles\n */\n.inline-notification-section{\n\tborder-radius: 3px;\n\tfont-size: 12px;\n\tpadding: 10px;\n}\n.inline-notification-section:not(td){ display: flex; }\n.inline-notification-section .notification-icon{\n\tfont-size: inherit;\n\tmargin-top: 4px;\n\tmargin-right: 10px;\n}\n.inline-notification-section.info{ background-color: #d8eafa; }\n.inline-notification-section.info .notification-icon{ color: #2d7ebf; }\n.inline-notification-section.error .notification-icon{ color: #db6561; }\n.inline-notification-section.success .notification-icon{ color: #52bc68; }\n.inline-notification-section.warning .notification-icon{ color: #f3824f; }\n\n/**\n * Basic Table styles\n ********************/\n\n.basic-table {\n\tbackground-color: #ffffff;\n\tline-height: 3;\n\tfont-size: 12px;\n\tcolor: #374047;\n\ttext-align: left;\n}\n.basic-table th {\n\tposition: sticky;\n\ttop: 0;\n\tpadding-left: 10px;\n\n\tbackground-color: #fff;\n\tborder: 1px solid #d6d8da;\n\n\t/* collapsed borders behave weirdly with `position: sticky` elements, so sidestep with box-shadow */\n\tborder-top: none;\n\tborder-bottom: none;\n\tbox-shadow: inset 0px 1px #d6d8da, inset 0px -1px #d6d8da;\n}\n\n.basic-table td {\n\tborder: 1px solid #d6d8da;\n\tborder-top: none;\n\tpadding-left: 10px;\n}\n\n/**\n * The 32px padding is to get things aligned within modals\n * Nearly every <BasicTable /> in use is within a modal and the title bar, and content of the modal has this padding\n */\n.c-modal__content .basic-table th:first-child,\n.c-modal__content .basic-table td:first-child {\n\tpadding-left:20px;\n}\n.basic-table th:first-child,\n.basic-table td:first-child {\n\tpadding: 0 32px;\n}\n\n.basic-table th:last-child,\n.basic-table td:last-child {\n\tpadding-right: 20px;\n}\n.basic-table .id-col {\n\twidth: 70px;\n}\n.basic-table .status-col {\n\twidth: 130px;\n}\n"]
  }]);

  /***/
}, /* 99 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.Checkbox = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _ControlWrapper = _interopRequireDefault(__webpack_require__(29));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _Tooltip = _interopRequireDefault(__webpack_require__(40));
  var _EnhancedTooltip = _interopRequireDefault(__webpack_require__(58));
  var _excluded = ["UID", "type", "checked", "useValue", "getCheckedFromValue", "id", "hasHeader", "inlineLabel", "inlineTip", "tooltipVersion"];
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var Checkbox = /*#__PURE__*/function (_React$Component) {
    _inherits(Checkbox, _React$Component);
    var _super = _createSuper(Checkbox);
    function Checkbox() {
      _classCallCheck(this, Checkbox);
      return _super.apply(this, arguments);
    }
    _createClass(Checkbox, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        var props = this.props,
          update = false;
        if (props.checked !== nextProps.checked) {
          update = true;
        }
        if (props.disabled !== nextProps.disabled) {
          update = true;
        }
        if (props.value !== nextProps.value) {
          update = true;
        }
        if (props.name !== nextProps.name) {
          update = true;
        }
        if (props.label !== nextProps.label) {
          update = true;
        }
        if (props.type !== nextProps.type) {
          update = true;
        }
        if (props.hasHeader !== nextProps.hasHeader) {
          update = true;
        }
        if (props.inlineLabel !== nextProps.inlineLabel) {
          update = true;
        }
        return update;
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
          UID = props.UID,
          type = props.type,
          checked = props.checked,
          useValue = props.useValue,
          getCheckedFromValue = props.getCheckedFromValue,
          id = props.id,
          hasHeader = props.hasHeader,
          inlineLabel = props.inlineLabel,
          inlineTip = props.inlineTip,
          tooltipVersion = props.tooltipVersion,
          remainderProps = _objectWithoutProperties(props, _excluded),
          uniqueID = id || UID,
          lbl = hasHeader && inlineLabel ? inlineLabel : props.label,
          inputProps = _objectSpread(_objectSpread({
            checked: false
          }, remainderProps), {}, {
            type: type,
            label: props["aria-label"] || lbl,
            id: uniqueID
          }),
          controlClassNameConfig = _defineProperty({
            "e-form__control": true,
            "is-checked": false,
            "is-disabled": props.disabled
          }, "checkbox-".concat(props.className), !!props.className),
          $tip = null;
        if (checked) {
          inputProps.checked = true;
          controlClassNameConfig["is-checked"] = true;
        }
        if (useValue) {
          if (getCheckedFromValue(props.value)) {
            inputProps.checked = true;
            controlClassNameConfig["is-checked"] = true;
          }
        }
        if (props.hasHeader && props.inlineTip && props.inlineTip.description) {
          if (tooltipVersion === 1) {
            $tip = /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], _extends({}, inlineTip, {
              className: "e-form__control-description"
            }));
          }
          if (tooltipVersion === 2) {
            $tip = /*#__PURE__*/_react["default"].createElement("span", {
              className: "u-form__help",
              "aria-label": inlineTip.description.trim()
            }, /*#__PURE__*/_react["default"].createElement("i", {
              className: "fa fa-info-circle",
              "data-tip": true,
              "data-for": UID,
              "data-html": inlineTip.html,
              "aria-label": "Get Info"
            }), /*#__PURE__*/_react["default"].createElement(_EnhancedTooltip["default"], _extends({}, inlineTip, {
              id: UID,
              content: inlineTip.description
            })));
          }
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])(controlClassNameConfig)
        }, /*#__PURE__*/_react["default"].createElement("label", {
          className: "e-form__".concat(type),
          htmlFor: uniqueID
        }, /*#__PURE__*/_react["default"].createElement("input", inputProps), /*#__PURE__*/_react["default"].createElement("span", {
          className: "e-form__".concat(type, "--bg")
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: "e-form__".concat(type, "--label")
        }, lbl)), $tip);
      }
    }]);
    return Checkbox;
  }(_react["default"].Component);
  /**
   * Creates a Checkbox for use as a control in a form
   */
  exports.Checkbox = Checkbox;
  _defineProperty(Checkbox, "displayName", 'Checkbox');
  _defineProperty(Checkbox, "defaultProps", {
    type: "checkbox",
    label: "",
    "aria-label": null,
    name: "",
    value: "",
    disabled: false,
    checked: false,
    onChange: function onChange() {},
    useValue: false,
    id: null,
    getCheckedFromValue: function getCheckedFromValue(value) {
      if (typeof value === "boolean") {
        return value;
      }
      if (parseInt(value) === 1) {
        return true;
      }
      if (value === "true") {
        return true;
      }
      return false;
    },
    // additional props for checkboxes with a ControlWrapper label
    hasHeader: false,
    inlineLabel: "",
    inlineTip: null
  });
  _defineProperty(Checkbox, "propTypes", {
    /** Should we render a checkbox, or a radio button */
    type: _propTypes["default"].oneOf(['checkbox', 'radio']),
    /** Label to display on the given checkbox */
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].node]),
    /** Name to attach the value to in a JSON structure */
    name: _propTypes["default"].string.isRequired,
    /** Value of this checkbox to either be checked (value of true, "true", 1) or not */
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]).isRequired,
    /** Function to call when the element is clicked */
    onChange: _propTypes["default"].func.isRequired,
    /** Should this checkbox be disabled or not*/
    disabled: _propTypes["default"].bool,
    /** Should this checkbox be checked or not */
    checked: _propTypes["default"].bool,
    /** Should checked be based on the value or not*/
    useValue: _propTypes["default"].bool,
    /** function to call when checked depends on the value */
    getCheckedFromValue: _propTypes["default"].func,
    // additional props for checkboxes with a ControlWrapper label
    /** If the checkbox has a ControlWrapper label - if true, use the inlineLabel prop, if false continue using the label prop */
    hasHeader: _propTypes["default"].bool,
    /** Inline label for the checkbox - only used if hasHeader:true */
    inlineLabel: _propTypes["default"].string,
    /** Tip for the inline label of the checkbox - only used if hasHeader:true */
    inlineTip: _propTypes["default"].object
  });
  var _default = (0, _ControlWrapper["default"])(Checkbox);
  exports["default"] = _default;

  /***/
}, /* 100 */
/***/function (module, exports) {
  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }
  module.exports = identity;

  /***/
}, /* 101 */
/***/function (module, exports, __webpack_require__) {
  var listCacheClear = __webpack_require__(266),
    listCacheDelete = __webpack_require__(267),
    listCacheGet = __webpack_require__(268),
    listCacheHas = __webpack_require__(269),
    listCacheSet = __webpack_require__(270);

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  module.exports = ListCache;

  /***/
}, /* 102 */
/***/function (module, exports, __webpack_require__) {
  var eq = __webpack_require__(103);

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  module.exports = assocIndexOf;

  /***/
}, /* 103 */
/***/function (module, exports) {
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  module.exports = eq;

  /***/
}, /* 104 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(75);

  /* Built-in method references that are verified to be native. */
  var nativeCreate = getNative(Object, 'create');
  module.exports = nativeCreate;

  /***/
}, /* 105 */
/***/function (module, exports, __webpack_require__) {
  var isKeyable = __webpack_require__(288);

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }
  module.exports = getMapData;

  /***/
}, /* 106 */
/***/function (module, exports, __webpack_require__) {
  var DataView = __webpack_require__(302),
    Map = __webpack_require__(155),
    Promise = __webpack_require__(303),
    Set = __webpack_require__(304),
    WeakMap = __webpack_require__(305),
    baseGetTag = __webpack_require__(80),
    toSource = __webpack_require__(193);

  /** `Object#toString` result references. */
  var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';
  var dataViewTag = '[object DataView]';

  /** Used to detect maps, sets, and weakmaps. */
  var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  var getTag = baseGetTag;

  // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function (value) {
      var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  module.exports = getTag;

  /***/
}, /* 107 */
/***/function (module, exports, __webpack_require__) {
  var arrayLikeKeys = __webpack_require__(187),
    baseKeysIn = __webpack_require__(309),
    isArrayLike = __webpack_require__(88);

  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */
  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }
  module.exports = keysIn;

  /***/
}, /* 108 */
/***/function (module, exports, __webpack_require__) {
  var isArray = __webpack_require__(44),
    isKey = __webpack_require__(162),
    stringToPath = __webpack_require__(328),
    toString = __webpack_require__(331);

  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {Object} [object] The object to query keys on.
   * @returns {Array} Returns the cast property path array.
   */
  function castPath(value, object) {
    if (isArray(value)) {
      return value;
    }
    return isKey(value, object) ? [value] : stringToPath(toString(value));
  }
  module.exports = castPath;

  /***/
}, /* 109 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // ESM COMPAT FLAG
  __webpack_require__.r(__webpack_exports__);

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "ContextMenu", function () {
    return (/* reexport */es6_ContextMenu
    );
  });
  __webpack_require__.d(__webpack_exports__, "ContextMenuTrigger", function () {
    return (/* reexport */es6_ContextMenuTrigger
    );
  });
  __webpack_require__.d(__webpack_exports__, "MenuItem", function () {
    return (/* reexport */es6_MenuItem
    );
  });
  __webpack_require__.d(__webpack_exports__, "SubMenu", function () {
    return (/* reexport */es6_SubMenu
    );
  });
  __webpack_require__.d(__webpack_exports__, "connectMenu", function () {
    return (/* reexport */connectMenu
    );
  });
  __webpack_require__.d(__webpack_exports__, "hideMenu", function () {
    return (/* reexport */hideMenu
    );
  });
  __webpack_require__.d(__webpack_exports__, "showMenu", function () {
    return (/* reexport */showMenu
    );
  });

  // EXTERNAL MODULE: external "react"
  var external_react_ = __webpack_require__(1);
  var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

  // EXTERNAL MODULE: external "prop-types"
  var external_prop_types_ = __webpack_require__(0);
  var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

  // EXTERNAL MODULE: ./node_modules/classnames/index.js
  var classnames = __webpack_require__(6);
  var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

  // EXTERNAL MODULE: ./node_modules/object-assign/index.js
  var object_assign = __webpack_require__(17);
  var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

  // CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/helpers.js
  function callIfExists(func) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return typeof func === 'function' && func.apply(undefined, args);
  }
  function hasOwnProp(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }
  function uniqueId() {
    return Math.random().toString(36).substring(7);
  }
  var cssClasses = {
    menu: 'react-contextmenu',
    menuVisible: 'react-contextmenu--visible',
    menuWrapper: 'react-contextmenu-wrapper',
    menuItem: 'react-contextmenu-item',
    menuItemActive: 'react-contextmenu-item--active',
    menuItemDisabled: 'react-contextmenu-item--disabled',
    menuItemDivider: 'react-contextmenu-item--divider',
    menuItemSelected: 'react-contextmenu-item--selected',
    subMenu: 'react-contextmenu-submenu'
  };
  var store = {};
  var canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
  // CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/actions.js

  var MENU_SHOW = 'REACT_CONTEXTMENU_SHOW';
  var MENU_HIDE = 'REACT_CONTEXTMENU_HIDE';
  function dispatchGlobalEvent(eventName, opts) {
    var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;

    // Compatibale with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    var event = void 0;
    if (typeof window.CustomEvent === 'function') {
      event = new window.CustomEvent(eventName, {
        detail: opts
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(eventName, false, true, opts);
    }
    if (target) {
      target.dispatchEvent(event);
      object_assign_default()(store, opts);
    }
  }
  function showMenu() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var target = arguments[1];
    dispatchGlobalEvent(MENU_SHOW, object_assign_default()({}, opts, {
      type: MENU_SHOW
    }), target);
  }
  function hideMenu() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var target = arguments[1];
    dispatchGlobalEvent(MENU_HIDE, object_assign_default()({}, opts, {
      type: MENU_HIDE
    }), target);
  }
  // CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/globalEventListener.js
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var globalEventListener_GlobalEventListener = function GlobalEventListener() {
    var _this = this;
    _classCallCheck(this, GlobalEventListener);
    this.handleShowEvent = function (event) {
      for (var id in _this.callbacks) {
        if (hasOwnProp(_this.callbacks, id)) _this.callbacks[id].show(event);
      }
    };
    this.handleHideEvent = function (event) {
      for (var id in _this.callbacks) {
        if (hasOwnProp(_this.callbacks, id)) _this.callbacks[id].hide(event);
      }
    };
    this.register = function (showCallback, hideCallback) {
      var id = uniqueId();
      _this.callbacks[id] = {
        show: showCallback,
        hide: hideCallback
      };
      return id;
    };
    this.unregister = function (id) {
      if (id && _this.callbacks[id]) {
        delete _this.callbacks[id];
      }
    };
    this.callbacks = {};
    if (canUseDOM) {
      window.addEventListener(MENU_SHOW, this.handleShowEvent);
      window.addEventListener(MENU_HIDE, this.handleHideEvent);
    }
  };

  /* harmony default export */
  var globalEventListener = new globalEventListener_GlobalEventListener();
  // CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/MenuItem.js
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function MenuItem_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MenuItem_MenuItem = function (_Component) {
    _inherits(MenuItem, _Component);
    function MenuItem() {
      var _ref;
      var _temp, _this, _ret;
      MenuItem_classCallCheck(this, MenuItem);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
        if (event.button !== 0 && event.button !== 1) {
          event.preventDefault();
        }
        if (_this.props.disabled || _this.props.divider) return;
        callIfExists(_this.props.onClick, event, object_assign_default()({}, _this.props.data, store.data), store.target);
        if (_this.props.preventClose) return;
        hideMenu();
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(MenuItem, [{
      key: 'render',
      value: function render() {
        var _cx,
          _this2 = this;
        var _props = this.props,
          attributes = _props.attributes,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          divider = _props.divider,
          selected = _props.selected;
        var menuItemClassNames = classnames_default()(className, cssClasses.menuItem, attributes.className, (_cx = {}, _defineProperty(_cx, classnames_default()(cssClasses.menuItemDisabled, attributes.disabledClassName), disabled), _defineProperty(_cx, classnames_default()(cssClasses.menuItemDivider, attributes.dividerClassName), divider), _defineProperty(_cx, classnames_default()(cssClasses.menuItemSelected, attributes.selectedClassName), selected), _cx));
        return external_react_default.a.createElement('div', _extends({}, attributes, {
          className: menuItemClassNames,
          role: 'menuitem',
          tabIndex: '-1',
          'aria-disabled': disabled ? 'true' : 'false',
          'aria-orientation': divider ? 'horizontal' : null,
          ref: function ref(_ref2) {
            _this2.ref = _ref2;
          },
          onMouseMove: this.props.onMouseMove,
          onMouseLeave: this.props.onMouseLeave,
          onTouchEnd: this.handleClick,
          onClick: this.handleClick
        }), divider ? null : children);
      }
    }]);
    return MenuItem;
  }(external_react_["Component"]);
  MenuItem_MenuItem.propTypes = {
    attributes: external_prop_types_default.a.object,
    children: external_prop_types_default.a.node,
    className: external_prop_types_default.a.string,
    data: external_prop_types_default.a.object,
    disabled: external_prop_types_default.a.bool,
    divider: external_prop_types_default.a.bool,
    onClick: external_prop_types_default.a.func,
    onMouseLeave: external_prop_types_default.a.func,
    onMouseMove: external_prop_types_default.a.func,
    preventClose: external_prop_types_default.a.bool,
    selected: external_prop_types_default.a.bool
  };
  MenuItem_MenuItem.defaultProps = {
    attributes: {},
    children: null,
    className: '',
    data: {},
    disabled: false,
    divider: false,
    onClick: function onClick() {
      return null;
    },
    onMouseMove: function onMouseMove() {
      return null;
    },
    onMouseLeave: function onMouseLeave() {
      return null;
    },
    preventClose: false,
    selected: false
  };
  /* harmony default export */
  var es6_MenuItem = MenuItem_MenuItem;
  // CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/AbstractMenu.js
  function AbstractMenu_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function AbstractMenu_possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function AbstractMenu_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var AbstractMenu = function (_Component) {
    AbstractMenu_inherits(AbstractMenu, _Component);
    function AbstractMenu(props) {
      AbstractMenu_classCallCheck(this, AbstractMenu);
      var _this = AbstractMenu_possibleConstructorReturn(this, (AbstractMenu.__proto__ || Object.getPrototypeOf(AbstractMenu)).call(this, props));
      AbstractMenu_initialiseProps.call(_this);
      _this.seletedItemRef = null;
      _this.state = {
        selectedItem: null,
        forceSubMenuOpen: false
      };
      return _this;
    }
    return AbstractMenu;
  }(external_react_["Component"]);
  AbstractMenu.propTypes = {
    children: external_prop_types_default.a.node.isRequired
  };
  var AbstractMenu_initialiseProps = function _initialiseProps() {
    var _this2 = this;
    this.handleKeyNavigation = function (e) {
      // check for isVisible strictly here as it might be undefined when this code executes in the context of SubMenu
      // but we only need to check when it runs in the ContextMenu context
      if (_this2.state.isVisible === false) {
        return;
      }
      switch (e.keyCode) {
        case 37: // left arrow
        case 27:
          // escape
          e.preventDefault();
          _this2.hideMenu(e);
          break;
        case 38:
          // up arrow
          e.preventDefault();
          _this2.selectChildren(true);
          break;
        case 40:
          // down arrow
          e.preventDefault();
          _this2.selectChildren(false);
          break;
        case 39:
          // right arrow
          _this2.tryToOpenSubMenu(e);
          break;
        case 13:
          // enter
          e.preventDefault();
          _this2.tryToOpenSubMenu(e);
          {
            // determine the selected item is disabled or not
            var disabled = _this2.seletedItemRef && _this2.seletedItemRef.props && _this2.seletedItemRef.props.disabled;
            if (_this2.seletedItemRef && _this2.seletedItemRef.ref instanceof HTMLElement && !disabled) {
              _this2.seletedItemRef.ref.click();
            } else {
              _this2.hideMenu(e);
            }
          }
          break;
        default:
        // do nothing
      }
    };

    this.handleForceClose = function () {
      _this2.setState({
        forceSubMenuOpen: false
      });
    };
    this.tryToOpenSubMenu = function (e) {
      if (_this2.state.selectedItem && _this2.state.selectedItem.type === _this2.getSubMenuType()) {
        e.preventDefault();
        _this2.setState({
          forceSubMenuOpen: true
        });
      }
    };
    this.selectChildren = function (forward) {
      var selectedItem = _this2.state.selectedItem;
      var children = [];
      var disabledChildrenCount = 0;
      var disabledChildIndexes = {};
      var childCollector = function childCollector(child, index) {
        // child can be empty in case you do conditional rendering of components, in which
        // case it should not be accounted for as a real child
        if (!child) {
          return;
        }
        if ([es6_MenuItem, _this2.getSubMenuType()].indexOf(child.type) < 0) {
          // Maybe the MenuItem or SubMenu is capsuled in a wrapper div or something else
          external_react_default.a.Children.forEach(child.props.children, childCollector);
        } else if (!child.props.divider) {
          if (child.props.disabled) {
            ++disabledChildrenCount;
            disabledChildIndexes[index] = true;
          }
          children.push(child);
        }
      };
      external_react_default.a.Children.forEach(_this2.props.children, childCollector);
      if (disabledChildrenCount === children.length) {
        // All menu items are disabled, so none can be selected, don't do anything
        return;
      }
      function findNextEnabledChildIndex(currentIndex) {
        var i = currentIndex;
        var incrementCounter = function incrementCounter() {
          if (forward) {
            --i;
          } else {
            ++i;
          }
          if (i < 0) {
            i = children.length - 1;
          } else if (i >= children.length) {
            i = 0;
          }
        };
        do {
          incrementCounter();
        } while (i !== currentIndex && disabledChildIndexes[i]);
        return i === currentIndex ? null : i;
      }
      var currentIndex = children.indexOf(selectedItem);
      var nextEnabledChildIndex = findNextEnabledChildIndex(currentIndex);
      if (nextEnabledChildIndex !== null) {
        _this2.setState({
          selectedItem: children[nextEnabledChildIndex],
          forceSubMenuOpen: false
        });
      }
    };
    this.onChildMouseMove = function (child) {
      if (_this2.state.selectedItem !== child) {
        _this2.setState({
          selectedItem: child,
          forceSubMenuOpen: false
        });
      }
    };
    this.onChildMouseLeave = function () {
      _this2.setState({
        selectedItem: null,
        forceSubMenuOpen: false
      });
    };
    this.renderChildren = function (children) {
      return external_react_default.a.Children.map(children, function (child) {
        var props = {};
        if (!external_react_default.a.isValidElement(child)) return child;
        if ([es6_MenuItem, _this2.getSubMenuType()].indexOf(child.type) < 0) {
          // Maybe the MenuItem or SubMenu is capsuled in a wrapper div or something else
          props.children = _this2.renderChildren(child.props.children);
          return external_react_default.a.cloneElement(child, props);
        }
        props.onMouseLeave = _this2.onChildMouseLeave.bind(_this2);
        if (child.type === _this2.getSubMenuType()) {
          // special props for SubMenu only
          props.forceOpen = _this2.state.forceSubMenuOpen && _this2.state.selectedItem === child;
          props.forceClose = _this2.handleForceClose;
          props.parentKeyNavigationHandler = _this2.handleKeyNavigation;
        }
        if (!child.props.divider && _this2.state.selectedItem === child) {
          // special props for selected item only
          props.selected = true;
          props.ref = function (ref) {
            _this2.seletedItemRef = ref;
          };
          return external_react_default.a.cloneElement(child, props);
        }
        // onMouseMove is only needed for non selected items
        props.onMouseMove = function () {
          return _this2.onChildMouseMove(child);
        };
        return external_react_default.a.cloneElement(child, props);
      });
    };
  };

  /* harmony default export */
  var es6_AbstractMenu = AbstractMenu;
  // CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/SubMenu.js
  var SubMenu_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var SubMenu_createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function SubMenu_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function SubMenu_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function SubMenu_possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function SubMenu_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var SubMenu_SubMenu = function (_AbstractMenu) {
    SubMenu_inherits(SubMenu, _AbstractMenu);
    function SubMenu(props) {
      SubMenu_classCallCheck(this, SubMenu);
      var _this = SubMenu_possibleConstructorReturn(this, (SubMenu.__proto__ || Object.getPrototypeOf(SubMenu)).call(this, props));
      _this.getMenuPosition = function () {
        var _window = window,
          innerWidth = _window.innerWidth,
          innerHeight = _window.innerHeight;
        var rect = _this.subMenu.getBoundingClientRect();
        var position = {};
        if (rect.bottom > innerHeight) {
          position.bottom = 0;
        } else {
          position.top = 0;
        }
        if (rect.right < innerWidth) {
          position.left = '100%';
        } else {
          position.right = '100%';
        }
        return position;
      };
      _this.getRTLMenuPosition = function () {
        var _window2 = window,
          innerHeight = _window2.innerHeight;
        var rect = _this.subMenu.getBoundingClientRect();
        var position = {};
        if (rect.bottom > innerHeight) {
          position.bottom = 0;
        } else {
          position.top = 0;
        }
        if (rect.left < 0) {
          position.left = '100%';
        } else {
          position.right = '100%';
        }
        return position;
      };
      _this.hideSubMenu = function (e) {
        // avoid closing submenus of a different menu tree
        if (e.detail && e.detail.id && _this.menu && e.detail.id !== _this.menu.id) {
          return;
        }
        if (_this.props.forceOpen) {
          _this.props.forceClose();
        }
        _this.setState({
          visible: false,
          selectedItem: null
        });
        _this.unregisterHandlers();
      };
      _this.handleClick = function (event) {
        event.preventDefault();
        if (_this.props.disabled) return;
        callIfExists(_this.props.onClick, event, object_assign_default()({}, _this.props.data, store.data), store.target);
        if (!_this.props.onClick || _this.props.preventCloseOnClick) return;
        hideMenu();
      };
      _this.handleMouseEnter = function () {
        if (_this.closetimer) clearTimeout(_this.closetimer);
        if (_this.props.disabled || _this.state.visible) return;
        _this.opentimer = setTimeout(function () {
          return _this.setState({
            visible: true,
            selectedItem: null
          });
        }, _this.props.hoverDelay);
      };
      _this.handleMouseLeave = function () {
        if (_this.opentimer) clearTimeout(_this.opentimer);
        if (!_this.state.visible) return;
        _this.closetimer = setTimeout(function () {
          return _this.setState({
            visible: false,
            selectedItem: null
          });
        }, _this.props.hoverDelay);
      };
      _this.menuRef = function (c) {
        _this.menu = c;
      };
      _this.subMenuRef = function (c) {
        _this.subMenu = c;
      };
      _this.registerHandlers = function () {
        document.removeEventListener('keydown', _this.props.parentKeyNavigationHandler);
        document.addEventListener('keydown', _this.handleKeyNavigation);
      };
      _this.unregisterHandlers = function (dismounting) {
        document.removeEventListener('keydown', _this.handleKeyNavigation);
        if (!dismounting) {
          document.addEventListener('keydown', _this.props.parentKeyNavigationHandler);
        }
      };
      _this.state = object_assign_default()({}, _this.state, {
        visible: false
      });
      return _this;
    }
    SubMenu_createClass(SubMenu, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.listenId = globalEventListener.register(function () {}, this.hideSubMenu);
      }
    }, {
      key: 'getSubMenuType',
      value: function getSubMenuType() {
        // eslint-disable-line class-methods-use-this
        return SubMenu;
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        this.isVisibilityChange = (this.state.visible !== nextState.visible || this.props.forceOpen !== nextProps.forceOpen) && !(this.state.visible && nextProps.forceOpen) && !(this.props.forceOpen && nextState.visible);
        return true;
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        var _this2 = this;
        if (!this.isVisibilityChange) return;
        if (this.props.forceOpen || this.state.visible) {
          var wrapper = window.requestAnimationFrame || setTimeout;
          wrapper(function () {
            var styles = _this2.props.rtl ? _this2.getRTLMenuPosition() : _this2.getMenuPosition();
            _this2.subMenu.style.removeProperty('top');
            _this2.subMenu.style.removeProperty('bottom');
            _this2.subMenu.style.removeProperty('left');
            _this2.subMenu.style.removeProperty('right');
            if (hasOwnProp(styles, 'top')) _this2.subMenu.style.top = styles.top;
            if (hasOwnProp(styles, 'left')) _this2.subMenu.style.left = styles.left;
            if (hasOwnProp(styles, 'bottom')) _this2.subMenu.style.bottom = styles.bottom;
            if (hasOwnProp(styles, 'right')) _this2.subMenu.style.right = styles.right;
            _this2.subMenu.classList.add(cssClasses.menuVisible);
            _this2.registerHandlers();
            _this2.setState({
              selectedItem: null
            });
          });
        } else {
          var cleanup = function cleanup() {
            _this2.subMenu.removeEventListener('transitionend', cleanup);
            _this2.subMenu.style.removeProperty('bottom');
            _this2.subMenu.style.removeProperty('right');
            _this2.subMenu.style.top = 0;
            _this2.subMenu.style.left = '100%';
            _this2.unregisterHandlers();
          };
          this.subMenu.addEventListener('transitionend', cleanup);
          this.subMenu.classList.remove(cssClasses.menuVisible);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.listenId) {
          globalEventListener.unregister(this.listenId);
        }
        if (this.opentimer) clearTimeout(this.opentimer);
        if (this.closetimer) clearTimeout(this.closetimer);
        this.unregisterHandlers(true);
      }
    }, {
      key: 'render',
      value: function render() {
        var _cx;
        var _props = this.props,
          children = _props.children,
          attributes = _props.attributes,
          disabled = _props.disabled,
          title = _props.title,
          selected = _props.selected;
        var visible = this.state.visible;
        var menuProps = {
          ref: this.menuRef,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          className: classnames_default()(cssClasses.menuItem, cssClasses.subMenu, attributes.listClassName),
          style: {
            position: 'relative'
          }
        };
        var menuItemProps = {
          className: classnames_default()(cssClasses.menuItem, attributes.className, (_cx = {}, SubMenu_defineProperty(_cx, classnames_default()(cssClasses.menuItemDisabled, attributes.disabledClassName), disabled), SubMenu_defineProperty(_cx, classnames_default()(cssClasses.menuItemActive, attributes.visibleClassName), visible), SubMenu_defineProperty(_cx, classnames_default()(cssClasses.menuItemSelected, attributes.selectedClassName), selected), _cx)),
          onMouseMove: this.props.onMouseMove,
          onMouseOut: this.props.onMouseOut,
          onClick: this.handleClick
        };
        var subMenuProps = {
          ref: this.subMenuRef,
          style: {
            position: 'absolute',
            transition: 'opacity 1ms',
            // trigger transitionend event
            top: 0,
            left: '100%'
          },
          className: classnames_default()(cssClasses.menu, this.props.className)
        };
        return external_react_default.a.createElement('nav', SubMenu_extends({}, menuProps, {
          role: 'menuitem',
          tabIndex: '-1',
          'aria-haspopup': 'true'
        }), external_react_default.a.createElement('div', SubMenu_extends({}, attributes, menuItemProps), title), external_react_default.a.createElement('nav', SubMenu_extends({}, subMenuProps, {
          role: 'menu',
          tabIndex: '-1'
        }), this.renderChildren(children)));
      }
    }]);
    return SubMenu;
  }(es6_AbstractMenu);
  SubMenu_SubMenu.propTypes = {
    children: external_prop_types_default.a.node.isRequired,
    attributes: external_prop_types_default.a.object,
    title: external_prop_types_default.a.node.isRequired,
    className: external_prop_types_default.a.string,
    disabled: external_prop_types_default.a.bool,
    hoverDelay: external_prop_types_default.a.number,
    rtl: external_prop_types_default.a.bool,
    selected: external_prop_types_default.a.bool,
    onMouseMove: external_prop_types_default.a.func,
    onMouseOut: external_prop_types_default.a.func,
    forceOpen: external_prop_types_default.a.bool,
    forceClose: external_prop_types_default.a.func,
    parentKeyNavigationHandler: external_prop_types_default.a.func
  };
  SubMenu_SubMenu.defaultProps = {
    disabled: false,
    hoverDelay: 500,
    attributes: {},
    className: '',
    rtl: false,
    selected: false,
    onMouseMove: function onMouseMove() {
      return null;
    },
    onMouseOut: function onMouseOut() {
      return null;
    },
    forceOpen: false,
    forceClose: function forceClose() {
      return null;
    },
    parentKeyNavigationHandler: function parentKeyNavigationHandler() {
      return null;
    }
  };
  /* harmony default export */
  var es6_SubMenu = SubMenu_SubMenu;
  // CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/ContextMenu.js
  var ContextMenu_createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function ContextMenu_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function ContextMenu_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function ContextMenu_possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function ContextMenu_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var ContextMenu_ContextMenu = function (_AbstractMenu) {
    ContextMenu_inherits(ContextMenu, _AbstractMenu);
    function ContextMenu(props) {
      ContextMenu_classCallCheck(this, ContextMenu);
      var _this = ContextMenu_possibleConstructorReturn(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).call(this, props));
      _this.registerHandlers = function () {
        document.addEventListener('mousedown', _this.handleOutsideClick);
        document.addEventListener('touchstart', _this.handleOutsideClick);
        if (!_this.props.preventHideOnScroll) document.addEventListener('scroll', _this.handleHide);
        if (!_this.props.preventHideOnContextMenu) document.addEventListener('contextmenu', _this.handleHide);
        document.addEventListener('keydown', _this.handleKeyNavigation);
        if (!_this.props.preventHideOnResize) window.addEventListener('resize', _this.handleHide);
      };
      _this.unregisterHandlers = function () {
        document.removeEventListener('mousedown', _this.handleOutsideClick);
        document.removeEventListener('touchstart', _this.handleOutsideClick);
        document.removeEventListener('scroll', _this.handleHide);
        document.removeEventListener('contextmenu', _this.handleHide);
        document.removeEventListener('keydown', _this.handleKeyNavigation);
        window.removeEventListener('resize', _this.handleHide);
      };
      _this.handleShow = function (e) {
        if (e.detail.id !== _this.props.id || _this.state.isVisible) return;
        var _e$detail$position = e.detail.position,
          x = _e$detail$position.x,
          y = _e$detail$position.y;
        _this.setState({
          isVisible: true,
          x: x,
          y: y
        });
        _this.registerHandlers();
        callIfExists(_this.props.onShow, e);
      };
      _this.handleHide = function (e) {
        if (_this.state.isVisible && (!e.detail || !e.detail.id || e.detail.id === _this.props.id)) {
          _this.unregisterHandlers();
          _this.setState({
            isVisible: false,
            selectedItem: null,
            forceSubMenuOpen: false
          });
          callIfExists(_this.props.onHide, e);
        }
      };
      _this.handleOutsideClick = function (e) {
        if (!_this.menu.contains(e.target)) hideMenu();
      };
      _this.handleMouseLeave = function (event) {
        event.preventDefault();
        callIfExists(_this.props.onMouseLeave, event, object_assign_default()({}, _this.props.data, store.data), store.target);
        if (_this.props.hideOnLeave) hideMenu();
      };
      _this.handleContextMenu = function (e) {
        if (true) {
          e.preventDefault();
        }
        _this.handleHide(e);
      };
      _this.hideMenu = function (e) {
        if (e.keyCode === 27 || e.keyCode === 13) {
          // ECS or enter
          hideMenu();
        }
      };
      _this.getMenuPosition = function () {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var menuStyles = {
          top: y,
          left: x
        };
        if (!_this.menu) return menuStyles;
        var _window = window,
          innerWidth = _window.innerWidth,
          innerHeight = _window.innerHeight;
        var rect = _this.menu.getBoundingClientRect();
        if (y + rect.height > innerHeight) {
          menuStyles.top -= rect.height;
        }
        if (x + rect.width > innerWidth) {
          menuStyles.left -= rect.width;
        }
        if (menuStyles.top < 0) {
          menuStyles.top = rect.height < innerHeight ? (innerHeight - rect.height) / 2 : 0;
        }
        if (menuStyles.left < 0) {
          menuStyles.left = rect.width < innerWidth ? (innerWidth - rect.width) / 2 : 0;
        }
        return menuStyles;
      };
      _this.getRTLMenuPosition = function () {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var menuStyles = {
          top: y,
          left: x
        };
        if (!_this.menu) return menuStyles;
        var _window2 = window,
          innerWidth = _window2.innerWidth,
          innerHeight = _window2.innerHeight;
        var rect = _this.menu.getBoundingClientRect();

        // Try to position the menu on the left side of the cursor
        menuStyles.left = x - rect.width;
        if (y + rect.height > innerHeight) {
          menuStyles.top -= rect.height;
        }
        if (menuStyles.left < 0) {
          menuStyles.left += rect.width;
        }
        if (menuStyles.top < 0) {
          menuStyles.top = rect.height < innerHeight ? (innerHeight - rect.height) / 2 : 0;
        }
        if (menuStyles.left + rect.width > innerWidth) {
          menuStyles.left = rect.width < innerWidth ? (innerWidth - rect.width) / 2 : 0;
        }
        return menuStyles;
      };
      _this.menuRef = function (c) {
        _this.menu = c;
      };
      _this.state = object_assign_default()({}, _this.state, {
        x: 0,
        y: 0,
        isVisible: false
      });
      return _this;
    }
    ContextMenu_createClass(ContextMenu, [{
      key: 'getSubMenuType',
      value: function getSubMenuType() {
        // eslint-disable-line class-methods-use-this
        return es6_SubMenu;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.listenId = globalEventListener.register(this.handleShow, this.handleHide);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        var _this2 = this;
        var wrapper = window.requestAnimationFrame || setTimeout;
        if (this.state.isVisible) {
          wrapper(function () {
            var _state = _this2.state,
              x = _state.x,
              y = _state.y;
            var _ref = _this2.props.rtl ? _this2.getRTLMenuPosition(x, y) : _this2.getMenuPosition(x, y),
              top = _ref.top,
              left = _ref.left;
            wrapper(function () {
              if (!_this2.menu) return;
              _this2.menu.style.top = top + 'px';
              _this2.menu.style.left = left + 'px';
              _this2.menu.style.opacity = 1;
              _this2.menu.style.pointerEvents = 'auto';
            });
          });
        } else {
          wrapper(function () {
            if (!_this2.menu) return;
            _this2.menu.style.opacity = 0;
            _this2.menu.style.pointerEvents = 'none';
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.listenId) {
          globalEventListener.unregister(this.listenId);
        }
        this.unregisterHandlers();
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
          children = _props.children,
          className = _props.className,
          style = _props.style;
        var isVisible = this.state.isVisible;
        var inlineStyle = object_assign_default()({}, style, {
          position: 'fixed',
          opacity: 0,
          pointerEvents: 'none'
        });
        var menuClassnames = classnames_default()(cssClasses.menu, className, ContextMenu_defineProperty({}, cssClasses.menuVisible, isVisible));
        return external_react_default.a.createElement('nav', {
          role: 'menu',
          tabIndex: '-1',
          ref: this.menuRef,
          style: inlineStyle,
          className: menuClassnames,
          onContextMenu: this.handleContextMenu,
          onMouseLeave: this.handleMouseLeave
        }, this.renderChildren(children));
      }
    }]);
    return ContextMenu;
  }(es6_AbstractMenu);
  ContextMenu_ContextMenu.propTypes = {
    id: external_prop_types_default.a.string.isRequired,
    children: external_prop_types_default.a.node.isRequired,
    data: external_prop_types_default.a.object,
    className: external_prop_types_default.a.string,
    hideOnLeave: external_prop_types_default.a.bool,
    rtl: external_prop_types_default.a.bool,
    onHide: external_prop_types_default.a.func,
    onMouseLeave: external_prop_types_default.a.func,
    onShow: external_prop_types_default.a.func,
    preventHideOnContextMenu: external_prop_types_default.a.bool,
    preventHideOnResize: external_prop_types_default.a.bool,
    preventHideOnScroll: external_prop_types_default.a.bool,
    style: external_prop_types_default.a.object
  };
  ContextMenu_ContextMenu.defaultProps = {
    className: '',
    data: {},
    hideOnLeave: false,
    rtl: false,
    onHide: function onHide() {
      return null;
    },
    onMouseLeave: function onMouseLeave() {
      return null;
    },
    onShow: function onShow() {
      return null;
    },
    preventHideOnContextMenu: false,
    preventHideOnResize: false,
    preventHideOnScroll: false,
    style: {}
  };
  /* harmony default export */
  var es6_ContextMenu = ContextMenu_ContextMenu;
  // CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/ContextMenuTrigger.js
  var ContextMenuTrigger_createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function ContextMenuTrigger_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function ContextMenuTrigger_possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function ContextMenuTrigger_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var ContextMenuTrigger_ContextMenuTrigger = function (_Component) {
    ContextMenuTrigger_inherits(ContextMenuTrigger, _Component);
    function ContextMenuTrigger() {
      var _ref;
      var _temp, _this, _ret;
      ContextMenuTrigger_classCallCheck(this, ContextMenuTrigger);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = ContextMenuTrigger_possibleConstructorReturn(this, (_ref = ContextMenuTrigger.__proto__ || Object.getPrototypeOf(ContextMenuTrigger)).call.apply(_ref, [this].concat(args))), _this), _this.touchHandled = false, _this.handleMouseDown = function (event) {
        if (_this.props.holdToDisplay >= 0 && event.button === 0) {
          event.persist();
          event.stopPropagation();
          _this.mouseDownTimeoutId = setTimeout(function () {
            return _this.handleContextClick(event);
          }, _this.props.holdToDisplay);
        }
        callIfExists(_this.props.attributes.onMouseDown, event);
      }, _this.handleMouseUp = function (event) {
        if (event.button === 0) {
          clearTimeout(_this.mouseDownTimeoutId);
        }
        callIfExists(_this.props.attributes.onMouseUp, event);
      }, _this.handleMouseOut = function (event) {
        if (event.button === 0) {
          clearTimeout(_this.mouseDownTimeoutId);
        }
        callIfExists(_this.props.attributes.onMouseOut, event);
      }, _this.handleTouchstart = function (event) {
        _this.touchHandled = false;
        if (_this.props.holdToDisplay >= 0) {
          event.persist();
          event.stopPropagation();
          _this.touchstartTimeoutId = setTimeout(function () {
            _this.handleContextClick(event);
            _this.touchHandled = true;
          }, _this.props.holdToDisplay);
        }
        callIfExists(_this.props.attributes.onTouchStart, event);
      }, _this.handleTouchEnd = function (event) {
        if (_this.touchHandled) {
          event.preventDefault();
        }
        clearTimeout(_this.touchstartTimeoutId);
        callIfExists(_this.props.attributes.onTouchEnd, event);
      }, _this.handleContextMenu = function (event) {
        if (event.button === _this.props.mouseButton) {
          _this.handleContextClick(event);
        }
        callIfExists(_this.props.attributes.onContextMenu, event);
      }, _this.handleMouseClick = function (event) {
        if (event.button === _this.props.mouseButton) {
          _this.handleContextClick(event);
        }
        callIfExists(_this.props.attributes.onClick, event);
      }, _this.handleContextClick = function (event) {
        if (_this.props.disable) return;
        if (_this.props.disableIfShiftIsPressed && event.shiftKey) return;
        event.preventDefault();
        event.stopPropagation();
        var x = event.clientX || event.touches && event.touches[0].pageX;
        var y = event.clientY || event.touches && event.touches[0].pageY;
        if (_this.props.posX) {
          x -= _this.props.posX;
        }
        if (_this.props.posY) {
          y -= _this.props.posY;
        }
        hideMenu();
        var data = callIfExists(_this.props.collect, _this.props);
        var showMenuConfig = {
          position: {
            x: x,
            y: y
          },
          target: _this.elem,
          id: _this.props.id
        };
        if (data && typeof data.then === 'function') {
          // it's promise
          data.then(function (resp) {
            showMenuConfig.data = object_assign_default()({}, resp, {
              target: event.target
            });
            showMenu(showMenuConfig);
          });
        } else {
          showMenuConfig.data = object_assign_default()({}, data, {
            target: event.target
          });
          showMenu(showMenuConfig);
        }
      }, _this.elemRef = function (c) {
        _this.elem = c;
      }, _temp), ContextMenuTrigger_possibleConstructorReturn(_this, _ret);
    }
    ContextMenuTrigger_createClass(ContextMenuTrigger, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
          renderTag = _props.renderTag,
          attributes = _props.attributes,
          children = _props.children;
        var newAttrs = object_assign_default()({}, attributes, {
          className: classnames_default()(cssClasses.menuWrapper, attributes.className),
          onContextMenu: this.handleContextMenu,
          onClick: this.handleMouseClick,
          onMouseDown: this.handleMouseDown,
          onMouseUp: this.handleMouseUp,
          onTouchStart: this.handleTouchstart,
          onTouchEnd: this.handleTouchEnd,
          onMouseOut: this.handleMouseOut,
          ref: this.elemRef
        });
        return external_react_default.a.createElement(renderTag, newAttrs, children);
      }
    }]);
    return ContextMenuTrigger;
  }(external_react_["Component"]);
  ContextMenuTrigger_ContextMenuTrigger.propTypes = {
    id: external_prop_types_default.a.string.isRequired,
    children: external_prop_types_default.a.node.isRequired,
    attributes: external_prop_types_default.a.object,
    collect: external_prop_types_default.a.func,
    disable: external_prop_types_default.a.bool,
    holdToDisplay: external_prop_types_default.a.number,
    posX: external_prop_types_default.a.number,
    posY: external_prop_types_default.a.number,
    renderTag: external_prop_types_default.a.elementType,
    mouseButton: external_prop_types_default.a.number,
    disableIfShiftIsPressed: external_prop_types_default.a.bool
  };
  ContextMenuTrigger_ContextMenuTrigger.defaultProps = {
    attributes: {},
    collect: function collect() {
      return null;
    },
    disable: false,
    holdToDisplay: 1000,
    renderTag: 'div',
    posX: 0,
    posY: 0,
    mouseButton: 2,
    // 0 is left click, 2 is right click
    disableIfShiftIsPressed: false
  };
  /* harmony default export */
  var es6_ContextMenuTrigger = ContextMenuTrigger_ContextMenuTrigger;
  // CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/connectMenu.js
  var connectMenu_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var connectMenu_createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function connectMenu_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function connectMenu_possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function connectMenu_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  // collect ContextMenuTrigger's expected props to NOT pass them on as part of the context
  var ignoredTriggerProps = [].concat(_toConsumableArray(Object.keys(es6_ContextMenuTrigger.propTypes)), ['children']);

  // expect the id of the menu to be responsible for as outer parameter
  /* harmony default export */
  var connectMenu = function (menuId) {
    // expect menu component to connect as inner parameter
    // <Child/> is presumably a wrapper of <ContextMenu/>
    return function connect(Child) {
      // return wrapper for <Child/> that forwards the ContextMenuTrigger's additional props
      return function (_Component) {
        connectMenu_inherits(ConnectMenu, _Component);
        function ConnectMenu(props) {
          connectMenu_classCallCheck(this, ConnectMenu);
          var _this = connectMenu_possibleConstructorReturn(this, (ConnectMenu.__proto__ || Object.getPrototypeOf(ConnectMenu)).call(this, props));
          _this.handleShow = function (e) {
            if (e.detail.id !== menuId) return;

            // the onShow event's detail.data object holds all ContextMenuTrigger props
            var data = e.detail.data;
            var filteredData = {};
            for (var key in data) {
              // exclude props the ContextMenuTrigger is expecting itself
              if (!ignoredTriggerProps.includes(key)) {
                filteredData[key] = data[key];
              }
            }
            _this.setState({
              trigger: filteredData
            });
          };
          _this.handleHide = function () {
            _this.setState({
              trigger: null
            });
          };
          _this.state = {
            trigger: null
          };
          return _this;
        }
        connectMenu_createClass(ConnectMenu, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.listenId = globalEventListener.register(this.handleShow, this.handleHide);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.listenId) {
              globalEventListener.unregister(this.listenId);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            return external_react_default.a.createElement(Child, connectMenu_extends({}, this.props, {
              id: menuId,
              trigger: this.state.trigger
            }));
          }
        }]);
        return ConnectMenu;
      }(external_react_["Component"]);
    };
  };
  // CONCATENATED MODULE: ./node_modules/react-contextmenu/es6/index.js

  /***/
}, /* 110 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "BailSignal", function () {
    return BailSignal;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "Controller", function () {
    return Controller;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "FrameValue", function () {
    return FrameValue;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "Interpolation", function () {
    return Interpolation;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "Spring", function () {
    return Spring;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "SpringContext", function () {
    return SpringContext;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "SpringRef", function () {
    return SpringRef;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "SpringValue", function () {
    return SpringValue;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "Trail", function () {
    return Trail;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "Transition", function () {
    return Transition;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "config", function () {
    return config;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "inferTo", function () {
    return inferTo;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "interpolate", function () {
    return interpolate;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "to", function () {
    return to;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "update", function () {
    return update;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "useChain", function () {
    return useChain;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "useInView", function () {
    return useInView;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "useResize", function () {
    return useResize;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "useScroll", function () {
    return useScroll;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "useSpring", function () {
    return useSpring;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "useSpringRef", function () {
    return useSpringRef;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "useSpringValue", function () {
    return useSpringValue;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "useSprings", function () {
    return useSprings;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "useTrail", function () {
    return useTrail;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "useTransition", function () {
    return useTransition;
  });
  /* harmony import */
  var _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
  /* harmony reexport (safe) */
  __webpack_require__.d(__webpack_exports__, "Globals", function () {
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__["b"];
  });

  /* harmony reexport (safe) */
  __webpack_require__.d(__webpack_exports__, "createInterpolator", function () {
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__["f"];
  });

  /* harmony reexport (safe) */
  __webpack_require__.d(__webpack_exports__, "easings", function () {
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__["m"];
  });

  /* harmony reexport (safe) */
  __webpack_require__.d(__webpack_exports__, "useIsomorphicLayoutEffect", function () {
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__["E"];
  });

  /* harmony reexport (safe) */
  __webpack_require__.d(__webpack_exports__, "useReducedMotion", function () {
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__["I"];
  });

  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
  /* harmony import */
  var _react_spring_animated__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26);
  /* harmony import */
  var _react_spring_types_animated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(209);
  /* harmony import */
  var _react_spring_types_animated__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_react_spring_types_animated__WEBPACK_IMPORTED_MODULE_3__);
  /* harmony reexport (unknown) */
  for (var __WEBPACK_IMPORT_KEY__ in _react_spring_types_animated__WEBPACK_IMPORTED_MODULE_3__) if (["default", "Globals", "createInterpolator", "easings", "useIsomorphicLayoutEffect", "useReducedMotion", "BailSignal", "Controller", "FrameValue", "Interpolation", "Spring", "SpringContext", "SpringRef", "SpringValue", "Trail", "Transition", "config", "inferTo", "interpolate", "to", "update", "useChain", "useInView", "useResize", "useScroll", "useSpring", "useSpringRef", "useSpringValue", "useSprings", "useTrail", "useTransition"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function (key) {
    __webpack_require__.d(__webpack_exports__, key, function () {
      return _react_spring_types_animated__WEBPACK_IMPORTED_MODULE_3__[key];
    });
  })(__WEBPACK_IMPORT_KEY__);
  /* harmony import */
  var _react_spring_types_interpolation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(210);
  /* harmony import */
  var _react_spring_types_interpolation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_react_spring_types_interpolation__WEBPACK_IMPORTED_MODULE_4__);
  /* harmony reexport (unknown) */
  for (var __WEBPACK_IMPORT_KEY__ in _react_spring_types_interpolation__WEBPACK_IMPORTED_MODULE_4__) if (["default", "Globals", "createInterpolator", "easings", "useIsomorphicLayoutEffect", "useReducedMotion", "BailSignal", "Controller", "FrameValue", "Interpolation", "Spring", "SpringContext", "SpringRef", "SpringValue", "Trail", "Transition", "config", "inferTo", "interpolate", "to", "update", "useChain", "useInView", "useResize", "useScroll", "useSpring", "useSpringRef", "useSpringValue", "useSprings", "useTrail", "useTransition"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function (key) {
    __webpack_require__.d(__webpack_exports__, key, function () {
      return _react_spring_types_interpolation__WEBPACK_IMPORTED_MODULE_4__[key];
    });
  })(__WEBPACK_IMPORT_KEY__);
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function callProp(value, ...args) {
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(value) ? value(...args) : value;
  }
  const matchProp = (value, key) => value === true || !!(key && value && (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(value) ? value(key) : Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(value).includes(key)));
  const resolveProp = (prop, key) => _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(prop) ? key && prop[key] : prop;
  const getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : undefined;
  const noopTransform = value => value;
  const getDefaultProps = (props, transform = noopTransform) => {
    let keys = DEFAULT_PROPS;
    if (props.default && props.default !== true) {
      props = props.default;
      keys = Object.keys(props);
    }
    const defaults = {};
    for (const key of keys) {
      const value = transform(props[key], key);
      if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(value)) {
        defaults[key] = value;
      }
    }
    return defaults;
  };
  const DEFAULT_PROPS = ['config', 'onProps', 'onStart', 'onChange', 'onPause', 'onResume', 'onRest'];
  const RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    keys: 1,
    callId: 1,
    parentId: 1
  };
  function getForwardProps(props) {
    const forward = {};
    let count = 0;
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* eachProp */"l"])(props, (value, prop) => {
      if (!RESERVED_PROPS[prop]) {
        forward[prop] = value;
        count++;
      }
    });
    if (count) {
      return forward;
    }
  }
  function inferTo(props) {
    const to = getForwardProps(props);
    if (to) {
      const out = {
        to
      };
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* eachProp */"l"])(props, (val, key) => key in to || (out[key] = val));
      return out;
    }
    return _extends({}, props);
  }
  function computeGoal(value) {
    value = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidValue */"r"])(value);
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].arr(value) ? value.map(computeGoal) : Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isAnimatedString */"u"])(value) ? _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* Globals */"b"].createStringInterpolator({
      range: [0, 1],
      output: [value, value]
    })(1) : value;
  }
  function hasProps(props) {
    for (const _ in props) return true;
    return false;
  }
  function isAsyncTo(to) {
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(to) || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].arr(to) && _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(to[0]);
  }
  function detachRefs(ctrl, ref) {
    var _ctrl$ref;
    (_ctrl$ref = ctrl.ref) == null ? void 0 : _ctrl$ref.delete(ctrl);
    ref == null ? void 0 : ref.delete(ctrl);
  }
  function replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
      var _ctrl$ref2;
      (_ctrl$ref2 = ctrl.ref) == null ? void 0 : _ctrl$ref2.delete(ctrl);
      ref.add(ctrl);
      ctrl.ref = ref;
    }
  }
  function useChain(refs, timeSteps, timeFrame = 1000) {
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useIsomorphicLayoutEffect */"E"])(() => {
      if (timeSteps) {
        let prevDelay = 0;
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(refs, (ref, i) => {
          const controllers = ref.current;
          if (controllers.length) {
            let delay = timeFrame * timeSteps[i];
            if (isNaN(delay)) delay = prevDelay;else prevDelay = delay;
            Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(controllers, ctrl => {
              Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(ctrl.queue, props => {
                const memoizedDelayProp = props.delay;
                props.delay = key => delay + callProp(memoizedDelayProp || 0, key);
              });
            });
            ref.start();
          }
        });
      } else {
        let p = Promise.resolve();
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(refs, ref => {
          const controllers = ref.current;
          if (controllers.length) {
            const queues = controllers.map(ctrl => {
              const q = ctrl.queue;
              ctrl.queue = [];
              return q;
            });
            p = p.then(() => {
              Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(controllers, (ctrl, i) => Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(queues[i] || [], update => ctrl.queue.push(update)));
              return Promise.all(ref.start());
            });
          }
        });
      }
    });
  }
  const config = {
    default: {
      tension: 170,
      friction: 26
    },
    gentle: {
      tension: 120,
      friction: 14
    },
    wobbly: {
      tension: 180,
      friction: 12
    },
    stiff: {
      tension: 210,
      friction: 20
    },
    slow: {
      tension: 280,
      friction: 60
    },
    molasses: {
      tension: 280,
      friction: 120
    }
  };
  const defaults = _extends({}, config.default, {
    mass: 1,
    damping: 1,
    easing: _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* easings */"m"].linear,
    clamp: false
  });
  class AnimationConfig {
    constructor() {
      this.tension = void 0;
      this.friction = void 0;
      this.frequency = void 0;
      this.damping = void 0;
      this.mass = void 0;
      this.velocity = 0;
      this.restVelocity = void 0;
      this.precision = void 0;
      this.progress = void 0;
      this.duration = void 0;
      this.easing = void 0;
      this.clamp = void 0;
      this.bounce = void 0;
      this.decay = void 0;
      this.round = void 0;
      Object.assign(this, defaults);
    }
  }
  function mergeConfig(config, newConfig, defaultConfig) {
    if (defaultConfig) {
      defaultConfig = _extends({}, defaultConfig);
      sanitizeConfig(defaultConfig, newConfig);
      newConfig = _extends({}, defaultConfig, newConfig);
    }
    sanitizeConfig(config, newConfig);
    Object.assign(config, newConfig);
    for (const key in defaults) {
      if (config[key] == null) {
        config[key] = defaults[key];
      }
    }
    let {
      mass,
      frequency,
      damping
    } = config;
    if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(frequency)) {
      if (frequency < 0.01) frequency = 0.01;
      if (damping < 0) damping = 0;
      config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
      config.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config;
  }
  function sanitizeConfig(config, props) {
    if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props.decay)) {
      config.duration = undefined;
    } else {
      const isTensionConfig = !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props.tension) || !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props.friction);
      if (isTensionConfig || !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props.frequency) || !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props.damping) || !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props.mass)) {
        config.duration = undefined;
        config.decay = undefined;
      }
      if (isTensionConfig) {
        config.frequency = undefined;
      }
    }
  }
  const emptyArray = [];
  class Animation {
    constructor() {
      this.changed = false;
      this.values = emptyArray;
      this.toValues = null;
      this.fromValues = emptyArray;
      this.to = void 0;
      this.from = void 0;
      this.config = new AnimationConfig();
      this.immediate = false;
    }
  }
  function scheduleProps(callId, {
    key,
    props,
    defaultProps,
    state,
    actions
  }) {
    return new Promise((resolve, reject) => {
      var _props$cancel;
      let delay;
      let timeout;
      let cancel = matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);
      if (cancel) {
        onStart();
      } else {
        if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props.pause)) {
          state.paused = matchProp(props.pause, key);
        }
        let pause = defaultProps == null ? void 0 : defaultProps.pause;
        if (pause !== true) {
          pause = state.paused || matchProp(pause, key);
        }
        delay = callProp(props.delay || 0, key);
        if (pause) {
          state.resumeQueue.add(onResume);
          actions.pause();
        } else {
          actions.resume();
          onResume();
        }
      }
      function onPause() {
        state.resumeQueue.add(onResume);
        state.timeouts.delete(timeout);
        timeout.cancel();
        delay = timeout.time - _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].now();
      }
      function onResume() {
        if (delay > 0 && !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* Globals */"b"].skipAnimation) {
          state.delayed = true;
          timeout = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].setTimeout(onStart, delay);
          state.pauseQueue.add(onPause);
          state.timeouts.add(timeout);
        } else {
          onStart();
        }
      }
      function onStart() {
        if (state.delayed) {
          state.delayed = false;
        }
        state.pauseQueue.delete(onPause);
        state.timeouts.delete(timeout);
        if (callId <= (state.cancelId || 0)) {
          cancel = true;
        }
        try {
          actions.start(_extends({}, props, {
            callId,
            cancel
          }), resolve);
        } catch (err) {
          reject(err);
        }
      }
    });
  }
  const getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some(result => result.cancelled) ? getCancelledResult(target.get()) : results.every(result => result.noop) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every(result => result.finished));
  const getNoopResult = value => ({
    value,
    noop: true,
    finished: true,
    cancelled: false
  });
  const getFinishedResult = (value, finished, cancelled = false) => ({
    value,
    finished,
    cancelled
  });
  const getCancelledResult = value => ({
    value,
    cancelled: true,
    finished: false
  });
  function runAsync(to, props, state, target) {
    const {
      callId,
      parentId,
      onRest
    } = props;
    const {
      asyncTo: prevTo,
      promise: prevPromise
    } = state;
    if (!parentId && to === prevTo && !props.reset) {
      return prevPromise;
    }
    return state.promise = (async () => {
      state.asyncId = callId;
      state.asyncTo = to;
      const defaultProps = getDefaultProps(props, (value, key) => key === 'onRest' ? undefined : value);
      let preventBail;
      let bail;
      const bailPromise = new Promise((resolve, reject) => (preventBail = resolve, bail = reject));
      const bailIfEnded = bailSignal => {
        const bailResult = callId <= (state.cancelId || 0) && getCancelledResult(target) || callId !== state.asyncId && getFinishedResult(target, false);
        if (bailResult) {
          bailSignal.result = bailResult;
          bail(bailSignal);
          throw bailSignal;
        }
      };
      const animate = (arg1, arg2) => {
        const bailSignal = new BailSignal();
        const skipAnimationSignal = new SkipAnimationSignal();
        return (async () => {
          if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* Globals */"b"].skipAnimation) {
            stopAsync(state);
            skipAnimationSignal.result = getFinishedResult(target, false);
            bail(skipAnimationSignal);
            throw skipAnimationSignal;
          }
          bailIfEnded(bailSignal);
          const props = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(arg1) ? _extends({}, arg1) : _extends({}, arg2, {
            to: arg1
          });
          props.parentId = callId;
          Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* eachProp */"l"])(defaultProps, (value, key) => {
            if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props[key])) {
              props[key] = value;
            }
          });
          const result = await target.start(props);
          bailIfEnded(bailSignal);
          if (state.paused) {
            await new Promise(resume => {
              state.resumeQueue.add(resume);
            });
          }
          return result;
        })();
      };
      let result;
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* Globals */"b"].skipAnimation) {
        stopAsync(state);
        return getFinishedResult(target, false);
      }
      try {
        let animating;
        if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].arr(to)) {
          animating = (async queue => {
            for (const props of queue) {
              await animate(props);
            }
          })(to);
        } else {
          animating = Promise.resolve(to(animate, target.stop.bind(target)));
        }
        await Promise.all([animating.then(preventBail), bailPromise]);
        result = getFinishedResult(target.get(), true, false);
      } catch (err) {
        if (err instanceof BailSignal) {
          result = err.result;
        } else if (err instanceof SkipAnimationSignal) {
          result = err.result;
        } else {
          throw err;
        }
      } finally {
        if (callId == state.asyncId) {
          state.asyncId = parentId;
          state.asyncTo = parentId ? prevTo : undefined;
          state.promise = parentId ? prevPromise : undefined;
        }
      }
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(onRest)) {
        _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].batchedUpdates(() => {
          onRest(result, target, target.item);
        });
      }
      return result;
    })();
  }
  function stopAsync(state, cancelId) {
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* flush */"n"])(state.timeouts, t => t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = undefined;
    if (cancelId) state.cancelId = cancelId;
  }
  class BailSignal extends Error {
    constructor() {
      super('An async animation has been interrupted. You see this error because you ' + 'forgot to use `await` or `.catch(...)` on its returned promise.');
      this.result = void 0;
    }
  }
  class SkipAnimationSignal extends Error {
    constructor() {
      super('SkipAnimationSignal');
      this.result = void 0;
    }
  }
  const isFrameValue = value => value instanceof FrameValue;
  let nextId$1 = 1;
  class FrameValue extends _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* FluidValue */"a"] {
    constructor(...args) {
      super(...args);
      this.id = nextId$1++;
      this.key = void 0;
      this._priority = 0;
    }
    get priority() {
      return this._priority;
    }
    set priority(priority) {
      if (this._priority != priority) {
        this._priority = priority;
        this._onPriorityChange(priority);
      }
    }
    get() {
      const node = Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimated */"e"])(this);
      return node && node.getValue();
    }
    to(...args) {
      return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* Globals */"b"].to(this, args);
    }
    interpolate(...args) {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* deprecateInterpolate */"j"])();
      return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* Globals */"b"].to(this, args);
    }
    toJSON() {
      return this.get();
    }
    observerAdded(count) {
      if (count == 1) this._attach();
    }
    observerRemoved(count) {
      if (count == 0) this._detach();
    }
    _attach() {}
    _detach() {}
    _onChange(value, idle = false) {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* callFluidObservers */"d"])(this, {
        type: 'change',
        parent: this,
        value,
        idle
      });
    }
    _onPriorityChange(priority) {
      if (!this.idle) {
        _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* frameLoop */"p"].sort(this);
      }
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* callFluidObservers */"d"])(this, {
        type: 'priority',
        parent: this,
        priority
      });
    }
  }
  const $P = Symbol.for('SpringPhase');
  const HAS_ANIMATED = 1;
  const IS_ANIMATING = 2;
  const IS_PAUSED = 4;
  const hasAnimated = target => (target[$P] & HAS_ANIMATED) > 0;
  const isAnimating = target => (target[$P] & IS_ANIMATING) > 0;
  const isPaused = target => (target[$P] & IS_PAUSED) > 0;
  const setActiveBit = (target, active) => active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
  const setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;
  class SpringValue extends FrameValue {
    constructor(arg1, arg2) {
      super();
      this.key = void 0;
      this.animation = new Animation();
      this.queue = void 0;
      this.defaultProps = {};
      this._state = {
        paused: false,
        delayed: false,
        pauseQueue: new Set(),
        resumeQueue: new Set(),
        timeouts: new Set()
      };
      this._pendingCalls = new Set();
      this._lastCallId = 0;
      this._lastToId = 0;
      this._memoizedDuration = 0;
      if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(arg1) || !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(arg2)) {
        const props = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(arg1) ? _extends({}, arg1) : _extends({}, arg2, {
          from: arg1
        });
        if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props.default)) {
          props.default = true;
        }
        this.start(props);
      }
    }
    get idle() {
      return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
    }
    get goal() {
      return Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidValue */"r"])(this.animation.to);
    }
    get velocity() {
      const node = Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimated */"e"])(this);
      return node instanceof _react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* AnimatedValue */"c"] ? node.lastVelocity || 0 : node.getPayload().map(node => node.lastVelocity || 0);
    }
    get hasAnimated() {
      return hasAnimated(this);
    }
    get isAnimating() {
      return isAnimating(this);
    }
    get isPaused() {
      return isPaused(this);
    }
    get isDelayed() {
      return this._state.delayed;
    }
    advance(dt) {
      let idle = true;
      let changed = false;
      const anim = this.animation;
      let {
        config,
        toValues
      } = anim;
      const payload = Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getPayload */"g"])(anim.to);
      if (!payload && Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* hasFluidValue */"s"])(anim.to)) {
        toValues = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidValue */"r"])(anim.to));
      }
      anim.values.forEach((node, i) => {
        if (node.done) return;
        const to = node.constructor == _react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* AnimatedString */"b"] ? 1 : payload ? payload[i].lastPosition : toValues[i];
        let finished = anim.immediate;
        let position = to;
        if (!finished) {
          position = node.lastPosition;
          if (config.tension <= 0) {
            node.done = true;
            return;
          }
          let elapsed = node.elapsedTime += dt;
          const from = anim.fromValues[i];
          const v0 = node.v0 != null ? node.v0 : node.v0 = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].arr(config.velocity) ? config.velocity[i] : config.velocity;
          let velocity;
          const precision = config.precision || (from == to ? 0.005 : Math.min(1, Math.abs(to - from) * 0.001));
          if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(config.duration)) {
            let p = 1;
            if (config.duration > 0) {
              if (this._memoizedDuration !== config.duration) {
                this._memoizedDuration = config.duration;
                if (node.durationProgress > 0) {
                  node.elapsedTime = config.duration * node.durationProgress;
                  elapsed = node.elapsedTime += dt;
                }
              }
              p = (config.progress || 0) + elapsed / this._memoizedDuration;
              p = p > 1 ? 1 : p < 0 ? 0 : p;
              node.durationProgress = p;
            }
            position = from + config.easing(p) * (to - from);
            velocity = (position - node.lastPosition) / dt;
            finished = p == 1;
          } else if (config.decay) {
            const decay = config.decay === true ? 0.998 : config.decay;
            const e = Math.exp(-(1 - decay) * elapsed);
            position = from + v0 / (1 - decay) * (1 - e);
            finished = Math.abs(node.lastPosition - position) <= precision;
            velocity = v0 * e;
          } else {
            velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
            const restVelocity = config.restVelocity || precision / 10;
            const bounceFactor = config.clamp ? 0 : config.bounce;
            const canBounce = !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(bounceFactor);
            const isGrowing = from == to ? node.v0 > 0 : from < to;
            let isMoving;
            let isBouncing = false;
            const step = 1;
            const numSteps = Math.ceil(dt / step);
            for (let n = 0; n < numSteps; ++n) {
              isMoving = Math.abs(velocity) > restVelocity;
              if (!isMoving) {
                finished = Math.abs(to - position) <= precision;
                if (finished) {
                  break;
                }
              }
              if (canBounce) {
                isBouncing = position == to || position > to == isGrowing;
                if (isBouncing) {
                  velocity = -velocity * bounceFactor;
                  position = to;
                }
              }
              const springForce = -config.tension * 0.000001 * (position - to);
              const dampingForce = -config.friction * 0.001 * velocity;
              const acceleration = (springForce + dampingForce) / config.mass;
              velocity = velocity + acceleration * step;
              position = position + velocity * step;
            }
          }
          node.lastVelocity = velocity;
          if (Number.isNaN(position)) {
            console.warn(`Got NaN while animating:`, this);
            finished = true;
          }
        }
        if (payload && !payload[i].done) {
          finished = false;
        }
        if (finished) {
          node.done = true;
        } else {
          idle = false;
        }
        if (node.setValue(position, config.round)) {
          changed = true;
        }
      });
      const node = Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimated */"e"])(this);
      const currVal = node.getValue();
      if (idle) {
        const finalVal = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidValue */"r"])(anim.to);
        if ((currVal !== finalVal || changed) && !config.decay) {
          node.setValue(finalVal);
          this._onChange(finalVal);
        } else if (changed && config.decay) {
          this._onChange(currVal);
        }
        this._stop();
      } else if (changed) {
        this._onChange(currVal);
      }
    }
    set(value) {
      _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].batchedUpdates(() => {
        this._stop();
        this._focus(value);
        this._set(value);
      });
      return this;
    }
    pause() {
      this._update({
        pause: true
      });
    }
    resume() {
      this._update({
        pause: false
      });
    }
    finish() {
      if (isAnimating(this)) {
        const {
          to,
          config
        } = this.animation;
        _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].batchedUpdates(() => {
          this._onStart();
          if (!config.decay) {
            this._set(to, false);
          }
          this._stop();
        });
      }
      return this;
    }
    update(props) {
      const queue = this.queue || (this.queue = []);
      queue.push(props);
      return this;
    }
    start(to, arg2) {
      let queue;
      if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(to)) {
        queue = [_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(to) ? to : _extends({}, arg2, {
          to
        })];
      } else {
        queue = this.queue || [];
        this.queue = [];
      }
      return Promise.all(queue.map(props => {
        const up = this._update(props);
        return up;
      })).then(results => getCombinedResult(this, results));
    }
    stop(cancel) {
      const {
        to
      } = this.animation;
      this._focus(this.get());
      stopAsync(this._state, cancel && this._lastCallId);
      _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].batchedUpdates(() => this._stop(to, cancel));
      return this;
    }
    reset() {
      this._update({
        reset: true
      });
    }
    eventObserved(event) {
      if (event.type == 'change') {
        this._start();
      } else if (event.type == 'priority') {
        this.priority = event.priority + 1;
      }
    }
    _prepareNode(props) {
      const key = this.key || '';
      let {
        to,
        from
      } = props;
      to = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(to) ? to[key] : to;
      if (to == null || isAsyncTo(to)) {
        to = undefined;
      }
      from = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(from) ? from[key] : from;
      if (from == null) {
        from = undefined;
      }
      const range = {
        to,
        from
      };
      if (!hasAnimated(this)) {
        if (props.reverse) [to, from] = [from, to];
        from = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidValue */"r"])(from);
        if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(from)) {
          this._set(from);
        } else if (!Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimated */"e"])(this)) {
          this._set(to);
        }
      }
      return range;
    }
    _update(_ref, isLoop) {
      let props = _extends({}, _ref);
      const {
        key,
        defaultProps
      } = this;
      if (props.default) Object.assign(defaultProps, getDefaultProps(props, (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value));
      mergeActiveFn(this, props, 'onProps');
      sendEvent(this, 'onProps', props, this);
      const range = this._prepareNode(props);
      if (Object.isFrozen(this)) {
        throw Error('Cannot animate a `SpringValue` object that is frozen. ' + 'Did you forget to pass your component to `animated(...)` before animating its props?');
      }
      const state = this._state;
      return scheduleProps(++this._lastCallId, {
        key,
        props,
        defaultProps,
        state,
        actions: {
          pause: () => {
            if (!isPaused(this)) {
              setPausedBit(this, true);
              Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* flushCalls */"o"])(state.pauseQueue);
              sendEvent(this, 'onPause', getFinishedResult(this, checkFinished(this, this.animation.to)), this);
            }
          },
          resume: () => {
            if (isPaused(this)) {
              setPausedBit(this, false);
              if (isAnimating(this)) {
                this._resume();
              }
              Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* flushCalls */"o"])(state.resumeQueue);
              sendEvent(this, 'onResume', getFinishedResult(this, checkFinished(this, this.animation.to)), this);
            }
          },
          start: this._merge.bind(this, range)
        }
      }).then(result => {
        if (props.loop && result.finished && !(isLoop && result.noop)) {
          const nextProps = createLoopUpdate(props);
          if (nextProps) {
            return this._update(nextProps, true);
          }
        }
        return result;
      });
    }
    _merge(range, props, resolve) {
      if (props.cancel) {
        this.stop(true);
        return resolve(getCancelledResult(this));
      }
      const hasToProp = !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(range.to);
      const hasFromProp = !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(range.from);
      if (hasToProp || hasFromProp) {
        if (props.callId > this._lastToId) {
          this._lastToId = props.callId;
        } else {
          return resolve(getCancelledResult(this));
        }
      }
      const {
        key,
        defaultProps,
        animation: anim
      } = this;
      const {
        to: prevTo,
        from: prevFrom
      } = anim;
      let {
        to = prevTo,
        from = prevFrom
      } = range;
      if (hasFromProp && !hasToProp && (!props.default || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(to))) {
        to = from;
      }
      if (props.reverse) [to, from] = [from, to];
      const hasFromChanged = !Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isEqual */"v"])(from, prevFrom);
      if (hasFromChanged) {
        anim.from = from;
      }
      from = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidValue */"r"])(from);
      const hasToChanged = !Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isEqual */"v"])(to, prevTo);
      if (hasToChanged) {
        this._focus(to);
      }
      const hasAsyncTo = isAsyncTo(props.to);
      const {
        config
      } = anim;
      const {
        decay,
        velocity
      } = config;
      if (hasToProp || hasFromProp) {
        config.velocity = 0;
      }
      if (props.config && !hasAsyncTo) {
        mergeConfig(config, callProp(props.config, key), props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
      }
      let node = Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimated */"e"])(this);
      if (!node || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(to)) {
        return resolve(getFinishedResult(this, true));
      }
      const reset = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props.reset) ? hasFromProp && !props.default : !_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(from) && matchProp(props.reset, key);
      const value = reset ? from : this.get();
      const goal = computeGoal(to);
      const isAnimatable = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].num(goal) || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].arr(goal) || Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isAnimatedString */"u"])(goal);
      const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));
      if (hasToChanged) {
        const nodeType = Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimatedType */"f"])(to);
        if (nodeType !== node.constructor) {
          if (immediate) {
            node = this._set(goal);
          } else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
        }
      }
      const goalType = node.constructor;
      let started = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* hasFluidValue */"s"])(to);
      let finished = false;
      if (!started) {
        const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;
        if (hasToChanged || hasValueChanged) {
          finished = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isEqual */"v"])(computeGoal(value), goal);
          started = !finished;
        }
        if (!Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isEqual */"v"])(anim.immediate, immediate) && !immediate || !Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isEqual */"v"])(config.decay, decay) || !Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isEqual */"v"])(config.velocity, velocity)) {
          started = true;
        }
      }
      if (finished && isAnimating(this)) {
        if (anim.changed && !reset) {
          started = true;
        } else if (!started) {
          this._stop(prevTo);
        }
      }
      if (!hasAsyncTo) {
        if (started || Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* hasFluidValue */"s"])(prevTo)) {
          anim.values = node.getPayload();
          anim.toValues = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* hasFluidValue */"s"])(to) ? null : goalType == _react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* AnimatedString */"b"] ? [1] : Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(goal);
        }
        if (anim.immediate != immediate) {
          anim.immediate = immediate;
          if (!immediate && !reset) {
            this._set(prevTo);
          }
        }
        if (started) {
          const {
            onRest
          } = anim;
          Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(ACTIVE_EVENTS, type => mergeActiveFn(this, props, type));
          const result = getFinishedResult(this, checkFinished(this, prevTo));
          Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* flushCalls */"o"])(this._pendingCalls, result);
          this._pendingCalls.add(resolve);
          if (anim.changed) _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].batchedUpdates(() => {
            anim.changed = !reset;
            onRest == null ? void 0 : onRest(result, this);
            if (reset) {
              callProp(defaultProps.onRest, result);
            } else {
              anim.onStart == null ? void 0 : anim.onStart(result, this);
            }
          });
        }
      }
      if (reset) {
        this._set(value);
      }
      if (hasAsyncTo) {
        resolve(runAsync(props.to, props, this._state, this));
      } else if (started) {
        this._start();
      } else if (isAnimating(this) && !hasToChanged) {
        this._pendingCalls.add(resolve);
      } else {
        resolve(getNoopResult(value));
      }
    }
    _focus(value) {
      const anim = this.animation;
      if (value !== anim.to) {
        if (Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidObservers */"q"])(this)) {
          this._detach();
        }
        anim.to = value;
        if (Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidObservers */"q"])(this)) {
          this._attach();
        }
      }
    }
    _attach() {
      let priority = 0;
      const {
        to
      } = this.animation;
      if (Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* hasFluidValue */"s"])(to)) {
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* addFluidObserver */"c"])(to, this);
        if (isFrameValue(to)) {
          priority = to.priority + 1;
        }
      }
      this.priority = priority;
    }
    _detach() {
      const {
        to
      } = this.animation;
      if (Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* hasFluidValue */"s"])(to)) {
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* removeFluidObserver */"A"])(to, this);
      }
    }
    _set(arg, idle = true) {
      const value = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidValue */"r"])(arg);
      if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(value)) {
        const oldNode = Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimated */"e"])(this);
        if (!oldNode || !Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isEqual */"v"])(value, oldNode.getValue())) {
          const nodeType = Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimatedType */"f"])(value);
          if (!oldNode || oldNode.constructor != nodeType) {
            Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* setAnimated */"h"])(this, nodeType.create(value));
          } else {
            oldNode.setValue(value);
          }
          if (oldNode) {
            _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].batchedUpdates(() => {
              this._onChange(value, idle);
            });
          }
        }
      }
      return Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimated */"e"])(this);
    }
    _onStart() {
      const anim = this.animation;
      if (!anim.changed) {
        anim.changed = true;
        sendEvent(this, 'onStart', getFinishedResult(this, checkFinished(this, anim.to)), this);
      }
    }
    _onChange(value, idle) {
      if (!idle) {
        this._onStart();
        callProp(this.animation.onChange, value, this);
      }
      callProp(this.defaultProps.onChange, value, this);
      super._onChange(value, idle);
    }
    _start() {
      const anim = this.animation;
      Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimated */"e"])(this).reset(Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidValue */"r"])(anim.to));
      if (!anim.immediate) {
        anim.fromValues = anim.values.map(node => node.lastPosition);
      }
      if (!isAnimating(this)) {
        setActiveBit(this, true);
        if (!isPaused(this)) {
          this._resume();
        }
      }
    }
    _resume() {
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* Globals */"b"].skipAnimation) {
        this.finish();
      } else {
        _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* frameLoop */"p"].start(this);
      }
    }
    _stop(goal, cancel) {
      if (isAnimating(this)) {
        setActiveBit(this, false);
        const anim = this.animation;
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(anim.values, node => {
          node.done = true;
        });
        if (anim.toValues) {
          anim.onChange = anim.onPause = anim.onResume = undefined;
        }
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* callFluidObservers */"d"])(this, {
          type: 'idle',
          parent: this
        });
        const result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal != null ? goal : anim.to));
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* flushCalls */"o"])(this._pendingCalls, result);
        if (anim.changed) {
          anim.changed = false;
          sendEvent(this, 'onRest', result, this);
        }
      }
    }
  }
  function checkFinished(target, to) {
    const goal = computeGoal(to);
    const value = computeGoal(target.get());
    return Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isEqual */"v"])(value, goal);
  }
  function createLoopUpdate(props, loop = props.loop, to = props.to) {
    let loopRet = callProp(loop);
    if (loopRet) {
      const overrides = loopRet !== true && inferTo(loopRet);
      const reverse = (overrides || props).reverse;
      const reset = !overrides || overrides.reset;
      return createUpdate(_extends({}, props, {
        loop,
        default: false,
        pause: undefined,
        to: !reverse || isAsyncTo(to) ? to : undefined,
        from: reset ? props.from : undefined,
        reset
      }, overrides));
    }
  }
  function createUpdate(props) {
    const {
      to,
      from
    } = props = inferTo(props);
    const keys = new Set();
    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(to)) findDefined(to, keys);
    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(from)) findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
  }
  function declareUpdate(props) {
    const update = createUpdate(props);
    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(update.default)) {
      update.default = getDefaultProps(update);
    }
    return update;
  }
  function findDefined(values, keys) {
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* eachProp */"l"])(values, (value, key) => value != null && keys.add(key));
  }
  const ACTIVE_EVENTS = ['onStart', 'onRest', 'onChange', 'onPause', 'onResume'];
  function mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : undefined;
  }
  function sendEvent(target, type, ...args) {
    var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;
    (_target$animation$typ = (_target$animation = target.animation)[type]) == null ? void 0 : _target$animation$typ.call(_target$animation, ...args);
    (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) == null ? void 0 : _target$defaultProps$.call(_target$defaultProps, ...args);
  }
  const BATCHED_EVENTS = ['onStart', 'onChange', 'onRest'];
  let nextId = 1;
  class Controller {
    constructor(props, flush) {
      this.id = nextId++;
      this.springs = {};
      this.queue = [];
      this.ref = void 0;
      this._flush = void 0;
      this._initialProps = void 0;
      this._lastAsyncId = 0;
      this._active = new Set();
      this._changed = new Set();
      this._started = false;
      this._item = void 0;
      this._state = {
        paused: false,
        pauseQueue: new Set(),
        resumeQueue: new Set(),
        timeouts: new Set()
      };
      this._events = {
        onStart: new Map(),
        onChange: new Map(),
        onRest: new Map()
      };
      this._onFrame = this._onFrame.bind(this);
      if (flush) {
        this._flush = flush;
      }
      if (props) {
        this.start(_extends({
          default: true
        }, props));
      }
    }
    get idle() {
      return !this._state.asyncTo && Object.values(this.springs).every(spring => {
        return spring.idle && !spring.isDelayed && !spring.isPaused;
      });
    }
    get item() {
      return this._item;
    }
    set item(item) {
      this._item = item;
    }
    get() {
      const values = {};
      this.each((spring, key) => values[key] = spring.get());
      return values;
    }
    set(values) {
      for (const key in values) {
        const value = values[key];
        if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(value)) {
          this.springs[key].set(value);
        }
      }
    }
    update(props) {
      if (props) {
        this.queue.push(createUpdate(props));
      }
      return this;
    }
    start(props) {
      let {
        queue
      } = this;
      if (props) {
        queue = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(props).map(createUpdate);
      } else {
        this.queue = [];
      }
      if (this._flush) {
        return this._flush(this, queue);
      }
      prepareKeys(this, queue);
      return flushUpdateQueue(this, queue);
    }
    stop(arg, keys) {
      if (arg !== !!arg) {
        keys = arg;
      }
      if (keys) {
        const springs = this.springs;
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(keys), key => springs[key].stop(!!arg));
      } else {
        stopAsync(this._state, this._lastAsyncId);
        this.each(spring => spring.stop(!!arg));
      }
      return this;
    }
    pause(keys) {
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(keys)) {
        this.start({
          pause: true
        });
      } else {
        const springs = this.springs;
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(keys), key => springs[key].pause());
      }
      return this;
    }
    resume(keys) {
      if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(keys)) {
        this.start({
          pause: false
        });
      } else {
        const springs = this.springs;
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(keys), key => springs[key].resume());
      }
      return this;
    }
    each(iterator) {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* eachProp */"l"])(this.springs, iterator);
    }
    _onFrame() {
      const {
        onStart,
        onChange,
        onRest
      } = this._events;
      const active = this._active.size > 0;
      const changed = this._changed.size > 0;
      if (active && !this._started || changed && !this._started) {
        this._started = true;
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* flush */"n"])(onStart, ([onStart, result]) => {
          result.value = this.get();
          onStart(result, this, this._item);
        });
      }
      const idle = !active && this._started;
      const values = changed || idle && onRest.size ? this.get() : null;
      if (changed && onChange.size) {
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* flush */"n"])(onChange, ([onChange, result]) => {
          result.value = values;
          onChange(result, this, this._item);
        });
      }
      if (idle) {
        this._started = false;
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* flush */"n"])(onRest, ([onRest, result]) => {
          result.value = values;
          onRest(result, this, this._item);
        });
      }
    }
    eventObserved(event) {
      if (event.type == 'change') {
        this._changed.add(event.parent);
        if (!event.idle) {
          this._active.add(event.parent);
        }
      } else if (event.type == 'idle') {
        this._active.delete(event.parent);
      } else return;
      _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].onFrame(this._onFrame);
    }
  }
  function flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map(props => flushUpdate(ctrl, props))).then(results => getCombinedResult(ctrl, results));
  }
  async function flushUpdate(ctrl, props, isLoop) {
    const {
      keys,
      to,
      from,
      loop,
      onRest,
      onResolve
    } = props;
    const defaults = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(props.default) && props.default;
    if (loop) {
      props.loop = false;
    }
    if (to === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].arr(to) || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(to) ? to : undefined;
    if (asyncTo) {
      props.to = undefined;
      props.onRest = undefined;
      if (defaults) {
        defaults.onRest = undefined;
      }
    } else {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(BATCHED_EVENTS, key => {
        const handler = props[key];
        if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(handler)) {
          const queue = ctrl['_events'][key];
          props[key] = ({
            finished,
            cancelled
          }) => {
            const result = queue.get(handler);
            if (result) {
              if (!finished) result.finished = false;
              if (cancelled) result.cancelled = true;
            } else {
              queue.set(handler, {
                value: null,
                finished: finished || false,
                cancelled: cancelled || false
              });
            }
          };
          if (defaults) {
            defaults[key] = props[key];
          }
        }
      });
    }
    const state = ctrl['_state'];
    if (props.pause === !state.paused) {
      state.paused = props.pause;
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* flushCalls */"o"])(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) {
      props.pause = true;
    }
    const promises = (keys || Object.keys(ctrl.springs)).map(key => ctrl.springs[key].start(props));
    const cancel = props.cancel === true || getDefaultProp(props, 'cancel') === true;
    if (asyncTo || cancel && state.asyncId) {
      promises.push(scheduleProps(++ctrl['_lastAsyncId'], {
        props,
        state,
        actions: {
          pause: _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* noop */"w"],
          resume: _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* noop */"w"],
          start(props, resolve) {
            if (cancel) {
              stopAsync(state, ctrl['_lastAsyncId']);
              resolve(getCancelledResult(ctrl));
            } else {
              props.onRest = onRest;
              resolve(runAsync(asyncTo, props, state, ctrl));
            }
          }
        }
      }));
    }
    if (state.paused) {
      await new Promise(resume => {
        state.resumeQueue.add(resume);
      });
    }
    const result = getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
      const nextProps = createLoopUpdate(props, loop, to);
      if (nextProps) {
        prepareKeys(ctrl, [nextProps]);
        return flushUpdate(ctrl, nextProps, true);
      }
    }
    if (onResolve) {
      _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
    }
    return result;
  }
  function getSprings(ctrl, props) {
    const springs = _extends({}, ctrl.springs);
    if (props) {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(props), props => {
        if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props.keys)) {
          props = createUpdate(props);
        }
        if (!_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(props.to)) {
          props = _extends({}, props, {
            to: undefined
          });
        }
        prepareSprings(springs, props, key => {
          return createSpring(key);
        });
      });
    }
    setSprings(ctrl, springs);
    return springs;
  }
  function setSprings(ctrl, springs) {
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* eachProp */"l"])(springs, (spring, key) => {
      if (!ctrl.springs[key]) {
        ctrl.springs[key] = spring;
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* addFluidObserver */"c"])(spring, ctrl);
      }
    });
  }
  function createSpring(key, observer) {
    const spring = new SpringValue();
    spring.key = key;
    if (observer) {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* addFluidObserver */"c"])(spring, observer);
    }
    return spring;
  }
  function prepareSprings(springs, props, create) {
    if (props.keys) {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(props.keys, key => {
        const spring = springs[key] || (springs[key] = create(key));
        spring['_prepareNode'](props);
      });
    }
  }
  function prepareKeys(ctrl, queue) {
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(queue, props => {
      prepareSprings(ctrl.springs, props, key => {
        return createSpring(key, ctrl);
      });
    });
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  const _excluded$6 = ["children"];
  const SpringContext = _ref => {
    let {
        children
      } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$6);
    const inherited = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(ctx);
    const pause = props.pause || !!inherited.pause,
      immediate = props.immediate || !!inherited.immediate;
    props = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useMemoOne */"F"])(() => ({
      pause,
      immediate
    }), [pause, immediate]);
    const {
      Provider
    } = ctx;
    return react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Provider, {
      value: props
    }, children);
  };
  const ctx = makeContext(SpringContext, {});
  SpringContext.Provider = ctx.Provider;
  SpringContext.Consumer = ctx.Consumer;
  function makeContext(target, init) {
    Object.assign(target, react__WEBPACK_IMPORTED_MODULE_1__["createContext"](init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
  }
  const SpringRef = () => {
    const current = [];
    const SpringRef = function SpringRef(props) {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* deprecateDirectCall */"i"])();
      const results = [];
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(current, (ctrl, i) => {
        if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props)) {
          results.push(ctrl.start());
        } else {
          const update = _getProps(props, ctrl, i);
          if (update) {
            results.push(ctrl.start(update));
          }
        }
      });
      return results;
    };
    SpringRef.current = current;
    SpringRef.add = function (ctrl) {
      if (!current.includes(ctrl)) {
        current.push(ctrl);
      }
    };
    SpringRef.delete = function (ctrl) {
      const i = current.indexOf(ctrl);
      if (~i) current.splice(i, 1);
    };
    SpringRef.pause = function () {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(current, ctrl => ctrl.pause(...arguments));
      return this;
    };
    SpringRef.resume = function () {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(current, ctrl => ctrl.resume(...arguments));
      return this;
    };
    SpringRef.set = function (values) {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(current, ctrl => ctrl.set(values));
    };
    SpringRef.start = function (props) {
      const results = [];
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(current, (ctrl, i) => {
        if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(props)) {
          results.push(ctrl.start());
        } else {
          const update = this._getProps(props, ctrl, i);
          if (update) {
            results.push(ctrl.start(update));
          }
        }
      });
      return results;
    };
    SpringRef.stop = function () {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(current, ctrl => ctrl.stop(...arguments));
      return this;
    };
    SpringRef.update = function (props) {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(current, (ctrl, i) => ctrl.update(this._getProps(props, ctrl, i)));
      return this;
    };
    const _getProps = function _getProps(arg, ctrl, index) {
      return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef._getProps = _getProps;
    return SpringRef;
  };
  function useSprings(length, props, deps) {
    const propsFn = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
    const layoutId = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])(0);
    const forceUpdate = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useForceUpdate */"D"])();
    const state = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(() => ({
      ctrls: [],
      queue: [],
      flush(ctrl, updates) {
        const springs = getSprings(ctrl, updates);
        const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some(key => !ctrl.springs[key]);
        return canFlushSync ? flushUpdateQueue(ctrl, updates) : new Promise(resolve => {
          setSprings(ctrl, springs);
          state.queue.push(() => {
            resolve(flushUpdateQueue(ctrl, updates));
          });
          forceUpdate();
        });
      }
    }), []);
    const ctrls = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])([...state.ctrls]);
    const updates = [];
    const prevLength = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* usePrev */"H"])(length) || 0;
    Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(() => {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(ctrls.current.slice(length, prevLength), ctrl => {
        detachRefs(ctrl, ref);
        ctrl.stop(true);
      });
      ctrls.current.length = length;
      declareUpdates(prevLength, length);
    }, [length]);
    Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(() => {
      declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
      for (let i = startIndex; i < endIndex; i++) {
        const ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
        const update = propsFn ? propsFn(i, ctrl) : props[i];
        if (update) {
          updates[i] = declareUpdate(update);
        }
      }
    }
    const springs = ctrls.current.map((ctrl, i) => getSprings(ctrl, updates[i]));
    const context = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(SpringContext);
    const prevContext = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* usePrev */"H"])(context);
    const hasContext = context !== prevContext && hasProps(context);
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useIsomorphicLayoutEffect */"E"])(() => {
      layoutId.current++;
      state.ctrls = ctrls.current;
      const {
        queue
      } = state;
      if (queue.length) {
        state.queue = [];
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(queue, cb => cb());
      }
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(ctrls.current, (ctrl, i) => {
        ref == null ? void 0 : ref.add(ctrl);
        if (hasContext) {
          ctrl.start({
            default: context
          });
        }
        const update = updates[i];
        if (update) {
          replaceRef(ctrl, update.ref);
          if (ctrl.ref) {
            ctrl.queue.push(update);
          } else {
            ctrl.start(update);
          }
        }
      });
    });
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useOnce */"G"])(() => () => {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(state.ctrls, ctrl => ctrl.stop(true));
    });
    const values = springs.map(x => _extends({}, x));
    return ref ? [values, ref] : values;
  }
  function useSpring(props, deps) {
    const isFn = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(props);
    const [[values], ref] = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [values, ref] : values;
  }
  const initSpringRef = () => SpringRef();
  const useSpringRef = () => Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(initSpringRef)[0];
  const useSpringValue = (initial, props) => {
    const springValue = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useConstant */"C"])(() => new SpringValue(initial, props));
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useOnce */"G"])(() => () => {
      springValue.stop();
    });
    return springValue;
  };
  function useTrail(length, propsArg, deps) {
    const propsFn = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = undefined;
    const result = useSprings(length, (i, ctrl) => {
      const props = propsFn ? propsFn(i, ctrl) : propsArg;
      passedRef = props.ref;
      reverse = reverse && props.reverse;
      return props;
    }, deps || [{}]);
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useIsomorphicLayoutEffect */"E"])(() => {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(result[1].current, (ctrl, i) => {
        const parent = result[1].current[i + (reverse ? 1 : -1)];
        replaceRef(ctrl, passedRef);
        if (ctrl.ref) {
          if (parent) {
            ctrl.update({
              to: parent.springs
            });
          }
          return;
        }
        if (parent) {
          ctrl.start({
            to: parent.springs
          });
        } else {
          ctrl.start();
        }
      });
    }, deps);
    if (propsFn || arguments.length == 3) {
      var _passedRef;
      const ref = (_passedRef = passedRef) != null ? _passedRef : result[1];
      ref['_getProps'] = (propsArg, ctrl, i) => {
        const props = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(propsArg) ? propsArg(i, ctrl) : propsArg;
        if (props) {
          const parent = ref.current[i + (props.reverse ? 1 : -1)];
          if (parent) props.to = parent.springs;
          return props;
        }
      };
      return result;
    }
    return result[0];
  }
  let TransitionPhase;
  (function (TransitionPhase) {
    TransitionPhase["MOUNT"] = "mount";
    TransitionPhase["ENTER"] = "enter";
    TransitionPhase["UPDATE"] = "update";
    TransitionPhase["LEAVE"] = "leave";
  })(TransitionPhase || (TransitionPhase = {}));
  function useTransition(data, props, deps) {
    const propsFn = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(props) && props;
    const {
      reset,
      sort,
      trail = 0,
      expires = true,
      exitBeforeEnter = false,
      onDestroyed,
      ref: propsRef,
      config: propsConfig
    } = propsFn ? propsFn() : props;
    const ref = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
    const items = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(data);
    const transitions = [];
    const usedTransitions = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useIsomorphicLayoutEffect */"E"])(() => {
      usedTransitions.current = transitions;
    });
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useOnce */"G"])(() => {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(transitions, t => {
        ref == null ? void 0 : ref.add(t.ctrl);
        t.ctrl.ref = ref;
      });
      return () => {
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(usedTransitions.current, t => {
          if (t.expired) {
            clearTimeout(t.expirationId);
          }
          detachRefs(t.ctrl, ref);
          t.ctrl.stop(true);
        });
      };
    });
    const keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useIsomorphicLayoutEffect */"E"])(() => Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(expired, ({
      ctrl,
      item,
      key
    }) => {
      detachRefs(ctrl, ref);
      callProp(onDestroyed, item, key);
    }));
    const reused = [];
    if (prevTransitions) Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(prevTransitions, (t, i) => {
      if (t.expired) {
        clearTimeout(t.expirationId);
        expired.push(t);
      } else {
        i = reused[i] = keys.indexOf(t.key);
        if (~i) transitions[i] = t;
      }
    });
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(items, (item, i) => {
      if (!transitions[i]) {
        transitions[i] = {
          key: keys[i],
          item,
          phase: TransitionPhase.MOUNT,
          ctrl: new Controller()
        };
        transitions[i].ctrl.item = item;
      }
    });
    if (reused.length) {
      let i = -1;
      const {
        leave
      } = propsFn ? propsFn() : props;
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(reused, (keyIndex, prevIndex) => {
        const t = prevTransitions[prevIndex];
        if (~keyIndex) {
          i = transitions.indexOf(t);
          transitions[i] = _extends({}, t, {
            item: items[keyIndex]
          });
        } else if (leave) {
          transitions.splice(++i, 0, t);
        }
      });
    }
    if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(sort)) {
      transitions.sort((a, b) => sort(a.item, b.item));
    }
    let delay = -trail;
    const forceUpdate = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useForceUpdate */"D"])();
    const defaultProps = getDefaultProps(props);
    const changes = new Map();
    const exitingTransitions = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])(new Map());
    const forceChange = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])(false);
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(transitions, (t, i) => {
      const key = t.key;
      const prevPhase = t.phase;
      const p = propsFn ? propsFn() : props;
      let to;
      let phase;
      let propsDelay = callProp(p.delay || 0, key);
      if (prevPhase == TransitionPhase.MOUNT) {
        to = p.enter;
        phase = TransitionPhase.ENTER;
      } else {
        const isLeave = keys.indexOf(key) < 0;
        if (prevPhase != TransitionPhase.LEAVE) {
          if (isLeave) {
            to = p.leave;
            phase = TransitionPhase.LEAVE;
          } else if (to = p.update) {
            phase = TransitionPhase.UPDATE;
          } else return;
        } else if (!isLeave) {
          to = p.enter;
          phase = TransitionPhase.ENTER;
        } else return;
      }
      to = callProp(to, t.item, i);
      to = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].obj(to) ? inferTo(to) : {
        to
      };
      if (!to.config) {
        const config = propsConfig || defaultProps.config;
        to.config = callProp(config, t.item, i, phase);
      }
      delay += trail;
      const payload = _extends({}, defaultProps, {
        delay: propsDelay + delay,
        ref: propsRef,
        immediate: p.immediate,
        reset: false
      }, to);
      if (phase == TransitionPhase.ENTER && _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(payload.from)) {
        const _p = propsFn ? propsFn() : props;
        const from = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(_p.initial) || prevTransitions ? _p.from : _p.initial;
        payload.from = callProp(from, t.item, i);
      }
      const {
        onResolve
      } = payload;
      payload.onResolve = result => {
        callProp(onResolve, result);
        const transitions = usedTransitions.current;
        const t = transitions.find(t => t.key === key);
        if (!t) return;
        if (result.cancelled && t.phase != TransitionPhase.UPDATE) {
          return;
        }
        if (t.ctrl.idle) {
          const idle = transitions.every(t => t.ctrl.idle);
          if (t.phase == TransitionPhase.LEAVE) {
            const expiry = callProp(expires, t.item);
            if (expiry !== false) {
              const expiryMs = expiry === true ? 0 : expiry;
              t.expired = true;
              if (!idle && expiryMs > 0) {
                if (expiryMs <= 0x7fffffff) t.expirationId = setTimeout(forceUpdate, expiryMs);
                return;
              }
            }
          }
          if (idle && transitions.some(t => t.expired)) {
            exitingTransitions.current.delete(t);
            if (exitBeforeEnter) {
              forceChange.current = true;
            }
            forceUpdate();
          }
        }
      };
      const springs = getSprings(t.ctrl, payload);
      if (phase === TransitionPhase.LEAVE && exitBeforeEnter) {
        exitingTransitions.current.set(t, {
          phase,
          springs,
          payload
        });
      } else {
        changes.set(t, {
          phase,
          springs,
          payload
        });
      }
    });
    const context = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(SpringContext);
    const prevContext = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* usePrev */"H"])(context);
    const hasContext = context !== prevContext && hasProps(context);
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useIsomorphicLayoutEffect */"E"])(() => {
      if (hasContext) {
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(transitions, t => {
          t.ctrl.start({
            default: context
          });
        });
      }
    }, [context]);
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(changes, (_, t) => {
      if (exitingTransitions.current.size) {
        const ind = transitions.findIndex(state => state.key === t.key);
        transitions.splice(ind, 1);
      }
    });
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useIsomorphicLayoutEffect */"E"])(() => {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(exitingTransitions.current.size ? exitingTransitions.current : changes, ({
        phase,
        payload
      }, t) => {
        const {
          ctrl
        } = t;
        t.phase = phase;
        ref == null ? void 0 : ref.add(ctrl);
        if (hasContext && phase == TransitionPhase.ENTER) {
          ctrl.start({
            default: context
          });
        }
        if (payload) {
          replaceRef(ctrl, payload.ref);
          if ((ctrl.ref || ref) && !forceChange.current) {
            ctrl.update(payload);
          } else {
            ctrl.start(payload);
            if (forceChange.current) {
              forceChange.current = false;
            }
          }
        }
      });
    }, reset ? void 0 : deps);
    const renderTransitions = render => react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, transitions.map((t, i) => {
      const {
        springs
      } = changes.get(t) || t.ctrl;
      const elem = render(_extends({}, springs), t.item, t, i);
      return elem && elem.type ? react__WEBPACK_IMPORTED_MODULE_1__["createElement"](elem.type, _extends({}, elem.props, {
        key: _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].str(t.key) || _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].num(t.key) ? t.key : t.ctrl.id,
        ref: elem.ref
      })) : elem;
    }));
    return ref ? [renderTransitions, ref] : renderTransitions;
  }
  let nextKey = 1;
  function getKeys(items, {
    key,
    keys = key
  }, prevTransitions) {
    if (keys === null) {
      const reused = new Set();
      return items.map(item => {
        const t = prevTransitions && prevTransitions.find(t => t.item === item && t.phase !== TransitionPhase.LEAVE && !reused.has(t));
        if (t) {
          reused.add(t);
          return t.key;
        }
        return nextKey++;
      });
    }
    return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].und(keys) ? items : _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(keys) ? items.map(keys) : Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(keys);
  }
  const _excluded$5 = ["container"];
  const useScroll = (_ref = {}) => {
    let {
        container
      } = _ref,
      springOptions = _objectWithoutPropertiesLoose(_ref, _excluded$5);
    const [scrollValues, api] = useSpring(() => _extends({
      scrollX: 0,
      scrollY: 0,
      scrollXProgress: 0,
      scrollYProgress: 0
    }, springOptions), []);
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useIsomorphicLayoutEffect */"E"])(() => {
      const cleanupScroll = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* onScroll */"y"])(({
        x,
        y
      }) => {
        api.start({
          scrollX: x.current,
          scrollXProgress: x.progress,
          scrollY: y.current,
          scrollYProgress: y.progress
        });
      }, {
        container: (container == null ? void 0 : container.current) || undefined
      });
      return () => {
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(Object.values(scrollValues), value => value.stop());
        cleanupScroll();
      };
    }, []);
    return scrollValues;
  };
  const _excluded$4 = ["container"];
  const useResize = _ref => {
    let {
        container
      } = _ref,
      springOptions = _objectWithoutPropertiesLoose(_ref, _excluded$4);
    const [sizeValues, api] = useSpring(() => _extends({
      width: 0,
      height: 0
    }, springOptions), []);
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useIsomorphicLayoutEffect */"E"])(() => {
      const cleanupScroll = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* onResize */"x"])(({
        width,
        height
      }) => {
        api.start({
          width,
          height,
          immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
        });
      }, {
        container: (container == null ? void 0 : container.current) || undefined
      });
      return () => {
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(Object.values(sizeValues), value => value.stop());
        cleanupScroll();
      };
    }, []);
    return sizeValues;
  };
  const _excluded$3 = ["to", "from"],
    _excluded2 = ["root", "once", "amount"];
  const defaultThresholdOptions = {
    any: 0,
    all: 1
  };
  function useInView(props, args) {
    const [isInView, setIsInView] = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false);
    const ref = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])();
    const propsFn = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const {
        to = {},
        from = {}
      } = springsProps,
      restSpringProps = _objectWithoutPropertiesLoose(springsProps, _excluded$3);
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = useSpring(() => _extends({
      from
    }, restSpringProps), []);
    Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* useIsomorphicLayoutEffect */"E"])(() => {
      const element = ref.current;
      const _ref = intersectionArguments != null ? intersectionArguments : {},
        {
          root,
          once,
          amount = 'any'
        } = _ref,
        restArgs = _objectWithoutPropertiesLoose(_ref, _excluded2);
      if (!element || once && isInView || typeof IntersectionObserver === 'undefined') return;
      const activeIntersections = new WeakMap();
      const onEnter = () => {
        if (to) {
          api.start(to);
        }
        setIsInView(true);
        const cleanup = () => {
          if (from) {
            api.start(from);
          }
          setIsInView(false);
        };
        return once ? undefined : cleanup;
      };
      const handleIntersection = entries => {
        entries.forEach(entry => {
          const onLeave = activeIntersections.get(entry.target);
          if (entry.isIntersecting === Boolean(onLeave)) {
            return;
          }
          if (entry.isIntersecting) {
            const newOnLeave = onEnter();
            if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(newOnLeave)) {
              activeIntersections.set(entry.target, newOnLeave);
            } else {
              observer.unobserve(entry.target);
            }
          } else if (onLeave) {
            onLeave();
            activeIntersections.delete(entry.target);
          }
        });
      };
      const observer = new IntersectionObserver(handleIntersection, _extends({
        root: root && root.current || undefined,
        threshold: typeof amount === 'number' || Array.isArray(amount) ? amount : defaultThresholdOptions[amount]
      }, restArgs));
      observer.observe(element);
      return () => observer.unobserve(element);
    }, [intersectionArguments]);
    if (propsFn) {
      return [ref, springs];
    }
    return [ref, isInView];
  }
  const _excluded$2 = ["children"];
  function Spring(_ref) {
    let {
        children
      } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
    return children(useSpring(props));
  }
  const _excluded$1 = ["items", "children"];
  function Trail(_ref) {
    let {
        items,
        children
      } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
    const trails = useTrail(items.length, props);
    return items.map((item, index) => {
      const result = children(item, index);
      return _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].fun(result) ? result(trails[index]) : result;
    });
  }
  const _excluded = ["items", "children"];
  function Transition(_ref) {
    let {
        items,
        children
      } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return useTransition(items, props)(children);
  }
  class Interpolation extends FrameValue {
    constructor(source, args) {
      super();
      this.key = void 0;
      this.idle = true;
      this.calc = void 0;
      this._active = new Set();
      this.source = source;
      this.calc = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* createInterpolator */"f"])(...args);
      const value = this._get();
      const nodeType = Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimatedType */"f"])(value);
      Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* setAnimated */"h"])(this, nodeType.create(value));
    }
    advance(_dt) {
      const value = this._get();
      const oldValue = this.get();
      if (!Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* isEqual */"v"])(value, oldValue)) {
        Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getAnimated */"e"])(this).setValue(value);
        this._onChange(value, this.idle);
      }
      if (!this.idle && checkIdle(this._active)) {
        becomeIdle(this);
      }
    }
    _get() {
      const inputs = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* is */"t"].arr(this.source) ? this.source.map(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidValue */"r"]) : Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* getFluidValue */"r"])(this.source));
      return this.calc(...inputs);
    }
    _start() {
      if (this.idle && !checkIdle(this._active)) {
        this.idle = false;
        Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getPayload */"g"])(this), node => {
          node.done = false;
        });
        if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* Globals */"b"].skipAnimation) {
          _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* raf */"z"].batchedUpdates(() => this.advance());
          becomeIdle(this);
        } else {
          _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* frameLoop */"p"].start(this);
        }
      }
    }
    _attach() {
      let priority = 1;
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(this.source), source => {
        if (Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* hasFluidValue */"s"])(source)) {
          Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* addFluidObserver */"c"])(source, this);
        }
        if (isFrameValue(source)) {
          if (!source.idle) {
            this._active.add(source);
          }
          priority = Math.max(priority, source.priority + 1);
        }
      });
      this.priority = priority;
      this._start();
    }
    _detach() {
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(this.source), source => {
        if (Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* hasFluidValue */"s"])(source)) {
          Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* removeFluidObserver */"A"])(source, this);
        }
      });
      this._active.clear();
      becomeIdle(this);
    }
    eventObserved(event) {
      if (event.type == 'change') {
        if (event.idle) {
          this.advance();
        } else {
          this._active.add(event.parent);
          this._start();
        }
      } else if (event.type == 'idle') {
        this._active.delete(event.parent);
      } else if (event.type == 'priority') {
        this.priority = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* toArray */"B"])(this.source).reduce((highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1), 0);
      }
    }
  }
  function isIdle(source) {
    return source.idle !== false;
  }
  function checkIdle(active) {
    return !active.size || Array.from(active).every(isIdle);
  }
  function becomeIdle(self) {
    if (!self.idle) {
      self.idle = true;
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* each */"k"])(Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_2__[/* getPayload */"g"])(self), node => {
        node.done = true;
      });
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* callFluidObservers */"d"])(self, {
        type: 'idle',
        parent: self
      });
    }
  }
  const to = (source, ...args) => new Interpolation(source, args);
  const interpolate = (source, ...args) => (Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* deprecateInterpolate */"j"])(), new Interpolation(source, args));
  _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* Globals */"b"].assign({
    createStringInterpolator: _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* createStringInterpolator */"g"],
    to: (source, args) => new Interpolation(source, args)
  });
  const update = _react_spring_shared__WEBPACK_IMPORTED_MODULE_0__[/* frameLoop */"p"].advance;

  /***/
}, /* 111 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ActionsComponent = ActionsComponent;
  exports["default"] = exports.MoreActionsPortal = exports.MoreActions = void 0;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _reactDom = _interopRequireDefault(__webpack_require__(15));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _reactContextmenu = __webpack_require__(109);
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _SharedPropTypes = __webpack_require__(27);
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var hasNeverBeenOpened = true; /*
                                 This patches an issue where the context menu wouldn't open
                                 on the first click, for all instances of MoreActions with
                                 `preOpen` enabled.  
                                 This may be related to vendor code with competing focus traps 
                                 for the grid cell, context menu, and ReactAriaModal.
                                 */
  var MoreActionsPortal = /*#__PURE__*/function (_Component) {
    _inherits(MoreActionsPortal, _Component);
    var _super = _createSuper(MoreActionsPortal);
    function MoreActionsPortal(props) {
      var _this;
      _classCallCheck(this, MoreActionsPortal);
      _this = _super.call(this, props);
      try {
        _this.el = document.createElement('div');
        _this.modalRoot = document.getElementById(props.modalRoot);
      } catch (err) {
        _this.el = null;
        _this.modalRoot = null;
      }
      return _this;
    }
    _createClass(MoreActionsPortal, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // The portal element is inserted in the DOM tree after
        // the Modal's children are mounted, meaning that children
        // will be mounted on a detached DOM node. If a child
        // component requires to be attached to the DOM tree
        // immediately when mounted, for example to measure a
        // DOM node, or uses 'autoFocus' in a descendant, add
        // state to Modal and only render the children when Modal
        // is inserted in the DOM tree.
        if (this.modalRoot) {
          try {
            this.modalRoot.appendChild(this.el);
          } catch (err) {}
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.modalRoot) {
          try {
            this.modalRoot.removeChild(this.el);
          } catch (err) {}
        }
      }
    }, {
      key: "render",
      value: function render() {
        if (this.el === null) {
          return this.props.children;
        }
        return /*#__PURE__*/_reactDom["default"].createPortal(this.props.children, this.el);
      }
    }]);
    return MoreActionsPortal;
  }(_react.Component);
  /* eslint-disable react/no-multi-comp */
  exports.MoreActionsPortal = MoreActionsPortal;
  _defineProperty(MoreActionsPortal, "defaultProps", {
    modalRoot: "more-acctions-portal"
  });
  var MoreActions = (_class = (_class2 = /*#__PURE__*/function (_Component2) {
    _inherits(MoreActions, _Component2);
    var _super2 = _createSuper(MoreActions);
    function MoreActions() {
      var _this2;
      _classCallCheck(this, MoreActions);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this2 = _super2.call.apply(_super2, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this2), "state", {
        isOpen: false,
        openUp: false,
        openLeft: false
      });
      return _this2;
    }
    _createClass(MoreActions, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        if (this.state.isOpen !== nextState.isOpen) {
          return true;
        }
        if (this.props.isDisabled !== nextProps.isDisabled) {
          return true;
        }
        if (!this.props.isActionKebab) {
          return true;
        }
        return false;
      }
    }, {
      key: "openMenu",
      value: function openMenu(event) {
        try {
          var me = this;
          event.persist();
          if (me.props.preOpen) {
            me.contextMenu.handleContextClick(event);
            me.setState({
              isOpen: true
            }, function () {
              if (document.querySelectorAll(".react-contextmenu.is-open").length === 0) {
                me.contextMenu.handleContextClick(event);
              } else if (hasNeverBeenOpened) {
                me.contextMenu.handleContextClick(event);
                hasNeverBeenOpened = false;
              }
            });
          } else {
            me.contextMenu.handleContextClick(event);
          }
        } catch (error) {
          console.error("Problem:", error);
        }
      }
    }, {
      key: "_onShow",
      value: function _onShow() {
        var nodeList = this.contextMenuList,
          nodeRects = nodeList.menu.getBoundingClientRect(),
          _window = window,
          innerHeight = _window.innerHeight,
          _this$props = this.props,
          menuItemHeight = _this$props.menuItemHeight,
          menuPadding = _this$props.menuPadding,
          footerHeight = _this$props.footerHeight,
          actionsList = _this$props.actionsList,
          menuHeight = actionsList.length * menuItemHeight,
          newState = {
            isOpen: true
          };

        // Setting "openUp" for the lower position menus seems to clash with
        // some built in functionality to keep the menus in the visible window
        // So we actually want to turn it off for these items, but we start with
        // position of the actual trigger cell, since the menu position we get is
        // unreliable. I think because built in functionality can move it afterwards
        var elemCell = this.contextMenu.elem.getBoundingClientRect();
        newState.openUp = elemCell.top + menuHeight + menuPadding <= innerHeight && menuHeight + menuPadding < elemCell.top;

        /*if((nodeRects.top + menuHeight + menuPadding) > (innerHeight - footerHeight)){
        	newState.openUp = true;
        } else {
        	newState.openUp = false;
        }*/

        if (innerWidth - (nodeRects.left + nodeRects.width) < nodeRects.width) {
          newState.openLeft = true;
          // newState.menuWidth = nodeRects.width;
        } else {
          newState.openLeft = false;
        }
        this.setState(newState);
      }
    }, {
      key: "_onHide",
      value: function _onHide() {
        this.setState({
          isOpen: false
        });
      }
    }, {
      key: "renderMenu",
      value: function renderMenu() {
        var _ctxClasses;
        var me = this,
          ctxClasses = (_ctxClasses = {
            "action-menu-list": true
          }, _defineProperty(_ctxClasses, me.props.menuClass, true), _defineProperty(_ctxClasses, "open-left", me.state.openLeft), _defineProperty(_ctxClasses, "open-up", me.state.openUp), _defineProperty(_ctxClasses, "is-open", me.state.isOpen), _ctxClasses),
          $contextMenu = null;
        if (me.props.actionsList.length === 0) {
          return null;
        }
        $contextMenu = /*#__PURE__*/_react["default"].createElement(_reactContextmenu.ContextMenu, {
          ref: function ref(ctx) {
            return me.contextMenuList = ctx;
          },
          className: (0, _classnames["default"])(ctxClasses),
          id: "context-menu--".concat(me.props.value),
          onShow: me._onShow,
          onHide: me._onHide
        }, me.renderActions());
        if (me.props.usePortal) {
          return /*#__PURE__*/_react["default"].createElement(MoreActionsPortal, {
            modalRoot: "more-acctions-portal"
          }, $contextMenu);
        }
        return $contextMenu;
      }
    }, {
      key: "renderActions",
      value: function renderActions() {
        var state = this.state,
          props = this.props,
          actionsList = props.actionsList;
        if (!state.isOpen) {
          return [];
        }
        if (actionsList && actionsList.length > 0) {
          return this._renderMenu(actionsList);
        }
        return [];
      }
    }, {
      key: "_renderMenu",
      value: function _renderMenu(level) {
        var me = this,
          dividers = 0;
        if (!level || !level.map) {
          throw new Error("Invalid Actions List");
        }
        return level.map(function (v, i) {
          var miProps = {
              data: me.props,
              title: v.name,
              className: v.className || "",
              disabled: v.disabled
            },
            childClassName = v.className || "",
            $child = null;
          if (v.divider) {
            dividers += 1;
            return /*#__PURE__*/_react["default"].createElement(_reactContextmenu.MenuItem, {
              key: "divider-".concat(dividers),
              divider: true
            });
          }
          if (v.onClick) {
            miProps.onClick = v.onClick.bind(me);
          }
          if (v.children) {
            return /*#__PURE__*/_react["default"].createElement(_reactContextmenu.SubMenu, {
              className: childClassName,
              key: v.name,
              title: v.title || v.name,
              hoverDelay: 250
            }, me._renderMenu(v.children));
          }
          if (v.renderChild) {
            $child = /*#__PURE__*/_react["default"].createElement(_reactContextmenu.MenuItem, _extends({
              key: v.name
            }, miProps), v.renderChild(me.props));
          } else {
            $child = /*#__PURE__*/_react["default"].createElement(_reactContextmenu.MenuItem, _extends({
              key: v.name
            }, miProps), /*#__PURE__*/_react["default"].createElement("div", {
              className: "selected-menu-item ".concat(childClassName)
            }, v.icon ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
              name: v.icon,
              "aria-hidden": "true"
            }) : null, /*#__PURE__*/_react["default"].createElement("span", {
              className: "action-value"
            }, v.name)));
          }
          return $child;
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _cls,
          _this3 = this;
        var props = this.props,
          cls = (_cls = {
            "cursor-pointer": true,
            "action-kebab": props.isActionKebab
          }, _defineProperty(_cls, props.className, true), _defineProperty(_cls, "theme-".concat(props.theme), true), _defineProperty(_cls, "icon-only", props.iconOnly), _defineProperty(_cls, "is-menu-open", this.state.isOpen), _cls);
        return /*#__PURE__*/_react["default"].createElement("div", {
          title: props.title,
          className: (0, _classnames["default"])(cls),
          onClick: this.openMenu
        }, /*#__PURE__*/_react["default"].createElement(_reactContextmenu.ContextMenuTrigger, {
          id: "context-menu--".concat(props.value),
          ref: function ref(cm) {
            return _this3.contextMenu = cm;
          }
        }, props.children), this.renderMenu());
      }
    }]);
    return MoreActions;
  }(_react.Component), _defineProperty(_class2, "defaultProps", {
    className: "",
    theme: "pink",
    addClass: "editing",
    parentClass: ".actions-cell",
    menuClass: "",
    iconOnly: true,
    title: "",
    value: null,
    actionsList: null,
    isDisabled: false,
    // Height of the footer - we need to know how much of the bottom of the screen to account for
    footerHeight: 50,
    // How tall are the menu items?  - used for determining the height of the Menu
    menuItemHeight: 30,
    // How much padding do we want at the bottom of the menu before we reverse it
    menuPadding: 10,
    usePortal: true,
    isActionKebab: true,
    preOpen: false
  }), _defineProperty(_class2, "propTypes", {
    /** */
    addClass: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
    /** */
    iconOnly: _propTypes["default"].bool,
    /** */
    theme: _SharedPropTypes.PROPTYPE_THEME,
    /** */
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    /** */
    actionsList: _propTypes["default"].array.isRequired,
    /** */
    usePortal: _propTypes["default"].bool,
    /** Height of the footer - we need to know how much of the bottom of the screen */
    footerHeight: _propTypes["default"].number,
    /** How tall are the menu items - used for determining the height of the Menu */
    menuItemHeight: _propTypes["default"].number,
    /** How much padding do we want at the bottom of the menu before we reverse it */
    menuPadding: _propTypes["default"].number,
    /** Should we add the action-kebab class? */
    isActionKebab: _propTypes["default"].bool,
    /** Should we set the state as open before we trigger the context menu item? (Used for Macros) */
    preOpen: _propTypes["default"].bool
  }), _defineProperty(_class2, "contextTypes", {
    store: _propTypes["default"].object,
    router: _propTypes["default"].object
  }), _class2), (_applyDecoratedDescriptor(_class.prototype, "openMenu", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "openMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_onShow", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_onShow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_onHide", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_onHide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "renderMenu", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "renderMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "renderActions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "renderActions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderMenu", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderMenu"), _class.prototype)), _class);
  exports.MoreActions = MoreActions;
  function ActionsComponent(props) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "actions-cell"
    }, /*#__PURE__*/_react["default"].createElement(MoreActions, props, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "moreHorizontal",
      className: "action-icon"
    })));
  }
  /* eslint-enable react/no-multi-comp */

  var ACTIONS_CELL = {
    key: "aid",
    name: "Actions",
    width: 70,
    sortable: false,
    formatter: function formatter(props) {
      if (props.dependentValues && props.dependentValues.actionsList && props.dependentValues.actionsList.length === 0) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(MoreActions, _extends({}, props.dependentValues, {
        value: props.value
      }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "moreHorizontal",
        className: "action-icon"
      }));
    },
    cellClass: "actions-cell",
    locked: false
  };
  var _default = ACTIONS_CELL;
  exports["default"] = _default;

  /***/
}, /* 112 */
/***/function (module, exports, __webpack_require__) {
  var _typeof = __webpack_require__(35)["default"];
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 113 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _lodash = __webpack_require__(57);
  __webpack_require__(180);
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var Search = (_class = (_class2 = /*#__PURE__*/function (_Component) {
    _inherits(Search, _Component);
    var _super = _createSuper(Search);
    function Search(props, context) {
      var _this;
      _classCallCheck(this, Search);
      _this = _super.call(this, props, context);
      _defineProperty(_assertThisInitialized(_this), "state", {
        isFocused: false
      });
      _this._debounceSearch = (0, _lodash.debounce)(props.onSearch, props.searchDebounce, props.searchImmediate);
      return _this;
    }
    _createClass(Search, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var searchValue = this.props.searchValue;
        if (!searchValue || searchValue === null) {
          this.input.value = "";
        } else {
          this.input.value = searchValue;
        }
      }
    }, {
      key: "onSearch",
      value: function onSearch(evt) {
        evt.persist();
        var val = this.props.shouldTrim ? evt.target.value.trim() : evt.target.value;
        this._debounceSearch(val);
      }
    }, {
      key: "clearSearch",
      value: function clearSearch(evt) {
        evt.preventDefault();
        this.input.value = "";
        this.props.onSearch("");
      }
    }, {
      key: "render",
      value: function render() {
        var _classNames,
          _this2 = this;
        var _this$props = this.props,
          searchValue = _this$props.searchValue,
          placeholder = _this$props.placeholder,
          isDisabled = _this$props.isDisabled,
          searchClass = (0, _classnames["default"])((_classNames = {
            "search-component": true
          }, _defineProperty(_classNames, this.props.className, true), _defineProperty(_classNames, "is-searching", !!searchValue), _defineProperty(_classNames, "is-focused", this.state.isFocused || searchValue), _classNames));
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: searchClass
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "search-input-wrapper"
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          name: "search"
        }), /*#__PURE__*/_react["default"].createElement("input", {
          className: "search-field",
          ref: function ref(inp) {
            return _this2.input = inp;
          },
          type: "search",
          onChange: this.onSearch,
          defaultValue: searchValue,
          placeholder: placeholder,
          disabled: isDisabled,
          onFocus: function onFocus() {
            return _this2.setState({
              isFocused: true
            });
          },
          onBlur: function onBlur() {
            return _this2.setState({
              isFocused: false
            });
          }
        }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          name: "clear",
          className: "clear-search",
          onClick: this.clearSearch,
          title: "Clear Search"
        })));
      }
    }]);
    return Search;
  }(_react.Component), _defineProperty(_class2, "displayName", "Search"), _defineProperty(_class2, "defaultProps", {
    searchValue: null,
    searchDebounce: 500,
    searchImmediate: false,
    className: "",
    placeholder: "Search",
    shouldTrim: true,
    isDisabled: false
  }), _defineProperty(_class2, "propTypes", {
    onSearch: _propTypes["default"].func.isRequired,
    /* How long in ms should we wait until we trigger onSearch() */
    searchDebounce: _propTypes["default"].number,
    searchValue: _propTypes["default"].string,
    /* Immediately trigger onSearch() on first change */
    searchImmediate: _propTypes["default"].bool,
    /* Additional className to apply to the markup */
    className: _propTypes["default"].string,
    /* HTML Input placeholder to display */
    placeholder: _propTypes["default"].string,
    /* Should whitespace be trimmed before sending the value to onSearch() */
    shouldTrim: _propTypes["default"].bool,
    /* Should the search box be disabled */
    isDisabled: _propTypes["default"].bool
  }), _class2), (_applyDecoratedDescriptor(_class.prototype, "onSearch", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSearch", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "clearSearch"), _class.prototype)), _class);
  exports["default"] = Search;

  /***/
}, /* 114 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.ReduxControls = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _Checkbox = _interopRequireDefault(__webpack_require__(99));
  var _CheckboxList = _interopRequireDefault(__webpack_require__(167));
  var _Input = _interopRequireDefault(__webpack_require__(87));
  var _RowController = _interopRequireDefault(__webpack_require__(170));
  var _Select = _interopRequireDefault(__webpack_require__(64));
  var _Toggle = _interopRequireDefault(__webpack_require__(171));
  var _TagGroup = _interopRequireDefault(__webpack_require__(172));
  var _Dates = _interopRequireDefault(__webpack_require__(168));
  var _TimePicker = _interopRequireDefault(__webpack_require__(183));
  var _MultiSelectWithList = _interopRequireDefault(__webpack_require__(184));
  var _excluded = ["input", "meta"];
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  var Slider = {};
  var Controls = {
    Checkbox: _Checkbox["default"],
    CheckboxList: _CheckboxList["default"],
    Input: _Input["default"],
    RowController: _RowController["default"],
    Select: _Select["default"],
    Toggle: _Toggle["default"],
    TagGroup: _TagGroup["default"],
    Slider: Slider,
    Dates: _Dates["default"],
    TimePicker: _TimePicker["default"],
    MultiSelectWithList: _MultiSelectWithList["default"]
  };
  var cc = null,
    RdxControls = {};
  for (cc in Controls) {
    RdxControls[cc] = reduxWrapper(Controls[cc]);
  }
  function reduxWrapper(Control) {
    return function RDX(_ref) {
      var input = _ref.input,
        meta = _ref.meta,
        props = _objectWithoutProperties(_ref, _excluded);
      return /*#__PURE__*/_react["default"].createElement(Control, _extends({}, input, props, {
        meta: meta
      }));
    };
  }
  var _default = Controls;
  exports["default"] = _default;
  var ReduxControls = RdxControls;
  exports.ReduxControls = ReduxControls;

  /***/
}, /* 115 */
/***/function (module, exports) {
  module.exports = require("redux-form");

  /***/
}, /* 116 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "NonceProvider", function () {
    return NonceProvider;
  });
  /* harmony import */
  var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65);
  /* harmony import */
  var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */
  var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37);
  /* harmony import */
  var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
  /* harmony import */
  var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48);
  /* harmony import */
  var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
  /* harmony import */
  var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66);
  /* harmony import */
  var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__);
  /* harmony import */
  var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11);
  /* harmony import */
  var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__);
  /* harmony import */
  var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12);
  /* harmony import */
  var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13);
  /* harmony import */
  var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7);
  /* harmony import */
  var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__);
  /* harmony import */
  var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14);
  /* harmony import */
  var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16);
  /* harmony import */
  var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
  /* harmony import */
  var memoize_one__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30);
  /* harmony import */
  var _emotion_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3);
  /* harmony import */
  var react_dom__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15);
  /* harmony import */
  var react_dom__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_14__);
  /* harmony import */
  var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35);
  /* harmony import */
  var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_15__);
  /* harmony import */
  var _index_75b02bac_browser_esm_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5);
  /* harmony reexport (safe) */
  __webpack_require__.d(__webpack_exports__, "components", function () {
    return _index_75b02bac_browser_esm_js__WEBPACK_IMPORTED_MODULE_16__["f"];
  });

  /* harmony import */
  var _Select_e1cf49ae_browser_esm_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21);
  /* harmony reexport (safe) */
  __webpack_require__.d(__webpack_exports__, "createFilter", function () {
    return _Select_e1cf49ae_browser_esm_js__WEBPACK_IMPORTED_MODULE_17__["c"];
  });

  /* harmony reexport (safe) */
  __webpack_require__.d(__webpack_exports__, "defaultTheme", function () {
    return _Select_e1cf49ae_browser_esm_js__WEBPACK_IMPORTED_MODULE_17__["b"];
  });

  /* harmony reexport (safe) */
  __webpack_require__.d(__webpack_exports__, "mergeStyles", function () {
    return _Select_e1cf49ae_browser_esm_js__WEBPACK_IMPORTED_MODULE_17__["d"];
  });

  /* harmony import */
  var _emotion_css__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(20);
  /* harmony import */
  var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(49);
  /* harmony import */
  var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_19__);
  /* harmony import */
  var react_input_autosize__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(38);
  /* harmony import */
  var react_input_autosize__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(react_input_autosize__WEBPACK_IMPORTED_MODULE_20__);
  /* harmony import */
  var _stateManager_2f2b6f5b_browser_esm_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(31);
  /* harmony import */
  var _emotion_cache__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__[/* default */"a"])(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__[/* default */"a"])(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__[/* default */"a"])(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var NonceProvider = /*#__PURE__*/function (_Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_8__[/* default */"a"])(NonceProvider, _Component);
    var _super = _createSuper(NonceProvider);
    function NonceProvider(props) {
      var _this;
      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */"a"])(this, NonceProvider);
      _this = _super.call(this, props);
      _this.createEmotionCache = function (nonce) {
        return Object(_emotion_cache__WEBPACK_IMPORTED_MODULE_22__[/* default */"a"])({
          nonce: nonce
        });
      };
      _this.createEmotionCache = Object(memoize_one__WEBPACK_IMPORTED_MODULE_12__[/* default */"a"])(_this.createEmotionCache);
      return _this;
    }
    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */"a"])(NonceProvider, [{
      key: "render",
      value: function render() {
        var emotionCache = this.createEmotionCache(this.props.nonce);
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement(_emotion_core__WEBPACK_IMPORTED_MODULE_13__[/* CacheProvider */"a"], {
          value: emotionCache
        }, this.props.children);
      }
    }]);
    return NonceProvider;
  }(react__WEBPACK_IMPORTED_MODULE_11__["Component"]);
  var index = Object(_stateManager_2f2b6f5b_browser_esm_js__WEBPACK_IMPORTED_MODULE_21__[/* m */"a"])(_Select_e1cf49ae_browser_esm_js__WEBPACK_IMPORTED_MODULE_17__[/* S */"a"]);

  /* harmony default export */
  __webpack_exports__["default"] = index;

  /***/
}, /* 117 */
/***/function (module, exports) {
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 118 */
/***/function (module, exports) {
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 119 */
/***/function (module, exports) {
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 120 */
/***/function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(85);
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
  }
  module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 121 */
/***/function (module, exports) {
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 122 */
/***/function (module, exports) {
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 123 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony import */
  var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65);
  /* harmony import */
  var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__);
  /* harmony import */
  var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37);
  /* harmony import */
  var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_1__);
  /* harmony import */
  var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48);
  /* harmony import */
  var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
  /* harmony import */
  var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66);
  /* harmony import */
  var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__);
  /* harmony import */
  var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11);
  /* harmony import */
  var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__);
  /* harmony import */
  var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(124);
  /* harmony import */
  var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
  /* harmony import */
  var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(125);
  /* harmony import */
  var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
  /* harmony import */
  var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7);
  /* harmony import */
  var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__);
  /* harmony import */
  var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(126);
  /* harmony import */
  var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
  /* harmony import */
  var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(127);
  /* harmony import */
  var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
  /* harmony import */
  var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(128);
  /* harmony import */
  var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1);
  /* harmony import */
  var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
  /* harmony import */
  var _emotion_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3);
  /* harmony import */
  var react_dom__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15);
  /* harmony import */
  var react_dom__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_13__);
  /* harmony import */
  var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35);
  /* harmony import */
  var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__);
  /* harmony import */
  var _dist_Select_e1cf49ae_browser_esm_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21);
  /* harmony import */
  var _emotion_css__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(20);
  /* harmony import */
  var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(49);
  /* harmony import */
  var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_17__);
  /* harmony import */
  var react_input_autosize__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(38);
  /* harmony import */
  var react_input_autosize__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(react_input_autosize__WEBPACK_IMPORTED_MODULE_18__);
  /* harmony import */
  var _dist_stateManager_2f2b6f5b_browser_esm_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(31);
  /* harmony import */
  var _async_dist_react_select_browser_esm_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(67);
  /* harmony import */
  var _creatable_dist_react_select_browser_esm_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(68);
  var SelectCreatable = Object(_creatable_dist_react_select_browser_esm_js__WEBPACK_IMPORTED_MODULE_21__["makeCreatableSelect"])(_dist_Select_e1cf49ae_browser_esm_js__WEBPACK_IMPORTED_MODULE_15__[/* S */"a"]);
  var SelectCreatableState = Object(_dist_stateManager_2f2b6f5b_browser_esm_js__WEBPACK_IMPORTED_MODULE_19__[/* m */"a"])(SelectCreatable);
  var AsyncCreatable = Object(_async_dist_react_select_browser_esm_js__WEBPACK_IMPORTED_MODULE_20__["makeAsyncSelect"])(SelectCreatableState);

  /* harmony default export */
  __webpack_exports__["default"] = AsyncCreatable;

  /***/
}, /* 124 */
/***/function (module, exports) {
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 125 */
/***/function (module, exports, __webpack_require__) {
  var toPropertyKey = __webpack_require__(78);
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 126 */
/***/function (module, exports, __webpack_require__) {
  var setPrototypeOf = __webpack_require__(79);
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) setPrototypeOf(subClass, superClass);
  }
  module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 127 */
/***/function (module, exports, __webpack_require__) {
  var _typeof = __webpack_require__(35)["default"];
  var assertThisInitialized = __webpack_require__(7);
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return assertThisInitialized(self);
  }
  module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 128 */
/***/function (module, exports) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _getPrototypeOf(o);
  }
  module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

  /***/
}, /* 129 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(211);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 130 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var slice = Array.prototype.slice;
  var isArgs = __webpack_require__(131);
  var origKeys = Object.keys;
  var keysShim = origKeys ? function keys(o) {
    return origKeys(o);
  } : __webpack_require__(217);
  var originalKeys = Object.keys;
  keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
      var keysWorksWithArguments = function () {
        // Safari 5.0 bug
        var args = Object.keys(arguments);
        return args && args.length === arguments.length;
      }(1, 2);
      if (!keysWorksWithArguments) {
        Object.keys = function keys(object) {
          // eslint-disable-line func-name-matching
          if (isArgs(object)) {
            return originalKeys(slice.call(object));
          }
          return originalKeys(object);
        };
      }
    } else {
      Object.keys = keysShim;
    }
    return Object.keys || keysShim;
  };
  module.exports = keysShim;

  /***/
}, /* 131 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var toStr = Object.prototype.toString;
  module.exports = function isArguments(value) {
    var str = toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) {
      isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
    }
    return isArgs;
  };

  /***/
}, /* 132 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* eslint complexity: [2, 18], max-statements: [2, 33] */
  module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
      return false;
    }
    if (typeof Symbol.iterator === 'symbol') {
      return true;
    }
    var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') {
      return false;
    }
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
      return false;
    }
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
      return false;
    }

    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }

    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

    var symVal = 42;
    obj[sym] = symVal;
    for (sym in obj) {
      return false;
    } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
      return false;
    }
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
      return false;
    }
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) {
      return false;
    }
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
      return false;
    }
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
      var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
      if (descriptor.value !== symVal || descriptor.enumerable !== true) {
        return false;
      }
    }
    return true;
  };

  /***/
}, /* 133 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var GetIntrinsic = __webpack_require__(93);
  var callBind = __webpack_require__(95);
  var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
  module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
      return callBind(intrinsic);
    }
    return intrinsic;
  };

  /***/
}, /* 134 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var numberIsNaN = function (value) {
    return value !== value;
  };
  module.exports = function is(a, b) {
    if (a === 0 && b === 0) {
      return 1 / a === 1 / b;
    }
    if (a === b) {
      return true;
    }
    if (numberIsNaN(a) && numberIsNaN(b)) {
      return true;
    }
    return false;
  };

  /***/
}, /* 135 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var implementation = __webpack_require__(134);
  module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : implementation;
  };

  /***/
}, /* 136 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var functionsHaveConfigurableNames = __webpack_require__(227).functionsHaveConfigurableNames();
  var $Object = Object;
  var $TypeError = TypeError;
  module.exports = function flags() {
    if (this != null && this !== $Object(this)) {
      throw new $TypeError('RegExp.prototype.flags getter called on non-object');
    }
    var result = '';
    if (this.hasIndices) {
      result += 'd';
    }
    if (this.global) {
      result += 'g';
    }
    if (this.ignoreCase) {
      result += 'i';
    }
    if (this.multiline) {
      result += 'm';
    }
    if (this.dotAll) {
      result += 's';
    }
    if (this.unicode) {
      result += 'u';
    }
    if (this.sticky) {
      result += 'y';
    }
    return result;
  };
  if (functionsHaveConfigurableNames && Object.defineProperty) {
    Object.defineProperty(module.exports, 'name', {
      value: 'get flags'
    });
  }

  /***/
}, /* 137 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var implementation = __webpack_require__(136);
  var supportsDescriptors = __webpack_require__(72).supportsDescriptors;
  var $gOPD = Object.getOwnPropertyDescriptor;
  module.exports = function getPolyfill() {
    if (supportsDescriptors && /a/mig.flags === 'gim') {
      var descriptor = $gOPD(RegExp.prototype, 'flags');
      if (descriptor && typeof descriptor.get === 'function' && typeof RegExp.prototype.dotAll === 'boolean' && typeof RegExp.prototype.hasIndices === 'boolean') {
        /* eslint getter-return: 0 */
        var calls = '';
        var o = {};
        Object.defineProperty(o, 'hasIndices', {
          get: function () {
            calls += 'd';
          }
        });
        Object.defineProperty(o, 'sticky', {
          get: function () {
            calls += 'y';
          }
        });
        if (calls === 'dy') {
          return descriptor.get;
        }
      }
    }
    return implementation;
  };

  /***/
}, /* 138 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.versionStatus = exports.qaLocationId = exports.numClicktags = exports.isTranscodingError = exports.isTranscoding = exports.encoded = exports["default"] = exports["boolean"] = exports.approval = exports.adType = void 0;
  var _constants = __webpack_require__(59);
  var _generateDictionary;
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  /*
  	Sometimes the API has values for fields that aren't user-friendly.
  	e.g. a status number instead of a label for what that status represents.
  
  	Rather than fiddle with every widget that might display those values, we can translate
  	them into the user-friendly values when receiving them from the API, and then back
  	from the user-friendly values into the API values when we use them for request parameters.
  
  	We use dictionaries in the form:
  	```
  		{
  			apiToUI: {
  				uglyAPIValue: "niceUIValue",
  				...
  			},
  			uiToAPI: {
  				niceUIValue: "uglyAPIValue",
  				...
  			},
  		}
  	```
  
  	You can use DICTIONARIES whenever there's one of these UI <-> API interactions, and
  	then we can just pretend we got user-friendly values from the API while working within the UI.
  		- For Column Filters, we use this when fetching distincts, and when we generate advanced filters.
  */

  function generateDictionary(apiToUI) {
    /*
    	Implements the two way interface when provided with the apiToUI mapping of values.
    	If you need to, you can specify them with square brackets [], to make a symbol key,
    		e.g.
    		```
    		generateDictionary({
    			["normally, invalid characters!!"]: "User Friendly"
    		})
    	```
    	generates:
    	```
    		{
    			apiToUI: {
    				["normally, invalid characters!!"]: "User Friendly"
    			},
    			uiToAPI: {
    				["User Friendly"]: "normally, invalid characters!!"
    			}
    		}
    	```
    		Prefer using this over hard coding the two way mapping, because it's easier to mess
    	up typing, and to forget to modify both sets.
    */
    var uiToAPI = Object.entries(apiToUI).reduce(function (prev, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];
      if (prev[v]) {
        console.error("Identical value found in dictionary.  This will break UI -> API lookups:", v);
      }
      prev[v] = k;
      return prev;
    }, {});
    return {
      apiToUI: apiToUI,
      uiToAPI: uiToAPI
    };
  }

  // Allow booleans to be represented as strings
  var _boolean = generateDictionary({
    "true": "True",
    "false": "False"
  });
  exports["boolean"] = _boolean;
  var approval = generateDictionary({
    FAILED: _constants.STATUS_MAP.failed.label,
    SUBMITTED: _constants.STATUS_MAP.submitted.label,
    UNSUBMITTED: _constants.STATUS_MAP.unsubmitted.label,
    PENDING_APPROVAL: _constants.STATUS_MAP.pending_approval.label,
    APPROVED: _constants.STATUS_MAP.approved.label,
    TRANSCODING: _constants.STATUS_MAP.transcoding.label,
    TRANSCODING_ERROR: _constants.STATUS_MAP.transcoding_error.label,
    PRODUCTION_INCOMPLETE: _constants.STATUS_MAP.production_incomplete.label,
    REJECTED_INCOMPLETE: _constants.STATUS_MAP.rejected_incomplete.label
  });
  exports.approval = approval;
  var compareStates = function compareStates(apiState, uiState) {
    return approval.apiToUI[apiState] === uiState;
  };
  var isTranscoding = function isTranscoding(apiState) {
    return compareStates(apiState, _constants.STATUS_MAP.transcoding.label);
  };
  exports.isTranscoding = isTranscoding;
  var isTranscodingError = function isTranscodingError(apiState) {
    return compareStates(apiState, _constants.STATUS_MAP.transcoding_error.label);
  };
  exports.isTranscodingError = isTranscodingError;
  var encoded = generateDictionary({
    "false": "Uploaded",
    "true": "Transcode"
  });
  exports.encoded = encoded;
  var versionStatus = generateDictionary({
    // 0: "Unpublished",
    // 1: "Deleted",
    // 2: "Published" // Never used
    // 3: "Published", // "Live" in DB
    Live: "Published"
  });
  exports.versionStatus = versionStatus;
  var adType = generateDictionary((_generateDictionary = {}, _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.FACEBOOK_IMAGE, "Facebook Image"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.FACEBOOK_VIDEO, "Facebook Video"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL, "Facebook Carousel"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO, "Facebook  Image"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO, "Facebook  Video"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO, "Facebook  Carousel"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_IMAGE, "Google Demand Gen Image"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_CAROUSEL, "Google Demand Gen Carousel"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.YOUTUBE_DISCOVERY, "YouTube TrueView Discovery"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.YOUTUBE_INSTREAM, "YouTube Video"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.LINKEDIN_IMAGE, "LinkedIn Sponsored Image"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.LINKEDIN_VIDEO, "LinkedIn Sponsored Video"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL, "LinkedIn Sponsored Carousel"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.PINTEREST_IMAGE, "Pinterest Image Pin"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.PINTEREST_VIDEO, "Pinterest Video Pin"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.PINTEREST_MAX_WIDTH_VIDEO, "Pinterest Max Width Video"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.PINTEREST_CAROUSEL, "Pinterest Carousel"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.SNAPCHAT_IMAGE, "Snapchat Web View Image"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.SNAPCHAT_VIDEO, "Snapchat Web View Video"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.TWITTER_IMAGE, "Twitter Image Website Card"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.TWITTER_VIDEO, "Twitter Video Website Card"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.TWITTER_CAROUSEL, "Twitter Website Carousel"), _defineProperty(_generateDictionary, _constants.SOCIAL_AD_TYPES.TIKTOK_VIDEO, "Tiktok In-Feed Video Ad"), _defineProperty(_generateDictionary, _constants.PARTNER_VAST, "VAST Creative Tag"), _generateDictionary));
  exports.adType = adType;
  var numClicktags = generateDictionary(_defineProperty({}, _constants.CLICK_TAG_NA_NUM, "N/A"));
  exports.numClicktags = numClicktags;
  var qaList = {};
  _constants.QATerritories.forEach(function (v) {
    qaList[v.value] = v.label;
  });
  var qaLocationId = generateDictionary(qaList);
  exports.qaLocationId = qaLocationId;
  var DICTIONARIES = {
    approval: approval,
    encoded: encoded,
    "boolean": _boolean,
    versionStatus: versionStatus,
    adType: adType,
    numClicktags: numClicktags,
    qaLocationId: qaLocationId,
    isTranscoding: isTranscoding,
    isTranscodingError: isTranscodingError
  };
  var _default = DICTIONARIES;
  exports["default"] = _default;

  /***/
}, /* 139 */
/***/function (module, exports, __webpack_require__) {
  var objectKeys = __webpack_require__(130);
  var isArguments = __webpack_require__(218);
  var is = __webpack_require__(222);
  var isRegex = __webpack_require__(225);
  var flags = __webpack_require__(226);
  var isDate = __webpack_require__(229);
  var getTime = Date.prototype.getTime;
  function deepEqual(actual, expected, options) {
    var opts = options || {};

    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? is(actual, expected) : actual === expected) {
      return true;
    }

    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') {
      return opts.strict ? is(actual, expected) : actual == expected;
    }

    /*
     * 7.4. For all other Object pairs, including Array objects, equivalence is
     * determined by having the same number of owned properties (as verified
     * with Object.prototype.hasOwnProperty.call), the same set of keys
     * (although not necessarily the same order), equivalent values for every
     * corresponding key, and an identical 'prototype' property. Note: this
     * accounts for both named and indexed properties on Arrays.
     */
    // eslint-disable-next-line no-use-before-define
    return objEquiv(actual, expected, opts);
  }
  function isUndefinedOrNull(value) {
    return value === null || value === undefined;
  }
  function isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
      return false;
    }
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
      return false;
    }
    if (x.length > 0 && typeof x[0] !== 'number') {
      return false;
    }
    return true;
  }
  function objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */
    var i, key;
    if (typeof a !== typeof b) {
      return false;
    }
    if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) {
      return false;
    }

    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) {
      return false;
    }
    if (isArguments(a) !== isArguments(b)) {
      return false;
    }
    var aIsRegex = isRegex(a);
    var bIsRegex = isRegex(b);
    if (aIsRegex !== bIsRegex) {
      return false;
    }
    if (aIsRegex || bIsRegex) {
      return a.source === b.source && flags(a) === flags(b);
    }
    if (isDate(a) && isDate(b)) {
      return getTime.call(a) === getTime.call(b);
    }
    var aIsBuffer = isBuffer(a);
    var bIsBuffer = isBuffer(b);
    if (aIsBuffer !== bIsBuffer) {
      return false;
    }
    if (aIsBuffer || bIsBuffer) {
      // && would work too, because both are true or both false here
      if (a.length !== b.length) {
        return false;
      }
      for (i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
          return false;
        }
      }
      return true;
    }
    if (typeof a !== typeof b) {
      return false;
    }
    try {
      var ka = objectKeys(a);
      var kb = objectKeys(b);
    } catch (e) {
      // happens when one is a string literal and the other isn't
      return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) {
      return false;
    }

    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for (i = ka.length - 1; i >= 0; i--) {
      if (ka[i] != kb[i]) {
        return false;
      }
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for (i = ka.length - 1; i >= 0; i--) {
      key = ka[i];
      if (!deepEqual(a[key], b[key], opts)) {
        return false;
      }
    }
    return true;
  }
  module.exports = deepEqual;

  /***/
},

  /* 140 */

  /* 418 */

  /* 611 */
  /* 612 */
, /* 141 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ModalHeader;
  exports.headerPropTypes = exports.headerDefaultProps = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Tooltip = _interopRequireDefault(__webpack_require__(40));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _functions = __webpack_require__(33);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ModalHeader(props) {
    var $tip = null,
      $close = null,
      $fullScreen = null,
      $icon = null,
      fsDirection = props.isFullScreen ? "right" : "left",
      buttonClass = "c-header-buttons";
    if (props.tip) {
      $tip = /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], _extends({}, props.tip, {
        iconSize: "medium"
      }));
    }
    if (props.xClose) {
      buttonClass += " has-close";
      // We use a button here because we want the control to be focusable
      $close = /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "c-button--close",
        onClick: props.onClose
      }, /*#__PURE__*/_react["default"].createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "is-hidden"
      }, "Close"));
    }
    if (props.allowFullScreen) {
      buttonClass += " has-full-screen";
      $fullScreen = /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "c-button--full-screen",
        onClick: props.onToggleFullScreen
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "fas fa-angle-double-".concat(fsDirection)
      }));
    }
    if (props.icon) {
      $icon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: props.icon
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "c-modal__header ".concat(props.className)
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: "c-heading-descriptive",
      title: props.title
    }, $icon, props.title, $tip), /*#__PURE__*/_react["default"].createElement("div", {
      className: buttonClass
    }, $fullScreen, $close));
  }
  var headerPropTypes = {
    /** The title to display*/
    title: _propTypes["default"].string.isRequired,
    /** What (if any) tooltip should be displayed */
    tip: _propTypes["default"].shape({
      description: _propTypes["default"].string,
      inline: _propTypes["default"].bool,
      direction: _propTypes["default"].oneOf(['left', 'right', 'top', 'bottom']),
      size: _propTypes["default"].oneOf(['small', 'medium', 'large', 'xlarge', 'fit'])
    }),
    /** Should the "x" icon to close the modal show up*/
    xClose: _propTypes["default"].bool,
    /** The function to call when hitting the "x" button */
    onClose: _propTypes["default"].func,
    /** Should the modal be allowed to go Full Screen */
    allowFullScreen: _propTypes["default"].bool,
    /** Is the modal currently in full screen mode */
    isFullScreen: _propTypes["default"].bool,
    /** The function to call when the modal toggles between full screen */
    onToggleFullScreen: _propTypes["default"].func,
    /** Extra custom class(es) to be applied to the Control */
    className: _propTypes["default"].string,
    /** Icon to show in front of the modal title */
    icon: _propTypes["default"].string
  };
  exports.headerPropTypes = headerPropTypes;
  var headerDefaultProps = {
    className: "",
    // title:null,
    tip: null,
    xClose: true,
    // onClose:noop,
    allowFullScreen: true,
    isFullScreen: false,
    onToggleFullScreen: _functions.noop,
    icon: null
  };
  exports.headerDefaultProps = headerDefaultProps;
  ModalHeader.propTypes = headerPropTypes;
  ModalHeader.defaultProps = headerDefaultProps;

  /***/
}, /* 142 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ModalFooter;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function ModalFooter(props) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "c-modal__footer flex-center ".concat(props.className)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "c-actions-bar flex-between"
    }, props.children));
  }
  ModalFooter.propTypes = {
    /* Children necessary for the footer */
    children: _propTypes["default"].node.isRequired,
    /* Additional classname to add to the footer div*/
    className: _propTypes["default"].string
  };
  ModalFooter.defaultProps = {
    className: ""
  };

  /***/
}, /* 143 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(144);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 144 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * Button.css\n */\nbutton:focus,\nbutton:active,\ninput:focus,\ninput:active {\n\toutline:none !important;\n\tbox-shadow: none !important;\n}\n\n.c-button {\n\tfont-weight: bold;\n\ttext-transform: capitalize;\n\tborder: 2px solid transparent;\n}\n\n.c-button:not(:disabled).is-hover,\n.c-button:not(:disabled):hover { background-color: #374047; }\n\n.c-actions-bar .c-actions-bar__element.c-button { display: flex; }\n\n.c-button.is-loading { cursor: not-allowed; }\n\n.c-button--small {\n\theight: 26px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tline-height: normal;\n\tpadding: 0 16px;\n}\n.c-button--small > .ft-ic {\n\tmargin-left: -4px;\n\tmargin-right: 4px;\n}\n.c-button--small.is-drop-down-button .split-icon { margin-left:3px;  }\n\n\n/**\n * @3. Split Button\n **/\n\n.split-button {\n\tdisplay:flex;\n\talign-items:center;\n}\n\n.split-button .c-button {\n\tborder:2px solid transparent;\n\tborder-top-right-radius:0;\n\tborder-bottom-right-radius:0;\n\tpadding:0 15px;\n\tmargin-right: 1px !important;\n}\n\n.split-button .split-side {\n\tborder:2px solid transparent;\n\tborder-top-right-radius:3px;\n\tborder-bottom-right-radius:3px;\n\theight:100%;\n\tdisplay:flex;\n\twidth:35px;\n\tbox-shadow:-1px 0px 0px 0px #fff;\n}\n\n.c-button,\n.split-button .split-side {\n\ttransition: 0.2s background-color, border-color;\n}\n\n.c-button:not(.is-disabled).t-button--green:hover {\n\tbackground-color:#349448 !important;\n\tborder-color: transparent;\n}\n.split-button.t-theme--green .split-side:active,\n.split-button.t-theme--green .split-side:focus { border-color:#006b1b; }\n.split-button.t-theme--green .split-side:hover { background-color:#006b1b; }\n.split-button.t-theme--green .split-side.is-disabled { background-color: #9fdaab; }\n\n.split-button.t-theme--blue .split-side { background-color:#2d7ebf; }\n.split-button.t-theme--blue .split-side:hover { background-color:#00447a; }\n.split-button.t-theme--blue .split-side:active,\n.split-button.t-theme--blue .split-side:focus { border-color:#00447a; }\n.split-button.t-theme--blue .split-side.is-disabled { background-color: #b8d1e5; }\n\n.split-button .split-side .split-icon { color: #fff; }\n\n.split-side .split-actions {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n}\n.split-side .action-kebab::after { display:none; }\n\n/**\n * @3.2 Icon Only Split Button\n **/\n.c-button.is-split-button.split-only { padding: 0; }\n.c-button.split-only .split-side { margin-left: 0; }\n.c-button.split-only .split-side .action-kebab { box-shadow: none; }\n\n/**\n * @3.3 Drop Down Button\n */\n.c-button.is-drop-down-button .split-icon {\n\tmargin-left: 0.5rem;\n\tmargin-right: 0;\n}\n\n/**\n * @4. Modal/Blade Buttons\n **/\n.c-actions-bar .c-button {\n\theight: 36px;\n\tline-height: normal;\n\tmargin: 0;\n\tpadding: 0 15px;\n\tfont-size: 14px;\n\tfont-weight: normal;\n}\n.c-actions-bar .c-button--small {\n\theight: 26px;\n}\n\n\n/**\n * @5. Colors\n **/\n.c-button.is-disabled {\n\tcursor: not-allowed;\n\tcolor: #fff;\n}\n\n/**\n * Green Buttons\n */\n.c-button.t-button--green { background-color: #52bc68; }\n.c-button:not(.is-disabled).t-button--green:focus {\n\tborder-color: transparent;\n\tbackground-color: #52bc68;\n}\n.c-button.is-disabled.t-button--green { background-color: #9fdaab; }\n\n/**\n * Blue Buttons\n */\n.c-button.t-button--blue {\n\tborder-radius: 3px;\n\tbackground-color: #2d7ebf;\n}\n.c-button:not(.is-disabled).t-button--blue:active,\n.c-button:not(.is-disabled).t-button--blue:focus {\n\tborder-color: transparent;\n\tbackground-color: #2d7ebf;\n}\n.c-button:not(.is-disabled).t-button--blue:hover { background-color: #00447a; }\n .c-button.is-disabled.t-button--blue { background-color: #b8d1e5; }\n\n/**\n * Red Buttons\n */\n.c-button:not(.is-disabled).t-button--red:hover {\n\tbackground-color: #a1100e;\n}\n\n/**\n * Grey Buttons\n */\n.t-button--default { background-color: #858c90; }\n.t-button--default:not(:disabled):focus {\n\tborder-color: transparent;\n\tbackground-color:#858c90;\n}\n.t-button--default:not(:disabled).is-hover,\n.t-button--default:not(:disabled):hover {\n\tborder-color:transparent;\n\tbackground-color: #374047;\n}\n.t-button--default.is-disabled { background-color: #d6d8da; }\n", "", {
    "version": 3,
    "sources": ["Button.css"],
    "names": [],
    "mappings": "AAAA;;EAEE;AACF;;;;CAIC,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;iCACiC,yBAAyB,EAAE;;AAE5D,kDAAkD,aAAa,EAAE;;AAEjE,uBAAuB,mBAAmB,EAAE;;AAE5C;CACC,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;AACA,mDAAmD,eAAe,GAAG;;;AAGrE;;GAEG;;AAEH;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;CAC5B,yBAAyB;CACzB,4BAA4B;CAC5B,cAAc;CACd,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;CAC3B,8BAA8B;CAC9B,WAAW;CACX,YAAY;CACZ,UAAU;CACV,gCAAgC;AACjC;;AAEA;;CAEC,+CAA+C;AAChD;;AAEA;CACC,mCAAmC;CACnC,yBAAyB;AAC1B;AACA;iDACiD,oBAAoB,EAAE;AACvE,iDAAiD,wBAAwB,EAAE;AAC3E,uDAAuD,yBAAyB,EAAE;;AAElF,0CAA0C,wBAAwB,EAAE;AACpE,gDAAgD,wBAAwB,EAAE;AAC1E;gDACgD,oBAAoB,EAAE;AACtE,sDAAsD,yBAAyB,EAAE;;AAEjF,wCAAwC,WAAW,EAAE;;AAErD;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;AACZ;AACA,mCAAmC,YAAY,EAAE;;AAEjD;;GAEG;AACH,uCAAuC,UAAU,EAAE;AACnD,mCAAmC,cAAc,EAAE;AACnD,iDAAiD,gBAAgB,EAAE;;AAEnE;;EAEE;AACF;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;;GAEG;AACH;CACC,YAAY;CACZ,mBAAmB;CACnB,SAAS;CACT,eAAe;CACf,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,YAAY;AACb;;;AAGA;;GAEG;AACH;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;;EAEE;AACF,4BAA4B,yBAAyB,EAAE;AACvD;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA,wCAAwC,yBAAyB,EAAE;;AAEnE;;EAEE;AACF;CACC,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA,mDAAmD,yBAAyB,EAAE;CAC7E,uCAAuC,yBAAyB,EAAE;;AAEnE;;EAEE;AACF;CACC,yBAAyB;AAC1B;;AAEA;;EAEE;AACF,qBAAqB,yBAAyB,EAAE;AAChD;CACC,yBAAyB;CACzB,wBAAwB;AACzB;AACA;;CAEC,wBAAwB;CACxB,yBAAyB;AAC1B;AACA,iCAAiC,yBAAyB,EAAE",
    "file": "Button.css",
    "sourcesContent": ["/**\n * Button.css\n */\nbutton:focus,\nbutton:active,\ninput:focus,\ninput:active {\n\toutline:none !important;\n\tbox-shadow: none !important;\n}\n\n.c-button {\n\tfont-weight: bold;\n\ttext-transform: capitalize;\n\tborder: 2px solid transparent;\n}\n\n.c-button:not(:disabled).is-hover,\n.c-button:not(:disabled):hover { background-color: #374047; }\n\n.c-actions-bar .c-actions-bar__element.c-button { display: flex; }\n\n.c-button.is-loading { cursor: not-allowed; }\n\n.c-button--small {\n\theight: 26px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tline-height: normal;\n\tpadding: 0 16px;\n}\n.c-button--small > .ft-ic {\n\tmargin-left: -4px;\n\tmargin-right: 4px;\n}\n.c-button--small.is-drop-down-button .split-icon { margin-left:3px;  }\n\n\n/**\n * @3. Split Button\n **/\n\n.split-button {\n\tdisplay:flex;\n\talign-items:center;\n}\n\n.split-button .c-button {\n\tborder:2px solid transparent;\n\tborder-top-right-radius:0;\n\tborder-bottom-right-radius:0;\n\tpadding:0 15px;\n\tmargin-right: 1px !important;\n}\n\n.split-button .split-side {\n\tborder:2px solid transparent;\n\tborder-top-right-radius:3px;\n\tborder-bottom-right-radius:3px;\n\theight:100%;\n\tdisplay:flex;\n\twidth:35px;\n\tbox-shadow:-1px 0px 0px 0px #fff;\n}\n\n.c-button,\n.split-button .split-side {\n\ttransition: 0.2s background-color, border-color;\n}\n\n.c-button:not(.is-disabled).t-button--green:hover {\n\tbackground-color:#349448 !important;\n\tborder-color: transparent;\n}\n.split-button.t-theme--green .split-side:active,\n.split-button.t-theme--green .split-side:focus { border-color:#006b1b; }\n.split-button.t-theme--green .split-side:hover { background-color:#006b1b; }\n.split-button.t-theme--green .split-side.is-disabled { background-color: #9fdaab; }\n\n.split-button.t-theme--blue .split-side { background-color:#2d7ebf; }\n.split-button.t-theme--blue .split-side:hover { background-color:#00447a; }\n.split-button.t-theme--blue .split-side:active,\n.split-button.t-theme--blue .split-side:focus { border-color:#00447a; }\n.split-button.t-theme--blue .split-side.is-disabled { background-color: #b8d1e5; }\n\n.split-button .split-side .split-icon { color: #fff; }\n\n.split-side .split-actions {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n}\n.split-side .action-kebab::after { display:none; }\n\n/**\n * @3.2 Icon Only Split Button\n **/\n.c-button.is-split-button.split-only { padding: 0; }\n.c-button.split-only .split-side { margin-left: 0; }\n.c-button.split-only .split-side .action-kebab { box-shadow: none; }\n\n/**\n * @3.3 Drop Down Button\n */\n.c-button.is-drop-down-button .split-icon {\n\tmargin-left: 0.5rem;\n\tmargin-right: 0;\n}\n\n/**\n * @4. Modal/Blade Buttons\n **/\n.c-actions-bar .c-button {\n\theight: 36px;\n\tline-height: normal;\n\tmargin: 0;\n\tpadding: 0 15px;\n\tfont-size: 14px;\n\tfont-weight: normal;\n}\n.c-actions-bar .c-button--small {\n\theight: 26px;\n}\n\n\n/**\n * @5. Colors\n **/\n.c-button.is-disabled {\n\tcursor: not-allowed;\n\tcolor: #fff;\n}\n\n/**\n * Green Buttons\n */\n.c-button.t-button--green { background-color: #52bc68; }\n.c-button:not(.is-disabled).t-button--green:focus {\n\tborder-color: transparent;\n\tbackground-color: #52bc68;\n}\n.c-button.is-disabled.t-button--green { background-color: #9fdaab; }\n\n/**\n * Blue Buttons\n */\n.c-button.t-button--blue {\n\tborder-radius: 3px;\n\tbackground-color: #2d7ebf;\n}\n.c-button:not(.is-disabled).t-button--blue:active,\n.c-button:not(.is-disabled).t-button--blue:focus {\n\tborder-color: transparent;\n\tbackground-color: #2d7ebf;\n}\n.c-button:not(.is-disabled).t-button--blue:hover { background-color: #00447a; }\n .c-button.is-disabled.t-button--blue { background-color: #b8d1e5; }\n\n/**\n * Red Buttons\n */\n.c-button:not(.is-disabled).t-button--red:hover {\n\tbackground-color: #a1100e;\n}\n\n/**\n * Grey Buttons\n */\n.t-button--default { background-color: #858c90; }\n.t-button--default:not(:disabled):focus {\n\tborder-color: transparent;\n\tbackground-color:#858c90;\n}\n.t-button--default:not(:disabled).is-hover,\n.t-button--default:not(:disabled):hover {\n\tborder-color:transparent;\n\tbackground-color: #374047;\n}\n.t-button--default.is-disabled { background-color: #d6d8da; }\n"]
  }]);

  /***/
}, /* 145 */
/***/function (module, exports, __webpack_require__) {
  var arrayEach = __webpack_require__(185),
    baseEach = __webpack_require__(186),
    castFunction = __webpack_require__(264),
    isArray = __webpack_require__(44);

  /**
   * Iterates over elements of `collection` and invokes `iteratee` for each element.
   * The iteratee is invoked with three arguments: (value, index|key, collection).
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * **Note:** As with other "Collections" methods, objects with a "length"
   * property are iterated like arrays. To avoid this behavior use `_.forIn`
   * or `_.forOwn` for object iteration.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @alias each
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Array|Object} Returns `collection`.
   * @see _.forEachRight
   * @example
   *
   * _.forEach([1, 2], function(value) {
   *   console.log(value);
   * });
   * // => Logs `1` then `2`.
   *
   * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
   *   console.log(key);
   * });
   * // => Logs 'a' then 'b' (iteration order is not guaranteed).
   */
  function forEach(collection, iteratee) {
    var func = isArray(collection) ? arrayEach : baseEach;
    return func(collection, castFunction(iteratee));
  }
  module.exports = forEach;

  /***/
}, /* 146 */
/***/function (module, exports, __webpack_require__) {
  var baseIsArguments = __webpack_require__(256),
    isObjectLike = __webpack_require__(62);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };
  module.exports = isArguments;

  /***/
}, /* 147 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (module) {
    var root = __webpack_require__(50),
      stubFalse = __webpack_require__(259);

    /** Detect free variable `exports`. */
    var freeExports = true && exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Built-in value references. */
    var Buffer = moduleExports ? root.Buffer : undefined;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;

    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(47)(module));

  /***/
}, /* 148 */
/***/function (module, exports) {
  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  module.exports = isIndex;

  /***/
}, /* 149 */
/***/function (module, exports) {
  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  module.exports = isLength;

  /***/
}, /* 150 */
/***/function (module, exports) {
  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }
  module.exports = baseUnary;

  /***/
}, /* 151 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (module) {
    var freeGlobal = __webpack_require__(188);

    /** Detect free variable `exports`. */
    var freeExports = true && exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Detect free variable `process` from Node.js. */
    var freeProcess = moduleExports && freeGlobal.process;

    /** Used to access faster Node.js helpers. */
    var nodeUtil = function () {
      try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) {
          return types;
        }

        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();
    module.exports = nodeUtil;

    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(47)(module));

  /***/
}, /* 152 */
/***/function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  module.exports = isPrototype;

  /***/
}, /* 153 */
/***/function (module, exports, __webpack_require__) {
  var baseIsEqualDeep = __webpack_require__(265),
    isObjectLike = __webpack_require__(62);

  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  module.exports = baseIsEqual;

  /***/
}, /* 154 */
/***/function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(101),
    stackClear = __webpack_require__(271),
    stackDelete = __webpack_require__(272),
    stackGet = __webpack_require__(273),
    stackHas = __webpack_require__(274),
    stackSet = __webpack_require__(275);

  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }

  // Add methods to `Stack`.
  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  module.exports = Stack;

  /***/
}, /* 155 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(75),
    root = __webpack_require__(50);

  /* Built-in method references that are verified to be native. */
  var Map = getNative(root, 'Map');
  module.exports = Map;

  /***/
}, /* 156 */
/***/function (module, exports, __webpack_require__) {
  var mapCacheClear = __webpack_require__(280),
    mapCacheDelete = __webpack_require__(287),
    mapCacheGet = __webpack_require__(289),
    mapCacheHas = __webpack_require__(290),
    mapCacheSet = __webpack_require__(291);

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  module.exports = MapCache;

  /***/
}, /* 157 */
/***/function (module, exports) {
  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
      length = values.length,
      offset = array.length;
    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }
  module.exports = arrayPush;

  /***/
}, /* 158 */
/***/function (module, exports, __webpack_require__) {
  var arrayFilter = __webpack_require__(301),
    stubArray = __webpack_require__(198);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeGetSymbols = Object.getOwnPropertySymbols;

  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */
  var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function (symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };
  module.exports = getSymbols;

  /***/
}, /* 159 */
/***/function (module, exports) {
  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);
    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }
  module.exports = arrayMap;

  /***/
}, /* 160 */
/***/function (module, exports, __webpack_require__) {
  var overArg = __webpack_require__(190);

  /** Built-in value references. */
  var getPrototype = overArg(Object.getPrototypeOf, Object);
  module.exports = getPrototype;

  /***/
}, /* 161 */
/***/function (module, exports, __webpack_require__) {
  var Uint8Array = __webpack_require__(195);

  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }
  module.exports = cloneArrayBuffer;

  /***/
}, /* 162 */
/***/function (module, exports, __webpack_require__) {
  var isArray = __webpack_require__(44),
    isSymbol = __webpack_require__(163);

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */
  function isKey(value, object) {
    if (isArray(value)) {
      return false;
    }
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  module.exports = isKey;

  /***/
}, /* 163 */
/***/function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(80),
    isObjectLike = __webpack_require__(62);

  /** `Object#toString` result references. */
  var symbolTag = '[object Symbol]';

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
  }
  module.exports = isSymbol;

  /***/
}, /* 164 */
/***/function (module, exports, __webpack_require__) {
  var castPath = __webpack_require__(108),
    toKey = __webpack_require__(89);

  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */
  function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0,
      length = path.length;
    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }
    return index && index == length ? object : undefined;
  }
  module.exports = baseGet;

  /***/
}, /* 165 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  // Shim to avoid requiring Velocity in Node environments, since it
  // requires window. Note that this just no-ops the components so
  // that they'll render, rather than doing something clever like
  // statically rendering the end state of any provided animations.
  //
  // TODO(finneganh): Circle back on jsdom to see if we can run full
  // Velocity with it in place. This come up in:
  // https://github.com/twitter-fabric/velocity-react/issues/119
  // but there may have been different loading issues in that case,
  // not a global incompatibility with jsdom.
  if (typeof window === 'undefined' || typeof navigator === 'undefined' || navigator.userAgent.indexOf('Node.js') !== -1 || navigator.userAgent.indexOf('jsdom') !== -1) {
    var Velocity = function Velocity() {};
    Velocity.Utilities = {};
    Velocity.Utilities.removeData = function () {};
    Velocity.velocityReactServerShim = true;
    module.exports = Velocity;
  } else {
    // this is how velocity-ui finds the Velocity instance, so lets make sure we find the right instance
    var g = window.jQuery || window.Zepto || window;

    // require Velocity if it doesn't already exist
    module.exports = g.Velocity ? g.Velocity : __webpack_require__(239);
  }

  /***/
}, /* 166 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames5 = _interopRequireDefault(__webpack_require__(6));
  var _SharedPropTypes = __webpack_require__(27);
  var _generateUnique = _interopRequireDefault(__webpack_require__(56));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _Input = _interopRequireDefault(__webpack_require__(87));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  __webpack_require__(55);
  __webpack_require__(129);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var Tag = /*#__PURE__*/function (_React$Component) {
    _inherits(Tag, _React$Component);
    var _super = _createSuper(Tag);
    function Tag(props, context) {
      var _this;
      _classCallCheck(this, Tag);
      _this = _super.call(this, props, context);
      _this.state = {
        value: props.value,
        editing: props.editable && !props.value.length
      };
      _this.UID = (0, _generateUnique["default"])(props);
      return _this;
    }
    _createClass(Tag, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if (this.state.value !== nextProps.value) {
          this.setState({
            value: nextProps.value,
            editing: nextProps.editable && !nextProps.value.length
          });
        }
      }
    }, {
      key: "_removeTag",
      value: function _removeTag(event) {
        var oldValue = this.state.value,
          value = '',
          newState = {
            oldValue: oldValue,
            value: value
          };
        event.stopPropagation();
        if (this.props.editable) {
          newState.editing = !this.state.editing;
        }
        this.setState(newState,
        //set the state to this
        this._continueRemove //then call this function
        );
      }
    }, {
      key: "_continueRemove",
      value: function _continueRemove(removeValue) {
        if (this.props.onRemove) {
          this.props.onRemove(this, this.state.oldValue);
        }
      }
    }, {
      key: "_onInputChange",
      value: function _onInputChange(e) {
        var value = e.target.value,
          oldValue = this.state.value,
          newState = {
            oldValue: oldValue,
            value: value
          };
        if (value.length) {
          newState.editing = !this.state.editing;
        }
        this.setState(newState,
        //set the state to this
        this._onChange //then call this function
        );
      }
    }, {
      key: "_onChange",
      value: function _onChange() {
        if (this.props.onChange) {
          this.props.onChange(this, this.state.value, this.state.oldValue);
        }
      }
    }, {
      key: "_renderTag",
      value: function _renderTag() {
        var _classnames,
          _classnames2,
          _classnames3,
          _this2 = this;
        var _this$props = this.props,
          theme = _this$props.theme,
          size = _this$props.size,
          style = _this$props.style,
          allowRemove = _this$props.allowRemove,
          allowClick = _this$props.allowClick,
          onRemove = _this$props.onRemove,
          editable = _this$props.editable,
          themeCls = (0, _classnames5["default"])((_classnames = {
            editable: editable
          }, _defineProperty(_classnames, "t-badge--".concat(theme), style === ''), _defineProperty(_classnames, "c-badge--ghost", style === 'ghost'), _defineProperty(_classnames, "t-badge--ghost-".concat(theme), style === 'ghost'), _defineProperty(_classnames, "c-badge--subtle", style === 'subtle'), _defineProperty(_classnames, "t-badge--subtle-".concat(theme), style === 'subtle'), _classnames)),
          badgeCls = (0, _classnames5["default"])((_classnames2 = {
            "c-tag": true,
            "c-tag--removable": allowRemove,
            "c-tag--clickable": allowClick,
            "c-badge": true,
            "flex-center": true
          }, _defineProperty(_classnames2, "c-badge--".concat(size), true), _defineProperty(_classnames2, themeCls, true), _classnames2)),
          removeCls = (0, _classnames5["default"])((_classnames3 = {
            "c-tag-remove": true,
            // "c-badge": true,
            editable: editable
          }, _defineProperty(_classnames3, "t-tag-remove--".concat(theme), style === ''), _defineProperty(_classnames3, "t-tag-remove--ghost-".concat(theme), style === 'ghost'), _defineProperty(_classnames3, "t-tag-remove--subtle-".concat(theme), style === 'subtle'), _classnames3)),
          remove = null,
          onClick = function onClick(event) {
            if (_this2.props.editable) {
              _this2.setState({
                editing: !_this2.state.editing
              });
            } else if (_this2.props.allowClick) {
              if (typeof _this2.props.onClick === 'function') {
                _this2.props.onClick(event);
              }
            }
          };
        if (allowRemove) {
          remove = /*#__PURE__*/_react["default"].createElement("span", {
            className: removeCls,
            "aria-hidden": true,
            title: "Remove",
            onClick: function onClick(event) {
              return _this2._removeTag(event);
            }
          }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            name: "clearCircle"
          }));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: badgeCls,
          onClick: onClick
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "c-tag-label",
          title: this.state.value
        }, this.state.value), remove);
      }
    }, {
      key: "_renderInput",
      value: function _renderInput() {
        var _this3 = this;
        var _this$props2 = this.props,
          theme = _this$props2.theme,
          placeholder = _this$props2.placeholder,
          inputProps = _this$props2.inputProps;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "c-tag-input"
        }, /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
          UID: this.UID,
          theme: theme,
          placeholder: placeholder,
          name: "taginput",
          defaultValue: this.state.value,
          onBlur: function onBlur(e) {
            return _this3._onInputChange(e);
          }
        }, inputProps)));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
          editable = _this$props3.editable,
          className = _this$props3.className,
          editing = this.state.editing,
          tagCls = (0, _classnames5["default"])(_defineProperty({
            "tag-component": true
          }, className, true));
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: tagCls
        }, editable && editing ? this._renderInput() : this._renderTag());
      }
    }]);
    return Tag;
  }(_react["default"].Component);
  exports["default"] = Tag;
  _defineProperty(Tag, "propTypes", {
    /** Value to display in the tag.  Can be changed via the input IF editable is true */
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    /** theme/color for the tag/input */
    theme: _SharedPropTypes.PROPTYPE_THEME,
    /** size of the tag */
    size: _propTypes["default"].oneOf(['small', 'medium', 'large', 'xlarge']),
    /** style of the tag */
    style: _propTypes["default"].oneOf(['', 'ghost', 'subtle']),
    /** Is the tag allowed to be removed? */
    allowRemove: _propTypes["default"].bool,
    /** what to do when the tag is removed */
    onRemove: _propTypes["default"].func,
    /** is the tag editable? */
    editable: _propTypes["default"].bool,
    /** placeholder to show in the input when editing */
    placeholder: _propTypes["default"].string,
    /** class to add to the tag */
    className: _propTypes["default"].string,
    /** additional props to pass to the edit input */
    inputProps: _propTypes["default"].object
  });
  _defineProperty(Tag, "defaultProps", {
    value: "",
    theme: 'default',
    size: 'small',
    style: "",
    allowRemove: false,
    editable: false,
    placeholder: 'Enter tag value',
    className: "",
    inputProps: {}
  });

  /***/
}, /* 167 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.CheckboxList = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _lodash = __webpack_require__(57);
  var _ControlWrapper = _interopRequireDefault(__webpack_require__(29));
  var _Search = _interopRequireDefault(__webpack_require__(113));
  var _functions = __webpack_require__(33);
  var _Tooltip = _interopRequireDefault(__webpack_require__(40));
  __webpack_require__(55);
  __webpack_require__(213);
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var CHECK_TYPES = {
    /** Label to display on the given checkbox */
    label: _propTypes["default"].string.isRequired,
    /** Name to attach the value to in a JSON structure */
    name: _propTypes["default"].string.isRequired,
    /** Value of this checkbox to either enable, or disable */
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    /** Should this checkbox be disabled or not*/
    disabled: _propTypes["default"].bool,
    /** should the checkbox be checked or not */
    checked: _propTypes["default"].bool
  };
  function getValue(attr) {
    return attr;
  }

  /**
   * Creates a checkbox or radio input.
   */
  var CheckboxList = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    _inherits(CheckboxList, _React$Component);
    var _super = _createSuper(CheckboxList);
    function CheckboxList(props, context) {
      var _this;
      _classCallCheck(this, CheckboxList);
      _this = _super.call(this, props, context);
      var items = _toConsumableArray(props.items),
        value = (0, _lodash.isArray)(props.value) ? props.value : [props.value];
      items.forEach(function (v) {
        return v.visible = true;
      });
      _this.state = {
        searchValue: "",
        value: value,
        items: items
      };
      return _this;
    }
    _createClass(CheckboxList, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;
        var _this$state = this.state,
          value = _this$state.value,
          items = _this$state.items,
          searchValue = _this$state.searchValue,
          newState = {},
          i,
          j;

        // if the new values are different from the old values, change them
        if (value.length !== nextProps.value.length) {
          newState.value = nextProps.value;
        } else {
          for (i = 0; i < value.length; i++) {
            /* eslint-disable */
            if (value[i] != nextProps.value[i]) {
              newState.value = nextProps.value;
              break;
            }
            /* eslint-enable */
          }
        }

        // if the new items are different from the old items, change them
        if (items.length !== nextProps.items.length) {
          newState.items = nextProps.items;
        } else {
          for (j = 0; j < items.length; j++) {
            /* eslint-disable */
            if (items[j] != nextProps.items[j]) {
              newState.items = nextProps.items;
              break;
            }
            /* eslint-enable */
          }
        }

        if (newState.items || newState.value) {
          this.setState(newState, function () {
            // make sure the showing items are filtered correctly after setting new items
            _this2.filterList(searchValue);
          });
        }
      } //end componentWillReceiveProps()
    }, {
      key: "onItemChange",
      value: function onItemChange(e) {
        var me = this,
          _me$props = me.props,
          name = _me$props.name,
          type = _me$props.type,
          getValue = _me$props.getValue,
          mapValues = _me$props.mapValues,
          items = _me$props.items,
          isConnected = _me$props.isConnected,
          isRedux = _me$props.isRedux,
          onChange = _me$props.onChange,
          allValues = [].concat(me.state.value),
          _e$target = e.target,
          value = _e$target.value,
          checked = _e$target.checked;
        if (/radio/gi.test(type)) {
          allValues = [value];
        } else {
          if (!checked) {
            /* eslint-disable */
            allValues = allValues.filter(function (v) {
              return getValue(v) != value;
            }); //since value can be a number or a string !== may fail
            /* eslint-enable */
          } else {
            allValues.push(value);
          }
        }
        if (mapValues) {
          allValues = allValues.map(function (v) {
            return mapValues(v, items);
          });
        }
        me.setState({
          value: allValues
        });
        if (isRedux) {
          // Redux-form controls expect onChange to take the new value
          onChange(allValues);
        } else {
          if (isConnected) {
            onChange(e);
          } else {
            onChange(name, allValues);
          }
        }
      }
    }, {
      key: "selectAll",
      value: function selectAll() {
        if (!this.props.disabled) {
          var _this$props = this.props,
            name = _this$props.name,
            isRedux = _this$props.isRedux,
            onChange = _this$props.onChange,
            newValue = this.state.items.filter(function (item) {
              return item.visible;
            }).map(function (item) {
              return item.value;
            });
          this.setState({
            value: newValue
          });
          if (isRedux) {
            onChange(newValue);
          } else {
            onChange(name, newValue);
          }
        }
      }
    }, {
      key: "deselectAll",
      value: function deselectAll() {
        if (!this.props.disabled) {
          var _this$props2 = this.props,
            name = _this$props2.name,
            isRedux = _this$props2.isRedux,
            onChange = _this$props2.onChange;
          this.setState({
            value: []
          });
          if (isRedux) {
            onChange([]);
          } else {
            onChange(name, []);
          }
        }
      }
    }, {
      key: "filterList",
      value: function filterList(searchValue) {
        if (typeof searchValue === 'string') {
          var search = searchValue.toLocaleLowerCase();
          var searchTerms = [];
          if (search.indexOf(',') >= 0) {
            //Splits on comma, trims whitespace, and removes empty strings from array (which would match all items so is bad)
            searchTerms = search.split(',').map(function (term) {
              return term.trim();
            }).filter(function (i) {
              return i;
            });
          } else {
            searchTerms.push(search);
          }
          var items = this.state.items.map(function (item) {
            item.visible = false;
            ['label', 'value'].forEach(function (key) {
              // No need to keep searching if already found match
              if (!item.visible) {
                var value = (0, _lodash.get)(item, key, '').toString().toLocaleLowerCase();
                for (var term in searchTerms) {
                  if (value.indexOf(searchTerms[term]) >= 0) {
                    item.visible = true;
                    break;
                  }
                }
              }
            });
            return item;
          });
          this.setState({
            items: items,
            searchValue: searchValue
          });
        }
      }
    }, {
      key: "_renderSearch",
      value: function _renderSearch() {
        var props = this.props,
          search = null;
        if (!props.isSearchable) {
          return null;
        }
        search = props.onSearch ? props.onSearch : this.filterList;
        return /*#__PURE__*/_react["default"].createElement(_Search["default"], {
          className: "search-header",
          onSearch: search,
          searchValue: this.state.searchValue
        });
      }
    }, {
      key: "_renderSelectAll",
      value: function _renderSelectAll() {
        var showSelectAll = this.props.showSelectAll,
          $all = null,
          linkClass = (0, _classnames["default"])("select-all-link", {
            "is-disabled": this.props.disabled
          });
        if (showSelectAll) {
          $all = /*#__PURE__*/_react["default"].createElement("div", {
            className: "select-all-wrapper"
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: linkClass,
            onClick: this.selectAll
          }, "Select all"), /*#__PURE__*/_react["default"].createElement("span", {
            className: "select-all-separator"
          }, "|"), /*#__PURE__*/_react["default"].createElement("span", {
            className: linkClass,
            onClick: this.deselectAll
          }, "Deselect all"));
        }
        return $all;
      }
    }, {
      key: "_renderItems",
      value: function _renderItems() {
        var me = this,
          _me$props2 = me.props,
          UID = _me$props2.UID,
          type = _me$props2.type,
          items = _me$props2.items,
          name = _me$props2.name,
          disabled = _me$props2.disabled,
          isGridLayout = _me$props2.isGridLayout,
          value = me.state.value,
          renderItems = items.filter(function (v) {
            return v.visible;
          });
        return renderItems.map(function (v, i) {
          var itemUID = "".concat(UID, "-item-").concat(i),
            inputProps = {
              value: v.value,
              label: v.label,
              type: type,
              name: name,
              checked: value.indexOf(getValue(v.value)) > -1,
              id: itemUID,
              disabled: disabled || v.disabled,
              onChange: me.onItemChange
            },
            $content = null,
            $tooltip = v.tip && v.tip.description && v.tip.description.length ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], _extends({}, v.tip, {
              key: "tip"
            })) : null,
            labelClass = (0, _classnames["default"])("e-form__".concat(type, "--label"), {
              "is-disabled": disabled || v.disabled
            }),
            itemClass = (0, _classnames["default"])("e-form__control checkbox-item", {
              "is-disabled": disabled || v.disabled
            });
          if (isGridLayout) {
            $content = [/*#__PURE__*/_react["default"].createElement("span", {
              key: "label",
              className: labelClass
            }, v.label), $tooltip];
          } else {
            $content = /*#__PURE__*/_react["default"].createElement("span", {
              key: "label",
              className: labelClass
            }, v.label, $tooltip);
          }
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: itemClass,
            key: v.value
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "e-form__".concat(type),
            htmlFor: itemUID,
            title: v.label
          }, /*#__PURE__*/_react["default"].createElement("input", inputProps), /*#__PURE__*/_react["default"].createElement("span", {
            className: "e-form__".concat(type, "--bg")
          }), $content));
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _classes;
        var props = this.props,
          classes = (_classes = {
            "e-form__control": true,
            "checkbox-list": true
          }, _defineProperty(_classes, "type-".concat(props.type), true), _defineProperty(_classes, "is-grid", props.isGridLayout), _classes);
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])(classes)
        }, this._renderSearch(), this._renderSelectAll(), /*#__PURE__*/_react["default"].createElement("div", {
          className: "list-items"
        }, this._renderItems()));
      }
    }]);
    return CheckboxList;
  }(_react["default"].Component), _defineProperty(_class2, "displayName", "CheckboxList"), _defineProperty(_class2, "defaultProps", {
    type: "checkbox",
    label: "",
    name: "",
    value: [],
    disabled: false,
    onChange: _functions.noop,
    items: [],
    isSearchable: true,
    onSearch: null,
    showSelectAll: true,
    isGridLayout: false,
    isConnected: false,
    isRedux: false,
    mapValues: null,
    getValue: getValue
  }), _defineProperty(_class2, "propTypes", {
    /** Should we render a checkbox, or a radio button */
    type: _propTypes["default"].oneOf(['checkbox', 'radio']),
    /** Label to display on the given checkbox */
    label: _propTypes["default"].string.isRequired,
    /** Name to attach the value to in a JSON structure */
    name: _propTypes["default"].string.isRequired,
    /** Value of this checkbox to either enable, or disable */
    value: _propTypes["default"].array,
    //array of strings or numbers

    /** Function to call when the element is clicked */
    onChange: _propTypes["default"].func.isRequired,
    /** Should this checkbox be disabled or not */
    disabled: _propTypes["default"].bool,
    /**	Individual items to render */
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape(CHECK_TYPES)).isRequired,
    /** Can we search the list */
    isSearchable: _propTypes["default"].bool,
    /**	Search function to overwrite the built in search function */
    onSearch: _propTypes["default"].func,
    /** Should Select/Deselect All links be shown? */
    showSelectAll: _propTypes["default"].bool,
    /** Should we use a grid based layout for the Checkboxes */
    isGridLayout: _propTypes["default"].bool,
    /** How do we determine if something is selected or not */
    getValue: _propTypes["default"].func,
    isConnected: _propTypes["default"].bool,
    /** Is this component hooked up to Redux-Form?  If so we need to pass through the onChange differently */
    isRedux: _propTypes["default"].bool,
    mapValues: _propTypes["default"].func
  }), _class2), (_applyDecoratedDescriptor(_class.prototype, "onItemChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onItemChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectAll", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "selectAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deselectAll", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "deselectAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filterList", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "filterList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderSearch", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderSelectAll", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderSelectAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderItems", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderItems"), _class.prototype)), _class);
  /**
   * Creates a CheckboxList for use as a control in a form
   */
  exports.CheckboxList = CheckboxList;
  var _default = (0, _ControlWrapper["default"])(CheckboxList);
  exports["default"] = _default;

  /***/
}, /* 168 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _moment = _interopRequireDefault(__webpack_require__(28));
  var _reactDatepicker = _interopRequireDefault(__webpack_require__(241));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _ControlWrapper = _interopRequireWildcard(__webpack_require__(29));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  __webpack_require__(232);
  __webpack_require__(234);
  var _class, _class2, _class3;
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  /**
   * KNOWN ISSUES:
   *	- when allowing use of keyboard to select dates in the calendar
   *		- possible to select invalid dates
   *		- impossible to use arrow keys in the input itself
   *	- when datepicker is open, click on select, datepicker closes then select opens then select closes then datepicker opens (https://github.com/Hacker0x01/react-datepicker/issues/730)
   */

  /* the default behavior of react-datepicker is to go off screen if its near the edge */
  function repositionDatePicker() {
    //needs to be async because if called synchronously react-datepicker-popper won't exist yet
    setTimeout(function () {
      var EXTRA_PADDING = 10;
      var TRIANGLE_OFFSET = 50;
      var elements = document.getElementsByClassName('react-datepicker-popper'),
        datepicker = null;
      if (elements && elements.length > 0) {
        var _elements = _slicedToArray(elements, 1);
        datepicker = _elements[0];
      }
      if (datepicker) {
        var rect = datepicker.getBoundingClientRect();
        var isOffscreen = rect.right > window.innerWidth;
        if (isOffscreen) {
          var overflowAmount = window.innerWidth - rect.right;
          datepicker.getElementsByClassName('react-datepicker__triangle')[0].style.left = "".concat((overflowAmount - EXTRA_PADDING) * -1 + TRIANGLE_OFFSET, "px");
          datepicker.style.left = "".concat(overflowAmount - EXTRA_PADDING, "px");
        }
      }
    }, 0);
  }
  var Dates = (0, _ControlWrapper["default"])(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
    _inherits(Dates, _React$Component);
    var _super = _createSuper(Dates);
    function Dates(props, context) {
      var _this;
      _classCallCheck(this, Dates);
      _this = _super.call(this, props, context);
      _defineProperty(_assertThisInitialized(_this), "state", {
        date: null,
        startDate: null,
        endDate: null
      });
      if (props.value) {
        if (props.isRange) {
          if (props.value.startDate && props.value.startDate !== _ControlWrapper.MULTIPLE_ENTRIES) {
            _this.state.startDate = (0, _moment["default"])(props.value.startDate);
          }
          if (props.value.endDate && props.value.endDate !== _ControlWrapper.MULTIPLE_ENTRIES) {
            _this.state.endDate = (0, _moment["default"])(props.value.endDate);
          }
        } else if (props.value !== _ControlWrapper.MULTIPLE_ENTRIES) {
          _this.state.date = (0, _moment["default"])(props.value);
        }
      }
      return _this;
    }
    _createClass(Dates, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        repositionDatePicker();
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var newState = {};
        if (nextProps.value) {
          if (this.props.isRange) {
            if (nextProps.value.startDate && nextProps.startDate !== _ControlWrapper.MULTIPLE_ENTRIES) {
              newState.startDate = (0, _moment["default"])(nextProps.value.startDate);
            }
            if (nextProps.value.endDate && nextProps.endDate !== _ControlWrapper.MULTIPLE_ENTRIES) {
              newState.endDate = (0, _moment["default"])(nextProps.value.endDate);
            }
          } else if (nextProps.value !== _ControlWrapper.MULTIPLE_ENTRIES) {
            newState.date = (0, _moment["default"])(nextProps.value);
          }
        }
        this.setState(newState);
        // var { props } = this
        // 	, pValue = props.value || null
        // 	, { value } = nextProps
        // 	, newState = {}
        // 	;

        // if(pValue === null){ return ; }

        // if(props.isRange) {
        // 	if(value.startDate !== pValue.startDate){ newState.startDate = value.startDate; }
        // 	if(value.endDate !== pValue.endDate){ newState.endDate = value.endDate; }
        // }else {
        // 	if(value !== pValue) { newState.date = value; }
        // }

        // if(typeof(newState.startDate) === "object" || typeof(newState.endDate) === "object"){
        // 	this.setState(newState);
        // }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        repositionDatePicker();
      }
    }, {
      key: "_isValidDate",
      value: function _isValidDate(value) {
        var _this$props = this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          dateFormat = _this$props.dateFormat,
          mValue = (0, _moment["default"])(value, dateFormat[0]),
          mMin = minDate ? (0, _moment["default"])(minDate, dateFormat[0]) : null,
          mMax = maxDate ? (0, _moment["default"])(maxDate, dateFormat[0]) : null,
          isAfterMin = mMin ? mValue.isSameOrAfter(mMin, "day") : true,
          isBeforeMax = mMax ? mValue.isSameOrBefore(mMax, "day") : true,
          matchesFormat = false;
        if (!mValue.isValid()) {
          return false;
        }
        if (!(isAfterMin && isBeforeMax)) {
          return false;
        }
        if (typeof value === "string") {
          dateFormat.forEach(function (format) {
            if (mValue.format(format) === value) {
              matchesFormat = true;
            }
          });
          return matchesFormat;
        }
        return true;
      }
    }, {
      key: "handleBlur",
      value: function handleBlur(e) {
        var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        if (e && e.target) {
          if (!this._isValidDate(e.target.value)) {
            this["handleChange".concat(field)](null);
            this["_datePicker".concat(field)].clear();
          }
        }
      }
    }, {
      key: "handleChangeRaw",
      value: function handleChangeRaw(e) {
        var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        if (e && e.target) {
          var value = e.target.value,
            dateFormat = this.props.dateFormat;
          if (this._isValidDate(value)) {
            this["handleChange".concat(field)]((0, _moment["default"])(value, dateFormat[0]));
          }
        }
      }
    }, {
      key: "handleChangeStart",
      value: function handleChangeStart(startDate) {
        var props = this.props,
          state = this.state,
          obj = {
            startDate: this._isValidDate(startDate) ? startDate.clone() : null,
            endDate: state.endDate ? state.endDate.clone() : null
          };
        this.setState(obj, props.onChange(obj));
      }
    }, {
      key: "handleChangeEnd",
      value: function handleChangeEnd(endDate) {
        var props = this.props,
          state = this.state,
          obj = {
            startDate: state.startDate ? state.startDate.clone() : null,
            endDate: this._isValidDate(endDate) ? endDate.clone() : null
          };
        this.setState(obj, props.onChange(obj));
      }
    }, {
      key: "handleChange",
      value: function handleChange(date) {
        this.setState({
          date: date
        }, this.props.onChange(date));
      }
    }, {
      key: "_renderRange",
      value: function _renderRange() {
        var _this2 = this;
        var props = this.props,
          state = this.state,
          theme = props.theme || this.context.rhombusTheme,
          pickerProps = _objectSpread({
            startDate: state.startDate,
            endDate: state.endDate,
            showMonthDropdown: props.showMonthDropdown,
            showYearDropdown: props.showYearDropdown,
            dateFormat: props.dateFormat,
            monthsShown: props.monthsShown
          }, props.dateProps),
          startProps = _objectSpread({
            selected: state.startDate,
            onChange: this.handleChangeStart,
            onChangeRaw: function onChangeRaw(e) {
              _this2.handleChangeRaw(e, "Start");
            },
            onBlur: function onBlur(e) {
              _this2.handleBlur(e, "Start");
            },
            placeholderText: "Start Date",
            disabled: props.disabled || props.startDisabled,
            isClearable: !props.disabled && !props.startDisabled && props.isClearable,
            ref: function ref(dp) {
              _this2._datePickerStart = dp;
            }
          }, props.startProps),
          endProps = _objectSpread({
            selected: state.endDate,
            onChange: this.handleChangeEnd,
            onChangeRaw: function onChangeRaw(e) {
              _this2.handleChangeRaw(e, "End");
            },
            onBlur: function onBlur(e) {
              _this2.handleBlur(e, "End");
            },
            placeholderText: "End Date",
            disabled: props.disabled || props.endDisabled,
            isClearable: !props.disabled && !props.endDisabled && props.isClearable,
            ref: function ref(dp) {
              _this2._datePickerEnd = dp;
            }
          }, props.endProps);
        if (props.minDate) {
          pickerProps.minDate = (0, _moment["default"])(props.minDate, props.dateFormat[0]);
        }
        if (props.maxDate) {
          pickerProps.maxDate = (0, _moment["default"])(props.maxDate, props.dateFormat[0]);
        }
        if (state.endDate) {
          startProps.maxDate = props.isSameDateAllowed ? state.endDate.clone() : state.endDate.clone().subtract(1, "days");
        }
        if (state.startDate) {
          endProps.minDate = props.isSameDateAllowed ? state.startDate.clone() : state.startDate.clone().add(1, "days");
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "e-form__control date-range rr-".concat(theme, " months-shown-").concat(props.monthsShown),
          onMouseDown: repositionDatePicker
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "rhombus-date-picker-wrapper".concat(props.multipleValues === 'startDate' || props.multipleValues === true ? ' multiple-values' : '')
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          name: "calendar",
          className: "rhombus-date-picker-icon"
        }), /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], _extends({
          selectsStart: true
        }, pickerProps, startProps))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "to-div"
        }, "to"), /*#__PURE__*/_react["default"].createElement("div", {
          className: "rhombus-date-picker-wrapper".concat(props.multipleValues === 'endDate' || props.multipleValues === true ? ' multiple-values' : '')
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          name: "calendar",
          className: "rhombus-date-picker-icon"
        }), /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], _extends({
          selectsEnd: true
        }, pickerProps, endProps))));
      }
    }, {
      key: "_renderSingle",
      value: function _renderSingle() {
        var _this3 = this;
        var props = this.props,
          state = this.state,
          theme = props.theme || this.context.rhombusTheme,
          pickerProps = {
            selected: state.date,
            onChange: this.handleChange,
            onChangeRaw: function onChangeRaw(e) {
              _this3.handleChangeRaw(e);
            },
            onBlur: function onBlur(e) {
              _this3.handleBlur(e);
            },
            placeholderText: "Date",
            disabled: props.disabled,
            isClearable: !props.disabled && props.isClearable,
            showMonthDropdown: props.showMonthDropdown,
            showYearDropdown: props.showYearDropdown,
            ref: function ref(dp) {
              _this3._datePicker = dp;
            },
            dateFormat: props.dateFormat
          };
        if (props.minDate) {
          pickerProps.minDate = (0, _moment["default"])(props.minDate, props.dateFormat[0]);
        }
        if (props.maxDate) {
          pickerProps.maxDate = (0, _moment["default"])(props.maxDate, props.dateFormat[0]);
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "e-form__control date-picker rr-".concat(theme)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "rhombus-date-picker-wrapper"
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          name: "calendar",
          className: "rhombus-date-picker-icon"
        }), /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], _extends({}, pickerProps, props.dateProps))));
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.isRange ? this._renderRange() : this._renderSingle();
      }
    }]);
    return Dates;
  }(_react["default"].Component), _defineProperty(_class3, "displayName", 'Dates'), _defineProperty(_class3, "defaultProps", {
    value: null,
    isRange: true,
    //is this a date range, or a single picker?
    onChange: function onChange() {},
    // <DatePicker/> props
    dateFormat: ["MM/DD/YYYY", "MM-DD-YYYY", "MM.DD.YYYY", "MM/D/YYYY", "MM-D-YYYY", "MM.D.YYYY", "M/DD/YYYY", "M-D-YYYY", "M-D-YYYY", "M/D/YYYY", "M-D-YYYY", "M.D.YYYY"],
    disabled: false,
    //is the entire control disabled?
    startDisabled: false,
    //is the start date specifically disabled?
    endDisabled: false,
    //is the end date specifically disabled?
    isSameDateAllowed: false,
    //are the start and end dates allowed to be the same?
    // isClearable:       true,
    showMonthDropdown: true,
    showYearDropdown: true,
    monthsShown: 1,
    minDate: null,
    //earliest allowed date - null for no minimum
    maxDate: null,
    //latest allowed date - null for no maximum
    // any additional props to send to DatePicker - see https://github.com/Hacker0x01/react-datepicker/blob/master/docs/datepicker.md
    dateProps: {},
    startProps: {},
    endProps: {}
  }), _defineProperty(_class3, "propTypes", {
    disabled: _propTypes["default"].bool
  }), _defineProperty(_class3, "contextTypes", {
    rhombusTheme: _propTypes["default"].oneOf(["default", "primary", "white", "blue", "purple", "pink", "orange", "green", "red", "grey", "yellow"])
  }), _class3), (_applyDecoratedDescriptor(_class2.prototype, "handleBlur", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "handleBlur"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleChangeRaw", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "handleChangeRaw"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleChangeStart", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "handleChangeStart"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleChangeEnd", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "handleChangeEnd"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "handleChange"), _class2.prototype)), _class2)) || _class;
  exports["default"] = Dates;

  /***/
}, /* 169 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "polyfill", function () {
    return polyfill;
  });
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) {
      this.setState(state);
    }
  }
  function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
      var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
      return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
  }
  function componentWillUpdate(nextProps, nextState) {
    try {
      var prevProps = this.props;
      var prevState = this.state;
      this.props = nextProps;
      this.state = nextState;
      this.__reactInternalSnapshotFlag = true;
      this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally {
      this.props = prevProps;
      this.state = prevState;
    }
  }

  // React may warn about cWM/cWRP/cWU methods being deprecated.
  // Add a flag to suppress these warnings for this special case.
  componentWillMount.__suppressDeprecationWarning = true;
  componentWillReceiveProps.__suppressDeprecationWarning = true;
  componentWillUpdate.__suppressDeprecationWarning = true;
  function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) {
      throw new Error('Can only polyfill class components');
    }
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
      return Component;
    }

    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') {
      foundWillMountName = 'componentWillMount';
    } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
      foundWillMountName = 'UNSAFE_componentWillMount';
    }
    if (typeof prototype.componentWillReceiveProps === 'function') {
      foundWillReceivePropsName = 'componentWillReceiveProps';
    } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
      foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    }
    if (typeof prototype.componentWillUpdate === 'function') {
      foundWillUpdateName = 'componentWillUpdate';
    } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
      foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    }
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
      var componentName = Component.displayName || Component.name;
      var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
      throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }

    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
      prototype.componentWillMount = componentWillMount;
      prototype.componentWillReceiveProps = componentWillReceiveProps;
    }

    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
      if (typeof prototype.componentDidUpdate !== 'function') {
        throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
      }
      prototype.componentWillUpdate = componentWillUpdate;
      var componentDidUpdate = prototype.componentDidUpdate;
      prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
        // 16.3+ will not execute our will-update method;
        // It will pass a snapshot value to did-update though.
        // Older versions will require our polyfilled will-update value.
        // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
        // Because for <= 15.x versions this might be a "prevContext" object.
        // We also can't just check "__reactInternalSnapshot",
        // Because get-snapshot might return a falsy value.
        // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
        var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
        componentDidUpdate.call(this, prevProps, prevState, snapshot);
      };
    }
    return Component;
  }

  /***/
}, /* 170 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _reduxForm = __webpack_require__(115);
  var _ControlWrapper = _interopRequireDefault(__webpack_require__(29));
  var _DefaultRow = _interopRequireDefault(__webpack_require__(182));
  var _Button = _interopRequireDefault(__webpack_require__(61));
  var _excluded = ["name", "component", "onChange", "onRemove", "manuallyAddRow"];
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  /**************** 
   * RowController
   * This component is basically a wrapper for a <FieldArray/>, with an optional button to add another row (Field)
   * The component for the <FieldArray/> defaults to <DefaultRow/> or can be passed in
   * manuallyAddRow defaults to false
   *			This means the that row component will auto-add an empty row when the last existing row is filled out.
   *			In this case, the row component is expected to enforce the max number of rows (where -1 is no max)
   * If manuallyAddRow is true
   *			A function can be passed in to render a custom component to handle the adding of a new row, otherwise an "Add Row" button is rendered.
   *			Because we don't have access to the values in this component, the max cannot be enforced here.
   * If we want the component to show the Add button and enforce a max
   *			Enforce max by disabling the add button		-- pass in addButtonProps: { disabled: true }	-- to be safe, also enforce the max in the onAdd function passed in
   *			Enforce max by not rendering the add button	-- pass in manuallyAddRow: false
   ****************/
  var RowController = (0, _ControlWrapper["default"])(_class = (_class2 = /*#__PURE__*/function (_Component) {
    _inherits(RowController, _Component);
    var _super = _createSuper(RowController);
    function RowController() {
      _classCallCheck(this, RowController);
      return _super.apply(this, arguments);
    }
    _createClass(RowController, [{
      key: "_renderAddRow",
      value: function _renderAddRow() {
        var _this = this;
        var _this$props = this.props,
          onAdd = _this$props.onAdd,
          manuallyAddRow = _this$props.manuallyAddRow,
          addRowLabel = _this$props.addRowLabel,
          defaultNewItem = _this$props.defaultNewItem,
          addButtonProps = _this$props.addButtonProps,
          disabled = _this$props.disabled,
          name = _this$props.name,
          $btn = null;
        if (typeof addRowLabel === "function") {
          $btn = addRowLabel();
        } else {
          $btn = /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
            className: "add-row",
            icon: "add",
            theme: "grey",
            onClick: function onClick() {
              _this.props.onAdd(name, -1, defaultNewItem);
            }
          }, addButtonProps, {
            disabled: disabled || addButtonProps.disabled
          }), addRowLabel);
        }
        return $btn;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          name = _this$props2.name,
          component = _this$props2.component,
          onChange = _this$props2.onChange,
          onRemove = _this$props2.onRemove,
          manuallyAddRow = _this$props2.manuallyAddRow,
          props = _objectWithoutProperties(_this$props2, _excluded),
          $add = manuallyAddRow && !props.readOnly ? this._renderAddRow() : null;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "row-controller"
        }, /*#__PURE__*/_react["default"].createElement(_reduxForm.FieldArray, _extends({
          name: name,
          component: component
        }, props, {
          type: name,
          onChange: onChange,
          onRemove: onRemove
        })), $add);
      }
    }]);
    return RowController;
  }(_react.Component), _defineProperty(_class2, "displayName", "RowController"), _defineProperty(_class2, "propTypes", {
    onChange: _propTypes["default"].func,
    onRemove: _propTypes["default"].func,
    onAdd: _propTypes["default"].func,
    manuallyAddRow: _propTypes["default"].bool,
    addRowLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
    addButtonProps: _propTypes["default"].object,
    name: _propTypes["default"].string
  }), _defineProperty(_class2, "defaultProps", {
    component: _DefaultRow["default"],
    onChange: function onChange() {},
    onRemove: function onRemove() {},
    onAdd: function onAdd() {},
    manuallyAddRow: false,
    addRowLabel: "Add Row",
    defaultNewItem: {},
    addButtonProps: {}
  }), _class2)) || _class;
  exports["default"] = RowController;

  /***/
}, /* 171 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _ControlWrapper = _interopRequireDefault(__webpack_require__(29));
  var _excluded = ["UID", "offLabel", "onLabel", "value", "getValue"];
  var _class, _class2, _class3;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  // TODO: also export plain toggle without the Control Wrapper

  function _renderLabel(message, UID) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "off";
    return message ? /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: UID,
      className: "".concat(type, "-label display-label")
    }, message) : null;
  }
  var Toggle = (0, _ControlWrapper["default"])(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
    _inherits(Toggle, _React$Component);
    var _super = _createSuper(Toggle);
    function Toggle() {
      var _this;
      _classCallCheck(this, Toggle);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", {
        isFocused: false
      });
      return _this;
    }
    _createClass(Toggle, [{
      key: "onFocus",
      value: function onFocus() {
        this.setState({
          isFocused: true
        });
      }
    }, {
      key: "onBlur",
      value: function onBlur() {
        this.setState({
          isFocused: false
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          UID = _this$props.UID,
          offLabel = _this$props.offLabel,
          onLabel = _this$props.onLabel,
          value = _this$props.value,
          getValue = _this$props.getValue,
          remainderProps = _objectWithoutProperties(_this$props, _excluded),
          inputProps = _objectSpread(_objectSpread({}, remainderProps), {}, {
            value: value,
            type: "checkbox",
            checked: getValue(this.props),
            id: UID,
            onFocus: this.onFocus,
            onBlur: this.onBlur
          }),
          focusCls = this.state.isFocused ? "is-focused" : "";
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "e-form__control toggle-control ".concat(focusCls)
        }, _renderLabel(offLabel, UID, "off"), /*#__PURE__*/_react["default"].createElement("label", {
          className: "e-form__toggle e-form__toggle--positive",
          htmlFor: UID
        }, /*#__PURE__*/_react["default"].createElement("input", inputProps), /*#__PURE__*/_react["default"].createElement("div", {
          className: "e-form__toggle--bg"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "e-form__toggle--handle"
        }))), _renderLabel(onLabel, UID, "on"));
      }
    }]);
    return Toggle;
  }(_react["default"].Component), _defineProperty(_class3, "displayName", "Toggle"), _defineProperty(_class3, "defaultProps", {
    label: "",
    name: "",
    value: "",
    disabled: false,
    onChange: function onChange() {},
    offLabel: null,
    onLabel: null,
    getValue: function getValue(props) {
      return props.value;
    }
  }), _defineProperty(_class3, "propTypes", {
    /** Label to display in the control wrapper */
    label: _propTypes["default"].string.isRequired,
    /** Name to attach the value to in a JSON structure */
    name: _propTypes["default"].string.isRequired,
    /** Value of this checkbox to either enable, or disable */
    value: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
    /** Function to call when the element is clicked */
    onChange: _propTypes["default"].func.isRequired,
    /** Should this Toggle be disabled or not*/
    disabled: _propTypes["default"].bool,
    /**	Should there be a label for the "off" position? (To the left of the toggle) */
    offLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].element]),
    /**	Should there be a label for the "on" position? (To the right of the toggle) */
    onLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].element])
  }), _class3), (_applyDecoratedDescriptor(_class2.prototype, "onFocus", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onFocus"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onBlur", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onBlur"), _class2.prototype)), _class2)) || _class;
  exports["default"] = Toggle;

  /***/
}, /* 172 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.TagGroup = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _SharedPropTypes = __webpack_require__(27);
  var _ControlWrapper = _interopRequireDefault(__webpack_require__(29));
  var _Tag = _interopRequireDefault(__webpack_require__(166));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  __webpack_require__(55);
  __webpack_require__(129);
  __webpack_require__(215);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  /**
   * NOTE:
   *	when using this component as part of a Redux form (as a component in a <Field/>)
   *	make sure to import tagGroupFormatter
   *	and include on the Field:
   *	format={tagGroupFormatter}
   */
  var TagGroup = /*#__PURE__*/function (_React$Component) {
    _inherits(TagGroup, _React$Component);
    var _super = _createSuper(TagGroup);
    function TagGroup(props, context) {
      var _this;
      _classCallCheck(this, TagGroup);
      _this = _super.call(this, props, context);
      _this.state = {
        value: props.value
      };
      return _this;
    }
    _createClass(TagGroup, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var value = nextProps.value,
          pv = this.props.value,
          sv = this.state.value,
          diffPv = value.length !== pv.length,
          diffSv = value.length !== sv.length;
        if (!diffPv || !diffSv) {
          value.forEach(function (v, i) {
            if (v !== pv[i]) {
              diffPv = true;
            }
            if (v !== sv[i]) {
              diffSv = true;
            }
          });
        }
        if (diffPv && diffSv) {
          this.setState({
            value: value
          });
        }
      }
    }, {
      key: "_addTag",
      value: function _addTag() {
        var newValue = this.state.value.slice(); //copy value array

        newValue.push('');
        this.setState({
          value: newValue
        });
        if (this.props.onChange) {
          this.props.onChange(newValue);
        }
      }
    }, {
      key: "_removeTag",
      value: function _removeTag(ind) {
        var newValue = this.state.value.slice();
        newValue.splice(ind, 1);
        this.setState({
          value: newValue
        });
        if (this.props.onChange) {
          this.props.onChange(newValue);
        }
      }
    }, {
      key: "_updateTag",
      value: function _updateTag(ind, tag, value, oldValue) {
        var allowDuplicates = this.props.allowDuplicates,
          newValue = this.state.value.slice();
        if (!allowDuplicates && newValue.indexOf(value) > -1) {
          console.warn("".concat(value, " already exists in this tag group and will not be added"));
        } else {
          newValue.splice(ind, 1, value);
        }
        this.setState({
          value: newValue
        });
        this.forceUpdate();
        if (this.props.onChange) {
          this.props.onChange(newValue);
        }
      }
    }, {
      key: "_renderTags",
      value: function _renderTags() {
        var _this2 = this;
        var value = this.state.value,
          _this$props = this.props,
          theme = _this$props.theme,
          size = _this$props.size,
          style = _this$props.style,
          placeholder = _this$props.placeholder,
          inputProps = _this$props.inputProps,
          tags = value.map(function (val, i) {
            var key = "".concat(val, "-").concat(i);
            return /*#__PURE__*/_react["default"].createElement(_Tag["default"], {
              key: key,
              value: val,
              theme: theme,
              size: size,
              style: style,
              placeholder: placeholder,
              allowRemove: true,
              editable: true,
              onRemove: function onRemove(tag, value) {
                return _this2._removeTag(i);
              },
              onChange: function onChange(tag, value, oldValue) {
                return _this2._updateTag(i, tag, value, oldValue);
              },
              inputProps: inputProps
            });
          });
        return tags;
      }
    }, {
      key: "_renderAdd",
      value: function _renderAdd() {
        var _this3 = this;
        var $add = null,
          value = this.state.value,
          maxTags = this.props.maxTags;
        if (maxTags === -1 || value.length < maxTags) {
          $add = /*#__PURE__*/_react["default"].createElement("div", {
            className: "add-tag group-section"
          }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            name: "add",
            size: "small",
            onClick: function onClick() {
              return _this3._addTag();
            }
          }));
        }
        return $add;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
          label = _this$props2.label;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "tag-group ".concat(className)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "group-label group-section"
        }, label), /*#__PURE__*/_react["default"].createElement("div", {
          className: "group-tags group-section"
        }, this._renderTags()), this._renderAdd());
      }
    }]);
    return TagGroup;
  }(_react["default"].Component);
  /**
   * Creates a tag group for use as a control in a form
   */
  exports.TagGroup = TagGroup;
  _defineProperty(TagGroup, "displayName", 'TagGroup');
  _defineProperty(TagGroup, "propTypes", {
    /** form label for the tag group */
    label: _propTypes["default"].string,
    /** theme/color for the tag/input */
    theme: _SharedPropTypes.PROPTYPE_THEME,
    /** array of values to set for each tag */
    value: _propTypes["default"].array,
    /** should duplicate tags be allowed? */
    allowDuplicates: _propTypes["default"].bool,
    /** maximum number of tags allowed in the group.  -1 indicates no maximum */
    maxTags: _propTypes["default"].number,
    // tag props:
    /** size of the tags */
    size: _propTypes["default"].oneOf(['small', 'medium', 'large', 'xlarge']),
    /** style for the tags */
    style: _propTypes["default"].oneOf(['', 'ghost', 'subtle']),
    /** placeholder to use when editing tags */
    placeholder: _propTypes["default"].string,
    /** additional props to pass to the edit input of tags */
    inputProps: _propTypes["default"].object
  });
  _defineProperty(TagGroup, "defaultProps", {
    label: "",
    theme: 'default',
    value: [],
    allowDuplicates: false,
    maxTags: -1,
    // tag props:
    size: 'small',
    style: 'ghost',
    placeholder: 'Enter Tag',
    inputProps: {}
  });
  var _default = (0, _ControlWrapper["default"])(TagGroup);
  exports["default"] = _default;

  /***/
}, /* 173 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = Media;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _constants = __webpack_require__(59);
  var _ScaledImage = _interopRequireDefault(__webpack_require__(174));
  var _ScaledVideo = _interopRequireDefault(__webpack_require__(175));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function Media(props) {
    switch (props.adType) {
      case _constants.SOCIAL_AD_TYPES.FACEBOOK_IMAGE:
      case _constants.SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO:
        return /*#__PURE__*/_react["default"].createElement(ImageContent, props);
      case _constants.SOCIAL_AD_TYPES.FACEBOOK_VIDEO:
      case _constants.SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO:
        return /*#__PURE__*/_react["default"].createElement(VideoContent, props);
    }
    return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
      message: "Missing adType"
    });
  }
  function VideoContent(props) {
    if (!props.video) {
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Video Asset"
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_ScaledVideo["default"], props.video);
  }
  function ImageContent(props) {
    if (!props.image) {
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Image Asset"
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_ScaledImage["default"], {
      image: props.image
    });
  }

  /***/
}, /* 174 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ScaledImage;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _socialHelpers = __webpack_require__(46);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  //adjusts images to fit facebook's size and aspect ratio constraints
  function ScaledImage(_ref) {
    var image = _ref.image;
    var name = (image === null || image === void 0 ? void 0 : image.name) || '[Missing Image Name]';
    var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      adjustedDims = _useState2[0],
      setAdjustedDims = _useState2[1];
    var onLoad = function onLoad(_ref2) {
      var img = _ref2.target;
      setAdjustedDims({
        width: _socialHelpers.FACEBOOK_WIDTH,
        height: (0, _socialHelpers.getFBAdjustedHeight)(img.naturalWidth, img.naturalHeight)
      });
    };
    return /*#__PURE__*/_react["default"].createElement("img", {
      key: image.src,
      className: "img-content",
      onLoad: onLoad,
      style: adjustedDims,
      src: image.src || '',
      alt: name
    });
  }

  /***/
}, /* 175 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ScaledVideo;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _socialHelpers = __webpack_require__(46);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  //adjusts video to fit facebook's size and aspect ratio constraints
  //also handles autoplay and looping rules
  function ScaledVideo(_ref) {
    var video = _ref.video,
      image = _ref.image,
      autoPlay = _ref.autoPlay,
      controls = _ref.controls,
      muted = _ref.muted,
      width = _ref.width;
    var _ref2 = video || {},
      src = _ref2.src;
    var thumbnail = image === null || image === void 0 ? void 0 : image.src; // optional thumbnail for carousels

    var videoRef = (0, _react.useRef)(),
      _useState = (0, _react.useState)(1),
      _useState2 = _slicedToArray(_useState, 2),
      currentPlay = _useState2[0],
      setCurrentPlay = _useState2[1],
      _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      maxLoop = _useState4[0],
      setMaxLoop = _useState4[1],
      _useState5 = (0, _react.useState)({
        width: width,
        height: _socialHelpers.FACEBOOK_MIN_HEIGHT
      }),
      _useState6 = _slicedToArray(_useState5, 2),
      adjustedDims = _useState6[0],
      setAdjustedDims = _useState6[1],
      videoProps = _objectSpread(_objectSpread({
        controls: controls,
        autoPlay: autoPlay
      }, adjustedDims), {}, {
        poster: thumbnail
      }),
      videoClass = "video video-content ".concat(!video || !(video !== null && video !== void 0 && video.src) ? 'facebook-missing-video' : '');
    if (typeof muted === 'boolean') {
      videoProps.muted = muted;
    } else {
      videoProps.muted = autoPlay;
    }
    var onLoad = function onLoad(_ref3) {
      var vid = _ref3.target;
      setAdjustedDims({
        width: width,
        height: (0, _socialHelpers.getFBAdjustedHeight)(vid === null || vid === void 0 ? void 0 : vid.videoWidth, vid === null || vid === void 0 ? void 0 : vid.videoHeight)
      });
    };

    /**
     * PRVW-168
     * 	If the video is less than 30s, loop it up to 90s
     * 	ONLY for Facebook Video Creatives
    	 */
    videoProps.onEnded = function () {
      var duration = (0, _socialHelpers.getVideoDuration)(videoRef.current);
      if (duration > 0 && duration < _socialHelpers.FB_LOOP_CUTOFF) {
        var numLoop = Math.floor(_socialHelpers.FB_LOOP_LENGTH / duration);
        setMaxLoop(numLoop);
        setCurrentPlay(currentPlay + 1);
      }
    };
    (0, _react.useEffect)(function () {
      if (currentPlay <= maxLoop) {
        (0, _socialHelpers.playVideo)(videoRef.current);
      }
    }, [currentPlay]);
    return /*#__PURE__*/_react["default"].createElement("video", _extends({
      key: src,
      ref: videoRef
    }, videoProps, {
      onLoadedData: onLoad,
      className: videoClass
    }), /*#__PURE__*/_react["default"].createElement("source", {
      src: src || ""
    }));
  }
  ScaledVideo.displayName = "ScaledVideo";
  ScaledVideo.defaultProps = {
    autoPlay: false,
    controls: true,
    width: _socialHelpers.FACEBOOK_WIDTH
  };

  /***/
}, /* 176 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = useCarousel;
  var _react = __webpack_require__(1);
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function useCarousel(cards, cardIncrement) {
    var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      left = _useState2[0],
      setLeft = _useState2[1];
    var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentCard = _useState4[0],
      setCurrentCard = _useState4[1];
    function nextCard() {
      if (!(cards !== null && cards !== void 0 && cards.length) || currentCard === cards.length - 1) {
        return;
      }
      setCurrentCard(currentCard + 1);
      setLeft(left - cardIncrement);
    }
    function prevCard() {
      if (!(cards !== null && cards !== void 0 && cards.length) || currentCard === 0) {
        return;
      }
      setCurrentCard(currentCard - 1);
      setLeft(left + cardIncrement);
    }
    function selectCard(card) {
      if (!(cards !== null && cards !== void 0 && cards.length)) {
        return;
      }
      setCurrentCard(card === null || card === void 0 ? void 0 : card.order);
      setLeft((card === null || card === void 0 ? void 0 : card.order) * -cardIncrement);
    }
    return {
      nextCard: nextCard,
      prevCard: prevCard,
      selectCard: selectCard,
      left: left,
      currentCard: currentCard
    };
  }

  /***/
}, /* 177 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var _defineProperty = __webpack_require__(523);
  var _defineProperty2 = _interopRequireDefault(_defineProperty);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.default = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  /***/
}, /* 178 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(179);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 179 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * Form Styles\n */\n.redux-form-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n}\n\n.form-content {\n\theight: calc(100% - 44px);\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow-y: scroll;\n}\n\n.form-content .c-cards { margin: 1rem 0; }\n\n.redux-form-container .e-form__control-wrapper {\n\tmargin: 1rem;\n}\n\n.e-form__control.with-icon {\n\tdisplay: flex;\n\talign-items: center;\n\tborder: 1px solid #aeb2b5;\n\tborder-radius: 3px;\n}\n\n.e-form__control.with-icon .ft-ic,\n.e-form__control.with-icon input:first-child{\n\tmargin-left: 5px;\n}\n.e-form__control.with-icon .inline-content {\n\tmargin-left: 5px;\n\tmargin-right: 5px;\n\tline-height: 2.125rem;\n\twhite-space: nowrap;\n}\n.e-form__control.with-icon .e-form__input {\n\tborder: none;\n\tpadding-left: 3px;\n}\n\n.e-form__control-wrapper.text-area-control,\n.e-form__control.is-text-area {\theight: 100%; }\n.e-form__control.is-text-area { position:relative; }\n\n/**\n * Checkbox Form Styles\n */\n.e-form__control-wrapper.has-label.checkbox-component .e-form__control,\n.e-form__control-wrapper.no-label.checkbox-component{\n\tdisplay: flex;\n}\n.e-form__control-wrapper.has-label.checkbox-component .e-form__control .u-form__help,\n.e-form__control-wrapper.no-label.checkbox-component .e-form__control-header{\n\torder: 2;\n\tmargin-left: 10px;\n}\n.e-form__control-wrapper.checkbox-component .e-form__checkbox .e-form__checkbox--label{\n\tfont-size: 12px;\n\tcolor: #374047;\n\tmargin-left: 7px;\n}\n.e-form__control-wrapper.checkbox-component .e-form__control.is-disabled .e-form__checkbox{\n\tcursor: not-allowed;\n}\n.e-form__control-wrapper.checkbox-component .e-form__control.is-disabled .e-form__checkbox .e-form__checkbox--label{\n\tcolor: #858c90;\n}\n.e-form__control-wrapper.no-label.checkbox-component .e-form__checkbox .e-form__checkbox--label{\n\tline-height: 2.5;\n}\n\n/**\n * Form Label\n */\n.e-form__control-wrapper .e-form__control-label {\n\tdisplay:flex;\n\talign-items:center;\n\tcolor: #4a4a4a;\n\tfont-weight: bold;\n\tfont-size: 12px;\n}\n\n/**\n * Form Messages\n */\n.e-form--error .e-form__control-label {\n\tcolor: #db6662;\n}\n.e-form--has-message .warning-message {\n\tcolor: #db6662;\n\tfont-size: 12px;\n}\n.e-form--has-message .warning-message.has-warning {\n\tcolor: #f3824f;\n}\n.e-form--has-message .warning-message.has-error {\n\tcolor: #db6662;\n}\n.e-form--has-message .e-form__control {\n\tmargin-bottom: 4px;\n}\n\n\n.e-form--warn .e-form__control-label {\n\tcolor:#f3824f;\n}\n\n.e-form--warn .e-form__input {\n\tbackground-color: #fff;\n\tborder-color: #f3824f;\n\tbox-shadow: inset 0 0 0 1px #f3824f;\n}\n\n.e-form__control-wrapper.required .e-form__control-label::after{\n\tcontent: \" *\";\n}\n\n/**\n * Form Warning/Error/Valid States\n */\ninput:not([disabled]):active, input:not([disabled]):focus { border-color:#aeb2b5 !important }\n\n.e-form__control-wrapper .e-form__control-label::after {\n\tfont-family: \"Font Awesome 5 Pro\";\n\tpadding-left: 0.15rem;\n\tpadding-bottom: 0.5rem;\n\tfont-size: 6px;\n\ttransition: 0.25s ease;\n}\n\n.e-form__control-wrapper.required .e-form__control-label::after,\n.e-form__control-wrapper.required.e-form--pristine .e-form__control-label::after {\n\tcontent: \"\\f005\";\n\tcolor:#d0021b;\n}\n\n.e-form__control-wrapper.required.e-form--valid .e-form__control-label::after,\n.e-form__control-wrapper.required.e-form--valid.e-form--pristine .e-form__control-label::after{\n\tcontent: \"\\f00c\";\n\tcolor: #40b658;\n\tfont-weight: 900;\n}\n\n.e-form__control-wrapper .char-count {\n\tflex-grow: 1;\n\ttext-align: right;\n\tfont-size: 11px;\n\tcolor: #858c90;\n\topacity: 1;\n\ttransition: 0.25s ease;\n}\n.e-form__control-wrapper .char-count.invalid {\n\tcolor: #d95652;\n\topacity: 1;\n}\n.e-form__control-wrapper .char-count.hidden {\n\topacity: 0;\n}\n\n.e-form__control-wrapper.required.e-form--error .e-form__control-label::after,\n.e-form__control-wrapper.required.e-form--pristine.e-form--error .e-form__control-label::after {\n\tcontent: \"\\f071\";\n\tcolor: #d95652;\n\tfont-weight: 900;\n}\n.e-form__control-wrapper.required.e-form--warn .e-form__control-label::after,\n.e-form__control-wrapper.required.e-form--pristine.e-form--warn .e-form__control-label::after {\n\tcontent: \"\\f06a\";\n\tcolor: #f3824f;\n\tfont-weight: 900;\n}\n.e-form--warn .e-form__input[disabled]{ background-color: #e0e5ee; }\n\n.e-form--error .e-form__control.with-icon {\n\tborder: 1px solid #db6662;\n\tbox-shadow: inset 0 0 0 1px #db6662;\n}\n\n.e-form--warn .e-form__control.with-icon {\n\tborder: 1px solid #f3824f;\n\tbox-shadow: inset 0 0 0 1px #f3824f;\n}\n\n.e-form--error .e-form__control.with-icon input,\n.e-form--warn .e-form__control.with-icon input {\n\tborder: none;\n\tbox-shadow: none;\n\tmargin: 1px; /* Without this margin, the input blocks its container's inset box-shadow */\n}\n\n.e-form--error .e-form__control.with-icon:focus-within,\n.e-form--warn .e-form__control.with-icon:focus-within {\n\tborder: 1px solid #aeb2b5;\n\tbox-shadow: none;\n}\n\n/**\n * [Multiple Entries] styles\n */\n .e-form__control-wrapper.multiple-values .e-form__control:not(.date-range) {\n \tfont-style: italic;\n }\n\n.e-form__control-wrapper.multiple-values .e-form__control:not(.date-range) .react-datepicker__input-container::after,\n.e-form__control-wrapper.multiple-values .e-form__control.date-range > .multiple-values .react-datepicker__input-container::after {\n\tcontent: '[Multiple Entries]';\n\tbackground-color: #fff;\n\tfont-style: italic;\n\tposition: absolute;\n\tleft: 10px;\n\ttop: 7px;\n}\n\n/**\n * Form Footer\n */\nfooter.form-action-footer {\n\tposition: relative;\n\tleft: inherit;\n\tbottom: inherit;\n\twidth: 100%;\n\t/* Reset rhombus padding */\n\tpadding: 0 20px;\n}\n\n.form-action-footer .actions {\n\tmargin-left: auto;\n\tmargin-right: 1rem;\n}\n\n/**\n * General Form Styles\n */\nbutton:focus,\nbutton:active,\ninput:focus,\ninput:active {\n\toutline:none !important;\n\tbox-shadow: none !important;\n}\n\n/**\n * Radio Buttons\n */\n.e-form__radio [type=radio].is-checked>.e-form__radio--bg,\n.e-form__radio [type=radio].is-checked~.e-form__radio--bg,\n.e-form__radio [type=radio]:checked>.e-form__radio--bg,\n.e-form__radio [type=radio]:checked~.e-form__radio--bg {\n\tbackground-color:#2d7ebf;\n\tborder-color:#2d7ebf;\n}\n.e-form__radio [type=radio].is-checked>.e-form__radio--bg:after,\n.e-form__radio [type=radio].is-checked~.e-form__radio--bg:after,\n.e-form__radio [type=radio]:checked>.e-form__radio--bg:after,\n.e-form__radio [type=radio]:checked~.e-form__radio--bg:after {\n\twidth:6px;\n\theight:6px;\n\tbackground-color:#fff;\n}\n\n\n\n.e-form__control.is-disabled .e-form__radio {\n\tcursor: not-allowed;\n\tcolor: #858c90;\n}\n.e-form__radio [type=radio][disabled]~.e-form__radio--bg {\n\tborder-color: #d6d8da;\n\tbackground-color: #f4f5f5;\n}\n.e-form__radio [type=radio][disabled].is-checked>.e-form__radio--bg,\n.e-form__radio [type=radio][disabled].is-checked~.e-form__radio--bg,\n.e-form__radio [type=radio][disabled]:checked>.e-form__radio--bg,\n.e-form__radio [type=radio][disabled]:checked~.e-form__radio--bg {\n\tbackground-color:#b8d1e5;\n\tborder-color:#b8d1e5;\n}\n\n/**\n * Disabled Styles\n */\n.e-form__checkbox [type=checkbox][disabled]>.e-form__checkbox--bg,\n.e-form__checkbox [type=checkbox][disabled]~.e-form__checkbox--bg,\n.e-form__input[disabled]:active,\n.e-form__input[disabled] {\n\tborder-color: #d6d8da;\n\tbackground-color: #f4f5f5;\n\tcolor: #858c90;\n}\n\n/**\n * Form Tooltips\n */\n.e-form__control-wrapper .e-form__control-header {\n\tdisplay: flex;\n\talign-items: center;\n}\n.e-form__control-wrapper .e-form__control-header .u-form__help {\n\tmargin-left: 5px;\n\tfloat: none;\n}\n", "", {
    "version": 3,
    "sources": ["Form.css"],
    "names": [],
    "mappings": "AAAA;;EAEE;AACF;CACC,aAAa;CACb,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA,yBAAyB,cAAc,EAAE;;AAEzC;CACC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;;CAEC,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;gCACgC,YAAY,EAAE;AAC9C,gCAAgC,iBAAiB,EAAE;;AAEnD;;EAEE;AACF;;CAEC,aAAa;AACd;AACA;;CAEC,QAAQ;CACR,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;AACjB;;AAEA;;EAEE;AACF;CACC,YAAY;CACZ,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,eAAe;AAChB;;AAEA;;EAEE;AACF;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;AACnB;;;AAGA;CACC,aAAa;AACd;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;CACrB,mCAAmC;AACpC;;AAEA;CACC,aAAa;AACd;;AAEA;;EAEE;AACF,4DAA4D,gCAAgC;;AAE5F;CACC,iCAAiC;CACjC,qBAAqB;CACrB,sBAAsB;CACtB,cAAc;CACd,sBAAsB;AACvB;;AAEA;;CAEC,gBAAgB;CAChB,aAAa;AACd;;AAEA;;CAEC,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,UAAU;CACV,sBAAsB;AACvB;AACA;CACC,cAAc;CACd,UAAU;AACX;AACA;CACC,UAAU;AACX;;AAEA;;CAEC,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;AACA;;CAEC,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;AACA,wCAAwC,yBAAyB,EAAE;;AAEnE;CACC,yBAAyB;CACzB,mCAAmC;AACpC;;AAEA;CACC,yBAAyB;CACzB,mCAAmC;AACpC;;AAEA;;CAEC,YAAY;CACZ,gBAAgB;CAChB,WAAW,EAAE,2EAA2E;AACzF;;AAEA;;CAEC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;;EAEE;CACD;EACC,kBAAkB;CACnB;;AAED;;CAEC,6BAA6B;CAC7B,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CACV,QAAQ;AACT;;AAEA;;EAEE;AACF;CACC,kBAAkB;CAClB,aAAa;CACb,eAAe;CACf,WAAW;CACX,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;;EAEE;AACF;;;;CAIC,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;;EAEE;AACF;;;;CAIC,wBAAwB;CACxB,oBAAoB;AACrB;AACA;;;;CAIC,SAAS;CACT,UAAU;CACV,qBAAqB;AACtB;;;;AAIA;CACC,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;;;;CAIC,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;;EAEE;AACF;;;;CAIC,qBAAqB;CACrB,yBAAyB;CACzB,cAAc;AACf;;AAEA;;EAEE;AACF;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,gBAAgB;CAChB,WAAW;AACZ",
    "file": "Form.css",
    "sourcesContent": ["/**\n * Form Styles\n */\n.redux-form-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n}\n\n.form-content {\n\theight: calc(100% - 44px);\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow-y: scroll;\n}\n\n.form-content .c-cards { margin: 1rem 0; }\n\n.redux-form-container .e-form__control-wrapper {\n\tmargin: 1rem;\n}\n\n.e-form__control.with-icon {\n\tdisplay: flex;\n\talign-items: center;\n\tborder: 1px solid #aeb2b5;\n\tborder-radius: 3px;\n}\n\n.e-form__control.with-icon .ft-ic,\n.e-form__control.with-icon input:first-child{\n\tmargin-left: 5px;\n}\n.e-form__control.with-icon .inline-content {\n\tmargin-left: 5px;\n\tmargin-right: 5px;\n\tline-height: 2.125rem;\n\twhite-space: nowrap;\n}\n.e-form__control.with-icon .e-form__input {\n\tborder: none;\n\tpadding-left: 3px;\n}\n\n.e-form__control-wrapper.text-area-control,\n.e-form__control.is-text-area {\theight: 100%; }\n.e-form__control.is-text-area { position:relative; }\n\n/**\n * Checkbox Form Styles\n */\n.e-form__control-wrapper.has-label.checkbox-component .e-form__control,\n.e-form__control-wrapper.no-label.checkbox-component{\n\tdisplay: flex;\n}\n.e-form__control-wrapper.has-label.checkbox-component .e-form__control .u-form__help,\n.e-form__control-wrapper.no-label.checkbox-component .e-form__control-header{\n\torder: 2;\n\tmargin-left: 10px;\n}\n.e-form__control-wrapper.checkbox-component .e-form__checkbox .e-form__checkbox--label{\n\tfont-size: 12px;\n\tcolor: #374047;\n\tmargin-left: 7px;\n}\n.e-form__control-wrapper.checkbox-component .e-form__control.is-disabled .e-form__checkbox{\n\tcursor: not-allowed;\n}\n.e-form__control-wrapper.checkbox-component .e-form__control.is-disabled .e-form__checkbox .e-form__checkbox--label{\n\tcolor: #858c90;\n}\n.e-form__control-wrapper.no-label.checkbox-component .e-form__checkbox .e-form__checkbox--label{\n\tline-height: 2.5;\n}\n\n/**\n * Form Label\n */\n.e-form__control-wrapper .e-form__control-label {\n\tdisplay:flex;\n\talign-items:center;\n\tcolor: #4a4a4a;\n\tfont-weight: bold;\n\tfont-size: 12px;\n}\n\n/**\n * Form Messages\n */\n.e-form--error .e-form__control-label {\n\tcolor: #db6662;\n}\n.e-form--has-message .warning-message {\n\tcolor: #db6662;\n\tfont-size: 12px;\n}\n.e-form--has-message .warning-message.has-warning {\n\tcolor: #f3824f;\n}\n.e-form--has-message .warning-message.has-error {\n\tcolor: #db6662;\n}\n.e-form--has-message .e-form__control {\n\tmargin-bottom: 4px;\n}\n\n\n.e-form--warn .e-form__control-label {\n\tcolor:#f3824f;\n}\n\n.e-form--warn .e-form__input {\n\tbackground-color: #fff;\n\tborder-color: #f3824f;\n\tbox-shadow: inset 0 0 0 1px #f3824f;\n}\n\n.e-form__control-wrapper.required .e-form__control-label::after{\n\tcontent: \" *\";\n}\n\n/**\n * Form Warning/Error/Valid States\n */\ninput:not([disabled]):active, input:not([disabled]):focus { border-color:#aeb2b5 !important }\n\n.e-form__control-wrapper .e-form__control-label::after {\n\tfont-family: \"Font Awesome 5 Pro\";\n\tpadding-left: 0.15rem;\n\tpadding-bottom: 0.5rem;\n\tfont-size: 6px;\n\ttransition: 0.25s ease;\n}\n\n.e-form__control-wrapper.required .e-form__control-label::after,\n.e-form__control-wrapper.required.e-form--pristine .e-form__control-label::after {\n\tcontent: \"\\f005\";\n\tcolor:#d0021b;\n}\n\n.e-form__control-wrapper.required.e-form--valid .e-form__control-label::after,\n.e-form__control-wrapper.required.e-form--valid.e-form--pristine .e-form__control-label::after{\n\tcontent: \"\\f00c\";\n\tcolor: #40b658;\n\tfont-weight: 900;\n}\n\n.e-form__control-wrapper .char-count {\n\tflex-grow: 1;\n\ttext-align: right;\n\tfont-size: 11px;\n\tcolor: #858c90;\n\topacity: 1;\n\ttransition: 0.25s ease;\n}\n.e-form__control-wrapper .char-count.invalid {\n\tcolor: #d95652;\n\topacity: 1;\n}\n.e-form__control-wrapper .char-count.hidden {\n\topacity: 0;\n}\n\n.e-form__control-wrapper.required.e-form--error .e-form__control-label::after,\n.e-form__control-wrapper.required.e-form--pristine.e-form--error .e-form__control-label::after {\n\tcontent: \"\\f071\";\n\tcolor: #d95652;\n\tfont-weight: 900;\n}\n.e-form__control-wrapper.required.e-form--warn .e-form__control-label::after,\n.e-form__control-wrapper.required.e-form--pristine.e-form--warn .e-form__control-label::after {\n\tcontent: \"\\f06a\";\n\tcolor: #f3824f;\n\tfont-weight: 900;\n}\n.e-form--warn .e-form__input[disabled]{ background-color: #e0e5ee; }\n\n.e-form--error .e-form__control.with-icon {\n\tborder: 1px solid #db6662;\n\tbox-shadow: inset 0 0 0 1px #db6662;\n}\n\n.e-form--warn .e-form__control.with-icon {\n\tborder: 1px solid #f3824f;\n\tbox-shadow: inset 0 0 0 1px #f3824f;\n}\n\n.e-form--error .e-form__control.with-icon input,\n.e-form--warn .e-form__control.with-icon input {\n\tborder: none;\n\tbox-shadow: none;\n\tmargin: 1px; /* Without this margin, the input blocks its container's inset box-shadow */\n}\n\n.e-form--error .e-form__control.with-icon:focus-within,\n.e-form--warn .e-form__control.with-icon:focus-within {\n\tborder: 1px solid #aeb2b5;\n\tbox-shadow: none;\n}\n\n/**\n * [Multiple Entries] styles\n */\n .e-form__control-wrapper.multiple-values .e-form__control:not(.date-range) {\n \tfont-style: italic;\n }\n\n.e-form__control-wrapper.multiple-values .e-form__control:not(.date-range) .react-datepicker__input-container::after,\n.e-form__control-wrapper.multiple-values .e-form__control.date-range > .multiple-values .react-datepicker__input-container::after {\n\tcontent: '[Multiple Entries]';\n\tbackground-color: #fff;\n\tfont-style: italic;\n\tposition: absolute;\n\tleft: 10px;\n\ttop: 7px;\n}\n\n/**\n * Form Footer\n */\nfooter.form-action-footer {\n\tposition: relative;\n\tleft: inherit;\n\tbottom: inherit;\n\twidth: 100%;\n\t/* Reset rhombus padding */\n\tpadding: 0 20px;\n}\n\n.form-action-footer .actions {\n\tmargin-left: auto;\n\tmargin-right: 1rem;\n}\n\n/**\n * General Form Styles\n */\nbutton:focus,\nbutton:active,\ninput:focus,\ninput:active {\n\toutline:none !important;\n\tbox-shadow: none !important;\n}\n\n/**\n * Radio Buttons\n */\n.e-form__radio [type=radio].is-checked>.e-form__radio--bg,\n.e-form__radio [type=radio].is-checked~.e-form__radio--bg,\n.e-form__radio [type=radio]:checked>.e-form__radio--bg,\n.e-form__radio [type=radio]:checked~.e-form__radio--bg {\n\tbackground-color:#2d7ebf;\n\tborder-color:#2d7ebf;\n}\n.e-form__radio [type=radio].is-checked>.e-form__radio--bg:after,\n.e-form__radio [type=radio].is-checked~.e-form__radio--bg:after,\n.e-form__radio [type=radio]:checked>.e-form__radio--bg:after,\n.e-form__radio [type=radio]:checked~.e-form__radio--bg:after {\n\twidth:6px;\n\theight:6px;\n\tbackground-color:#fff;\n}\n\n\n\n.e-form__control.is-disabled .e-form__radio {\n\tcursor: not-allowed;\n\tcolor: #858c90;\n}\n.e-form__radio [type=radio][disabled]~.e-form__radio--bg {\n\tborder-color: #d6d8da;\n\tbackground-color: #f4f5f5;\n}\n.e-form__radio [type=radio][disabled].is-checked>.e-form__radio--bg,\n.e-form__radio [type=radio][disabled].is-checked~.e-form__radio--bg,\n.e-form__radio [type=radio][disabled]:checked>.e-form__radio--bg,\n.e-form__radio [type=radio][disabled]:checked~.e-form__radio--bg {\n\tbackground-color:#b8d1e5;\n\tborder-color:#b8d1e5;\n}\n\n/**\n * Disabled Styles\n */\n.e-form__checkbox [type=checkbox][disabled]>.e-form__checkbox--bg,\n.e-form__checkbox [type=checkbox][disabled]~.e-form__checkbox--bg,\n.e-form__input[disabled]:active,\n.e-form__input[disabled] {\n\tborder-color: #d6d8da;\n\tbackground-color: #f4f5f5;\n\tcolor: #858c90;\n}\n\n/**\n * Form Tooltips\n */\n.e-form__control-wrapper .e-form__control-header {\n\tdisplay: flex;\n\talign-items: center;\n}\n.e-form__control-wrapper .e-form__control-header .u-form__help {\n\tmargin-left: 5px;\n\tfloat: none;\n}\n"]
  }]);

  /***/
}, /* 180 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(181);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 181 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * Search Styles\n */\n\n.search-component {\n\tdisplay:flex;\n\talign-items: center;\n/* \tbox-shadow:\n\t\tinset 3px 0px 0px #fff\n\t\t, inset -5px 0 0 #fff\n\t\t, inset 0 -2px 0 rgba(0,0,0,.3)\n\t\t; */\n\t/*box-shadow: 0 2px 0 rgba(100,122,137,0.2);*/\n\ttransition: 0.35s ease-out;\n}\n/*.search-component.is-focused {\n\tbox-shadow: 0 2px 0 #647a89;\n\twidth: 500px;\n\tmax-width: 100%;\n}*/\n.search-component .search-input-wrapper{\n\tborder-bottom: 1px solid #d6d8da;\n\twidth: 100%;\n}\n.search-component .search-input-wrapper input{\n\twidth: calc(100% - 30px);\n}\n.search-component.is-focused .search-input-wrapper{\n\tborder-bottom: 1px solid #858c90;\n}\n.search-component .search-field { transition: 0.3s; }\n/*.search-component.is-focused .search-field { width:100%; }*/\n\n.search-component .ft-ic {\n\t-webkit-user-select: none;\n\tuser-select: none;\n\tfont-size: 14px;\n\tcolor: #647a89;\n}\n\n.search-component input {\n\tborder: none;\n\tmargin: 2px 0;\n\tpadding-left: 5px;\n\tfont-size: 12px;\n\tline-height: 1.5;\n\tbackground-color: transparent;\n}\n\n.search-component .clear-search {\n\tcursor: pointer;\n\topacity: 0;\n\tpointer-events: none;\n\ttransition: 0.25s ease;\n}\n.search-component .clear-search:hover {\n\tcolor: #364047;\n}\n\n.search-component.is-searching .clear-search {\n\topacity: 1;\n\tpointer-events: all;\n}\n\n", "", {
    "version": 3,
    "sources": ["Search.css"],
    "names": [],
    "mappings": "AAAA;;EAEE;;AAEF;CACC,YAAY;CACZ,mBAAmB;AACpB;;;;KAIK;CACJ,6CAA6C;CAC7C,0BAA0B;AAC3B;AACA;;;;EAIE;AACF;CACC,gCAAgC;CAChC,WAAW;AACZ;AACA;CACC,wBAAwB;AACzB;AACA;CACC,gCAAgC;AACjC;AACA,kCAAkC,gBAAgB,EAAE;AACpD,6DAA6D;;AAE7D;CACC,yBAAyB;CACzB,iBAAiB;CACjB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,6BAA6B;AAC9B;;AAEA;CACC,eAAe;CACf,UAAU;CACV,oBAAoB;CACpB,sBAAsB;AACvB;AACA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,mBAAmB;AACpB",
    "file": "Search.css",
    "sourcesContent": ["/**\n * Search Styles\n */\n\n.search-component {\n\tdisplay:flex;\n\talign-items: center;\n/* \tbox-shadow:\n\t\tinset 3px 0px 0px #fff\n\t\t, inset -5px 0 0 #fff\n\t\t, inset 0 -2px 0 rgba(0,0,0,.3)\n\t\t; */\n\t/*box-shadow: 0 2px 0 rgba(100,122,137,0.2);*/\n\ttransition: 0.35s ease-out;\n}\n/*.search-component.is-focused {\n\tbox-shadow: 0 2px 0 #647a89;\n\twidth: 500px;\n\tmax-width: 100%;\n}*/\n.search-component .search-input-wrapper{\n\tborder-bottom: 1px solid #d6d8da;\n\twidth: 100%;\n}\n.search-component .search-input-wrapper input{\n\twidth: calc(100% - 30px);\n}\n.search-component.is-focused .search-input-wrapper{\n\tborder-bottom: 1px solid #858c90;\n}\n.search-component .search-field { transition: 0.3s; }\n/*.search-component.is-focused .search-field { width:100%; }*/\n\n.search-component .ft-ic {\n\t-webkit-user-select: none;\n\tuser-select: none;\n\tfont-size: 14px;\n\tcolor: #647a89;\n}\n\n.search-component input {\n\tborder: none;\n\tmargin: 2px 0;\n\tpadding-left: 5px;\n\tfont-size: 12px;\n\tline-height: 1.5;\n\tbackground-color: transparent;\n}\n\n.search-component .clear-search {\n\tcursor: pointer;\n\topacity: 0;\n\tpointer-events: none;\n\ttransition: 0.25s ease;\n}\n.search-component .clear-search:hover {\n\tcolor: #364047;\n}\n\n.search-component.is-searching .clear-search {\n\topacity: 1;\n\tpointer-events: all;\n}\n\n"]
  }]);

  /***/
}, /* 182 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _classnames2 = _interopRequireDefault(__webpack_require__(6));
  var _Select = _interopRequireDefault(__webpack_require__(64));
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var DefaultRow = (_class = (_class2 = /*#__PURE__*/function (_Component) {
    _inherits(DefaultRow, _Component);
    var _super = _createSuper(DefaultRow);
    function DefaultRow() {
      _classCallCheck(this, DefaultRow);
      return _super.apply(this, arguments);
    }
    _createClass(DefaultRow, [{
      key: "_onChange",
      value: function _onChange(ind, value) {
        var val = _typeof(value) === "object" ? value.value : value,
          newItem = this.props.available.find(function (v) {
            return v.value === val;
          });
        if (this.props.onChange) {
          this.props.onChange(this.props.type, ind, newItem);
        }
      }
    }, {
      key: "_onEmail",
      value: function _onEmail(item) {
        if (this.props.onEmail) {
          this.props.onEmail();
        }
      }
    }, {
      key: "_onRemove",
      value: function _onRemove(ind, item) {
        if (this.props.onRemove) {
          this.props.onRemove(this.props.type, ind);
        }
      }
    }, {
      key: "_renderEmail",
      value: function _renderEmail(item) {
        var $icon = null;
        if (item.email) {
          $icon = /*#__PURE__*/_react["default"].createElement("a", {
            href: "mailto:".concat(item.email),
            target: "_top",
            rel: "noopener noreferrer",
            className: "row-actions c-tooltip c-tooltip--left",
            "aria-label": item.email
          }, /*#__PURE__*/_react["default"].createElement("i", {
            className: "ft-ic fas fa-envelope"
          }));
        } else {
          $icon = /*#__PURE__*/_react["default"].createElement("i", {
            className: "row-actions c-tooltip c-tooltip--left ft-ic far fa-envelope",
            title: "Email",
            "aria-label": "No Email on File"
          });
        }
        return $icon;
      }
    }, {
      key: "_renderRemove",
      value: function _renderRemove(item, ind) {
        var _this = this;
        var onRemove = function onRemove() {
          return _this._onRemove(ind, item);
        };
        return /*#__PURE__*/_react["default"].createElement("i", {
          className: "row-actions ft-ic fa fa-times-circle cursor-pointer circle-around remove-item",
          onClick: onRemove,
          title: "Remove",
          "aria-label": "Remove Item"
        });
      }
    }, {
      key: "_renderDisplay",
      value: function _renderDisplay(item, ind) {
        var _this2 = this;
        var _this$props = this.props,
          readOnly = _this$props.readOnly,
          disabledItems = _this$props.disabledItems,
          selectProps = _this$props.selectProps,
          available = _this$props.available,
          cls = (0, _classnames2["default"])({
            'item-value': true,
            'read-only': !!readOnly
          }),
          $display = null;
        if (readOnly || disabledItems.indexOf(ind) > -1) {
          $display = /*#__PURE__*/_react["default"].createElement("div", {
            className: cls
          }, item.label);
        } else {
          $display = /*#__PURE__*/_react["default"].createElement(_Select["default"], _extends({
            clearable: false,
            options: available,
            className: cls,
            optionClassName: "item-value-option",
            value: item,
            onChange: function onChange(value) {
              _this2._onChange(ind, value);
            }
          }, selectProps));
        }
        return $display;
      }
    }, {
      key: "_renderItem",
      value: function _renderItem(v, i) {
        var _this$props2 = this.props,
          showEmail = _this$props2.showEmail,
          readOnly = _this$props2.readOnly,
          disabledItems = _this$props2.disabledItems,
          $email = v.value && showEmail ? this._renderEmail(v) : null,
          $remove = v.value && !readOnly && disabledItems.indexOf(i) === -1 ? this._renderRemove(v, i) : null,
          key = i;
        if (v.value) {
          key = "".concat(i, "--").concat(v.value, "--").concat(v.label.split(" ").join("-"));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "row-item",
          key: key
        }, this._renderDisplay(v, i), $email, $remove);
      }
    }, {
      key: "render",
      value: function render() {
        var _classnames;
        var _this$props3 = this.props,
          className = _this$props3.className,
          readOnly = _this$props3.readOnly,
          addEmpty = _this$props3.addEmpty,
          max = _this$props3.max,
          fields = _this$props3.fields,
          values = fields.getAll(),
          cls = (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, className, true), _defineProperty(_classnames, 'row-selector', true), _defineProperty(_classnames, 'read-only', !!readOnly), _classnames)),
          $items = null;
        if (!values || !values.length) {
          values = [];
        }
        if (addEmpty) {
          if (!values.length || values[values.length - 1].value) {
            if (max === -1 || max > -1 && values.length < max) {
              values.push({});
            }
          }
        }
        $items = values.map(this._renderItem);
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: cls
        }, $items);
      }
    }]);
    return DefaultRow;
  }(_react.Component), _defineProperty(_class2, "displayName", "DefaultRow"), _defineProperty(_class2, "defaultProps", {
    readOnly: false,
    // render entire control as read-only
    disabledItems: [],
    // render specific rows as read-only
    addEmpty: true,
    // add an empty row?
    showEmail: true,
    // show the email button
    available: [],
    // select options
    selectProps: {},
    className: "",
    max: -1 // max number of rows. -1 for no max
  }), _class2), (_applyDecoratedDescriptor(_class.prototype, "_onChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_onEmail", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_onEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_onRemove", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_onRemove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderRemove", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderRemove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderDisplay", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderItem", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderItem"), _class.prototype)), _class);
  exports["default"] = DefaultRow;

  /***/
}, /* 183 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _ControlWrapper = _interopRequireDefault(__webpack_require__(29));
  var _Select = _interopRequireDefault(__webpack_require__(64));
  var _Checkbox = _interopRequireDefault(__webpack_require__(99));
  __webpack_require__(236);
  var _class, _class2, _class3;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var TimePicker = (0, _ControlWrapper["default"])(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
    _inherits(TimePicker, _React$Component);
    var _super = _createSuper(TimePicker);
    function TimePicker(props, context) {
      var _this;
      _classCallCheck(this, TimePicker);
      _this = _super.call(this, props, context);
      _this._defaultHour = props.use24HourTime ? "00" : "12";
      _this._defaultMinute = "00";
      var _this$_formatTimeForU = _this._formatTimeForUse(props.value),
        hour = _this$_formatTimeForU.hour,
        minute = _this$_formatTimeForU.minute,
        ampm = _this$_formatTimeForU.ampm;
      _this.state = {
        hour: {
          value: hour,
          label: hour
        },
        minute: {
          value: minute,
          label: minute
        },
        ampm: props.use24HourTime ? null : ampm
      };
      return _this;
    }
    _createClass(TimePicker, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var props = this.props,
          nextState = {};
        if (props.value !== nextProps.value) {
          var _this$_formatTimeForU2 = this._formatTimeForUse(nextProps.value),
            hour = _this$_formatTimeForU2.hour,
            minute = _this$_formatTimeForU2.minute,
            ampm = _this$_formatTimeForU2.ampm;
          if (hour) {
            nextState.hour = {
              value: hour,
              label: hour
            };
          }
          if (minute) {
            nextState.minute = {
              value: minute,
              label: minute
            };
          }
          if (!nextProps.use24HourTime && ampm) {
            nextState.ampm = nextProps.ampm;
          }
        }
        this.setState(nextState);
      }
    }, {
      key: "_formatTimeForUse",
      value: function _formatTimeForUse(value) {
        var time = value.split(":"),
          hourList = HOURS.slice(1, 13),
          hour = this._defaultHour,
          minute = this._defaultMinute,
          ampm = null;
        if (value) {
          hour = time[0];
          minute = time[1];
          if (!this.props.use24HourTime) {
            hour = hourList[parseInt(hour)];
            ampm = hour < 12 ? "am" : "pm";
          }
        }
        return {
          hour: hour,
          minute: minute,
          ampm: ampm
        };
      }
    }, {
      key: "_formatTimeForEndpoint",
      value: function _formatTimeForEndpoint(nextState) {
        var props = this.props,
          _nextState$hour = nextState.hour,
          hour = _nextState$hour === void 0 ? {
            value: "00"
          } : _nextState$hour,
          _nextState$minute = nextState.minute,
          minute = _nextState$minute === void 0 ? {
            value: "00"
          } : _nextState$minute,
          ampm = nextState.ampm,
          pmHours = HOURS.slice(12),
          time = null;
        if (props.use24HourTime || ampm === "am" || hour.value === "12") {
          time = "".concat(hour.value, ":").concat(minute.value);
        } else {
          time = "".concat(pmHours[parseInt(hour.value)], ":").concat(minute.value);
        }
        return time;
      }
    }, {
      key: "_onChange",
      value: function _onChange(type, value) {
        var state = this.state,
          props = this.props,
          nextState = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, type, value)),
          time = this._formatTimeForEndpoint(nextState);
        this.setState(nextState, function () {
          if (props.onChange) {
            props.onChange(time);
          }
        });
      }

      // TODO: did not test 12-hr time when this component was built
    }, {
      key: "_renderAMPM",
      value: function _renderAMPM() {
        var _this2 = this;
        var props = this.props,
          state = this.state,
          $ampm = null,
          isAm = state.ampm === "am";
        if (!props.use24HourTime) {
          $ampm = /*#__PURE__*/_react["default"].createElement("div", {
            className: "ampm"
          }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            name: "ampm",
            label: "am",
            type: "radio",
            value: "am",
            checked: isAm,
            disabled: props.disabled,
            onChange: function onChange(e) {
              _this2._onChange("ampm", e.target.value);
            }
          }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            name: "ampm",
            label: "pm",
            type: "radio",
            value: "pm",
            checked: !isAm,
            disabled: props.disabled,
            onChange: function onChange(e) {
              _this2._onChange("ampm", e.target.value);
            }
          }));
        }
        return $ampm;
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;
        var props = this.props,
          state = this.state,
          hourName = props.hourName || "hour",
          minuteName = props.minuteName || "minute",
          hourOpts = props.use24HourTime ? HOURS : HOURS.slice(1, 13);
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "time-picker"
        }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
          name: hourName,
          options: hourOpts,
          value: state.hour,
          className: "time-piece hour",
          onChange: function onChange(value) {
            _this3._onChange("hour", value);
          },
          clearable: props.clearable,
          disabled: props.disabled
        }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
          name: minuteName,
          options: MINUTES,
          value: state.minute,
          className: "time-piece minute",
          onChange: function onChange(value) {
            _this3._onChange("minute", value);
          },
          clearable: props.clearable,
          disabled: props.disabled
        }), this._renderAMPM());
      }
    }]);
    return TimePicker;
  }(_react["default"].Component), _defineProperty(_class3, "displayName", "TimePicker"), _defineProperty(_class3, "propTypes", {
    use24HourTime: _propTypes["default"].bool,
    value: _propTypes["default"].string,
    // "00:00" always, we will need to properly reformat it for 12-hr time
    clearable: _propTypes["default"].bool // can hour/minute be empty?
  }), _defineProperty(_class3, "defaultProps", {
    use24HourTime: true,
    value: "00:00",
    clearable: false
  }), _class3), (_applyDecoratedDescriptor(_class2.prototype, "_formatTimeForUse", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "_formatTimeForUse"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_formatTimeForEndpoint", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "_formatTimeForEndpoint"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_onChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "_onChange"), _class2.prototype)), _class2)) || _class;
  exports["default"] = TimePicker;
  var HOURS = [{
      value: "00",
      label: "00"
    }, {
      value: "01",
      label: "01"
    }, {
      value: "02",
      label: "02"
    }, {
      value: "03",
      label: "03"
    }, {
      value: "04",
      label: "04"
    }, {
      value: "05",
      label: "05"
    }, {
      value: "06",
      label: "06"
    }, {
      value: "07",
      label: "07"
    }, {
      value: "08",
      label: "08"
    }, {
      value: "09",
      label: "09"
    }, {
      value: "10",
      label: "10"
    }, {
      value: "11",
      label: "11"
    }, {
      value: "12",
      label: "12"
    }, {
      value: "13",
      label: "13"
    }, {
      value: "14",
      label: "14"
    }, {
      value: "15",
      label: "15"
    }, {
      value: "16",
      label: "16"
    }, {
      value: "17",
      label: "17"
    }, {
      value: "18",
      label: "18"
    }, {
      value: "19",
      label: "19"
    }, {
      value: "20",
      label: "20"
    }, {
      value: "21",
      label: "21"
    }, {
      value: "22",
      label: "22"
    }, {
      value: "23",
      label: "23"
    }],
    MINUTES = [{
      value: "00",
      label: "00"
    }, {
      value: "01",
      label: "01"
    }, {
      value: "02",
      label: "02"
    }, {
      value: "03",
      label: "03"
    }, {
      value: "04",
      label: "04"
    }, {
      value: "05",
      label: "05"
    }, {
      value: "06",
      label: "06"
    }, {
      value: "07",
      label: "07"
    }, {
      value: "08",
      label: "08"
    }, {
      value: "09",
      label: "09"
    }, {
      value: "10",
      label: "10"
    }, {
      value: "11",
      label: "11"
    }, {
      value: "12",
      label: "12"
    }, {
      value: "13",
      label: "13"
    }, {
      value: "14",
      label: "14"
    }, {
      value: "15",
      label: "15"
    }, {
      value: "16",
      label: "16"
    }, {
      value: "17",
      label: "17"
    }, {
      value: "18",
      label: "18"
    }, {
      value: "19",
      label: "19"
    }, {
      value: "20",
      label: "20"
    }, {
      value: "21",
      label: "21"
    }, {
      value: "22",
      label: "22"
    }, {
      value: "23",
      label: "23"
    }, {
      value: "24",
      label: "24"
    }, {
      value: "25",
      label: "25"
    }, {
      value: "26",
      label: "26"
    }, {
      value: "27",
      label: "27"
    }, {
      value: "28",
      label: "28"
    }, {
      value: "29",
      label: "29"
    }, {
      value: "30",
      label: "30"
    }, {
      value: "31",
      label: "31"
    }, {
      value: "32",
      label: "32"
    }, {
      value: "33",
      label: "33"
    }, {
      value: "34",
      label: "34"
    }, {
      value: "35",
      label: "35"
    }, {
      value: "36",
      label: "36"
    }, {
      value: "37",
      label: "37"
    }, {
      value: "38",
      label: "38"
    }, {
      value: "39",
      label: "39"
    }, {
      value: "40",
      label: "40"
    }, {
      value: "41",
      label: "41"
    }, {
      value: "42",
      label: "42"
    }, {
      value: "43",
      label: "43"
    }, {
      value: "44",
      label: "44"
    }, {
      value: "45",
      label: "45"
    }, {
      value: "46",
      label: "46"
    }, {
      value: "47",
      label: "47"
    }, {
      value: "48",
      label: "48"
    }, {
      value: "49",
      label: "49"
    }, {
      value: "50",
      label: "50"
    }, {
      value: "51",
      label: "51"
    }, {
      value: "52",
      label: "52"
    }, {
      value: "53",
      label: "53"
    }, {
      value: "54",
      label: "54"
    }, {
      value: "55",
      label: "55"
    }, {
      value: "56",
      label: "56"
    }, {
      value: "57",
      label: "57"
    }, {
      value: "58",
      label: "58"
    }, {
      value: "59",
      label: "59"
    }];

  /***/
}, /* 184 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _ControlWrapper = _interopRequireDefault(__webpack_require__(29));
  var _Select = _interopRequireDefault(__webpack_require__(64));
  var _Button = _interopRequireDefault(__webpack_require__(61));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _class, _class2, _class3;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var MultiSelectWithList = (0, _ControlWrapper["default"])(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
    _inherits(MultiSelectWithList, _React$Component);
    var _super = _createSuper(MultiSelectWithList);
    function MultiSelectWithList(props) {
      var _this;
      _classCallCheck(this, MultiSelectWithList);
      _this = _super.call(this, props);
      var value = props.value,
        state = {
          /** currently selected, not yet added to the list */
          currentlySelected: [],
          /** items added to the list */
          selectedItems: []
        };
      if (value && Array.isArray(value)) {
        state.selectedItems = value;
      }
      _this.state = state;
      return _this;
    }
    _createClass(MultiSelectWithList, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var value = this.props.value,
          nextValue = nextProps.value;
        if (value !== nextValue) {
          if (Array.isArray(nextValue)) {
            this.setState({
              selectedItems: nextValue
            });
          } else {
            this.setState({
              selectedItems: []
            });
          }
        }
      }
    }, {
      key: "_setCurrentlySelected",
      value: function _setCurrentlySelected(sel) {
        var currentlySelected = sel || [];
        this.setState({
          currentlySelected: currentlySelected
        });
      }
    }, {
      key: "_removeItem",
      value: function _removeItem(item) {
        var props = this.props,
          state = this.state,
          selectedItems = state.selectedItems.filter(function (v) {
            return v.id !== item.id;
          });
        if (props.disabled) {
          return;
        }
        this.setState({
          selectedItems: selectedItems
        }, function () {
          if (typeof props.onChange === "function") {
            props.onChange(selectedItems);
          }
        });
      }
    }, {
      key: "_addItems",
      value: function _addItems(items) {
        var props = this.props,
          state = this.state,
          selectedItems = [].concat(state.selectedItems, items);
        if (props.disabled) {
          return;
        }
        this.setState({
          selectedItems: selectedItems
        }, function () {
          if (typeof props.onChange === "function") {
            props.onChange(selectedItems);
          }
        });
      }
    }, {
      key: "_buildList",
      value: function _buildList() {
        var _this2 = this;
        var props = this.props,
          state = this.state,
          $list = [],
          $display = null;
        if (Array.isArray(state.selectedItems)) {
          state.selectedItems.forEach(function (v, i) {
            var key = "list-item--".concat(i),
              $remove = null,
              label = typeof props.formatItemLabel === "function" ? props.formatItemLabel(v) : v.label;
            if (props.allowRemove) {
              var $classNames = (0, _classnames["default"])({
                "remove-icon": true,
                "cursor-pointer": !props.disabled,
                "is-disabled": props.disabled
              });
              $remove = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
                name: "clearCircle",
                className: $classNames,
                title: props.removeTitle,
                onClick: function onClick(e) {
                  _this2._removeItem(v);
                }
              });
            }
            $list.push( /*#__PURE__*/_react["default"].createElement("li", {
              key: key,
              className: "selected-item"
            }, label, $remove));
          });
        }
        if (!$list.length && props.alwaysShowList) {
          $display = /*#__PURE__*/_react["default"].createElement("span", {
            className: "no-items"
          }, props.noItems);
        } else {
          $display = /*#__PURE__*/_react["default"].createElement("ul", {
            className: "selected-list"
          }, $list);
        }
        return $display;
      }
    }, {
      key: "_buildOptions",
      value: function _buildOptions() {
        var props = this.props,
          state = this.state,
          selected = [],
          options = [];
        if (state.selectedItems && state.selectedItems.map) {
          selected = state.selectedItems.map(function (v) {
            return v.id;
          });
        }
        options = props.options.map(function (v, i) {
          return _objectSpread(_objectSpread({}, v), {}, {
            isDisabled: selected.indexOf(v.id) > -1
          });
        });
        return options;
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;
        var me = this,
          props = this.props,
          state = this.state,
          $listHeader = state.selectedItems.length || props.alwaysShowList ? /*#__PURE__*/_react["default"].createElement("h6", {
            className: "selected-header"
          }, props.listHeader) : null,
          isMaxSelectedClass = props.maxSelected && state.selectedItems.length + state.currentlySelected.length >= props.maxSelected ? "max-selected" : "",
          options = isMaxSelectedClass.length ? [{
            label: props.maxSelectedLabel,
            disabled: true
          }] : this._buildOptions(),
          selectOpts = _objectSpread({
            isClearable: props.clearable || props.isClearable,
            isLoading: props.isLoading,
            icon: "search",
            closeMenuOnSelect: props.closeOnSelect || props.closeMenuOnSelect,
            // NOTE:             onSelectResetsInput was removed in react-select 2.x... see Select.jsx for more info
            onSelectResetsInput: false,
            options: options,
            onChange: this._setCurrentlySelected,
            disabled: props.disabled,
            isMulti: true,
            showIcon: props.showIcon
          }, props.selectOpts),
          buttonOpts = {
            theme: "blue",
            disabled: props.disabled || !state.currentlySelected.length,
            onClick: function onClick() {
              if (props.disabled) {
                return;
              }
              var comp = me._select.composedComponent;
              me._addItems(comp.state.value);
              comp.setState({
                value: null
              }, function () {
                me._setCurrentlySelected([]);
              });
            }
          };
        if (props.buttonIcon) {
          buttonOpts.icon = props.buttonIcon;
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "multi-select-section ".concat(props.sectionClass, " ").concat(isMaxSelectedClass)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "available-section flex-around"
        }, /*#__PURE__*/_react["default"].createElement(_Select["default"], _extends({
          ref: function ref(sel) {
            _this3._select = sel;
          }
        }, selectOpts)), /*#__PURE__*/_react["default"].createElement(_Button["default"], buttonOpts, "Add")), /*#__PURE__*/_react["default"].createElement("div", {
          className: "selected-section"
        }, $listHeader, this._buildList()));
      }
    }]);
    return MultiSelectWithList;
  }(_react["default"].Component), _defineProperty(_class3, "displayName", "MultiSelectWithList"), _defineProperty(_class3, "defaultProps", {
    /** options for the select */
    options: [],
    /** maximum allowed items, 0 for no maximum */
    maxSelected: 0,
    /**  */
    maxSelectedLabel: "Max Items Selected",
    /** header for the selected-section */
    listHeader: "Added Items",
    /** additional class(es) to add to the component */
    sectionClass: "",
    /** title text for remove icon */
    removeTitle: "Remove Item From List",
    /** allow removal of item from list */
    allowRemove: true,
    /** close options list when an items is selected */
    closeMenuOnSelect: false,
    /** can the selection be cleared */
    isClearable: false,
    /** is the data for the select loading */
    isLoading: false,
    /** is this component disabled */
    disabled: false,
    /** on change of state.selectedItems -> called with updated list of selectedItems */
    onChange: null,
    /** Should we show the icon for the <Select /> */
    showIcon: true,
    /** should the list section always be visible */
    alwaysShowList: false,
    /** text to show when no items are selected if alwaysShowList is true */
    noItems: "No items added",
    selectOpts: {},
    buttonIcon: null
  }), _class3), (_applyDecoratedDescriptor(_class2.prototype, "_setCurrentlySelected", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "_setCurrentlySelected"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_removeItem", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "_removeItem"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_addItems", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "_addItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_buildList", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "_buildList"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_buildOptions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "_buildOptions"), _class2.prototype)), _class2)) || _class;
  exports["default"] = MultiSelectWithList;

  /***/
}, /* 185 */
/***/function (module, exports) {
  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }
  module.exports = arrayEach;

  /***/
}, /* 186 */
/***/function (module, exports, __webpack_require__) {
  var baseForOwn = __webpack_require__(252),
    createBaseEach = __webpack_require__(263);

  /**
   * The base implementation of `_.forEach` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array|Object} Returns `collection`.
   */
  var baseEach = createBaseEach(baseForOwn);
  module.exports = baseEach;

  /***/
}, /* 187 */
/***/function (module, exports, __webpack_require__) {
  var baseTimes = __webpack_require__(255),
    isArguments = __webpack_require__(146),
    isArray = __webpack_require__(44),
    isBuffer = __webpack_require__(147),
    isIndex = __webpack_require__(148),
    isTypedArray = __webpack_require__(189);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
      // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' ||
      // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') ||
      // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
      // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  module.exports = arrayLikeKeys;

  /***/
}, /* 188 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global) {
    /** Detect free variable `global` from Node.js. */
    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    module.exports = freeGlobal;

    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(36));

  /***/
}, /* 189 */
/***/function (module, exports, __webpack_require__) {
  var baseIsTypedArray = __webpack_require__(260),
    baseUnary = __webpack_require__(150),
    nodeUtil = __webpack_require__(151);

  /* Node.js helper references. */
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  module.exports = isTypedArray;

  /***/
}, /* 190 */
/***/function (module, exports) {
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  module.exports = overArg;

  /***/
}, /* 191 */
/***/function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(80),
    isObject = __webpack_require__(63);

  /** `Object#toString` result references. */
  var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  module.exports = isFunction;

  /***/
}, /* 192 */
/***/function (module, exports, __webpack_require__) {
  var baseIsEqual = __webpack_require__(153);

  /**
   * Performs a deep comparison between two values to determine if they are
   * equivalent.
   *
   * **Note:** This method supports comparing arrays, array buffers, booleans,
   * date objects, error objects, maps, numbers, `Object` objects, regexes,
   * sets, strings, symbols, and typed arrays. `Object` objects are compared
   * by their own, not inherited, enumerable properties. Functions and DOM
   * nodes are compared by strict equality, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.isEqual(object, other);
   * // => true
   *
   * object === other;
   * // => false
   */
  function isEqual(value, other) {
    return baseIsEqual(value, other);
  }
  module.exports = isEqual;

  /***/
}, /* 193 */
/***/function (module, exports) {
  /** Used for built-in method references. */
  var funcProto = Function.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return func + '';
      } catch (e) {}
    }
    return '';
  }
  module.exports = toSource;

  /***/
}, /* 194 */
/***/function (module, exports, __webpack_require__) {
  var SetCache = __webpack_require__(292),
    arraySome = __webpack_require__(295),
    cacheHas = __webpack_require__(296);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array;
    }
    var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
    stack.set(array, other);
    stack.set(other, array);

    // Ignore non-index properties.
    while (++index < arrLength) {
      var arrValue = array[index],
        othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== undefined) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      // Recursively compare arrays (susceptible to call stack limits).
      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
  }
  module.exports = equalArrays;

  /***/
}, /* 195 */
/***/function (module, exports, __webpack_require__) {
  var root = __webpack_require__(50);

  /** Built-in value references. */
  var Uint8Array = root.Uint8Array;
  module.exports = Uint8Array;

  /***/
}, /* 196 */
/***/function (module, exports, __webpack_require__) {
  var baseGetAllKeys = __webpack_require__(197),
    getSymbols = __webpack_require__(158),
    keys = __webpack_require__(74);

  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }
  module.exports = getAllKeys;

  /***/
}, /* 197 */
/***/function (module, exports, __webpack_require__) {
  var arrayPush = __webpack_require__(157),
    isArray = __webpack_require__(44);

  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  module.exports = baseGetAllKeys;

  /***/
}, /* 198 */
/***/function (module, exports) {
  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */
  function stubArray() {
    return [];
  }
  module.exports = stubArray;

  /***/
}, /* 199 */
/***/function (module, exports, __webpack_require__) {
  var arrayMap = __webpack_require__(159),
    baseClone = __webpack_require__(306),
    baseUnset = __webpack_require__(327),
    castPath = __webpack_require__(108),
    copyObject = __webpack_require__(82),
    customOmitClone = __webpack_require__(336),
    flatRest = __webpack_require__(338),
    getAllKeysIn = __webpack_require__(204);

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

  /**
   * The opposite of `_.pick`; this method creates an object composed of the
   * own and inherited enumerable property paths of `object` that are not omitted.
   *
   * **Note:** This method is considerably slower than `_.pick`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The source object.
   * @param {...(string|string[])} [paths] The property paths to omit.
   * @returns {Object} Returns the new object.
   * @example
   *
   * var object = { 'a': 1, 'b': '2', 'c': 3 };
   *
   * _.omit(object, ['a', 'c']);
   * // => { 'b': '2' }
   */
  var omit = flatRest(function (object, paths) {
    var result = {};
    if (object == null) {
      return result;
    }
    var isDeep = false;
    paths = arrayMap(paths, function (path) {
      path = castPath(path, object);
      isDeep || (isDeep = path.length > 1);
      return path;
    });
    copyObject(object, getAllKeysIn(object), result);
    if (isDeep) {
      result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
    }
    var length = paths.length;
    while (length--) {
      baseUnset(result, paths[length]);
    }
    return result;
  });
  module.exports = omit;

  /***/
}, /* 200 */
/***/function (module, exports, __webpack_require__) {
  var baseAssignValue = __webpack_require__(201),
    eq = __webpack_require__(103);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  module.exports = assignValue;

  /***/
}, /* 201 */
/***/function (module, exports, __webpack_require__) {
  var defineProperty = __webpack_require__(202);

  /**
   * The base implementation of `assignValue` and `assignMergeValue` without
   * value checks.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) {
      defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
      });
    } else {
      object[key] = value;
    }
  }
  module.exports = baseAssignValue;

  /***/
}, /* 202 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(75);
  var defineProperty = function () {
    try {
      var func = getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }();
  module.exports = defineProperty;

  /***/
}, /* 203 */
/***/function (module, exports, __webpack_require__) {
  var arrayPush = __webpack_require__(157),
    getPrototype = __webpack_require__(160),
    getSymbols = __webpack_require__(158),
    stubArray = __webpack_require__(198);

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeGetSymbols = Object.getOwnPropertySymbols;

  /**
   * Creates an array of the own and inherited enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */
  var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
    var result = [];
    while (object) {
      arrayPush(result, getSymbols(object));
      object = getPrototype(object);
    }
    return result;
  };
  module.exports = getSymbolsIn;

  /***/
}, /* 204 */
/***/function (module, exports, __webpack_require__) {
  var baseGetAllKeys = __webpack_require__(197),
    getSymbolsIn = __webpack_require__(203),
    keysIn = __webpack_require__(107);

  /**
   * Creates an array of own and inherited enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
  }
  module.exports = getAllKeysIn;

  /***/
}, /* 205 */
/***/function (module, exports, __webpack_require__) {
  var apply = __webpack_require__(342);

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax = Math.max;

  /**
   * A specialized version of `baseRest` which transforms the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @param {Function} transform The rest array transform.
   * @returns {Function} Returns the new function.
   */
  function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function () {
      var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);
      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform(array);
      return apply(func, this, otherArgs);
    };
  }
  module.exports = overRest;

  /***/
}, /* 206 */
/***/function (module, exports, __webpack_require__) {
  var baseSetToString = __webpack_require__(343),
    shortOut = __webpack_require__(345);

  /**
   * Sets the `toString` method of `func` to return `string`.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var setToString = shortOut(baseSetToString);
  module.exports = setToString;

  /***/
}, /* 207 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(63);

  /**
   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` if suitable for strict
   *  equality comparisons, else `false`.
   */
  function isStrictComparable(value) {
    return value === value && !isObject(value);
  }
  module.exports = isStrictComparable;

  /***/
}, /* 208 */
/***/function (module, exports) {
  /**
   * A specialized version of `matchesProperty` for source values suitable
   * for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function matchesStrictComparable(key, srcValue) {
    return function (object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
  }
  module.exports = matchesStrictComparable;

  /***/
}, /* 209 */
/***/function (module, exports) {

  /***/}, /* 210 */
/***/function (module, exports) {

  /***/}, /* 211 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * Tag Component\n */\n.c-tag {\n\theight: 27px;\n\tborder-radius: 13px;\n\t/*background-color: rgba(100, 122, 137, 0.5);*/\n\tbackground-color: #5e666b;\n\tcolor: #fff;\n\tpadding: 0 10px;\n\tfont-size: 11px;\n\tfont-weight: bold;\n\tpadding-right: 5px;\n}\n\n.c-tag .c-tag-label { padding: 2px 5px; }\n.c-tag.editable .c-tag-label{ cursor: pointer; }\n\n.c-tag .c-tag-remove{\n\tcursor: pointer;\n\tpadding: 0 3px;\n\tpadding: 0 3px;\n\tfont-weight: bold;\n\ttext-transform: uppercase;\n\t/*color: #fff;*/\n\tbackground-color: transparent;\n}\n.c-tag .c-tag-remove i.ft-ic{\n\tfont-size: 14px;\n\tcolor: #aeb2b5;\n}\n.c-tag .c-tag-remove:hover i.ft-ic{\n\tcolor: #fff;\n}\n.c-tag .c-tag-remove.t-tag-remove--orange i.ft-ic{\n\tcolor: #fff;\n}\n.c-tag .c-tag-remove.t-tag-remove--orange:hover i.ft-ic{\n\tcolor: #5e666b;\n}\n.c-tag .c-tag-remove.c-badge--subtle{\n\tborder-radius: 30rem;\n}\n.c-tag.c-tag--clickable{\n\tcursor: pointer;\n}\n.c-tag.c-tag--clickable:hover{\n\tbackground-color: #374047;\n}\n\n.c-tag .c-tag-remove:hover{\t/* default */\n\t/*background-color: #fff;*/\n\tcolor: #fff;\n}\n.c-tag.t-badge--white .c-tag-remove:hover{\n\tcolor: #fff;\n\tbackground-color: #374047;\n}\n.c-tag.t-badge--primary .c-tag-remove:hover{ color: #374047; }\n.c-tag.t-badge--blue .c-tag-remove:hover{ color: #1771b9; }\n.c-tag.t-badge--purple .c-tag-remove:hover{ color: #8e76b5; }\n.c-tag.t-badge--pink .c-tag-remove:hover{ color: #d11560; }\n.c-tag.t-badge--orange .c-tag-remove:hover{ color: #f3753d; }\n.c-tag.t-badge--green .c-tag-remove:hover{ color: #40b658; }\n.c-badge--subtle.t-badge--subtle-red,\n.c-tag.t-badge--red .c-tag-remove:hover{ color: #d95652; }\n\n.c-tag.c-badge--ghost .c-tag-remove{ border-color: transparent; } /*default*/\n.c-tag.c-badge--ghost .c-tag-remove:hover,\n.c-tag.c-badge--subtle .c-tag-remove:hover{\n\tbackground-color: #aeb2b5;\n\tcolor: #fff;\n}\n.c-tag.t-badge--ghost-white .c-tag-remove:hover,\n.c-tag.t-badge--subtle-white .c-tag-remove:hover,\n.c-tag.t-badge--ghost-primary .c-tag-remove:hover,\n.c-tag.t-badge--subtle-primary .c-tag-remove:hover{\n\tbackground-color: #374047;\n}\n.c-tag.t-badge--ghost-blue .c-tag-remove:hover,\n.c-tag.t-badge--subtle-blue .c-tag-remove:hover{\n\tbackground-color: #1771b9;\n}\n.c-tag.t-badge--ghost-purple .c-tag-remove:hover,\n.c-tag.t-badge--subtle-purple .c-tag-remove:hover{\n\tbackground-color: #8e76b5;\n}\n.c-tag.t-badge--ghost-pink .c-tag-remove:hover,\n.c-tag.t-badge--subtle-pink .c-tag-remove:hover{\n\tbackground-color: #d11560;\n}\n.c-tag.t-badge--ghost-orange .c-tag-remove:hover,\n.c-tag.t-badge--subtle-orange .c-tag-remove:hover{\n\tbackground-color: #f3753d;\n}\n.c-tag.t-badge--ghost-green .c-tag-remove:hover,\n.c-tag.t-badge--subtle-green .c-tag-remove:hover{\n\tbackground-color: #40b658;\n}\n.c-tag.t-badge--ghost-red .c-tag-remove:hover,\n.c-tag.t-badge--subtle-red .c-tag-remove:hover{\n\tbackground-color: #d95652;\n}\n", "", {
    "version": 3,
    "sources": ["Tag.css"],
    "names": [],
    "mappings": "AAAA;;EAEE;AACF;CACC,YAAY;CACZ,mBAAmB;CACnB,8CAA8C;CAC9C,yBAAyB;CACzB,WAAW;CACX,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA,sBAAsB,gBAAgB,EAAE;AACxC,8BAA8B,eAAe,EAAE;;AAE/C;CACC,eAAe;CACf,cAAc;CACd,cAAc;CACd,iBAAiB;CACjB,yBAAyB;CACzB,eAAe;CACf,6BAA6B;AAC9B;AACA;CACC,eAAe;CACf,cAAc;AACf;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,oBAAoB;AACrB;AACA;CACC,eAAe;AAChB;AACA;CACC,yBAAyB;AAC1B;;AAEA,4BAA4B,YAAY;CACvC,0BAA0B;CAC1B,WAAW;AACZ;AACA;CACC,WAAW;CACX,yBAAyB;AAC1B;AACA,6CAA6C,cAAc,EAAE;AAC7D,0CAA0C,cAAc,EAAE;AAC1D,4CAA4C,cAAc,EAAE;AAC5D,0CAA0C,cAAc,EAAE;AAC1D,4CAA4C,cAAc,EAAE;AAC5D,2CAA2C,cAAc,EAAE;AAC3D;yCACyC,cAAc,EAAE;;AAEzD,qCAAqC,yBAAyB,EAAE,EAAE,UAAU;AAC5E;;CAEC,yBAAyB;CACzB,WAAW;AACZ;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B",
    "file": "Tag.css",
    "sourcesContent": ["/**\n * Tag Component\n */\n.c-tag {\n\theight: 27px;\n\tborder-radius: 13px;\n\t/*background-color: rgba(100, 122, 137, 0.5);*/\n\tbackground-color: #5e666b;\n\tcolor: #fff;\n\tpadding: 0 10px;\n\tfont-size: 11px;\n\tfont-weight: bold;\n\tpadding-right: 5px;\n}\n\n.c-tag .c-tag-label { padding: 2px 5px; }\n.c-tag.editable .c-tag-label{ cursor: pointer; }\n\n.c-tag .c-tag-remove{\n\tcursor: pointer;\n\tpadding: 0 3px;\n\tpadding: 0 3px;\n\tfont-weight: bold;\n\ttext-transform: uppercase;\n\t/*color: #fff;*/\n\tbackground-color: transparent;\n}\n.c-tag .c-tag-remove i.ft-ic{\n\tfont-size: 14px;\n\tcolor: #aeb2b5;\n}\n.c-tag .c-tag-remove:hover i.ft-ic{\n\tcolor: #fff;\n}\n.c-tag .c-tag-remove.t-tag-remove--orange i.ft-ic{\n\tcolor: #fff;\n}\n.c-tag .c-tag-remove.t-tag-remove--orange:hover i.ft-ic{\n\tcolor: #5e666b;\n}\n.c-tag .c-tag-remove.c-badge--subtle{\n\tborder-radius: 30rem;\n}\n.c-tag.c-tag--clickable{\n\tcursor: pointer;\n}\n.c-tag.c-tag--clickable:hover{\n\tbackground-color: #374047;\n}\n\n.c-tag .c-tag-remove:hover{\t/* default */\n\t/*background-color: #fff;*/\n\tcolor: #fff;\n}\n.c-tag.t-badge--white .c-tag-remove:hover{\n\tcolor: #fff;\n\tbackground-color: #374047;\n}\n.c-tag.t-badge--primary .c-tag-remove:hover{ color: #374047; }\n.c-tag.t-badge--blue .c-tag-remove:hover{ color: #1771b9; }\n.c-tag.t-badge--purple .c-tag-remove:hover{ color: #8e76b5; }\n.c-tag.t-badge--pink .c-tag-remove:hover{ color: #d11560; }\n.c-tag.t-badge--orange .c-tag-remove:hover{ color: #f3753d; }\n.c-tag.t-badge--green .c-tag-remove:hover{ color: #40b658; }\n.c-badge--subtle.t-badge--subtle-red,\n.c-tag.t-badge--red .c-tag-remove:hover{ color: #d95652; }\n\n.c-tag.c-badge--ghost .c-tag-remove{ border-color: transparent; } /*default*/\n.c-tag.c-badge--ghost .c-tag-remove:hover,\n.c-tag.c-badge--subtle .c-tag-remove:hover{\n\tbackground-color: #aeb2b5;\n\tcolor: #fff;\n}\n.c-tag.t-badge--ghost-white .c-tag-remove:hover,\n.c-tag.t-badge--subtle-white .c-tag-remove:hover,\n.c-tag.t-badge--ghost-primary .c-tag-remove:hover,\n.c-tag.t-badge--subtle-primary .c-tag-remove:hover{\n\tbackground-color: #374047;\n}\n.c-tag.t-badge--ghost-blue .c-tag-remove:hover,\n.c-tag.t-badge--subtle-blue .c-tag-remove:hover{\n\tbackground-color: #1771b9;\n}\n.c-tag.t-badge--ghost-purple .c-tag-remove:hover,\n.c-tag.t-badge--subtle-purple .c-tag-remove:hover{\n\tbackground-color: #8e76b5;\n}\n.c-tag.t-badge--ghost-pink .c-tag-remove:hover,\n.c-tag.t-badge--subtle-pink .c-tag-remove:hover{\n\tbackground-color: #d11560;\n}\n.c-tag.t-badge--ghost-orange .c-tag-remove:hover,\n.c-tag.t-badge--subtle-orange .c-tag-remove:hover{\n\tbackground-color: #f3753d;\n}\n.c-tag.t-badge--ghost-green .c-tag-remove:hover,\n.c-tag.t-badge--subtle-green .c-tag-remove:hover{\n\tbackground-color: #40b658;\n}\n.c-tag.t-badge--ghost-red .c-tag-remove:hover,\n.c-tag.t-badge--subtle-red .c-tag-remove:hover{\n\tbackground-color: #d95652;\n}\n"]
  }]);

  /***/
}, /* 212 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var React = __webpack_require__(1);
  var FocusTrap = __webpack_require__(405);
  var displace = __webpack_require__(409);
  var noScroll = __webpack_require__(410);
  var Modal = function (_React$Component) {
    _inherits(Modal, _React$Component);
    function Modal() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck(this, Modal);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.getApplicationNode = function () {
        if (_this.props.getApplicationNode) return _this.props.getApplicationNode();
        return _this.props.applicationNode;
      }, _this.checkUnderlayClick = function (event) {
        if (_this.dialogNode && _this.dialogNode.contains(event.target)
        // If the click is on the scrollbar we don't want to close the modal.
        || event.pageX > event.target.clientWidth || event.pageY > event.target.clientHeight) return;
        _this.exit(event);
      }, _this.checkDocumentKeyDown = function (event) {
        if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
          _this.exit(event);
        }
      }, _this.exit = function (event) {
        if (_this.props.onExit) {
          _this.props.onExit(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Modal, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (!this.props.titleText && !this.props.titleId) {
          throw new Error('react-aria-modal instances should have a `titleText` or `titleId`');
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var props = this.props;
        if (props.onEnter) {
          props.onEnter();
        }

        // Timeout to ensure this happens *after* focus has moved
        var applicationNode = this.getApplicationNode();
        setTimeout(function () {
          if (applicationNode) {
            applicationNode.setAttribute('aria-hidden', 'true');
          }
        }, 0);
        if (props.escapeExits) {
          document.addEventListener('keydown', this.checkDocumentKeyDown);
        }
        if (this.props.scrollDisabled) {
          noScroll.on();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (prevProps.scrollDisabled && !this.props.scrollDisabled) {
          noScroll.off();
        } else if (!prevProps.scrollDisabled && this.props.scrollDisabled) {
          noScroll.on();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.props.scrollDisabled) {
          noScroll.off();
        }
        var applicationNode = this.getApplicationNode();
        if (applicationNode) {
          applicationNode.setAttribute('aria-hidden', 'false');
        }
        document.removeEventListener('keydown', this.checkDocumentKeyDown);
      }
    }, {
      key: 'render',
      value: function render() {
        var props = this.props;
        var style = {};
        if (props.includeDefaultStyles) {
          style = {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1050,
            overflowX: 'hidden',
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            textAlign: 'center'
          };
          if (props.underlayColor) {
            style.background = props.underlayColor;
          }
          if (props.underlayClickExits) {
            style.cursor = 'pointer';
          }
        }
        if (props.underlayStyle) {
          for (var key in props.underlayStyle) {
            if (!props.underlayStyle.hasOwnProperty(key)) continue;
            style[key] = props.underlayStyle[key];
          }
        }
        var underlayProps = {
          className: props.underlayClass,
          style: style
        };
        if (props.underlayClickExits) {
          underlayProps.onMouseDown = this.checkUnderlayClick;
        }
        for (var prop in this.props.underlayProps) {
          underlayProps[prop] = this.props.underlayProps[prop];
        }
        var verticalCenterStyle = {};
        if (props.includeDefaultStyles) {
          verticalCenterStyle = {
            display: 'inline-block',
            height: '100%',
            verticalAlign: 'middle'
          };
        }
        var verticalCenterHelperProps = {
          key: 'a',
          style: verticalCenterStyle
        };
        var dialogStyle = {};
        if (props.includeDefaultStyles) {
          dialogStyle = {
            display: 'inline-block',
            textAlign: 'left',
            top: 0,
            maxWidth: '100%',
            cursor: 'default',
            outline: props.focusDialog ? 0 : null
          };
          if (props.verticallyCenter) {
            dialogStyle.verticalAlign = 'middle';
            dialogStyle.top = 0;
          }
        }
        if (props.dialogStyle) {
          for (var _key2 in props.dialogStyle) {
            if (!props.dialogStyle.hasOwnProperty(_key2)) continue;
            dialogStyle[_key2] = props.dialogStyle[_key2];
          }
        }
        var dialogProps = {
          key: 'b',
          ref: function (el) {
            this.dialogNode = el;
          }.bind(this),
          role: props.alert ? 'alertdialog' : 'dialog',
          id: props.dialogId,
          className: props.dialogClass,
          style: dialogStyle
        };
        if (props.titleId) {
          dialogProps['aria-labelledby'] = props.titleId;
        } else if (props.titleText) {
          dialogProps['aria-label'] = props.titleText;
        }
        if (props.focusDialog) {
          dialogProps.tabIndex = '-1';
        }

        // Apply data- and aria- attributes passed as props
        for (var _key3 in props) {
          if (/^(data-|aria-)/.test(_key3)) {
            dialogProps[_key3] = props[_key3];
          }
        }
        var childrenArray = [React.createElement('div', dialogProps, props.children)];
        if (props.verticallyCenter) {
          childrenArray.unshift(React.createElement('div', verticalCenterHelperProps));
        }
        var focusTrapOptions = props.focusTrapOptions || {};
        if (props.focusDialog || props.initialFocus) {
          focusTrapOptions.initialFocus = props.focusDialog ? '#' + this.props.dialogId : props.initialFocus;
        }
        focusTrapOptions.escapeDeactivates = props.escapeExits;
        return React.createElement(FocusTrap, {
          focusTrapOptions: focusTrapOptions,
          paused: props.focusTrapPaused
        }, React.createElement('div', underlayProps, childrenArray));
      }
    }]);
    return Modal;
  }(React.Component);
  Modal.defaultProps = {
    underlayProps: {},
    dialogId: 'react-aria-modal-dialog',
    underlayClickExits: true,
    escapeExits: true,
    underlayColor: 'rgba(0,0,0,0.5)',
    includeDefaultStyles: true,
    focusTrapPaused: false,
    scrollDisabled: true
  };
  var DisplacedModal = displace(Modal);
  DisplacedModal.renderTo = function (input) {
    return displace(Modal, {
      renderTo: input
    });
  };
  module.exports = DisplacedModal;

  /***/
}, /* 213 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(214);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 214 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * Checkboxlist CSS\n */\n\n.checkbox-list {\n\twidth: 500px;\n\tborder: 1px solid #adadad;\n}\n\n.checkbox-list .search-header input {\n\tbox-sizing: border-box;\n\tborder: none;\n\tborder-radius: 0;\n}\n\n.checkbox-list .search-header {\n\tborder-bottom: 1px solid #d6d8da;\n\tpadding: 12px 20px;\n\tbackground-color: #f4f5f5;\n}\n\n.checkbox-list .list-items {\n\tmargin: 10px;\n}\n\n/**\n *  @2 Items\n **/\n.checkbox-list .checkbox-item label {\n\tdisplay: grid;\n\tgrid-template-columns: 20px 1fr;\n\talign-content: center;\n\talign-self: center;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 25px;\n\tgrid-column-gap: 5px;\n}\n.checkbox-list .checkbox-item .e-form__checkbox--label {\n\tdisplay: initial !important;\n\twidth: 100%;\n\theight: auto;\n\tmargin-left: 0;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.checkbox-list.is-grid {\n\twidth: 100%;\n}\n.checkbox-list.is-grid .list-items {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n}\n\n.checkbox-list.is-grid .checkbox-item .e-form__checkbox--label {\n\tline-height: 1;\n\tdisplay: flex;\n\talign-self: center;\n\twidth: auto;\n\tmax-width: calc(100% - 40px);\n\theight: auto !important;\n}\n\n.checkbox-list .checkbox-item.is-disabled .e-form__checkbox,\n.checkbox-list .checkbox-item .e-form__checkbox--label.is-disabled {\n\tcolor: #858c90;\n\tcursor: not-allowed;\n}\n.checkbox-list .u-form__help{\n\tdisplay: inline-block;\n\tfloat: none;\n\tmargin-left: 10px;\n}\n\n.checkbox-list .select-all-wrapper {\n\tfont-size: 12px;\n\tcolor: #858c90;\n\tmargin: 10px;\n\tmargin-bottom: 0;\n}\n.checkbox-list .select-all-wrapper span.select-all-link {\n\tcursor: pointer;\n}\n.checkbox-list .select-all-wrapper .select-all-separator {\n\tmargin: 0 6px;\n}\n.checkbox-list .select-all-wrapper span.select-all-link:hover {\n\tcolor: #374047;\n\ttext-decoration: underline;\n}\n.checkbox-list .select-all-wrapper span.select-all-link.is-disabled:hover {\n\tcolor: #858c90;\n\ttext-decoration: none;\n\tcursor: not-allowed;\n}\n", "", {
    "version": 3,
    "sources": ["CheckboxList.css"],
    "names": [],
    "mappings": "AAAA;;EAEE;;AAEF;CACC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,YAAY;AACb;;AAEA;;GAEG;AACH;CACC,aAAa;CACb,+BAA+B;CAC/B,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,oBAAoB;AACrB;AACA;CACC,2BAA2B;CAC3B,WAAW;CACX,YAAY;CACZ,cAAc;CACd,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;AACA;CACC,aAAa;CACb,qCAAqC;AACtC;;AAEA;CACC,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,WAAW;CACX,4BAA4B;CAC5B,uBAAuB;AACxB;;AAEA;;CAEC,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,qBAAqB;CACrB,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,YAAY;CACZ,gBAAgB;AACjB;AACA;CACC,eAAe;AAChB;AACA;CACC,aAAa;AACd;AACA;CACC,cAAc;CACd,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,qBAAqB;CACrB,mBAAmB;AACpB",
    "file": "CheckboxList.css",
    "sourcesContent": ["/**\n * Checkboxlist CSS\n */\n\n.checkbox-list {\n\twidth: 500px;\n\tborder: 1px solid #adadad;\n}\n\n.checkbox-list .search-header input {\n\tbox-sizing: border-box;\n\tborder: none;\n\tborder-radius: 0;\n}\n\n.checkbox-list .search-header {\n\tborder-bottom: 1px solid #d6d8da;\n\tpadding: 12px 20px;\n\tbackground-color: #f4f5f5;\n}\n\n.checkbox-list .list-items {\n\tmargin: 10px;\n}\n\n/**\n *  @2 Items\n **/\n.checkbox-list .checkbox-item label {\n\tdisplay: grid;\n\tgrid-template-columns: 20px 1fr;\n\talign-content: center;\n\talign-self: center;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 25px;\n\tgrid-column-gap: 5px;\n}\n.checkbox-list .checkbox-item .e-form__checkbox--label {\n\tdisplay: initial !important;\n\twidth: 100%;\n\theight: auto;\n\tmargin-left: 0;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.checkbox-list.is-grid {\n\twidth: 100%;\n}\n.checkbox-list.is-grid .list-items {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n}\n\n.checkbox-list.is-grid .checkbox-item .e-form__checkbox--label {\n\tline-height: 1;\n\tdisplay: flex;\n\talign-self: center;\n\twidth: auto;\n\tmax-width: calc(100% - 40px);\n\theight: auto !important;\n}\n\n.checkbox-list .checkbox-item.is-disabled .e-form__checkbox,\n.checkbox-list .checkbox-item .e-form__checkbox--label.is-disabled {\n\tcolor: #858c90;\n\tcursor: not-allowed;\n}\n.checkbox-list .u-form__help{\n\tdisplay: inline-block;\n\tfloat: none;\n\tmargin-left: 10px;\n}\n\n.checkbox-list .select-all-wrapper {\n\tfont-size: 12px;\n\tcolor: #858c90;\n\tmargin: 10px;\n\tmargin-bottom: 0;\n}\n.checkbox-list .select-all-wrapper span.select-all-link {\n\tcursor: pointer;\n}\n.checkbox-list .select-all-wrapper .select-all-separator {\n\tmargin: 0 6px;\n}\n.checkbox-list .select-all-wrapper span.select-all-link:hover {\n\tcolor: #374047;\n\ttext-decoration: underline;\n}\n.checkbox-list .select-all-wrapper span.select-all-link.is-disabled:hover {\n\tcolor: #858c90;\n\ttext-decoration: none;\n\tcursor: not-allowed;\n}\n"]
  }]);

  /***/
}, /* 215 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(216);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 216 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, ".tag-group{}\n\n.tag-group .group-section,\n.tag-group .tag-component,\n.tag-group .c-tag-input{\n\tdisplay: inline-block;\n}\n.tag-group .group-label{}\n.tag-group .group-tags,\n.tag-group .tag-component{\n\tpadding: 0 5px;\n}\n.tag-group .add-tag{\n\tcursor: pointer;\n\tposition: relative;\n}\n.add-tag svg{\n\tmargin-top: -5px;\n}\n", "", {
    "version": 3,
    "sources": ["TagGroup.css"],
    "names": [],
    "mappings": "AAAA,WAAW;;AAEX;;;CAGC,qBAAqB;AACtB;AACA,wBAAwB;AACxB;;CAEC,cAAc;AACf;AACA;CACC,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB",
    "file": "TagGroup.css",
    "sourcesContent": [".tag-group{}\n\n.tag-group .group-section,\n.tag-group .tag-component,\n.tag-group .c-tag-input{\n\tdisplay: inline-block;\n}\n.tag-group .group-label{}\n.tag-group .group-tags,\n.tag-group .tag-component{\n\tpadding: 0 5px;\n}\n.tag-group .add-tag{\n\tcursor: pointer;\n\tposition: relative;\n}\n.add-tag svg{\n\tmargin-top: -5px;\n}\n"]
  }]);

  /***/
}, /* 217 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var keysShim;
  if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = __webpack_require__(131); // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
      toString: null
    }, 'toString');
    var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
    var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];
    var equalsConstructorPrototype = function (o) {
      var ctor = o.constructor;
      return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
      $applicationCache: true,
      $console: true,
      $external: true,
      $frame: true,
      $frameElement: true,
      $frames: true,
      $innerHeight: true,
      $innerWidth: true,
      $onmozfullscreenchange: true,
      $onmozfullscreenerror: true,
      $outerHeight: true,
      $outerWidth: true,
      $pageXOffset: true,
      $pageYOffset: true,
      $parent: true,
      $scrollLeft: true,
      $scrollTop: true,
      $scrollX: true,
      $scrollY: true,
      $self: true,
      $webkitIndexedDB: true,
      $webkitStorageInfo: true,
      $window: true
    };
    var hasAutomationEqualityBug = function () {
      /* global window */
      if (typeof window === 'undefined') {
        return false;
      }
      for (var k in window) {
        try {
          if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
            try {
              equalsConstructorPrototype(window[k]);
            } catch (e) {
              return true;
            }
          }
        } catch (e) {
          return true;
        }
      }
      return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function (o) {
      /* global window */
      if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
        return equalsConstructorPrototype(o);
      }
      try {
        return equalsConstructorPrototype(o);
      } catch (e) {
        return false;
      }
    };
    keysShim = function keys(object) {
      var isObject = object !== null && typeof object === 'object';
      var isFunction = toStr.call(object) === '[object Function]';
      var isArguments = isArgs(object);
      var isString = isObject && toStr.call(object) === '[object String]';
      var theKeys = [];
      if (!isObject && !isFunction && !isArguments) {
        throw new TypeError('Object.keys called on a non-object');
      }
      var skipProto = hasProtoEnumBug && isFunction;
      if (isString && object.length > 0 && !has.call(object, 0)) {
        for (var i = 0; i < object.length; ++i) {
          theKeys.push(String(i));
        }
      }
      if (isArguments && object.length > 0) {
        for (var j = 0; j < object.length; ++j) {
          theKeys.push(String(j));
        }
      } else {
        for (var name in object) {
          if (!(skipProto && name === 'prototype') && has.call(object, name)) {
            theKeys.push(String(name));
          }
        }
      }
      if (hasDontEnumBug) {
        var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
        for (var k = 0; k < dontEnums.length; ++k) {
          if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
            theKeys.push(dontEnums[k]);
          }
        }
      }
      return theKeys;
    };
  }
  module.exports = keysShim;

  /***/
}, /* 218 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var hasToStringTag = __webpack_require__(92)();
  var callBound = __webpack_require__(133);
  var $toString = callBound('Object.prototype.toString');
  var isStandardArguments = function isArguments(value) {
    if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
      return false;
    }
    return $toString(value) === '[object Arguments]';
  };
  var isLegacyArguments = function isArguments(value) {
    if (isStandardArguments(value)) {
      return true;
    }
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $toString(value) !== '[object Array]' && $toString(value.callee) === '[object Function]';
  };
  var supportsStandardArguments = function () {
    return isStandardArguments(arguments);
  }();
  isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

  module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

  /***/
}, /* 219 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var origSymbol = typeof Symbol !== 'undefined' && Symbol;
  var hasSymbolSham = __webpack_require__(132);
  module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== 'function') {
      return false;
    }
    if (typeof Symbol !== 'function') {
      return false;
    }
    if (typeof origSymbol('foo') !== 'symbol') {
      return false;
    }
    if (typeof Symbol('bar') !== 'symbol') {
      return false;
    }
    return hasSymbolSham();
  };

  /***/
}, /* 220 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* eslint no-invalid-this: 1 */
  var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
  var slice = Array.prototype.slice;
  var toStr = Object.prototype.toString;
  var funcType = '[object Function]';
  module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
      throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);
    var bound;
    var binder = function () {
      if (this instanceof bound) {
        var result = target.apply(this, args.concat(slice.call(arguments)));
        if (Object(result) === result) {
          return result;
        }
        return this;
      } else {
        return target.apply(that, args.concat(slice.call(arguments)));
      }
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
      boundArgs.push('$' + i);
    }
    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
      var Empty = function Empty() {};
      Empty.prototype = target.prototype;
      bound.prototype = new Empty();
      Empty.prototype = null;
    }
    return bound;
  };

  /***/
}, /* 221 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var bind = __webpack_require__(94);
  module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

  /***/
}, /* 222 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var define = __webpack_require__(72);
  var callBind = __webpack_require__(95);
  var implementation = __webpack_require__(134);
  var getPolyfill = __webpack_require__(135);
  var shim = __webpack_require__(224);
  var polyfill = callBind(getPolyfill(), Object);
  define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
  });
  module.exports = polyfill;

  /***/
}, /* 223 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var GetIntrinsic = __webpack_require__(93);
  var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
  var hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($defineProperty) {
      try {
        $defineProperty({}, 'a', {
          value: 1
        });
        return true;
      } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
      }
    }
    return false;
  };
  hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!hasPropertyDescriptors()) {
      return null;
    }
    try {
      return $defineProperty([], 'length', {
        value: 1
      }).length !== 1;
    } catch (e) {
      // In Firefox 4-22, defining length on an array throws an exception.
      return true;
    }
  };
  module.exports = hasPropertyDescriptors;

  /***/
}, /* 224 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var getPolyfill = __webpack_require__(135);
  var define = __webpack_require__(72);
  module.exports = function shimObjectIs() {
    var polyfill = getPolyfill();
    define(Object, {
      is: polyfill
    }, {
      is: function testObjectIs() {
        return Object.is !== polyfill;
      }
    });
    return polyfill;
  };

  /***/
}, /* 225 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var callBound = __webpack_require__(133);
  var hasToStringTag = __webpack_require__(92)();
  var has;
  var $exec;
  var isRegexMarker;
  var badStringifier;
  if (hasToStringTag) {
    has = callBound('Object.prototype.hasOwnProperty');
    $exec = callBound('RegExp.prototype.exec');
    isRegexMarker = {};
    var throwRegexMarker = function () {
      throw isRegexMarker;
    };
    badStringifier = {
      toString: throwRegexMarker,
      valueOf: throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') {
      badStringifier[Symbol.toPrimitive] = throwRegexMarker;
    }
  }
  var $toString = callBound('Object.prototype.toString');
  var gOPD = Object.getOwnPropertyDescriptor;
  var regexClass = '[object RegExp]';
  module.exports = hasToStringTag
  // eslint-disable-next-line consistent-return
  ? function isRegex(value) {
    if (!value || typeof value !== 'object') {
      return false;
    }
    var descriptor = gOPD(value, 'lastIndex');
    var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
    if (!hasLastIndexDataProperty) {
      return false;
    }
    try {
      $exec(value, badStringifier);
    } catch (e) {
      return e === isRegexMarker;
    }
  } : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== 'object' && typeof value !== 'function') {
      return false;
    }
    return $toString(value) === regexClass;
  };

  /***/
}, /* 226 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var define = __webpack_require__(72);
  var callBind = __webpack_require__(95);
  var implementation = __webpack_require__(136);
  var getPolyfill = __webpack_require__(137);
  var shim = __webpack_require__(228);
  var flagsBound = callBind(getPolyfill());
  define(flagsBound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
  });
  module.exports = flagsBound;

  /***/
}, /* 227 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var functionsHaveNames = function functionsHaveNames() {
    return typeof function f() {}.name === 'string';
  };
  var gOPD = Object.getOwnPropertyDescriptor;
  if (gOPD) {
    try {
      gOPD([], 'length');
    } catch (e) {
      // IE 8 has a broken gOPD
      gOPD = null;
    }
  }
  functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!functionsHaveNames() || !gOPD) {
      return false;
    }
    var desc = gOPD(function () {}, 'name');
    return !!desc && !!desc.configurable;
  };
  var $bind = Function.prototype.bind;
  functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
  };
  module.exports = functionsHaveNames;

  /***/
}, /* 228 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var supportsDescriptors = __webpack_require__(72).supportsDescriptors;
  var getPolyfill = __webpack_require__(137);
  var gOPD = Object.getOwnPropertyDescriptor;
  var defineProperty = Object.defineProperty;
  var TypeErr = TypeError;
  var getProto = Object.getPrototypeOf;
  var regex = /a/;
  module.exports = function shimFlags() {
    if (!supportsDescriptors || !getProto) {
      throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    }
    var polyfill = getPolyfill();
    var proto = getProto(regex);
    var descriptor = gOPD(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) {
      defineProperty(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
      });
    }
    return polyfill;
  };

  /***/
}, /* 229 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var getDay = Date.prototype.getDay;
  var tryDateObject = function tryDateGetDayCall(value) {
    try {
      getDay.call(value);
      return true;
    } catch (e) {
      return false;
    }
  };
  var toStr = Object.prototype.toString;
  var dateClass = '[object Date]';
  var hasToStringTag = __webpack_require__(92)();
  module.exports = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) {
      return false;
    }
    return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
  };

  /***/
}, /* 230 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var _react = __webpack_require__(1);
  var _react2 = _interopRequireDefault(_react);
  var _propTypes = __webpack_require__(0);
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _gud = __webpack_require__(231);
  var _gud2 = _interopRequireDefault(_gud);
  var _warning = __webpack_require__(83);
  var _warning2 = _interopRequireDefault(_warning);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MAX_SIGNED_31_BIT_INT = 1073741823;

  // Inlined Object.is polyfill.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
  function objectIs(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function createEventEmitter(value) {
    var handlers = [];
    return {
      on: function on(handler) {
        handlers.push(handler);
      },
      off: function off(handler) {
        handlers = handlers.filter(function (h) {
          return h !== handler;
        });
      },
      get: function get() {
        return value;
      },
      set: function set(newValue, changedBits) {
        value = newValue;
        handlers.forEach(function (handler) {
          return handler(value, changedBits);
        });
      }
    };
  }
  function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
  }
  function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
    var Provider = function (_Component) {
      _inherits(Provider, _Component);
      function Provider() {
        var _temp, _this, _ret;
        _classCallCheck(this, Provider);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
      }
      Provider.prototype.getChildContext = function getChildContext() {
        var _ref;
        return _ref = {}, _ref[contextProp] = this.emitter, _ref;
      };
      Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
          var oldValue = this.props.value;
          var newValue = nextProps.value;
          var changedBits = void 0;
          if (objectIs(oldValue, newValue)) {
            changedBits = 0; // No change
          } else {
            changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            if (false) {}
            changedBits |= 0;
            if (changedBits !== 0) {
              this.emitter.set(nextProps.value, changedBits);
            }
          }
        }
      };
      Provider.prototype.render = function render() {
        return this.props.children;
      };
      return Provider;
    }(_react.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function (_Component2) {
      _inherits(Consumer, _Component2);
      function Consumer() {
        var _temp2, _this2, _ret2;
        _classCallCheck(this, Consumer);
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
          value: _this2.getValue()
        }, _this2.onUpdate = function (newValue, changedBits) {
          var observedBits = _this2.observedBits | 0;
          if ((observedBits & changedBits) !== 0) {
            _this2.setState({
              value: _this2.getValue()
            });
          }
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
      }
      Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var observedBits = nextProps.observedBits;
        this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
        : observedBits;
      };
      Consumer.prototype.componentDidMount = function componentDidMount() {
        if (this.context[contextProp]) {
          this.context[contextProp].on(this.onUpdate);
        }
        var observedBits = this.props.observedBits;
        this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
        : observedBits;
      };
      Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.context[contextProp]) {
          this.context[contextProp].off(this.onUpdate);
        }
      };
      Consumer.prototype.getValue = function getValue() {
        if (this.context[contextProp]) {
          return this.context[contextProp].get();
        } else {
          return defaultValue;
        }
      };
      Consumer.prototype.render = function render() {
        return onlyChild(this.props.children)(this.state.value);
      };
      return Consumer;
    }(_react.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
    return {
      Provider: Provider,
      Consumer: Consumer
    };
  }
  exports.default = createReactContext;
  module.exports = exports['default'];

  /***/
}, /* 231 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    // @flow

    var key = '__global_unique_id__';
    module.exports = function () {
      return global[key] = (global[key] || 0) + 1;
    };

    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(36));

  /***/
}, /* 232 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(233);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 233 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * DatePicker.css\n *\n * TODO: Move this into Rhombus;\n */\n\n.CalendarDay {\n\tborder: none;\n}\n\n.e-form__control.date-range .DayPickerNavigation__prev,\n.DayPickerNavigation__next {\n\tborder: none;\n\tbackground: none;\n\twidth: 30px;\n\theight: 30px;\n\tpadding: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.DateInput {\n\tfont-size: 16px;\n\tpadding: 2px;\n\tmin-width: 120px;\n\twidth: auto;\n}\n\n\n.CalendarDay--selected { border-radius: 50%; }\n.CalendarDay--selected-start { border-radius: 50% 0 0 50%; }\n.CalendarDay--selected-end { border-radius: 0 50% 50% 0; }\n\n/**\n * @2. Themes\n */\n\t/**\n\t * @2.1 Pink\n\t ****/\n\t\t.rr-pink .CalendarDay--after-hovered-start,\n\t\t.rr-pink .CalendarDay--hovered-span,\n\t\t.rr-pink .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-pink .CalendarDay--selected-span:active,\n\t\t.rr-pink .CalendarDay--selected-span {\n\t\t\tbackground-color: #ea8daf;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-pink .CalendarDay--selected,\n\t\t.rr-pink .CalendarDay--selected-start,\n\t\t.rr-pink .CalendarDay--selected-end {\n\t\t\tbackground-color: #d52f6f;\n\t\t}\n\t\t.rr-pink .DateInput__display-text--focused {\n\t\t\tbackground-color: #d11560;\n\t\t\tborder-color: #d52f6f;\n\t\t\tcolor: #fff;\n\t\t}\n\t/**\n\t * @2.2 Blue\n\t ****/\n\t\t.rr-blue .CalendarDay--after-hovered-start,\n\t\t.rr-blue .CalendarDay--hovered-span,\n\t\t.rr-blue .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-blue .CalendarDay--selected-span:active,\n\t\t.rr-blue .CalendarDay--selected-span {\n\t\t\tbackground-color: #8ab7db;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-blue .CalendarDay--selected,\n\t\t.rr-blue .CalendarDay--selected-start,\n\t\t.rr-blue .CalendarDay--selected-end {\n\t\t\tbackground-color: #2d7ebf;\n\t\t}\n\t\t.rr-blue .DateInput__display-text--focused {\n\t\t\tbackground-color: #1771B9;\n\t\t\tborder-color: #2d7ebf;\n\t\t\tcolor: #fff;\n\t\t}\n\n\t/**\n\t * @2.3 Green\n\t ****/\n\t\t.rr-green .CalendarDay--after-hovered-start,\n\t\t.rr-green .CalendarDay--hovered-span,\n\t\t.rr-green .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-green .CalendarDay--selected-span:active,\n\t\t.rr-green .CalendarDay--selected-span {\n\t\t\tbackground-color: #9fdaab;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-green .CalendarDay--selected,\n\t\t.rr-green .CalendarDay--selected-start,\n\t\t.rr-green .CalendarDay--selected-end {\n\t\t\tbackground-color: #52bc68;\n\t\t}\n\t\t.rr-green .DateInput__display-text--focused {\n\t\t\tbackground-color: #40b658;\n\t\t\tborder-color: #52bc68;\n\t\t\tcolor: #fff;\n\t\t}\n\t/**\n\t * @2.4 Purple\n\t ****/\n\t\t.rr-purple .CalendarDay--after-hovered-start,\n\t\t.rr-purple .CalendarDay--hovered-span,\n\t\t.rr-purple .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-purple .CalendarDay--selected-span:active,\n\t\t.rr-purple .CalendarDay--selected-span {\n\t\t\tbackground-color: #c6bad9;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-purple .CalendarDay--selected,\n\t\t.rr-purple .CalendarDay--selected-start,\n\t\t.rr-purple .CalendarDay--selected-end {\n\t\t\tbackground-color: #9883bb;\n\t\t}\n\t\t.rr-purple .DateInput__display-text--focused {\n\t\t\tbackground-color: #8e76b5;\n\t\t\tborder-color: #9883bb;\n\t\t\tcolor: #fff;\n\t\t}\n\t/**\n\t * @2.5 Orange\n\t ****/\n\t\t.rr-orange .CalendarDay--after-hovered-start,\n\t\t.rr-orange .CalendarDay--hovered-span,\n\t\t.rr-orange .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-orange .CalendarDay--selected-span:active,\n\t\t.rr-orange .CalendarDay--selected-span {\n\t\t\tbackground-color: #f8b99d;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-orange .CalendarDay--selected,\n\t\t.rr-orange .CalendarDay--selected-start,\n\t\t.rr-orange .CalendarDay--selected-end {\n\t\t\tbackground-color: #f3824f;\n\t\t}\n\t\t.rr-orange .DateInput__display-text--focused {\n\t\t\tbackground-color: #f3753d;\n\t\t\tborder-color: #f3824f;\n\t\t\tcolor: #fff;\n\t\t}\n\t/**\n\t * @2.6 Yellow\n\t ****/\n\t\t.rr-yellow .CalendarDay--after-hovered-start,\n\t\t.rr-yellow .CalendarDay--hovered-span,\n\t\t.rr-yellow .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-yellow .CalendarDay--selected-span:active,\n\t\t.rr-yellow .CalendarDay--selected-span {\n\t\t\tbackground-color: #ecdd93;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-yellow .CalendarDay--selected,\n\t\t.rr-yellow .CalendarDay--selected-start,\n\t\t.rr-yellow .CalendarDay--selected-end {\n\t\t\tbackground-color: #e3cc3b;\n\t\t}\n\t\t.rr-yellow .DateInput__display-text--focused {\n\t\t\tbackground-color: #e1c921;\n\t\t\tborder-color: #e3cc3b;\n\t\t\tcolor: #fff;\n\t\t}\n\t/**\n\t * @2.7 Red\n\t ****/\n\t\t.rr-red .CalendarDay--after-hovered-start,\n\t\t.rr-red .CalendarDay--hovered-span,\n\t\t.rr-red .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-red .CalendarDay--selected-span:active,\n\t\t.rr-red .CalendarDay--selected-span {\n\t\t\tbackground-color: #ebaaa8;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-red .CalendarDay--selected,\n\t\t.rr-red .CalendarDay--selected-start,\n\t\t.rr-red .CalendarDay--selected-end {\n\t\t\tbackground-color: #db6662;\n\t\t}\n\n\t\t.rr-red .DateInput__display-text--focused {\n\t\t\tbackground-color: #d95652;\n\t\t\tborder-color: #db6662;\n\t\t\tcolor: #fff;\n\t\t}\n\n/**\n * @3. Header\n *****/\n .CalendarMonth--horizontal .CalendarMonth__caption,\n .CalendarMonth--vertical .CalendarMonth__caption {\n \tpadding: 10px 0 25px;\n }\n .DayPicker__week-header {\n \ttransform: translateY(-10px);\n }\n.DateRangePickerInput__clear-dates,\n.DateRangePickerInput__clear-dates--hover,\n.DateRangePickerInput__clear-dates:focus {\n\t/* TODO: Change this to be padding based; */\n\ttransform: scale(0.7 );\n}\n", "", {
    "version": 3,
    "sources": ["DatePicker.css"],
    "names": [],
    "mappings": "AAAA;;;;EAIE;;AAEF;CACC,YAAY;AACb;;AAEA;;CAEC,YAAY;CACZ,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,UAAU;CACV,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,WAAW;AACZ;;;AAGA,yBAAyB,kBAAkB,EAAE;AAC7C,+BAA+B,0BAA0B,EAAE;AAC3D,6BAA6B,0BAA0B,EAAE;;AAEzD;;EAEE;CACD;;MAEK;EACJ;;;;;GAKC,yBAAyB;GACzB,YAAY;GACZ,WAAW;EACZ;EACA;;;GAGC,yBAAyB;EAC1B;EACA;GACC,yBAAyB;GACzB,qBAAqB;GACrB,WAAW;EACZ;CACD;;MAEK;EACJ;;;;;GAKC,yBAAyB;GACzB,YAAY;GACZ,WAAW;EACZ;EACA;;;GAGC,yBAAyB;EAC1B;EACA;GACC,yBAAyB;GACzB,qBAAqB;GACrB,WAAW;EACZ;;CAED;;MAEK;EACJ;;;;;GAKC,yBAAyB;GACzB,YAAY;GACZ,WAAW;EACZ;EACA;;;GAGC,yBAAyB;EAC1B;EACA;GACC,yBAAyB;GACzB,qBAAqB;GACrB,WAAW;EACZ;CACD;;MAEK;EACJ;;;;;GAKC,yBAAyB;GACzB,YAAY;GACZ,WAAW;EACZ;EACA;;;GAGC,yBAAyB;EAC1B;EACA;GACC,yBAAyB;GACzB,qBAAqB;GACrB,WAAW;EACZ;CACD;;MAEK;EACJ;;;;;GAKC,yBAAyB;GACzB,YAAY;GACZ,WAAW;EACZ;EACA;;;GAGC,yBAAyB;EAC1B;EACA;GACC,yBAAyB;GACzB,qBAAqB;GACrB,WAAW;EACZ;CACD;;MAEK;EACJ;;;;;GAKC,yBAAyB;GACzB,YAAY;GACZ,WAAW;EACZ;EACA;;;GAGC,yBAAyB;EAC1B;EACA;GACC,yBAAyB;GACzB,qBAAqB;GACrB,WAAW;EACZ;CACD;;MAEK;EACJ;;;;;GAKC,yBAAyB;GACzB,YAAY;GACZ,WAAW;EACZ;EACA;;;GAGC,yBAAyB;EAC1B;;EAEA;GACC,yBAAyB;GACzB,qBAAqB;GACrB,WAAW;EACZ;;AAEF;;MAEM;CACL;;EAEC,oBAAoB;CACrB;CACA;EACC,4BAA4B;CAC7B;AACD;;;CAGC,2CAA2C;CAC3C,sBAAsB;AACvB",
    "file": "DatePicker.css",
    "sourcesContent": ["/**\n * DatePicker.css\n *\n * TODO: Move this into Rhombus;\n */\n\n.CalendarDay {\n\tborder: none;\n}\n\n.e-form__control.date-range .DayPickerNavigation__prev,\n.DayPickerNavigation__next {\n\tborder: none;\n\tbackground: none;\n\twidth: 30px;\n\theight: 30px;\n\tpadding: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.DateInput {\n\tfont-size: 16px;\n\tpadding: 2px;\n\tmin-width: 120px;\n\twidth: auto;\n}\n\n\n.CalendarDay--selected { border-radius: 50%; }\n.CalendarDay--selected-start { border-radius: 50% 0 0 50%; }\n.CalendarDay--selected-end { border-radius: 0 50% 50% 0; }\n\n/**\n * @2. Themes\n */\n\t/**\n\t * @2.1 Pink\n\t ****/\n\t\t.rr-pink .CalendarDay--after-hovered-start,\n\t\t.rr-pink .CalendarDay--hovered-span,\n\t\t.rr-pink .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-pink .CalendarDay--selected-span:active,\n\t\t.rr-pink .CalendarDay--selected-span {\n\t\t\tbackground-color: #ea8daf;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-pink .CalendarDay--selected,\n\t\t.rr-pink .CalendarDay--selected-start,\n\t\t.rr-pink .CalendarDay--selected-end {\n\t\t\tbackground-color: #d52f6f;\n\t\t}\n\t\t.rr-pink .DateInput__display-text--focused {\n\t\t\tbackground-color: #d11560;\n\t\t\tborder-color: #d52f6f;\n\t\t\tcolor: #fff;\n\t\t}\n\t/**\n\t * @2.2 Blue\n\t ****/\n\t\t.rr-blue .CalendarDay--after-hovered-start,\n\t\t.rr-blue .CalendarDay--hovered-span,\n\t\t.rr-blue .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-blue .CalendarDay--selected-span:active,\n\t\t.rr-blue .CalendarDay--selected-span {\n\t\t\tbackground-color: #8ab7db;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-blue .CalendarDay--selected,\n\t\t.rr-blue .CalendarDay--selected-start,\n\t\t.rr-blue .CalendarDay--selected-end {\n\t\t\tbackground-color: #2d7ebf;\n\t\t}\n\t\t.rr-blue .DateInput__display-text--focused {\n\t\t\tbackground-color: #1771B9;\n\t\t\tborder-color: #2d7ebf;\n\t\t\tcolor: #fff;\n\t\t}\n\n\t/**\n\t * @2.3 Green\n\t ****/\n\t\t.rr-green .CalendarDay--after-hovered-start,\n\t\t.rr-green .CalendarDay--hovered-span,\n\t\t.rr-green .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-green .CalendarDay--selected-span:active,\n\t\t.rr-green .CalendarDay--selected-span {\n\t\t\tbackground-color: #9fdaab;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-green .CalendarDay--selected,\n\t\t.rr-green .CalendarDay--selected-start,\n\t\t.rr-green .CalendarDay--selected-end {\n\t\t\tbackground-color: #52bc68;\n\t\t}\n\t\t.rr-green .DateInput__display-text--focused {\n\t\t\tbackground-color: #40b658;\n\t\t\tborder-color: #52bc68;\n\t\t\tcolor: #fff;\n\t\t}\n\t/**\n\t * @2.4 Purple\n\t ****/\n\t\t.rr-purple .CalendarDay--after-hovered-start,\n\t\t.rr-purple .CalendarDay--hovered-span,\n\t\t.rr-purple .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-purple .CalendarDay--selected-span:active,\n\t\t.rr-purple .CalendarDay--selected-span {\n\t\t\tbackground-color: #c6bad9;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-purple .CalendarDay--selected,\n\t\t.rr-purple .CalendarDay--selected-start,\n\t\t.rr-purple .CalendarDay--selected-end {\n\t\t\tbackground-color: #9883bb;\n\t\t}\n\t\t.rr-purple .DateInput__display-text--focused {\n\t\t\tbackground-color: #8e76b5;\n\t\t\tborder-color: #9883bb;\n\t\t\tcolor: #fff;\n\t\t}\n\t/**\n\t * @2.5 Orange\n\t ****/\n\t\t.rr-orange .CalendarDay--after-hovered-start,\n\t\t.rr-orange .CalendarDay--hovered-span,\n\t\t.rr-orange .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-orange .CalendarDay--selected-span:active,\n\t\t.rr-orange .CalendarDay--selected-span {\n\t\t\tbackground-color: #f8b99d;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-orange .CalendarDay--selected,\n\t\t.rr-orange .CalendarDay--selected-start,\n\t\t.rr-orange .CalendarDay--selected-end {\n\t\t\tbackground-color: #f3824f;\n\t\t}\n\t\t.rr-orange .DateInput__display-text--focused {\n\t\t\tbackground-color: #f3753d;\n\t\t\tborder-color: #f3824f;\n\t\t\tcolor: #fff;\n\t\t}\n\t/**\n\t * @2.6 Yellow\n\t ****/\n\t\t.rr-yellow .CalendarDay--after-hovered-start,\n\t\t.rr-yellow .CalendarDay--hovered-span,\n\t\t.rr-yellow .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-yellow .CalendarDay--selected-span:active,\n\t\t.rr-yellow .CalendarDay--selected-span {\n\t\t\tbackground-color: #ecdd93;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-yellow .CalendarDay--selected,\n\t\t.rr-yellow .CalendarDay--selected-start,\n\t\t.rr-yellow .CalendarDay--selected-end {\n\t\t\tbackground-color: #e3cc3b;\n\t\t}\n\t\t.rr-yellow .DateInput__display-text--focused {\n\t\t\tbackground-color: #e1c921;\n\t\t\tborder-color: #e3cc3b;\n\t\t\tcolor: #fff;\n\t\t}\n\t/**\n\t * @2.7 Red\n\t ****/\n\t\t.rr-red .CalendarDay--after-hovered-start,\n\t\t.rr-red .CalendarDay--hovered-span,\n\t\t.rr-red .CalendarDay--selected-span.CalendarDay--hovered,\n\t\t.rr-red .CalendarDay--selected-span:active,\n\t\t.rr-red .CalendarDay--selected-span {\n\t\t\tbackground-color: #ebaaa8;\n\t\t\tborder: none;\n\t\t\tcolor: #fff;\n\t\t}\n\t\t.rr-red .CalendarDay--selected,\n\t\t.rr-red .CalendarDay--selected-start,\n\t\t.rr-red .CalendarDay--selected-end {\n\t\t\tbackground-color: #db6662;\n\t\t}\n\n\t\t.rr-red .DateInput__display-text--focused {\n\t\t\tbackground-color: #d95652;\n\t\t\tborder-color: #db6662;\n\t\t\tcolor: #fff;\n\t\t}\n\n/**\n * @3. Header\n *****/\n .CalendarMonth--horizontal .CalendarMonth__caption,\n .CalendarMonth--vertical .CalendarMonth__caption {\n \tpadding: 10px 0 25px;\n }\n .DayPicker__week-header {\n \ttransform: translateY(-10px);\n }\n.DateRangePickerInput__clear-dates,\n.DateRangePickerInput__clear-dates--hover,\n.DateRangePickerInput__clear-dates:focus {\n\t/* TODO: Change this to be padding based; */\n\ttransform: scale(0.7 );\n}\n"]
  }]);

  /***/
}, /* 234 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(235);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 235 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/* TODO merge this file with DatePicker.css, which is currently unused */\n\n.rhombus-date-picker-wrapper .react-datepicker-wrapper input {\n\tpadding-left: 33px;\n\tbackground: transparent;\n\twidth: 173px;\n}\n\n.date-range .to-div {\n\tmargin-right: 10px;\n\tmargin-top: 6px;\n}\n\n.rhombus-date-picker-wrapper .rhombus-date-picker-icon {\n\tposition: absolute;\n\ttop: 9px;\n\tleft: 10px;\n\t/* needs a z-index > 0 to force it to show up for some reason */\n\tz-index: 1;\n}\n\n.date-range>div {\n\tposition: relative;\n}\n\n/* prevent react-datepicker from line breaking when 2 months are shown\n * seems to be a bug in the library\n */\n.date-range.months-shown-2 .react-datepicker-popper {\n\twidth: 423px;\n}\n\n/* needs to be the same as .e-form__input styles */\n.e-form__control.date-picker .react-datepicker__input-container input,\n.e-form__control.date-range .react-datepicker__input-container input{\n\tbackground-color: #FFF;\n\tcolor: #374047;\n\tborder: 1px solid #aeb2b5;\n\tborder-radius: 3px;\n\twidth: 173px;\n\t-webkit-transition: border .1s linear,background-color .1s linear;\n\tdisplay: inline-block;\n\tpadding: 0 1rem 0 33px;\n\tline-height: 2.125rem;\n\tmin-height: calc(2.125rem + 5px);\n}\n", "", {
    "version": 3,
    "sources": ["DatePickerTemp.css"],
    "names": [],
    "mappings": "AAAA,wEAAwE;;AAExE;CACC,kBAAkB;CAClB,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,+DAA+D;CAC/D,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;EAEE;AACF;CACC,YAAY;AACb;;AAEA,kDAAkD;AAClD;;CAEC,sBAAsB;CACtB,cAAc;CACd,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,iEAAiE;CACjE,qBAAqB;CACrB,sBAAsB;CACtB,qBAAqB;CACrB,gCAAgC;AACjC",
    "file": "DatePickerTemp.css",
    "sourcesContent": ["/* TODO merge this file with DatePicker.css, which is currently unused */\n\n.rhombus-date-picker-wrapper .react-datepicker-wrapper input {\n\tpadding-left: 33px;\n\tbackground: transparent;\n\twidth: 173px;\n}\n\n.date-range .to-div {\n\tmargin-right: 10px;\n\tmargin-top: 6px;\n}\n\n.rhombus-date-picker-wrapper .rhombus-date-picker-icon {\n\tposition: absolute;\n\ttop: 9px;\n\tleft: 10px;\n\t/* needs a z-index > 0 to force it to show up for some reason */\n\tz-index: 1;\n}\n\n.date-range>div {\n\tposition: relative;\n}\n\n/* prevent react-datepicker from line breaking when 2 months are shown\n * seems to be a bug in the library\n */\n.date-range.months-shown-2 .react-datepicker-popper {\n\twidth: 423px;\n}\n\n/* needs to be the same as .e-form__input styles */\n.e-form__control.date-picker .react-datepicker__input-container input,\n.e-form__control.date-range .react-datepicker__input-container input{\n\tbackground-color: #FFF;\n\tcolor: #374047;\n\tborder: 1px solid #aeb2b5;\n\tborder-radius: 3px;\n\twidth: 173px;\n\t-webkit-transition: border .1s linear,background-color .1s linear;\n\tdisplay: inline-block;\n\tpadding: 0 1rem 0 33px;\n\tline-height: 2.125rem;\n\tmin-height: calc(2.125rem + 5px);\n}\n"]
  }]);

  /***/
}, /* 236 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(237);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 237 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, ".time-picker,\n.time-picker .ampm{\n\tdisplay: flex;\n}\n.time-picker .e-form__control-wrapper.time-piece{\n\twidth: 75px;\n\tmargin-right: 10px;\n\tmargin-left: 0;\n}\n.time-picker .e-form__control-wrapper.checkbox-component{\n\twidth: 50px;\n}\n", "", {
    "version": 3,
    "sources": ["TimePicker.css"],
    "names": [],
    "mappings": "AAAA;;CAEC,aAAa;AACd;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;AACA;CACC,WAAW;AACZ",
    "file": "TimePicker.css",
    "sourcesContent": [".time-picker,\n.time-picker .ampm{\n\tdisplay: flex;\n}\n.time-picker .e-form__control-wrapper.time-piece{\n\twidth: 75px;\n\tmargin-right: 10px;\n\tmargin-left: 0;\n}\n.time-picker .e-form__control-wrapper.checkbox-component{\n\twidth: 50px;\n}\n"]
  }]);

  /***/
}, /* 238 */
/***/function (module, exports) {
  var core = module.exports = {
    version: '2.6.12'
  };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

  /***/
}, /* 239 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /*! VelocityJS.org (1.5.2). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */

  /*************************
   Velocity jQuery Shim
   *************************/

  /*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */

  /* This file contains the jQuery functions that Velocity relies on, thereby removing Velocity's dependency on a full copy of jQuery, and allowing it to work in any environment. */
  /* These shimmed functions are only used if jQuery isn't present. If both this shim and jQuery are loaded, Velocity defaults to jQuery proper. */
  /* Browser support: Using this shim instead of jQuery proper removes support for IE8. */

  (function (window) {
    "use strict";

    /***************
     Setup
     ***************/

    /* If jQuery is already loaded, there's no point in loading this shim. */
    if (window.jQuery) {
      return;
    }

    /* jQuery base. */
    var $ = function (selector, context) {
      return new $.fn.init(selector, context);
    };

    /********************
     Private Methods
     ********************/

    /* jQuery */
    $.isWindow = function (obj) {
      /* jshint eqeqeq: false */
      return obj && obj === obj.window;
    };

    /* jQuery */
    $.type = function (obj) {
      if (!obj) {
        return obj + "";
      }
      return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    };

    /* jQuery */
    $.isArray = Array.isArray || function (obj) {
      return $.type(obj) === "array";
    };

    /* jQuery */
    function isArraylike(obj) {
      var length = obj.length,
        type = $.type(obj);
      if (type === "function" || $.isWindow(obj)) {
        return false;
      }
      if (obj.nodeType === 1 && length) {
        return true;
      }
      return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }

    /***************
     $ Methods
     ***************/

    /* jQuery: Support removed for IE<9. */
    $.isPlainObject = function (obj) {
      var key;
      if (!obj || $.type(obj) !== "object" || obj.nodeType || $.isWindow(obj)) {
        return false;
      }
      try {
        if (obj.constructor && !hasOwn.call(obj, "constructor") && !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
          return false;
        }
      } catch (e) {
        return false;
      }
      for (key in obj) {}
      return key === undefined || hasOwn.call(obj, key);
    };

    /* jQuery */
    $.each = function (obj, callback, args) {
      var value,
        i = 0,
        length = obj.length,
        isArray = isArraylike(obj);
      if (args) {
        if (isArray) {
          for (; i < length; i++) {
            value = callback.apply(obj[i], args);
            if (value === false) {
              break;
            }
          }
        } else {
          for (i in obj) {
            if (!obj.hasOwnProperty(i)) {
              continue;
            }
            value = callback.apply(obj[i], args);
            if (value === false) {
              break;
            }
          }
        }
      } else {
        if (isArray) {
          for (; i < length; i++) {
            value = callback.call(obj[i], i, obj[i]);
            if (value === false) {
              break;
            }
          }
        } else {
          for (i in obj) {
            if (!obj.hasOwnProperty(i)) {
              continue;
            }
            value = callback.call(obj[i], i, obj[i]);
            if (value === false) {
              break;
            }
          }
        }
      }
      return obj;
    };

    /* Custom */
    $.data = function (node, key, value) {
      /* $.getData() */
      if (value === undefined) {
        var getId = node[$.expando],
          store = getId && cache[getId];
        if (key === undefined) {
          return store;
        } else if (store) {
          if (key in store) {
            return store[key];
          }
        }
        /* $.setData() */
      } else if (key !== undefined) {
        var setId = node[$.expando] || (node[$.expando] = ++$.uuid);
        cache[setId] = cache[setId] || {};
        cache[setId][key] = value;
        return value;
      }
    };

    /* Custom */
    $.removeData = function (node, keys) {
      var id = node[$.expando],
        store = id && cache[id];
      if (store) {
        // Cleanup the entire store if no keys are provided.
        if (!keys) {
          delete cache[id];
        } else {
          $.each(keys, function (_, key) {
            delete store[key];
          });
        }
      }
    };

    /* jQuery */
    $.extend = function () {
      var src,
        copyIsArray,
        copy,
        name,
        options,
        clone,
        target = arguments[0] || {},
        i = 1,
        length = arguments.length,
        deep = false;
      if (typeof target === "boolean") {
        deep = target;
        target = arguments[i] || {};
        i++;
      }
      if (typeof target !== "object" && $.type(target) !== "function") {
        target = {};
      }
      if (i === length) {
        target = this;
        i--;
      }
      for (; i < length; i++) {
        if (options = arguments[i]) {
          for (name in options) {
            if (!options.hasOwnProperty(name)) {
              continue;
            }
            src = target[name];
            copy = options[name];
            if (target === copy) {
              continue;
            }
            if (deep && copy && ($.isPlainObject(copy) || (copyIsArray = $.isArray(copy)))) {
              if (copyIsArray) {
                copyIsArray = false;
                clone = src && $.isArray(src) ? src : [];
              } else {
                clone = src && $.isPlainObject(src) ? src : {};
              }
              target[name] = $.extend(deep, clone, copy);
            } else if (copy !== undefined) {
              target[name] = copy;
            }
          }
        }
      }
      return target;
    };

    /* jQuery 1.4.3 */
    $.queue = function (elem, type, data) {
      function $makeArray(arr, results) {
        var ret = results || [];
        if (arr) {
          if (isArraylike(Object(arr))) {
            /* $.merge */
            (function (first, second) {
              var len = +second.length,
                j = 0,
                i = first.length;
              while (j < len) {
                first[i++] = second[j++];
              }
              if (len !== len) {
                while (second[j] !== undefined) {
                  first[i++] = second[j++];
                }
              }
              first.length = i;
              return first;
            })(ret, typeof arr === "string" ? [arr] : arr);
          } else {
            [].push.call(ret, arr);
          }
        }
        return ret;
      }
      if (!elem) {
        return;
      }
      type = (type || "fx") + "queue";
      var q = $.data(elem, type);
      if (!data) {
        return q || [];
      }
      if (!q || $.isArray(data)) {
        q = $.data(elem, type, $makeArray(data));
      } else {
        q.push(data);
      }
      return q;
    };

    /* jQuery 1.4.3 */
    $.dequeue = function (elems, type) {
      /* Custom: Embed element iteration. */
      $.each(elems.nodeType ? [elems] : elems, function (i, elem) {
        type = type || "fx";
        var queue = $.queue(elem, type),
          fn = queue.shift();
        if (fn === "inprogress") {
          fn = queue.shift();
        }
        if (fn) {
          if (type === "fx") {
            queue.unshift("inprogress");
          }
          fn.call(elem, function () {
            $.dequeue(elem, type);
          });
        }
      });
    };

    /******************
     $.fn Methods
     ******************/

    /* jQuery */
    $.fn = $.prototype = {
      init: function (selector) {
        /* Just return the element wrapped inside an array; don't proceed with the actual jQuery node wrapping process. */
        if (selector.nodeType) {
          this[0] = selector;
          return this;
        } else {
          throw new Error("Not a DOM node.");
        }
      },
      offset: function () {
        /* jQuery altered code: Dropped disconnected DOM node checking. */
        var box = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {
          top: 0,
          left: 0
        };
        return {
          top: box.top + (window.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
          left: box.left + (window.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
        };
      },
      position: function () {
        /* jQuery */
        function offsetParentFn(elem) {
          var offsetParent = elem.offsetParent;
          while (offsetParent && offsetParent.nodeName.toLowerCase() !== "html" && offsetParent.style && offsetParent.style.position.toLowerCase() === "static") {
            offsetParent = offsetParent.offsetParent;
          }
          return offsetParent || document;
        }

        /* Zepto */
        var elem = this[0],
          offsetParent = offsetParentFn(elem),
          offset = this.offset(),
          parentOffset = /^(?:body|html)$/i.test(offsetParent.nodeName) ? {
            top: 0,
            left: 0
          } : $(offsetParent).offset();
        offset.top -= parseFloat(elem.style.marginTop) || 0;
        offset.left -= parseFloat(elem.style.marginLeft) || 0;
        if (offsetParent.style) {
          parentOffset.top += parseFloat(offsetParent.style.borderTopWidth) || 0;
          parentOffset.left += parseFloat(offsetParent.style.borderLeftWidth) || 0;
        }
        return {
          top: offset.top - parentOffset.top,
          left: offset.left - parentOffset.left
        };
      }
    };

    /**********************
     Private Variables
     **********************/

    /* For $.data() */
    var cache = {};
    $.expando = "velocity" + new Date().getTime();
    $.uuid = 0;

    /* For $.queue() */
    var class2type = {},
      hasOwn = class2type.hasOwnProperty,
      toString = class2type.toString;
    var types = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
    for (var i = 0; i < types.length; i++) {
      class2type["[object " + types[i] + "]"] = types[i].toLowerCase();
    }

    /* Makes $(node) possible, without having to call init. */
    $.fn.init.prototype = $.fn;

    /* Globalize Velocity onto the window, and assign its Utilities property. */
    window.Velocity = {
      Utilities: $
    };
  })(window);

  /******************
   Velocity.js
   ******************/

  (function (factory) {
    "use strict";

    /* CommonJS module. */
    if (true && typeof module.exports === "object") {
      module.exports = factory();
      /* AMD module. */
    } else if (true) {
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      /* Browser globals. */
    } else {}
  })(function () {
    "use strict";

    return function (global, window, document, undefined) {
      /***************
       Summary
       ***************/

      /*
       - CSS: CSS stack that works independently from the rest of Velocity.
       - animate(): Core animation method that iterates over the targeted elements and queues the incoming call onto each element individually.
       - Pre-Queueing: Prepare the element for animation by instantiating its data cache and processing the call's options.
       - Queueing: The logic that runs once the call has reached its point of execution in the element's $.queue() stack.
       Most logic is placed here to avoid risking it becoming stale (if the element's properties have changed).
       - Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
       - tick(): The single requestAnimationFrame loop responsible for tweening all in-progress calls.
       - completeCall(): Handles the cleanup process for each Velocity call.
       */

      /*********************
       Helper Functions
       *********************/

      /* IE detection. Gist: https://gist.github.com/julianshapiro/9098609 */
      var IE = function () {
        if (document.documentMode) {
          return document.documentMode;
        } else {
          for (var i = 7; i > 4; i--) {
            var div = document.createElement("div");
            div.innerHTML = "<!--[if IE " + i + "]><span></span><![endif]-->";
            if (div.getElementsByTagName("span").length) {
              div = null;
              return i;
            }
          }
        }
        return undefined;
      }();

      /* rAF shim. Gist: https://gist.github.com/julianshapiro/9497513 */
      var rAFShim = function () {
        var timeLast = 0;
        return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
          var timeCurrent = new Date().getTime(),
            timeDelta;

          /* Dynamically set delay on a per-tick basis to match 60fps. */
          /* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
          timeDelta = Math.max(0, 16 - (timeCurrent - timeLast));
          timeLast = timeCurrent + timeDelta;
          return setTimeout(function () {
            callback(timeCurrent + timeDelta);
          }, timeDelta);
        };
      }();
      var performance = function () {
        var perf = window.performance || {};
        if (typeof perf.now !== "function") {
          var nowOffset = perf.timing && perf.timing.navigationStart ? perf.timing.navigationStart : new Date().getTime();
          perf.now = function () {
            return new Date().getTime() - nowOffset;
          };
        }
        return perf;
      }();

      /* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
      function compactSparseArray(array) {
        var index = -1,
          length = array ? array.length : 0,
          result = [];
        while (++index < length) {
          var value = array[index];
          if (value) {
            result.push(value);
          }
        }
        return result;
      }

      /**
       * Shim for "fixing" IE's lack of support (IE < 9) for applying slice
       * on host objects like NamedNodeMap, NodeList, and HTMLCollection
       * (technically, since host objects have been implementation-dependent,
       * at least before ES2015, IE hasn't needed to work this way).
       * Also works on strings, fixes IE < 9 to allow an explicit undefined
       * for the 2nd argument (as in Firefox), and prevents errors when
       * called on other DOM objects.
       */
      var _slice = function () {
        var slice = Array.prototype.slice;
        try {
          // Can't be used with DOM elements in IE < 9
          slice.call(document.documentElement);
          return slice;
        } catch (e) {
          // Fails in IE < 9

          // This will work for genuine arrays, array-like objects, 
          // NamedNodeMap (attributes, entities, notations),
          // NodeList (e.g., getElementsByTagName), HTMLCollection (e.g., childNodes),
          // and will not fail on other DOM objects (as do DOM elements in IE < 9)
          return function (begin, end) {
            var len = this.length;
            if (typeof begin !== "number") {
              begin = 0;
            }
            // IE < 9 gets unhappy with an undefined end argument
            if (typeof end !== "number") {
              end = len;
            }
            // For native Array objects, we use the native slice function
            if (this.slice) {
              return slice.call(this, begin, end);
            }
            // For array like object we handle it ourselves.
            var i,
              cloned = [],
              // Handle negative value for "begin"
              start = begin >= 0 ? begin : Math.max(0, len + begin),
              // Handle negative value for "end"
              upTo = end < 0 ? len + end : Math.min(end, len),
              // Actual expected size of the slice
              size = upTo - start;
            if (size > 0) {
              cloned = new Array(size);
              if (this.charAt) {
                for (i = 0; i < size; i++) {
                  cloned[i] = this.charAt(start + i);
                }
              } else {
                for (i = 0; i < size; i++) {
                  cloned[i] = this[start + i];
                }
              }
            }
            return cloned;
          };
        }
      }();

      /* .indexOf doesn't exist in IE<9 */
      var _inArray = function () {
        if (Array.prototype.includes) {
          return function (arr, val) {
            return arr.includes(val);
          };
        }
        if (Array.prototype.indexOf) {
          return function (arr, val) {
            return arr.indexOf(val) >= 0;
          };
        }
        return function (arr, val) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i] === val) {
              return true;
            }
          }
          return false;
        };
      };
      function sanitizeElements(elements) {
        /* Unwrap jQuery/Zepto objects. */
        if (Type.isWrapped(elements)) {
          elements = _slice.call(elements);
          /* Wrap a single element in an array so that $.each() can iterate with the element instead of its node's children. */
        } else if (Type.isNode(elements)) {
          elements = [elements];
        }
        return elements;
      }
      var Type = {
        isNumber: function (variable) {
          return typeof variable === "number";
        },
        isString: function (variable) {
          return typeof variable === "string";
        },
        isArray: Array.isArray || function (variable) {
          return Object.prototype.toString.call(variable) === "[object Array]";
        },
        isFunction: function (variable) {
          return Object.prototype.toString.call(variable) === "[object Function]";
        },
        isNode: function (variable) {
          return variable && variable.nodeType;
        },
        /* Determine if variable is an array-like wrapped jQuery, Zepto or similar element, or even a NodeList etc. */
        /* NOTE: HTMLFormElements also have a length. */
        isWrapped: function (variable) {
          return variable && variable !== window && Type.isNumber(variable.length) && !Type.isString(variable) && !Type.isFunction(variable) && !Type.isNode(variable) && (variable.length === 0 || Type.isNode(variable[0]));
        },
        isSVG: function (variable) {
          return window.SVGElement && variable instanceof window.SVGElement;
        },
        isEmptyObject: function (variable) {
          for (var name in variable) {
            if (variable.hasOwnProperty(name)) {
              return false;
            }
          }
          return true;
        }
      };

      /*****************
       Dependencies
       *****************/

      var $,
        isJQuery = false;
      if (global.fn && global.fn.jquery) {
        $ = global;
        isJQuery = true;
      } else {
        $ = window.Velocity.Utilities;
      }
      if (IE <= 8 && !isJQuery) {
        throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
      } else if (IE <= 7) {
        /* Revert to jQuery's $.animate(), and lose Velocity's extra features. */
        jQuery.fn.velocity = jQuery.fn.animate;

        /* Now that $.fn.velocity is aliased, abort this Velocity declaration. */
        return;
      }

      /*****************
       Constants
       *****************/

      var DURATION_DEFAULT = 400,
        EASING_DEFAULT = "swing";

      /*************
       State
       *************/

      var Velocity = {
        /* Container for page-wide Velocity state data. */
        State: {
          /* Detect mobile devices to determine if mobileHA should be turned on. */
          isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent),
          /* The mobileHA option's behavior changes on older Android devices (Gingerbread, versions 2.3.3-2.3.7). */
          isAndroid: /Android/i.test(window.navigator.userAgent),
          isGingerbread: /Android 2\.3\.[3-7]/i.test(window.navigator.userAgent),
          isChrome: window.chrome,
          isFirefox: /Firefox/i.test(window.navigator.userAgent),
          /* Create a cached element for re-use when checking for CSS property prefixes. */
          prefixElement: document.createElement("div"),
          /* Cache every prefix match to avoid repeating lookups. */
          prefixMatches: {},
          /* Cache the anchor used for animating window scrolling. */
          scrollAnchor: null,
          /* Cache the browser-specific property names associated with the scroll anchor. */
          scrollPropertyLeft: null,
          scrollPropertyTop: null,
          /* Keep track of whether our RAF tick is running. */
          isTicking: false,
          /* Container for every in-progress call to Velocity. */
          calls: [],
          delayedElements: {
            count: 0
          }
        },
        /* Velocity's custom CSS stack. Made global for unit testing. */
        CSS: {/* Defined below. */},
        /* A shim of the jQuery utility functions used by Velocity -- provided by Velocity's optional jQuery shim. */
        Utilities: $,
        /* Container for the user's custom animation redirects that are referenced by name in place of the properties map argument. */
        Redirects: {/* Manually registered by the user. */},
        Easings: {/* Defined below. */},
        /* Attempt to use ES6 Promises by default. Users can override this with a third-party promises library. */
        Promise: window.Promise,
        /* Velocity option defaults, which can be overriden by the user. */
        defaults: {
          queue: "",
          duration: DURATION_DEFAULT,
          easing: EASING_DEFAULT,
          begin: undefined,
          complete: undefined,
          progress: undefined,
          display: undefined,
          visibility: undefined,
          loop: false,
          delay: false,
          mobileHA: true,
          /* Advanced: Set to false to prevent property values from being cached between consecutive Velocity-initiated chain calls. */
          _cacheValues: true,
          /* Advanced: Set to false if the promise should always resolve on empty element lists. */
          promiseRejectEmpty: true
        },
        /* A design goal of Velocity is to cache data wherever possible in order to avoid DOM requerying. Accordingly, each element has a data cache. */
        init: function (element) {
          $.data(element, "velocity", {
            /* Store whether this is an SVG element, since its properties are retrieved and updated differently than standard HTML elements. */
            isSVG: Type.isSVG(element),
            /* Keep track of whether the element is currently being animated by Velocity.
             This is used to ensure that property values are not transferred between non-consecutive (stale) calls. */
            isAnimating: false,
            /* A reference to the element's live computedStyle object. Learn more here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
            computedStyle: null,
            /* Tween data is cached for each animation on the element so that data can be passed across calls --
             in particular, end values are used as subsequent start values in consecutive Velocity calls. */
            tweensContainer: null,
            /* The full root property values of each CSS hook being animated on this element are cached so that:
             1) Concurrently-animating hooks sharing the same root can have their root values' merged into one while tweening.
             2) Post-hook-injection root values can be transferred over to consecutively chained Velocity calls as starting root values. */
            rootPropertyValueCache: {},
            /* A cache for transform updates, which must be manually flushed via CSS.flushTransformCache(). */
            transformCache: {}
          });
        },
        /* A parallel to jQuery's $.css(), used for getting/setting Velocity's hooked CSS properties. */
        hook: null,
        /* Defined below. */
        /* Velocity-wide animation time remapping for testing purposes. */
        mock: false,
        version: {
          major: 1,
          minor: 5,
          patch: 2
        },
        /* Set to 1 or 2 (most verbose) to output debug info to console. */
        debug: false,
        /* Use rAF high resolution timestamp when available */
        timestamp: true,
        /* Pause all animations */
        pauseAll: function (queueName) {
          var currentTime = new Date().getTime();
          $.each(Velocity.State.calls, function (i, activeCall) {
            if (activeCall) {
              /* If we have a queueName and this call is not on that queue, skip */
              if (queueName !== undefined && (activeCall[2].queue !== queueName || activeCall[2].queue === false)) {
                return true;
              }

              /* Set call to paused */
              activeCall[5] = {
                resume: false
              };
            }
          });

          /* Pause timers on any currently delayed calls */
          $.each(Velocity.State.delayedElements, function (k, element) {
            if (!element) {
              return;
            }
            pauseDelayOnElement(element, currentTime);
          });
        },
        /* Resume all animations */
        resumeAll: function (queueName) {
          var currentTime = new Date().getTime();
          $.each(Velocity.State.calls, function (i, activeCall) {
            if (activeCall) {
              /* If we have a queueName and this call is not on that queue, skip */
              if (queueName !== undefined && (activeCall[2].queue !== queueName || activeCall[2].queue === false)) {
                return true;
              }

              /* Set call to resumed if it was paused */
              if (activeCall[5]) {
                activeCall[5].resume = true;
              }
            }
          });
          /* Resume timers on any currently delayed calls */
          $.each(Velocity.State.delayedElements, function (k, element) {
            if (!element) {
              return;
            }
            resumeDelayOnElement(element, currentTime);
          });
        }
      };

      /* Retrieve the appropriate scroll anchor and property name for the browser: https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY */
      if (window.pageYOffset !== undefined) {
        Velocity.State.scrollAnchor = window;
        Velocity.State.scrollPropertyLeft = "pageXOffset";
        Velocity.State.scrollPropertyTop = "pageYOffset";
      } else {
        Velocity.State.scrollAnchor = document.documentElement || document.body.parentNode || document.body;
        Velocity.State.scrollPropertyLeft = "scrollLeft";
        Velocity.State.scrollPropertyTop = "scrollTop";
      }

      /* Shorthand alias for jQuery's $.data() utility. */
      function Data(element) {
        /* Hardcode a reference to the plugin name. */
        var response = $.data(element, "velocity");

        /* jQuery <=1.4.2 returns null instead of undefined when no match is found. We normalize this behavior. */
        return response === null ? undefined : response;
      }

      /**************
       Delay Timer
       **************/

      function pauseDelayOnElement(element, currentTime) {
        /* Check for any delay timers, and pause the set timeouts (while preserving time data)
         to be resumed when the "resume" command is issued */
        var data = Data(element);
        if (data && data.delayTimer && !data.delayPaused) {
          data.delayRemaining = data.delay - currentTime + data.delayBegin;
          data.delayPaused = true;
          clearTimeout(data.delayTimer.setTimeout);
        }
      }
      function resumeDelayOnElement(element, currentTime) {
        /* Check for any paused timers and resume */
        var data = Data(element);
        if (data && data.delayTimer && data.delayPaused) {
          /* If the element was mid-delay, re initiate the timeout with the remaining delay */
          data.delayPaused = false;
          data.delayTimer.setTimeout = setTimeout(data.delayTimer.next, data.delayRemaining);
        }
      }

      /**************
       Easing
       **************/

      /* Step easing generator. */
      function generateStep(steps) {
        return function (p) {
          return Math.round(p * steps) * (1 / steps);
        };
      }

      /* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
      function generateBezier(mX1, mY1, mX2, mY2) {
        var NEWTON_ITERATIONS = 4,
          NEWTON_MIN_SLOPE = 0.001,
          SUBDIVISION_PRECISION = 0.0000001,
          SUBDIVISION_MAX_ITERATIONS = 10,
          kSplineTableSize = 11,
          kSampleStepSize = 1.0 / (kSplineTableSize - 1.0),
          float32ArraySupported = ("Float32Array" in window);

        /* Must contain four arguments. */
        if (arguments.length !== 4) {
          return false;
        }

        /* Arguments must be numbers. */
        for (var i = 0; i < 4; ++i) {
          if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) {
            return false;
          }
        }

        /* X values must be in the [0, 1] range. */
        mX1 = Math.min(mX1, 1);
        mX2 = Math.min(mX2, 1);
        mX1 = Math.max(mX1, 0);
        mX2 = Math.max(mX2, 0);
        var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
        function A(aA1, aA2) {
          return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
          return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
          return 3.0 * aA1;
        }
        function calcBezier(aT, aA1, aA2) {
          return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        }
        function getSlope(aT, aA1, aA2) {
          return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function newtonRaphsonIterate(aX, aGuessT) {
          for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) {
              return aGuessT;
            }
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
          }
          return aGuessT;
        }
        function calcSampleValues() {
          for (var i = 0; i < kSplineTableSize; ++i) {
            mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
          }
        }
        function binarySubdivide(aX, aA, aB) {
          var currentX,
            currentT,
            i = 0;
          do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) {
              aB = currentT;
            } else {
              aA = currentT;
            }
          } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
          return currentT;
        }
        function getTForX(aX) {
          var intervalStart = 0.0,
            currentSample = 1,
            lastSample = kSplineTableSize - 1;
          for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += kSampleStepSize;
          }
          --currentSample;
          var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]),
            guessForT = intervalStart + dist * kSampleStepSize,
            initialSlope = getSlope(guessForT, mX1, mX2);
          if (initialSlope >= NEWTON_MIN_SLOPE) {
            return newtonRaphsonIterate(aX, guessForT);
          } else if (initialSlope === 0.0) {
            return guessForT;
          } else {
            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
          }
        }
        var _precomputed = false;
        function precompute() {
          _precomputed = true;
          if (mX1 !== mY1 || mX2 !== mY2) {
            calcSampleValues();
          }
        }
        var f = function (aX) {
          if (!_precomputed) {
            precompute();
          }
          if (mX1 === mY1 && mX2 === mY2) {
            return aX;
          }
          if (aX === 0) {
            return 0;
          }
          if (aX === 1) {
            return 1;
          }
          return calcBezier(getTForX(aX), mY1, mY2);
        };
        f.getControlPoints = function () {
          return [{
            x: mX1,
            y: mY1
          }, {
            x: mX2,
            y: mY2
          }];
        };
        var str = "generateBezier(" + [mX1, mY1, mX2, mY2] + ")";
        f.toString = function () {
          return str;
        };
        return f;
      }

      /* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
      /* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
       then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
      var generateSpringRK4 = function () {
        function springAccelerationForState(state) {
          return -state.tension * state.x - state.friction * state.v;
        }
        function springEvaluateStateWithDerivative(initialState, dt, derivative) {
          var state = {
            x: initialState.x + derivative.dx * dt,
            v: initialState.v + derivative.dv * dt,
            tension: initialState.tension,
            friction: initialState.friction
          };
          return {
            dx: state.v,
            dv: springAccelerationForState(state)
          };
        }
        function springIntegrateState(state, dt) {
          var a = {
              dx: state.v,
              dv: springAccelerationForState(state)
            },
            b = springEvaluateStateWithDerivative(state, dt * 0.5, a),
            c = springEvaluateStateWithDerivative(state, dt * 0.5, b),
            d = springEvaluateStateWithDerivative(state, dt, c),
            dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx),
            dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);
          state.x = state.x + dxdt * dt;
          state.v = state.v + dvdt * dt;
          return state;
        }
        return function springRK4Factory(tension, friction, duration) {
          var initState = {
              x: -1,
              v: 0,
              tension: null,
              friction: null
            },
            path = [0],
            time_lapsed = 0,
            tolerance = 1 / 10000,
            DT = 16 / 1000,
            have_duration,
            dt,
            last_state;
          tension = parseFloat(tension) || 500;
          friction = parseFloat(friction) || 20;
          duration = duration || null;
          initState.tension = tension;
          initState.friction = friction;
          have_duration = duration !== null;

          /* Calculate the actual time it takes for this animation to complete with the provided conditions. */
          if (have_duration) {
            /* Run the simulation without a duration. */
            time_lapsed = springRK4Factory(tension, friction);
            /* Compute the adjusted time delta. */
            dt = time_lapsed / duration * DT;
          } else {
            dt = DT;
          }
          while (true) {
            /* Next/step function .*/
            last_state = springIntegrateState(last_state || initState, dt);
            /* Store the position. */
            path.push(1 + last_state.x);
            time_lapsed += 16;
            /* If the change threshold is reached, break. */
            if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) {
              break;
            }
          }

          /* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
           computed path and returns a snapshot of the position according to a given percentComplete. */
          return !have_duration ? time_lapsed : function (percentComplete) {
            return path[percentComplete * (path.length - 1) | 0];
          };
        };
      }();

      /* jQuery easings. */
      Velocity.Easings = {
        linear: function (p) {
          return p;
        },
        swing: function (p) {
          return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        /* Bonus "spring" easing, which is a less exaggerated version of easeInOutElastic. */
        spring: function (p) {
          return 1 - Math.cos(p * 4.5 * Math.PI) * Math.exp(-p * 6);
        }
      };

      /* CSS3 and Robert Penner easings. */
      $.each([["ease", [0.25, 0.1, 0.25, 1.0]], ["ease-in", [0.42, 0.0, 1.00, 1.0]], ["ease-out", [0.00, 0.0, 0.58, 1.0]], ["ease-in-out", [0.42, 0.0, 0.58, 1.0]], ["easeInSine", [0.47, 0, 0.745, 0.715]], ["easeOutSine", [0.39, 0.575, 0.565, 1]], ["easeInOutSine", [0.445, 0.05, 0.55, 0.95]], ["easeInQuad", [0.55, 0.085, 0.68, 0.53]], ["easeOutQuad", [0.25, 0.46, 0.45, 0.94]], ["easeInOutQuad", [0.455, 0.03, 0.515, 0.955]], ["easeInCubic", [0.55, 0.055, 0.675, 0.19]], ["easeOutCubic", [0.215, 0.61, 0.355, 1]], ["easeInOutCubic", [0.645, 0.045, 0.355, 1]], ["easeInQuart", [0.895, 0.03, 0.685, 0.22]], ["easeOutQuart", [0.165, 0.84, 0.44, 1]], ["easeInOutQuart", [0.77, 0, 0.175, 1]], ["easeInQuint", [0.755, 0.05, 0.855, 0.06]], ["easeOutQuint", [0.23, 1, 0.32, 1]], ["easeInOutQuint", [0.86, 0, 0.07, 1]], ["easeInExpo", [0.95, 0.05, 0.795, 0.035]], ["easeOutExpo", [0.19, 1, 0.22, 1]], ["easeInOutExpo", [1, 0, 0, 1]], ["easeInCirc", [0.6, 0.04, 0.98, 0.335]], ["easeOutCirc", [0.075, 0.82, 0.165, 1]], ["easeInOutCirc", [0.785, 0.135, 0.15, 0.86]]], function (i, easingArray) {
        Velocity.Easings[easingArray[0]] = generateBezier.apply(null, easingArray[1]);
      });

      /* Determine the appropriate easing type given an easing input. */
      function getEasing(value, duration) {
        var easing = value;

        /* The easing option can either be a string that references a pre-registered easing,
         or it can be a two-/four-item array of integers to be converted into a bezier/spring function. */
        if (Type.isString(value)) {
          /* Ensure that the easing has been assigned to jQuery's Velocity.Easings object. */
          if (!Velocity.Easings[value]) {
            easing = false;
          }
        } else if (Type.isArray(value) && value.length === 1) {
          easing = generateStep.apply(null, value);
        } else if (Type.isArray(value) && value.length === 2) {
          /* springRK4 must be passed the animation's duration. */
          /* Note: If the springRK4 array contains non-numbers, generateSpringRK4() returns an easing
           function generated with default tension and friction values. */
          easing = generateSpringRK4.apply(null, value.concat([duration]));
        } else if (Type.isArray(value) && value.length === 4) {
          /* Note: If the bezier array contains non-numbers, generateBezier() returns false. */
          easing = generateBezier.apply(null, value);
        } else {
          easing = false;
        }

        /* Revert to the Velocity-wide default easing type, or fall back to "swing" (which is also jQuery's default)
         if the Velocity-wide default has been incorrectly modified. */
        if (easing === false) {
          if (Velocity.Easings[Velocity.defaults.easing]) {
            easing = Velocity.defaults.easing;
          } else {
            easing = EASING_DEFAULT;
          }
        }
        return easing;
      }

      /*****************
       CSS Stack
       *****************/

      /* The CSS object is a highly condensed and performant CSS stack that fully replaces jQuery's.
       It handles the validation, getting, and setting of both standard CSS properties and CSS property hooks. */
      /* Note: A "CSS" shorthand is aliased so that our code is easier to read. */
      var CSS = Velocity.CSS = {
        /*************
         RegEx
         *************/

        RegEx: {
          isHex: /^#([A-f\d]{3}){1,2}$/i,
          /* Unwrap a property value's surrounding text, e.g. "rgba(4, 3, 2, 1)" ==> "4, 3, 2, 1" and "rect(4px 3px 2px 1px)" ==> "4px 3px 2px 1px". */
          valueUnwrap: /^[A-z]+\((.*)\)$/i,
          wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
          /* Split a multi-value property into an array of subvalues, e.g. "rgba(4, 3, 2, 1) 4px 3px 2px 1px" ==> [ "rgba(4, 3, 2, 1)", "4px", "3px", "2px", "1px" ]. */
          valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/ig
        },
        /************
         Lists
         ************/

        Lists: {
          colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
          transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
          transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"],
          units: ["%",
          // relative
          "em", "ex", "ch", "rem",
          // font relative
          "vw", "vh", "vmin", "vmax",
          // viewport relative
          "cm", "mm", "Q", "in", "pc", "pt", "px",
          // absolute lengths
          "deg", "grad", "rad", "turn",
          // angles
          "s", "ms" // time
          ],

          colorNames: {
            "aliceblue": "240,248,255",
            "antiquewhite": "250,235,215",
            "aquamarine": "127,255,212",
            "aqua": "0,255,255",
            "azure": "240,255,255",
            "beige": "245,245,220",
            "bisque": "255,228,196",
            "black": "0,0,0",
            "blanchedalmond": "255,235,205",
            "blueviolet": "138,43,226",
            "blue": "0,0,255",
            "brown": "165,42,42",
            "burlywood": "222,184,135",
            "cadetblue": "95,158,160",
            "chartreuse": "127,255,0",
            "chocolate": "210,105,30",
            "coral": "255,127,80",
            "cornflowerblue": "100,149,237",
            "cornsilk": "255,248,220",
            "crimson": "220,20,60",
            "cyan": "0,255,255",
            "darkblue": "0,0,139",
            "darkcyan": "0,139,139",
            "darkgoldenrod": "184,134,11",
            "darkgray": "169,169,169",
            "darkgrey": "169,169,169",
            "darkgreen": "0,100,0",
            "darkkhaki": "189,183,107",
            "darkmagenta": "139,0,139",
            "darkolivegreen": "85,107,47",
            "darkorange": "255,140,0",
            "darkorchid": "153,50,204",
            "darkred": "139,0,0",
            "darksalmon": "233,150,122",
            "darkseagreen": "143,188,143",
            "darkslateblue": "72,61,139",
            "darkslategray": "47,79,79",
            "darkturquoise": "0,206,209",
            "darkviolet": "148,0,211",
            "deeppink": "255,20,147",
            "deepskyblue": "0,191,255",
            "dimgray": "105,105,105",
            "dimgrey": "105,105,105",
            "dodgerblue": "30,144,255",
            "firebrick": "178,34,34",
            "floralwhite": "255,250,240",
            "forestgreen": "34,139,34",
            "fuchsia": "255,0,255",
            "gainsboro": "220,220,220",
            "ghostwhite": "248,248,255",
            "gold": "255,215,0",
            "goldenrod": "218,165,32",
            "gray": "128,128,128",
            "grey": "128,128,128",
            "greenyellow": "173,255,47",
            "green": "0,128,0",
            "honeydew": "240,255,240",
            "hotpink": "255,105,180",
            "indianred": "205,92,92",
            "indigo": "75,0,130",
            "ivory": "255,255,240",
            "khaki": "240,230,140",
            "lavenderblush": "255,240,245",
            "lavender": "230,230,250",
            "lawngreen": "124,252,0",
            "lemonchiffon": "255,250,205",
            "lightblue": "173,216,230",
            "lightcoral": "240,128,128",
            "lightcyan": "224,255,255",
            "lightgoldenrodyellow": "250,250,210",
            "lightgray": "211,211,211",
            "lightgrey": "211,211,211",
            "lightgreen": "144,238,144",
            "lightpink": "255,182,193",
            "lightsalmon": "255,160,122",
            "lightseagreen": "32,178,170",
            "lightskyblue": "135,206,250",
            "lightslategray": "119,136,153",
            "lightsteelblue": "176,196,222",
            "lightyellow": "255,255,224",
            "limegreen": "50,205,50",
            "lime": "0,255,0",
            "linen": "250,240,230",
            "magenta": "255,0,255",
            "maroon": "128,0,0",
            "mediumaquamarine": "102,205,170",
            "mediumblue": "0,0,205",
            "mediumorchid": "186,85,211",
            "mediumpurple": "147,112,219",
            "mediumseagreen": "60,179,113",
            "mediumslateblue": "123,104,238",
            "mediumspringgreen": "0,250,154",
            "mediumturquoise": "72,209,204",
            "mediumvioletred": "199,21,133",
            "midnightblue": "25,25,112",
            "mintcream": "245,255,250",
            "mistyrose": "255,228,225",
            "moccasin": "255,228,181",
            "navajowhite": "255,222,173",
            "navy": "0,0,128",
            "oldlace": "253,245,230",
            "olivedrab": "107,142,35",
            "olive": "128,128,0",
            "orangered": "255,69,0",
            "orange": "255,165,0",
            "orchid": "218,112,214",
            "palegoldenrod": "238,232,170",
            "palegreen": "152,251,152",
            "paleturquoise": "175,238,238",
            "palevioletred": "219,112,147",
            "papayawhip": "255,239,213",
            "peachpuff": "255,218,185",
            "peru": "205,133,63",
            "pink": "255,192,203",
            "plum": "221,160,221",
            "powderblue": "176,224,230",
            "purple": "128,0,128",
            "red": "255,0,0",
            "rosybrown": "188,143,143",
            "royalblue": "65,105,225",
            "saddlebrown": "139,69,19",
            "salmon": "250,128,114",
            "sandybrown": "244,164,96",
            "seagreen": "46,139,87",
            "seashell": "255,245,238",
            "sienna": "160,82,45",
            "silver": "192,192,192",
            "skyblue": "135,206,235",
            "slateblue": "106,90,205",
            "slategray": "112,128,144",
            "snow": "255,250,250",
            "springgreen": "0,255,127",
            "steelblue": "70,130,180",
            "tan": "210,180,140",
            "teal": "0,128,128",
            "thistle": "216,191,216",
            "tomato": "255,99,71",
            "turquoise": "64,224,208",
            "violet": "238,130,238",
            "wheat": "245,222,179",
            "whitesmoke": "245,245,245",
            "white": "255,255,255",
            "yellowgreen": "154,205,50",
            "yellow": "255,255,0"
          }
        },
        /************
         Hooks
         ************/

        /* Hooks allow a subproperty (e.g. "boxShadowBlur") of a compound-value CSS property
         (e.g. "boxShadow: X Y Blur Spread Color") to be animated as if it were a discrete property. */
        /* Note: Beyond enabling fine-grained property animation, hooking is necessary since Velocity only
         tweens properties with single numeric values; unlike CSS transitions, Velocity does not interpolate compound-values. */
        Hooks: {
          /********************
           Registration
           ********************/

          /* Templates are a concise way of indicating which subproperties must be individually registered for each compound-value CSS property. */
          /* Each template consists of the compound-value's base name, its constituent subproperty names, and those subproperties' default values. */
          templates: {
            "textShadow": ["Color X Y Blur", "black 0px 0px 0px"],
            "boxShadow": ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
            "clip": ["Top Right Bottom Left", "0px 0px 0px 0px"],
            "backgroundPosition": ["X Y", "0% 0%"],
            "transformOrigin": ["X Y Z", "50% 50% 0px"],
            "perspectiveOrigin": ["X Y", "50% 50%"]
          },
          /* A "registered" hook is one that has been converted from its template form into a live,
           tweenable property. It contains data to associate it with its root property. */
          registered: {
            /* Note: A registered hook looks like this ==> textShadowBlur: [ "textShadow", 3 ],
             which consists of the subproperty's name, the associated root property's name,
             and the subproperty's position in the root's value. */
          },
          /* Convert the templates into individual hooks then append them to the registered object above. */
          register: function () {
            /* Color hooks registration: Colors are defaulted to white -- as opposed to black -- since colors that are
             currently set to "transparent" default to their respective template below when color-animated,
             and white is typically a closer match to transparent than black is. An exception is made for text ("color"),
             which is almost always set closer to black than white. */
            for (var i = 0; i < CSS.Lists.colors.length; i++) {
              var rgbComponents = CSS.Lists.colors[i] === "color" ? "0 0 0 1" : "255 255 255 1";
              CSS.Hooks.templates[CSS.Lists.colors[i]] = ["Red Green Blue Alpha", rgbComponents];
            }
            var rootProperty, hookTemplate, hookNames;

            /* In IE, color values inside compound-value properties are positioned at the end the value instead of at the beginning.
             Thus, we re-arrange the templates accordingly. */
            if (IE) {
              for (rootProperty in CSS.Hooks.templates) {
                if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
                  continue;
                }
                hookTemplate = CSS.Hooks.templates[rootProperty];
                hookNames = hookTemplate[0].split(" ");
                var defaultValues = hookTemplate[1].match(CSS.RegEx.valueSplit);
                if (hookNames[0] === "Color") {
                  /* Reposition both the hook's name and its default value to the end of their respective strings. */
                  hookNames.push(hookNames.shift());
                  defaultValues.push(defaultValues.shift());

                  /* Replace the existing template for the hook's root property. */
                  CSS.Hooks.templates[rootProperty] = [hookNames.join(" "), defaultValues.join(" ")];
                }
              }
            }

            /* Hook registration. */
            for (rootProperty in CSS.Hooks.templates) {
              if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
                continue;
              }
              hookTemplate = CSS.Hooks.templates[rootProperty];
              hookNames = hookTemplate[0].split(" ");
              for (var j in hookNames) {
                if (!hookNames.hasOwnProperty(j)) {
                  continue;
                }
                var fullHookName = rootProperty + hookNames[j],
                  hookPosition = j;

                /* For each hook, register its full name (e.g. textShadowBlur) with its root property (e.g. textShadow)
                 and the hook's position in its template's default value string. */
                CSS.Hooks.registered[fullHookName] = [rootProperty, hookPosition];
              }
            }
          },
          /*****************************
           Injection and Extraction
           *****************************/

          /* Look up the root property associated with the hook (e.g. return "textShadow" for "textShadowBlur"). */
          /* Since a hook cannot be set directly (the browser won't recognize it), style updating for hooks is routed through the hook's root property. */
          getRoot: function (property) {
            var hookData = CSS.Hooks.registered[property];
            if (hookData) {
              return hookData[0];
            } else {
              /* If there was no hook match, return the property name untouched. */
              return property;
            }
          },
          getUnit: function (str, start) {
            var unit = (str.substr(start || 0, 5).match(/^[a-z%]+/) || [])[0] || "";
            if (unit && _inArray(CSS.Lists.units, unit)) {
              return unit;
            }
            return "";
          },
          fixColors: function (str) {
            return str.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function ($0, $1, $2) {
              if (CSS.Lists.colorNames.hasOwnProperty($2)) {
                return ($1 ? $1 : "rgba(") + CSS.Lists.colorNames[$2] + ($1 ? "" : ",1)");
              }
              return $1 + $2;
            });
          },
          /* Convert any rootPropertyValue, null or otherwise, into a space-delimited list of hook values so that
           the targeted hook can be injected or extracted at its standard position. */
          cleanRootPropertyValue: function (rootProperty, rootPropertyValue) {
            /* If the rootPropertyValue is wrapped with "rgb()", "clip()", etc., remove the wrapping to normalize the value before manipulation. */
            if (CSS.RegEx.valueUnwrap.test(rootPropertyValue)) {
              rootPropertyValue = rootPropertyValue.match(CSS.RegEx.valueUnwrap)[1];
            }

            /* If rootPropertyValue is a CSS null-value (from which there's inherently no hook value to extract),
             default to the root's default value as defined in CSS.Hooks.templates. */
            /* Note: CSS null-values include "none", "auto", and "transparent". They must be converted into their
             zero-values (e.g. textShadow: "none" ==> textShadow: "0px 0px 0px black") for hook manipulation to proceed. */
            if (CSS.Values.isCSSNullValue(rootPropertyValue)) {
              rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
            }
            return rootPropertyValue;
          },
          /* Extracted the hook's value from its root property's value. This is used to get the starting value of an animating hook. */
          extractValue: function (fullHookName, rootPropertyValue) {
            var hookData = CSS.Hooks.registered[fullHookName];
            if (hookData) {
              var hookRoot = hookData[0],
                hookPosition = hookData[1];
              rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);

              /* Split rootPropertyValue into its constituent hook values then grab the desired hook at its standard position. */
              return rootPropertyValue.toString().match(CSS.RegEx.valueSplit)[hookPosition];
            } else {
              /* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
              return rootPropertyValue;
            }
          },
          /* Inject the hook's value into its root property's value. This is used to piece back together the root property
           once Velocity has updated one of its individually hooked values through tweening. */
          injectValue: function (fullHookName, hookValue, rootPropertyValue) {
            var hookData = CSS.Hooks.registered[fullHookName];
            if (hookData) {
              var hookRoot = hookData[0],
                hookPosition = hookData[1],
                rootPropertyValueParts,
                rootPropertyValueUpdated;
              rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);

              /* Split rootPropertyValue into its individual hook values, replace the targeted value with hookValue,
               then reconstruct the rootPropertyValue string. */
              rootPropertyValueParts = rootPropertyValue.toString().match(CSS.RegEx.valueSplit);
              rootPropertyValueParts[hookPosition] = hookValue;
              rootPropertyValueUpdated = rootPropertyValueParts.join(" ");
              return rootPropertyValueUpdated;
            } else {
              /* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
              return rootPropertyValue;
            }
          }
        },
        /*******************
         Normalizations
         *******************/

        /* Normalizations standardize CSS property manipulation by pollyfilling browser-specific implementations (e.g. opacity)
         and reformatting special properties (e.g. clip, rgba) to look like standard ones. */
        Normalizations: {
          /* Normalizations are passed a normalization target (either the property's name, its extracted value, or its injected value),
           the targeted element (which may need to be queried), and the targeted property value. */
          registered: {
            clip: function (type, element, propertyValue) {
              switch (type) {
                case "name":
                  return "clip";
                /* Clip needs to be unwrapped and stripped of its commas during extraction. */
                case "extract":
                  var extracted;

                  /* If Velocity also extracted this value, skip extraction. */
                  if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
                    extracted = propertyValue;
                  } else {
                    /* Remove the "rect()" wrapper. */
                    extracted = propertyValue.toString().match(CSS.RegEx.valueUnwrap);

                    /* Strip off commas. */
                    extracted = extracted ? extracted[1].replace(/,(\s+)?/g, " ") : propertyValue;
                  }
                  return extracted;
                /* Clip needs to be re-wrapped during injection. */
                case "inject":
                  return "rect(" + propertyValue + ")";
              }
            },
            blur: function (type, element, propertyValue) {
              switch (type) {
                case "name":
                  return Velocity.State.isFirefox ? "filter" : "-webkit-filter";
                case "extract":
                  var extracted = parseFloat(propertyValue);

                  /* If extracted is NaN, meaning the value isn't already extracted. */
                  if (!(extracted || extracted === 0)) {
                    var blurComponent = propertyValue.toString().match(/blur\(([0-9]+[A-z]+)\)/i);

                    /* If the filter string had a blur component, return just the blur value and unit type. */
                    if (blurComponent) {
                      extracted = blurComponent[1];
                      /* If the component doesn't exist, default blur to 0. */
                    } else {
                      extracted = 0;
                    }
                  }
                  return extracted;
                /* Blur needs to be re-wrapped during injection. */
                case "inject":
                  /* For the blur effect to be fully de-applied, it needs to be set to "none" instead of 0. */
                  if (!parseFloat(propertyValue)) {
                    return "none";
                  } else {
                    return "blur(" + propertyValue + ")";
                  }
              }
            },
            /* <=IE8 do not support the standard opacity property. They use filter:alpha(opacity=INT) instead. */
            opacity: function (type, element, propertyValue) {
              if (IE <= 8) {
                switch (type) {
                  case "name":
                    return "filter";
                  case "extract":
                    /* <=IE8 return a "filter" value of "alpha(opacity=\d{1,3})".
                     Extract the value and convert it to a decimal value to match the standard CSS opacity property's formatting. */
                    var extracted = propertyValue.toString().match(/alpha\(opacity=(.*)\)/i);
                    if (extracted) {
                      /* Convert to decimal value. */
                      propertyValue = extracted[1] / 100;
                    } else {
                      /* When extracting opacity, default to 1 since a null value means opacity hasn't been set. */
                      propertyValue = 1;
                    }
                    return propertyValue;
                  case "inject":
                    /* Opacified elements are required to have their zoom property set to a non-zero value. */
                    element.style.zoom = 1;

                    /* Setting the filter property on elements with certain font property combinations can result in a
                     highly unappealing ultra-bolding effect. There's no way to remedy this throughout a tween, but dropping the
                     value altogether (when opacity hits 1) at leasts ensures that the glitch is gone post-tweening. */
                    if (parseFloat(propertyValue) >= 1) {
                      return "";
                    } else {
                      /* As per the filter property's spec, convert the decimal value to a whole number and wrap the value. */
                      return "alpha(opacity=" + parseInt(parseFloat(propertyValue) * 100, 10) + ")";
                    }
                }
                /* With all other browsers, normalization is not required; return the same values that were passed in. */
              } else {
                switch (type) {
                  case "name":
                    return "opacity";
                  case "extract":
                    return propertyValue;
                  case "inject":
                    return propertyValue;
                }
              }
            }
          },
          /*****************************
           Batched Registrations
           *****************************/

          /* Note: Batched normalizations extend the CSS.Normalizations.registered object. */
          register: function () {
            /*****************
             Transforms
             *****************/

            /* Transforms are the subproperties contained by the CSS "transform" property. Transforms must undergo normalization
             so that they can be referenced in a properties map by their individual names. */
            /* Note: When transforms are "set", they are actually assigned to a per-element transformCache. When all transform
             setting is complete complete, CSS.flushTransformCache() must be manually called to flush the values to the DOM.
             Transform setting is batched in this way to improve performance: the transform style only needs to be updated
             once when multiple transform subproperties are being animated simultaneously. */
            /* Note: IE9 and Android Gingerbread have support for 2D -- but not 3D -- transforms. Since animating unsupported
             transform properties results in the browser ignoring the *entire* transform string, we prevent these 3D values
             from being normalized for these browsers so that tweening skips these properties altogether
             (since it will ignore them as being unsupported by the browser.) */
            if ((!IE || IE > 9) && !Velocity.State.isGingerbread) {
              /* Note: Since the standalone CSS "perspective" property and the CSS transform "perspective" subproperty
               share the same name, the latter is given a unique token within Velocity: "transformPerspective". */
              CSS.Lists.transformsBase = CSS.Lists.transformsBase.concat(CSS.Lists.transforms3D);
            }
            for (var i = 0; i < CSS.Lists.transformsBase.length; i++) {
              /* Wrap the dynamically generated normalization function in a new scope so that transformName's value is
               paired with its respective function. (Otherwise, all functions would take the final for loop's transformName.) */
              (function () {
                var transformName = CSS.Lists.transformsBase[i];
                CSS.Normalizations.registered[transformName] = function (type, element, propertyValue) {
                  switch (type) {
                    /* The normalized property name is the parent "transform" property -- the property that is actually set in CSS. */
                    case "name":
                      return "transform";
                    /* Transform values are cached onto a per-element transformCache object. */
                    case "extract":
                      /* If this transform has yet to be assigned a value, return its null value. */
                      if (Data(element) === undefined || Data(element).transformCache[transformName] === undefined) {
                        /* Scale CSS.Lists.transformsBase default to 1 whereas all other transform properties default to 0. */
                        return /^scale/i.test(transformName) ? 1 : 0;
                        /* When transform values are set, they are wrapped in parentheses as per the CSS spec.
                         Thus, when extracting their values (for tween calculations), we strip off the parentheses. */
                      }

                      return Data(element).transformCache[transformName].replace(/[()]/g, "");
                    case "inject":
                      var invalid = false;

                      /* If an individual transform property contains an unsupported unit type, the browser ignores the *entire* transform property.
                       Thus, protect users from themselves by skipping setting for transform values supplied with invalid unit types. */
                      /* Switch on the base transform type; ignore the axis by removing the last letter from the transform's name. */
                      switch (transformName.substr(0, transformName.length - 1)) {
                        /* Whitelist unit types for each transform. */
                        case "translate":
                          invalid = !/(%|px|em|rem|vw|vh|\d)$/i.test(propertyValue);
                          break;
                        /* Since an axis-free "scale" property is supported as well, a little hack is used here to detect it by chopping off its last letter. */
                        case "scal":
                        case "scale":
                          /* Chrome on Android has a bug in which scaled elements blur if their initial scale
                           value is below 1 (which can happen with forcefeeding). Thus, we detect a yet-unset scale property
                           and ensure that its first value is always 1. More info: http://stackoverflow.com/questions/10417890/css3-animations-with-transform-causes-blurred-elements-on-webkit/10417962#10417962 */
                          if (Velocity.State.isAndroid && Data(element).transformCache[transformName] === undefined && propertyValue < 1) {
                            propertyValue = 1;
                          }
                          invalid = !/(\d)$/i.test(propertyValue);
                          break;
                        case "skew":
                          invalid = !/(deg|\d)$/i.test(propertyValue);
                          break;
                        case "rotate":
                          invalid = !/(deg|\d)$/i.test(propertyValue);
                          break;
                      }
                      if (!invalid) {
                        /* As per the CSS spec, wrap the value in parentheses. */
                        Data(element).transformCache[transformName] = "(" + propertyValue + ")";
                      }

                      /* Although the value is set on the transformCache object, return the newly-updated value for the calling code to process as normal. */
                      return Data(element).transformCache[transformName];
                  }
                };
              })();
            }

            /*************
             Colors
             *************/

            /* Since Velocity only animates a single numeric value per property, color animation is achieved by hooking the individual RGBA components of CSS color properties.
             Accordingly, color values must be normalized (e.g. "#ff0000", "red", and "rgb(255, 0, 0)" ==> "255 0 0 1") so that their components can be injected/extracted by CSS.Hooks logic. */
            for (var j = 0; j < CSS.Lists.colors.length; j++) {
              /* Wrap the dynamically generated normalization function in a new scope so that colorName's value is paired with its respective function.
               (Otherwise, all functions would take the final for loop's colorName.) */
              (function () {
                var colorName = CSS.Lists.colors[j];

                /* Note: In IE<=8, which support rgb but not rgba, color properties are reverted to rgb by stripping off the alpha component. */
                CSS.Normalizations.registered[colorName] = function (type, element, propertyValue) {
                  switch (type) {
                    case "name":
                      return colorName;
                    /* Convert all color values into the rgb format. (Old IE can return hex values and color names instead of rgb/rgba.) */
                    case "extract":
                      var extracted;

                      /* If the color is already in its hookable form (e.g. "255 255 255 1") due to having been previously extracted, skip extraction. */
                      if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
                        extracted = propertyValue;
                      } else {
                        var converted,
                          colorNames = {
                            black: "rgb(0, 0, 0)",
                            blue: "rgb(0, 0, 255)",
                            gray: "rgb(128, 128, 128)",
                            green: "rgb(0, 128, 0)",
                            red: "rgb(255, 0, 0)",
                            white: "rgb(255, 255, 255)"
                          };

                        /* Convert color names to rgb. */
                        if (/^[A-z]+$/i.test(propertyValue)) {
                          if (colorNames[propertyValue] !== undefined) {
                            converted = colorNames[propertyValue];
                          } else {
                            /* If an unmatched color name is provided, default to black. */
                            converted = colorNames.black;
                          }
                          /* Convert hex values to rgb. */
                        } else if (CSS.RegEx.isHex.test(propertyValue)) {
                          converted = "rgb(" + CSS.Values.hexToRgb(propertyValue).join(" ") + ")";
                          /* If the provided color doesn't match any of the accepted color formats, default to black. */
                        } else if (!/^rgba?\(/i.test(propertyValue)) {
                          converted = colorNames.black;
                        }

                        /* Remove the surrounding "rgb/rgba()" string then replace commas with spaces and strip
                         repeated spaces (in case the value included spaces to begin with). */
                        extracted = (converted || propertyValue).toString().match(CSS.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
                      }

                      /* So long as this isn't <=IE8, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
                      if ((!IE || IE > 8) && extracted.split(" ").length === 3) {
                        extracted += " 1";
                      }
                      return extracted;
                    case "inject":
                      /* If we have a pattern then it might already have the right values */
                      if (/^rgb/.test(propertyValue)) {
                        return propertyValue;
                      }

                      /* If this is IE<=8 and an alpha component exists, strip it off. */
                      if (IE <= 8) {
                        if (propertyValue.split(" ").length === 4) {
                          propertyValue = propertyValue.split(/\s+/).slice(0, 3).join(" ");
                        }
                        /* Otherwise, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
                      } else if (propertyValue.split(" ").length === 3) {
                        propertyValue += " 1";
                      }

                      /* Re-insert the browser-appropriate wrapper("rgb/rgba()"), insert commas, and strip off decimal units
                       on all values but the fourth (R, G, and B only accept whole numbers). */
                      return (IE <= 8 ? "rgb" : "rgba") + "(" + propertyValue.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";
                  }
                };
              })();
            }

            /**************
             Dimensions
             **************/
            function augmentDimension(name, element, wantInner) {
              var isBorderBox = CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() === "border-box";
              if (isBorderBox === (wantInner || false)) {
                /* in box-sizing mode, the CSS width / height accessors already give the outerWidth / outerHeight. */
                var i,
                  value,
                  augment = 0,
                  sides = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"],
                  fields = ["padding" + sides[0], "padding" + sides[1], "border" + sides[0] + "Width", "border" + sides[1] + "Width"];
                for (i = 0; i < fields.length; i++) {
                  value = parseFloat(CSS.getPropertyValue(element, fields[i]));
                  if (!isNaN(value)) {
                    augment += value;
                  }
                }
                return wantInner ? -augment : augment;
              }
              return 0;
            }
            function getDimension(name, wantInner) {
              return function (type, element, propertyValue) {
                switch (type) {
                  case "name":
                    return name;
                  case "extract":
                    return parseFloat(propertyValue) + augmentDimension(name, element, wantInner);
                  case "inject":
                    return parseFloat(propertyValue) - augmentDimension(name, element, wantInner) + "px";
                }
              };
            }
            CSS.Normalizations.registered.innerWidth = getDimension("width", true);
            CSS.Normalizations.registered.innerHeight = getDimension("height", true);
            CSS.Normalizations.registered.outerWidth = getDimension("width");
            CSS.Normalizations.registered.outerHeight = getDimension("height");
          }
        },
        /************************
         CSS Property Names
         ************************/

        Names: {
          /* Camelcase a property name into its JavaScript notation (e.g. "background-color" ==> "backgroundColor").
           Camelcasing is used to normalize property names between and across calls. */
          camelCase: function (property) {
            return property.replace(/-(\w)/g, function (match, subMatch) {
              return subMatch.toUpperCase();
            });
          },
          /* For SVG elements, some properties (namely, dimensional ones) are GET/SET via the element's HTML attributes (instead of via CSS styles). */
          SVGAttribute: function (property) {
            var SVGAttributes = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";

            /* Certain browsers require an SVG transform to be applied as an attribute. (Otherwise, application via CSS is preferable due to 3D support.) */
            if (IE || Velocity.State.isAndroid && !Velocity.State.isChrome) {
              SVGAttributes += "|transform";
            }
            return new RegExp("^(" + SVGAttributes + ")$", "i").test(property);
          },
          /* Determine whether a property should be set with a vendor prefix. */
          /* If a prefixed version of the property exists, return it. Otherwise, return the original property name.
           If the property is not at all supported by the browser, return a false flag. */
          prefixCheck: function (property) {
            /* If this property has already been checked, return the cached value. */
            if (Velocity.State.prefixMatches[property]) {
              return [Velocity.State.prefixMatches[property], true];
            } else {
              var vendors = ["", "Webkit", "Moz", "ms", "O"];
              for (var i = 0, vendorsLength = vendors.length; i < vendorsLength; i++) {
                var propertyPrefixed;
                if (i === 0) {
                  propertyPrefixed = property;
                } else {
                  /* Capitalize the first letter of the property to conform to JavaScript vendor prefix notation (e.g. webkitFilter). */
                  propertyPrefixed = vendors[i] + property.replace(/^\w/, function (match) {
                    return match.toUpperCase();
                  });
                }

                /* Check if the browser supports this property as prefixed. */
                if (Type.isString(Velocity.State.prefixElement.style[propertyPrefixed])) {
                  /* Cache the match. */
                  Velocity.State.prefixMatches[property] = propertyPrefixed;
                  return [propertyPrefixed, true];
                }
              }

              /* If the browser doesn't support this property in any form, include a false flag so that the caller can decide how to proceed. */
              return [property, false];
            }
          }
        },
        /************************
         CSS Property Values
         ************************/

        Values: {
          /* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
          hexToRgb: function (hex) {
            var shortformRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
              longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
              rgbParts;
            hex = hex.replace(shortformRegex, function (m, r, g, b) {
              return r + r + g + g + b + b;
            });
            rgbParts = longformRegex.exec(hex);
            return rgbParts ? [parseInt(rgbParts[1], 16), parseInt(rgbParts[2], 16), parseInt(rgbParts[3], 16)] : [0, 0, 0];
          },
          isCSSNullValue: function (value) {
            /* The browser defaults CSS values that have not been set to either 0 or one of several possible null-value strings.
             Thus, we check for both falsiness and these special strings. */
            /* Null-value checking is performed to default the special strings to 0 (for the sake of tweening) or their hook
             templates as defined as CSS.Hooks (for the sake of hook injection/extraction). */
            /* Note: Chrome returns "rgba(0, 0, 0, 0)" for an undefined color whereas IE returns "transparent". */
            return !value || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(value);
          },
          /* Retrieve a property's default unit type. Used for assigning a unit type when one is not supplied by the user. */
          getUnitType: function (property) {
            if (/^(rotate|skew)/i.test(property)) {
              return "deg";
            } else if (/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(property)) {
              /* The above properties are unitless. */
              return "";
            } else {
              /* Default to px for all other properties. */
              return "px";
            }
          },
          /* HTML elements default to an associated display type when they're not set to display:none. */
          /* Note: This function is used for correctly setting the non-"none" display value in certain Velocity redirects, such as fadeIn/Out. */
          getDisplayType: function (element) {
            var tagName = element && element.tagName.toString().toLowerCase();
            if (/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(tagName)) {
              return "inline";
            } else if (/^(li)$/i.test(tagName)) {
              return "list-item";
            } else if (/^(tr)$/i.test(tagName)) {
              return "table-row";
            } else if (/^(table)$/i.test(tagName)) {
              return "table";
            } else if (/^(tbody)$/i.test(tagName)) {
              return "table-row-group";
              /* Default to "block" when no match is found. */
            } else {
              return "block";
            }
          },
          /* The class add/remove functions are used to temporarily apply a "velocity-animating" class to elements while they're animating. */
          addClass: function (element, className) {
            if (element) {
              if (element.classList) {
                element.classList.add(className);
              } else if (Type.isString(element.className)) {
                // Element.className is around 15% faster then set/getAttribute
                element.className += (element.className.length ? " " : "") + className;
              } else {
                // Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
                var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";
                element.setAttribute("class", currentClass + (currentClass ? " " : "") + className);
              }
            }
          },
          removeClass: function (element, className) {
            if (element) {
              if (element.classList) {
                element.classList.remove(className);
              } else if (Type.isString(element.className)) {
                // Element.className is around 15% faster then set/getAttribute
                // TODO: Need some jsperf tests on performance - can we get rid of the regex and maybe use split / array manipulation?
                element.className = element.className.toString().replace(new RegExp("(^|\\s)" + className.split(" ").join("|") + "(\\s|$)", "gi"), " ");
              } else {
                // Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
                var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";
                element.setAttribute("class", currentClass.replace(new RegExp("(^|\s)" + className.split(" ").join("|") + "(\s|$)", "gi"), " "));
              }
            }
          }
        },
        /****************************
         Style Getting & Setting
         ****************************/

        /* The singular getPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
        getPropertyValue: function (element, property, rootPropertyValue, forceStyleLookup) {
          /* Get an element's computed property value. */
          /* Note: Retrieving the value of a CSS property cannot simply be performed by checking an element's
           style attribute (which only reflects user-defined values). Instead, the browser must be queried for a property's
           *computed* value. You can read more about getComputedStyle here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
          function computePropertyValue(element, property) {
            /* When box-sizing isn't set to border-box, height and width style values are incorrectly computed when an
             element's scrollbars are visible (which expands the element's dimensions). Thus, we defer to the more accurate
             offsetHeight/Width property, which includes the total dimensions for interior, border, padding, and scrollbar.
             We subtract border and padding to get the sum of interior + scrollbar. */
            var computedValue = 0;

            /* IE<=8 doesn't support window.getComputedStyle, thus we defer to jQuery, which has an extensive array
             of hacks to accurately retrieve IE8 property values. Re-implementing that logic here is not worth bloating the
             codebase for a dying browser. The performance repercussions of using jQuery here are minimal since
             Velocity is optimized to rarely (and sometimes never) query the DOM. Further, the $.css() codepath isn't that slow. */
            if (IE <= 8) {
              computedValue = $.css(element, property); /* GET */
              /* All other browsers support getComputedStyle. The returned live object reference is cached onto its
               associated element so that it does not need to be refetched upon every GET. */
            } else {
              /* Browsers do not return height and width values for elements that are set to display:"none". Thus, we temporarily
               toggle display to the element type's default value. */
              var toggleDisplay = false;
              if (/^(width|height)$/.test(property) && CSS.getPropertyValue(element, "display") === 0) {
                toggleDisplay = true;
                CSS.setPropertyValue(element, "display", CSS.Values.getDisplayType(element));
              }
              var revertDisplay = function () {
                if (toggleDisplay) {
                  CSS.setPropertyValue(element, "display", "none");
                }
              };
              if (!forceStyleLookup) {
                if (property === "height" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
                  var contentBoxHeight = element.offsetHeight - (parseFloat(CSS.getPropertyValue(element, "borderTopWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderBottomWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingTop")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingBottom")) || 0);
                  revertDisplay();
                  return contentBoxHeight;
                } else if (property === "width" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
                  var contentBoxWidth = element.offsetWidth - (parseFloat(CSS.getPropertyValue(element, "borderLeftWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderRightWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingLeft")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingRight")) || 0);
                  revertDisplay();
                  return contentBoxWidth;
                }
              }
              var computedStyle;

              /* For elements that Velocity hasn't been called on directly (e.g. when Velocity queries the DOM on behalf
               of a parent of an element its animating), perform a direct getComputedStyle lookup since the object isn't cached. */
              if (Data(element) === undefined) {
                computedStyle = window.getComputedStyle(element, null); /* GET */
                /* If the computedStyle object has yet to be cached, do so now. */
              } else if (!Data(element).computedStyle) {
                computedStyle = Data(element).computedStyle = window.getComputedStyle(element, null); /* GET */
                /* If computedStyle is cached, use it. */
              } else {
                computedStyle = Data(element).computedStyle;
              }

              /* IE and Firefox do not return a value for the generic borderColor -- they only return individual values for each border side's color.
               Also, in all browsers, when border colors aren't all the same, a compound value is returned that Velocity isn't setup to parse.
               So, as a polyfill for querying individual border side colors, we just return the top border's color and animate all borders from that value. */
              if (property === "borderColor") {
                property = "borderTopColor";
              }

              /* IE9 has a bug in which the "filter" property must be accessed from computedStyle using the getPropertyValue method
               instead of a direct property lookup. The getPropertyValue method is slower than a direct lookup, which is why we avoid it by default. */
              if (IE === 9 && property === "filter") {
                computedValue = computedStyle.getPropertyValue(property); /* GET */
              } else {
                computedValue = computedStyle[property];
              }

              /* Fall back to the property's style value (if defined) when computedValue returns nothing,
               which can happen when the element hasn't been painted. */
              if (computedValue === "" || computedValue === null) {
                computedValue = element.style[property];
              }
              revertDisplay();
            }

            /* For top, right, bottom, and left (TRBL) values that are set to "auto" on elements of "fixed" or "absolute" position,
             defer to jQuery for converting "auto" to a numeric value. (For elements with a "static" or "relative" position, "auto" has the same
             effect as being set to 0, so no conversion is necessary.) */
            /* An example of why numeric conversion is necessary: When an element with "position:absolute" has an untouched "left"
             property, which reverts to "auto", left's value is 0 relative to its parent element, but is often non-zero relative
             to its *containing* (not parent) element, which is the nearest "position:relative" ancestor or the viewport (and always the viewport in the case of "position:fixed"). */
            if (computedValue === "auto" && /^(top|right|bottom|left)$/i.test(property)) {
              var position = computePropertyValue(element, "position"); /* GET */

              /* For absolute positioning, jQuery's $.position() only returns values for top and left;
               right and bottom will have their "auto" value reverted to 0. */
              /* Note: A jQuery object must be created here since jQuery doesn't have a low-level alias for $.position().
               Not a big deal since we're currently in a GET batch anyway. */
              if (position === "fixed" || position === "absolute" && /top|left/i.test(property)) {
                /* Note: jQuery strips the pixel unit from its returned values; we re-add it here to conform with computePropertyValue's behavior. */
                computedValue = $(element).position()[property] + "px"; /* GET */
              }
            }

            return computedValue;
          }
          var propertyValue;

          /* If this is a hooked property (e.g. "clipLeft" instead of the root property of "clip"),
           extract the hook's value from a normalized rootPropertyValue using CSS.Hooks.extractValue(). */
          if (CSS.Hooks.registered[property]) {
            var hook = property,
              hookRoot = CSS.Hooks.getRoot(hook);

            /* If a cached rootPropertyValue wasn't passed in (which Velocity always attempts to do in order to avoid requerying the DOM),
             query the DOM for the root property's value. */
            if (rootPropertyValue === undefined) {
              /* Since the browser is now being directly queried, use the official post-prefixing property name for this lookup. */
              rootPropertyValue = CSS.getPropertyValue(element, CSS.Names.prefixCheck(hookRoot)[0]); /* GET */
            }

            /* If this root has a normalization registered, peform the associated normalization extraction. */
            if (CSS.Normalizations.registered[hookRoot]) {
              rootPropertyValue = CSS.Normalizations.registered[hookRoot]("extract", element, rootPropertyValue);
            }

            /* Extract the hook's value. */
            propertyValue = CSS.Hooks.extractValue(hook, rootPropertyValue);

            /* If this is a normalized property (e.g. "opacity" becomes "filter" in <=IE8) or "translateX" becomes "transform"),
             normalize the property's name and value, and handle the special case of transforms. */
            /* Note: Normalizing a property is mutually exclusive from hooking a property since hook-extracted values are strictly
             numerical and therefore do not require normalization extraction. */
          } else if (CSS.Normalizations.registered[property]) {
            var normalizedPropertyName, normalizedPropertyValue;
            normalizedPropertyName = CSS.Normalizations.registered[property]("name", element);

            /* Transform values are calculated via normalization extraction (see below), which checks against the element's transformCache.
             At no point do transform GETs ever actually query the DOM; initial stylesheet values are never processed.
             This is because parsing 3D transform matrices is not always accurate and would bloat our codebase;
             thus, normalization extraction defaults initial transform values to their zero-values (e.g. 1 for scaleX and 0 for translateX). */
            if (normalizedPropertyName !== "transform") {
              normalizedPropertyValue = computePropertyValue(element, CSS.Names.prefixCheck(normalizedPropertyName)[0]); /* GET */

              /* If the value is a CSS null-value and this property has a hook template, use that zero-value template so that hooks can be extracted from it. */
              if (CSS.Values.isCSSNullValue(normalizedPropertyValue) && CSS.Hooks.templates[property]) {
                normalizedPropertyValue = CSS.Hooks.templates[property][1];
              }
            }
            propertyValue = CSS.Normalizations.registered[property]("extract", element, normalizedPropertyValue);
          }

          /* If a (numeric) value wasn't produced via hook extraction or normalization, query the DOM. */
          if (!/^[\d-]/.test(propertyValue)) {
            /* For SVG elements, dimensional properties (which SVGAttribute() detects) are tweened via
             their HTML attribute values instead of their CSS style values. */
            var data = Data(element);
            if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
              /* Since the height/width attribute values must be set manually, they don't reflect computed values.
               Thus, we use use getBBox() to ensure we always get values for elements with undefined height/width attributes. */
              if (/^(height|width)$/i.test(property)) {
                /* Firefox throws an error if .getBBox() is called on an SVG that isn't attached to the DOM. */
                try {
                  propertyValue = element.getBBox()[property];
                } catch (error) {
                  propertyValue = 0;
                }
                /* Otherwise, access the attribute value directly. */
              } else {
                propertyValue = element.getAttribute(property);
              }
            } else {
              propertyValue = computePropertyValue(element, CSS.Names.prefixCheck(property)[0]); /* GET */
            }
          }

          /* Since property lookups are for animation purposes (which entails computing the numeric delta between start and end values),
           convert CSS null-values to an integer of value 0. */
          if (CSS.Values.isCSSNullValue(propertyValue)) {
            propertyValue = 0;
          }
          if (Velocity.debug >= 2) {
            console.log("Get " + property + ": " + propertyValue);
          }
          return propertyValue;
        },
        /* The singular setPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
        setPropertyValue: function (element, property, propertyValue, rootPropertyValue, scrollData) {
          var propertyName = property;

          /* In order to be subjected to call options and element queueing, scroll animation is routed through Velocity as if it were a standard CSS property. */
          if (property === "scroll") {
            /* If a container option is present, scroll the container instead of the browser window. */
            if (scrollData.container) {
              scrollData.container["scroll" + scrollData.direction] = propertyValue;
              /* Otherwise, Velocity defaults to scrolling the browser window. */
            } else {
              if (scrollData.direction === "Left") {
                window.scrollTo(propertyValue, scrollData.alternateValue);
              } else {
                window.scrollTo(scrollData.alternateValue, propertyValue);
              }
            }
          } else {
            /* Transforms (translateX, rotateZ, etc.) are applied to a per-element transformCache object, which is manually flushed via flushTransformCache().
             Thus, for now, we merely cache transforms being SET. */
            if (CSS.Normalizations.registered[property] && CSS.Normalizations.registered[property]("name", element) === "transform") {
              /* Perform a normalization injection. */
              /* Note: The normalization logic handles the transformCache updating. */
              CSS.Normalizations.registered[property]("inject", element, propertyValue);
              propertyName = "transform";
              propertyValue = Data(element).transformCache[property];
            } else {
              /* Inject hooks. */
              if (CSS.Hooks.registered[property]) {
                var hookName = property,
                  hookRoot = CSS.Hooks.getRoot(property);

                /* If a cached rootPropertyValue was not provided, query the DOM for the hookRoot's current value. */
                rootPropertyValue = rootPropertyValue || CSS.getPropertyValue(element, hookRoot); /* GET */

                propertyValue = CSS.Hooks.injectValue(hookName, propertyValue, rootPropertyValue);
                property = hookRoot;
              }

              /* Normalize names and values. */
              if (CSS.Normalizations.registered[property]) {
                propertyValue = CSS.Normalizations.registered[property]("inject", element, propertyValue);
                property = CSS.Normalizations.registered[property]("name", element);
              }

              /* Assign the appropriate vendor prefix before performing an official style update. */
              propertyName = CSS.Names.prefixCheck(property)[0];

              /* A try/catch is used for IE<=8, which throws an error when "invalid" CSS values are set, e.g. a negative width.
               Try/catch is avoided for other browsers since it incurs a performance overhead. */
              if (IE <= 8) {
                try {
                  element.style[propertyName] = propertyValue;
                } catch (error) {
                  if (Velocity.debug) {
                    console.log("Browser does not support [" + propertyValue + "] for [" + propertyName + "]");
                  }
                }
                /* SVG elements have their dimensional properties (width, height, x, y, cx, etc.) applied directly as attributes instead of as styles. */
                /* Note: IE8 does not support SVG elements, so it's okay that we skip it for SVG animation. */
              } else {
                var data = Data(element);
                if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
                  /* Note: For SVG attributes, vendor-prefixed property names are never used. */
                  /* Note: Not all CSS properties can be animated via attributes, but the browser won't throw an error for unsupported properties. */
                  element.setAttribute(property, propertyValue);
                } else {
                  element.style[propertyName] = propertyValue;
                }
              }
              if (Velocity.debug >= 2) {
                console.log("Set " + property + " (" + propertyName + "): " + propertyValue);
              }
            }
          }

          /* Return the normalized property name and value in case the caller wants to know how these values were modified before being applied to the DOM. */
          return [propertyName, propertyValue];
        },
        /* To increase performance by batching transform updates into a single SET, transforms are not directly applied to an element until flushTransformCache() is called. */
        /* Note: Velocity applies transform properties in the same order that they are chronogically introduced to the element's CSS styles. */
        flushTransformCache: function (element) {
          var transformString = "",
            data = Data(element);

          /* Certain browsers require that SVG transforms be applied as an attribute. However, the SVG transform attribute takes a modified version of CSS's transform string
           (units are dropped and, except for skewX/Y, subproperties are merged into their master property -- e.g. scaleX and scaleY are merged into scale(X Y). */
          if ((IE || Velocity.State.isAndroid && !Velocity.State.isChrome) && data && data.isSVG) {
            /* Since transform values are stored in their parentheses-wrapped form, we use a helper function to strip out their numeric values.
             Further, SVG transform properties only take unitless (representing pixels) values, so it's okay that parseFloat() strips the unit suffixed to the float value. */
            var getTransformFloat = function (transformProperty) {
              return parseFloat(CSS.getPropertyValue(element, transformProperty));
            };

            /* Create an object to organize all the transforms that we'll apply to the SVG element. To keep the logic simple,
             we process *all* transform properties -- even those that may not be explicitly applied (since they default to their zero-values anyway). */
            var SVGTransforms = {
              translate: [getTransformFloat("translateX"), getTransformFloat("translateY")],
              skewX: [getTransformFloat("skewX")],
              skewY: [getTransformFloat("skewY")],
              /* If the scale property is set (non-1), use that value for the scaleX and scaleY values
               (this behavior mimics the result of animating all these properties at once on HTML elements). */
              scale: getTransformFloat("scale") !== 1 ? [getTransformFloat("scale"), getTransformFloat("scale")] : [getTransformFloat("scaleX"), getTransformFloat("scaleY")],
              /* Note: SVG's rotate transform takes three values: rotation degrees followed by the X and Y values
               defining the rotation's origin point. We ignore the origin values (default them to 0). */
              rotate: [getTransformFloat("rotateZ"), 0, 0]
            };

            /* Iterate through the transform properties in the user-defined property map order.
             (This mimics the behavior of non-SVG transform animation.) */
            $.each(Data(element).transformCache, function (transformName) {
              /* Except for with skewX/Y, revert the axis-specific transform subproperties to their axis-free master
               properties so that they match up with SVG's accepted transform properties. */
              if (/^translate/i.test(transformName)) {
                transformName = "translate";
              } else if (/^scale/i.test(transformName)) {
                transformName = "scale";
              } else if (/^rotate/i.test(transformName)) {
                transformName = "rotate";
              }

              /* Check that we haven't yet deleted the property from the SVGTransforms container. */
              if (SVGTransforms[transformName]) {
                /* Append the transform property in the SVG-supported transform format. As per the spec, surround the space-delimited values in parentheses. */
                transformString += transformName + "(" + SVGTransforms[transformName].join(" ") + ")" + " ";

                /* After processing an SVG transform property, delete it from the SVGTransforms container so we don't
                 re-insert the same master property if we encounter another one of its axis-specific properties. */
                delete SVGTransforms[transformName];
              }
            });
          } else {
            var transformValue, perspective;

            /* Transform properties are stored as members of the transformCache object. Concatenate all the members into a string. */
            $.each(Data(element).transformCache, function (transformName) {
              transformValue = Data(element).transformCache[transformName];

              /* Transform's perspective subproperty must be set first in order to take effect. Store it temporarily. */
              if (transformName === "transformPerspective") {
                perspective = transformValue;
                return true;
              }

              /* IE9 only supports one rotation type, rotateZ, which it refers to as "rotate". */
              if (IE === 9 && transformName === "rotateZ") {
                transformName = "rotate";
              }
              transformString += transformName + transformValue + " ";
            });

            /* If present, set the perspective subproperty first. */
            if (perspective) {
              transformString = "perspective" + perspective + " " + transformString;
            }
          }
          CSS.setPropertyValue(element, "transform", transformString);
        }
      };

      /* Register hooks and normalizations. */
      CSS.Hooks.register();
      CSS.Normalizations.register();

      /* Allow hook setting in the same fashion as jQuery's $.css(). */
      Velocity.hook = function (elements, arg2, arg3) {
        var value;
        elements = sanitizeElements(elements);
        $.each(elements, function (i, element) {
          /* Initialize Velocity's per-element data cache if this element hasn't previously been animated. */
          if (Data(element) === undefined) {
            Velocity.init(element);
          }

          /* Get property value. If an element set was passed in, only return the value for the first element. */
          if (arg3 === undefined) {
            if (value === undefined) {
              value = CSS.getPropertyValue(element, arg2);
            }
            /* Set property value. */
          } else {
            /* sPV returns an array of the normalized propertyName/propertyValue pair used to update the DOM. */
            var adjustedSet = CSS.setPropertyValue(element, arg2, arg3);

            /* Transform properties don't automatically set. They have to be flushed to the DOM. */
            if (adjustedSet[0] === "transform") {
              Velocity.CSS.flushTransformCache(element);
            }
            value = adjustedSet;
          }
        });
        return value;
      };

      /*****************
       Animation
       *****************/

      var animate = function () {
        var opts;

        /******************
         Call Chain
         ******************/

        /* Logic for determining what to return to the call stack when exiting out of Velocity. */
        function getChain() {
          /* If we are using the utility function, attempt to return this call's promise. If no promise library was detected,
           default to null instead of returning the targeted elements so that utility function's return value is standardized. */
          if (isUtility) {
            return promiseData.promise || null;
            /* Otherwise, if we're using $.fn, return the jQuery-/Zepto-wrapped element set. */
          } else {
            return elementsWrapped;
          }
        }

        /*************************
         Arguments Assignment
         *************************/

        /* To allow for expressive CoffeeScript code, Velocity supports an alternative syntax in which "elements" (or "e"), "properties" (or "p"), and "options" (or "o")
         objects are defined on a container object that's passed in as Velocity's sole argument. */
        /* Note: Some browsers automatically populate arguments with a "properties" object. We detect it by checking for its default "names" property. */
        var syntacticSugar = arguments[0] && (arguments[0].p || $.isPlainObject(arguments[0].properties) && !arguments[0].properties.names || Type.isString(arguments[0].properties)),
          /* Whether Velocity was called via the utility function (as opposed to on a jQuery/Zepto object). */
          isUtility,
          /* When Velocity is called via the utility function ($.Velocity()/Velocity()), elements are explicitly
           passed in as the first parameter. Thus, argument positioning varies. We normalize them here. */
          elementsWrapped,
          argumentIndex;
        var elements, propertiesMap, options;

        /* Detect jQuery/Zepto elements being animated via the $.fn method. */
        if (Type.isWrapped(this)) {
          isUtility = false;
          argumentIndex = 0;
          elements = this;
          elementsWrapped = this;
          /* Otherwise, raw elements are being animated via the utility function. */
        } else {
          isUtility = true;
          argumentIndex = 1;
          elements = syntacticSugar ? arguments[0].elements || arguments[0].e : arguments[0];
        }

        /***************
         Promises
         ***************/

        var promiseData = {
          promise: null,
          resolver: null,
          rejecter: null
        };

        /* If this call was made via the utility function (which is the default method of invocation when jQuery/Zepto are not being used), and if
         promise support was detected, create a promise object for this call and store references to its resolver and rejecter methods. The resolve
         method is used when a call completes naturally or is prematurely stopped by the user. In both cases, completeCall() handles the associated
         call cleanup and promise resolving logic. The reject method is used when an invalid set of arguments is passed into a Velocity call. */
        /* Note: Velocity employs a call-based queueing architecture, which means that stopping an animating element actually stops the full call that
         triggered it -- not that one element exclusively. Similarly, there is one promise per call, and all elements targeted by a Velocity call are
         grouped together for the purposes of resolving and rejecting a promise. */
        if (isUtility && Velocity.Promise) {
          promiseData.promise = new Velocity.Promise(function (resolve, reject) {
            promiseData.resolver = resolve;
            promiseData.rejecter = reject;
          });
        }
        if (syntacticSugar) {
          propertiesMap = arguments[0].properties || arguments[0].p;
          options = arguments[0].options || arguments[0].o;
        } else {
          propertiesMap = arguments[argumentIndex];
          options = arguments[argumentIndex + 1];
        }
        elements = sanitizeElements(elements);
        if (!elements) {
          if (promiseData.promise) {
            if (!propertiesMap || !options || options.promiseRejectEmpty !== false) {
              promiseData.rejecter();
            } else {
              promiseData.resolver();
            }
          }
          return;
        }

        /* The length of the element set (in the form of a nodeList or an array of elements) is defaulted to 1 in case a
         single raw DOM element is passed in (which doesn't contain a length property). */
        var elementsLength = elements.length,
          elementsIndex = 0;

        /***************************
         Argument Overloading
         ***************************/

        /* Support is included for jQuery's argument overloading: $.animate(propertyMap [, duration] [, easing] [, complete]).
         Overloading is detected by checking for the absence of an object being passed into options. */
        /* Note: The stop/finish/pause/resume actions do not accept animation options, and are therefore excluded from this check. */
        if (!/^(stop|finish|finishAll|pause|resume)$/i.test(propertiesMap) && !$.isPlainObject(options)) {
          /* The utility function shifts all arguments one position to the right, so we adjust for that offset. */
          var startingArgumentPosition = argumentIndex + 1;
          options = {};

          /* Iterate through all options arguments */
          for (var i = startingArgumentPosition; i < arguments.length; i++) {
            /* Treat a number as a duration. Parse it out. */
            /* Note: The following RegEx will return true if passed an array with a number as its first item.
             Thus, arrays are skipped from this check. */
            if (!Type.isArray(arguments[i]) && (/^(fast|normal|slow)$/i.test(arguments[i]) || /^\d/.test(arguments[i]))) {
              options.duration = arguments[i];
              /* Treat strings and arrays as easings. */
            } else if (Type.isString(arguments[i]) || Type.isArray(arguments[i])) {
              options.easing = arguments[i];
              /* Treat a function as a complete callback. */
            } else if (Type.isFunction(arguments[i])) {
              options.complete = arguments[i];
            }
          }
        }

        /*********************
         Action Detection
         *********************/

        /* Velocity's behavior is categorized into "actions": Elements can either be specially scrolled into view,
         or they can be started, stopped, paused, resumed, or reversed . If a literal or referenced properties map is passed in as Velocity's
         first argument, the associated action is "start". Alternatively, "scroll", "reverse", "pause", "resume" or "stop" can be passed in 
         instead of a properties map. */
        var action;
        switch (propertiesMap) {
          case "scroll":
            action = "scroll";
            break;
          case "reverse":
            action = "reverse";
            break;
          case "pause":
            /*******************
             Action: Pause
             *******************/

            var currentTime = new Date().getTime();

            /* Handle delay timers */
            $.each(elements, function (i, element) {
              pauseDelayOnElement(element, currentTime);
            });

            /* Pause and Resume are call-wide (not on a per element basis). Thus, calling pause or resume on a 
             single element will cause any calls that containt tweens for that element to be paused/resumed
             as well. */

            /* Iterate through all calls and pause any that contain any of our elements */
            $.each(Velocity.State.calls, function (i, activeCall) {
              var found = false;
              /* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
              if (activeCall) {
                /* Iterate through the active call's targeted elements. */
                $.each(activeCall[1], function (k, activeElement) {
                  var queueName = options === undefined ? "" : options;
                  if (queueName !== true && activeCall[2].queue !== queueName && !(options === undefined && activeCall[2].queue === false)) {
                    return true;
                  }

                  /* Iterate through the calls targeted by the stop command. */
                  $.each(elements, function (l, element) {
                    /* Check that this call was applied to the target element. */
                    if (element === activeElement) {
                      /* Set call to paused */
                      activeCall[5] = {
                        resume: false
                      };

                      /* Once we match an element, we can bounce out to the next call entirely */
                      found = true;
                      return false;
                    }
                  });

                  /* Proceed to check next call if we have already matched */
                  if (found) {
                    return false;
                  }
                });
              }
            });

            /* Since pause creates no new tweens, exit out of Velocity. */
            return getChain();
          case "resume":
            /*******************
             Action: Resume
             *******************/

            /* Handle delay timers */
            $.each(elements, function (i, element) {
              resumeDelayOnElement(element, currentTime);
            });

            /* Pause and Resume are call-wide (not on a per elemnt basis). Thus, calling pause or resume on a 
             single element will cause any calls that containt tweens for that element to be paused/resumed
             as well. */

            /* Iterate through all calls and pause any that contain any of our elements */
            $.each(Velocity.State.calls, function (i, activeCall) {
              var found = false;
              /* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
              if (activeCall) {
                /* Iterate through the active call's targeted elements. */
                $.each(activeCall[1], function (k, activeElement) {
                  var queueName = options === undefined ? "" : options;
                  if (queueName !== true && activeCall[2].queue !== queueName && !(options === undefined && activeCall[2].queue === false)) {
                    return true;
                  }

                  /* Skip any calls that have never been paused */
                  if (!activeCall[5]) {
                    return true;
                  }

                  /* Iterate through the calls targeted by the stop command. */
                  $.each(elements, function (l, element) {
                    /* Check that this call was applied to the target element. */
                    if (element === activeElement) {
                      /* Flag a pause object to be resumed, which will occur during the next tick. In
                       addition, the pause object will at that time be deleted */
                      activeCall[5].resume = true;

                      /* Once we match an element, we can bounce out to the next call entirely */
                      found = true;
                      return false;
                    }
                  });

                  /* Proceed to check next call if we have already matched */
                  if (found) {
                    return false;
                  }
                });
              }
            });

            /* Since resume creates no new tweens, exit out of Velocity. */
            return getChain();
          case "finish":
          case "finishAll":
          case "stop":
            /*******************
             Action: Stop
             *******************/

            /* Clear the currently-active delay on each targeted element. */
            $.each(elements, function (i, element) {
              if (Data(element) && Data(element).delayTimer) {
                /* Stop the timer from triggering its cached next() function. */
                clearTimeout(Data(element).delayTimer.setTimeout);

                /* Manually call the next() function so that the subsequent queue items can progress. */
                if (Data(element).delayTimer.next) {
                  Data(element).delayTimer.next();
                }
                delete Data(element).delayTimer;
              }

              /* If we want to finish everything in the queue, we have to iterate through it
               and call each function. This will make them active calls below, which will
               cause them to be applied via the duration setting. */
              if (propertiesMap === "finishAll" && (options === true || Type.isString(options))) {
                /* Iterate through the items in the element's queue. */
                $.each($.queue(element, Type.isString(options) ? options : ""), function (_, item) {
                  /* The queue array can contain an "inprogress" string, which we skip. */
                  if (Type.isFunction(item)) {
                    item();
                  }
                });

                /* Clearing the $.queue() array is achieved by resetting it to []. */
                $.queue(element, Type.isString(options) ? options : "", []);
              }
            });
            var callsToStop = [];

            /* When the stop action is triggered, the elements' currently active call is immediately stopped. The active call might have
             been applied to multiple elements, in which case all of the call's elements will be stopped. When an element
             is stopped, the next item in its animation queue is immediately triggered. */
            /* An additional argument may be passed in to clear an element's remaining queued calls. Either true (which defaults to the "fx" queue)
             or a custom queue string can be passed in. */
            /* Note: The stop command runs prior to Velocity's Queueing phase since its behavior is intended to take effect *immediately*,
             regardless of the element's current queue state. */

            /* Iterate through every active call. */
            $.each(Velocity.State.calls, function (i, activeCall) {
              /* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
              if (activeCall) {
                /* Iterate through the active call's targeted elements. */
                $.each(activeCall[1], function (k, activeElement) {
                  /* If true was passed in as a secondary argument, clear absolutely all calls on this element. Otherwise, only
                   clear calls associated with the relevant queue. */
                  /* Call stopping logic works as follows:
                   - options === true --> stop current default queue calls (and queue:false calls), including remaining queued ones.
                   - options === undefined --> stop current queue:"" call and all queue:false calls.
                   - options === false --> stop only queue:false calls.
                   - options === "custom" --> stop current queue:"custom" call, including remaining queued ones (there is no functionality to only clear the currently-running queue:"custom" call). */
                  var queueName = options === undefined ? "" : options;
                  if (queueName !== true && activeCall[2].queue !== queueName && !(options === undefined && activeCall[2].queue === false)) {
                    return true;
                  }

                  /* Iterate through the calls targeted by the stop command. */
                  $.each(elements, function (l, element) {
                    /* Check that this call was applied to the target element. */
                    if (element === activeElement) {
                      /* Optionally clear the remaining queued calls. If we're doing "finishAll" this won't find anything,
                       due to the queue-clearing above. */
                      if (options === true || Type.isString(options)) {
                        /* Iterate through the items in the element's queue. */
                        $.each($.queue(element, Type.isString(options) ? options : ""), function (_, item) {
                          /* The queue array can contain an "inprogress" string, which we skip. */
                          if (Type.isFunction(item)) {
                            /* Pass the item's callback a flag indicating that we want to abort from the queue call.
                             (Specifically, the queue will resolve the call's associated promise then abort.)  */
                            item(null, true);
                          }
                        });

                        /* Clearing the $.queue() array is achieved by resetting it to []. */
                        $.queue(element, Type.isString(options) ? options : "", []);
                      }
                      if (propertiesMap === "stop") {
                        /* Since "reverse" uses cached start values (the previous call's endValues), these values must be
                         changed to reflect the final value that the elements were actually tweened to. */
                        /* Note: If only queue:false/queue:"custom" animations are currently running on an element, it won't have a tweensContainer
                         object. Also, queue:false/queue:"custom" animations can't be reversed. */
                        var data = Data(element);
                        if (data && data.tweensContainer && (queueName === true || queueName === "")) {
                          $.each(data.tweensContainer, function (m, activeTween) {
                            activeTween.endValue = activeTween.currentValue;
                          });
                        }
                        callsToStop.push(i);
                      } else if (propertiesMap === "finish" || propertiesMap === "finishAll") {
                        /* To get active tweens to finish immediately, we forcefully shorten their durations to 1ms so that
                         they finish upon the next rAf tick then proceed with normal call completion logic. */
                        activeCall[2].duration = 1;
                      }
                    }
                  });
                });
              }
            });

            /* Prematurely call completeCall() on each matched active call. Pass an additional flag for "stop" to indicate
             that the complete callback and display:none setting should be skipped since we're completing prematurely. */
            if (propertiesMap === "stop") {
              $.each(callsToStop, function (i, j) {
                completeCall(j, true);
              });
              if (promiseData.promise) {
                /* Immediately resolve the promise associated with this stop call since stop runs synchronously. */
                promiseData.resolver(elements);
              }
            }

            /* Since we're stopping, and not proceeding with queueing, exit out of Velocity. */
            return getChain();
          default:
            /* Treat a non-empty plain object as a literal properties map. */
            if ($.isPlainObject(propertiesMap) && !Type.isEmptyObject(propertiesMap)) {
              action = "start";

              /****************
               Redirects
               ****************/

              /* Check if a string matches a registered redirect (see Redirects above). */
            } else if (Type.isString(propertiesMap) && Velocity.Redirects[propertiesMap]) {
              opts = $.extend({}, options);
              var durationOriginal = opts.duration,
                delayOriginal = opts.delay || 0;

              /* If the backwards option was passed in, reverse the element set so that elements animate from the last to the first. */
              if (opts.backwards === true) {
                elements = $.extend(true, [], elements).reverse();
              }

              /* Individually trigger the redirect for each element in the set to prevent users from having to handle iteration logic in their redirect. */
              $.each(elements, function (elementIndex, element) {
                /* If the stagger option was passed in, successively delay each element by the stagger value (in ms). Retain the original delay value. */
                if (parseFloat(opts.stagger)) {
                  opts.delay = delayOriginal + parseFloat(opts.stagger) * elementIndex;
                } else if (Type.isFunction(opts.stagger)) {
                  opts.delay = delayOriginal + opts.stagger.call(element, elementIndex, elementsLength);
                }

                /* If the drag option was passed in, successively increase/decrease (depending on the presense of opts.backwards)
                 the duration of each element's animation, using floors to prevent producing very short durations. */
                if (opts.drag) {
                  /* Default the duration of UI pack effects (callouts and transitions) to 1000ms instead of the usual default duration of 400ms. */
                  opts.duration = parseFloat(durationOriginal) || (/^(callout|transition)/.test(propertiesMap) ? 1000 : DURATION_DEFAULT);

                  /* For each element, take the greater duration of: A) animation completion percentage relative to the original duration,
                   B) 75% of the original duration, or C) a 200ms fallback (in case duration is already set to a low value).
                   The end result is a baseline of 75% of the redirect's duration that increases/decreases as the end of the element set is approached. */
                  opts.duration = Math.max(opts.duration * (opts.backwards ? 1 - elementIndex / elementsLength : (elementIndex + 1) / elementsLength), opts.duration * 0.75, 200);
                }

                /* Pass in the call's opts object so that the redirect can optionally extend it. It defaults to an empty object instead of null to
                 reduce the opts checking logic required inside the redirect. */
                Velocity.Redirects[propertiesMap].call(element, element, opts || {}, elementIndex, elementsLength, elements, promiseData.promise ? promiseData : undefined);
              });

              /* Since the animation logic resides within the redirect's own code, abort the remainder of this call.
               (The performance overhead up to this point is virtually non-existant.) */
              /* Note: The jQuery call chain is kept intact by returning the complete element set. */
              return getChain();
            } else {
              var abortError = "Velocity: First argument (" + propertiesMap + ") was not a property map, a known action, or a registered redirect. Aborting.";
              if (promiseData.promise) {
                promiseData.rejecter(new Error(abortError));
              } else if (window.console) {
                console.log(abortError);
              }
              return getChain();
            }
        }

        /**************************
         Call-Wide Variables
         **************************/

        /* A container for CSS unit conversion ratios (e.g. %, rem, and em ==> px) that is used to cache ratios across all elements
         being animated in a single Velocity call. Calculating unit ratios necessitates DOM querying and updating, and is therefore
         avoided (via caching) wherever possible. This container is call-wide instead of page-wide to avoid the risk of using stale
         conversion metrics across Velocity animations that are not immediately consecutively chained. */
        var callUnitConversionData = {
          lastParent: null,
          lastPosition: null,
          lastFontSize: null,
          lastPercentToPxWidth: null,
          lastPercentToPxHeight: null,
          lastEmToPx: null,
          remToPx: null,
          vwToPx: null,
          vhToPx: null
        };

        /* A container for all the ensuing tween data and metadata associated with this call. This container gets pushed to the page-wide
         Velocity.State.calls array that is processed during animation ticking. */
        var call = [];

        /************************
         Element Processing
         ************************/

        /* Element processing consists of three parts -- data processing that cannot go stale and data processing that *can* go stale (i.e. third-party style modifications):
         1) Pre-Queueing: Element-wide variables, including the element's data storage, are instantiated. Call options are prepared. If triggered, the Stop action is executed.
         2) Queueing: The logic that runs once this call has reached its point of execution in the element's $.queue() stack. Most logic is placed here to avoid risking it becoming stale.
         3) Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
         `elementArrayIndex` allows passing index of the element in the original array to value functions.
         If `elementsIndex` were used instead the index would be determined by the elements' per-element queue.
         */
        function processElement(element, elementArrayIndex) {
          /*************************
           Part I: Pre-Queueing
           *************************/

          /***************************
           Element-Wide Variables
           ***************************/

          var /* The runtime opts object is the extension of the current call's options and Velocity's page-wide option defaults. */
            opts = $.extend({}, Velocity.defaults, options),
            /* A container for the processed data associated with each property in the propertyMap.
             (Each property in the map produces its own "tween".) */
            tweensContainer = {},
            elementUnitConversionData;

          /******************
           Element Init
           ******************/

          if (Data(element) === undefined) {
            Velocity.init(element);
          }

          /******************
           Option: Delay
           ******************/

          /* Since queue:false doesn't respect the item's existing queue, we avoid injecting its delay here (it's set later on). */
          /* Note: Velocity rolls its own delay function since jQuery doesn't have a utility alias for $.fn.delay()
           (and thus requires jQuery element creation, which we avoid since its overhead includes DOM querying). */
          if (parseFloat(opts.delay) && opts.queue !== false) {
            $.queue(element, opts.queue, function (next, clearQueue) {
              if (clearQueue === true) {
                /* Do not continue with animation queueing. */
                return true;
              }

              /* This is a flag used to indicate to the upcoming completeCall() function that this queue entry was initiated by Velocity. See completeCall() for further details. */
              Velocity.velocityQueueEntryFlag = true;

              /* The ensuing queue item (which is assigned to the "next" argument that $.queue() automatically passes in) will be triggered after a setTimeout delay.
               The setTimeout is stored so that it can be subjected to clearTimeout() if this animation is prematurely stopped via Velocity's "stop" command, and
               delayBegin/delayTime is used to ensure we can "pause" and "resume" a tween that is still mid-delay. */

              /* Temporarily store delayed elements to facilite access for global pause/resume */
              var callIndex = Velocity.State.delayedElements.count++;
              Velocity.State.delayedElements[callIndex] = element;
              var delayComplete = function (index) {
                return function () {
                  /* Clear the temporary element */
                  Velocity.State.delayedElements[index] = false;

                  /* Finally, issue the call */
                  next();
                };
              }(callIndex);
              Data(element).delayBegin = new Date().getTime();
              Data(element).delay = parseFloat(opts.delay);
              Data(element).delayTimer = {
                setTimeout: setTimeout(next, parseFloat(opts.delay)),
                next: delayComplete
              };
            });
          }

          /*********************
           Option: Duration
           *********************/

          /* Support for jQuery's named durations. */
          switch (opts.duration.toString().toLowerCase()) {
            case "fast":
              opts.duration = 200;
              break;
            case "normal":
              opts.duration = DURATION_DEFAULT;
              break;
            case "slow":
              opts.duration = 600;
              break;
            default:
              /* Remove the potential "ms" suffix and default to 1 if the user is attempting to set a duration of 0 (in order to produce an immediate style change). */
              opts.duration = parseFloat(opts.duration) || 1;
          }

          /************************
           Global Option: Mock
           ************************/

          if (Velocity.mock !== false) {
            /* In mock mode, all animations are forced to 1ms so that they occur immediately upon the next rAF tick.
             Alternatively, a multiplier can be passed in to time remap all delays and durations. */
            if (Velocity.mock === true) {
              opts.duration = opts.delay = 1;
            } else {
              opts.duration *= parseFloat(Velocity.mock) || 1;
              opts.delay *= parseFloat(Velocity.mock) || 1;
            }
          }

          /*******************
           Option: Easing
           *******************/

          opts.easing = getEasing(opts.easing, opts.duration);

          /**********************
           Option: Callbacks
           **********************/

          /* Callbacks must functions. Otherwise, default to null. */
          if (opts.begin && !Type.isFunction(opts.begin)) {
            opts.begin = null;
          }
          if (opts.progress && !Type.isFunction(opts.progress)) {
            opts.progress = null;
          }
          if (opts.complete && !Type.isFunction(opts.complete)) {
            opts.complete = null;
          }

          /*********************************
           Option: Display & Visibility
           *********************************/

          /* Refer to Velocity's documentation (VelocityJS.org/#displayAndVisibility) for a description of the display and visibility options' behavior. */
          /* Note: We strictly check for undefined instead of falsiness because display accepts an empty string value. */
          if (opts.display !== undefined && opts.display !== null) {
            opts.display = opts.display.toString().toLowerCase();

            /* Users can pass in a special "auto" value to instruct Velocity to set the element to its default display value. */
            if (opts.display === "auto") {
              opts.display = Velocity.CSS.Values.getDisplayType(element);
            }
          }
          if (opts.visibility !== undefined && opts.visibility !== null) {
            opts.visibility = opts.visibility.toString().toLowerCase();
          }

          /**********************
           Option: mobileHA
           **********************/

          /* When set to true, and if this is a mobile device, mobileHA automatically enables hardware acceleration (via a null transform hack)
           on animating elements. HA is removed from the element at the completion of its animation. */
          /* Note: Android Gingerbread doesn't support HA. If a null transform hack (mobileHA) is in fact set, it will prevent other tranform subproperties from taking effect. */
          /* Note: You can read more about the use of mobileHA in Velocity's documentation: VelocityJS.org/#mobileHA. */
          opts.mobileHA = opts.mobileHA && Velocity.State.isMobile && !Velocity.State.isGingerbread;

          /***********************
           Part II: Queueing
           ***********************/

          /* When a set of elements is targeted by a Velocity call, the set is broken up and each element has the current Velocity call individually queued onto it.
           In this way, each element's existing queue is respected; some elements may already be animating and accordingly should not have this current Velocity call triggered immediately. */
          /* In each queue, tween data is processed for each animating property then pushed onto the call-wide calls array. When the last element in the set has had its tweens processed,
           the call array is pushed to Velocity.State.calls for live processing by the requestAnimationFrame tick. */
          function buildQueue(next) {
            var data, lastTweensContainer;

            /*******************
             Option: Begin
             *******************/

            /* The begin callback is fired once per call -- not once per elemenet -- and is passed the full raw DOM element set as both its context and its first argument. */
            if (opts.begin && elementsIndex === 0) {
              /* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
              try {
                opts.begin.call(elements, elements);
              } catch (error) {
                setTimeout(function () {
                  throw error;
                }, 1);
              }
            }

            /*****************************************
             Tween Data Construction (for Scroll)
             *****************************************/

            /* Note: In order to be subjected to chaining and animation options, scroll's tweening is routed through Velocity as if it were a standard CSS property animation. */
            if (action === "scroll") {
              /* The scroll action uniquely takes an optional "offset" option -- specified in pixels -- that offsets the targeted scroll position. */
              var scrollDirection = /^x$/i.test(opts.axis) ? "Left" : "Top",
                scrollOffset = parseFloat(opts.offset) || 0,
                scrollPositionCurrent,
                scrollPositionCurrentAlternate,
                scrollPositionEnd;

              /* Scroll also uniquely takes an optional "container" option, which indicates the parent element that should be scrolled --
               as opposed to the browser window itself. This is useful for scrolling toward an element that's inside an overflowing parent element. */
              if (opts.container) {
                /* Ensure that either a jQuery object or a raw DOM element was passed in. */
                if (Type.isWrapped(opts.container) || Type.isNode(opts.container)) {
                  /* Extract the raw DOM element from the jQuery wrapper. */
                  opts.container = opts.container[0] || opts.container;
                  /* Note: Unlike other properties in Velocity, the browser's scroll position is never cached since it so frequently changes
                   (due to the user's natural interaction with the page). */
                  scrollPositionCurrent = opts.container["scroll" + scrollDirection]; /* GET */

                  /* $.position() values are relative to the container's currently viewable area (without taking into account the container's true dimensions
                   -- say, for example, if the container was not overflowing). Thus, the scroll end value is the sum of the child element's position *and*
                   the scroll container's current scroll position. */
                  scrollPositionEnd = scrollPositionCurrent + $(element).position()[scrollDirection.toLowerCase()] + scrollOffset; /* GET */
                  /* If a value other than a jQuery object or a raw DOM element was passed in, default to null so that this option is ignored. */
                } else {
                  opts.container = null;
                }
              } else {
                /* If the window itself is being scrolled -- not a containing element -- perform a live scroll position lookup using
                 the appropriate cached property names (which differ based on browser type). */
                scrollPositionCurrent = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + scrollDirection]]; /* GET */
                /* When scrolling the browser window, cache the alternate axis's current value since window.scrollTo() doesn't let us change only one value at a time. */
                scrollPositionCurrentAlternate = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + (scrollDirection === "Left" ? "Top" : "Left")]]; /* GET */

                /* Unlike $.position(), $.offset() values are relative to the browser window's true dimensions -- not merely its currently viewable area --
                 and therefore end values do not need to be compounded onto current values. */
                scrollPositionEnd = $(element).offset()[scrollDirection.toLowerCase()] + scrollOffset; /* GET */
              }

              /* Since there's only one format that scroll's associated tweensContainer can take, we create it manually. */
              tweensContainer = {
                scroll: {
                  rootPropertyValue: false,
                  startValue: scrollPositionCurrent,
                  currentValue: scrollPositionCurrent,
                  endValue: scrollPositionEnd,
                  unitType: "",
                  easing: opts.easing,
                  scrollData: {
                    container: opts.container,
                    direction: scrollDirection,
                    alternateValue: scrollPositionCurrentAlternate
                  }
                },
                element: element
              };
              if (Velocity.debug) {
                console.log("tweensContainer (scroll): ", tweensContainer.scroll, element);
              }

              /******************************************
               Tween Data Construction (for Reverse)
               ******************************************/

              /* Reverse acts like a "start" action in that a property map is animated toward. The only difference is
               that the property map used for reverse is the inverse of the map used in the previous call. Thus, we manipulate
               the previous call to construct our new map: use the previous map's end values as our new map's start values. Copy over all other data. */
              /* Note: Reverse can be directly called via the "reverse" parameter, or it can be indirectly triggered via the loop option. (Loops are composed of multiple reverses.) */
              /* Note: Reverse calls do not need to be consecutively chained onto a currently-animating element in order to operate on cached values;
               there is no harm to reverse being called on a potentially stale data cache since reverse's behavior is simply defined
               as reverting to the element's values as they were prior to the previous *Velocity* call. */
            } else if (action === "reverse") {
              data = Data(element);

              /* Abort if there is no prior animation data to reverse to. */
              if (!data) {
                return;
              }
              if (!data.tweensContainer) {
                /* Dequeue the element so that this queue entry releases itself immediately, allowing subsequent queue entries to run. */
                $.dequeue(element, opts.queue);
                return;
              } else {
                /*********************
                 Options Parsing
                 *********************/

                /* If the element was hidden via the display option in the previous call,
                 revert display to "auto" prior to reversal so that the element is visible again. */
                if (data.opts.display === "none") {
                  data.opts.display = "auto";
                }
                if (data.opts.visibility === "hidden") {
                  data.opts.visibility = "visible";
                }

                /* If the loop option was set in the previous call, disable it so that "reverse" calls aren't recursively generated.
                 Further, remove the previous call's callback options; typically, users do not want these to be refired. */
                data.opts.loop = false;
                data.opts.begin = null;
                data.opts.complete = null;

                /* Since we're extending an opts object that has already been extended with the defaults options object,
                 we remove non-explicitly-defined properties that are auto-assigned values. */
                if (!options.easing) {
                  delete opts.easing;
                }
                if (!options.duration) {
                  delete opts.duration;
                }

                /* The opts object used for reversal is an extension of the options object optionally passed into this
                 reverse call plus the options used in the previous Velocity call. */
                opts = $.extend({}, data.opts, opts);

                /*************************************
                 Tweens Container Reconstruction
                 *************************************/

                /* Create a deepy copy (indicated via the true flag) of the previous call's tweensContainer. */
                lastTweensContainer = $.extend(true, {}, data ? data.tweensContainer : null);

                /* Manipulate the previous tweensContainer by replacing its end values and currentValues with its start values. */
                for (var lastTween in lastTweensContainer) {
                  /* In addition to tween data, tweensContainers contain an element property that we ignore here. */
                  if (lastTweensContainer.hasOwnProperty(lastTween) && lastTween !== "element") {
                    var lastStartValue = lastTweensContainer[lastTween].startValue;
                    lastTweensContainer[lastTween].startValue = lastTweensContainer[lastTween].currentValue = lastTweensContainer[lastTween].endValue;
                    lastTweensContainer[lastTween].endValue = lastStartValue;

                    /* Easing is the only option that embeds into the individual tween data (since it can be defined on a per-property basis).
                     Accordingly, every property's easing value must be updated when an options object is passed in with a reverse call.
                     The side effect of this extensibility is that all per-property easing values are forcefully reset to the new value. */
                    if (!Type.isEmptyObject(options)) {
                      lastTweensContainer[lastTween].easing = opts.easing;
                    }
                    if (Velocity.debug) {
                      console.log("reverse tweensContainer (" + lastTween + "): " + JSON.stringify(lastTweensContainer[lastTween]), element);
                    }
                  }
                }
                tweensContainer = lastTweensContainer;
              }

              /*****************************************
               Tween Data Construction (for Start)
               *****************************************/
            } else if (action === "start") {
              /*************************
               Value Transferring
               *************************/

              /* If this queue entry follows a previous Velocity-initiated queue entry *and* if this entry was created
               while the element was in the process of being animated by Velocity, then this current call is safe to use
               the end values from the prior call as its start values. Velocity attempts to perform this value transfer
               process whenever possible in order to avoid requerying the DOM. */
              /* If values aren't transferred from a prior call and start values were not forcefed by the user (more on this below),
               then the DOM is queried for the element's current values as a last resort. */
              /* Note: Conversely, animation reversal (and looping) *always* perform inter-call value transfers; they never requery the DOM. */

              data = Data(element);

              /* The per-element isAnimating flag is used to indicate whether it's safe (i.e. the data isn't stale)
               to transfer over end values to use as start values. If it's set to true and there is a previous
               Velocity call to pull values from, do so. */
              if (data && data.tweensContainer && data.isAnimating === true) {
                lastTweensContainer = data.tweensContainer;
              }

              /***************************
               Tween Data Calculation
               ***************************/

              /* This function parses property data and defaults endValue, easing, and startValue as appropriate. */
              /* Property map values can either take the form of 1) a single value representing the end value,
               or 2) an array in the form of [ endValue, [, easing] [, startValue] ].
               The optional third parameter is a forcefed startValue to be used instead of querying the DOM for
               the element's current value. Read Velocity's docmentation to learn more about forcefeeding: VelocityJS.org/#forcefeeding */
              var parsePropertyValue = function (valueData, skipResolvingEasing) {
                var endValue, easing, startValue;

                /* If we have a function as the main argument then resolve it first, in case it returns an array that needs to be split */
                if (Type.isFunction(valueData)) {
                  valueData = valueData.call(element, elementArrayIndex, elementsLength);
                }

                /* Handle the array format, which can be structured as one of three potential overloads:
                 A) [ endValue, easing, startValue ], B) [ endValue, easing ], or C) [ endValue, startValue ] */
                if (Type.isArray(valueData)) {
                  /* endValue is always the first item in the array. Don't bother validating endValue's value now
                   since the ensuing property cycling logic does that. */
                  endValue = valueData[0];

                  /* Two-item array format: If the second item is a number, function, or hex string, treat it as a
                   start value since easings can only be non-hex strings or arrays. */
                  if (!Type.isArray(valueData[1]) && /^[\d-]/.test(valueData[1]) || Type.isFunction(valueData[1]) || CSS.RegEx.isHex.test(valueData[1])) {
                    startValue = valueData[1];
                    /* Two or three-item array: If the second item is a non-hex string easing name or an array, treat it as an easing. */
                  } else if (Type.isString(valueData[1]) && !CSS.RegEx.isHex.test(valueData[1]) && Velocity.Easings[valueData[1]] || Type.isArray(valueData[1])) {
                    easing = skipResolvingEasing ? valueData[1] : getEasing(valueData[1], opts.duration);

                    /* Don't bother validating startValue's value now since the ensuing property cycling logic inherently does that. */
                    startValue = valueData[2];
                  } else {
                    startValue = valueData[1] || valueData[2];
                  }
                  /* Handle the single-value format. */
                } else {
                  endValue = valueData;
                }

                /* Default to the call's easing if a per-property easing type was not defined. */
                if (!skipResolvingEasing) {
                  easing = easing || opts.easing;
                }

                /* If functions were passed in as values, pass the function the current element as its context,
                 plus the element's index and the element set's size as arguments. Then, assign the returned value. */
                if (Type.isFunction(endValue)) {
                  endValue = endValue.call(element, elementArrayIndex, elementsLength);
                }
                if (Type.isFunction(startValue)) {
                  startValue = startValue.call(element, elementArrayIndex, elementsLength);
                }

                /* Allow startValue to be left as undefined to indicate to the ensuing code that its value was not forcefed. */
                return [endValue || 0, easing, startValue];
              };
              var fixPropertyValue = function (property, valueData) {
                /* In case this property is a hook, there are circumstances where we will intend to work on the hook's root property and not the hooked subproperty. */
                var rootProperty = CSS.Hooks.getRoot(property),
                  rootPropertyValue = false,
                  /* Parse out endValue, easing, and startValue from the property's data. */
                  endValue = valueData[0],
                  easing = valueData[1],
                  startValue = valueData[2],
                  pattern;

                /**************************
                 Start Value Sourcing
                 **************************/

                /* Other than for the dummy tween property, properties that are not supported by the browser (and do not have an associated normalization) will
                 inherently produce no style changes when set, so they are skipped in order to decrease animation tick overhead.
                 Property support is determined via prefixCheck(), which returns a false flag when no supported is detected. */
                /* Note: Since SVG elements have some of their properties directly applied as HTML attributes,
                 there is no way to check for their explicit browser support, and so we skip skip this check for them. */
                if ((!data || !data.isSVG) && rootProperty !== "tween" && CSS.Names.prefixCheck(rootProperty)[1] === false && CSS.Normalizations.registered[rootProperty] === undefined) {
                  if (Velocity.debug) {
                    console.log("Skipping [" + rootProperty + "] due to a lack of browser support.");
                  }
                  return;
                }

                /* If the display option is being set to a non-"none" (e.g. "block") and opacity (filter on IE<=8) is being
                 animated to an endValue of non-zero, the user's intention is to fade in from invisible, thus we forcefeed opacity
                 a startValue of 0 if its startValue hasn't already been sourced by value transferring or prior forcefeeding. */
                if ((opts.display !== undefined && opts.display !== null && opts.display !== "none" || opts.visibility !== undefined && opts.visibility !== "hidden") && /opacity|filter/.test(property) && !startValue && endValue !== 0) {
                  startValue = 0;
                }

                /* If values have been transferred from the previous Velocity call, extract the endValue and rootPropertyValue
                 for all of the current call's properties that were *also* animated in the previous call. */
                /* Note: Value transferring can optionally be disabled by the user via the _cacheValues option. */
                if (opts._cacheValues && lastTweensContainer && lastTweensContainer[property]) {
                  if (startValue === undefined) {
                    startValue = lastTweensContainer[property].endValue + lastTweensContainer[property].unitType;
                  }

                  /* The previous call's rootPropertyValue is extracted from the element's data cache since that's the
                   instance of rootPropertyValue that gets freshly updated by the tweening process, whereas the rootPropertyValue
                   attached to the incoming lastTweensContainer is equal to the root property's value prior to any tweening. */
                  rootPropertyValue = data.rootPropertyValueCache[rootProperty];
                  /* If values were not transferred from a previous Velocity call, query the DOM as needed. */
                } else {
                  /* Handle hooked properties. */
                  if (CSS.Hooks.registered[property]) {
                    if (startValue === undefined) {
                      rootPropertyValue = CSS.getPropertyValue(element, rootProperty); /* GET */
                      /* Note: The following getPropertyValue() call does not actually trigger a DOM query;
                       getPropertyValue() will extract the hook from rootPropertyValue. */
                      startValue = CSS.getPropertyValue(element, property, rootPropertyValue);
                      /* If startValue is already defined via forcefeeding, do not query the DOM for the root property's value;
                       just grab rootProperty's zero-value template from CSS.Hooks. This overwrites the element's actual
                       root property value (if one is set), but this is acceptable since the primary reason users forcefeed is
                       to avoid DOM queries, and thus we likewise avoid querying the DOM for the root property's value. */
                    } else {
                      /* Grab this hook's zero-value template, e.g. "0px 0px 0px black". */
                      rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
                    }
                    /* Handle non-hooked properties that haven't already been defined via forcefeeding. */
                  } else if (startValue === undefined) {
                    startValue = CSS.getPropertyValue(element, property); /* GET */
                  }
                }

                /**************************
                 Value Data Extraction
                 **************************/

                var separatedValue,
                  endValueUnitType,
                  startValueUnitType,
                  operator = false;

                /* Separates a property value into its numeric value and its unit type. */
                var separateValue = function (property, value) {
                  var unitType, numericValue;
                  numericValue = (value || "0").toString().toLowerCase()
                  /* Match the unit type at the end of the value. */.replace(/[%A-z]+$/, function (match) {
                    /* Grab the unit type. */
                    unitType = match;

                    /* Strip the unit type off of value. */
                    return "";
                  });

                  /* If no unit type was supplied, assign one that is appropriate for this property (e.g. "deg" for rotateZ or "px" for width). */
                  if (!unitType) {
                    unitType = CSS.Values.getUnitType(property);
                  }
                  return [numericValue, unitType];
                };
                if (startValue !== endValue && Type.isString(startValue) && Type.isString(endValue)) {
                  pattern = "";
                  var iStart = 0,
                    // index in startValue
                    iEnd = 0,
                    // index in endValue
                    aStart = [],
                    // array of startValue numbers
                    aEnd = [],
                    // array of endValue numbers
                    inCalc = 0,
                    // Keep track of being inside a "calc()" so we don't duplicate it
                    inRGB = 0,
                    // Keep track of being inside an RGB as we can't use fractional values
                    inRGBA = 0; // Keep track of being inside an RGBA as we must pass fractional for the alpha channel

                  startValue = CSS.Hooks.fixColors(startValue);
                  endValue = CSS.Hooks.fixColors(endValue);
                  while (iStart < startValue.length && iEnd < endValue.length) {
                    var cStart = startValue[iStart],
                      cEnd = endValue[iEnd];
                    if (/[\d\.-]/.test(cStart) && /[\d\.-]/.test(cEnd)) {
                      var tStart = cStart,
                        // temporary character buffer
                        tEnd = cEnd,
                        // temporary character buffer
                        dotStart = ".",
                        // Make sure we can only ever match a single dot in a decimal
                        dotEnd = "."; // Make sure we can only ever match a single dot in a decimal

                      while (++iStart < startValue.length) {
                        cStart = startValue[iStart];
                        if (cStart === dotStart) {
                          dotStart = ".."; // Can never match two characters
                        } else if (!/\d/.test(cStart)) {
                          break;
                        }
                        tStart += cStart;
                      }
                      while (++iEnd < endValue.length) {
                        cEnd = endValue[iEnd];
                        if (cEnd === dotEnd) {
                          dotEnd = ".."; // Can never match two characters
                        } else if (!/\d/.test(cEnd)) {
                          break;
                        }
                        tEnd += cEnd;
                      }
                      var uStart = CSS.Hooks.getUnit(startValue, iStart),
                        // temporary unit type
                        uEnd = CSS.Hooks.getUnit(endValue, iEnd); // temporary unit type

                      iStart += uStart.length;
                      iEnd += uEnd.length;
                      if (uStart === uEnd) {
                        // Same units
                        if (tStart === tEnd) {
                          // Same numbers, so just copy over
                          pattern += tStart + uStart;
                        } else {
                          // Different numbers, so store them
                          pattern += "{" + aStart.length + (inRGB ? "!" : "") + "}" + uStart;
                          aStart.push(parseFloat(tStart));
                          aEnd.push(parseFloat(tEnd));
                        }
                      } else {
                        // Different units, so put into a "calc(from + to)" and animate each side to/from zero
                        var nStart = parseFloat(tStart),
                          nEnd = parseFloat(tEnd);
                        pattern += (inCalc < 5 ? "calc" : "") + "(" + (nStart ? "{" + aStart.length + (inRGB ? "!" : "") + "}" : "0") + uStart + " + " + (nEnd ? "{" + (aStart.length + (nStart ? 1 : 0)) + (inRGB ? "!" : "") + "}" : "0") + uEnd + ")";
                        if (nStart) {
                          aStart.push(nStart);
                          aEnd.push(0);
                        }
                        if (nEnd) {
                          aStart.push(0);
                          aEnd.push(nEnd);
                        }
                      }
                    } else if (cStart === cEnd) {
                      pattern += cStart;
                      iStart++;
                      iEnd++;
                      // Keep track of being inside a calc()
                      if (inCalc === 0 && cStart === "c" || inCalc === 1 && cStart === "a" || inCalc === 2 && cStart === "l" || inCalc === 3 && cStart === "c" || inCalc >= 4 && cStart === "(") {
                        inCalc++;
                      } else if (inCalc && inCalc < 5 || inCalc >= 4 && cStart === ")" && --inCalc < 5) {
                        inCalc = 0;
                      }
                      // Keep track of being inside an rgb() / rgba()
                      if (inRGB === 0 && cStart === "r" || inRGB === 1 && cStart === "g" || inRGB === 2 && cStart === "b" || inRGB === 3 && cStart === "a" || inRGB >= 3 && cStart === "(") {
                        if (inRGB === 3 && cStart === "a") {
                          inRGBA = 1;
                        }
                        inRGB++;
                      } else if (inRGBA && cStart === ",") {
                        if (++inRGBA > 3) {
                          inRGB = inRGBA = 0;
                        }
                      } else if (inRGBA && inRGB < (inRGBA ? 5 : 4) || inRGB >= (inRGBA ? 4 : 3) && cStart === ")" && --inRGB < (inRGBA ? 5 : 4)) {
                        inRGB = inRGBA = 0;
                      }
                    } else {
                      inCalc = 0;
                      // TODO: changing units, fixing colours
                      break;
                    }
                  }
                  if (iStart !== startValue.length || iEnd !== endValue.length) {
                    if (Velocity.debug) {
                      console.error("Trying to pattern match mis-matched strings [\"" + endValue + "\", \"" + startValue + "\"]");
                    }
                    pattern = undefined;
                  }
                  if (pattern) {
                    if (aStart.length) {
                      if (Velocity.debug) {
                        console.log("Pattern found \"" + pattern + "\" -> ", aStart, aEnd, "[" + startValue + "," + endValue + "]");
                      }
                      startValue = aStart;
                      endValue = aEnd;
                      endValueUnitType = startValueUnitType = "";
                    } else {
                      pattern = undefined;
                    }
                  }
                }
                if (!pattern) {
                  /* Separate startValue. */
                  separatedValue = separateValue(property, startValue);
                  startValue = separatedValue[0];
                  startValueUnitType = separatedValue[1];

                  /* Separate endValue, and extract a value operator (e.g. "+=", "-=") if one exists. */
                  separatedValue = separateValue(property, endValue);
                  endValue = separatedValue[0].replace(/^([+-\/*])=/, function (match, subMatch) {
                    operator = subMatch;

                    /* Strip the operator off of the value. */
                    return "";
                  });
                  endValueUnitType = separatedValue[1];

                  /* Parse float values from endValue and startValue. Default to 0 if NaN is returned. */
                  startValue = parseFloat(startValue) || 0;
                  endValue = parseFloat(endValue) || 0;

                  /***************************************
                   Property-Specific Value Conversion
                   ***************************************/

                  /* Custom support for properties that don't actually accept the % unit type, but where pollyfilling is trivial and relatively foolproof. */
                  if (endValueUnitType === "%") {
                    /* A %-value fontSize/lineHeight is relative to the parent's fontSize (as opposed to the parent's dimensions),
                     which is identical to the em unit's behavior, so we piggyback off of that. */
                    if (/^(fontSize|lineHeight)$/.test(property)) {
                      /* Convert % into an em decimal value. */
                      endValue = endValue / 100;
                      endValueUnitType = "em";
                      /* For scaleX and scaleY, convert the value into its decimal format and strip off the unit type. */
                    } else if (/^scale/.test(property)) {
                      endValue = endValue / 100;
                      endValueUnitType = "";
                      /* For RGB components, take the defined percentage of 255 and strip off the unit type. */
                    } else if (/(Red|Green|Blue)$/i.test(property)) {
                      endValue = endValue / 100 * 255;
                      endValueUnitType = "";
                    }
                  }
                }

                /***************************
                 Unit Ratio Calculation
                 ***************************/

                /* When queried, the browser returns (most) CSS property values in pixels. Therefore, if an endValue with a unit type of
                 %, em, or rem is animated toward, startValue must be converted from pixels into the same unit type as endValue in order
                 for value manipulation logic (increment/decrement) to proceed. Further, if the startValue was forcefed or transferred
                 from a previous call, startValue may also not be in pixels. Unit conversion logic therefore consists of two steps:
                 1) Calculating the ratio of %/em/rem/vh/vw relative to pixels
                 2) Converting startValue into the same unit of measurement as endValue based on these ratios. */
                /* Unit conversion ratios are calculated by inserting a sibling node next to the target node, copying over its position property,
                 setting values with the target unit type then comparing the returned pixel value. */
                /* Note: Even if only one of these unit types is being animated, all unit ratios are calculated at once since the overhead
                 of batching the SETs and GETs together upfront outweights the potential overhead
                 of layout thrashing caused by re-querying for uncalculated ratios for subsequently-processed properties. */
                /* Todo: Shift this logic into the calls' first tick instance so that it's synced with RAF. */
                var calculateUnitRatios = function () {
                  /************************
                   Same Ratio Checks
                   ************************/

                  /* The properties below are used to determine whether the element differs sufficiently from this call's
                   previously iterated element to also differ in its unit conversion ratios. If the properties match up with those
                   of the prior element, the prior element's conversion ratios are used. Like most optimizations in Velocity,
                   this is done to minimize DOM querying. */
                  var sameRatioIndicators = {
                      myParent: element.parentNode || document.body,
                      /* GET */
                      position: CSS.getPropertyValue(element, "position"),
                      /* GET */
                      fontSize: CSS.getPropertyValue(element, "fontSize") /* GET */
                    },
                    /* Determine if the same % ratio can be used. % is based on the element's position value and its parent's width and height dimensions. */
                    samePercentRatio = sameRatioIndicators.position === callUnitConversionData.lastPosition && sameRatioIndicators.myParent === callUnitConversionData.lastParent,
                    /* Determine if the same em ratio can be used. em is relative to the element's fontSize. */
                    sameEmRatio = sameRatioIndicators.fontSize === callUnitConversionData.lastFontSize;

                  /* Store these ratio indicators call-wide for the next element to compare against. */
                  callUnitConversionData.lastParent = sameRatioIndicators.myParent;
                  callUnitConversionData.lastPosition = sameRatioIndicators.position;
                  callUnitConversionData.lastFontSize = sameRatioIndicators.fontSize;

                  /***************************
                   Element-Specific Units
                   ***************************/

                  /* Note: IE8 rounds to the nearest pixel when returning CSS values, thus we perform conversions using a measurement
                   of 100 (instead of 1) to give our ratios a precision of at least 2 decimal values. */
                  var measurement = 100,
                    unitRatios = {};
                  if (!sameEmRatio || !samePercentRatio) {
                    var dummy = data && data.isSVG ? document.createElementNS("http://www.w3.org/2000/svg", "rect") : document.createElement("div");
                    Velocity.init(dummy);
                    sameRatioIndicators.myParent.appendChild(dummy);

                    /* To accurately and consistently calculate conversion ratios, the element's cascaded overflow and box-sizing are stripped.
                     Similarly, since width/height can be artificially constrained by their min-/max- equivalents, these are controlled for as well. */
                    /* Note: Overflow must be also be controlled for per-axis since the overflow property overwrites its per-axis values. */
                    $.each(["overflow", "overflowX", "overflowY"], function (i, property) {
                      Velocity.CSS.setPropertyValue(dummy, property, "hidden");
                    });
                    Velocity.CSS.setPropertyValue(dummy, "position", sameRatioIndicators.position);
                    Velocity.CSS.setPropertyValue(dummy, "fontSize", sameRatioIndicators.fontSize);
                    Velocity.CSS.setPropertyValue(dummy, "boxSizing", "content-box");

                    /* width and height act as our proxy properties for measuring the horizontal and vertical % ratios. */
                    $.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function (i, property) {
                      Velocity.CSS.setPropertyValue(dummy, property, measurement + "%");
                    });
                    /* paddingLeft arbitrarily acts as our proxy property for the em ratio. */
                    Velocity.CSS.setPropertyValue(dummy, "paddingLeft", measurement + "em");

                    /* Divide the returned value by the measurement to get the ratio between 1% and 1px. Default to 1 since working with 0 can produce Infinite. */
                    unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth = (parseFloat(CSS.getPropertyValue(dummy, "width", null, true)) || 1) / measurement; /* GET */
                    unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight = (parseFloat(CSS.getPropertyValue(dummy, "height", null, true)) || 1) / measurement; /* GET */
                    unitRatios.emToPx = callUnitConversionData.lastEmToPx = (parseFloat(CSS.getPropertyValue(dummy, "paddingLeft")) || 1) / measurement; /* GET */

                    sameRatioIndicators.myParent.removeChild(dummy);
                  } else {
                    unitRatios.emToPx = callUnitConversionData.lastEmToPx;
                    unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth;
                    unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight;
                  }

                  /***************************
                   Element-Agnostic Units
                   ***************************/

                  /* Whereas % and em ratios are determined on a per-element basis, the rem unit only needs to be checked
                   once per call since it's exclusively dependant upon document.body's fontSize. If this is the first time
                   that calculateUnitRatios() is being run during this call, remToPx will still be set to its default value of null,
                   so we calculate it now. */
                  if (callUnitConversionData.remToPx === null) {
                    /* Default to browsers' default fontSize of 16px in the case of 0. */
                    callUnitConversionData.remToPx = parseFloat(CSS.getPropertyValue(document.body, "fontSize")) || 16; /* GET */
                  }

                  /* Similarly, viewport units are %-relative to the window's inner dimensions. */
                  if (callUnitConversionData.vwToPx === null) {
                    callUnitConversionData.vwToPx = parseFloat(window.innerWidth) / 100; /* GET */
                    callUnitConversionData.vhToPx = parseFloat(window.innerHeight) / 100; /* GET */
                  }

                  unitRatios.remToPx = callUnitConversionData.remToPx;
                  unitRatios.vwToPx = callUnitConversionData.vwToPx;
                  unitRatios.vhToPx = callUnitConversionData.vhToPx;
                  if (Velocity.debug >= 1) {
                    console.log("Unit ratios: " + JSON.stringify(unitRatios), element);
                  }
                  return unitRatios;
                };

                /********************
                 Unit Conversion
                 ********************/

                /* The * and / operators, which are not passed in with an associated unit, inherently use startValue's unit. Skip value and unit conversion. */
                if (/[\/*]/.test(operator)) {
                  endValueUnitType = startValueUnitType;
                  /* If startValue and endValue differ in unit type, convert startValue into the same unit type as endValue so that if endValueUnitType
                   is a relative unit (%, em, rem), the values set during tweening will continue to be accurately relative even if the metrics they depend
                   on are dynamically changing during the course of the animation. Conversely, if we always normalized into px and used px for setting values, the px ratio
                   would become stale if the original unit being animated toward was relative and the underlying metrics change during the animation. */
                  /* Since 0 is 0 in any unit type, no conversion is necessary when startValue is 0 -- we just start at 0 with endValueUnitType. */
                } else if (startValueUnitType !== endValueUnitType && startValue !== 0) {
                  /* Unit conversion is also skipped when endValue is 0, but *startValueUnitType* must be used for tween values to remain accurate. */
                  /* Note: Skipping unit conversion here means that if endValueUnitType was originally a relative unit, the animation won't relatively
                   match the underlying metrics if they change, but this is acceptable since we're animating toward invisibility instead of toward visibility,
                   which remains past the point of the animation's completion. */
                  if (endValue === 0) {
                    endValueUnitType = startValueUnitType;
                  } else {
                    /* By this point, we cannot avoid unit conversion (it's undesirable since it causes layout thrashing).
                     If we haven't already, we trigger calculateUnitRatios(), which runs once per element per call. */
                    elementUnitConversionData = elementUnitConversionData || calculateUnitRatios();

                    /* The following RegEx matches CSS properties that have their % values measured relative to the x-axis. */
                    /* Note: W3C spec mandates that all of margin and padding's properties (even top and bottom) are %-relative to the *width* of the parent element. */
                    var axis = /margin|padding|left|right|width|text|word|letter/i.test(property) || /X$/.test(property) || property === "x" ? "x" : "y";

                    /* In order to avoid generating n^2 bespoke conversion functions, unit conversion is a two-step process:
                     1) Convert startValue into pixels. 2) Convert this new pixel value into endValue's unit type. */
                    switch (startValueUnitType) {
                      case "%":
                        /* Note: translateX and translateY are the only properties that are %-relative to an element's own dimensions -- not its parent's dimensions.
                         Velocity does not include a special conversion process to account for this behavior. Therefore, animating translateX/Y from a % value
                         to a non-% value will produce an incorrect start value. Fortunately, this sort of cross-unit conversion is rarely done by users in practice. */
                        startValue *= axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight;
                        break;
                      case "px":
                        /* px acts as our midpoint in the unit conversion process; do nothing. */
                        break;
                      default:
                        startValue *= elementUnitConversionData[startValueUnitType + "ToPx"];
                    }

                    /* Invert the px ratios to convert into to the target unit. */
                    switch (endValueUnitType) {
                      case "%":
                        startValue *= 1 / (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
                        break;
                      case "px":
                        /* startValue is already in px, do nothing; we're done. */
                        break;
                      default:
                        startValue *= 1 / elementUnitConversionData[endValueUnitType + "ToPx"];
                    }
                  }
                }

                /*********************
                 Relative Values
                 *********************/

                /* Operator logic must be performed last since it requires unit-normalized start and end values. */
                /* Note: Relative *percent values* do not behave how most people think; while one would expect "+=50%"
                 to increase the property 1.5x its current value, it in fact increases the percent units in absolute terms:
                 50 points is added on top of the current % value. */
                switch (operator) {
                  case "+":
                    endValue = startValue + endValue;
                    break;
                  case "-":
                    endValue = startValue - endValue;
                    break;
                  case "*":
                    endValue = startValue * endValue;
                    break;
                  case "/":
                    endValue = startValue / endValue;
                    break;
                }

                /**************************
                 tweensContainer Push
                 **************************/

                /* Construct the per-property tween object, and push it to the element's tweensContainer. */
                tweensContainer[property] = {
                  rootPropertyValue: rootPropertyValue,
                  startValue: startValue,
                  currentValue: startValue,
                  endValue: endValue,
                  unitType: endValueUnitType,
                  easing: easing
                };
                if (pattern) {
                  tweensContainer[property].pattern = pattern;
                }
                if (Velocity.debug) {
                  console.log("tweensContainer (" + property + "): " + JSON.stringify(tweensContainer[property]), element);
                }
              };

              /* Create a tween out of each property, and append its associated data to tweensContainer. */
              for (var property in propertiesMap) {
                if (!propertiesMap.hasOwnProperty(property)) {
                  continue;
                }
                /* The original property name's format must be used for the parsePropertyValue() lookup,
                 but we then use its camelCase styling to normalize it for manipulation. */
                var propertyName = CSS.Names.camelCase(property),
                  valueData = parsePropertyValue(propertiesMap[property]);

                /* Find shorthand color properties that have been passed a hex string. */
                /* Would be quicker to use CSS.Lists.colors.includes() if possible */
                if (_inArray(CSS.Lists.colors, propertyName)) {
                  /* Parse the value data for each shorthand. */
                  var endValue = valueData[0],
                    easing = valueData[1],
                    startValue = valueData[2];
                  if (CSS.RegEx.isHex.test(endValue)) {
                    /* Convert the hex strings into their RGB component arrays. */
                    var colorComponents = ["Red", "Green", "Blue"],
                      endValueRGB = CSS.Values.hexToRgb(endValue),
                      startValueRGB = startValue ? CSS.Values.hexToRgb(startValue) : undefined;

                    /* Inject the RGB component tweens into propertiesMap. */
                    for (var i = 0; i < colorComponents.length; i++) {
                      var dataArray = [endValueRGB[i]];
                      if (easing) {
                        dataArray.push(easing);
                      }
                      if (startValueRGB !== undefined) {
                        dataArray.push(startValueRGB[i]);
                      }
                      fixPropertyValue(propertyName + colorComponents[i], dataArray);
                    }
                    /* If we have replaced a shortcut color value then don't update the standard property name */
                    continue;
                  }
                }
                fixPropertyValue(propertyName, valueData);
              }

              /* Along with its property data, store a reference to the element itself onto tweensContainer. */
              tweensContainer.element = element;
            }

            /*****************
             Call Push
             *****************/

            /* Note: tweensContainer can be empty if all of the properties in this call's property map were skipped due to not
             being supported by the browser. The element property is used for checking that the tweensContainer has been appended to. */
            if (tweensContainer.element) {
              /* Apply the "velocity-animating" indicator class. */
              CSS.Values.addClass(element, "velocity-animating");

              /* The call array houses the tweensContainers for each element being animated in the current call. */
              call.push(tweensContainer);
              data = Data(element);
              if (data) {
                /* Store the tweensContainer and options if we're working on the default effects queue, so that they can be used by the reverse command. */
                if (opts.queue === "") {
                  data.tweensContainer = tweensContainer;
                  data.opts = opts;
                }

                /* Switch on the element's animating flag. */
                data.isAnimating = true;
              }

              /* Once the final element in this call's element set has been processed, push the call array onto
               Velocity.State.calls for the animation tick to immediately begin processing. */
              if (elementsIndex === elementsLength - 1) {
                /* Add the current call plus its associated metadata (the element set and the call's options) onto the global call container.
                 Anything on this call container is subjected to tick() processing. */
                Velocity.State.calls.push([call, elements, opts, null, promiseData.resolver, null, 0]);

                /* If the animation tick isn't running, start it. (Velocity shuts it off when there are no active calls to process.) */
                if (Velocity.State.isTicking === false) {
                  Velocity.State.isTicking = true;

                  /* Start the tick loop. */
                  tick();
                }
              } else {
                elementsIndex++;
              }
            }
          }

          /* When the queue option is set to false, the call skips the element's queue and fires immediately. */
          if (opts.queue === false) {
            /* Since this buildQueue call doesn't respect the element's existing queue (which is where a delay option would have been appended),
             we manually inject the delay property here with an explicit setTimeout. */
            if (opts.delay) {
              /* Temporarily store delayed elements to facilitate access for global pause/resume */
              var callIndex = Velocity.State.delayedElements.count++;
              Velocity.State.delayedElements[callIndex] = element;
              var delayComplete = function (index) {
                return function () {
                  /* Clear the temporary element */
                  Velocity.State.delayedElements[index] = false;

                  /* Finally, issue the call */
                  buildQueue();
                };
              }(callIndex);
              Data(element).delayBegin = new Date().getTime();
              Data(element).delay = parseFloat(opts.delay);
              Data(element).delayTimer = {
                setTimeout: setTimeout(buildQueue, parseFloat(opts.delay)),
                next: delayComplete
              };
            } else {
              buildQueue();
            }
            /* Otherwise, the call undergoes element queueing as normal. */
            /* Note: To interoperate with jQuery, Velocity uses jQuery's own $.queue() stack for queuing logic. */
          } else {
            $.queue(element, opts.queue, function (next, clearQueue) {
              /* If the clearQueue flag was passed in by the stop command, resolve this call's promise. (Promises can only be resolved once,
               so it's fine if this is repeatedly triggered for each element in the associated call.) */
              if (clearQueue === true) {
                if (promiseData.promise) {
                  promiseData.resolver(elements);
                }

                /* Do not continue with animation queueing. */
                return true;
              }

              /* This flag indicates to the upcoming completeCall() function that this queue entry was initiated by Velocity.
               See completeCall() for further details. */
              Velocity.velocityQueueEntryFlag = true;
              buildQueue(next);
            });
          }

          /*********************
           Auto-Dequeuing
           *********************/

          /* As per jQuery's $.queue() behavior, to fire the first non-custom-queue entry on an element, the element
           must be dequeued if its queue stack consists *solely* of the current call. (This can be determined by checking
           for the "inprogress" item that jQuery prepends to active queue stack arrays.) Regardless, whenever the element's
           queue is further appended with additional items -- including $.delay()'s or even $.animate() calls, the queue's
           first entry is automatically fired. This behavior contrasts that of custom queues, which never auto-fire. */
          /* Note: When an element set is being subjected to a non-parallel Velocity call, the animation will not begin until
           each one of the elements in the set has reached the end of its individually pre-existing queue chain. */
          /* Note: Unfortunately, most people don't fully grasp jQuery's powerful, yet quirky, $.queue() function.
           Lean more here: http://stackoverflow.com/questions/1058158/can-somebody-explain-jquery-queue-to-me */
          if ((opts.queue === "" || opts.queue === "fx") && $.queue(element)[0] !== "inprogress") {
            $.dequeue(element);
          }
        }

        /**************************
         Element Set Iteration
         **************************/

        /* If the "nodeType" property exists on the elements variable, we're animating a single element.
         Place it in an array so that $.each() can iterate over it. */
        $.each(elements, function (i, element) {
          /* Ensure each element in a set has a nodeType (is a real element) to avoid throwing errors. */
          if (Type.isNode(element)) {
            processElement(element, i);
          }
        });

        /******************
         Option: Loop
         ******************/

        /* The loop option accepts an integer indicating how many times the element should loop between the values in the
         current call's properties map and the element's property values prior to this call. */
        /* Note: The loop option's logic is performed here -- after element processing -- because the current call needs
         to undergo its queue insertion prior to the loop option generating its series of constituent "reverse" calls,
         which chain after the current call. Two reverse calls (two "alternations") constitute one loop. */
        opts = $.extend({}, Velocity.defaults, options);
        opts.loop = parseInt(opts.loop, 10);
        var reverseCallsCount = opts.loop * 2 - 1;
        if (opts.loop) {
          /* Double the loop count to convert it into its appropriate number of "reverse" calls.
           Subtract 1 from the resulting value since the current call is included in the total alternation count. */
          for (var x = 0; x < reverseCallsCount; x++) {
            /* Since the logic for the reverse action occurs inside Queueing and therefore this call's options object
             isn't parsed until then as well, the current call's delay option must be explicitly passed into the reverse
             call so that the delay logic that occurs inside *Pre-Queueing* can process it. */
            var reverseOptions = {
              delay: opts.delay,
              progress: opts.progress
            };

            /* If a complete callback was passed into this call, transfer it to the loop redirect's final "reverse" call
             so that it's triggered when the entire redirect is complete (and not when the very first animation is complete). */
            if (x === reverseCallsCount - 1) {
              reverseOptions.display = opts.display;
              reverseOptions.visibility = opts.visibility;
              reverseOptions.complete = opts.complete;
            }
            animate(elements, "reverse", reverseOptions);
          }
        }

        /***************
         Chaining
         ***************/

        /* Return the elements back to the call chain, with wrapped elements taking precedence in case Velocity was called via the $.fn. extension. */
        return getChain();
      };

      /* Turn Velocity into the animation function, extended with the pre-existing Velocity object. */
      Velocity = $.extend(animate, Velocity);
      /* For legacy support, also expose the literal animate method. */
      Velocity.animate = animate;

      /**************
       Timing
       **************/

      /* Ticker function. */
      var ticker = window.requestAnimationFrame || rAFShim;

      /* Inactive browser tabs pause rAF, which results in all active animations immediately sprinting to their completion states when the tab refocuses.
       To get around this, we dynamically switch rAF to setTimeout (which the browser *doesn't* pause) when the tab loses focus. We skip this for mobile
       devices to avoid wasting battery power on inactive tabs. */
      /* Note: Tab focus detection doesn't work on older versions of IE, but that's okay since they don't support rAF to begin with. */
      if (!Velocity.State.isMobile && document.hidden !== undefined) {
        var updateTicker = function () {
          /* Reassign the rAF function (which the global tick() function uses) based on the tab's focus state. */
          if (document.hidden) {
            ticker = function (callback) {
              /* The tick function needs a truthy first argument in order to pass its internal timestamp check. */
              return setTimeout(function () {
                callback(true);
              }, 16);
            };

            /* The rAF loop has been paused by the browser, so we manually restart the tick. */
            tick();
          } else {
            ticker = window.requestAnimationFrame || rAFShim;
          }
        };

        /* Page could be sitting in the background at this time (i.e. opened as new tab) so making sure we use correct ticker from the start */
        updateTicker();

        /* And then run check again every time visibility changes */
        document.addEventListener("visibilitychange", updateTicker);
      }

      /************
       Tick
       ************/

      /* Note: All calls to Velocity are pushed to the Velocity.State.calls array, which is fully iterated through upon each tick. */
      function tick(timestamp) {
        /* An empty timestamp argument indicates that this is the first tick occurence since ticking was turned on.
         We leverage this metadata to fully ignore the first tick pass since RAF's initial pass is fired whenever
         the browser's next tick sync time occurs, which results in the first elements subjected to Velocity
         calls being animated out of sync with any elements animated immediately thereafter. In short, we ignore
         the first RAF tick pass so that elements being immediately consecutively animated -- instead of simultaneously animated
         by the same Velocity call -- are properly batched into the same initial RAF tick and consequently remain in sync thereafter. */
        if (timestamp) {
          /* We normally use RAF's high resolution timestamp but as it can be significantly offset when the browser is
           under high stress we give the option for choppiness over allowing the browser to drop huge chunks of frames.
           We use performance.now() and shim it if it doesn't exist for when the tab is hidden. */
          var timeCurrent = Velocity.timestamp && timestamp !== true ? timestamp : performance.now();

          /********************
           Call Iteration
           ********************/

          var callsLength = Velocity.State.calls.length;

          /* To speed up iterating over this array, it is compacted (falsey items -- calls that have completed -- are removed)
           when its length has ballooned to a point that can impact tick performance. This only becomes necessary when animation
           has been continuous with many elements over a long period of time; whenever all active calls are completed, completeCall() clears Velocity.State.calls. */
          if (callsLength > 10000) {
            Velocity.State.calls = compactSparseArray(Velocity.State.calls);
            callsLength = Velocity.State.calls.length;
          }

          /* Iterate through each active call. */
          for (var i = 0; i < callsLength; i++) {
            /* When a Velocity call is completed, its Velocity.State.calls entry is set to false. Continue on to the next call. */
            if (!Velocity.State.calls[i]) {
              continue;
            }

            /************************
             Call-Wide Variables
             ************************/

            var callContainer = Velocity.State.calls[i],
              call = callContainer[0],
              opts = callContainer[2],
              timeStart = callContainer[3],
              firstTick = !timeStart,
              tweenDummyValue = null,
              pauseObject = callContainer[5],
              millisecondsEllapsed = callContainer[6];

            /* If timeStart is undefined, then this is the first time that this call has been processed by tick().
             We assign timeStart now so that its value is as close to the real animation start time as possible.
             (Conversely, had timeStart been defined when this call was added to Velocity.State.calls, the delay
             between that time and now would cause the first few frames of the tween to be skipped since
             percentComplete is calculated relative to timeStart.) */
            /* Further, subtract 16ms (the approximate resolution of RAF) from the current time value so that the
             first tick iteration isn't wasted by animating at 0% tween completion, which would produce the
             same style value as the element's current value. */
            if (!timeStart) {
              timeStart = Velocity.State.calls[i][3] = timeCurrent - 16;
            }

            /* If a pause object is present, skip processing unless it has been set to resume */
            if (pauseObject) {
              if (pauseObject.resume === true) {
                /* Update the time start to accomodate the paused completion amount */
                timeStart = callContainer[3] = Math.round(timeCurrent - millisecondsEllapsed - 16);

                /* Remove pause object after processing */
                callContainer[5] = null;
              } else {
                continue;
              }
            }
            millisecondsEllapsed = callContainer[6] = timeCurrent - timeStart;

            /* The tween's completion percentage is relative to the tween's start time, not the tween's start value
             (which would result in unpredictable tween durations since JavaScript's timers are not particularly accurate).
             Accordingly, we ensure that percentComplete does not exceed 1. */
            var percentComplete = Math.min(millisecondsEllapsed / opts.duration, 1);

            /**********************
             Element Iteration
             **********************/

            /* For every call, iterate through each of the elements in its set. */
            for (var j = 0, callLength = call.length; j < callLength; j++) {
              var tweensContainer = call[j],
                element = tweensContainer.element;

              /* Check to see if this element has been deleted midway through the animation by checking for the
               continued existence of its data cache. If it's gone, or the element is currently paused, skip animating this element. */
              if (!Data(element)) {
                continue;
              }
              var transformPropertyExists = false;

              /**********************************
               Display & Visibility Toggling
               **********************************/

              /* If the display option is set to non-"none", set it upfront so that the element can become visible before tweening begins.
               (Otherwise, display's "none" value is set in completeCall() once the animation has completed.) */
              if (opts.display !== undefined && opts.display !== null && opts.display !== "none") {
                if (opts.display === "flex") {
                  var flexValues = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];
                  $.each(flexValues, function (i, flexValue) {
                    CSS.setPropertyValue(element, "display", flexValue);
                  });
                }
                CSS.setPropertyValue(element, "display", opts.display);
              }

              /* Same goes with the visibility option, but its "none" equivalent is "hidden". */
              if (opts.visibility !== undefined && opts.visibility !== "hidden") {
                CSS.setPropertyValue(element, "visibility", opts.visibility);
              }

              /************************
               Property Iteration
               ************************/

              /* For every element, iterate through each property. */
              for (var property in tweensContainer) {
                /* Note: In addition to property tween data, tweensContainer contains a reference to its associated element. */
                if (tweensContainer.hasOwnProperty(property) && property !== "element") {
                  var tween = tweensContainer[property],
                    currentValue,
                    /* Easing can either be a pre-genereated function or a string that references a pre-registered easing
                     on the Velocity.Easings object. In either case, return the appropriate easing *function*. */
                    easing = Type.isString(tween.easing) ? Velocity.Easings[tween.easing] : tween.easing;

                  /******************************
                   Current Value Calculation
                   ******************************/

                  if (Type.isString(tween.pattern)) {
                    var patternReplace = percentComplete === 1 ? function ($0, index, round) {
                      var result = tween.endValue[index];
                      return round ? Math.round(result) : result;
                    } : function ($0, index, round) {
                      var startValue = tween.startValue[index],
                        tweenDelta = tween.endValue[index] - startValue,
                        result = startValue + tweenDelta * easing(percentComplete, opts, tweenDelta);
                      return round ? Math.round(result) : result;
                    };
                    currentValue = tween.pattern.replace(/{(\d+)(!)?}/g, patternReplace);
                  } else if (percentComplete === 1) {
                    /* If this is the last tick pass (if we've reached 100% completion for this tween),
                     ensure that currentValue is explicitly set to its target endValue so that it's not subjected to any rounding. */
                    currentValue = tween.endValue;
                  } else {
                    /* Otherwise, calculate currentValue based on the current delta from startValue. */
                    var tweenDelta = tween.endValue - tween.startValue;
                    currentValue = tween.startValue + tweenDelta * easing(percentComplete, opts, tweenDelta);
                    /* If no value change is occurring, don't proceed with DOM updating. */
                  }

                  if (!firstTick && currentValue === tween.currentValue) {
                    continue;
                  }
                  tween.currentValue = currentValue;

                  /* If we're tweening a fake 'tween' property in order to log transition values, update the one-per-call variable so that
                   it can be passed into the progress callback. */
                  if (property === "tween") {
                    tweenDummyValue = currentValue;
                  } else {
                    /******************
                     Hooks: Part I
                     ******************/
                    var hookRoot;

                    /* For hooked properties, the newly-updated rootPropertyValueCache is cached onto the element so that it can be used
                     for subsequent hooks in this call that are associated with the same root property. If we didn't cache the updated
                     rootPropertyValue, each subsequent update to the root property in this tick pass would reset the previous hook's
                     updates to rootPropertyValue prior to injection. A nice performance byproduct of rootPropertyValue caching is that
                     subsequently chained animations using the same hookRoot but a different hook can use this cached rootPropertyValue. */
                    if (CSS.Hooks.registered[property]) {
                      hookRoot = CSS.Hooks.getRoot(property);
                      var rootPropertyValueCache = Data(element).rootPropertyValueCache[hookRoot];
                      if (rootPropertyValueCache) {
                        tween.rootPropertyValue = rootPropertyValueCache;
                      }
                    }

                    /*****************
                     DOM Update
                     *****************/

                    /* setPropertyValue() returns an array of the property name and property value post any normalization that may have been performed. */
                    /* Note: To solve an IE<=8 positioning bug, the unit type is dropped when setting a property value of 0. */
                    var adjustedSetData = CSS.setPropertyValue(element, /* SET */
                    property, tween.currentValue + (IE < 9 && parseFloat(currentValue) === 0 ? "" : tween.unitType), tween.rootPropertyValue, tween.scrollData);

                    /*******************
                     Hooks: Part II
                     *******************/

                    /* Now that we have the hook's updated rootPropertyValue (the post-processed value provided by adjustedSetData), cache it onto the element. */
                    if (CSS.Hooks.registered[property]) {
                      /* Since adjustedSetData contains normalized data ready for DOM updating, the rootPropertyValue needs to be re-extracted from its normalized form. ?? */
                      if (CSS.Normalizations.registered[hookRoot]) {
                        Data(element).rootPropertyValueCache[hookRoot] = CSS.Normalizations.registered[hookRoot]("extract", null, adjustedSetData[1]);
                      } else {
                        Data(element).rootPropertyValueCache[hookRoot] = adjustedSetData[1];
                      }
                    }

                    /***************
                     Transforms
                     ***************/

                    /* Flag whether a transform property is being animated so that flushTransformCache() can be triggered once this tick pass is complete. */
                    if (adjustedSetData[0] === "transform") {
                      transformPropertyExists = true;
                    }
                  }
                }
              }

              /****************
               mobileHA
               ****************/

              /* If mobileHA is enabled, set the translate3d transform to null to force hardware acceleration.
               It's safe to override this property since Velocity doesn't actually support its animation (hooks are used in its place). */
              if (opts.mobileHA) {
                /* Don't set the null transform hack if we've already done so. */
                if (Data(element).transformCache.translate3d === undefined) {
                  /* All entries on the transformCache object are later concatenated into a single transform string via flushTransformCache(). */
                  Data(element).transformCache.translate3d = "(0px, 0px, 0px)";
                  transformPropertyExists = true;
                }
              }
              if (transformPropertyExists) {
                CSS.flushTransformCache(element);
              }
            }

            /* The non-"none" display value is only applied to an element once -- when its associated call is first ticked through.
             Accordingly, it's set to false so that it isn't re-processed by this call in the next tick. */
            if (opts.display !== undefined && opts.display !== "none") {
              Velocity.State.calls[i][2].display = false;
            }
            if (opts.visibility !== undefined && opts.visibility !== "hidden") {
              Velocity.State.calls[i][2].visibility = false;
            }

            /* Pass the elements and the timing data (percentComplete, msRemaining, timeStart, tweenDummyValue) into the progress callback. */
            if (opts.progress) {
              opts.progress.call(callContainer[1], callContainer[1], percentComplete, Math.max(0, timeStart + opts.duration - timeCurrent), timeStart, tweenDummyValue);
            }

            /* If this call has finished tweening, pass its index to completeCall() to handle call cleanup. */
            if (percentComplete === 1) {
              completeCall(i);
            }
          }
        }

        /* Note: completeCall() sets the isTicking flag to false when the last call on Velocity.State.calls has completed. */
        if (Velocity.State.isTicking) {
          ticker(tick);
        }
      }

      /**********************
       Call Completion
       **********************/

      /* Note: Unlike tick(), which processes all active calls at once, call completion is handled on a per-call basis. */
      function completeCall(callIndex, isStopped) {
        /* Ensure the call exists. */
        if (!Velocity.State.calls[callIndex]) {
          return false;
        }

        /* Pull the metadata from the call. */
        var call = Velocity.State.calls[callIndex][0],
          elements = Velocity.State.calls[callIndex][1],
          opts = Velocity.State.calls[callIndex][2],
          resolver = Velocity.State.calls[callIndex][4];
        var remainingCallsExist = false;

        /*************************
         Element Finalization
         *************************/

        for (var i = 0, callLength = call.length; i < callLength; i++) {
          var element = call[i].element;

          /* If the user set display to "none" (intending to hide the element), set it now that the animation has completed. */
          /* Note: display:none isn't set when calls are manually stopped (via Velocity("stop"). */
          /* Note: Display gets ignored with "reverse" calls and infinite loops, since this behavior would be undesirable. */
          if (!isStopped && !opts.loop) {
            if (opts.display === "none") {
              CSS.setPropertyValue(element, "display", opts.display);
            }
            if (opts.visibility === "hidden") {
              CSS.setPropertyValue(element, "visibility", opts.visibility);
            }
          }

          /* If the element's queue is empty (if only the "inprogress" item is left at position 0) or if its queue is about to run
           a non-Velocity-initiated entry, turn off the isAnimating flag. A non-Velocity-initiatied queue entry's logic might alter
           an element's CSS values and thereby cause Velocity's cached value data to go stale. To detect if a queue entry was initiated by Velocity,
           we check for the existence of our special Velocity.queueEntryFlag declaration, which minifiers won't rename since the flag
           is assigned to jQuery's global $ object and thus exists out of Velocity's own scope. */
          var data = Data(element);
          if (opts.loop !== true && ($.queue(element)[1] === undefined || !/\.velocityQueueEntryFlag/i.test($.queue(element)[1]))) {
            /* The element may have been deleted. Ensure that its data cache still exists before acting on it. */
            if (data) {
              data.isAnimating = false;
              /* Clear the element's rootPropertyValueCache, which will become stale. */
              data.rootPropertyValueCache = {};
              var transformHAPropertyExists = false;
              /* If any 3D transform subproperty is at its default value (regardless of unit type), remove it. */
              $.each(CSS.Lists.transforms3D, function (i, transformName) {
                var defaultValue = /^scale/.test(transformName) ? 1 : 0,
                  currentValue = data.transformCache[transformName];
                if (data.transformCache[transformName] !== undefined && new RegExp("^\\(" + defaultValue + "[^.]").test(currentValue)) {
                  transformHAPropertyExists = true;
                  delete data.transformCache[transformName];
                }
              });

              /* Mobile devices have hardware acceleration removed at the end of the animation in order to avoid hogging the GPU's memory. */
              if (opts.mobileHA) {
                transformHAPropertyExists = true;
                delete data.transformCache.translate3d;
              }

              /* Flush the subproperty removals to the DOM. */
              if (transformHAPropertyExists) {
                CSS.flushTransformCache(element);
              }

              /* Remove the "velocity-animating" indicator class. */
              CSS.Values.removeClass(element, "velocity-animating");
            }
          }

          /*********************
           Option: Complete
           *********************/

          /* Complete is fired once per call (not once per element) and is passed the full raw DOM element set as both its context and its first argument. */
          /* Note: Callbacks aren't fired when calls are manually stopped (via Velocity("stop"). */
          if (!isStopped && opts.complete && !opts.loop && i === callLength - 1) {
            /* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
            try {
              opts.complete.call(elements, elements);
            } catch (error) {
              setTimeout(function () {
                throw error;
              }, 1);
            }
          }

          /**********************
           Promise Resolving
           **********************/

          /* Note: Infinite loops don't return promises. */
          if (resolver && opts.loop !== true) {
            resolver(elements);
          }

          /****************************
           Option: Loop (Infinite)
           ****************************/

          if (data && opts.loop === true && !isStopped) {
            /* If a rotateX/Y/Z property is being animated by 360 deg with loop:true, swap tween start/end values to enable
             continuous iterative rotation looping. (Otherise, the element would just rotate back and forth.) */
            $.each(data.tweensContainer, function (propertyName, tweenContainer) {
              if (/^rotate/.test(propertyName) && (parseFloat(tweenContainer.startValue) - parseFloat(tweenContainer.endValue)) % 360 === 0) {
                var oldStartValue = tweenContainer.startValue;
                tweenContainer.startValue = tweenContainer.endValue;
                tweenContainer.endValue = oldStartValue;
              }
              if (/^backgroundPosition/.test(propertyName) && parseFloat(tweenContainer.endValue) === 100 && tweenContainer.unitType === "%") {
                tweenContainer.endValue = 0;
                tweenContainer.startValue = 100;
              }
            });
            Velocity(element, "reverse", {
              loop: true,
              delay: opts.delay
            });
          }

          /***************
           Dequeueing
           ***************/

          /* Fire the next call in the queue so long as this call's queue wasn't set to false (to trigger a parallel animation),
           which would have already caused the next call to fire. Note: Even if the end of the animation queue has been reached,
           $.dequeue() must still be called in order to completely clear jQuery's animation queue. */
          if (opts.queue !== false) {
            $.dequeue(element, opts.queue);
          }
        }

        /************************
         Calls Array Cleanup
         ************************/

        /* Since this call is complete, set it to false so that the rAF tick skips it. This array is later compacted via compactSparseArray().
         (For performance reasons, the call is set to false instead of being deleted from the array: http://www.html5rocks.com/en/tutorials/speed/v8/) */
        Velocity.State.calls[callIndex] = false;

        /* Iterate through the calls array to determine if this was the final in-progress animation.
         If so, set a flag to end ticking and clear the calls array. */
        for (var j = 0, callsLength = Velocity.State.calls.length; j < callsLength; j++) {
          if (Velocity.State.calls[j] !== false) {
            remainingCallsExist = true;
            break;
          }
        }
        if (remainingCallsExist === false) {
          /* tick() will detect this flag upon its next iteration and subsequently turn itself off. */
          Velocity.State.isTicking = false;

          /* Clear the calls array so that its length is reset. */
          delete Velocity.State.calls;
          Velocity.State.calls = [];
        }
      }

      /******************
       Frameworks
       ******************/

      /* Both jQuery and Zepto allow their $.fn object to be extended to allow wrapped elements to be subjected to plugin calls.
       If either framework is loaded, register a "velocity" extension pointing to Velocity's core animate() method.  Velocity
       also registers itself onto a global container (window.jQuery || window.Zepto || window) so that certain features are
       accessible beyond just a per-element scope. This master object contains an .animate() method, which is later assigned to $.fn
       (if jQuery or Zepto are present). Accordingly, Velocity can both act on wrapped DOM elements and stand alone for targeting raw DOM elements. */
      global.Velocity = Velocity;
      if (global !== window) {
        /* Assign the element function to Velocity's core animate() method. */
        global.fn.velocity = animate;
        /* Assign the object function's defaults to Velocity's global defaults object. */
        global.fn.velocity.defaults = Velocity.defaults;
      }

      /***********************
       Packaged Redirects
       ***********************/

      /* slideUp, slideDown */
      $.each(["Down", "Up"], function (i, direction) {
        Velocity.Redirects["slide" + direction] = function (element, options, elementsIndex, elementsSize, elements, promiseData) {
          var opts = $.extend({}, options),
            begin = opts.begin,
            complete = opts.complete,
            inlineValues = {},
            computedValues = {
              height: "",
              marginTop: "",
              marginBottom: "",
              paddingTop: "",
              paddingBottom: ""
            };
          if (opts.display === undefined) {
            /* Show the element before slideDown begins and hide the element after slideUp completes. */
            /* Note: Inline elements cannot have dimensions animated, so they're reverted to inline-block. */
            opts.display = direction === "Down" ? Velocity.CSS.Values.getDisplayType(element) === "inline" ? "inline-block" : "block" : "none";
          }
          opts.begin = function () {
            /* If the user passed in a begin callback, fire it now. */
            if (elementsIndex === 0 && begin) {
              begin.call(elements, elements);
            }

            /* Cache the elements' original vertical dimensional property values so that we can animate back to them. */
            for (var property in computedValues) {
              if (!computedValues.hasOwnProperty(property)) {
                continue;
              }
              inlineValues[property] = element.style[property];

              /* For slideDown, use forcefeeding to animate all vertical properties from 0. For slideUp,
               use forcefeeding to start from computed values and animate down to 0. */
              var propertyValue = CSS.getPropertyValue(element, property);
              computedValues[property] = direction === "Down" ? [propertyValue, 0] : [0, propertyValue];
            }

            /* Force vertical overflow content to clip so that sliding works as expected. */
            inlineValues.overflow = element.style.overflow;
            element.style.overflow = "hidden";
          };
          opts.complete = function () {
            /* Reset element to its pre-slide inline values once its slide animation is complete. */
            for (var property in inlineValues) {
              if (inlineValues.hasOwnProperty(property)) {
                element.style[property] = inlineValues[property];
              }
            }

            /* If the user passed in a complete callback, fire it now. */
            if (elementsIndex === elementsSize - 1) {
              if (complete) {
                complete.call(elements, elements);
              }
              if (promiseData) {
                promiseData.resolver(elements);
              }
            }
          };
          Velocity(element, computedValues, opts);
        };
      });

      /* fadeIn, fadeOut */
      $.each(["In", "Out"], function (i, direction) {
        Velocity.Redirects["fade" + direction] = function (element, options, elementsIndex, elementsSize, elements, promiseData) {
          var opts = $.extend({}, options),
            complete = opts.complete,
            propertiesMap = {
              opacity: direction === "In" ? 1 : 0
            };

          /* Since redirects are triggered individually for each element in the animated set, avoid repeatedly triggering
           callbacks by firing them only when the final element has been reached. */
          if (elementsIndex !== 0) {
            opts.begin = null;
          }
          if (elementsIndex !== elementsSize - 1) {
            opts.complete = null;
          } else {
            opts.complete = function () {
              if (complete) {
                complete.call(elements, elements);
              }
              if (promiseData) {
                promiseData.resolver(elements);
              }
            };
          }

          /* If a display was passed in, use it. Otherwise, default to "none" for fadeOut or the element-specific default for fadeIn. */
          /* Note: We allow users to pass in "null" to skip display setting altogether. */
          if (opts.display === undefined) {
            opts.display = direction === "In" ? "auto" : "none";
          }
          Velocity(this, propertiesMap, opts);
        };
      });
      return Velocity;
    }(window.jQuery || window.Zepto || window, window, window ? window.document : undefined);
  });

  /******************
   Known Issues
   ******************/

  /* The CSS spec mandates that the translateX/Y/Z transforms are %-relative to the element itself -- not its parent.
   Velocity, however, doesn't make this distinction. Thus, converting to or from the % unit with these subproperties
   will produce an inaccurate conversion value. The same issue exists with the cx/cy attributes of SVG circles and ellipses. */

  /***/
}, /* 240 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.ITEM_PROPS = void 0;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var DISMISS_TIME = 2500,
    NOTIFICATION_ITEM_PROPS = {
      id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
      formatter: _propTypes["default"].func,
      visible: _propTypes["default"].bool,
      dismissIn: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
      isDismissed: _propTypes["default"].bool,
      message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
      messageHeader: _propTypes["default"].string,
      moreDetails: _propTypes["default"].string,
      moreDetailsMessage: _propTypes["default"].string,
      type: _propTypes["default"].oneOf(["info", "success", "warning", "error"])
    },
    ICON_TYPES = {
      info: "error",
      success: "success",
      warning: "errorT",
      error: "errorT"
    };
  var NotificationItem = (_class = (_class2 = /*#__PURE__*/function (_Component) {
    _inherits(NotificationItem, _Component);
    var _super = _createSuper(NotificationItem);
    function NotificationItem(props, context) {
      var _this;
      _classCallCheck(this, NotificationItem);
      _this = _super.call(this, props, context);
      _defineProperty(_assertThisInitialized(_this), "_dismissTimeout", null);
      _this.state = {
        visible: props.visible,
        showDetails: false
      };
      return _this;
    }
    _createClass(NotificationItem, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var dismissIn = this.props.dismissIn;
        if (typeof dismissIn === "number" && !!dismissIn) {
          //if dismissIn is a number greater than 0
          this.resetRemovalTimer();
        }
      }
    }, {
      key: "closeNotification",
      value: function closeNotification() {
        this.pauseRemoval();
        this.props.onExit(this.props);
      }
    }, {
      key: "resetRemovalTimer",
      value: function resetRemovalTimer() {
        var _this2 = this;
        this._dismissTimeout = setTimeout(function () {
          _this2.props.onExit(_this2.props);
        }, this.props.dismissIn);
      }
    }, {
      key: "pauseRemoval",
      value: function pauseRemoval() {
        clearTimeout(this._dismissTimeout);
      }
    }, {
      key: "startRemoval",
      value: function startRemoval() {
        this.resetRemovalTimer();
      }
    }, {
      key: "_renderDetails",
      value: function _renderDetails(moreDetails) {
        var details = null;
        if (moreDetails && this.state.showDetails) {
          details = /*#__PURE__*/_react["default"].createElement("div", {
            className: "notification-details"
          }, moreDetails);
        }
        return details;
      }
    }, {
      key: "_renderDetailsLink",
      value: function _renderDetailsLink(moreDetails) {
        var toggle = null;
        if (moreDetails && moreDetails.length) {
          toggle = /*#__PURE__*/_react["default"].createElement("button", {
            className: "c-button c-button-medium notification-details-link",
            onClick: this.toggleShowDetails
          }, this.props.moreDetailsMessage);
        }
        return toggle;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          dismissIn = _this$props.dismissIn,
          type = _this$props.type,
          message = _this$props.message,
          formatter = _this$props.formatter,
          messageHeader = _this$props.messageHeader,
          itemProps = {
            className: (0, _classnames["default"])(_defineProperty({
              "growl-notification": true
            }, "notification-".concat(type), true))
          };
        var body = message;
        if (typeof formatter === 'function') {
          body = formatter();
        }

        // Only add the mouseover un/pause for messages we can remove
        if (!isNaN(dismissIn)) {
          itemProps.onMouseEnter = this.pauseRemoval;
          itemProps.onMouseLeave = this.startRemoval;
        }
        return /*#__PURE__*/_react["default"].createElement("div", itemProps, /*#__PURE__*/_react["default"].createElement("div", {
          className: "notification-body flex-center"
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          name: ICON_TYPES[type],
          "aria-hidden": "true",
          className: "notification-icon"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "info-side"
        }, /*#__PURE__*/_react["default"].createElement("h5", {
          className: "header"
        }, messageHeader), /*#__PURE__*/_react["default"].createElement("div", {
          className: "message"
        }, body)), /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          title: "Dismiss Alert",
          onClick: this.closeNotification,
          className: "c-button--close dismiss-notification"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fa fa-times ft-ic",
          "aria-hidden": "true"
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: "is-hidden"
        }, "Close"))));
      }
    }]);
    return NotificationItem;
  }(_react.Component), _defineProperty(_class2, "defaultProps", {
    id: null,
    formatter: null,
    dismissIn: DISMISS_TIME,
    //auto-dismiss in x ms
    type: "info",
    message: "",
    messageHeader: " ",
    moreDetails: null,
    moreDetailsMessage: "More Info",
    onExit: function onExit() {}
  }), _defineProperty(_class2, "propTypes", NOTIFICATION_ITEM_PROPS), _class2), (_applyDecoratedDescriptor(_class.prototype, "closeNotification", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "closeNotification"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetRemovalTimer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "resetRemovalTimer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pauseRemoval", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "pauseRemoval"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startRemoval", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "startRemoval"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderDetails", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderDetailsLink", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderDetailsLink"), _class.prototype)), _class);
  exports["default"] = NotificationItem;
  var ITEM_PROPS = NOTIFICATION_ITEM_PROPS;
  exports.ITEM_PROPS = ITEM_PROPS;

  /***/
}, /* 241 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // ESM COMPAT FLAG
  __webpack_require__.r(__webpack_exports__);

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "CalendarContainer", function () {
    return (/* binding */CalendarContainer
    );
  });

  // EXTERNAL MODULE: external "react"
  var external_react_ = __webpack_require__(1);
  var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

  // EXTERNAL MODULE: external "prop-types"
  var external_prop_types_ = __webpack_require__(0);
  var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

  // EXTERNAL MODULE: ./node_modules/classnames/index.js
  var classnames = __webpack_require__(6);
  var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

  // EXTERNAL MODULE: external "react-dom"
  var external_react_dom_ = __webpack_require__(15);

  // CONCATENATED MODULE: ./node_modules/react-onclickoutside/dist/react-onclickoutside.es.js
  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  } /**
    * Check whether some DOM node is our Component's node.
    */
  function isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) {
      return true;
    } // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17

    if (current.correspondingElement) {
      return current.correspondingElement.classList.contains(ignoreClass);
    }
    return current.classList.contains(ignoreClass);
  }
  /**
   * Try to find our node in a hierarchy of nodes, returning the document
   * node as highest node if our node is not found in the path up.
   */

  function findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) {
      return true;
    } // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host

    while (current.parentNode || current.host) {
      // Only check normal node without shadowRoot
      if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
        return true;
      }
      current = current.parentNode || current.host;
    }
    return current;
  }
  /**
   * Check if the browser scrollbar was clicked
   */

  function clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
  } // ideally will get replaced with external dep
  // when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
  var testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
      return;
    }
    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passive = true;
      }
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
  };
  function autoInc(seed) {
    if (seed === void 0) {
      seed = 0;
    }
    return function () {
      return ++seed;
    };
  }
  var uid = autoInc();
  var passiveEventSupport;
  var handlersMap = {};
  var enabledInstances = {};
  var touchEvents = ['touchstart', 'touchmove'];
  var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
  /**
   * Options for addEventHandler and removeEventHandler
   */

  function getEventHandlerOptions(instance, eventName) {
    var handlerOptions = null;
    var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && passiveEventSupport) {
      handlerOptions = {
        passive: !instance.props.preventDefault
      };
    }
    return handlerOptions;
  }
  /**
   * This function generates the HOC function that you'll use
   * in order to impart onOutsideClick listening to an
   * arbitrary component. It gets called at the end of the
   * bootstrapping code to yield an instance of the
   * onClickOutsideHOC function defined inside setupHOC().
   */

  function onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/function (_Component) {
      _inheritsLoose(onClickOutside, _Component);
      function onClickOutside(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.__outsideClickHandler = function (event) {
          if (typeof _this.__clickOutsideHandlerProp === 'function') {
            _this.__clickOutsideHandlerProp(event);
            return;
          }
          var instance = _this.getInstance();
          if (typeof instance.props.handleClickOutside === 'function') {
            instance.props.handleClickOutside(event);
            return;
          }
          if (typeof instance.handleClickOutside === 'function') {
            instance.handleClickOutside(event);
            return;
          }
          throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
        };
        _this.__getComponentNode = function () {
          var instance = _this.getInstance();
          if (config && typeof config.setClickOutsideRef === 'function') {
            return config.setClickOutsideRef()(instance);
          }
          if (typeof instance.setClickOutsideRef === 'function') {
            return instance.setClickOutsideRef();
          }
          return Object(external_react_dom_["findDOMNode"])(instance);
        };
        _this.enableOnClickOutside = function () {
          if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
            return;
          }
          if (typeof passiveEventSupport === 'undefined') {
            passiveEventSupport = testPassiveEventSupport();
          }
          enabledInstances[_this._uid] = true;
          var events = _this.props.eventTypes;
          if (!events.forEach) {
            events = [events];
          }
          handlersMap[_this._uid] = function (event) {
            if (_this.componentNode === null) return;
            if (_this.props.preventDefault) {
              event.preventDefault();
            }
            if (_this.props.stopPropagation) {
              event.stopPropagation();
            }
            if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
            var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
            if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
              return;
            }
            _this.__outsideClickHandler(event);
          };
          events.forEach(function (eventName) {
            document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
        };
        _this.disableOnClickOutside = function () {
          delete enabledInstances[_this._uid];
          var fn = handlersMap[_this._uid];
          if (fn && typeof document !== 'undefined') {
            var events = _this.props.eventTypes;
            if (!events.forEach) {
              events = [events];
            }
            events.forEach(function (eventName) {
              return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
            });
            delete handlersMap[_this._uid];
          }
        };
        _this.getRef = function (ref) {
          return _this.instanceRef = ref;
        };
        _this._uid = uid();
        return _this;
      }
      /**
       * Access the WrappedComponent's instance.
       */

      var _proto = onClickOutside.prototype;
      _proto.getInstance = function getInstance() {
        if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
          return this;
        }
        var ref = this.instanceRef;
        return ref.getInstance ? ref.getInstance() : ref;
      };

      /**
       * Add click listeners to the current document,
       * linked to this component's state.
       */
      _proto.componentDidMount = function componentDidMount() {
        // If we are in an environment without a DOM such
        // as shallow rendering or snapshots then we exit
        // early to prevent any unhandled errors being thrown.
        if (typeof document === 'undefined' || !document.createElement) {
          return;
        }
        var instance = this.getInstance();
        if (config && typeof config.handleClickOutside === 'function') {
          this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
          if (typeof this.__clickOutsideHandlerProp !== 'function') {
            throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
          }
        }
        this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

        if (this.props.disableOnClickOutside) return;
        this.enableOnClickOutside();
      };
      _proto.componentDidUpdate = function componentDidUpdate() {
        this.componentNode = this.__getComponentNode();
      }
      /**
       * Remove all document's event listeners for this component
       */;

      _proto.componentWillUnmount = function componentWillUnmount() {
        this.disableOnClickOutside();
      }
      /**
       * Can be called to explicitly enable event listening
       * for clicks and touches outside of this element.
       */;

      /**
       * Pass-through render
       */
      _proto.render = function render() {
        // eslint-disable-next-line no-unused-vars
        var _this$props = this.props;
        _this$props.excludeScrollbar;
        var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);
        if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
          props.ref = this.getRef;
        } else {
          props.wrappedRef = this.getRef;
        }
        props.disableOnClickOutside = this.disableOnClickOutside;
        props.enableOnClickOutside = this.enableOnClickOutside;
        return Object(external_react_["createElement"])(WrappedComponent, props);
      };
      return onClickOutside;
    }(external_react_["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
      eventTypes: ['mousedown', 'touchstart'],
      excludeScrollbar: config && config.excludeScrollbar || false,
      outsideClickIgnoreClass: IGNORE_CLASS_NAME,
      preventDefault: false,
      stopPropagation: false
    }, _class.getClass = function () {
      return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
  } /* harmony default export */
  var react_onclickoutside_es = onClickOutsideHOC;
  // EXTERNAL MODULE: external "moment"
  var external_moment_ = __webpack_require__(28);
  var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js
  var objectWithoutPropertiesLoose = __webpack_require__(77);
  var objectWithoutPropertiesLoose_default = /*#__PURE__*/__webpack_require__.n(objectWithoutPropertiesLoose);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/extends.js
  var helpers_extends = __webpack_require__(37);
  var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/inheritsLoose.js
  var inheritsLoose = __webpack_require__(45);
  var inheritsLoose_default = /*#__PURE__*/__webpack_require__.n(inheritsLoose);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/assertThisInitialized.js
  var assertThisInitialized = __webpack_require__(7);
  var assertThisInitialized_default = /*#__PURE__*/__webpack_require__.n(assertThisInitialized);

  // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js
  var defineProperty = __webpack_require__(11);
  var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

  // EXTERNAL MODULE: ./node_modules/deep-equal/index.js
  var deep_equal = __webpack_require__(139);
  var deep_equal_default = /*#__PURE__*/__webpack_require__.n(deep_equal);

  // EXTERNAL MODULE: ./node_modules/popper.js/dist/esm/popper.js
  var esm_popper = __webpack_require__(96);

  // EXTERNAL MODULE: ./node_modules/@hypnosphi/create-react-context/lib/index.js
  var lib = __webpack_require__(97);
  var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

  // CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Manager.js

  var ManagerReferenceNodeContext = lib_default()();
  var ManagerReferenceNodeSetterContext = lib_default()();
  var Manager_Manager = /*#__PURE__*/
  function (_React$Component) {
    inheritsLoose_default()(Manager, _React$Component);
    function Manager() {
      var _this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "referenceNode", void 0);
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "setReferenceNode", function (newReferenceNode) {
        if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
          _this.referenceNode = newReferenceNode;
          _this.forceUpdate();
        }
      });
      return _this;
    }
    var _proto = Manager.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.referenceNode = null;
    };
    _proto.render = function render() {
      return external_react_["createElement"](ManagerReferenceNodeContext.Provider, {
        value: this.referenceNode
      }, external_react_["createElement"](ManagerReferenceNodeSetterContext.Provider, {
        value: this.setReferenceNode
      }, this.props.children));
    };
    return Manager;
  }(external_react_["Component"]);

  // CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/utils.js
  /**
   * Takes an argument and if it's an array, returns the first item in the array,
   * otherwise returns the argument. Used for Preact compatibility.
   */
  var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
  };
  /**
   * Takes a maybe-undefined function and arbitrary args and invokes the function
   * only if it is defined.
   */

  var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === "function") {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return fn.apply(void 0, args);
    }
  };
  /**
   * Does a shallow equality check of two objects by comparing the reference
   * equality of each value.
   */

  var shallowEqual = function shallowEqual(objA, objB) {
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    if (bKeys.length !== aKeys.length) {
      return false;
    }
    for (var i = 0; i < bKeys.length; i++) {
      var key = aKeys[i];
      if (objA[key] !== objB[key]) {
        return false;
      }
    }
    return true;
  };
  /**
   * Sets a ref using either a ref callback or a ref object
   */

  var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") {
      return safeInvoke(ref, node);
    } // otherwise we should treat it as a ref object
    else if (ref != null) {
      ref.current = node;
    }
  };
  // CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Popper.js

  var initialStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    pointerEvents: 'none'
  };
  var initialArrowStyle = {};
  var Popper_InnerPopper = /*#__PURE__*/
  function (_React$Component) {
    inheritsLoose_default()(InnerPopper, _React$Component);
    function InnerPopper() {
      var _this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "state", {
        data: undefined,
        placement: undefined
      });
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "popperInstance", void 0);
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "popperNode", null);
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "arrowNode", null);
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "setPopperNode", function (popperNode) {
        if (!popperNode || _this.popperNode === popperNode) return;
        setRef(_this.props.innerRef, popperNode);
        _this.popperNode = popperNode;
        _this.updatePopperInstance();
      });
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "setArrowNode", function (arrowNode) {
        _this.arrowNode = arrowNode;
      });
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "updateStateModifier", {
        enabled: true,
        order: 900,
        fn: function fn(data) {
          var placement = data.placement;
          _this.setState({
            data: data,
            placement: placement
          });
          return data;
        }
      });
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "getOptions", function () {
        return {
          placement: _this.props.placement,
          eventsEnabled: _this.props.eventsEnabled,
          positionFixed: _this.props.positionFixed,
          modifiers: extends_default()({}, _this.props.modifiers, {
            arrow: extends_default()({}, _this.props.modifiers && _this.props.modifiers.arrow, {
              enabled: !!_this.arrowNode,
              element: _this.arrowNode
            }),
            applyStyle: {
              enabled: false
            },
            updateStateModifier: _this.updateStateModifier
          })
        };
      });
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "getPopperStyle", function () {
        return !_this.popperNode || !_this.state.data ? initialStyle : extends_default()({
          position: _this.state.data.offsets.popper.position
        }, _this.state.data.styles);
      });
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "getPopperPlacement", function () {
        return !_this.state.data ? undefined : _this.state.placement;
      });
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "getArrowStyle", function () {
        return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
      });
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "getOutOfBoundariesState", function () {
        return _this.state.data ? _this.state.data.hide : undefined;
      });
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "destroyPopperInstance", function () {
        if (!_this.popperInstance) return;
        _this.popperInstance.destroy();
        _this.popperInstance = null;
      });
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "updatePopperInstance", function () {
        _this.destroyPopperInstance();
        var _assertThisInitialize = assertThisInitialized_default()(assertThisInitialized_default()(_this)),
          popperNode = _assertThisInitialize.popperNode;
        var referenceElement = _this.props.referenceElement;
        if (!referenceElement || !popperNode) return;
        _this.popperInstance = new esm_popper["a" /* default */](referenceElement, popperNode, _this.getOptions());
      });
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "scheduleUpdate", function () {
        if (_this.popperInstance) {
          _this.popperInstance.scheduleUpdate();
        }
      });
      return _this;
    }
    var _proto = InnerPopper.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      // If the Popper.js options have changed, update the instance (destroy + create)
      if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !deep_equal_default()(this.props.modifiers, prevProps.modifiers, {
        strict: true
      })) {
        // develop only check that modifiers isn't being updated needlessly
        if (false) {}
        this.updatePopperInstance();
      } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
        this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
      } // A placement difference in state means popper determined a new placement
      // apart from the props value. By the time the popper element is rendered with
      // the new position Popper has already measured it, if the place change triggers
      // a size change it will result in a misaligned popper. So we schedule an update to be sure.

      if (prevState.placement !== this.state.placement) {
        this.scheduleUpdate();
      }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      setRef(this.props.innerRef, null);
      this.destroyPopperInstance();
    };
    _proto.render = function render() {
      return unwrapArray(this.props.children)({
        ref: this.setPopperNode,
        style: this.getPopperStyle(),
        placement: this.getPopperPlacement(),
        outOfBoundaries: this.getOutOfBoundariesState(),
        scheduleUpdate: this.scheduleUpdate,
        arrowProps: {
          ref: this.setArrowNode,
          style: this.getArrowStyle()
        }
      });
    };
    return InnerPopper;
  }(external_react_["Component"]);
  defineProperty_default()(Popper_InnerPopper, "defaultProps", {
    placement: 'bottom',
    eventsEnabled: true,
    referenceElement: undefined,
    positionFixed: false
  });
  var placements = esm_popper["a" /* default */].placements;
  function Popper(_ref) {
    var referenceElement = _ref.referenceElement,
      props = objectWithoutPropertiesLoose_default()(_ref, ["referenceElement"]);
    return external_react_["createElement"](ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
      return external_react_["createElement"](Popper_InnerPopper, extends_default()({
        referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
      }, props));
    });
  }
  // EXTERNAL MODULE: ./node_modules/warning/warning.js
  var warning = __webpack_require__(83);
  var warning_default = /*#__PURE__*/__webpack_require__.n(warning);

  // CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Reference.js

  var Reference_InnerReference = /*#__PURE__*/
  function (_React$Component) {
    inheritsLoose_default()(InnerReference, _React$Component);
    function InnerReference() {
      var _this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      defineProperty_default()(assertThisInitialized_default()(assertThisInitialized_default()(_this)), "refHandler", function (node) {
        setRef(_this.props.innerRef, node);
        safeInvoke(_this.props.setReferenceNode, node);
      });
      return _this;
    }
    var _proto = InnerReference.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
      setRef(this.props.innerRef, null);
    };
    _proto.render = function render() {
      warning_default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
      return unwrapArray(this.props.children)({
        ref: this.refHandler
      });
    };
    return InnerReference;
  }(external_react_["Component"]);
  function Reference(props) {
    return external_react_["createElement"](ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
      return external_react_["createElement"](Reference_InnerReference, extends_default()({
        setReferenceNode: setReferenceNode
      }, props));
    });
  }
  // CONCATENATED MODULE: ./node_modules/react-datepicker/es/index.js

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var inherits = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };
  var possibleConstructorReturn = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  };
  function generateYears(year, noOfYear, minDate, maxDate) {
    var list = [];
    for (var i = 0; i < 2 * noOfYear + 1; i++) {
      var newYear = year + noOfYear - i;
      var isInRange = true;
      if (minDate) {
        isInRange = minDate.year() <= newYear;
      }
      if (maxDate && isInRange) {
        isInRange = maxDate.year() >= newYear;
      }
      if (isInRange) {
        list.push(newYear);
      }
    }
    return list;
  }
  var es_YearDropdownOptions = function (_React$Component) {
    inherits(YearDropdownOptions, _React$Component);
    function YearDropdownOptions(props) {
      classCallCheck(this, YearDropdownOptions);
      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
      _this.renderOptions = function () {
        var selectedYear = _this.props.year;
        var options = _this.state.yearsList.map(function (year) {
          return external_react_default.a.createElement("div", {
            className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
            key: year,
            ref: year,
            onClick: _this.onChange.bind(_this, year)
          }, selectedYear === year ? external_react_default.a.createElement("span", {
            className: "react-datepicker__year-option--selected"
          }, "\u2713") : "", year);
        });
        var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
        var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;
        if (!maxYear || !_this.state.yearsList.find(function (year) {
          return year === maxYear;
        })) {
          options.unshift(external_react_default.a.createElement("div", {
            className: "react-datepicker__year-option",
            ref: "upcoming",
            key: "upcoming",
            onClick: _this.incrementYears
          }, external_react_default.a.createElement("a", {
            className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
          })));
        }
        if (!minYear || !_this.state.yearsList.find(function (year) {
          return year === minYear;
        })) {
          options.push(external_react_default.a.createElement("div", {
            className: "react-datepicker__year-option",
            ref: "previous",
            key: "previous",
            onClick: _this.decrementYears
          }, external_react_default.a.createElement("a", {
            className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
          })));
        }
        return options;
      };
      _this.onChange = function (year) {
        _this.props.onChange(year);
      };
      _this.handleClickOutside = function () {
        _this.props.onCancel();
      };
      _this.shiftYears = function (amount) {
        var years = _this.state.yearsList.map(function (year) {
          return year + amount;
        });
        _this.setState({
          yearsList: years
        });
      };
      _this.incrementYears = function () {
        return _this.shiftYears(1);
      };
      _this.decrementYears = function () {
        return _this.shiftYears(-1);
      };
      var yearDropdownItemNumber = props.yearDropdownItemNumber,
        scrollableYearDropdown = props.scrollableYearDropdown;
      var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
      _this.state = {
        yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
      };
      return _this;
    }
    YearDropdownOptions.prototype.render = function render() {
      var dropdownClass = classnames_default()({
        "react-datepicker__year-dropdown": true,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return external_react_default.a.createElement("div", {
        className: dropdownClass
      }, this.renderOptions());
    };
    return YearDropdownOptions;
  }(external_react_default.a.Component);
  es_YearDropdownOptions.propTypes = {
    minDate: external_prop_types_default.a.object,
    maxDate: external_prop_types_default.a.object,
    onCancel: external_prop_types_default.a.func.isRequired,
    onChange: external_prop_types_default.a.func.isRequired,
    scrollableYearDropdown: external_prop_types_default.a.bool,
    year: external_prop_types_default.a.number.isRequired,
    yearDropdownItemNumber: external_prop_types_default.a.number
  };
  var dayOfWeekCodes = {
    1: "mon",
    2: "tue",
    3: "wed",
    4: "thu",
    5: "fri",
    6: "sat",
    7: "sun"
  };

  // These functions are not exported so
  // that we avoid magic strings like 'days'
  function set$1(date, unit, to) {
    return date.set(unit, to);
  }
  function add(date, amount, unit) {
    return date.add(amount, unit);
  }
  function subtract(date, amount, unit) {
    return date.subtract(amount, unit);
  }
  function get$1(date, unit) {
    return date.get(unit);
  }
  function getStartOf(date, unit) {
    return date.startOf(unit);
  }

  // ** Date Constructors **

  function newDate(point) {
    return external_moment_default()(point);
  }
  function newDateWithOffset(utcOffset) {
    return external_moment_default()().utc().utcOffset(utcOffset);
  }
  function now(maybeFixedUtcOffset) {
    if (maybeFixedUtcOffset == null) {
      return newDate();
    }
    return newDateWithOffset(maybeFixedUtcOffset);
  }
  function cloneDate(date) {
    return date.clone();
  }
  function parseDate(value, _ref) {
    var dateFormat = _ref.dateFormat,
      locale = _ref.locale;
    var m = external_moment_default()(value, dateFormat, locale || external_moment_default.a.locale(), true);
    return m.isValid() ? m : null;
  }

  // ** Date "Reflection" **

  function isMoment(date) {
    return external_moment_default.a.isMoment(date);
  }
  function isDate(date) {
    return external_moment_default.a.isDate(date);
  }

  // ** Date Formatting **

  function formatDate(date, format) {
    return date.format(format);
  }
  function safeDateFormat(date, _ref2) {
    var dateFormat = _ref2.dateFormat,
      locale = _ref2.locale;
    return date && date.clone().locale(locale || external_moment_default.a.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
  }

  // ** Date Setters **

  function setTime(date, _ref3) {
    var hour = _ref3.hour,
      minute = _ref3.minute,
      second = _ref3.second;
    date.set({
      hour: hour,
      minute: minute,
      second: second
    });
    return date;
  }
  function setMonth(date, month) {
    return set$1(date, "month", month);
  }
  function setYear(date, year) {
    return set$1(date, "year", year);
  }

  // ** Date Getters **

  function getSecond(date) {
    return get$1(date, "second");
  }
  function getMinute(date) {
    return get$1(date, "minute");
  }
  function getHour(date) {
    return get$1(date, "hour");
  }

  // Returns day of week
  function getDay(date) {
    return get$1(date, "day");
  }
  function getWeek(date) {
    return get$1(date, "week");
  }
  function getMonth(date) {
    return get$1(date, "month");
  }
  function getYear(date) {
    return get$1(date, "year");
  }

  // Returns day of month
  function getDate(date) {
    return get$1(date, "date");
  }
  function getDayOfWeekCode(day) {
    return dayOfWeekCodes[day.isoWeekday()];
  }

  // *** Start of ***

  function getStartOfDay(date) {
    return getStartOf(date, "day");
  }
  function getStartOfWeek(date) {
    return getStartOf(date, "week");
  }
  function getStartOfMonth(date) {
    return getStartOf(date, "month");
  }
  function getStartOfDate(date) {
    return getStartOf(date, "date");
  }

  // *** End of ***

  // ** Date Math **

  // *** Addition ***

  function addMinutes(date, amount) {
    return add(date, amount, "minutes");
  }
  function addHours(date, amount) {
    return add(date, amount, "hours");
  }
  function addDays(date, amount) {
    return add(date, amount, "days");
  }
  function addWeeks(date, amount) {
    return add(date, amount, "weeks");
  }
  function addMonths(date, amount) {
    return add(date, amount, "months");
  }
  function addYears(date, amount) {
    return add(date, amount, "years");
  }

  // *** Subtraction ***
  function subtractDays(date, amount) {
    return subtract(date, amount, "days");
  }
  function subtractWeeks(date, amount) {
    return subtract(date, amount, "weeks");
  }
  function subtractMonths(date, amount) {
    return subtract(date, amount, "months");
  }
  function subtractYears(date, amount) {
    return subtract(date, amount, "years");
  }

  // ** Date Comparison **

  function isBefore(date1, date2) {
    return date1.isBefore(date2);
  }
  function isAfter(date1, date2) {
    return date1.isAfter(date2);
  }
  function equals(date1, date2) {
    return date1.isSame(date2);
  }
  function isSameYear(date1, date2) {
    if (date1 && date2) {
      return date1.isSame(date2, "year");
    } else {
      return !date1 && !date2;
    }
  }
  function isSameMonth(date1, date2) {
    if (date1 && date2) {
      return date1.isSame(date2, "month");
    } else {
      return !date1 && !date2;
    }
  }
  function isSameDay(moment1, moment2) {
    if (moment1 && moment2) {
      return moment1.isSame(moment2, "day");
    } else {
      return !moment1 && !moment2;
    }
  }
  function isDayInRange(day, startDate, endDate) {
    var before = startDate.clone().startOf("day").subtract(1, "seconds");
    var after = endDate.clone().startOf("day").add(1, "seconds");
    return day.clone().startOf("day").isBetween(before, after);
  }

  // *** Diffing ***

  // ** Date Localization **

  function localizeDate(date, locale) {
    return date.clone().locale(locale || external_moment_default.a.locale());
  }
  function getLocaleData(date) {
    return date.localeData();
  }
  function getLocaleDataForLocale(locale) {
    return external_moment_default.a.localeData(locale);
  }
  function getFormattedWeekdayInLocale(locale, date, formatFunc) {
    return formatFunc(locale.weekdays(date));
  }
  function getWeekdayMinInLocale(locale, date) {
    return locale.weekdaysMin(date);
  }
  function getWeekdayShortInLocale(locale, date) {
    return locale.weekdaysShort(date);
  }

  // TODO what is this format exactly?
  function getMonthInLocale(locale, date, format) {
    return locale.months(date, format);
  }
  function getMonthShortInLocale(locale, date) {
    return locale.monthsShort(date);
  }

  // ** Utils for some components **

  function isDayDisabled(day) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref4.minDate,
      maxDate = _ref4.maxDate,
      excludeDates = _ref4.excludeDates,
      includeDates = _ref4.includeDates,
      filterDate = _ref4.filterDate;
    return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
      return isSameDay(day, excludeDate);
    }) || includeDates && !includeDates.some(function (includeDate) {
      return isSameDay(day, includeDate);
    }) || filterDate && !filterDate(day.clone()) || false;
  }
  function isOutOfBounds(day) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref5.minDate,
      maxDate = _ref5.maxDate;
    return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day");
  }
  function isTimeDisabled(time, disabledTimes) {
    var l = disabledTimes.length;
    for (var i = 0; i < l; i++) {
      if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
        return true;
      }
    }
    return false;
  }
  function isTimeInDisabledRange(time, _ref6) {
    var minTime = _ref6.minTime,
      maxTime = _ref6.maxTime;
    if (!minTime || !maxTime) {
      throw new Error("Both minTime and maxTime props required");
    }
    var base = external_moment_default()().hours(0).minutes(0).seconds(0);
    var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
    var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
    var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));
    return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
  }
  function allDaysDisabledBefore(day, unit) {
    var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      minDate = _ref7.minDate,
      includeDates = _ref7.includeDates;
    var dateBefore = day.clone().subtract(1, unit);
    return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
      return dateBefore.isBefore(includeDate, unit);
    }) || false;
  }
  function allDaysDisabledAfter(day, unit) {
    var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      maxDate = _ref8.maxDate,
      includeDates = _ref8.includeDates;
    var dateAfter = day.clone().add(1, unit);
    return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
      return dateAfter.isAfter(includeDate, unit);
    }) || false;
  }
  function getEffectiveMinDate(_ref9) {
    var minDate = _ref9.minDate,
      includeDates = _ref9.includeDates;
    if (includeDates && minDate) {
      return external_moment_default.a.min(includeDates.filter(function (includeDate) {
        return minDate.isSameOrBefore(includeDate, "day");
      }));
    } else if (includeDates) {
      return external_moment_default.a.min(includeDates);
    } else {
      return minDate;
    }
  }
  function getEffectiveMaxDate(_ref10) {
    var maxDate = _ref10.maxDate,
      includeDates = _ref10.includeDates;
    if (includeDates && maxDate) {
      return external_moment_default.a.max(includeDates.filter(function (includeDate) {
        return maxDate.isSameOrAfter(includeDate, "day");
      }));
    } else if (includeDates) {
      return external_moment_default.a.max(includeDates);
    } else {
      return maxDate;
    }
  }
  function getHightLightDaysMap() {
    var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";
    var dateClasses = new Map();
    for (var i = 0, len = highlightDates.length; i < len; i++) {
      var obj = highlightDates[i];
      if (isMoment(obj)) {
        var key = obj.format("MM.DD.YYYY");
        var classNamesArr = dateClasses.get(key) || [];
        if (!classNamesArr.includes(defaultClassName)) {
          classNamesArr.push(defaultClassName);
          dateClasses.set(key, classNamesArr);
        }
      } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
        var keys = Object.keys(obj);
        var className = keys[0];
        var arrOfMoments = obj[keys[0]];
        if (typeof className === "string" && arrOfMoments.constructor === Array) {
          for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
            var _key = arrOfMoments[k].format("MM.DD.YYYY");
            var _classNamesArr = dateClasses.get(_key) || [];
            if (!_classNamesArr.includes(className)) {
              _classNamesArr.push(className);
              dateClasses.set(_key, _classNamesArr);
            }
          }
        }
      }
    }
    return dateClasses;
  }
  function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
    var l = injectedTimes.length;
    var times = [];
    for (var i = 0; i < l; i++) {
      var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
      var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);
      if (injectedTime.isBetween(currentTime, nextTime)) {
        times.push(injectedTimes[i]);
      }
    }
    return times;
  }
  var WrappedYearDropdownOptions = react_onclickoutside_es(es_YearDropdownOptions);
  var es_YearDropdown = function (_React$Component) {
    inherits(YearDropdown, _React$Component);
    function YearDropdown() {
      var _temp, _this, _ret;
      classCallCheck(this, YearDropdown);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
        dropdownVisible: false
      }, _this.renderSelectOptions = function () {
        var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
        var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
        var options = [];
        for (var i = minYear; i <= maxYear; i++) {
          options.push(external_react_default.a.createElement("option", {
            key: i,
            value: i
          }, i));
        }
        return options;
      }, _this.onSelectChange = function (e) {
        _this.onChange(e.target.value);
      }, _this.renderSelectMode = function () {
        return external_react_default.a.createElement("select", {
          value: _this.props.year,
          className: "react-datepicker__year-select",
          onChange: _this.onSelectChange
        }, _this.renderSelectOptions());
      }, _this.renderReadView = function (visible) {
        return external_react_default.a.createElement("div", {
          key: "read",
          style: {
            visibility: visible ? "visible" : "hidden"
          },
          className: "react-datepicker__year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        }, external_react_default.a.createElement("span", {
          className: "react-datepicker__year-read-view--down-arrow"
        }), external_react_default.a.createElement("span", {
          className: "react-datepicker__year-read-view--selected-year"
        }, _this.props.year));
      }, _this.renderDropdown = function () {
        return external_react_default.a.createElement(WrappedYearDropdownOptions, {
          key: "dropdown",
          ref: "options",
          year: _this.props.year,
          onChange: _this.onChange,
          onCancel: _this.toggleDropdown,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber
        });
      }, _this.renderScrollMode = function () {
        var dropdownVisible = _this.state.dropdownVisible;
        var result = [_this.renderReadView(!dropdownVisible)];
        if (dropdownVisible) {
          result.unshift(_this.renderDropdown());
        }
        return result;
      }, _this.onChange = function (year) {
        _this.toggleDropdown();
        if (year === _this.props.year) return;
        _this.props.onChange(year);
      }, _this.toggleDropdown = function (event) {
        _this.setState({
          dropdownVisible: !_this.state.dropdownVisible
        }, function () {
          if (_this.props.adjustDateOnChange) {
            _this.handleYearChange(_this.props.date, event);
          }
        });
      }, _this.handleYearChange = function (date, event) {
        _this.onSelect(date, event);
        _this.setOpen();
      }, _this.onSelect = function (date, event) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date, event);
        }
      }, _this.setOpen = function () {
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }, _temp), possibleConstructorReturn(_this, _ret);
    }
    YearDropdown.prototype.render = function render() {
      var renderedDropdown = void 0;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode();
          break;
        case "select":
          renderedDropdown = this.renderSelectMode();
          break;
      }
      return external_react_default.a.createElement("div", {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
      }, renderedDropdown);
    };
    return YearDropdown;
  }(external_react_default.a.Component);
  es_YearDropdown.propTypes = {
    adjustDateOnChange: external_prop_types_default.a.bool,
    dropdownMode: external_prop_types_default.a.oneOf(["scroll", "select"]).isRequired,
    maxDate: external_prop_types_default.a.object,
    minDate: external_prop_types_default.a.object,
    onChange: external_prop_types_default.a.func.isRequired,
    scrollableYearDropdown: external_prop_types_default.a.bool,
    year: external_prop_types_default.a.number.isRequired,
    yearDropdownItemNumber: external_prop_types_default.a.number,
    date: external_prop_types_default.a.object,
    onSelect: external_prop_types_default.a.func,
    setOpen: external_prop_types_default.a.func
  };
  var es_MonthDropdownOptions = function (_React$Component) {
    inherits(MonthDropdownOptions, _React$Component);
    function MonthDropdownOptions() {
      var _temp, _this, _ret;
      classCallCheck(this, MonthDropdownOptions);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
        return _this.props.monthNames.map(function (month, i) {
          return external_react_default.a.createElement("div", {
            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
            key: month,
            ref: month,
            onClick: _this.onChange.bind(_this, i)
          }, _this.props.month === i ? external_react_default.a.createElement("span", {
            className: "react-datepicker__month-option--selected"
          }, "\u2713") : "", month);
        });
      }, _this.onChange = function (month) {
        return _this.props.onChange(month);
      }, _this.handleClickOutside = function () {
        return _this.props.onCancel();
      }, _temp), possibleConstructorReturn(_this, _ret);
    }
    MonthDropdownOptions.prototype.render = function render() {
      return external_react_default.a.createElement("div", {
        className: "react-datepicker__month-dropdown"
      }, this.renderOptions());
    };
    return MonthDropdownOptions;
  }(external_react_default.a.Component);
  es_MonthDropdownOptions.propTypes = {
    onCancel: external_prop_types_default.a.func.isRequired,
    onChange: external_prop_types_default.a.func.isRequired,
    month: external_prop_types_default.a.number.isRequired,
    monthNames: external_prop_types_default.a.arrayOf(external_prop_types_default.a.string.isRequired).isRequired
  };
  var WrappedMonthDropdownOptions = react_onclickoutside_es(es_MonthDropdownOptions);
  var es_MonthDropdown = function (_React$Component) {
    inherits(MonthDropdown, _React$Component);
    function MonthDropdown() {
      var _temp, _this, _ret;
      classCallCheck(this, MonthDropdown);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
        dropdownVisible: false
      }, _this.renderSelectOptions = function (monthNames) {
        return monthNames.map(function (M, i) {
          return external_react_default.a.createElement("option", {
            key: i,
            value: i
          }, M);
        });
      }, _this.renderSelectMode = function (monthNames) {
        return external_react_default.a.createElement("select", {
          value: _this.props.month,
          className: "react-datepicker__month-select",
          onChange: function onChange(e) {
            return _this.onChange(e.target.value);
          }
        }, _this.renderSelectOptions(monthNames));
      }, _this.renderReadView = function (visible, monthNames) {
        return external_react_default.a.createElement("div", {
          key: "read",
          style: {
            visibility: visible ? "visible" : "hidden"
          },
          className: "react-datepicker__month-read-view",
          onClick: _this.toggleDropdown
        }, external_react_default.a.createElement("span", {
          className: "react-datepicker__month-read-view--down-arrow"
        }), external_react_default.a.createElement("span", {
          className: "react-datepicker__month-read-view--selected-month"
        }, monthNames[_this.props.month]));
      }, _this.renderDropdown = function (monthNames) {
        return external_react_default.a.createElement(WrappedMonthDropdownOptions, {
          key: "dropdown",
          ref: "options",
          month: _this.props.month,
          monthNames: monthNames,
          onChange: _this.onChange,
          onCancel: _this.toggleDropdown
        });
      }, _this.renderScrollMode = function (monthNames) {
        var dropdownVisible = _this.state.dropdownVisible;
        var result = [_this.renderReadView(!dropdownVisible, monthNames)];
        if (dropdownVisible) {
          result.unshift(_this.renderDropdown(monthNames));
        }
        return result;
      }, _this.onChange = function (month) {
        _this.toggleDropdown();
        if (month !== _this.props.month) {
          _this.props.onChange(month);
        }
      }, _this.toggleDropdown = function () {
        return _this.setState({
          dropdownVisible: !_this.state.dropdownVisible
        });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }
    MonthDropdown.prototype.render = function render() {
      var _this2 = this;
      var localeData = getLocaleDataForLocale(this.props.locale);
      var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
        return getMonthShortInLocale(localeData, newDate({
          M: M
        }));
      } : function (M) {
        return getMonthInLocale(localeData, newDate({
          M: M
        }), _this2.props.dateFormat);
      });
      var renderedDropdown = void 0;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode(monthNames);
          break;
        case "select":
          renderedDropdown = this.renderSelectMode(monthNames);
          break;
      }
      return external_react_default.a.createElement("div", {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
      }, renderedDropdown);
    };
    return MonthDropdown;
  }(external_react_default.a.Component);
  es_MonthDropdown.propTypes = {
    dropdownMode: external_prop_types_default.a.oneOf(["scroll", "select"]).isRequired,
    locale: external_prop_types_default.a.string,
    dateFormat: external_prop_types_default.a.string.isRequired,
    month: external_prop_types_default.a.number.isRequired,
    onChange: external_prop_types_default.a.func.isRequired,
    useShortMonthInDropdown: external_prop_types_default.a.bool
  };
  function generateMonthYears(minDate, maxDate) {
    var list = [];
    var currDate = getStartOfMonth(cloneDate(minDate));
    var lastDate = getStartOfMonth(cloneDate(maxDate));
    while (!isAfter(currDate, lastDate)) {
      list.push(cloneDate(currDate));
      addMonths(currDate, 1);
    }
    return list;
  }
  var es_MonthYearDropdownOptions = function (_React$Component) {
    inherits(MonthYearDropdownOptions, _React$Component);
    function MonthYearDropdownOptions(props) {
      classCallCheck(this, MonthYearDropdownOptions);
      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
      _this.renderOptions = function () {
        return _this.state.monthYearsList.map(function (monthYear) {
          var monthYearPoint = monthYear.valueOf();
          var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);
          return external_react_default.a.createElement("div", {
            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
            key: monthYearPoint,
            ref: monthYearPoint,
            onClick: _this.onChange.bind(_this, monthYearPoint)
          }, isSameMonthYear ? external_react_default.a.createElement("span", {
            className: "react-datepicker__month-year-option--selected"
          }, "\u2713") : "", formatDate(monthYear, _this.props.dateFormat));
        });
      };
      _this.onChange = function (monthYear) {
        return _this.props.onChange(monthYear);
      };
      _this.handleClickOutside = function () {
        _this.props.onCancel();
      };
      _this.state = {
        monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
      };
      return _this;
    }
    MonthYearDropdownOptions.prototype.render = function render() {
      var dropdownClass = classnames_default()({
        "react-datepicker__month-year-dropdown": true,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return external_react_default.a.createElement("div", {
        className: dropdownClass
      }, this.renderOptions());
    };
    return MonthYearDropdownOptions;
  }(external_react_default.a.Component);
  es_MonthYearDropdownOptions.propTypes = {
    minDate: external_prop_types_default.a.object.isRequired,
    maxDate: external_prop_types_default.a.object.isRequired,
    onCancel: external_prop_types_default.a.func.isRequired,
    onChange: external_prop_types_default.a.func.isRequired,
    scrollableMonthYearDropdown: external_prop_types_default.a.bool,
    date: external_prop_types_default.a.object.isRequired,
    dateFormat: external_prop_types_default.a.string.isRequired
  };
  var WrappedMonthYearDropdownOptions = react_onclickoutside_es(es_MonthYearDropdownOptions);
  var es_MonthYearDropdown = function (_React$Component) {
    inherits(MonthYearDropdown, _React$Component);
    function MonthYearDropdown() {
      var _temp, _this, _ret;
      classCallCheck(this, MonthYearDropdown);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
        dropdownVisible: false
      }, _this.renderSelectOptions = function () {
        var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
        var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));
        var options = [];
        while (!isAfter(currDate, lastDate)) {
          var timepoint = currDate.valueOf();
          options.push(external_react_default.a.createElement("option", {
            key: timepoint,
            value: timepoint
          }, formatDate(currDate, _this.props.dateFormat)));
          addMonths(currDate, 1);
        }
        return options;
      }, _this.onSelectChange = function (e) {
        _this.onChange(e.target.value);
      }, _this.renderSelectMode = function () {
        return external_react_default.a.createElement("select", {
          value: getStartOfMonth(_this.props.date).valueOf(),
          className: "react-datepicker__month-year-select",
          onChange: _this.onSelectChange
        }, _this.renderSelectOptions());
      }, _this.renderReadView = function (visible) {
        var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);
        return external_react_default.a.createElement("div", {
          key: "read",
          style: {
            visibility: visible ? "visible" : "hidden"
          },
          className: "react-datepicker__month-year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        }, external_react_default.a.createElement("span", {
          className: "react-datepicker__month-year-read-view--down-arrow"
        }), external_react_default.a.createElement("span", {
          className: "react-datepicker__month-year-read-view--selected-month-year"
        }, yearMonth));
      }, _this.renderDropdown = function () {
        return external_react_default.a.createElement(WrappedMonthYearDropdownOptions, {
          key: "dropdown",
          ref: "options",
          date: _this.props.date,
          dateFormat: _this.props.dateFormat,
          onChange: _this.onChange,
          onCancel: _this.toggleDropdown,
          minDate: localizeDate(_this.props.minDate, _this.props.locale),
          maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
        });
      }, _this.renderScrollMode = function () {
        var dropdownVisible = _this.state.dropdownVisible;
        var result = [_this.renderReadView(!dropdownVisible)];
        if (dropdownVisible) {
          result.unshift(_this.renderDropdown());
        }
        return result;
      }, _this.onChange = function (monthYearPoint) {
        _this.toggleDropdown();
        var changedDate = newDate(parseInt(monthYearPoint));
        if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
          return;
        }
        _this.props.onChange(changedDate);
      }, _this.toggleDropdown = function () {
        return _this.setState({
          dropdownVisible: !_this.state.dropdownVisible
        });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }
    MonthYearDropdown.prototype.render = function render() {
      var renderedDropdown = void 0;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode();
          break;
        case "select":
          renderedDropdown = this.renderSelectMode();
          break;
      }
      return external_react_default.a.createElement("div", {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
      }, renderedDropdown);
    };
    return MonthYearDropdown;
  }(external_react_default.a.Component);
  es_MonthYearDropdown.propTypes = {
    dropdownMode: external_prop_types_default.a.oneOf(["scroll", "select"]).isRequired,
    dateFormat: external_prop_types_default.a.string.isRequired,
    locale: external_prop_types_default.a.string,
    maxDate: external_prop_types_default.a.object.isRequired,
    minDate: external_prop_types_default.a.object.isRequired,
    date: external_prop_types_default.a.object.isRequired,
    onChange: external_prop_types_default.a.func.isRequired,
    scrollableMonthYearDropdown: external_prop_types_default.a.bool
  };
  var es_Day = function (_React$Component) {
    inherits(Day, _React$Component);
    function Day() {
      var _temp, _this, _ret;
      classCallCheck(this, Day);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
        if (!_this.isDisabled() && _this.props.onClick) {
          _this.props.onClick(event);
        }
      }, _this.handleMouseEnter = function (event) {
        if (!_this.isDisabled() && _this.props.onMouseEnter) {
          _this.props.onMouseEnter(event);
        }
      }, _this.isSameDay = function (other) {
        return isSameDay(_this.props.day, other);
      }, _this.isKeyboardSelected = function () {
        return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
      }, _this.isDisabled = function () {
        return isDayDisabled(_this.props.day, _this.props);
      }, _this.getHighLightedClass = function (defaultClassName) {
        var _this$props = _this.props,
          day = _this$props.day,
          highlightDates = _this$props.highlightDates;
        if (!highlightDates) {
          return false;
        }

        // Looking for className in the Map of {'day string, 'className'}
        var dayStr = day.format("MM.DD.YYYY");
        return highlightDates.get(dayStr);
      }, _this.isInRange = function () {
        var _this$props2 = _this.props,
          day = _this$props2.day,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate;
        if (!startDate || !endDate) {
          return false;
        }
        return isDayInRange(day, startDate, endDate);
      }, _this.isInSelectingRange = function () {
        var _this$props3 = _this.props,
          day = _this$props3.day,
          selectsStart = _this$props3.selectsStart,
          selectsEnd = _this$props3.selectsEnd,
          selectingDate = _this$props3.selectingDate,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate;
        if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
          return false;
        }
        if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
          return isDayInRange(day, selectingDate, endDate);
        }
        if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
          return isDayInRange(day, startDate, selectingDate);
        }
        return false;
      }, _this.isSelectingRangeStart = function () {
        if (!_this.isInSelectingRange()) {
          return false;
        }
        var _this$props4 = _this.props,
          day = _this$props4.day,
          selectingDate = _this$props4.selectingDate,
          startDate = _this$props4.startDate,
          selectsStart = _this$props4.selectsStart;
        if (selectsStart) {
          return isSameDay(day, selectingDate);
        } else {
          return isSameDay(day, startDate);
        }
      }, _this.isSelectingRangeEnd = function () {
        if (!_this.isInSelectingRange()) {
          return false;
        }
        var _this$props5 = _this.props,
          day = _this$props5.day,
          selectingDate = _this$props5.selectingDate,
          endDate = _this$props5.endDate,
          selectsEnd = _this$props5.selectsEnd;
        if (selectsEnd) {
          return isSameDay(day, selectingDate);
        } else {
          return isSameDay(day, endDate);
        }
      }, _this.isRangeStart = function () {
        var _this$props6 = _this.props,
          day = _this$props6.day,
          startDate = _this$props6.startDate,
          endDate = _this$props6.endDate;
        if (!startDate || !endDate) {
          return false;
        }
        return isSameDay(startDate, day);
      }, _this.isRangeEnd = function () {
        var _this$props7 = _this.props,
          day = _this$props7.day,
          startDate = _this$props7.startDate,
          endDate = _this$props7.endDate;
        if (!startDate || !endDate) {
          return false;
        }
        return isSameDay(endDate, day);
      }, _this.isWeekend = function () {
        var weekday = getDay(_this.props.day);
        return weekday === 0 || weekday === 6;
      }, _this.isOutsideMonth = function () {
        return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
      }, _this.getClassNames = function (date) {
        var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
        return classnames_default()("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
          "react-datepicker__day--disabled": _this.isDisabled(),
          "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
          "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
          "react-datepicker__day--range-start": _this.isRangeStart(),
          "react-datepicker__day--range-end": _this.isRangeEnd(),
          "react-datepicker__day--in-range": _this.isInRange(),
          "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
          "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
          "react-datepicker__day--weekend": _this.isWeekend(),
          "react-datepicker__day--outside-month": _this.isOutsideMonth()
        }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
      }, _temp), possibleConstructorReturn(_this, _ret);
    }
    Day.prototype.render = function render() {
      return external_react_default.a.createElement("div", {
        className: this.getClassNames(this.props.day),
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        "aria-label": "day-" + getDate(this.props.day),
        role: "option"
      }, this.props.renderDayContents ? this.props.renderDayContents(getDate(this.props.day)) : getDate(this.props.day));
    };
    return Day;
  }(external_react_default.a.Component);
  es_Day.propTypes = {
    disabledKeyboardNavigation: external_prop_types_default.a.bool,
    day: external_prop_types_default.a.object.isRequired,
    dayClassName: external_prop_types_default.a.func,
    endDate: external_prop_types_default.a.object,
    highlightDates: external_prop_types_default.a.instanceOf(Map),
    inline: external_prop_types_default.a.bool,
    month: external_prop_types_default.a.number,
    onClick: external_prop_types_default.a.func,
    onMouseEnter: external_prop_types_default.a.func,
    preSelection: external_prop_types_default.a.object,
    selected: external_prop_types_default.a.object,
    selectingDate: external_prop_types_default.a.object,
    selectsEnd: external_prop_types_default.a.bool,
    selectsStart: external_prop_types_default.a.bool,
    startDate: external_prop_types_default.a.object,
    utcOffset: external_prop_types_default.a.oneOfType([external_prop_types_default.a.number, external_prop_types_default.a.string]),
    renderDayContents: external_prop_types_default.a.func
  };
  var es_WeekNumber = function (_React$Component) {
    inherits(WeekNumber, _React$Component);
    function WeekNumber() {
      var _temp, _this, _ret;
      classCallCheck(this, WeekNumber);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
        if (_this.props.onClick) {
          _this.props.onClick(event);
        }
      }, _temp), possibleConstructorReturn(_this, _ret);
    }
    WeekNumber.prototype.render = function render() {
      var weekNumberClasses = {
        "react-datepicker__week-number": true,
        "react-datepicker__week-number--clickable": !!this.props.onClick
      };
      return external_react_default.a.createElement("div", {
        className: classnames_default()(weekNumberClasses),
        "aria-label": "week-" + this.props.weekNumber,
        onClick: this.handleClick
      }, this.props.weekNumber);
    };
    return WeekNumber;
  }(external_react_default.a.Component);
  es_WeekNumber.propTypes = {
    weekNumber: external_prop_types_default.a.number.isRequired,
    onClick: external_prop_types_default.a.func
  };
  var es_Week = function (_React$Component) {
    inherits(Week, _React$Component);
    function Week() {
      var _temp, _this, _ret;
      classCallCheck(this, Week);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
        if (_this.props.onDayClick) {
          _this.props.onDayClick(day, event);
        }
      }, _this.handleDayMouseEnter = function (day) {
        if (_this.props.onDayMouseEnter) {
          _this.props.onDayMouseEnter(day);
        }
      }, _this.handleWeekClick = function (day, weekNumber, event) {
        if (typeof _this.props.onWeekSelect === "function") {
          _this.props.onWeekSelect(day, weekNumber, event);
        }
      }, _this.formatWeekNumber = function (startOfWeek) {
        if (_this.props.formatWeekNumber) {
          return _this.props.formatWeekNumber(startOfWeek);
        }
        return getWeek(startOfWeek);
      }, _this.renderDays = function () {
        var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
        var days = [];
        var weekNumber = _this.formatWeekNumber(startOfWeek);
        if (_this.props.showWeekNumber) {
          var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
          days.push(external_react_default.a.createElement(es_WeekNumber, {
            key: "W",
            weekNumber: weekNumber,
            onClick: onClickAction
          }));
        }
        return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
          var day = addDays(cloneDate(startOfWeek), offset);
          return external_react_default.a.createElement(es_Day, {
            key: offset,
            day: day,
            month: _this.props.month,
            onClick: _this.handleDayClick.bind(_this, day),
            onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.props.selectingDate,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            dayClassName: _this.props.dayClassName,
            utcOffset: _this.props.utcOffset,
            renderDayContents: _this.props.renderDayContents,
            disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
          });
        }));
      }, _temp), possibleConstructorReturn(_this, _ret);
    }
    Week.prototype.render = function render() {
      return external_react_default.a.createElement("div", {
        className: "react-datepicker__week"
      }, this.renderDays());
    };
    return Week;
  }(external_react_default.a.Component);
  es_Week.propTypes = {
    disabledKeyboardNavigation: external_prop_types_default.a.bool,
    day: external_prop_types_default.a.object.isRequired,
    dayClassName: external_prop_types_default.a.func,
    endDate: external_prop_types_default.a.object,
    excludeDates: external_prop_types_default.a.array,
    filterDate: external_prop_types_default.a.func,
    formatWeekNumber: external_prop_types_default.a.func,
    highlightDates: external_prop_types_default.a.instanceOf(Map),
    includeDates: external_prop_types_default.a.array,
    inline: external_prop_types_default.a.bool,
    maxDate: external_prop_types_default.a.object,
    minDate: external_prop_types_default.a.object,
    month: external_prop_types_default.a.number,
    onDayClick: external_prop_types_default.a.func,
    onDayMouseEnter: external_prop_types_default.a.func,
    onWeekSelect: external_prop_types_default.a.func,
    preSelection: external_prop_types_default.a.object,
    selected: external_prop_types_default.a.object,
    selectingDate: external_prop_types_default.a.object,
    selectsEnd: external_prop_types_default.a.bool,
    selectsStart: external_prop_types_default.a.bool,
    showWeekNumber: external_prop_types_default.a.bool,
    startDate: external_prop_types_default.a.object,
    utcOffset: external_prop_types_default.a.oneOfType([external_prop_types_default.a.number, external_prop_types_default.a.string]),
    renderDayContents: external_prop_types_default.a.func
  };
  var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
  var es_Month = function (_React$Component) {
    inherits(Month, _React$Component);
    function Month() {
      var _temp, _this, _ret;
      classCallCheck(this, Month);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
        if (_this.props.onDayClick) {
          _this.props.onDayClick(day, event);
        }
      }, _this.handleDayMouseEnter = function (day) {
        if (_this.props.onDayMouseEnter) {
          _this.props.onDayMouseEnter(day);
        }
      }, _this.handleMouseLeave = function () {
        if (_this.props.onMouseLeave) {
          _this.props.onMouseLeave();
        }
      }, _this.isWeekInMonth = function (startOfWeek) {
        var day = _this.props.day;
        var endOfWeek = addDays(cloneDate(startOfWeek), 6);
        return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
      }, _this.renderWeeks = function () {
        var weeks = [];
        var isFixedHeight = _this.props.fixedHeight;
        var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
        var i = 0;
        var breakAfterNextPush = false;
        while (true) {
          weeks.push(external_react_default.a.createElement(es_Week, {
            key: i,
            day: currentWeekStart,
            month: getMonth(_this.props.day),
            onDayClick: _this.handleDayClick,
            onDayMouseEnter: _this.handleDayMouseEnter,
            onWeekSelect: _this.props.onWeekSelect,
            formatWeekNumber: _this.props.formatWeekNumber,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.props.selectingDate,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            showWeekNumber: _this.props.showWeekNumbers,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            dayClassName: _this.props.dayClassName,
            utcOffset: _this.props.utcOffset,
            disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
            renderDayContents: _this.props.renderDayContents
          }));
          if (breakAfterNextPush) break;
          i++;
          currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);

          // If one of these conditions is true, we will either break on this week
          // or break on the next week
          var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
          var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
          if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
            if (_this.props.peekNextMonth) {
              breakAfterNextPush = true;
            } else {
              break;
            }
          }
        }
        return weeks;
      }, _this.getClassNames = function () {
        var _this$props = _this.props,
          selectingDate = _this$props.selectingDate,
          selectsStart = _this$props.selectsStart,
          selectsEnd = _this$props.selectsEnd;
        return classnames_default()("react-datepicker__month", {
          "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
        });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }
    Month.prototype.render = function render() {
      return external_react_default.a.createElement("div", {
        className: this.getClassNames(),
        onMouseLeave: this.handleMouseLeave,
        role: "listbox",
        "aria-label": "month-" + this.props.day.format("YYYY-MM")
      }, this.renderWeeks());
    };
    return Month;
  }(external_react_default.a.Component);
  es_Month.propTypes = {
    disabledKeyboardNavigation: external_prop_types_default.a.bool,
    day: external_prop_types_default.a.object.isRequired,
    dayClassName: external_prop_types_default.a.func,
    endDate: external_prop_types_default.a.object,
    excludeDates: external_prop_types_default.a.array,
    filterDate: external_prop_types_default.a.func,
    fixedHeight: external_prop_types_default.a.bool,
    formatWeekNumber: external_prop_types_default.a.func,
    highlightDates: external_prop_types_default.a.instanceOf(Map),
    includeDates: external_prop_types_default.a.array,
    inline: external_prop_types_default.a.bool,
    maxDate: external_prop_types_default.a.object,
    minDate: external_prop_types_default.a.object,
    onDayClick: external_prop_types_default.a.func,
    onDayMouseEnter: external_prop_types_default.a.func,
    onMouseLeave: external_prop_types_default.a.func,
    onWeekSelect: external_prop_types_default.a.func,
    peekNextMonth: external_prop_types_default.a.bool,
    preSelection: external_prop_types_default.a.object,
    selected: external_prop_types_default.a.object,
    selectingDate: external_prop_types_default.a.object,
    selectsEnd: external_prop_types_default.a.bool,
    selectsStart: external_prop_types_default.a.bool,
    showWeekNumbers: external_prop_types_default.a.bool,
    startDate: external_prop_types_default.a.object,
    utcOffset: external_prop_types_default.a.oneOfType([external_prop_types_default.a.number, external_prop_types_default.a.string]),
    renderDayContents: external_prop_types_default.a.func
  };
  var es_Time = function (_React$Component) {
    inherits(Time, _React$Component);
    function Time() {
      var _temp, _this, _ret;
      classCallCheck(this, Time);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
        if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
          return;
        }
        _this.props.onChange(time);
      }, _this.liClasses = function (time, currH, currM) {
        var classes = ["react-datepicker__time-list-item"];
        if (currH === getHour(time) && currM === getMinute(time)) {
          classes.push("react-datepicker__time-list-item--selected");
        }
        if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
          classes.push("react-datepicker__time-list-item--disabled");
        }
        if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
          classes.push("react-datepicker__time-list-item--injected");
        }
        return classes.join(" ");
      }, _this.renderTimes = function () {
        var times = [];
        var format = _this.props.format ? _this.props.format : "hh:mm A";
        var intervals = _this.props.intervals;
        var activeTime = _this.props.selected ? _this.props.selected : newDate();
        var currH = getHour(activeTime);
        var currM = getMinute(activeTime);
        var base = getStartOfDay(newDate());
        var multiplier = 1440 / intervals;
        var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
          return a - b;
        });
        for (var i = 0; i < multiplier; i++) {
          var currentTime = addMinutes(cloneDate(base), i * intervals);
          times.push(currentTime);
          if (sortedInjectTimes) {
            var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
            times = times.concat(timesToInject);
          }
        }
        return times.map(function (time, i) {
          return external_react_default.a.createElement("li", {
            key: i,
            onClick: _this.handleClick.bind(_this, time),
            className: _this.liClasses(time, currH, currM),
            ref: function ref(li) {
              if (currH === getHour(time) && currM === getMinute(time) || currH === getHour(time) && !_this.centerLi) {
                _this.centerLi = li;
              }
            }
          }, formatDate(time, format));
        });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }
    Time.prototype.componentDidMount = function componentDidMount() {
      // code to ensure selected time will always be in focus within time window when it first appears
      this.list.scrollTop = Time.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi);
    };
    Time.prototype.render = function render() {
      var _this2 = this;
      var height = null;
      if (this.props.monthRef && this.header) {
        height = this.props.monthRef.clientHeight - this.header.clientHeight;
      }
      return external_react_default.a.createElement("div", {
        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      }, external_react_default.a.createElement("div", {
        className: "react-datepicker__header react-datepicker__header--time",
        ref: function ref(header) {
          _this2.header = header;
        }
      }, external_react_default.a.createElement("div", {
        className: "react-datepicker-time__header"
      }, this.props.timeCaption)), external_react_default.a.createElement("div", {
        className: "react-datepicker__time"
      }, external_react_default.a.createElement("div", {
        className: "react-datepicker__time-box"
      }, external_react_default.a.createElement("ul", {
        className: "react-datepicker__time-list",
        ref: function ref(list) {
          _this2.list = list;
        },
        style: height ? {
          height: height
        } : {}
      }, this.renderTimes.bind(this)()))));
    };
    createClass(Time, null, [{
      key: "defaultProps",
      get: function get$$1() {
        return {
          intervals: 30,
          onTimeChange: function onTimeChange() {},
          todayButton: null,
          timeCaption: "Time"
        };
      }
    }]);
    return Time;
  }(external_react_default.a.Component);
  es_Time.propTypes = {
    format: external_prop_types_default.a.string,
    includeTimes: external_prop_types_default.a.array,
    intervals: external_prop_types_default.a.number,
    selected: external_prop_types_default.a.object,
    onChange: external_prop_types_default.a.func,
    todayButton: external_prop_types_default.a.node,
    minTime: external_prop_types_default.a.object,
    maxTime: external_prop_types_default.a.object,
    excludeTimes: external_prop_types_default.a.array,
    monthRef: external_prop_types_default.a.object,
    timeCaption: external_prop_types_default.a.string,
    injectTimes: external_prop_types_default.a.array
  };
  es_Time.calcCenterPosition = function (listHeight, centerLiRef) {
    return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
  };
  function CalendarContainer(_ref) {
    var className = _ref.className,
      children = _ref.children,
      _ref$arrowProps = _ref.arrowProps,
      arrowProps = _ref$arrowProps === undefined ? {} : _ref$arrowProps;
    return external_react_default.a.createElement("div", {
      className: className
    }, external_react_default.a.createElement("div", _extends({
      className: "react-datepicker__triangle"
    }, arrowProps)), children);
  }
  CalendarContainer.propTypes = {
    className: external_prop_types_default.a.string,
    children: external_prop_types_default.a.node,
    arrowProps: external_prop_types_default.a.object // react-popper arrow props
  };

  var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];
  var isDropdownSelect = function isDropdownSelect() {
    var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var classNames = (element.className || "").split(/\s+/);
    return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
      return classNames.indexOf(testClassname) >= 0;
    });
  };
  var es_Calendar = function (_React$Component) {
    inherits(Calendar, _React$Component);
    createClass(Calendar, null, [{
      key: "defaultProps",
      get: function get$$1() {
        return {
          onDropdownFocus: function onDropdownFocus() {},
          monthsShown: 1,
          forceShowMonthNavigation: false,
          timeCaption: "Time",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month"
        };
      }
    }]);
    function Calendar(props) {
      classCallCheck(this, Calendar);
      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
      _this.handleClickOutside = function (event) {
        _this.props.onClickOutside(event);
      };
      _this.handleDropdownFocus = function (event) {
        if (isDropdownSelect(event.target)) {
          _this.props.onDropdownFocus();
        }
      };
      _this.getDateInView = function () {
        var _this$props = _this.props,
          preSelection = _this$props.preSelection,
          selected = _this$props.selected,
          openToDate = _this$props.openToDate,
          utcOffset = _this$props.utcOffset;
        var minDate = getEffectiveMinDate(_this.props);
        var maxDate = getEffectiveMaxDate(_this.props);
        var current = now(utcOffset);
        var initialDate = openToDate || selected || preSelection;
        if (initialDate) {
          return initialDate;
        } else {
          if (minDate && isBefore(current, minDate)) {
            return minDate;
          } else if (maxDate && isAfter(current, maxDate)) {
            return maxDate;
          }
        }
        return current;
      };
      _this.localizeDate = function (date) {
        return localizeDate(date, _this.props.locale);
      };
      _this.increaseMonth = function () {
        _this.setState({
          date: addMonths(cloneDate(_this.state.date), 1)
        }, function () {
          return _this.handleMonthChange(_this.state.date);
        });
      };
      _this.decreaseMonth = function () {
        _this.setState({
          date: subtractMonths(cloneDate(_this.state.date), 1)
        }, function () {
          return _this.handleMonthChange(_this.state.date);
        });
      };
      _this.handleDayClick = function (day, event) {
        return _this.props.onSelect(day, event);
      };
      _this.handleDayMouseEnter = function (day) {
        return _this.setState({
          selectingDate: day
        });
      };
      _this.handleMonthMouseLeave = function () {
        return _this.setState({
          selectingDate: null
        });
      };
      _this.handleYearChange = function (date) {
        if (_this.props.onYearChange) {
          _this.props.onYearChange(date);
        }
      };
      _this.handleMonthChange = function (date) {
        if (_this.props.onMonthChange) {
          _this.props.onMonthChange(date);
        }
        if (_this.props.adjustDateOnChange) {
          if (_this.props.onSelect) {
            _this.props.onSelect(date);
          }
          if (_this.props.setOpen) {
            _this.props.setOpen(true);
          }
        }
      };
      _this.handleMonthYearChange = function (date) {
        _this.handleYearChange(date);
        _this.handleMonthChange(date);
      };
      _this.changeYear = function (year) {
        _this.setState({
          date: setYear(cloneDate(_this.state.date), year)
        }, function () {
          return _this.handleYearChange(_this.state.date);
        });
      };
      _this.changeMonth = function (month) {
        _this.setState({
          date: setMonth(cloneDate(_this.state.date), month)
        }, function () {
          return _this.handleMonthChange(_this.state.date);
        });
      };
      _this.changeMonthYear = function (monthYear) {
        _this.setState({
          date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
        }, function () {
          return _this.handleMonthYearChange(_this.state.date);
        });
      };
      _this.header = function () {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
        var startOfWeek = getStartOfWeek(cloneDate(date));
        var dayNames = [];
        if (_this.props.showWeekNumbers) {
          dayNames.push(external_react_default.a.createElement("div", {
            key: "W",
            className: "react-datepicker__day-name"
          }, _this.props.weekLabel || "#"));
        }
        return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
          var day = addDays(cloneDate(startOfWeek), offset);
          var localeData = getLocaleData(day);
          var weekDayName = _this.formatWeekday(localeData, day);
          return external_react_default.a.createElement("div", {
            key: offset,
            className: "react-datepicker__day-name"
          }, weekDayName);
        }));
      };
      _this.formatWeekday = function (localeData, day) {
        if (_this.props.formatWeekDay) {
          return getFormattedWeekdayInLocale(localeData, day, _this.props.formatWeekDay);
        }
        return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
      };
      _this.renderPreviousMonthButton = function () {
        if (_this.props.renderCustomHeader) {
          return;
        }
        var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);
        if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
          return;
        }
        var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];
        var clickHandler = _this.decreaseMonth;
        if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
          classes.push("react-datepicker__navigation--previous--disabled");
          clickHandler = null;
        }
        return external_react_default.a.createElement("button", {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        }, _this.props.previousMonthButtonLabel);
      };
      _this.renderNextMonthButton = function () {
        if (_this.props.renderCustomHeader) {
          return;
        }
        var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);
        if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
          return;
        }
        var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
        if (_this.props.showTimeSelect) {
          classes.push("react-datepicker__navigation--next--with-time");
        }
        if (_this.props.todayButton) {
          classes.push("react-datepicker__navigation--next--with-today-button");
        }
        var clickHandler = _this.increaseMonth;
        if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
          classes.push("react-datepicker__navigation--next--disabled");
          clickHandler = null;
        }
        return external_react_default.a.createElement("button", {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        }, _this.props.nextMonthButtonLabel);
      };
      _this.renderCurrentMonth = function () {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
        var classes = ["react-datepicker__current-month"];
        if (_this.props.showYearDropdown) {
          classes.push("react-datepicker__current-month--hasYearDropdown");
        }
        if (_this.props.showMonthDropdown) {
          classes.push("react-datepicker__current-month--hasMonthDropdown");
        }
        if (_this.props.showMonthYearDropdown) {
          classes.push("react-datepicker__current-month--hasMonthYearDropdown");
        }
        return external_react_default.a.createElement("div", {
          className: classes.join(" ")
        }, formatDate(date, _this.props.dateFormat));
      };
      _this.renderYearDropdown = function () {
        var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!_this.props.showYearDropdown || overrideHide) {
          return;
        }
        return external_react_default.a.createElement(es_YearDropdown, {
          adjustDateOnChange: _this.props.adjustDateOnChange,
          date: _this.state.date,
          onSelect: _this.props.onSelect,
          setOpen: _this.props.setOpen,
          dropdownMode: _this.props.dropdownMode,
          onChange: _this.changeYear,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          year: getYear(_this.state.date),
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber
        });
      };
      _this.renderMonthDropdown = function () {
        var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!_this.props.showMonthDropdown || overrideHide) {
          return;
        }
        return external_react_default.a.createElement(es_MonthDropdown, {
          dropdownMode: _this.props.dropdownMode,
          locale: _this.props.locale,
          dateFormat: _this.props.dateFormat,
          onChange: _this.changeMonth,
          month: getMonth(_this.state.date),
          useShortMonthInDropdown: _this.props.useShortMonthInDropdown
        });
      };
      _this.renderMonthYearDropdown = function () {
        var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!_this.props.showMonthYearDropdown || overrideHide) {
          return;
        }
        return external_react_default.a.createElement(es_MonthYearDropdown, {
          dropdownMode: _this.props.dropdownMode,
          locale: _this.props.locale,
          dateFormat: _this.props.dateFormat,
          onChange: _this.changeMonthYear,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          date: _this.state.date,
          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
        });
      };
      _this.renderTodayButton = function () {
        if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
          return;
        }
        return external_react_default.a.createElement("div", {
          className: "react-datepicker__today-button",
          onClick: function onClick(e) {
            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
          }
        }, _this.props.todayButton);
      };
      _this.renderDefaultHeader = function (_ref) {
        var monthDate = _ref.monthDate,
          i = _ref.i;
        return external_react_default.a.createElement("div", {
          className: "react-datepicker__header"
        }, _this.renderCurrentMonth(monthDate), external_react_default.a.createElement("div", {
          className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
          onFocus: _this.handleDropdownFocus
        }, _this.renderMonthDropdown(i !== 0), _this.renderMonthYearDropdown(i !== 0), _this.renderYearDropdown(i !== 0)), external_react_default.a.createElement("div", {
          className: "react-datepicker__day-names"
        }, _this.header(monthDate)));
      };
      _this.renderCustomHeader = function (_ref2) {
        var monthDate = _ref2.monthDate,
          i = _ref2.i;
        if (i !== 0) {
          return null;
        }
        var prevMonthButtonDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);
        var nextMonthButtonDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);
        return external_react_default.a.createElement("div", {
          className: "react-datepicker__header react-datepicker__header--custom",
          onFocus: _this.props.onDropdownFocus
        }, _this.props.renderCustomHeader(_extends({}, _this.state, {
          changeMonth: _this.changeMonth,
          changeYear: _this.changeYear,
          decreaseMonth: _this.decreaseMonth,
          increaseMonth: _this.increaseMonth,
          prevMonthButtonDisabled: prevMonthButtonDisabled,
          nextMonthButtonDisabled: nextMonthButtonDisabled
        })), external_react_default.a.createElement("div", {
          className: "react-datepicker__day-names"
        }, _this.header(monthDate)));
      };
      _this.renderMonths = function () {
        if (_this.props.showTimeSelectOnly) {
          return;
        }
        var monthList = [];
        for (var i = 0; i < _this.props.monthsShown; ++i) {
          var monthDate = addMonths(cloneDate(_this.state.date), i);
          var monthKey = "month-" + i;
          monthList.push(external_react_default.a.createElement("div", {
            key: monthKey,
            ref: function ref(div) {
              _this.monthContainer = div;
            },
            className: "react-datepicker__month-container"
          }, _this.props.renderCustomHeader ? _this.renderCustomHeader({
            monthDate: monthDate,
            i: i
          }) : _this.renderDefaultHeader({
            monthDate: monthDate,
            i: i
          }), external_react_default.a.createElement(es_Month, {
            day: monthDate,
            dayClassName: _this.props.dayClassName,
            onDayClick: _this.handleDayClick,
            onDayMouseEnter: _this.handleDayMouseEnter,
            onMouseLeave: _this.handleMonthMouseLeave,
            onWeekSelect: _this.props.onWeekSelect,
            formatWeekNumber: _this.props.formatWeekNumber,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.state.selectingDate,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            fixedHeight: _this.props.fixedHeight,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            showWeekNumbers: _this.props.showWeekNumbers,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            peekNextMonth: _this.props.peekNextMonth,
            utcOffset: _this.props.utcOffset,
            renderDayContents: _this.props.renderDayContents,
            disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
          })));
        }
        return monthList;
      };
      _this.renderTimeSection = function () {
        if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) {
          return external_react_default.a.createElement(es_Time, {
            selected: _this.props.selected,
            onChange: _this.props.onTimeChange,
            format: _this.props.timeFormat,
            includeTimes: _this.props.includeTimes,
            intervals: _this.props.timeIntervals,
            minTime: _this.props.minTime,
            maxTime: _this.props.maxTime,
            excludeTimes: _this.props.excludeTimes,
            timeCaption: _this.props.timeCaption,
            todayButton: _this.props.todayButton,
            showMonthDropdown: _this.props.showMonthDropdown,
            showMonthYearDropdown: _this.props.showMonthYearDropdown,
            showYearDropdown: _this.props.showYearDropdown,
            withPortal: _this.props.withPortal,
            monthRef: _this.state.monthContainer,
            injectTimes: _this.props.injectTimes
          });
        }
      };
      _this.state = {
        date: _this.localizeDate(_this.getDateInView()),
        selectingDate: null,
        monthContainer: null
      };
      return _this;
    }
    Calendar.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      // monthContainer height is needed in time component
      // to determine the height for the ul in the time component
      // setState here so height is given after final component
      // layout is rendered
      if (this.props.showTimeSelect) {
        this.assignMonthContainer = function () {
          _this2.setState({
            monthContainer: _this2.monthContainer
          });
        }();
      }
    };
    Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (this.props.preSelection && !isSameDay(this.props.preSelection, prevProps.preSelection)) {
        this.setState({
          date: this.localizeDate(this.props.preSelection)
        });
      } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
        this.setState({
          date: this.localizeDate(this.props.openToDate)
        });
      }
    };
    Calendar.prototype.render = function render() {
      var Container = this.props.container || CalendarContainer;
      return external_react_default.a.createElement(Container, {
        className: classnames_default()("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        })
      }, this.renderPreviousMonthButton(), this.renderNextMonthButton(), this.renderMonths(), this.renderTodayButton(), this.renderTimeSection(), this.props.children);
    };
    return Calendar;
  }(external_react_default.a.Component);
  es_Calendar.propTypes = {
    adjustDateOnChange: external_prop_types_default.a.bool,
    className: external_prop_types_default.a.string,
    children: external_prop_types_default.a.node,
    container: external_prop_types_default.a.func,
    dateFormat: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.array]).isRequired,
    dayClassName: external_prop_types_default.a.func,
    disabledKeyboardNavigation: external_prop_types_default.a.bool,
    dropdownMode: external_prop_types_default.a.oneOf(["scroll", "select"]),
    endDate: external_prop_types_default.a.object,
    excludeDates: external_prop_types_default.a.array,
    filterDate: external_prop_types_default.a.func,
    fixedHeight: external_prop_types_default.a.bool,
    formatWeekNumber: external_prop_types_default.a.func,
    highlightDates: external_prop_types_default.a.instanceOf(Map),
    includeDates: external_prop_types_default.a.array,
    includeTimes: external_prop_types_default.a.array,
    injectTimes: external_prop_types_default.a.array,
    inline: external_prop_types_default.a.bool,
    locale: external_prop_types_default.a.string,
    maxDate: external_prop_types_default.a.object,
    minDate: external_prop_types_default.a.object,
    monthsShown: external_prop_types_default.a.number,
    onClickOutside: external_prop_types_default.a.func.isRequired,
    onMonthChange: external_prop_types_default.a.func,
    onYearChange: external_prop_types_default.a.func,
    forceShowMonthNavigation: external_prop_types_default.a.bool,
    onDropdownFocus: external_prop_types_default.a.func,
    onSelect: external_prop_types_default.a.func.isRequired,
    onWeekSelect: external_prop_types_default.a.func,
    showTimeSelect: external_prop_types_default.a.bool,
    showTimeSelectOnly: external_prop_types_default.a.bool,
    timeFormat: external_prop_types_default.a.string,
    timeIntervals: external_prop_types_default.a.number,
    onTimeChange: external_prop_types_default.a.func,
    minTime: external_prop_types_default.a.object,
    maxTime: external_prop_types_default.a.object,
    excludeTimes: external_prop_types_default.a.array,
    timeCaption: external_prop_types_default.a.string,
    openToDate: external_prop_types_default.a.object,
    peekNextMonth: external_prop_types_default.a.bool,
    scrollableYearDropdown: external_prop_types_default.a.bool,
    scrollableMonthYearDropdown: external_prop_types_default.a.bool,
    preSelection: external_prop_types_default.a.object,
    selected: external_prop_types_default.a.object,
    selectsEnd: external_prop_types_default.a.bool,
    selectsStart: external_prop_types_default.a.bool,
    showMonthDropdown: external_prop_types_default.a.bool,
    showMonthYearDropdown: external_prop_types_default.a.bool,
    showWeekNumbers: external_prop_types_default.a.bool,
    showYearDropdown: external_prop_types_default.a.bool,
    startDate: external_prop_types_default.a.object,
    todayButton: external_prop_types_default.a.node,
    useWeekdaysShort: external_prop_types_default.a.bool,
    formatWeekDay: external_prop_types_default.a.func,
    withPortal: external_prop_types_default.a.bool,
    utcOffset: external_prop_types_default.a.oneOfType([external_prop_types_default.a.number, external_prop_types_default.a.string]),
    weekLabel: external_prop_types_default.a.string,
    yearDropdownItemNumber: external_prop_types_default.a.number,
    setOpen: external_prop_types_default.a.func,
    useShortMonthInDropdown: external_prop_types_default.a.bool,
    showDisabledMonthNavigation: external_prop_types_default.a.bool,
    previousMonthButtonLabel: external_prop_types_default.a.string,
    nextMonthButtonLabel: external_prop_types_default.a.string,
    renderCustomHeader: external_prop_types_default.a.func,
    renderDayContents: external_prop_types_default.a.func
  };
  var popperPlacementPositions = ["bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];
  var es_PopperComponent = function (_React$Component) {
    inherits(PopperComponent, _React$Component);
    function PopperComponent() {
      classCallCheck(this, PopperComponent);
      return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    PopperComponent.prototype.render = function render() {
      var _props = this.props,
        className = _props.className,
        hidePopper = _props.hidePopper,
        popperComponent = _props.popperComponent,
        popperModifiers = _props.popperModifiers,
        popperPlacement = _props.popperPlacement,
        popperProps = _props.popperProps,
        targetComponent = _props.targetComponent;
      var popper = void 0;
      if (!hidePopper) {
        var classes = classnames_default()("react-datepicker-popper", className);
        popper = external_react_default.a.createElement(Popper, _extends({
          modifiers: popperModifiers,
          placement: popperPlacement
        }, popperProps), function (_ref) {
          var ref = _ref.ref,
            style = _ref.style,
            placement = _ref.placement,
            arrowProps = _ref.arrowProps;
          return external_react_default.a.createElement("div", _extends({
            ref: ref,
            style: style
          }, {
            className: classes,
            "data-placement": placement
          }), external_react_default.a.cloneElement(popperComponent, {
            arrowProps: arrowProps
          }));
        });
      }
      if (this.props.popperContainer) {
        popper = external_react_default.a.createElement(this.props.popperContainer, {}, popper);
      }
      return external_react_default.a.createElement(Manager_Manager, null, external_react_default.a.createElement(Reference, null, function (_ref2) {
        var ref = _ref2.ref;
        return external_react_default.a.createElement("div", {
          ref: ref,
          className: "react-datepicker-wrapper"
        }, targetComponent);
      }), popper);
    };
    createClass(PopperComponent, null, [{
      key: "defaultProps",
      get: function get$$1() {
        return {
          hidePopper: true,
          popperModifiers: {
            preventOverflow: {
              enabled: true,
              escapeWithReference: true,
              boundariesElement: "viewport"
            }
          },
          popperProps: {},
          popperPlacement: "bottom-start"
        };
      }
    }]);
    return PopperComponent;
  }(external_react_default.a.Component);
  es_PopperComponent.propTypes = {
    className: external_prop_types_default.a.string,
    hidePopper: external_prop_types_default.a.bool,
    popperComponent: external_prop_types_default.a.element,
    popperModifiers: external_prop_types_default.a.object,
    // <datepicker/> props
    popperPlacement: external_prop_types_default.a.oneOf(popperPlacementPositions),
    // <datepicker/> props
    popperContainer: external_prop_types_default.a.func,
    popperProps: external_prop_types_default.a.object,
    targetComponent: external_prop_types_default.a.element
  };
  var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
  var WrappedCalendar = react_onclickoutside_es(es_Calendar);

  // Compares dates year+month combinations
  function hasPreSelectionChanged(date1, date2) {
    if (date1 && date2) {
      return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
    }
    return date1 !== date2;
  }
  function hasSelectionChanged(date1, date2) {
    if (date1 && date2) {
      return !equals(date1, date2);
    }
    return false;
  }

  /**
   * General datepicker component.
   */
  var INPUT_ERR_1 = "Date input not valid.";
  var es_DatePicker = function (_React$Component) {
    inherits(DatePicker, _React$Component);
    createClass(DatePicker, null, [{
      key: "defaultProps",
      get: function get$$1() {
        return {
          allowSameDay: false,
          dateFormat: "L",
          dateFormatCalendar: "MMMM YYYY",
          onChange: function onChange() {},
          disabled: false,
          disabledKeyboardNavigation: false,
          dropdownMode: "scroll",
          onFocus: function onFocus() {},
          onBlur: function onBlur() {},
          onKeyDown: function onKeyDown() {},
          onInputClick: function onInputClick() {},
          onSelect: function onSelect() {},
          onClickOutside: function onClickOutside$$1() {},
          onMonthChange: function onMonthChange() {},
          preventOpenOnFocus: false,
          onYearChange: function onYearChange() {},
          onInputError: function onInputError() {},
          monthsShown: 1,
          readOnly: false,
          withPortal: false,
          shouldCloseOnSelect: true,
          showTimeSelect: false,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next month",
          renderDayContents: function renderDayContents(date) {
            return date;
          }
        };
      }
    }]);
    function DatePicker(props) {
      classCallCheck(this, DatePicker);
      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
      _this.getPreSelection = function () {
        return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
      };
      _this.calcInitialState = function () {
        var defaultPreSelection = _this.getPreSelection();
        var minDate = getEffectiveMinDate(_this.props);
        var maxDate = getEffectiveMaxDate(_this.props);
        var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
        return {
          open: _this.props.startOpen || false,
          preventFocus: false,
          preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: getHightLightDaysMap(_this.props.highlightDates),
          focused: false
        };
      };
      _this.clearPreventFocusTimeout = function () {
        if (_this.preventFocusTimeout) {
          clearTimeout(_this.preventFocusTimeout);
        }
      };
      _this.setFocus = function () {
        if (_this.input && _this.input.focus) {
          _this.input.focus();
        }
      };
      _this.setBlur = function () {
        if (_this.input && _this.input.blur) {
          _this.input.blur();
        }
        if (_this.props.onBlur) {
          _this.props.onBlur();
        }
        _this.cancelFocusInput();
      };
      _this.setOpen = function (open) {
        var skipSetBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        _this.setState({
          open: open,
          preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
          lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
        }, function () {
          if (!open) {
            _this.setState(function (prev) {
              return {
                focused: skipSetBlur ? prev.focused : false
              };
            }, function () {
              !skipSetBlur && _this.setBlur();
              _this.setState({
                inputValue: null
              });
            });
          }
        });
      };
      _this.inputOk = function () {
        return isMoment(_this.state.preSelection) || isDate(_this.state.preSelection);
      };
      _this.isCalendarOpen = function () {
        return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
      };
      _this.handleFocus = function (event) {
        if (!_this.state.preventFocus) {
          _this.props.onFocus(event);
          if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
            _this.setOpen(true);
          }
        }
        _this.setState({
          focused: true
        });
      };
      _this.cancelFocusInput = function () {
        clearTimeout(_this.inputFocusTimeout);
        _this.inputFocusTimeout = null;
      };
      _this.deferFocusInput = function () {
        _this.cancelFocusInput();
        _this.inputFocusTimeout = setTimeout(function () {
          return _this.setFocus();
        }, 1);
      };
      _this.handleDropdownFocus = function () {
        _this.cancelFocusInput();
      };
      _this.handleBlur = function (event) {
        if (_this.state.open && !_this.props.withPortal) {
          _this.deferFocusInput();
        } else {
          _this.props.onBlur(event);
        }
        _this.setState({
          focused: false
        });
      };
      _this.handleCalendarClickOutside = function (event) {
        if (!_this.props.inline) {
          _this.setOpen(false);
        }
        _this.props.onClickOutside(event);
        if (_this.props.withPortal) {
          event.preventDefault();
        }
      };
      _this.handleChange = function () {
        for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
          allArgs[_key] = arguments[_key];
        }
        var event = allArgs[0];
        if (_this.props.onChangeRaw) {
          _this.props.onChangeRaw.apply(_this, allArgs);
          if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
            return;
          }
        }
        _this.setState({
          inputValue: event.target.value,
          lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
        });
        var date = parseDate(event.target.value, _this.props);
        if (date || !event.target.value) {
          _this.setSelected(date, event, true);
        }
      };
      _this.handleSelect = function (date, event) {
        // Preventing onFocus event to fix issue
        // https://github.com/Hacker0x01/react-datepicker/issues/628
        _this.setState({
          preventFocus: true
        }, function () {
          _this.preventFocusTimeout = setTimeout(function () {
            return _this.setState({
              preventFocus: false
            });
          }, 50);
          return _this.preventFocusTimeout;
        });
        _this.setSelected(date, event);
        if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
          _this.setPreSelection(date);
        } else if (!_this.props.inline) {
          _this.setOpen(false);
        }
      };
      _this.setSelected = function (date, event, keepInput) {
        var changedDate = date;
        if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
          if (isOutOfBounds(changedDate, _this.props)) {
            _this.props.onChange(date, event);
            _this.props.onSelect(changedDate, event);
          }
          return;
        }
        if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
          if (changedDate !== null) {
            if (_this.props.selected) {
              var selected = _this.props.selected;
              if (keepInput) selected = newDate(changedDate);
              changedDate = setTime(newDate(changedDate), {
                hour: getHour(selected),
                minute: getMinute(selected),
                second: getSecond(selected)
              });
            }
            if (!_this.props.inline) {
              _this.setState({
                preSelection: changedDate
              });
            }
          }
          _this.props.onChange(changedDate, event);
        }
        _this.props.onSelect(changedDate, event);
        if (!keepInput) {
          _this.setState({
            inputValue: null
          });
        }
      };
      _this.setPreSelection = function (date) {
        var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
        var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
        if (isValidDateSelection) {
          _this.setState({
            preSelection: date
          });
        }
      };
      _this.handleTimeChange = function (time) {
        var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
        var changedDate = setTime(cloneDate(selected), {
          hour: getHour(time),
          minute: getMinute(time)
        });
        _this.setState({
          preSelection: changedDate
        });
        _this.props.onChange(changedDate);
        if (_this.props.shouldCloseOnSelect) {
          _this.setOpen(false);
        }
        _this.setState({
          inputValue: null
        });
      };
      _this.onInputClick = function () {
        if (!_this.props.disabled && !_this.props.readOnly) {
          _this.setOpen(true);
        }
        _this.props.onInputClick();
      };
      _this.onInputKeyDown = function (event) {
        _this.props.onKeyDown(event);
        var eventKey = event.key;
        if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
          if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
            _this.onInputClick();
          }
          return;
        }
        var copy = newDate(_this.state.preSelection);
        if (eventKey === "Enter") {
          event.preventDefault();
          if (_this.inputOk() && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
            _this.handleSelect(copy, event);
            !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
          } else {
            _this.setOpen(false);
          }
        } else if (eventKey === "Escape") {
          event.preventDefault();
          _this.setOpen(false);
          if (!_this.inputOk()) {
            _this.props.onInputError({
              code: 1,
              msg: INPUT_ERR_1
            });
          }
        } else if (eventKey === "Tab") {
          _this.setOpen(false, true);
        } else if (!_this.props.disabledKeyboardNavigation) {
          var newSelection = void 0;
          switch (eventKey) {
            case "ArrowLeft":
              newSelection = subtractDays(copy, 1);
              break;
            case "ArrowRight":
              newSelection = addDays(copy, 1);
              break;
            case "ArrowUp":
              newSelection = subtractWeeks(copy, 1);
              break;
            case "ArrowDown":
              newSelection = addWeeks(copy, 1);
              break;
            case "PageUp":
              newSelection = subtractMonths(copy, 1);
              break;
            case "PageDown":
              newSelection = addMonths(copy, 1);
              break;
            case "Home":
              newSelection = subtractYears(copy, 1);
              break;
            case "End":
              newSelection = addYears(copy, 1);
              break;
          }
          if (!newSelection) {
            if (_this.props.onInputError) {
              _this.props.onInputError({
                code: 1,
                msg: INPUT_ERR_1
              });
            }
            return; // Let the input component handle this keydown
          }

          event.preventDefault();
          _this.setState({
            lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
          });
          if (_this.props.adjustDateOnChange) {
            _this.setSelected(newSelection);
          }
          _this.setPreSelection(newSelection);
        }
      };
      _this.onClearClick = function (event) {
        if (event) {
          if (event.preventDefault) {
            event.preventDefault();
          }
        }
        _this.props.onChange(null, event);
        _this.setState({
          inputValue: null
        });
      };
      _this.clear = function () {
        _this.onClearClick();
      };
      _this.renderCalendar = function () {
        if (!_this.props.inline && !_this.isCalendarOpen()) {
          return null;
        }
        return external_react_default.a.createElement(WrappedCalendar, {
          ref: function ref(elem) {
            _this.calendar = elem;
          },
          locale: _this.props.locale,
          adjustDateOnChange: _this.props.adjustDateOnChange,
          setOpen: _this.setOpen,
          dateFormat: _this.props.dateFormatCalendar,
          useWeekdaysShort: _this.props.useWeekdaysShort,
          formatWeekDay: _this.props.formatWeekDay,
          dropdownMode: _this.props.dropdownMode,
          selected: _this.props.selected,
          preSelection: _this.state.preSelection,
          onSelect: _this.handleSelect,
          onWeekSelect: _this.props.onWeekSelect,
          openToDate: _this.props.openToDate,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          onClickOutside: _this.handleCalendarClickOutside,
          formatWeekNumber: _this.props.formatWeekNumber,
          highlightDates: _this.state.highlightDates,
          includeDates: _this.props.includeDates,
          includeTimes: _this.props.includeTimes,
          injectTimes: _this.props.injectTimes,
          inline: _this.props.inline,
          peekNextMonth: _this.props.peekNextMonth,
          showMonthDropdown: _this.props.showMonthDropdown,
          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showWeekNumbers: _this.props.showWeekNumbers,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
          todayButton: _this.props.todayButton,
          weekLabel: _this.props.weekLabel,
          utcOffset: _this.props.utcOffset,
          outsideClickIgnoreClass: outsideClickIgnoreClass,
          fixedHeight: _this.props.fixedHeight,
          monthsShown: _this.props.monthsShown,
          onDropdownFocus: _this.handleDropdownFocus,
          onMonthChange: _this.props.onMonthChange,
          onYearChange: _this.props.onYearChange,
          dayClassName: _this.props.dayClassName,
          showTimeSelect: _this.props.showTimeSelect,
          showTimeSelectOnly: _this.props.showTimeSelectOnly,
          onTimeChange: _this.handleTimeChange,
          timeFormat: _this.props.timeFormat,
          timeIntervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          className: _this.props.calendarClassName,
          container: _this.props.calendarContainer,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
          previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
          nextMonthButtonLabel: _this.props.nextMonthButtonLabel,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          renderCustomHeader: _this.props.renderCustomHeader,
          popperProps: _this.props.popperProps,
          renderDayContents: _this.props.renderDayContents
        }, _this.props.children);
      };
      _this.renderDateInput = function () {
        var _classnames, _React$cloneElement;
        var className = classnames_default()(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));
        var customInput = _this.props.customInput || external_react_default.a.createElement("input", {
          type: "text"
        });
        var customInputRef = _this.props.customInputRef || "ref";
        var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);
        return external_react_default.a.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
          _this.input = input;
        }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
      };
      _this.renderClearButton = function () {
        if (_this.props.isClearable && _this.props.selected != null) {
          return external_react_default.a.createElement("button", {
            type: "button",
            className: "react-datepicker__close-icon",
            onClick: _this.onClearClick,
            title: _this.props.clearButtonTitle,
            tabIndex: -1
          });
        } else {
          return null;
        }
      };
      _this.state = _this.calcInitialState();
      return _this;
    }
    DatePicker.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
        this.setPreSelection(this.props.selected);
      }
      if (prevProps.highlightDates !== this.props.highlightDates) {
        this.setState({
          highlightDates: getHightLightDaysMap(this.props.highlightDates)
        });
      }
      if (!prevState.focused && hasSelectionChanged(prevProps.selected, this.props.selected)) {
        this.setState({
          inputValue: null
        });
      }
    };
    DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
      this.clearPreventFocusTimeout();
    };
    DatePicker.prototype.render = function render() {
      var calendar = this.renderCalendar();
      if (this.props.inline && !this.props.withPortal) {
        return calendar;
      }
      if (this.props.withPortal) {
        return external_react_default.a.createElement("div", null, !this.props.inline ? external_react_default.a.createElement("div", {
          className: "react-datepicker__input-container"
        }, this.renderDateInput(), this.renderClearButton()) : null, this.state.open || this.props.inline ? external_react_default.a.createElement("div", {
          className: "react-datepicker__portal"
        }, calendar) : null);
      }
      return external_react_default.a.createElement(es_PopperComponent, {
        className: this.props.popperClassName,
        hidePopper: !this.isCalendarOpen(),
        popperModifiers: this.props.popperModifiers,
        targetComponent: external_react_default.a.createElement("div", {
          className: "react-datepicker__input-container"
        }, this.renderDateInput(), this.renderClearButton()),
        popperContainer: this.props.popperContainer,
        popperComponent: calendar,
        popperPlacement: this.props.popperPlacement,
        popperProps: this.props.popperProps
      });
    };
    return DatePicker;
  }(external_react_default.a.Component);
  es_DatePicker.propTypes = {
    adjustDateOnChange: external_prop_types_default.a.bool,
    allowSameDay: external_prop_types_default.a.bool,
    autoComplete: external_prop_types_default.a.string,
    autoFocus: external_prop_types_default.a.bool,
    calendarClassName: external_prop_types_default.a.string,
    calendarContainer: external_prop_types_default.a.func,
    children: external_prop_types_default.a.node,
    className: external_prop_types_default.a.string,
    customInput: external_prop_types_default.a.element,
    customInputRef: external_prop_types_default.a.string,
    // eslint-disable-next-line react/no-unused-prop-types
    dateFormat: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.array]),
    dateFormatCalendar: external_prop_types_default.a.string,
    dayClassName: external_prop_types_default.a.func,
    disabled: external_prop_types_default.a.bool,
    disabledKeyboardNavigation: external_prop_types_default.a.bool,
    dropdownMode: external_prop_types_default.a.oneOf(["scroll", "select"]).isRequired,
    endDate: external_prop_types_default.a.object,
    excludeDates: external_prop_types_default.a.array,
    filterDate: external_prop_types_default.a.func,
    fixedHeight: external_prop_types_default.a.bool,
    formatWeekNumber: external_prop_types_default.a.func,
    highlightDates: external_prop_types_default.a.array,
    id: external_prop_types_default.a.string,
    includeDates: external_prop_types_default.a.array,
    includeTimes: external_prop_types_default.a.array,
    injectTimes: external_prop_types_default.a.array,
    inline: external_prop_types_default.a.bool,
    isClearable: external_prop_types_default.a.bool,
    locale: external_prop_types_default.a.string,
    maxDate: external_prop_types_default.a.object,
    minDate: external_prop_types_default.a.object,
    monthsShown: external_prop_types_default.a.number,
    name: external_prop_types_default.a.string,
    onBlur: external_prop_types_default.a.func,
    onChange: external_prop_types_default.a.func.isRequired,
    onSelect: external_prop_types_default.a.func,
    onWeekSelect: external_prop_types_default.a.func,
    onClickOutside: external_prop_types_default.a.func,
    onChangeRaw: external_prop_types_default.a.func,
    onFocus: external_prop_types_default.a.func,
    onInputClick: external_prop_types_default.a.func,
    onKeyDown: external_prop_types_default.a.func,
    onMonthChange: external_prop_types_default.a.func,
    onYearChange: external_prop_types_default.a.func,
    onInputError: external_prop_types_default.a.func,
    open: external_prop_types_default.a.bool,
    openToDate: external_prop_types_default.a.object,
    peekNextMonth: external_prop_types_default.a.bool,
    placeholderText: external_prop_types_default.a.string,
    popperContainer: external_prop_types_default.a.func,
    popperClassName: external_prop_types_default.a.string,
    // <PopperComponent/> props
    popperModifiers: external_prop_types_default.a.object,
    // <PopperComponent/> props
    popperPlacement: external_prop_types_default.a.oneOf(popperPlacementPositions),
    // <PopperComponent/> props
    popperProps: external_prop_types_default.a.object,
    preventOpenOnFocus: external_prop_types_default.a.bool,
    readOnly: external_prop_types_default.a.bool,
    required: external_prop_types_default.a.bool,
    scrollableYearDropdown: external_prop_types_default.a.bool,
    scrollableMonthYearDropdown: external_prop_types_default.a.bool,
    selected: external_prop_types_default.a.object,
    selectsEnd: external_prop_types_default.a.bool,
    selectsStart: external_prop_types_default.a.bool,
    showMonthDropdown: external_prop_types_default.a.bool,
    showMonthYearDropdown: external_prop_types_default.a.bool,
    showWeekNumbers: external_prop_types_default.a.bool,
    showYearDropdown: external_prop_types_default.a.bool,
    forceShowMonthNavigation: external_prop_types_default.a.bool,
    showDisabledMonthNavigation: external_prop_types_default.a.bool,
    startDate: external_prop_types_default.a.object,
    startOpen: external_prop_types_default.a.bool,
    tabIndex: external_prop_types_default.a.number,
    timeCaption: external_prop_types_default.a.string,
    title: external_prop_types_default.a.string,
    todayButton: external_prop_types_default.a.node,
    useWeekdaysShort: external_prop_types_default.a.bool,
    formatWeekDay: external_prop_types_default.a.func,
    utcOffset: external_prop_types_default.a.oneOfType([external_prop_types_default.a.number, external_prop_types_default.a.string]),
    value: external_prop_types_default.a.string,
    weekLabel: external_prop_types_default.a.string,
    withPortal: external_prop_types_default.a.bool,
    yearDropdownItemNumber: external_prop_types_default.a.number,
    shouldCloseOnSelect: external_prop_types_default.a.bool,
    showTimeSelect: external_prop_types_default.a.bool,
    showTimeSelectOnly: external_prop_types_default.a.bool,
    timeFormat: external_prop_types_default.a.string,
    timeIntervals: external_prop_types_default.a.number,
    minTime: external_prop_types_default.a.object,
    maxTime: external_prop_types_default.a.object,
    excludeTimes: external_prop_types_default.a.array,
    useShortMonthInDropdown: external_prop_types_default.a.bool,
    clearButtonTitle: external_prop_types_default.a.string,
    previousMonthButtonLabel: external_prop_types_default.a.string,
    nextMonthButtonLabel: external_prop_types_default.a.string,
    renderCustomHeader: external_prop_types_default.a.func,
    renderDayContents: external_prop_types_default.a.func
  };
  var PRESELECT_CHANGE_VIA_INPUT = "input";
  var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";

  /* harmony default export */
  var es = __webpack_exports__["default"] = es_DatePicker;

  /***/
}, /* 242 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ProgressIndicator;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  __webpack_require__(448);
  __webpack_require__(55);
  __webpack_require__(450);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function ProgressIndicator(_ref) {
    var description = _ref.description,
      isLoading = _ref.isLoading,
      message = _ref.message,
      icon = _ref.icon,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$isOpaque = _ref.isOpaque,
      isOpaque = _ref$isOpaque === void 0 ? false : _ref$isOpaque;
    if (!isLoading) {
      return null;
    }
    var cln = "progress-indicator ".concat(className);
    if (isOpaque) {
      cln += " is-opaque";
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cln,
      title: message
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: icon,
      className: "generating-circle"
    }), !!description ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "description"
    }, description) : null);
  }
  ProgressIndicator.defaultProps = {
    description: "",
    icon: "fas fa-circle-notch",
    isLoading: true,
    message: ""
  };
  ProgressIndicator.propTypes = {
    /** a description of the loading action to display under the icon */
    description: _propTypes["default"].string,
    /** Icon to display and animate */
    icon: _propTypes["default"].string,
    /** should the isLoading class be added? */
    isLoading: _propTypes["default"].bool.isRequired,
    /** Tool-tip message to display on mouse hover */
    message: _propTypes["default"].string
  };

  /***/
}, /* 243 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  // Convenience main entrypoint if you are running with destructuring support:
  //
  //   import {VelocityComponent, VelocityTransitionGroup} from 'velocity-react';
  //
  // You can also require just the component(s) you're using:
  //
  //   var VelocityComponent = require('velocity-react/velocity-component');
  //
  // Note that if you want to use UI Pack you will need to require 'velocity' and
  // 'velocity.ui' at a top level in your app:
  //
  //   require('velocity');
  //   require('velocity-animate/velocity.ui');
  module.exports = {
    VelocityComponent: __webpack_require__(251),
    VelocityTransitionGroup: __webpack_require__(346),
    velocityHelpers: __webpack_require__(371)
  };

  /***/
}, /* 244 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(411);

  /***/
}, /* 245 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Content = Content;
  exports.Header = Header;
  exports["default"] = NewCard;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _reactTooltip = _interopRequireDefault(__webpack_require__(60));
  var _web = __webpack_require__(372);
  var _functions = __webpack_require__(33);
  var _generateUnique = _interopRequireDefault(__webpack_require__(56));
  var _EnhancedTooltip = _interopRequireDefault(__webpack_require__(58));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  /**
   * The NewCard's isOpen status can be controlled by using state in the parent component.
   *
   * If you don't need to track/manage the state of the card, omit the setIsOpen prop
   * and the card will manage its own internal state. (You may also omit the isOpen prop,
   * and the card will default to initiating in a closed state.) Set isOpen to true if
   * you'd like the card to initiate in an open state.
   *
   * ----------------------------------------------------------------
   * Example card with INTERNALLY managed state, initiating open: ***
   * ----------------------------------------------------------------
   * export function TestParentFunc() {
   * 	return (
   * 		<NewCard
   * 			header="Func Card"
   * 			isOpen
   * 		>
   * 			Card Contents
   * 		</NewCard>
   * 	);
   * }
   *
   *
   * -------------------------------------------------------------------------
   *** Example of EXTERNALLY managed state by FUNCTIONAL parent component: ***
   * -------------------------------------------------------------------------
   * export function TestParentFunc() {
   * 	const [isOpen, setIsOpen]= useState(true);
   *
   * 	return (
   * 		<NewCard
   * 			header="Func Card"
   * 			isOpen={isOpen}
   * 			setIsOpen={setIsOpen}
   * 		>
   * 			Card Contents
   * 		</NewCard>
   * 	);
   * }
   *
   *
   * --------------------------------------------------------------------
   *** Example of EXTERNALLY managed state by CLASS parent component: ***
   * --------------------------------------------------------------------
   * export class TestParentClass extends Component {
   *
   * 	state = {
   * 		isOpen: true,
   * 	}
   *
   * 	render(){
   * 		let { state, props } = this;
   * 		return (
   * 			<NewCard
   * 				header="Class Card"
   * 				isCollapsible={true}
   * 				isOpen={state.isOpen}
   * 				setIsOpen={()=>this.setState((state) => {
   * 					return { isOpen: !state.isOpen };
   * 				})}
   * 			>
   * 				Card Contents
   * 			</NewCard>
   * 		);
   *  }
   * }
   *
   */

  function Header(_ref) {
    var isOpen = _ref.isOpen,
      header = _ref.header,
      tip = _ref.tip,
      toggleCard = _ref.toggleCard,
      isCollapsible = _ref.isCollapsible;
    var styles = (0, _web.useSpring)({
      transform: isOpen ? "rotate(90deg)" : "rotate(0deg)"
    });
    var tooltip = null,
      caret = null,
      className = "card-header flex-center",
      handleClick = _functions.noop;
    var UID = (0, _react.useMemo)(function () {
      return (0, _generateUnique["default"])({});
    }, []);
    if (tip) {
      tooltip = /*#__PURE__*/_react["default"].createElement("div", {
        className: "u-form__help"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "fa fa-info-circle flex-center card-tip",
        "data-for": UID,
        "data-tip": true
      }), /*#__PURE__*/_react["default"].createElement(_EnhancedTooltip["default"], _extends({}, tip, {
        id: UID
      })));
    }
    if (isCollapsible) {
      var caretTip = isOpen ? "Collapse Content" : "Expand Content";
      caret = /*#__PURE__*/_react["default"].createElement(_web.animated.i, {
        className: "fa fa-caret-square-right",
        style: styles,
        title: caretTip
      });
      handleClick = toggleCard;
      className = className.concat(" collapsible cursor-pointer");
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: className,
      onClick: handleClick
    }, caret, /*#__PURE__*/_react["default"].createElement("div", {
      className: "card-title"
    }, header), tooltip);
  }
  function Content(_ref2) {
    var _ref$current2;
    var isOpen = _ref2.isOpen,
      content = _ref2.content;
    var ref = (0, _react.useRef)(null);
    var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      contentHeight = _useState2[0],
      setContentHeight = _useState2[1];
    var styles = (0, _web.useSpring)({
      height: isOpen ? contentHeight : 0,
      overflow: "hidden"
    });
    (0, _react.useEffect)(function () {
      var _ref$current;
      setContentHeight(ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientHeight);
    }, [ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.clientHeight, content]);

    /*
    	This "card-content" and "card-content-wrapper" combo (below) exists because we
    	use/reference the "card-content" height (contentHeight) to dynamically grow/open
    	the "card-content-wrapper" to the appropriate height when the card isOpen.
    		You can't add margin/padding to the wrapper (bc it won't "hide" on !isOpen),
    	but you can add padding to "card-content" to create any spacing you need.
    */
    return /*#__PURE__*/_react["default"].createElement(_web.animated.div, {
      className: "card-content-wrapper",
      style: styles
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: ref,
      className: "card-content"
    }, content));
  }
  function NewCard(props) {
    var header = props.header,
      tip = props.tip,
      className = props.className,
      children = props.children,
      isOpen = props.isOpen,
      setIsOpen = props.setIsOpen,
      isCollapsible = props.isCollapsible,
      onToggle = props.onToggle;
    var _useState3 = (0, _react.useState)(isOpen),
      _useState4 = _slicedToArray(_useState3, 2),
      internalState = _useState4[0],
      setInternalState = _useState4[1];
    if (setIsOpen === null) {
      setIsOpen = setInternalState;
      isOpen = internalState;
    }
    (0, _react.useEffect)(function () {
      _reactTooltip["default"].rebuild();
    }, []);
    function toggleCard() {
      onToggle();
      setIsOpen(!isOpen);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(className, " card-wrapper")
    }, /*#__PURE__*/_react["default"].createElement(Header, {
      header: header,
      tip: tip,
      toggleCard: toggleCard,
      isOpen: isOpen,
      isCollapsible: isCollapsible
    }), /*#__PURE__*/_react["default"].createElement(Content, {
      isOpen: isOpen,
      content: children
    }));
  }
  NewCard.displayName = "NewCard";
  NewCard.defaultProps = {
    header: "Oh, wow! What an amazing card title this is.",
    tip: null,
    isCollapsible: true,
    isOpen: false,
    setIsOpen: null,
    onToggle: _functions.noop,
    className: ""
  };
  NewCard.propTypes = {
    /** The title of the card, can be string or valid React renderable element*/
    header: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
    /** if we want to show a tooltip after the header title */
    tip: _propTypes["default"].shape({
      /** Text or JSX content rendered inside of the tooltip */
      content: _propTypes["default"].any,
      /** What is the placement of the tooltip */
      place: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left']),
      /** Sets the general theme and style of the tooltip */
      type: _propTypes["default"].oneOf(['dark', 'success', 'warning', 'error', 'info', 'light']),
      /** Tooltip moves with cursor or holds position */
      effect: _propTypes["default"].oneOf(['float', 'solid'])
    }),
    /** Optional custom class name to add to this component */
    className: _propTypes["default"].string,
    /** Can the card be opened/closed, or is it permanently open? */
    isCollapsible: _propTypes["default"].bool,
    /** Do we want/need to do anything when we toggle the card open/closed? */
    onToggle: _propTypes["default"].func,
    /** Is the card open/closed? */
    isOpen: _propTypes["default"].bool,
    /** The setState function from the parent component. */
    setIsOpen: _propTypes["default"].func
  };

  /***/
}, /* 246 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = VerticalContent;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _socialHelpers = __webpack_require__(46);
  var _FacebookMedia = _interopRequireDefault(__webpack_require__(173));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function VerticalContent(props) {
    var cta = props.cta,
      placementType = props.placementType,
      primaryText = props.primaryText;
    var reelsClass = placementType === _socialHelpers.FT_ASPECT_RATIOS.REEL ? "reels" : "";
    var reelsPrimaryTxt = placementType === _socialHelpers.FT_ASPECT_RATIOS.REEL ? primaryText : null;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview vertical ".concat(reelsClass)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fal fa-times",
      className: "close"
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, reelsPrimaryTxt)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle-icon-bar"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle-icon"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle-icon"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle-icon"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle-icon"
    })), /*#__PURE__*/_react["default"].createElement(_FacebookMedia["default"], props), (cta === null || cta === void 0 ? void 0 : cta.name) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "cta-label"
    }, cta === null || cta === void 0 ? void 0 : cta.name)));
  }
  VerticalContent.displayName = "VerticalContent";

  /***/
}, /* 247 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = StandardContent;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _FacebookMedia = _interopRequireDefault(__webpack_require__(173));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function StandardContent(props) {
    var primaryText = props.primaryText,
      displayLink = props.displayLink,
      headline = props.headline,
      description = props.description,
      cta = props.cta;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-text"
    }, /*#__PURE__*/_react["default"].createElement("span", null, primaryText)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, /*#__PURE__*/_react["default"].createElement(_FacebookMedia["default"], props)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-grey-box"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "grey-text"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-1 display-link"
    }, displayLink), /*#__PURE__*/_react["default"].createElement("br", null), headline ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-2"
    }, headline) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "headline-skeleton"
    }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-3"
    }, description)), (cta === null || cta === void 0 ? void 0 : cta.name) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "cta-label"
    }, /*#__PURE__*/_react["default"].createElement("span", null, cta === null || cta === void 0 ? void 0 : cta.name))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "bottom-section"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    })));
  }
  StandardContent.displayName = "StandardContent";

  /***/
}, /* 248 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.default = function (obj, keys) {
    var target = {};
    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }
    return target;
  };

  /***/
}, /* 249 */
/***/function (module, exports, __webpack_require__) {
  var store = __webpack_require__(481)('wks');
  var uid = __webpack_require__(465);
  var Symbol = __webpack_require__(394).Symbol;
  var USE_SYMBOL = typeof Symbol == 'function';
  var $exports = module.exports = function (name) {
    return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
  };
  $exports.store = store;

  /***/
}, /* 250 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = EmptyGrid;
  var _react = _interopRequireDefault(__webpack_require__(1));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function EmptyGrid(props) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "empty-grid-message"
    }, /*#__PURE__*/_react["default"].createElement("p", null, "No Data to display"));
  }

  /***/
}, /* 251 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  /*
  Copyright (c) 2015 Twitter, Inc. and other contributors
  
  Component to add Velocity animations to one or more children. Wraps a single child without adding
  additional DOM nodes.
  
  The API attempts to be as declarative as possible. A single animation property declares what
  animation the child should have. If that property changes, this component applies the new animation
  to the child on the next tick.
  
  By default, the animation is not run when the component is mounted. Instead, Velocity's "finish"
  command is used to jump to the animation's end state. For a component that animates out of and
  back in to a default state, this allows the parent to specify the "animate into" animation as
  the default, and therefore not have to distinguish between the initial state and the state to
  return to after animating away.
  
  Properties:
   animation: Either an animation key or hash defining the animation. See Velocity's documentation
     for what this can be. (It is passed to Velocity exactly.)
   runOnMount: If true, runs the animation even when the component is first mounted.
   targetQuerySelector: By default, this component's single child is animated. If targetQuerySelector
     is provided, it is used to select descendants to apply the animation to. Use with caution, only
     when you're confident that React's reconciliation will preserve these nodes during animation.
     Also note querySelectorAll's silly behavior w.r.t. pruning results when being called on a node.
     A special value of "children" will use the direct children of the node, since there isn't a
     great way to specify that to querySelectorAll.
   interruptBehavior: Sets how the previous animation should behave when the "animation" prop is
     changed before it’s done. Default is "stop", which halts the animation where it is. "finish"
     will jump the animation to its completed appearance. "queue" will run the new animation after
     the previous one has finished.
  
  Unrecognized properties are passed as options to Velocity (e.g. "duration", "delay", "loop").
  
  Methods:
   runAnimation: Triggers the animation immediately. Useful for when you want an animation that
     corresponds to an event but not a particular model state change (e.g. a "bump" when a click
     occurs).
  */
  /* eslint react/no-find-dom-node: 0 */

  var _ = {
    forEach: __webpack_require__(145),
    isEqual: __webpack_require__(192),
    keys: __webpack_require__(74),
    omit: __webpack_require__(199)
  };
  var React = __webpack_require__(1);
  var ReactDOM = __webpack_require__(15);
  var PropTypes = __webpack_require__(0);
  var Velocity = __webpack_require__(165);
  var VelocityComponent = function (_React$Component) {
    _inherits(VelocityComponent, _React$Component);
    function VelocityComponent(props) {
      _classCallCheck(this, VelocityComponent);
      var _this = _possibleConstructorReturn(this, (VelocityComponent.__proto__ || Object.getPrototypeOf(VelocityComponent)).call(this, props));
      _this._animationTimeout = null;

      // This public method is kept as self-bound to maintain compatibility with the React.createClass
      // version of the component.
      _this.runAnimation = _this.runAnimation.bind(_this);
      return _this;
    }
    _createClass(VelocityComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.runAnimation();

        // Jump to the end so that the component has the visual appearance of the animation having
        // been run to completion.
        if (this.props.runOnMount !== true) {
          this._finishAnimation();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(oldProps) {
        if (!_.isEqual(oldProps.animation, this.props.animation)) {
          if (this.props.interruptBehavior === 'stop') {
            this._stopAnimation();
          } else if (this.props.interruptBehavior === 'finish') {
            this._finishAnimation();
          }
          this._scheduleAnimation();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._stopAnimation();
        this._clearVelocityCache(this._getDOMTarget());
        if (this._animationTimeout) {
          clearTimeout(this._animationTimeout);
        }
      }

      // It's ok to call this externally! By default the animation will be queued up. Pass stop: true in
      // to stop the current animation before running. Pass finish: true to finish the current animation
      // before running.
    }, {
      key: 'runAnimation',
      value: function runAnimation(config) {
        config = config || {};
        this._animationTimeout = null;
        if (this.props.animation == null) {
          return;
        }
        if (config.stop) {
          Velocity(this._getDOMTarget(), 'stop', true);
        } else if (config.finish) {
          Velocity(this._getDOMTarget(), 'finishAll', true);
        }

        // Delegate all props except for the ones that we have specified as our own via propTypes.
        var opts = _.omit(this.props, _.keys(VelocityComponent.propTypes));
        Velocity(this._getDOMTarget(), this.props.animation, opts);
      }

      // We trigger animations on a new tick because of a Velocity bug where adding a
      // multi-step animation from within a complete callback causes the first 2 animations to run
      // simultaneously.
    }, {
      key: '_scheduleAnimation',
      value: function _scheduleAnimation() {
        if (this._animationTimeout) {
          return;
        }
        this._animationTimeout = setTimeout(this.runAnimation, 0);
      }

      // Returns one or more DOM nodes to apply the animation to. This is checked every time we start
      // or stop an animation, which means that if an animation is proceeding but the element is removed
      // from the page, it will run its course rather than ever being stopped. (We go this route
      // because of difficulty in tracking what animations are currently being animated, due to both
      // chained animations and the need to be able to "stop" an animation before it begins.)
    }, {
      key: '_getDOMTarget',
      value: function _getDOMTarget() {
        var node = ReactDOM.findDOMNode(this);
        if (this.props.targetQuerySelector === 'children') {
          return node.children;
        } else if (this.props.targetQuerySelector != null) {
          return node.querySelectorAll(this.props.targetQuerySelector);
        } else {
          return node;
        }
      }
    }, {
      key: '_finishAnimation',
      value: function _finishAnimation() {
        Velocity(this._getDOMTarget(), 'finishAll', true);
      }
    }, {
      key: '_stopAnimation',
      value: function _stopAnimation() {
        Velocity(this._getDOMTarget(), 'stop', true);
      }

      // Velocity keeps extensive caches for all animated elements to minimize layout thrashing.
      // This can cause a serious memory leak, keeping references to unmounted elements as well
      // completion handlers and associated react objects. This crudely clears these references.
    }, {
      key: '_clearVelocityCache',
      value: function _clearVelocityCache(target) {
        if (target.length) {
          _.forEach(target, this._clearVelocityCache);
        } else {
          Velocity.Utilities.removeData(target, ['velocity', 'fxqueue']);
        }
      }

      // This component does not include any DOM footprint of its own, so instead we return our
      // child out of render(). (Render must only return a single element, which restricts us to
      // one child. If you want to animate multiple children, provide your own wrapper element and
      // use the "targetQuerySelector" prop to target its children.)
    }, {
      key: 'render',
      value: function render() {
        return this.props.children;
      }
    }]);
    return VelocityComponent;
  }(React.Component);
  VelocityComponent.propTypes = {
    animation: PropTypes.any,
    children: PropTypes.element.isRequired,
    runOnMount: PropTypes.bool,
    targetQuerySelector: PropTypes.string,
    interruptBehavior: PropTypes.string
    // Any additional properties will be sent as options to Velocity
  };

  VelocityComponent.defaultProps = {
    animation: null,
    runOnMount: false,
    targetQuerySelector: null,
    interruptBehavior: 'stop'
  };
  module.exports = VelocityComponent;

  /***/
}, /* 252 */
/***/function (module, exports, __webpack_require__) {
  var baseFor = __webpack_require__(253),
    keys = __webpack_require__(74);

  /**
   * The base implementation of `_.forOwn` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */
  function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
  }
  module.exports = baseForOwn;

  /***/
}, /* 253 */
/***/function (module, exports, __webpack_require__) {
  var createBaseFor = __webpack_require__(254);

  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */
  var baseFor = createBaseFor();
  module.exports = baseFor;

  /***/
}, /* 254 */
/***/function (module, exports) {
  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
      var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  module.exports = createBaseFor;

  /***/
}, /* 255 */
/***/function (module, exports) {
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
      result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  module.exports = baseTimes;

  /***/
}, /* 256 */
/***/function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(80),
    isObjectLike = __webpack_require__(62);

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]';

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }
  module.exports = baseIsArguments;

  /***/
}, /* 257 */
/***/function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(81);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Built-in value references. */
  var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];
    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }
  module.exports = getRawTag;

  /***/
}, /* 258 */
/***/function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  module.exports = objectToString;

  /***/
}, /* 259 */
/***/function (module, exports) {
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }
  module.exports = stubFalse;

  /***/
}, /* 260 */
/***/function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(80),
    isLength = __webpack_require__(149),
    isObjectLike = __webpack_require__(62);

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  module.exports = baseIsTypedArray;

  /***/
}, /* 261 */
/***/function (module, exports, __webpack_require__) {
  var isPrototype = __webpack_require__(152),
    nativeKeys = __webpack_require__(262);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }
    return result;
  }
  module.exports = baseKeys;

  /***/
}, /* 262 */
/***/function (module, exports, __webpack_require__) {
  var overArg = __webpack_require__(190);

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeKeys = overArg(Object.keys, Object);
  module.exports = nativeKeys;

  /***/
}, /* 263 */
/***/function (module, exports, __webpack_require__) {
  var isArrayLike = __webpack_require__(88);

  /**
   * Creates a `baseEach` or `baseEachRight` function.
   *
   * @private
   * @param {Function} eachFunc The function to iterate over a collection.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseEach(eachFunc, fromRight) {
    return function (collection, iteratee) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike(collection)) {
        return eachFunc(collection, iteratee);
      }
      var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);
      while (fromRight ? index-- : ++index < length) {
        if (iteratee(iterable[index], index, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }
  module.exports = createBaseEach;

  /***/
}, /* 264 */
/***/function (module, exports, __webpack_require__) {
  var identity = __webpack_require__(100);

  /**
   * Casts `value` to `identity` if it's not a function.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Function} Returns cast function.
   */
  function castFunction(value) {
    return typeof value == 'function' ? value : identity;
  }
  module.exports = castFunction;

  /***/
}, /* 265 */
/***/function (module, exports, __webpack_require__) {
  var Stack = __webpack_require__(154),
    equalArrays = __webpack_require__(194),
    equalByTag = __webpack_require__(297),
    equalObjects = __webpack_require__(300),
    getTag = __webpack_require__(106),
    isArray = __webpack_require__(44),
    isBuffer = __webpack_require__(147),
    isTypedArray = __webpack_require__(189);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }
  module.exports = baseIsEqualDeep;

  /***/
}, /* 266 */
/***/function (module, exports) {
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  module.exports = listCacheClear;

  /***/
}, /* 267 */
/***/function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(102);

  /** Used for built-in method references. */
  var arrayProto = Array.prototype;

  /** Built-in value references. */
  var splice = arrayProto.splice;

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  module.exports = listCacheDelete;

  /***/
}, /* 268 */
/***/function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(102);

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }
  module.exports = listCacheGet;

  /***/
}, /* 269 */
/***/function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(102);

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  module.exports = listCacheHas;

  /***/
}, /* 270 */
/***/function (module, exports, __webpack_require__) {
  var assocIndexOf = __webpack_require__(102);

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  module.exports = listCacheSet;

  /***/
}, /* 271 */
/***/function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(101);

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  module.exports = stackClear;

  /***/
}, /* 272 */
/***/function (module, exports) {
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
      result = data['delete'](key);
    this.size = data.size;
    return result;
  }
  module.exports = stackDelete;

  /***/
}, /* 273 */
/***/function (module, exports) {
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }
  module.exports = stackGet;

  /***/
}, /* 274 */
/***/function (module, exports) {
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }
  module.exports = stackHas;

  /***/
}, /* 275 */
/***/function (module, exports, __webpack_require__) {
  var ListCache = __webpack_require__(101),
    Map = __webpack_require__(155),
    MapCache = __webpack_require__(156);

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
      var pairs = data.__data__;
      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  module.exports = stackSet;

  /***/
}, /* 276 */
/***/function (module, exports, __webpack_require__) {
  var isFunction = __webpack_require__(191),
    isMasked = __webpack_require__(277),
    isObject = __webpack_require__(63),
    toSource = __webpack_require__(193);

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used for built-in method references. */
  var funcProto = Function.prototype,
    objectProto = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  module.exports = baseIsNative;

  /***/
}, /* 277 */
/***/function (module, exports, __webpack_require__) {
  var coreJsData = __webpack_require__(278);

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  module.exports = isMasked;

  /***/
}, /* 278 */
/***/function (module, exports, __webpack_require__) {
  var root = __webpack_require__(50);

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root['__core-js_shared__'];
  module.exports = coreJsData;

  /***/
}, /* 279 */
/***/function (module, exports) {
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  module.exports = getValue;

  /***/
}, /* 280 */
/***/function (module, exports, __webpack_require__) {
  var Hash = __webpack_require__(281),
    ListCache = __webpack_require__(101),
    Map = __webpack_require__(155);

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }
  module.exports = mapCacheClear;

  /***/
}, /* 281 */
/***/function (module, exports, __webpack_require__) {
  var hashClear = __webpack_require__(282),
    hashDelete = __webpack_require__(283),
    hashGet = __webpack_require__(284),
    hashHas = __webpack_require__(285),
    hashSet = __webpack_require__(286);

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  module.exports = Hash;

  /***/
}, /* 282 */
/***/function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(104);

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }
  module.exports = hashClear;

  /***/
}, /* 283 */
/***/function (module, exports) {
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  module.exports = hashDelete;

  /***/
}, /* 284 */
/***/function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(104);

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }
  module.exports = hashGet;

  /***/
}, /* 285 */
/***/function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(104);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }
  module.exports = hashHas;

  /***/
}, /* 286 */
/***/function (module, exports, __webpack_require__) {
  var nativeCreate = __webpack_require__(104);

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  }
  module.exports = hashSet;

  /***/
}, /* 287 */
/***/function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(105);

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  module.exports = mapCacheDelete;

  /***/
}, /* 288 */
/***/function (module, exports) {
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }
  module.exports = isKeyable;

  /***/
}, /* 289 */
/***/function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(105);

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  module.exports = mapCacheGet;

  /***/
}, /* 290 */
/***/function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(105);

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  module.exports = mapCacheHas;

  /***/
}, /* 291 */
/***/function (module, exports, __webpack_require__) {
  var getMapData = __webpack_require__(105);

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
      size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }
  module.exports = mapCacheSet;

  /***/
}, /* 292 */
/***/function (module, exports, __webpack_require__) {
  var MapCache = __webpack_require__(156),
    setCacheAdd = __webpack_require__(293),
    setCacheHas = __webpack_require__(294);

  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */
  function SetCache(values) {
    var index = -1,
      length = values == null ? 0 : values.length;
    this.__data__ = new MapCache();
    while (++index < length) {
      this.add(values[index]);
    }
  }

  // Add methods to `SetCache`.
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  module.exports = SetCache;

  /***/
}, /* 293 */
/***/function (module, exports) {
  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
  }
  module.exports = setCacheAdd;

  /***/
}, /* 294 */
/***/function (module, exports) {
  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */
  function setCacheHas(value) {
    return this.__data__.has(value);
  }
  module.exports = setCacheHas;

  /***/
}, /* 295 */
/***/function (module, exports) {
  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  module.exports = arraySome;

  /***/
}, /* 296 */
/***/function (module, exports) {
  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }
  module.exports = cacheHas;

  /***/
}, /* 297 */
/***/function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(81),
    Uint8Array = __webpack_require__(195),
    eq = __webpack_require__(103),
    equalArrays = __webpack_require__(194),
    mapToArray = __webpack_require__(298),
    setToArray = __webpack_require__(299);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

  /** `Object#toString` result references. */
  var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';
  var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }
        return true;
      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);
      case errorTag:
        return object.name == other.name && object.message == other.message;
      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';
      case mapTag:
        var convert = mapToArray;
      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        // Assume cyclic values are equal.
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG;

        // Recursively compare objects (susceptible to call stack limits).
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;
      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }
  module.exports = equalByTag;

  /***/
}, /* 298 */
/***/function (module, exports) {
  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
      result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  module.exports = mapToArray;

  /***/
}, /* 299 */
/***/function (module, exports) {
  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
      result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }
  module.exports = setToArray;

  /***/
}, /* 300 */
/***/function (module, exports, __webpack_require__) {
  var getAllKeys = __webpack_require__(196);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1;

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
        othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      // Recursively compare objects (susceptible to call stack limits).
      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor,
        othCtor = other.constructor;

      // Non `Object` object instances with different constructors are not equal.
      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
  }
  module.exports = equalObjects;

  /***/
}, /* 301 */
/***/function (module, exports) {
  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  module.exports = arrayFilter;

  /***/
}, /* 302 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(75),
    root = __webpack_require__(50);

  /* Built-in method references that are verified to be native. */
  var DataView = getNative(root, 'DataView');
  module.exports = DataView;

  /***/
}, /* 303 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(75),
    root = __webpack_require__(50);

  /* Built-in method references that are verified to be native. */
  var Promise = getNative(root, 'Promise');
  module.exports = Promise;

  /***/
}, /* 304 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(75),
    root = __webpack_require__(50);

  /* Built-in method references that are verified to be native. */
  var Set = getNative(root, 'Set');
  module.exports = Set;

  /***/
}, /* 305 */
/***/function (module, exports, __webpack_require__) {
  var getNative = __webpack_require__(75),
    root = __webpack_require__(50);

  /* Built-in method references that are verified to be native. */
  var WeakMap = getNative(root, 'WeakMap');
  module.exports = WeakMap;

  /***/
}, /* 306 */
/***/function (module, exports, __webpack_require__) {
  var Stack = __webpack_require__(154),
    arrayEach = __webpack_require__(185),
    assignValue = __webpack_require__(200),
    baseAssign = __webpack_require__(307),
    baseAssignIn = __webpack_require__(308),
    cloneBuffer = __webpack_require__(311),
    copyArray = __webpack_require__(312),
    copySymbols = __webpack_require__(313),
    copySymbolsIn = __webpack_require__(314),
    getAllKeys = __webpack_require__(196),
    getAllKeysIn = __webpack_require__(204),
    getTag = __webpack_require__(106),
    initCloneArray = __webpack_require__(315),
    initCloneByTag = __webpack_require__(316),
    initCloneObject = __webpack_require__(321),
    isArray = __webpack_require__(44),
    isBuffer = __webpack_require__(147),
    isMap = __webpack_require__(323),
    isObject = __webpack_require__(63),
    isSet = __webpack_require__(325),
    keys = __webpack_require__(74),
    keysIn = __webpack_require__(107);

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

  /**
   * The base implementation of `_.clone` and `_.cloneDeep` which tracks
   * traversed objects.
   *
   * @private
   * @param {*} value The value to clone.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Deep clone
   *  2 - Flatten inherited properties
   *  4 - Clone symbols
   * @param {Function} [customizer] The function to customize cloning.
   * @param {string} [key] The key of `value`.
   * @param {Object} [object] The parent object of `value`.
   * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
   * @returns {*} Returns the cloned value.
   */
  function baseClone(value, bitmask, customizer, key, object, stack) {
    var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) {
      result = object ? customizer(value, key, object, stack) : customizer(value);
    }
    if (result !== undefined) {
      return result;
    }
    if (!isObject(value)) {
      return value;
    }
    var isArr = isArray(value);
    if (isArr) {
      result = initCloneArray(value);
      if (!isDeep) {
        return copyArray(value, result);
      }
    } else {
      var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;
      if (isBuffer(value)) {
        return cloneBuffer(value, isDeep);
      }
      if (tag == objectTag || tag == argsTag || isFunc && !object) {
        result = isFlat || isFunc ? {} : initCloneObject(value);
        if (!isDeep) {
          return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }
        result = initCloneByTag(value, tag, isDeep);
      }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack());
    var stacked = stack.get(value);
    if (stacked) {
      return stacked;
    }
    stack.set(value, result);
    if (isSet(value)) {
      value.forEach(function (subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
      });
    } else if (isMap(value)) {
      value.forEach(function (subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
    }
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function (subValue, key) {
      if (props) {
        key = subValue;
        subValue = value[key];
      }
      // Recursively populate clone (susceptible to call stack limits).
      assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
  }
  module.exports = baseClone;

  /***/
}, /* 307 */
/***/function (module, exports, __webpack_require__) {
  var copyObject = __webpack_require__(82),
    keys = __webpack_require__(74);

  /**
   * The base implementation of `_.assign` without support for multiple sources
   * or `customizer` functions.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @returns {Object} Returns `object`.
   */
  function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
  }
  module.exports = baseAssign;

  /***/
}, /* 308 */
/***/function (module, exports, __webpack_require__) {
  var copyObject = __webpack_require__(82),
    keysIn = __webpack_require__(107);

  /**
   * The base implementation of `_.assignIn` without support for multiple sources
   * or `customizer` functions.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @returns {Object} Returns `object`.
   */
  function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
  }
  module.exports = baseAssignIn;

  /***/
}, /* 309 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(63),
    isPrototype = __webpack_require__(152),
    nativeKeysIn = __webpack_require__(310);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeysIn(object) {
    if (!isObject(object)) {
      return nativeKeysIn(object);
    }
    var isProto = isPrototype(object),
      result = [];
    for (var key in object) {
      if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }
  module.exports = baseKeysIn;

  /***/
}, /* 310 */
/***/function (module, exports) {
  /**
   * This function is like
   * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * except that it includes inherited enumerable properties.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }
  module.exports = nativeKeysIn;

  /***/
}, /* 311 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (module) {
    var root = __webpack_require__(50);

    /** Detect free variable `exports`. */
    var freeExports = true && exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Built-in value references. */
    var Buffer = moduleExports ? root.Buffer : undefined,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }
    module.exports = cloneBuffer;

    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(47)(module));

  /***/
}, /* 312 */
/***/function (module, exports) {
  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */
  function copyArray(source, array) {
    var index = -1,
      length = source.length;
    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }
  module.exports = copyArray;

  /***/
}, /* 313 */
/***/function (module, exports, __webpack_require__) {
  var copyObject = __webpack_require__(82),
    getSymbols = __webpack_require__(158);

  /**
   * Copies own symbols of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy symbols from.
   * @param {Object} [object={}] The object to copy symbols to.
   * @returns {Object} Returns `object`.
   */
  function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
  }
  module.exports = copySymbols;

  /***/
}, /* 314 */
/***/function (module, exports, __webpack_require__) {
  var copyObject = __webpack_require__(82),
    getSymbolsIn = __webpack_require__(203);

  /**
   * Copies own and inherited symbols of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy symbols from.
   * @param {Object} [object={}] The object to copy symbols to.
   * @returns {Object} Returns `object`.
   */
  function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
  }
  module.exports = copySymbolsIn;

  /***/
}, /* 315 */
/***/function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Initializes an array clone.
   *
   * @private
   * @param {Array} array The array to clone.
   * @returns {Array} Returns the initialized clone.
   */
  function initCloneArray(array) {
    var length = array.length,
      result = new array.constructor(length);

    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
      result.index = array.index;
      result.input = array.input;
    }
    return result;
  }
  module.exports = initCloneArray;

  /***/
}, /* 316 */
/***/function (module, exports, __webpack_require__) {
  var cloneArrayBuffer = __webpack_require__(161),
    cloneDataView = __webpack_require__(317),
    cloneRegExp = __webpack_require__(318),
    cloneSymbol = __webpack_require__(319),
    cloneTypedArray = __webpack_require__(320);

  /** `Object#toString` result references. */
  var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';
  var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

  /**
   * Initializes an object clone based on its `toStringTag`.
   *
   * **Note:** This function only supports cloning values with tags of
   * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {string} tag The `toStringTag` of the object to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag:
        return cloneArrayBuffer(object);
      case boolTag:
      case dateTag:
        return new Ctor(+object);
      case dataViewTag:
        return cloneDataView(object, isDeep);
      case float32Tag:
      case float64Tag:
      case int8Tag:
      case int16Tag:
      case int32Tag:
      case uint8Tag:
      case uint8ClampedTag:
      case uint16Tag:
      case uint32Tag:
        return cloneTypedArray(object, isDeep);
      case mapTag:
        return new Ctor();
      case numberTag:
      case stringTag:
        return new Ctor(object);
      case regexpTag:
        return cloneRegExp(object);
      case setTag:
        return new Ctor();
      case symbolTag:
        return cloneSymbol(object);
    }
  }
  module.exports = initCloneByTag;

  /***/
}, /* 317 */
/***/function (module, exports, __webpack_require__) {
  var cloneArrayBuffer = __webpack_require__(161);

  /**
   * Creates a clone of `dataView`.
   *
   * @private
   * @param {Object} dataView The data view to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned data view.
   */
  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  module.exports = cloneDataView;

  /***/
}, /* 318 */
/***/function (module, exports) {
  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /**
   * Creates a clone of `regexp`.
   *
   * @private
   * @param {Object} regexp The regexp to clone.
   * @returns {Object} Returns the cloned regexp.
   */
  function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
  }
  module.exports = cloneRegExp;

  /***/
}, /* 319 */
/***/function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(81);

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

  /**
   * Creates a clone of the `symbol` object.
   *
   * @private
   * @param {Object} symbol The symbol object to clone.
   * @returns {Object} Returns the cloned symbol object.
   */
  function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  module.exports = cloneSymbol;

  /***/
}, /* 320 */
/***/function (module, exports, __webpack_require__) {
  var cloneArrayBuffer = __webpack_require__(161);

  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  module.exports = cloneTypedArray;

  /***/
}, /* 321 */
/***/function (module, exports, __webpack_require__) {
  var baseCreate = __webpack_require__(322),
    getPrototype = __webpack_require__(160),
    isPrototype = __webpack_require__(152);

  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }
  module.exports = initCloneObject;

  /***/
}, /* 322 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(63);

  /** Built-in value references. */
  var objectCreate = Object.create;

  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} proto The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  var baseCreate = function () {
    function object() {}
    return function (proto) {
      if (!isObject(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result = new object();
      object.prototype = undefined;
      return result;
    };
  }();
  module.exports = baseCreate;

  /***/
}, /* 323 */
/***/function (module, exports, __webpack_require__) {
  var baseIsMap = __webpack_require__(324),
    baseUnary = __webpack_require__(150),
    nodeUtil = __webpack_require__(151);

  /* Node.js helper references. */
  var nodeIsMap = nodeUtil && nodeUtil.isMap;

  /**
   * Checks if `value` is classified as a `Map` object.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a map, else `false`.
   * @example
   *
   * _.isMap(new Map);
   * // => true
   *
   * _.isMap(new WeakMap);
   * // => false
   */
  var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
  module.exports = isMap;

  /***/
}, /* 324 */
/***/function (module, exports, __webpack_require__) {
  var getTag = __webpack_require__(106),
    isObjectLike = __webpack_require__(62);

  /** `Object#toString` result references. */
  var mapTag = '[object Map]';

  /**
   * The base implementation of `_.isMap` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a map, else `false`.
   */
  function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
  }
  module.exports = baseIsMap;

  /***/
}, /* 325 */
/***/function (module, exports, __webpack_require__) {
  var baseIsSet = __webpack_require__(326),
    baseUnary = __webpack_require__(150),
    nodeUtil = __webpack_require__(151);

  /* Node.js helper references. */
  var nodeIsSet = nodeUtil && nodeUtil.isSet;

  /**
   * Checks if `value` is classified as a `Set` object.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a set, else `false`.
   * @example
   *
   * _.isSet(new Set);
   * // => true
   *
   * _.isSet(new WeakSet);
   * // => false
   */
  var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
  module.exports = isSet;

  /***/
}, /* 326 */
/***/function (module, exports, __webpack_require__) {
  var getTag = __webpack_require__(106),
    isObjectLike = __webpack_require__(62);

  /** `Object#toString` result references. */
  var setTag = '[object Set]';

  /**
   * The base implementation of `_.isSet` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a set, else `false`.
   */
  function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
  }
  module.exports = baseIsSet;

  /***/
}, /* 327 */
/***/function (module, exports, __webpack_require__) {
  var castPath = __webpack_require__(108),
    last = __webpack_require__(333),
    parent = __webpack_require__(334),
    toKey = __webpack_require__(89);

  /**
   * The base implementation of `_.unset`.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {Array|string} path The property path to unset.
   * @returns {boolean} Returns `true` if the property is deleted, else `false`.
   */
  function baseUnset(object, path) {
    path = castPath(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last(path))];
  }
  module.exports = baseUnset;

  /***/
}, /* 328 */
/***/function (module, exports, __webpack_require__) {
  var memoizeCapped = __webpack_require__(329);

  /** Used to match property names within property paths. */
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */
  var stringToPath = memoizeCapped(function (string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
    string.replace(rePropName, function (match, number, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
  });
  module.exports = stringToPath;

  /***/
}, /* 329 */
/***/function (module, exports, __webpack_require__) {
  var memoize = __webpack_require__(330);

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /**
   * A specialized version of `_.memoize` which clears the memoized function's
   * cache when it exceeds `MAX_MEMOIZE_SIZE`.
   *
   * @private
   * @param {Function} func The function to have its output memoized.
   * @returns {Function} Returns the new memoized function.
   */
  function memoizeCapped(func) {
    var result = memoize(func, function (key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });
    var cache = result.cache;
    return result;
  }
  module.exports = memoizeCapped;

  /***/
}, /* 330 */
/***/function (module, exports, __webpack_require__) {
  var MapCache = __webpack_require__(156);

  /** Error message constants. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `clear`, `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */
  function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function () {
      var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result) || cache;
      return result;
    };
    memoized.cache = new (memoize.Cache || MapCache)();
    return memoized;
  }

  // Expose `MapCache`.
  memoize.Cache = MapCache;
  module.exports = memoize;

  /***/
}, /* 331 */
/***/function (module, exports, __webpack_require__) {
  var baseToString = __webpack_require__(332);

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString(value) {
    return value == null ? '' : baseToString(value);
  }
  module.exports = toString;

  /***/
}, /* 332 */
/***/function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(81),
    arrayMap = __webpack_require__(159),
    isArray = __webpack_require__(44),
    isSymbol = __webpack_require__(163);

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isArray(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }
  module.exports = baseToString;

  /***/
}, /* 333 */
/***/function (module, exports) {
  /**
   * Gets the last element of `array`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to query.
   * @returns {*} Returns the last element of `array`.
   * @example
   *
   * _.last([1, 2, 3]);
   * // => 3
   */
  function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
  }
  module.exports = last;

  /***/
}, /* 334 */
/***/function (module, exports, __webpack_require__) {
  var baseGet = __webpack_require__(164),
    baseSlice = __webpack_require__(335);

  /**
   * Gets the parent value at `path` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} path The path to get the parent value of.
   * @returns {*} Returns the parent value.
   */
  function parent(object, path) {
    return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
  }
  module.exports = parent;

  /***/
}, /* 335 */
/***/function (module, exports) {
  /**
   * The base implementation of `_.slice` without an iteratee call guard.
   *
   * @private
   * @param {Array} array The array to slice.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the slice of `array`.
   */
  function baseSlice(array, start, end) {
    var index = -1,
      length = array.length;
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while (++index < length) {
      result[index] = array[index + start];
    }
    return result;
  }
  module.exports = baseSlice;

  /***/
}, /* 336 */
/***/function (module, exports, __webpack_require__) {
  var isPlainObject = __webpack_require__(337);

  /**
   * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
   * objects.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {string} key The key of the property to inspect.
   * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
   */
  function customOmitClone(value) {
    return isPlainObject(value) ? undefined : value;
  }
  module.exports = customOmitClone;

  /***/
}, /* 337 */
/***/function (module, exports, __webpack_require__) {
  var baseGetTag = __webpack_require__(80),
    getPrototype = __webpack_require__(160),
    isObjectLike = __webpack_require__(62);

  /** `Object#toString` result references. */
  var objectTag = '[object Object]';

  /** Used for built-in method references. */
  var funcProto = Function.prototype,
    objectProto = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to infer the `Object` constructor. */
  var objectCtorString = funcToString.call(Object);

  /**
   * Checks if `value` is a plain object, that is, an object created by the
   * `Object` constructor or one with a `[[Prototype]]` of `null`.
   *
   * @static
   * @memberOf _
   * @since 0.8.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * _.isPlainObject(new Foo);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   *
   * _.isPlainObject(Object.create(null));
   * // => true
   */
  function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
      return false;
    }
    var proto = getPrototype(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
  }
  module.exports = isPlainObject;

  /***/
}, /* 338 */
/***/function (module, exports, __webpack_require__) {
  var flatten = __webpack_require__(339),
    overRest = __webpack_require__(205),
    setToString = __webpack_require__(206);

  /**
   * A specialized version of `baseRest` which flattens the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @returns {Function} Returns the new function.
   */
  function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + '');
  }
  module.exports = flatRest;

  /***/
}, /* 339 */
/***/function (module, exports, __webpack_require__) {
  var baseFlatten = __webpack_require__(340);

  /**
   * Flattens `array` a single level deep.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to flatten.
   * @returns {Array} Returns the new flattened array.
   * @example
   *
   * _.flatten([1, [2, [3, [4]], 5]]);
   * // => [1, 2, [3, [4]], 5]
   */
  function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
  }
  module.exports = flatten;

  /***/
}, /* 340 */
/***/function (module, exports, __webpack_require__) {
  var arrayPush = __webpack_require__(157),
    isFlattenable = __webpack_require__(341);

  /**
   * The base implementation of `_.flatten` with support for restricting flattening.
   *
   * @private
   * @param {Array} array The array to flatten.
   * @param {number} depth The maximum recursion depth.
   * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
   * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
   * @param {Array} [result=[]] The initial result value.
   * @returns {Array} Returns the new flattened array.
   */
  function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1,
      length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while (++index < length) {
      var value = array[index];
      if (depth > 0 && predicate(value)) {
        if (depth > 1) {
          // Recursively flatten arrays (susceptible to call stack limits).
          baseFlatten(value, depth - 1, predicate, isStrict, result);
        } else {
          arrayPush(result, value);
        }
      } else if (!isStrict) {
        result[result.length] = value;
      }
    }
    return result;
  }
  module.exports = baseFlatten;

  /***/
}, /* 341 */
/***/function (module, exports, __webpack_require__) {
  var Symbol = __webpack_require__(81),
    isArguments = __webpack_require__(146),
    isArray = __webpack_require__(44);

  /** Built-in value references. */
  var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

  /**
   * Checks if `value` is a flattenable `arguments` object or array.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
   */
  function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
  }
  module.exports = isFlattenable;

  /***/
}, /* 342 */
/***/function (module, exports) {
  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  module.exports = apply;

  /***/
}, /* 343 */
/***/function (module, exports, __webpack_require__) {
  var constant = __webpack_require__(344),
    defineProperty = __webpack_require__(202),
    identity = __webpack_require__(100);

  /**
   * The base implementation of `setToString` without support for hot loop shorting.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var baseSetToString = !defineProperty ? identity : function (func, string) {
    return defineProperty(func, 'toString', {
      'configurable': true,
      'enumerable': false,
      'value': constant(string),
      'writable': true
    });
  };
  module.exports = baseSetToString;

  /***/
}, /* 344 */
/***/function (module, exports) {
  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new constant function.
   * @example
   *
   * var objects = _.times(2, _.constant({ 'a': 1 }));
   *
   * console.log(objects);
   * // => [{ 'a': 1 }, { 'a': 1 }]
   *
   * console.log(objects[0] === objects[1]);
   * // => true
   */
  function constant(value) {
    return function () {
      return value;
    };
  }
  module.exports = constant;

  /***/
}, /* 345 */
/***/function (module, exports) {
  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
    HOT_SPAN = 16;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeNow = Date.now;

  /**
   * Creates a function that'll short out and invoke `identity` instead
   * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
   * milliseconds.
   *
   * @private
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new shortable function.
   */
  function shortOut(func) {
    var count = 0,
      lastCalled = 0;
    return function () {
      var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(undefined, arguments);
    };
  }
  module.exports = shortOut;

  /***/
}, /* 346 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  /*
  Copyright (c) 2015 Twitter, Inc. and other contributors
  
  Component to add Velocity animations around React transitions. Delegates to the React TransitionGroup
  addon.
  
  Properties
    enter: Animation to run on a child component being added
    leave: Animation to run on a child component leaving
    runOnMount: if true, runs the "enter" animation on the elements that exist as children when this
      component is mounted.
    enterHideStyle/enterShowStyle: see below.
  
  Any additional properties (e.g. "className", "component") will be passed to the internal
  TransitionGroup.
  
  "enter" and "leave" should either be a string naming an animation, or a hash with an
  "animation" key that can either be a string itself, or a hash of style attributes to animate (this
  value is passed to Velocity its the first arg).
  
  If "enter" or "leave" is a hash, it can additionally have a "style" value that is applied the tick
  before the Velocity animation starts. Use this for non-animating properties (like "position") that
  are prerequisites for correct animation. The style value is applied using Velocity's JS -> CSS
  routines, which may differ from React's.
  
  Any hash entries beyond "animation" and "style" are passed in an options hash to Velocity. Use this
  for options like "stagger", "reverse", &tc.
  
  By default, this component will immediately hide all entering children with display: 'none', and
  unhide them one tick later with display: ''. This is done so that we can coalesce multiple enters
  into a single animation, and we want to avoid any popping of elements in while they're collected. If
  you prefer a different way of hiding these elements so that e.g. geometry can be immediately
  calculated, use the enterHideStyle and enterShowStyle props to provide alternate style hashes for
  hiding and revealing entering elements.
  
  Statics
    disabledForTest: Set this to true globally to turn off all custom animation logic. Instead, this
      component will behave like a vanilla TransitionGroup.
  
  Inspired by https://gist.github.com/tkafka/0d94c6ec94297bb67091
  */
  /* eslint react/no-find-dom-node: 0 */

  var _ = {
    each: __webpack_require__(347),
    extend: __webpack_require__(348),
    forEach: __webpack_require__(145),
    isEqual: __webpack_require__(192),
    keys: __webpack_require__(74),
    omit: __webpack_require__(199),
    map: __webpack_require__(353)
  };
  var React = __webpack_require__(1);
  var ReactDOM = __webpack_require__(15);
  var PropTypes = __webpack_require__(0);
  var TransitionGroup = __webpack_require__(367);
  var Transition = __webpack_require__(369).default;
  var Velocity = __webpack_require__(165);

  // Shim requestAnimationFrame for browsers that don't support it, in particular IE 9.
  var shimRequestAnimationFrame = typeof window !== 'undefined' && (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 0);
  });

  // Fix 'Invalid calling object' error in IE
  shimRequestAnimationFrame = typeof window !== 'undefined' && shimRequestAnimationFrame.bind(window);
  var shimCancelAnimationFrame = typeof window !== 'undefined' && (window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || function (timeout) {
    window.clearTimeout(timeout);
  });
  shimCancelAnimationFrame = typeof window !== 'undefined' && shimCancelAnimationFrame.bind(window);

  // Internal wrapper for the transitioned elements. Delegates all child lifecycle events to the
  // parent VelocityTransitionGroup so that it can co-ordinate animating all of the elements at once.

  var VelocityTransitionGroupChild = function (_React$Component) {
    _inherits(VelocityTransitionGroupChild, _React$Component);
    function VelocityTransitionGroupChild() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck(this, VelocityTransitionGroupChild);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VelocityTransitionGroupChild.__proto__ || Object.getPrototypeOf(VelocityTransitionGroupChild)).call.apply(_ref, [this].concat(args))), _this), _this.lastState = 'appear', _this.componentWillEnter = function (node, appearing) {
        _this.lastState = appearing ? 'appear' : 'enter';
      }, _this.componentWillExit = function () {
        _this.lastState = 'exit';
      }, _this.endListener = function (node, done) {
        switch (_this.lastState) {
          case 'appear':
            _this.props.willAppearFunc(node, done);
            break;
          case 'enter':
            _this.props.willEnterFunc(node, done);
            break;
          case 'exit':
            _this.props.willLeaveFunc(node, done);
            break;
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    // We trigger our transitions out of endListener because that gives us access to the done callback
    // we can use to tell the Transition that the animation has completed.

    _createClass(VelocityTransitionGroupChild, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        // Clear references from velocity cache.
        Velocity.Utilities.removeData(ReactDOM.findDOMNode(this), ['velocity', 'fxqueue']);
      }
    }, {
      key: 'render',
      value: function render() {
        var transitionProps = _.omit(this.props, _.keys(VelocityTransitionGroupChild.propTypes));
        return React.createElement(Transition, _extends({}, transitionProps, {
          timeout: null,
          addEndListener: this.endListener,
          appear: true,
          onEnter: this.componentWillEnter,
          onExit: this.componentWillExit
        }), this.props.children);
      }
    }]);
    return VelocityTransitionGroupChild;
  }(React.Component);
  VelocityTransitionGroupChild.propTypes = {
    children: PropTypes.element.isRequired,
    willAppearFunc: PropTypes.func.isRequired,
    willEnterFunc: PropTypes.func.isRequired,
    willLeaveFunc: PropTypes.func.isRequired
  };
  var VelocityTransitionGroup = function (_React$Component2) {
    _inherits(VelocityTransitionGroup, _React$Component2);
    function VelocityTransitionGroup(props) {
      _classCallCheck(this, VelocityTransitionGroup);
      var _this2 = _possibleConstructorReturn(this, (VelocityTransitionGroup.__proto__ || Object.getPrototypeOf(VelocityTransitionGroup)).call(this, props));
      _this2._scheduledAnimationFrame = null;
      _this2._scheduledAnimationRunFrames = [];
      _this2._entering = [];
      _this2._leaving = [];
      _this2._timers = [];
      _this2._unmounted = false;
      _this2.childWillAppear = _this2.childWillAppear.bind(_this2);
      _this2.childWillEnter = _this2.childWillEnter.bind(_this2);
      _this2.childWillLeave = _this2.childWillLeave.bind(_this2);
      _this2._runAnimations = _this2._runAnimations.bind(_this2);
      _this2._wrapChild = _this2._wrapChild.bind(_this2);
      return _this2;
    }
    _createClass(VelocityTransitionGroup, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._scheduledAnimationFrame) {
          shimCancelAnimationFrame(this._scheduledAnimationFrame);
        }
        _.forEach(this._timers, function (timer) {
          clearTimeout(timer);
        });
        _.forEach(this._scheduledAnimationRunFrames, function (frame) {
          shimCancelAnimationFrame(frame);
        });

        // We don't cancel all the in-process animations, so we use this to know if the component
        // is gone when an animation is over.
        this._unmounted = true;
      }
    }, {
      key: 'render',
      value: function render() {
        // Pass any props that are not our own on into the TransitionGroup delegate.
        var transitionGroupProps = _.omit(this.props, _.keys(VelocityTransitionGroup.propTypes));
        return React.createElement(TransitionGroup, transitionGroupProps, !this.constructor.disabledForTest && !Velocity.velocityReactServerShim ? React.Children.map(this.props.children, this._wrapChild) : React.Children.map(this.props.children,
        // Wrapping in a no-op Transition to consume the props that
        // TransitionGroup gives its children. Fixes react-dom warnings
        // in test for those props appearing on divs and such.
        function (child) {
          return child && React.createElement(Transition, {
            timeout: 0
          }, child);
        }));
      }
    }, {
      key: 'childWillAppear',
      value: function childWillAppear(node, doneFn) {
        var _this3 = this;
        if (this.props.runOnMount) {
          this.childWillEnter(node, doneFn);
        } else {
          this._finishAnimation(node, this.props.enter);

          // Important to tick over so that any callbacks due to finishing the animation complete first.
          //
          // Using setTimeout so that doneFn gets called even when the tab is hidden.
          var t = setTimeout(function () {
            var idx = _this3._timers.indexOf(t);
            if (idx >= 0) {
              _this3._timers.splice(idx, 1);
            }
            doneFn();
          }, 0);
          this._timers.push(t);
        }
      }
    }, {
      key: 'childWillEnter',
      value: function childWillEnter(node, doneFn) {
        if (this._shortCircuitAnimation(this.props.enter, doneFn)) return;

        // By finishing a "leave" on the element, we put it in the right state to be animated in. Useful
        // if "leave" includes a rotation or something that we'd like to have as our starting point, for
        // symmetry.
        // We use overrideOpts to prevent any "begin" or "complete" callback from triggering in this case, since
        // it doesn't make a ton of sense.
        this._finishAnimation(node, this.props.leave, {
          begin: undefined,
          complete: undefined
        });

        // We're not going to start the animation for a tick, so set the node's display to none (or any
        // custom "hide" style provided) so that it doesn't flash in.
        _.forEach(this.props.enterHideStyle, function (val, key) {
          Velocity.CSS.setPropertyValue(node, key, val);
        });
        this._entering.push({
          node: node,
          doneFn: doneFn
        });
        this._schedule();
      }
    }, {
      key: 'childWillLeave',
      value: function childWillLeave(node, doneFn) {
        if (this._shortCircuitAnimation(this.props.leave, doneFn)) return;
        this._leaving.push({
          node: node,
          doneFn: doneFn
        });
        this._schedule();
      }

      // document.hidden check is there because animation completion callbacks won't fire (due to
      // chaining off of rAF), which would prevent entering / leaving DOM nodes from being cleaned up
      // while the tab is hidden.
      //
      // Returns true if this did short circuit, false if lifecycle methods should continue with
      // their animations.
    }, {
      key: '_shortCircuitAnimation',
      value: function _shortCircuitAnimation(animationProp, doneFn) {
        if (document.hidden || this._parseAnimationProp(animationProp).animation == null) {
          doneFn();
          return true;
        } else {
          return false;
        }
      }
    }, {
      key: '_schedule',
      value: function _schedule() {
        if (this._scheduledAnimationFrame) {
          return;
        }

        // Need rAF to make sure we're in the same event queue as Velocity from here out. Important
        // for avoiding getting wrong interleaving with Velocity callbacks.
        this._scheduledAnimationFrame = shimRequestAnimationFrame(this._runAnimations);
      }

      // arrow function because this is used as an rAF callback
    }, {
      key: '_runAnimations',
      value: function _runAnimations() {
        this._scheduledAnimationFrame = null;
        this._runAnimation(true, this._entering, this.props.enter);
        this._runAnimation(false, this._leaving, this.props.leave);
        this._entering = [];
        this._leaving = [];
      }

      // Used to parse out the 'enter' and 'leave' properties. Handles cases where they are omitted
      // as well as when they are just strings and not hashes of animation and options.
    }, {
      key: '_parseAnimationProp',
      value: function _parseAnimationProp(animationProp) {
        var animation, opts, style;
        if (typeof animationProp === 'string') {
          animation = animationProp;
          style = null;
          opts = {};
        } else {
          animation = animationProp != null ? animationProp.animation : null;
          style = animationProp != null ? animationProp.style : null;
          opts = _.omit(animationProp, 'animation', 'style');
        }
        return {
          animation: animation,
          style: style,
          opts: opts
        };
      }
    }, {
      key: '_runAnimation',
      value: function _runAnimation(entering, queue, animationProp) {
        var _this4 = this;
        if (queue.length === 0) {
          return;
        }
        var nodes = _.map(queue, 'node');
        var doneFns = _.map(queue, 'doneFn');
        var parsedAnimation = this._parseAnimationProp(animationProp);
        var animation = parsedAnimation.animation;
        var style = parsedAnimation.style;
        var opts = parsedAnimation.opts;

        // Clearing display reverses the behavior from childWillAppear where all elements are added with
        // display: none to prevent them from flashing in before the animation starts. We don't do this
        // for the fade/slide animations or any animation that ends in "In," since Velocity will handle
        // it for us.
        //
        // If a custom "enterShowStyle" prop is passed, (i.e. not one that just reverses display: none)
        // we always run it, regardless of the animation, since it's probably doing something around
        // opacity or positioning that Velocity will not necessarily reset.
        if (entering) {
          if (!_.isEqual(this.props.enterShowStyle, {
            display: ''
          }) || !(/^(fade|slide)/.test(animation) || /In$/.test(animation))) {
            style = _.extend({}, this.props.enterShowStyle, style);
          }
        }

        // Because Safari can synchronously repaint when CSS "display" is reset, we set styles for all
        // browsers before the rAF tick below that starts the animation. This way you know in all
        // cases that you need to support your static styles being visible on the element before
        // the animation begins.
        if (style != null) {
          _.each(style, function (value, key) {
            Velocity.hook(nodes, key, value);
          });
        }
        var doneFn = function doneFn() {
          // calling doneFns after the parent has unmounted leads to errors
          if (_this4._unmounted) {
            return;
          }
          doneFns.map(function (doneFn) {
            doneFn();
          });
        };

        // For nodes that are entering, we tell the TransitionGroup that we're done with them
        // immediately. That way, they can be removed later before their entering animations complete.
        // If we're leaving, we stop current animations (which may be partially-completed enter
        // animations) so that we can then animate out. Velocity typically makes these transitions
        // very smooth, correctly animating from whatever state the element is currently in.
        if (entering) {
          doneFn();
          doneFn = null;
        } else {
          Velocity(nodes, 'stop');
        }
        var combinedCompleteFn;
        if (doneFn && opts.complete) {
          var optsCompleteFn = opts.complete;
          combinedCompleteFn = function combinedCompleteFn() {
            doneFn();
            // preserve this / args from Velocity so the complete function has context for what completed
            optsCompleteFn.apply(this, arguments);
          };
        } else {
          // One or the other or neither.
          combinedCompleteFn = doneFn || opts.complete;
        }

        // Bit of a hack. Without this rAF, sometimes an enter animation doesn't start running, or is
        // stopped before getting anywhere. This should get us on the other side of both completeFn and
        // any _finishAnimation that's happening.
        var t = shimRequestAnimationFrame(function () {
          var idx = _this4._scheduledAnimationRunFrames.indexOf(t);
          if (idx >= 0) {
            _this4._scheduledAnimationRunFrames.splice(idx, 1);
          }
          Velocity(nodes, animation, _.extend({}, opts, {
            complete: combinedCompleteFn
          }));
        });
        this._scheduledAnimationRunFrames.push(t);
      }
    }, {
      key: '_finishAnimation',
      value: function _finishAnimation(node, animationProp, overrideOpts) {
        var parsedAnimation = this._parseAnimationProp(animationProp);
        var animation = parsedAnimation.animation;
        var style = parsedAnimation.style;
        var opts = _.extend({}, parsedAnimation.opts, overrideOpts);
        if (style != null) {
          _.each(style, function (value, key) {
            Velocity.hook(node, key, value);
          });
        }
        if (animation != null) {
          // Opts are relevant even though we're immediately finishing, since things like "display"
          // can affect the animation outcome.

          Velocity(node, animation, opts);
          Velocity(node, 'finishAll', true);
        }
      }
    }, {
      key: '_wrapChild',
      value: function _wrapChild(child) {
        // Need to guard against falsey children, which React will sometimes pass
        // in.
        if (!child) {
          return null;
        }
        return React.createElement(VelocityTransitionGroupChild, {
          key: child.key,
          willAppearFunc: this.childWillAppear,
          willEnterFunc: this.childWillEnter,
          willLeaveFunc: this.childWillLeave
        }, child);
      }
    }]);
    return VelocityTransitionGroup;
  }(React.Component);
  VelocityTransitionGroup.disabledForTest = false; // global, mutable, for disabling animations during test

  VelocityTransitionGroup.propTypes = {
    runOnMount: PropTypes.bool,
    enter: PropTypes.any,
    leave: PropTypes.any,
    children: PropTypes.any,
    enterHideStyle: PropTypes.object,
    enterShowStyle: PropTypes.object
  };
  VelocityTransitionGroup.defaultProps = {
    runOnMount: false,
    enter: null,
    leave: null,
    enterHideStyle: {
      display: 'none'
    },
    enterShowStyle: {
      display: ''
    }
  };
  module.exports = VelocityTransitionGroup;

  /***/
}, /* 347 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(145);

  /***/
}, /* 348 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(349);

  /***/
}, /* 349 */
/***/function (module, exports, __webpack_require__) {
  var copyObject = __webpack_require__(82),
    createAssigner = __webpack_require__(350),
    keysIn = __webpack_require__(107);

  /**
   * This method is like `_.assign` except that it iterates over own and
   * inherited source properties.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @alias extend
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @see _.assign
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * function Bar() {
   *   this.c = 3;
   * }
   *
   * Foo.prototype.b = 2;
   * Bar.prototype.d = 4;
   *
   * _.assignIn({ 'a': 0 }, new Foo, new Bar);
   * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
   */
  var assignIn = createAssigner(function (object, source) {
    copyObject(source, keysIn(source), object);
  });
  module.exports = assignIn;

  /***/
}, /* 350 */
/***/function (module, exports, __webpack_require__) {
  var baseRest = __webpack_require__(351),
    isIterateeCall = __webpack_require__(352);

  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */
  function createAssigner(assigner) {
    return baseRest(function (object, sources) {
      var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;
      customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? undefined : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }
  module.exports = createAssigner;

  /***/
}, /* 351 */
/***/function (module, exports, __webpack_require__) {
  var identity = __webpack_require__(100),
    overRest = __webpack_require__(205),
    setToString = __webpack_require__(206);

  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */
  function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
  }
  module.exports = baseRest;

  /***/
}, /* 352 */
/***/function (module, exports, __webpack_require__) {
  var eq = __webpack_require__(103),
    isArrayLike = __webpack_require__(88),
    isIndex = __webpack_require__(148),
    isObject = __webpack_require__(63);

  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */
  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
      return eq(object[index], value);
    }
    return false;
  }
  module.exports = isIterateeCall;

  /***/
}, /* 353 */
/***/function (module, exports, __webpack_require__) {
  var arrayMap = __webpack_require__(159),
    baseIteratee = __webpack_require__(354),
    baseMap = __webpack_require__(366),
    isArray = __webpack_require__(44);

  /**
   * Creates an array of values by running each element in `collection` thru
   * `iteratee`. The iteratee is invoked with three arguments:
   * (value, index|key, collection).
   *
   * Many lodash methods are guarded to work as iteratees for methods like
   * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
   *
   * The guarded methods are:
   * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
   * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
   * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
   * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   * @example
   *
   * function square(n) {
   *   return n * n;
   * }
   *
   * _.map([4, 8], square);
   * // => [16, 64]
   *
   * _.map({ 'a': 4, 'b': 8 }, square);
   * // => [16, 64] (iteration order is not guaranteed)
   *
   * var users = [
   *   { 'user': 'barney' },
   *   { 'user': 'fred' }
   * ];
   *
   * // The `_.property` iteratee shorthand.
   * _.map(users, 'user');
   * // => ['barney', 'fred']
   */
  function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
  }
  module.exports = map;

  /***/
}, /* 354 */
/***/function (module, exports, __webpack_require__) {
  var baseMatches = __webpack_require__(355),
    baseMatchesProperty = __webpack_require__(358),
    identity = __webpack_require__(100),
    isArray = __webpack_require__(44),
    property = __webpack_require__(363);

  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */
  function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
      return value;
    }
    if (value == null) {
      return identity;
    }
    if (typeof value == 'object') {
      return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }
    return property(value);
  }
  module.exports = baseIteratee;

  /***/
}, /* 355 */
/***/function (module, exports, __webpack_require__) {
  var baseIsMatch = __webpack_require__(356),
    getMatchData = __webpack_require__(357),
    matchesStrictComparable = __webpack_require__(208);

  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function (object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }
  module.exports = baseMatches;

  /***/
}, /* 356 */
/***/function (module, exports, __webpack_require__) {
  var Stack = __webpack_require__(154),
    baseIsEqual = __webpack_require__(153);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

  /**
   * The base implementation of `_.isMatch` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Object} source The object of property values to match.
   * @param {Array} matchData The property names, values, and compare flags to match.
   * @param {Function} [customizer] The function to customize comparisons.
   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
   */
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length,
      length = index,
      noCustomizer = !customizer;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0],
        objValue = object[key],
        srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === undefined && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack();
        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
          return false;
        }
      }
    }
    return true;
  }
  module.exports = baseIsMatch;

  /***/
}, /* 357 */
/***/function (module, exports, __webpack_require__) {
  var isStrictComparable = __webpack_require__(207),
    keys = __webpack_require__(74);

  /**
   * Gets the property names, values, and compare flags of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the match data of `object`.
   */
  function getMatchData(object) {
    var result = keys(object),
      length = result.length;
    while (length--) {
      var key = result[length],
        value = object[key];
      result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
  }
  module.exports = getMatchData;

  /***/
}, /* 358 */
/***/function (module, exports, __webpack_require__) {
  var baseIsEqual = __webpack_require__(153),
    get = __webpack_require__(359),
    hasIn = __webpack_require__(360),
    isKey = __webpack_require__(162),
    isStrictComparable = __webpack_require__(207),
    matchesStrictComparable = __webpack_require__(208),
    toKey = __webpack_require__(89);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

  /**
   * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
   *
   * @private
   * @param {string} path The path of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey(path), srcValue);
    }
    return function (object) {
      var objValue = get(object, path);
      return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
  }
  module.exports = baseMatchesProperty;

  /***/
}, /* 359 */
/***/function (module, exports, __webpack_require__) {
  var baseGet = __webpack_require__(164);

  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */
  function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }
  module.exports = get;

  /***/
}, /* 360 */
/***/function (module, exports, __webpack_require__) {
  var baseHasIn = __webpack_require__(361),
    hasPath = __webpack_require__(362);

  /**
   * Checks if `path` is a direct or inherited property of `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.hasIn(object, 'a');
   * // => true
   *
   * _.hasIn(object, 'a.b');
   * // => true
   *
   * _.hasIn(object, ['a', 'b']);
   * // => true
   *
   * _.hasIn(object, 'b');
   * // => false
   */
  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }
  module.exports = hasIn;

  /***/
}, /* 361 */
/***/function (module, exports) {
  /**
   * The base implementation of `_.hasIn` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }
  module.exports = baseHasIn;

  /***/
}, /* 362 */
/***/function (module, exports, __webpack_require__) {
  var castPath = __webpack_require__(108),
    isArguments = __webpack_require__(146),
    isArray = __webpack_require__(44),
    isIndex = __webpack_require__(148),
    isLength = __webpack_require__(149),
    toKey = __webpack_require__(89);

  /**
   * Checks if `path` exists on `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @param {Function} hasFunc The function to check properties.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   */
  function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1,
      length = path.length,
      result = false;
    while (++index < length) {
      var key = toKey(path[index]);
      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result || ++index != length) {
      return result;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
  }
  module.exports = hasPath;

  /***/
}, /* 363 */
/***/function (module, exports, __webpack_require__) {
  var baseProperty = __webpack_require__(364),
    basePropertyDeep = __webpack_require__(365),
    isKey = __webpack_require__(162),
    toKey = __webpack_require__(89);

  /**
   * Creates a function that returns the value at `path` of a given object.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   * @example
   *
   * var objects = [
   *   { 'a': { 'b': 2 } },
   *   { 'a': { 'b': 1 } }
   * ];
   *
   * _.map(objects, _.property('a.b'));
   * // => [2, 1]
   *
   * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
   * // => [1, 2]
   */
  function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
  }
  module.exports = property;

  /***/
}, /* 364 */
/***/function (module, exports) {
  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function (object) {
      return object == null ? undefined : object[key];
    };
  }
  module.exports = baseProperty;

  /***/
}, /* 365 */
/***/function (module, exports, __webpack_require__) {
  var baseGet = __webpack_require__(164);

  /**
   * A specialized version of `baseProperty` which supports deep paths.
   *
   * @private
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyDeep(path) {
    return function (object) {
      return baseGet(object, path);
    };
  }
  module.exports = basePropertyDeep;

  /***/
}, /* 366 */
/***/function (module, exports, __webpack_require__) {
  var baseEach = __webpack_require__(186),
    isArrayLike = __webpack_require__(88);

  /**
   * The base implementation of `_.map` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function baseMap(collection, iteratee) {
    var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function (value, key, collection) {
      result[++index] = iteratee(value, key, collection);
    });
    return result;
  }
  module.exports = baseMap;

  /***/
}, /* 367 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.default = void 0;
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _reactLifecyclesCompat = __webpack_require__(169);
  var _ChildMapping = __webpack_require__(368);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  var values = Object.values || function (obj) {
    return Object.keys(obj).map(function (k) {
      return obj[k];
    });
  };
  var defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
      return child;
    }
    /**
     * The `<TransitionGroup>` component manages a set of transition components
     * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
     * components, `<TransitionGroup>` is a state machine for managing the mounting
     * and unmounting of components over time.
     *
     * Consider the example below. As items are removed or added to the TodoList the
     * `in` prop is toggled automatically by the `<TransitionGroup>`.
     *
     * Note that `<TransitionGroup>`  does not define any animation behavior!
     * Exactly _how_ a list item animates is up to the individual transition
     * component. This means you can mix and match animations across different list
     * items.
     */
  };

  var TransitionGroup = /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
      var _this;
      _this = _React$Component.call(this, props, context) || this;
      var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear

      _this.state = {
        handleExited: handleExited,
        firstRender: true
      };
      return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
      return {
        transitionGroup: {
          isMounting: !this.appeared
        }
      };
    };
    _proto.componentDidMount = function componentDidMount() {
      this.appeared = true;
      this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
      var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
      return {
        children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
        firstRender: false
      };
    };
    _proto.handleExited = function handleExited(child, node) {
      var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
      if (child.key in currentChildMapping) return;
      if (child.props.onExited) {
        child.props.onExited(node);
      }
      if (this.mounted) {
        this.setState(function (state) {
          var children = _extends({}, state.children);
          delete children[child.key];
          return {
            children: children
          };
        });
      }
    };
    _proto.render = function render() {
      var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
      var children = values(this.state.children).map(childFactory);
      delete props.appear;
      delete props.enter;
      delete props.exit;
      if (Component === null) {
        return children;
      }
      return _react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
  }(_react.default.Component);
  TransitionGroup.childContextTypes = {
    transitionGroup: _propTypes.default.object.isRequired
  };
  TransitionGroup.propTypes = false ? undefined : {};
  TransitionGroup.defaultProps = defaultProps;
  var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
  exports.default = _default;
  module.exports = exports["default"];

  /***/
}, /* 368 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.getChildMapping = getChildMapping;
  exports.mergeChildMappings = mergeChildMappings;
  exports.getInitialChildMapping = getInitialChildMapping;
  exports.getNextChildMapping = getNextChildMapping;
  var _react = __webpack_require__(1);

  /**
   * Given `this.props.children`, return an object mapping key to child.
   *
   * @param {*} children `this.props.children`
   * @return {object} Mapping of key to child
   */
  function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
      return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) _react.Children.map(children, function (c) {
      return c;
    }).forEach(function (child) {
      // run the map function here instead so that the key is the computed one
      result[child.key] = mapper(child);
    });
    return result;
  }
  /**
   * When you're adding or removing children some may be added or removed in the
   * same render pass. We want to show *both* since we want to simultaneously
   * animate elements in and out. This function takes a previous set of keys
   * and a new set of keys and merges them with its best guess of the correct
   * ordering. In the future we may expose some of the utilities in
   * ReactMultiChild to make this easy, but for now React itself does not
   * directly have this concept of the union of prevChildren and nextChildren
   * so we implement it here.
   *
   * @param {object} prev prev children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @param {object} next next children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @return {object} a key set that contains all keys in `prev` and all keys
   * in `next` in a reasonable order.
   */

  function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
      return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list

    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for (var prevKey in prev) {
      if (prevKey in next) {
        if (pendingKeys.length) {
          nextKeysPending[prevKey] = pendingKeys;
          pendingKeys = [];
        }
      } else {
        pendingKeys.push(prevKey);
      }
    }
    var i;
    var childMapping = {};
    for (var nextKey in next) {
      if (nextKeysPending[nextKey]) {
        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
          var pendingNextKey = nextKeysPending[nextKey][i];
          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
      }
      childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`

    for (i = 0; i < pendingKeys.length; i++) {
      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    }
    return childMapping;
  }
  function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
  }
  function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function (child) {
      return (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        appear: getProp(child, 'appear', props),
        enter: getProp(child, 'enter', props),
        exit: getProp(child, 'exit', props)
      });
    });
  }
  function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function (key) {
      var child = children[key];
      if (!(0, _react.isValidElement)(child)) return;
      var hasPrev = (key in prevChildMapping);
      var hasNext = (key in nextChildMapping);
      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited.bind(null, child),
          in: true,
          exit: getProp(child, 'exit', nextProps),
          enter: getProp(child, 'enter', nextProps)
        });
      } else if (!hasNext && hasPrev && !isLeaving) {
        // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
          in: false
        });
      } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
        // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited.bind(null, child),
          in: prevChild.props.in,
          exit: getProp(child, 'exit', nextProps),
          enter: getProp(child, 'enter', nextProps)
        });
      }
    });
    return children;
  }

  /***/
}, /* 369 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
  var PropTypes = _interopRequireWildcard(__webpack_require__(0));
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _reactDom = _interopRequireDefault(__webpack_require__(15));
  var _reactLifecyclesCompat = __webpack_require__(169);
  var _PropTypes = __webpack_require__(370);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
            if (desc.get || desc.set) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }
  var UNMOUNTED = 'unmounted';
  exports.UNMOUNTED = UNMOUNTED;
  var EXITED = 'exited';
  exports.EXITED = EXITED;
  var ENTERING = 'entering';
  exports.ENTERING = ENTERING;
  var ENTERED = 'entered';
  exports.ENTERED = ENTERED;
  var EXITING = 'exiting';
  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * ---
   *
   * **Note**: `Transition` is a platform-agnostic base component. If you're using
   * transitions in CSS, you'll probably want to use
   * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
   * instead. It inherits all the features of `Transition`, but contains
   * additional features necessary to play nice with CSS transitions (hence the
   * name of the component).
   *
   * ---
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the
   * components. It's up to you to give meaning and effect to those states. For
   * example we can add styles to a component when it enters or exits:
   *
   * ```jsx
   * import { Transition } from 'react-transition-group';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 0 },
   *   entered:  { opacity: 1 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {state => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm a fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * There are 4 main states a Transition can be in:
   *  - `'entering'`
   *  - `'entered'`
   *  - `'exiting'`
   *  - `'exited'`
   *
   * Transition state is toggled via the `in` prop. When `true` the component
   * begins the "Enter" stage. During this stage, the component will shift from
   * its current transition state, to `'entering'` for the duration of the
   * transition and then to the `'entered'` stage once it's complete. Let's take
   * the following example (we'll use the
   * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
   *
   * ```jsx
   * function App() {
   *   const [inProp, setInProp] = useState(false);
   *   return (
   *     <div>
   *       <Transition in={inProp} timeout={500}>
   *         {state => (
   *           // ...
   *         )}
   *       </Transition>
   *       <button onClick={() => setInProp(true)}>
   *         Click to Enter
   *       </button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state
   * and stay there for 500ms (the value of `timeout`) before it finally switches
   * to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from
   * `'exiting'` to `'exited'`.
   */

  exports.EXITING = EXITING;
  var Transition = /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
      var _this;
      _this = _React$Component.call(this, props, context) || this;
      var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
      var initialStatus;
      _this.appearStatus = null;
      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.appearStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }
      _this.state = {
        status: initialStatus
      };
      _this.nextCallback = null;
      return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
      return {
        transitionGroup: null // allows for nested Transitions
      };
    };

    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
      var nextIn = _ref.in;
      if (nextIn && prevState.status === UNMOUNTED) {
        return {
          status: EXITED
        };
      }
      return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }

    _proto.componentDidMount = function componentDidMount() {
      this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      var nextStatus = null;
      if (prevProps !== this.props) {
        var status = this.state.status;
        if (this.props.in) {
          if (status !== ENTERING && status !== ENTERED) {
            nextStatus = ENTERING;
          }
        } else {
          if (status === ENTERING || status === ENTERED) {
            nextStatus = EXITING;
          }
        }
      }
      this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;
      var exit, enter, appear;
      exit = enter = appear = timeout;
      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter; // TODO: remove fallback for next major

        appear = timeout.appear !== undefined ? timeout.appear : enter;
      }
      return {
        exit: exit,
        enter: enter,
        appear: appear
      };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
      if (mounting === void 0) {
        mounting = false;
      }
      if (nextStatus !== null) {
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();
        var node = _reactDom.default.findDOMNode(this);
        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({
          status: UNMOUNTED
        });
      }
    };
    _proto.performEnter = function performEnter(node, mounting) {
      var _this2 = this;
      var enter = this.props.enter;
      var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
      var timeouts = this.getTimeouts();
      var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set

      if (!mounting && !enter) {
        this.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node);
        });
        return;
      }
      this.props.onEnter(node, appearing);
      this.safeSetState({
        status: ENTERING
      }, function () {
        _this2.props.onEntering(node, appearing);
        _this2.onTransitionEnd(node, enterTimeout, function () {
          _this2.safeSetState({
            status: ENTERED
          }, function () {
            _this2.props.onEntered(node, appearing);
          });
        });
      });
    };
    _proto.performExit = function performExit(node) {
      var _this3 = this;
      var exit = this.props.exit;
      var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

      if (!exit) {
        this.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
        return;
      }
      this.props.onExit(node);
      this.safeSetState({
        status: EXITING
      }, function () {
        _this3.props.onExiting(node);
        _this3.onTransitionEnd(node, timeouts.exit, function () {
          _this3.safeSetState({
            status: EXITED
          }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
      var _this4 = this;
      var active = true;
      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this4.nextCallback = null;
          callback(event);
        }
      };
      this.nextCallback.cancel = function () {
        active = false;
      };
      return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);
      var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
      if (!node || doesNotHaveTimeoutOrListener) {
        setTimeout(this.nextCallback, 0);
        return;
      }
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    };
    _proto.render = function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }
      var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition

      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;
      if (typeof children === 'function') {
        return children(status, childProps);
      }
      var child = _react.default.Children.only(children);
      return _react.default.cloneElement(child, childProps);
    };
    return Transition;
  }(_react.default.Component);
  Transition.contextTypes = {
    transitionGroup: PropTypes.object
  };
  Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
  };
  Transition.propTypes = false ? undefined : {};
  function noop() {}
  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
  };
  Transition.UNMOUNTED = 0;
  Transition.EXITED = 1;
  Transition.ENTERING = 2;
  Transition.ENTERED = 3;
  Transition.EXITING = 4;
  var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
  exports.default = _default;

  /***/
}, /* 370 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.classNamesShape = exports.timeoutsShape = void 0;
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var timeoutsShape = false ? undefined : null;
  exports.timeoutsShape = timeoutsShape;
  var classNamesShape = false ? undefined : null;
  exports.classNamesShape = classNamesShape;

  /***/
}, /* 371 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  // Copyright (c) 2015 Twitter, Inc. and other contributors
  var _ = {
    isObject: __webpack_require__(63)
  };
  var Velocity = __webpack_require__(165);
  var effectCounter = 0;

  // Takes a Velocity "UI pack effect" definition and registers it with a unique key, returning that
  // key (to later pass as a value for the "animation" property). Takes an optional suffix, which can
  // be "In" or "Out" to modify UI Pack's behavior.
  //
  // Unlike what you get from passing a style hash to VelocityComponent's "animation" property,
  // Velocity "UI pack effects" can have chained animation calls and specify a "defaultDuration", and
  // also can take advantage of "stagger" and "reverse" options on the VelocityComponent.
  //
  // You will need to manually register the UI Pack with the global Velocity in your application with:
  //
  //   require('velocity');
  //   require('velocity-animate/velocity.ui');
  //
  // See: http://julian.com/research/velocity/#uiPack
  //
  // Typical usage:
  //
  // var Animations = {
  //   down: VelocityHelpers.registerEffect({
  //     defaultDuration: 1100,
  //     calls: [
  //       [{
  //         transformOriginX: [ '50%', '50%' ],
  //         transformOriginY: [ 0, 0 ],
  //         rotateX: [0, 'spring'],
  //       }, 1, {
  //         delay: 100,
  //         easing: 'ease-in',
  //       }]
  //     ],
  //   }),
  //
  //   up: VelocityHelpers.registerEffect({
  //     defaultDuration: 200,
  //     calls: [
  //       [{
  //         transformOriginX: [ '50%', '50%' ],
  //         transformOriginY: [ 0, 0 ],
  //         rotateX: 160,
  //       }]
  //     ],
  //   }),
  // };
  // ...
  // <VelocityComponent animation={this.state.isUp ? Animations.up : Animations.down}>
  //   ...
  // <Velocity>
  function registerEffect(suffix, animation) {
    if (_.isObject(suffix)) {
      animation = suffix;
      suffix = '';
    }
    var key = 'VelocityHelper.animation.' + effectCounter++ + suffix;

    // No-op on the server for now.
    if (Velocity.velocityReactServerShim) {
      return key;
    }
    if (Velocity.RegisterEffect === undefined) {
      throw "Velocity.RegisterEffect not found. You need to require 'velocity-animate/velocity.ui' at a top level for UI Pack.";
    }
    Velocity.RegisterEffect(key, animation);
    return key;
  }
  module.exports = {
    registerEffect: registerEffect
  };

  /***/
}, /* 372 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return animated;
  });
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "animated", function () {
    return animated;
  });
  /* harmony import */
  var _react_spring_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(110);
  /* harmony reexport (unknown) */
  for (var __WEBPACK_IMPORT_KEY__ in _react_spring_core__WEBPACK_IMPORTED_MODULE_0__) if (["default", "a", "animated"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function (key) {
    __webpack_require__.d(__webpack_exports__, key, function () {
      return _react_spring_core__WEBPACK_IMPORTED_MODULE_0__[key];
    });
  })(__WEBPACK_IMPORT_KEY__);
  /* harmony import */
  var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15);
  /* harmony import */
  var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
  /* harmony import */
  var _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);
  /* harmony import */
  var _react_spring_animated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26);
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  const _excluded$2 = ["style", "children", "scrollTop", "scrollLeft", "viewBox"];
  const isCustomPropRE = /^--/;
  function dangerousStyleValue(name, value) {
    if (value == null || typeof value === 'boolean' || value === '') return '';
    if (typeof value === 'number' && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px';
    return ('' + value).trim();
  }
  const attributeCache = {};
  function applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) {
      return false;
    }
    const isFilterElement = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';
    const _ref = props,
      {
        style,
        children,
        scrollTop,
        scrollLeft,
        viewBox
      } = _ref,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded$2);
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map(name => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, n => '-' + n.toLowerCase())));
    if (children !== void 0) {
      instance.textContent = children;
    }
    for (let name in style) {
      if (style.hasOwnProperty(name)) {
        const value = dangerousStyleValue(name, style[name]);
        if (isCustomPropRE.test(name)) {
          instance.style.setProperty(name, value);
        } else {
          instance.style[name] = value;
        }
      }
    }
    names.forEach((name, i) => {
      instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) {
      instance.scrollTop = scrollTop;
    }
    if (scrollLeft !== void 0) {
      instance.scrollLeft = scrollLeft;
    }
    if (viewBox !== void 0) {
      instance.setAttribute('viewBox', viewBox);
    }
  }
  let isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
  };
  const prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);
  const prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
  isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
    prefixes.forEach(prefix => acc[prefixKey(prefix, prop)] = acc[prop]);
    return acc;
  }, isUnitlessNumber);
  const _excluded$1 = ["x", "y", "z"];
  const domTransforms = /^(matrix|translate|scale|rotate|skew)/;
  const pxTransforms = /^(translate)/;
  const degTransforms = /^(rotate|skew)/;
  const addUnit = (value, unit) => _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* is */"t"].num(value) && value !== 0 ? value + unit : value;
  const isValueIdentity = (value, id) => _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* is */"t"].arr(value) ? value.every(v => isValueIdentity(v, id)) : _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* is */"t"].num(value) ? value === id : parseFloat(value) === id;
  class AnimatedStyle extends _react_spring_animated__WEBPACK_IMPORTED_MODULE_3__[/* AnimatedObject */"a"] {
    constructor(_ref) {
      let {
          x,
          y,
          z
        } = _ref,
        style = _objectWithoutPropertiesLoose(_ref, _excluded$1);
      const inputs = [];
      const transforms = [];
      if (x || y || z) {
        inputs.push([x || 0, y || 0, z || 0]);
        transforms.push(xyz => [`translate3d(${xyz.map(v => addUnit(v, 'px')).join(',')})`, isValueIdentity(xyz, 0)]);
      }
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* eachProp */"l"])(style, (value, key) => {
        if (key === 'transform') {
          inputs.push([value || '']);
          transforms.push(transform => [transform, transform === '']);
        } else if (domTransforms.test(key)) {
          delete style[key];
          if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* is */"t"].und(value)) return;
          const unit = pxTransforms.test(key) ? 'px' : degTransforms.test(key) ? 'deg' : '';
          inputs.push(Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* toArray */"B"])(value));
          transforms.push(key === 'rotate3d' ? ([x, y, z, deg]) => [`rotate3d(${x},${y},${z},${addUnit(deg, unit)})`, isValueIdentity(deg, 0)] : input => [`${key}(${input.map(v => addUnit(v, unit)).join(',')})`, isValueIdentity(input, key.startsWith('scale') ? 1 : 0)]);
        }
      });
      if (inputs.length) {
        style.transform = new FluidTransform(inputs, transforms);
      }
      super(style);
    }
  }
  class FluidTransform extends _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* FluidValue */"a"] {
    constructor(inputs, transforms) {
      super();
      this._value = null;
      this.inputs = inputs;
      this.transforms = transforms;
    }
    get() {
      return this._value || (this._value = this._get());
    }
    _get() {
      let transform = '';
      let identity = true;
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* each */"k"])(this.inputs, (input, i) => {
        const arg1 = Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* getFluidValue */"r"])(input[0]);
        const [t, id] = this.transforms[i](_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* is */"t"].arr(arg1) ? arg1 : input.map(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* getFluidValue */"r"]));
        transform += ' ' + t;
        identity = identity && id;
      });
      return identity ? 'none' : transform;
    }
    observerAdded(count) {
      if (count == 1) Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* each */"k"])(this.inputs, input => Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* each */"k"])(input, value => Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* hasFluidValue */"s"])(value) && Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* addFluidObserver */"c"])(value, this)));
    }
    observerRemoved(count) {
      if (count == 0) Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* each */"k"])(this.inputs, input => Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* each */"k"])(input, value => Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* hasFluidValue */"s"])(value) && Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* removeFluidObserver */"A"])(value, this)));
    }
    eventObserved(event) {
      if (event.type == 'change') {
        this._value = null;
      }
      Object(_react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* callFluidObservers */"d"])(this, event);
    }
  }
  const primitives = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
  const _excluded = ["scrollTop", "scrollLeft"];
  _react_spring_core__WEBPACK_IMPORTED_MODULE_0__["Globals"].assign({
    batchedUpdates: react_dom__WEBPACK_IMPORTED_MODULE_1__["unstable_batchedUpdates"],
    createStringInterpolator: _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* createStringInterpolator */"g"],
    colors: _react_spring_shared__WEBPACK_IMPORTED_MODULE_2__[/* colors */"e"]
  });
  const host = Object(_react_spring_animated__WEBPACK_IMPORTED_MODULE_3__[/* createHost */"d"])(primitives, {
    applyAnimatedValues,
    createAnimatedStyle: style => new AnimatedStyle(style),
    getComponentProps: _ref => {
      let props = _objectWithoutPropertiesLoose(_ref, _excluded);
      return props;
    }
  });
  const animated = host.animated;

  /***/
}, /* 373 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ReelsVertical;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ReelsVertical(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media-vertical video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 reels reel vertical"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "vertical-icon-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "footer-placeholder-shapes"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText || "[Missing Primary Text]"), $cta));
  }
  ReelsVertical.displayName = "ReelsVertical";
  ReelsVertical.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  ReelsVertical.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 374 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ReelsSquare;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ReelsSquare(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        alt: image.name,
        src: image.src,
        className: "fb-media image"
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media-square video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 reels square reel"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "vertical-icon-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "footer-placeholder-shapes"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText || "[Missing Primary Text]"), $cta));
  }
  ReelsSquare.displayName = "ReelsSquare";
  ReelsSquare.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  ReelsSquare.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 375 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ReelsHorizontal;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ReelsHorizontal(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name,
        className: "fb-media image"
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media-horizontal"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 reels reel horizontal horizontal-reel vertical"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "vertical-icon-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "footer-placeholder-shapes"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText || "[Missing Primary Text]"), $cta));
  }
  ReelsHorizontal.displayName = "ReelsHorizontal";
  ReelsHorizontal.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  ReelsHorizontal.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 376 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FeedsVertical;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _functions = __webpack_require__(33);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function FeedsVertical(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      displayLink = socialValues.displayLink,
      headline = socialValues.headline,
      description = socialValues.description,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      landingPage = socialValues.landingPage,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name));
    }
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name,
        className: "fb-media image"
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media-square video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    var domainName = (0, _functions.getDomainFromUrl)(landingPage);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 feeds vertical"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "facebook-header-text"
    }, primaryText || "[Missing Primary Text]")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-container"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-grey-box"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "grey-text"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-1 display-link"
    }, displayLink ? displayLink : domainName), /*#__PURE__*/_react["default"].createElement("br", null), headline ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-2 headline"
    }, headline) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "headline-skeleton"
    }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-3 description"
    }, description)), $cta), /*#__PURE__*/_react["default"].createElement("div", {
      className: "bottom-section"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }))));
  }
  FeedsVertical.displayName = "FeedsVertical";
  FeedsVertical.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  FeedsVertical.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      displayLink: _propTypes["default"].string,
      headline: _propTypes["default"].string,
      description: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 377 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FacebookImageSquare;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _functions = __webpack_require__(33);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  // Facebook Image Feeds Square
  function FacebookImageSquare(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      displayLink = socialValues.displayLink,
      headline = socialValues.headline,
      description = socialValues.description,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      landingPage = socialValues.landingPage,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name));
    }
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name,
        className: "fb-media image"
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media-square video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    var domainName = (0, _functions.getDomainFromUrl)(landingPage);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 feeds square"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "facebook-header-text"
    }, primaryText || "[Missing Primary Text]")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-container"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-grey-box"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "grey-text"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-1 display-link"
    }, displayLink ? displayLink : domainName), /*#__PURE__*/_react["default"].createElement("br", null), headline ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-2 headline"
    }, headline) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "headline-skeleton"
    }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-3 description"
    }, description)), $cta), /*#__PURE__*/_react["default"].createElement("div", {
      className: "bottom-section"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }))));
  }
  FacebookImageSquare.displayName = "FacebookImageSquare";
  FacebookImageSquare.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  FacebookImageSquare.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      displayLink: _propTypes["default"].string,
      headline: _propTypes["default"].string,
      description: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 378 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FeedsHorizontal;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _functions = __webpack_require__(33);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function FeedsHorizontal(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      displayLink = socialValues.displayLink,
      headline = socialValues.headline,
      description = socialValues.description,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      landingPage = socialValues.landingPage,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name));
    }
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name,
        className: "fb-media image"
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media-horizontal"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    var domainName = (0, _functions.getDomainFromUrl)(landingPage);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 horizontal feeds"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header-text-container"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "facebook-header-text"
    }, primaryText || "[Missing Primary Text]"))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-grey-box"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "grey-text"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-1 display-link"
    }, displayLink ? displayLink : domainName), /*#__PURE__*/_react["default"].createElement("br", null), headline ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-2 headline"
    }, headline) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "headline-skeleton"
    }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
      className: "grey-text-3 description"
    }, description)), $cta), /*#__PURE__*/_react["default"].createElement("div", {
      className: "bottom-section"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }))));
  }
  FeedsHorizontal.displayName = "FeedsHorizontal";
  FeedsHorizontal.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  FeedsHorizontal.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      displayLink: _propTypes["default"].string,
      headline: _propTypes["default"].string,
      description: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 379 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = StoriesVertical;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function StoriesVertical(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media-vertical image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media-vertical video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-container"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-up",
        className: "chevron-up"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta === null || cta === void 0 ? void 0 : cta.name)));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 story vertical"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress-bar facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fal fa-times",
      className: "close"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), $cta);
  }
  StoriesVertical.displayName = "StoriesVertical";
  StoriesVertical.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  StoriesVertical.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 380 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = StoriesSquare;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function StoriesSquare(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var cta = socialValues.cta,
      image = socialValues.image,
      primaryText = socialValues.primaryText,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media-vertical image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media-vertical video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-up",
        className: "chevron-up"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta === null || cta === void 0 ? void 0 : cta.name)));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 stories square story"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress-bar facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fal fa-times",
      className: "close"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText), $cta);
  }
  StoriesSquare.displayName = "StoriesSquare";
  StoriesSquare.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  StoriesSquare.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      primaryText: _propTypes["default"].string,
      cta: _propTypes["default"].object,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 381 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = StoriesHorizontal;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function StoriesHorizontal(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var cta = socialValues.cta,
      image = socialValues.image,
      primaryText = socialValues.primaryText,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media-vertical image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media-horizontal video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-container"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-up",
        className: "chevron-up"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta === null || cta === void 0 ? void 0 : cta.name)));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 stories story horizontal horizontal-stories vertical"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress-bar facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fal fa-times",
      className: "close"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "primary-text-container"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText)), $cta);
  }
  StoriesHorizontal.displayName = "StoriesHorizontal";
  StoriesHorizontal.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  StoriesHorizontal.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      image: _propTypes["default"].object,
      primaryText: _propTypes["default"].string
    })
  };

  /***/
}, /* 382 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramReelsVertical;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function InstagramReelsVertical(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 reels reel vertical instagram"
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: "reel-header"
    }, "Reels"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "vertical-icon-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-ovals"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "footer-placeholder-shapes"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    })), $cta, /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-footer-container"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText || "[Missing Primary Text]"), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "footer-ellipsis"
    }))));
  }
  InstagramReelsVertical.displayName = "InstagramReelsVertical";
  InstagramReelsVertical.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  InstagramReelsVertical.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 383 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramFeedsVertical;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function InstagramFeedsVertical(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "missing-cta"
      }),
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "cta-name"
      }, cta.name), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-right",
        className: "chevron-right"
      }));
    }
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name,
        className: "fb-media image"
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 vertical feeds instagram"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "top-bar"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-container"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, $cta, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "left-side"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "right-side"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }))), /*#__PURE__*/_react["default"].createElement("p", {
      className: "facebook-footer-text"
    }, primaryText || "[Missing Primary Text]")));
  }
  InstagramFeedsVertical.displayName = "InstagramFeedsVertical";
  InstagramFeedsVertical.defaultProps = {
    socialValues: {}
  };
  InstagramFeedsVertical.propTypes = {
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 384 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramStoriesVertical;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function InstagramStoriesVertical(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media-vertical image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-container"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-up",
        className: "chevron-up"
      }), ";", /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name)));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 story vertical instagram"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress-bar facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fal fa-times",
      className: "close"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), $cta);
  }
  InstagramStoriesVertical.displayName = "InstagramStoriesVertical";
  InstagramStoriesVertical.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  InstagramStoriesVertical.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 385 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramReelsSquare;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function InstagramReelsSquare(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name,
        className: "fb-media image"
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 square reels reel instagram"
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: "reel-header"
    }, "Reels"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "vertical-icon-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-ovals"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "footer-placeholder-shapes"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    })), $cta, /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-footer-container"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText || "[Missing Primary Text]"), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "footer-ellipsis"
    }))));
  }
  InstagramReelsSquare.displayName = "InstagramReelsSquare";
  InstagramReelsSquare.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  InstagramReelsSquare.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 386 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramFeedsSquare;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function InstagramFeedsSquare(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "missing-cta"
      }),
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "cta-name"
      }, cta.name), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-right",
        className: "chevron-right"
      }));
    }
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name,
        className: "fb-media image"
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 square feeds instagram"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "top-bar"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-container"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, $cta, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "left-side"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "right-side"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }))), /*#__PURE__*/_react["default"].createElement("p", {
      className: "facebook-footer-text"
    }, primaryText || "[Missing Primary Text]")));
  }
  InstagramFeedsSquare.displayName = "InstagramFeedsSquare";
  InstagramFeedsSquare.defaultProps = {
    socialValues: {}
  };
  InstagramFeedsSquare.propTypes = {
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 387 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramStoriesSquare;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function InstagramStoriesSquare(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var cta = socialValues.cta,
      image = socialValues.image,
      primaryText = socialValues.primaryText,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-up",
        className: "chevron-up"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta === null || cta === void 0 ? void 0 : cta.name)));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 square story"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress-bar facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fal fa-times",
      className: "close"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText), $cta);
  }
  InstagramStoriesSquare.displayName = "InstagramStoriesSquare";
  InstagramStoriesSquare.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  InstagramStoriesSquare.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      primaryText: _propTypes["default"].string,
      cta: _propTypes["default"].object,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 388 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramReelsHorizontal;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function InstagramReelsHorizontal(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media-horizontal video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 reels horizontal reel horizontal-reel instagram vertical"
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: "reel-header"
    }, "Reels"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "vertical-icon-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-ovals"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "footer-placeholder-shapes"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    })), $cta, /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-footer-container"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText || "[Missing Primary Text]"), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "footer-ellipsis"
    }))));
  }
  InstagramReelsHorizontal.displayName = "InstagramReelsHorizontal";
  InstagramReelsHorizontal.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  InstagramReelsHorizontal.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 389 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramFeedsHorizontal;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function InstagramFeedsHorizontal(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      cta = socialValues.cta,
      image = socialValues.image,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "missing-cta"
      }),
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media image"
      });
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "cta-name"
      }, cta.name), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-right",
        className: "chevron-right"
      }));
    }
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name,
        className: "fb-media image"
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 feeds horizontal-feeds vertical instagram horizontal"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "top-bar"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-container"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, $cta, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "left-side"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "right-side"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }))), /*#__PURE__*/_react["default"].createElement("p", {
      className: "facebook-footer-text"
    }, primaryText || "[Missing Primary Text]")));
  }
  InstagramFeedsHorizontal.displayName = "InstagramFeedsHorizontal";
  InstagramFeedsHorizontal.defaultProps = {
    socialValues: {}
  };
  InstagramFeedsHorizontal.propTypes = {
    socialValues: _propTypes["default"].shape({
      cta: _propTypes["default"].object,
      primaryText: _propTypes["default"].string,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 390 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramStoriesHorizontal;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function InstagramStoriesHorizontal(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var cta = socialValues.cta,
      image = socialValues.image,
      primaryText = socialValues.primaryText,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe;
    var $cta = null,
      $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Media Asset",
        className: "fb-media-vertical image"
      });
    if (image !== null && image !== void 0 && image.src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name
      });
    }
    if (video !== null && video !== void 0 && video.src) {
      var vidProps = {
        autoPlay: autoPlay,
        controls: controls
      };
      if (typeof muted === "boolean") {
        vidProps.muted = muted;
      } else {
        vidProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
        className: "fb-media video"
      }), /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-up",
        className: "chevron-up"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta === null || cta === void 0 ? void 0 : cta.name)));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 horizontal-stories horizontal story vertical instagram"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress-bar facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fal fa-times",
      className: "close"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-media"
    }, $media), /*#__PURE__*/_react["default"].createElement("div", {
      className: "primary-text-container"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText)), $cta);
  }
  InstagramStoriesHorizontal.displayName = "InstagramStoriesHorizontal";
  InstagramStoriesHorizontal.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  InstagramStoriesHorizontal.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      primaryText: _propTypes["default"].string,
      cta: _propTypes["default"].object,
      image: _propTypes["default"].object
    })
  };

  /***/
}, /* 391 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = RenderMedia;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function RenderMedia(card) {
    var videoProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var image = card.image,
      video = card.video,
      type = card.type;
    var muted = videoProps.muted,
      autoPlay = videoProps.autoPlay;
    var $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
      message: "Missing Media Asset"
    });
    if (video !== null && video !== void 0 && video.src && type === "video") {
      if (typeof muted === "boolean") {
        videoProps.muted = muted;
      } else {
        videoProps.muted = autoPlay;
      }
      $media = /*#__PURE__*/_react["default"].createElement("video", videoProps, /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      }));
    } else if (image !== null && image !== void 0 && image.src && type === "image") {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: image.src,
        alt: image.name
      });
    }
    return $media;
  }

  /***/
}, /* 392 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _reactDataGrid = _interopRequireDefault(__webpack_require__(244));
  var _EmptyGrid = _interopRequireDefault(__webpack_require__(250));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var DataGrid = /*#__PURE__*/function (_Component) {
    _inherits(DataGrid, _Component);
    var _super = _createSuper(DataGrid);
    function DataGrid(props) {
      var _this;
      _classCallCheck(this, DataGrid);
      _this = _super.call(this, props);
      _this._ref = /*#__PURE__*/_react["default"].createRef();
      return _this;
    }
    _createClass(DataGrid, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var openEditorOnSingleClick = nextProps.openEditorOnSingleClick,
          columns = nextProps.columns;
        if (openEditorOnSingleClick && columns) {
          var ref = this._ref;
          columns.forEach(function (col) {
            if (col.editable) {
              var events = col.events || {};
              events.onClick = function (event, args) {
                //open editor on single click, instead of double click
                ref && ref.current && ref.current.openCellEditor(args.rowIdx, args.idx);
              };
              col.events = events;
            }
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "data-grid-holder"
        }, /*#__PURE__*/_react["default"].createElement(_reactDataGrid["default"], _extends({}, this.props, {
          ref: this._ref
        })));
      }
    }]);
    return DataGrid;
  }(_react.Component);
  exports["default"] = DataGrid;
  _defineProperty(DataGrid, "defaultProps", {
    rowGetter: null,
    columns: [],
    rowsCount: 0,
    data: [],
    emptyRowsView: _EmptyGrid["default"],
    openEditorOnSingleClick: false
  });
  _defineProperty(DataGrid, "propTypes", {
    rowGetter: _propTypes["default"].func.isRequired,
    rowsCount: _propTypes["default"].number.isRequired,
    columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      key: _propTypes["default"].string.isRequired,
      name: _propTypes["default"].string.isRequired,
      resizable: _propTypes["default"].bool,
      width: _propTypes["default"].number,
      formatter: _propTypes["default"].any,
      locked: _propTypes["default"].bool,
      editable: _propTypes["default"].bool,
      sortable: _propTypes["default"].bool,
      editor: _propTypes["default"].any,
      filterable: _propTypes["default"].bool
    })).isRequired,
    openEditorOnSingleClick: _propTypes["default"].bool
  });

  /***/
}, /* 393 */
/***/function (module, exports, __webpack_require__) {
  var global = __webpack_require__(394);
  var core = __webpack_require__(238);
  var ctx = __webpack_require__(475);
  var hide = __webpack_require__(427);
  var has = __webpack_require__(412);
  var PROTOTYPE = 'prototype';
  var $export = function (type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var IS_WRAP = type & $export.W;
    var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
    var expProto = exports[PROTOTYPE];
    var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for (key in source) {
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined;
      if (own && has(exports, key)) continue;
      // export native or passed
      out = own ? target[key] : source[key];
      // prevent global pollution for namespaces
      exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
      // bind timers to global for call from export context
      : IS_BIND && own ? ctx(out, global)
      // wrap global constructors for prevent change them in library
      : IS_WRAP && target[key] == out ? function (C) {
        var F = function (a, b, c) {
          if (this instanceof C) {
            switch (arguments.length) {
              case 0:
                return new C();
              case 1:
                return new C(a);
              case 2:
                return new C(a, b);
            }
            return new C(a, b, c);
          }
          return C.apply(this, arguments);
        };
        F[PROTOTYPE] = C[PROTOTYPE];
        return F;
        // make static versions for prototype methods
      }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
      // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
      if (IS_PROTO) {
        (exports.virtual || (exports.virtual = {}))[key] = out;
        // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
        if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
      }
    }
  };
  // type bitmap
  $export.F = 1; // forced
  $export.G = 2; // global
  $export.S = 4; // static
  $export.P = 8; // proto
  $export.B = 16; // bind
  $export.W = 32; // wrap
  $export.U = 64; // safe
  $export.R = 128; // real proto method for `library`
  module.exports = $export;

  /***/
}, /* 394 */
/***/function (module, exports) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

  /***/
}, /* 395 */
/***/function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(428);
  var IE8_DOM_DEFINE = __webpack_require__(518);
  var toPrimitive = __webpack_require__(476);
  var dP = Object.defineProperty;
  exports.f = __webpack_require__(396) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
      return dP(O, P, Attributes);
    } catch (e) {/* empty */}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };

  /***/
}, /* 396 */
/***/function (module, exports, __webpack_require__) {
  // Thank's IE8 for his funny defineProperty
  module.exports = !__webpack_require__(430)(function () {
    return Object.defineProperty({}, 'a', {
      get: function () {
        return 7;
      }
    }).a != 7;
  });

  /***/
}, /* 397 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _reduxForm = __webpack_require__(115);
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _index = __webpack_require__(114);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var Dimensions = /*#__PURE__*/function (_Component) {
    _inherits(Dimensions, _Component);
    var _super = _createSuper(Dimensions);
    function Dimensions() {
      _classCallCheck(this, Dimensions);
      return _super.apply(this, arguments);
    }
    _createClass(Dimensions, [{
      key: "_renderFreeForm",
      value: function _renderFreeForm() {
        var props = this.props,
          $by = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            icon: "close"
          }),
          $dims = null,
          widthProps = {
            name: props.widthName,
            className: "dim-width",
            required: props.required,
            label: props.label || ""
          },
          heightProps = {
            name: props.heightName,
            className: "dim-height",
            required: props.required,
            label: props.label ? " " : ""
          };
        if (props.useField) {
          $dims = /*#__PURE__*/_react["default"].createElement("div", {
            className: "dimensions"
          }, /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
            component: _index.ReduxControls.Input
          }, widthProps, {
            props: {
              type: "number",
              placeholder: "Width"
            }
          })), $by, /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
            component: _index.ReduxControls.Input
          }, heightProps, {
            props: {
              type: "number",
              placeholder: "Height"
            }
          })));
        } else {
          $dims = /*#__PURE__*/_react["default"].createElement("div", {
            className: "dimensions"
          }, /*#__PURE__*/_react["default"].createElement(_index.ReduxControls.Input, _extends({}, widthProps, {
            type: "number",
            placeholder: "Width"
          })), $by, /*#__PURE__*/_react["default"].createElement(_index.ReduxControls.Input, _extends({}, heightProps, {
            type: "number",
            placeholder: "Height"
          })));
        }
        return $dims;
      }
    }, {
      key: "_renderSelect",
      value: function _renderSelect() {
        var props = this.props,
          $control = null,
          _props$label = props.label,
          label = _props$label === void 0 ? "" : _props$label,
          selectProps = props.selectProps,
          fieldProps = props.fieldProps;
        if (props.useField) {
          $control = /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
            name: props.dimensionsName,
            label: label,
            required: props.required,
            className: "dim-select",
            component: _index.ReduxControls.Select,
            props: _objectSpread({
              options: props.options,
              allowCreate: props.allowCreate,
              isValidNewOption: props.isValidNewOption,
              newOptionCreator: props.newOptionCreator
            }, selectProps)
          }, fieldProps));
        } else {
          $control = /*#__PURE__*/_react["default"].createElement(_index.ReduxControls.Select, {
            className: "dim-select",
            name: props.dimensionsName,
            label: label,
            required: props.required,
            options: props.options,
            allowCreate: props.allowCreate,
            isValidNewOption: props.isValidNewOption,
            value: props.defaultValue
          });
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "dimensions"
        }, $control);
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.isFreeForm ? this._renderFreeForm() : this._renderSelect();
      }
    }]);
    return Dimensions;
  }(_react.Component);
  exports["default"] = Dimensions;
  _defineProperty(Dimensions, "displayName", "Dimensions");
  _defineProperty(Dimensions, "defaultProps", {
    //use text entry, or select?
    isFreeForm: false,
    //names to use for width/height/select fields
    widthName: "width",
    heightName: "height",
    dimensionsName: "dimensions",
    //options for the dimensions select
    options: [{
      value: "1x1",
      label: "1x1"
    }, {
      value: "120x600",
      label: "120x600"
    }, {
      value: "160x600",
      label: "160x600"
    }, {
      value: "180x150",
      label: "180x150"
    }, {
      value: "200x600",
      label: "200x600"
    }, {
      value: "234x60",
      label: "234x60"
    }, {
      value: "300x50",
      label: "300x50"
    }, {
      value: "300x250",
      label: "300x250"
    }, {
      value: "300x600",
      label: "300x600"
    }, {
      value: "320x50",
      label: "320x50"
    }, {
      value: "320x100",
      label: "320x100"
    }, {
      value: "320x480",
      label: "320x480"
    }, {
      value: "336x280",
      label: "336x280"
    }, {
      value: "468x60",
      label: "468x60"
    }, {
      value: "640x360",
      label: "640x360"
    }, {
      value: "640x480",
      label: "640x480"
    }, {
      value: "728x90",
      label: "728x90"
    }, {
      value: "800x250",
      label: "800x250"
    }, {
      value: "970x90",
      label: "970x90"
    }, {
      value: "970x250",
      label: "970x250"
    }, {
      value: "1280x720",
      label: "1280x720"
    }, {
      value: "1920x1080",
      label: "1920x1080"
    }],
    //allow user to create options?
    allowCreate: true,
    //function to check if option user wants to create is valid
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
      var p1 = /^\d{1,5}[xX]\d{1,4}$/g // (1-5 digits)x(1-4 digits)
        ,
        p2 = /^\d{1,4}[xX]\d{1,5}$/g // (1-4 digits)x(1-5 digits)
      ;

      return p1.test(inputValue) || p2.test(inputValue);
    },
    newOptionCreator: function newOptionCreator(_ref) {
      var label = _ref.label,
        labelKey = _ref.labelKey,
        valueKey = _ref.valueKey;
      return {
        label: label.toLowerCase(),
        labelKey: labelKey,
        valueKey: valueKey,
        value: label.toLowerCase()
      };
    },
    // Will this control live within a ReduxForm, or a general form?
    useField: true,
    selectProps: {},
    fieldProps: {}
  });
  _defineProperty(Dimensions, "propTypes", {
    /** Is the dimensions control free-form (width & height inputs) or not (select)? */
    isFreeForm: _propTypes["default"].bool,
    /** name for width field for free-form */
    widthName: _propTypes["default"].string,
    /** name for height field for free-form */
    heightName: _propTypes["default"].string,
    /** name for dimensions select */
    dimensionsName: _propTypes["default"].string,
    /** options for the dimensions select */
    options: _propTypes["default"].array,
    /** allow user to create options in the select? */
    allowCreate: _propTypes["default"].bool,
    /** function to check if an option the user wants to create is valid */
    isValidNewOption: _propTypes["default"].func,
    /** function to create new option */
    newOptionCreator: _propTypes["default"].func,
    /** Should this be rendered as a Field (within a ReduxForm) or not? */
    useField: _propTypes["default"].bool,
    /** additional props to pass to the select */
    selectProps: _propTypes["default"].object,
    /** additional props to pass to the Field */
    fieldProps: _propTypes["default"].object
  });

  /***/
}, /* 398 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _functions = __webpack_require__(33);
  var _Button = _interopRequireDefault(__webpack_require__(61));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function FormFooter(props) {
    var submitting = props.submitting,
      children = props.children,
      handleSubmit = props.handleSubmit,
      onSubmit = props.onSubmit,
      onCancel = props.onCancel,
      isSaveDisabled = props.isSaveDisabled,
      formId = props.formId,
      saveProps = {
        className: "submit-button",
        theme: "green",
        disabled: submitting || isSaveDisabled,
        title: props.saveTitle,
        type: props.saveType
      },
      $items = [];
    if (handleSubmit && onSubmit) {
      saveProps.onClick = handleSubmit(onSubmit);
    }
    if (formId) {
      saveProps.form = formId;
    }
    $items = [/*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "cancel-button",
      key: "cancel-button",
      disabled: submitting,
      title: "Cancel Changes",
      type: "reset",
      theme: "default",
      onClick: onCancel
    }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({}, saveProps, {
      key: "save"
    }), "Save")];
    if (children) {
      $items.push( /*#__PURE__*/_react["default"].createElement("aside", {
        key: "extra-items",
        className: "extra-footer-items"
      }, children));
    }
    return /*#__PURE__*/_react["default"].createElement("footer", {
      className: "form-action-footer c-actions-bar c-modal__footer flex-center flex-between"
    }, $items);
  }
  FormFooter.defaultProps = {
    isSaveDisabled: false,
    submitting: false,
    pristine: true,
    children: null,
    handleSubmit: null,
    onSubmit: null,
    onCancel: _functions.noop,
    saveTitle: "Save Changes",
    saveType: "button",
    formId: null
  };
  FormFooter.propTypes = {
    /** Disable the save button for any reason */
    isSaveDisabled: _propTypes["default"].bool,
    /** Is the form in a submitting phase? */
    submitting: _propTypes["default"].bool,
    /** Is the form pristine? */
    pristine: _propTypes["default"].bool,
    /** Any children to render AFTER the buttons */
    children: _propTypes["default"].node,
    /** What function to call when we submit the form */
    handleSubmit: _propTypes["default"].func,
    /** What function to call when the form is submitted */
    onSubmit: _propTypes["default"].func,
    /** What function to call when we click cancel */
    onCancel: _propTypes["default"].func.isRequired,
    /** The title text for the save button */
    saveTitle: _propTypes["default"].string,
    /** If using browser functionality to save the form, this should be a `submit` button */
    saveType: _propTypes["default"].oneOf(["button", "submit"]),
    /** This button should be attached to this form */
    formId: _propTypes["default"].string
  };
  FormFooter.displayName = "FormFooter";
  var _default = FormFooter;
  exports["default"] = _default;

  /***/
}, /* 399 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _functions = __webpack_require__(33);
  var _reduxForm = __webpack_require__(115);
  var _Button = _interopRequireDefault(__webpack_require__(61));
  var _Input = _interopRequireDefault(__webpack_require__(87));
  var _ = __webpack_require__(114);
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var FileImport = (_class = (_class2 = /*#__PURE__*/function (_Component) {
    _inherits(FileImport, _Component);
    var _super = _createSuper(FileImport);
    function FileImport() {
      _classCallCheck(this, FileImport);
      return _super.apply(this, arguments);
    }
    _createClass(FileImport, [{
      key: "_clickImport",
      value: function _clickImport() {
        if (!this.file) {
          return;
        }
        this.file.click();
      }
    }, {
      key: "_onFileChange",
      value: function _onFileChange(evt) {
        evt.persist();
        var fileList = evt.target.files,
          flen = fileList.length,
          ff = 0,
          changeList = [];
        for (ff; ff < flen; ff++) {
          var formFile = new FormData();
          formFile.append("file", fileList[ff]);
          formFile.append("filename", fileList[ff].name);
          changeList.push({
            formData: formFile,
            size: fileList[ff].size,
            name: fileList[ff].name
          });
        }
        this.props.onChange(changeList);
        this.setState({
          file: fileList
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;
        var props = this.props,
          file = this.file,
          $input = null,
          inputProps = {
            className: "file-name-text"
          },
          value = file && file.files && file.files[0] ? file.files[0].name : null;
        if (props.inputClickOpensFileSelect) {
          inputProps.onClick = this._clickImport;
        }
        if (props.useField) {
          inputProps.props = {
            label: props.label,
            required: props.required,
            disabled: props.disabled,
            readOnly: true,
            placeholder: props.inputPlaceholder
          };
          if (value) {
            inputProps.props.value = value;
          }
          $input = /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({}, inputProps, {
            name: props.inputName,
            component: _.ReduxControls.Input
          }));
        } else {
          if (value) {
            inputProps.value = value;
          }
          $input = /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({}, inputProps, {
            label: props.label,
            required: props.required,
            disabled: props.disabled,
            placeholder: props.inputPlaceholder,
            readOnly: true
          }));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "file-input-control ".concat(props.className)
        }, /*#__PURE__*/_react["default"].createElement("input", {
          component: "input",
          type: "file",
          name: "browser-file-input",
          ref: function ref(file) {
            return _this.file = file;
          },
          onChange: this._onFileChange,
          multiple: props.multipleFiles,
          accept: props.accept,
          disabled: props.disabled,
          hidden: true
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "input-holder flex"
        }, $input, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: "add-file-button",
          theme: "blue",
          onClick: this._clickImport,
          style: "block",
          disabled: props.disabled
        }, props.buttonLabel)));
      }
    }]);
    return FileImport;
  }(_react.Component), _defineProperty(_class2, "displayName", "FileImport"), _defineProperty(_class2, "defaultProps", {
    inputName: "file-input",
    inputClickOpensFileSelect: false,
    inputPlaceholder: "Click browse to select file",
    label: "File Input",
    buttonLabel: "Browse",
    className: "",
    required: true,
    multipleFiles: false,
    accept: "*",
    onChange: _functions.noop,
    useField: true,
    disabled: false
  }), _defineProperty(_class2, "propTypes", {
    inputName: _propTypes["default"].string,
    inputClickOpensFileSelect: _propTypes["default"].bool,
    inputPlaceholder: _propTypes["default"].string,
    label: _propTypes["default"].string,
    buttonLabel: _propTypes["default"].string,
    className: _propTypes["default"].string,
    required: _propTypes["default"].bool,
    multipleFiles: _propTypes["default"].bool,
    accept: _propTypes["default"].string,
    onChange: _propTypes["default"].func.isRequired,
    useField: _propTypes["default"].bool,
    disabled: _propTypes["default"].bool
  }), _class2), (_applyDecoratedDescriptor(_class.prototype, "_clickImport", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_clickImport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_onFileChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_onFileChange"), _class.prototype)), _class);
  exports["default"] = FileImport;

  /***/
}, /* 400 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _velocityReact = __webpack_require__(243);
  var _functions = __webpack_require__(33);
  var _Tooltip = _interopRequireDefault(__webpack_require__(40));
  __webpack_require__(414);
  __webpack_require__(55);
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  /**
   * Creates a Rhombus Card element with the given content.
   * Allows the card to be of a collapsable format, in which all but the header will be visible
   *
   */
  var Card = (_class = (_class2 = /*#__PURE__*/function (_Component) {
    _inherits(Card, _Component);
    var _super = _createSuper(Card);
    function Card(props, context) {
      var _this;
      _classCallCheck(this, Card);
      _this = _super.call(this, props, context);
      _defineProperty(_assertThisInitialized(_this), "state", {
        isVisible: true
      });
      if (typeof props.isVisible === "boolean") {
        _this.state = {
          isVisible: props.isVisible
        };
      }
      return _this;
    }
    _createClass(Card, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var isVisible = this.props.isVisible;
        if (prevProps.isVisible !== isVisible) {
          this.setState({
            isVisible: isVisible
          });
        }
      }
    }, {
      key: "_onHeaderClick",
      value: function _onHeaderClick(e) {
        var me = this;
        me.setState({
          isVisible: !me.state.isVisible
        }, function () {
          me.props.onToggleHeader(me.props, me.state);
        });
      }
    }, {
      key: "_renderHeader",
      value: function _renderHeader() {
        var me = this,
          _me$props = me.props,
          header = _me$props.header,
          tip = _me$props.tip,
          isCollapsable = _me$props.isCollapsable,
          $header = null,
          $tip = null,
          $collapse = null,
          headerProps = {
            className: "c-cards__header flex-center cursor-pointer"
          };
        if (!header) {
          return null;
        }
        if (typeof header === "string") {
          $header = /*#__PURE__*/_react["default"].createElement("span", {
            className: "c-heading-descriptive"
          }, header);
        } else {
          $header = header;
        }
        if (tip) {
          $tip = /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], _extends({}, tip, {
            iconSize: "medium"
          }));
        }
        if (isCollapsable) {
          var title = "Collapse Content";
          headerProps.onClick = me._onHeaderClick;
          if (me.state.isVisible) {
            title = "Expand Content";
          }
          $collapse = /*#__PURE__*/_react["default"].createElement("span", {
            className: "collapse-icon flex-center cursor-pointer",
            title: title
          }, /*#__PURE__*/_react["default"].createElement("i", {
            className: "fa fa-caret-square-right"
          }));
        }
        return /*#__PURE__*/_react["default"].createElement("div", headerProps, $collapse, $header, $tip);
      }
    }, {
      key: "_renderFooter",
      value: function _renderFooter() {
        var footer = this.props.footer;
        if (!footer) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "c-cards__footer"
        }, footer);
      }
    }, {
      key: "_renderContent",
      value: function _renderContent() {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "collapse-content"
        }, /*#__PURE__*/_react["default"].createElement("section", {
          className: "c-cards__content"
        }, this.props.children), this._renderFooter());
      }
    }, {
      key: "render",
      value: function render() {
        var _classes;
        var me = this,
          state = me.state,
          _me$props2 = me.props,
          isCollapsable = _me$props2.isCollapsable,
          className = _me$props2.className,
          duration = _me$props2.duration,
          enter = {
            animation: 'slideDown',
            duration: duration,
            style: {
              height: ''
            }
          },
          leave = {
            animation: 'slideUp',
            duration: duration
          },
          classes = (_classes = {
            "c-cards": true
          }, _defineProperty(_classes, className, !!className), _defineProperty(_classes, "collapsable", isCollapsable), _defineProperty(_classes, "visible", state.isVisible), _defineProperty(_classes, "hidden", !state.isVisible), _classes);
        return /*#__PURE__*/_react["default"].createElement("article", {
          className: (0, _classnames["default"])(classes)
        }, me._renderHeader(), /*#__PURE__*/_react["default"].createElement(_velocityReact.VelocityTransitionGroup, {
          component: "div",
          enter: enter,
          leave: leave
        }, state.isVisible ? me._renderContent() : null));
      }
    }]);
    return Card;
  }(_react.Component), _defineProperty(_class2, "defaultProps", {
    header: null,
    tip: null,
    footer: null,
    onToggleHeader: _functions.noop,
    className: "",
    duration: 500,
    isCollapsable: false,
    isVisible: true

    /**
     * TODO:	Add in the ability to manually toggle the state of the Card
     * 			Add in the ability to instanciate the Card in a closed state
     * 			Add in the ability to automatically track expand/collapse of the card
     * 				Create a UID for the card in the tracking case
     */
  }), _defineProperty(_class2, "propTypes", {
    /**	Duration of the slide animation */
    duration: _propTypes["default"].number,
    /*A custom class name to add to this component*/
    className: _propTypes["default"].string,
    /**	Can the Card be collapsable  */
    isCollapsable: _propTypes["default"].bool,
    /* Should the component be visible initially*/
    isVisible: _propTypes["default"].bool,
    /**
     * The title of the card, any valid React renderable element
     * @type {[type]}
     */
    header: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
    /** if we want to show a tooltip after the header title */
    tip: _propTypes["default"].shape({
      description: _propTypes["default"].string,
      inline: _propTypes["default"].bool,
      direction: _propTypes["default"].oneOf(['left', 'right', 'top', 'bottom']),
      size: _propTypes["default"].oneOf(['small', 'medium', 'large', 'xlarge', 'fit'])
    }),
    /**	We can pass in a string, HTML, or a React element for the footer*/
    footer: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    /* Do we want/need to do anything when we toggle the component open/closed? */
    onToggleHeader: _propTypes["default"].func
  }), _class2), _applyDecoratedDescriptor(_class.prototype, "_onHeaderClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_onHeaderClick"), _class.prototype), _class);
  exports["default"] = Card;

  /***/
}, /* 401 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  __webpack_require__(239);
  __webpack_require__(416);
  var _velocityReact = __webpack_require__(243);
  var _NotificationItem = _interopRequireDefault(__webpack_require__(240));
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var NotificationController = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    _inherits(NotificationController, _React$Component);
    var _super = _createSuper(NotificationController);
    function NotificationController() {
      _classCallCheck(this, NotificationController);
      return _super.apply(this, arguments);
    }
    _createClass(NotificationController, [{
      key: "onExit",
      value:
      // static propTypes = {
      // 	messages: PropTypes.arrayOf(ITEM_PROPS),
      // };
      // 

      function onExit(message) {
        this.props.onExit(message);
      }
    }, {
      key: "_renderMessages",
      value: function _renderMessages() {
        var _this = this;
        var dismissIn = this.props.dismissIn,
          messages = null,
          vtg = {
            component: "section",
            enter: {
              animation: "transition.expandIn",
              duration: 300
            },
            leave: {
              animation: "transition.expandOut",
              duration: 300
            }
          };
        messages = this.props.messages.filter(function (v) {
          return !v.isHidden;
        }).map(function (v) {
          var itemProps = _objectSpread({}, v);

          //if a dismissIn value was passed in
          if (typeof dismissIn === "number") {
            //and the message doesn't already have a dismissIn value
            if (typeof itemProps.dismissIn !== "number") {
              //apply the controller's dismissIn value to the message
              itemProps.dismissIn = dismissIn;
            }
          }
          return /*#__PURE__*/_react["default"].createElement(_NotificationItem["default"], _extends({}, itemProps, {
            key: v.id,
            onExit: _this.onExit
          }));
        });
        return /*#__PURE__*/_react["default"].createElement(_velocityReact.VelocityTransitionGroup, vtg, messages);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "notifications"
        }, this._renderMessages());
      }
    }]);
    return NotificationController;
  }(_react["default"].Component), _defineProperty(_class2, "defaultProps", {
    messages: [],
    duration: 500,
    dismissIn: null,
    onExit: function onExit() {}
  }), _class2), (_applyDecoratedDescriptor(_class.prototype, "onExit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onExit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderMessages", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderMessages"), _class.prototype)), _class);
  exports["default"] = NotificationController;

  /***/
}, /* 402 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var Tabs = /*#__PURE__*/function (_React$Component) {
    _inherits(Tabs, _React$Component);
    var _super = _createSuper(Tabs);
    function Tabs() {
      _classCallCheck(this, Tabs);
      return _super.apply(this, arguments);
    }
    _createClass(Tabs, [{
      key: "render",
      value: function render() {
        var props = this.props;
        return /*#__PURE__*/_react["default"].createElement("nav", {
          className: "rhombus-tabs ".concat(props.className)
        }, /*#__PURE__*/_react["default"].createElement("ul", {
          className: "tab-list"
        }, props.tabs.map(function (v) {
          var _cls;
          var isActive = props.selectedTab.value === v.value,
            isDisabled = props.disabledTabs.indexOf(v.value) !== -1,
            vClass = v.className || "",
            cls = (_cls = {
              "tab-item": true,
              "flex-center": true
            }, _defineProperty(_cls, vClass, true), _defineProperty(_cls, "cursor-pointer", !isDisabled), _defineProperty(_cls, "is-active", isActive), _defineProperty(_cls, "is-disabled", isDisabled), _cls),
            opts = {
              className: (0, _classnames["default"])(cls)
            },
            $body = null;
          if (!isActive && !isDisabled) {
            opts.onClick = function () {
              return props.onTabChange(v, props.selectedTab);
            };
          }
          if (v.renderLabel) {
            $body = v.renderLabel(v, props);
          } else {
            $body = /*#__PURE__*/_react["default"].createElement("span", {
              className: "tab-label"
            }, v.label);
          }
          return /*#__PURE__*/_react["default"].createElement("li", _extends({
            key: v.value
          }, opts), $body);
        })));
      }
    }]);
    return Tabs;
  }(_react["default"].Component);
  exports["default"] = Tabs;
  _defineProperty(Tabs, "defaultProps", {
    disabledTabs: [],
    selectedTab: {},
    tabs: [],
    className: ""
  });
  _defineProperty(Tabs, "propTypes", {
    disabledTabs: _propTypes["default"].array,
    selectedTab: _propTypes["default"].object,
    tabs: _propTypes["default"].array.isRequired,
    onTabChange: _propTypes["default"].func.isRequired
  });

  /***/
}, /* 403 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.debounce = debounce;
  exports["default"] = void 0;
  exports.throttle = throttle;
  /*eslint-disable*/
  function throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function later() {
      previous = options.leading === false ? 0 : OVER.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function () {
      var now = OVER.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  }
  var OVER = {
    now: function now() {
      return Date.now || new Date().getTime();
    }
  };
  function debounce(func, wait, immediate) {
    var timeout,
      args,
      mee,
      timestamp,
      result,
      later = function later() {
        var last = OVER.now() - timestamp;
        if (last < wait && last >= 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          if (!immediate) {
            result = func.apply(mee, args);
            if (!timeout) {
              mee = args = null;
            }
          }
        }
      };
    return function () {
      mee = this;
      args = arguments;
      timestamp = OVER.now();
      var callNow = immediate && !timeout;
      if (!timeout) {
        timeout = setTimeout(later, wait);
      }
      if (callNow) {
        result = func.apply(mee, args);
        mee = args = null;
      }
      return result;
    };
  }
  var Limit = {
    throttle: throttle,
    debounce: debounce
  };
  var _default = Limit;
  /*eslint-enable*/
  exports["default"] = _default;

  /***/
}, /* 404 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = tagGroupFormatter;
  function tagGroupFormatter(value, name) {
    var val = [];
    if (value && value.length) {
      if (typeof value === "string") {
        val = value.split(",");
      } else {
        val = value;
      }
    }
    return val;
  }

  // TODO: look in to exporting TagGroup as a Redux Field?

  /***/
}, /* 405 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var React = __webpack_require__(1);
  var createFocusTrap = __webpack_require__(406);
  var checkedProps = ['active', 'paused', 'tag', 'focusTrapOptions', '_createFocusTrap'];
  var FocusTrap = function (_React$Component) {
    _inherits(FocusTrap, _React$Component);
    function FocusTrap(props) {
      _classCallCheck(this, FocusTrap);
      var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));
      _this.setNode = function (el) {
        _this.node = el;
      };
      if (typeof document !== 'undefined') {
        _this.previouslyFocusedElement = document.activeElement;
      }
      return _this;
    }
    _createClass(FocusTrap, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // We need to hijack the returnFocusOnDeactivate option,
        // because React can move focus into the element before we arrived at
        // this lifecycle hook (e.g. with autoFocus inputs). So the component
        // captures the previouslyFocusedElement in componentWillMount,
        // then (optionally) returns focus to it in componentWillUnmount.
        var specifiedFocusTrapOptions = this.props.focusTrapOptions;
        var tailoredFocusTrapOptions = {
          returnFocusOnDeactivate: false
        };
        for (var optionName in specifiedFocusTrapOptions) {
          if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
          if (optionName === 'returnFocusOnDeactivate') continue;
          tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
        }
        this.focusTrap = this.props._createFocusTrap(this.node, tailoredFocusTrapOptions);
        if (this.props.active) {
          this.focusTrap.activate();
        }
        if (this.props.paused) {
          this.focusTrap.pause();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (prevProps.active && !this.props.active) {
          var returnFocusOnDeactivate = this.props.focusTrapOptions.returnFocusOnDeactivate;
          var returnFocus = returnFocusOnDeactivate || false;
          var config = {
            returnFocus: returnFocus
          };
          this.focusTrap.deactivate(config);
        } else if (!prevProps.active && this.props.active) {
          this.focusTrap.activate();
        }
        if (prevProps.paused && !this.props.paused) {
          this.focusTrap.unpause();
        } else if (!prevProps.paused && this.props.paused) {
          this.focusTrap.pause();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.focusTrap.deactivate();
        if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
          this.previouslyFocusedElement.focus();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var elementProps = {
          ref: this.setNode
        };

        // This will get id, className, style, etc. -- arbitrary element props
        for (var prop in this.props) {
          if (!this.props.hasOwnProperty(prop)) continue;
          if (checkedProps.indexOf(prop) !== -1) continue;
          elementProps[prop] = this.props[prop];
        }
        return React.createElement(this.props.tag, elementProps, this.props.children);
      }
    }]);
    return FocusTrap;
  }(React.Component);
  FocusTrap.defaultProps = {
    active: true,
    tag: 'div',
    paused: false,
    focusTrapOptions: {},
    _createFocusTrap: createFocusTrap
  };
  module.exports = FocusTrap;

  /***/
}, /* 406 */
/***/function (module, exports, __webpack_require__) {
  var tabbable = __webpack_require__(407);
  var xtend = __webpack_require__(408);
  var listeningFocusTrap = null;
  function focusTrap(element, userOptions) {
    var doc = document;
    var container = typeof element === 'string' ? doc.querySelector(element) : element;
    var config = xtend({
      returnFocusOnDeactivate: true,
      escapeDeactivates: true
    }, userOptions);
    var state = {
      firstTabbableNode: null,
      lastTabbableNode: null,
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false
    };
    var trap = {
      activate: activate,
      deactivate: deactivate,
      pause: pause,
      unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
      if (state.active) return;
      updateTabbableNodes();
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      var onActivate = activateOptions && activateOptions.onActivate ? activateOptions.onActivate : config.onActivate;
      if (onActivate) {
        onActivate();
      }
      addListeners();
      return trap;
    }
    function deactivate(deactivateOptions) {
      if (!state.active) return;
      removeListeners();
      state.active = false;
      state.paused = false;
      var onDeactivate = deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate;
      if (onDeactivate) {
        onDeactivate();
      }
      var returnFocus = deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate;
      if (returnFocus) {
        delay(function () {
          tryFocus(state.nodeFocusedBeforeActivation);
        });
      }
      return trap;
    }
    function pause() {
      if (state.paused || !state.active) return;
      state.paused = true;
      removeListeners();
    }
    function unpause() {
      if (!state.paused || !state.active) return;
      state.paused = false;
      addListeners();
    }
    function addListeners() {
      if (!state.active) return;

      // There can be only one listening focus trap at a time
      if (listeningFocusTrap) {
        listeningFocusTrap.pause();
      }
      listeningFocusTrap = trap;
      updateTabbableNodes();

      // Delay ensures that the focused element doesn't capture the event
      // that caused the focus trap activation.
      delay(function () {
        tryFocus(getInitialFocusNode());
      });
      doc.addEventListener('focusin', checkFocusIn, true);
      doc.addEventListener('mousedown', checkPointerDown, true);
      doc.addEventListener('touchstart', checkPointerDown, true);
      doc.addEventListener('click', checkClick, true);
      doc.addEventListener('keydown', checkKey, true);
      return trap;
    }
    function removeListeners() {
      if (!state.active || listeningFocusTrap !== trap) return;
      doc.removeEventListener('focusin', checkFocusIn, true);
      doc.removeEventListener('mousedown', checkPointerDown, true);
      doc.removeEventListener('touchstart', checkPointerDown, true);
      doc.removeEventListener('click', checkClick, true);
      doc.removeEventListener('keydown', checkKey, true);
      listeningFocusTrap = null;
      return trap;
    }
    function getNodeForOption(optionName) {
      var optionValue = config[optionName];
      var node = optionValue;
      if (!optionValue) {
        return null;
      }
      if (typeof optionValue === 'string') {
        node = doc.querySelector(optionValue);
        if (!node) {
          throw new Error('`' + optionName + '` refers to no known node');
        }
      }
      if (typeof optionValue === 'function') {
        node = optionValue();
        if (!node) {
          throw new Error('`' + optionName + '` did not return a node');
        }
      }
      return node;
    }
    function getInitialFocusNode() {
      var node;
      if (getNodeForOption('initialFocus') !== null) {
        node = getNodeForOption('initialFocus');
      } else if (container.contains(doc.activeElement)) {
        node = doc.activeElement;
      } else {
        node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
      }
      if (!node) {
        throw new Error("You can't have a focus-trap without at least one focusable element");
      }
      return node;
    }

    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    function checkPointerDown(e) {
      if (container.contains(e.target)) return;
      if (config.clickOutsideDeactivates) {
        deactivate({
          returnFocus: !tabbable.isFocusable(e.target)
        });
      } else {
        e.preventDefault();
      }
    }

    // In case focus escapes the trap for some strange reason, pull it back in.
    function checkFocusIn(e) {
      // In Firefox when you Tab out of an iframe the Document is briefly focused.
      if (container.contains(e.target) || e.target instanceof Document) {
        return;
      }
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
    function checkKey(e) {
      if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
        e.preventDefault();
        deactivate();
        return;
      }
      if (isTabEvent(e)) {
        checkTab(e);
        return;
      }
    }

    // Hijack Tab events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    function checkTab(e) {
      updateTabbableNodes();
      if (e.shiftKey && e.target === state.firstTabbableNode) {
        e.preventDefault();
        tryFocus(state.lastTabbableNode);
        return;
      }
      if (!e.shiftKey && e.target === state.lastTabbableNode) {
        e.preventDefault();
        tryFocus(state.firstTabbableNode);
        return;
      }
    }
    function checkClick(e) {
      if (config.clickOutsideDeactivates) return;
      if (container.contains(e.target)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    }
    function updateTabbableNodes() {
      var tabbableNodes = tabbable(container);
      state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
      state.lastTabbableNode = tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
    }
    function tryFocus(node) {
      if (node === doc.activeElement) return;
      if (!node || !node.focus) {
        tryFocus(getInitialFocusNode());
        return;
      }
      node.focus();
      state.mostRecentlyFocusedNode = node;
      if (isSelectableInput(node)) {
        node.select();
      }
    }
  }
  function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
  }
  function isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
  }
  function isTabEvent(e) {
    return e.key === 'Tab' || e.keyCode === 9;
  }
  function delay(fn) {
    return setTimeout(fn, 0);
  }
  module.exports = focusTrap;

  /***/
}, /* 407 */
/***/function (module, exports) {
  var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];
  var candidateSelector = candidateSelectors.join(',');
  var matches = typeof Element === 'undefined' ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  function tabbable(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var regularTabbables = [];
    var orderedTabbables = [];
    var untouchabilityChecker = new UntouchabilityChecker(elementDocument);
    var candidates = el.querySelectorAll(candidateSelector);
    if (options.includeContainer) {
      if (matches.call(el, candidateSelector)) {
        candidates = Array.prototype.slice.apply(candidates);
        candidates.unshift(el);
      }
    }
    var i, candidate, candidateTabindex;
    for (i = 0; i < candidates.length; i++) {
      candidate = candidates[i];
      if (!isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;
      candidateTabindex = getTabindex(candidate);
      if (candidateTabindex === 0) {
        regularTabbables.push(candidate);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          node: candidate
        });
      }
    }
    var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function (a) {
      return a.node;
    }).concat(regularTabbables);
    return tabbableNodes;
  }
  tabbable.isTabbable = isTabbable;
  tabbable.isFocusable = isFocusable;
  function isNodeMatchingSelectorTabbable(node, untouchabilityChecker) {
    if (!isNodeMatchingSelectorFocusable(node, untouchabilityChecker) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
      return false;
    }
    return true;
  }
  function isTabbable(node, untouchabilityChecker) {
    if (!node) throw new Error('No node provided');
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(node, untouchabilityChecker);
  }
  function isNodeMatchingSelectorFocusable(node, untouchabilityChecker) {
    untouchabilityChecker = untouchabilityChecker || new UntouchabilityChecker(node.ownerDocument || node);
    if (node.disabled || isHiddenInput(node) || untouchabilityChecker.isUntouchable(node)) {
      return false;
    }
    return true;
  }
  var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
  function isFocusable(node, untouchabilityChecker) {
    if (!node) throw new Error('No node provided');
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(node, untouchabilityChecker);
  }
  function getTabindex(node) {
    var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
    if (!isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if (isContentEditable(node)) return 0;
    return node.tabIndex;
  }
  function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  }

  // Array.prototype.find not available in IE.
  function find(list, predicate) {
    for (var i = 0, length = list.length; i < length; i++) {
      if (predicate(list[i])) return list[i];
    }
  }
  function isContentEditable(node) {
    return node.contentEditable === 'true';
  }
  function isInput(node) {
    return node.tagName === 'INPUT';
  }
  function isHiddenInput(node) {
    return isInput(node) && node.type === 'hidden';
  }
  function isRadio(node) {
    return isInput(node) && node.type === 'radio';
  }
  function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
  }
  function getCheckedRadio(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked) {
        return nodes[i];
      }
    }
  }
  function isTabbableRadio(node) {
    if (!node.name) return true;
    // This won't account for the edge case where you have radio groups with the same
    // in separate forms on the same page.
    var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
    var checked = getCheckedRadio(radioSet);
    return !checked || checked === node;
  }

  // An element is "untouchable" if *it or one of its ancestors* has
  // `visibility: hidden` or `display: none`.
  function UntouchabilityChecker(elementDocument) {
    this.doc = elementDocument;
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed. The cache contains tuples
    // mapping nodes to their boolean result.
    this.cache = [];
  }

  // getComputedStyle accurately reflects `visibility: hidden` of ancestors
  // but not `display: none`, so we need to recursively check parents.
  UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node, nodeComputedStyle) {
    if (node.nodeType !== Node.ELEMENT_NODE) return false;

    // Search for a cached result.
    var cached = find(this.cache, function (item) {
      return item === node;
    });
    if (cached) return cached[1];
    nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node);
    var result = false;
    if (nodeComputedStyle.display === 'none') {
      result = true;
    } else if (node.parentNode) {
      result = this.hasDisplayNone(node.parentNode);
    }
    this.cache.push([node, result]);
    return result;
  };
  UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node) {
    if (node === this.doc.documentElement) return false;
    var computedStyle = this.doc.defaultView.getComputedStyle(node);
    if (this.hasDisplayNone(node, computedStyle)) return true;
    return computedStyle.visibility === 'hidden';
  };
  module.exports = tabbable;

  /***/
}, /* 408 */
/***/function (module, exports) {
  module.exports = extend;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  function extend() {
    var target = {};
    for (var i = 0; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }

  /***/
}, /* 409 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var React = __webpack_require__(1);
    var ReactDOM = __webpack_require__(15);

    // React 16+ supports Portals.
    var canUsePortals = !!ReactDOM.createPortal;
    function displace(WrappedComponent, options) {
      if (!global.document) {
        return function (_React$Component) {
          _inherits(EmptyDisplace, _React$Component);
          function EmptyDisplace() {
            _classCallCheck(this, EmptyDisplace);
            return _possibleConstructorReturn(this, (EmptyDisplace.__proto__ || Object.getPrototypeOf(EmptyDisplace)).apply(this, arguments));
          }
          _createClass(EmptyDisplace, [{
            key: 'render',
            value: function render() {
              return false;
            }
          }]);
          return EmptyDisplace;
        }(React.Component);
      }
      options = options || {};
      var Displaced = function (_React$Component2) {
        _inherits(Displaced, _React$Component2);
        function Displaced() {
          var _ref;
          var _temp, _this2, _ret;
          _classCallCheck(this, Displaced);
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Displaced.__proto__ || Object.getPrototypeOf(Displaced)).call.apply(_ref, [this].concat(args))), _this2), _this2.renderDisplaced = function () {
            ReactDOM.unstable_renderSubtreeIntoContainer(_this2, React.createElement(WrappedComponent, _this2.props, _this2.props.children), _this2.container);
          }, _this2.removeDisplaced = function () {
            ReactDOM.unmountComponentAtNode(_this2.container);
          }, _temp), _possibleConstructorReturn(_this2, _ret);
        }
        _createClass(Displaced, [{
          key: 'componentWillMount',
          value: function componentWillMount() {
            this.container = function () {
              if (!options.renderTo) {
                var result = document.createElement('div');
                document.body.appendChild(result);
                return result;
              } else if (typeof options.renderTo === 'string') {
                return document.querySelector(options.renderTo);
              } else {
                return options.renderTo;
              }
            }();
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (canUsePortals) return;
            if (this.props.mounted) {
              this.renderDisplaced();
            }
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate(prevProps) {
            if (canUsePortals) return;
            if (prevProps.mounted && !this.props.mounted) {
              ReactDOM.unmountComponentAtNode(this.container);
            } else if (this.props.mounted) {
              this.renderDisplaced();
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (!canUsePortals) {
              ReactDOM.unmountComponentAtNode(this.container);
            }
            if (!options.renderTo) {
              this.container.parentNode.removeChild(this.container);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            if (!canUsePortals || this.props.mounted === false) {
              return null;
            }
            return ReactDOM.createPortal(React.createElement(WrappedComponent, this.props, this.props.children), this.container);
          }
        }]);
        return Displaced;
      }(React.Component);
      Displaced.defaultProps = {
        mounted: true
      };
      Displaced.WrappedComponent = WrappedComponent;
      return Displaced;
    }
    module.exports = displace;
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(36));

  /***/
}, /* 410 */
/***/function (module, exports, __webpack_require__) {
  (function (root) {
    var isOn = false;
    var scrollbarSize;
    var scrollTop;
    function getScrollbarSize() {
      if (typeof scrollbarSize !== 'undefined') return scrollbarSize;
      var doc = document.documentElement;
      var dummyScroller = document.createElement('div');
      dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
      doc.appendChild(dummyScroller);
      scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
      doc.removeChild(dummyScroller);
      return scrollbarSize;
    }
    function hasScrollbar() {
      return document.documentElement.scrollHeight > window.innerHeight;
    }
    function on(options) {
      if (typeof document === 'undefined' || isOn) return;
      var doc = document.documentElement;
      scrollTop = window.pageYOffset;
      if (hasScrollbar()) {
        doc.style.width = 'calc(100% - ' + getScrollbarSize() + 'px)';
      } else {
        doc.style.width = '100%';
      }
      doc.style.position = 'fixed';
      doc.style.top = -scrollTop + 'px';
      doc.style.overflow = 'hidden';
      isOn = true;
    }
    function off() {
      if (typeof document === 'undefined' || !isOn) return;
      var doc = document.documentElement;
      doc.style.width = '';
      doc.style.position = '';
      doc.style.top = '';
      doc.style.overflow = '';
      window.scroll(0, scrollTop);
      isOn = false;
    }
    function toggle() {
      if (isOn) {
        off();
        return;
      }
      on();
    }
    var noScroll = {
      on: on,
      off: off,
      toggle: toggle
    };
    if (true && typeof module.exports !== 'undefined') {
      module.exports = noScroll;
    } else {
      root.noScroll = noScroll;
    }
  })(this);

  /***/
}, /* 411 */
/***/function (module, exports, __webpack_require__) {
  (function webpackUniversalModuleDefinition(root, factory) {
    if (true) module.exports = factory(__webpack_require__(1), __webpack_require__(15));else {}
  })(this, function (__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_9__) {
    return (/******/function (modules) {
        // webpackBootstrap
        /******/ // The module cache
        /******/
        var installedModules = {};

        /******/ // The require function
        /******/
        function __webpack_require__(moduleId) {
          /******/ // Check if module is in cache
          /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;

          /******/ // Create a new module (and put it into the cache)
          /******/
          var module = installedModules[moduleId] = {
            /******/exports: {},
            /******/id: moduleId,
            /******/loaded: false
            /******/
          };

          /******/ // Execute the module function
          /******/
          modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

          /******/ // Flag the module as loaded
          /******/
          module.loaded = true;

          /******/ // Return the exports of the module
          /******/
          return module.exports;
          /******/
        }

        /******/ // expose the modules object (__webpack_modules__)
        /******/
        __webpack_require__.m = modules;

        /******/ // expose the module cache
        /******/
        __webpack_require__.c = installedModules;

        /******/ // __webpack_public_path__
        /******/
        __webpack_require__.p = "";

        /******/ // Load entry module and return exports
        /******/
        return __webpack_require__(0);
        /******/
      }
      /************************************************************************/
      /******/([/* 0 */
      /***/function (module, exports, __webpack_require__) {
        module.exports = __webpack_require__(130);

        /***/
      },

        /* 1 */

        /* 4 */

        /* 10 */

        /* 13 */

        /* 16 */
        /* 17 */

        /* 21 */
        /* 22 */
        /* 23 */
        /* 24 */
        /* 25 */
        /* 26 */
        /* 27 */
        /* 28 */

        /* 33 */
        /* 34 */
        /* 35 */
        /* 36 */

        /* 38 */
        /* 39 */

        /* 56 */
        /* 57 */
        /* 58 */
        /* 59 */
        /* 60 */
        /* 61 */
        /* 62 */
        /* 63 */
        /* 64 */
        /* 65 */
        /* 66 */
        /* 67 */
        /* 68 */

        /* 71 */
        /* 72 */
        /* 73 */
        /* 74 */
        /* 75 */
        /* 76 */
        /* 77 */

        /* 79 */
        /* 80 */
        /* 81 */
        /* 82 */
        /* 83 */
        /* 84 */
        /* 85 */
        /* 86 */
        /* 87 */
        /* 88 */
        /* 89 */
        /* 90 */
        /* 91 */
        /* 92 */
        /* 93 */
        /* 94 */
        /* 95 */
        /* 96 */
        /* 97 */
        /* 98 */
        /* 99 */
        /* 100 */
        /* 101 */
        /* 102 */
        /* 103 */
      , /* 2 */
      /***/function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

        /***/
      }, /* 3 */
      /***/function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        if (false) {
          var throwOnDirectAccess, isValidElement, REACT_ELEMENT_TYPE;
        } else {
          // By explicitly using `prop-types` you are opting into new production behavior.
          // http://fb.me/prop-types-in-prod
          module.exports = __webpack_require__(147)();
        }

        /***/
      },, /* 5 */
      /***/function (module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                         Copyright (c) 2016 Jed Watson.
                                                                         Licensed under the MIT License (MIT), see
                                                                         http://jedwatson.github.io/classnames
                                                                         */
        /* global define */

        (function () {
          'use strict';

          var hasOwn = {}.hasOwnProperty;
          function classNames() {
            var classes = [];
            for (var i = 0; i < arguments.length; i++) {
              var arg = arguments[i];
              if (!arg) continue;
              var argType = typeof arg;
              if (argType === 'string' || argType === 'number') {
                classes.push(arg);
              } else if (Array.isArray(arg)) {
                classes.push(classNames.apply(null, arg));
              } else if (argType === 'object') {
                for (var key in arg) {
                  if (hasOwn.call(arg, key) && arg[key]) {
                    classes.push(key);
                  }
                }
              }
            }
            return classes.join(' ');
          }
          if (typeof module !== 'undefined' && module.exports) {
            module.exports = classNames;
          } else if (true) {
            // register as 'classnames', consistent with npm package name
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return classNames;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {}
        })();

        /***/
      }, /* 6 */
      /***/function (module, exports) {
        'use strict';

        module.exports = {
          getColumn: function getColumn(columns, idx) {
            if (Array.isArray(columns)) {
              return columns[idx];
            } else if (typeof Immutable !== 'undefined') {
              return columns.get(idx);
            }
          },
          spliceColumn: function spliceColumn(metrics, idx, column) {
            if (Array.isArray(metrics.columns)) {
              metrics.columns.splice(idx, 1, column);
            } else if (typeof Immutable !== 'undefined') {
              metrics.columns = metrics.columns.splice(idx, 1, column);
            }
            return metrics;
          },
          getSize: function getSize(columns) {
            if (Array.isArray(columns)) {
              return columns.length;
            } else if (typeof Immutable !== 'undefined') {
              return columns.size;
            }
          },
          // Logic extented to allow for functions to be passed down in column.editable
          // this allows us to deicde whether we can be edting from a cell level
          canEdit: function canEdit(col, rowData, enableCellSelect) {
            if (!col) return false;
            if (col.editable != null && typeof col.editable === 'function') {
              return enableCellSelect === true && col.editable(rowData);
            }
            return enableCellSelect === true && (!!col.editor || !!col.editable);
          },
          getValue: function getValue(column, property) {
            var value = void 0;
            if (column.toJSON && column.get) {
              value = column.get(property);
            } else {
              value = column[property];
            }
            return value;
          }
        };

        /***/
      }, /* 7 */
      /***/function (module, exports) {
        /*
        	MIT License http://www.opensource.org/licenses/mit-license.php
        	Author Tobias Koppers @sokra
        */
        // css base code, injected by the css-loader
        module.exports = function () {
          var list = [];

          // return the list of modules as css string
          list.toString = function toString() {
            var result = [];
            for (var i = 0; i < this.length; i++) {
              var item = this[i];
              if (item[2]) {
                result.push("@media " + item[2] + "{" + item[1] + "}");
              } else {
                result.push(item[1]);
              }
            }
            return result.join("");
          };

          // import a list of modules into the list
          list.i = function (modules, mediaQuery) {
            if (typeof modules === "string") modules = [[null, modules, ""]];
            var alreadyImportedModules = {};
            for (var i = 0; i < this.length; i++) {
              var id = this[i][0];
              if (typeof id === "number") alreadyImportedModules[id] = true;
            }
            for (i = 0; i < modules.length; i++) {
              var item = modules[i];
              // skip already imported module
              // this implementation is not 100% perfect for weird media query combinations
              //  when a module is imported multiple times with different media queries.
              //  I hope this will never occur (Hey this way we have smaller bundles)
              if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
                if (mediaQuery && !item[2]) {
                  item[2] = mediaQuery;
                } else if (mediaQuery) {
                  item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
                }
                list.push(item);
              }
            }
          };
          return list;
        };

        /***/
      }, /* 8 */
      /***/function (module, exports, __webpack_require__) {
        /*
        	MIT License http://www.opensource.org/licenses/mit-license.php
        	Author Tobias Koppers @sokra
        */
        var stylesInDom = {},
          memoize = function (fn) {
            var memo;
            return function () {
              if (typeof memo === "undefined") memo = fn.apply(this, arguments);
              return memo;
            };
          },
          isOldIE = memoize(function () {
            return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
          }),
          getHeadElement = memoize(function () {
            return document.head || document.getElementsByTagName("head")[0];
          }),
          singletonElement = null,
          singletonCounter = 0,
          styleElementsInsertedAtTop = [];
        module.exports = function (list, options) {
          if (false) {}
          options = options || {};
          // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
          // tags it will allow on a page
          if (typeof options.singleton === "undefined") options.singleton = isOldIE();

          // By default, add <style> tags to the bottom of <head>.
          if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
          var styles = listToStyles(list);
          addStylesToDom(styles, options);
          return function update(newList) {
            var mayRemove = [];
            for (var i = 0; i < styles.length; i++) {
              var item = styles[i];
              var domStyle = stylesInDom[item.id];
              domStyle.refs--;
              mayRemove.push(domStyle);
            }
            if (newList) {
              var newStyles = listToStyles(newList);
              addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
              var domStyle = mayRemove[i];
              if (domStyle.refs === 0) {
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                delete stylesInDom[domStyle.id];
              }
            }
          };
        };
        function addStylesToDom(styles, options) {
          for (var i = 0; i < styles.length; i++) {
            var item = styles[i];
            var domStyle = stylesInDom[item.id];
            if (domStyle) {
              domStyle.refs++;
              for (var j = 0; j < domStyle.parts.length; j++) {
                domStyle.parts[j](item.parts[j]);
              }
              for (; j < item.parts.length; j++) {
                domStyle.parts.push(addStyle(item.parts[j], options));
              }
            } else {
              var parts = [];
              for (var j = 0; j < item.parts.length; j++) {
                parts.push(addStyle(item.parts[j], options));
              }
              stylesInDom[item.id] = {
                id: item.id,
                refs: 1,
                parts: parts
              };
            }
          }
        }
        function listToStyles(list) {
          var styles = [];
          var newStyles = {};
          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            var id = item[0];
            var css = item[1];
            var media = item[2];
            var sourceMap = item[3];
            var part = {
              css: css,
              media: media,
              sourceMap: sourceMap
            };
            if (!newStyles[id]) styles.push(newStyles[id] = {
              id: id,
              parts: [part]
            });else newStyles[id].parts.push(part);
          }
          return styles;
        }
        function insertStyleElement(options, styleElement) {
          var head = getHeadElement();
          var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
          if (options.insertAt === "top") {
            if (!lastStyleElementInsertedAtTop) {
              head.insertBefore(styleElement, head.firstChild);
            } else if (lastStyleElementInsertedAtTop.nextSibling) {
              head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
            } else {
              head.appendChild(styleElement);
            }
            styleElementsInsertedAtTop.push(styleElement);
          } else if (options.insertAt === "bottom") {
            head.appendChild(styleElement);
          } else {
            throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
          }
        }
        function removeStyleElement(styleElement) {
          styleElement.parentNode.removeChild(styleElement);
          var idx = styleElementsInsertedAtTop.indexOf(styleElement);
          if (idx >= 0) {
            styleElementsInsertedAtTop.splice(idx, 1);
          }
        }
        function createStyleElement(options) {
          var styleElement = document.createElement("style");
          styleElement.type = "text/css";
          insertStyleElement(options, styleElement);
          return styleElement;
        }
        function createLinkElement(options) {
          var linkElement = document.createElement("link");
          linkElement.rel = "stylesheet";
          insertStyleElement(options, linkElement);
          return linkElement;
        }
        function addStyle(obj, options) {
          var styleElement, update, remove;
          if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options));
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
            remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
          } else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
            styleElement = createLinkElement(options);
            update = updateLink.bind(null, styleElement);
            remove = function () {
              removeStyleElement(styleElement);
              if (styleElement.href) URL.revokeObjectURL(styleElement.href);
            };
          } else {
            styleElement = createStyleElement(options);
            update = applyToTag.bind(null, styleElement);
            remove = function () {
              removeStyleElement(styleElement);
            };
          }
          update(obj);
          return function updateStyle(newObj) {
            if (newObj) {
              if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
              update(obj = newObj);
            } else {
              remove();
            }
          };
        }
        var replaceText = function () {
          var textStore = [];
          return function (index, replacement) {
            textStore[index] = replacement;
            return textStore.filter(Boolean).join('\n');
          };
        }();
        function applyToSingletonTag(styleElement, index, remove, obj) {
          var css = remove ? "" : obj.css;
          if (styleElement.styleSheet) {
            styleElement.styleSheet.cssText = replaceText(index, css);
          } else {
            var cssNode = document.createTextNode(css);
            var childNodes = styleElement.childNodes;
            if (childNodes[index]) styleElement.removeChild(childNodes[index]);
            if (childNodes.length) {
              styleElement.insertBefore(cssNode, childNodes[index]);
            } else {
              styleElement.appendChild(cssNode);
            }
          }
        }
        function applyToTag(styleElement, obj) {
          var css = obj.css;
          var media = obj.media;
          if (media) {
            styleElement.setAttribute("media", media);
          }
          if (styleElement.styleSheet) {
            styleElement.styleSheet.cssText = css;
          } else {
            while (styleElement.firstChild) {
              styleElement.removeChild(styleElement.firstChild);
            }
            styleElement.appendChild(document.createTextNode(css));
          }
        }
        function updateLink(linkElement, obj) {
          var css = obj.css;
          var sourceMap = obj.sourceMap;
          if (sourceMap) {
            // http://stackoverflow.com/a/26603875
            css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
          }
          var blob = new Blob([css], {
            type: "text/css"
          });
          var oldSrc = linkElement.href;
          linkElement.href = URL.createObjectURL(blob);
          if (oldSrc) URL.revokeObjectURL(oldSrc);
        }

        /***/
      }, /* 9 */
      /***/function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

        /***/
      },, /* 11 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        module.exports = {
          selected: _propTypes2['default'].object.isRequired,
          copied: _propTypes2['default'].object,
          dragged: _propTypes2['default'].object,
          onCellClick: _propTypes2['default'].func.isRequired,
          onCellDoubleClick: _propTypes2['default'].func.isRequired,
          onCommit: _propTypes2['default'].func.isRequired,
          onCommitCancel: _propTypes2['default'].func.isRequired,
          handleDragEnterRow: _propTypes2['default'].func.isRequired,
          handleTerminateDrag: _propTypes2['default'].func.isRequired,
          getCellActions: _propTypes2['default'].func
        };

        /***/
      }, /* 12 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var ExcelColumnShape = {
          name: _propTypes2['default'].node.isRequired,
          key: _propTypes2['default'].string.isRequired,
          width: _propTypes2['default'].number.isRequired,
          filterable: _propTypes2['default'].bool
        };
        module.exports = ExcelColumnShape;

        /***/
      },, /* 14 */
      /***/function (module, exports) {
        "use strict";

        function createObjectWithProperties(originalObj, properties) {
          var result = {};
          for (var _iterator = properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;
            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }
            var property = _ref;
            if (property in originalObj) {
              result[property] = originalObj[property];
            }
          }
          return result;
        }
        module.exports = createObjectWithProperties;

        /***/
      }, /* 15 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(141);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      },,, /* 18 */
      /***/function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        (function (global, factory) {
          true ? module.exports = factory() : undefined;
        })(this, function () {
          'use strict';

          var SLICE$0 = Array.prototype.slice;
          function createClass(ctor, superClass) {
            if (superClass) {
              ctor.prototype = Object.create(superClass.prototype);
            }
            ctor.prototype.constructor = ctor;
          }
          function Iterable(value) {
            return isIterable(value) ? value : Seq(value);
          }
          createClass(KeyedIterable, Iterable);
          function KeyedIterable(value) {
            return isKeyed(value) ? value : KeyedSeq(value);
          }
          createClass(IndexedIterable, Iterable);
          function IndexedIterable(value) {
            return isIndexed(value) ? value : IndexedSeq(value);
          }
          createClass(SetIterable, Iterable);
          function SetIterable(value) {
            return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
          }
          function isIterable(maybeIterable) {
            return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
          }
          function isKeyed(maybeKeyed) {
            return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
          }
          function isIndexed(maybeIndexed) {
            return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
          }
          function isAssociative(maybeAssociative) {
            return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
          }
          function isOrdered(maybeOrdered) {
            return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
          }
          Iterable.isIterable = isIterable;
          Iterable.isKeyed = isKeyed;
          Iterable.isIndexed = isIndexed;
          Iterable.isAssociative = isAssociative;
          Iterable.isOrdered = isOrdered;
          Iterable.Keyed = KeyedIterable;
          Iterable.Indexed = IndexedIterable;
          Iterable.Set = SetIterable;
          var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
          var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
          var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
          var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

          // Used for setting prototype methods that IE8 chokes on.
          var DELETE = 'delete';

          // Constants describing the size of trie nodes.
          var SHIFT = 5; // Resulted in best performance after ______?
          var SIZE = 1 << SHIFT;
          var MASK = SIZE - 1;

          // A consistent shared value representing "not set" which equals nothing other
          // than itself, and nothing that could be provided externally.
          var NOT_SET = {};

          // Boolean references, Rough equivalent of `bool &`.
          var CHANGE_LENGTH = {
            value: false
          };
          var DID_ALTER = {
            value: false
          };
          function MakeRef(ref) {
            ref.value = false;
            return ref;
          }
          function SetRef(ref) {
            ref && (ref.value = true);
          }

          // A function which returns a value representing an "owner" for transient writes
          // to tries. The return value will only ever equal itself, and will not equal
          // the return of any subsequent call of this function.
          function OwnerID() {}

          // http://jsperf.com/copy-array-inline
          function arrCopy(arr, offset) {
            offset = offset || 0;
            var len = Math.max(0, arr.length - offset);
            var newArr = new Array(len);
            for (var ii = 0; ii < len; ii++) {
              newArr[ii] = arr[ii + offset];
            }
            return newArr;
          }
          function ensureSize(iter) {
            if (iter.size === undefined) {
              iter.size = iter.__iterate(returnTrue);
            }
            return iter.size;
          }
          function wrapIndex(iter, index) {
            // This implements "is array index" which the ECMAString spec defines as:
            //
            //     A String property name P is an array index if and only if
            //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
            //     to 2^32−1.
            //
            // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
            if (typeof index !== 'number') {
              var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
              if ('' + uint32Index !== index || uint32Index === 4294967295) {
                return NaN;
              }
              index = uint32Index;
            }
            return index < 0 ? ensureSize(iter) + index : index;
          }
          function returnTrue() {
            return true;
          }
          function wholeSlice(begin, end, size) {
            return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
          }
          function resolveBegin(begin, size) {
            return resolveIndex(begin, size, 0);
          }
          function resolveEnd(end, size) {
            return resolveIndex(end, size, size);
          }
          function resolveIndex(index, size, defaultIndex) {
            return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
          }

          /* global Symbol */

          var ITERATE_KEYS = 0;
          var ITERATE_VALUES = 1;
          var ITERATE_ENTRIES = 2;
          var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
          var FAUX_ITERATOR_SYMBOL = '@@iterator';
          var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
          function Iterator(next) {
            this.next = next;
          }
          Iterator.prototype.toString = function () {
            return '[Iterator]';
          };
          Iterator.KEYS = ITERATE_KEYS;
          Iterator.VALUES = ITERATE_VALUES;
          Iterator.ENTRIES = ITERATE_ENTRIES;
          Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
            return this.toString();
          };
          Iterator.prototype[ITERATOR_SYMBOL] = function () {
            return this;
          };
          function iteratorValue(type, k, v, iteratorResult) {
            var value = type === 0 ? k : type === 1 ? v : [k, v];
            iteratorResult ? iteratorResult.value = value : iteratorResult = {
              value: value,
              done: false
            };
            return iteratorResult;
          }
          function iteratorDone() {
            return {
              value: undefined,
              done: true
            };
          }
          function hasIterator(maybeIterable) {
            return !!getIteratorFn(maybeIterable);
          }
          function isIterator(maybeIterator) {
            return maybeIterator && typeof maybeIterator.next === 'function';
          }
          function getIterator(iterable) {
            var iteratorFn = getIteratorFn(iterable);
            return iteratorFn && iteratorFn.call(iterable);
          }
          function getIteratorFn(iterable) {
            var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
            if (typeof iteratorFn === 'function') {
              return iteratorFn;
            }
          }
          function isArrayLike(value) {
            return value && typeof value.length === 'number';
          }
          createClass(Seq, Iterable);
          function Seq(value) {
            return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
          }
          Seq.of = function /*...values*/
          () {
            return Seq(arguments);
          };
          Seq.prototype.toSeq = function () {
            return this;
          };
          Seq.prototype.toString = function () {
            return this.__toString('Seq {', '}');
          };
          Seq.prototype.cacheResult = function () {
            if (!this._cache && this.__iterateUncached) {
              this._cache = this.entrySeq().toArray();
              this.size = this._cache.length;
            }
            return this;
          };

          // abstract __iterateUncached(fn, reverse)

          Seq.prototype.__iterate = function (fn, reverse) {
            return seqIterate(this, fn, reverse, true);
          };

          // abstract __iteratorUncached(type, reverse)

          Seq.prototype.__iterator = function (type, reverse) {
            return seqIterator(this, type, reverse, true);
          };
          createClass(KeyedSeq, Seq);
          function KeyedSeq(value) {
            return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
          }
          KeyedSeq.prototype.toKeyedSeq = function () {
            return this;
          };
          createClass(IndexedSeq, Seq);
          function IndexedSeq(value) {
            return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
          }
          IndexedSeq.of = function /*...values*/
          () {
            return IndexedSeq(arguments);
          };
          IndexedSeq.prototype.toIndexedSeq = function () {
            return this;
          };
          IndexedSeq.prototype.toString = function () {
            return this.__toString('Seq [', ']');
          };
          IndexedSeq.prototype.__iterate = function (fn, reverse) {
            return seqIterate(this, fn, reverse, false);
          };
          IndexedSeq.prototype.__iterator = function (type, reverse) {
            return seqIterator(this, type, reverse, false);
          };
          createClass(SetSeq, Seq);
          function SetSeq(value) {
            return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
          }
          SetSeq.of = function /*...values*/
          () {
            return SetSeq(arguments);
          };
          SetSeq.prototype.toSetSeq = function () {
            return this;
          };
          Seq.isSeq = isSeq;
          Seq.Keyed = KeyedSeq;
          Seq.Set = SetSeq;
          Seq.Indexed = IndexedSeq;
          var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
          Seq.prototype[IS_SEQ_SENTINEL] = true;
          createClass(ArraySeq, IndexedSeq);
          function ArraySeq(array) {
            this._array = array;
            this.size = array.length;
          }
          ArraySeq.prototype.get = function (index, notSetValue) {
            return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
          };
          ArraySeq.prototype.__iterate = function (fn, reverse) {
            var array = this._array;
            var maxIndex = array.length - 1;
            for (var ii = 0; ii <= maxIndex; ii++) {
              if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
                return ii + 1;
              }
            }
            return ii;
          };
          ArraySeq.prototype.__iterator = function (type, reverse) {
            var array = this._array;
            var maxIndex = array.length - 1;
            var ii = 0;
            return new Iterator(function () {
              return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
            });
          };
          createClass(ObjectSeq, KeyedSeq);
          function ObjectSeq(object) {
            var keys = Object.keys(object);
            this._object = object;
            this._keys = keys;
            this.size = keys.length;
          }
          ObjectSeq.prototype.get = function (key, notSetValue) {
            if (notSetValue !== undefined && !this.has(key)) {
              return notSetValue;
            }
            return this._object[key];
          };
          ObjectSeq.prototype.has = function (key) {
            return this._object.hasOwnProperty(key);
          };
          ObjectSeq.prototype.__iterate = function (fn, reverse) {
            var object = this._object;
            var keys = this._keys;
            var maxIndex = keys.length - 1;
            for (var ii = 0; ii <= maxIndex; ii++) {
              var key = keys[reverse ? maxIndex - ii : ii];
              if (fn(object[key], key, this) === false) {
                return ii + 1;
              }
            }
            return ii;
          };
          ObjectSeq.prototype.__iterator = function (type, reverse) {
            var object = this._object;
            var keys = this._keys;
            var maxIndex = keys.length - 1;
            var ii = 0;
            return new Iterator(function () {
              var key = keys[reverse ? maxIndex - ii : ii];
              return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
            });
          };
          ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
          createClass(IterableSeq, IndexedSeq);
          function IterableSeq(iterable) {
            this._iterable = iterable;
            this.size = iterable.length || iterable.size;
          }
          IterableSeq.prototype.__iterateUncached = function (fn, reverse) {
            if (reverse) {
              return this.cacheResult().__iterate(fn, reverse);
            }
            var iterable = this._iterable;
            var iterator = getIterator(iterable);
            var iterations = 0;
            if (isIterator(iterator)) {
              var step;
              while (!(step = iterator.next()).done) {
                if (fn(step.value, iterations++, this) === false) {
                  break;
                }
              }
            }
            return iterations;
          };
          IterableSeq.prototype.__iteratorUncached = function (type, reverse) {
            if (reverse) {
              return this.cacheResult().__iterator(type, reverse);
            }
            var iterable = this._iterable;
            var iterator = getIterator(iterable);
            if (!isIterator(iterator)) {
              return new Iterator(iteratorDone);
            }
            var iterations = 0;
            return new Iterator(function () {
              var step = iterator.next();
              return step.done ? step : iteratorValue(type, iterations++, step.value);
            });
          };
          createClass(IteratorSeq, IndexedSeq);
          function IteratorSeq(iterator) {
            this._iterator = iterator;
            this._iteratorCache = [];
          }
          IteratorSeq.prototype.__iterateUncached = function (fn, reverse) {
            if (reverse) {
              return this.cacheResult().__iterate(fn, reverse);
            }
            var iterator = this._iterator;
            var cache = this._iteratorCache;
            var iterations = 0;
            while (iterations < cache.length) {
              if (fn(cache[iterations], iterations++, this) === false) {
                return iterations;
              }
            }
            var step;
            while (!(step = iterator.next()).done) {
              var val = step.value;
              cache[iterations] = val;
              if (fn(val, iterations++, this) === false) {
                break;
              }
            }
            return iterations;
          };
          IteratorSeq.prototype.__iteratorUncached = function (type, reverse) {
            if (reverse) {
              return this.cacheResult().__iterator(type, reverse);
            }
            var iterator = this._iterator;
            var cache = this._iteratorCache;
            var iterations = 0;
            return new Iterator(function () {
              if (iterations >= cache.length) {
                var step = iterator.next();
                if (step.done) {
                  return step;
                }
                cache[iterations] = step.value;
              }
              return iteratorValue(type, iterations, cache[iterations++]);
            });
          };

          // # pragma Helper functions

          function isSeq(maybeSeq) {
            return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
          }
          var EMPTY_SEQ;
          function emptySequence() {
            return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
          }
          function keyedSeqFromValue(value) {
            var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === 'object' ? new ObjectSeq(value) : undefined;
            if (!seq) {
              throw new TypeError('Expected Array or iterable object of [k, v] entries, ' + 'or keyed object: ' + value);
            }
            return seq;
          }
          function indexedSeqFromValue(value) {
            var seq = maybeIndexedSeqFromValue(value);
            if (!seq) {
              throw new TypeError('Expected Array or iterable object of values: ' + value);
            }
            return seq;
          }
          function seqFromValue(value) {
            var seq = maybeIndexedSeqFromValue(value) || typeof value === 'object' && new ObjectSeq(value);
            if (!seq) {
              throw new TypeError('Expected Array or iterable object of values, or keyed object: ' + value);
            }
            return seq;
          }
          function maybeIndexedSeqFromValue(value) {
            return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
          }
          function seqIterate(seq, fn, reverse, useKeys) {
            var cache = seq._cache;
            if (cache) {
              var maxIndex = cache.length - 1;
              for (var ii = 0; ii <= maxIndex; ii++) {
                var entry = cache[reverse ? maxIndex - ii : ii];
                if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
                  return ii + 1;
                }
              }
              return ii;
            }
            return seq.__iterateUncached(fn, reverse);
          }
          function seqIterator(seq, type, reverse, useKeys) {
            var cache = seq._cache;
            if (cache) {
              var maxIndex = cache.length - 1;
              var ii = 0;
              return new Iterator(function () {
                var entry = cache[reverse ? maxIndex - ii : ii];
                return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
              });
            }
            return seq.__iteratorUncached(type, reverse);
          }
          function fromJS(json, converter) {
            return converter ? fromJSWith(converter, json, '', {
              '': json
            }) : fromJSDefault(json);
          }
          function fromJSWith(converter, json, key, parentJSON) {
            if (Array.isArray(json)) {
              return converter.call(parentJSON, key, IndexedSeq(json).map(function (v, k) {
                return fromJSWith(converter, v, k, json);
              }));
            }
            if (isPlainObj(json)) {
              return converter.call(parentJSON, key, KeyedSeq(json).map(function (v, k) {
                return fromJSWith(converter, v, k, json);
              }));
            }
            return json;
          }
          function fromJSDefault(json) {
            if (Array.isArray(json)) {
              return IndexedSeq(json).map(fromJSDefault).toList();
            }
            if (isPlainObj(json)) {
              return KeyedSeq(json).map(fromJSDefault).toMap();
            }
            return json;
          }
          function isPlainObj(value) {
            return value && (value.constructor === Object || value.constructor === undefined);
          }

          /**
           * An extension of the "same-value" algorithm as [described for use by ES6 Map
           * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
           *
           * NaN is considered the same as NaN, however -0 and 0 are considered the same
           * value, which is different from the algorithm described by
           * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
           *
           * This is extended further to allow Objects to describe the values they
           * represent, by way of `valueOf` or `equals` (and `hashCode`).
           *
           * Note: because of this extension, the key equality of Immutable.Map and the
           * value equality of Immutable.Set will differ from ES6 Map and Set.
           *
           * ### Defining custom values
           *
           * The easiest way to describe the value an object represents is by implementing
           * `valueOf`. For example, `Date` represents a value by returning a unix
           * timestamp for `valueOf`:
           *
           *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
           *     var date2 = new Date(1234567890000);
           *     date1.valueOf(); // 1234567890000
           *     assert( date1 !== date2 );
           *     assert( Immutable.is( date1, date2 ) );
           *
           * Note: overriding `valueOf` may have other implications if you use this object
           * where JavaScript expects a primitive, such as implicit string coercion.
           *
           * For more complex types, especially collections, implementing `valueOf` may
           * not be performant. An alternative is to implement `equals` and `hashCode`.
           *
           * `equals` takes another object, presumably of similar type, and returns true
           * if the it is equal. Equality is symmetrical, so the same result should be
           * returned if this and the argument are flipped.
           *
           *     assert( a.equals(b) === b.equals(a) );
           *
           * `hashCode` returns a 32bit integer number representing the object which will
           * be used to determine how to store the value object in a Map or Set. You must
           * provide both or neither methods, one must not exist without the other.
           *
           * Also, an important relationship between these methods must be upheld: if two
           * values are equal, they *must* return the same hashCode. If the values are not
           * equal, they might have the same hashCode; this is called a hash collision,
           * and while undesirable for performance reasons, it is acceptable.
           *
           *     if (a.equals(b)) {
           *       assert( a.hashCode() === b.hashCode() );
           *     }
           *
           * All Immutable collections implement `equals` and `hashCode`.
           *
           */
          function is(valueA, valueB) {
            if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
              return true;
            }
            if (!valueA || !valueB) {
              return false;
            }
            if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
              valueA = valueA.valueOf();
              valueB = valueB.valueOf();
              if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
                return true;
              }
              if (!valueA || !valueB) {
                return false;
              }
            }
            if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) {
              return true;
            }
            return false;
          }
          function deepEqual(a, b) {
            if (a === b) {
              return true;
            }
            if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) {
              return false;
            }
            if (a.size === 0 && b.size === 0) {
              return true;
            }
            var notAssociative = !isAssociative(a);
            if (isOrdered(a)) {
              var entries = a.entries();
              return b.every(function (v, k) {
                var entry = entries.next().value;
                return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
              }) && entries.next().done;
            }
            var flipped = false;
            if (a.size === undefined) {
              if (b.size === undefined) {
                if (typeof a.cacheResult === 'function') {
                  a.cacheResult();
                }
              } else {
                flipped = true;
                var _ = a;
                a = b;
                b = _;
              }
            }
            var allEqual = true;
            var bSize = b.__iterate(function (v, k) {
              if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
                allEqual = false;
                return false;
              }
            });
            return allEqual && a.size === bSize;
          }
          createClass(Repeat, IndexedSeq);
          function Repeat(value, times) {
            if (!(this instanceof Repeat)) {
              return new Repeat(value, times);
            }
            this._value = value;
            this.size = times === undefined ? Infinity : Math.max(0, times);
            if (this.size === 0) {
              if (EMPTY_REPEAT) {
                return EMPTY_REPEAT;
              }
              EMPTY_REPEAT = this;
            }
          }
          Repeat.prototype.toString = function () {
            if (this.size === 0) {
              return 'Repeat []';
            }
            return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
          };
          Repeat.prototype.get = function (index, notSetValue) {
            return this.has(index) ? this._value : notSetValue;
          };
          Repeat.prototype.includes = function (searchValue) {
            return is(this._value, searchValue);
          };
          Repeat.prototype.slice = function (begin, end) {
            var size = this.size;
            return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
          };
          Repeat.prototype.reverse = function () {
            return this;
          };
          Repeat.prototype.indexOf = function (searchValue) {
            if (is(this._value, searchValue)) {
              return 0;
            }
            return -1;
          };
          Repeat.prototype.lastIndexOf = function (searchValue) {
            if (is(this._value, searchValue)) {
              return this.size;
            }
            return -1;
          };
          Repeat.prototype.__iterate = function (fn, reverse) {
            for (var ii = 0; ii < this.size; ii++) {
              if (fn(this._value, ii, this) === false) {
                return ii + 1;
              }
            }
            return ii;
          };
          Repeat.prototype.__iterator = function (type, reverse) {
            var this$0 = this;
            var ii = 0;
            return new Iterator(function () {
              return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
            });
          };
          Repeat.prototype.equals = function (other) {
            return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
          };
          var EMPTY_REPEAT;
          function invariant(condition, error) {
            if (!condition) throw new Error(error);
          }
          createClass(Range, IndexedSeq);
          function Range(start, end, step) {
            if (!(this instanceof Range)) {
              return new Range(start, end, step);
            }
            invariant(step !== 0, 'Cannot step a Range by 0');
            start = start || 0;
            if (end === undefined) {
              end = Infinity;
            }
            step = step === undefined ? 1 : Math.abs(step);
            if (end < start) {
              step = -step;
            }
            this._start = start;
            this._end = end;
            this._step = step;
            this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
            if (this.size === 0) {
              if (EMPTY_RANGE) {
                return EMPTY_RANGE;
              }
              EMPTY_RANGE = this;
            }
          }
          Range.prototype.toString = function () {
            if (this.size === 0) {
              return 'Range []';
            }
            return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
          };
          Range.prototype.get = function (index, notSetValue) {
            return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
          };
          Range.prototype.includes = function (searchValue) {
            var possibleIndex = (searchValue - this._start) / this._step;
            return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
          };
          Range.prototype.slice = function (begin, end) {
            if (wholeSlice(begin, end, this.size)) {
              return this;
            }
            begin = resolveBegin(begin, this.size);
            end = resolveEnd(end, this.size);
            if (end <= begin) {
              return new Range(0, 0);
            }
            return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
          };
          Range.prototype.indexOf = function (searchValue) {
            var offsetValue = searchValue - this._start;
            if (offsetValue % this._step === 0) {
              var index = offsetValue / this._step;
              if (index >= 0 && index < this.size) {
                return index;
              }
            }
            return -1;
          };
          Range.prototype.lastIndexOf = function (searchValue) {
            return this.indexOf(searchValue);
          };
          Range.prototype.__iterate = function (fn, reverse) {
            var maxIndex = this.size - 1;
            var step = this._step;
            var value = reverse ? this._start + maxIndex * step : this._start;
            for (var ii = 0; ii <= maxIndex; ii++) {
              if (fn(value, ii, this) === false) {
                return ii + 1;
              }
              value += reverse ? -step : step;
            }
            return ii;
          };
          Range.prototype.__iterator = function (type, reverse) {
            var maxIndex = this.size - 1;
            var step = this._step;
            var value = reverse ? this._start + maxIndex * step : this._start;
            var ii = 0;
            return new Iterator(function () {
              var v = value;
              value += reverse ? -step : step;
              return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
            });
          };
          Range.prototype.equals = function (other) {
            return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
          };
          var EMPTY_RANGE;
          createClass(Collection, Iterable);
          function Collection() {
            throw TypeError('Abstract');
          }
          createClass(KeyedCollection, Collection);
          function KeyedCollection() {}
          createClass(IndexedCollection, Collection);
          function IndexedCollection() {}
          createClass(SetCollection, Collection);
          function SetCollection() {}
          Collection.Keyed = KeyedCollection;
          Collection.Indexed = IndexedCollection;
          Collection.Set = SetCollection;
          var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
            a = a | 0; // int
            b = b | 0; // int
            var c = a & 0xffff;
            var d = b & 0xffff;
            // Shift by 0 fixes the sign on the high part.
            return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
          };

          // v8 has an optimization for storing 31-bit signed numbers.
          // Values which have either 00 or 11 as the high order bits qualify.
          // This function drops the highest order bit in a signed number, maintaining
          // the sign bit.
          function smi(i32) {
            return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
          }
          function hash(o) {
            if (o === false || o === null || o === undefined) {
              return 0;
            }
            if (typeof o.valueOf === 'function') {
              o = o.valueOf();
              if (o === false || o === null || o === undefined) {
                return 0;
              }
            }
            if (o === true) {
              return 1;
            }
            var type = typeof o;
            if (type === 'number') {
              if (o !== o || o === Infinity) {
                return 0;
              }
              var h = o | 0;
              if (h !== o) {
                h ^= o * 0xFFFFFFFF;
              }
              while (o > 0xFFFFFFFF) {
                o /= 0xFFFFFFFF;
                h ^= o;
              }
              return smi(h);
            }
            if (type === 'string') {
              return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
            }
            if (typeof o.hashCode === 'function') {
              return o.hashCode();
            }
            if (type === 'object') {
              return hashJSObj(o);
            }
            if (typeof o.toString === 'function') {
              return hashString(o.toString());
            }
            throw new Error('Value type ' + type + ' cannot be hashed.');
          }
          function cachedHashString(string) {
            var hash = stringHashCache[string];
            if (hash === undefined) {
              hash = hashString(string);
              if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
                STRING_HASH_CACHE_SIZE = 0;
                stringHashCache = {};
              }
              STRING_HASH_CACHE_SIZE++;
              stringHashCache[string] = hash;
            }
            return hash;
          }

          // http://jsperf.com/hashing-strings
          function hashString(string) {
            // This is the hash from JVM
            // The hash code for a string is computed as
            // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
            // where s[i] is the ith character of the string and n is the length of
            // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
            // (exclusive) by dropping high bits.
            var hash = 0;
            for (var ii = 0; ii < string.length; ii++) {
              hash = 31 * hash + string.charCodeAt(ii) | 0;
            }
            return smi(hash);
          }
          function hashJSObj(obj) {
            var hash;
            if (usingWeakMap) {
              hash = weakMap.get(obj);
              if (hash !== undefined) {
                return hash;
              }
            }
            hash = obj[UID_HASH_KEY];
            if (hash !== undefined) {
              return hash;
            }
            if (!canDefineProperty) {
              hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
              if (hash !== undefined) {
                return hash;
              }
              hash = getIENodeHash(obj);
              if (hash !== undefined) {
                return hash;
              }
            }
            hash = ++objHashUID;
            if (objHashUID & 0x40000000) {
              objHashUID = 0;
            }
            if (usingWeakMap) {
              weakMap.set(obj, hash);
            } else if (isExtensible !== undefined && isExtensible(obj) === false) {
              throw new Error('Non-extensible objects are not allowed as keys.');
            } else if (canDefineProperty) {
              Object.defineProperty(obj, UID_HASH_KEY, {
                'enumerable': false,
                'configurable': false,
                'writable': false,
                'value': hash
              });
            } else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
              // Since we can't define a non-enumerable property on the object
              // we'll hijack one of the less-used non-enumerable properties to
              // save our hash on it. Since this is a function it will not show up in
              // `JSON.stringify` which is what we want.
              obj.propertyIsEnumerable = function () {
                return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
              };
              obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
            } else if (obj.nodeType !== undefined) {
              // At this point we couldn't get the IE `uniqueID` to use as a hash
              // and we couldn't use a non-enumerable property to exploit the
              // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
              // itself.
              obj[UID_HASH_KEY] = hash;
            } else {
              throw new Error('Unable to set a non-enumerable property on object.');
            }
            return hash;
          }

          // Get references to ES5 object methods.
          var isExtensible = Object.isExtensible;

          // True if Object.defineProperty works as expected. IE8 fails this test.
          var canDefineProperty = function () {
            try {
              Object.defineProperty({}, '@', {});
              return true;
            } catch (e) {
              return false;
            }
          }();

          // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
          // and avoid memory leaks from the IE cloneNode bug.
          function getIENodeHash(node) {
            if (node && node.nodeType > 0) {
              switch (node.nodeType) {
                case 1:
                  // Element
                  return node.uniqueID;
                case 9:
                  // Document
                  return node.documentElement && node.documentElement.uniqueID;
              }
            }
          }

          // If possible, use a WeakMap.
          var usingWeakMap = typeof WeakMap === 'function';
          var weakMap;
          if (usingWeakMap) {
            weakMap = new WeakMap();
          }
          var objHashUID = 0;
          var UID_HASH_KEY = '__immutablehash__';
          if (typeof Symbol === 'function') {
            UID_HASH_KEY = Symbol(UID_HASH_KEY);
          }
          var STRING_HASH_CACHE_MIN_STRLEN = 16;
          var STRING_HASH_CACHE_MAX_SIZE = 255;
          var STRING_HASH_CACHE_SIZE = 0;
          var stringHashCache = {};
          function assertNotInfinite(size) {
            invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
          }
          createClass(Map, KeyedCollection);

          // @pragma Construction

          function Map(value) {
            return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function (map) {
              var iter = KeyedIterable(value);
              assertNotInfinite(iter.size);
              iter.forEach(function (v, k) {
                return map.set(k, v);
              });
            });
          }
          Map.of = function () {
            var keyValues = SLICE$0.call(arguments, 0);
            return emptyMap().withMutations(function (map) {
              for (var i = 0; i < keyValues.length; i += 2) {
                if (i + 1 >= keyValues.length) {
                  throw new Error('Missing value for key: ' + keyValues[i]);
                }
                map.set(keyValues[i], keyValues[i + 1]);
              }
            });
          };
          Map.prototype.toString = function () {
            return this.__toString('Map {', '}');
          };

          // @pragma Access

          Map.prototype.get = function (k, notSetValue) {
            return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
          };

          // @pragma Modification

          Map.prototype.set = function (k, v) {
            return updateMap(this, k, v);
          };
          Map.prototype.setIn = function (keyPath, v) {
            return this.updateIn(keyPath, NOT_SET, function () {
              return v;
            });
          };
          Map.prototype.remove = function (k) {
            return updateMap(this, k, NOT_SET);
          };
          Map.prototype.deleteIn = function (keyPath) {
            return this.updateIn(keyPath, function () {
              return NOT_SET;
            });
          };
          Map.prototype.update = function (k, notSetValue, updater) {
            return arguments.length === 1 ? k(this) : this.updateIn([k], notSetValue, updater);
          };
          Map.prototype.updateIn = function (keyPath, notSetValue, updater) {
            if (!updater) {
              updater = notSetValue;
              notSetValue = undefined;
            }
            var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
            return updatedValue === NOT_SET ? undefined : updatedValue;
          };
          Map.prototype.clear = function () {
            if (this.size === 0) {
              return this;
            }
            if (this.__ownerID) {
              this.size = 0;
              this._root = null;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return emptyMap();
          };

          // @pragma Composition

          Map.prototype.merge = function /*...iters*/
          () {
            return mergeIntoMapWith(this, undefined, arguments);
          };
          Map.prototype.mergeWith = function (merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoMapWith(this, merger, iters);
          };
          Map.prototype.mergeIn = function (keyPath) {
            var iters = SLICE$0.call(arguments, 1);
            return this.updateIn(keyPath, emptyMap(), function (m) {
              return typeof m.merge === 'function' ? m.merge.apply(m, iters) : iters[iters.length - 1];
            });
          };
          Map.prototype.mergeDeep = function /*...iters*/
          () {
            return mergeIntoMapWith(this, deepMerger, arguments);
          };
          Map.prototype.mergeDeepWith = function (merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoMapWith(this, deepMergerWith(merger), iters);
          };
          Map.prototype.mergeDeepIn = function (keyPath) {
            var iters = SLICE$0.call(arguments, 1);
            return this.updateIn(keyPath, emptyMap(), function (m) {
              return typeof m.mergeDeep === 'function' ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
            });
          };
          Map.prototype.sort = function (comparator) {
            // Late binding
            return OrderedMap(sortFactory(this, comparator));
          };
          Map.prototype.sortBy = function (mapper, comparator) {
            // Late binding
            return OrderedMap(sortFactory(this, comparator, mapper));
          };

          // @pragma Mutability

          Map.prototype.withMutations = function (fn) {
            var mutable = this.asMutable();
            fn(mutable);
            return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
          };
          Map.prototype.asMutable = function () {
            return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
          };
          Map.prototype.asImmutable = function () {
            return this.__ensureOwner();
          };
          Map.prototype.wasAltered = function () {
            return this.__altered;
          };
          Map.prototype.__iterator = function (type, reverse) {
            return new MapIterator(this, type, reverse);
          };
          Map.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            this._root && this._root.iterate(function (entry) {
              iterations++;
              return fn(entry[1], entry[0], this$0);
            }, reverse);
            return iterations;
          };
          Map.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            if (!ownerID) {
              this.__ownerID = ownerID;
              this.__altered = false;
              return this;
            }
            return makeMap(this.size, this._root, ownerID, this.__hash);
          };
          function isMap(maybeMap) {
            return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
          }
          Map.isMap = isMap;
          var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
          var MapPrototype = Map.prototype;
          MapPrototype[IS_MAP_SENTINEL] = true;
          MapPrototype[DELETE] = MapPrototype.remove;
          MapPrototype.removeIn = MapPrototype.deleteIn;

          // #pragma Trie Nodes

          function ArrayMapNode(ownerID, entries) {
            this.ownerID = ownerID;
            this.entries = entries;
          }
          ArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
            var entries = this.entries;
            for (var ii = 0, len = entries.length; ii < len; ii++) {
              if (is(key, entries[ii][0])) {
                return entries[ii][1];
              }
            }
            return notSetValue;
          };
          ArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            var removed = value === NOT_SET;
            var entries = this.entries;
            var idx = 0;
            for (var len = entries.length; idx < len; idx++) {
              if (is(key, entries[idx][0])) {
                break;
              }
            }
            var exists = idx < len;
            if (exists ? entries[idx][1] === value : removed) {
              return this;
            }
            SetRef(didAlter);
            (removed || !exists) && SetRef(didChangeSize);
            if (removed && entries.length === 1) {
              return; // undefined
            }

            if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
              return createNodes(ownerID, entries, key, value);
            }
            var isEditable = ownerID && ownerID === this.ownerID;
            var newEntries = isEditable ? entries : arrCopy(entries);
            if (exists) {
              if (removed) {
                idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
              } else {
                newEntries[idx] = [key, value];
              }
            } else {
              newEntries.push([key, value]);
            }
            if (isEditable) {
              this.entries = newEntries;
              return this;
            }
            return new ArrayMapNode(ownerID, newEntries);
          };
          function BitmapIndexedNode(ownerID, bitmap, nodes) {
            this.ownerID = ownerID;
            this.bitmap = bitmap;
            this.nodes = nodes;
          }
          BitmapIndexedNode.prototype.get = function (shift, keyHash, key, notSetValue) {
            if (keyHash === undefined) {
              keyHash = hash(key);
            }
            var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
            var bitmap = this.bitmap;
            return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
          };
          BitmapIndexedNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            if (keyHash === undefined) {
              keyHash = hash(key);
            }
            var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
            var bit = 1 << keyHashFrag;
            var bitmap = this.bitmap;
            var exists = (bitmap & bit) !== 0;
            if (!exists && value === NOT_SET) {
              return this;
            }
            var idx = popCount(bitmap & bit - 1);
            var nodes = this.nodes;
            var node = exists ? nodes[idx] : undefined;
            var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
            if (newNode === node) {
              return this;
            }
            if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
              return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
            }
            if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
              return nodes[idx ^ 1];
            }
            if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
              return newNode;
            }
            var isEditable = ownerID && ownerID === this.ownerID;
            var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
            var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
            if (isEditable) {
              this.bitmap = newBitmap;
              this.nodes = newNodes;
              return this;
            }
            return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
          };
          function HashArrayMapNode(ownerID, count, nodes) {
            this.ownerID = ownerID;
            this.count = count;
            this.nodes = nodes;
          }
          HashArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
            if (keyHash === undefined) {
              keyHash = hash(key);
            }
            var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
            var node = this.nodes[idx];
            return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
          };
          HashArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            if (keyHash === undefined) {
              keyHash = hash(key);
            }
            var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
            var removed = value === NOT_SET;
            var nodes = this.nodes;
            var node = nodes[idx];
            if (removed && !node) {
              return this;
            }
            var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
            if (newNode === node) {
              return this;
            }
            var newCount = this.count;
            if (!node) {
              newCount++;
            } else if (!newNode) {
              newCount--;
              if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
                return packNodes(ownerID, nodes, newCount, idx);
              }
            }
            var isEditable = ownerID && ownerID === this.ownerID;
            var newNodes = setIn(nodes, idx, newNode, isEditable);
            if (isEditable) {
              this.count = newCount;
              this.nodes = newNodes;
              return this;
            }
            return new HashArrayMapNode(ownerID, newCount, newNodes);
          };
          function HashCollisionNode(ownerID, keyHash, entries) {
            this.ownerID = ownerID;
            this.keyHash = keyHash;
            this.entries = entries;
          }
          HashCollisionNode.prototype.get = function (shift, keyHash, key, notSetValue) {
            var entries = this.entries;
            for (var ii = 0, len = entries.length; ii < len; ii++) {
              if (is(key, entries[ii][0])) {
                return entries[ii][1];
              }
            }
            return notSetValue;
          };
          HashCollisionNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            if (keyHash === undefined) {
              keyHash = hash(key);
            }
            var removed = value === NOT_SET;
            if (keyHash !== this.keyHash) {
              if (removed) {
                return this;
              }
              SetRef(didAlter);
              SetRef(didChangeSize);
              return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
            }
            var entries = this.entries;
            var idx = 0;
            for (var len = entries.length; idx < len; idx++) {
              if (is(key, entries[idx][0])) {
                break;
              }
            }
            var exists = idx < len;
            if (exists ? entries[idx][1] === value : removed) {
              return this;
            }
            SetRef(didAlter);
            (removed || !exists) && SetRef(didChangeSize);
            if (removed && len === 2) {
              return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
            }
            var isEditable = ownerID && ownerID === this.ownerID;
            var newEntries = isEditable ? entries : arrCopy(entries);
            if (exists) {
              if (removed) {
                idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
              } else {
                newEntries[idx] = [key, value];
              }
            } else {
              newEntries.push([key, value]);
            }
            if (isEditable) {
              this.entries = newEntries;
              return this;
            }
            return new HashCollisionNode(ownerID, this.keyHash, newEntries);
          };
          function ValueNode(ownerID, keyHash, entry) {
            this.ownerID = ownerID;
            this.keyHash = keyHash;
            this.entry = entry;
          }
          ValueNode.prototype.get = function (shift, keyHash, key, notSetValue) {
            return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
          };
          ValueNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            var removed = value === NOT_SET;
            var keyMatch = is(key, this.entry[0]);
            if (keyMatch ? value === this.entry[1] : removed) {
              return this;
            }
            SetRef(didAlter);
            if (removed) {
              SetRef(didChangeSize);
              return; // undefined
            }

            if (keyMatch) {
              if (ownerID && ownerID === this.ownerID) {
                this.entry[1] = value;
                return this;
              }
              return new ValueNode(ownerID, this.keyHash, [key, value]);
            }
            SetRef(didChangeSize);
            return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
          };

          // #pragma Iterators

          ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function (fn, reverse) {
            var entries = this.entries;
            for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
              if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
                return false;
              }
            }
          };
          BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function (fn, reverse) {
            var nodes = this.nodes;
            for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
              var node = nodes[reverse ? maxIndex - ii : ii];
              if (node && node.iterate(fn, reverse) === false) {
                return false;
              }
            }
          };
          ValueNode.prototype.iterate = function (fn, reverse) {
            return fn(this.entry);
          };
          createClass(MapIterator, Iterator);
          function MapIterator(map, type, reverse) {
            this._type = type;
            this._reverse = reverse;
            this._stack = map._root && mapIteratorFrame(map._root);
          }
          MapIterator.prototype.next = function () {
            var type = this._type;
            var stack = this._stack;
            while (stack) {
              var node = stack.node;
              var index = stack.index++;
              var maxIndex;
              if (node.entry) {
                if (index === 0) {
                  return mapIteratorValue(type, node.entry);
                }
              } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) {
                  return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
                }
              } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                  var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                  if (subNode) {
                    if (subNode.entry) {
                      return mapIteratorValue(type, subNode.entry);
                    }
                    stack = this._stack = mapIteratorFrame(subNode, stack);
                  }
                  continue;
                }
              }
              stack = this._stack = this._stack.__prev;
            }
            return iteratorDone();
          };
          function mapIteratorValue(type, entry) {
            return iteratorValue(type, entry[0], entry[1]);
          }
          function mapIteratorFrame(node, prev) {
            return {
              node: node,
              index: 0,
              __prev: prev
            };
          }
          function makeMap(size, root, ownerID, hash) {
            var map = Object.create(MapPrototype);
            map.size = size;
            map._root = root;
            map.__ownerID = ownerID;
            map.__hash = hash;
            map.__altered = false;
            return map;
          }
          var EMPTY_MAP;
          function emptyMap() {
            return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
          }
          function updateMap(map, k, v) {
            var newRoot;
            var newSize;
            if (!map._root) {
              if (v === NOT_SET) {
                return map;
              }
              newSize = 1;
              newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
            } else {
              var didChangeSize = MakeRef(CHANGE_LENGTH);
              var didAlter = MakeRef(DID_ALTER);
              newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
              if (!didAlter.value) {
                return map;
              }
              newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
            }
            if (map.__ownerID) {
              map.size = newSize;
              map._root = newRoot;
              map.__hash = undefined;
              map.__altered = true;
              return map;
            }
            return newRoot ? makeMap(newSize, newRoot) : emptyMap();
          }
          function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            if (!node) {
              if (value === NOT_SET) {
                return node;
              }
              SetRef(didAlter);
              SetRef(didChangeSize);
              return new ValueNode(ownerID, keyHash, [key, value]);
            }
            return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
          }
          function isLeafNode(node) {
            return node.constructor === ValueNode || node.constructor === HashCollisionNode;
          }
          function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
            if (node.keyHash === keyHash) {
              return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
            }
            var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
            var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
            var newNode;
            var nodes = idx1 === idx2 ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [node, newNode] : [newNode, node]);
            return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
          }
          function createNodes(ownerID, entries, key, value) {
            if (!ownerID) {
              ownerID = new OwnerID();
            }
            var node = new ValueNode(ownerID, hash(key), [key, value]);
            for (var ii = 0; ii < entries.length; ii++) {
              var entry = entries[ii];
              node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
            }
            return node;
          }
          function packNodes(ownerID, nodes, count, excluding) {
            var bitmap = 0;
            var packedII = 0;
            var packedNodes = new Array(count);
            for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
              var node = nodes[ii];
              if (node !== undefined && ii !== excluding) {
                bitmap |= bit;
                packedNodes[packedII++] = node;
              }
            }
            return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
          }
          function expandNodes(ownerID, nodes, bitmap, including, node) {
            var count = 0;
            var expandedNodes = new Array(SIZE);
            for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
              expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
            }
            expandedNodes[including] = node;
            return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
          }
          function mergeIntoMapWith(map, merger, iterables) {
            var iters = [];
            for (var ii = 0; ii < iterables.length; ii++) {
              var value = iterables[ii];
              var iter = KeyedIterable(value);
              if (!isIterable(value)) {
                iter = iter.map(function (v) {
                  return fromJS(v);
                });
              }
              iters.push(iter);
            }
            return mergeIntoCollectionWith(map, merger, iters);
          }
          function deepMerger(existing, value, key) {
            return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
          }
          function deepMergerWith(merger) {
            return function (existing, value, key) {
              if (existing && existing.mergeDeepWith && isIterable(value)) {
                return existing.mergeDeepWith(merger, value);
              }
              var nextValue = merger(existing, value, key);
              return is(existing, nextValue) ? existing : nextValue;
            };
          }
          function mergeIntoCollectionWith(collection, merger, iters) {
            iters = iters.filter(function (x) {
              return x.size !== 0;
            });
            if (iters.length === 0) {
              return collection;
            }
            if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
              return collection.constructor(iters[0]);
            }
            return collection.withMutations(function (collection) {
              var mergeIntoMap = merger ? function (value, key) {
                collection.update(key, NOT_SET, function (existing) {
                  return existing === NOT_SET ? value : merger(existing, value, key);
                });
              } : function (value, key) {
                collection.set(key, value);
              };
              for (var ii = 0; ii < iters.length; ii++) {
                iters[ii].forEach(mergeIntoMap);
              }
            });
          }
          function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
            var isNotSet = existing === NOT_SET;
            var step = keyPathIter.next();
            if (step.done) {
              var existingValue = isNotSet ? notSetValue : existing;
              var newValue = updater(existingValue);
              return newValue === existingValue ? existing : newValue;
            }
            invariant(isNotSet || existing && existing.set, 'invalid keyPath');
            var key = step.value;
            var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
            var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
            return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
          }
          function popCount(x) {
            x = x - (x >> 1 & 0x55555555);
            x = (x & 0x33333333) + (x >> 2 & 0x33333333);
            x = x + (x >> 4) & 0x0f0f0f0f;
            x = x + (x >> 8);
            x = x + (x >> 16);
            return x & 0x7f;
          }
          function setIn(array, idx, val, canEdit) {
            var newArray = canEdit ? array : arrCopy(array);
            newArray[idx] = val;
            return newArray;
          }
          function spliceIn(array, idx, val, canEdit) {
            var newLen = array.length + 1;
            if (canEdit && idx + 1 === newLen) {
              array[idx] = val;
              return array;
            }
            var newArray = new Array(newLen);
            var after = 0;
            for (var ii = 0; ii < newLen; ii++) {
              if (ii === idx) {
                newArray[ii] = val;
                after = -1;
              } else {
                newArray[ii] = array[ii + after];
              }
            }
            return newArray;
          }
          function spliceOut(array, idx, canEdit) {
            var newLen = array.length - 1;
            if (canEdit && idx === newLen) {
              array.pop();
              return array;
            }
            var newArray = new Array(newLen);
            var after = 0;
            for (var ii = 0; ii < newLen; ii++) {
              if (ii === idx) {
                after = 1;
              }
              newArray[ii] = array[ii + after];
            }
            return newArray;
          }
          var MAX_ARRAY_MAP_SIZE = SIZE / 4;
          var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
          var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
          createClass(List, IndexedCollection);

          // @pragma Construction

          function List(value) {
            var empty = emptyList();
            if (value === null || value === undefined) {
              return empty;
            }
            if (isList(value)) {
              return value;
            }
            var iter = IndexedIterable(value);
            var size = iter.size;
            if (size === 0) {
              return empty;
            }
            assertNotInfinite(size);
            if (size > 0 && size < SIZE) {
              return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
            }
            return empty.withMutations(function (list) {
              list.setSize(size);
              iter.forEach(function (v, i) {
                return list.set(i, v);
              });
            });
          }
          List.of = function /*...values*/
          () {
            return this(arguments);
          };
          List.prototype.toString = function () {
            return this.__toString('List [', ']');
          };

          // @pragma Access

          List.prototype.get = function (index, notSetValue) {
            index = wrapIndex(this, index);
            if (index >= 0 && index < this.size) {
              index += this._origin;
              var node = listNodeFor(this, index);
              return node && node.array[index & MASK];
            }
            return notSetValue;
          };

          // @pragma Modification

          List.prototype.set = function (index, value) {
            return updateList(this, index, value);
          };
          List.prototype.remove = function (index) {
            return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
          };
          List.prototype.insert = function (index, value) {
            return this.splice(index, 0, value);
          };
          List.prototype.clear = function () {
            if (this.size === 0) {
              return this;
            }
            if (this.__ownerID) {
              this.size = this._origin = this._capacity = 0;
              this._level = SHIFT;
              this._root = this._tail = null;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return emptyList();
          };
          List.prototype.push = function /*...values*/
          () {
            var values = arguments;
            var oldSize = this.size;
            return this.withMutations(function (list) {
              setListBounds(list, 0, oldSize + values.length);
              for (var ii = 0; ii < values.length; ii++) {
                list.set(oldSize + ii, values[ii]);
              }
            });
          };
          List.prototype.pop = function () {
            return setListBounds(this, 0, -1);
          };
          List.prototype.unshift = function /*...values*/
          () {
            var values = arguments;
            return this.withMutations(function (list) {
              setListBounds(list, -values.length);
              for (var ii = 0; ii < values.length; ii++) {
                list.set(ii, values[ii]);
              }
            });
          };
          List.prototype.shift = function () {
            return setListBounds(this, 1);
          };

          // @pragma Composition

          List.prototype.merge = function /*...iters*/
          () {
            return mergeIntoListWith(this, undefined, arguments);
          };
          List.prototype.mergeWith = function (merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoListWith(this, merger, iters);
          };
          List.prototype.mergeDeep = function /*...iters*/
          () {
            return mergeIntoListWith(this, deepMerger, arguments);
          };
          List.prototype.mergeDeepWith = function (merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoListWith(this, deepMergerWith(merger), iters);
          };
          List.prototype.setSize = function (size) {
            return setListBounds(this, 0, size);
          };

          // @pragma Iteration

          List.prototype.slice = function (begin, end) {
            var size = this.size;
            if (wholeSlice(begin, end, size)) {
              return this;
            }
            return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
          };
          List.prototype.__iterator = function (type, reverse) {
            var index = 0;
            var values = iterateList(this, reverse);
            return new Iterator(function () {
              var value = values();
              return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
            });
          };
          List.prototype.__iterate = function (fn, reverse) {
            var index = 0;
            var values = iterateList(this, reverse);
            var value;
            while ((value = values()) !== DONE) {
              if (fn(value, index++, this) === false) {
                break;
              }
            }
            return index;
          };
          List.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            if (!ownerID) {
              this.__ownerID = ownerID;
              return this;
            }
            return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
          };
          function isList(maybeList) {
            return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
          }
          List.isList = isList;
          var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
          var ListPrototype = List.prototype;
          ListPrototype[IS_LIST_SENTINEL] = true;
          ListPrototype[DELETE] = ListPrototype.remove;
          ListPrototype.setIn = MapPrototype.setIn;
          ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
          ListPrototype.update = MapPrototype.update;
          ListPrototype.updateIn = MapPrototype.updateIn;
          ListPrototype.mergeIn = MapPrototype.mergeIn;
          ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
          ListPrototype.withMutations = MapPrototype.withMutations;
          ListPrototype.asMutable = MapPrototype.asMutable;
          ListPrototype.asImmutable = MapPrototype.asImmutable;
          ListPrototype.wasAltered = MapPrototype.wasAltered;
          function VNode(array, ownerID) {
            this.array = array;
            this.ownerID = ownerID;
          }

          // TODO: seems like these methods are very similar

          VNode.prototype.removeBefore = function (ownerID, level, index) {
            if (index === level ? 1 << level : false || this.array.length === 0) {
              return this;
            }
            var originIndex = index >>> level & MASK;
            if (originIndex >= this.array.length) {
              return new VNode([], ownerID);
            }
            var removingFirst = originIndex === 0;
            var newChild;
            if (level > 0) {
              var oldChild = this.array[originIndex];
              newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
              if (newChild === oldChild && removingFirst) {
                return this;
              }
            }
            if (removingFirst && !newChild) {
              return this;
            }
            var editable = editableVNode(this, ownerID);
            if (!removingFirst) {
              for (var ii = 0; ii < originIndex; ii++) {
                editable.array[ii] = undefined;
              }
            }
            if (newChild) {
              editable.array[originIndex] = newChild;
            }
            return editable;
          };
          VNode.prototype.removeAfter = function (ownerID, level, index) {
            if (index === (level ? 1 << level : 0) || this.array.length === 0) {
              return this;
            }
            var sizeIndex = index - 1 >>> level & MASK;
            if (sizeIndex >= this.array.length) {
              return this;
            }
            var newChild;
            if (level > 0) {
              var oldChild = this.array[sizeIndex];
              newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
              if (newChild === oldChild && sizeIndex === this.array.length - 1) {
                return this;
              }
            }
            var editable = editableVNode(this, ownerID);
            editable.array.splice(sizeIndex + 1);
            if (newChild) {
              editable.array[sizeIndex] = newChild;
            }
            return editable;
          };
          var DONE = {};
          function iterateList(list, reverse) {
            var left = list._origin;
            var right = list._capacity;
            var tailPos = getTailOffset(right);
            var tail = list._tail;
            return iterateNodeOrLeaf(list._root, list._level, 0);
            function iterateNodeOrLeaf(node, level, offset) {
              return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
            }
            function iterateLeaf(node, offset) {
              var array = offset === tailPos ? tail && tail.array : node && node.array;
              var from = offset > left ? 0 : left - offset;
              var to = right - offset;
              if (to > SIZE) {
                to = SIZE;
              }
              return function () {
                if (from === to) {
                  return DONE;
                }
                var idx = reverse ? --to : from++;
                return array && array[idx];
              };
            }
            function iterateNode(node, level, offset) {
              var values;
              var array = node && node.array;
              var from = offset > left ? 0 : left - offset >> level;
              var to = (right - offset >> level) + 1;
              if (to > SIZE) {
                to = SIZE;
              }
              return function () {
                do {
                  if (values) {
                    var value = values();
                    if (value !== DONE) {
                      return value;
                    }
                    values = null;
                  }
                  if (from === to) {
                    return DONE;
                  }
                  var idx = reverse ? --to : from++;
                  values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
                } while (true);
              };
            }
          }
          function makeList(origin, capacity, level, root, tail, ownerID, hash) {
            var list = Object.create(ListPrototype);
            list.size = capacity - origin;
            list._origin = origin;
            list._capacity = capacity;
            list._level = level;
            list._root = root;
            list._tail = tail;
            list.__ownerID = ownerID;
            list.__hash = hash;
            list.__altered = false;
            return list;
          }
          var EMPTY_LIST;
          function emptyList() {
            return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
          }
          function updateList(list, index, value) {
            index = wrapIndex(list, index);
            if (index !== index) {
              return list;
            }
            if (index >= list.size || index < 0) {
              return list.withMutations(function (list) {
                index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
              });
            }
            index += list._origin;
            var newTail = list._tail;
            var newRoot = list._root;
            var didAlter = MakeRef(DID_ALTER);
            if (index >= getTailOffset(list._capacity)) {
              newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
            } else {
              newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
            }
            if (!didAlter.value) {
              return list;
            }
            if (list.__ownerID) {
              list._root = newRoot;
              list._tail = newTail;
              list.__hash = undefined;
              list.__altered = true;
              return list;
            }
            return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
          }
          function updateVNode(node, ownerID, level, index, value, didAlter) {
            var idx = index >>> level & MASK;
            var nodeHas = node && idx < node.array.length;
            if (!nodeHas && value === undefined) {
              return node;
            }
            var newNode;
            if (level > 0) {
              var lowerNode = node && node.array[idx];
              var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
              if (newLowerNode === lowerNode) {
                return node;
              }
              newNode = editableVNode(node, ownerID);
              newNode.array[idx] = newLowerNode;
              return newNode;
            }
            if (nodeHas && node.array[idx] === value) {
              return node;
            }
            SetRef(didAlter);
            newNode = editableVNode(node, ownerID);
            if (value === undefined && idx === newNode.array.length - 1) {
              newNode.array.pop();
            } else {
              newNode.array[idx] = value;
            }
            return newNode;
          }
          function editableVNode(node, ownerID) {
            if (ownerID && node && ownerID === node.ownerID) {
              return node;
            }
            return new VNode(node ? node.array.slice() : [], ownerID);
          }
          function listNodeFor(list, rawIndex) {
            if (rawIndex >= getTailOffset(list._capacity)) {
              return list._tail;
            }
            if (rawIndex < 1 << list._level + SHIFT) {
              var node = list._root;
              var level = list._level;
              while (node && level > 0) {
                node = node.array[rawIndex >>> level & MASK];
                level -= SHIFT;
              }
              return node;
            }
          }
          function setListBounds(list, begin, end) {
            // Sanitize begin & end using this shorthand for ToInt32(argument)
            // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
            if (begin !== undefined) {
              begin = begin | 0;
            }
            if (end !== undefined) {
              end = end | 0;
            }
            var owner = list.__ownerID || new OwnerID();
            var oldOrigin = list._origin;
            var oldCapacity = list._capacity;
            var newOrigin = oldOrigin + begin;
            var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
            if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
              return list;
            }

            // If it's going to end after it starts, it's empty.
            if (newOrigin >= newCapacity) {
              return list.clear();
            }
            var newLevel = list._level;
            var newRoot = list._root;

            // New origin might need creating a higher root.
            var offsetShift = 0;
            while (newOrigin + offsetShift < 0) {
              newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
              newLevel += SHIFT;
              offsetShift += 1 << newLevel;
            }
            if (offsetShift) {
              newOrigin += offsetShift;
              oldOrigin += offsetShift;
              newCapacity += offsetShift;
              oldCapacity += offsetShift;
            }
            var oldTailOffset = getTailOffset(oldCapacity);
            var newTailOffset = getTailOffset(newCapacity);

            // New size might need creating a higher root.
            while (newTailOffset >= 1 << newLevel + SHIFT) {
              newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
              newLevel += SHIFT;
            }

            // Locate or create the new tail.
            var oldTail = list._tail;
            var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

            // Merge Tail into tree.
            if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
              newRoot = editableVNode(newRoot, owner);
              var node = newRoot;
              for (var level = newLevel; level > SHIFT; level -= SHIFT) {
                var idx = oldTailOffset >>> level & MASK;
                node = node.array[idx] = editableVNode(node.array[idx], owner);
              }
              node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
            }

            // If the size has been reduced, there's a chance the tail needs to be trimmed.
            if (newCapacity < oldCapacity) {
              newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
            }

            // If the new origin is within the tail, then we do not need a root.
            if (newOrigin >= newTailOffset) {
              newOrigin -= newTailOffset;
              newCapacity -= newTailOffset;
              newLevel = SHIFT;
              newRoot = null;
              newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

              // Otherwise, if the root has been trimmed, garbage collect.
            } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
              offsetShift = 0;

              // Identify the new top root node of the subtree of the old root.
              while (newRoot) {
                var beginIndex = newOrigin >>> newLevel & MASK;
                if (beginIndex !== newTailOffset >>> newLevel & MASK) {
                  break;
                }
                if (beginIndex) {
                  offsetShift += (1 << newLevel) * beginIndex;
                }
                newLevel -= SHIFT;
                newRoot = newRoot.array[beginIndex];
              }

              // Trim the new sides of the new root.
              if (newRoot && newOrigin > oldOrigin) {
                newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
              }
              if (newRoot && newTailOffset < oldTailOffset) {
                newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
              }
              if (offsetShift) {
                newOrigin -= offsetShift;
                newCapacity -= offsetShift;
              }
            }
            if (list.__ownerID) {
              list.size = newCapacity - newOrigin;
              list._origin = newOrigin;
              list._capacity = newCapacity;
              list._level = newLevel;
              list._root = newRoot;
              list._tail = newTail;
              list.__hash = undefined;
              list.__altered = true;
              return list;
            }
            return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
          }
          function mergeIntoListWith(list, merger, iterables) {
            var iters = [];
            var maxSize = 0;
            for (var ii = 0; ii < iterables.length; ii++) {
              var value = iterables[ii];
              var iter = IndexedIterable(value);
              if (iter.size > maxSize) {
                maxSize = iter.size;
              }
              if (!isIterable(value)) {
                iter = iter.map(function (v) {
                  return fromJS(v);
                });
              }
              iters.push(iter);
            }
            if (maxSize > list.size) {
              list = list.setSize(maxSize);
            }
            return mergeIntoCollectionWith(list, merger, iters);
          }
          function getTailOffset(size) {
            return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
          }
          createClass(OrderedMap, Map);

          // @pragma Construction

          function OrderedMap(value) {
            return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function (map) {
              var iter = KeyedIterable(value);
              assertNotInfinite(iter.size);
              iter.forEach(function (v, k) {
                return map.set(k, v);
              });
            });
          }
          OrderedMap.of = function /*...values*/
          () {
            return this(arguments);
          };
          OrderedMap.prototype.toString = function () {
            return this.__toString('OrderedMap {', '}');
          };

          // @pragma Access

          OrderedMap.prototype.get = function (k, notSetValue) {
            var index = this._map.get(k);
            return index !== undefined ? this._list.get(index)[1] : notSetValue;
          };

          // @pragma Modification

          OrderedMap.prototype.clear = function () {
            if (this.size === 0) {
              return this;
            }
            if (this.__ownerID) {
              this.size = 0;
              this._map.clear();
              this._list.clear();
              return this;
            }
            return emptyOrderedMap();
          };
          OrderedMap.prototype.set = function (k, v) {
            return updateOrderedMap(this, k, v);
          };
          OrderedMap.prototype.remove = function (k) {
            return updateOrderedMap(this, k, NOT_SET);
          };
          OrderedMap.prototype.wasAltered = function () {
            return this._map.wasAltered() || this._list.wasAltered();
          };
          OrderedMap.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            return this._list.__iterate(function (entry) {
              return entry && fn(entry[1], entry[0], this$0);
            }, reverse);
          };
          OrderedMap.prototype.__iterator = function (type, reverse) {
            return this._list.fromEntrySeq().__iterator(type, reverse);
          };
          OrderedMap.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            var newMap = this._map.__ensureOwner(ownerID);
            var newList = this._list.__ensureOwner(ownerID);
            if (!ownerID) {
              this.__ownerID = ownerID;
              this._map = newMap;
              this._list = newList;
              return this;
            }
            return makeOrderedMap(newMap, newList, ownerID, this.__hash);
          };
          function isOrderedMap(maybeOrderedMap) {
            return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
          }
          OrderedMap.isOrderedMap = isOrderedMap;
          OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
          OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
          function makeOrderedMap(map, list, ownerID, hash) {
            var omap = Object.create(OrderedMap.prototype);
            omap.size = map ? map.size : 0;
            omap._map = map;
            omap._list = list;
            omap.__ownerID = ownerID;
            omap.__hash = hash;
            return omap;
          }
          var EMPTY_ORDERED_MAP;
          function emptyOrderedMap() {
            return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
          }
          function updateOrderedMap(omap, k, v) {
            var map = omap._map;
            var list = omap._list;
            var i = map.get(k);
            var has = i !== undefined;
            var newMap;
            var newList;
            if (v === NOT_SET) {
              // removed
              if (!has) {
                return omap;
              }
              if (list.size >= SIZE && list.size >= map.size * 2) {
                newList = list.filter(function (entry, idx) {
                  return entry !== undefined && i !== idx;
                });
                newMap = newList.toKeyedSeq().map(function (entry) {
                  return entry[0];
                }).flip().toMap();
                if (omap.__ownerID) {
                  newMap.__ownerID = newList.__ownerID = omap.__ownerID;
                }
              } else {
                newMap = map.remove(k);
                newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
              }
            } else {
              if (has) {
                if (v === list.get(i)[1]) {
                  return omap;
                }
                newMap = map;
                newList = list.set(i, [k, v]);
              } else {
                newMap = map.set(k, list.size);
                newList = list.set(list.size, [k, v]);
              }
            }
            if (omap.__ownerID) {
              omap.size = newMap.size;
              omap._map = newMap;
              omap._list = newList;
              omap.__hash = undefined;
              return omap;
            }
            return makeOrderedMap(newMap, newList);
          }
          createClass(ToKeyedSequence, KeyedSeq);
          function ToKeyedSequence(indexed, useKeys) {
            this._iter = indexed;
            this._useKeys = useKeys;
            this.size = indexed.size;
          }
          ToKeyedSequence.prototype.get = function (key, notSetValue) {
            return this._iter.get(key, notSetValue);
          };
          ToKeyedSequence.prototype.has = function (key) {
            return this._iter.has(key);
          };
          ToKeyedSequence.prototype.valueSeq = function () {
            return this._iter.valueSeq();
          };
          ToKeyedSequence.prototype.reverse = function () {
            var this$0 = this;
            var reversedSequence = reverseFactory(this, true);
            if (!this._useKeys) {
              reversedSequence.valueSeq = function () {
                return this$0._iter.toSeq().reverse();
              };
            }
            return reversedSequence;
          };
          ToKeyedSequence.prototype.map = function (mapper, context) {
            var this$0 = this;
            var mappedSequence = mapFactory(this, mapper, context);
            if (!this._useKeys) {
              mappedSequence.valueSeq = function () {
                return this$0._iter.toSeq().map(mapper, context);
              };
            }
            return mappedSequence;
          };
          ToKeyedSequence.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            var ii;
            return this._iter.__iterate(this._useKeys ? function (v, k) {
              return fn(v, k, this$0);
            } : (ii = reverse ? resolveSize(this) : 0, function (v) {
              return fn(v, reverse ? --ii : ii++, this$0);
            }), reverse);
          };
          ToKeyedSequence.prototype.__iterator = function (type, reverse) {
            if (this._useKeys) {
              return this._iter.__iterator(type, reverse);
            }
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            var ii = reverse ? resolveSize(this) : 0;
            return new Iterator(function () {
              var step = iterator.next();
              return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
            });
          };
          ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
          createClass(ToIndexedSequence, IndexedSeq);
          function ToIndexedSequence(iter) {
            this._iter = iter;
            this.size = iter.size;
          }
          ToIndexedSequence.prototype.includes = function (value) {
            return this._iter.includes(value);
          };
          ToIndexedSequence.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            return this._iter.__iterate(function (v) {
              return fn(v, iterations++, this$0);
            }, reverse);
          };
          ToIndexedSequence.prototype.__iterator = function (type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            var iterations = 0;
            return new Iterator(function () {
              var step = iterator.next();
              return step.done ? step : iteratorValue(type, iterations++, step.value, step);
            });
          };
          createClass(ToSetSequence, SetSeq);
          function ToSetSequence(iter) {
            this._iter = iter;
            this.size = iter.size;
          }
          ToSetSequence.prototype.has = function (key) {
            return this._iter.includes(key);
          };
          ToSetSequence.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            return this._iter.__iterate(function (v) {
              return fn(v, v, this$0);
            }, reverse);
          };
          ToSetSequence.prototype.__iterator = function (type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            return new Iterator(function () {
              var step = iterator.next();
              return step.done ? step : iteratorValue(type, step.value, step.value, step);
            });
          };
          createClass(FromEntriesSequence, KeyedSeq);
          function FromEntriesSequence(entries) {
            this._iter = entries;
            this.size = entries.size;
          }
          FromEntriesSequence.prototype.entrySeq = function () {
            return this._iter.toSeq();
          };
          FromEntriesSequence.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            return this._iter.__iterate(function (entry) {
              // Check if entry exists first so array access doesn't throw for holes
              // in the parent iteration.
              if (entry) {
                validateEntry(entry);
                var indexedIterable = isIterable(entry);
                return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
              }
            }, reverse);
          };
          FromEntriesSequence.prototype.__iterator = function (type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            return new Iterator(function () {
              while (true) {
                var step = iterator.next();
                if (step.done) {
                  return step;
                }
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                  validateEntry(entry);
                  var indexedIterable = isIterable(entry);
                  return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
                }
              }
            });
          };
          ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
          function flipFactory(iterable) {
            var flipSequence = makeSequence(iterable);
            flipSequence._iter = iterable;
            flipSequence.size = iterable.size;
            flipSequence.flip = function () {
              return iterable;
            };
            flipSequence.reverse = function () {
              var reversedSequence = iterable.reverse.apply(this); // super.reverse()
              reversedSequence.flip = function () {
                return iterable.reverse();
              };
              return reversedSequence;
            };
            flipSequence.has = function (key) {
              return iterable.includes(key);
            };
            flipSequence.includes = function (key) {
              return iterable.has(key);
            };
            flipSequence.cacheResult = cacheResultThrough;
            flipSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              return iterable.__iterate(function (v, k) {
                return fn(k, v, this$0) !== false;
              }, reverse);
            };
            flipSequence.__iteratorUncached = function (type, reverse) {
              if (type === ITERATE_ENTRIES) {
                var iterator = iterable.__iterator(type, reverse);
                return new Iterator(function () {
                  var step = iterator.next();
                  if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                  }
                  return step;
                });
              }
              return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
            };
            return flipSequence;
          }
          function mapFactory(iterable, mapper, context) {
            var mappedSequence = makeSequence(iterable);
            mappedSequence.size = iterable.size;
            mappedSequence.has = function (key) {
              return iterable.has(key);
            };
            mappedSequence.get = function (key, notSetValue) {
              var v = iterable.get(key, NOT_SET);
              return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
            };
            mappedSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              return iterable.__iterate(function (v, k, c) {
                return fn(mapper.call(context, v, k, c), k, this$0) !== false;
              }, reverse);
            };
            mappedSequence.__iteratorUncached = function (type, reverse) {
              var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
              return new Iterator(function () {
                var step = iterator.next();
                if (step.done) {
                  return step;
                }
                var entry = step.value;
                var key = entry[0];
                return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
              });
            };
            return mappedSequence;
          }
          function reverseFactory(iterable, useKeys) {
            var reversedSequence = makeSequence(iterable);
            reversedSequence._iter = iterable;
            reversedSequence.size = iterable.size;
            reversedSequence.reverse = function () {
              return iterable;
            };
            if (iterable.flip) {
              reversedSequence.flip = function () {
                var flipSequence = flipFactory(iterable);
                flipSequence.reverse = function () {
                  return iterable.flip();
                };
                return flipSequence;
              };
            }
            reversedSequence.get = function (key, notSetValue) {
              return iterable.get(useKeys ? key : -1 - key, notSetValue);
            };
            reversedSequence.has = function (key) {
              return iterable.has(useKeys ? key : -1 - key);
            };
            reversedSequence.includes = function (value) {
              return iterable.includes(value);
            };
            reversedSequence.cacheResult = cacheResultThrough;
            reversedSequence.__iterate = function (fn, reverse) {
              var this$0 = this;
              return iterable.__iterate(function (v, k) {
                return fn(v, k, this$0);
              }, !reverse);
            };
            reversedSequence.__iterator = function (type, reverse) {
              return iterable.__iterator(type, !reverse);
            };
            return reversedSequence;
          }
          function filterFactory(iterable, predicate, context, useKeys) {
            var filterSequence = makeSequence(iterable);
            if (useKeys) {
              filterSequence.has = function (key) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
              };
              filterSequence.get = function (key, notSetValue) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
              };
            }
            filterSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              var iterations = 0;
              iterable.__iterate(function (v, k, c) {
                if (predicate.call(context, v, k, c)) {
                  iterations++;
                  return fn(v, useKeys ? k : iterations - 1, this$0);
                }
              }, reverse);
              return iterations;
            };
            filterSequence.__iteratorUncached = function (type, reverse) {
              var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
              var iterations = 0;
              return new Iterator(function () {
                while (true) {
                  var step = iterator.next();
                  if (step.done) {
                    return step;
                  }
                  var entry = step.value;
                  var key = entry[0];
                  var value = entry[1];
                  if (predicate.call(context, value, key, iterable)) {
                    return iteratorValue(type, useKeys ? key : iterations++, value, step);
                  }
                }
              });
            };
            return filterSequence;
          }
          function countByFactory(iterable, grouper, context) {
            var groups = Map().asMutable();
            iterable.__iterate(function (v, k) {
              groups.update(grouper.call(context, v, k, iterable), 0, function (a) {
                return a + 1;
              });
            });
            return groups.asImmutable();
          }
          function groupByFactory(iterable, grouper, context) {
            var isKeyedIter = isKeyed(iterable);
            var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
            iterable.__iterate(function (v, k) {
              groups.update(grouper.call(context, v, k, iterable), function (a) {
                return a = a || [], a.push(isKeyedIter ? [k, v] : v), a;
              });
            });
            var coerce = iterableClass(iterable);
            return groups.map(function (arr) {
              return reify(iterable, coerce(arr));
            });
          }
          function sliceFactory(iterable, begin, end, useKeys) {
            var originalSize = iterable.size;

            // Sanitize begin & end using this shorthand for ToInt32(argument)
            // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
            if (begin !== undefined) {
              begin = begin | 0;
            }
            if (end !== undefined) {
              if (end === Infinity) {
                end = originalSize;
              } else {
                end = end | 0;
              }
            }
            if (wholeSlice(begin, end, originalSize)) {
              return iterable;
            }
            var resolvedBegin = resolveBegin(begin, originalSize);
            var resolvedEnd = resolveEnd(end, originalSize);

            // begin or end will be NaN if they were provided as negative numbers and
            // this iterable's size is unknown. In that case, cache first so there is
            // a known size and these do not resolve to NaN.
            if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
              return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
            }

            // Note: resolvedEnd is undefined when the original sequence's length is
            // unknown and this slice did not supply an end and should contain all
            // elements after resolvedBegin.
            // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
            var resolvedSize = resolvedEnd - resolvedBegin;
            var sliceSize;
            if (resolvedSize === resolvedSize) {
              sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
            }
            var sliceSeq = makeSequence(iterable);

            // If iterable.size is undefined, the size of the realized sliceSeq is
            // unknown at this point unless the number of items to slice is 0
            sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
            if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
              sliceSeq.get = function (index, notSetValue) {
                index = wrapIndex(this, index);
                return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
              };
            }
            sliceSeq.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              if (sliceSize === 0) {
                return 0;
              }
              if (reverse) {
                return this.cacheResult().__iterate(fn, reverse);
              }
              var skipped = 0;
              var isSkipping = true;
              var iterations = 0;
              iterable.__iterate(function (v, k) {
                if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                  iterations++;
                  return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
                }
              });
              return iterations;
            };
            sliceSeq.__iteratorUncached = function (type, reverse) {
              if (sliceSize !== 0 && reverse) {
                return this.cacheResult().__iterator(type, reverse);
              }
              // Don't bother instantiating parent iterator if taking 0.
              var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
              var skipped = 0;
              var iterations = 0;
              return new Iterator(function () {
                while (skipped++ < resolvedBegin) {
                  iterator.next();
                }
                if (++iterations > sliceSize) {
                  return iteratorDone();
                }
                var step = iterator.next();
                if (useKeys || type === ITERATE_VALUES) {
                  return step;
                } else if (type === ITERATE_KEYS) {
                  return iteratorValue(type, iterations - 1, undefined, step);
                } else {
                  return iteratorValue(type, iterations - 1, step.value[1], step);
                }
              });
            };
            return sliceSeq;
          }
          function takeWhileFactory(iterable, predicate, context) {
            var takeSequence = makeSequence(iterable);
            takeSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              if (reverse) {
                return this.cacheResult().__iterate(fn, reverse);
              }
              var iterations = 0;
              iterable.__iterate(function (v, k, c) {
                return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
              });
              return iterations;
            };
            takeSequence.__iteratorUncached = function (type, reverse) {
              var this$0 = this;
              if (reverse) {
                return this.cacheResult().__iterator(type, reverse);
              }
              var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
              var iterating = true;
              return new Iterator(function () {
                if (!iterating) {
                  return iteratorDone();
                }
                var step = iterator.next();
                if (step.done) {
                  return step;
                }
                var entry = step.value;
                var k = entry[0];
                var v = entry[1];
                if (!predicate.call(context, v, k, this$0)) {
                  iterating = false;
                  return iteratorDone();
                }
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
              });
            };
            return takeSequence;
          }
          function skipWhileFactory(iterable, predicate, context, useKeys) {
            var skipSequence = makeSequence(iterable);
            skipSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              if (reverse) {
                return this.cacheResult().__iterate(fn, reverse);
              }
              var isSkipping = true;
              var iterations = 0;
              iterable.__iterate(function (v, k, c) {
                if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                  iterations++;
                  return fn(v, useKeys ? k : iterations - 1, this$0);
                }
              });
              return iterations;
            };
            skipSequence.__iteratorUncached = function (type, reverse) {
              var this$0 = this;
              if (reverse) {
                return this.cacheResult().__iterator(type, reverse);
              }
              var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
              var skipping = true;
              var iterations = 0;
              return new Iterator(function () {
                var step, k, v;
                do {
                  step = iterator.next();
                  if (step.done) {
                    if (useKeys || type === ITERATE_VALUES) {
                      return step;
                    } else if (type === ITERATE_KEYS) {
                      return iteratorValue(type, iterations++, undefined, step);
                    } else {
                      return iteratorValue(type, iterations++, step.value[1], step);
                    }
                  }
                  var entry = step.value;
                  k = entry[0];
                  v = entry[1];
                  skipping && (skipping = predicate.call(context, v, k, this$0));
                } while (skipping);
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
              });
            };
            return skipSequence;
          }
          function concatFactory(iterable, values) {
            var isKeyedIterable = isKeyed(iterable);
            var iters = [iterable].concat(values).map(function (v) {
              if (!isIterable(v)) {
                v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
              } else if (isKeyedIterable) {
                v = KeyedIterable(v);
              }
              return v;
            }).filter(function (v) {
              return v.size !== 0;
            });
            if (iters.length === 0) {
              return iterable;
            }
            if (iters.length === 1) {
              var singleton = iters[0];
              if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) {
                return singleton;
              }
            }
            var concatSeq = new ArraySeq(iters);
            if (isKeyedIterable) {
              concatSeq = concatSeq.toKeyedSeq();
            } else if (!isIndexed(iterable)) {
              concatSeq = concatSeq.toSetSeq();
            }
            concatSeq = concatSeq.flatten(true);
            concatSeq.size = iters.reduce(function (sum, seq) {
              if (sum !== undefined) {
                var size = seq.size;
                if (size !== undefined) {
                  return sum + size;
                }
              }
            }, 0);
            return concatSeq;
          }
          function flattenFactory(iterable, depth, useKeys) {
            var flatSequence = makeSequence(iterable);
            flatSequence.__iterateUncached = function (fn, reverse) {
              var iterations = 0;
              var stopped = false;
              function flatDeep(iter, currentDepth) {
                var this$0 = this;
                iter.__iterate(function (v, k) {
                  if ((!depth || currentDepth < depth) && isIterable(v)) {
                    flatDeep(v, currentDepth + 1);
                  } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
                    stopped = true;
                  }
                  return !stopped;
                }, reverse);
              }
              flatDeep(iterable, 0);
              return iterations;
            };
            flatSequence.__iteratorUncached = function (type, reverse) {
              var iterator = iterable.__iterator(type, reverse);
              var stack = [];
              var iterations = 0;
              return new Iterator(function () {
                while (iterator) {
                  var step = iterator.next();
                  if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                  }
                  var v = step.value;
                  if (type === ITERATE_ENTRIES) {
                    v = v[1];
                  }
                  if ((!depth || stack.length < depth) && isIterable(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                  } else {
                    return useKeys ? step : iteratorValue(type, iterations++, v, step);
                  }
                }
                return iteratorDone();
              });
            };
            return flatSequence;
          }
          function flatMapFactory(iterable, mapper, context) {
            var coerce = iterableClass(iterable);
            return iterable.toSeq().map(function (v, k) {
              return coerce(mapper.call(context, v, k, iterable));
            }).flatten(true);
          }
          function interposeFactory(iterable, separator) {
            var interposedSequence = makeSequence(iterable);
            interposedSequence.size = iterable.size && iterable.size * 2 - 1;
            interposedSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              var iterations = 0;
              iterable.__iterate(function (v, k) {
                return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
              }, reverse);
              return iterations;
            };
            interposedSequence.__iteratorUncached = function (type, reverse) {
              var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
              var iterations = 0;
              var step;
              return new Iterator(function () {
                if (!step || iterations % 2) {
                  step = iterator.next();
                  if (step.done) {
                    return step;
                  }
                }
                return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
              });
            };
            return interposedSequence;
          }
          function sortFactory(iterable, comparator, mapper) {
            if (!comparator) {
              comparator = defaultComparator;
            }
            var isKeyedIterable = isKeyed(iterable);
            var index = 0;
            var entries = iterable.toSeq().map(function (v, k) {
              return [k, v, index++, mapper ? mapper(v, k, iterable) : v];
            }).toArray();
            entries.sort(function (a, b) {
              return comparator(a[3], b[3]) || a[2] - b[2];
            }).forEach(isKeyedIterable ? function (v, i) {
              entries[i].length = 2;
            } : function (v, i) {
              entries[i] = v[1];
            });
            return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
          }
          function maxFactory(iterable, comparator, mapper) {
            if (!comparator) {
              comparator = defaultComparator;
            }
            if (mapper) {
              var entry = iterable.toSeq().map(function (v, k) {
                return [v, mapper(v, k, iterable)];
              }).reduce(function (a, b) {
                return maxCompare(comparator, a[1], b[1]) ? b : a;
              });
              return entry && entry[0];
            } else {
              return iterable.reduce(function (a, b) {
                return maxCompare(comparator, a, b) ? b : a;
              });
            }
          }
          function maxCompare(comparator, a, b) {
            var comp = comparator(b, a);
            // b is considered the new max if the comparator declares them equal, but
            // they are not equal and b is in fact a nullish value.
            return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
          }
          function zipWithFactory(keyIter, zipper, iters) {
            var zipSequence = makeSequence(keyIter);
            zipSequence.size = new ArraySeq(iters).map(function (i) {
              return i.size;
            }).min();
            // Note: this a generic base implementation of __iterate in terms of
            // __iterator which may be more generically useful in the future.
            zipSequence.__iterate = function (fn, reverse) {
              /* generic:
              var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
              var step;
              var iterations = 0;
              while (!(step = iterator.next()).done) {
                iterations++;
                if (fn(step.value[1], step.value[0], this) === false) {
                  break;
                }
              }
              return iterations;
              */
              // indexed:
              var iterator = this.__iterator(ITERATE_VALUES, reverse);
              var step;
              var iterations = 0;
              while (!(step = iterator.next()).done) {
                if (fn(step.value, iterations++, this) === false) {
                  break;
                }
              }
              return iterations;
            };
            zipSequence.__iteratorUncached = function (type, reverse) {
              var iterators = iters.map(function (i) {
                return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
              });
              var iterations = 0;
              var isDone = false;
              return new Iterator(function () {
                var steps;
                if (!isDone) {
                  steps = iterators.map(function (i) {
                    return i.next();
                  });
                  isDone = steps.some(function (s) {
                    return s.done;
                  });
                }
                if (isDone) {
                  return iteratorDone();
                }
                return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function (s) {
                  return s.value;
                })));
              });
            };
            return zipSequence;
          }

          // #pragma Helper Functions

          function reify(iter, seq) {
            return isSeq(iter) ? seq : iter.constructor(seq);
          }
          function validateEntry(entry) {
            if (entry !== Object(entry)) {
              throw new TypeError('Expected [K, V] tuple: ' + entry);
            }
          }
          function resolveSize(iter) {
            assertNotInfinite(iter.size);
            return ensureSize(iter);
          }
          function iterableClass(iterable) {
            return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
          }
          function makeSequence(iterable) {
            return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
          }
          function cacheResultThrough() {
            if (this._iter.cacheResult) {
              this._iter.cacheResult();
              this.size = this._iter.size;
              return this;
            } else {
              return Seq.prototype.cacheResult.call(this);
            }
          }
          function defaultComparator(a, b) {
            return a > b ? 1 : a < b ? -1 : 0;
          }
          function forceIterator(keyPath) {
            var iter = getIterator(keyPath);
            if (!iter) {
              // Array might not be iterable in this environment, so we need a fallback
              // to our wrapped type.
              if (!isArrayLike(keyPath)) {
                throw new TypeError('Expected iterable or array-like: ' + keyPath);
              }
              iter = getIterator(Iterable(keyPath));
            }
            return iter;
          }
          createClass(Record, KeyedCollection);
          function Record(defaultValues, name) {
            var hasInitialized;
            var RecordType = function Record(values) {
              if (values instanceof RecordType) {
                return values;
              }
              if (!(this instanceof RecordType)) {
                return new RecordType(values);
              }
              if (!hasInitialized) {
                hasInitialized = true;
                var keys = Object.keys(defaultValues);
                setProps(RecordTypePrototype, keys);
                RecordTypePrototype.size = keys.length;
                RecordTypePrototype._name = name;
                RecordTypePrototype._keys = keys;
                RecordTypePrototype._defaultValues = defaultValues;
              }
              this._map = Map(values);
            };
            var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
            RecordTypePrototype.constructor = RecordType;
            return RecordType;
          }
          Record.prototype.toString = function () {
            return this.__toString(recordName(this) + ' {', '}');
          };

          // @pragma Access

          Record.prototype.has = function (k) {
            return this._defaultValues.hasOwnProperty(k);
          };
          Record.prototype.get = function (k, notSetValue) {
            if (!this.has(k)) {
              return notSetValue;
            }
            var defaultVal = this._defaultValues[k];
            return this._map ? this._map.get(k, defaultVal) : defaultVal;
          };

          // @pragma Modification

          Record.prototype.clear = function () {
            if (this.__ownerID) {
              this._map && this._map.clear();
              return this;
            }
            var RecordType = this.constructor;
            return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
          };
          Record.prototype.set = function (k, v) {
            if (!this.has(k)) {
              throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
            }
            if (this._map && !this._map.has(k)) {
              var defaultVal = this._defaultValues[k];
              if (v === defaultVal) {
                return this;
              }
            }
            var newMap = this._map && this._map.set(k, v);
            if (this.__ownerID || newMap === this._map) {
              return this;
            }
            return makeRecord(this, newMap);
          };
          Record.prototype.remove = function (k) {
            if (!this.has(k)) {
              return this;
            }
            var newMap = this._map && this._map.remove(k);
            if (this.__ownerID || newMap === this._map) {
              return this;
            }
            return makeRecord(this, newMap);
          };
          Record.prototype.wasAltered = function () {
            return this._map.wasAltered();
          };
          Record.prototype.__iterator = function (type, reverse) {
            var this$0 = this;
            return KeyedIterable(this._defaultValues).map(function (_, k) {
              return this$0.get(k);
            }).__iterator(type, reverse);
          };
          Record.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            return KeyedIterable(this._defaultValues).map(function (_, k) {
              return this$0.get(k);
            }).__iterate(fn, reverse);
          };
          Record.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            var newMap = this._map && this._map.__ensureOwner(ownerID);
            if (!ownerID) {
              this.__ownerID = ownerID;
              this._map = newMap;
              return this;
            }
            return makeRecord(this, newMap, ownerID);
          };
          var RecordPrototype = Record.prototype;
          RecordPrototype[DELETE] = RecordPrototype.remove;
          RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
          RecordPrototype.merge = MapPrototype.merge;
          RecordPrototype.mergeWith = MapPrototype.mergeWith;
          RecordPrototype.mergeIn = MapPrototype.mergeIn;
          RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
          RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
          RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
          RecordPrototype.setIn = MapPrototype.setIn;
          RecordPrototype.update = MapPrototype.update;
          RecordPrototype.updateIn = MapPrototype.updateIn;
          RecordPrototype.withMutations = MapPrototype.withMutations;
          RecordPrototype.asMutable = MapPrototype.asMutable;
          RecordPrototype.asImmutable = MapPrototype.asImmutable;
          function makeRecord(likeRecord, map, ownerID) {
            var record = Object.create(Object.getPrototypeOf(likeRecord));
            record._map = map;
            record.__ownerID = ownerID;
            return record;
          }
          function recordName(record) {
            return record._name || record.constructor.name || 'Record';
          }
          function setProps(prototype, names) {
            try {
              names.forEach(setProp.bind(undefined, prototype));
            } catch (error) {
              // Object.defineProperty failed. Probably IE8.
            }
          }
          function setProp(prototype, name) {
            Object.defineProperty(prototype, name, {
              get: function () {
                return this.get(name);
              },
              set: function (value) {
                invariant(this.__ownerID, 'Cannot set on an immutable record.');
                this.set(name, value);
              }
            });
          }
          createClass(Set, SetCollection);

          // @pragma Construction

          function Set(value) {
            return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function (set) {
              var iter = SetIterable(value);
              assertNotInfinite(iter.size);
              iter.forEach(function (v) {
                return set.add(v);
              });
            });
          }
          Set.of = function /*...values*/
          () {
            return this(arguments);
          };
          Set.fromKeys = function (value) {
            return this(KeyedIterable(value).keySeq());
          };
          Set.prototype.toString = function () {
            return this.__toString('Set {', '}');
          };

          // @pragma Access

          Set.prototype.has = function (value) {
            return this._map.has(value);
          };

          // @pragma Modification

          Set.prototype.add = function (value) {
            return updateSet(this, this._map.set(value, true));
          };
          Set.prototype.remove = function (value) {
            return updateSet(this, this._map.remove(value));
          };
          Set.prototype.clear = function () {
            return updateSet(this, this._map.clear());
          };

          // @pragma Composition

          Set.prototype.union = function () {
            var iters = SLICE$0.call(arguments, 0);
            iters = iters.filter(function (x) {
              return x.size !== 0;
            });
            if (iters.length === 0) {
              return this;
            }
            if (this.size === 0 && !this.__ownerID && iters.length === 1) {
              return this.constructor(iters[0]);
            }
            return this.withMutations(function (set) {
              for (var ii = 0; ii < iters.length; ii++) {
                SetIterable(iters[ii]).forEach(function (value) {
                  return set.add(value);
                });
              }
            });
          };
          Set.prototype.intersect = function () {
            var iters = SLICE$0.call(arguments, 0);
            if (iters.length === 0) {
              return this;
            }
            iters = iters.map(function (iter) {
              return SetIterable(iter);
            });
            var originalSet = this;
            return this.withMutations(function (set) {
              originalSet.forEach(function (value) {
                if (!iters.every(function (iter) {
                  return iter.includes(value);
                })) {
                  set.remove(value);
                }
              });
            });
          };
          Set.prototype.subtract = function () {
            var iters = SLICE$0.call(arguments, 0);
            if (iters.length === 0) {
              return this;
            }
            iters = iters.map(function (iter) {
              return SetIterable(iter);
            });
            var originalSet = this;
            return this.withMutations(function (set) {
              originalSet.forEach(function (value) {
                if (iters.some(function (iter) {
                  return iter.includes(value);
                })) {
                  set.remove(value);
                }
              });
            });
          };
          Set.prototype.merge = function () {
            return this.union.apply(this, arguments);
          };
          Set.prototype.mergeWith = function (merger) {
            var iters = SLICE$0.call(arguments, 1);
            return this.union.apply(this, iters);
          };
          Set.prototype.sort = function (comparator) {
            // Late binding
            return OrderedSet(sortFactory(this, comparator));
          };
          Set.prototype.sortBy = function (mapper, comparator) {
            // Late binding
            return OrderedSet(sortFactory(this, comparator, mapper));
          };
          Set.prototype.wasAltered = function () {
            return this._map.wasAltered();
          };
          Set.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            return this._map.__iterate(function (_, k) {
              return fn(k, k, this$0);
            }, reverse);
          };
          Set.prototype.__iterator = function (type, reverse) {
            return this._map.map(function (_, k) {
              return k;
            }).__iterator(type, reverse);
          };
          Set.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            var newMap = this._map.__ensureOwner(ownerID);
            if (!ownerID) {
              this.__ownerID = ownerID;
              this._map = newMap;
              return this;
            }
            return this.__make(newMap, ownerID);
          };
          function isSet(maybeSet) {
            return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
          }
          Set.isSet = isSet;
          var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
          var SetPrototype = Set.prototype;
          SetPrototype[IS_SET_SENTINEL] = true;
          SetPrototype[DELETE] = SetPrototype.remove;
          SetPrototype.mergeDeep = SetPrototype.merge;
          SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
          SetPrototype.withMutations = MapPrototype.withMutations;
          SetPrototype.asMutable = MapPrototype.asMutable;
          SetPrototype.asImmutable = MapPrototype.asImmutable;
          SetPrototype.__empty = emptySet;
          SetPrototype.__make = makeSet;
          function updateSet(set, newMap) {
            if (set.__ownerID) {
              set.size = newMap.size;
              set._map = newMap;
              return set;
            }
            return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
          }
          function makeSet(map, ownerID) {
            var set = Object.create(SetPrototype);
            set.size = map ? map.size : 0;
            set._map = map;
            set.__ownerID = ownerID;
            return set;
          }
          var EMPTY_SET;
          function emptySet() {
            return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
          }
          createClass(OrderedSet, Set);

          // @pragma Construction

          function OrderedSet(value) {
            return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function (set) {
              var iter = SetIterable(value);
              assertNotInfinite(iter.size);
              iter.forEach(function (v) {
                return set.add(v);
              });
            });
          }
          OrderedSet.of = function /*...values*/
          () {
            return this(arguments);
          };
          OrderedSet.fromKeys = function (value) {
            return this(KeyedIterable(value).keySeq());
          };
          OrderedSet.prototype.toString = function () {
            return this.__toString('OrderedSet {', '}');
          };
          function isOrderedSet(maybeOrderedSet) {
            return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
          }
          OrderedSet.isOrderedSet = isOrderedSet;
          var OrderedSetPrototype = OrderedSet.prototype;
          OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
          OrderedSetPrototype.__empty = emptyOrderedSet;
          OrderedSetPrototype.__make = makeOrderedSet;
          function makeOrderedSet(map, ownerID) {
            var set = Object.create(OrderedSetPrototype);
            set.size = map ? map.size : 0;
            set._map = map;
            set.__ownerID = ownerID;
            return set;
          }
          var EMPTY_ORDERED_SET;
          function emptyOrderedSet() {
            return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
          }
          createClass(Stack, IndexedCollection);

          // @pragma Construction

          function Stack(value) {
            return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
          }
          Stack.of = function /*...values*/
          () {
            return this(arguments);
          };
          Stack.prototype.toString = function () {
            return this.__toString('Stack [', ']');
          };

          // @pragma Access

          Stack.prototype.get = function (index, notSetValue) {
            var head = this._head;
            index = wrapIndex(this, index);
            while (head && index--) {
              head = head.next;
            }
            return head ? head.value : notSetValue;
          };
          Stack.prototype.peek = function () {
            return this._head && this._head.value;
          };

          // @pragma Modification

          Stack.prototype.push = function /*...values*/
          () {
            if (arguments.length === 0) {
              return this;
            }
            var newSize = this.size + arguments.length;
            var head = this._head;
            for (var ii = arguments.length - 1; ii >= 0; ii--) {
              head = {
                value: arguments[ii],
                next: head
              };
            }
            if (this.__ownerID) {
              this.size = newSize;
              this._head = head;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return makeStack(newSize, head);
          };
          Stack.prototype.pushAll = function (iter) {
            iter = IndexedIterable(iter);
            if (iter.size === 0) {
              return this;
            }
            assertNotInfinite(iter.size);
            var newSize = this.size;
            var head = this._head;
            iter.reverse().forEach(function (value) {
              newSize++;
              head = {
                value: value,
                next: head
              };
            });
            if (this.__ownerID) {
              this.size = newSize;
              this._head = head;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return makeStack(newSize, head);
          };
          Stack.prototype.pop = function () {
            return this.slice(1);
          };
          Stack.prototype.unshift = function /*...values*/
          () {
            return this.push.apply(this, arguments);
          };
          Stack.prototype.unshiftAll = function (iter) {
            return this.pushAll(iter);
          };
          Stack.prototype.shift = function () {
            return this.pop.apply(this, arguments);
          };
          Stack.prototype.clear = function () {
            if (this.size === 0) {
              return this;
            }
            if (this.__ownerID) {
              this.size = 0;
              this._head = undefined;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return emptyStack();
          };
          Stack.prototype.slice = function (begin, end) {
            if (wholeSlice(begin, end, this.size)) {
              return this;
            }
            var resolvedBegin = resolveBegin(begin, this.size);
            var resolvedEnd = resolveEnd(end, this.size);
            if (resolvedEnd !== this.size) {
              // super.slice(begin, end);
              return IndexedCollection.prototype.slice.call(this, begin, end);
            }
            var newSize = this.size - resolvedBegin;
            var head = this._head;
            while (resolvedBegin--) {
              head = head.next;
            }
            if (this.__ownerID) {
              this.size = newSize;
              this._head = head;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return makeStack(newSize, head);
          };

          // @pragma Mutability

          Stack.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            if (!ownerID) {
              this.__ownerID = ownerID;
              this.__altered = false;
              return this;
            }
            return makeStack(this.size, this._head, ownerID, this.__hash);
          };

          // @pragma Iteration

          Stack.prototype.__iterate = function (fn, reverse) {
            if (reverse) {
              return this.reverse().__iterate(fn);
            }
            var iterations = 0;
            var node = this._head;
            while (node) {
              if (fn(node.value, iterations++, this) === false) {
                break;
              }
              node = node.next;
            }
            return iterations;
          };
          Stack.prototype.__iterator = function (type, reverse) {
            if (reverse) {
              return this.reverse().__iterator(type);
            }
            var iterations = 0;
            var node = this._head;
            return new Iterator(function () {
              if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
              }
              return iteratorDone();
            });
          };
          function isStack(maybeStack) {
            return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
          }
          Stack.isStack = isStack;
          var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
          var StackPrototype = Stack.prototype;
          StackPrototype[IS_STACK_SENTINEL] = true;
          StackPrototype.withMutations = MapPrototype.withMutations;
          StackPrototype.asMutable = MapPrototype.asMutable;
          StackPrototype.asImmutable = MapPrototype.asImmutable;
          StackPrototype.wasAltered = MapPrototype.wasAltered;
          function makeStack(size, head, ownerID, hash) {
            var map = Object.create(StackPrototype);
            map.size = size;
            map._head = head;
            map.__ownerID = ownerID;
            map.__hash = hash;
            map.__altered = false;
            return map;
          }
          var EMPTY_STACK;
          function emptyStack() {
            return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
          }

          /**
           * Contributes additional methods to a constructor
           */
          function mixin(ctor, methods) {
            var keyCopier = function (key) {
              ctor.prototype[key] = methods[key];
            };
            Object.keys(methods).forEach(keyCopier);
            Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
            return ctor;
          }
          Iterable.Iterator = Iterator;
          mixin(Iterable, {
            // ### Conversion to other types

            toArray: function () {
              assertNotInfinite(this.size);
              var array = new Array(this.size || 0);
              this.valueSeq().__iterate(function (v, i) {
                array[i] = v;
              });
              return array;
            },
            toIndexedSeq: function () {
              return new ToIndexedSequence(this);
            },
            toJS: function () {
              return this.toSeq().map(function (value) {
                return value && typeof value.toJS === 'function' ? value.toJS() : value;
              }).__toJS();
            },
            toJSON: function () {
              return this.toSeq().map(function (value) {
                return value && typeof value.toJSON === 'function' ? value.toJSON() : value;
              }).__toJS();
            },
            toKeyedSeq: function () {
              return new ToKeyedSequence(this, true);
            },
            toMap: function () {
              // Use Late Binding here to solve the circular dependency.
              return Map(this.toKeyedSeq());
            },
            toObject: function () {
              assertNotInfinite(this.size);
              var object = {};
              this.__iterate(function (v, k) {
                object[k] = v;
              });
              return object;
            },
            toOrderedMap: function () {
              // Use Late Binding here to solve the circular dependency.
              return OrderedMap(this.toKeyedSeq());
            },
            toOrderedSet: function () {
              // Use Late Binding here to solve the circular dependency.
              return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
            },
            toSet: function () {
              // Use Late Binding here to solve the circular dependency.
              return Set(isKeyed(this) ? this.valueSeq() : this);
            },
            toSetSeq: function () {
              return new ToSetSequence(this);
            },
            toSeq: function () {
              return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
            },
            toStack: function () {
              // Use Late Binding here to solve the circular dependency.
              return Stack(isKeyed(this) ? this.valueSeq() : this);
            },
            toList: function () {
              // Use Late Binding here to solve the circular dependency.
              return List(isKeyed(this) ? this.valueSeq() : this);
            },
            // ### Common JavaScript methods and properties

            toString: function () {
              return '[Iterable]';
            },
            __toString: function (head, tail) {
              if (this.size === 0) {
                return head + tail;
              }
              return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
            },
            // ### ES6 Collection methods (ES6 Array and Map)

            concat: function () {
              var values = SLICE$0.call(arguments, 0);
              return reify(this, concatFactory(this, values));
            },
            includes: function (searchValue) {
              return this.some(function (value) {
                return is(value, searchValue);
              });
            },
            entries: function () {
              return this.__iterator(ITERATE_ENTRIES);
            },
            every: function (predicate, context) {
              assertNotInfinite(this.size);
              var returnValue = true;
              this.__iterate(function (v, k, c) {
                if (!predicate.call(context, v, k, c)) {
                  returnValue = false;
                  return false;
                }
              });
              return returnValue;
            },
            filter: function (predicate, context) {
              return reify(this, filterFactory(this, predicate, context, true));
            },
            find: function (predicate, context, notSetValue) {
              var entry = this.findEntry(predicate, context);
              return entry ? entry[1] : notSetValue;
            },
            forEach: function (sideEffect, context) {
              assertNotInfinite(this.size);
              return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
            },
            join: function (separator) {
              assertNotInfinite(this.size);
              separator = separator !== undefined ? '' + separator : ',';
              var joined = '';
              var isFirst = true;
              this.__iterate(function (v) {
                isFirst ? isFirst = false : joined += separator;
                joined += v !== null && v !== undefined ? v.toString() : '';
              });
              return joined;
            },
            keys: function () {
              return this.__iterator(ITERATE_KEYS);
            },
            map: function (mapper, context) {
              return reify(this, mapFactory(this, mapper, context));
            },
            reduce: function (reducer, initialReduction, context) {
              assertNotInfinite(this.size);
              var reduction;
              var useFirst;
              if (arguments.length < 2) {
                useFirst = true;
              } else {
                reduction = initialReduction;
              }
              this.__iterate(function (v, k, c) {
                if (useFirst) {
                  useFirst = false;
                  reduction = v;
                } else {
                  reduction = reducer.call(context, reduction, v, k, c);
                }
              });
              return reduction;
            },
            reduceRight: function (reducer, initialReduction, context) {
              var reversed = this.toKeyedSeq().reverse();
              return reversed.reduce.apply(reversed, arguments);
            },
            reverse: function () {
              return reify(this, reverseFactory(this, true));
            },
            slice: function (begin, end) {
              return reify(this, sliceFactory(this, begin, end, true));
            },
            some: function (predicate, context) {
              return !this.every(not(predicate), context);
            },
            sort: function (comparator) {
              return reify(this, sortFactory(this, comparator));
            },
            values: function () {
              return this.__iterator(ITERATE_VALUES);
            },
            // ### More sequential methods

            butLast: function () {
              return this.slice(0, -1);
            },
            isEmpty: function () {
              return this.size !== undefined ? this.size === 0 : !this.some(function () {
                return true;
              });
            },
            count: function (predicate, context) {
              return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
            },
            countBy: function (grouper, context) {
              return countByFactory(this, grouper, context);
            },
            equals: function (other) {
              return deepEqual(this, other);
            },
            entrySeq: function () {
              var iterable = this;
              if (iterable._cache) {
                // We cache as an entries array, so we can just return the cache!
                return new ArraySeq(iterable._cache);
              }
              var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
              entriesSequence.fromEntrySeq = function () {
                return iterable.toSeq();
              };
              return entriesSequence;
            },
            filterNot: function (predicate, context) {
              return this.filter(not(predicate), context);
            },
            findEntry: function (predicate, context, notSetValue) {
              var found = notSetValue;
              this.__iterate(function (v, k, c) {
                if (predicate.call(context, v, k, c)) {
                  found = [k, v];
                  return false;
                }
              });
              return found;
            },
            findKey: function (predicate, context) {
              var entry = this.findEntry(predicate, context);
              return entry && entry[0];
            },
            findLast: function (predicate, context, notSetValue) {
              return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
            },
            findLastEntry: function (predicate, context, notSetValue) {
              return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
            },
            findLastKey: function (predicate, context) {
              return this.toKeyedSeq().reverse().findKey(predicate, context);
            },
            first: function () {
              return this.find(returnTrue);
            },
            flatMap: function (mapper, context) {
              return reify(this, flatMapFactory(this, mapper, context));
            },
            flatten: function (depth) {
              return reify(this, flattenFactory(this, depth, true));
            },
            fromEntrySeq: function () {
              return new FromEntriesSequence(this);
            },
            get: function (searchKey, notSetValue) {
              return this.find(function (_, key) {
                return is(key, searchKey);
              }, undefined, notSetValue);
            },
            getIn: function (searchKeyPath, notSetValue) {
              var nested = this;
              // Note: in an ES6 environment, we would prefer:
              // for (var key of searchKeyPath) {
              var iter = forceIterator(searchKeyPath);
              var step;
              while (!(step = iter.next()).done) {
                var key = step.value;
                nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
                if (nested === NOT_SET) {
                  return notSetValue;
                }
              }
              return nested;
            },
            groupBy: function (grouper, context) {
              return groupByFactory(this, grouper, context);
            },
            has: function (searchKey) {
              return this.get(searchKey, NOT_SET) !== NOT_SET;
            },
            hasIn: function (searchKeyPath) {
              return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
            },
            isSubset: function (iter) {
              iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
              return this.every(function (value) {
                return iter.includes(value);
              });
            },
            isSuperset: function (iter) {
              iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
              return iter.isSubset(this);
            },
            keyOf: function (searchValue) {
              return this.findKey(function (value) {
                return is(value, searchValue);
              });
            },
            keySeq: function () {
              return this.toSeq().map(keyMapper).toIndexedSeq();
            },
            last: function () {
              return this.toSeq().reverse().first();
            },
            lastKeyOf: function (searchValue) {
              return this.toKeyedSeq().reverse().keyOf(searchValue);
            },
            max: function (comparator) {
              return maxFactory(this, comparator);
            },
            maxBy: function (mapper, comparator) {
              return maxFactory(this, comparator, mapper);
            },
            min: function (comparator) {
              return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
            },
            minBy: function (mapper, comparator) {
              return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
            },
            rest: function () {
              return this.slice(1);
            },
            skip: function (amount) {
              return this.slice(Math.max(0, amount));
            },
            skipLast: function (amount) {
              return reify(this, this.toSeq().reverse().skip(amount).reverse());
            },
            skipWhile: function (predicate, context) {
              return reify(this, skipWhileFactory(this, predicate, context, true));
            },
            skipUntil: function (predicate, context) {
              return this.skipWhile(not(predicate), context);
            },
            sortBy: function (mapper, comparator) {
              return reify(this, sortFactory(this, comparator, mapper));
            },
            take: function (amount) {
              return this.slice(0, Math.max(0, amount));
            },
            takeLast: function (amount) {
              return reify(this, this.toSeq().reverse().take(amount).reverse());
            },
            takeWhile: function (predicate, context) {
              return reify(this, takeWhileFactory(this, predicate, context));
            },
            takeUntil: function (predicate, context) {
              return this.takeWhile(not(predicate), context);
            },
            valueSeq: function () {
              return this.toIndexedSeq();
            },
            // ### Hashable Object

            hashCode: function () {
              return this.__hash || (this.__hash = hashIterable(this));
            }

            // ### Internal

            // abstract __iterate(fn, reverse)

            // abstract __iterator(type, reverse)
          });

          // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
          // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
          // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
          // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

          var IterablePrototype = Iterable.prototype;
          IterablePrototype[IS_ITERABLE_SENTINEL] = true;
          IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
          IterablePrototype.__toJS = IterablePrototype.toArray;
          IterablePrototype.__toStringMapper = quoteString;
          IterablePrototype.inspect = IterablePrototype.toSource = function () {
            return this.toString();
          };
          IterablePrototype.chain = IterablePrototype.flatMap;
          IterablePrototype.contains = IterablePrototype.includes;
          mixin(KeyedIterable, {
            // ### More sequential methods

            flip: function () {
              return reify(this, flipFactory(this));
            },
            mapEntries: function (mapper, context) {
              var this$0 = this;
              var iterations = 0;
              return reify(this, this.toSeq().map(function (v, k) {
                return mapper.call(context, [k, v], iterations++, this$0);
              }).fromEntrySeq());
            },
            mapKeys: function (mapper, context) {
              var this$0 = this;
              return reify(this, this.toSeq().flip().map(function (k, v) {
                return mapper.call(context, k, v, this$0);
              }).flip());
            }
          });
          var KeyedIterablePrototype = KeyedIterable.prototype;
          KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
          KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
          KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
          KeyedIterablePrototype.__toStringMapper = function (v, k) {
            return JSON.stringify(k) + ': ' + quoteString(v);
          };
          mixin(IndexedIterable, {
            // ### Conversion to other types

            toKeyedSeq: function () {
              return new ToKeyedSequence(this, false);
            },
            // ### ES6 Collection methods (ES6 Array and Map)

            filter: function (predicate, context) {
              return reify(this, filterFactory(this, predicate, context, false));
            },
            findIndex: function (predicate, context) {
              var entry = this.findEntry(predicate, context);
              return entry ? entry[0] : -1;
            },
            indexOf: function (searchValue) {
              var key = this.keyOf(searchValue);
              return key === undefined ? -1 : key;
            },
            lastIndexOf: function (searchValue) {
              var key = this.lastKeyOf(searchValue);
              return key === undefined ? -1 : key;
            },
            reverse: function () {
              return reify(this, reverseFactory(this, false));
            },
            slice: function (begin, end) {
              return reify(this, sliceFactory(this, begin, end, false));
            },
            splice: function (index, removeNum /*, ...values*/) {
              var numArgs = arguments.length;
              removeNum = Math.max(removeNum | 0, 0);
              if (numArgs === 0 || numArgs === 2 && !removeNum) {
                return this;
              }
              // If index is negative, it should resolve relative to the size of the
              // collection. However size may be expensive to compute if not cached, so
              // only call count() if the number is in fact negative.
              index = resolveBegin(index, index < 0 ? this.count() : this.size);
              var spliced = this.slice(0, index);
              return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
            },
            // ### More collection methods

            findLastIndex: function (predicate, context) {
              var entry = this.findLastEntry(predicate, context);
              return entry ? entry[0] : -1;
            },
            first: function () {
              return this.get(0);
            },
            flatten: function (depth) {
              return reify(this, flattenFactory(this, depth, false));
            },
            get: function (index, notSetValue) {
              index = wrapIndex(this, index);
              return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function (_, key) {
                return key === index;
              }, undefined, notSetValue);
            },
            has: function (index) {
              index = wrapIndex(this, index);
              return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
            },
            interpose: function (separator) {
              return reify(this, interposeFactory(this, separator));
            },
            interleave: function /*...iterables*/
            () {
              var iterables = [this].concat(arrCopy(arguments));
              var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
              var interleaved = zipped.flatten(true);
              if (zipped.size) {
                interleaved.size = zipped.size * iterables.length;
              }
              return reify(this, interleaved);
            },
            keySeq: function () {
              return Range(0, this.size);
            },
            last: function () {
              return this.get(-1);
            },
            skipWhile: function (predicate, context) {
              return reify(this, skipWhileFactory(this, predicate, context, false));
            },
            zip: function /*, ...iterables */
            () {
              var iterables = [this].concat(arrCopy(arguments));
              return reify(this, zipWithFactory(this, defaultZipper, iterables));
            },
            zipWith: function (zipper /*, ...iterables */) {
              var iterables = arrCopy(arguments);
              iterables[0] = this;
              return reify(this, zipWithFactory(this, zipper, iterables));
            }
          });
          IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
          IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
          mixin(SetIterable, {
            // ### ES6 Collection methods (ES6 Array and Map)

            get: function (value, notSetValue) {
              return this.has(value) ? value : notSetValue;
            },
            includes: function (value) {
              return this.has(value);
            },
            // ### More sequential methods

            keySeq: function () {
              return this.valueSeq();
            }
          });
          SetIterable.prototype.has = IterablePrototype.includes;
          SetIterable.prototype.contains = SetIterable.prototype.includes;

          // Mixin subclasses

          mixin(KeyedSeq, KeyedIterable.prototype);
          mixin(IndexedSeq, IndexedIterable.prototype);
          mixin(SetSeq, SetIterable.prototype);
          mixin(KeyedCollection, KeyedIterable.prototype);
          mixin(IndexedCollection, IndexedIterable.prototype);
          mixin(SetCollection, SetIterable.prototype);

          // #pragma Helper functions

          function keyMapper(v, k) {
            return k;
          }
          function entryMapper(v, k) {
            return [k, v];
          }
          function not(predicate) {
            return function () {
              return !predicate.apply(this, arguments);
            };
          }
          function neg(predicate) {
            return function () {
              return -predicate.apply(this, arguments);
            };
          }
          function quoteString(value) {
            return typeof value === 'string' ? JSON.stringify(value) : String(value);
          }
          function defaultZipper() {
            return arrCopy(arguments);
          }
          function defaultNegComparator(a, b) {
            return a < b ? 1 : a > b ? -1 : 0;
          }
          function hashIterable(iterable) {
            if (iterable.size === Infinity) {
              return 0;
            }
            var ordered = isOrdered(iterable);
            var keyed = isKeyed(iterable);
            var h = ordered ? 1 : 0;
            var size = iterable.__iterate(keyed ? ordered ? function (v, k) {
              h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
            } : function (v, k) {
              h = h + hashMerge(hash(v), hash(k)) | 0;
            } : ordered ? function (v) {
              h = 31 * h + hash(v) | 0;
            } : function (v) {
              h = h + hash(v) | 0;
            });
            return murmurHashOfSize(size, h);
          }
          function murmurHashOfSize(size, h) {
            h = imul(h, 0xCC9E2D51);
            h = imul(h << 15 | h >>> -15, 0x1B873593);
            h = imul(h << 13 | h >>> -13, 5);
            h = (h + 0xE6546B64 | 0) ^ size;
            h = imul(h ^ h >>> 16, 0x85EBCA6B);
            h = imul(h ^ h >>> 13, 0xC2B2AE35);
            h = smi(h ^ h >>> 16);
            return h;
          }
          function hashMerge(a, b) {
            return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
          }

          var Immutable = {
            Iterable: Iterable,
            Seq: Seq,
            Collection: Collection,
            Map: Map,
            OrderedMap: OrderedMap,
            List: List,
            Stack: Stack,
            Set: Set,
            OrderedSet: OrderedSet,
            Record: Record,
            Range: Range,
            Repeat: Repeat,
            is: is,
            fromJS: fromJS
          };
          return Immutable;
        });

        /***/
      }, /* 19 */
      /***/function (module, exports) {
        'use strict';

        var isFunction = function isFunction(functionToCheck) {
          var getType = {};
          return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
        };
        module.exports = isFunction;

        /***/
      }, /* 20 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(140);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      },,,,,,,,, /* 29 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(142);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      }, /* 30 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _keymirror = __webpack_require__(145);
        var _keymirror2 = _interopRequireDefault(_keymirror);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var constants = {
          UpdateActions: (0, _keymirror2['default'])({
            CELL_UPDATE: null,
            COLUMN_FILL: null,
            COPY_PASTE: null,
            CELL_DRAG: null
          }),
          DragItemTypes: {
            Column: 'column'
          },
          CellExpand: {
            DOWN_TRIANGLE: String.fromCharCode('9660'),
            RIGHT_TRIANGLE: String.fromCharCode('9654')
          }
        };
        module.exports = constants;

        /***/
      }, /* 31 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var shallowCloneObject = __webpack_require__(52);
        var sameColumn = __webpack_require__(108);
        var ColumnUtils = __webpack_require__(6);
        var getScrollbarSize = __webpack_require__(32);
        var isColumnsImmutable = __webpack_require__(54);
        function setColumnWidths(columns, totalWidth) {
          return columns.map(function (column) {
            var colInfo = Object.assign({}, column);
            if (column.width) {
              if (/^([0-9]+)%$/.exec(column.width.toString())) {
                colInfo.width = Math.floor(column.width / 100 * totalWidth);
              }
            }
            return colInfo;
          });
        }
        function setDefferedColumnWidths(columns, unallocatedWidth, minColumnWidth) {
          var defferedColumns = columns.filter(function (c) {
            return !c.width;
          });
          return columns.map(function (column) {
            if (!column.width && column.width !== 0) {
              if (unallocatedWidth <= 0) {
                column.width = minColumnWidth;
              } else {
                var columnWidth = Math.floor(unallocatedWidth / ColumnUtils.getSize(defferedColumns));
                if (columnWidth < minColumnWidth) {
                  column.width = minColumnWidth;
                } else {
                  column.width = columnWidth;
                }
              }
            }
            return column;
          });
        }
        function setColumnOffsets(columns) {
          var left = 0;
          return columns.map(function (column) {
            column.left = left;
            left += column.width;
            return column;
          });
        }

        /**
         * Update column metrics calculation.
         *
         * @param {ColumnMetricsType} metrics
         */
        function recalculate(metrics) {
          // compute width for columns which specify width
          var columns = setColumnWidths(metrics.columns, metrics.totalWidth);
          var unallocatedWidth = columns.filter(function (c) {
            return c.width;
          }).reduce(function (w, column) {
            return w - column.width;
          }, metrics.totalWidth);
          unallocatedWidth -= getScrollbarSize();
          var width = columns.filter(function (c) {
            return c.width;
          }).reduce(function (w, column) {
            return w + column.width;
          }, 0);

          // compute width for columns which doesn't specify width
          columns = setDefferedColumnWidths(columns, unallocatedWidth, metrics.minColumnWidth);

          // compute left offset
          columns = setColumnOffsets(columns);
          return {
            columns: columns,
            width: width,
            totalWidth: metrics.totalWidth,
            minColumnWidth: metrics.minColumnWidth
          };
        }

        /**
         * Update column metrics calculation by resizing a column.
         *
         * @param {ColumnMetricsType} metrics
         * @param {Column} column
         * @param {number} width
         */
        function resizeColumn(metrics, index, width) {
          var column = ColumnUtils.getColumn(metrics.columns, index);
          var metricsClone = shallowCloneObject(metrics);
          metricsClone.columns = metrics.columns.slice(0);
          var updatedColumn = shallowCloneObject(column);
          updatedColumn.width = Math.max(width, metricsClone.minColumnWidth);
          metricsClone = ColumnUtils.spliceColumn(metricsClone, index, updatedColumn);
          return recalculate(metricsClone);
        }
        function areColumnsImmutable(prevColumns, nextColumns) {
          return isColumnsImmutable(prevColumns) && isColumnsImmutable(nextColumns);
        }
        function compareEachColumn(prevColumns, nextColumns, isSameColumn) {
          var i = void 0;
          var len = void 0;
          var column = void 0;
          var prevColumnsByKey = {};
          var nextColumnsByKey = {};
          if (ColumnUtils.getSize(prevColumns) !== ColumnUtils.getSize(nextColumns)) {
            return false;
          }
          for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
            column = prevColumns[i];
            prevColumnsByKey[column.key] = column;
          }
          for (i = 0, len = ColumnUtils.getSize(nextColumns); i < len; i++) {
            column = nextColumns[i];
            nextColumnsByKey[column.key] = column;
            var prevColumn = prevColumnsByKey[column.key];
            if (prevColumn === undefined || !isSameColumn(prevColumn, column)) {
              return false;
            }
          }
          for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
            column = prevColumns[i];
            var nextColumn = nextColumnsByKey[column.key];
            if (nextColumn === undefined) {
              return false;
            }
          }
          return true;
        }
        function sameColumns(prevColumns, nextColumns, isSameColumn) {
          if (areColumnsImmutable(prevColumns, nextColumns)) {
            return prevColumns === nextColumns;
          }
          return compareEachColumn(prevColumns, nextColumns, isSameColumn);
        }
        module.exports = {
          recalculate: recalculate,
          resizeColumn: resizeColumn,
          sameColumn: sameColumn,
          sameColumns: sameColumns
        };

        /***/
      }, /* 32 */
      /***/function (module, exports) {
        'use strict';

        var size = void 0;
        function getScrollbarSize() {
          if (size === undefined) {
            var outer = document.createElement('div');
            outer.style.width = '50px';
            outer.style.height = '50px';
            outer.style.position = 'absolute';
            outer.style.top = '-200px';
            outer.style.left = '-200px';
            var inner = document.createElement('div');
            inner.style.height = '100px';
            inner.style.width = '100%';
            outer.appendChild(inner);
            document.body.appendChild(outer);
            var outerWidth = outer.clientWidth;
            outer.style.overflowY = 'scroll';
            var innerWidth = inner.clientWidth;
            document.body.removeChild(outer);
            size = outerWidth - innerWidth;
          }
          return size;
        }
        module.exports = getScrollbarSize;

        /***/
      },,,,, /* 37 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(138);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      },,, /* 40 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _underscore = __webpack_require__(78);
        var _underscore2 = _interopRequireDefault(_underscore);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _CellAction = __webpack_require__(105);
        var _CellAction2 = _interopRequireDefault(_CellAction);
        var _CellExpand = __webpack_require__(106);
        var _CellExpand2 = _interopRequireDefault(_CellExpand);
        var _ChildRowDeleteButton = __webpack_require__(107);
        var _ChildRowDeleteButton2 = _interopRequireDefault(_ChildRowDeleteButton);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var joinClasses = __webpack_require__(5);
        var EditorContainer = __webpack_require__(124);
        var ExcelColumn = __webpack_require__(12);
        var isFunction = __webpack_require__(19);
        var CellMetaDataShape = __webpack_require__(11);
        var SimpleCellFormatter = __webpack_require__(51);
        var ColumnUtils = __webpack_require__(6);
        var createObjectWithProperties = __webpack_require__(14);
        __webpack_require__(37);

        // The list of the propTypes that we want to include in the Cell div
        var knownDivPropertyKeys = ['height', 'tabIndex', 'value'];
        var Cell = function (_React$Component) {
          _inherits(Cell, _React$Component);
          function Cell() {
            var _temp, _this, _ret;
            _classCallCheck(this, Cell);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              isCellValueChanging: false,
              isLockChanging: false
            }, _this.onCellClick = function (e) {
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onCellClick && typeof meta.onCellClick === 'function') {
                meta.onCellClick({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx
                }, e);
              }
            }, _this.onCellFocus = function () {
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onCellFocus && typeof meta.onCellFocus === 'function') {
                meta.onCellFocus({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx
                });
              }
            }, _this.onCellContextMenu = function () {
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onCellContextMenu && typeof meta.onCellContextMenu === 'function') {
                meta.onCellContextMenu({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx
                });
              }
            }, _this.onCellDoubleClick = function (e) {
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onCellDoubleClick && typeof meta.onCellDoubleClick === 'function') {
                meta.onCellDoubleClick({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx
                }, e);
              }
            }, _this.onCellExpand = function (e) {
              e.stopPropagation();
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onCellExpand != null) {
                meta.onCellExpand({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx,
                  rowData: _this.props.rowData,
                  expandArgs: _this.props.expandableOptions
                });
              }
            }, _this.onCellKeyDown = function (e) {
              if (_this.canExpand() && e.key === 'Enter') {
                _this.onCellExpand(e);
              }
            }, _this.onDeleteSubRow = function () {
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onDeleteSubRow != null) {
                meta.onDeleteSubRow({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx,
                  rowData: _this.props.rowData,
                  expandArgs: _this.props.expandableOptions
                });
              }
            }, _this.onDragHandleDoubleClick = function (e) {
              e.stopPropagation();
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onDragHandleDoubleClick && typeof meta.onDragHandleDoubleClick === 'function') {
                meta.onDragHandleDoubleClick({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx,
                  rowData: _this.getRowData(),
                  e: e
                });
              }
            }, _this.onDragOver = function (e) {
              e.preventDefault();
            }, _this.getStyle = function () {
              var style = {
                position: 'absolute',
                width: _this.props.column.width,
                height: _this.props.height,
                left: _this.props.column.left
              };
              return style;
            }, _this.getFormatter = function () {
              var col = _this.props.column;
              if (_this.isActive()) {
                return React.createElement(EditorContainer, {
                  rowData: _this.getRowData(),
                  rowIdx: _this.props.rowIdx,
                  value: _this.props.value,
                  idx: _this.props.idx,
                  cellMetaData: _this.props.cellMetaData,
                  column: col,
                  height: _this.props.height
                });
              }
              return _this.props.column.formatter;
            }, _this.getRowData = function () {
              var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
              return props.rowData.toJSON ? props.rowData.toJSON() : props.rowData;
            }, _this.getFormatterDependencies = function () {
              // convention based method to get corresponding Id or Name of any Name or Id property
              if (typeof _this.props.column.getRowMetaData === 'function') {
                return _this.props.column.getRowMetaData(_this.getRowData(), _this.props.column);
              }
            }, _this.getCellClass = function () {
              var className = joinClasses(_this.props.column.cellClass, 'react-grid-Cell', _this.props.className, _this.props.column.locked ? 'react-grid-Cell--locked' : null);
              var extraClasses = joinClasses({
                'row-selected': _this.props.isRowSelected,
                editing: _this.isActive(),
                copied: _this.isCopied() || _this.wasDraggedOver() || _this.isDraggedOverUpwards() || _this.isDraggedOverDownwards(),
                'is-dragged-over-up': _this.isDraggedOverUpwards(),
                'is-dragged-over-down': _this.isDraggedOverDownwards(),
                'was-dragged-over': _this.wasDraggedOver(),
                'cell-tooltip': _this.props.tooltip ? true : false,
                'rdg-child-cell': _this.props.expandableOptions && _this.props.expandableOptions.subRowDetails && _this.props.expandableOptions.treeDepth > 0,
                'last-column': _this.props.column.isLastColumn
              });
              return joinClasses(className, extraClasses);
            }, _this.getUpdateCellClass = function () {
              return _this.props.column.getUpdateCellClass ? _this.props.column.getUpdateCellClass(_this.props.selectedColumn, _this.props.column, _this.state.isCellValueChanging) : '';
            }, _this.isColumnSelected = function () {
              var meta = _this.props.cellMetaData;
              if (meta == null) {
                return false;
              }
              return meta.selected && meta.selected.idx === _this.props.idx;
            }, _this.isSelected = function () {
              var meta = _this.props.cellMetaData;
              if (meta == null) {
                return false;
              }
              return meta.selected && meta.selected.rowIdx === _this.props.rowIdx && meta.selected.idx === _this.props.idx;
            }, _this.isActive = function () {
              var meta = _this.props.cellMetaData;
              if (meta == null) {
                return false;
              }
              return _this.isSelected() && meta.selected.active === true;
            }, _this.isCellSelectionChanging = function (nextProps) {
              var meta = _this.props.cellMetaData;
              if (meta == null) {
                return false;
              }
              var nextSelected = nextProps.cellMetaData.selected;
              if (meta.selected && nextSelected) {
                return _this.props.idx === nextSelected.idx || _this.props.idx === meta.selected.idx;
              }
              return true;
            }, _this.isCellSelectEnabled = function () {
              var meta = _this.props.cellMetaData;
              if (meta == null) {
                return false;
              }
              return meta.enableCellSelect;
            }, _this.hasChangedDependentValues = function (nextProps) {
              var currentColumn = _this.props.column;
              var hasChangedDependentValues = false;
              if (currentColumn.getRowMetaData) {
                var currentRowMetaData = currentColumn.getRowMetaData(_this.getRowData(), currentColumn);
                var nextColumn = nextProps.column;
                var nextRowMetaData = nextColumn.getRowMetaData(_this.getRowData(nextProps), nextColumn);
                hasChangedDependentValues = !_underscore2['default'].isEqual(currentRowMetaData, nextRowMetaData);
              }
              return hasChangedDependentValues;
            }, _this.applyUpdateClass = function () {
              var updateCellClass = _this.getUpdateCellClass();
              // -> removing the class
              if (updateCellClass != null && updateCellClass !== '') {
                var cellDOMNode = _this.node;
                if (cellDOMNode.classList) {
                  cellDOMNode.classList.remove(updateCellClass);
                  // -> and re-adding the class
                  cellDOMNode.classList.add(updateCellClass);
                } else if (cellDOMNode.className.indexOf(updateCellClass) === -1) {
                  // IE9 doesn't support classList, nor (I think) altering element.className
                  // without replacing it wholesale.
                  cellDOMNode.className = cellDOMNode.className + ' ' + updateCellClass;
                }
              }
            }, _this.setScrollLeft = function (scrollLeft) {
              var node = _this.node;
              if (node) {
                var transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
                node.style.webkitTransform = transform;
                node.style.transform = transform;
              }
            }, _this.removeScroll = function () {
              var node = _this.node;
              if (node) {
                node.style.webkitTransform = null;
                node.style.transform = null;
              }
            }, _this.isCopied = function () {
              var copied = _this.props.cellMetaData.copied;
              return copied && copied.rowIdx === _this.props.rowIdx && copied.idx === _this.props.idx;
            }, _this.isDraggedOver = function () {
              var dragged = _this.props.cellMetaData.dragged;
              return dragged && dragged.overRowIdx === _this.props.rowIdx && dragged.idx === _this.props.idx;
            }, _this.wasDraggedOver = function () {
              var dragged = _this.props.cellMetaData.dragged;
              return dragged && (dragged.overRowIdx < _this.props.rowIdx && _this.props.rowIdx < dragged.rowIdx || dragged.overRowIdx > _this.props.rowIdx && _this.props.rowIdx > dragged.rowIdx) && dragged.idx === _this.props.idx;
            }, _this.isDraggedCellChanging = function (nextProps) {
              var isChanging = void 0;
              var dragged = _this.props.cellMetaData.dragged;
              var nextDragged = nextProps.cellMetaData.dragged;
              if (dragged) {
                isChanging = nextDragged && _this.props.idx === nextDragged.idx || dragged && _this.props.idx === dragged.idx;
                return isChanging;
              }
              return false;
            }, _this.isCopyCellChanging = function (nextProps) {
              var isChanging = void 0;
              var copied = _this.props.cellMetaData.copied;
              var nextCopied = nextProps.cellMetaData.copied;
              if (copied) {
                isChanging = nextCopied && _this.props.idx === nextCopied.idx || copied && _this.props.idx === copied.idx;
                return isChanging;
              }
              return false;
            }, _this.isDraggedOverUpwards = function () {
              var dragged = _this.props.cellMetaData.dragged;
              return !_this.isSelected() && _this.isDraggedOver() && _this.props.rowIdx < dragged.rowIdx;
            }, _this.isDraggedOverDownwards = function () {
              var dragged = _this.props.cellMetaData.dragged;
              return !_this.isSelected() && _this.isDraggedOver() && _this.props.rowIdx > dragged.rowIdx;
            }, _this.isFocusedOnBody = function () {
              return document.activeElement == null || document.activeElement.nodeName && typeof document.activeElement.nodeName === 'string' && document.activeElement.nodeName.toLowerCase() === 'body';
            }, _this.isFocusedOnCell = function () {
              return document.activeElement && document.activeElement.className.indexOf('react-grid-Cell') !== -1;
            }, _this.checkFocus = function () {
              if (_this.isSelected() && !_this.isActive()) {
                if (_this.props.isScrolling && !_this.props.cellMetaData.isScrollingVerticallyWithKeyboard && !_this.props.cellMetaData.isScrollingHorizontallyWithKeyboard) {
                  return;
                }
                // If the enableCellAutoFocus is set in the ReactDataGrid props, it will allow the cell to take focus when the browser is focused on the body.
                // Otherwise, only focus to the current cell if the currently active node in the document is within the data grid.
                // Meaning focus should not be stolen from elements that the grid doesnt control.
                var cellAutoFocusEnabled = _this.props.cellMetaData && _this.props.cellMetaData.enableCellAutoFocus;
                var dataGridDOMNode = _this.props.cellMetaData && _this.props.cellMetaData.getDataGridDOMNode ? _this.props.cellMetaData.getDataGridDOMNode() : null;
                if (_this.isFocusedOnCell() || cellAutoFocusEnabled && _this.isFocusedOnBody() || dataGridDOMNode && dataGridDOMNode.contains(document.activeElement)) {
                  var cellDOMNode = _this.node;
                  if (cellDOMNode) {
                    cellDOMNode.focus();
                  }
                }
              }
            }, _this.canEdit = function () {
              return _this.props.column.editor != null || _this.props.column.editable;
            }, _this.canExpand = function () {
              return _this.props.expandableOptions && _this.props.expandableOptions.canExpand;
            }, _this.createColumEventCallBack = function (onColumnEvent, info) {
              return function (e) {
                onColumnEvent(e, info);
              };
            }, _this.createCellEventCallBack = function (gridEvent, columnEvent) {
              return function (e) {
                gridEvent(e);
                columnEvent(e);
              };
            }, _this.createEventDTO = function (gridEvents, columnEvents, onColumnEvent) {
              var allEvents = Object.assign({}, gridEvents);
              for (var eventKey in columnEvents) {
                if (columnEvents.hasOwnProperty(eventKey)) {
                  var event = columnEvents[event];
                  var eventInfo = {
                    idx: _this.props.idx,
                    rowIdx: _this.props.rowIdx,
                    rowId: _this.props.rowData[_this.props.cellMetaData.rowKey],
                    name: eventKey
                  };
                  var eventCallback = _this.createColumEventCallBack(onColumnEvent, eventInfo);
                  if (allEvents.hasOwnProperty(eventKey)) {
                    var currentEvent = allEvents[eventKey];
                    allEvents[eventKey] = _this.createCellEventCallBack(currentEvent, eventCallback);
                  } else {
                    allEvents[eventKey] = eventCallback;
                  }
                }
              }
              return allEvents;
            }, _this.getEvents = function () {
              var columnEvents = _this.props.column ? Object.assign({}, _this.props.column.events) : undefined;
              var onColumnEvent = _this.props.cellMetaData ? _this.props.cellMetaData.onColumnEvent : undefined;
              var gridEvents = {
                onClick: _this.onCellClick,
                onFocus: _this.onCellFocus,
                onDoubleClick: _this.onCellDoubleClick,
                onContextMenu: _this.onCellContextMenu,
                onDragOver: _this.onDragOver
              };
              if (!columnEvents || !onColumnEvent) {
                return gridEvents;
              }
              return _this.createEventDTO(gridEvents, columnEvents, onColumnEvent);
            }, _this.getKnownDivProps = function () {
              return createObjectWithProperties(_this.props, knownDivPropertyKeys);
            }, _this.renderCellContent = function (props) {
              var CellContent = void 0;
              var Formatter = _this.getFormatter();
              if (React.isValidElement(Formatter)) {
                props.dependentValues = _this.getFormatterDependencies();
                CellContent = React.cloneElement(Formatter, props);
              } else if (isFunction(Formatter)) {
                CellContent = React.createElement(Formatter, {
                  value: _this.props.value,
                  dependentValues: _this.getFormatterDependencies()
                });
              } else {
                CellContent = React.createElement(SimpleCellFormatter, {
                  value: _this.props.value
                });
              }
              var isExpandCell = _this.props.expandableOptions ? _this.props.expandableOptions.field === _this.props.column.key : false;
              var treeDepth = _this.props.expandableOptions ? _this.props.expandableOptions.treeDepth : 0;
              var marginLeft = _this.props.expandableOptions && isExpandCell ? _this.props.expandableOptions.treeDepth * 30 : 0;
              var cellExpander = void 0;
              var cellDeleter = void 0;
              if (_this.canExpand()) {
                cellExpander = React.createElement(_CellExpand2['default'], {
                  expandableOptions: _this.props.expandableOptions,
                  onCellExpand: _this.onCellExpand
                });
              }
              var isDeleteSubRowEnabled = _this.props.cellMetaData.onDeleteSubRow ? true : false;
              if (treeDepth > 0 && isExpandCell) {
                cellDeleter = React.createElement(_ChildRowDeleteButton2['default'], {
                  treeDepth: treeDepth,
                  cellHeight: _this.props.height,
                  siblingIndex: _this.props.expandableOptions.subRowDetails.siblingIndex,
                  numberSiblings: _this.props.expandableOptions.subRowDetails.numberSiblings,
                  onDeleteSubRow: _this.onDeleteSubRow,
                  isDeleteSubRowEnabled: isDeleteSubRowEnabled
                });
              }
              return React.createElement('div', {
                className: 'react-grid-Cell__value'
              }, cellDeleter, React.createElement('div', {
                style: {
                  marginLeft: marginLeft
                }
              }, React.createElement('span', null, CellContent), ' ', _this.props.cellControls, ' ', cellExpander));
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Cell.prototype.componentDidMount = function componentDidMount() {
            this.checkFocus();
          };
          Cell.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            this.setState({
              isCellValueChanging: this.props.isCellValueChanging(this.props.value, nextProps.value),
              isLockChanging: this.props.column.locked !== nextProps.column.locked
            });
          };
          Cell.prototype.componentDidUpdate = function componentDidUpdate() {
            this.checkFocus();
            var dragged = this.props.cellMetaData.dragged;
            if (dragged && dragged.complete === true) {
              this.props.cellMetaData.handleTerminateDrag();
            }
            if (this.state.isCellValueChanging && this.props.selectedColumn != null) {
              this.applyUpdateClass();
            }
            if (this.state.isLockChanging && !this.props.column.locked) {
              this.removeScroll();
            }
          };
          Cell.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            var shouldUpdate = this.props.column.width !== nextProps.column.width || this.props.column.left !== nextProps.column.left || this.props.column.cellClass !== nextProps.column.cellClass || this.props.height !== nextProps.height || this.props.rowIdx !== nextProps.rowIdx || this.isCellSelectionChanging(nextProps) || this.isDraggedCellChanging(nextProps) || this.isCopyCellChanging(nextProps) || this.props.isRowSelected !== nextProps.isRowSelected || this.isSelected() || this.props.isCellValueChanging(this.props.value, nextProps.value) || this.props.forceUpdate === true || this.props.className !== nextProps.className || this.props.expandableOptions !== nextProps.expandableOptions || this.hasChangedDependentValues(nextProps) || this.props.column.locked !== nextProps.column.locked;
            return shouldUpdate;
          };
          Cell.prototype.getCellActions = function getCellActions() {
            var _props = this.props,
              cellMetaData = _props.cellMetaData,
              column = _props.column,
              rowData = _props.rowData;
            if (cellMetaData && cellMetaData.getCellActions) {
              var cellActions = cellMetaData.getCellActions(column, rowData);
              if (cellActions && cellActions.length) {
                return cellActions.map(function (action, index) {
                  return React.createElement(_CellAction2['default'], {
                    key: index,
                    action: action,
                    isFirst: index === 0
                  });
                });
              }
              return null;
            }
            return null;
          };
          Cell.prototype.render = function render() {
            var _this2 = this;
            if (this.props.column.hidden) {
              return null;
            }
            var style = this.getStyle();
            var className = this.getCellClass();
            var cellActions = this.getCellActions();
            var cellContent = this.props.children || this.renderCellContent({
              value: this.props.value,
              column: this.props.column,
              rowIdx: this.props.rowIdx,
              isExpanded: this.props.isExpanded
            });
            var dragHandle = !this.isActive() && ColumnUtils.canEdit(this.props.column, this.props.rowData, this.props.cellMetaData.enableCellSelect) ? React.createElement('div', {
              className: 'drag-handle',
              draggable: 'true',
              onDoubleClick: this.onDragHandleDoubleClick
            }, React.createElement('span', {
              style: {
                display: 'none'
              }
            })) : null;
            var events = this.getEvents();
            var tooltip = this.props.tooltip ? React.createElement('span', {
              className: 'cell-tooltip-text'
            }, this.props.tooltip) : null;
            return React.createElement('div', _extends({}, this.getKnownDivProps(), {
              className: className,
              style: style
            }, events, {
              ref: function ref(node) {
                _this2.node = node;
              }
            }), cellActions, cellContent, dragHandle, tooltip);
          };
          return Cell;
        }(React.Component);
        Cell.propTypes = {
          rowIdx: _propTypes2['default'].number.isRequired,
          idx: _propTypes2['default'].number.isRequired,
          selected: _propTypes2['default'].shape({
            idx: _propTypes2['default'].number.isRequired
          }),
          selectedColumn: _propTypes2['default'].object,
          height: _propTypes2['default'].number,
          tabIndex: _propTypes2['default'].number,
          column: _propTypes2['default'].shape(ExcelColumn).isRequired,
          value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].object, _propTypes2['default'].bool]),
          isExpanded: _propTypes2['default'].bool,
          isRowSelected: _propTypes2['default'].bool,
          cellMetaData: _propTypes2['default'].shape(CellMetaDataShape).isRequired,
          handleDragStart: _propTypes2['default'].func,
          className: _propTypes2['default'].string,
          cellControls: _propTypes2['default'].any,
          rowData: _propTypes2['default'].object.isRequired,
          forceUpdate: _propTypes2['default'].bool,
          expandableOptions: _propTypes2['default'].object.isRequired,
          isScrolling: _propTypes2['default'].bool.isRequired,
          tooltip: _propTypes2['default'].string,
          isCellValueChanging: _propTypes2['default'].func,
          children: _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(_propTypes2['default'].node), _propTypes2['default'].node])
        };
        Cell.defaultProps = {
          tabIndex: 0,
          isExpanded: false,
          value: '',
          isCellValueChanging: function isCellValueChanging(value, nextValue) {
            return value !== nextValue;
          }
        };
        module.exports = Cell;

        /***/
      }, /* 41 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var ReactDOM = __webpack_require__(9);
        var joinClasses = __webpack_require__(5);
        var ExcelColumn = __webpack_require__(12);
        var ResizeHandle = __webpack_require__(120);
        __webpack_require__(15);
        function simpleCellRenderer(objArgs) {
          var headerText = objArgs.column.rowType === 'header' ? objArgs.column.name : '';
          return React.createElement('div', {
            className: 'widget-HeaderCell__value'
          }, headerText);
        }
        var HeaderCell = function (_React$Component) {
          _inherits(HeaderCell, _React$Component);
          function HeaderCell() {
            var _temp, _this, _ret;
            _classCallCheck(this, HeaderCell);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              resizing: false
            }, _this.onDragStart = function (e) {
              _this.setState({
                resizing: true
              });
              // need to set dummy data for FF
              if (e && e.dataTransfer && e.dataTransfer.setData) e.dataTransfer.setData('text/plain', 'dummy');
            }, _this.onDrag = function (e) {
              var resize = _this.props.onResize || null; // for flows sake, doesnt recognise a null check direct
              if (resize) {
                var _width = _this.getWidthFromMouseEvent(e);
                if (_width > 0) {
                  resize(_this.props.column, _width);
                }
              }
            }, _this.onDragEnd = function (e) {
              var width = _this.getWidthFromMouseEvent(e);
              _this.props.onResizeEnd(_this.props.column, width);
              _this.setState({
                resizing: false
              });
            }, _this.getWidthFromMouseEvent = function (e) {
              var right = e.pageX || e.touches && e.touches[0] && e.touches[0].pageX || e.changedTouches && e.changedTouches[e.changedTouches.length - 1].pageX;
              var left = ReactDOM.findDOMNode(_this).getBoundingClientRect().left;
              return right - left;
            }, _this.getCell = function () {
              if (React.isValidElement(_this.props.renderer)) {
                // if it is a string, it's an HTML element, and column is not a valid property, so only pass height
                if (typeof _this.props.renderer.type === 'string') {
                  return React.cloneElement(_this.props.renderer, {
                    height: _this.props.height
                  });
                }
                return React.cloneElement(_this.props.renderer, {
                  column: _this.props.column,
                  height: _this.props.height
                });
              }
              return _this.props.renderer({
                column: _this.props.column
              });
            }, _this.getStyle = function () {
              return {
                width: _this.props.column.width,
                left: _this.props.column.left,
                display: 'inline-block',
                position: 'absolute',
                height: _this.props.height,
                margin: 0,
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              };
            }, _this.setScrollLeft = function (scrollLeft) {
              var node = ReactDOM.findDOMNode(_this);
              node.style.webkitTransform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
              node.style.transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
            }, _this.removeScroll = function () {
              var node = ReactDOM.findDOMNode(_this);
              if (node) {
                var transform = 'none';
                node.style.webkitTransform = transform;
                node.style.transform = transform;
              }
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          HeaderCell.prototype.render = function render() {
            var resizeHandle = void 0;
            if (this.props.column.resizable) {
              resizeHandle = React.createElement(ResizeHandle, {
                onDrag: this.onDrag,
                onDragStart: this.onDragStart,
                onDragEnd: this.onDragEnd
              });
            }
            var className = joinClasses({
              'react-grid-HeaderCell': true,
              'react-grid-HeaderCell--resizing': this.state.resizing,
              'react-grid-HeaderCell--locked': this.props.column.locked
            });
            className = joinClasses(className, this.props.className, this.props.column.cellClass);
            var cell = this.getCell();
            return React.createElement('div', {
              className: className,
              style: this.getStyle()
            }, cell, resizeHandle);
          };
          return HeaderCell;
        }(React.Component);
        HeaderCell.propTypes = {
          renderer: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].element]).isRequired,
          column: _propTypes2['default'].shape(ExcelColumn).isRequired,
          onResize: _propTypes2['default'].func.isRequired,
          height: _propTypes2['default'].number.isRequired,
          onResizeEnd: _propTypes2['default'].func.isRequired,
          className: _propTypes2['default'].string
        };
        HeaderCell.defaultProps = {
          renderer: simpleCellRenderer
        };
        module.exports = HeaderCell;

        /***/
      }, /* 42 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _OverflowCell = __webpack_require__(116);
        var _OverflowCell2 = _interopRequireDefault(_OverflowCell);
        var _RowComparer = __webpack_require__(43);
        var _RowComparer2 = _interopRequireDefault(_RowComparer);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var joinClasses = __webpack_require__(5);
        var Cell = __webpack_require__(40);
        var columnUtils = __webpack_require__(6);
        var cellMetaDataShape = __webpack_require__(11);
        var createObjectWithProperties = __webpack_require__(14);
        __webpack_require__(29);
        var CellExpander = function (_React$Component) {
          _inherits(CellExpander, _React$Component);
          function CellExpander() {
            _classCallCheck(this, CellExpander);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          CellExpander.prototype.render = function render() {
            return React.createElement(Cell, this.props);
          };
          return CellExpander;
        }(React.Component);

        // The list of the propTypes that we want to include in the Row div

        var knownDivPropertyKeys = ['height'];
        var Row = function (_React$Component2) {
          _inherits(Row, _React$Component2);
          function Row() {
            var _temp, _this2, _ret;
            _classCallCheck(this, Row);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this2), _this2.handleDragEnter = function () {
              var handleDragEnterRow = _this2.props.cellMetaData.handleDragEnterRow;
              if (handleDragEnterRow) {
                handleDragEnterRow(_this2.props.idx);
              }
            }, _this2.getSelectedColumn = function () {
              if (_this2.props.cellMetaData) {
                var selected = _this2.props.cellMetaData.selected;
                if (selected && selected.idx) {
                  return columnUtils.getColumn(_this2.props.columns, selected.idx);
                }
              }
            }, _this2.getCellRenderer = function (columnKey) {
              var CellRenderer = _this2.props.cellRenderer;
              if (_this2.props.subRowDetails && _this2.props.subRowDetails.field === columnKey) {
                return CellExpander;
              }
              return CellRenderer;
            }, _this2.getCell = function (column, i, selectedColumn) {
              var CellRenderer = _this2.props.cellRenderer;
              var _this2$props = _this2.props,
                colVisibleStart = _this2$props.colVisibleStart,
                colVisibleEnd = _this2$props.colVisibleEnd,
                idx = _this2$props.idx,
                cellMetaData = _this2$props.cellMetaData;
              var key = column.key,
                formatter = column.formatter,
                locked = column.locked;
              var baseCellProps = {
                key: key + '-' + idx,
                idx: i,
                rowIdx: idx,
                height: _this2.getRowHeight(),
                column: column,
                cellMetaData: cellMetaData
              };
              if ((i < colVisibleStart || i > colVisibleEnd) && !locked) {
                return React.createElement(_OverflowCell2['default'], _extends({
                  ref: function ref(node) {
                    return _this2[key] = node;
                  }
                }, baseCellProps));
              }
              var _this2$props2 = _this2.props,
                row = _this2$props2.row,
                isSelected = _this2$props2.isSelected;
              var cellProps = {
                ref: function ref(node) {
                  return _this2[key] = node;
                },
                value: _this2.getCellValue(key || i),
                rowData: row,
                isRowSelected: isSelected,
                expandableOptions: _this2.getExpandableOptions(key),
                selectedColumn: selectedColumn,
                formatter: formatter,
                isScrolling: _this2.props.isScrolling
              };
              return React.createElement(CellRenderer, _extends({}, baseCellProps, cellProps));
            }, _this2.getCells = function () {
              var cells = [];
              var lockedCells = [];
              var selectedColumn = _this2.getSelectedColumn();
              var lastColumnIdx = _this2.props.columns.size - 1;
              if (_this2.props.columns) {
                _this2.props.columns.forEach(function (column, i) {
                  if (i === lastColumnIdx) {
                    column.isLastColumn = true;
                  }
                  var cell = _this2.getCell(column, i, selectedColumn);
                  if (column.locked) {
                    lockedCells.push(cell);
                  } else {
                    cells.push(cell);
                  }
                });
              }
              return cells.concat(lockedCells);
            }, _this2.getRowHeight = function () {
              var rows = _this2.props.expandedRows || null;
              if (rows && _this2.props.idx) {
                var row = rows[_this2.props.idx] || null;
                if (row) {
                  return row.height;
                }
              }
              return _this2.props.height;
            }, _this2.getCellValue = function (key) {
              var val = void 0;
              if (key === 'select-row') {
                return _this2.props.isSelected;
              } else if (typeof _this2.props.row.get === 'function') {
                val = _this2.props.row.get(key);
              } else {
                val = _this2.props.row[key];
              }
              return val;
            }, _this2.isContextMenuDisplayed = function () {
              if (_this2.props.cellMetaData) {
                var selected = _this2.props.cellMetaData.selected;
                if (selected && selected.contextMenuDisplayed && selected.rowIdx === _this2.props.idx) {
                  return true;
                }
              }
              return false;
            }, _this2.getExpandableOptions = function (columnKey) {
              var subRowDetails = _this2.props.subRowDetails;
              if (subRowDetails) {
                return {
                  canExpand: subRowDetails && subRowDetails.field === columnKey && (subRowDetails.children && subRowDetails.children.length > 0 || subRowDetails.group === true),
                  field: subRowDetails.field,
                  expanded: subRowDetails && subRowDetails.expanded,
                  children: subRowDetails && subRowDetails.children,
                  treeDepth: subRowDetails ? subRowDetails.treeDepth : 0,
                  subRowDetails: subRowDetails
                };
              }
              return {};
            }, _this2.setScrollLeft = function (scrollLeft) {
              _this2.props.columns.forEach(function (column) {
                if (column.locked) {
                  if (!_this2[column.key]) return;
                  _this2[column.key].setScrollLeft(scrollLeft);
                }
              });
            }, _this2.getKnownDivProps = function () {
              return createObjectWithProperties(_this2.props, knownDivPropertyKeys);
            }, _this2.renderCell = function (props) {
              if (typeof _this2.props.cellRenderer === 'function') {
                _this2.props.cellRenderer.call(_this2, props);
              }
              if (React.isValidElement(_this2.props.cellRenderer)) {
                return React.cloneElement(_this2.props.cellRenderer, props);
              }
              return _this2.props.cellRenderer(props);
            }, _temp), _possibleConstructorReturn(_this2, _ret);
          }
          Row.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return (0, _RowComparer2['default'])(nextProps, this.props);
          };
          Row.prototype.render = function render() {
            var className = joinClasses('react-grid-Row', 'react-grid-Row--' + (this.props.idx % 2 === 0 ? 'even' : 'odd'), {
              'row-selected': this.props.isSelected,
              'row-context-menu': this.isContextMenuDisplayed()
            }, this.props.extraClasses);
            var style = {
              height: this.getRowHeight(this.props),
              overflow: 'hidden'
            };
            var cells = this.getCells();
            return React.createElement('div', _extends({}, this.getKnownDivProps(), {
              className: className,
              style: style,
              onDragEnter: this.handleDragEnter
            }), React.isValidElement(this.props.row) ? this.props.row : cells);
          };
          return Row;
        }(React.Component);
        Row.displayName = 'Row';
        Row.propTypes = {
          height: _propTypes2['default'].number.isRequired,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
          row: _propTypes2['default'].any.isRequired,
          cellRenderer: _propTypes2['default'].func,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
          isSelected: _propTypes2['default'].bool,
          idx: _propTypes2['default'].number.isRequired,
          expandedRows: _propTypes2['default'].arrayOf(_propTypes2['default'].object),
          extraClasses: _propTypes2['default'].string,
          forceUpdate: _propTypes2['default'].bool,
          subRowDetails: _propTypes2['default'].object,
          isRowHovered: _propTypes2['default'].bool,
          colVisibleStart: _propTypes2['default'].number.isRequired,
          colVisibleEnd: _propTypes2['default'].number.isRequired,
          colDisplayStart: _propTypes2['default'].number.isRequired,
          colDisplayEnd: _propTypes2['default'].number.isRequired,
          isScrolling: _propTypes2['default'].bool.isRequired
        };
        Row.defaultProps = {
          cellRenderer: Cell,
          isSelected: false,
          height: 35
        };
        module.exports = Row;

        /***/
      }, /* 43 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        exports.shouldRowUpdate = undefined;
        var _ColumnMetrics = __webpack_require__(31);
        var _ColumnMetrics2 = _interopRequireDefault(_ColumnMetrics);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function doesRowContainSelectedCell(props) {
          var selected = props.cellMetaData.selected;
          if (selected && selected.rowIdx === props.idx) {
            return true;
          }
          return false;
        }
        function willRowBeDraggedOver(props) {
          var dragged = props.cellMetaData.dragged;
          return dragged != null && (dragged.rowIdx >= 0 || dragged.complete === true);
        }
        function hasRowBeenCopied(props) {
          var copied = props.cellMetaData.copied;
          return copied != null && copied.rowIdx === props.idx;
        }
        var shouldRowUpdate = exports.shouldRowUpdate = function shouldRowUpdate(nextProps, currentProps) {
          return !_ColumnMetrics2['default'].sameColumns(currentProps.columns, nextProps.columns, _ColumnMetrics2['default'].sameColumn) || doesRowContainSelectedCell(currentProps) || doesRowContainSelectedCell(nextProps) || willRowBeDraggedOver(nextProps) || nextProps.row !== currentProps.row || currentProps.colDisplayStart !== nextProps.colDisplayStart || currentProps.colDisplayEnd !== nextProps.colDisplayEnd || currentProps.colVisibleStart !== nextProps.colVisibleStart || currentProps.colVisibleEnd !== nextProps.colVisibleEnd || hasRowBeenCopied(currentProps) || currentProps.isSelected !== nextProps.isSelected || nextProps.height !== currentProps.height || currentProps.isOver !== nextProps.isOver || currentProps.expandedRows !== nextProps.expandedRows || currentProps.canDrop !== nextProps.canDrop || currentProps.forceUpdate === true || currentProps.extraClasses !== nextProps.extraClasses;
        };
        exports['default'] = shouldRowUpdate;

        /***/
      }, /* 44 */
      /***/function (module, exports) {
        'use strict';

        var RowUtils = {
          get: function get(row, property) {
            if (typeof row.get === 'function') {
              return row.get(property);
            }
            return row[property];
          },
          isRowSelected: function isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx) {
            if (indexes && Object.prototype.toString.call(indexes) === '[object Array]') {
              return indexes.indexOf(rowIdx) > -1;
            } else if (keys && keys.rowKey && keys.values && Object.prototype.toString.call(keys.values) === '[object Array]') {
              return keys.values.indexOf(rowData[keys.rowKey]) > -1;
            } else if (isSelectedKey && rowData && typeof isSelectedKey === 'string') {
              return rowData[isSelectedKey];
            }
            return false;
          }
        };
        module.exports = RowUtils;

        /***/
      }, /* 45 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        exports.SimpleRowsContainer = exports.getNewContextMenuProps = exports.DEFAULT_CONTEXT_MENU_ID = undefined;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var DEFAULT_CONTEXT_MENU_ID = exports.DEFAULT_CONTEXT_MENU_ID = 'rgdContextMenu';
        var SimpleRowsContainer = function SimpleRowsContainer(props) {
          return _react2['default'].createElement('div', {
            key: 'rows-container'
          }, props.rows);
        };
        SimpleRowsContainer.propTypes = {
          width: _propTypes2['default'].number,
          rows: _propTypes2['default'].array
        };
        var getNewContextMenuProps = exports.getNewContextMenuProps = function getNewContextMenuProps(_ref) {
          var contextMenu = _ref.contextMenu,
            rowIdx = _ref.rowIdx,
            idx = _ref.idx;
          return {
            rowIdx: rowIdx,
            idx: idx,
            id: contextMenu.props.id || DEFAULT_CONTEXT_MENU_ID
          };
        };
        var RowsContainer = function (_React$Component) {
          _inherits(RowsContainer, _React$Component);
          function RowsContainer(props) {
            _classCallCheck(this, RowsContainer);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.plugins = props.window ? props.window.ReactDataGridPlugins : window.ReactDataGridPlugins;
            return _this;
          }
          RowsContainer.prototype.validatePlugin = function validatePlugin() {
            if (!this.plugins) {
              throw new Error('You need to include ReactDataGrid UiPlugins in order to initialise context menu');
            }
          };
          RowsContainer.prototype.hasContextMenu = function hasContextMenu() {
            return this.props.contextMenu && _react2['default'].isValidElement(this.props.contextMenu);
          };
          RowsContainer.prototype.renderRowsWithContextMenu = function renderRowsWithContextMenu() {
            var ContextMenuTrigger = this.plugins.Menu.ContextMenuTrigger;
            var newProps = getNewContextMenuProps(this.props);
            var contextMenu = _react2['default'].cloneElement(this.props.contextMenu, newProps);
            // Initialise the context menu if it is available
            return _react2['default'].createElement('div', null, _react2['default'].createElement(ContextMenuTrigger, {
              id: newProps.id
            }, _react2['default'].createElement(SimpleRowsContainer, this.props)), contextMenu);
          };
          RowsContainer.prototype.render = function render() {
            if (this.hasContextMenu()) {
              this.validatePlugin();
              return this.renderRowsWithContextMenu();
            }
            return _react2['default'].createElement(SimpleRowsContainer, this.props);
          };
          return RowsContainer;
        }(_react2['default'].Component);
        RowsContainer.propTypes = {
          contextMenu: _propTypes2['default'].element,
          rowIdx: _propTypes2['default'].number,
          idx: _propTypes2['default'].number,
          window: _propTypes2['default'].object
        };
        exports['default'] = RowsContainer;
        exports.SimpleRowsContainer = SimpleRowsContainer;

        /***/
      }, /* 46 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var joinClasses = __webpack_require__(5);
        var DEFINE_SORT = {
          ASC: 'ASC',
          DESC: 'DESC',
          NONE: 'NONE'
        };
        var SortableHeaderCell = function (_React$Component) {
          _inherits(SortableHeaderCell, _React$Component);
          function SortableHeaderCell() {
            var _temp, _this, _ret;
            _classCallCheck(this, SortableHeaderCell);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onClick = function () {
              var direction = void 0;
              var _this$props = _this.props,
                sortDirection = _this$props.sortDirection,
                sortDescendingFirst = _this$props.sortDescendingFirst;
              switch (sortDirection) {
                default:
                case null:
                case undefined:
                case DEFINE_SORT.NONE:
                  direction = sortDescendingFirst ? DEFINE_SORT.DESC : DEFINE_SORT.ASC;
                  break;
                case DEFINE_SORT.ASC:
                  direction = sortDescendingFirst ? DEFINE_SORT.NONE : DEFINE_SORT.DESC;
                  break;
                case DEFINE_SORT.DESC:
                  direction = sortDescendingFirst ? DEFINE_SORT.ASC : DEFINE_SORT.NONE;
                  break;
              }
              _this.props.onSort(_this.props.columnKey, direction);
            }, _this.getSortByText = function () {
              var unicodeKeys = {
                ASC: '9650',
                DESC: '9660'
              };
              return _this.props.sortDirection === 'NONE' ? '' : String.fromCharCode(unicodeKeys[_this.props.sortDirection]);
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          SortableHeaderCell.prototype.render = function render() {
            var className = joinClasses({
              'react-grid-HeaderCell-sortable': true,
              'react-grid-HeaderCell-sortable--ascending': this.props.sortDirection === 'ASC',
              'react-grid-HeaderCell-sortable--descending': this.props.sortDirection === 'DESC'
            });
            var content = this.props.headerRenderer ? this.props.headerRenderer : this.props.column.name;
            return React.createElement('div', {
              className: className,
              onClick: this.onClick,
              style: {
                cursor: 'pointer'
              }
            }, React.createElement('span', {
              className: 'pull-right'
            }, this.getSortByText()), content);
          };
          return SortableHeaderCell;
        }(React.Component);
        SortableHeaderCell.propTypes = {
          columnKey: _propTypes2['default'].string.isRequired,
          column: _propTypes2['default'].shape({
            name: _propTypes2['default'].node
          }),
          onSort: _propTypes2['default'].func.isRequired,
          sortDirection: _propTypes2['default'].oneOf(Object.keys(DEFINE_SORT)),
          headerRenderer: _propTypes2['default'].node,
          sortDescendingFirst: _propTypes2['default'].bool
        };
        module.exports = SortableHeaderCell;
        module.exports.DEFINE_SORT = DEFINE_SORT;

        /***/
      }, /* 47 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        __webpack_require__(70);
        var CheckboxEditor = function (_React$Component) {
          _inherits(CheckboxEditor, _React$Component);
          function CheckboxEditor() {
            var _temp, _this, _ret;
            _classCallCheck(this, CheckboxEditor);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleChange = function (e) {
              _this.props.column.onCellChange(_this.props.rowIdx, _this.props.column.key, _this.props.dependentValues, e);
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          CheckboxEditor.prototype.render = function render() {
            var checked = this.props.value != null ? this.props.value : false;
            var checkboxName = 'checkbox' + this.props.rowIdx;
            return React.createElement('div', {
              className: 'react-grid-checkbox-container checkbox-align',
              onClick: this.handleChange
            }, React.createElement('input', {
              className: 'react-grid-checkbox',
              type: 'checkbox',
              name: checkboxName,
              checked: checked
            }), React.createElement('label', {
              htmlFor: checkboxName,
              className: 'react-grid-checkbox-label'
            }));
          };
          return CheckboxEditor;
        }(React.Component);
        CheckboxEditor.propTypes = {
          value: _propTypes2['default'].bool,
          rowIdx: _propTypes2['default'].number,
          column: _propTypes2['default'].shape({
            key: _propTypes2['default'].string,
            onCellChange: _propTypes2['default'].func
          }),
          dependentValues: _propTypes2['default'].object
        };
        module.exports = CheckboxEditor;

        /***/
      }, /* 48 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var ReactDOM = __webpack_require__(9);
        var ExcelColumn = __webpack_require__(12);
        var EditorBase = function (_React$Component) {
          _inherits(EditorBase, _React$Component);
          function EditorBase() {
            _classCallCheck(this, EditorBase);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          EditorBase.prototype.getStyle = function getStyle() {
            return {
              width: '100%'
            };
          };
          EditorBase.prototype.getValue = function getValue() {
            var updated = {};
            updated[this.props.column.key] = this.getInputNode().value;
            return updated;
          };
          EditorBase.prototype.getInputNode = function getInputNode() {
            var domNode = ReactDOM.findDOMNode(this);
            if (domNode.tagName === 'INPUT') {
              return domNode;
            }
            return domNode.querySelector('input:not([type=hidden])');
          };
          EditorBase.prototype.inheritContainerStyles = function inheritContainerStyles() {
            return true;
          };
          return EditorBase;
        }(React.Component);
        EditorBase.propTypes = {
          onKeyDown: _propTypes2['default'].func.isRequired,
          value: _propTypes2['default'].any.isRequired,
          onBlur: _propTypes2['default'].func.isRequired,
          column: _propTypes2['default'].shape(ExcelColumn).isRequired,
          commit: _propTypes2['default'].func.isRequired
        };
        module.exports = EditorBase;

        /***/
      }, /* 49 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var EditorBase = __webpack_require__(48);
        var SimpleTextEditor = function (_EditorBase) {
          _inherits(SimpleTextEditor, _EditorBase);
          function SimpleTextEditor() {
            _classCallCheck(this, SimpleTextEditor);
            return _possibleConstructorReturn(this, _EditorBase.apply(this, arguments));
          }
          SimpleTextEditor.prototype.render = function render() {
            var _this2 = this;
            return React.createElement('input', {
              ref: function ref(node) {
                return _this2.input = node;
              },
              type: 'text',
              onBlur: this.props.onBlur,
              className: 'form-control',
              defaultValue: this.props.value
            });
          };
          return SimpleTextEditor;
        }(EditorBase);
        module.exports = SimpleTextEditor;

        /***/
      }, /* 50 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var SelectAll = function SelectAll(props) {
          return _react2['default'].createElement('div', {
            className: 'react-grid-checkbox-container checkbox-align'
          }, _react2['default'].createElement('input', {
            className: 'react-grid-checkbox',
            type: 'checkbox',
            name: 'select-all-checkbox',
            id: 'select-all-checkbox',
            ref: props.inputRef,
            onChange: props.onChange
          }), _react2['default'].createElement('label', {
            htmlFor: 'select-all-checkbox',
            className: 'react-grid-checkbox-label'
          }));
        };
        SelectAll.propTypes = {
          onChange: _propTypes2['default'].func,
          inputRef: _propTypes2['default'].func
        };
        exports['default'] = SelectAll;

        /***/
      }, /* 51 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var SimpleCellFormatter = function (_React$Component) {
          _inherits(SimpleCellFormatter, _React$Component);
          function SimpleCellFormatter() {
            _classCallCheck(this, SimpleCellFormatter);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          SimpleCellFormatter.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return nextProps.value !== this.props.value;
          };
          SimpleCellFormatter.prototype.render = function render() {
            return React.createElement('div', {
              title: this.props.value
            }, this.props.value);
          };
          return SimpleCellFormatter;
        }(React.Component);
        SimpleCellFormatter.propTypes = {
          value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].object, _propTypes2['default'].bool]).isRequired
        };
        module.exports = SimpleCellFormatter;

        /***/
      }, /* 52 */
      /***/function (module, exports) {
        "use strict";

        function shallowCloneObject(obj) {
          var result = {};
          for (var k in obj) {
            if (obj.hasOwnProperty(k)) {
              result[k] = obj[k];
            }
          }
          return result;
        }
        module.exports = shallowCloneObject;

        /***/
      }, /* 53 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var _immutable = __webpack_require__(18);
        module.exports = {
          isEmptyArray: __webpack_require__(131),
          isEmptyObject: __webpack_require__(132),
          isFunction: __webpack_require__(19),
          isImmutableCollection: __webpack_require__(133),
          getMixedTypeValueRetriever: __webpack_require__(135),
          isColumnsImmutable: __webpack_require__(54),
          isImmutableMap: __webpack_require__(134),
          last: function last(arrayOrList) {
            if (arrayOrList == null) {
              throw new Error('arrayOrCollection is null');
            }
            if (_immutable.List.isList(arrayOrList)) {
              return arrayOrList.last();
            }
            if (Array.isArray(arrayOrList)) {
              return arrayOrList[arrayOrList.length - 1];
            }
            throw new Error('Cant get last of: ' + (typeof arrayOrList === 'undefined' ? 'undefined' : _typeof(arrayOrList)));
          }
        };

        /***/
      }, /* 54 */
      /***/function (module, exports) {
        'use strict';

        module.exports = function isColumnsImmutable(columns) {
          return typeof Immutable !== 'undefined' && columns instanceof Immutable.List;
        };

        /***/
      }, /* 55 */
      /***/function (module, exports) {
        'use strict';

        exports.__esModule = true;
        function isKeyPrintable(keycode) {
          var valid = keycode > 47 && keycode < 58 ||
          // number keys
          keycode === 32 || keycode === 13 ||
          // spacebar & return key(s) (if you want to allow carriage returns)
          keycode > 64 && keycode < 91 ||
          // letter keys
          keycode > 95 && keycode < 112 ||
          // numpad keys
          keycode > 185 && keycode < 193 ||
          // ;=,-./` (in order)
          keycode > 218 && keycode < 223; // [\]' (in order)

          return valid;
        }
        function isCtrlKeyHeldDown(e) {
          return (e.ctrlKey === true || e.metaKey === true) && e.key !== 'Control';
        }
        exports.isKeyPrintable = isKeyPrintable;
        exports.isCtrlKeyHeldDown = isCtrlKeyHeldDown;

        /***/
      },,,,,,,,,,,,,, /* 69 */
      /***/function (module, exports) {
        module.exports = function shallowEqual(objA, objB, compare, compareContext) {
          var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
          if (ret !== void 0) {
            return !!ret;
          }
          if (objA === objB) {
            return true;
          }
          if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
            return false;
          }
          var keysA = Object.keys(objA);
          var keysB = Object.keys(objB);
          if (keysA.length !== keysB.length) {
            return false;
          }
          var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

          // Test for A's keys different from B.
          for (var idx = 0; idx < keysA.length; idx++) {
            var key = keysA[idx];
            if (!bHasOwnProperty(key)) {
              return false;
            }
            var valueA = objA[key];
            var valueB = objB[key];
            ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
            if (ret === false || ret === void 0 && valueA !== valueB) {
              return false;
            }
          }
          return true;
        };

        /***/
      }, /* 70 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(139);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      },,,,,,,, /* 78 */
      /***/function (module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; //     Underscore.js 1.8.3
        //     http://underscorejs.org
        //     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
        //     Underscore may be freely distributed under the MIT license.

        (function () {
          // Baseline setup
          // --------------

          // Establish the root object, `window` in the browser, or `exports` on the server.
          var root = this;

          // Save the previous value of the `_` variable.
          var previousUnderscore = root._;

          // Save bytes in the minified (but not gzipped) version:
          var ArrayProto = Array.prototype,
            ObjProto = Object.prototype,
            FuncProto = Function.prototype;

          // Create quick reference variables for speed access to core prototypes.
          var push = ArrayProto.push,
            slice = ArrayProto.slice,
            toString = ObjProto.toString,
            hasOwnProperty = ObjProto.hasOwnProperty;

          // All **ECMAScript 5** native function implementations that we hope to use
          // are declared here.
          var nativeIsArray = Array.isArray,
            nativeKeys = Object.keys,
            nativeBind = FuncProto.bind,
            nativeCreate = Object.create;

          // Naked function reference for surrogate-prototype-swapping.
          var Ctor = function () {};

          // Create a safe reference to the Underscore object for use below.
          var _ = function (obj) {
            if (obj instanceof _) return obj;
            if (!(this instanceof _)) return new _(obj);
            this._wrapped = obj;
          };

          // Export the Underscore object for **Node.js**, with
          // backwards-compatibility for the old `require()` API. If we're in
          // the browser, add `_` as a global object.
          if (true) {
            if (typeof module !== 'undefined' && module.exports) {
              exports = module.exports = _;
            }
            exports._ = _;
          } else {}

          // Current version.
          _.VERSION = '1.8.3';

          // Internal function that returns an efficient (for current engines) version
          // of the passed-in callback, to be repeatedly applied in other Underscore
          // functions.
          var optimizeCb = function (func, context, argCount) {
            if (context === void 0) return func;
            switch (argCount == null ? 3 : argCount) {
              case 1:
                return function (value) {
                  return func.call(context, value);
                };
              case 2:
                return function (value, other) {
                  return func.call(context, value, other);
                };
              case 3:
                return function (value, index, collection) {
                  return func.call(context, value, index, collection);
                };
              case 4:
                return function (accumulator, value, index, collection) {
                  return func.call(context, accumulator, value, index, collection);
                };
            }
            return function () {
              return func.apply(context, arguments);
            };
          };

          // A mostly-internal function to generate callbacks that can be applied
          // to each element in a collection, returning the desired result — either
          // identity, an arbitrary callback, a property matcher, or a property accessor.
          var cb = function (value, context, argCount) {
            if (value == null) return _.identity;
            if (_.isFunction(value)) return optimizeCb(value, context, argCount);
            if (_.isObject(value)) return _.matcher(value);
            return _.property(value);
          };
          _.iteratee = function (value, context) {
            return cb(value, context, Infinity);
          };

          // An internal function for creating assigner functions.
          var createAssigner = function (keysFunc, undefinedOnly) {
            return function (obj) {
              var length = arguments.length;
              if (length < 2 || obj == null) return obj;
              for (var index = 1; index < length; index++) {
                var source = arguments[index],
                  keys = keysFunc(source),
                  l = keys.length;
                for (var i = 0; i < l; i++) {
                  var key = keys[i];
                  if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
                }
              }
              return obj;
            };
          };

          // An internal function for creating a new object that inherits from another.
          var baseCreate = function (prototype) {
            if (!_.isObject(prototype)) return {};
            if (nativeCreate) return nativeCreate(prototype);
            Ctor.prototype = prototype;
            var result = new Ctor();
            Ctor.prototype = null;
            return result;
          };
          var property = function (key) {
            return function (obj) {
              return obj == null ? void 0 : obj[key];
            };
          };

          // Helper for collection methods to determine whether a collection
          // should be iterated as an array or as an object
          // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
          // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
          var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
          var getLength = property('length');
          var isArrayLike = function (collection) {
            var length = getLength(collection);
            return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
          };

          // Collection Functions
          // --------------------

          // The cornerstone, an `each` implementation, aka `forEach`.
          // Handles raw objects in addition to array-likes. Treats all
          // sparse array-likes as if they were dense.
          _.each = _.forEach = function (obj, iteratee, context) {
            iteratee = optimizeCb(iteratee, context);
            var i, length;
            if (isArrayLike(obj)) {
              for (i = 0, length = obj.length; i < length; i++) {
                iteratee(obj[i], i, obj);
              }
            } else {
              var keys = _.keys(obj);
              for (i = 0, length = keys.length; i < length; i++) {
                iteratee(obj[keys[i]], keys[i], obj);
              }
            }
            return obj;
          };

          // Return the results of applying the iteratee to each element.
          _.map = _.collect = function (obj, iteratee, context) {
            iteratee = cb(iteratee, context);
            var keys = !isArrayLike(obj) && _.keys(obj),
              length = (keys || obj).length,
              results = Array(length);
            for (var index = 0; index < length; index++) {
              var currentKey = keys ? keys[index] : index;
              results[index] = iteratee(obj[currentKey], currentKey, obj);
            }
            return results;
          };

          // Create a reducing function iterating left or right.
          function createReduce(dir) {
            // Optimized iterator function as using arguments.length
            // in the main function will deoptimize the, see #1991.
            function iterator(obj, iteratee, memo, keys, index, length) {
              for (; index >= 0 && index < length; index += dir) {
                var currentKey = keys ? keys[index] : index;
                memo = iteratee(memo, obj[currentKey], currentKey, obj);
              }
              return memo;
            }
            return function (obj, iteratee, memo, context) {
              iteratee = optimizeCb(iteratee, context, 4);
              var keys = !isArrayLike(obj) && _.keys(obj),
                length = (keys || obj).length,
                index = dir > 0 ? 0 : length - 1;
              // Determine the initial value if none is provided.
              if (arguments.length < 3) {
                memo = obj[keys ? keys[index] : index];
                index += dir;
              }
              return iterator(obj, iteratee, memo, keys, index, length);
            };
          }

          // **Reduce** builds up a single result from a list of values, aka `inject`,
          // or `foldl`.
          _.reduce = _.foldl = _.inject = createReduce(1);

          // The right-associative version of reduce, also known as `foldr`.
          _.reduceRight = _.foldr = createReduce(-1);

          // Return the first value which passes a truth test. Aliased as `detect`.
          _.find = _.detect = function (obj, predicate, context) {
            var key;
            if (isArrayLike(obj)) {
              key = _.findIndex(obj, predicate, context);
            } else {
              key = _.findKey(obj, predicate, context);
            }
            if (key !== void 0 && key !== -1) return obj[key];
          };

          // Return all the elements that pass a truth test.
          // Aliased as `select`.
          _.filter = _.select = function (obj, predicate, context) {
            var results = [];
            predicate = cb(predicate, context);
            _.each(obj, function (value, index, list) {
              if (predicate(value, index, list)) results.push(value);
            });
            return results;
          };

          // Return all the elements for which a truth test fails.
          _.reject = function (obj, predicate, context) {
            return _.filter(obj, _.negate(cb(predicate)), context);
          };

          // Determine whether all of the elements match a truth test.
          // Aliased as `all`.
          _.every = _.all = function (obj, predicate, context) {
            predicate = cb(predicate, context);
            var keys = !isArrayLike(obj) && _.keys(obj),
              length = (keys || obj).length;
            for (var index = 0; index < length; index++) {
              var currentKey = keys ? keys[index] : index;
              if (!predicate(obj[currentKey], currentKey, obj)) return false;
            }
            return true;
          };

          // Determine if at least one element in the object matches a truth test.
          // Aliased as `any`.
          _.some = _.any = function (obj, predicate, context) {
            predicate = cb(predicate, context);
            var keys = !isArrayLike(obj) && _.keys(obj),
              length = (keys || obj).length;
            for (var index = 0; index < length; index++) {
              var currentKey = keys ? keys[index] : index;
              if (predicate(obj[currentKey], currentKey, obj)) return true;
            }
            return false;
          };

          // Determine if the array or object contains a given item (using `===`).
          // Aliased as `includes` and `include`.
          _.contains = _.includes = _.include = function (obj, item, fromIndex, guard) {
            if (!isArrayLike(obj)) obj = _.values(obj);
            if (typeof fromIndex != 'number' || guard) fromIndex = 0;
            return _.indexOf(obj, item, fromIndex) >= 0;
          };

          // Invoke a method (with arguments) on every item in a collection.
          _.invoke = function (obj, method) {
            var args = slice.call(arguments, 2);
            var isFunc = _.isFunction(method);
            return _.map(obj, function (value) {
              var func = isFunc ? method : value[method];
              return func == null ? func : func.apply(value, args);
            });
          };

          // Convenience version of a common use case of `map`: fetching a property.
          _.pluck = function (obj, key) {
            return _.map(obj, _.property(key));
          };

          // Convenience version of a common use case of `filter`: selecting only objects
          // containing specific `key:value` pairs.
          _.where = function (obj, attrs) {
            return _.filter(obj, _.matcher(attrs));
          };

          // Convenience version of a common use case of `find`: getting the first object
          // containing specific `key:value` pairs.
          _.findWhere = function (obj, attrs) {
            return _.find(obj, _.matcher(attrs));
          };

          // Return the maximum element (or element-based computation).
          _.max = function (obj, iteratee, context) {
            var result = -Infinity,
              lastComputed = -Infinity,
              value,
              computed;
            if (iteratee == null && obj != null) {
              obj = isArrayLike(obj) ? obj : _.values(obj);
              for (var i = 0, length = obj.length; i < length; i++) {
                value = obj[i];
                if (value > result) {
                  result = value;
                }
              }
            } else {
              iteratee = cb(iteratee, context);
              _.each(obj, function (value, index, list) {
                computed = iteratee(value, index, list);
                if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                  result = value;
                  lastComputed = computed;
                }
              });
            }
            return result;
          };

          // Return the minimum element (or element-based computation).
          _.min = function (obj, iteratee, context) {
            var result = Infinity,
              lastComputed = Infinity,
              value,
              computed;
            if (iteratee == null && obj != null) {
              obj = isArrayLike(obj) ? obj : _.values(obj);
              for (var i = 0, length = obj.length; i < length; i++) {
                value = obj[i];
                if (value < result) {
                  result = value;
                }
              }
            } else {
              iteratee = cb(iteratee, context);
              _.each(obj, function (value, index, list) {
                computed = iteratee(value, index, list);
                if (computed < lastComputed || computed === Infinity && result === Infinity) {
                  result = value;
                  lastComputed = computed;
                }
              });
            }
            return result;
          };

          // Shuffle a collection, using the modern version of the
          // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
          _.shuffle = function (obj) {
            var set = isArrayLike(obj) ? obj : _.values(obj);
            var length = set.length;
            var shuffled = Array(length);
            for (var index = 0, rand; index < length; index++) {
              rand = _.random(0, index);
              if (rand !== index) shuffled[index] = shuffled[rand];
              shuffled[rand] = set[index];
            }
            return shuffled;
          };

          // Sample **n** random values from a collection.
          // If **n** is not specified, returns a single random element.
          // The internal `guard` argument allows it to work with `map`.
          _.sample = function (obj, n, guard) {
            if (n == null || guard) {
              if (!isArrayLike(obj)) obj = _.values(obj);
              return obj[_.random(obj.length - 1)];
            }
            return _.shuffle(obj).slice(0, Math.max(0, n));
          };

          // Sort the object's values by a criterion produced by an iteratee.
          _.sortBy = function (obj, iteratee, context) {
            iteratee = cb(iteratee, context);
            return _.pluck(_.map(obj, function (value, index, list) {
              return {
                value: value,
                index: index,
                criteria: iteratee(value, index, list)
              };
            }).sort(function (left, right) {
              var a = left.criteria;
              var b = right.criteria;
              if (a !== b) {
                if (a > b || a === void 0) return 1;
                if (a < b || b === void 0) return -1;
              }
              return left.index - right.index;
            }), 'value');
          };

          // An internal function used for aggregate "group by" operations.
          var group = function (behavior) {
            return function (obj, iteratee, context) {
              var result = {};
              iteratee = cb(iteratee, context);
              _.each(obj, function (value, index) {
                var key = iteratee(value, index, obj);
                behavior(result, value, key);
              });
              return result;
            };
          };

          // Groups the object's values by a criterion. Pass either a string attribute
          // to group by, or a function that returns the criterion.
          _.groupBy = group(function (result, value, key) {
            if (_.has(result, key)) result[key].push(value);else result[key] = [value];
          });

          // Indexes the object's values by a criterion, similar to `groupBy`, but for
          // when you know that your index values will be unique.
          _.indexBy = group(function (result, value, key) {
            result[key] = value;
          });

          // Counts instances of an object that group by a certain criterion. Pass
          // either a string attribute to count by, or a function that returns the
          // criterion.
          _.countBy = group(function (result, value, key) {
            if (_.has(result, key)) result[key]++;else result[key] = 1;
          });

          // Safely create a real, live array from anything iterable.
          _.toArray = function (obj) {
            if (!obj) return [];
            if (_.isArray(obj)) return slice.call(obj);
            if (isArrayLike(obj)) return _.map(obj, _.identity);
            return _.values(obj);
          };

          // Return the number of elements in an object.
          _.size = function (obj) {
            if (obj == null) return 0;
            return isArrayLike(obj) ? obj.length : _.keys(obj).length;
          };

          // Split a collection into two arrays: one whose elements all satisfy the given
          // predicate, and one whose elements all do not satisfy the predicate.
          _.partition = function (obj, predicate, context) {
            predicate = cb(predicate, context);
            var pass = [],
              fail = [];
            _.each(obj, function (value, key, obj) {
              (predicate(value, key, obj) ? pass : fail).push(value);
            });
            return [pass, fail];
          };

          // Array Functions
          // ---------------

          // Get the first element of an array. Passing **n** will return the first N
          // values in the array. Aliased as `head` and `take`. The **guard** check
          // allows it to work with `_.map`.
          _.first = _.head = _.take = function (array, n, guard) {
            if (array == null) return void 0;
            if (n == null || guard) return array[0];
            return _.initial(array, array.length - n);
          };

          // Returns everything but the last entry of the array. Especially useful on
          // the arguments object. Passing **n** will return all the values in
          // the array, excluding the last N.
          _.initial = function (array, n, guard) {
            return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
          };

          // Get the last element of an array. Passing **n** will return the last N
          // values in the array.
          _.last = function (array, n, guard) {
            if (array == null) return void 0;
            if (n == null || guard) return array[array.length - 1];
            return _.rest(array, Math.max(0, array.length - n));
          };

          // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
          // Especially useful on the arguments object. Passing an **n** will return
          // the rest N values in the array.
          _.rest = _.tail = _.drop = function (array, n, guard) {
            return slice.call(array, n == null || guard ? 1 : n);
          };

          // Trim out all falsy values from an array.
          _.compact = function (array) {
            return _.filter(array, _.identity);
          };

          // Internal implementation of a recursive `flatten` function.
          var flatten = function (input, shallow, strict, startIndex) {
            var output = [],
              idx = 0;
            for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
              var value = input[i];
              if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
                //flatten current level of array or arguments object
                if (!shallow) value = flatten(value, shallow, strict);
                var j = 0,
                  len = value.length;
                output.length += len;
                while (j < len) {
                  output[idx++] = value[j++];
                }
              } else if (!strict) {
                output[idx++] = value;
              }
            }
            return output;
          };

          // Flatten out an array, either recursively (by default), or just one level.
          _.flatten = function (array, shallow) {
            return flatten(array, shallow, false);
          };

          // Return a version of the array that does not contain the specified value(s).
          _.without = function (array) {
            return _.difference(array, slice.call(arguments, 1));
          };

          // Produce a duplicate-free version of the array. If the array has already
          // been sorted, you have the option of using a faster algorithm.
          // Aliased as `unique`.
          _.uniq = _.unique = function (array, isSorted, iteratee, context) {
            if (!_.isBoolean(isSorted)) {
              context = iteratee;
              iteratee = isSorted;
              isSorted = false;
            }
            if (iteratee != null) iteratee = cb(iteratee, context);
            var result = [];
            var seen = [];
            for (var i = 0, length = getLength(array); i < length; i++) {
              var value = array[i],
                computed = iteratee ? iteratee(value, i, array) : value;
              if (isSorted) {
                if (!i || seen !== computed) result.push(value);
                seen = computed;
              } else if (iteratee) {
                if (!_.contains(seen, computed)) {
                  seen.push(computed);
                  result.push(value);
                }
              } else if (!_.contains(result, value)) {
                result.push(value);
              }
            }
            return result;
          };

          // Produce an array that contains the union: each distinct element from all of
          // the passed-in arrays.
          _.union = function () {
            return _.uniq(flatten(arguments, true, true));
          };

          // Produce an array that contains every item shared between all the
          // passed-in arrays.
          _.intersection = function (array) {
            var result = [];
            var argsLength = arguments.length;
            for (var i = 0, length = getLength(array); i < length; i++) {
              var item = array[i];
              if (_.contains(result, item)) continue;
              for (var j = 1; j < argsLength; j++) {
                if (!_.contains(arguments[j], item)) break;
              }
              if (j === argsLength) result.push(item);
            }
            return result;
          };

          // Take the difference between one array and a number of other arrays.
          // Only the elements present in just the first array will remain.
          _.difference = function (array) {
            var rest = flatten(arguments, true, true, 1);
            return _.filter(array, function (value) {
              return !_.contains(rest, value);
            });
          };

          // Zip together multiple lists into a single array -- elements that share
          // an index go together.
          _.zip = function () {
            return _.unzip(arguments);
          };

          // Complement of _.zip. Unzip accepts an array of arrays and groups
          // each array's elements on shared indices
          _.unzip = function (array) {
            var length = array && _.max(array, getLength).length || 0;
            var result = Array(length);
            for (var index = 0; index < length; index++) {
              result[index] = _.pluck(array, index);
            }
            return result;
          };

          // Converts lists into objects. Pass either a single array of `[key, value]`
          // pairs, or two parallel arrays of the same length -- one of keys, and one of
          // the corresponding values.
          _.object = function (list, values) {
            var result = {};
            for (var i = 0, length = getLength(list); i < length; i++) {
              if (values) {
                result[list[i]] = values[i];
              } else {
                result[list[i][0]] = list[i][1];
              }
            }
            return result;
          };

          // Generator function to create the findIndex and findLastIndex functions
          function createPredicateIndexFinder(dir) {
            return function (array, predicate, context) {
              predicate = cb(predicate, context);
              var length = getLength(array);
              var index = dir > 0 ? 0 : length - 1;
              for (; index >= 0 && index < length; index += dir) {
                if (predicate(array[index], index, array)) return index;
              }
              return -1;
            };
          }

          // Returns the first index on an array-like that passes a predicate test
          _.findIndex = createPredicateIndexFinder(1);
          _.findLastIndex = createPredicateIndexFinder(-1);

          // Use a comparator function to figure out the smallest index at which
          // an object should be inserted so as to maintain order. Uses binary search.
          _.sortedIndex = function (array, obj, iteratee, context) {
            iteratee = cb(iteratee, context, 1);
            var value = iteratee(obj);
            var low = 0,
              high = getLength(array);
            while (low < high) {
              var mid = Math.floor((low + high) / 2);
              if (iteratee(array[mid]) < value) low = mid + 1;else high = mid;
            }
            return low;
          };

          // Generator function to create the indexOf and lastIndexOf functions
          function createIndexFinder(dir, predicateFind, sortedIndex) {
            return function (array, item, idx) {
              var i = 0,
                length = getLength(array);
              if (typeof idx == 'number') {
                if (dir > 0) {
                  i = idx >= 0 ? idx : Math.max(idx + length, i);
                } else {
                  length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
                }
              } else if (sortedIndex && idx && length) {
                idx = sortedIndex(array, item);
                return array[idx] === item ? idx : -1;
              }
              if (item !== item) {
                idx = predicateFind(slice.call(array, i, length), _.isNaN);
                return idx >= 0 ? idx + i : -1;
              }
              for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
                if (array[idx] === item) return idx;
              }
              return -1;
            };
          }

          // Return the position of the first occurrence of an item in an array,
          // or -1 if the item is not included in the array.
          // If the array is large and already in sort order, pass `true`
          // for **isSorted** to use binary search.
          _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
          _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

          // Generate an integer Array containing an arithmetic progression. A port of
          // the native Python `range()` function. See
          // [the Python documentation](http://docs.python.org/library/functions.html#range).
          _.range = function (start, stop, step) {
            if (stop == null) {
              stop = start || 0;
              start = 0;
            }
            step = step || 1;
            var length = Math.max(Math.ceil((stop - start) / step), 0);
            var range = Array(length);
            for (var idx = 0; idx < length; idx++, start += step) {
              range[idx] = start;
            }
            return range;
          };

          // Function (ahem) Functions
          // ------------------

          // Determines whether to execute a function as a constructor
          // or a normal function with the provided arguments
          var executeBound = function (sourceFunc, boundFunc, context, callingContext, args) {
            if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
            var self = baseCreate(sourceFunc.prototype);
            var result = sourceFunc.apply(self, args);
            if (_.isObject(result)) return result;
            return self;
          };

          // Create a function bound to a given object (assigning `this`, and arguments,
          // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
          // available.
          _.bind = function (func, context) {
            if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
            if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
            var args = slice.call(arguments, 2);
            var bound = function () {
              return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
            };
            return bound;
          };

          // Partially apply a function by creating a version that has had some of its
          // arguments pre-filled, without changing its dynamic `this` context. _ acts
          // as a placeholder, allowing any combination of arguments to be pre-filled.
          _.partial = function (func) {
            var boundArgs = slice.call(arguments, 1);
            var bound = function () {
              var position = 0,
                length = boundArgs.length;
              var args = Array(length);
              for (var i = 0; i < length; i++) {
                args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
              }
              while (position < arguments.length) args.push(arguments[position++]);
              return executeBound(func, bound, this, this, args);
            };
            return bound;
          };

          // Bind a number of an object's methods to that object. Remaining arguments
          // are the method names to be bound. Useful for ensuring that all callbacks
          // defined on an object belong to it.
          _.bindAll = function (obj) {
            var i,
              length = arguments.length,
              key;
            if (length <= 1) throw new Error('bindAll must be passed function names');
            for (i = 1; i < length; i++) {
              key = arguments[i];
              obj[key] = _.bind(obj[key], obj);
            }
            return obj;
          };

          // Memoize an expensive function by storing its results.
          _.memoize = function (func, hasher) {
            var memoize = function (key) {
              var cache = memoize.cache;
              var address = '' + (hasher ? hasher.apply(this, arguments) : key);
              if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
              return cache[address];
            };
            memoize.cache = {};
            return memoize;
          };

          // Delays a function for the given number of milliseconds, and then calls
          // it with the arguments supplied.
          _.delay = function (func, wait) {
            var args = slice.call(arguments, 2);
            return setTimeout(function () {
              return func.apply(null, args);
            }, wait);
          };

          // Defers a function, scheduling it to run after the current call stack has
          // cleared.
          _.defer = _.partial(_.delay, _, 1);

          // Returns a function, that, when invoked, will only be triggered at most once
          // during a given window of time. Normally, the throttled function will run
          // as much as it can, without ever going more than once per `wait` duration;
          // but if you'd like to disable the execution on the leading edge, pass
          // `{leading: false}`. To disable execution on the trailing edge, ditto.
          _.throttle = function (func, wait, options) {
            var context, args, result;
            var timeout = null;
            var previous = 0;
            if (!options) options = {};
            var later = function () {
              previous = options.leading === false ? 0 : _.now();
              timeout = null;
              result = func.apply(context, args);
              if (!timeout) context = args = null;
            };
            return function () {
              var now = _.now();
              if (!previous && options.leading === false) previous = now;
              var remaining = wait - (now - previous);
              context = this;
              args = arguments;
              if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                  clearTimeout(timeout);
                  timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
              } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
              }
              return result;
            };
          };

          // Returns a function, that, as long as it continues to be invoked, will not
          // be triggered. The function will be called after it stops being called for
          // N milliseconds. If `immediate` is passed, trigger the function on the
          // leading edge, instead of the trailing.
          _.debounce = function (func, wait, immediate) {
            var timeout, args, context, timestamp, result;
            var later = function () {
              var last = _.now() - timestamp;
              if (last < wait && last >= 0) {
                timeout = setTimeout(later, wait - last);
              } else {
                timeout = null;
                if (!immediate) {
                  result = func.apply(context, args);
                  if (!timeout) context = args = null;
                }
              }
            };
            return function () {
              context = this;
              args = arguments;
              timestamp = _.now();
              var callNow = immediate && !timeout;
              if (!timeout) timeout = setTimeout(later, wait);
              if (callNow) {
                result = func.apply(context, args);
                context = args = null;
              }
              return result;
            };
          };

          // Returns the first function passed as an argument to the second,
          // allowing you to adjust arguments, run code before and after, and
          // conditionally execute the original function.
          _.wrap = function (func, wrapper) {
            return _.partial(wrapper, func);
          };

          // Returns a negated version of the passed-in predicate.
          _.negate = function (predicate) {
            return function () {
              return !predicate.apply(this, arguments);
            };
          };

          // Returns a function that is the composition of a list of functions, each
          // consuming the return value of the function that follows.
          _.compose = function () {
            var args = arguments;
            var start = args.length - 1;
            return function () {
              var i = start;
              var result = args[start].apply(this, arguments);
              while (i--) result = args[i].call(this, result);
              return result;
            };
          };

          // Returns a function that will only be executed on and after the Nth call.
          _.after = function (times, func) {
            return function () {
              if (--times < 1) {
                return func.apply(this, arguments);
              }
            };
          };

          // Returns a function that will only be executed up to (but not including) the Nth call.
          _.before = function (times, func) {
            var memo;
            return function () {
              if (--times > 0) {
                memo = func.apply(this, arguments);
              }
              if (times <= 1) func = null;
              return memo;
            };
          };

          // Returns a function that will be executed at most one time, no matter how
          // often you call it. Useful for lazy initialization.
          _.once = _.partial(_.before, 2);

          // Object Functions
          // ----------------

          // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
          var hasEnumBug = !{
            toString: null
          }.propertyIsEnumerable('toString');
          var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
          function collectNonEnumProps(obj, keys) {
            var nonEnumIdx = nonEnumerableProps.length;
            var constructor = obj.constructor;
            var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

            // Constructor is a special case.
            var prop = 'constructor';
            if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
            while (nonEnumIdx--) {
              prop = nonEnumerableProps[nonEnumIdx];
              if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
                keys.push(prop);
              }
            }
          }

          // Retrieve the names of an object's own properties.
          // Delegates to **ECMAScript 5**'s native `Object.keys`
          _.keys = function (obj) {
            if (!_.isObject(obj)) return [];
            if (nativeKeys) return nativeKeys(obj);
            var keys = [];
            for (var key in obj) if (_.has(obj, key)) keys.push(key);
            // Ahem, IE < 9.
            if (hasEnumBug) collectNonEnumProps(obj, keys);
            return keys;
          };

          // Retrieve all the property names of an object.
          _.allKeys = function (obj) {
            if (!_.isObject(obj)) return [];
            var keys = [];
            for (var key in obj) keys.push(key);
            // Ahem, IE < 9.
            if (hasEnumBug) collectNonEnumProps(obj, keys);
            return keys;
          };

          // Retrieve the values of an object's properties.
          _.values = function (obj) {
            var keys = _.keys(obj);
            var length = keys.length;
            var values = Array(length);
            for (var i = 0; i < length; i++) {
              values[i] = obj[keys[i]];
            }
            return values;
          };

          // Returns the results of applying the iteratee to each element of the object
          // In contrast to _.map it returns an object
          _.mapObject = function (obj, iteratee, context) {
            iteratee = cb(iteratee, context);
            var keys = _.keys(obj),
              length = keys.length,
              results = {},
              currentKey;
            for (var index = 0; index < length; index++) {
              currentKey = keys[index];
              results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
            }
            return results;
          };

          // Convert an object into a list of `[key, value]` pairs.
          _.pairs = function (obj) {
            var keys = _.keys(obj);
            var length = keys.length;
            var pairs = Array(length);
            for (var i = 0; i < length; i++) {
              pairs[i] = [keys[i], obj[keys[i]]];
            }
            return pairs;
          };

          // Invert the keys and values of an object. The values must be serializable.
          _.invert = function (obj) {
            var result = {};
            var keys = _.keys(obj);
            for (var i = 0, length = keys.length; i < length; i++) {
              result[obj[keys[i]]] = keys[i];
            }
            return result;
          };

          // Return a sorted list of the function names available on the object.
          // Aliased as `methods`
          _.functions = _.methods = function (obj) {
            var names = [];
            for (var key in obj) {
              if (_.isFunction(obj[key])) names.push(key);
            }
            return names.sort();
          };

          // Extend a given object with all the properties in passed-in object(s).
          _.extend = createAssigner(_.allKeys);

          // Assigns a given object with all the own properties in the passed-in object(s)
          // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
          _.extendOwn = _.assign = createAssigner(_.keys);

          // Returns the first key on an object that passes a predicate test
          _.findKey = function (obj, predicate, context) {
            predicate = cb(predicate, context);
            var keys = _.keys(obj),
              key;
            for (var i = 0, length = keys.length; i < length; i++) {
              key = keys[i];
              if (predicate(obj[key], key, obj)) return key;
            }
          };

          // Return a copy of the object only containing the whitelisted properties.
          _.pick = function (object, oiteratee, context) {
            var result = {},
              obj = object,
              iteratee,
              keys;
            if (obj == null) return result;
            if (_.isFunction(oiteratee)) {
              keys = _.allKeys(obj);
              iteratee = optimizeCb(oiteratee, context);
            } else {
              keys = flatten(arguments, false, false, 1);
              iteratee = function (value, key, obj) {
                return key in obj;
              };
              obj = Object(obj);
            }
            for (var i = 0, length = keys.length; i < length; i++) {
              var key = keys[i];
              var value = obj[key];
              if (iteratee(value, key, obj)) result[key] = value;
            }
            return result;
          };

          // Return a copy of the object without the blacklisted properties.
          _.omit = function (obj, iteratee, context) {
            if (_.isFunction(iteratee)) {
              iteratee = _.negate(iteratee);
            } else {
              var keys = _.map(flatten(arguments, false, false, 1), String);
              iteratee = function (value, key) {
                return !_.contains(keys, key);
              };
            }
            return _.pick(obj, iteratee, context);
          };

          // Fill in a given object with default properties.
          _.defaults = createAssigner(_.allKeys, true);

          // Creates an object that inherits from the given prototype object.
          // If additional properties are provided then they will be added to the
          // created object.
          _.create = function (prototype, props) {
            var result = baseCreate(prototype);
            if (props) _.extendOwn(result, props);
            return result;
          };

          // Create a (shallow-cloned) duplicate of an object.
          _.clone = function (obj) {
            if (!_.isObject(obj)) return obj;
            return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
          };

          // Invokes interceptor with the obj, and then returns obj.
          // The primary purpose of this method is to "tap into" a method chain, in
          // order to perform operations on intermediate results within the chain.
          _.tap = function (obj, interceptor) {
            interceptor(obj);
            return obj;
          };

          // Returns whether an object has a given set of `key:value` pairs.
          _.isMatch = function (object, attrs) {
            var keys = _.keys(attrs),
              length = keys.length;
            if (object == null) return !length;
            var obj = Object(object);
            for (var i = 0; i < length; i++) {
              var key = keys[i];
              if (attrs[key] !== obj[key] || !(key in obj)) return false;
            }
            return true;
          };

          // Internal recursive comparison function for `isEqual`.
          var eq = function (a, b, aStack, bStack) {
            // Identical objects are equal. `0 === -0`, but they aren't identical.
            // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
            if (a === b) return a !== 0 || 1 / a === 1 / b;
            // A strict comparison is necessary because `null == undefined`.
            if (a == null || b == null) return a === b;
            // Unwrap any wrapped objects.
            if (a instanceof _) a = a._wrapped;
            if (b instanceof _) b = b._wrapped;
            // Compare `[[Class]]` names.
            var className = toString.call(a);
            if (className !== toString.call(b)) return false;
            switch (className) {
              // Strings, numbers, regular expressions, dates, and booleans are compared by value.
              case '[object RegExp]':
              // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
              case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                return '' + a === '' + b;
              case '[object Number]':
                // `NaN`s are equivalent, but non-reflexive.
                // Object(NaN) is equivalent to NaN
                if (+a !== +a) return +b !== +b;
                // An `egal` comparison is performed for other numeric values.
                return +a === 0 ? 1 / +a === 1 / b : +a === +b;
              case '[object Date]':
              case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                return +a === +b;
            }
            var areArrays = className === '[object Array]';
            if (!areArrays) {
              if (typeof a != 'object' || typeof b != 'object') return false;

              // Objects with different constructors are not equivalent, but `Object`s or `Array`s
              // from different frames are.
              var aCtor = a.constructor,
                bCtor = b.constructor;
              if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
                return false;
              }
            }
            // Assume equality for cyclic structures. The algorithm for detecting cyclic
            // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

            // Initializing stack of traversed objects.
            // It's done here since we only need them for objects and arrays comparison.
            aStack = aStack || [];
            bStack = bStack || [];
            var length = aStack.length;
            while (length--) {
              // Linear search. Performance is inversely proportional to the number of
              // unique nested structures.
              if (aStack[length] === a) return bStack[length] === b;
            }

            // Add the first object to the stack of traversed objects.
            aStack.push(a);
            bStack.push(b);

            // Recursively compare objects and arrays.
            if (areArrays) {
              // Compare array lengths to determine if a deep comparison is necessary.
              length = a.length;
              if (length !== b.length) return false;
              // Deep compare the contents, ignoring non-numeric properties.
              while (length--) {
                if (!eq(a[length], b[length], aStack, bStack)) return false;
              }
            } else {
              // Deep compare objects.
              var keys = _.keys(a),
                key;
              length = keys.length;
              // Ensure that both objects contain the same number of properties before comparing deep equality.
              if (_.keys(b).length !== length) return false;
              while (length--) {
                // Deep compare each member
                key = keys[length];
                if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
              }
            }
            // Remove the first object from the stack of traversed objects.
            aStack.pop();
            bStack.pop();
            return true;
          };

          // Perform a deep comparison to check if two objects are equal.
          _.isEqual = function (a, b) {
            return eq(a, b);
          };

          // Is a given array, string, or object empty?
          // An "empty" object has no enumerable own-properties.
          _.isEmpty = function (obj) {
            if (obj == null) return true;
            if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
            return _.keys(obj).length === 0;
          };

          // Is a given value a DOM element?
          _.isElement = function (obj) {
            return !!(obj && obj.nodeType === 1);
          };

          // Is a given value an array?
          // Delegates to ECMA5's native Array.isArray
          _.isArray = nativeIsArray || function (obj) {
            return toString.call(obj) === '[object Array]';
          };

          // Is a given variable an object?
          _.isObject = function (obj) {
            var type = typeof obj;
            return type === 'function' || type === 'object' && !!obj;
          };

          // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
          _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function (name) {
            _['is' + name] = function (obj) {
              return toString.call(obj) === '[object ' + name + ']';
            };
          });

          // Define a fallback version of the method in browsers (ahem, IE < 9), where
          // there isn't any inspectable "Arguments" type.
          if (!_.isArguments(arguments)) {
            _.isArguments = function (obj) {
              return _.has(obj, 'callee');
            };
          }

          // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
          // IE 11 (#1621), and in Safari 8 (#1929).
          if (true && typeof Int8Array != 'object') {
            _.isFunction = function (obj) {
              return typeof obj == 'function' || false;
            };
          }

          // Is a given object a finite number?
          _.isFinite = function (obj) {
            return isFinite(obj) && !isNaN(parseFloat(obj));
          };

          // Is the given value `NaN`? (NaN is the only number which does not equal itself).
          _.isNaN = function (obj) {
            return _.isNumber(obj) && obj !== +obj;
          };

          // Is a given value a boolean?
          _.isBoolean = function (obj) {
            return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
          };

          // Is a given value equal to null?
          _.isNull = function (obj) {
            return obj === null;
          };

          // Is a given variable undefined?
          _.isUndefined = function (obj) {
            return obj === void 0;
          };

          // Shortcut function for checking if an object has a given property directly
          // on itself (in other words, not on a prototype).
          _.has = function (obj, key) {
            return obj != null && hasOwnProperty.call(obj, key);
          };

          // Utility Functions
          // -----------------

          // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
          // previous owner. Returns a reference to the Underscore object.
          _.noConflict = function () {
            root._ = previousUnderscore;
            return this;
          };

          // Keep the identity function around for default iteratees.
          _.identity = function (value) {
            return value;
          };

          // Predicate-generating functions. Often useful outside of Underscore.
          _.constant = function (value) {
            return function () {
              return value;
            };
          };
          _.noop = function () {};
          _.property = property;

          // Generates a function for a given object that returns a given property.
          _.propertyOf = function (obj) {
            return obj == null ? function () {} : function (key) {
              return obj[key];
            };
          };

          // Returns a predicate for checking whether an object has a given set of
          // `key:value` pairs.
          _.matcher = _.matches = function (attrs) {
            attrs = _.extendOwn({}, attrs);
            return function (obj) {
              return _.isMatch(obj, attrs);
            };
          };

          // Run a function **n** times.
          _.times = function (n, iteratee, context) {
            var accum = Array(Math.max(0, n));
            iteratee = optimizeCb(iteratee, context, 1);
            for (var i = 0; i < n; i++) accum[i] = iteratee(i);
            return accum;
          };

          // Return a random integer between min and max (inclusive).
          _.random = function (min, max) {
            if (max == null) {
              max = min;
              min = 0;
            }
            return min + Math.floor(Math.random() * (max - min + 1));
          };

          // A (possibly faster) way to get the current timestamp as an integer.
          _.now = Date.now || function () {
            return new Date().getTime();
          };

          // List of HTML entities for escaping.
          var escapeMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            '`': '&#x60;'
          };
          var unescapeMap = _.invert(escapeMap);

          // Functions for escaping and unescaping strings to/from HTML interpolation.
          var createEscaper = function (map) {
            var escaper = function (match) {
              return map[match];
            };
            // Regexes for identifying a key that needs to be escaped
            var source = '(?:' + _.keys(map).join('|') + ')';
            var testRegexp = RegExp(source);
            var replaceRegexp = RegExp(source, 'g');
            return function (string) {
              string = string == null ? '' : '' + string;
              return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
            };
          };
          _.escape = createEscaper(escapeMap);
          _.unescape = createEscaper(unescapeMap);

          // If the value of the named `property` is a function then invoke it with the
          // `object` as context; otherwise, return it.
          _.result = function (object, property, fallback) {
            var value = object == null ? void 0 : object[property];
            if (value === void 0) {
              value = fallback;
            }
            return _.isFunction(value) ? value.call(object) : value;
          };

          // Generate a unique integer id (unique within the entire client session).
          // Useful for temporary DOM ids.
          var idCounter = 0;
          _.uniqueId = function (prefix) {
            var id = ++idCounter + '';
            return prefix ? prefix + id : id;
          };

          // By default, Underscore uses ERB-style template delimiters, change the
          // following template settings to use alternative delimiters.
          _.templateSettings = {
            evaluate: /<%([\s\S]+?)%>/g,
            interpolate: /<%=([\s\S]+?)%>/g,
            escape: /<%-([\s\S]+?)%>/g
          };

          // When customizing `templateSettings`, if you don't want to define an
          // interpolation, evaluation or escaping regex, we need one that is
          // guaranteed not to match.
          var noMatch = /(.)^/;

          // Certain characters need to be escaped so that they can be put into a
          // string literal.
          var escapes = {
            "'": "'",
            '\\': '\\',
            '\r': 'r',
            '\n': 'n',
            '\u2028': 'u2028',
            '\u2029': 'u2029'
          };
          var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
          var escapeChar = function (match) {
            return '\\' + escapes[match];
          };

          // JavaScript micro-templating, similar to John Resig's implementation.
          // Underscore templating handles arbitrary delimiters, preserves whitespace,
          // and correctly escapes quotes within interpolated code.
          // NB: `oldSettings` only exists for backwards compatibility.
          _.template = function (text, settings, oldSettings) {
            if (!settings && oldSettings) settings = oldSettings;
            settings = _.defaults({}, settings, _.templateSettings);

            // Combine delimiters into one regular expression via alternation.
            var matcher = RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join('|') + '|$', 'g');

            // Compile the template source, escaping string literals appropriately.
            var index = 0;
            var source = "__p+='";
            text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
              source += text.slice(index, offset).replace(escaper, escapeChar);
              index = offset + match.length;
              if (escape) {
                source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
              } else if (interpolate) {
                source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
              } else if (evaluate) {
                source += "';\n" + evaluate + "\n__p+='";
              }

              // Adobe VMs need the match returned to produce the correct offest.
              return match;
            });
            source += "';\n";

            // If a variable is not specified, place data values in local scope.
            if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
            source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
            try {
              var render = new Function(settings.variable || 'obj', '_', source);
            } catch (e) {
              e.source = source;
              throw e;
            }
            var template = function (data) {
              return render.call(this, data, _);
            };

            // Provide the compiled source as a convenience for precompilation.
            var argument = settings.variable || 'obj';
            template.source = 'function(' + argument + '){\n' + source + '}';
            return template;
          };

          // Add a "chain" function. Start chaining a wrapped Underscore object.
          _.chain = function (obj) {
            var instance = _(obj);
            instance._chain = true;
            return instance;
          };

          // OOP
          // ---------------
          // If Underscore is called as a function, it returns a wrapped object that
          // can be used OO-style. This wrapper holds altered versions of all the
          // underscore functions. Wrapped objects may be chained.

          // Helper function to continue chaining intermediate results.
          var result = function (instance, obj) {
            return instance._chain ? _(obj).chain() : obj;
          };

          // Add your own custom functions to the Underscore object.
          _.mixin = function (obj) {
            _.each(_.functions(obj), function (name) {
              var func = _[name] = obj[name];
              _.prototype[name] = function () {
                var args = [this._wrapped];
                push.apply(args, arguments);
                return result(this, func.apply(_, args));
              };
            });
          };

          // Add all of the Underscore functions to the wrapper object.
          _.mixin(_);

          // Add all mutator Array functions to the wrapper.
          _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
            var method = ArrayProto[name];
            _.prototype[name] = function () {
              var obj = this._wrapped;
              method.apply(obj, arguments);
              if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
              return result(this, obj);
            };
          });

          // Add all accessor Array functions to the wrapper.
          _.each(['concat', 'join', 'slice'], function (name) {
            var method = ArrayProto[name];
            _.prototype[name] = function () {
              return result(this, method.apply(this._wrapped, arguments));
            };
          });

          // Extracts the result from a wrapped and chained object.
          _.prototype.value = function () {
            return this._wrapped;
          };

          // Provide unwrapping proxy for some methods used in engine operations
          // such as arithmetic and JSON stringification.
          _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
          _.prototype.toString = function () {
            return '' + this._wrapped;
          };

          // AMD registration happens at the end for compatibility with AMD loaders
          // that may not enforce next-turn semantics on modules. Even though general
          // practice for AMD registration is to be anonymous, underscore registers
          // as a named module because, like jQuery, it is a base library that is
          // popular enough to be bundled in a third party lib, but not be part of
          // an AMD load request. Those cases could generate an error when an
          // anonymous define() is called outside of a loader request.
          if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return _;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          }
        }).call(this);

        /***/
      },,,,,,,,,,,,,,,,,,,,,,,,,, /* 104 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _scrollUtils = __webpack_require__(136);
        var _shallowequal = __webpack_require__(69);
        var _shallowequal2 = _interopRequireDefault(_shallowequal);
        var _RowsContainer = __webpack_require__(45);
        var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
        var _RowGroup = __webpack_require__(121);
        var _RowGroup2 = _interopRequireDefault(_RowGroup);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var joinClasses = __webpack_require__(5);
        var Row = __webpack_require__(42);
        var cellMetaDataShape = __webpack_require__(11);
        var RowUtils = __webpack_require__(44);
        __webpack_require__(20);
        var Canvas = function (_React$Component) {
          _inherits(Canvas, _React$Component);
          function Canvas() {
            var _temp, _this, _ret;
            _classCallCheck(this, Canvas);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              displayStart: _this.props.displayStart,
              displayEnd: _this.props.displayEnd,
              scrollingTimeout: null
            }, _this._currentRowsLength = 0, _this._currentRowsRange = {
              start: 0,
              end: 0
            }, _this._scroll = {
              scrollTop: 0,
              scrollLeft: 0
            }, _this.appendScrollShim = function () {
              if (!_this._scrollShim) {
                var size = _this._scrollShimSize();
                var shim = (0, _scrollUtils.createScrollShim)(size);
                _this.canvas.appendChild(shim);
                _this._scrollShim = shim;
              }
              _this._scheduleRemoveScrollShim();
            }, _this._scrollShimSize = function () {
              return {
                width: _this.props.width,
                height: _this.props.length * _this.props.rowHeight
              };
            }, _this._scheduleRemoveScrollShim = function () {
              if (_this._scheduleRemoveScrollShimTimer) {
                clearTimeout(_this._scheduleRemoveScrollShimTimer);
              }
              _this._scheduleRemoveScrollShimTimer = setTimeout(_this._removeScrollShim, 200);
            }, _this._removeScrollShim = function () {
              if (_this._scrollShim) {
                _this._scrollShim.parentNode.removeChild(_this._scrollShim);
                _this._scrollShim = undefined;
              }
            }, _this.onRows = function () {
              if (_this._currentRowsRange !== {
                start: 0,
                end: 0
              }) {
                _this.props.onRows(_this._currentRowsRange);
                _this._currentRowsRange = {
                  start: 0,
                  end: 0
                };
              }
            }, _this.onScroll = function (e) {
              if (_this.canvas !== e.target) {
                return;
              }
              _this.appendScrollShim();
              var scrollLeft = e.target.scrollLeft;
              var scrollTop = e.target.scrollTop;
              var scroll = {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft
              };
              _this._scroll = scroll;
              _this.props.onScroll(scroll);
            }, _this.getRows = function (displayStart, displayEnd) {
              _this._currentRowsRange = {
                start: displayStart,
                end: displayEnd
              };
              if (Array.isArray(_this.props.rowGetter)) {
                return _this.props.rowGetter.slice(displayStart, displayEnd);
              }
              var rows = [];
              var i = displayStart;
              while (i < displayEnd) {
                var row = _this.props.rowGetter(i);
                var subRowDetails = {};
                if (_this.props.getSubRowDetails) {
                  subRowDetails = _this.props.getSubRowDetails(row);
                }
                rows.push({
                  row: row,
                  subRowDetails: subRowDetails
                });
                i++;
              }
              return rows;
            }, _this.getScrollbarWidth = function () {
              // Get the scrollbar width
              var scrollbarWidth = _this.canvas.offsetWidth - _this.canvas.clientWidth;
              return scrollbarWidth;
            }, _this.getScroll = function () {
              var _this$canvas = _this.canvas,
                scrollTop = _this$canvas.scrollTop,
                scrollLeft = _this$canvas.scrollLeft;
              return {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft
              };
            }, _this.isRowSelected = function (idx, row) {
              // Use selectedRows if set
              if (_this.props.selectedRows !== null) {
                var selectedRows = _this.props.selectedRows.filter(function (r) {
                  var rowKeyValue = row.get ? row.get(_this.props.rowKey) : row[_this.props.rowKey];
                  return r[_this.props.rowKey] === rowKeyValue;
                });
                return selectedRows.length > 0 && selectedRows[0].isSelected;
              }

              // Else use new rowSelection props
              if (_this.props.rowSelection) {
                var _this$props$rowSelect = _this.props.rowSelection,
                  keys = _this$props$rowSelect.keys,
                  indexes = _this$props$rowSelect.indexes,
                  isSelectedKey = _this$props$rowSelect.isSelectedKey;
                return RowUtils.isRowSelected(keys, indexes, isSelectedKey, row, idx);
              }
              return false;
            }, _this.setScrollLeft = function (scrollLeft) {
              if (_this._currentRowsLength !== 0) {
                if (!_this.rows) return;
                for (var i = 0, len = _this._currentRowsLength; i < len; i++) {
                  if (_this.rows[i]) {
                    var row = _this.getRowByRef(i);
                    if (row && row.setScrollLeft) {
                      row.setScrollLeft(scrollLeft);
                    }
                  }
                }
              }
            }, _this.getRowByRef = function (i) {
              // check if wrapped with React DND drop target
              var wrappedRow = _this.rows[i].getDecoratedComponentInstance ? _this.rows[i].getDecoratedComponentInstance(i) : null;
              if (wrappedRow) {
                return wrappedRow.row;
              }
              return _this.rows[i];
            }, _this.renderRow = function (props) {
              var row = props.row;
              if (row.__metaData && row.__metaData.getRowRenderer) {
                return row.__metaData.getRowRenderer(_this.props, props.idx);
              }
              if (row.__metaData && row.__metaData.isGroup) {
                return React.createElement(_RowGroup2['default'], _extends({}, props, row.__metaData, {
                  name: row.name,
                  renderer: _this.props.rowGroupRenderer
                }));
              }
              var RowsRenderer = _this.props.rowRenderer;
              if (typeof RowsRenderer === 'function') {
                return React.createElement(RowsRenderer, props);
              }
              if (React.isValidElement(_this.props.rowRenderer)) {
                return React.cloneElement(_this.props.rowRenderer, props);
              }
            }, _this.renderPlaceholder = function (key, height) {
              // just renders empty cells
              // if we wanted to show gridlines, we'd need classes and position as with renderScrollingPlaceholder
              return React.createElement('div', {
                key: key,
                style: {
                  height: height
                }
              }, _this.props.columns.map(function (column, idx) {
                return React.createElement('div', {
                  style: {
                    width: column.width
                  },
                  key: idx
                });
              }));
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Canvas.prototype.componentWillMount = function componentWillMount() {
            this.rows = [];
            this._currentRowsLength = 0;
            this._currentRowsRange = {
              start: 0,
              end: 0
            };
            this._scroll = {
              scrollTop: 0,
              scrollLeft: 0
            };
          };
          Canvas.prototype.componentDidMount = function componentDidMount() {
            this.onRows();
          };
          Canvas.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (nextProps.displayStart !== this.state.displayStart || nextProps.displayEnd !== this.state.displayEnd) {
              this.setState({
                displayStart: nextProps.displayStart,
                displayEnd: nextProps.displayEnd
              });
            }
          };
          Canvas.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            var shouldUpdate = nextState.displayStart !== this.state.displayStart || nextState.displayEnd !== this.state.displayEnd || nextState.scrollingTimeout !== this.state.scrollingTimeout || this.props.scrollToRowIndex !== nextProps.scrollToRowIndex || nextProps.rowsCount !== this.props.rowsCount || nextProps.rowHeight !== this.props.rowHeight || nextProps.columns !== this.props.columns || nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.cellMetaData !== this.props.cellMetaData || this.props.colDisplayStart !== nextProps.colDisplayStart || this.props.colDisplayEnd !== nextProps.colDisplayEnd || this.props.colVisibleStart !== nextProps.colVisibleStart || this.props.colVisibleEnd !== nextProps.colVisibleEnd || !(0, _shallowequal2['default'])(nextProps.style, this.props.style) || this.props.isScrolling !== nextProps.isScrolling;
            return shouldUpdate;
          };
          Canvas.prototype.componentWillUnmount = function componentWillUnmount() {
            this._currentRowsLength = 0;
            this._currentRowsRange = {
              start: 0,
              end: 0
            };
            this._scroll = {
              scrollTop: 0,
              scrollLeft: 0
            };
          };
          Canvas.prototype.componentDidUpdate = function componentDidUpdate() {
            if (this._scroll.scrollTop !== 0 && this._scroll.scrollLeft !== 0) {
              this.setScrollLeft(this._scroll.scrollLeft);
            }
            if (this.props.scrollToRowIndex !== 0) {
              this.canvas.scrollTop = Math.min(this.props.scrollToRowIndex * this.props.rowHeight, this.props.rowsCount * this.props.rowHeight - this.props.height);
            }
            this.onRows();
          };
          Canvas.prototype.render = function render() {
            var _this2 = this;
            var _state = this.state,
              displayStart = _state.displayStart,
              displayEnd = _state.displayEnd;
            var _props = this.props,
              rowHeight = _props.rowHeight,
              rowsCount = _props.rowsCount;
            var rows = this.getRows(displayStart, displayEnd).map(function (r, idx) {
              return _this2.renderRow({
                key: 'row-' + (displayStart + idx),
                ref: function ref(node) {
                  return _this2.rows[idx] = node;
                },
                idx: displayStart + idx,
                visibleStart: _this2.props.visibleStart,
                visibleEnd: _this2.props.visibleEnd,
                row: r.row,
                height: rowHeight,
                onMouseOver: _this2.onMouseOver,
                columns: _this2.props.columns,
                isSelected: _this2.isRowSelected(displayStart + idx, r.row, displayStart, displayEnd),
                expandedRows: _this2.props.expandedRows,
                cellMetaData: _this2.props.cellMetaData,
                subRowDetails: r.subRowDetails,
                colVisibleStart: _this2.props.colVisibleStart,
                colVisibleEnd: _this2.props.colVisibleEnd,
                colDisplayStart: _this2.props.colDisplayStart,
                colDisplayEnd: _this2.props.colDisplayEnd,
                isScrolling: _this2.props.isScrolling
              });
            });
            this._currentRowsLength = rows.length;
            if (displayStart > 0) {
              rows.unshift(this.renderPlaceholder('top', displayStart * rowHeight));
            }
            if (rowsCount - displayEnd > 0) {
              rows.push(this.renderPlaceholder('bottom', (rowsCount - displayEnd) * rowHeight));
            }
            var style = {
              position: 'absolute',
              top: 0,
              left: 0,
              overflowX: 'auto',
              overflowY: 'scroll',
              width: this.props.totalWidth,
              height: this.props.height
            };
            return React.createElement('div', {
              ref: function ref(div) {
                _this2.canvas = div;
              },
              style: style,
              onScroll: this.onScroll,
              className: joinClasses('react-grid-Canvas', this.props.className, {
                opaque: this.props.cellMetaData.selected && this.props.cellMetaData.selected.active
              })
            }, React.createElement(_RowsContainer2['default'], {
              width: this.props.width,
              rows: rows,
              contextMenu: this.props.contextMenu,
              rowIdx: this.props.cellMetaData.selected.rowIdx,
              idx: this.props.cellMetaData.selected.idx
            }));
          };
          return Canvas;
        }(React.Component);
        Canvas.displayName = 'Canvas';
        Canvas.propTypes = {
          rowRenderer: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].element]),
          rowHeight: _propTypes2['default'].number.isRequired,
          height: _propTypes2['default'].number.isRequired,
          width: _propTypes2['default'].number,
          totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
          style: _propTypes2['default'].string,
          className: _propTypes2['default'].string,
          displayStart: _propTypes2['default'].number.isRequired,
          displayEnd: _propTypes2['default'].number.isRequired,
          visibleStart: _propTypes2['default'].number.isRequired,
          visibleEnd: _propTypes2['default'].number.isRequired,
          colVisibleStart: _propTypes2['default'].number.isRequired,
          colVisibleEnd: _propTypes2['default'].number.isRequired,
          colDisplayStart: _propTypes2['default'].number.isRequired,
          colDisplayEnd: _propTypes2['default'].number.isRequired,
          rowsCount: _propTypes2['default'].number.isRequired,
          rowGetter: _propTypes2['default'].oneOfType([_propTypes2['default'].func.isRequired, _propTypes2['default'].array.isRequired]),
          expandedRows: _propTypes2['default'].array,
          onRows: _propTypes2['default'].func,
          onScroll: _propTypes2['default'].func,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape).isRequired,
          selectedRows: _propTypes2['default'].array,
          rowKey: _propTypes2['default'].string,
          rowScrollTimeout: _propTypes2['default'].number,
          scrollToRowIndex: _propTypes2['default'].number,
          contextMenu: _propTypes2['default'].element,
          getSubRowDetails: _propTypes2['default'].func,
          rowSelection: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
            indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
          }), _propTypes2['default'].shape({
            isSelectedKey: _propTypes2['default'].string.isRequired
          }), _propTypes2['default'].shape({
            keys: _propTypes2['default'].shape({
              values: _propTypes2['default'].array.isRequired,
              rowKey: _propTypes2['default'].string.isRequired
            }).isRequired
          })]),
          rowGroupRenderer: _propTypes2['default'].func,
          isScrolling: _propTypes2['default'].bool,
          length: _propTypes2['default'].number
        };
        Canvas.defaultProps = {
          rowRenderer: Row,
          onRows: function onRows() {},
          selectedRows: [],
          rowScrollTimeout: 0
        };
        module.exports = Canvas;

        /***/
      }, /* 105 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _classnames = __webpack_require__(5);
        var _classnames2 = _interopRequireDefault(_classnames);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _CellActionShape = __webpack_require__(117);
        var _CellActionShape2 = _interopRequireDefault(_CellActionShape);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var CellAction = function (_React$Component) {
          _inherits(CellAction, _React$Component);
          function CellAction() {
            var _temp, _this, _ret;
            _classCallCheck(this, CellAction);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              isMenuOpen: false
            }, _this.onToggleMenu = function () {
              _this.setState(function (prevState) {
                return {
                  isMenuOpen: !prevState.isMenuOpen
                };
              });
            }, _this.onHideMenu = function () {
              _this.setState({
                isMenuOpen: false
              });
            }, _this.onGetMenuOptions = function () {
              return _this.props.action.actions.map(function (action, index) {
                return _react2['default'].createElement('span', {
                  key: index,
                  onClick: action.callback
                }, action.text);
              });
            }, _this.isActionMenu = function () {
              return !_this.props.action.callback && _this.props.action.actions && _this.props.action.actions.length;
            }, _this.onActionButtonBlur = function () {
              if (_this.isActionMenu()) {
                _this.onHideMenu();
              }
            }, _this.onActionIconClick = function () {
              if (!_this.isActionMenu()) {
                _this.props.action.callback();
              } else if (_this.props.action.actions && _this.props.action.actions.length) {
                _this.onToggleMenu();
              }
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          CellAction.prototype.render = function render() {
            var isActionMenu = this.isActionMenu();
            var cellActionClasses = (0, _classnames2['default'])('rdg-cell-action', {
              'rdg-cell-action-last': this.props.isFirst
            });
            var actionButtonClasses = (0, _classnames2['default'])('rdg-cell-action-button', {
              'rdg-cell-action-button-toggled': this.state.isMenuOpen
            });
            return _react2['default'].createElement('div', {
              className: cellActionClasses,
              onMouseLeave: this.onActionButtonBlur
            }, _react2['default'].createElement('div', {
              className: actionButtonClasses,
              onClick: this.onActionIconClick
            }, _react2['default'].createElement('span', {
              className: this.props.action.icon
            })), isActionMenu && this.state.isMenuOpen && _react2['default'].createElement('div', {
              className: 'rdg-cell-action-menu'
            }, this.onGetMenuOptions()));
          };
          return CellAction;
        }(_react2['default'].Component);
        CellAction.propTypes = {
          action: _propTypes2['default'].shape(_CellActionShape2['default']).isRequired,
          isFirst: _propTypes2['default'].bool.isRequired
        };
        exports['default'] = CellAction;

        /***/
      }, /* 106 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _AppConstants = __webpack_require__(30);
        var _AppConstants2 = _interopRequireDefault(_AppConstants);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var CellExpand = function (_React$Component) {
          _inherits(CellExpand, _React$Component);
          function CellExpand(props) {
            _classCallCheck(this, CellExpand);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.onCellExpand = function (e) {
              _this.setState({
                expanded: !_this.state.expanded
              });
              _this.props.onCellExpand(e);
            };
            var expanded = props.expandableOptions && props.expandableOptions.expanded;
            _this.state = {
              expanded: expanded
            };
            return _this;
          }
          CellExpand.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var expanded = nextProps.expandableOptions && nextProps.expandableOptions.expanded;
            if (this.state.expanded !== expanded) {
              this.setState({
                expanded: expanded
              });
            }
          };
          CellExpand.prototype.render = function render() {
            return _react2['default'].createElement('span', {
              className: 'rdg-cell-expand',
              onClick: this.onCellExpand
            }, this.state.expanded ? _AppConstants2['default'].CellExpand.DOWN_TRIANGLE : _AppConstants2['default'].CellExpand.RIGHT_TRIANGLE);
          };
          return CellExpand;
        }(_react2['default'].Component);
        CellExpand.propTypes = {
          expandableOptions: _propTypes2['default'].object.isRequired,
          onCellExpand: _propTypes2['default'].func.isRequired
        };
        exports['default'] = CellExpand;

        /***/
      }, /* 107 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _classnames = __webpack_require__(5);
        var _classnames2 = _interopRequireDefault(_classnames);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var ChildRowDeleteButton = function ChildRowDeleteButton(_ref) {
          var treeDepth = _ref.treeDepth,
            cellHeight = _ref.cellHeight,
            siblingIndex = _ref.siblingIndex,
            numberSiblings = _ref.numberSiblings,
            onDeleteSubRow = _ref.onDeleteSubRow,
            isDeleteSubRowEnabled = _ref.isDeleteSubRowEnabled,
            _ref$allowAddChildRow = _ref.allowAddChildRow,
            allowAddChildRow = _ref$allowAddChildRow === undefined ? true : _ref$allowAddChildRow;
          var lastSibling = siblingIndex === numberSiblings - 1;
          var className = (0, _classnames2['default'])({
            'rdg-child-row-action-cross': allowAddChildRow === true || !lastSibling
          }, {
            'rdg-child-row-action-cross-last': allowAddChildRow === false && (lastSibling || numberSiblings === 1)
          });
          var height = 12;
          var width = 12;
          var left = treeDepth * 15;
          var top = (cellHeight - 12) / 2;
          return _react2['default'].createElement('div', null, _react2['default'].createElement('div', {
            className: className
          }), isDeleteSubRowEnabled && _react2['default'].createElement('div', {
            style: {
              left: left,
              top: top,
              width: width,
              height: height
            },
            className: 'rdg-child-row-btn',
            onClick: onDeleteSubRow
          }, _react2['default'].createElement('div', {
            className: 'glyphicon glyphicon-remove-sign'
          })));
        };
        exports['default'] = ChildRowDeleteButton;

        /***/
      }, /* 108 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var isValidElement = __webpack_require__(2).isValidElement;
        module.exports = function sameColumn(a, b) {
          var k = void 0;
          for (k in a) {
            if (a.hasOwnProperty(k)) {
              if (typeof a[k] === 'function' && typeof b[k] === 'function' || isValidElement(a[k]) && isValidElement(b[k])) {
                continue;
              }
              if (!b.hasOwnProperty(k) || a[k] !== b[k]) {
                return false;
              }
            }
          }
          for (k in b) {
            if (b.hasOwnProperty(k) && !a.hasOwnProperty(k)) {
              return false;
            }
          }
          return true;
        };

        /***/
      }, /* 109 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var createObjectWithProperties = __webpack_require__(14);
        __webpack_require__(15);

        // The list of the propTypes that we want to include in the Draggable div
        var knownDivPropertyKeys = ['onDragStart', 'onDragEnd', 'onDrag', 'style'];
        var Draggable = function (_React$Component) {
          _inherits(Draggable, _React$Component);
          function Draggable() {
            var _temp, _this, _ret;
            _classCallCheck(this, Draggable);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              drag: null
            }, _this.onMouseDown = function (e) {
              var drag = _this.props.onDragStart(e);
              if (e.preventDefault) {
                e.preventDefault();
              }
              if (drag === null && e.button !== 0) {
                return;
              }
              window.addEventListener('mouseup', _this.onMouseUp);
              window.addEventListener('mousemove', _this.onMouseMove);
              window.addEventListener('touchend', _this.onMouseUp);
              window.addEventListener('touchmove', _this.onMouseMove);
              _this.setState({
                drag: drag
              });
            }, _this.onMouseMove = function (e) {
              if (_this.state.drag === null) {
                return;
              }
              if (e.preventDefault) {
                e.preventDefault();
              }
              _this.props.onDrag(e);
            }, _this.onMouseUp = function (e) {
              _this.cleanUp();
              _this.props.onDragEnd(e, _this.state.drag);
              _this.setState({
                drag: null
              });
            }, _this.cleanUp = function () {
              window.removeEventListener('mouseup', _this.onMouseUp);
              window.removeEventListener('mousemove', _this.onMouseMove);
              window.removeEventListener('touchend', _this.onMouseUp);
              window.removeEventListener('touchmove', _this.onMouseMove);
            }, _this.getKnownDivProps = function () {
              return createObjectWithProperties(_this.props, knownDivPropertyKeys);
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Draggable.prototype.componentWillUnmount = function componentWillUnmount() {
            this.cleanUp();
          };
          Draggable.prototype.render = function render() {
            return React.createElement('div', _extends({}, this.getKnownDivProps(), {
              onMouseDown: this.onMouseDown,
              onTouchStart: this.onMouseDown,
              className: 'react-grid-HeaderCell__draggable'
            }));
          };
          return Draggable;
        }(React.Component);
        Draggable.propTypes = {
          onDragStart: _propTypes2['default'].func,
          onDragEnd: _propTypes2['default'].func,
          onDrag: _propTypes2['default'].func,
          component: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].constructor]),
          style: _propTypes2['default'].object
        };
        Draggable.defaultProps = {
          onDragStart: function onDragStart() {
            return true;
          },
          onDragEnd: function onDragEnd() {},
          onDrag: function onDrag() {}
        };
        module.exports = Draggable;

        /***/
      }, /* 110 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _ColumnUtils = __webpack_require__(6);
        var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var EmptyChildRow = function (_React$Component) {
          _inherits(EmptyChildRow, _React$Component);
          function EmptyChildRow() {
            _classCallCheck(this, EmptyChildRow);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this));
            _this.onAddSubRow = _this.onAddSubRow.bind(_this);
            return _this;
          }
          EmptyChildRow.prototype.onAddSubRow = function onAddSubRow() {
            this.props.onAddSubRow(this.props.parentRowId);
          };
          EmptyChildRow.prototype.getFixedColumnsWidth = function getFixedColumnsWidth() {
            var fixedWidth = 0;
            var size = _ColumnUtils2['default'].getSize(this.props.columns);
            for (var i = 0; i < size; i++) {
              var column = _ColumnUtils2['default'].getColumn(this.props.columns, i);
              if (column) {
                if (_ColumnUtils2['default'].getValue(column, 'locked')) {
                  fixedWidth += _ColumnUtils2['default'].getValue(column, 'width');
                }
              }
            }
            return fixedWidth;
          };
          EmptyChildRow.prototype.render = function render() {
            var _this2 = this;
            var _props = this.props,
              cellHeight = _props.cellHeight,
              treeDepth = _props.treeDepth;
            var height = 12;
            var width = 12;
            var left = treeDepth * 15;
            var top = (cellHeight - 12) / 2;
            var style = {
              height: cellHeight,
              borderBottom: '1px solid #dddddd'
            };
            var expandColumn = _ColumnUtils2['default'].getColumn(this.props.columns.filter(function (c) {
              return c.key === _this2.props.expandColumnKey;
            }), 0);
            var cellLeft = expandColumn ? expandColumn.left : 0;
            return _react2['default'].createElement('div', {
              className: 'react-grid-Row rdg-add-child-row-container',
              style: style
            }, _react2['default'].createElement('div', {
              className: 'react-grid-Cell',
              style: {
                position: 'absolute',
                height: cellHeight,
                width: '100%',
                left: cellLeft
              }
            }, _react2['default'].createElement('div', {
              className: 'rdg-empty-child-row',
              style: {
                marginLeft: '30px',
                lineHeight: cellHeight + 'px'
              }
            }, _react2['default'].createElement('div', {
              className: '\'rdg-child-row-action-cross rdg-child-row-action-cross-last'
            }), _react2['default'].createElement('div', {
              style: {
                left: left,
                top: top,
                width: width,
                height: height
              },
              className: 'rdg-child-row-btn',
              onClick: this.onAddSubRow
            }, _react2['default'].createElement('div', {
              className: 'glyphicon glyphicon-plus-sign'
            })))));
          };
          return EmptyChildRow;
        }(_react2['default'].Component);
        EmptyChildRow.propTypes = {
          treeDepth: _propTypes2['default'].number.isRequired,
          cellHeight: _propTypes2['default'].number.isRequired,
          onAddSubRow: _propTypes2['default'].func.isRequired,
          parentRowId: _propTypes2['default'].number,
          columns: _propTypes2['default'].array.isRequired,
          expandColumnKey: _propTypes2['default'].string.isRequired
        };
        exports['default'] = EmptyChildRow;

        /***/
      }, /* 111 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var ReactDOM = __webpack_require__(9);
        var Header = __webpack_require__(112);
        var Viewport = __webpack_require__(122);
        var cellMetaDataShape = __webpack_require__(11);
        __webpack_require__(20);
        var Grid = function (_React$Component) {
          _inherits(Grid, _React$Component);
          function Grid() {
            var _temp, _this, _ret;
            _classCallCheck(this, Grid);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getStyle = function () {
              return {
                overflow: 'hidden',
                outline: 0,
                position: 'relative',
                minHeight: _this.props.minHeight
              };
            }, _this._onScroll = function () {
              if (_this._scrollLeft !== undefined) {
                _this.header.setScrollLeft(_this._scrollLeft);
                if (_this.viewport) {
                  _this.viewport.setScrollLeft(_this._scrollLeft);
                }
              }
            }, _this.onScroll = function (props) {
              if (_this._scrollLeft !== props.scrollLeft) {
                _this._scrollLeft = props.scrollLeft;
                _this._onScroll();
              }
            }, _this.onHeaderScroll = function (e) {
              var scrollLeft = e.target.scrollLeft;
              if (_this._scrollLeft !== scrollLeft) {
                _this._scrollLeft = scrollLeft;
                _this.header.setScrollLeft(scrollLeft);
                var canvas = ReactDOM.findDOMNode(_this.viewport.canvas);
                canvas.scrollLeft = scrollLeft;
                _this.viewport.canvas.setScrollLeft(scrollLeft);
              }
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Grid.prototype.componentDidMount = function componentDidMount() {
            this._scrollLeft = this.viewport ? this.viewport.getScroll().scrollLeft : 0;
            this._onScroll();
          };
          Grid.prototype.componentDidUpdate = function componentDidUpdate() {
            this._onScroll();
          };
          Grid.prototype.componentWillMount = function componentWillMount() {
            this._scrollLeft = undefined;
          };
          Grid.prototype.componentWillUnmount = function componentWillUnmount() {
            this._scrollLeft = undefined;
          };
          Grid.prototype.render = function render() {
            var _this2 = this;
            var headerRows = this.props.headerRows || [{
              ref: function ref(node) {
                return _this2.row = node;
              }
            }];
            var EmptyRowsView = this.props.emptyRowsView;
            return React.createElement('div', {
              style: this.getStyle(),
              className: 'react-grid-Grid'
            }, React.createElement(Header, {
              ref: function ref(input) {
                _this2.header = input;
              },
              columnMetrics: this.props.columnMetrics,
              onColumnResize: this.props.onColumnResize,
              height: this.props.rowHeight,
              totalWidth: this.props.totalWidth,
              headerRows: headerRows,
              sortColumn: this.props.sortColumn,
              sortDirection: this.props.sortDirection,
              draggableHeaderCell: this.props.draggableHeaderCell,
              onSort: this.props.onSort,
              onHeaderDrop: this.props.onHeaderDrop,
              onScroll: this.onHeaderScroll,
              getValidFilterValues: this.props.getValidFilterValues,
              cellMetaData: this.props.cellMetaData
            }), this.props.rowsCount >= 1 || this.props.rowsCount === 0 && !this.props.emptyRowsView ? React.createElement('div', {
              ref: function ref(node) {
                _this2.viewPortContainer = node;
              },
              tabIndex: this.props.tabIndex,
              onKeyDown: this.props.onViewportKeydown,
              onKeyUp: this.props.onViewportKeyup,
              onClick: this.props.onViewportClick,
              onDoubleClick: this.props.onViewportDoubleClick,
              onDragStart: this.props.onViewportDragStart,
              onDragEnd: this.props.onViewportDragEnd
            }, React.createElement(Viewport, {
              ref: function ref(node) {
                _this2.viewport = node;
              },
              rowKey: this.props.rowKey,
              width: this.props.columnMetrics.width,
              rowHeight: this.props.rowHeight,
              rowRenderer: this.props.rowRenderer,
              rowGetter: this.props.rowGetter,
              rowsCount: this.props.rowsCount,
              selectedRows: this.props.selectedRows,
              expandedRows: this.props.expandedRows,
              columnMetrics: this.props.columnMetrics,
              totalWidth: this.props.totalWidth,
              onScroll: this.onScroll,
              onRows: this.props.onRows,
              cellMetaData: this.props.cellMetaData,
              rowOffsetHeight: this.props.rowOffsetHeight || this.props.rowHeight * headerRows.length,
              minHeight: this.props.minHeight,
              rowScrollTimeout: this.props.rowScrollTimeout,
              scrollToRowIndex: this.props.scrollToRowIndex,
              contextMenu: this.props.contextMenu,
              rowSelection: this.props.rowSelection,
              getSubRowDetails: this.props.getSubRowDetails,
              rowGroupRenderer: this.props.rowGroupRenderer,
              overScan: this.props.overScan
            })) : React.createElement('div', {
              ref: function ref(node) {
                _this2.emptyView = node;
              },
              className: 'react-grid-Empty'
            }, React.createElement(EmptyRowsView, null)));
          };
          return Grid;
        }(React.Component);
        Grid.displayName = 'Grid';
        Grid.propTypes = {
          rowGetter: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]).isRequired,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].object]),
          tabIndex: _propTypes2['default'].number,
          columnMetrics: _propTypes2['default'].object,
          minHeight: _propTypes2['default'].number,
          totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
          headerRows: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]),
          rowHeight: _propTypes2['default'].number,
          rowRenderer: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].func]),
          emptyRowsView: _propTypes2['default'].func,
          expandedRows: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]),
          selectedRows: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]),
          rowSelection: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
            indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
          }), _propTypes2['default'].shape({
            isSelectedKey: _propTypes2['default'].string.isRequired
          }), _propTypes2['default'].shape({
            keys: _propTypes2['default'].shape({
              values: _propTypes2['default'].array.isRequired,
              rowKey: _propTypes2['default'].string.isRequired
            }).isRequired
          })]),
          rowsCount: _propTypes2['default'].number,
          onRows: _propTypes2['default'].func,
          sortColumn: _propTypes2['default'].string,
          sortDirection: _propTypes2['default'].oneOf(['ASC', 'DESC', 'NONE']),
          rowOffsetHeight: _propTypes2['default'].number.isRequired,
          onViewportKeydown: _propTypes2['default'].func.isRequired,
          onViewportKeyup: _propTypes2['default'].func,
          onViewportDragStart: _propTypes2['default'].func.isRequired,
          onViewportDragEnd: _propTypes2['default'].func.isRequired,
          onViewportClick: _propTypes2['default'].func.isRequired,
          onViewportDoubleClick: _propTypes2['default'].func.isRequired,
          onColumnResize: _propTypes2['default'].func,
          onSort: _propTypes2['default'].func,
          onHeaderDrop: _propTypes2['default'].func,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
          rowKey: _propTypes2['default'].string.isRequired,
          rowScrollTimeout: _propTypes2['default'].number,
          scrollToRowIndex: _propTypes2['default'].number,
          contextMenu: _propTypes2['default'].element,
          getSubRowDetails: _propTypes2['default'].func,
          draggableHeaderCell: _propTypes2['default'].func,
          getValidFilterValues: _propTypes2['default'].func,
          rowGroupRenderer: _propTypes2['default'].func,
          overScan: _propTypes2['default'].object
        };
        Grid.defaultProps = {
          rowHeight: 35,
          minHeight: 350,
          tabIndex: 0
        };
        module.exports = Grid;

        /***/
      }, /* 112 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var ReactDOM = __webpack_require__(9);
        var joinClasses = __webpack_require__(5);
        var shallowCloneObject = __webpack_require__(52);
        var ColumnMetrics = __webpack_require__(31);
        var ColumnUtils = __webpack_require__(6);
        var HeaderRow = __webpack_require__(114);
        var getScrollbarSize = __webpack_require__(32);
        var createObjectWithProperties = __webpack_require__(14);
        var cellMetaDataShape = __webpack_require__(11);
        __webpack_require__(15);

        // The list of the propTypes that we want to include in the Header div
        var knownDivPropertyKeys = ['height', 'onScroll'];
        var Header = function (_React$Component) {
          _inherits(Header, _React$Component);
          function Header() {
            var _temp, _this, _ret;
            _classCallCheck(this, Header);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              resizing: null
            }, _this.onColumnResize = function (column, width) {
              var state = _this.state.resizing || _this.props;
              var pos = _this.getColumnPosition(column);
              if (pos != null) {
                var _resizing = {
                  columnMetrics: shallowCloneObject(state.columnMetrics)
                };
                _resizing.columnMetrics = ColumnMetrics.resizeColumn(_resizing.columnMetrics, pos, width);

                // we don't want to influence scrollLeft while resizing
                if (_resizing.columnMetrics.totalWidth < state.columnMetrics.totalWidth) {
                  _resizing.columnMetrics.totalWidth = state.columnMetrics.totalWidth;
                }
                _resizing.column = ColumnUtils.getColumn(_resizing.columnMetrics.columns, pos);
                _this.setState({
                  resizing: _resizing
                });
              }
            }, _this.onColumnResizeEnd = function (column, width) {
              var pos = _this.getColumnPosition(column);
              if (pos !== null && _this.props.onColumnResize) {
                _this.props.onColumnResize(pos, width || column.width);
              }
            }, _this.getHeaderRows = function () {
              var columnMetrics = _this.getColumnMetrics();
              var resizeColumn = void 0;
              if (_this.state.resizing) {
                resizeColumn = _this.state.resizing.column;
              }
              var headerRows = [];
              _this.props.headerRows.forEach(function (row, index) {
                // To allow header filters to be visible
                var rowHeight = 'auto';
                if (row.rowType === 'filter') {
                  rowHeight = '500px';
                }
                var scrollbarSize = getScrollbarSize() > 0 ? getScrollbarSize() : 0;
                var updatedWidth = isNaN(_this.props.totalWidth - scrollbarSize) ? _this.props.totalWidth : _this.props.totalWidth - scrollbarSize;
                var headerRowStyle = {
                  position: 'absolute',
                  top: _this.getCombinedHeaderHeights(index),
                  left: 0,
                  width: updatedWidth,
                  overflowX: 'hidden',
                  minHeight: rowHeight
                };
                headerRows.push(React.createElement(HeaderRow, {
                  key: row.ref,
                  ref: function ref(node) {
                    return row.rowType === 'filter' ? _this.filterRow = node : _this.row = node;
                  },
                  rowType: row.rowType,
                  style: headerRowStyle,
                  onColumnResize: _this.onColumnResize,
                  onColumnResizeEnd: _this.onColumnResizeEnd,
                  width: columnMetrics.width,
                  height: row.height || _this.props.height,
                  columns: columnMetrics.columns,
                  resizing: resizeColumn,
                  draggableHeaderCell: _this.props.draggableHeaderCell,
                  filterable: row.filterable,
                  onFilterChange: row.onFilterChange,
                  onHeaderDrop: _this.props.onHeaderDrop,
                  sortColumn: _this.props.sortColumn,
                  sortDirection: _this.props.sortDirection,
                  onSort: _this.props.onSort,
                  onScroll: _this.props.onScroll,
                  getValidFilterValues: _this.props.getValidFilterValues
                }));
              });
              return headerRows;
            }, _this.getColumnMetrics = function () {
              var columnMetrics = void 0;
              if (_this.state.resizing) {
                columnMetrics = _this.state.resizing.columnMetrics;
              } else {
                columnMetrics = _this.props.columnMetrics;
              }
              return columnMetrics;
            }, _this.getColumnPosition = function (column) {
              var columnMetrics = _this.getColumnMetrics();
              var pos = -1;
              columnMetrics.columns.forEach(function (c, idx) {
                if (c.key === column.key) {
                  pos = idx;
                }
              });
              return pos === -1 ? null : pos;
            }, _this.getCombinedHeaderHeights = function (until) {
              var stopAt = _this.props.headerRows.length;
              if (typeof until !== 'undefined') {
                stopAt = until;
              }
              var height = 0;
              for (var index = 0; index < stopAt; index++) {
                height += _this.props.headerRows[index].height || _this.props.height;
              }
              return height;
            }, _this.getStyle = function () {
              return {
                position: 'relative',
                height: _this.getCombinedHeaderHeights()
              };
            }, _this.setScrollLeft = function (scrollLeft) {
              var node = ReactDOM.findDOMNode(_this.row);
              node.scrollLeft = scrollLeft;
              _this.row.setScrollLeft(scrollLeft);
              if (_this.filterRow) {
                var nodeFilters = ReactDOM.findDOMNode(_this.filterRow);
                nodeFilters.scrollLeft = scrollLeft;
                _this.filterRow.setScrollLeft(scrollLeft);
              }
            }, _this.getKnownDivProps = function () {
              return createObjectWithProperties(_this.props, knownDivPropertyKeys);
            }, _this.onHeaderClick = function () {
              _this.props.cellMetaData.onCellClick({
                rowIdx: -1,
                idx: -1
              });
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Header.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
            this.setState({
              resizing: null
            });
          };
          Header.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            var update = !ColumnMetrics.sameColumns(this.props.columnMetrics.columns, nextProps.columnMetrics.columns, ColumnMetrics.sameColumn) || this.props.totalWidth !== nextProps.totalWidth || this.props.headerRows.length !== nextProps.headerRows.length || this.state.resizing !== nextState.resizing || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
            return update;
          };

          // Set the cell selection to -1 x -1 when clicking on the header

          Header.prototype.render = function render() {
            var className = joinClasses({
              'react-grid-Header': true,
              'react-grid-Header--resizing': !!this.state.resizing
            });
            var headerRows = this.getHeaderRows();
            return React.createElement('div', _extends({}, this.getKnownDivProps(), {
              style: this.getStyle(),
              className: className,
              onClick: this.onHeaderClick
            }), headerRows);
          };
          return Header;
        }(React.Component);
        Header.propTypes = {
          columnMetrics: _propTypes2['default'].shape({
            width: _propTypes2['default'].number.isRequired,
            columns: _propTypes2['default'].any
          }).isRequired,
          totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
          height: _propTypes2['default'].number.isRequired,
          headerRows: _propTypes2['default'].array.isRequired,
          sortColumn: _propTypes2['default'].string,
          sortDirection: _propTypes2['default'].oneOf(['ASC', 'DESC', 'NONE']),
          onSort: _propTypes2['default'].func,
          onColumnResize: _propTypes2['default'].func,
          onScroll: _propTypes2['default'].func,
          onHeaderDrop: _propTypes2['default'].func,
          draggableHeaderCell: _propTypes2['default'].func,
          getValidFilterValues: _propTypes2['default'].func,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape)
        };
        module.exports = Header;

        /***/
      }, /* 113 */
      /***/function (module, exports) {
        "use strict";

        var HeaderCellType = {
          SORTABLE: 0,
          FILTERABLE: 1,
          NONE: 2,
          CHECKBOX: 3
        };
        module.exports = HeaderCellType;

        /***/
      }, /* 114 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var shallowEqual = __webpack_require__(69);
        var BaseHeaderCell = __webpack_require__(41);
        var getScrollbarSize = __webpack_require__(32);
        var ExcelColumn = __webpack_require__(12);
        var columnUtils = __webpack_require__(6);
        var SortableHeaderCell = __webpack_require__(46);
        var FilterableHeaderCell = __webpack_require__(123);
        var HeaderCellType = __webpack_require__(113);
        var createObjectWithProperties = __webpack_require__(14);
        __webpack_require__(15);
        var HeaderRowStyle = {
          overflow: _propTypes2['default'].string,
          width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
          height: _propTypes2['default'].number,
          position: _propTypes2['default'].string
        };

        // The list of the propTypes that we want to include in the HeaderRow div
        var knownDivPropertyKeys = ['width', 'height', 'style', 'onScroll'];
        var HeaderRow = function (_React$Component) {
          _inherits(HeaderRow, _React$Component);
          function HeaderRow() {
            var _temp, _this, _ret;
            _classCallCheck(this, HeaderRow);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getHeaderCellType = function (column) {
              if (column.filterable) {
                if (_this.props.filterable) return HeaderCellType.FILTERABLE;
              }
              if (column.sortable && column.rowType !== 'filter') return HeaderCellType.SORTABLE;
              return HeaderCellType.NONE;
            }, _this.getFilterableHeaderCell = function (column) {
              var FilterRenderer = FilterableHeaderCell;
              if (column.filterRenderer !== undefined) {
                FilterRenderer = column.filterRenderer;
              }
              return React.createElement(FilterRenderer, _extends({}, _this.props, {
                onChange: _this.props.onFilterChange
              }));
            }, _this.getSortableHeaderCell = function (column) {
              var sortDirection = _this.props.sortColumn === column.key ? _this.props.sortDirection : SortableHeaderCell.DEFINE_SORT.NONE;
              var sortDescendingFirst = column.sortDescendingFirst === undefined ? false : column.sortDescendingFirst;
              return React.createElement(SortableHeaderCell, {
                columnKey: column.key,
                onSort: _this.props.onSort,
                sortDirection: sortDirection,
                sortDescendingFirst: sortDescendingFirst,
                headerRenderer: column.headerRenderer
              });
            }, _this.getHeaderRenderer = function (column) {
              var renderer = void 0;
              if (column.headerRenderer && !column.sortable && !_this.props.filterable) {
                renderer = column.headerRenderer;
              } else {
                var headerCellType = _this.getHeaderCellType(column);
                switch (headerCellType) {
                  case HeaderCellType.SORTABLE:
                    renderer = _this.getSortableHeaderCell(column);
                    break;
                  case HeaderCellType.FILTERABLE:
                    renderer = _this.getFilterableHeaderCell(column);
                    break;
                  default:
                    break;
                }
              }
              return renderer;
            }, _this.getStyle = function () {
              return {
                overflow: 'hidden',
                width: '100%',
                height: _this.props.height,
                position: 'absolute'
              };
            }, _this.getCells = function () {
              var cells = [];
              var lockedCells = [];
              var _loop = function _loop(i, len) {
                var column = Object.assign({
                  rowType: _this.props.rowType
                }, columnUtils.getColumn(_this.props.columns, i));
                var _renderer = _this.getHeaderRenderer(column);
                if (column.key === 'select-row' && _this.props.rowType === 'filter') {
                  _renderer = React.createElement('div', null);
                }
                var HeaderCell = column.draggable ? _this.props.draggableHeaderCell : BaseHeaderCell;
                var cell = React.createElement(HeaderCell, {
                  ref: function ref(node) {
                    return _this.cells[i] = node;
                  },
                  key: i,
                  height: _this.props.height,
                  column: column,
                  renderer: _renderer,
                  resizing: _this.props.resizing === column,
                  onResize: _this.props.onColumnResize,
                  onResizeEnd: _this.props.onColumnResizeEnd,
                  onHeaderDrop: _this.props.onHeaderDrop
                });
                if (column.locked) {
                  lockedCells.push(cell);
                } else {
                  cells.push(cell);
                }
              };
              for (var i = 0, len = columnUtils.getSize(_this.props.columns); i < len; i++) {
                _loop(i, len);
              }
              return cells.concat(lockedCells);
            }, _this.setScrollLeft = function (scrollLeft) {
              _this.props.columns.forEach(function (column, i) {
                if (column.locked) {
                  _this.cells[i].setScrollLeft(scrollLeft);
                } else {
                  if (_this.cells[i] && _this.cells[i].removeScroll) {
                    _this.cells[i].removeScroll();
                  }
                }
              });
            }, _this.getKnownDivProps = function () {
              return createObjectWithProperties(_this.props, knownDivPropertyKeys);
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          HeaderRow.prototype.componentWillMount = function componentWillMount() {
            this.cells = [];
          };
          HeaderRow.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.columns !== this.props.columns || !shallowEqual(nextProps.style, this.props.style) || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
          };
          HeaderRow.prototype.render = function render() {
            var cellsStyle = {
              width: this.props.width ? this.props.width + getScrollbarSize() : '100%',
              height: this.props.height,
              whiteSpace: 'nowrap',
              overflowX: 'hidden',
              overflowY: 'hidden'
            };
            var cells = this.getCells();
            return React.createElement('div', _extends({}, this.getKnownDivProps(), {
              className: 'react-grid-HeaderRow'
            }), React.createElement('div', {
              style: cellsStyle
            }, cells));
          };
          return HeaderRow;
        }(React.Component);
        HeaderRow.displayName = 'HeaderRow';
        HeaderRow.propTypes = {
          width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
          height: _propTypes2['default'].number.isRequired,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].object]).isRequired,
          onColumnResize: _propTypes2['default'].func,
          onSort: _propTypes2['default'].func.isRequired,
          onColumnResizeEnd: _propTypes2['default'].func,
          style: _propTypes2['default'].shape(HeaderRowStyle),
          sortColumn: _propTypes2['default'].string,
          sortDirection: _propTypes2['default'].oneOf(Object.keys(SortableHeaderCell.DEFINE_SORT)),
          cellRenderer: _propTypes2['default'].func,
          headerCellRenderer: _propTypes2['default'].func,
          filterable: _propTypes2['default'].bool,
          onFilterChange: _propTypes2['default'].func,
          resizing: _propTypes2['default'].object,
          onScroll: _propTypes2['default'].func,
          rowType: _propTypes2['default'].string,
          draggableHeaderCell: _propTypes2['default'].func,
          onHeaderDrop: _propTypes2['default'].func
        };
        module.exports = HeaderRow;

        /***/
      }, /* 115 */
      /***/function (module, exports) {
        "use strict";

        module.exports = {
          Backspace: 8,
          Tab: 9,
          Enter: 13,
          Shift: 16,
          Ctrl: 17,
          Alt: 18,
          PauseBreak: 19,
          CapsLock: 20,
          Escape: 27,
          PageUp: 33,
          PageDown: 34,
          End: 35,
          Home: 36,
          LeftArrow: 37,
          UpArrow: 38,
          RightArrow: 39,
          DownArrow: 40,
          Insert: 45,
          Delete: 46,
          0: 48,
          1: 49,
          2: 50,
          3: 51,
          4: 52,
          5: 53,
          6: 54,
          7: 55,
          8: 56,
          9: 57,
          a: 65,
          b: 66,
          c: 67,
          d: 68,
          e: 69,
          f: 70,
          g: 71,
          h: 72,
          i: 73,
          j: 74,
          k: 75,
          l: 76,
          m: 77,
          n: 78,
          o: 79,
          p: 80,
          q: 81,
          r: 82,
          s: 83,
          t: 84,
          u: 85,
          v: 86,
          w: 87,
          x: 88,
          y: 89,
          z: 90,
          LeftWindowKey: 91,
          RightWindowKey: 92,
          SelectKey: 93,
          NumPad0: 96,
          NumPad1: 97,
          NumPad2: 98,
          NumPad3: 99,
          NumPad4: 100,
          NumPad5: 101,
          NumPad6: 102,
          NumPad7: 103,
          NumPad8: 104,
          NumPad9: 105,
          Multiply: 106,
          Add: 107,
          Subtract: 109,
          DecimalPoint: 110,
          Divide: 111,
          F1: 112,
          F2: 113,
          F3: 114,
          F4: 115,
          F5: 116,
          F6: 117,
          F7: 118,
          F8: 119,
          F9: 120,
          F10: 121,
          F12: 123,
          NumLock: 144,
          ScrollLock: 145,
          SemiColon: 186,
          EqualSign: 187,
          Comma: 188,
          Dash: 189,
          Period: 190,
          ForwardSlash: 191,
          GraveAccent: 192,
          OpenBracket: 219,
          BackSlash: 220,
          CloseBracket: 221,
          SingleQuote: 222
        };

        /***/
      }, /* 116 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        exports.OverflowCellComponent = undefined;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _focusableComponentWrapper = __webpack_require__(126);
        var _focusableComponentWrapper2 = _interopRequireDefault(_focusableComponentWrapper);
        __webpack_require__(37);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var OverflowCell = function (_React$Component) {
          _inherits(OverflowCell, _React$Component);
          function OverflowCell() {
            _classCallCheck(this, OverflowCell);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          OverflowCell.prototype.getStyle = function getStyle() {
            var style = {
              position: 'absolute',
              width: this.props.column.width,
              height: this.props.height,
              left: this.props.column.left,
              border: '1px solid #eee'
            };
            return style;
          };
          OverflowCell.prototype.render = function render() {
            return _react2['default'].createElement('div', {
              tabIndex: '-1',
              style: this.getStyle(),
              width: '100%',
              className: 'react-grid-Cell'
            });
          };
          return OverflowCell;
        }(_react2['default'].Component);
        OverflowCell.isSelected = function (props) {
          var cellMetaData = props.cellMetaData,
            rowIdx = props.rowIdx,
            idx = props.idx;
          if (cellMetaData == null) {
            return false;
          }
          var selected = cellMetaData.selected;
          return selected && selected.rowIdx === rowIdx && selected.idx === idx;
        };
        OverflowCell.isScrolling = function (props) {
          return props.cellMetaData.isScrollingHorizontallyWithKeyboard;
        };
        OverflowCell.propTypes = {
          rowIdx: _propTypes2['default'].number,
          idx: _propTypes2['default'].number,
          height: _propTypes2['default'].number,
          column: _propTypes2['default'].object,
          cellMetaData: _propTypes2['default'].object
        };
        OverflowCell.displayName = 'Cell';
        var OverflowCellComponent = OverflowCell;
        exports['default'] = (0, _focusableComponentWrapper2['default'])(OverflowCell);
        exports.OverflowCellComponent = OverflowCellComponent;

        /***/
      }, /* 117 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var CellActionShape = {
          icon: _propTypes2['default'].string.isRequired,
          callback: _propTypes2['default'].func,
          actions: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
            text: _propTypes2['default'].string,
            callback: _propTypes2['default'].func
          }))
        };
        exports['default'] = CellActionShape;

        /***/
      }, /* 118 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _ExcelColumn = __webpack_require__(12);
        var _ExcelColumn2 = _interopRequireDefault(_ExcelColumn);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        exports['default'] = {
          ExcelColumn: _ExcelColumn2['default']
        };

        /***/
      }, /* 119 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _SelectAll = __webpack_require__(50);
        var _SelectAll2 = _interopRequireDefault(_SelectAll);
        var _AppConstants = __webpack_require__(30);
        var _AppConstants2 = _interopRequireDefault(_AppConstants);
        var _SortableHeaderCell = __webpack_require__(46);
        var _keyboardUtils = __webpack_require__(55);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var BaseGrid = __webpack_require__(111);
        var CheckboxEditor = __webpack_require__(47);
        var RowUtils = __webpack_require__(44);
        var ColumnUtils = __webpack_require__(6);
        var KeyCodes = __webpack_require__(115);
        var isFunction = __webpack_require__(19);
        var ColumnMetrics = __webpack_require__(31);
        __webpack_require__(20);
        __webpack_require__(70);
        if (!Object.assign) {
          Object.assign = __webpack_require__(146);
        }
        var ReactDataGrid = function (_React$Component) {
          _inherits(ReactDataGrid, _React$Component);
          function ReactDataGrid(props, context) {
            _classCallCheck(this, ReactDataGrid);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
            _initialiseProps.call(_this);
            var columnMetrics = _this.createColumnMetrics();
            var initialState = {
              columnMetrics: columnMetrics,
              selectedRows: [],
              copied: null,
              expandedRows: [],
              canFilter: false,
              columnFilters: {},
              sortDirection: null,
              sortColumn: null,
              dragged: null,
              scrollOffset: 0,
              lastRowIdxUiSelected: -1
            };
            if (props.enableCellSelect) {
              initialState.selected = {
                rowIdx: 0,
                idx: 0
              };
            } else {
              initialState.selected = {
                rowIdx: -1,
                idx: -1
              };
            }
            if (_this.props.sortColumn && _this.props.sortDirection) {
              initialState.sortColumn = _this.props.sortColumn;
              initialState.sortDirection = _this.props.sortDirection;
            }
            _this.state = initialState;
            return _this;
          }
          ReactDataGrid.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
          };
          ReactDataGrid.prototype.componentDidMount = function componentDidMount() {
            if (window.addEventListener) {
              window.addEventListener('resize', this.metricsUpdated);
            } else {
              window.attachEvent('resize', this.metricsUpdated);
            }
            this.metricsUpdated();
          };
          ReactDataGrid.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            window.removeEventListener('resize', this.metricsUpdated);
          };
          ReactDataGrid.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (nextProps.columns) {
              if (!ColumnMetrics.sameColumns(this.props.columns, nextProps.columns, this.props.columnEquality) || nextProps.minWidth !== this.props.minWidth) {
                var columnMetrics = this.createColumnMetrics(nextProps);
                this.setState({
                  columnMetrics: columnMetrics
                });
              }
            }
          };

          // return false if not a shift select so can be handled as normal row selection

          // columnKey not used here as this function will select the whole row,
          // but needed to match the function signature in the CheckboxEditor

          ReactDataGrid.prototype.render = function render() {
            var _this2 = this;
            var cellMetaData = {
              rowKey: this.props.rowKey,
              selected: this.state.selected,
              dragged: this.state.dragged,
              hoveredRowIdx: this.state.hoveredRowIdx,
              onCellClick: this.onCellClick,
              onCellFocus: this.onCellFocus,
              onCellContextMenu: this.onCellContextMenu,
              onCellDoubleClick: this.onCellDoubleClick,
              onCommit: this.onCellCommit,
              onCommitCancel: this.setInactive,
              copied: this.state.copied,
              handleDragEnterRow: this.handleDragEnter,
              handleTerminateDrag: this.handleTerminateDrag,
              enableCellSelect: this.props.enableCellSelect,
              onColumnEvent: this.onColumnEvent,
              openCellEditor: this.openCellEditor,
              onDragHandleDoubleClick: this.onDragHandleDoubleClick,
              onCellExpand: this.onCellExpand,
              onRowExpandToggle: this.onRowExpandToggle,
              onRowHover: this.onRowHover,
              getDataGridDOMNode: this.getDataGridDOMNode,
              getCellActions: this.props.getCellActions,
              onDeleteSubRow: this.props.onDeleteSubRow,
              onAddSubRow: this.props.onAddSubRow,
              isScrollingVerticallyWithKeyboard: this.isKeyDown(KeyCodes.DownArrow) || this.isKeyDown(KeyCodes.UpArrow),
              isScrollingHorizontallyWithKeyboard: this.isKeyDown(KeyCodes.LeftArrow) || this.isKeyDown(KeyCodes.RightArrow) || this.isKeyDown(KeyCodes.Tab),
              enableCellAutoFocus: this.props.enableCellAutoFocus
            };
            var toolbar = this.renderToolbar();
            var containerWidth = this.props.minWidth || this.gridWidth();
            var gridWidth = containerWidth - this.state.scrollOffset;

            // depending on the current lifecycle stage, gridWidth() may not initialize correctly
            // this also handles cases where it always returns undefined -- such as when inside a div with display:none
            // eg Bootstrap tabs and collapses
            if (typeof containerWidth === 'undefined' || isNaN(containerWidth) || containerWidth === 0) {
              containerWidth = '100%';
            }
            if (typeof gridWidth === 'undefined' || isNaN(gridWidth) || gridWidth === 0) {
              gridWidth = '100%';
            }
            return React.createElement('div', {
              className: 'react-grid-Container',
              style: {
                width: containerWidth
              },
              ref: function ref(node) {
                _this2.grid = node;
              }
            }, toolbar, React.createElement('div', {
              className: 'react-grid-Main'
            }, React.createElement(BaseGrid, _extends({
              ref: function ref(node) {
                return _this2.base = node;
              }
            }, this.props, {
              rowKey: this.props.rowKey,
              headerRows: this.getHeaderRows(),
              columnMetrics: this.state.columnMetrics,
              rowGetter: this.props.rowGetter,
              rowsCount: this.props.rowsCount,
              rowHeight: this.props.rowHeight,
              cellMetaData: cellMetaData,
              selectedRows: this.getSelectedRows(),
              rowSelection: this.getRowSelectionProps(),
              expandedRows: this.state.expandedRows,
              rowOffsetHeight: this.getRowOffsetHeight(),
              sortColumn: this.state.sortColumn,
              sortDirection: this.state.sortDirection,
              onSort: this.handleSort,
              minHeight: this.props.minHeight,
              totalWidth: gridWidth,
              onViewportKeydown: this.onKeyDown,
              onViewportKeyup: this.onKeyUp,
              onViewportDragStart: this.onDragStart,
              onViewportDragEnd: this.handleDragEnd,
              onViewportClick: this.deselect,
              onViewportDoubleClick: this.deselect,
              onColumnResize: this.onColumnResize,
              rowScrollTimeout: this.props.rowScrollTimeout,
              scrollToRowIndex: this.props.scrollToRowIndex,
              contextMenu: this.props.contextMenu,
              overScan: this.props.overScan
            }))));
          };
          return ReactDataGrid;
        }(React.Component);
        ReactDataGrid.displayName = 'ReactDataGrid';
        ReactDataGrid.propTypes = {
          rowHeight: _propTypes2['default'].number.isRequired,
          headerRowHeight: _propTypes2['default'].number,
          headerFiltersHeight: _propTypes2['default'].number,
          minHeight: _propTypes2['default'].number.isRequired,
          minWidth: _propTypes2['default'].number,
          enableRowSelect: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].string]),
          onRowUpdated: _propTypes2['default'].func,
          rowGetter: _propTypes2['default'].func.isRequired,
          rowsCount: _propTypes2['default'].number.isRequired,
          toolbar: _propTypes2['default'].element,
          enableCellSelect: _propTypes2['default'].bool,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
          onFilter: _propTypes2['default'].func,
          onCellCopyPaste: _propTypes2['default'].func,
          onCellsDragged: _propTypes2['default'].func,
          getCellActions: _propTypes2['default'].func,
          onAddFilter: _propTypes2['default'].func,
          onGridSort: _propTypes2['default'].func,
          sortColumn: _propTypes2['default'].string,
          sortDirection: _propTypes2['default'].oneOf(Object.keys(_SortableHeaderCell.DEFINE_SORT)),
          onDragHandleDoubleClick: _propTypes2['default'].func,
          onGridRowsUpdated: _propTypes2['default'].func,
          onRowSelect: _propTypes2['default'].func,
          rowKey: _propTypes2['default'].string,
          rowScrollTimeout: _propTypes2['default'].number,
          scrollToRowIndex: _propTypes2['default'].number,
          onClearFilters: _propTypes2['default'].func,
          contextMenu: _propTypes2['default'].element,
          cellNavigationMode: _propTypes2['default'].oneOf(['none', 'loopOverRow', 'changeRow']),
          onCellSelected: _propTypes2['default'].func,
          onCellDeSelected: _propTypes2['default'].func,
          onCellExpand: _propTypes2['default'].func,
          enableDragAndDrop: _propTypes2['default'].bool,
          tabIndex: _propTypes2['default'].number,
          onRowExpandToggle: _propTypes2['default'].func,
          draggableHeaderCell: _propTypes2['default'].func,
          getValidFilterValues: _propTypes2['default'].func,
          rowSelection: _propTypes2['default'].shape({
            enableShiftSelect: _propTypes2['default'].bool,
            onRowsSelected: _propTypes2['default'].func,
            onRowsDeselected: _propTypes2['default'].func,
            showCheckbox: _propTypes2['default'].bool,
            selectBy: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
              indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
            }), _propTypes2['default'].shape({
              isSelectedKey: _propTypes2['default'].string.isRequired
            }), _propTypes2['default'].shape({
              keys: _propTypes2['default'].shape({
                values: _propTypes2['default'].array.isRequired,
                rowKey: _propTypes2['default'].string.isRequired
              }).isRequired
            })]).isRequired
          }),
          onRowClick: _propTypes2['default'].func,
          onRowDoubleClick: _propTypes2['default'].func,
          onGridKeyUp: _propTypes2['default'].func,
          onGridKeyDown: _propTypes2['default'].func,
          rowGroupRenderer: _propTypes2['default'].func,
          rowActionsCell: _propTypes2['default'].func,
          onCheckCellIsEditable: _propTypes2['default'].func,
          /* called before cell is set active, returns a boolean to determine whether cell is editable */
          overScan: _propTypes2['default'].object,
          onDeleteSubRow: _propTypes2['default'].func,
          onAddSubRow: _propTypes2['default'].func,
          enableCellAutoFocus: _propTypes2['default'].bool,
          onBeforeEdit: _propTypes2['default'].func,
          selectAllRenderer: _propTypes2['default'].object,
          minColumnWidth: _propTypes2['default'].number,
          columnEquality: _propTypes2['default'].func,
          onColumnResize: _propTypes2['default'].func
        };
        ReactDataGrid.defaultProps = {
          enableCellSelect: false,
          tabIndex: -1,
          rowHeight: 35,
          headerFiltersHeight: 45,
          enableRowSelect: false,
          minHeight: 350,
          rowKey: 'id',
          rowScrollTimeout: 0,
          scrollToRowIndex: 0,
          cellNavigationMode: 'none',
          overScan: {
            colsStart: 5,
            colsEnd: 5,
            rowsStart: 5,
            rowsEnd: 5
          },
          enableCellAutoFocus: true,
          onBeforeEdit: function onBeforeEdit() {},
          minColumnWidth: 80,
          columnEquality: ColumnMetrics.sameColumn
        };
        var _initialiseProps = function _initialiseProps() {
          var _this3 = this;
          this.gridWidth = function () {
            return _this3.grid ? _this3.grid.parentElement.offsetWidth : 0;
          };
          this.getTotalWidth = function () {
            var totalWidth = 0;
            if (_this3._mounted) {
              totalWidth = _this3.gridWidth();
            } else {
              totalWidth = ColumnUtils.getSize(_this3.props.columns) * _this3.props.minColumnWidth;
            }
            return totalWidth;
          };
          this.getColumnMetricsType = function (metrics) {
            var totalWidth = metrics.totalWidth || _this3.getTotalWidth();
            var currentMetrics = {
              columns: metrics.columns,
              totalWidth: totalWidth,
              minColumnWidth: metrics.minColumnWidth
            };
            var updatedMetrics = ColumnMetrics.recalculate(currentMetrics);
            return updatedMetrics;
          };
          this.getColumn = function (idx) {
            var columns = _this3.state.columnMetrics.columns;
            if (Array.isArray(columns)) {
              return columns[idx];
            } else if (typeof Immutable !== 'undefined') {
              return columns.get(idx);
            }
          };
          this.getSize = function () {
            var columns = _this3.state.columnMetrics.columns;
            if (Array.isArray(columns)) {
              return columns.length;
            } else if (typeof Immutable !== 'undefined') {
              return columns.size;
            }
          };
          this.metricsUpdated = function () {
            var columnMetrics = _this3.createColumnMetrics();
            _this3.setState({
              columnMetrics: columnMetrics
            });
          };
          this.createColumnMetrics = function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;
            var gridColumns = _this3.setupGridColumns(props);
            return _this3.getColumnMetricsType({
              columns: gridColumns,
              minColumnWidth: _this3.props.minColumnWidth,
              totalWidth: props.minWidth
            });
          };
          this.onColumnResize = function (index, width) {
            var columnMetrics = ColumnMetrics.resizeColumn(_this3.state.columnMetrics, index, width);
            _this3.setState({
              columnMetrics: columnMetrics
            });
            if (_this3.props.onColumnResize) {
              _this3.props.onColumnResize(index, width);
            }
          };
          this.onKeyDown = function (e) {
            if ((0, _keyboardUtils.isCtrlKeyHeldDown)(e)) {
              _this3.checkAndCall('onPressKeyWithCtrl', e);
            } else if (_this3.isKeyExplicitlyHandled(e.key)) {
              // break up individual keyPress events to have their own specific callbacks
              var callBack = 'onPress' + e.key;
              _this3.checkAndCall(callBack, e);
            } else if ((0, _keyboardUtils.isKeyPrintable)(e.keyCode)) {
              _this3.checkAndCall('onPressChar', e);
            }

            // Track which keys are currently down for shift clicking etc
            _this3._keysDown = _this3._keysDown || {};
            _this3._keysDown[e.keyCode] = true;
            if (isFunction(_this3.props.onGridKeyDown)) {
              _this3.props.onGridKeyDown(e);
            }
          };
          this.onKeyUp = function (e) {
            // Track which keys are currently down for shift clicking etc
            _this3._keysDown = _this3._keysDown || {};
            delete _this3._keysDown[e.keyCode];
            if (isFunction(_this3.props.onGridKeyUp)) {
              _this3.props.onGridKeyUp(e);
            }
          };
          this.isKeyDown = function (keyCode) {
            if (!_this3._keysDown) return false;
            return keyCode in _this3._keysDown;
          };
          this.isSingleKeyDown = function (keyCode) {
            if (!_this3._keysDown) return false;
            return keyCode in _this3._keysDown && Object.keys(_this3._keysDown).length === 1;
          };
          this.checkAndCall = function (methodName, args) {
            if (typeof _this3[methodName] === 'function') {
              _this3[methodName](args);
            }
          };
          this.isKeyExplicitlyHandled = function (key) {
            return typeof _this3['onPress' + key] === 'function';
          };
          this.hasSelectedCellChanged = function (selected) {
            var previouslySelected = Object.assign({}, _this3.state.selected);
            return previouslySelected.rowIdx !== selected.rowIdx || previouslySelected.idx !== selected.idx || previouslySelected.active === false;
          };
          this.onContextMenuHide = function () {
            document.removeEventListener('click', _this3.onContextMenuHide);
            var newSelected = Object.assign({}, _this3.state.selected, {
              contextMenuDisplayed: false
            });
            _this3.setState({
              selected: newSelected
            });
          };
          this.onColumnEvent = function (ev, columnEvent) {
            var idx = columnEvent.idx,
              name = columnEvent.name;
            if (name && typeof idx !== 'undefined') {
              var column = _this3.getColumn(idx);
              if (column && column.events && column.events[name] && typeof column.events[name] === 'function') {
                var eventArgs = {
                  idx: idx,
                  rowIdx: columnEvent.rowIdx,
                  rowId: columnEvent.rowId,
                  column: column
                };
                column.events[name](ev, eventArgs);
              }
            }
          };
          this.onSelect = function (selected) {
            if (_this3.state.selected.rowIdx !== selected.rowIdx || _this3.state.selected.idx !== selected.idx || _this3.state.selected.active === false) {
              var _idx = selected.idx;
              var _rowIdx = selected.rowIdx;
              if (_this3.isCellWithinBounds(selected)) {
                var oldSelection = _this3.state.selected;
                _this3.setState({
                  selected: selected
                }, function () {
                  if (typeof _this3.props.onCellDeSelected === 'function') {
                    _this3.props.onCellDeSelected(oldSelection);
                  }
                  if (typeof _this3.props.onCellSelected === 'function') {
                    _this3.props.onCellSelected(selected);
                  }
                });
              } else if (_rowIdx === -1 && _idx === -1) {
                // When it's outside of the grid, set rowIdx anyway
                _this3.setState({
                  selected: {
                    idx: _idx,
                    rowIdx: _rowIdx
                  }
                });
              }
            }
          };
          this.onCellClick = function (cell, e) {
            _this3.onSelect({
              rowIdx: cell.rowIdx,
              idx: cell.idx
            });
            if (_this3.props.onRowClick && typeof _this3.props.onRowClick === 'function') {
              _this3.props.onRowClick(cell.rowIdx, _this3.props.rowGetter(cell.rowIdx), _this3.getColumn(cell.idx));
            }
            if (e) {
              e.stopPropagation();
            }
          };
          this.onCellFocus = function (cell) {
            _this3.onSelect(cell);
          };
          this.onCellContextMenu = function (cell) {
            _this3.onSelect({
              rowIdx: cell.rowIdx,
              idx: cell.idx,
              contextMenuDisplayed: _this3.props.contextMenu
            });
            if (_this3.props.contextMenu) {
              document.addEventListener('click', _this3.onContextMenuHide);
            }
          };
          this.onCellDoubleClick = function (cell, e) {
            _this3.onSelect({
              rowIdx: cell.rowIdx,
              idx: cell.idx
            });
            if (_this3.props.onRowDoubleClick && typeof _this3.props.onRowDoubleClick === 'function') {
              _this3.props.onRowDoubleClick(cell.rowIdx, _this3.props.rowGetter(cell.rowIdx), _this3.getColumn(cell.idx));
            }
            _this3.setActive();
            if (e) {
              e.stopPropagation();
            }
          };
          this.onPressArrowUp = function (e) {
            _this3.moveSelectedCell(e, -1, 0);
          };
          this.onPressArrowDown = function (e) {
            _this3.moveSelectedCell(e, 1, 0);
          };
          this.onPressArrowLeft = function (e) {
            _this3.moveSelectedCell(e, 0, -1);
          };
          this.onPressArrowRight = function (e) {
            _this3.moveSelectedCell(e, 0, 1);
          };
          this.isFocusedOnCell = function () {
            return document.activeElement && document.activeElement.classList && document.activeElement.classList.contains('react-grid-Cell');
          };
          this.isFocusedOnTable = function () {
            var domNode = _this3.getDataGridDOMNode();
            return domNode && domNode.contains(document.activeElement);
          };
          this.exitGrid = function (oldSelectedCell, newSelectedValue) {
            _this3.setState({
              selected: newSelectedValue
            }, function () {
              if (typeof _this3.props.onCellDeSelected === 'function') {
                _this3.props.onCellDeSelected(oldSelectedCell);
              }
            });
          };
          this.enterGrid = function (newSelectedValue) {
            _this3.setState({
              selected: newSelectedValue
            }, function () {
              if (typeof _this3.props.onCellSelected === 'function') {
                _this3.props.onCellSelected(newSelectedValue);
              }
            });
          };
          this.onPressTab = function (e) {
            // Scenario 0a: When there are no rows in the grid, pressing tab needs to allow the browser to handle it
            if (_this3.props.rowsCount === 0) {
              return;
            }
            // Scenario 0b: When we're editing a cell
            var idx = _this3.state.selected.idx;
            var rowIdx = _this3.state.selected.rowIdx;
            if (_this3.state.selected.active === true) {
              // if we are in a position to leave the grid, stop editing but stay in that cell
              if (_this3.canExitGrid(e)) {
                _this3.moveSelectedCell(e, 0, 0);
                return;
              }
              // otherwise move left or right as appropriate
              _this3.moveSelectedCell(e, 0, e.shiftKey ? -1 : 1);
              return;
            }
            var shift = e.shiftKey === true;
            // Scenario 1: we're at a cell where we can exit the grid
            if (_this3.canExitGrid(e) && _this3.isFocusedOnCell()) {
              if (shift && idx >= 0) {
                _this3.exitGrid({
                  idx: idx,
                  rowIdx: rowIdx
                }, {
                  idx: -1,
                  rowIdx: rowIdx,
                  exitedLeft: true
                });
                return;
              } else if (!shift && idx >= 0) {
                _this3.exitGrid({
                  idx: idx,
                  rowIdx: rowIdx
                }, {
                  idx: -1,
                  rowIdx: rowIdx
                });
                return;
              }
            }
            // Scenario 2: we're on the div surrounding the grid and press shift+Tab
            // and we just exited left, so we want to let the browser handle it
            // KNOWN ISSUE: Focus on the table can come from either side and at this point we can't know how
            // they user arrived, so it is possible that exitLeft gets set and then the user clicks out of the table
            // and they won't be able to Shift+Tab around the site to re-enter the table from the right.
            if (_this3.isFocusedOnTable() && !_this3.isFocusedOnCell() && shift && _this3.state.selected.exitedLeft) {
              _this3.enterGrid({
                idx: idx,
                rowIdx: rowIdx
              });
              return;
            }
            // Scenario 3: we're on the div surrounding the grid and we want to enter the grid
            if (!_this3.isFocusedOnCell()) {
              // Scenario 3A: idx has been set to -1 (eg can happen when clicking into the filter box)
              // we want to go to the first cell in the row if we press Tab
              // we want to go to the last cell in the row if we press Shift+Tab
              if (idx === -1) {
                _this3.moveSelectedCell(e, rowIdx === -1 ? 1 : 0, shift ? _this3.getNbrColumns() : 1);
                return;
              }
              // otherwise, there is a selected cell in the table already, and
              // we want to trigger it to focus - setting selected in state will update
              // the cell props, and checkFocus will be called
              _this3.enterGrid({
                idx: idx,
                rowIdx: rowIdx,
                changeSomething: true
              });
              // make sure the browser doesn't handle it
              e.preventDefault();
              return;
            }
            _this3.moveSelectedCell(e, 0, e.shiftKey ? -1 : 1);
          };
          this.onPressEnter = function (e) {
            _this3.setActive(e.key);
          };
          this.onPressDelete = function (e) {
            _this3.setActive(e.key);
          };
          this.onPressEscape = function (e) {
            _this3.setInactive(e.key);
            _this3.handleCancelCopy();
          };
          this.onPressBackspace = function (e) {
            _this3.setActive(e.key);
          };
          this.onPressChar = function (e) {
            if ((0, _keyboardUtils.isKeyPrintable)(e.keyCode)) {
              _this3.setActive(e.keyCode);
            }
          };
          this.onPressKeyWithCtrl = function (e) {
            var keys = {
              KeyCode_c: 99,
              KeyCode_C: 67,
              KeyCode_V: 86,
              KeyCode_v: 118
            };
            var rowIdx = _this3.state.selected.rowIdx;
            var row = _this3.props.rowGetter(rowIdx);
            var idx = _this3.state.selected.idx;
            var col = _this3.getColumn(idx);
            if (ColumnUtils.canEdit(col, row, _this3.props.enableCellSelect)) {
              if (e.keyCode === keys.KeyCode_c || e.keyCode === keys.KeyCode_C) {
                var _value = _this3.getSelectedValue();
                _this3.handleCopy({
                  value: _value
                });
              } else if (e.keyCode === keys.KeyCode_v || e.keyCode === keys.KeyCode_V) {
                _this3.handlePaste();
              }
            }
          };
          this.onGridRowsUpdated = function (cellKey, fromRow, toRow, updated, action, originRow) {
            var rowIds = [];
            for (var i = fromRow; i <= toRow; i++) {
              rowIds.push(_this3.props.rowGetter(i)[_this3.props.rowKey]);
            }
            var fromRowData = _this3.props.rowGetter(action === 'COPY_PASTE' ? originRow : fromRow);
            var fromRowId = fromRowData[_this3.props.rowKey];
            var toRowId = _this3.props.rowGetter(toRow)[_this3.props.rowKey];
            _this3.props.onGridRowsUpdated({
              cellKey: cellKey,
              fromRow: fromRow,
              toRow: toRow,
              fromRowId: fromRowId,
              toRowId: toRowId,
              rowIds: rowIds,
              updated: updated,
              action: action,
              fromRowData: fromRowData
            });
          };
          this.onCellCommit = function (commit) {
            var selected = Object.assign({}, _this3.state.selected);
            selected.active = false;
            var expandedRows = _this3.state.expandedRows;
            // if(commit.changed && commit.changed.expandedHeight){
            //   expandedRows = this.expandRow(commit.rowIdx, commit.changed.expandedHeight);
            // }
            _this3.setState({
              selected: selected,
              expandedRows: expandedRows
            });
            if (_this3.props.onRowUpdated) {
              _this3.props.onRowUpdated(commit);
            }
            var targetRow = commit.rowIdx;
            if (_this3.props.onGridRowsUpdated) {
              _this3.onGridRowsUpdated(commit.cellKey, targetRow, targetRow, commit.updated, _AppConstants2['default'].UpdateActions.CELL_UPDATE);
            }
          };
          this.onDragStart = function (e) {
            var idx = _this3.state.selected.idx;
            // To prevent dragging down/up when reordering rows.
            var isViewportDragging = e && e.target && e.target.className;
            if (idx > -1 && isViewportDragging) {
              var _value2 = _this3.getSelectedValue();
              _this3.handleDragStart({
                idx: _this3.state.selected.idx,
                rowIdx: _this3.state.selected.rowIdx,
                value: _value2
              });
              // need to set dummy data for FF
              if (e && e.dataTransfer) {
                if (e.dataTransfer.setData) {
                  e.dataTransfer.dropEffect = 'move';
                  e.dataTransfer.effectAllowed = 'move';
                  e.dataTransfer.setData('text/plain', '');
                }
              }
            }
          };
          this.onToggleFilter = function () {
            // setState() does not immediately mutate this.state but creates a pending state transition.
            // Therefore if you want to do something after the state change occurs, pass it in as a callback function.
            _this3.setState({
              canFilter: !_this3.state.canFilter
            }, function () {
              if (_this3.state.canFilter === false && _this3.props.onClearFilters) {
                _this3.props.onClearFilters();
              }
            });
          };
          this.onDragHandleDoubleClick = function (e) {
            if (_this3.props.onDragHandleDoubleClick) {
              _this3.props.onDragHandleDoubleClick(e);
            }
            if (_this3.props.onGridRowsUpdated) {
              var _this3$onGridRowsUpda;
              var cellKey = _this3.getColumn(e.idx).key;
              _this3.onGridRowsUpdated(cellKey, e.rowIdx, _this3.props.rowsCount - 1, (_this3$onGridRowsUpda = {}, _this3$onGridRowsUpda[cellKey] = e.rowData[cellKey], _this3$onGridRowsUpda), _AppConstants2['default'].UpdateActions.COLUMN_FILL);
            }
          };
          this.onCellExpand = function (args) {
            if (_this3.props.onCellExpand) {
              _this3.props.onCellExpand(args);
            }
          };
          this.onRowExpandToggle = function (args) {
            if (typeof _this3.props.onRowExpandToggle === 'function') {
              _this3.props.onRowExpandToggle(args);
            }
          };
          this.isCellWithinBounds = function (_ref) {
            var idx = _ref.idx,
              rowIdx = _ref.rowIdx;
            return idx >= 0 && rowIdx >= 0 && idx < ColumnUtils.getSize(_this3.state.columnMetrics.columns) && rowIdx < _this3.props.rowsCount;
          };
          this.handleDragStart = function (dragged) {
            if (!_this3.dragEnabled()) {
              return;
            }
            if (_this3.isCellWithinBounds(dragged)) {
              _this3.setState({
                dragged: dragged
              });
            }
          };
          this.handleDragEnd = function () {
            if (!_this3.dragEnabled()) {
              return;
            }
            var _state = _this3.state,
              selected = _state.selected,
              dragged = _state.dragged;
            var column = _this3.getColumn(_this3.state.selected.idx);
            if (selected && dragged && column) {
              var cellKey = column.key;
              var fromRow = selected.rowIdx < dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
              var toRow = selected.rowIdx > dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
              if (_this3.props.onCellsDragged) {
                _this3.props.onCellsDragged({
                  cellKey: cellKey,
                  fromRow: fromRow,
                  toRow: toRow,
                  value: dragged.value
                });
              }
              if (_this3.props.onGridRowsUpdated) {
                var _this3$onGridRowsUpda2;
                _this3.onGridRowsUpdated(cellKey, fromRow, toRow, (_this3$onGridRowsUpda2 = {}, _this3$onGridRowsUpda2[cellKey] = dragged.value, _this3$onGridRowsUpda2), _AppConstants2['default'].UpdateActions.CELL_DRAG);
              }
            }
            _this3.setState({
              dragged: {
                complete: true
              }
            });
          };
          this.handleDragEnter = function (row) {
            if (!_this3.dragEnabled() || _this3.state.dragged == null) {
              return;
            }
            var dragged = _this3.state.dragged;
            dragged.overRowIdx = row;
            _this3.setState({
              dragged: dragged
            });
          };
          this.handleTerminateDrag = function () {
            if (!_this3.dragEnabled()) {
              return;
            }
            _this3.setState({
              dragged: null
            });
          };
          this.handlePaste = function () {
            if (!_this3.copyPasteEnabled() || !_this3.state.copied) {
              return;
            }
            var selected = _this3.state.selected;
            var cellKey = _this3.getColumn(_this3.state.selected.idx).key;
            var textToCopy = _this3.state.textToCopy;
            var fromRow = _this3.state.copied.rowIdx;
            var toRow = selected.rowIdx;
            if (_this3.props.onCellCopyPaste) {
              _this3.props.onCellCopyPaste({
                cellKey: cellKey,
                rowIdx: toRow,
                value: textToCopy,
                fromRow: fromRow,
                toRow: toRow
              });
            }
            if (_this3.props.onGridRowsUpdated) {
              var _this3$onGridRowsUpda3;
              _this3.onGridRowsUpdated(cellKey, toRow, toRow, (_this3$onGridRowsUpda3 = {}, _this3$onGridRowsUpda3[cellKey] = textToCopy, _this3$onGridRowsUpda3), _AppConstants2['default'].UpdateActions.COPY_PASTE, fromRow);
            }
          };
          this.handleCancelCopy = function () {
            _this3.setState({
              copied: null
            });
          };
          this.handleCopy = function (args) {
            if (!_this3.copyPasteEnabled()) {
              return;
            }
            var textToCopy = args.value;
            var selected = _this3.state.selected;
            var copied = {
              idx: selected.idx,
              rowIdx: selected.rowIdx
            };
            _this3.setState({
              textToCopy: textToCopy,
              copied: copied
            });
          };
          this.handleSort = function (columnKey, direction) {
            _this3.setState({
              sortDirection: direction,
              sortColumn: columnKey
            }, function () {
              this.props.onGridSort(columnKey, direction);
            });
          };
          this.getSelectedRow = function (rows, key) {
            var selectedRow = rows.filter(function (r) {
              if (r[_this3.props.rowKey] === key) {
                return true;
              }
              return false;
            });
            if (selectedRow.length > 0) {
              return selectedRow[0];
            }
          };
          this.useNewRowSelection = function () {
            return _this3.props.rowSelection && _this3.props.rowSelection.selectBy;
          };
          this.handleShiftSelect = function (rowIdx) {
            if (_this3.state.lastRowIdxUiSelected > -1 && _this3.isSingleKeyDown(KeyCodes.Shift)) {
              var _props$rowSelection$s = _this3.props.rowSelection.selectBy,
                keys = _props$rowSelection$s.keys,
                indexes = _props$rowSelection$s.indexes,
                isSelectedKey = _props$rowSelection$s.isSelectedKey;
              var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, _this3.props.rowGetter(rowIdx), rowIdx);
              if (isPreviouslySelected) return false;
              var handled = false;
              if (rowIdx > _this3.state.lastRowIdxUiSelected) {
                var rowsSelected = [];
                for (var i = _this3.state.lastRowIdxUiSelected + 1; i <= rowIdx; i++) {
                  rowsSelected.push({
                    rowIdx: i,
                    row: _this3.props.rowGetter(i)
                  });
                }
                if (typeof _this3.props.rowSelection.onRowsSelected === 'function') {
                  _this3.props.rowSelection.onRowsSelected(rowsSelected);
                }
                handled = true;
              } else if (rowIdx < _this3.state.lastRowIdxUiSelected) {
                var _rowsSelected = [];
                for (var _i = rowIdx; _i <= _this3.state.lastRowIdxUiSelected - 1; _i++) {
                  _rowsSelected.push({
                    rowIdx: _i,
                    row: _this3.props.rowGetter(_i)
                  });
                }
                if (typeof _this3.props.rowSelection.onRowsSelected === 'function') {
                  _this3.props.rowSelection.onRowsSelected(_rowsSelected);
                }
                handled = true;
              }
              if (handled) {
                _this3.setState({
                  lastRowIdxUiSelected: rowIdx
                });
              }
              return handled;
            }
            return false;
          };
          this.handleNewRowSelect = function (rowIdx, rowData) {
            if (_this3.selectAllCheckbox && _this3.selectAllCheckbox.checked === true) {
              _this3.selectAllCheckbox.checked = false;
            }
            var _props$rowSelection$s2 = _this3.props.rowSelection.selectBy,
              keys = _props$rowSelection$s2.keys,
              indexes = _props$rowSelection$s2.indexes,
              isSelectedKey = _props$rowSelection$s2.isSelectedKey;
            var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx);
            _this3.setState({
              lastRowIdxUiSelected: isPreviouslySelected ? -1 : rowIdx,
              selected: {
                rowIdx: rowIdx,
                idx: 0
              }
            });
            if (isPreviouslySelected && typeof _this3.props.rowSelection.onRowsDeselected === 'function') {
              _this3.props.rowSelection.onRowsDeselected([{
                rowIdx: rowIdx,
                row: rowData
              }]);
            } else if (!isPreviouslySelected && typeof _this3.props.rowSelection.onRowsSelected === 'function') {
              _this3.props.rowSelection.onRowsSelected([{
                rowIdx: rowIdx,
                row: rowData
              }]);
            }
          };
          this.handleRowSelect = function (rowIdx, columnKey, rowData, e) {
            e.stopPropagation();
            if (_this3.useNewRowSelection()) {
              if (_this3.props.rowSelection.enableShiftSelect === true) {
                if (!_this3.handleShiftSelect(rowIdx)) {
                  _this3.handleNewRowSelect(rowIdx, rowData);
                }
              } else {
                _this3.handleNewRowSelect(rowIdx, rowData);
              }
            } else {
              // Fallback to old onRowSelect handler
              var selectedRows = _this3.props.enableRowSelect === 'single' ? [] : _this3.state.selectedRows.slice(0);
              var selectedRow = _this3.getSelectedRow(selectedRows, rowData[_this3.props.rowKey]);
              if (selectedRow) {
                selectedRow.isSelected = !selectedRow.isSelected;
              } else {
                rowData.isSelected = true;
                selectedRows.push(rowData);
              }
              _this3.setState({
                selectedRows: selectedRows,
                selected: {
                  rowIdx: rowIdx,
                  idx: 0
                }
              });
              if (_this3.props.onRowSelect) {
                _this3.props.onRowSelect(selectedRows.filter(function (r) {
                  return r.isSelected === true;
                }));
              }
            }
          };
          this.handleCheckboxChange = function (e) {
            var allRowsSelected = void 0;
            if (e.currentTarget instanceof HTMLInputElement && e.currentTarget.checked === true) {
              allRowsSelected = true;
            } else {
              allRowsSelected = false;
            }
            if (_this3.useNewRowSelection()) {
              var _props$rowSelection$s3 = _this3.props.rowSelection.selectBy,
                keys = _props$rowSelection$s3.keys,
                indexes = _props$rowSelection$s3.indexes,
                isSelectedKey = _props$rowSelection$s3.isSelectedKey;
              if (allRowsSelected && typeof _this3.props.rowSelection.onRowsSelected === 'function') {
                var selectedRows = [];
                for (var i = 0; i < _this3.props.rowsCount; i++) {
                  var rowData = _this3.props.rowGetter(i);
                  if (!RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, i)) {
                    selectedRows.push({
                      rowIdx: i,
                      row: rowData
                    });
                  }
                }
                if (selectedRows.length > 0) {
                  _this3.props.rowSelection.onRowsSelected(selectedRows);
                }
              } else if (!allRowsSelected && typeof _this3.props.rowSelection.onRowsDeselected === 'function') {
                var deselectedRows = [];
                for (var _i2 = 0; _i2 < _this3.props.rowsCount; _i2++) {
                  var _rowData = _this3.props.rowGetter(_i2);
                  if (RowUtils.isRowSelected(keys, indexes, isSelectedKey, _rowData, _i2)) {
                    deselectedRows.push({
                      rowIdx: _i2,
                      row: _rowData
                    });
                  }
                }
                if (deselectedRows.length > 0) {
                  _this3.props.rowSelection.onRowsDeselected(deselectedRows);
                }
              }
            } else {
              var _selectedRows = [];
              for (var _i3 = 0; _i3 < _this3.props.rowsCount; _i3++) {
                var row = Object.assign({}, _this3.props.rowGetter(_i3), {
                  isSelected: allRowsSelected
                });
                _selectedRows.push(row);
              }
              _this3.setState({
                selectedRows: _selectedRows
              });
              if (typeof _this3.props.onRowSelect === 'function') {
                _this3.props.onRowSelect(_selectedRows.filter(function (r) {
                  return r.isSelected === true;
                }));
              }
            }
          };
          this.getScrollOffSet = function () {
            var scrollOffset = 0;
            if (_this3.grid) {
              var canvas = _this3.grid.querySelector('.react-grid-Canvas');
              if (canvas) {
                scrollOffset = canvas.offsetWidth - canvas.clientWidth;
              }
            }
            _this3.setState({
              scrollOffset: scrollOffset
            });
          };
          this.getRowOffsetHeight = function () {
            var offsetHeight = 0;
            _this3.getHeaderRows().forEach(function (row) {
              return offsetHeight += parseFloat(row.height, 10);
            });
            return offsetHeight;
          };
          this.getHeaderRows = function () {
            var rows = [{
              ref: function ref(node) {
                return _this3.row = node;
              },
              height: _this3.props.headerRowHeight || _this3.props.rowHeight,
              rowType: 'header'
            }];
            if (_this3.state.canFilter === true) {
              rows.push({
                ref: function ref(node) {
                  return _this3.filterRow = node;
                },
                filterable: true,
                onFilterChange: _this3.props.onAddFilter,
                height: _this3.props.headerFiltersHeight,
                rowType: 'filter'
              });
            }
            return rows;
          };
          this.getInitialSelectedRows = function () {
            var selectedRows = [];
            for (var i = 0; i < _this3.props.rowsCount; i++) {
              selectedRows.push(false);
            }
            return selectedRows;
          };
          this.getRowSelectionProps = function () {
            if (_this3.props.rowSelection) {
              return _this3.props.rowSelection.selectBy;
            }
            return null;
          };
          this.getSelectedRows = function () {
            if (_this3.props.rowSelection) {
              return null;
            }
            return _this3.state.selectedRows.filter(function (r) {
              return r.isSelected === true;
            });
          };
          this.getSelectedValue = function () {
            var rowIdx = _this3.state.selected.rowIdx;
            var idx = _this3.state.selected.idx;
            var cellKey = _this3.getColumn(idx).key;
            var row = _this3.props.rowGetter(rowIdx);
            return RowUtils.get(row, cellKey);
          };
          this.canExitGrid = function (e) {
            // When the cellNavigationMode is 'none', you can exit the grid if you're at the start or end of the row
            // When the cellNavigationMode is 'changeRow', you can exit the grid if you're at the first or last cell of the grid
            // When the cellNavigationMode is 'loopOverRow', there is no logical exit point so you can't exit the grid
            var atLastCellInRow = _this3.isAtLastCellInRow(_this3.getNbrColumns());
            var atFirstCellInRow = _this3.isAtFirstCellInRow();
            var atLastRow = _this3.isAtLastRow();
            var atFirstRow = _this3.isAtFirstRow();
            var shift = e.shiftKey === true;
            var cellNavigationMode = _this3.props.cellNavigationMode;
            if (shift) {
              if (cellNavigationMode === 'none') {
                if (atFirstCellInRow) {
                  return true;
                }
              } else if (cellNavigationMode === 'changeRow') {
                if (atFirstCellInRow && atFirstRow) {
                  return true;
                }
              }
            } else {
              if (cellNavigationMode === 'none') {
                if (atLastCellInRow) {
                  return true;
                }
              } else if (cellNavigationMode === 'changeRow') {
                if (atLastCellInRow && atLastRow) {
                  return true;
                }
              }
            }
            return false;
          };
          this.moveSelectedCell = function (e, rowDelta, cellDelta) {
            // we need to prevent default as we control grid scroll
            // otherwise it moves every time you left/right which is janky
            e.preventDefault();
            var rowIdx = void 0;
            var idx = void 0;
            var cellNavigationMode = _this3.props.cellNavigationMode;
            if (cellNavigationMode !== 'none') {
              var _calculateNextSelecti = _this3.calculateNextSelectionPosition(cellNavigationMode, cellDelta, rowDelta);
              idx = _calculateNextSelecti.idx;
              rowIdx = _calculateNextSelecti.rowIdx;
            } else {
              rowIdx = _this3.state.selected.rowIdx + rowDelta;
              idx = _this3.state.selected.idx + cellDelta;
            }
            _this3.scrollToColumn(idx);
            _this3.onSelect({
              idx: idx,
              rowIdx: rowIdx
            });
          };
          this.getNbrColumns = function () {
            var _props = _this3.props,
              columns = _props.columns,
              enableRowSelect = _props.enableRowSelect;
            return enableRowSelect ? columns.length + 1 : columns.length;
          };
          this.getDataGridDOMNode = function () {
            return _this3.grid;
          };
          this.calculateNextSelectionPosition = function (cellNavigationMode, cellDelta, rowDelta) {
            var _rowDelta = rowDelta;
            var idx = _this3.state.selected.idx + cellDelta;
            var nbrColumns = _this3.getNbrColumns();
            if (cellDelta > 0) {
              if (_this3.isAtLastCellInRow(nbrColumns)) {
                if (cellNavigationMode === 'changeRow') {
                  _rowDelta = _this3.isAtLastRow() ? rowDelta : rowDelta + 1;
                  idx = _this3.isAtLastRow() ? idx : 0;
                } else {
                  idx = 0;
                }
              }
            } else if (cellDelta < 0) {
              if (_this3.isAtFirstCellInRow()) {
                if (cellNavigationMode === 'changeRow') {
                  _rowDelta = _this3.isAtFirstRow() ? rowDelta : rowDelta - 1;
                  idx = _this3.isAtFirstRow() ? 0 : nbrColumns - 1;
                } else {
                  idx = nbrColumns - 1;
                }
              }
            }
            var rowIdx = _this3.state.selected.rowIdx + _rowDelta;
            return {
              idx: idx,
              rowIdx: rowIdx
            };
          };
          this.isAtLastCellInRow = function (nbrColumns) {
            return _this3.state.selected.idx === nbrColumns - 1;
          };
          this.isAtLastRow = function () {
            return _this3.state.selected.rowIdx === _this3.props.rowsCount - 1;
          };
          this.isAtFirstCellInRow = function () {
            return _this3.state.selected.idx === 0;
          };
          this.isAtFirstRow = function () {
            return _this3.state.selected.rowIdx === 0;
          };
          this.openCellEditor = function (rowIdx, idx) {
            var row = _this3.props.rowGetter(rowIdx);
            var col = _this3.getColumn(idx);
            if (!ColumnUtils.canEdit(col, row, _this3.props.enableCellSelect)) {
              return;
            }
            var selected = {
              rowIdx: rowIdx,
              idx: idx
            };
            if (_this3.hasSelectedCellChanged(selected)) {
              _this3.setState({
                selected: selected
              }, function () {
                _this3.setActive('Enter');
              });
            } else {
              _this3.setActive('Enter');
            }
          };
          this.scrollToColumn = function (colIdx) {
            if (_this3.grid) {
              var canvas = _this3.grid.querySelector('.react-grid-Canvas');
              if (canvas) {
                var left = 0;
                var locked = 0;
                for (var i = 0; i < colIdx; i++) {
                  var column = _this3.getColumn(i);
                  if (column) {
                    if (column.width) {
                      left += column.width;
                    }
                    if (column.locked) {
                      locked += column.width;
                    }
                  }
                }
                var selectedColumn = _this3.getColumn(colIdx);
                if (selectedColumn) {
                  var scrollLeft = left - locked - canvas.scrollLeft;
                  var scrollRight = left + selectedColumn.width - canvas.scrollLeft;
                  if (scrollLeft < 0) {
                    canvas.scrollLeft += scrollLeft;
                  } else if (scrollRight > canvas.clientWidth) {
                    var scrollAmount = scrollRight - canvas.clientWidth;
                    canvas.scrollLeft += scrollAmount;
                  }
                }
              }
            }
          };
          this.deselect = function () {
            var selected = {
              rowIdx: -1,
              idx: -1
            };
            _this3.setState({
              selected: selected
            });
          };
          this.setActive = function (keyPressed) {
            var rowIdx = _this3.state.selected.rowIdx;
            var row = _this3.props.rowGetter(rowIdx);
            var idx = _this3.state.selected.idx;
            var column = _this3.getColumn(idx);
            if (ColumnUtils.canEdit(column, row, _this3.props.enableCellSelect) && !_this3.isActive()) {
              var selected = Object.assign({}, _this3.state.selected, {
                idx: idx,
                rowIdx: rowIdx,
                active: true,
                initialKeyCode: keyPressed
              });
              var showEditor = true;
              if (typeof _this3.props.onCheckCellIsEditable === 'function') {
                var args = Object.assign({}, {
                  row: row,
                  column: column
                }, selected);
                showEditor = _this3.props.onCheckCellIsEditable(args);
              }
              if (showEditor !== false) {
                if (column.locked) {
                  _this3.setState({
                    selected: selected
                  });
                } else {
                  _this3.setState({
                    selected: selected
                  }, function () {
                    _this3.scrollToColumn(idx);
                  });
                }
                _this3.props.onBeforeEdit();
                _this3.handleCancelCopy();
              }
            }
          };
          this.setInactive = function () {
            var rowIdx = _this3.state.selected.rowIdx;
            var row = _this3.props.rowGetter(rowIdx);
            var idx = _this3.state.selected.idx;
            var col = _this3.getColumn(idx);
            if (ColumnUtils.canEdit(col, row, _this3.props.enableCellSelect) && _this3.isActive()) {
              var selected = Object.assign({}, _this3.state.selected, {
                idx: idx,
                rowIdx: rowIdx,
                active: false
              });
              _this3.setState({
                selected: selected
              });
            }
          };
          this.isActive = function () {
            return _this3.state.selected.active === true;
          };
          this.setupGridColumns = function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;
            var columns = props.columns;
            if (_this3._cachedColumns === columns) {
              return _this3._cachedComputedColumns;
            }
            _this3._cachedColumns = columns;
            var cols = columns.slice(0);
            var unshiftedCols = {};
            if (_this3.props.rowActionsCell || props.enableRowSelect && !_this3.props.rowSelection || props.rowSelection && props.rowSelection.showCheckbox !== false) {
              var SelectAllComponent = _this3.props.selectAllRenderer || _SelectAll2['default'];
              var SelectAllRenderer = React.createElement(SelectAllComponent, {
                onChange: _this3.handleCheckboxChange,
                inputRef: function inputRef(grid) {
                  return _this3.selectAllCheckbox = grid;
                }
              });
              var headerRenderer = props.enableRowSelect === 'single' ? null : SelectAllRenderer;
              var Formatter = _this3.props.rowActionsCell ? _this3.props.rowActionsCell : CheckboxEditor;
              var selectColumn = {
                key: 'select-row',
                name: '',
                formatter: React.createElement(Formatter, {
                  rowSelection: _this3.props.rowSelection
                }),
                onCellChange: _this3.handleRowSelect,
                filterable: false,
                headerRenderer: headerRenderer,
                width: 60,
                locked: true,
                getRowMetaData: function getRowMetaData(rowData) {
                  return rowData;
                },
                cellClass: _this3.props.rowActionsCell ? 'rdg-row-actions-cell' : ''
              };
              unshiftedCols = cols.unshift(selectColumn);
              cols = unshiftedCols > 0 ? cols : unshiftedCols;
            }
            _this3._cachedComputedColumns = cols;
            return _this3._cachedComputedColumns;
          };
          this.copyPasteEnabled = function () {
            return _this3.props.onCellCopyPaste !== null;
          };
          this.dragEnabled = function () {
            return _this3.props.onGridRowsUpdated !== undefined || _this3.props.onCellsDragged !== undefined;
          };
          this.renderToolbar = function () {
            var Toolbar = _this3.props.toolbar;
            var toolBarProps = {
              columns: _this3.props.columns,
              onToggleFilter: _this3.onToggleFilter,
              numberOfRows: _this3.props.rowsCount
            };
            if (React.isValidElement(Toolbar)) {
              return React.cloneElement(Toolbar, toolBarProps);
            } else if (isFunction(Toolbar)) {
              return React.createElement(Toolbar, toolBarProps);
            }
          };
        };
        module.exports = ReactDataGrid;

        /***/
      }, /* 120 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var Draggable = __webpack_require__(109);
        __webpack_require__(15);
        var style = {
          position: 'absolute',
          top: 0,
          right: 0,
          width: 6,
          height: '100%'
        };
        var ResizeHandle = function (_React$Component) {
          _inherits(ResizeHandle, _React$Component);
          function ResizeHandle() {
            _classCallCheck(this, ResizeHandle);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          ResizeHandle.prototype.render = function render() {
            return React.createElement(Draggable, _extends({}, this.props, {
              className: 'react-grid-HeaderCell__resizeHandle',
              style: style
            }));
          };
          return ResizeHandle;
        }(React.Component);
        module.exports = ResizeHandle;

        /***/
      }, /* 121 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _utils = __webpack_require__(53);
        var _utils2 = _interopRequireDefault(_utils);
        __webpack_require__(29);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var cellMetaDataShape = __webpack_require__(11);
        var RowGroup = function (_Component) {
          _inherits(RowGroup, _Component);
          function RowGroup(props) {
            _classCallCheck(this, RowGroup);
            var _this = _possibleConstructorReturn(this, _Component.call(this, props));
            _this.onRowExpandToggle = _this.onRowExpandToggle.bind(_this);
            _this.onRowExpandClick = _this.onRowExpandClick.bind(_this);
            _this.setScrollLeft = _this.setScrollLeft.bind(_this);
            return _this;
          }
          RowGroup.prototype.onRowExpandToggle = function onRowExpandToggle(expand) {
            var shouldExpand = expand == null ? !this.props.isExpanded : expand;
            var meta = this.props.cellMetaData;
            if (meta != null && meta.onRowExpandToggle && typeof meta.onRowExpandToggle === 'function') {
              meta.onRowExpandToggle({
                rowIdx: this.props.idx,
                shouldExpand: shouldExpand,
                columnGroupName: this.props.columnGroupName,
                name: this.props.name
              });
            }
          };
          RowGroup.prototype.onRowExpandClick = function onRowExpandClick() {
            this.onRowExpandToggle(!this.props.isExpanded);
          };
          RowGroup.prototype.setScrollLeft = function setScrollLeft(scrollLeft) {
            if (this.rowGroupRenderer) {
              this.rowGroupRenderer.setScrollLeft ? this.rowGroupRenderer.setScrollLeft(scrollLeft) : null;
            }
          };
          RowGroup.prototype.render = function render() {
            var _this2 = this;
            var lastColumn = _utils2['default'].last(this.props.columns);
            var style = {
              width: lastColumn.left + lastColumn.width
            };
            return _react2['default'].createElement('div', {
              style: style,
              className: 'react-grid-row-group'
            }, _react2['default'].createElement(this.props.renderer, _extends({
              ref: function ref(node) {
                _this2.rowGroupRenderer = node;
              }
            }, this.props, {
              onRowExpandClick: this.onRowExpandClick,
              onRowExpandToggle: this.onRowExpandToggle
            })));
          };
          return RowGroup;
        }(_react.Component);
        RowGroup.propTypes = {
          height: _propTypes2['default'].number.isRequired,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
          row: _propTypes2['default'].any.isRequired,
          cellRenderer: _propTypes2['default'].func,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
          isSelected: _propTypes2['default'].bool,
          idx: _propTypes2['default'].number.isRequired,
          expandedRows: _propTypes2['default'].arrayOf(_propTypes2['default'].object),
          extraClasses: _propTypes2['default'].string,
          forceUpdate: _propTypes2['default'].bool,
          subRowDetails: _propTypes2['default'].object,
          isRowHovered: _propTypes2['default'].bool,
          colVisibleStart: _propTypes2['default'].number.isRequired,
          colVisibleEnd: _propTypes2['default'].number.isRequired,
          colDisplayStart: _propTypes2['default'].number.isRequired,
          colDisplayEnd: _propTypes2['default'].number.isRequired,
          isScrolling: _propTypes2['default'].bool.isRequired,
          columnGroupName: _propTypes2['default'].string.isRequired,
          isExpanded: _propTypes2['default'].bool.isRequired,
          treeDepth: _propTypes2['default'].number.isRequired,
          name: _propTypes2['default'].string.isRequired,
          renderer: _propTypes2['default'].func
        };
        var DefaultRowGroupRenderer = function DefaultRowGroupRenderer(props) {
          var treeDepth = props.treeDepth || 0;
          var marginLeft = treeDepth * 20;
          var style = {
            height: '50px',
            border: '1px solid #dddddd',
            paddingTop: '15px',
            paddingLeft: '5px'
          };
          var onKeyDown = function onKeyDown(e) {
            if (e.key === 'ArrowLeft') {
              props.onRowExpandToggle(false);
            }
            if (e.key === 'ArrowRight') {
              props.onRowExpandToggle(true);
            }
            if (e.key === 'Enter') {
              props.onRowExpandToggle(!props.isExpanded);
            }
          };
          return _react2['default'].createElement('div', {
            style: style,
            onKeyDown: onKeyDown,
            tabIndex: 0
          }, _react2['default'].createElement('span', {
            className: 'row-expand-icon',
            style: {
              float: 'left',
              marginLeft: marginLeft,
              cursor: 'pointer'
            },
            onClick: props.onRowExpandClick
          }, props.isExpanded ? String.fromCharCode('9660') : String.fromCharCode('9658')), _react2['default'].createElement('strong', null, props.columnGroupName, ': ', props.name));
        };
        DefaultRowGroupRenderer.propTypes = {
          onRowExpandClick: _propTypes2['default'].func.isRequired,
          onRowExpandToggle: _propTypes2['default'].func.isRequired,
          isExpanded: _propTypes2['default'].bool.isRequired,
          treeDepth: _propTypes2['default'].number.isRequired,
          name: _propTypes2['default'].string.isRequired,
          columnGroupName: _propTypes2['default'].string.isRequired,
          hideColumnName: _propTypes2['default'].bool
        };
        RowGroup.defaultProps = {
          renderer: DefaultRowGroupRenderer
        };
        exports['default'] = RowGroup;

        /***/
      }, /* 122 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _ColumnUtils = __webpack_require__(6);
        var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);
        var _viewportUtils = __webpack_require__(137);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var Canvas = __webpack_require__(104);
        var cellMetaDataShape = __webpack_require__(11);
        var Viewport = function (_React$Component) {
          _inherits(Viewport, _React$Component);
          function Viewport() {
            var _temp, _this, _ret;
            _classCallCheck(this, Viewport);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = (0, _viewportUtils.getGridState)(_this.props), _this.onScroll = function (scroll) {
              _this.updateScroll(scroll.scrollTop, scroll.scrollLeft, _this.state.height, _this.props.rowHeight, _this.props.rowsCount);
              if (_this.props.onScroll) {
                _this.props.onScroll({
                  scrollTop: scroll.scrollTop,
                  scrollLeft: scroll.scrollLeft
                });
              }
            }, _this.getScroll = function () {
              return _this.canvas.getScroll();
            }, _this.setScrollLeft = function (scrollLeft) {
              _this.canvas.setScrollLeft(scrollLeft);
            }, _this.getDOMNodeOffsetWidth = function () {
              return _this.viewport ? _this.viewport.offsetWidth : 0;
            }, _this.clearScrollTimer = function () {
              if (_this.resetScrollStateTimeoutId) {
                clearTimeout(_this.resetScrollStateTimeoutId);
              }
            }, _this.resetScrollStateAfterDelay = function () {
              _this.clearScrollTimer();
              _this.resetScrollStateTimeoutId = setTimeout(_this.resetScrollStateAfterDelayCallback, 500);
            }, _this.resetScrollStateAfterDelayCallback = function () {
              _this.resetScrollStateTimeoutId = null;
              _this.setState({
                isScrolling: false
              });
            }, _this.updateScroll = function (scrollTop, scrollLeft, height, rowHeight, length, width) {
              _this.resetScrollStateAfterDelay();
              var nextScrollState = (0, _viewportUtils.getNextScrollState)(_this.props, _this.getDOMNodeOffsetWidth, scrollTop, scrollLeft, height, rowHeight, length, width);
              _this.setState(nextScrollState);
            }, _this.metricsUpdated = function () {
              var height = _this.viewportHeight();
              var width = _this.viewportWidth();
              if (height) {
                _this.updateScroll(_this.state.scrollTop, _this.state.scrollLeft, height, _this.props.rowHeight, _this.props.rowsCount, width);
              }
            }, _this.viewportHeight = function () {
              return _this.viewport ? _this.viewport.offsetHeight : 0;
            }, _this.viewportWidth = function () {
              return _this.viewport ? _this.viewport.offsetWidth : 0;
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Viewport.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.rowHeight !== nextProps.rowHeight || this.props.minHeight !== nextProps.minHeight) {
              var newState = (0, _viewportUtils.getGridState)(nextProps);
              this.updateScroll(newState.scrollTop, newState.scrollLeft, newState.height, nextProps.rowHeight, nextProps.rowsCount);
            } else if (_ColumnUtils2['default'].getSize(this.props.columnMetrics.columns) !== _ColumnUtils2['default'].getSize(nextProps.columnMetrics.columns)) {
              this.setState((0, _viewportUtils.getGridState)(nextProps));
            } else if (this.props.rowsCount !== nextProps.rowsCount) {
              this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height, nextProps.rowHeight, nextProps.rowsCount);
              // Added to fix the hiding of the bottom scrollbar when showing the filters.
            } else if (this.props.rowOffsetHeight !== nextProps.rowOffsetHeight) {
              // The value of height can be positive or negative and will be added to the current height to cater for changes in the header height (due to the filer)
              var height = this.props.rowOffsetHeight - nextProps.rowOffsetHeight;
              this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height + height, nextProps.rowHeight, nextProps.rowsCount);
            }
          };
          Viewport.prototype.componentDidMount = function componentDidMount() {
            if (window.addEventListener) {
              window.addEventListener('resize', this.metricsUpdated);
            } else {
              window.attachEvent('resize', this.metricsUpdated);
            }
            this.metricsUpdated();
          };
          Viewport.prototype.componentWillUnmount = function componentWillUnmount() {
            window.removeEventListener('resize', this.metricsUpdated);
            this.clearScrollTimer();
          };
          Viewport.prototype.render = function render() {
            var _this2 = this;
            var style = {
              padding: 0,
              bottom: 0,
              left: 0,
              right: 0,
              overflow: 'hidden',
              position: 'absolute',
              top: this.props.rowOffsetHeight
            };
            return React.createElement('div', {
              className: 'react-grid-Viewport',
              style: style,
              ref: function ref(node) {
                _this2.viewport = node;
              }
            }, React.createElement(Canvas, {
              ref: function ref(node) {
                return _this2.canvas = node;
              },
              rowKey: this.props.rowKey,
              totalWidth: this.props.totalWidth,
              width: this.props.columnMetrics.width,
              rowGetter: this.props.rowGetter,
              rowsCount: this.props.rowsCount,
              selectedRows: this.props.selectedRows,
              expandedRows: this.props.expandedRows,
              columns: this.props.columnMetrics.columns,
              rowRenderer: this.props.rowRenderer,
              displayStart: this.state.displayStart,
              displayEnd: this.state.displayEnd,
              visibleStart: this.state.visibleStart,
              visibleEnd: this.state.visibleEnd,
              colVisibleStart: this.state.colVisibleStart,
              colVisibleEnd: this.state.colVisibleEnd,
              colDisplayStart: this.state.colDisplayStart,
              colDisplayEnd: this.state.colDisplayEnd,
              cellMetaData: this.props.cellMetaData,
              height: this.state.height,
              rowHeight: this.props.rowHeight,
              onScroll: this.onScroll,
              onRows: this.props.onRows,
              rowScrollTimeout: this.props.rowScrollTimeout,
              scrollToRowIndex: this.props.scrollToRowIndex,
              contextMenu: this.props.contextMenu,
              rowSelection: this.props.rowSelection,
              getSubRowDetails: this.props.getSubRowDetails,
              rowGroupRenderer: this.props.rowGroupRenderer,
              isScrolling: this.state.isScrolling || false
            }));
          };
          return Viewport;
        }(React.Component);
        Viewport.displayName = 'Viewport';
        Viewport.propTypes = {
          rowOffsetHeight: _propTypes2['default'].number.isRequired,
          totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]).isRequired,
          columnMetrics: _propTypes2['default'].object.isRequired,
          rowGetter: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]).isRequired,
          selectedRows: _propTypes2['default'].array,
          rowSelection: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
            indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
          }), _propTypes2['default'].shape({
            isSelectedKey: _propTypes2['default'].string.isRequired
          }), _propTypes2['default'].shape({
            keys: _propTypes2['default'].shape({
              values: _propTypes2['default'].array.isRequired,
              rowKey: _propTypes2['default'].string.isRequired
            }).isRequired
          })]),
          expandedRows: _propTypes2['default'].array,
          rowRenderer: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].func]),
          rowsCount: _propTypes2['default'].number.isRequired,
          rowHeight: _propTypes2['default'].number.isRequired,
          onRows: _propTypes2['default'].func,
          onScroll: _propTypes2['default'].func,
          minHeight: _propTypes2['default'].number,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
          rowKey: _propTypes2['default'].string.isRequired,
          rowScrollTimeout: _propTypes2['default'].number,
          scrollToRowIndex: _propTypes2['default'].number,
          contextMenu: _propTypes2['default'].element,
          getSubRowDetails: _propTypes2['default'].func,
          rowGroupRenderer: _propTypes2['default'].func
        };
        Viewport.defaultProps = {
          rowHeight: 30
        };
        module.exports = Viewport;

        /***/
      }, /* 123 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var ExcelColumn = __webpack_require__(12);
        var FilterableHeaderCell = function (_React$Component) {
          _inherits(FilterableHeaderCell, _React$Component);
          function FilterableHeaderCell() {
            var _temp, _this, _ret;
            _classCallCheck(this, FilterableHeaderCell);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              filterTerm: ''
            }, _this.handleChange = function (e) {
              var val = e.target.value;
              _this.setState({
                filterTerm: val
              });
              _this.props.onChange({
                filterTerm: val,
                column: _this.props.column
              });
            }, _this.renderInput = function () {
              if (_this.props.column.filterable === false) {
                return React.createElement('span', null);
              }
              var inputKey = 'header-filter-' + _this.props.column.key;
              return React.createElement('input', {
                key: inputKey,
                type: 'text',
                className: 'form-control input-sm',
                placeholder: 'Search',
                value: _this.state.filterTerm,
                onChange: _this.handleChange
              });
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          FilterableHeaderCell.prototype.render = function render() {
            return React.createElement('div', null, React.createElement('div', {
              className: 'form-group'
            }, this.renderInput()));
          };
          return FilterableHeaderCell;
        }(React.Component);
        FilterableHeaderCell.propTypes = {
          onChange: _propTypes2['default'].func.isRequired,
          column: _propTypes2['default'].shape(ExcelColumn)
        };
        module.exports = FilterableHeaderCell;

        /***/
      }, /* 124 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _keyboardUtils = __webpack_require__(55);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var joinClasses = __webpack_require__(5);
        var SimpleTextEditor = __webpack_require__(49);
        var isFunction = __webpack_require__(19);
        __webpack_require__(20);
        var EditorContainer = function (_React$Component) {
          _inherits(EditorContainer, _React$Component);
          function EditorContainer() {
            var _temp, _this, _ret;
            _classCallCheck(this, EditorContainer);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
          }
          EditorContainer.prototype.componentDidMount = function componentDidMount() {
            var inputNode = this.getInputNode();
            if (inputNode !== undefined) {
              this.setTextInputFocus();
              if (!this.getEditor().disableContainerStyles) {
                inputNode.className += ' editor-main';
                inputNode.style.height = this.props.height - 1 + 'px';
              }
            }
          };
          EditorContainer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (!this.changeCommitted && !this.changeCanceled) {
              this.commit({
                key: 'Enter'
              });
            }
          };
          EditorContainer.prototype.render = function render() {
            return React.createElement('div', {
              className: this.getContainerClass(),
              onBlur: this.handleBlur,
              onKeyDown: this.onKeyDown,
              onContextMenu: this.handleRightClick
            }, this.createEditor(), this.renderStatusIcon());
          };
          return EditorContainer;
        }(React.Component);
        EditorContainer.displayName = 'EditorContainer';
        EditorContainer.propTypes = {
          rowIdx: _propTypes2['default'].number,
          rowData: _propTypes2['default'].object.isRequired,
          value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].object, _propTypes2['default'].bool]).isRequired,
          cellMetaData: _propTypes2['default'].shape({
            selected: _propTypes2['default'].object.isRequired,
            copied: _propTypes2['default'].object,
            dragged: _propTypes2['default'].object,
            onCellClick: _propTypes2['default'].func,
            onCellDoubleClick: _propTypes2['default'].func,
            onCommitCancel: _propTypes2['default'].func,
            onCommit: _propTypes2['default'].func
          }).isRequired,
          column: _propTypes2['default'].object.isRequired,
          height: _propTypes2['default'].number.isRequired,
          onGridKeyDown: _propTypes2['default'].func
        };
        var _initialiseProps = function _initialiseProps() {
          var _this2 = this;
          this.state = {
            isInvalid: false
          };
          this.changeCommitted = false;
          this.changeCanceled = false;
          this.isKeyExplicitlyHandled = function (key) {
            return isFunction(_this2['onPress' + key]);
          };
          this.checkAndCall = function (methodName, args) {
            if (isFunction(_this2[methodName])) {
              _this2[methodName](args);
            }
          };
          this.onKeyDown = function (e) {
            if ((0, _keyboardUtils.isCtrlKeyHeldDown)(e)) {
              _this2.checkAndCall('onPressKeyWithCtrl', e);
            } else if (_this2.isKeyExplicitlyHandled(e.key)) {
              // break up individual keyPress events to have their own specific callbacks
              var callBack = 'onPress' + e.key;
              _this2.checkAndCall(callBack, e);
            } else if ((0, _keyboardUtils.isKeyPrintable)(e.keyCode)) {
              _this2.checkAndCall('onPressChar', e);
            }

            // Track which keys are currently down for shift clicking etc
            _this2._keysDown = _this2._keysDown || {};
            _this2._keysDown[e.keyCode] = true;
            if (isFunction(_this2.props.onGridKeyDown)) {
              _this2.props.onGridKeyDown(e);
            }
          };
          this.createEditorRef = function (ref) {
            _this2.editor = ref;
          };
          this.createEditor = function () {
            var editorProps = {
              ref: _this2.createEditorRef,
              column: _this2.props.column,
              value: _this2.getInitialValue(),
              onCommit: _this2.commit,
              onCommitCancel: _this2.commitCancel,
              rowMetaData: _this2.getRowMetaData(),
              rowData: _this2.props.rowData,
              height: _this2.props.height,
              onBlur: _this2.commit,
              onOverrideKeyDown: _this2.onKeyDown
            };
            var CustomEditor = _this2.props.column.editor;
            // return custom column editor or SimpleEditor if none specified
            if (React.isValidElement(CustomEditor)) {
              return React.cloneElement(CustomEditor, editorProps);
            }
            if (isFunction(CustomEditor)) {
              return React.createElement(CustomEditor, _extends({
                ref: _this2.createEditorRef
              }, editorProps));
            }
            return React.createElement(SimpleTextEditor, {
              ref: _this2.createEditorRef,
              column: _this2.props.column,
              value: _this2.getInitialValue(),
              onBlur: _this2.commit,
              rowMetaData: _this2.getRowMetaData(),
              onKeyDown: function onKeyDown() {},
              commit: function commit() {}
            });
          };
          this.onPressEnter = function () {
            _this2.commit({
              key: 'Enter'
            });
          };
          this.onPressTab = function () {
            _this2.commit({
              key: 'Tab'
            });
          };
          this.onPressEscape = function (e) {
            if (!_this2.editorIsSelectOpen()) {
              _this2.commitCancel();
            } else {
              // prevent event from bubbling if editor has results to select
              e.stopPropagation();
            }
          };
          this.onPressArrowDown = function (e) {
            if (_this2.editorHasResults()) {
              // dont want to propogate as that then moves us round the grid
              e.stopPropagation();
            } else {
              _this2.commit(e);
            }
          };
          this.onPressArrowUp = function (e) {
            if (_this2.editorHasResults()) {
              // dont want to propogate as that then moves us round the grid
              e.stopPropagation();
            } else {
              _this2.commit(e);
            }
          };
          this.onPressArrowLeft = function (e) {
            // prevent event propogation. this disables left cell navigation
            if (!_this2.isCaretAtBeginningOfInput()) {
              e.stopPropagation();
            } else {
              _this2.commit(e);
            }
          };
          this.onPressArrowRight = function (e) {
            // prevent event propogation. this disables right cell navigation
            if (!_this2.isCaretAtEndOfInput()) {
              e.stopPropagation();
            } else {
              _this2.commit(e);
            }
          };
          this.editorHasResults = function () {
            if (isFunction(_this2.getEditor().hasResults)) {
              return _this2.getEditor().hasResults();
            }
            return false;
          };
          this.editorIsSelectOpen = function () {
            if (isFunction(_this2.getEditor().isSelectOpen)) {
              return _this2.getEditor().isSelectOpen();
            }
            return false;
          };
          this.getRowMetaData = function () {
            // clone row data so editor cannot actually change this
            // convention based method to get corresponding Id or Name of any Name or Id property
            if (typeof _this2.props.column.getRowMetaData === 'function') {
              return _this2.props.column.getRowMetaData(_this2.props.rowData, _this2.props.column);
            }
          };
          this.getEditor = function () {
            return _this2.editor;
          };
          this.getInputNode = function () {
            return _this2.getEditor().getInputNode();
          };
          this.getInitialValue = function () {
            var selected = _this2.props.cellMetaData.selected;
            var keyCode = selected.initialKeyCode;
            if (keyCode === 'Delete' || keyCode === 'Backspace') {
              return '';
            } else if (keyCode === 'Enter') {
              return _this2.props.value;
            }
            var text = keyCode ? String.fromCharCode(keyCode) : _this2.props.value;
            return text;
          };
          this.getContainerClass = function () {
            return joinClasses({
              'has-error': _this2.state.isInvalid === true
            });
          };
          this.commit = function (args) {
            var opts = args || {};
            var updated = _this2.getEditor().getValue();
            if (_this2.isNewValueValid(updated)) {
              _this2.changeCommitted = true;
              var cellKey = _this2.props.column.key;
              _this2.props.cellMetaData.onCommit({
                cellKey: cellKey,
                rowIdx: _this2.props.rowIdx,
                updated: updated,
                key: opts.key
              });
            }
          };
          this.commitCancel = function () {
            _this2.changeCanceled = true;
            _this2.props.cellMetaData.onCommitCancel();
          };
          this.isNewValueValid = function (value) {
            if (isFunction(_this2.getEditor().validate)) {
              var isValid = _this2.getEditor().validate(value);
              _this2.setState({
                isInvalid: !isValid
              });
              return isValid;
            }
            return true;
          };
          this.setCaretAtEndOfInput = function () {
            var input = _this2.getInputNode();
            // taken from http://stackoverflow.com/questions/511088/use-javascript-to-place-cursor-at-end-of-text-in-text-input-element
            var txtLength = input.value.length;
            if (input.setSelectionRange) {
              input.setSelectionRange(txtLength, txtLength);
            } else if (input.createTextRange) {
              var fieldRange = input.createTextRange();
              fieldRange.moveStart('character', txtLength);
              fieldRange.collapse();
              fieldRange.select();
            }
          };
          this.isCaretAtBeginningOfInput = function () {
            var inputNode = _this2.getInputNode();
            return inputNode.selectionStart === inputNode.selectionEnd && inputNode.selectionStart === 0;
          };
          this.isCaretAtEndOfInput = function () {
            var inputNode = _this2.getInputNode();
            return inputNode.selectionStart === inputNode.value.length;
          };
          this.isBodyClicked = function (e) {
            var relatedTarget = _this2.getRelatedTarget(e);
            return relatedTarget === null;
          };
          this.isViewportClicked = function (e) {
            var relatedTarget = _this2.getRelatedTarget(e);
            return relatedTarget.className.indexOf('react-grid-Viewport') > -1;
          };
          this.isClickInsideEditor = function (e) {
            var relatedTarget = _this2.getRelatedTarget(e);
            return e.currentTarget.contains(relatedTarget) || relatedTarget.className.indexOf('editing') > -1 || relatedTarget.className.indexOf('react-grid-Cell') > -1;
          };
          this.getRelatedTarget = function (e) {
            return e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
          };

          this.handleRightClick = function (e) {
            e.stopPropagation();
          };
          this.handleBlur = function (e) {
            e.stopPropagation();
            if (_this2.isBodyClicked(e)) {
              _this2.commit(e);
            }
            if (!_this2.isBodyClicked(e)) {
              // prevent null reference
              if (_this2.isViewportClicked(e) || !_this2.isClickInsideEditor(e)) {
                _this2.commit(e);
              }
            }
          };
          this.setTextInputFocus = function () {
            var selected = _this2.props.cellMetaData.selected;
            var keyCode = selected.initialKeyCode;
            var inputNode = _this2.getInputNode();
            inputNode.focus();
            if (inputNode.tagName === 'INPUT') {
              if (!(0, _keyboardUtils.isKeyPrintable)(keyCode)) {
                inputNode.focus();
                inputNode.select();
              } else {
                inputNode.select();
              }
            }
          };
          this.renderStatusIcon = function () {
            if (_this2.state.isInvalid === true) {
              return React.createElement('span', {
                className: 'glyphicon glyphicon-remove form-control-feedback'
              });
            }
          };
        };
        module.exports = EditorContainer;

        /***/
      }, /* 125 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        module.exports = {
          CheckboxEditor: __webpack_require__(47),
          EditorBase: __webpack_require__(48),
          SimpleTextEditor: __webpack_require__(49)
        };

        /***/
      }, /* 126 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _reactDom = __webpack_require__(9);
        var _reactDom2 = _interopRequireDefault(_reactDom);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        } /* eslint-disable react/prop-types */

        var focusableComponentWrapper = function focusableComponentWrapper(WrappedComponent) {
          return function (_Component) {
            _inherits(ComponentWrapper, _Component);
            function ComponentWrapper() {
              _classCallCheck(this, ComponentWrapper);
              var _this = _possibleConstructorReturn(this, _Component.call(this));
              _this.checkFocus = _this.checkFocus.bind(_this);
              _this.state = {
                isScrolling: false
              };
              return _this;
            }
            ComponentWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
              return WrappedComponent.isSelected(this.props) !== WrappedComponent.isSelected(nextProps);
            };
            ComponentWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
              var isScrolling = WrappedComponent.isScrolling(nextProps);
              if (isScrolling && !this.state.isScrolling) {
                this.setState({
                  isScrolling: isScrolling
                });
              }
            };
            ComponentWrapper.prototype.componentDidMount = function componentDidMount() {
              this.checkFocus();
            };
            ComponentWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
              this.checkFocus();
            };
            ComponentWrapper.prototype.checkFocus = function checkFocus() {
              if (WrappedComponent.isSelected(this.props) && this.state.isScrolling) {
                this.focus();
                this.setState({
                  isScrolling: false
                });
              }
            };
            ComponentWrapper.prototype.focus = function focus() {
              _reactDom2['default'].findDOMNode(this).focus();
            };
            ComponentWrapper.prototype.render = function render() {
              return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, this.state));
            };
            return ComponentWrapper;
          }(_react.Component);
        };
        exports['default'] = focusableComponentWrapper;

        /***/
      }, /* 127 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        module.exports = {
          SimpleCellFormatter: __webpack_require__(51),
          SelectAll: __webpack_require__(50)
        };

        /***/
      }, /* 128 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _GridPropHelpers = __webpack_require__(129);
        var _GridPropHelpers2 = _interopRequireDefault(_GridPropHelpers);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        module.exports = {
          test: {
            GridPropHelpers: _GridPropHelpers2['default']
          }
        };

        /***/
      }, /* 129 */
      /***/function (module, exports) {
        'use strict';

        var _rows = [];
        for (var i = 0; i < 1000; i++) {
          _rows.push({
            id: i,
            title: 'Title ' + i,
            count: i * 1000
          });
        }
        module.exports = {
          columns: [{
            key: 'id',
            name: 'ID',
            width: 100
          }, {
            key: 'title',
            name: 'Title',
            width: 100
          }, {
            key: 'count',
            name: 'Count',
            width: 100
          }],
          rowGetter: function rowGetter(i) {
            return _rows[i];
          },
          rowsCount: function rowsCount() {
            return _rows.length;
          },
          cellMetaData: {
            selected: {
              idx: 2,
              rowIdx: 3
            },
            dragged: null,
            copied: null
          }
        };

        /***/
      }, /* 130 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _RowComparer = __webpack_require__(43);
        var _RowComparer2 = _interopRequireDefault(_RowComparer);
        var _RowsContainer = __webpack_require__(45);
        var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var Grid = __webpack_require__(119);
        module.exports = Grid;
        module.exports.Row = __webpack_require__(42);
        module.exports.Cell = __webpack_require__(40);
        module.exports.HeaderCell = __webpack_require__(41);
        module.exports.RowComparer = _RowComparer2['default'];
        module.exports.EmptyChildRow = __webpack_require__(110);
        module.exports.RowsContainer = _RowsContainer2['default'];
        module.exports.editors = __webpack_require__(125);
        module.exports.formatters = __webpack_require__(127);
        module.exports.utils = __webpack_require__(53);
        module.exports.shapes = __webpack_require__(118);
        module.exports._constants = __webpack_require__(30);
        module.exports._helpers = __webpack_require__(128);

        /***/
      }, /* 131 */
      /***/function (module, exports) {
        "use strict";

        var isEmptyArray = function isEmptyArray(obj) {
          return Array.isArray(obj) && obj.length === 0;
        };
        module.exports = isEmptyArray;

        /***/
      }, /* 132 */
      /***/function (module, exports) {
        "use strict";

        function isEmpty(obj) {
          return Object.keys(obj).length === 0 && obj.constructor === Object;
        }
        module.exports = isEmpty;

        /***/
      }, /* 133 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _immutable = __webpack_require__(18);
        var isImmutableCollection = function isImmutableCollection(objToVerify) {
          return _immutable.Iterable.isIterable(objToVerify);
        };
        module.exports = isImmutableCollection;

        /***/
      }, /* 134 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _immutable = __webpack_require__(18);
        module.exports = _immutable.Map.isMap;

        /***/
      }, /* 135 */
      /***/function (module, exports) {
        "use strict";

        var getMixedTypeValueRetriever = function getMixedTypeValueRetriever(isImmutable) {
          var retObj = {};
          var retriever = function retriever(item, key) {
            return item[key];
          };
          var immutableRetriever = function immutableRetriever(immutable, key) {
            return immutable.get(key);
          };
          retObj.getValue = isImmutable ? immutableRetriever : retriever;
          return retObj;
        };
        module.exports = getMixedTypeValueRetriever;

        /***/
      }, /* 136 */
      /***/function (module, exports) {
        'use strict';

        exports.__esModule = true;
        function createScrollShim(size) {
          var shim = document.createElement('div');
          if (shim.classList) {
            shim.classList.add('react-grid-ScrollShim'); // flow - not compatible with HTMLElement
          } else {
            shim.className += ' react-grid-ScrollShim';
          }
          shim.style.position = 'absolute';
          shim.style.top = 0;
          shim.style.left = 0;
          shim.style.width = size.width + 'px';
          shim.style.height = size.height + 'px';
          return shim;
        }
        exports.createScrollShim = createScrollShim;

        /***/
      }, /* 137 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        exports.getRenderedColumnCount = exports.getNextScrollState = exports.getGridState = undefined;
        var _ColumnUtils = __webpack_require__(6);
        var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var min = Math.min;
        var max = Math.max;
        var floor = Math.floor;
        var ceil = Math.ceil;
        function getGridState(props) {
          var totalNumberColumns = _ColumnUtils2['default'].getSize(props.columnMetrics.columns);
          var canvasHeight = props.minHeight - props.rowOffsetHeight;
          var renderedRowsCount = ceil((props.minHeight - props.rowHeight) / props.rowHeight);
          var totalRowCount = min(renderedRowsCount * 4, props.rowsCount);
          return {
            displayStart: 0,
            displayEnd: totalRowCount,
            visibleStart: 0,
            visibleEnd: totalRowCount,
            height: canvasHeight,
            scrollTop: 0,
            scrollLeft: 0,
            colVisibleStart: 0,
            colVisibleEnd: totalNumberColumns,
            colDisplayStart: 0,
            colDisplayEnd: totalNumberColumns
          };
        }
        function getRenderedColumnCount(props, getDOMNodeOffsetWidth, displayStart, width) {
          var remainingWidth = width && width > 0 ? width : props.columnMetrics.totalWidth;
          if (remainingWidth === 0) {
            remainingWidth = getDOMNodeOffsetWidth();
          }
          var columnIndex = displayStart;
          var columnCount = 0;
          while (remainingWidth > 0) {
            var column = _ColumnUtils2['default'].getColumn(props.columnMetrics.columns, columnIndex);
            if (!column) {
              break;
            }
            columnCount++;
            columnIndex++;
            remainingWidth -= column.width;
          }
          return columnCount;
        }
        function getVisibleColStart(props, scrollLeft) {
          var remainingScroll = scrollLeft;
          var columnIndex = -1;
          while (remainingScroll >= 0) {
            columnIndex++;
            remainingScroll -= _ColumnUtils2['default'].getColumn(props.columnMetrics.columns, columnIndex).width;
          }
          return columnIndex;
        }
        function getNextScrollState(props, getDOMNodeOffsetWidth, scrollTop, scrollLeft, height, rowHeight, length, width) {
          var isScrolling = true;
          var renderedRowsCount = ceil(height / rowHeight);
          var visibleStart = max(0, floor(scrollTop / rowHeight));
          var visibleEnd = min(visibleStart + renderedRowsCount, length);
          var displayStart = max(0, visibleStart - props.overScan.rowsStart);
          var displayEnd = min(visibleEnd + props.overScan.rowsEnd, length);
          var totalNumberColumns = _ColumnUtils2['default'].getSize(props.columnMetrics.columns);
          var colVisibleStart = totalNumberColumns > 0 ? max(0, getVisibleColStart(props, scrollLeft)) : 0;
          var renderedColumnCount = getRenderedColumnCount(props, getDOMNodeOffsetWidth, colVisibleStart, width);
          var colVisibleEnd = renderedColumnCount !== 0 ? colVisibleStart + renderedColumnCount : totalNumberColumns;
          var colDisplayStart = max(0, colVisibleStart - props.overScan.colsStart);
          var colDisplayEnd = min(colVisibleEnd + props.overScan.colsEnd, totalNumberColumns);
          var nextScrollState = {
            visibleStart: visibleStart,
            visibleEnd: visibleEnd,
            displayStart: displayStart,
            displayEnd: displayEnd,
            height: height,
            scrollTop: scrollTop,
            scrollLeft: scrollLeft,
            colVisibleStart: colVisibleStart,
            colVisibleEnd: colVisibleEnd,
            colDisplayStart: colDisplayStart,
            colDisplayEnd: colDisplayEnd,
            isScrolling: isScrolling
          };
          return nextScrollState;
        }
        exports.getGridState = getGridState;
        exports.getNextScrollState = getNextScrollState;
        exports.getRenderedColumnCount = getRenderedColumnCount;

        /***/
      }, /* 138 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".react-grid-Cell{background-color:#fff;padding-left:8px;padding-right:8px;border-right:1px solid #eee;border-bottom:1px solid #ddd}.react-grid-Cell:focus{outline:2px solid #66afe9;outline-offset:-2px}.react-grid-Cell--locked:focus{z-index:100}.react-grid-Cell:focus .drag-handle{position:absolute;bottom:-5px;right:-4px;background:#66afe9;width:8px;height:8px;border:1px solid #fff;border-right:0;border-bottom:0;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Cell:not(.editing) .react-grid-Cell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.react-grid-Cell:not(.editing):not(.rdg-child-cell) .react-grid-Cell__value{position:relative;top:50%;transform:translateY(-50%)}.rdg-child-cell .react-grid-Cell__value{line-height:35px}.react-grid-Cell.readonly{background-color:#000}.react-grid-Cell.copied{background:rgba(0,0,255,.2)!important}.react-grid-Cell--locked:last-of-type{border-right:1px solid #ddd;box-shadow:none}.react-grid-Cell:hover:focus .drag-handle .glyphicon-arrow-down{display:\"block\"}.react-grid-Cell.is-dragged-over-down{border-right:1px dashed #000;border-left:1px dashed #000;border-bottom:1px dashed #000}.react-grid-Cell.is-dragged-over-up{border-right:1px dashed #000;border-left:1px dashed #000;border-top:1px dashed #000}.react-grid-Cell.is-dragged-over-up .drag-handle{top:-5px}.react-grid-Cell:hover{background:#eee}.react-grid-cell .form-control-feedback{color:#a94442;position:absolute;top:0;right:10px;z-index:1000000;display:block;width:34px;height:34px}.react-grid-Cell.was-dragged-over{border-right:1px dashed #000;border-left:1px dashed #000}.react-grid-Cell:hover:focus .drag-handle{position:absolute;bottom:-8px;right:-7px;background:#fff;width:16px;height:16px;border:1px solid #66afe9;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Row.row-selected .react-grid-Cell{background-color:#dbecfa}.react-grid-Cell.editing{padding:0;overflow:visible!important}.react-grid-Cell--locked.editing{z-index:100}.react-grid-Cell.editing .has-error input{border:2px solid red!important;border-radius:2px!important}.react-grid-Cell__value ul{margin-top:0;margin-bottom:0;display:inline-block}.react-grid-Cell__value .btn-sm{padding:0}.cell-tooltip{position:relative;display:inline-block}.cell-tooltip:hover{z-index:101}.cell-tooltip .cell-tooltip-text{visibility:hidden;width:150px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;bottom:-150%;left:50%;margin-left:-60px;opacity:1s}.cell-tooltip:hover .cell-tooltip-text{visibility:visible;opacity:.8}.cell-tooltip .cell-tooltip-text:after{content:\" \";position:absolute;bottom:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #000}.react-grid-Canvas.opaque .react-grid-Cell.cell-tooltip:hover .cell-tooltip-text{visibility:hidden}.rdg-cell-expand{top:0;right:20px;position:absolute;cursor:pointer}.rdg-child-row-action-cross-last:before,.rdg-child-row-action-cross:before,rdg-child-row-action-cross-last:after,rdg-child-row-action-cross:after{content:\"\";position:absolute;background:grey;height:50%}.rdg-child-row-action-cross:before{left:21px;width:1px;height:35px}.rdg-child-row-action-cross-last:before{left:21px;width:1px}.rdg-child-row-action-cross-last:after,.rdg-child-row-action-cross:after{top:50%;left:20px;height:1px;width:15px;content:\"\";position:absolute;background:grey}.rdg-child-row-action-cross:hover{background:red}.rdg-child-row-btn{position:absolute;cursor:pointer;border:1px solid grey;border-radius:14px;z-index:3;background:#fff}.rdg-child-row-btn div{font-size:12px;text-align:center;line-height:19px;color:grey;height:20px;width:20px;position:absolute;top:60%;left:53%;margin-top:-10px;margin-left:-10px}.rdg-empty-child-row:hover .glyphicon-plus-sign,.rdg-empty-child-row:hover a{color:green}.rdg-child-row-btn .glyphicon-remove-sign:hover{color:red}.last-column .cell-tooltip-text{right:100%;left:0!important}.rdg-cell-action{float:right;height:100%}.rdg-cell-action-last{margin-right:-8px}.rdg-cell-action-button{width:35px;height:100%;text-align:center;position:relative;display:table}.rdg-cell-action-button>span{display:table-cell;vertical-align:middle}.rdg-cell-action-button:hover{background-color:#fff}.rdg-cell-action-button-toggled{background-color:#fff;border-right:1px solid #ccc;border-left:1px solid #ccc}.rdg-cell-action-button-toggled:after{content:\"\";height:1px;position:absolute;bottom:-1px;left:0;right:0;background:inherit;z-index:10001}.rdg-cell-action-menu{position:absolute;top:100%;right:0;z-index:1000;float:left;min-width:160px;padding:5px 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc}.rdg-cell-action-menu>span{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.rdg-cell-action-menu>span:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}", ""]);

        // exports

        /***/
      }, /* 139 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".radio-custom,.react-grid-checkbox{opacity:0;position:absolute}.radio-custom,.radio-custom-label,.react-grid-checkbox,.react-grid-checkbox-label{display:inline-block;vertical-align:middle;cursor:pointer}.radio-custom-label,.react-grid-checkbox-label{position:relative}.radio-custom+.radio-custom-label:before,.react-grid-checkbox+.react-grid-checkbox-label:before{content:\"\";background:#fff;border:2px solid #ddd;display:inline-block;vertical-align:middle;width:20px;height:20px;text-align:center}.react-grid-checkbox:checked+.react-grid-checkbox-label:before{background:#005295;box-shadow:inset 0 0 0 4px #fff}.radio-custom:focus+.radio-custom-label,.react-grid-checkbox:focus+.react-grid-checkbox-label{outline:1px solid #ddd}.react-grid-HeaderCell input[type=checkbox]{z-index:99999}.react-grid-HeaderCell>.react-grid-checkbox-container{padding:0 10px;height:100%}.react-grid-HeaderCell>.react-grid-checkbox-container>.react-grid-checkbox-label{margin:0;position:relative;top:50%;transform:translateY(-50%)}.radio-custom+.radio-custom-label:before{border-radius:50%}.radio-custom:checked+.radio-custom-label:before{background:#ccc;box-shadow:inset 0 0 0 4px #fff}.checkbox-align{text-align:center}", ""]);

        // exports

        /***/
      }, /* 140 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".react-grid-Container{clear:both;margin-top:0;padding:0}.react-grid-Main{background-color:#fff;color:inherit;padding:0;outline:1px solid #e7eaec;clear:both}.react-grid-Grid{border:1px solid #ddd}.react-grid-Canvas,.react-grid-Grid{background-color:#fff}.react-grid-Cell input.editor-main,select.editor-main{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}input.editor-main:focus,select.editor-main:focus{border-color:#66afe9;border:2px solid #66afe9;background:#eee;border-radius:4px}.react-grid-Cell input.editor-main::-moz-placeholder,select.editor-main::-moz-placeholder{color:#999;opacity:1}.react-grid-Cell input.editor-main:-ms-input-placeholder,select.editor-main:-ms-input-placeholder{color:#999}.react-grid-Cell input.editor-main::-webkit-input-placeholder,select.editor-main::-webkit-input-placeholder{color:#999}.react-grid-Cell input.editor-main[disabled],.react-grid-Cell input.editor-main[readonly],fieldset[disabled] .react-grid-Cell input.editor-main,fieldset[disabled] select.editor-main,select.editor-main[disabled],select.editor-main[readonly]{cursor:not-allowed;background-color:#eee;opacity:1}textarea.react-grid-Cell input.editor-main,textareaselect.editor-main{height:auto}.react-grid-ScrollShim{z-index:10002}", ""]);

        // exports

        /***/
      }, /* 141 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".react-grid-Header{box-shadow:0 0 4px 0 #ddd;background:#f9f9f9}.react-grid-Header--resizing{cursor:ew-resize}.react-grid-HeaderCell,.react-grid-HeaderRow{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.react-grid-HeaderCell{background:#f9f9f9;padding:8px;font-weight:700;border-right:1px solid #ddd;border-bottom:1px solid #ddd}.react-grid-HeaderCell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-HeaderCell__resizeHandle:hover{cursor:ew-resize;background:#ddd}.react-grid-HeaderCell--locked:last-of-type{box-shadow:none}.react-grid-HeaderCell--resizing .react-grid-HeaderCell__resizeHandle{background:#ddd}.react-grid-HeaderCell__draggable{cursor:col-resize}.rdg-can-drop>.react-grid-HeaderCell{background:#ececec}.react-grid-HeaderCell .Select{max-height:30px;font-size:12px;font-weight:400}.react-grid-HeaderCell .Select-control{max-height:30px;border:1px solid #ccc;color:#555;border-radius:3px}.react-grid-HeaderCell .is-focused:not(.is-open)>.Select-control{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.react-grid-HeaderCell .Select-control .Select-placeholder{line-height:20px;color:#999;padding:4px}.react-grid-HeaderCell .Select-control .Select-input{max-height:28px;padding:4px;margin-left:0}.react-grid-HeaderCell .Select-control .Select-input input{padding:0;height:100%}.react-grid-HeaderCell .Select-control .Select-arrow-zone .Select-arrow{border-color:gray transparent transparent;border-width:4px 4px 2.5px}.react-grid-HeaderCell .Select-control .Select-value{padding:4px;line-height:20px!important}.react-grid-HeaderCell .Select--multi .Select-control .Select-value{padding:0;line-height:16px!important;max-height:20px}.react-grid-HeaderCell .Select--multi .Select-control .Select-value .Select-value-icon,.react-grid-HeaderCell .Select--multi .Select-control .Select-value .Select-value-label{max-height:20px}.react-grid-HeaderCell .Select-control .Select-value .Select-value-label{color:#555!important}.react-grid-HeaderCell .Select-menu-outer .Select-option{padding:4px;line-height:20px}.react-grid-HeaderCell .Select-menu-outer .Select-menu .Select-option.is-focused,.react-grid-HeaderCell .Select-menu-outer .Select-menu .Select-option.is-selected{color:#555}", ""]);

        // exports

        /***/
      }, /* 142 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".react-grid-Row.row-context-menu .react-grid-Cell,.react-grid-Row:hover .react-grid-Cell{background-color:#f9f9f9}.react-grid-Row:hover .rdg-row-index{display:none}.react-grid-Row:hover .rdg-actions-checkbox{display:block}.react-grid-Row:hover .rdg-drag-row-handle{cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab;width:12px;height:30px;margin-left:0;background-image:url(\"data:image/svg+xml;base64, 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\");background-repeat:no-repeat}.react-grid-Row.row-selected,.react-grid-Row .row-selected{background-color:#dbecfa}.react-grid-row-group .row-expand-icon:hover{color:#777}.react-grid-row-index{padding:0 18px}.rdg-row-index{display:block;text-align:center}.rdg-row-actions-cell{padding:0}.rdg-actions-checkbox{display:none;text-align:center}.rdg-actions-checkbox.selected{display:block}.rdg-dragging{cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.rdg-dragged-row{border-bottom:1px solid #000}", ""]);

        // exports

        /***/
      }, /* 143 */
      /***/function (module, exports) {
        "use strict";

        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         * 
         */
        function makeEmptyFunction(arg) {
          return function () {
            return arg;
          };
        }

        /**
         * This function accepts and discards inputs; it has no side effects. This is
         * primarily useful idiomatically for overridable function endpoints which
         * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
         */
        var emptyFunction = function emptyFunction() {};
        emptyFunction.thatReturns = makeEmptyFunction;
        emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
        emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
        emptyFunction.thatReturnsNull = makeEmptyFunction(null);
        emptyFunction.thatReturnsThis = function () {
          return this;
        };
        emptyFunction.thatReturnsArgument = function (arg) {
          return arg;
        };
        module.exports = emptyFunction;

        /***/
      }, /* 144 */
      /***/function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         */

        'use strict';

        /**
         * Use invariant() to assert state which your program assumes to be true.
         *
         * Provide sprintf-style format (only %s is supported) and arguments
         * to provide information about what broke and what you were
         * expecting.
         *
         * The invariant message will be stripped in production, but the invariant
         * will remain to ensure logic does not differ in production.
         */
        var validateFormat = function validateFormat(format) {};
        if (false) {}
        function invariant(condition, format, a, b, c, d, e, f) {
          validateFormat(format);
          if (!condition) {
            var error;
            if (format === undefined) {
              error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
            } else {
              var args = [a, b, c, d, e, f];
              var argIndex = 0;
              error = new Error(format.replace(/%s/g, function () {
                return args[argIndex++];
              }));
              error.name = 'Invariant Violation';
            }
            error.framesToPop = 1; // we don't care about invariant's own frame
            throw error;
          }
        }
        module.exports = invariant;

        /***/
      }, /* 145 */
      /***/function (module, exports) {
        /**
         * Copyright 2013-2014 Facebook, Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         *
         */

        "use strict";

        /**
         * Constructs an enumeration with keys equal to their value.
         *
         * For example:
         *
         *   var COLORS = keyMirror({blue: null, red: null});
         *   var myColor = COLORS.blue;
         *   var isColorValid = !!COLORS[myColor];
         *
         * The last line could not be performed if the values of the generated enum were
         * not equal to their keys.
         *
         *   Input:  {key1: val1, key2: val2}
         *   Output: {key1: key1, key2: key2}
         *
         * @param {object} obj
         * @return {object}
         */
        var keyMirror = function (obj) {
          var ret = {};
          var key;
          if (!(obj instanceof Object && !Array.isArray(obj))) {
            throw new Error('keyMirror(...): Argument must be an object.');
          }
          for (key in obj) {
            if (!obj.hasOwnProperty(key)) {
              continue;
            }
            ret[key] = key;
          }
          return ret;
        };
        module.exports = keyMirror;

        /***/
      }, /* 146 */
      /***/function (module, exports) {
        /*
        object-assign
        (c) Sindre Sorhus
        @license MIT
        */

        'use strict';

        /* eslint-disable no-unused-vars */
        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var propIsEnumerable = Object.prototype.propertyIsEnumerable;
        function toObject(val) {
          if (val === null || val === undefined) {
            throw new TypeError('Object.assign cannot be called with null or undefined');
          }
          return Object(val);
        }
        function shouldUseNative() {
          try {
            if (!Object.assign) {
              return false;
            }

            // Detect buggy property enumeration order in older V8 versions.

            // https://bugs.chromium.org/p/v8/issues/detail?id=4118
            var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
            test1[5] = 'de';
            if (Object.getOwnPropertyNames(test1)[0] === '5') {
              return false;
            }

            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test2 = {};
            for (var i = 0; i < 10; i++) {
              test2['_' + String.fromCharCode(i)] = i;
            }
            var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
              return test2[n];
            });
            if (order2.join('') !== '0123456789') {
              return false;
            }

            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test3 = {};
            'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
              test3[letter] = letter;
            });
            if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
              return false;
            }
            return true;
          } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false;
          }
        }
        module.exports = shouldUseNative() ? Object.assign : function (target, source) {
          var from;
          var to = toObject(target);
          var symbols;
          for (var s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);
            for (var key in from) {
              if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
              }
            }
            if (getOwnPropertySymbols) {
              symbols = getOwnPropertySymbols(from);
              for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                  to[symbols[i]] = from[symbols[i]];
                }
              }
            }
          }
          return to;
        };

        /***/
      }, /* 147 */
      /***/function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        'use strict';

        var emptyFunction = __webpack_require__(143);
        var invariant = __webpack_require__(144);
        var ReactPropTypesSecret = __webpack_require__(148);
        module.exports = function () {
          function shim(props, propName, componentName, location, propFullName, secret) {
            if (secret === ReactPropTypesSecret) {
              // It is still safe when called from React.
              return;
            }
            invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          }
          ;
          shim.isRequired = shim;
          function getShim() {
            return shim;
          }
          ;
          // Important!
          // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
          var ReactPropTypes = {
            array: shim,
            bool: shim,
            func: shim,
            number: shim,
            object: shim,
            string: shim,
            symbol: shim,
            any: shim,
            arrayOf: getShim,
            element: shim,
            instanceOf: getShim,
            node: shim,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim
          };
          ReactPropTypes.checkPropTypes = emptyFunction;
          ReactPropTypes.PropTypes = ReactPropTypes;
          return ReactPropTypes;
        };

        /***/
      }, /* 148 */
      /***/function (module, exports) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        'use strict';

        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        module.exports = ReactPropTypesSecret;

        /***/
      }
      /******/])
    );
  });

  ;

  /***/
}, /* 412 */
/***/function (module, exports) {
  var hasOwnProperty = {}.hasOwnProperty;
  module.exports = function (it, key) {
    return hasOwnProperty.call(it, key);
  };

  /***/
}, /* 413 */
/***/function (module, exports, __webpack_require__) {
  // to indexed object, toObject with fallback for non-array-like ES3 strings
  var IObject = __webpack_require__(521);
  var defined = __webpack_require__(478);
  module.exports = function (it) {
    return IObject(defined(it));
  };

  /***/
}, /* 414 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(415);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 415 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * Card.css\n */\n\n/** Cards next to cards should minimze the margin between each */\n.c-cards + .c-cards { margin-top: 0; }\n\n.c-cards {\n\tborder-radius: 3px;\n\tbox-shadow: 1px 1px 5px 0px #eaebec;\n\tbackground-color: #fff;\n\tborder:1px solid #eaebec;\n}\n\n.c-cards .c-cards__header {\n\tpadding: 4px 18px;\n\theight: 50px;\n\tbackground-color: transparent;\n\tborder-bottom: 1px solid #eaebec;\n}\n\n.c-cards .c-cards__header .c-heading-descriptive {\n\tmargin-bottom: 0;\n\tcolor: #374047;\n\tfont-size: 14px;\n\tfont-weight: normal;\n}\n.c-cards__header .u-form__help,\n.e-form__control-wrapper .e-form__control-header .u-form__help {\n\tmargin-left: 10px;\n}\n\n.c-cards.collapsable .collapse-icon {\n\tmargin:0;\n\tmargin-right: 7px;\n\tfont-size: 16px;\n\tcolor: #374047;\n\ttransition: 0.3s ease;\n}\n.c-cards.collapsable.visible .collapse-icon { transform:rotate(90deg); }\n\n.c-cards .c-cards__header .u-form__help.c-tooltip { display: flex; }\n\n.c-cards__content .e-form__control-wrapper:first-of-type { margin-top: 0; }\n.c-cards__content .e-form__control-wrapper {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n", "", {
    "version": 3,
    "sources": ["Card.css"],
    "names": [],
    "mappings": "AAAA;;EAEE;;AAEF,gEAAgE;AAChE,sBAAsB,aAAa,EAAE;;AAErC;CACC,kBAAkB;CAClB,mCAAmC;CACnC,sBAAsB;CACtB,wBAAwB;AACzB;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,6BAA6B;CAC7B,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,mBAAmB;AACpB;AACA;;CAEC,iBAAiB;AAClB;;AAEA;CACC,QAAQ;CACR,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,qBAAqB;AACtB;AACA,8CAA8C,uBAAuB,EAAE;;AAEvE,oDAAoD,aAAa,EAAE;;AAEnE,2DAA2D,aAAa,EAAE;AAC1E;CACC,cAAc;CACd,eAAe;AAChB",
    "file": "Card.css",
    "sourcesContent": ["/**\n * Card.css\n */\n\n/** Cards next to cards should minimze the margin between each */\n.c-cards + .c-cards { margin-top: 0; }\n\n.c-cards {\n\tborder-radius: 3px;\n\tbox-shadow: 1px 1px 5px 0px #eaebec;\n\tbackground-color: #fff;\n\tborder:1px solid #eaebec;\n}\n\n.c-cards .c-cards__header {\n\tpadding: 4px 18px;\n\theight: 50px;\n\tbackground-color: transparent;\n\tborder-bottom: 1px solid #eaebec;\n}\n\n.c-cards .c-cards__header .c-heading-descriptive {\n\tmargin-bottom: 0;\n\tcolor: #374047;\n\tfont-size: 14px;\n\tfont-weight: normal;\n}\n.c-cards__header .u-form__help,\n.e-form__control-wrapper .e-form__control-header .u-form__help {\n\tmargin-left: 10px;\n}\n\n.c-cards.collapsable .collapse-icon {\n\tmargin:0;\n\tmargin-right: 7px;\n\tfont-size: 16px;\n\tcolor: #374047;\n\ttransition: 0.3s ease;\n}\n.c-cards.collapsable.visible .collapse-icon { transform:rotate(90deg); }\n\n.c-cards .c-cards__header .u-form__help.c-tooltip { display: flex; }\n\n.c-cards__content .e-form__control-wrapper:first-of-type { margin-top: 0; }\n.c-cards__content .e-form__control-wrapper {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n"]
  }]);

  /***/
}, /* 416 */
/***/function (module, exports, __webpack_require__) {
  /**********************
   Velocity UI Pack
   **********************/

  /* VelocityJS.org UI Pack (5.2.0). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License. Portions copyright Daniel Eden, Christian Pucci. */

  (function (factory) {
    "use strict";

    /* CommonJS module. */
    if (true) {
      module.exports = factory();
      /* AMD module. */
    } else {}
  })(function () {
    "use strict";

    return function (global, window, document, undefined) {
      /*************
       Checks
       *************/
      var Velocity = global.Velocity;
      if (!Velocity || !Velocity.Utilities) {
        if (window.console) {
          console.log("Velocity UI Pack: Velocity must be loaded first. Aborting.");
        }
        return;
      }
      var $ = Velocity.Utilities;
      var velocityVersion = Velocity.version,
        requiredVersion = {
          major: 1,
          minor: 1,
          patch: 0
        };
      function greaterSemver(primary, secondary) {
        var versionInts = [];
        if (!primary || !secondary) {
          return false;
        }
        $.each([primary, secondary], function (i, versionObject) {
          var versionIntsComponents = [];
          $.each(versionObject, function (component, value) {
            while (value.toString().length < 5) {
              value = "0" + value;
            }
            versionIntsComponents.push(value);
          });
          versionInts.push(versionIntsComponents.join(""));
        });
        return parseFloat(versionInts[0]) > parseFloat(versionInts[1]);
      }
      if (greaterSemver(requiredVersion, velocityVersion)) {
        var abortError = "Velocity UI Pack: You need to update Velocity (velocity.js) to a newer version. Visit http://github.com/julianshapiro/velocity.";
        alert(abortError);
        throw new Error(abortError);
      }

      /************************
       Effect Registration
       ************************/

      /* Note: RegisterUI is a legacy name. */
      Velocity.RegisterEffect = Velocity.RegisterUI = function (effectName, properties) {
        /* Animate the expansion/contraction of the elements' parent's height for In/Out effects. */
        function animateParentHeight(elements, direction, totalDuration, stagger) {
          var totalHeightDelta = 0,
            parentNode;

          /* Sum the total height (including padding and margin) of all targeted elements. */
          $.each(elements.nodeType ? [elements] : elements, function (i, element) {
            if (stagger) {
              /* Increase the totalDuration by the successive delay amounts produced by the stagger option. */
              totalDuration += i * stagger;
            }
            parentNode = element.parentNode;
            var propertiesToSum = ["height", "paddingTop", "paddingBottom", "marginTop", "marginBottom"];

            /* If box-sizing is border-box, the height already includes padding and margin */
            if (Velocity.CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() === "border-box") {
              propertiesToSum = ["height"];
            }
            $.each(propertiesToSum, function (i, property) {
              totalHeightDelta += parseFloat(Velocity.CSS.getPropertyValue(element, property));
            });
          });

          /* Animate the parent element's height adjustment (with a varying duration multiplier for aesthetic benefits). */
          Velocity.animate(parentNode, {
            height: (direction === "In" ? "+" : "-") + "=" + totalHeightDelta
          }, {
            queue: false,
            easing: "ease-in-out",
            duration: totalDuration * (direction === "In" ? 0.6 : 1)
          });
        }

        /* Register a custom redirect for each effect. */
        Velocity.Redirects[effectName] = function (element, redirectOptions, elementsIndex, elementsSize, elements, promiseData, loop) {
          var finalElement = elementsIndex === elementsSize - 1,
            totalDuration = 0;
          loop = loop || properties.loop;
          if (typeof properties.defaultDuration === "function") {
            properties.defaultDuration = properties.defaultDuration.call(elements, elements);
          } else {
            properties.defaultDuration = parseFloat(properties.defaultDuration);
          }

          /* Get the total duration used, so we can share it out with everything that doesn't have a duration */
          for (var callIndex = 0; callIndex < properties.calls.length; callIndex++) {
            durationPercentage = properties.calls[callIndex][1];
            if (typeof durationPercentage === "number") {
              totalDuration += durationPercentage;
            }
          }
          var shareDuration = totalDuration >= 1 ? 0 : properties.calls.length ? (1 - totalDuration) / properties.calls.length : 1;

          /* Iterate through each effect's call array. */
          for (callIndex = 0; callIndex < properties.calls.length; callIndex++) {
            var call = properties.calls[callIndex],
              propertyMap = call[0],
              redirectDuration = 1000,
              durationPercentage = call[1],
              callOptions = call[2] || {},
              opts = {};
            if (redirectOptions.duration !== undefined) {
              redirectDuration = redirectOptions.duration;
            } else if (properties.defaultDuration !== undefined) {
              redirectDuration = properties.defaultDuration;
            }

            /* Assign the whitelisted per-call options. */
            opts.duration = redirectDuration * (typeof durationPercentage === "number" ? durationPercentage : shareDuration);
            opts.queue = redirectOptions.queue || "";
            opts.easing = callOptions.easing || "ease";
            opts.delay = parseFloat(callOptions.delay) || 0;
            opts.loop = !properties.loop && callOptions.loop;
            opts._cacheValues = callOptions._cacheValues || true;

            /* Special processing for the first effect call. */
            if (callIndex === 0) {
              /* If a delay was passed into the redirect, combine it with the first call's delay. */
              opts.delay += parseFloat(redirectOptions.delay) || 0;
              if (elementsIndex === 0) {
                opts.begin = function () {
                  /* Only trigger a begin callback on the first effect call with the first element in the set. */
                  if (redirectOptions.begin) {
                    redirectOptions.begin.call(elements, elements);
                  }
                  var direction = effectName.match(/(In|Out)$/);

                  /* Make "in" transitioning elements invisible immediately so that there's no FOUC between now
                   and the first RAF tick. */
                  if (direction && direction[0] === "In" && propertyMap.opacity !== undefined) {
                    $.each(elements.nodeType ? [elements] : elements, function (i, element) {
                      Velocity.CSS.setPropertyValue(element, "opacity", 0);
                    });
                  }

                  /* Only trigger animateParentHeight() if we're using an In/Out transition. */
                  if (redirectOptions.animateParentHeight && direction) {
                    animateParentHeight(elements, direction[0], redirectDuration + opts.delay, redirectOptions.stagger);
                  }
                };
              }

              /* If the user isn't overriding the display option, default to "auto" for "In"-suffixed transitions. */
              if (redirectOptions.display !== null) {
                if (redirectOptions.display !== undefined && redirectOptions.display !== "none") {
                  opts.display = redirectOptions.display;
                } else if (/In$/.test(effectName)) {
                  /* Inline elements cannot be subjected to transforms, so we switch them to inline-block. */
                  var defaultDisplay = Velocity.CSS.Values.getDisplayType(element);
                  opts.display = defaultDisplay === "inline" ? "inline-block" : defaultDisplay;
                }
              }
              if (redirectOptions.visibility && redirectOptions.visibility !== "hidden") {
                opts.visibility = redirectOptions.visibility;
              }
            }

            /* Special processing for the last effect call. */
            if (callIndex === properties.calls.length - 1) {
              /* Append promise resolving onto the user's redirect callback. */
              var injectFinalCallbacks = function () {
                if ((redirectOptions.display === undefined || redirectOptions.display === "none") && /Out$/.test(effectName)) {
                  $.each(elements.nodeType ? [elements] : elements, function (i, element) {
                    Velocity.CSS.setPropertyValue(element, "display", "none");
                  });
                }
                if (redirectOptions.complete) {
                  redirectOptions.complete.call(elements, elements);
                }
                if (promiseData) {
                  promiseData.resolver(elements || element);
                }
              };
              opts.complete = function () {
                if (loop) {
                  Velocity.Redirects[effectName](element, redirectOptions, elementsIndex, elementsSize, elements, promiseData, loop === true ? true : Math.max(0, loop - 1));
                }
                if (properties.reset) {
                  for (var resetProperty in properties.reset) {
                    if (!properties.reset.hasOwnProperty(resetProperty)) {
                      continue;
                    }
                    var resetValue = properties.reset[resetProperty];

                    /* Format each non-array value in the reset property map to [ value, value ] so that changes apply
                     immediately and DOM querying is avoided (via forcefeeding). */
                    /* Note: Don't forcefeed hooks, otherwise their hook roots will be defaulted to their null values. */
                    if (Velocity.CSS.Hooks.registered[resetProperty] === undefined && (typeof resetValue === "string" || typeof resetValue === "number")) {
                      properties.reset[resetProperty] = [properties.reset[resetProperty], properties.reset[resetProperty]];
                    }
                  }

                  /* So that the reset values are applied instantly upon the next rAF tick, use a zero duration and parallel queueing. */
                  var resetOptions = {
                    duration: 0,
                    queue: false
                  };

                  /* Since the reset option uses up the complete callback, we trigger the user's complete callback at the end of ours. */
                  if (finalElement) {
                    resetOptions.complete = injectFinalCallbacks;
                  }
                  Velocity.animate(element, properties.reset, resetOptions);
                  /* Only trigger the user's complete callback on the last effect call with the last element in the set. */
                } else if (finalElement) {
                  injectFinalCallbacks();
                }
              };
              if (redirectOptions.visibility === "hidden") {
                opts.visibility = redirectOptions.visibility;
              }
            }
            Velocity.animate(element, propertyMap, opts);
          }
        };

        /* Return the Velocity object so that RegisterUI calls can be chained. */
        return Velocity;
      };

      /*********************
       Packaged Effects
       *********************/

      /* Externalize the packagedEffects data so that they can optionally be modified and re-registered. */
      /* Support: <=IE8: Callouts will have no effect, and transitions will simply fade in/out. IE9/Android 2.3: Most effects are fully supported, the rest fade in/out. All other browsers: full support. */
      Velocity.RegisterEffect.packagedEffects = {
        /* Animate.css */
        "callout.bounce": {
          defaultDuration: 550,
          calls: [[{
            translateY: -30
          }, 0.25], [{
            translateY: 0
          }, 0.125], [{
            translateY: -15
          }, 0.125], [{
            translateY: 0
          }, 0.25]]
        },
        /* Animate.css */
        "callout.shake": {
          defaultDuration: 800,
          calls: [[{
            translateX: -11
          }], [{
            translateX: 11
          }], [{
            translateX: -11
          }], [{
            translateX: 11
          }], [{
            translateX: -11
          }], [{
            translateX: 11
          }], [{
            translateX: -11
          }], [{
            translateX: 0
          }]]
        },
        /* Animate.css */
        "callout.flash": {
          defaultDuration: 1100,
          calls: [[{
            opacity: [0, "easeInOutQuad", 1]
          }], [{
            opacity: [1, "easeInOutQuad"]
          }], [{
            opacity: [0, "easeInOutQuad"]
          }], [{
            opacity: [1, "easeInOutQuad"]
          }]]
        },
        /* Animate.css */
        "callout.pulse": {
          defaultDuration: 825,
          calls: [[{
            scaleX: 1.1,
            scaleY: 1.1
          }, 0.50, {
            easing: "easeInExpo"
          }], [{
            scaleX: 1,
            scaleY: 1
          }, 0.50]]
        },
        /* Animate.css */
        "callout.swing": {
          defaultDuration: 950,
          calls: [[{
            rotateZ: 15
          }], [{
            rotateZ: -10
          }], [{
            rotateZ: 5
          }], [{
            rotateZ: -5
          }], [{
            rotateZ: 0
          }]]
        },
        /* Animate.css */
        "callout.tada": {
          defaultDuration: 1000,
          calls: [[{
            scaleX: 0.9,
            scaleY: 0.9,
            rotateZ: -3
          }, 0.10], [{
            scaleX: 1.1,
            scaleY: 1.1,
            rotateZ: 3
          }, 0.10], [{
            scaleX: 1.1,
            scaleY: 1.1,
            rotateZ: -3
          }, 0.10], ["reverse", 0.125], ["reverse", 0.125], ["reverse", 0.125], ["reverse", 0.125], ["reverse", 0.125], [{
            scaleX: 1,
            scaleY: 1,
            rotateZ: 0
          }, 0.20]]
        },
        "transition.fadeIn": {
          defaultDuration: 500,
          calls: [[{
            opacity: [1, 0]
          }]]
        },
        "transition.fadeOut": {
          defaultDuration: 500,
          calls: [[{
            opacity: [0, 1]
          }]]
        },
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.flipXIn": {
          defaultDuration: 700,
          calls: [[{
            opacity: [1, 0],
            transformPerspective: [800, 800],
            rotateY: [0, -55]
          }]],
          reset: {
            transformPerspective: 0
          }
        },
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.flipXOut": {
          defaultDuration: 700,
          calls: [[{
            opacity: [0, 1],
            transformPerspective: [800, 800],
            rotateY: 55
          }]],
          reset: {
            transformPerspective: 0,
            rotateY: 0
          }
        },
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.flipYIn": {
          defaultDuration: 800,
          calls: [[{
            opacity: [1, 0],
            transformPerspective: [800, 800],
            rotateX: [0, -45]
          }]],
          reset: {
            transformPerspective: 0
          }
        },
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.flipYOut": {
          defaultDuration: 800,
          calls: [[{
            opacity: [0, 1],
            transformPerspective: [800, 800],
            rotateX: 25
          }]],
          reset: {
            transformPerspective: 0,
            rotateX: 0
          }
        },
        /* Animate.css */
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.flipBounceXIn": {
          defaultDuration: 900,
          calls: [[{
            opacity: [0.725, 0],
            transformPerspective: [400, 400],
            rotateY: [-10, 90]
          }, 0.50], [{
            opacity: 0.80,
            rotateY: 10
          }, 0.25], [{
            opacity: 1,
            rotateY: 0
          }, 0.25]],
          reset: {
            transformPerspective: 0
          }
        },
        /* Animate.css */
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.flipBounceXOut": {
          defaultDuration: 800,
          calls: [[{
            opacity: [0.9, 1],
            transformPerspective: [400, 400],
            rotateY: -10
          }], [{
            opacity: 0,
            rotateY: 90
          }]],
          reset: {
            transformPerspective: 0,
            rotateY: 0
          }
        },
        /* Animate.css */
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.flipBounceYIn": {
          defaultDuration: 850,
          calls: [[{
            opacity: [0.725, 0],
            transformPerspective: [400, 400],
            rotateX: [-10, 90]
          }, 0.50], [{
            opacity: 0.80,
            rotateX: 10
          }, 0.25], [{
            opacity: 1,
            rotateX: 0
          }, 0.25]],
          reset: {
            transformPerspective: 0
          }
        },
        /* Animate.css */
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.flipBounceYOut": {
          defaultDuration: 800,
          calls: [[{
            opacity: [0.9, 1],
            transformPerspective: [400, 400],
            rotateX: -15
          }], [{
            opacity: 0,
            rotateX: 90
          }]],
          reset: {
            transformPerspective: 0,
            rotateX: 0
          }
        },
        /* Magic.css */
        "transition.swoopIn": {
          defaultDuration: 850,
          calls: [[{
            opacity: [1, 0],
            transformOriginX: ["100%", "50%"],
            transformOriginY: ["100%", "100%"],
            scaleX: [1, 0],
            scaleY: [1, 0],
            translateX: [0, -700],
            translateZ: 0
          }]],
          reset: {
            transformOriginX: "50%",
            transformOriginY: "50%"
          }
        },
        /* Magic.css */
        "transition.swoopOut": {
          defaultDuration: 850,
          calls: [[{
            opacity: [0, 1],
            transformOriginX: ["50%", "100%"],
            transformOriginY: ["100%", "100%"],
            scaleX: 0,
            scaleY: 0,
            translateX: -700,
            translateZ: 0
          }]],
          reset: {
            transformOriginX: "50%",
            transformOriginY: "50%",
            scaleX: 1,
            scaleY: 1,
            translateX: 0
          }
        },
        /* Magic.css */
        /* Support: Loses rotation in IE9/Android 2.3. (Fades and scales only.) */
        "transition.whirlIn": {
          defaultDuration: 850,
          calls: [[{
            opacity: [1, 0],
            transformOriginX: ["50%", "50%"],
            transformOriginY: ["50%", "50%"],
            scaleX: [1, 0],
            scaleY: [1, 0],
            rotateY: [0, 160]
          }, 1, {
            easing: "easeInOutSine"
          }]]
        },
        /* Magic.css */
        /* Support: Loses rotation in IE9/Android 2.3. (Fades and scales only.) */
        "transition.whirlOut": {
          defaultDuration: 750,
          calls: [[{
            opacity: [0, "easeInOutQuint", 1],
            transformOriginX: ["50%", "50%"],
            transformOriginY: ["50%", "50%"],
            scaleX: 0,
            scaleY: 0,
            rotateY: 160
          }, 1, {
            easing: "swing"
          }]],
          reset: {
            scaleX: 1,
            scaleY: 1,
            rotateY: 0
          }
        },
        "transition.shrinkIn": {
          defaultDuration: 750,
          calls: [[{
            opacity: [1, 0],
            transformOriginX: ["50%", "50%"],
            transformOriginY: ["50%", "50%"],
            scaleX: [1, 1.5],
            scaleY: [1, 1.5],
            translateZ: 0
          }]]
        },
        "transition.shrinkOut": {
          defaultDuration: 600,
          calls: [[{
            opacity: [0, 1],
            transformOriginX: ["50%", "50%"],
            transformOriginY: ["50%", "50%"],
            scaleX: 1.3,
            scaleY: 1.3,
            translateZ: 0
          }]],
          reset: {
            scaleX: 1,
            scaleY: 1
          }
        },
        "transition.expandIn": {
          defaultDuration: 700,
          calls: [[{
            opacity: [1, 0],
            transformOriginX: ["50%", "50%"],
            transformOriginY: ["50%", "50%"],
            scaleX: [1, 0.625],
            scaleY: [1, 0.625],
            translateZ: 0
          }]]
        },
        "transition.expandOut": {
          defaultDuration: 700,
          calls: [[{
            opacity: [0, 1],
            transformOriginX: ["50%", "50%"],
            transformOriginY: ["50%", "50%"],
            scaleX: 0.5,
            scaleY: 0.5,
            translateZ: 0
          }]],
          reset: {
            scaleX: 1,
            scaleY: 1
          }
        },
        /* Animate.css */
        "transition.bounceIn": {
          defaultDuration: 800,
          calls: [[{
            opacity: [1, 0],
            scaleX: [1.05, 0.3],
            scaleY: [1.05, 0.3]
          }, 0.35], [{
            scaleX: 0.9,
            scaleY: 0.9,
            translateZ: 0
          }, 0.20], [{
            scaleX: 1,
            scaleY: 1
          }, 0.45]]
        },
        /* Animate.css */
        "transition.bounceOut": {
          defaultDuration: 800,
          calls: [[{
            scaleX: 0.95,
            scaleY: 0.95
          }, 0.35], [{
            scaleX: 1.1,
            scaleY: 1.1,
            translateZ: 0
          }, 0.35], [{
            opacity: [0, 1],
            scaleX: 0.3,
            scaleY: 0.3
          }, 0.30]],
          reset: {
            scaleX: 1,
            scaleY: 1
          }
        },
        /* Animate.css */
        "transition.bounceUpIn": {
          defaultDuration: 800,
          calls: [[{
            opacity: [1, 0],
            translateY: [-30, 1000]
          }, 0.60, {
            easing: "easeOutCirc"
          }], [{
            translateY: 10
          }, 0.20], [{
            translateY: 0
          }, 0.20]]
        },
        /* Animate.css */
        "transition.bounceUpOut": {
          defaultDuration: 1000,
          calls: [[{
            translateY: 20
          }, 0.20], [{
            opacity: [0, "easeInCirc", 1],
            translateY: -1000
          }, 0.80]],
          reset: {
            translateY: 0
          }
        },
        /* Animate.css */
        "transition.bounceDownIn": {
          defaultDuration: 800,
          calls: [[{
            opacity: [1, 0],
            translateY: [30, -1000]
          }, 0.60, {
            easing: "easeOutCirc"
          }], [{
            translateY: -10
          }, 0.20], [{
            translateY: 0
          }, 0.20]]
        },
        /* Animate.css */
        "transition.bounceDownOut": {
          defaultDuration: 1000,
          calls: [[{
            translateY: -20
          }, 0.20], [{
            opacity: [0, "easeInCirc", 1],
            translateY: 1000
          }, 0.80]],
          reset: {
            translateY: 0
          }
        },
        /* Animate.css */
        "transition.bounceLeftIn": {
          defaultDuration: 750,
          calls: [[{
            opacity: [1, 0],
            translateX: [30, -1250]
          }, 0.60, {
            easing: "easeOutCirc"
          }], [{
            translateX: -10
          }, 0.20], [{
            translateX: 0
          }, 0.20]]
        },
        /* Animate.css */
        "transition.bounceLeftOut": {
          defaultDuration: 750,
          calls: [[{
            translateX: 30
          }, 0.20], [{
            opacity: [0, "easeInCirc", 1],
            translateX: -1250
          }, 0.80]],
          reset: {
            translateX: 0
          }
        },
        /* Animate.css */
        "transition.bounceRightIn": {
          defaultDuration: 750,
          calls: [[{
            opacity: [1, 0],
            translateX: [-30, 1250]
          }, 0.60, {
            easing: "easeOutCirc"
          }], [{
            translateX: 10
          }, 0.20], [{
            translateX: 0
          }, 0.20]]
        },
        /* Animate.css */
        "transition.bounceRightOut": {
          defaultDuration: 750,
          calls: [[{
            translateX: -30
          }, 0.20], [{
            opacity: [0, "easeInCirc", 1],
            translateX: 1250
          }, 0.80]],
          reset: {
            translateX: 0
          }
        },
        "transition.slideUpIn": {
          defaultDuration: 900,
          calls: [[{
            opacity: [1, 0],
            translateY: [0, 20],
            translateZ: 0
          }]]
        },
        "transition.slideUpOut": {
          defaultDuration: 900,
          calls: [[{
            opacity: [0, 1],
            translateY: -20,
            translateZ: 0
          }]],
          reset: {
            translateY: 0
          }
        },
        "transition.slideDownIn": {
          defaultDuration: 900,
          calls: [[{
            opacity: [1, 0],
            translateY: [0, -20],
            translateZ: 0
          }]]
        },
        "transition.slideDownOut": {
          defaultDuration: 900,
          calls: [[{
            opacity: [0, 1],
            translateY: 20,
            translateZ: 0
          }]],
          reset: {
            translateY: 0
          }
        },
        "transition.slideLeftIn": {
          defaultDuration: 1000,
          calls: [[{
            opacity: [1, 0],
            translateX: [0, -20],
            translateZ: 0
          }]]
        },
        "transition.slideLeftOut": {
          defaultDuration: 1050,
          calls: [[{
            opacity: [0, 1],
            translateX: -20,
            translateZ: 0
          }]],
          reset: {
            translateX: 0
          }
        },
        "transition.slideRightIn": {
          defaultDuration: 1000,
          calls: [[{
            opacity: [1, 0],
            translateX: [0, 20],
            translateZ: 0
          }]]
        },
        "transition.slideRightOut": {
          defaultDuration: 1050,
          calls: [[{
            opacity: [0, 1],
            translateX: 20,
            translateZ: 0
          }]],
          reset: {
            translateX: 0
          }
        },
        "transition.slideUpBigIn": {
          defaultDuration: 850,
          calls: [[{
            opacity: [1, 0],
            translateY: [0, 75],
            translateZ: 0
          }]]
        },
        "transition.slideUpBigOut": {
          defaultDuration: 800,
          calls: [[{
            opacity: [0, 1],
            translateY: -75,
            translateZ: 0
          }]],
          reset: {
            translateY: 0
          }
        },
        "transition.slideDownBigIn": {
          defaultDuration: 850,
          calls: [[{
            opacity: [1, 0],
            translateY: [0, -75],
            translateZ: 0
          }]]
        },
        "transition.slideDownBigOut": {
          defaultDuration: 800,
          calls: [[{
            opacity: [0, 1],
            translateY: 75,
            translateZ: 0
          }]],
          reset: {
            translateY: 0
          }
        },
        "transition.slideLeftBigIn": {
          defaultDuration: 800,
          calls: [[{
            opacity: [1, 0],
            translateX: [0, -75],
            translateZ: 0
          }]]
        },
        "transition.slideLeftBigOut": {
          defaultDuration: 750,
          calls: [[{
            opacity: [0, 1],
            translateX: -75,
            translateZ: 0
          }]],
          reset: {
            translateX: 0
          }
        },
        "transition.slideRightBigIn": {
          defaultDuration: 800,
          calls: [[{
            opacity: [1, 0],
            translateX: [0, 75],
            translateZ: 0
          }]]
        },
        "transition.slideRightBigOut": {
          defaultDuration: 750,
          calls: [[{
            opacity: [0, 1],
            translateX: 75,
            translateZ: 0
          }]],
          reset: {
            translateX: 0
          }
        },
        /* Magic.css */
        "transition.perspectiveUpIn": {
          defaultDuration: 800,
          calls: [[{
            opacity: [1, 0],
            transformPerspective: [800, 800],
            transformOriginX: [0, 0],
            transformOriginY: ["100%", "100%"],
            rotateX: [0, -180]
          }]],
          reset: {
            transformPerspective: 0,
            transformOriginX: "50%",
            transformOriginY: "50%"
          }
        },
        /* Magic.css */
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.perspectiveUpOut": {
          defaultDuration: 850,
          calls: [[{
            opacity: [0, 1],
            transformPerspective: [800, 800],
            transformOriginX: [0, 0],
            transformOriginY: ["100%", "100%"],
            rotateX: -180
          }]],
          reset: {
            transformPerspective: 0,
            transformOriginX: "50%",
            transformOriginY: "50%",
            rotateX: 0
          }
        },
        /* Magic.css */
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.perspectiveDownIn": {
          defaultDuration: 800,
          calls: [[{
            opacity: [1, 0],
            transformPerspective: [800, 800],
            transformOriginX: [0, 0],
            transformOriginY: [0, 0],
            rotateX: [0, 180]
          }]],
          reset: {
            transformPerspective: 0,
            transformOriginX: "50%",
            transformOriginY: "50%"
          }
        },
        /* Magic.css */
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.perspectiveDownOut": {
          defaultDuration: 850,
          calls: [[{
            opacity: [0, 1],
            transformPerspective: [800, 800],
            transformOriginX: [0, 0],
            transformOriginY: [0, 0],
            rotateX: 180
          }]],
          reset: {
            transformPerspective: 0,
            transformOriginX: "50%",
            transformOriginY: "50%",
            rotateX: 0
          }
        },
        /* Magic.css */
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.perspectiveLeftIn": {
          defaultDuration: 950,
          calls: [[{
            opacity: [1, 0],
            transformPerspective: [2000, 2000],
            transformOriginX: [0, 0],
            transformOriginY: [0, 0],
            rotateY: [0, -180]
          }]],
          reset: {
            transformPerspective: 0,
            transformOriginX: "50%",
            transformOriginY: "50%"
          }
        },
        /* Magic.css */
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.perspectiveLeftOut": {
          defaultDuration: 950,
          calls: [[{
            opacity: [0, 1],
            transformPerspective: [2000, 2000],
            transformOriginX: [0, 0],
            transformOriginY: [0, 0],
            rotateY: -180
          }]],
          reset: {
            transformPerspective: 0,
            transformOriginX: "50%",
            transformOriginY: "50%",
            rotateY: 0
          }
        },
        /* Magic.css */
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.perspectiveRightIn": {
          defaultDuration: 950,
          calls: [[{
            opacity: [1, 0],
            transformPerspective: [2000, 2000],
            transformOriginX: ["100%", "100%"],
            transformOriginY: [0, 0],
            rotateY: [0, 180]
          }]],
          reset: {
            transformPerspective: 0,
            transformOriginX: "50%",
            transformOriginY: "50%"
          }
        },
        /* Magic.css */
        /* Support: Loses rotation in IE9/Android 2.3 (fades only). */
        "transition.perspectiveRightOut": {
          defaultDuration: 950,
          calls: [[{
            opacity: [0, 1],
            transformPerspective: [2000, 2000],
            transformOriginX: ["100%", "100%"],
            transformOriginY: [0, 0],
            rotateY: 180
          }]],
          reset: {
            transformPerspective: 0,
            transformOriginX: "50%",
            transformOriginY: "50%",
            rotateY: 0
          }
        }
      };

      /* Register the packaged effects. */
      for (var effectName in Velocity.RegisterEffect.packagedEffects) {
        if (Velocity.RegisterEffect.packagedEffects.hasOwnProperty(effectName)) {
          Velocity.RegisterEffect(effectName, Velocity.RegisterEffect.packagedEffects[effectName]);
        }
      }

      /*********************
       Sequence Running
       **********************/

      /* Note: Sequence calls must use Velocity's single-object arguments syntax. */
      Velocity.RunSequence = function (originalSequence) {
        var sequence = $.extend(true, [], originalSequence);
        if (sequence.length > 1) {
          $.each(sequence.reverse(), function (i, currentCall) {
            var nextCall = sequence[i + 1];
            if (nextCall) {
              /* Parallel sequence calls (indicated via sequenceQueue:false) are triggered
               in the previous call's begin callback. Otherwise, chained calls are normally triggered
               in the previous call's complete callback. */
              var currentCallOptions = currentCall.o || currentCall.options,
                nextCallOptions = nextCall.o || nextCall.options;
              var timing = currentCallOptions && currentCallOptions.sequenceQueue === false ? "begin" : "complete",
                callbackOriginal = nextCallOptions && nextCallOptions[timing],
                options = {};
              options[timing] = function () {
                var nextCallElements = nextCall.e || nextCall.elements;
                var elements = nextCallElements.nodeType ? [nextCallElements] : nextCallElements;
                if (callbackOriginal) {
                  callbackOriginal.call(elements, elements);
                }
                Velocity(currentCall);
              };
              if (nextCall.o) {
                nextCall.o = $.extend({}, nextCallOptions, options);
              } else {
                nextCall.options = $.extend({}, nextCallOptions, options);
              }
            }
          });
          sequence.reverse();
        }
        Velocity(sequence[0]);
      };
    }(window.jQuery || window.Zepto || window, window, window ? window.document : undefined);
  });

  /***/
}, /* 417 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ChangeCard;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function ChangeCard(_ref) {
    var cards = _ref.cards,
      currentCard = _ref.currentCard,
      prevCard = _ref.prevCard,
      nextCard = _ref.nextCard;
    if (!cards.length) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-chevron-right",
      className: "chevron-right ".concat(currentCard === (cards === null || cards === void 0 ? void 0 : cards.length) - 1 ? "hidden" : ""),
      onClick: nextCard
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-chevron-left",
      className: "chevron-left ".concat(currentCard === 0 ? "hidden" : ""),
      onClick: prevCard
    }));
  }

  /***/
},, /* 419 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _SharedPropTypes = __webpack_require__(27);
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var Header = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(Header, _React$PureComponent);
    var _super = _createSuper(Header);
    function Header() {
      _classCallCheck(this, Header);
      return _super.apply(this, arguments);
    }
    _createClass(Header, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          logo = _this$props.logo,
          className = _this$props.className,
          theme = _this$props.theme,
          children = _this$props.children,
          headerLink = _this$props.headerLink,
          colorTheme = theme ? theme : this.context.rhombusTheme,
          hClass = ["o-app__header", className],
          $headerContent = null;
        if (!colorTheme) {
          colorTheme = "default";
        }
        hClass.push("o-app__header--".concat(colorTheme));
        if (headerLink) {
          $headerContent = /*#__PURE__*/_react["default"].createElement("div", {
            className: "e-product-logo"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            href: headerLink
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "bold"
          }, logo.bold), /*#__PURE__*/_react["default"].createElement("span", {
            className: "normal"
          }, logo.normal)));
        } else {
          $headerContent = /*#__PURE__*/_react["default"].createElement("div", {
            className: "e-product-logo"
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "bold"
          }, logo.bold), /*#__PURE__*/_react["default"].createElement("span", {
            className: "normal"
          }, logo.normal));
        }
        return /*#__PURE__*/_react["default"].createElement("header", {
          className: (0, _classnames["default"])(hClass)
        }, $headerContent, children);
      }
    }]);
    return Header;
  }(_react["default"].PureComponent);
  exports["default"] = Header;
  _defineProperty(Header, "contextTypes", {
    rhombusTheme: _propTypes["default"].string
  });
  _defineProperty(Header, "propTypes", {
    theme: _SharedPropTypes.PROPTYPE_THEME,
    headerLink: _propTypes["default"].string,
    className: _propTypes["default"].string,
    logo: _propTypes["default"].shape({
      bold: _propTypes["default"].string,
      normal: _propTypes["default"].string
    })
  });
  _defineProperty(Header, "defaultProps", {
    theme: null,
    headerLink: null,
    className: '',
    logo: {
      bold: '',
      normal: ''
    }
  });

  /***/
}, /* 420 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _SharedPropTypes = __webpack_require__(27);
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var NavbarItem = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(NavbarItem, _React$PureComponent);
    var _super = _createSuper(NavbarItem);
    function NavbarItem() {
      _classCallCheck(this, NavbarItem);
      return _super.apply(this, arguments);
    }
    _createClass(NavbarItem, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          iconClassPrefix: "c-navbar__icon"
        };
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          link = _this$props.link,
          icon = _this$props.icon,
          title = _this$props.title,
          target = _this$props.target,
          isActive = _this$props.isActive,
          isInternalLink = _this$props.isInternalLink,
          onClick = _this$props.onClick,
          isBottom = _this$props.isBottom,
          $linkContent = null,
          className = (0, _classnames["default"])({
            "nav-bar-link": true,
            "is-active": isActive,
            "c-navbar__bottom-link": isBottom
          }),
          clickHandler = link ? null : function (e) {
            return e.preventDefault(), onClick(e);
          };
        if (isInternalLink) {
          $linkContent = /*#__PURE__*/_react["default"].createElement("a", {
            href: link,
            title: title,
            className: "nav-link"
          }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            name: icon
          }), /*#__PURE__*/_react["default"].createElement("span", null, title));
        } else {
          $linkContent = /*#__PURE__*/_react["default"].createElement("a", {
            href: link || "#",
            className: "nav-link external",
            title: title,
            target: target,
            onClick: clickHandler
          }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            name: icon
          }), /*#__PURE__*/_react["default"].createElement("span", null, title));
        }
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: className
        }, $linkContent);
      }
    }]);
    return NavbarItem;
  }(_react["default"].PureComponent);
  _defineProperty(NavbarItem, "childContextTypes", {
    /** Extra className applied to Icons */
    iconClassPrefix: _propTypes["default"].string
  });
  _defineProperty(NavbarItem, "defaultProps", {
    isBottom: false,
    isActive: false,
    isInternalLink: false,
    target: null
  });
  var NAV_ITEM_SHAPE = {
    /** The text and tooltip content for this item */
    title: _propTypes["default"].string.isRequired,
    /** Name of a Icon for this item */
    icon: _propTypes["default"].string.isRequired,
    /** Highlight this item as the "active" item */
    isActive: _propTypes["default"].bool,
    /** A URL target to visit if this item is clicked */
    link: _propTypes["default"].string,
    /** A callback function executed when this item is clicked */
    onClick: _propTypes["default"].func,
    /** Use a react-router link, or use a native HTML a tag */
    isInternalLink: _propTypes["default"].bool,
    /** Should the native HTML tag open in a new window target */
    target: _propTypes["default"].string
  };

  /**
   * A Rhombus navbar that is fixed to the left of the viewport
   *
   * https://rhombus.flashtalking.net/components/navigation/#navbar
   */
  /* eslint-disable react/no-multi-comp */
  var Navbar = /*#__PURE__*/function (_React$PureComponent2) {
    _inherits(Navbar, _React$PureComponent2);
    var _super2 = _createSuper(Navbar);
    function Navbar() {
      _classCallCheck(this, Navbar);
      return _super2.apply(this, arguments);
    }
    _createClass(Navbar, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          theme = _this$props2.theme,
          productIcon = _this$props2.productIcon,
          _this$props2$items = _this$props2.items,
          items = _this$props2$items === void 0 ? [] : _this$props2$items,
          footLink = _this$props2.footLink,
          productIconURL = _this$props2.productIconURL,
          $footer = footLink ? /*#__PURE__*/_react["default"].createElement(NavbarItem, _extends({}, footLink, {
            isBottom: true
          })) : null,
          $product = null,
          $items = null;
        if (!theme) {
          theme = this.context.rhombusTheme || "default";
        }
        if (productIcon) {
          var url = productIconURL ? productIconURL : productIcon;
          $product = /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("span", {
            className: "e-product-icon"
          }, /*#__PURE__*/_react["default"].createElement("img", {
            src: url,
            name: productIcon,
            size: "xlarge"
          })));
        }
        $items = items.map(function (v) {
          return /*#__PURE__*/_react["default"].createElement(NavbarItem, _extends({}, v, {
            key: v.title
          }));
        });
        return /*#__PURE__*/_react["default"].createElement("nav", {
          className: "c-navbar t-navbar--".concat(theme)
        }, /*#__PURE__*/_react["default"].createElement("ul", null, $footer, $product, $items));
      }
    }]);
    return Navbar;
  }(_react["default"].PureComponent);
  /* eslint-enable react/no-multi-comp */
  exports["default"] = Navbar;
  _defineProperty(Navbar, "rhombusAppSlot", "after");
  _defineProperty(Navbar, "contextTypes", {
    /** Theme passed down from Rhombus App layout component */
    rhombusTheme: _propTypes["default"].string
  });
  _defineProperty(Navbar, "propTypes", {
    /** The list of menu items to display */
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape(NAV_ITEM_SHAPE)),
    /** The icon to display at the top of the navbar */
    productIcon: _propTypes["default"].string,
    /** The URL of the icon to display at the top of the navbar */
    productIconURL: _propTypes["default"].string,
    /** An item to be displayed at the foot of the navbar */
    footLink: _propTypes["default"].shape(NAV_ITEM_SHAPE),
    /** The theme/colour to apply to the menu */
    theme: _SharedPropTypes.PROPTYPE_THEME
  });
  _defineProperty(Navbar, "defaultProps", {
    items: [],
    productIcon: null,
    productIconURL: null,
    footerLink: null
  });

  /***/
}, /* 421 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _reactPaginate = _interopRequireDefault(__webpack_require__(447));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _SharedPropTypes = __webpack_require__(27);
  var _excluded = ["showRowCount", "rowCountItems", "onRowCountChange", "pageSize", "disabled"];
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  /**
   * Renders a Pager component.  We use the React-Paginate package to control things, please see their documentation for a full list of the properties it takes
   *
   * https://github.com/AdeleD/react-paginate
   */
  var Pager = (_class = (_class2 = /*#__PURE__*/function (_Component) {
    _inherits(Pager, _Component);
    var _super = _createSuper(Pager);
    function Pager() {
      _classCallCheck(this, Pager);
      return _super.apply(this, arguments);
    }
    _createClass(Pager, [{
      key: "onRowCountChange",
      value: function onRowCountChange(evt) {
        var value = evt.currentTarget.value;
        if (this.props.onRowCountChange) {
          this.props.onRowCountChange(value);
        }
      }
    }, {
      key: "onPageChange",
      value: function onPageChange(newPage) {
        this.props.onPageChange(newPage.selected + 1);
      }
    }, {
      key: "_renderRowCounter",
      value: function _renderRowCounter() {
        var _this$props = this.props,
          showRowCount = _this$props.showRowCount,
          rowCountItems = _this$props.rowCountItems,
          pageSize = _this$props.pageSize,
          disabled = _this$props.disabled;
        if (!showRowCount) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement("fieldset", {
          className: "row-count-fieldset"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "e-form__control"
        }, /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: "row-count-selector"
        }, "Rows"), /*#__PURE__*/_react["default"].createElement("div", {
          className: "e-form__control--select"
        }, /*#__PURE__*/_react["default"].createElement("select", {
          disabled: disabled,
          className: "e-form__select row-count-selector",
          id: "row-count-selector",
          onChange: this.onRowCountChange,
          value: pageSize
        }, rowCountItems.map(function (v) {
          return /*#__PURE__*/_react["default"].createElement("option", {
            key: v,
            value: v
          }, v);
        })))));
      }
    }, {
      key: "_renderItemCount",
      value: function _renderItemCount() {
        var _this$props2 = this.props,
          pageSize = _this$props2.pageSize,
          initialPage = _this$props2.initialPage,
          showItemCount = _this$props2.showItemCount,
          showItemWord = _this$props2.showItemWord,
          maxItems = _this$props2.maxItems,
          startNumber = 1,
          endNumber = 1;
        if (!showItemCount) {
          return null;
        }
        try {
          if (/all/gi.test(pageSize)) {
            startNumber = 1;
            endNumber = maxItems;
          } else {
            startNumber = pageSize * (initialPage - 1) + 1;
            endNumber = pageSize * initialPage;
          }
        } catch (error) {
          console.error("Tried to subtract something small");
        }
        if (endNumber > maxItems) {
          endNumber = maxItems;
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "item-count"
        }, /*#__PURE__*/_react["default"].createElement("span", null, "".concat(showItemWord, " ").concat(startNumber, "-").concat(endNumber, " of ").concat(maxItems)));
      }

      /*eslint-disable no-unused-vars */
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
          showRowCount = _this$props3.showRowCount,
          rowCountItems = _this$props3.rowCountItems,
          onRowCountChange = _this$props3.onRowCountChange,
          pageSize = _this$props3.pageSize,
          disabled = _this$props3.disabled,
          props = _objectWithoutProperties(_this$props3, _excluded),
          pageTheme = "t-pagination--".concat(this.context.rhombusTheme),
          classes = (0, _classnames["default"])(_defineProperty({
            "flex-center": true,
            "has-row-counter": showRowCount,
            "is-disabled": disabled,
            "c-pagination": true,
            pager: true
          }, pageTheme, true)),
          forcePage = props.forcePage ? props.forcePage - 1 : null,
          initialPage = props.initialPage - 1;
        return /*#__PURE__*/_react["default"].createElement("nav", {
          className: classes
        }, /*#__PURE__*/_react["default"].createElement(_reactPaginate["default"], _extends({}, props, {
          onPageChange: this.onPageChange,
          forcePage: forcePage,
          initialPage: initialPage
        })), this._renderItemCount(), this._renderRowCounter());
      }
      /*eslint-enable no-unused-vars */
    }]);

    return Pager;
  }(_react.Component), _defineProperty(_class2, "defaultProps", {
    previousLabel: "",
    nextLabel: "",
    /*eslint-disable no-magic-numbers*/
    pageCount: 25,
    pageRangeDisplayed: 3,
    marginPagesDisplayed: 3,
    previousLinkClassName: "c-pagination__previous",
    nextLinkClassName: "c-pagination__next",
    disabledClassName: "is-disabled",
    pageClassName: "individual-pages",
    onPageChange: null,
    containerClassName: "pager-list",
    showRowCount: true,
    rowCountItems: [10, 25, 50, "All"],
    pageSize: 10,
    onRowCountChange: null,
    initialPage: 1,
    forcePage: null,
    showItemCount: false,
    showItemWord: "Items:",
    maxItems: 1,
    /*eslint-enable no-magic-numbers*/
    disabled: false
  }), _defineProperty(_class2, "propTypes", {
    /**	What happens when we change the page? */
    onPageChange: _propTypes["default"].func.isRequired,
    /**	What items should we allow the row count selector to be? */
    rowCountItems: _propTypes["default"].array,
    /**	Should we show the row count selector? */
    showRowCount: _propTypes["default"].bool,
    pageSize: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    /**	 When we change the row count, what should happen? */
    /*eslint-disable prefer-template */
    onRowCountChange: function onRowCountChange(props, propName, componentName) {
      if (props.showRowCount) {
        if (!props[propName]) {
          return new Error('Missing prop `' + propName + '` supplied to' + ' `' + componentName + '`. You are allowing the page count to change, but not connecting to the event.');
        }
      }
    }
    /*eslint-enable prefer-template */
  }), _defineProperty(_class2, "contextTypes", {
    rhombusTheme: _SharedPropTypes.PROPTYPE_THEME
  }), _class2), (_applyDecoratedDescriptor(_class.prototype, "onRowCountChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onRowCountChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPageChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onPageChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderRowCounter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderRowCounter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderItemCount", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderItemCount"), _class.prototype)), _class);
  exports["default"] = Pager;

  /***/
}, /* 422 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _SharedPropTypes = __webpack_require__(27);
  var _Search = _interopRequireDefault(__webpack_require__(113));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  // import Input from '../form/Input.jsx';
  // import { debounce } from "../helpers/Debounce";
  /**
   * Renders a toolbar with optional search box.  Any children are rendered at the right of the
   * toolbar, Button components are the recommended pattern to use here.
   *
   * https://rhombus.flashtalking.net/components/toolbar/
   */
  var Toolbar = /*#__PURE__*/function (_React$Component) {
    _inherits(Toolbar, _React$Component);
    var _super = _createSuper(Toolbar);
    function Toolbar() {
      _classCallCheck(this, Toolbar);
      return _super.apply(this, arguments);
    }
    _createClass(Toolbar, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          rhombusButtonDefaults: {
            theme: this.props.theme || this.context.rhombusTheme,
            size: 'small',
            style: 'link'
          }
        };
      }
    }, {
      key: "render",
      value: function render() {
        var searchInput,
          _this$props = this.props,
          children = _this$props.children,
          search = _this$props.search,
          searchValue = _this$props.searchValue,
          className = _this$props.className,
          searchProps = _this$props.searchProps,
          onSearch = _this$props.onSearch,
          searchDebounce = _this$props.searchDebounce;
        if (search) {
          searchInput = /*#__PURE__*/_react["default"].createElement(_Search["default"], _extends({}, searchProps, {
            onSearch: onSearch,
            searchValue: searchValue,
            searchDebounce: searchDebounce
          }));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "c-toolbar ".concat(className)
        }, searchInput, children);
      }
    }]);
    return Toolbar;
  }(_react["default"].Component);
  exports["default"] = Toolbar;
  _defineProperty(Toolbar, "childContextTypes", {
    rhombusButtonDefaults: _propTypes["default"].shape({
      theme: _SharedPropTypes.PROPTYPE_THEME,
      size: _propTypes["default"].oneOf(['small']),
      style: _propTypes["default"].oneOf(['link'])
    })
  });
  _defineProperty(Toolbar, "contextTypes", {
    rhombusTheme: _SharedPropTypes.PROPTYPE_THEME
  });
  _defineProperty(Toolbar, "defaultProps", {
    className: "",
    searchDebounce: 500,
    onSearch: null,
    searchProps: {}
  });
  _defineProperty(Toolbar, "propTypes", {
    /** Theme of the toolbar components.  Also inherits theme from RhombusApp */
    theme: _SharedPropTypes.PROPTYPE_THEME,
    /** Callback function to run when search text is entered */
    onSearch: _propTypes["default"].func,
    /** Displays the search box */
    search: _propTypes["default"].bool,
    /** Value to populate the search with */
    searchValue: _propTypes["default"].string,
    /** What milisecond delay to debounce the search by */
    searchDebounce: _propTypes["default"].number,
    /** Additional props for <Search /> component*/
    searchProps: _propTypes["default"].object
    /* {
    	   className:       PropTypes.string,
    	   placeholder:     PropTypes.string,
    	} */
  });

  /***/
}, /* 423 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = EmptyItem;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  __webpack_require__(55);
  __webpack_require__(452);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  // defaults for commonly used error pages
  var TYPES = {
    noAccess: {
      classes: "no-access",
      icon: "locked",
      message: "Sorry, you do not have permission to access this page.",
      title: "Unauthorized"
    },
    notFound: {
      classes: "not-found oops",
      icon: "oops",
      message: "Sorry, we can't find the page you are looking for.",
      title: "Oops."
    },
    tokenExpired: {
      classes: "expired",
      icon: "expired",
      message: "Sorry, the shared link either has expired or is invalid.",
      title: "Expired or invalid link"
    }
  };
  function EmptyItem(props) {
    var typeInfo = TYPES[props.type],
      useTitle = props.title || (typeInfo === null || typeInfo === void 0 ? void 0 : typeInfo.title),
      useIcon = props.icon || (typeInfo === null || typeInfo === void 0 ? void 0 : typeInfo.icon) || "oops",
      useMessage = props.message || (typeInfo === null || typeInfo === void 0 ? void 0 : typeInfo.message) || "Something went wrong.",
      $iconOrImage = props.src ? /*#__PURE__*/_react["default"].createElement("img", {
        src: props.src,
        className: "image item-image",
        alt: props.alt
      }) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: useIcon,
        className: "item-icon"
      }),
      $title = !!useTitle ? /*#__PURE__*/_react["default"].createElement("h4", null, useTitle) : null,
      $buttons = !!props.buttons ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "buttons"
      }, props.buttons) : null;
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "empty-item flex-center ".concat((typeInfo === null || typeInfo === void 0 ? void 0 : typeInfo.classes) || "", " ").concat(props.className)
    }, $iconOrImage, $title, /*#__PURE__*/_react["default"].createElement("p", null, useMessage), $buttons);
  }
  EmptyItem.propTypes = {
    buttons: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].element)]),
    className: _propTypes["default"].string,
    icon: _propTypes["default"].string,
    src: _propTypes["default"].string,
    alt: _propTypes["default"].string,
    message: _propTypes["default"].string,
    title: _propTypes["default"].string,
    type: _propTypes["default"].oneOf(["noAccess", "notFound", "tokenExpired"])
  };
  EmptyItem.defaultProps = {
    className: "",
    alt: "Empty Item Image"
  };

  /***/
}, /* 424 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.HelpItem = HelpItem;
  exports["default"] = AppHeader;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _HeaderUser = _interopRequireDefault(__webpack_require__(454));
  var _HeaderNavItem = _interopRequireDefault(__webpack_require__(455));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _AccountModal = _interopRequireDefault(__webpack_require__(426));
  var _SharedPropTypes = __webpack_require__(27);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  var DEFAULT_LOGO = {
    alt: "Flashtalking Logo",
    image: "/images/flashtalking-white-1@3x.png",
    title: "Flashtalking Logo",
    url: null
  };
  function AppHeader(props) {
    var user = props.user,
      currentPage = props.currentPage,
      navItems = props.navItems,
      className = props.className,
      logo = props.logo,
      product = props.product,
      children = props.children,
      environmentName = props.environmentName,
      environmentNameTheme = props.environmentNameTheme,
      showSettings = props.showSettings,
      onSaveSettings = props.onSaveSettings,
      showSignout = props.showSignout,
      onSignout = props.onSignout,
      _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAccountModalVisible = _useState2[0],
      setAccountVisible = _useState2[1],
      _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSaving = _useState4[0],
      setIsSaving = _useState4[1],
      $user = null,
      $navItems = null,
      logoInfo = _objectSpread(_objectSpread({}, DEFAULT_LOGO), logo),
      $prod = product;
    if (user) {
      $user = /*#__PURE__*/_react["default"].createElement(_HeaderUser["default"], {
        userName: user.name,
        showSettings: showSettings,
        onSettingsClick: onSettingsClick,
        showSignout: showSignout,
        onSignoutClick: onSignout
      });
    }
    $navItems = navItems.map(function (v) {
      var isActive = v.link && v.link === currentPage;
      return /*#__PURE__*/_react["default"].createElement(_HeaderNavItem["default"], _extends({
        key: v.id
      }, v, {
        isActive: isActive
      }));
    });
    function onSettingsClick() {
      setAccountVisible(true);
    }
    function _onSaveSettings(values) {
      setIsSaving(true);
      onSaveSettings(values).then(function (resp) {
        setIsSaving(false);
        if (resp !== null && resp !== void 0 && resp.success) {
          setAccountVisible(false);
        }
      });
    }
    return /*#__PURE__*/_react["default"].createElement("header", {
      className: "ft-header ".concat(className)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "logo-side flex-center"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: logoInfo.url,
      target: "_HUB",
      className: "ft-logo",
      title: logoInfo.title
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: logoInfo.image,
      alt: logoInfo.alt
    })), /*#__PURE__*/_react["default"].createElement("h1", {
      className: "ft-product-name"
    }, $prod, /*#__PURE__*/_react["default"].createElement(EnvironmentBadge, {
      name: environmentName,
      theme: environmentNameTheme
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "header-children"
    }, children), /*#__PURE__*/_react["default"].createElement("div", {
      className: "nav-side"
    }, $navItems, $user), /*#__PURE__*/_react["default"].createElement(_AccountModal["default"], {
      isVisible: isAccountModalVisible,
      onClose: function onClose() {
        return setAccountVisible(false);
      },
      userInfo: user,
      onSave: _onSaveSettings,
      isSaving: isSaving
    }));
  }
  AppHeader.displayName = "AppHeader";
  AppHeader.defaultProps = {
    className: "",
    currentPage: null,
    environmentName: null,
    environmentNameTheme: 'red',
    logo: DEFAULT_LOGO,
    navItems: [],
    onSaveSettings: function onSaveSettings() {
      return Promise.resolve({
        success: true
      });
    },
    onSignout: function onSignout() {
      return Promise.resolve({
        success: true
      });
    },
    product: null,
    showSettings: true,
    showSignout: true,
    user: {
      name: "",
      firstName: "",
      lastName: ""
    }
  };
  AppHeader.propTypes = {
    /** Custom className to pass through to the parent `header` element */
    className: _propTypes["default"].string,
    /** The currently selected nav item */
    currentPage: _propTypes["default"].string,
    /** Text to display in environment badge */
    environmentName: _propTypes["default"].string,
    /** Sets the theme/colour of the environment name badge */
    environmentNameTheme: _SharedPropTypes.PROPTYPE_THEME,
    /** logo information */
    logo: _propTypes["default"].shape({
      alt: _propTypes["default"].string,
      image: _propTypes["default"].string,
      title: _propTypes["default"].string,
      url: _propTypes["default"].string
    }),
    /** List of navigation links */
    navItems: _propTypes["default"].array,
    /** What should happen when settings are saved */
    onSaveSettings: _propTypes["default"].func,
    /** What should happen on sign out */
    onSignout: _propTypes["default"].func,
    /** Title of the app */
    product: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]).isRequired,
    /** Should the `HeaderUser` component show the User Account action */
    showSettings: _propTypes["default"].bool,
    /** Should the `HeaderUser` component show the signout action */
    showSignout: _propTypes["default"].bool,
    /** User name to display in the corner */
    user: _propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      firstName: _propTypes["default"].string.isRequired,
      lastName: _propTypes["default"].string.isRequired
    }).isRequired
  };
  function EnvironmentBadge(_ref) {
    var name = _ref.name,
      theme = _ref.theme;
    if (!name) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "u-margin-left--small"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "c-badge c-environment-badge c-badge--large c-badge--ghost t-badge--ghost-".concat(theme)
    }, name));
  }

  // TODO: Figure out why this isn't working
  function HelpItem(items) {
    var $helpItems = items.forEach(function (v) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: "ft-header-option",
        key: v.key
      }, v.item);
    });
    return {
      id: "help",
      icon: "fas fa-question-circle",
      title: "View Help",
      className: "has-more-options ft-help-item pendo-help-nav-icon",
      renderChild: function renderChild(props, classes) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: classes
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          className: "fas fa-question-circle"
        }), /*#__PURE__*/_react["default"].createElement("ul", {
          className: "ft-header-more-options"
        }, $helpItems));
      }
    };
  }

  /***/
}, /* 425 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = useClickOutsideHandler;
  var _react = __webpack_require__(1);
  var _reactDom = _interopRequireDefault(__webpack_require__(15));
  var _functions = __webpack_require__(33);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function useClickOutsideHandler() {
    var onClickOutside = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _functions.noop;
    var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "mousedown";
    var compRef = (0, _react.useRef)();
    function handler(e) {
      var node = _reactDom["default"].findDOMNode(compRef.current);
      if (node) {
        if (!node.contains(e.target)) {
          onClickOutside();
        }
      }
    }
    (0, _react.useEffect)(function () {
      document.addEventListener(eventType, handler, true);
      return function () {
        document.removeEventListener(eventType, handler, true);
      };
    }, []);
    return [compRef];
  }

  /***/
}, /* 426 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.INITIAL_ACCOUNT_STATE = exports.ACCOUNT_REDUX = exports.ACCOUNT_HANDLERS = exports.ACCOUNT_ACTIONS = void 0;
  exports.beginSaveSettings = beginSaveSettings;
  exports["default"] = AccountModal;
  exports.saveAccountInfo = saveAccountInfo;
  exports.saveSettings = saveSettings;
  exports.saveSettingsError = saveSettingsError;
  exports.signoutUser = signoutUser;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _reactAriaModal = _interopRequireDefault(__webpack_require__(212));
  var _functions = __webpack_require__(33);
  var _constants = __webpack_require__(59);
  var _ModalHeader = _interopRequireDefault(__webpack_require__(141));
  var _ModalFooter = _interopRequireDefault(__webpack_require__(142));
  var _ProgressIndicator = _interopRequireDefault(__webpack_require__(242));
  var _Button = _interopRequireDefault(__webpack_require__(61));
  var _index = _interopRequireDefault(__webpack_require__(114));
  var _PasswordToggle = _interopRequireDefault(__webpack_require__(456));
  var _userInfo, _PropTypes$shape, _ACCOUNT_HANDLERS;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  var FIRST = "firstName",
    LAST = "lastName",
    PASS = "newPassword",
    MATCH = "password_match",
    TYPE_TEXT = "text",
    TYPE_PASS = "password";
  function AccountModal(_ref) {
    var _useState5;
    var isVisible = _ref.isVisible,
      isSaving = _ref.isSaving,
      userInfo = _ref.userInfo,
      onClose = _ref.onClose,
      onSave = _ref.onSave,
      passwordValidation = _ref.passwordValidation,
      nameValidation = _ref.nameValidation;
    if (!isVisible) {
      return null;
    }
    var _useState = (0, _react.useState)(_objectSpread({}, userInfo)),
      _useState2 = _slicedToArray(_useState, 2),
      currentVals = _useState2[0],
      setVals = _useState2[1],
      _useState3 = (0, _react.useState)((_useState5 = {}, _defineProperty(_useState5, FIRST, {
        valid: !!userInfo.first,
        initial: !!userInfo.first
      }), _defineProperty(_useState5, LAST, {
        valid: !!userInfo.last,
        initial: !!userInfo.last
      }), _defineProperty(_useState5, PASS, {}), _defineProperty(_useState5, MATCH, {}), _useState5)),
      _useState4 = _slicedToArray(_useState3, 2),
      currentMeta = _useState4[0],
      setMeta = _useState4[1];
    function saveSettings(e) {
      e.preventDefault();
      onSave(currentVals);
    }
    function onFieldChange(value, key) {
      setVals(_objectSpread(_objectSpread({}, currentVals), {}, _defineProperty({}, key, value)));
      var metaObj = {
        dirty: true
      };
      if (/password/gi.test(key)) {
        metaObj.valid = passwordValidation(value);
        /**
         * Only check that the passwords match if they are valid
         * This fixes the issue of setting `newPass` = `Password` which is invalid and marked as such
         * And then setting `matchPass` = `Password` which will mark the fields valid because now 1 & 2 match
         */
        if (metaObj.valid) {
          if (key === MATCH) {
            metaObj.valid = value === currentVals[PASS];
          }
          if (key === PASS) {
            if (currentVals[MATCH]) {
              metaObj.valid = value === currentVals[MATCH];
            }
          }
        }
      } else {
        metaObj.valid = nameValidation(value, key);
      }
      setMeta(_objectSpread(_objectSpread({}, currentMeta), {}, _defineProperty({}, key, metaObj)));
    }
    var _useState6 = (0, _react.useState)({
        isVisible: false,
        tooltip: "Show Password",
        passIcon: "fa-eye-slash"
      }),
      _useState7 = _slicedToArray(_useState6, 2),
      showPass = _useState7[0],
      setShowPass = _useState7[1];
    var _useState8 = (0, _react.useState)({
        isVisible: false,
        tooltip: "Show Password",
        passIcon: "fa-eye-slash"
      }),
      _useState9 = _slicedToArray(_useState8, 2),
      showConfirm = _useState9[0],
      setShowConfirm = _useState9[1];
    function _toggleInputType(input, setInput) {
      !input.isVisible ? setInput({
        isVisible: true,
        tooltip: "Hide Password",
        passIcon: "fa-eye"
      }) : setInput({
        isVisible: false,
        tooltip: "Show Password",
        passIcon: "fa-eye-slash"
      });
    }
    var disableSave = false;
    if (isSaving) {
      disableSave = true;
    }
    /**
     * Users can save settings without changing their password
     * Only compare the passwords if one of them is filled in
     */
    if (currentVals[PASS] || currentVals[MATCH]) {
      if (!(currentVals[PASS] && currentVals[MATCH])) {
        disableSave = true;
      }
      if (currentMeta[PASS] && currentMeta[MATCH]) {
        if (!(currentMeta[PASS].valid && currentMeta[MATCH].valid)) {
          disableSave = true;
        }
      }
    }
    return /*#__PURE__*/_react["default"].createElement(_reactAriaModal["default"], {
      onExit: onClose,
      title: "Account Settings",
      titleText: "Account Settings",
      dialogClass: "account-modal c-modal",
      underlayClickExits: false,
      verticallyCenter: true
    }, /*#__PURE__*/_react["default"].createElement(_ModalHeader["default"], {
      title: "Account Settings",
      allowFullScreen: false,
      onClose: onClose
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "c-modal__content c-modal__content--footer account-modal-content"
    }, /*#__PURE__*/_react["default"].createElement(_ProgressIndicator["default"], {
      isLoading: isSaving
    }), /*#__PURE__*/_react["default"].createElement("form", {
      id: "account-settings-form",
      action: ""
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: "account-info account-grouping"
    }, /*#__PURE__*/_react["default"].createElement("h3", null, "Account Info"), /*#__PURE__*/_react["default"].createElement(_index["default"].Input, {
      label: "First Name",
      name: FIRST,
      required: true,
      defaultValue: userInfo[FIRST],
      meta: currentMeta[FIRST],
      onChange: function onChange(val) {
        return onFieldChange(val, [FIRST]);
      }
    }), /*#__PURE__*/_react["default"].createElement(_index["default"].Input, {
      label: "Last Name",
      name: LAST,
      required: true,
      onChange: function onChange(val) {
        return onFieldChange(val, LAST);
      },
      defaultValue: userInfo[LAST],
      meta: currentMeta[LAST]
    })), /*#__PURE__*/_react["default"].createElement("section", {
      className: "password-section account-grouping"
    }, /*#__PURE__*/_react["default"].createElement("h3", null, "Change Password"), /*#__PURE__*/_react["default"].createElement("header", {
      className: "password-info"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, "Password must be a minimum of 8 characters, and include at least 3 of the following:"), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "password-rules"
    }, /*#__PURE__*/_react["default"].createElement("li", null, "At least one lowercase letter (a-z)"), /*#__PURE__*/_react["default"].createElement("li", null, "At least one capital letter (A-Z)"), /*#__PURE__*/_react["default"].createElement("li", null, "At least one numeric character (0-9)"), /*#__PURE__*/_react["default"].createElement("li", null, "Special characters (!@#$%^&*)"))), /*#__PURE__*/_react["default"].createElement(_index["default"].Input, {
      label: "Password",
      name: PASS,
      required: true,
      onChange: function onChange(val) {
        return onFieldChange(val, PASS);
      },
      type: showPass.isVisible ? TYPE_TEXT : TYPE_PASS,
      className: "password-input",
      placeholder: "Enter new password",
      autoComplete: "false",
      meta: currentMeta[PASS],
      post: /*#__PURE__*/_react["default"].createElement(_PasswordToggle["default"], {
        tooltip: showPass.tooltip,
        passIcon: showPass.passIcon,
        toggleInputType: function toggleInputType() {
          return _toggleInputType(showPass, setShowPass);
        }
      })
    }), /*#__PURE__*/_react["default"].createElement(_index["default"].Input, {
      label: "Confirm Password",
      name: MATCH,
      required: true,
      onChange: function onChange(val) {
        return onFieldChange(val, MATCH);
      },
      type: showConfirm.isVisible ? TYPE_TEXT : TYPE_PASS,
      className: "password-input",
      placeholder: "Enter matching password",
      autoComplete: "false",
      meta: currentMeta[MATCH],
      post: /*#__PURE__*/_react["default"].createElement(_PasswordToggle["default"], {
        tooltip: showConfirm.tooltip,
        passIcon: showConfirm.passIcon,
        toggleInputType: function toggleInputType() {
          return _toggleInputType(showConfirm, setShowConfirm);
        }
      })
    })))), /*#__PURE__*/_react["default"].createElement(_ModalFooter["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      theme: "default",
      onClick: onClose,
      className: "cypress-account-cancel account-cancel-button"
    }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      theme: "green",
      className: "cypress-account-save account-save-button",
      onClick: saveSettings,
      form: "account-settings-form",
      type: "submit",
      disabled: disableSave
    }, "Save Settings")));
  }
  var MIN_PASS_LENGTH = 8;
  AccountModal.displayName = "AccountModal";
  AccountModal.defaultProps = {
    isVisible: false,
    isSaving: false,
    userInfo: (_userInfo = {}, _defineProperty(_userInfo, LAST, ""), _defineProperty(_userInfo, FIRST, ""), _userInfo),
    onClose: _functions.noop,
    onSave: _functions.noop,
    /**
     * Password Validation currently conssists of the following:
     *
     * Password must be a minimum of 8 characters, and include at least 3 of the following:
     * 		At least one lowercase letter (a-z)
     * 		At least one capital letter (A-Z)
     * 		At least one numeric character (0-9)
     * 		Special characters (!@#$%^&*)
     *
     * 	It's easier to test for each individual segment as a series of regexes
     *
     */
    passwordValidation: function passwordValidation(val) {
      var totalPass = 0;
      if ((val === null || val === void 0 ? void 0 : val.length) < MIN_PASS_LENGTH) {
        return false;
      }
      if (/[a-z]/.test(val)) {
        totalPass += 1;
      }
      if (/[A-Z]/.test(val)) {
        totalPass += 1;
      }
      if (/[0-9]/.test(val)) {
        totalPass += 1;
      }
      if (/[!@#$%^&\*\(\)\ ]/.test(val)) {
        totalPass += 1;
      }

      //eslint-disable no-magic-numbers
      return totalPass >= 3;
    },
    nameValidation: function nameValidation(val, key) {
      return val && val.length < 300;
    }
  };
  AccountModal.propTypes = {
    /** Should the Modal be open or closed? */
    isVisible: _propTypes["default"].bool.isRequired,
    /** Is the modal currently saving?  Show Progress Indicator */
    isSaving: _propTypes["default"].bool,
    /** First & Last Name for Form Values */
    userInfo: _propTypes["default"].shape((_PropTypes$shape = {}, _defineProperty(_PropTypes$shape, LAST, _propTypes["default"].string.isRequired), _defineProperty(_PropTypes$shape, FIRST, _propTypes["default"].string.isRequired), _PropTypes$shape)),
    /** Function to call when modal is closed */
    onClose: _propTypes["default"].func.isRequired,
    /** Function to call when Save begins */
    onSave: _propTypes["default"].func.isRequired,
    /** Default Validation to apply for the Passwords */
    passwordValidation: _propTypes["default"].func,
    /** Default Validation to apply for the First & Last name fields */
    nameValidation: _propTypes["default"].func
  };
  var ACCOUNT_ACTIONS = {
    SAVE_ACCOUNT_AJAX: "SAVE_ACCOUNT_AJAX",
    SAVE_ACCOUNT_SUCCESS: "SAVE_ACCOUNT_SUCCESS",
    SAVE_ACCOUNT_ERROR: "SAVE_ACCOUNT_ERROR",
    SIGNOUT_USER_AJAX: "SIGNOUT_USER_AJAX",
    SIGNOUT_USER_SUCCESS: "SIGNOUT_USER_SUCCESS",
    SIGNOUT_USER_ERROR: "SIGNOUT_USER_ERROR"
  };
  exports.ACCOUNT_ACTIONS = ACCOUNT_ACTIONS;
  var INITIAL_ACCOUNT_STATE = {
    isSaving: false,
    hasError: false
  };
  exports.INITIAL_ACCOUNT_STATE = INITIAL_ACCOUNT_STATE;
  function saveAccountInfo(userInfo) {
    return function (dispatch) {
      var firstName = userInfo.firstName,
        lastName = userInfo.lastName,
        newPassword = userInfo.newPassword;
      return dispatch({
        type: ACCOUNT_ACTIONS.SAVE_ACCOUNT_AJAX,
        meta: {
          buildMessage: function buildMessage() {
            var respObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _ref2 = (respObj === null || respObj === void 0 ? void 0 : respObj.data) || {},
              _ref2$data = _ref2.data,
              data = _ref2$data === void 0 ? [] : _ref2$data,
              _ref2$name = _ref2.name,
              name = _ref2$name === void 0 ? "" : _ref2$name;
            var messagePayload = {
              id: Math.floor(Math.random() * _constants.MAX_GROWL)
            };
            if (respObj.status < 300) {
              return _objectSpread(_objectSpread({}, messagePayload), {}, {
                type: "success",
                message: "Successfully Updated User Info",
                messageHeader: "Success"
              });
            }
            return _objectSpread(_objectSpread({}, messagePayload), {}, {
              type: "error",
              messageHeader: name,
              message: data.map(function (msg) {
                return /*#__PURE__*/_react["default"].createElement("div", {
                  key: msg
                }, msg);
              })
            });
          }
        },
        /* adm/v1/ui/user does not ignore fields that are not part of its schema and will throw
        a 400 error so we need to de-structure userInfo and only pass through what is accepted */
        AJAX: {
          url: "ui/user",
          gateway: "adm",
          method: "put",
          data: {
            firstName: firstName,
            lastName: lastName,
            newPassword: newPassword
          },
          success: ACCOUNT_ACTIONS.SAVE_ACCOUNT_SUCCESS,
          error: ACCOUNT_ACTIONS.SAVE_ACCOUNT_ERROR
        }
      });
    };
  }
  function signoutUser() {
    return function (dispatch) {
      return dispatch({
        type: ACCOUNT_ACTIONS.SIGNOUT_USER_AJAX,
        AJAX: {
          url: "logout",
          gateway: false,
          version: 0,
          success: ACCOUNT_ACTIONS.SIGNOUT_USER_SUCCESS,
          error: ACCOUNT_ACTIONS.SIGNOUT_USER_ERROR
        }
      });
    };
  }
  function beginSaveSettings(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      account: {
        isSaving: true,
        hasError: false
      }
    });
  }
  function saveSettings(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      account: {
        isSaving: false,
        hasError: false
      }
    });
  }
  function saveSettingsError(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      account: {
        isSaving: false,
        hasError: true
      }
    });
  }
  var ACCOUNT_HANDLERS = (_ACCOUNT_HANDLERS = {}, _defineProperty(_ACCOUNT_HANDLERS, ACCOUNT_ACTIONS.SAVE_ACCOUNT_AJAX, beginSaveSettings), _defineProperty(_ACCOUNT_HANDLERS, ACCOUNT_ACTIONS.SAVE_ACCOUNT_SUCCESS, saveSettings), _defineProperty(_ACCOUNT_HANDLERS, ACCOUNT_ACTIONS.SAVE_ACCOUNT_ERROR, saveSettingsError), _ACCOUNT_HANDLERS);
  exports.ACCOUNT_HANDLERS = ACCOUNT_HANDLERS;
  var ACCOUNT_REDUX = {
    ACCOUNT_ACTIONS: ACCOUNT_ACTIONS,
    saveAccountInfo: saveAccountInfo,
    signoutUser: signoutUser,
    INITIAL_ACCOUNT_STATE: INITIAL_ACCOUNT_STATE,
    ACCOUNT_HANDLERS: ACCOUNT_HANDLERS
  };
  exports.ACCOUNT_REDUX = ACCOUNT_REDUX;

  /***/
}, /* 427 */
/***/function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(395);
  var createDesc = __webpack_require__(457);
  module.exports = __webpack_require__(396) ? function (object, key, value) {
    return dP.f(object, key, createDesc(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };

  /***/
}, /* 428 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(429);
  module.exports = function (it) {
    if (!isObject(it)) throw TypeError(it + ' is not an object!');
    return it;
  };

  /***/
}, /* 429 */
/***/function (module, exports) {
  module.exports = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };

  /***/
}, /* 430 */
/***/function (module, exports) {
  module.exports = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };

  /***/
}, /* 431 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(461);

  /***/
}, /* 432 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.INITIAL_CONFIRM_STATE = exports.CONFIRM_REDUX = exports.CONFIRM_HANDLERS = exports.CONFIRM_ACTIONS = void 0;
  exports.closeConfirm = closeConfirm;
  exports.closeConfirmAction = closeConfirmAction;
  exports["default"] = void 0;
  exports.openConfirm = openConfirm;
  exports.openConfirmAction = openConfirmAction;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _reactAriaModal = _interopRequireDefault(__webpack_require__(212));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _functions = __webpack_require__(33);
  var _ModalHeader = _interopRequireDefault(__webpack_require__(141));
  var _ModalFooter = _interopRequireDefault(__webpack_require__(142));
  var _Button = _interopRequireDefault(__webpack_require__(61));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _ProgressIndicator = _interopRequireDefault(__webpack_require__(242));
  var _CONFIRM_HANDLERS, _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var ConfirmModal = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    _inherits(ConfirmModal, _React$Component);
    var _super = _createSuper(ConfirmModal);
    function ConfirmModal() {
      var _this;
      _classCallCheck(this, ConfirmModal);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", {
        isWorking: false
      });
      return _this;
    }
    _createClass(ConfirmModal, [{
      key: "onCommit",
      value: function onCommit() {
        var me = this;
        me.setState({
          isWorking: true
        }, function () {
          me.props.onCommit().then(function (resp) {
            if (resp) {
              if (resp.success) {
                me.props.onClose();
              }
            }
            return resp;
          });
        });
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
          state = this.state,
          classes = _defineProperty({
            "c-modal": true,
            "u-modal-responsive": true
          }, props.className, true),
          $buttonTxt = props.commitLabel,
          loadingProps = {
            description: props.loadingDescription,
            isLoading: true
          },
          $loading = null,
          $desc = props.desc;
        if (state.isWorking) {
          $buttonTxt = [/*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            key: "icon",
            name: "generating",
            className: "circle-spin"
          }), /*#__PURE__*/_react["default"].createElement("span", {
            key: "label"
          }, props.commitLabel)];
          if (props.showLoading) {
            // if we have a loading description, make the loading background opaque to hide the modal description
            // just not rendering the modal description will change the height/width of the modal
            if (props.loadingDescription.length) {
              loadingProps.isOpaque = true;
            }
            $loading = /*#__PURE__*/_react["default"].createElement(_ProgressIndicator["default"], loadingProps);
          }
        }
        return /*#__PURE__*/_react["default"].createElement(_reactAriaModal["default"], _extends({
          onExit: props.onClose,
          title: props.title,
          titleText: props.title,
          dialogClass: (0, _classnames["default"])(classes),
          underlayClickExits: false,
          verticallyCenter: true
        }, props.modalOpts), /*#__PURE__*/_react["default"].createElement(_ModalHeader["default"], {
          title: props.title,
          xClose: !state.isWorking,
          onClose: props.onClose,
          allowFullScreen: false
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "c-modal__content c-modal__content--footer confirm-modal-content"
        }, $loading, $desc), /*#__PURE__*/_react["default"].createElement(_ModalFooter["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          theme: "default",
          onClick: props.onClose,
          disabled: state.isWorking
        }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          theme: props.commitTheme,
          onClick: this.onCommit,
          disabled: state.isWorking || props.isCommitDisabled
        }, $buttonTxt)));
      }
    }]);
    return ConfirmModal;
  }(_react["default"].Component), _defineProperty(_class2, "defaultProps", {
    modalOpts: {},
    title: "Delete Confirmation",
    desc: "Are you sure you want to delete this?",
    commitLabel: "Delete",
    commitTheme: "red",
    showLoading: false,
    loadingDescription: "",
    isCommitDisabled: false,
    onClose: _functions.noop,
    onCommit: _functions.noop //Must Return a Promise
  }), _defineProperty(_class2, "propTypes", {
    desc: _propTypes["default"].node.isRequired,
    modalOpts: _propTypes["default"].object,
    onClose: _propTypes["default"].func.isRequired,
    onCommit: _propTypes["default"].func.isRequired,
    isCommitDisabled: _propTypes["default"].bool
  }), _class2), _applyDecoratedDescriptor(_class.prototype, "onCommit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onCommit"), _class.prototype), _class);
  exports["default"] = ConfirmModal;
  /**
   * The Confirm Modal is meant to be used with a Redux Store
   * By declaring the Redux reducers and action creators here, we ensure that all Applications at FT use the same workflows
   *
   * The Redux store should be a single object of a valid set of Props for <ConfirmModal />
   *
   * All of the above must be pass in via the only prop to:
   * 		openConfirmAction()
   *
   *
   * We don't want to include Redux as a dependency of Rhombus
   * We don't want to assume the way reducers are created in Rhombus
   * 		Inside of the project that consumes and uses this ConfirmModal
   *
   * 		import createReducer from "./createReducer";
   * 		import { Confirm } from "rhombus-react";
   * 		export default createReducer(Confirm.INITIAL_CONFIRM_STATE, Confirm.CONFIRM_HANDLERS);
   *
   *
   * Inside of the main JS file the app uses to render everything
   * 	(The one which contains whatever routes the application needs)
   * 	(The first file connected to the Redux Store)
   *
   * Add the following:
   * 		in mapStateToProps()
   * 			return {
   * 				...
   * 				showConfirm: state.confirm.isOpen || false,
   * 				confirmProps:state.confirm
   * 			}
   *
   * 		in mapDispatchToProps()
   * 			return {
   * 				...
   * 						onCloseConfirm(){ return dispatch(Confirm.closeConfirmAction()); },
   * 			}
   *
   * 		In the class:
   * 				_renderConfirm(){
   * 					var { props } = this;
   *
   * 					if(!props.showConfirm){ return null; }
   *
   * 					return <Confirm.ConfirmModal {...props.confirmProps} onClose={props.onCloseConfirm} />;
   * 				}
   *
   * 		In the render:
   * 			{this._renderConfirm()}
   *
   *
   * For full examples of how this is used, please see:
   * 		CMApp.js in activate/campaign-manager-ui
   * 		DTree.js in activate/d-tree-ui
   *
   */
  var CONFIRM_ACTIONS = {
    OPEN_CONFIRM_MODAL: "OPEN_CONFIRM_MODAL",
    CLOSE_CONFIRM_MODAL: "CLOSE_CONFIRM_MODAL"
  };
  exports.CONFIRM_ACTIONS = CONFIRM_ACTIONS;
  var INITIAL_CONFIRM_STATE = {
    isOpen: false
  };
  exports.INITIAL_CONFIRM_STATE = INITIAL_CONFIRM_STATE;
  function openConfirmAction(confirmProps) {
    return function (dispatch) {
      return dispatch({
        type: CONFIRM_ACTIONS.OPEN_CONFIRM_MODAL,
        payload: confirmProps
      });
    };
  }
  function closeConfirmAction() {
    return function (dispatch) {
      return dispatch({
        type: CONFIRM_ACTIONS.CLOSE_CONFIRM_MODAL
      });
    };
  }
  function openConfirm(state, action) {
    return _objectSpread(_objectSpread({}, action.payload), {}, {
      isOpen: true
    });
  }
  function closeConfirm(state, action) {
    return {
      isOpen: false
    };
  }
  var CONFIRM_HANDLERS = (_CONFIRM_HANDLERS = {}, _defineProperty(_CONFIRM_HANDLERS, CONFIRM_ACTIONS.OPEN_CONFIRM_MODAL, openConfirm), _defineProperty(_CONFIRM_HANDLERS, CONFIRM_ACTIONS.CLOSE_CONFIRM_MODAL, closeConfirm), _CONFIRM_HANDLERS);
  exports.CONFIRM_HANDLERS = CONFIRM_HANDLERS;
  var CONFIRM_REDUX = {
    CONFIRM_ACTIONS: CONFIRM_ACTIONS,
    openConfirmAction: openConfirmAction,
    openConfirm: openConfirm,
    closeConfirmAction: closeConfirmAction,
    closeConfirm: closeConfirm,
    INITIAL_CONFIRM_STATE: INITIAL_CONFIRM_STATE,
    CONFIRM_HANDLERS: CONFIRM_HANDLERS
  };
  exports.CONFIRM_REDUX = CONFIRM_REDUX;

  /***/
}, /* 433 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FacebookImage;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _VerticalContent = _interopRequireDefault(__webpack_require__(246));
  var _StandardContent = _interopRequireDefault(__webpack_require__(247));
  var _socialHelpers = __webpack_require__(46);
  var _ReelsVertical = _interopRequireDefault(__webpack_require__(373));
  var _ReelsSquare = _interopRequireDefault(__webpack_require__(374));
  var _ReelsHorizontal = _interopRequireDefault(__webpack_require__(375));
  var _FeedsVertical = _interopRequireDefault(__webpack_require__(376));
  var _FeedsSquare = _interopRequireDefault(__webpack_require__(377));
  var _FeedsHorizontal = _interopRequireDefault(__webpack_require__(378));
  var _StoriesVertical = _interopRequireDefault(__webpack_require__(379));
  var _StoriesSquare = _interopRequireDefault(__webpack_require__(380));
  var _StoriesHorizontal = _interopRequireDefault(__webpack_require__(381));
  var _InstagramReelsVertical = _interopRequireDefault(__webpack_require__(382));
  var _InstagramFeedsVertical = _interopRequireDefault(__webpack_require__(383));
  var _InstagramStoriesVertical = _interopRequireDefault(__webpack_require__(384));
  var _InstagramReelsSquare = _interopRequireDefault(__webpack_require__(385));
  var _InstagramFeedsSquare = _interopRequireDefault(__webpack_require__(386));
  var _InstagramStoriesSquare = _interopRequireDefault(__webpack_require__(387));
  var _InstagramReelsHorizontal = _interopRequireDefault(__webpack_require__(388));
  var _InstagramFeedsHorizontal = _interopRequireDefault(__webpack_require__(389));
  var _InstagramStoriesHorizontal = _interopRequireDefault(__webpack_require__(390));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function Reels(props) {
    var partner = props.partner,
      aspectRatio = props.aspectRatio;
    if (/square/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramReelsSquare["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_ReelsSquare["default"], props);
    }
    if (/horizontal/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramReelsHorizontal["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_ReelsHorizontal["default"], props);
    }
    if (/instagram/i.test(partner)) {
      return /*#__PURE__*/_react["default"].createElement(_InstagramReelsVertical["default"], props);
    }
    return /*#__PURE__*/_react["default"].createElement(_ReelsVertical["default"], props);
  }
  function Feeds(props) {
    var partner = props.partner,
      aspectRatio = props.aspectRatio;
    if (/square/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramFeedsSquare["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_FeedsSquare["default"], props);
    }
    if (/horizontal/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramFeedsHorizontal["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_FeedsHorizontal["default"], props);
    }
    if (/instagram/i.test(partner)) {
      return /*#__PURE__*/_react["default"].createElement(_InstagramFeedsVertical["default"], props);
    }
    return /*#__PURE__*/_react["default"].createElement(_FeedsVertical["default"], props);
  }
  function Stories(props) {
    var partner = props.partner,
      aspectRatio = props.aspectRatio;
    if (/square/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramStoriesSquare["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_StoriesSquare["default"], props);
    }
    if (/horizontal/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramStoriesHorizontal["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_StoriesHorizontal["default"], props);
    }
    if (/instagram/i.test(partner)) {
      return /*#__PURE__*/_react["default"].createElement(_InstagramStoriesVertical["default"], props);
    }
    return /*#__PURE__*/_react["default"].createElement(_StoriesVertical["default"], props);
  }
  function FacebookImage(props) {
    var socialValues = props.socialValues,
      placementType = props.placementType,
      adType = props.adType,
      placementInfo = props.placementInfo,
      fbPreviewVersion = props.fbPreviewVersion,
      placement = props.placement,
      cta = socialValues.cta,
      placementAssetCustomizationType = socialValues.placementAssetCustomizationType;
    if (fbPreviewVersion && fbPreviewVersion > 1) {
      if (/reel|reels/i.test(placement)) {
        return /*#__PURE__*/_react["default"].createElement(Reels, props);
      } else if (/feed|feeds/i.test(placement)) {
        return /*#__PURE__*/_react["default"].createElement(Feeds, props);
      } else if (/story|stories/i.test(placement)) {
        return /*#__PURE__*/_react["default"].createElement(Stories, props);
      }
    }
    if (!placementType || placementType === _socialHelpers.FT_ASPECT_RATIOS.DEFAULT || placementAssetCustomizationType === "none") {
      return /*#__PURE__*/_react["default"].createElement(_StandardContent["default"], _extends({}, socialValues, {
        adType: adType
      }));
    } else if (placementInfo && (placementType === _socialHelpers.FT_ASPECT_RATIOS.VERTICAL || placementType === _socialHelpers.FT_ASPECT_RATIOS.REEL)) {
      return /*#__PURE__*/_react["default"].createElement(_VerticalContent["default"], _extends({}, socialValues, {
        image: placementInfo.image,
        placementType: placementType,
        adType: adType
      }));
    }
    var standardContentProps = socialValues;
    if (placementInfo) {
      standardContentProps = _objectSpread({
        cta: cta
      }, placementInfo);
    }
    return /*#__PURE__*/_react["default"].createElement(_StandardContent["default"], _extends({}, standardContentProps, {
      adType: adType
    }));
  }
  FacebookImage.displayName = "FacebookImage";
  FacebookImage.defaultProps = {
    socialValues: {},
    placementType: _socialHelpers.FT_ASPECT_RATIOS.DEFAULT,
    facebookPlacementType: null,
    fbPreviewVersion: 1,
    placement: "vertical"
  };
  FacebookImage.propTypes = {
    socialValues: _propTypes["default"].object
  };

  /***/
}, /* 434 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FacebookVideo;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _VerticalContent = _interopRequireDefault(__webpack_require__(246));
  var _StandardContent = _interopRequireDefault(__webpack_require__(247));
  var _socialHelpers = __webpack_require__(46);
  var _ReelsVertical = _interopRequireDefault(__webpack_require__(373));
  var _ReelsSquare = _interopRequireDefault(__webpack_require__(374));
  var _ReelsHorizontal = _interopRequireDefault(__webpack_require__(375));
  var _FeedsVertical = _interopRequireDefault(__webpack_require__(376));
  var _FeedsSquare = _interopRequireDefault(__webpack_require__(377));
  var _FeedsHorizontal = _interopRequireDefault(__webpack_require__(378));
  var _StoriesVertical = _interopRequireDefault(__webpack_require__(379));
  var _StoriesSquare = _interopRequireDefault(__webpack_require__(380));
  var _StoriesHorizontal = _interopRequireDefault(__webpack_require__(381));
  var _InstagramReelsVertical = _interopRequireDefault(__webpack_require__(382));
  var _InstagramFeedsVertical = _interopRequireDefault(__webpack_require__(383));
  var _InstagramStoriesVertical = _interopRequireDefault(__webpack_require__(384));
  var _InstagramReelsSquare = _interopRequireDefault(__webpack_require__(385));
  var _InstagramFeedsSquare = _interopRequireDefault(__webpack_require__(386));
  var _InstagramStoriesSquare = _interopRequireDefault(__webpack_require__(387));
  var _InstagramReelsHorizontal = _interopRequireDefault(__webpack_require__(388));
  var _InstagramFeedsHorizontal = _interopRequireDefault(__webpack_require__(389));
  var _InstagramStoriesHorizontal = _interopRequireDefault(__webpack_require__(390));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function Reels(props) {
    var partner = props.partner,
      aspectRatio = props.aspectRatio;
    if (/square/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramReelsSquare["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_ReelsSquare["default"], props);
    }
    if (/horizontal/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramReelsHorizontal["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_ReelsHorizontal["default"], props);
    }
    if (/instagram/i.test(partner)) {
      return /*#__PURE__*/_react["default"].createElement(_InstagramReelsVertical["default"], props);
    }
    return /*#__PURE__*/_react["default"].createElement(_ReelsVertical["default"], props);
  }
  function Feeds(props) {
    var partner = props.partner,
      aspectRatio = props.aspectRatio;
    if (/square/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramFeedsSquare["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_FeedsSquare["default"], props);
    }
    if (/horizontal/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramFeedsHorizontal["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_FeedsHorizontal["default"], props);
    }
    if (/instagram/i.test(partner)) {
      return /*#__PURE__*/_react["default"].createElement(_InstagramFeedsVertical["default"], props);
    }
    return /*#__PURE__*/_react["default"].createElement(_FeedsVertical["default"], props);
  }
  function Stories(props) {
    var partner = props.partner,
      aspectRatio = props.aspectRatio;
    if (/square/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramStoriesSquare["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_StoriesSquare["default"], props);
    }
    if (/horizontal/i.test(aspectRatio)) {
      if (/instagram/i.test(partner)) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramStoriesHorizontal["default"], props);
      }
      return /*#__PURE__*/_react["default"].createElement(_StoriesHorizontal["default"], props);
    }
    if (/instagram/i.test(partner)) {
      return /*#__PURE__*/_react["default"].createElement(_InstagramStoriesVertical["default"], props);
    }
    return /*#__PURE__*/_react["default"].createElement(_StoriesVertical["default"], props);
  }
  function FacebookVideo(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted,
      adType = props.adType,
      placementType = props.placementType,
      placementInfo = props.placementInfo,
      fbPreviewVersion = props.fbPreviewVersion,
      placement = props.placement;
    var placementAssetCustomizationType = socialValues.placementAssetCustomizationType,
      cta = socialValues.cta,
      video = socialValues.video;
    var baseVideoProps = {
      autoPlay: autoPlay,
      muted: muted,
      controls: controls
    };
    if (fbPreviewVersion > 1) {
      if (/reel|reels/i.test(placement)) {
        return /*#__PURE__*/_react["default"].createElement(Reels, props);
      } else if (/feed|feeds/i.test(placement)) {
        return /*#__PURE__*/_react["default"].createElement(Feeds, props);
      } else if (/story|stories/i.test(placement)) {
        return /*#__PURE__*/_react["default"].createElement(Stories, props);
      }
    }
    if (!placementType || placementType === _socialHelpers.FT_ASPECT_RATIOS.DEFAULT || placementAssetCustomizationType === "none") {
      var _standardScaledVideoProps = _objectSpread(_objectSpread({}, baseVideoProps), {}, {
        width: _socialHelpers.FACEBOOK_WIDTH,
        video: video
      });
      return /*#__PURE__*/_react["default"].createElement(_StandardContent["default"], _extends({}, socialValues, {
        video: _standardScaledVideoProps,
        adType: adType
      }));
    } else if (placementInfo && (placementType === _socialHelpers.FT_ASPECT_RATIOS.VERTICAL || placementType === _socialHelpers.FT_ASPECT_RATIOS.REEL)) {
      //!TEMPORARY how are we determining reels? what are the adtype and placementType?
      var verticalScaledVideoProps = _objectSpread(_objectSpread({}, baseVideoProps), {}, {
        width: _socialHelpers.FACEBOOK_WIDTH_VERTICAL,
        video: (placementInfo === null || placementInfo === void 0 ? void 0 : placementInfo.video) || {}
      });
      return /*#__PURE__*/_react["default"].createElement(_VerticalContent["default"], _extends({}, socialValues, {
        placementInfo: placementInfo,
        placementType: placementType,
        video: verticalScaledVideoProps,
        adType: adType
      }));
    }
    var standardContentProps = socialValues;
    var standardScaledVideoProps = _objectSpread(_objectSpread({}, baseVideoProps), {}, {
      width: _socialHelpers.FACEBOOK_WIDTH,
      video: (placementInfo === null || placementInfo === void 0 ? void 0 : placementInfo.video) || video
    });
    if (placementInfo) {
      standardContentProps = _objectSpread({
        cta: cta
      }, placementInfo);
    }
    return /*#__PURE__*/_react["default"].createElement(_StandardContent["default"], _extends({}, standardContentProps, {
      video: standardScaledVideoProps,
      adType: adType
    }));
  }
  FacebookVideo.displayName = "FacebookVideo";
  FacebookVideo.defaultProps = {
    socialValues: {},
    autoPlay: false,
    controls: true,
    placementType: _socialHelpers.FT_ASPECT_RATIOS.DEFAULT,
    placement: "vertical",
    facebookPlacementType: null,
    fbPreviewVersion: 1
  };
  FacebookVideo.propTypes = {
    socialValues: _propTypes["default"].object,
    autoPlay: _propTypes["default"].bool
  };

  /***/
}, /* 435 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = LinkedInImage;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function LinkedInImage(props) {
    var socialValues = props.socialValues,
      headline = socialValues.headline,
      intro = socialValues.intro,
      image = socialValues.image,
      landingPage = socialValues.landingPage,
      adStudioIframe = socialValues.adStudioIframe,
      _ref = image || {},
      src = _ref.src,
      name = _ref.name;
    var imageComponent = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], null);
    if (src) {
      imageComponent = /*#__PURE__*/_react["default"].createElement("img", {
        src: src,
        alt: name || '[Missing Image Name]'
      });
    }
    if (adStudioIframe) {
      imageComponent = adStudioIframe;
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      className: "linkedin-preview border"
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: "linkedin-main-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "header-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "upper"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "square w-32 h-32 item1"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "right-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-150 h-10 item2"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-100 h-10 item3"
    }))), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "article-text"
    }, intro || '[Missing Intro]')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "linkedin-media-container"
    }, imageComponent), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "link-container"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: "headline"
    }, headline || '[Missing Headline]'), /*#__PURE__*/_react["default"].createElement("span", {
      className: "landing-page"
    }, landingPage || '[Missing Landing Page]'))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-2"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-3"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-4"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "reactions"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "react"
    }, "Be the first to react")))));
  }
  LinkedInImage.displayName = "LinkedInImage";
  LinkedInImage.defaultProps = {
    socialValues: {}
  };
  LinkedInImage.propTypes = {
    socialValues: _propTypes["default"].shape({
      headline: _propTypes["default"].string,
      landingPage: _propTypes["default"].string,
      cta: _propTypes["default"].string,
      intro: _propTypes["default"].string,
      image: _propTypes["default"].object,
      video: _propTypes["default"].object
    })
  };

  /***/
}, /* 436 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = LinkedInVideo;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function LinkedInVideo(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted,
      headline = socialValues.headline,
      intro = socialValues.intro,
      video = socialValues.video,
      cta = socialValues.cta,
      landingPage = socialValues.landingPage,
      adStudioIframe = socialValues.adStudioIframe,
      _ref = video || {},
      src = _ref.src,
      isMuted = muted;
    var videoContent = _MissingMedia["default"];
    if (src) {
      //video src
      if (typeof muted !== 'boolean') {
        isMuted = autoPlay;
      }
      videoContent = /*#__PURE__*/_react["default"].createElement("video", {
        controls: controls,
        autoPlay: autoPlay,
        muted: isMuted,
        className: "".concat(!src ? 'linkedin-missing-video' : '')
      }, /*#__PURE__*/_react["default"].createElement("source", {
        src: src
      }));
    }
    if (adStudioIframe) {
      videoContent = adStudioIframe;
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      className: "linkedin-preview border"
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: "linkedin-main-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "header-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "upper"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "square w-32 h-32 item1"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "right-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-150 h-10 item2"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-100 h-10 item3"
    }))), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "article-text"
    }, intro || '[Missing Intro]')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "linkedin-media-container"
    }, videoContent), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "link-container"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: "headline"
    }, headline || '[Missing Headline]'), /*#__PURE__*/_react["default"].createElement("span", {
      className: "landing-page"
    }, landingPage || '[Missing Landing Page]')), /*#__PURE__*/_react["default"].createElement("span", {
      className: "learn-more"
    }, cta || '[Missing CTA]')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-2"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-3"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-4"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "reactions"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "react"
    }, "Be the first to react")))));
  }
  LinkedInVideo.displayName = "LinkedInVideo";
  LinkedInVideo.defaultProps = {
    socialValues: {},
    autoPlay: false,
    controls: true
  };
  LinkedInVideo.propTypes = {
    autoPlay: _propTypes["default"].bool,
    socialValues: _propTypes["default"].shape({
      headline: _propTypes["default"].string,
      landingPage: _propTypes["default"].string,
      cta: _propTypes["default"].string,
      intro: _propTypes["default"].string,
      image: _propTypes["default"].object,
      video: _propTypes["default"].object
    })
  };

  /***/
}, /* 437 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = PinterestImage;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function PinterestImage(props) {
    var socialValues = props.socialValues,
      image = socialValues.image,
      landingPage = socialValues.landingPage,
      title = socialValues.title,
      adStudioIframe = socialValues.adStudioIframe,
      _ref = image || {},
      src = _ref.src,
      name = _ref.name;
    var media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], null);
    if (src) {
      media = /*#__PURE__*/_react["default"].createElement("img", {
        src: src,
        alt: name
      });
    }
    if (adStudioIframe) {
      media = adStudioIframe;
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      className: "pinterest-preview"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "pinterest-main-content"
    }, media, /*#__PURE__*/_react["default"].createElement("span", {
      className: "save"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, "Save")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action-container"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "landing-page"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, landingPage || '[Missing Landing Page]')), /*#__PURE__*/_react["default"].createElement("span", {
      className: "download circle w-32 h-32"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-content"
    }, title && /*#__PURE__*/_react["default"].createElement("p", {
      className: "title"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "shape-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-32 h-32"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "shape-grid"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-130 h-10"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-100 h-10"
    })), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h"
    })))));
  }
  PinterestImage.displayName = "PinterestImage";
  PinterestImage.defaultProps = {
    socialValues: {}
  };
  PinterestImage.propTypes = {
    socialValues: _propTypes["default"].shape({
      image: _propTypes["default"].object,
      title: _propTypes["default"].string,
      landingPage: _propTypes["default"].string
    })
  };

  /***/
}, /* 438 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = PinterestVideo;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function PinterestVideo(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted,
      video = socialValues.video,
      landingPage = socialValues.landingPage,
      title = socialValues.title,
      _ref = video || {},
      src = _ref.src,
      isMuted = muted;
    var videoComponent = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
      message: "Missing Video"
    });
    if (typeof muted !== 'boolean') {
      isMuted = autoPlay;
    }
    if (src) {
      videoComponent = /*#__PURE__*/_react["default"].createElement("video", {
        autoPlay: autoPlay,
        muted: isMuted,
        controls: controls
      }, /*#__PURE__*/_react["default"].createElement("source", {
        src: src
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      className: "pinterest-preview"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "pinterest-main-content"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "save"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, "Save")), videoComponent, /*#__PURE__*/_react["default"].createElement("div", {
      className: "action-container"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "landing-page"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, landingPage || '[Missing Landing Page]')), /*#__PURE__*/_react["default"].createElement("span", {
      className: "download circle w-32 h-32"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-content"
    }, title && /*#__PURE__*/_react["default"].createElement("p", {
      className: "title"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "shape-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-32 h-32"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "shape-grid"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-130 h-10"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-100 h-10"
    })), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h"
    })))));
  }
  PinterestVideo.displayName = "PinterestVideo";
  PinterestVideo.defaultProps = {
    socialValues: {},
    autoPlay: false,
    controls: true
  };
  PinterestVideo.propTypes = {
    autoPlay: _propTypes["default"].bool,
    socialValues: _propTypes["default"].shape({
      video: _propTypes["default"].object,
      landingPage: _propTypes["default"].string,
      title: _propTypes["default"].string
    })
  };

  /***/
}, /* 439 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = SnapchatImage;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function SnapchatImage(props) {
    var socialValues = props.socialValues,
      headline = socialValues.headline,
      brandName = socialValues.brandName,
      cta = socialValues.cta,
      image = socialValues.image,
      adStudioIframe = socialValues.adStudioIframe,
      _ref = image || {},
      src = _ref.src,
      name = _ref.name;
    var $media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], null);
    if (src) {
      $media = /*#__PURE__*/_react["default"].createElement("img", {
        src: src,
        alt: name
      });
    }
    if (adStudioIframe) {
      $media = adStudioIframe;
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      "aria-label": name,
      className: "snapchat-preview border"
    }, $media, /*#__PURE__*/_react["default"].createElement("section", {
      className: "snapchat-main-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "snapchat-header"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "brand-name shadow"
    }, brandName || '[Missing Brand Name]'), /*#__PURE__*/_react["default"].createElement("p", {
      className: "headline shadow"
    }, headline || '[Missing Headline]')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "snapchat-footer"
    }, cta && /*#__PURE__*/_react["default"].createElement("div", {
      className: "ad-cta"
    }, /*#__PURE__*/_react["default"].createElement("span", null, cta)), /*#__PURE__*/_react["default"].createElement("p", {
      className: "footnote shadow"
    }, "Ad"))));
  }
  SnapchatImage.displayName = "SnapchatImage";
  SnapchatImage.defaultProps = {
    socialValues: {}
  };
  SnapchatImage.propTypes = {
    socialValues: _propTypes["default"].shape({
      brandName: _propTypes["default"].string,
      headline: _propTypes["default"].string,
      landingPage: _propTypes["default"].string,
      image: _propTypes["default"].object,
      video: _propTypes["default"].object
    })
  };

  /***/
}, /* 440 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = SnapchatVideo;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function SnapchatVideo(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted,
      headline = socialValues.headline,
      brandName = socialValues.brandName,
      cta = socialValues.cta,
      video = socialValues.video,
      adStudioIframe = socialValues.adStudioIframe,
      _ref = video || {},
      src = _ref.src,
      name = _ref.name,
      isMuted = muted;
    var videoComponent = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
      message: "Missing Video"
    });
    if (typeof muted !== 'boolean') {
      isMuted = autoPlay;
    }
    if (src) {
      videoComponent = /*#__PURE__*/_react["default"].createElement("video", {
        autoPlay: autoPlay,
        muted: isMuted,
        controls: controls
      }, /*#__PURE__*/_react["default"].createElement("source", {
        src: src
      }));
    }
    if (adStudioIframe) {
      videoComponent = adStudioIframe;
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      className: "is-video snapchat-preview border"
    }, videoComponent, /*#__PURE__*/_react["default"].createElement("section", {
      className: "snapchat-main-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "snapchat-header"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "brand-name shadow"
    }, brandName || '[Missing Brand Name]'), /*#__PURE__*/_react["default"].createElement("p", {
      className: "headline shadow"
    }, headline || '[Missing Headline]')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "snapchat-footer"
    }, cta && /*#__PURE__*/_react["default"].createElement("div", {
      className: "ad-cta"
    }, /*#__PURE__*/_react["default"].createElement("span", null, cta)), /*#__PURE__*/_react["default"].createElement("p", {
      className: "footnote shadow"
    }, "Ad"))));
  }
  SnapchatVideo.displayName = "SnapchatVideo";
  SnapchatVideo.defaultProps = {
    socialValues: {},
    autoPlay: false,
    controls: true
  };
  SnapchatVideo.propTypes = {
    autoPlay: _propTypes["default"].bool,
    socialValues: _propTypes["default"].shape({
      brandName: _propTypes["default"].string,
      headline: _propTypes["default"].string,
      landingPage: _propTypes["default"].string,
      image: _propTypes["default"].object,
      video: _propTypes["default"].object
    })
  };

  /***/
}, /* 441 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = TwitterImage;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function TwitterImage(props) {
    var socialValues = props.socialValues,
      tweet = socialValues.tweet,
      headline = socialValues.headline,
      landingPage = socialValues.landingPage,
      image = socialValues.image,
      _ref = image || {},
      src = _ref.src,
      name = _ref.name;
    var imageComponent = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], null);
    if (src) {
      imageComponent = /*#__PURE__*/_react["default"].createElement("img", {
        src: src,
        alt: name || '[Missing Image Name]'
      });
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      className: "twitter-preview"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-50 h-50"
    }), /*#__PURE__*/_react["default"].createElement("section", {
      className: "twitter-main-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "twitter-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-container"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-150 h-10"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "header-text"
    }, tweet || '[Missing Tweet]'))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-container border"
    }, imageComponent, /*#__PURE__*/_react["default"].createElement("div", {
      className: "link-container"
    }, /*#__PURE__*/_react["default"].createElement("p", null, headline || '[Missing Headline]'), /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(landingPage ? 'link' : '')
    }, landingPage || '[Missing Landing Page]'))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-action-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "action"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-30 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-30 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-30 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    })))));
  }
  TwitterImage.displayName = "TwitterImage";
  TwitterImage.defaultProps = {
    socialValues: {}
  };
  TwitterImage.propTypes = {
    socialValues: _propTypes["default"].shape({
      tweet: _propTypes["default"].string,
      headline: _propTypes["default"].string,
      landingPage: _propTypes["default"].string,
      image: _propTypes["default"].object,
      video: _propTypes["default"].object
    })
  };

  /***/
}, /* 442 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = TwitterVideo;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function TwitterVideo(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted,
      tweet = socialValues.tweet,
      headline = socialValues.headline,
      landingPage = socialValues.landingPage,
      video = socialValues.video,
      _ref = video || {},
      src = _ref.src,
      isMuted = muted;
    if (typeof muted !== 'boolean') {
      isMuted = autoPlay;
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      className: "twitter-preview"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-50 h-50"
    }), /*#__PURE__*/_react["default"].createElement("section", {
      className: "twitter-main-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "twitter-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-container"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-150 h-10"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "header-text"
    }, tweet || '[Missing Tweet]'))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-container border"
    }, /*#__PURE__*/_react["default"].createElement("video", {
      autoPlay: autoPlay,
      muted: isMuted,
      controls: controls,
      className: "".concat(!src ? 'twitter-missing-video' : '')
    }, /*#__PURE__*/_react["default"].createElement("source", {
      src: src
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "link-container"
    }, /*#__PURE__*/_react["default"].createElement("p", null, headline || '[Missing Headline]'), /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(landingPage ? 'link' : '')
    }, landingPage || '[Missing Landing Page]'))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-action-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "action"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-30 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-30 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-30 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    })))));
  }
  TwitterVideo.displayName = "TwitterVideo";
  TwitterVideo.defaultProps = {
    socialValues: {},
    autoPlay: false,
    controls: true
  };
  TwitterVideo.propTypes = {
    autoPlay: _propTypes["default"].bool,
    socialValues: _propTypes["default"].shape({
      tweet: _propTypes["default"].string,
      headline: _propTypes["default"].string,
      landingPage: _propTypes["default"].string,
      image: _propTypes["default"].object,
      video: _propTypes["default"].object
    })
  };

  /***/
}, /* 443 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = YouTubeDiscovery;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function YouTubeDiscoveryAdBox(_ref) {
    var socialValues = _ref.socialValues;
    var thumbnail = socialValues.thumbnail,
      headline = socialValues.headline,
      description1 = socialValues.description1,
      description2 = socialValues.description2;
    var imgComponent = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
      message: "Missing Thumbnail"
    });
    if (thumbnail && thumbnail.src) {
      imgComponent = /*#__PURE__*/_react["default"].createElement("img", {
        src: thumbnail.src,
        alt: thumbnail.name || ''
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "ad-preview"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "card-label"
    }, "Discovery"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "image-container"
    }, imgComponent), /*#__PURE__*/_react["default"].createElement("div", {
      className: "context"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "headline"
    }, headline || '[Missing Headline]'), /*#__PURE__*/_react["default"].createElement("div", {
      className: "account"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "ad"
    }, "Ad"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle h-18 w-150"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "description-1"
    }, description1 || '[Missing Description 1]'), /*#__PURE__*/_react["default"].createElement("div", {
      className: "description-2"
    }, description2 || '[Missing Description 2]'))));
  }
  function YouTubeDiscovery(_ref2) {
    var autoPlay = _ref2.autoPlay,
      socialValues = _ref2.socialValues,
      controls = _ref2.controls,
      muted = _ref2.muted;
    var thumbnail = socialValues.thumbnail,
      headline = socialValues.headline,
      description1 = socialValues.description1,
      description2 = socialValues.description2;
    var video = socialValues.video || {};
    var src = video.src || '';
    var isMuted = muted;
    if (typeof muted !== 'boolean') {
      isMuted = autoPlay;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "youtube youtube-discovery"
    }, /*#__PURE__*/_react["default"].createElement(YouTubeDiscoveryAdBox, {
      socialValues: {
        thumbnail: thumbnail,
        headline: headline,
        description1: description1,
        description2: description2
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "video-preview"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "video-label"
    }, "Video"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "youtube-video-wrapper"
    }, /*#__PURE__*/_react["default"].createElement("video", {
      controls: controls,
      autoPlay: autoPlay,
      muted: isMuted
    }, /*#__PURE__*/_react["default"].createElement("source", {
      src: src
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "video-title"
    }, headline || '[Missing Headline]')));
  }
  YouTubeDiscovery.displayName = "YouTubeDiscovery";
  YouTubeDiscovery.defaultProps = {
    socialValues: {},
    autoPlay: false,
    controls: true
  };
  YouTubeDiscovery.propTypes = {
    socialValues: _propTypes["default"].object,
    autoPlay: _propTypes["default"].bool
  };

  /***/
}, /* 444 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = YouTubeInStream;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function YouTubeInStream(_ref) {
    var autoPlay = _ref.autoPlay,
      socialValues = _ref.socialValues,
      controls = _ref.controls,
      muted = _ref.muted;
    var video = socialValues.video,
      thumbnail = socialValues.thumbnail,
      src = (video === null || video === void 0 ? void 0 : video.src) || '',
      isMuted = muted;
    if (typeof muted !== 'boolean') {
      isMuted = autoPlay;
    }
    var thumbnailImg = /*#__PURE__*/_react["default"].createElement("div", {
      className: "missing-thumbnail"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "far fa-image-polaroid"
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: "no-thumbnail"
    }, "No Thumbnail")));
    if (socialValues !== null && socialValues !== void 0 && socialValues.thumbnail) {
      thumbnailImg = /*#__PURE__*/_react["default"].createElement("img", {
        className: "youtube-instream thumbnail-image",
        src: thumbnail.src,
        alt: thumbnail.src
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "youtube-instream-container"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "thumbnail-message"
    }, "Thumbnail"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "thumbnail-container"
    }, thumbnailImg), /*#__PURE__*/_react["default"].createElement("p", {
      className: "video-message"
    }, "Video"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "youtube youtube-instream"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "youtube-video-wrapper"
    }, /*#__PURE__*/_react["default"].createElement("video", {
      controls: controls,
      autoPlay: autoPlay,
      muted: isMuted
    }, /*#__PURE__*/_react["default"].createElement("source", {
      src: src
    })))));
  }
  YouTubeInStream.displayName = "YouTubeInStream";
  YouTubeInStream.defaultProps = {
    socialValues: {},
    autoPlay: false,
    controls: true
  };
  YouTubeInStream.propTypes = {
    socialValues: _propTypes["default"].object,
    autoPlay: _propTypes["default"].bool
  };

  /***/
}, /* 445 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = PreviewError;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function PreviewError(_ref) {
    var icon = _ref.icon,
      message = _ref.message;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "preview-error"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: icon
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "error-message"
    }, message));
  }
  PreviewError.displayName = "PreviewError";
  PreviewError.defaultProps = {
    message: "Oops, something went wrong with this preview",
    icon: "far fa-frown"
  };
  PreviewError.propTypes = {
    message: _propTypes["default"].string,
    icon: _propTypes["default"].string
  };

  /***/
}, /* 446 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var _from = __webpack_require__(595);
  var _from2 = _interopRequireDefault(_from);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.default = function (arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return (0, _from2.default)(arr);
    }
  };

  /***/
}, /* 447 */
/***/function (module, exports, __webpack_require__) {
  !function (e, t) {
    true ? module.exports = t(__webpack_require__(1)) : undefined;
  }(this, e => (() => {
    var t = {
        703: (e, t, a) => {
          "use strict";

          var r = a(414);
          function n() {}
          function i() {}
          i.resetWarningCache = n, e.exports = function () {
            function e(e, t, a, n, i, o) {
              if (o !== r) {
                var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw s.name = "Invariant Violation", s;
              }
            }
            function t() {
              return e;
            }
            e.isRequired = e;
            var a = {
              array: e,
              bigint: e,
              bool: e,
              func: e,
              number: e,
              object: e,
              string: e,
              symbol: e,
              any: e,
              arrayOf: t,
              element: e,
              elementType: e,
              instanceOf: t,
              node: e,
              objectOf: t,
              oneOf: t,
              oneOfType: t,
              shape: t,
              exact: t,
              checkPropTypes: i,
              resetWarningCache: n
            };
            return a.PropTypes = a, a;
          };
        },
        697: (e, t, a) => {
          e.exports = a(703)();
        },
        414: e => {
          "use strict";

          e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        98: t => {
          "use strict";

          t.exports = e;
        }
      },
      a = {};
    function r(e) {
      var n = a[e];
      if (void 0 !== n) return n.exports;
      var i = a[e] = {
        exports: {}
      };
      return t[e](i, i.exports, r), i.exports;
    }
    r.n = e => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return r.d(t, {
        a: t
      }), t;
    }, r.d = (e, t) => {
      for (var a in t) r.o(t, a) && !r.o(e, a) && Object.defineProperty(e, a, {
        enumerable: !0,
        get: t[a]
      });
    }, r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), r.r = e => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var n = {};
    return (() => {
      "use strict";

      r.r(n), r.d(n, {
        default: () => k
      });
      var e = r(98),
        t = r.n(e),
        a = r(697),
        i = r.n(a);
      function o() {
        return o = Object.assign ? Object.assign.bind() : function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var a = arguments[t];
            for (var r in a) Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
          }
          return e;
        }, o.apply(this, arguments);
      }
      var s = function (e) {
        var a = e.pageClassName,
          r = e.pageLinkClassName,
          n = e.page,
          i = e.selected,
          s = e.activeClassName,
          l = e.activeLinkClassName,
          c = e.getEventListener,
          p = e.pageSelectedHandler,
          u = e.href,
          g = e.extraAriaContext,
          d = e.pageLabelBuilder,
          f = e.rel,
          v = e.ariaLabel || "Page " + n + (g ? " " + g : ""),
          b = null;
        return i && (b = "page", v = e.ariaLabel || "Page " + n + " is your current page", a = void 0 !== a ? a + " " + s : s, void 0 !== r ? void 0 !== l && (r = r + " " + l) : r = l), t().createElement("li", {
          className: a
        }, t().createElement("a", o({
          rel: f,
          role: u ? void 0 : "button",
          className: r,
          href: u,
          tabIndex: i ? "-1" : "0",
          "aria-label": v,
          "aria-current": b,
          onKeyPress: p
        }, c(p)), d(n)));
      };
      s.propTypes = {
        pageSelectedHandler: i().func.isRequired,
        selected: i().bool.isRequired,
        pageClassName: i().string,
        pageLinkClassName: i().string,
        activeClassName: i().string,
        activeLinkClassName: i().string,
        extraAriaContext: i().string,
        href: i().string,
        ariaLabel: i().string,
        page: i().number.isRequired,
        getEventListener: i().func.isRequired,
        pageLabelBuilder: i().func.isRequired,
        rel: i().string
      };
      const l = s;
      function c() {
        return c = Object.assign ? Object.assign.bind() : function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var a = arguments[t];
            for (var r in a) Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
          }
          return e;
        }, c.apply(this, arguments);
      }
      var p = function (e) {
        var a = e.breakLabel,
          r = e.breakClassName,
          n = e.breakLinkClassName,
          i = e.breakHandler,
          o = e.getEventListener,
          s = r || "break";
        return t().createElement("li", {
          className: s
        }, t().createElement("a", c({
          className: n,
          role: "button",
          tabIndex: "0",
          onKeyPress: i
        }, o(i)), a));
      };
      p.propTypes = {
        breakLabel: i().oneOfType([i().string, i().node]),
        breakClassName: i().string,
        breakLinkClassName: i().string,
        breakHandler: i().func.isRequired,
        getEventListener: i().func.isRequired
      };
      const u = p;
      function g(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        return null != e ? e : t;
      }
      function d(e) {
        return d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, d(e);
      }
      function f() {
        return f = Object.assign ? Object.assign.bind() : function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var a = arguments[t];
            for (var r in a) Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
          }
          return e;
        }, f.apply(this, arguments);
      }
      function v(e, t) {
        for (var a = 0; a < t.length; a++) {
          var r = t[a];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function b(e, t) {
        return b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
          return e.__proto__ = t, e;
        }, b(e, t);
      }
      function h(e, t) {
        if (t && ("object" === d(t) || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return m(e);
      }
      function m(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function y(e) {
        return y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, y(e);
      }
      function C(e, t, a) {
        return t in e ? Object.defineProperty(e, t, {
          value: a,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = a, e;
      }
      var P = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && b(e, t);
        }(s, e);
        var a,
          r,
          n,
          i,
          o = (n = s, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              t = y(n);
            if (i) {
              var a = y(this).constructor;
              e = Reflect.construct(t, arguments, a);
            } else e = t.apply(this, arguments);
            return h(this, e);
          });
        function s(e) {
          var a, r;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, s), C(m(a = o.call(this, e)), "handlePreviousPage", function (e) {
            var t = a.state.selected;
            a.handleClick(e, null, t > 0 ? t - 1 : void 0, {
              isPrevious: !0
            });
          }), C(m(a), "handleNextPage", function (e) {
            var t = a.state.selected,
              r = a.props.pageCount;
            a.handleClick(e, null, t < r - 1 ? t + 1 : void 0, {
              isNext: !0
            });
          }), C(m(a), "handlePageSelected", function (e, t) {
            if (a.state.selected === e) return a.callActiveCallback(e), void a.handleClick(t, null, void 0, {
              isActive: !0
            });
            a.handleClick(t, null, e);
          }), C(m(a), "handlePageChange", function (e) {
            a.state.selected !== e && (a.setState({
              selected: e
            }), a.callCallback(e));
          }), C(m(a), "getEventListener", function (e) {
            return C({}, a.props.eventListener, e);
          }), C(m(a), "handleClick", function (e, t, r) {
            var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              i = n.isPrevious,
              o = void 0 !== i && i,
              s = n.isNext,
              l = void 0 !== s && s,
              c = n.isBreak,
              p = void 0 !== c && c,
              u = n.isActive,
              g = void 0 !== u && u;
            e.preventDefault ? e.preventDefault() : e.returnValue = !1;
            var d = a.state.selected,
              f = a.props.onClick,
              v = r;
            if (f) {
              var b = f({
                index: t,
                selected: d,
                nextSelectedPage: r,
                event: e,
                isPrevious: o,
                isNext: l,
                isBreak: p,
                isActive: g
              });
              if (!1 === b) return;
              Number.isInteger(b) && (v = b);
            }
            void 0 !== v && a.handlePageChange(v);
          }), C(m(a), "handleBreakClick", function (e, t) {
            var r = a.state.selected;
            a.handleClick(t, e, r < e ? a.getForwardJump() : a.getBackwardJump(), {
              isBreak: !0
            });
          }), C(m(a), "callCallback", function (e) {
            void 0 !== a.props.onPageChange && "function" == typeof a.props.onPageChange && a.props.onPageChange({
              selected: e
            });
          }), C(m(a), "callActiveCallback", function (e) {
            void 0 !== a.props.onPageActive && "function" == typeof a.props.onPageActive && a.props.onPageActive({
              selected: e
            });
          }), C(m(a), "getElementPageRel", function (e) {
            var t = a.state.selected,
              r = a.props,
              n = r.nextPageRel,
              i = r.prevPageRel,
              o = r.selectedPageRel;
            return t - 1 === e ? i : t === e ? o : t + 1 === e ? n : void 0;
          }), C(m(a), "pagination", function () {
            var e = [],
              r = a.props,
              n = r.pageRangeDisplayed,
              i = r.pageCount,
              o = r.marginPagesDisplayed,
              s = r.breakLabel,
              l = r.breakClassName,
              c = r.breakLinkClassName,
              p = a.state.selected;
            if (i <= n) for (var g = 0; g < i; g++) e.push(a.getPageElement(g));else {
              var d = n / 2,
                f = n - d;
              p > i - n / 2 ? d = n - (f = i - p) : p < n / 2 && (f = n - (d = p));
              var v,
                b,
                h = function (e) {
                  return a.getPageElement(e);
                },
                m = [];
              for (v = 0; v < i; v++) {
                var y = v + 1;
                y <= o || y > i - o || v >= p - d && v <= p + (0 === p && n > 1 ? f - 1 : f) ? m.push({
                  type: "page",
                  index: v,
                  display: h(v)
                }) : s && m.length > 0 && m[m.length - 1].display !== b && (n > 0 || o > 0) && (b = t().createElement(u, {
                  key: v,
                  breakLabel: s,
                  breakClassName: l,
                  breakLinkClassName: c,
                  breakHandler: a.handleBreakClick.bind(null, v),
                  getEventListener: a.getEventListener
                }), m.push({
                  type: "break",
                  index: v,
                  display: b
                }));
              }
              m.forEach(function (t, a) {
                var r = t;
                "break" === t.type && m[a - 1] && "page" === m[a - 1].type && m[a + 1] && "page" === m[a + 1].type && m[a + 1].index - m[a - 1].index <= 2 && (r = {
                  type: "page",
                  index: t.index,
                  display: h(t.index)
                }), e.push(r.display);
              });
            }
            return e;
          }), void 0 !== e.initialPage && void 0 !== e.forcePage && console.warn("(react-paginate): Both initialPage (".concat(e.initialPage, ") and forcePage (").concat(e.forcePage, ") props are provided, which is discouraged.") + " Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"), r = e.initialPage ? e.initialPage : e.forcePage ? e.forcePage : 0, a.state = {
            selected: r
          }, a;
        }
        return a = s, (r = [{
          key: "componentDidMount",
          value: function () {
            var e = this.props,
              t = e.initialPage,
              a = e.disableInitialCallback,
              r = e.extraAriaContext,
              n = e.pageCount,
              i = e.forcePage;
            void 0 === t || a || this.callCallback(t), r && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(n) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(n, "). Did you forget a Math.ceil()?")), void 0 !== t && t > n - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(t, " > ").concat(n - 1, ").")), void 0 !== i && i > n - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(i, " > ").concat(n - 1, ")."));
          }
        }, {
          key: "componentDidUpdate",
          value: function (e) {
            void 0 !== this.props.forcePage && this.props.forcePage !== e.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({
              selected: this.props.forcePage
            })), Number.isInteger(e.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
          }
        }, {
          key: "getForwardJump",
          value: function () {
            var e = this.state.selected,
              t = this.props,
              a = t.pageCount,
              r = e + t.pageRangeDisplayed;
            return r >= a ? a - 1 : r;
          }
        }, {
          key: "getBackwardJump",
          value: function () {
            var e = this.state.selected - this.props.pageRangeDisplayed;
            return e < 0 ? 0 : e;
          }
        }, {
          key: "getElementHref",
          value: function (e) {
            var t = this.props,
              a = t.hrefBuilder,
              r = t.pageCount,
              n = t.hrefAllControls;
            if (a) return n || e >= 0 && e < r ? a(e + 1, r, this.state.selected) : void 0;
          }
        }, {
          key: "ariaLabelBuilder",
          value: function (e) {
            var t = e === this.state.selected;
            if (this.props.ariaLabelBuilder && e >= 0 && e < this.props.pageCount) {
              var a = this.props.ariaLabelBuilder(e + 1, t);
              return this.props.extraAriaContext && !t && (a = a + " " + this.props.extraAriaContext), a;
            }
          }
        }, {
          key: "getPageElement",
          value: function (e) {
            var a = this.state.selected,
              r = this.props,
              n = r.pageClassName,
              i = r.pageLinkClassName,
              o = r.activeClassName,
              s = r.activeLinkClassName,
              c = r.extraAriaContext,
              p = r.pageLabelBuilder;
            return t().createElement(l, {
              key: e,
              pageSelectedHandler: this.handlePageSelected.bind(null, e),
              selected: a === e,
              rel: this.getElementPageRel(e),
              pageClassName: n,
              pageLinkClassName: i,
              activeClassName: o,
              activeLinkClassName: s,
              extraAriaContext: c,
              href: this.getElementHref(e),
              ariaLabel: this.ariaLabelBuilder(e),
              page: e + 1,
              pageLabelBuilder: p,
              getEventListener: this.getEventListener
            });
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.renderOnZeroPageCount;
            if (0 === this.props.pageCount && void 0 !== e) return e ? e(this.props) : e;
            var a = this.props,
              r = a.disabledClassName,
              n = a.disabledLinkClassName,
              i = a.pageCount,
              o = a.className,
              s = a.containerClassName,
              l = a.previousLabel,
              c = a.previousClassName,
              p = a.previousLinkClassName,
              u = a.previousAriaLabel,
              d = a.prevRel,
              v = a.nextLabel,
              b = a.nextClassName,
              h = a.nextLinkClassName,
              m = a.nextAriaLabel,
              y = a.nextRel,
              C = this.state.selected,
              P = 0 === C,
              k = C === i - 1,
              x = "".concat(g(c)).concat(P ? " ".concat(g(r)) : ""),
              N = "".concat(g(b)).concat(k ? " ".concat(g(r)) : ""),
              L = "".concat(g(p)).concat(P ? " ".concat(g(n)) : ""),
              O = "".concat(g(h)).concat(k ? " ".concat(g(n)) : ""),
              R = P ? "true" : "false",
              E = k ? "true" : "false";
            return t().createElement("ul", {
              className: o || s,
              role: "navigation",
              "aria-label": "Pagination"
            }, t().createElement("li", {
              className: x
            }, t().createElement("a", f({
              className: L,
              href: this.getElementHref(C - 1),
              tabIndex: P ? "-1" : "0",
              role: "button",
              onKeyPress: this.handlePreviousPage,
              "aria-disabled": R,
              "aria-label": u,
              rel: d
            }, this.getEventListener(this.handlePreviousPage)), l)), this.pagination(), t().createElement("li", {
              className: N
            }, t().createElement("a", f({
              className: O,
              href: this.getElementHref(C + 1),
              tabIndex: k ? "-1" : "0",
              role: "button",
              onKeyPress: this.handleNextPage,
              "aria-disabled": E,
              "aria-label": m,
              rel: y
            }, this.getEventListener(this.handleNextPage)), v)));
          }
        }]) && v(a.prototype, r), Object.defineProperty(a, "prototype", {
          writable: !1
        }), s;
      }(e.Component);
      C(P, "propTypes", {
        pageCount: i().number.isRequired,
        pageRangeDisplayed: i().number,
        marginPagesDisplayed: i().number,
        previousLabel: i().node,
        previousAriaLabel: i().string,
        prevPageRel: i().string,
        prevRel: i().string,
        nextLabel: i().node,
        nextAriaLabel: i().string,
        nextPageRel: i().string,
        nextRel: i().string,
        breakLabel: i().oneOfType([i().string, i().node]),
        hrefBuilder: i().func,
        hrefAllControls: i().bool,
        onPageChange: i().func,
        onPageActive: i().func,
        onClick: i().func,
        initialPage: i().number,
        forcePage: i().number,
        disableInitialCallback: i().bool,
        containerClassName: i().string,
        className: i().string,
        pageClassName: i().string,
        pageLinkClassName: i().string,
        pageLabelBuilder: i().func,
        activeClassName: i().string,
        activeLinkClassName: i().string,
        previousClassName: i().string,
        nextClassName: i().string,
        previousLinkClassName: i().string,
        nextLinkClassName: i().string,
        disabledClassName: i().string,
        disabledLinkClassName: i().string,
        breakClassName: i().string,
        breakLinkClassName: i().string,
        extraAriaContext: i().string,
        ariaLabelBuilder: i().func,
        eventListener: i().string,
        renderOnZeroPageCount: i().func,
        selectedPageRel: i().string
      }), C(P, "defaultProps", {
        pageRangeDisplayed: 2,
        marginPagesDisplayed: 3,
        activeClassName: "selected",
        previousLabel: "Previous",
        previousClassName: "previous",
        previousAriaLabel: "Previous page",
        prevPageRel: "prev",
        prevRel: "prev",
        nextLabel: "Next",
        nextClassName: "next",
        nextAriaLabel: "Next page",
        nextPageRel: "next",
        nextRel: "next",
        breakLabel: "...",
        disabledClassName: "disabled",
        disableInitialCallback: !1,
        pageLabelBuilder: function (e) {
          return e;
        },
        eventListener: "onClick",
        renderOnZeroPageCount: void 0,
        selectedPageRel: "canonical",
        hrefAllControls: !1
      });
      const k = P;
    })(), n;
  })());

  /***/
}, /* 448 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(449);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 449 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, ".progress-indicator {\n\tposition: absolute;\n\tz-index: 100;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin: 0 auto;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color:rgba(255,255,255,0.85);\n\tpointer-events: all;\n\tcursor: wait;\n}\n.progress-indicator.is-opaque{\n\tbackground-color:rgba(255,255,255,1);\n}\n.progress-indicator .generating-circle {\n\tfont-size: 36px;\n\tcolor: #9b0649;\n\tanimation: rotateInACircle 2s linear infinite;\n}\n.progress-indicator .description {\n\tfont-size: 12px;\n\tfont-family: Open Sans;\n\tcolor: #374047;\n}\n", "", {
    "version": 3,
    "sources": ["ProgressIndicator.css"],
    "names": [],
    "mappings": "AAAA;CACC,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,cAAc;CACd,WAAW;CACX,YAAY;CACZ,uCAAuC;CACvC,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,oCAAoC;AACrC;AACA;CACC,eAAe;CACf,cAAc;CACd,6CAA6C;AAC9C;AACA;CACC,eAAe;CACf,sBAAsB;CACtB,cAAc;AACf",
    "file": "ProgressIndicator.css",
    "sourcesContent": [".progress-indicator {\n\tposition: absolute;\n\tz-index: 100;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin: 0 auto;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color:rgba(255,255,255,0.85);\n\tpointer-events: all;\n\tcursor: wait;\n}\n.progress-indicator.is-opaque{\n\tbackground-color:rgba(255,255,255,1);\n}\n.progress-indicator .generating-circle {\n\tfont-size: 36px;\n\tcolor: #9b0649;\n\tanimation: rotateInACircle 2s linear infinite;\n}\n.progress-indicator .description {\n\tfont-size: 12px;\n\tfont-family: Open Sans;\n\tcolor: #374047;\n}\n"]
  }]);

  /***/
}, /* 450 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(451);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 451 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * Animations\n * Various animations in use throughout Rhombus + The Applications\n */\n/**\n * bounceIn\n * \t- used in action-kebabs\n * \t- used in hover on certain icons\n */\n@keyframes bounceIn {\n\t0%, 100%, 20%, 40%, 60%, 80% {\n\t\tanimation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n\t}\n\t0% {\n\t\topacity: 0;\n\t\ttransform: scale3d(0.3, 0.3, 0.3);\n\t}\n\t20% {\n\t\ttransform: scale3d(1.1, 1.1, 1.1);\n\t}\n\t40% {\n\t\ttransform: scale3d(0.9, 0.9, 0.9);\n\t}\n\t60% {\n\t\topacity: 1;\n\t\ttransform: scale3d(1.03, 1.03, 1.03);\n\t}\n \t80% {\n\t\ttransform: scale3d(0.97, 0.97, 0.97);\n\t}\n\t100% {\n\t\topacity: 1;\n\t\ttransform: scale3d(1, 1, 1);\n\t}\n}\n\n.reverse-animation { animation-direction: reverse; }\n@keyframes rotateInACircle {\n\tto { transform: rotate(360deg); }\n}\n\n.rotate-y-3d { animation: rotateY3D 1s ease-out infinite; }\n@keyframes rotateY3D {\n\tto { transform:rotateY(360deg); }\n}\n\n@keyframes wiggle {\n\t0% { transform:rotateX(30deg); }\n\t30% { transform:rotate(-30deg);\t}\n\t50% { transform:rotate(0); }\n\t70% { transform:rotate(30deg); }\n\t100% { transform:rotate(0);\t}\n}\n\n@keyframes marchingAnts {\n\t0% { background-position:0 0; }\n\tto { background-position:100% 0; }\n}", "", {
    "version": 3,
    "sources": ["Animations.css"],
    "names": [],
    "mappings": "AAAA;;;EAGE;AACF;;;;EAIE;AACF;CACC;EACC,8DAA8D;CAC/D;CACA;EACC,UAAU;EACV,iCAAiC;CAClC;CACA;EACC,iCAAiC;CAClC;CACA;EACC,iCAAiC;CAClC;CACA;EACC,UAAU;EACV,oCAAoC;CACrC;EACC;EACA,oCAAoC;CACrC;CACA;EACC,UAAU;EACV,2BAA2B;CAC5B;AACD;;AAEA,qBAAqB,4BAA4B,EAAE;AACnD;CACC,KAAK,yBAAyB,EAAE;AACjC;;AAEA,eAAe,yCAAyC,EAAE;AAC1D;CACC,KAAK,yBAAyB,EAAE;AACjC;;AAEA;CACC,KAAK,wBAAwB,EAAE;CAC/B,MAAM,wBAAwB,EAAE;CAChC,MAAM,mBAAmB,EAAE;CAC3B,MAAM,uBAAuB,EAAE;CAC/B,OAAO,mBAAmB,EAAE;AAC7B;;AAEA;CACC,KAAK,uBAAuB,EAAE;CAC9B,KAAK,0BAA0B,EAAE;AAClC",
    "file": "Animations.css",
    "sourcesContent": ["/**\n * Animations\n * Various animations in use throughout Rhombus + The Applications\n */\n/**\n * bounceIn\n * \t- used in action-kebabs\n * \t- used in hover on certain icons\n */\n@keyframes bounceIn {\n\t0%, 100%, 20%, 40%, 60%, 80% {\n\t\tanimation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n\t}\n\t0% {\n\t\topacity: 0;\n\t\ttransform: scale3d(0.3, 0.3, 0.3);\n\t}\n\t20% {\n\t\ttransform: scale3d(1.1, 1.1, 1.1);\n\t}\n\t40% {\n\t\ttransform: scale3d(0.9, 0.9, 0.9);\n\t}\n\t60% {\n\t\topacity: 1;\n\t\ttransform: scale3d(1.03, 1.03, 1.03);\n\t}\n \t80% {\n\t\ttransform: scale3d(0.97, 0.97, 0.97);\n\t}\n\t100% {\n\t\topacity: 1;\n\t\ttransform: scale3d(1, 1, 1);\n\t}\n}\n\n.reverse-animation { animation-direction: reverse; }\n@keyframes rotateInACircle {\n\tto { transform: rotate(360deg); }\n}\n\n.rotate-y-3d { animation: rotateY3D 1s ease-out infinite; }\n@keyframes rotateY3D {\n\tto { transform:rotateY(360deg); }\n}\n\n@keyframes wiggle {\n\t0% { transform:rotateX(30deg); }\n\t30% { transform:rotate(-30deg);\t}\n\t50% { transform:rotate(0); }\n\t70% { transform:rotate(30deg); }\n\t100% { transform:rotate(0);\t}\n}\n\n@keyframes marchingAnts {\n\t0% { background-position:0 0; }\n\tto { background-position:100% 0; }\n}"]
  }]);

  /***/
}, /* 452 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(453);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 453 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * EmptyItem.css\n */\n.empty-item {\n\tborder-radius: 3px;\n\tbox-shadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.1);\n\tbackground-color: #ffffff;\n\tborder: solid 1px #eaebec;\n\tpadding: 20px;\n\tpadding-bottom: 0;\n\tmargin: 20px 0;\n\tflex-direction: column;\n\tcolor: #858c90;\n\tfont-size: 18px;\n\t/* 26px for the header + 20px for the margin */\n\theight: calc(100% - 46px);\n\tjustify-content: center;\n}\n\n.empty-item .item-icon {\n\tfont-size: 60px;\n\tcolor: #858c90;\n\tmargin-bottom: 15px;\n}\n.empty-item .item-image{\n\tmargin-bottom: 15px;\n}\n.empty-item h4{\n\tmargin-bottom: 0;\n}\n.empty-item p {\n\tmargin: 0 0 15px 0;\n}\n.empty-item .buttons a:nth-child(n+2),\n.empty-item .buttons button:nth-child(n+2){\n\tmargin-left: 10px;\n}\n", "", {
    "version": 3,
    "sources": ["EmptyItem.css"],
    "names": [],
    "mappings": "AAAA;;EAEE;AACF;CACC,kBAAkB;CAClB,4CAA4C;CAC5C,yBAAyB;CACzB,yBAAyB;CACzB,aAAa;CACb,iBAAiB;CACjB,cAAc;CACd,sBAAsB;CACtB,cAAc;CACd,eAAe;CACf,8CAA8C;CAC9C,yBAAyB;CACzB,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;;CAEC,iBAAiB;AAClB",
    "file": "EmptyItem.css",
    "sourcesContent": ["/**\n * EmptyItem.css\n */\n.empty-item {\n\tborder-radius: 3px;\n\tbox-shadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.1);\n\tbackground-color: #ffffff;\n\tborder: solid 1px #eaebec;\n\tpadding: 20px;\n\tpadding-bottom: 0;\n\tmargin: 20px 0;\n\tflex-direction: column;\n\tcolor: #858c90;\n\tfont-size: 18px;\n\t/* 26px for the header + 20px for the margin */\n\theight: calc(100% - 46px);\n\tjustify-content: center;\n}\n\n.empty-item .item-icon {\n\tfont-size: 60px;\n\tcolor: #858c90;\n\tmargin-bottom: 15px;\n}\n.empty-item .item-image{\n\tmargin-bottom: 15px;\n}\n.empty-item h4{\n\tmargin-bottom: 0;\n}\n.empty-item p {\n\tmargin: 0 0 15px 0;\n}\n.empty-item .buttons a:nth-child(n+2),\n.empty-item .buttons button:nth-child(n+2){\n\tmargin-left: 10px;\n}\n"]
  }]);

  /***/
}, /* 454 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = HeaderUser;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _functions = __webpack_require__(33);
  var _useClickOutsideHandler = _interopRequireDefault(__webpack_require__(425));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function HeaderUser(_ref) {
    var userName = _ref.userName,
      showSettings = _ref.showSettings,
      showSignout = _ref.showSignout,
      onSettingsClick = _ref.onSettingsClick,
      onSignoutClick = _ref.onSignoutClick;
    var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDropdownOpen = _useState2[0],
      setIsDropdownOpen = _useState2[1],
      actions = [],
      dropDown = null,
      classes = ["ft-user-info", "button-actions", "ft-nav-item"],
      divOptions = {},
      buttonOptions = {
        type: "button",
        className: "action-header-button cypress-header-button user-button"
      },
      _useClickOutsideHandl = (0, _useClickOutsideHandler["default"])(function () {
        /* istanbul ignore next */
        setIsDropdownOpen(false);
      }, "click"),
      _useClickOutsideHandl2 = _slicedToArray(_useClickOutsideHandl, 1),
      ref = _useClickOutsideHandl2[0];
    function _onSettings(e) {
      e.preventDefault();
      onSettingsClick();
      setIsDropdownOpen(false);
    }
    function _onSignout(e) {
      e.preventDefault();
      onSignoutClick();
      setIsDropdownOpen(false);
    }
    if (showSettings) {
      actions.push( /*#__PURE__*/_react["default"].createElement("li", {
        key: "settings",
        className: "ft-header-option settings-action"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "action-header-button cypress-header-button",
        onClick: _onSettings,
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fas fa-cog",
        className: "option-icon"
      }), /*#__PURE__*/_react["default"].createElement("span", null, "Account Settings"))));
    }
    if (showSignout) {
      actions.push( /*#__PURE__*/_react["default"].createElement("li", {
        key: "signout",
        className: "ft-header-option signout-action"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "action-header-button cypress-header-button",
        onClick: _onSignout,
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fas fa-sign-out-alt",
        className: "option-icon"
      }), /*#__PURE__*/_react["default"].createElement("span", null, "Sign Out"))));
    }
    if (actions.length) {
      classes.push("has-more-options", "click-to-open");
      dropDown = /*#__PURE__*/_react["default"].createElement("ul", {
        className: "ft-header-more-options"
      }, actions);
      divOptions.onClick = function (e) {
        e.preventDefault();
        setIsDropdownOpen(!isDropdownOpen);
      };
    }
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      ref: ref,
      className: (0, _classnames["default"])(classes, {
        "is-open": isDropdownOpen
      })
    }, divOptions), /*#__PURE__*/_react["default"].createElement("button", buttonOptions, /*#__PURE__*/_react["default"].createElement("span", {
      className: "welcome-who"
    }, "Welcome, ", userName), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "profile",
      className: "user-icon"
    })), dropDown);
  }
  HeaderUser.displayName = "HeaderUser";
  HeaderUser.defaultProps = {
    /**The Username to show */
    userName: "",
    /* Should we show the User Account action */
    showSettings: true,
    onSettingsClick: _functions.noop,
    /* Should we show the signout action */
    showSignout: true,
    onSignoutClick: null
  };
  HeaderUser.propTypes = {
    userName: _propTypes["default"].string.isRequired,
    showSettings: _propTypes["default"].bool,
    showSignout: _propTypes["default"].bool,
    /* istanbul ignore next */onSignoutClick: function onSignoutClick(props, propName, componentName) {
      if (props.showSignout && !props.onSignoutClick) {
        return new Error("<".concat(componentName, "> is showing the `Signout` action, but no method `onSignoutClick` was passed in.  Nothing will happen!"));
      }
    }
  };

  /***/
}, /* 455 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = HeaderNavItem;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function HeaderNavItem(props) {
    var _classNames;
    var $label = props.label ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "ft-nav-label"
      }, props.label) : null,
      classes = (0, _classnames["default"])((_classNames = {
        "ft-nav-item": true
      }, _defineProperty(_classNames, props.className, true), _defineProperty(_classNames, "is-active", props.isActive), _classNames)),
      divProps = {
        className: classes,
        title: props.title
      };
    if (props.renderChild) {
      return props.renderChild(props, classes);
    }
    if (props.link) {
      return /*#__PURE__*/_react["default"].createElement("a", {
        href: props.link,
        className: classes,
        title: props.title
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: props.icon
      }), $label);
    }
    if (props.onClick) {
      divProps.onClick = props.onClick;
    }
    return /*#__PURE__*/_react["default"].createElement("div", divProps, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: props.icon
    }), $label);
  }
  HeaderNavItem.defaultProps = {
    className: "",
    title: "",
    link: null
  };
  HeaderNavItem.propTypes = {
    id: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string,
    label: _propTypes["default"].string,
    icon: _propTypes["default"].string,
    renderChild: _propTypes["default"].func
  };

  /***/
}, /* 456 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = PasswordToggle;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _Tooltip = _interopRequireDefault(__webpack_require__(40));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function PasswordToggle(_ref) {
    var tooltip = _ref.tooltip,
      passIcon = _ref.passIcon,
      toggleInputType = _ref.toggleInputType;
    return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      direction: "top",
      description: tooltip
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      className: "toggle-password",
      name: "fas ".concat(passIcon),
      onClick: toggleInputType
    }));
  }

  /***/
}, /* 457 */
/***/function (module, exports) {
  module.exports = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };

  /***/
}, /* 458 */
/***/function (module, exports, __webpack_require__) {
  // 7.1.13 ToObject(argument)
  var defined = __webpack_require__(478);
  module.exports = function (it) {
    return Object(defined(it));
  };

  /***/
}, /* 459 */
/***/function (module, exports) {
  module.exports = {};

  /***/
}, /* 460 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "ActionsCell", {
    enumerable: true,
    get: function get() {
      return _MoreActions["default"];
    }
  });
  Object.defineProperty(exports, "ActionsComponent", {
    enumerable: true,
    get: function get() {
      return _MoreActions.ActionsComponent;
    }
  });
  Object.defineProperty(exports, "AppHeader", {
    enumerable: true,
    get: function get() {
      return _AppHeader["default"];
    }
  });
  Object.defineProperty(exports, "AppHelp", {
    enumerable: true,
    get: function get() {
      return _AppHeader.HelpItem;
    }
  });
  Object.defineProperty(exports, "Button", {
    enumerable: true,
    get: function get() {
      return _Button["default"];
    }
  });
  Object.defineProperty(exports, "Card", {
    enumerable: true,
    get: function get() {
      return _Card["default"];
    }
  });
  Object.defineProperty(exports, "Checkbox", {
    enumerable: true,
    get: function get() {
      return _Checkbox["default"];
    }
  });
  Object.defineProperty(exports, "CheckboxList", {
    enumerable: true,
    get: function get() {
      return _CheckboxList["default"];
    }
  });
  exports.Confirm = void 0;
  Object.defineProperty(exports, "ControlWrapper", {
    enumerable: true,
    get: function get() {
      return _ControlWrapper["default"];
    }
  });
  Object.defineProperty(exports, "DataGrid", {
    enumerable: true,
    get: function get() {
      return _DataGrid["default"];
    }
  });
  Object.defineProperty(exports, "Dates", {
    enumerable: true,
    get: function get() {
      return _Dates["default"];
    }
  });
  Object.defineProperty(exports, "Dimensions", {
    enumerable: true,
    get: function get() {
      return _Dimensions["default"];
    }
  });
  Object.defineProperty(exports, "EmptyItem", {
    enumerable: true,
    get: function get() {
      return _EmptyItem["default"];
    }
  });
  Object.defineProperty(exports, "FileImport", {
    enumerable: true,
    get: function get() {
      return _FileImport["default"];
    }
  });
  exports.Form = void 0;
  Object.defineProperty(exports, "FormFooter", {
    enumerable: true,
    get: function get() {
      return _FormFooter["default"];
    }
  });
  Object.defineProperty(exports, "Header", {
    enumerable: true,
    get: function get() {
      return _Header["default"];
    }
  });
  Object.defineProperty(exports, "Icon", {
    enumerable: true,
    get: function get() {
      return _Icon["default"];
    }
  });
  Object.defineProperty(exports, "IconMap", {
    enumerable: true,
    get: function get() {
      return _Icons["default"];
    }
  });
  Object.defineProperty(exports, "Input", {
    enumerable: true,
    get: function get() {
      return _Input["default"];
    }
  });
  exports.Layout = void 0;
  Object.defineProperty(exports, "ModalFooter", {
    enumerable: true,
    get: function get() {
      return _ModalFooter["default"];
    }
  });
  Object.defineProperty(exports, "ModalHeader", {
    enumerable: true,
    get: function get() {
      return _ModalHeader["default"];
    }
  });
  Object.defineProperty(exports, "MoreActions", {
    enumerable: true,
    get: function get() {
      return _MoreActions.MoreActions;
    }
  });
  Object.defineProperty(exports, "Navbar", {
    enumerable: true,
    get: function get() {
      return _Navbar["default"];
    }
  });
  Object.defineProperty(exports, "NewCard", {
    enumerable: true,
    get: function get() {
      return _NewCard["default"];
    }
  });
  Object.defineProperty(exports, "NotificationController", {
    enumerable: true,
    get: function get() {
      return _NotificationController["default"];
    }
  });
  Object.defineProperty(exports, "NotificationItem", {
    enumerable: true,
    get: function get() {
      return _NotificationItem["default"];
    }
  });
  Object.defineProperty(exports, "Pager", {
    enumerable: true,
    get: function get() {
      return _Pager["default"];
    }
  });
  Object.defineProperty(exports, "ProgressIndicator", {
    enumerable: true,
    get: function get() {
      return _ProgressIndicator["default"];
    }
  });
  exports.ReactDataGridAddons = exports.ReactDataGrid = void 0;
  Object.defineProperty(exports, "ReduxControls", {
    enumerable: true,
    get: function get() {
      return _form.ReduxControls;
    }
  });
  Object.defineProperty(exports, "RowController", {
    enumerable: true,
    get: function get() {
      return _RowController["default"];
    }
  });
  Object.defineProperty(exports, "Search", {
    enumerable: true,
    get: function get() {
      return _Search["default"];
    }
  });
  Object.defineProperty(exports, "Select", {
    enumerable: true,
    get: function get() {
      return _Select["default"];
    }
  });
  Object.defineProperty(exports, "Tabs", {
    enumerable: true,
    get: function get() {
      return _Tabs["default"];
    }
  });
  Object.defineProperty(exports, "Tag", {
    enumerable: true,
    get: function get() {
      return _Tag["default"];
    }
  });
  Object.defineProperty(exports, "TagGroup", {
    enumerable: true,
    get: function get() {
      return _TagGroup["default"];
    }
  });
  Object.defineProperty(exports, "Toggle", {
    enumerable: true,
    get: function get() {
      return _Toggle["default"];
    }
  });
  Object.defineProperty(exports, "Toolbar", {
    enumerable: true,
    get: function get() {
      return _Toolbar["default"];
    }
  });
  Object.defineProperty(exports, "Tooltip", {
    enumerable: true,
    get: function get() {
      return _Tooltip["default"];
    }
  });
  exports.Utils = void 0;
  Object.defineProperty(exports, "debounce", {
    enumerable: true,
    get: function get() {
      return _Debounce.debounce;
    }
  });
  exports["default"] = void 0;
  Object.defineProperty(exports, "tagGroupFormatter", {
    enumerable: true,
    get: function get() {
      return _TagGroupFormatter["default"];
    }
  });
  Object.defineProperty(exports, "throttle", {
    enumerable: true,
    get: function get() {
      return _Debounce.throttle;
    }
  });
  var _DataGrid = _interopRequireDefault(__webpack_require__(392));
  var _Header = _interopRequireDefault(__webpack_require__(419));
  var _Navbar = _interopRequireDefault(__webpack_require__(420));
  var _Pager = _interopRequireDefault(__webpack_require__(421));
  var _Tag = _interopRequireDefault(__webpack_require__(166));
  var _Toolbar = _interopRequireDefault(__webpack_require__(422));
  var _Tooltip = _interopRequireDefault(__webpack_require__(40));
  var _ProgressIndicator = _interopRequireDefault(__webpack_require__(242));
  var _EmptyItem = _interopRequireDefault(__webpack_require__(423));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MoreActions = _interopRequireWildcard(__webpack_require__(111));
  var _AppHeader = _interopRequireWildcard(__webpack_require__(424));
  var _ControlWrapper = _interopRequireDefault(__webpack_require__(29));
  var _Button = _interopRequireDefault(__webpack_require__(61));
  var _Checkbox = _interopRequireDefault(__webpack_require__(99));
  var _CheckboxList = _interopRequireDefault(__webpack_require__(167));
  var _Dates = _interopRequireDefault(__webpack_require__(168));
  var _Dimensions = _interopRequireDefault(__webpack_require__(397));
  var _FormFooter = _interopRequireDefault(__webpack_require__(398));
  var _Input = _interopRequireDefault(__webpack_require__(87));
  var _form = __webpack_require__(114);
  var _RowController = _interopRequireDefault(__webpack_require__(170));
  var _Search = _interopRequireDefault(__webpack_require__(113));
  var _Select = _interopRequireDefault(__webpack_require__(64));
  var _TagGroup = _interopRequireDefault(__webpack_require__(172));
  var _Toggle = _interopRequireDefault(__webpack_require__(171));
  var _FileImport = _interopRequireDefault(__webpack_require__(399));
  var _Card = _interopRequireDefault(__webpack_require__(400));
  var _NewCard = _interopRequireDefault(__webpack_require__(245));
  var _ModalFooter = _interopRequireDefault(__webpack_require__(142));
  var _ModalHeader = _interopRequireDefault(__webpack_require__(141));
  var _NotificationController = _interopRequireDefault(__webpack_require__(401));
  var _NotificationItem = _interopRequireDefault(__webpack_require__(240));
  var _Tabs = _interopRequireDefault(__webpack_require__(402));
  var RDG = _interopRequireWildcard(__webpack_require__(244));
  exports.ReactDataGrid = RDG;
  var RDA = _interopRequireWildcard(__webpack_require__(431));
  exports.ReactDataGridAddons = RDA;
  var _Debounce = __webpack_require__(403);
  var _TagGroupFormatter = _interopRequireDefault(__webpack_require__(404));
  var _Icons = _interopRequireDefault(__webpack_require__(34));
  var _ConfirmModal = _interopRequireWildcard(__webpack_require__(432));
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var Form = {
      ControlWrapper: _ControlWrapper["default"],
      Button: _Button["default"],
      Checkbox: _Checkbox["default"],
      CheckboxList: _CheckboxList["default"],
      Dates: _Dates["default"],
      Dimensions: _Dimensions["default"],
      FormFooter: _FormFooter["default"],
      Input: _Input["default"],
      ReduxControls: _form.ReduxControls,
      RowController: _RowController["default"],
      Search: _Search["default"],
      Select: _Select["default"],
      TagGroup: _TagGroup["default"],
      Toggle: _Toggle["default"],
      FileImport: _FileImport["default"]
    },
    Layout = {
      Card: _Card["default"],
      NewCard: _NewCard["default"],
      ModalFooter: _ModalFooter["default"],
      ModalHeader: _ModalHeader["default"],
      NotificationController: _NotificationController["default"],
      NotificationItem: _NotificationItem["default"],
      Tabs: _Tabs["default"]
    },
    Utils = {
      debounce: _Debounce.debounce,
      throttle: _Debounce.throttle,
      tagGroupFormatter: _TagGroupFormatter["default"]
    },
    Confirm = _objectSpread({
      ConfirmModal: _ConfirmModal["default"]
    }, _ConfirmModal.CONFIRM_REDUX),
    Rhombus = {
      version: "2.9.6",
      buildTime: "2024-12-12T16:52:36.252Z",
      Form: Form,
      Layout: Layout,
      Utils: Utils,
      DataGrid: _DataGrid["default"],
      Header: _Header["default"],
      AppHeader: _AppHeader["default"],
      AppHelp: _AppHeader.HelpItem,
      Navbar: _Navbar["default"],
      Pager: _Pager["default"],
      ProgressIndicator: _ProgressIndicator["default"],
      EmptyItem: _EmptyItem["default"],
      Tag: _Tag["default"],
      Toolbar: _Toolbar["default"],
      Tooltip: _Tooltip["default"],
      Icon: _Icon["default"],
      // For backwards compatible - map Rhombicon to Icon
      Rhombicon: _Icon["default"]
    };

  //not sure why we can't just do export Form;
  exports.Confirm = Confirm;
  exports.Utils = Utils;
  exports.Layout = Layout;
  exports.Form = Form;
  var _default = Rhombus;
  exports["default"] = _default;

  /***/
}, /* 461 */
/***/function (module, exports, __webpack_require__) {
  (function webpackUniversalModuleDefinition(root, factory) {
    if (true) module.exports = factory(__webpack_require__(1), __webpack_require__(15));else {}
  })(this, function (__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_9__) {
    return (/******/function (modules) {
        // webpackBootstrap
        /******/ // The module cache
        /******/
        var installedModules = {};

        /******/ // The require function
        /******/
        function __webpack_require__(moduleId) {
          /******/ // Check if module is in cache
          /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;

          /******/ // Create a new module (and put it into the cache)
          /******/
          var module = installedModules[moduleId] = {
            /******/exports: {},
            /******/id: moduleId,
            /******/loaded: false
            /******/
          };

          /******/ // Execute the module function
          /******/
          modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

          /******/ // Flag the module as loaded
          /******/
          module.loaded = true;

          /******/ // Return the exports of the module
          /******/
          return module.exports;
          /******/
        }

        /******/ // expose the modules object (__webpack_modules__)
        /******/
        __webpack_require__.m = modules;

        /******/ // expose the module cache
        /******/
        __webpack_require__.c = installedModules;

        /******/ // __webpack_public_path__
        /******/
        __webpack_require__.p = "";

        /******/ // Load entry module and return exports
        /******/
        return __webpack_require__(0);
        /******/
      }
      /************************************************************************/
      /******/(function (modules) {
        // Check all modules for deduplicated modules
        for (var i in modules) {
          if (Object.prototype.hasOwnProperty.call(modules, i)) {
            switch (typeof modules[i]) {
              case "function":
                break;
              case "object":
                // Module can be created from a template
                modules[i] = function (_m) {
                  var args = _m.slice(1),
                    fn = modules[_m[0]];
                  return function (a, b, c) {
                    fn.apply(this, [a, b, c].concat(args));
                  };
                }(modules[i]);
                break;
              default:
                // Module is a copy of another module
                modules[i] = modules[modules[i]];
                break;
            }
          }
        }
        return modules;
      }([/* 0 */
      /***/function (module, exports, __webpack_require__) {
        module.exports = __webpack_require__(236);

        /***/
      }, /* 1 */
      /***/function (module, exports) {
        module.exports = function (module) {
          if (!module.webpackPolyfill) {
            module.deprecate = function () {};
            module.paths = [];
            // module.parent = undefined by default
            module.children = [];
            module.webpackPolyfill = 1;
          }
          return module;
        };

        /***/
      }, /* 2 */
      /***/function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

        /***/
      }, /* 3 */
      /***/function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        if (false) {
          var throwOnDirectAccess, isValidElement, REACT_ELEMENT_TYPE;
        } else {
          // By explicitly using `prop-types` you are opting into new production behavior.
          // http://fb.me/prop-types-in-prod
          module.exports = __webpack_require__(147)();
        }

        /***/
      }, /* 4 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        module.exports = __webpack_require__(130);

        /***/
      }, /* 5 */
      /***/function (module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                         Copyright (c) 2016 Jed Watson.
                                                                         Licensed under the MIT License (MIT), see
                                                                         http://jedwatson.github.io/classnames
                                                                         */
        /* global define */

        (function () {
          'use strict';

          var hasOwn = {}.hasOwnProperty;
          function classNames() {
            var classes = [];
            for (var i = 0; i < arguments.length; i++) {
              var arg = arguments[i];
              if (!arg) continue;
              var argType = typeof arg;
              if (argType === 'string' || argType === 'number') {
                classes.push(arg);
              } else if (Array.isArray(arg)) {
                classes.push(classNames.apply(null, arg));
              } else if (argType === 'object') {
                for (var key in arg) {
                  if (hasOwn.call(arg, key) && arg[key]) {
                    classes.push(key);
                  }
                }
              }
            }
            return classes.join(' ');
          }
          if (typeof module !== 'undefined' && module.exports) {
            module.exports = classNames;
          } else if (true) {
            // register as 'classnames', consistent with npm package name
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return classNames;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {}
        })();

        /***/
      }, /* 6 */
      /***/function (module, exports) {
        'use strict';

        module.exports = {
          getColumn: function getColumn(columns, idx) {
            if (Array.isArray(columns)) {
              return columns[idx];
            } else if (typeof Immutable !== 'undefined') {
              return columns.get(idx);
            }
          },
          spliceColumn: function spliceColumn(metrics, idx, column) {
            if (Array.isArray(metrics.columns)) {
              metrics.columns.splice(idx, 1, column);
            } else if (typeof Immutable !== 'undefined') {
              metrics.columns = metrics.columns.splice(idx, 1, column);
            }
            return metrics;
          },
          getSize: function getSize(columns) {
            if (Array.isArray(columns)) {
              return columns.length;
            } else if (typeof Immutable !== 'undefined') {
              return columns.size;
            }
          },
          // Logic extented to allow for functions to be passed down in column.editable
          // this allows us to deicde whether we can be edting from a cell level
          canEdit: function canEdit(col, rowData, enableCellSelect) {
            if (!col) return false;
            if (col.editable != null && typeof col.editable === 'function') {
              return enableCellSelect === true && col.editable(rowData);
            }
            return enableCellSelect === true && (!!col.editor || !!col.editable);
          },
          getValue: function getValue(column, property) {
            var value = void 0;
            if (column.toJSON && column.get) {
              value = column.get(property);
            } else {
              value = column[property];
            }
            return value;
          }
        };

        /***/
      }, /* 7 */
      /***/function (module, exports) {
        /*
        	MIT License http://www.opensource.org/licenses/mit-license.php
        	Author Tobias Koppers @sokra
        */
        // css base code, injected by the css-loader
        module.exports = function () {
          var list = [];

          // return the list of modules as css string
          list.toString = function toString() {
            var result = [];
            for (var i = 0; i < this.length; i++) {
              var item = this[i];
              if (item[2]) {
                result.push("@media " + item[2] + "{" + item[1] + "}");
              } else {
                result.push(item[1]);
              }
            }
            return result.join("");
          };

          // import a list of modules into the list
          list.i = function (modules, mediaQuery) {
            if (typeof modules === "string") modules = [[null, modules, ""]];
            var alreadyImportedModules = {};
            for (var i = 0; i < this.length; i++) {
              var id = this[i][0];
              if (typeof id === "number") alreadyImportedModules[id] = true;
            }
            for (i = 0; i < modules.length; i++) {
              var item = modules[i];
              // skip already imported module
              // this implementation is not 100% perfect for weird media query combinations
              //  when a module is imported multiple times with different media queries.
              //  I hope this will never occur (Hey this way we have smaller bundles)
              if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
                if (mediaQuery && !item[2]) {
                  item[2] = mediaQuery;
                } else if (mediaQuery) {
                  item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
                }
                list.push(item);
              }
            }
          };
          return list;
        };

        /***/
      }, /* 8 */
      /***/function (module, exports, __webpack_require__) {
        /*
        	MIT License http://www.opensource.org/licenses/mit-license.php
        	Author Tobias Koppers @sokra
        */
        var stylesInDom = {},
          memoize = function (fn) {
            var memo;
            return function () {
              if (typeof memo === "undefined") memo = fn.apply(this, arguments);
              return memo;
            };
          },
          isOldIE = memoize(function () {
            return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
          }),
          getHeadElement = memoize(function () {
            return document.head || document.getElementsByTagName("head")[0];
          }),
          singletonElement = null,
          singletonCounter = 0,
          styleElementsInsertedAtTop = [];
        module.exports = function (list, options) {
          if (false) {}
          options = options || {};
          // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
          // tags it will allow on a page
          if (typeof options.singleton === "undefined") options.singleton = isOldIE();

          // By default, add <style> tags to the bottom of <head>.
          if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
          var styles = listToStyles(list);
          addStylesToDom(styles, options);
          return function update(newList) {
            var mayRemove = [];
            for (var i = 0; i < styles.length; i++) {
              var item = styles[i];
              var domStyle = stylesInDom[item.id];
              domStyle.refs--;
              mayRemove.push(domStyle);
            }
            if (newList) {
              var newStyles = listToStyles(newList);
              addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
              var domStyle = mayRemove[i];
              if (domStyle.refs === 0) {
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                delete stylesInDom[domStyle.id];
              }
            }
          };
        };
        function addStylesToDom(styles, options) {
          for (var i = 0; i < styles.length; i++) {
            var item = styles[i];
            var domStyle = stylesInDom[item.id];
            if (domStyle) {
              domStyle.refs++;
              for (var j = 0; j < domStyle.parts.length; j++) {
                domStyle.parts[j](item.parts[j]);
              }
              for (; j < item.parts.length; j++) {
                domStyle.parts.push(addStyle(item.parts[j], options));
              }
            } else {
              var parts = [];
              for (var j = 0; j < item.parts.length; j++) {
                parts.push(addStyle(item.parts[j], options));
              }
              stylesInDom[item.id] = {
                id: item.id,
                refs: 1,
                parts: parts
              };
            }
          }
        }
        function listToStyles(list) {
          var styles = [];
          var newStyles = {};
          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            var id = item[0];
            var css = item[1];
            var media = item[2];
            var sourceMap = item[3];
            var part = {
              css: css,
              media: media,
              sourceMap: sourceMap
            };
            if (!newStyles[id]) styles.push(newStyles[id] = {
              id: id,
              parts: [part]
            });else newStyles[id].parts.push(part);
          }
          return styles;
        }
        function insertStyleElement(options, styleElement) {
          var head = getHeadElement();
          var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
          if (options.insertAt === "top") {
            if (!lastStyleElementInsertedAtTop) {
              head.insertBefore(styleElement, head.firstChild);
            } else if (lastStyleElementInsertedAtTop.nextSibling) {
              head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
            } else {
              head.appendChild(styleElement);
            }
            styleElementsInsertedAtTop.push(styleElement);
          } else if (options.insertAt === "bottom") {
            head.appendChild(styleElement);
          } else {
            throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
          }
        }
        function removeStyleElement(styleElement) {
          styleElement.parentNode.removeChild(styleElement);
          var idx = styleElementsInsertedAtTop.indexOf(styleElement);
          if (idx >= 0) {
            styleElementsInsertedAtTop.splice(idx, 1);
          }
        }
        function createStyleElement(options) {
          var styleElement = document.createElement("style");
          styleElement.type = "text/css";
          insertStyleElement(options, styleElement);
          return styleElement;
        }
        function createLinkElement(options) {
          var linkElement = document.createElement("link");
          linkElement.rel = "stylesheet";
          insertStyleElement(options, linkElement);
          return linkElement;
        }
        function addStyle(obj, options) {
          var styleElement, update, remove;
          if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options));
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
            remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
          } else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
            styleElement = createLinkElement(options);
            update = updateLink.bind(null, styleElement);
            remove = function () {
              removeStyleElement(styleElement);
              if (styleElement.href) URL.revokeObjectURL(styleElement.href);
            };
          } else {
            styleElement = createStyleElement(options);
            update = applyToTag.bind(null, styleElement);
            remove = function () {
              removeStyleElement(styleElement);
            };
          }
          update(obj);
          return function updateStyle(newObj) {
            if (newObj) {
              if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
              update(obj = newObj);
            } else {
              remove();
            }
          };
        }
        var replaceText = function () {
          var textStore = [];
          return function (index, replacement) {
            textStore[index] = replacement;
            return textStore.filter(Boolean).join('\n');
          };
        }();
        function applyToSingletonTag(styleElement, index, remove, obj) {
          var css = remove ? "" : obj.css;
          if (styleElement.styleSheet) {
            styleElement.styleSheet.cssText = replaceText(index, css);
          } else {
            var cssNode = document.createTextNode(css);
            var childNodes = styleElement.childNodes;
            if (childNodes[index]) styleElement.removeChild(childNodes[index]);
            if (childNodes.length) {
              styleElement.insertBefore(cssNode, childNodes[index]);
            } else {
              styleElement.appendChild(cssNode);
            }
          }
        }
        function applyToTag(styleElement, obj) {
          var css = obj.css;
          var media = obj.media;
          if (media) {
            styleElement.setAttribute("media", media);
          }
          if (styleElement.styleSheet) {
            styleElement.styleSheet.cssText = css;
          } else {
            while (styleElement.firstChild) {
              styleElement.removeChild(styleElement.firstChild);
            }
            styleElement.appendChild(document.createTextNode(css));
          }
        }
        function updateLink(linkElement, obj) {
          var css = obj.css;
          var sourceMap = obj.sourceMap;
          if (sourceMap) {
            // http://stackoverflow.com/a/26603875
            css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
          }
          var blob = new Blob([css], {
            type: "text/css"
          });
          var oldSrc = linkElement.href;
          linkElement.href = URL.createObjectURL(blob);
          if (oldSrc) URL.revokeObjectURL(oldSrc);
        }

        /***/
      }, /* 9 */
      /***/function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

        /***/
      }, /* 10 */
      /***/function (module, exports, __webpack_require__) {
        /**
         * Copyright 2013-2015, Facebook, Inc.
         * All rights reserved.
         *
         * This source code is licensed under the BSD-style license found in the
         * LICENSE file in the root directory of this source tree. An additional grant
         * of patent rights can be found in the PATENTS file in the same directory.
         */

        'use strict';

        /**
         * Use invariant() to assert state which your program assumes to be true.
         *
         * Provide sprintf-style format (only %s is supported) and arguments
         * to provide information about what broke and what you were
         * expecting.
         *
         * The invariant message will be stripped in production, but the invariant
         * will remain to ensure logic does not differ in production.
         */
        var invariant = function (condition, format, a, b, c, d, e, f) {
          if (false) {}
          if (!condition) {
            var error;
            if (format === undefined) {
              error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
            } else {
              var args = [a, b, c, d, e, f];
              var argIndex = 0;
              error = new Error(format.replace(/%s/g, function () {
                return args[argIndex++];
              }));
              error.name = 'Invariant Violation';
            }
            error.framesToPop = 1; // we don't care about invariant's own frame
            throw error;
          }
        };
        module.exports = invariant;

        /***/
      }, /* 11 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        module.exports = {
          selected: _propTypes2['default'].object.isRequired,
          copied: _propTypes2['default'].object,
          dragged: _propTypes2['default'].object,
          onCellClick: _propTypes2['default'].func.isRequired,
          onCellDoubleClick: _propTypes2['default'].func.isRequired,
          onCommit: _propTypes2['default'].func.isRequired,
          onCommitCancel: _propTypes2['default'].func.isRequired,
          handleDragEnterRow: _propTypes2['default'].func.isRequired,
          handleTerminateDrag: _propTypes2['default'].func.isRequired,
          getCellActions: _propTypes2['default'].func
        };

        /***/
      }, /* 12 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var ExcelColumnShape = {
          name: _propTypes2['default'].node.isRequired,
          key: _propTypes2['default'].string.isRequired,
          width: _propTypes2['default'].number.isRequired,
          filterable: _propTypes2['default'].bool
        };
        module.exports = ExcelColumnShape;

        /***/
      },

        /* 13 */

        /* 25 */

        /* 77 */

        /* 79 */

        /* 103 */

        /* 207 */
        /* 208 */
        /* 209 */

        /* 467 */
        /* 468 */
        /* 469 */
        /* 470 */
        /* 471 */
        /* 472 */
        /* 473 */
        /* 474 */
        /* 475 */
        /* 476 */
        /* 477 */
        /* 478 */
        /* 479 */
        /* 480 */
        /* 481 */
        /* 482 */
        /* 483 */
        /* 484 */
        /* 485 */
        /* 486 */
        /* 487 */
        /* 488 */
        /* 489 */
        /* 490 */
        /* 491 */
        /* 492 */
        /* 493 */
        /* 494 */
        /* 495 */
        /* 496 */
        /* 497 */
        /* 498 */
        /* 499 */
        /* 500 */
        /* 501 */
        /* 502 */
        /* 503 */
        /* 504 */
        /* 505 */
        /* 506 */
        /* 507 */
        /* 508 */
        /* 509 */
        /* 510 */
        /* 511 */
        /* 512 */
        /* 513 */
        /* 514 */
        /* 515 */
        /* 516 */
        /* 517 */
        /* 518 */
        /* 519 */
        /* 520 */
        /* 521 */
        /* 522 */
        /* 523 */
        /* 524 */
        /* 525 */
        /* 526 */
        /* 527 */
        /* 528 */
        /* 529 */
        /* 530 */
        /* 531 */
        /* 532 */
        /* 533 */
        /* 534 */
        /* 535 */
        /* 536 */
        /* 537 */
        /* 538 */
        /* 539 */
        /* 540 */
        /* 541 */
        /* 542 */
        /* 543 */
        /* 544 */
        /* 545 */
        /* 546 */
        /* 547 */
        /* 548 */
        /* 549 */
        /* 550 */
        /* 551 */
        /* 552 */
        /* 553 */
        /* 554 */
        /* 555 */
        /* 556 */
        /* 557 */
        /* 558 */
        /* 559 */
        /* 560 */
        /* 561 */
        /* 562 */
        /* 563 */
        /* 564 */
        /* 565 */
        /* 566 */
        /* 567 */
        /* 568 */
        /* 569 */
        /* 570 */
        /* 571 */
        /* 572 */
        /* 573 */
        /* 574 */
        /* 575 */
        /* 576 */
        /* 577 */
        /* 578 */
        /* 579 */
        /* 580 */
        /* 581 */
        /* 582 */
        /* 583 */
        /* 584 */
        /* 585 */
        /* 586 */
        /* 587 */
        /* 588 */
        /* 589 */
        /* 590 */
        /* 591 */
        /* 592 */
        /* 593 */
        /* 594 */
        /* 595 */
        /* 596 */
        /* 597 */
        /* 598 */
        /* 599 */
        /* 600 */
        /* 601 */
        /* 602 */
        /* 603 */
        /* 604 */
        /* 605 */
        /* 606 */
        /* 607 */
        /* 608 */
        /* 609 */
        /* 610 */
        /* 611 */
        /* 612 */
        /* 613 */
        /* 614 */
        /* 615 */
        /* 616 */
        /* 617 */
        /* 618 */
        /* 619 */
        /* 620 */
        /* 621 */
        /* 622 */
        /* 623 */
        /* 624 */
        /* 625 */
        /* 626 */
        /* 627 */
        /* 628 */
        /* 629 */
        /* 630 */
        /* 631 */
        /* 632 */
        /* 633 */
        /* 634 */
        /* 635 */
        /* 636 */
        /* 637 */
        /* 638 */
        /* 639 */
        /* 640 */
        /* 641 */
        /* 642 */
        /* 643 */
        /* 644 */
        /* 645 */
        /* 646 */
        /* 647 */
        /* 648 */
        /* 649 */
        /* 650 */
        /* 651 */
        /* 652 */
        /* 653 */
        /* 654 */
        /* 655 */
        /* 656 */
        /* 657 */
        /* 658 */
        /* 659 */
        /* 660 */
        /* 661 */
        /* 662 */
        /* 663 */
        /* 664 */
        /* 665 */
        /* 666 */
        /* 667 */
        /* 668 */
        /* 669 */
        /* 670 */
        /* 671 */
        /* 672 */
        /* 673 */
        /* 674 */
        /* 675 */
        /* 676 */
        /* 677 */
        /* 678 */
        /* 679 */
        /* 680 */
        /* 681 */
        /* 682 */
        /* 683 */
        /* 684 */
        /* 685 */
        /* 686 */
        /* 687 */
        /* 688 */
        /* 689 */
        /* 690 */
        /* 691 */
        /* 692 */
        /* 693 */
        /* 694 */
        /* 695 */
        /* 696 */
        /* 697 */
        /* 698 */
        /* 699 */
        /* 700 */
        /* 701 */
        /* 702 */
        /* 703 */
        /* 704 */
        /* 705 */
        /* 706 */
        /* 707 */
        /* 708 */
        /* 709 */
        /* 710 */
        /* 711 */
        /* 712 */
        /* 713 */
        /* 714 */
        /* 715 */
        /* 716 */
        /* 717 */
        /* 718 */
        /* 719 */
        /* 720 */
        /* 721 */
        /* 722 */
        /* 723 */
        /* 724 */
        /* 725 */
        /* 726 */
        /* 727 */
        /* 728 */
        /* 729 */
        /* 730 */
        /* 731 */
        /* 732 */
        /* 733 */
        /* 734 */
        /* 735 */
        /* 736 */
        /* 737 */
        /* 738 */
        /* 739 */
        /* 740 */
        /* 741 */
        /* 742 */
        /* 743 */
        /* 744 */
        /* 745 */
        /* 746 */
        /* 747 */
        /* 748 */
        /* 749 */
        /* 750 */
        /* 751 */
        /* 752 */
        /* 753 */
        /* 754 */
        /* 755 */
        /* 756 */
        /* 757 */
        /* 758 */
        /* 759 */
        /* 760 */
        /* 761 */
        /* 762 */
        /* 763 */
        /* 764 */
        /* 765 */
        /* 766 */
        /* 767 */
        /* 768 */
        /* 769 */
        /* 770 */
        /* 771 */
        /* 772 */
        /* 773 */
        /* 774 */
        /* 775 */
        /* 776 */
        /* 777 */
        /* 778 */
        /* 779 */
        /* 780 */
        /* 781 */
        /* 782 */
        /* 783 */
        /* 784 */
        /* 785 */
        /* 786 */
        /* 787 */
        /* 788 */
        /* 789 */
        /* 790 */
        /* 791 */
        /* 792 */
        /* 793 */
        /* 794 */
        /* 795 */
        /* 796 */
        /* 797 */
        /* 798 */
        /* 799 */
        /* 800 */
        /* 801 */
        /* 802 */
        /* 803 */
        /* 804 */
        /* 805 */
        /* 806 */
        /* 807 */
        /* 808 */
        /* 809 */
        /* 810 */
        /* 811 */
        /* 812 */
        /* 813 */
        /* 814 */
        /* 815 */
        /* 816 */
        /* 817 */
        /* 818 */
        /* 819 */
        /* 820 */
        /* 821 */
        /* 822 */
        /* 823 */
        /* 824 */
        /* 825 */
        /* 826 */
        /* 827 */
        /* 828 */
        /* 829 */
        /* 830 */
        /* 831 */
        /* 832 */
        /* 833 */
        /* 834 */
        /* 835 */
        /* 836 */
        /* 837 */
        /* 838 */
        /* 839 */
        /* 840 */
        /* 841 */
        /* 842 */
        /* 843 */
        /* 844 */
        /* 845 */
        /* 846 */
        /* 847 */
        /* 848 */
        /* 849 */
        /* 850 */
        /* 851 */
        /* 852 */
        /* 853 */
        /* 854 */
        /* 855 */
        /* 856 */
        /* 857 */
        /* 858 */
        /* 859 */
        /* 860 */
        /* 861 */
        /* 862 */
        /* 863 */
        /* 864 */
        /* 865 */
        /* 866 */
        /* 867 */
        /* 868 */
        /* 869 */
        /* 870 */
        /* 871 */
        /* 872 */
        /* 873 */
        /* 874 */
        /* 875 */
        /* 876 */
        /* 877 */
        /* 878 */
        /* 879 */
        /* 880 */
        /* 881 */
        /* 882 */
        /* 883 */
        /* 884 */
        /* 885 */
        /* 886 */
        /* 887 */
        /* 888 */
        /* 889 */
        /* 890 */
        /* 891 */
        /* 892 */
        /* 893 */
        /* 894 */
        /* 895 */
        /* 896 */
        /* 897 */
        /* 898 */
        /* 899 */
        /* 900 */
        /* 901 */
        /* 902 */
        /* 903 */
        /* 904 */
        /* 905 */
        /* 906 */
        /* 907 */
        /* 908 */
        /* 909 */
        /* 910 */
        /* 911 */
        /* 912 */
        /* 913 */
        /* 914 */
        /* 915 */
        /* 916 */
        /* 917 */
        /* 918 */
        /* 919 */
        /* 920 */
        /* 921 */
        /* 922 */
        /* 923 */
        /* 924 */
        /* 925 */
        /* 926 */
        /* 927 */
        /* 928 */
        /* 929 */
        /* 930 */
        /* 931 */
        /* 932 */
        /* 933 */
        /* 934 */
        /* 935 */
        /* 936 */
        /* 937 */
        /* 938 */
        /* 939 */
        /* 940 */
        /* 941 */
        /* 942 */
        /* 943 */
        /* 944 */
        /* 945 */
        /* 946 */
        /* 947 */
        /* 948 */
        /* 949 */
        /* 950 */
        /* 951 */
        /* 952 */
        /* 953 */
        /* 954 */
        /* 955 */
        /* 956 */
        /* 957 */
        /* 958 */
        /* 959 */
        /* 960 */
        /* 961 */
        /* 962 */
        /* 963 */
        /* 964 */
        /* 965 */
        /* 966 */
        /* 967 */
        /* 968 */
        /* 969 */
        /* 970 */
        /* 971 */
        /* 972 */
        /* 973 */
        /* 974 */
        /* 975 */
        /* 976 */
        /* 977 */
        /* 978 */
        /* 979 */
        /* 980 */
        /* 981 */
        /* 982 */
        /* 983 */
        /* 984 */
        /* 985 */
        /* 986 */
        /* 987 */
        /* 988 */
        /* 989 */
        /* 990 */
        /* 991 */
        /* 992 */
        /* 993 */
        /* 994 */
        /* 995 */
        /* 996 */
        /* 997 */
        /* 998 */
        /* 999 */
        /* 1000 */
        /* 1001 */
        /* 1002 */
        /* 1003 */
        /* 1004 */
        /* 1005 */
        /* 1006 */
        /* 1007 */
        /* 1008 */
        /* 1009 */
        /* 1010 */
        /* 1011 */
        /* 1012 */
        /* 1013 */
        /* 1014 */
        /* 1015 */
        /* 1016 */
        /* 1017 */
        /* 1018 */
        /* 1019 */
        /* 1020 */
        /* 1021 */
        /* 1022 */
        /* 1023 */
        /* 1024 */
        /* 1025 */
        /* 1026 */
        /* 1027 */
        /* 1028 */
        /* 1029 */
        /* 1030 */
        /* 1031 */
        /* 1032 */
        /* 1033 */
        /* 1034 */
        /* 1035 */
        /* 1036 */
        /* 1037 */
        /* 1038 */
        /* 1039 */
        /* 1040 */
        /* 1041 */
        /* 1042 */
        /* 1043 */
        /* 1044 */
        /* 1045 */
        /* 1046 */
        /* 1047 */
        /* 1048 */
        /* 1049 */
        /* 1050 */
        /* 1051 */
        /* 1052 */
        /* 1053 */
        /* 1054 */
        /* 1055 */
        /* 1056 */
        /* 1057 */
        /* 1058 */
        /* 1059 */
        /* 1060 */
        /* 1061 */
        /* 1062 */
        /* 1063 */
        /* 1064 */
        /* 1065 */
        /* 1066 */
        /* 1067 */
        /* 1068 */
        /* 1069 */
        /* 1070 */
        /* 1071 */
        /* 1072 */
        /* 1073 */
        /* 1074 */
        /* 1075 */
        /* 1076 */
        /* 1077 */
        /* 1078 */
        /* 1079 */
        /* 1080 */
        /* 1081 */
        /* 1082 */
        /* 1083 */
        /* 1084 */
        /* 1085 */
        /* 1086 */
        /* 1087 */
        /* 1088 */
        /* 1089 */
        /* 1090 */
        /* 1091 */
        /* 1092 */
        /* 1093 */
        /* 1094 */
        /* 1095 */
        /* 1096 */
        /* 1097 */
        /* 1098 */
        /* 1099 */
        /* 1100 */
        /* 1101 */
        /* 1102 */
        /* 1103 */
        /* 1104 */
        /* 1105 */
        /* 1106 */
        /* 1107 */
        /* 1108 */
        /* 1109 */
        /* 1110 */
        /* 1111 */
        /* 1112 */
        /* 1113 */
        /* 1114 */
        /* 1115 */
        /* 1116 */
        /* 1117 */
        /* 1118 */
        /* 1119 */
        /* 1120 */
        /* 1121 */
        /* 1122 */
        /* 1123 */
        /* 1124 */
        /* 1125 */
        /* 1126 */
        /* 1127 */
        /* 1128 */
        /* 1129 */
        /* 1130 */
        /* 1131 */
        /* 1132 */
        /* 1133 */
        /* 1134 */
        /* 1135 */
        /* 1136 */
        /* 1137 */
        /* 1138 */
        /* 1139 */
        /* 1140 */
        /* 1141 */
        /* 1142 */
        /* 1143 */
        /* 1144 */
        /* 1145 */
        /* 1146 */
        /* 1147 */
        /* 1148 */
        /* 1149 */
        /* 1150 */
        /* 1151 */
        /* 1152 */
        /* 1153 */
        /* 1154 */
        /* 1155 */
        /* 1156 */
        /* 1157 */
        /* 1158 */
        /* 1159 */
        /* 1160 */
        /* 1161 */
        /* 1162 */
        /* 1163 */
        /* 1164 */
        /* 1165 */
        /* 1166 */
        /* 1167 */
        /* 1168 */
        /* 1169 */
        /* 1170 */
        /* 1171 */
        /* 1172 */
        /* 1173 */
        /* 1174 */
        /* 1175 */
        /* 1176 */
        /* 1177 */
        /* 1178 */
        /* 1179 */
        /* 1180 */
        /* 1181 */
        /* 1182 */
        /* 1183 */
        /* 1184 */
        /* 1185 */
        /* 1186 */
        /* 1187 */
        /* 1188 */
        /* 1189 */
        /* 1190 */
        /* 1191 */
        /* 1192 */
        /* 1193 */
        /* 1194 */
        /* 1195 */
        /* 1196 */
        /* 1197 */
        /* 1198 */
        /* 1199 */
        /* 1200 */
        /* 1201 */
        /* 1202 */
        /* 1203 */
        /* 1204 */
        /* 1205 */
        /* 1206 */
        /* 1207 */
        /* 1208 */
        /* 1209 */
        /* 1210 */
        /* 1211 */
        /* 1212 */
        /* 1213 */
        /* 1214 */
        /* 1215 */
        /* 1216 */
        /* 1217 */
        /* 1218 */
        /* 1219 */
        /* 1220 */
        /* 1221 */
        /* 1222 */
        /* 1223 */
        /* 1224 */
        /* 1225 */
        /* 1226 */
        /* 1227 */
        /* 1228 */
        /* 1229 */
        /* 1230 */
        /* 1231 */
        /* 1232 */
        /* 1233 */
        /* 1234 */
        /* 1235 */
        /* 1236 */
        /* 1237 */
        /* 1238 */
        /* 1239 */
        /* 1240 */
        /* 1241 */
        /* 1242 */
        /* 1243 */
        /* 1244 */
        /* 1245 */
        /* 1246 */
        /* 1247 */
        /* 1248 */
        /* 1249 */
        /* 1250 */
        /* 1251 */
        /* 1252 */
        /* 1253 */
        /* 1254 */
        /* 1255 */
        /* 1256 */
        /* 1257 */
        /* 1258 */
        /* 1259 */
        /* 1260 */
        /* 1261 */
        /* 1262 */
        /* 1263 */
        /* 1264 */
        /* 1265 */
        /* 1266 */
        /* 1267 */
        /* 1268 */
        /* 1269 */
        /* 1270 */
        /* 1271 */
        /* 1272 */
        /* 1273 */
        /* 1274 */
        /* 1275 */
        /* 1276 */
        /* 1277 */
        /* 1278 */
        /* 1279 */
        /* 1280 */
        /* 1281 */
        /* 1282 */
        /* 1283 */
        /* 1284 */
        /* 1285 */
        /* 1286 */
        /* 1287 */
        /* 1288 */
        /* 1289 */
        /* 1290 */
        /* 1291 */
        /* 1292 */
        /* 1293 */
        /* 1294 */
        /* 1295 */
        /* 1296 */
        /* 1297 */
        /* 1298 */
        /* 1299 */
        /* 1300 */
        /* 1301 */
        /* 1302 */
        /* 1303 */
        /* 1304 */
        /* 1305 */
        /* 1306 */
        /* 1307 */
        /* 1308 */
        /* 1309 */
        /* 1310 */
        /* 1311 */
        /* 1312 */
        /* 1313 */
        /* 1314 */
        /* 1315 */
        /* 1316 */
        /* 1317 */
        /* 1318 */
        /* 1319 */
        /* 1320 */
        /* 1321 */
        /* 1322 */
        /* 1323 */
        /* 1324 */
        /* 1325 */
        /* 1326 */
        /* 1327 */
        /* 1328 */
        /* 1329 */
        /* 1330 */
        /* 1331 */
        /* 1332 */
        /* 1333 */
        /* 1334 */
        /* 1335 */
        /* 1336 */
        /* 1337 */
        /* 1338 */
        /* 1339 */
        /* 1340 */
        /* 1341 */
        /* 1342 */
        /* 1343 */
        /* 1344 */
        /* 1345 */
        /* 1346 */
        /* 1347 */
        /* 1348 */
        /* 1349 */
        /* 1350 */
        /* 1351 */
        /* 1352 */
        /* 1353 */
        /* 1354 */
        /* 1355 */
        /* 1356 */
        /* 1357 */
        /* 1358 */
        /* 1359 */
        /* 1360 */
        /* 1361 */
        /* 1362 */
        /* 1363 */
        /* 1364 */
        /* 1365 */
        /* 1366 */
        /* 1367 */
        /* 1368 */
        /* 1369 */
        /* 1370 */
        /* 1371 */
        /* 1372 */
        /* 1373 */
        /* 1374 */
        /* 1375 */
        /* 1376 */
        /* 1377 */
        /* 1378 */
        /* 1379 */
        /* 1380 */
        /* 1381 */
        /* 1382 */
        /* 1383 */
        /* 1384 */
        /* 1385 */
        /* 1386 */
        /* 1387 */
        /* 1388 */
        /* 1389 */
        /* 1390 */
        /* 1391 */
        /* 1392 */
        /* 1393 */
        /* 1394 */
        /* 1395 */
        /* 1396 */
        /* 1397 */
        /* 1398 */
        /* 1399 */
        /* 1400 */
        /* 1401 */
        /* 1402 */
        /* 1403 */
        /* 1404 */
        /* 1405 */
        /* 1406 */
        /* 1407 */
        /* 1408 */
        /* 1409 */
        /* 1410 */
        /* 1411 */
        /* 1412 */
        /* 1413 */
        /* 1414 */
        /* 1415 */
        /* 1416 */
        /* 1417 */
        /* 1418 */
        /* 1419 */
        /* 1420 */
        /* 1421 */
        /* 1422 */
        /* 1423 */
        /* 1424 */
        /* 1425 */
        /* 1426 */
        /* 1427 */
        /* 1428 */
        /* 1429 */
        /* 1430 */
        /* 1431 */
        /* 1432 */
        /* 1433 */
        /* 1434 */
        /* 1435 */
        /* 1436 */
        /* 1437 */
        /* 1438 */
        /* 1439 */
        /* 1440 */
        /* 1441 */
        /* 1442 */
        /* 1443 */
        /* 1444 */
        /* 1445 */
        /* 1446 */
        /* 1447 */
        /* 1448 */
        /* 1449 */
        /* 1450 */
        /* 1451 */
        /* 1452 */
        /* 1453 */
        /* 1454 */
        /* 1455 */
        /* 1456 */
        /* 1457 */
        /* 1458 */
        /* 1459 */
        /* 1460 */
        /* 1461 */
        /* 1462 */
        /* 1463 */
        /* 1464 */
        /* 1465 */
        /* 1466 */
        /* 1467 */
        /* 1468 */
        /* 1469 */
        /* 1470 */
        /* 1471 */
        /* 1472 */
        /* 1473 */
        /* 1474 */
        /* 1475 */
        /* 1476 */
        /* 1477 */
        /* 1478 */
        /* 1479 */
        /* 1480 */
        /* 1481 */
        /* 1482 */
        /* 1483 */
        /* 1484 */
        /* 1485 */
        /* 1486 */
        /* 1487 */
        /* 1488 */
        /* 1489 */
        /* 1490 */
        /* 1491 */
        /* 1492 */
        /* 1493 */
        /* 1494 */
        /* 1495 */
        /* 1496 */
        /* 1497 */
        /* 1498 */
        /* 1499 */
        /* 1500 */
        /* 1501 */
        /* 1502 */
        /* 1503 */
        /* 1504 */
        /* 1505 */
        /* 1506 */
        /* 1507 */
        /* 1508 */
        /* 1509 */
        /* 1510 */
        /* 1511 */
        /* 1512 */
        /* 1513 */
        /* 1514 */
        /* 1515 */
        /* 1516 */
        /* 1517 */
        /* 1518 */
        /* 1519 */
        /* 1520 */
        /* 1521 */
        /* 1522 */
        /* 1523 */
        /* 1524 */
        /* 1525 */
        /* 1526 */
        /* 1527 */
        /* 1528 */
        /* 1529 */
        /* 1530 */
        /* 1531 */
        /* 1532 */
        /* 1533 */
        /* 1534 */
        /* 1535 */
        /* 1536 */
        /* 1537 */
        /* 1538 */
        /* 1539 */
        /* 1540 */
        /* 1541 */
        /* 1542 */
        /* 1543 */

        /* 1546 */
        /* 1547 */

        /* 1549 */
        /* 1550 */

        /* 1552 */
        /* 1553 */

        /* 1555 */
        /* 1556 */
        /* 1557 */
        /* 1558 */

        /* 1561 */
        /* 1562 */

        /* 1564 */
        /* 1565 */
        /* 1566 */

        /* 1568 */
        /* 1569 */

        /* 1571 */
        /* 1572 */

        /* 1574 */
        /* 1575 */

        /* 1577 */

        /* 1579 */
        /* 1580 */

        /* 1582 */
        /* 1583 */
        /* 1584 */
        /* 1585 */

        /* 1587 */
        /* 1588 */

        /* 1591 */
        /* 1592 */
        /* 1593 */
        /* 1594 */

        /* 1597 */
        /* 1598 */

        /* 1600 */
        /* 1601 */
        /* 1602 */

        /* 1604 */
        /* 1605 */
        /* 1606 */

        /* 1608 */
        /* 1609 */

        /* 1611 */

        /* 1613 */
        /* 1614 */

        /* 1616 */
        /* 1617 */

        /* 1619 */

        /* 1621 */
        /* 1622 */

        /* 1624 */
        /* 1625 */
        /* 1626 */
        /* 1627 */

        /* 1629 */
        /* 1630 */

        /* 1632 */

        /* 1634 */

        /* 1636 */
        /* 1637 */
        /* 1638 */

        /* 1640 */
        /* 1641 */

        /* 1643 */

        /* 1645 */
        /* 1646 */
        /* 1647 */

        /* 1649 */
        /* 1650 */
        /* 1651 */

        /* 1654 */
        /* 1655 */
        /* 1656 */

        /* 1658 */
        /* 1659 */
        /* 1660 */

        /* 1663 */
        /* 1664 */
        /* 1665 */
        /* 1666 */
      , /* 14 */
      /***/function (module, exports) {
        "use strict";

        function createObjectWithProperties(originalObj, properties) {
          var result = {};
          for (var _iterator = properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;
            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }
            var property = _ref;
            if (property in originalObj) {
              result[property] = originalObj[property];
            }
          }
          return result;
        }
        module.exports = createObjectWithProperties;

        /***/
      }, /* 15 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(141);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      }, /* 16 */
      [1648, 196], /* 17 */
      /***/function (module, exports) {
        /**
         * Checks if `value` is classified as an `Array` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array, else `false`.
         * @example
         *
         * _.isArray([1, 2, 3]);
         * // => true
         *
         * _.isArray(document.body.children);
         * // => false
         *
         * _.isArray('abc');
         * // => false
         *
         * _.isArray(_.noop);
         * // => false
         */
        var isArray = Array.isArray;
        module.exports = isArray;

        /***/
      }, /* 18 */
      /***/function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        (function (global, factory) {
          true ? module.exports = factory() : undefined;
        })(this, function () {
          'use strict';

          var SLICE$0 = Array.prototype.slice;
          function createClass(ctor, superClass) {
            if (superClass) {
              ctor.prototype = Object.create(superClass.prototype);
            }
            ctor.prototype.constructor = ctor;
          }
          function Iterable(value) {
            return isIterable(value) ? value : Seq(value);
          }
          createClass(KeyedIterable, Iterable);
          function KeyedIterable(value) {
            return isKeyed(value) ? value : KeyedSeq(value);
          }
          createClass(IndexedIterable, Iterable);
          function IndexedIterable(value) {
            return isIndexed(value) ? value : IndexedSeq(value);
          }
          createClass(SetIterable, Iterable);
          function SetIterable(value) {
            return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
          }
          function isIterable(maybeIterable) {
            return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
          }
          function isKeyed(maybeKeyed) {
            return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
          }
          function isIndexed(maybeIndexed) {
            return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
          }
          function isAssociative(maybeAssociative) {
            return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
          }
          function isOrdered(maybeOrdered) {
            return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
          }
          Iterable.isIterable = isIterable;
          Iterable.isKeyed = isKeyed;
          Iterable.isIndexed = isIndexed;
          Iterable.isAssociative = isAssociative;
          Iterable.isOrdered = isOrdered;
          Iterable.Keyed = KeyedIterable;
          Iterable.Indexed = IndexedIterable;
          Iterable.Set = SetIterable;
          var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
          var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
          var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
          var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

          // Used for setting prototype methods that IE8 chokes on.
          var DELETE = 'delete';

          // Constants describing the size of trie nodes.
          var SHIFT = 5; // Resulted in best performance after ______?
          var SIZE = 1 << SHIFT;
          var MASK = SIZE - 1;

          // A consistent shared value representing "not set" which equals nothing other
          // than itself, and nothing that could be provided externally.
          var NOT_SET = {};

          // Boolean references, Rough equivalent of `bool &`.
          var CHANGE_LENGTH = {
            value: false
          };
          var DID_ALTER = {
            value: false
          };
          function MakeRef(ref) {
            ref.value = false;
            return ref;
          }
          function SetRef(ref) {
            ref && (ref.value = true);
          }

          // A function which returns a value representing an "owner" for transient writes
          // to tries. The return value will only ever equal itself, and will not equal
          // the return of any subsequent call of this function.
          function OwnerID() {}

          // http://jsperf.com/copy-array-inline
          function arrCopy(arr, offset) {
            offset = offset || 0;
            var len = Math.max(0, arr.length - offset);
            var newArr = new Array(len);
            for (var ii = 0; ii < len; ii++) {
              newArr[ii] = arr[ii + offset];
            }
            return newArr;
          }
          function ensureSize(iter) {
            if (iter.size === undefined) {
              iter.size = iter.__iterate(returnTrue);
            }
            return iter.size;
          }
          function wrapIndex(iter, index) {
            // This implements "is array index" which the ECMAString spec defines as:
            //
            //     A String property name P is an array index if and only if
            //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
            //     to 2^32−1.
            //
            // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
            if (typeof index !== 'number') {
              var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
              if ('' + uint32Index !== index || uint32Index === 4294967295) {
                return NaN;
              }
              index = uint32Index;
            }
            return index < 0 ? ensureSize(iter) + index : index;
          }
          function returnTrue() {
            return true;
          }
          function wholeSlice(begin, end, size) {
            return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
          }
          function resolveBegin(begin, size) {
            return resolveIndex(begin, size, 0);
          }
          function resolveEnd(end, size) {
            return resolveIndex(end, size, size);
          }
          function resolveIndex(index, size, defaultIndex) {
            return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
          }

          /* global Symbol */

          var ITERATE_KEYS = 0;
          var ITERATE_VALUES = 1;
          var ITERATE_ENTRIES = 2;
          var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
          var FAUX_ITERATOR_SYMBOL = '@@iterator';
          var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
          function Iterator(next) {
            this.next = next;
          }
          Iterator.prototype.toString = function () {
            return '[Iterator]';
          };
          Iterator.KEYS = ITERATE_KEYS;
          Iterator.VALUES = ITERATE_VALUES;
          Iterator.ENTRIES = ITERATE_ENTRIES;
          Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
            return this.toString();
          };
          Iterator.prototype[ITERATOR_SYMBOL] = function () {
            return this;
          };
          function iteratorValue(type, k, v, iteratorResult) {
            var value = type === 0 ? k : type === 1 ? v : [k, v];
            iteratorResult ? iteratorResult.value = value : iteratorResult = {
              value: value,
              done: false
            };
            return iteratorResult;
          }
          function iteratorDone() {
            return {
              value: undefined,
              done: true
            };
          }
          function hasIterator(maybeIterable) {
            return !!getIteratorFn(maybeIterable);
          }
          function isIterator(maybeIterator) {
            return maybeIterator && typeof maybeIterator.next === 'function';
          }
          function getIterator(iterable) {
            var iteratorFn = getIteratorFn(iterable);
            return iteratorFn && iteratorFn.call(iterable);
          }
          function getIteratorFn(iterable) {
            var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
            if (typeof iteratorFn === 'function') {
              return iteratorFn;
            }
          }
          function isArrayLike(value) {
            return value && typeof value.length === 'number';
          }
          createClass(Seq, Iterable);
          function Seq(value) {
            return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
          }
          Seq.of = function /*...values*/
          () {
            return Seq(arguments);
          };
          Seq.prototype.toSeq = function () {
            return this;
          };
          Seq.prototype.toString = function () {
            return this.__toString('Seq {', '}');
          };
          Seq.prototype.cacheResult = function () {
            if (!this._cache && this.__iterateUncached) {
              this._cache = this.entrySeq().toArray();
              this.size = this._cache.length;
            }
            return this;
          };

          // abstract __iterateUncached(fn, reverse)

          Seq.prototype.__iterate = function (fn, reverse) {
            return seqIterate(this, fn, reverse, true);
          };

          // abstract __iteratorUncached(type, reverse)

          Seq.prototype.__iterator = function (type, reverse) {
            return seqIterator(this, type, reverse, true);
          };
          createClass(KeyedSeq, Seq);
          function KeyedSeq(value) {
            return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
          }
          KeyedSeq.prototype.toKeyedSeq = function () {
            return this;
          };
          createClass(IndexedSeq, Seq);
          function IndexedSeq(value) {
            return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
          }
          IndexedSeq.of = function /*...values*/
          () {
            return IndexedSeq(arguments);
          };
          IndexedSeq.prototype.toIndexedSeq = function () {
            return this;
          };
          IndexedSeq.prototype.toString = function () {
            return this.__toString('Seq [', ']');
          };
          IndexedSeq.prototype.__iterate = function (fn, reverse) {
            return seqIterate(this, fn, reverse, false);
          };
          IndexedSeq.prototype.__iterator = function (type, reverse) {
            return seqIterator(this, type, reverse, false);
          };
          createClass(SetSeq, Seq);
          function SetSeq(value) {
            return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
          }
          SetSeq.of = function /*...values*/
          () {
            return SetSeq(arguments);
          };
          SetSeq.prototype.toSetSeq = function () {
            return this;
          };
          Seq.isSeq = isSeq;
          Seq.Keyed = KeyedSeq;
          Seq.Set = SetSeq;
          Seq.Indexed = IndexedSeq;
          var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
          Seq.prototype[IS_SEQ_SENTINEL] = true;
          createClass(ArraySeq, IndexedSeq);
          function ArraySeq(array) {
            this._array = array;
            this.size = array.length;
          }
          ArraySeq.prototype.get = function (index, notSetValue) {
            return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
          };
          ArraySeq.prototype.__iterate = function (fn, reverse) {
            var array = this._array;
            var maxIndex = array.length - 1;
            for (var ii = 0; ii <= maxIndex; ii++) {
              if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
                return ii + 1;
              }
            }
            return ii;
          };
          ArraySeq.prototype.__iterator = function (type, reverse) {
            var array = this._array;
            var maxIndex = array.length - 1;
            var ii = 0;
            return new Iterator(function () {
              return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
            });
          };
          createClass(ObjectSeq, KeyedSeq);
          function ObjectSeq(object) {
            var keys = Object.keys(object);
            this._object = object;
            this._keys = keys;
            this.size = keys.length;
          }
          ObjectSeq.prototype.get = function (key, notSetValue) {
            if (notSetValue !== undefined && !this.has(key)) {
              return notSetValue;
            }
            return this._object[key];
          };
          ObjectSeq.prototype.has = function (key) {
            return this._object.hasOwnProperty(key);
          };
          ObjectSeq.prototype.__iterate = function (fn, reverse) {
            var object = this._object;
            var keys = this._keys;
            var maxIndex = keys.length - 1;
            for (var ii = 0; ii <= maxIndex; ii++) {
              var key = keys[reverse ? maxIndex - ii : ii];
              if (fn(object[key], key, this) === false) {
                return ii + 1;
              }
            }
            return ii;
          };
          ObjectSeq.prototype.__iterator = function (type, reverse) {
            var object = this._object;
            var keys = this._keys;
            var maxIndex = keys.length - 1;
            var ii = 0;
            return new Iterator(function () {
              var key = keys[reverse ? maxIndex - ii : ii];
              return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
            });
          };
          ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
          createClass(IterableSeq, IndexedSeq);
          function IterableSeq(iterable) {
            this._iterable = iterable;
            this.size = iterable.length || iterable.size;
          }
          IterableSeq.prototype.__iterateUncached = function (fn, reverse) {
            if (reverse) {
              return this.cacheResult().__iterate(fn, reverse);
            }
            var iterable = this._iterable;
            var iterator = getIterator(iterable);
            var iterations = 0;
            if (isIterator(iterator)) {
              var step;
              while (!(step = iterator.next()).done) {
                if (fn(step.value, iterations++, this) === false) {
                  break;
                }
              }
            }
            return iterations;
          };
          IterableSeq.prototype.__iteratorUncached = function (type, reverse) {
            if (reverse) {
              return this.cacheResult().__iterator(type, reverse);
            }
            var iterable = this._iterable;
            var iterator = getIterator(iterable);
            if (!isIterator(iterator)) {
              return new Iterator(iteratorDone);
            }
            var iterations = 0;
            return new Iterator(function () {
              var step = iterator.next();
              return step.done ? step : iteratorValue(type, iterations++, step.value);
            });
          };
          createClass(IteratorSeq, IndexedSeq);
          function IteratorSeq(iterator) {
            this._iterator = iterator;
            this._iteratorCache = [];
          }
          IteratorSeq.prototype.__iterateUncached = function (fn, reverse) {
            if (reverse) {
              return this.cacheResult().__iterate(fn, reverse);
            }
            var iterator = this._iterator;
            var cache = this._iteratorCache;
            var iterations = 0;
            while (iterations < cache.length) {
              if (fn(cache[iterations], iterations++, this) === false) {
                return iterations;
              }
            }
            var step;
            while (!(step = iterator.next()).done) {
              var val = step.value;
              cache[iterations] = val;
              if (fn(val, iterations++, this) === false) {
                break;
              }
            }
            return iterations;
          };
          IteratorSeq.prototype.__iteratorUncached = function (type, reverse) {
            if (reverse) {
              return this.cacheResult().__iterator(type, reverse);
            }
            var iterator = this._iterator;
            var cache = this._iteratorCache;
            var iterations = 0;
            return new Iterator(function () {
              if (iterations >= cache.length) {
                var step = iterator.next();
                if (step.done) {
                  return step;
                }
                cache[iterations] = step.value;
              }
              return iteratorValue(type, iterations, cache[iterations++]);
            });
          };

          // # pragma Helper functions

          function isSeq(maybeSeq) {
            return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
          }
          var EMPTY_SEQ;
          function emptySequence() {
            return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
          }
          function keyedSeqFromValue(value) {
            var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === 'object' ? new ObjectSeq(value) : undefined;
            if (!seq) {
              throw new TypeError('Expected Array or iterable object of [k, v] entries, ' + 'or keyed object: ' + value);
            }
            return seq;
          }
          function indexedSeqFromValue(value) {
            var seq = maybeIndexedSeqFromValue(value);
            if (!seq) {
              throw new TypeError('Expected Array or iterable object of values: ' + value);
            }
            return seq;
          }
          function seqFromValue(value) {
            var seq = maybeIndexedSeqFromValue(value) || typeof value === 'object' && new ObjectSeq(value);
            if (!seq) {
              throw new TypeError('Expected Array or iterable object of values, or keyed object: ' + value);
            }
            return seq;
          }
          function maybeIndexedSeqFromValue(value) {
            return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
          }
          function seqIterate(seq, fn, reverse, useKeys) {
            var cache = seq._cache;
            if (cache) {
              var maxIndex = cache.length - 1;
              for (var ii = 0; ii <= maxIndex; ii++) {
                var entry = cache[reverse ? maxIndex - ii : ii];
                if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
                  return ii + 1;
                }
              }
              return ii;
            }
            return seq.__iterateUncached(fn, reverse);
          }
          function seqIterator(seq, type, reverse, useKeys) {
            var cache = seq._cache;
            if (cache) {
              var maxIndex = cache.length - 1;
              var ii = 0;
              return new Iterator(function () {
                var entry = cache[reverse ? maxIndex - ii : ii];
                return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
              });
            }
            return seq.__iteratorUncached(type, reverse);
          }
          function fromJS(json, converter) {
            return converter ? fromJSWith(converter, json, '', {
              '': json
            }) : fromJSDefault(json);
          }
          function fromJSWith(converter, json, key, parentJSON) {
            if (Array.isArray(json)) {
              return converter.call(parentJSON, key, IndexedSeq(json).map(function (v, k) {
                return fromJSWith(converter, v, k, json);
              }));
            }
            if (isPlainObj(json)) {
              return converter.call(parentJSON, key, KeyedSeq(json).map(function (v, k) {
                return fromJSWith(converter, v, k, json);
              }));
            }
            return json;
          }
          function fromJSDefault(json) {
            if (Array.isArray(json)) {
              return IndexedSeq(json).map(fromJSDefault).toList();
            }
            if (isPlainObj(json)) {
              return KeyedSeq(json).map(fromJSDefault).toMap();
            }
            return json;
          }
          function isPlainObj(value) {
            return value && (value.constructor === Object || value.constructor === undefined);
          }

          /**
           * An extension of the "same-value" algorithm as [described for use by ES6 Map
           * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
           *
           * NaN is considered the same as NaN, however -0 and 0 are considered the same
           * value, which is different from the algorithm described by
           * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
           *
           * This is extended further to allow Objects to describe the values they
           * represent, by way of `valueOf` or `equals` (and `hashCode`).
           *
           * Note: because of this extension, the key equality of Immutable.Map and the
           * value equality of Immutable.Set will differ from ES6 Map and Set.
           *
           * ### Defining custom values
           *
           * The easiest way to describe the value an object represents is by implementing
           * `valueOf`. For example, `Date` represents a value by returning a unix
           * timestamp for `valueOf`:
           *
           *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
           *     var date2 = new Date(1234567890000);
           *     date1.valueOf(); // 1234567890000
           *     assert( date1 !== date2 );
           *     assert( Immutable.is( date1, date2 ) );
           *
           * Note: overriding `valueOf` may have other implications if you use this object
           * where JavaScript expects a primitive, such as implicit string coercion.
           *
           * For more complex types, especially collections, implementing `valueOf` may
           * not be performant. An alternative is to implement `equals` and `hashCode`.
           *
           * `equals` takes another object, presumably of similar type, and returns true
           * if the it is equal. Equality is symmetrical, so the same result should be
           * returned if this and the argument are flipped.
           *
           *     assert( a.equals(b) === b.equals(a) );
           *
           * `hashCode` returns a 32bit integer number representing the object which will
           * be used to determine how to store the value object in a Map or Set. You must
           * provide both or neither methods, one must not exist without the other.
           *
           * Also, an important relationship between these methods must be upheld: if two
           * values are equal, they *must* return the same hashCode. If the values are not
           * equal, they might have the same hashCode; this is called a hash collision,
           * and while undesirable for performance reasons, it is acceptable.
           *
           *     if (a.equals(b)) {
           *       assert( a.hashCode() === b.hashCode() );
           *     }
           *
           * All Immutable collections implement `equals` and `hashCode`.
           *
           */
          function is(valueA, valueB) {
            if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
              return true;
            }
            if (!valueA || !valueB) {
              return false;
            }
            if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
              valueA = valueA.valueOf();
              valueB = valueB.valueOf();
              if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
                return true;
              }
              if (!valueA || !valueB) {
                return false;
              }
            }
            if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) {
              return true;
            }
            return false;
          }
          function deepEqual(a, b) {
            if (a === b) {
              return true;
            }
            if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) {
              return false;
            }
            if (a.size === 0 && b.size === 0) {
              return true;
            }
            var notAssociative = !isAssociative(a);
            if (isOrdered(a)) {
              var entries = a.entries();
              return b.every(function (v, k) {
                var entry = entries.next().value;
                return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
              }) && entries.next().done;
            }
            var flipped = false;
            if (a.size === undefined) {
              if (b.size === undefined) {
                if (typeof a.cacheResult === 'function') {
                  a.cacheResult();
                }
              } else {
                flipped = true;
                var _ = a;
                a = b;
                b = _;
              }
            }
            var allEqual = true;
            var bSize = b.__iterate(function (v, k) {
              if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
                allEqual = false;
                return false;
              }
            });
            return allEqual && a.size === bSize;
          }
          createClass(Repeat, IndexedSeq);
          function Repeat(value, times) {
            if (!(this instanceof Repeat)) {
              return new Repeat(value, times);
            }
            this._value = value;
            this.size = times === undefined ? Infinity : Math.max(0, times);
            if (this.size === 0) {
              if (EMPTY_REPEAT) {
                return EMPTY_REPEAT;
              }
              EMPTY_REPEAT = this;
            }
          }
          Repeat.prototype.toString = function () {
            if (this.size === 0) {
              return 'Repeat []';
            }
            return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
          };
          Repeat.prototype.get = function (index, notSetValue) {
            return this.has(index) ? this._value : notSetValue;
          };
          Repeat.prototype.includes = function (searchValue) {
            return is(this._value, searchValue);
          };
          Repeat.prototype.slice = function (begin, end) {
            var size = this.size;
            return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
          };
          Repeat.prototype.reverse = function () {
            return this;
          };
          Repeat.prototype.indexOf = function (searchValue) {
            if (is(this._value, searchValue)) {
              return 0;
            }
            return -1;
          };
          Repeat.prototype.lastIndexOf = function (searchValue) {
            if (is(this._value, searchValue)) {
              return this.size;
            }
            return -1;
          };
          Repeat.prototype.__iterate = function (fn, reverse) {
            for (var ii = 0; ii < this.size; ii++) {
              if (fn(this._value, ii, this) === false) {
                return ii + 1;
              }
            }
            return ii;
          };
          Repeat.prototype.__iterator = function (type, reverse) {
            var this$0 = this;
            var ii = 0;
            return new Iterator(function () {
              return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
            });
          };
          Repeat.prototype.equals = function (other) {
            return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
          };
          var EMPTY_REPEAT;
          function invariant(condition, error) {
            if (!condition) throw new Error(error);
          }
          createClass(Range, IndexedSeq);
          function Range(start, end, step) {
            if (!(this instanceof Range)) {
              return new Range(start, end, step);
            }
            invariant(step !== 0, 'Cannot step a Range by 0');
            start = start || 0;
            if (end === undefined) {
              end = Infinity;
            }
            step = step === undefined ? 1 : Math.abs(step);
            if (end < start) {
              step = -step;
            }
            this._start = start;
            this._end = end;
            this._step = step;
            this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
            if (this.size === 0) {
              if (EMPTY_RANGE) {
                return EMPTY_RANGE;
              }
              EMPTY_RANGE = this;
            }
          }
          Range.prototype.toString = function () {
            if (this.size === 0) {
              return 'Range []';
            }
            return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
          };
          Range.prototype.get = function (index, notSetValue) {
            return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
          };
          Range.prototype.includes = function (searchValue) {
            var possibleIndex = (searchValue - this._start) / this._step;
            return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
          };
          Range.prototype.slice = function (begin, end) {
            if (wholeSlice(begin, end, this.size)) {
              return this;
            }
            begin = resolveBegin(begin, this.size);
            end = resolveEnd(end, this.size);
            if (end <= begin) {
              return new Range(0, 0);
            }
            return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
          };
          Range.prototype.indexOf = function (searchValue) {
            var offsetValue = searchValue - this._start;
            if (offsetValue % this._step === 0) {
              var index = offsetValue / this._step;
              if (index >= 0 && index < this.size) {
                return index;
              }
            }
            return -1;
          };
          Range.prototype.lastIndexOf = function (searchValue) {
            return this.indexOf(searchValue);
          };
          Range.prototype.__iterate = function (fn, reverse) {
            var maxIndex = this.size - 1;
            var step = this._step;
            var value = reverse ? this._start + maxIndex * step : this._start;
            for (var ii = 0; ii <= maxIndex; ii++) {
              if (fn(value, ii, this) === false) {
                return ii + 1;
              }
              value += reverse ? -step : step;
            }
            return ii;
          };
          Range.prototype.__iterator = function (type, reverse) {
            var maxIndex = this.size - 1;
            var step = this._step;
            var value = reverse ? this._start + maxIndex * step : this._start;
            var ii = 0;
            return new Iterator(function () {
              var v = value;
              value += reverse ? -step : step;
              return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
            });
          };
          Range.prototype.equals = function (other) {
            return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
          };
          var EMPTY_RANGE;
          createClass(Collection, Iterable);
          function Collection() {
            throw TypeError('Abstract');
          }
          createClass(KeyedCollection, Collection);
          function KeyedCollection() {}
          createClass(IndexedCollection, Collection);
          function IndexedCollection() {}
          createClass(SetCollection, Collection);
          function SetCollection() {}
          Collection.Keyed = KeyedCollection;
          Collection.Indexed = IndexedCollection;
          Collection.Set = SetCollection;
          var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
            a = a | 0; // int
            b = b | 0; // int
            var c = a & 0xffff;
            var d = b & 0xffff;
            // Shift by 0 fixes the sign on the high part.
            return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
          };

          // v8 has an optimization for storing 31-bit signed numbers.
          // Values which have either 00 or 11 as the high order bits qualify.
          // This function drops the highest order bit in a signed number, maintaining
          // the sign bit.
          function smi(i32) {
            return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
          }
          function hash(o) {
            if (o === false || o === null || o === undefined) {
              return 0;
            }
            if (typeof o.valueOf === 'function') {
              o = o.valueOf();
              if (o === false || o === null || o === undefined) {
                return 0;
              }
            }
            if (o === true) {
              return 1;
            }
            var type = typeof o;
            if (type === 'number') {
              if (o !== o || o === Infinity) {
                return 0;
              }
              var h = o | 0;
              if (h !== o) {
                h ^= o * 0xFFFFFFFF;
              }
              while (o > 0xFFFFFFFF) {
                o /= 0xFFFFFFFF;
                h ^= o;
              }
              return smi(h);
            }
            if (type === 'string') {
              return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
            }
            if (typeof o.hashCode === 'function') {
              return o.hashCode();
            }
            if (type === 'object') {
              return hashJSObj(o);
            }
            if (typeof o.toString === 'function') {
              return hashString(o.toString());
            }
            throw new Error('Value type ' + type + ' cannot be hashed.');
          }
          function cachedHashString(string) {
            var hash = stringHashCache[string];
            if (hash === undefined) {
              hash = hashString(string);
              if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
                STRING_HASH_CACHE_SIZE = 0;
                stringHashCache = {};
              }
              STRING_HASH_CACHE_SIZE++;
              stringHashCache[string] = hash;
            }
            return hash;
          }

          // http://jsperf.com/hashing-strings
          function hashString(string) {
            // This is the hash from JVM
            // The hash code for a string is computed as
            // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
            // where s[i] is the ith character of the string and n is the length of
            // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
            // (exclusive) by dropping high bits.
            var hash = 0;
            for (var ii = 0; ii < string.length; ii++) {
              hash = 31 * hash + string.charCodeAt(ii) | 0;
            }
            return smi(hash);
          }
          function hashJSObj(obj) {
            var hash;
            if (usingWeakMap) {
              hash = weakMap.get(obj);
              if (hash !== undefined) {
                return hash;
              }
            }
            hash = obj[UID_HASH_KEY];
            if (hash !== undefined) {
              return hash;
            }
            if (!canDefineProperty) {
              hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
              if (hash !== undefined) {
                return hash;
              }
              hash = getIENodeHash(obj);
              if (hash !== undefined) {
                return hash;
              }
            }
            hash = ++objHashUID;
            if (objHashUID & 0x40000000) {
              objHashUID = 0;
            }
            if (usingWeakMap) {
              weakMap.set(obj, hash);
            } else if (isExtensible !== undefined && isExtensible(obj) === false) {
              throw new Error('Non-extensible objects are not allowed as keys.');
            } else if (canDefineProperty) {
              Object.defineProperty(obj, UID_HASH_KEY, {
                'enumerable': false,
                'configurable': false,
                'writable': false,
                'value': hash
              });
            } else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
              // Since we can't define a non-enumerable property on the object
              // we'll hijack one of the less-used non-enumerable properties to
              // save our hash on it. Since this is a function it will not show up in
              // `JSON.stringify` which is what we want.
              obj.propertyIsEnumerable = function () {
                return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
              };
              obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
            } else if (obj.nodeType !== undefined) {
              // At this point we couldn't get the IE `uniqueID` to use as a hash
              // and we couldn't use a non-enumerable property to exploit the
              // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
              // itself.
              obj[UID_HASH_KEY] = hash;
            } else {
              throw new Error('Unable to set a non-enumerable property on object.');
            }
            return hash;
          }

          // Get references to ES5 object methods.
          var isExtensible = Object.isExtensible;

          // True if Object.defineProperty works as expected. IE8 fails this test.
          var canDefineProperty = function () {
            try {
              Object.defineProperty({}, '@', {});
              return true;
            } catch (e) {
              return false;
            }
          }();

          // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
          // and avoid memory leaks from the IE cloneNode bug.
          function getIENodeHash(node) {
            if (node && node.nodeType > 0) {
              switch (node.nodeType) {
                case 1:
                  // Element
                  return node.uniqueID;
                case 9:
                  // Document
                  return node.documentElement && node.documentElement.uniqueID;
              }
            }
          }

          // If possible, use a WeakMap.
          var usingWeakMap = typeof WeakMap === 'function';
          var weakMap;
          if (usingWeakMap) {
            weakMap = new WeakMap();
          }
          var objHashUID = 0;
          var UID_HASH_KEY = '__immutablehash__';
          if (typeof Symbol === 'function') {
            UID_HASH_KEY = Symbol(UID_HASH_KEY);
          }
          var STRING_HASH_CACHE_MIN_STRLEN = 16;
          var STRING_HASH_CACHE_MAX_SIZE = 255;
          var STRING_HASH_CACHE_SIZE = 0;
          var stringHashCache = {};
          function assertNotInfinite(size) {
            invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
          }
          createClass(Map, KeyedCollection);

          // @pragma Construction

          function Map(value) {
            return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function (map) {
              var iter = KeyedIterable(value);
              assertNotInfinite(iter.size);
              iter.forEach(function (v, k) {
                return map.set(k, v);
              });
            });
          }
          Map.of = function () {
            var keyValues = SLICE$0.call(arguments, 0);
            return emptyMap().withMutations(function (map) {
              for (var i = 0; i < keyValues.length; i += 2) {
                if (i + 1 >= keyValues.length) {
                  throw new Error('Missing value for key: ' + keyValues[i]);
                }
                map.set(keyValues[i], keyValues[i + 1]);
              }
            });
          };
          Map.prototype.toString = function () {
            return this.__toString('Map {', '}');
          };

          // @pragma Access

          Map.prototype.get = function (k, notSetValue) {
            return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
          };

          // @pragma Modification

          Map.prototype.set = function (k, v) {
            return updateMap(this, k, v);
          };
          Map.prototype.setIn = function (keyPath, v) {
            return this.updateIn(keyPath, NOT_SET, function () {
              return v;
            });
          };
          Map.prototype.remove = function (k) {
            return updateMap(this, k, NOT_SET);
          };
          Map.prototype.deleteIn = function (keyPath) {
            return this.updateIn(keyPath, function () {
              return NOT_SET;
            });
          };
          Map.prototype.update = function (k, notSetValue, updater) {
            return arguments.length === 1 ? k(this) : this.updateIn([k], notSetValue, updater);
          };
          Map.prototype.updateIn = function (keyPath, notSetValue, updater) {
            if (!updater) {
              updater = notSetValue;
              notSetValue = undefined;
            }
            var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
            return updatedValue === NOT_SET ? undefined : updatedValue;
          };
          Map.prototype.clear = function () {
            if (this.size === 0) {
              return this;
            }
            if (this.__ownerID) {
              this.size = 0;
              this._root = null;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return emptyMap();
          };

          // @pragma Composition

          Map.prototype.merge = function /*...iters*/
          () {
            return mergeIntoMapWith(this, undefined, arguments);
          };
          Map.prototype.mergeWith = function (merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoMapWith(this, merger, iters);
          };
          Map.prototype.mergeIn = function (keyPath) {
            var iters = SLICE$0.call(arguments, 1);
            return this.updateIn(keyPath, emptyMap(), function (m) {
              return typeof m.merge === 'function' ? m.merge.apply(m, iters) : iters[iters.length - 1];
            });
          };
          Map.prototype.mergeDeep = function /*...iters*/
          () {
            return mergeIntoMapWith(this, deepMerger, arguments);
          };
          Map.prototype.mergeDeepWith = function (merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoMapWith(this, deepMergerWith(merger), iters);
          };
          Map.prototype.mergeDeepIn = function (keyPath) {
            var iters = SLICE$0.call(arguments, 1);
            return this.updateIn(keyPath, emptyMap(), function (m) {
              return typeof m.mergeDeep === 'function' ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
            });
          };
          Map.prototype.sort = function (comparator) {
            // Late binding
            return OrderedMap(sortFactory(this, comparator));
          };
          Map.prototype.sortBy = function (mapper, comparator) {
            // Late binding
            return OrderedMap(sortFactory(this, comparator, mapper));
          };

          // @pragma Mutability

          Map.prototype.withMutations = function (fn) {
            var mutable = this.asMutable();
            fn(mutable);
            return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
          };
          Map.prototype.asMutable = function () {
            return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
          };
          Map.prototype.asImmutable = function () {
            return this.__ensureOwner();
          };
          Map.prototype.wasAltered = function () {
            return this.__altered;
          };
          Map.prototype.__iterator = function (type, reverse) {
            return new MapIterator(this, type, reverse);
          };
          Map.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            this._root && this._root.iterate(function (entry) {
              iterations++;
              return fn(entry[1], entry[0], this$0);
            }, reverse);
            return iterations;
          };
          Map.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            if (!ownerID) {
              this.__ownerID = ownerID;
              this.__altered = false;
              return this;
            }
            return makeMap(this.size, this._root, ownerID, this.__hash);
          };
          function isMap(maybeMap) {
            return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
          }
          Map.isMap = isMap;
          var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
          var MapPrototype = Map.prototype;
          MapPrototype[IS_MAP_SENTINEL] = true;
          MapPrototype[DELETE] = MapPrototype.remove;
          MapPrototype.removeIn = MapPrototype.deleteIn;

          // #pragma Trie Nodes

          function ArrayMapNode(ownerID, entries) {
            this.ownerID = ownerID;
            this.entries = entries;
          }
          ArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
            var entries = this.entries;
            for (var ii = 0, len = entries.length; ii < len; ii++) {
              if (is(key, entries[ii][0])) {
                return entries[ii][1];
              }
            }
            return notSetValue;
          };
          ArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            var removed = value === NOT_SET;
            var entries = this.entries;
            var idx = 0;
            for (var len = entries.length; idx < len; idx++) {
              if (is(key, entries[idx][0])) {
                break;
              }
            }
            var exists = idx < len;
            if (exists ? entries[idx][1] === value : removed) {
              return this;
            }
            SetRef(didAlter);
            (removed || !exists) && SetRef(didChangeSize);
            if (removed && entries.length === 1) {
              return; // undefined
            }

            if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
              return createNodes(ownerID, entries, key, value);
            }
            var isEditable = ownerID && ownerID === this.ownerID;
            var newEntries = isEditable ? entries : arrCopy(entries);
            if (exists) {
              if (removed) {
                idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
              } else {
                newEntries[idx] = [key, value];
              }
            } else {
              newEntries.push([key, value]);
            }
            if (isEditable) {
              this.entries = newEntries;
              return this;
            }
            return new ArrayMapNode(ownerID, newEntries);
          };
          function BitmapIndexedNode(ownerID, bitmap, nodes) {
            this.ownerID = ownerID;
            this.bitmap = bitmap;
            this.nodes = nodes;
          }
          BitmapIndexedNode.prototype.get = function (shift, keyHash, key, notSetValue) {
            if (keyHash === undefined) {
              keyHash = hash(key);
            }
            var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
            var bitmap = this.bitmap;
            return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
          };
          BitmapIndexedNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            if (keyHash === undefined) {
              keyHash = hash(key);
            }
            var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
            var bit = 1 << keyHashFrag;
            var bitmap = this.bitmap;
            var exists = (bitmap & bit) !== 0;
            if (!exists && value === NOT_SET) {
              return this;
            }
            var idx = popCount(bitmap & bit - 1);
            var nodes = this.nodes;
            var node = exists ? nodes[idx] : undefined;
            var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
            if (newNode === node) {
              return this;
            }
            if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
              return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
            }
            if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
              return nodes[idx ^ 1];
            }
            if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
              return newNode;
            }
            var isEditable = ownerID && ownerID === this.ownerID;
            var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
            var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
            if (isEditable) {
              this.bitmap = newBitmap;
              this.nodes = newNodes;
              return this;
            }
            return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
          };
          function HashArrayMapNode(ownerID, count, nodes) {
            this.ownerID = ownerID;
            this.count = count;
            this.nodes = nodes;
          }
          HashArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
            if (keyHash === undefined) {
              keyHash = hash(key);
            }
            var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
            var node = this.nodes[idx];
            return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
          };
          HashArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            if (keyHash === undefined) {
              keyHash = hash(key);
            }
            var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
            var removed = value === NOT_SET;
            var nodes = this.nodes;
            var node = nodes[idx];
            if (removed && !node) {
              return this;
            }
            var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
            if (newNode === node) {
              return this;
            }
            var newCount = this.count;
            if (!node) {
              newCount++;
            } else if (!newNode) {
              newCount--;
              if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
                return packNodes(ownerID, nodes, newCount, idx);
              }
            }
            var isEditable = ownerID && ownerID === this.ownerID;
            var newNodes = setIn(nodes, idx, newNode, isEditable);
            if (isEditable) {
              this.count = newCount;
              this.nodes = newNodes;
              return this;
            }
            return new HashArrayMapNode(ownerID, newCount, newNodes);
          };
          function HashCollisionNode(ownerID, keyHash, entries) {
            this.ownerID = ownerID;
            this.keyHash = keyHash;
            this.entries = entries;
          }
          HashCollisionNode.prototype.get = function (shift, keyHash, key, notSetValue) {
            var entries = this.entries;
            for (var ii = 0, len = entries.length; ii < len; ii++) {
              if (is(key, entries[ii][0])) {
                return entries[ii][1];
              }
            }
            return notSetValue;
          };
          HashCollisionNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            if (keyHash === undefined) {
              keyHash = hash(key);
            }
            var removed = value === NOT_SET;
            if (keyHash !== this.keyHash) {
              if (removed) {
                return this;
              }
              SetRef(didAlter);
              SetRef(didChangeSize);
              return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
            }
            var entries = this.entries;
            var idx = 0;
            for (var len = entries.length; idx < len; idx++) {
              if (is(key, entries[idx][0])) {
                break;
              }
            }
            var exists = idx < len;
            if (exists ? entries[idx][1] === value : removed) {
              return this;
            }
            SetRef(didAlter);
            (removed || !exists) && SetRef(didChangeSize);
            if (removed && len === 2) {
              return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
            }
            var isEditable = ownerID && ownerID === this.ownerID;
            var newEntries = isEditable ? entries : arrCopy(entries);
            if (exists) {
              if (removed) {
                idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
              } else {
                newEntries[idx] = [key, value];
              }
            } else {
              newEntries.push([key, value]);
            }
            if (isEditable) {
              this.entries = newEntries;
              return this;
            }
            return new HashCollisionNode(ownerID, this.keyHash, newEntries);
          };
          function ValueNode(ownerID, keyHash, entry) {
            this.ownerID = ownerID;
            this.keyHash = keyHash;
            this.entry = entry;
          }
          ValueNode.prototype.get = function (shift, keyHash, key, notSetValue) {
            return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
          };
          ValueNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            var removed = value === NOT_SET;
            var keyMatch = is(key, this.entry[0]);
            if (keyMatch ? value === this.entry[1] : removed) {
              return this;
            }
            SetRef(didAlter);
            if (removed) {
              SetRef(didChangeSize);
              return; // undefined
            }

            if (keyMatch) {
              if (ownerID && ownerID === this.ownerID) {
                this.entry[1] = value;
                return this;
              }
              return new ValueNode(ownerID, this.keyHash, [key, value]);
            }
            SetRef(didChangeSize);
            return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
          };

          // #pragma Iterators

          ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function (fn, reverse) {
            var entries = this.entries;
            for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
              if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
                return false;
              }
            }
          };
          BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function (fn, reverse) {
            var nodes = this.nodes;
            for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
              var node = nodes[reverse ? maxIndex - ii : ii];
              if (node && node.iterate(fn, reverse) === false) {
                return false;
              }
            }
          };
          ValueNode.prototype.iterate = function (fn, reverse) {
            return fn(this.entry);
          };
          createClass(MapIterator, Iterator);
          function MapIterator(map, type, reverse) {
            this._type = type;
            this._reverse = reverse;
            this._stack = map._root && mapIteratorFrame(map._root);
          }
          MapIterator.prototype.next = function () {
            var type = this._type;
            var stack = this._stack;
            while (stack) {
              var node = stack.node;
              var index = stack.index++;
              var maxIndex;
              if (node.entry) {
                if (index === 0) {
                  return mapIteratorValue(type, node.entry);
                }
              } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) {
                  return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
                }
              } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                  var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                  if (subNode) {
                    if (subNode.entry) {
                      return mapIteratorValue(type, subNode.entry);
                    }
                    stack = this._stack = mapIteratorFrame(subNode, stack);
                  }
                  continue;
                }
              }
              stack = this._stack = this._stack.__prev;
            }
            return iteratorDone();
          };
          function mapIteratorValue(type, entry) {
            return iteratorValue(type, entry[0], entry[1]);
          }
          function mapIteratorFrame(node, prev) {
            return {
              node: node,
              index: 0,
              __prev: prev
            };
          }
          function makeMap(size, root, ownerID, hash) {
            var map = Object.create(MapPrototype);
            map.size = size;
            map._root = root;
            map.__ownerID = ownerID;
            map.__hash = hash;
            map.__altered = false;
            return map;
          }
          var EMPTY_MAP;
          function emptyMap() {
            return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
          }
          function updateMap(map, k, v) {
            var newRoot;
            var newSize;
            if (!map._root) {
              if (v === NOT_SET) {
                return map;
              }
              newSize = 1;
              newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
            } else {
              var didChangeSize = MakeRef(CHANGE_LENGTH);
              var didAlter = MakeRef(DID_ALTER);
              newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
              if (!didAlter.value) {
                return map;
              }
              newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
            }
            if (map.__ownerID) {
              map.size = newSize;
              map._root = newRoot;
              map.__hash = undefined;
              map.__altered = true;
              return map;
            }
            return newRoot ? makeMap(newSize, newRoot) : emptyMap();
          }
          function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
            if (!node) {
              if (value === NOT_SET) {
                return node;
              }
              SetRef(didAlter);
              SetRef(didChangeSize);
              return new ValueNode(ownerID, keyHash, [key, value]);
            }
            return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
          }
          function isLeafNode(node) {
            return node.constructor === ValueNode || node.constructor === HashCollisionNode;
          }
          function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
            if (node.keyHash === keyHash) {
              return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
            }
            var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
            var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
            var newNode;
            var nodes = idx1 === idx2 ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [node, newNode] : [newNode, node]);
            return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
          }
          function createNodes(ownerID, entries, key, value) {
            if (!ownerID) {
              ownerID = new OwnerID();
            }
            var node = new ValueNode(ownerID, hash(key), [key, value]);
            for (var ii = 0; ii < entries.length; ii++) {
              var entry = entries[ii];
              node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
            }
            return node;
          }
          function packNodes(ownerID, nodes, count, excluding) {
            var bitmap = 0;
            var packedII = 0;
            var packedNodes = new Array(count);
            for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
              var node = nodes[ii];
              if (node !== undefined && ii !== excluding) {
                bitmap |= bit;
                packedNodes[packedII++] = node;
              }
            }
            return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
          }
          function expandNodes(ownerID, nodes, bitmap, including, node) {
            var count = 0;
            var expandedNodes = new Array(SIZE);
            for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
              expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
            }
            expandedNodes[including] = node;
            return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
          }
          function mergeIntoMapWith(map, merger, iterables) {
            var iters = [];
            for (var ii = 0; ii < iterables.length; ii++) {
              var value = iterables[ii];
              var iter = KeyedIterable(value);
              if (!isIterable(value)) {
                iter = iter.map(function (v) {
                  return fromJS(v);
                });
              }
              iters.push(iter);
            }
            return mergeIntoCollectionWith(map, merger, iters);
          }
          function deepMerger(existing, value, key) {
            return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
          }
          function deepMergerWith(merger) {
            return function (existing, value, key) {
              if (existing && existing.mergeDeepWith && isIterable(value)) {
                return existing.mergeDeepWith(merger, value);
              }
              var nextValue = merger(existing, value, key);
              return is(existing, nextValue) ? existing : nextValue;
            };
          }
          function mergeIntoCollectionWith(collection, merger, iters) {
            iters = iters.filter(function (x) {
              return x.size !== 0;
            });
            if (iters.length === 0) {
              return collection;
            }
            if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
              return collection.constructor(iters[0]);
            }
            return collection.withMutations(function (collection) {
              var mergeIntoMap = merger ? function (value, key) {
                collection.update(key, NOT_SET, function (existing) {
                  return existing === NOT_SET ? value : merger(existing, value, key);
                });
              } : function (value, key) {
                collection.set(key, value);
              };
              for (var ii = 0; ii < iters.length; ii++) {
                iters[ii].forEach(mergeIntoMap);
              }
            });
          }
          function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
            var isNotSet = existing === NOT_SET;
            var step = keyPathIter.next();
            if (step.done) {
              var existingValue = isNotSet ? notSetValue : existing;
              var newValue = updater(existingValue);
              return newValue === existingValue ? existing : newValue;
            }
            invariant(isNotSet || existing && existing.set, 'invalid keyPath');
            var key = step.value;
            var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
            var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
            return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
          }
          function popCount(x) {
            x = x - (x >> 1 & 0x55555555);
            x = (x & 0x33333333) + (x >> 2 & 0x33333333);
            x = x + (x >> 4) & 0x0f0f0f0f;
            x = x + (x >> 8);
            x = x + (x >> 16);
            return x & 0x7f;
          }
          function setIn(array, idx, val, canEdit) {
            var newArray = canEdit ? array : arrCopy(array);
            newArray[idx] = val;
            return newArray;
          }
          function spliceIn(array, idx, val, canEdit) {
            var newLen = array.length + 1;
            if (canEdit && idx + 1 === newLen) {
              array[idx] = val;
              return array;
            }
            var newArray = new Array(newLen);
            var after = 0;
            for (var ii = 0; ii < newLen; ii++) {
              if (ii === idx) {
                newArray[ii] = val;
                after = -1;
              } else {
                newArray[ii] = array[ii + after];
              }
            }
            return newArray;
          }
          function spliceOut(array, idx, canEdit) {
            var newLen = array.length - 1;
            if (canEdit && idx === newLen) {
              array.pop();
              return array;
            }
            var newArray = new Array(newLen);
            var after = 0;
            for (var ii = 0; ii < newLen; ii++) {
              if (ii === idx) {
                after = 1;
              }
              newArray[ii] = array[ii + after];
            }
            return newArray;
          }
          var MAX_ARRAY_MAP_SIZE = SIZE / 4;
          var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
          var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
          createClass(List, IndexedCollection);

          // @pragma Construction

          function List(value) {
            var empty = emptyList();
            if (value === null || value === undefined) {
              return empty;
            }
            if (isList(value)) {
              return value;
            }
            var iter = IndexedIterable(value);
            var size = iter.size;
            if (size === 0) {
              return empty;
            }
            assertNotInfinite(size);
            if (size > 0 && size < SIZE) {
              return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
            }
            return empty.withMutations(function (list) {
              list.setSize(size);
              iter.forEach(function (v, i) {
                return list.set(i, v);
              });
            });
          }
          List.of = function /*...values*/
          () {
            return this(arguments);
          };
          List.prototype.toString = function () {
            return this.__toString('List [', ']');
          };

          // @pragma Access

          List.prototype.get = function (index, notSetValue) {
            index = wrapIndex(this, index);
            if (index >= 0 && index < this.size) {
              index += this._origin;
              var node = listNodeFor(this, index);
              return node && node.array[index & MASK];
            }
            return notSetValue;
          };

          // @pragma Modification

          List.prototype.set = function (index, value) {
            return updateList(this, index, value);
          };
          List.prototype.remove = function (index) {
            return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
          };
          List.prototype.insert = function (index, value) {
            return this.splice(index, 0, value);
          };
          List.prototype.clear = function () {
            if (this.size === 0) {
              return this;
            }
            if (this.__ownerID) {
              this.size = this._origin = this._capacity = 0;
              this._level = SHIFT;
              this._root = this._tail = null;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return emptyList();
          };
          List.prototype.push = function /*...values*/
          () {
            var values = arguments;
            var oldSize = this.size;
            return this.withMutations(function (list) {
              setListBounds(list, 0, oldSize + values.length);
              for (var ii = 0; ii < values.length; ii++) {
                list.set(oldSize + ii, values[ii]);
              }
            });
          };
          List.prototype.pop = function () {
            return setListBounds(this, 0, -1);
          };
          List.prototype.unshift = function /*...values*/
          () {
            var values = arguments;
            return this.withMutations(function (list) {
              setListBounds(list, -values.length);
              for (var ii = 0; ii < values.length; ii++) {
                list.set(ii, values[ii]);
              }
            });
          };
          List.prototype.shift = function () {
            return setListBounds(this, 1);
          };

          // @pragma Composition

          List.prototype.merge = function /*...iters*/
          () {
            return mergeIntoListWith(this, undefined, arguments);
          };
          List.prototype.mergeWith = function (merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoListWith(this, merger, iters);
          };
          List.prototype.mergeDeep = function /*...iters*/
          () {
            return mergeIntoListWith(this, deepMerger, arguments);
          };
          List.prototype.mergeDeepWith = function (merger) {
            var iters = SLICE$0.call(arguments, 1);
            return mergeIntoListWith(this, deepMergerWith(merger), iters);
          };
          List.prototype.setSize = function (size) {
            return setListBounds(this, 0, size);
          };

          // @pragma Iteration

          List.prototype.slice = function (begin, end) {
            var size = this.size;
            if (wholeSlice(begin, end, size)) {
              return this;
            }
            return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
          };
          List.prototype.__iterator = function (type, reverse) {
            var index = 0;
            var values = iterateList(this, reverse);
            return new Iterator(function () {
              var value = values();
              return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
            });
          };
          List.prototype.__iterate = function (fn, reverse) {
            var index = 0;
            var values = iterateList(this, reverse);
            var value;
            while ((value = values()) !== DONE) {
              if (fn(value, index++, this) === false) {
                break;
              }
            }
            return index;
          };
          List.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            if (!ownerID) {
              this.__ownerID = ownerID;
              return this;
            }
            return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
          };
          function isList(maybeList) {
            return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
          }
          List.isList = isList;
          var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
          var ListPrototype = List.prototype;
          ListPrototype[IS_LIST_SENTINEL] = true;
          ListPrototype[DELETE] = ListPrototype.remove;
          ListPrototype.setIn = MapPrototype.setIn;
          ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
          ListPrototype.update = MapPrototype.update;
          ListPrototype.updateIn = MapPrototype.updateIn;
          ListPrototype.mergeIn = MapPrototype.mergeIn;
          ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
          ListPrototype.withMutations = MapPrototype.withMutations;
          ListPrototype.asMutable = MapPrototype.asMutable;
          ListPrototype.asImmutable = MapPrototype.asImmutable;
          ListPrototype.wasAltered = MapPrototype.wasAltered;
          function VNode(array, ownerID) {
            this.array = array;
            this.ownerID = ownerID;
          }

          // TODO: seems like these methods are very similar

          VNode.prototype.removeBefore = function (ownerID, level, index) {
            if (index === level ? 1 << level : false || this.array.length === 0) {
              return this;
            }
            var originIndex = index >>> level & MASK;
            if (originIndex >= this.array.length) {
              return new VNode([], ownerID);
            }
            var removingFirst = originIndex === 0;
            var newChild;
            if (level > 0) {
              var oldChild = this.array[originIndex];
              newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
              if (newChild === oldChild && removingFirst) {
                return this;
              }
            }
            if (removingFirst && !newChild) {
              return this;
            }
            var editable = editableVNode(this, ownerID);
            if (!removingFirst) {
              for (var ii = 0; ii < originIndex; ii++) {
                editable.array[ii] = undefined;
              }
            }
            if (newChild) {
              editable.array[originIndex] = newChild;
            }
            return editable;
          };
          VNode.prototype.removeAfter = function (ownerID, level, index) {
            if (index === (level ? 1 << level : 0) || this.array.length === 0) {
              return this;
            }
            var sizeIndex = index - 1 >>> level & MASK;
            if (sizeIndex >= this.array.length) {
              return this;
            }
            var newChild;
            if (level > 0) {
              var oldChild = this.array[sizeIndex];
              newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
              if (newChild === oldChild && sizeIndex === this.array.length - 1) {
                return this;
              }
            }
            var editable = editableVNode(this, ownerID);
            editable.array.splice(sizeIndex + 1);
            if (newChild) {
              editable.array[sizeIndex] = newChild;
            }
            return editable;
          };
          var DONE = {};
          function iterateList(list, reverse) {
            var left = list._origin;
            var right = list._capacity;
            var tailPos = getTailOffset(right);
            var tail = list._tail;
            return iterateNodeOrLeaf(list._root, list._level, 0);
            function iterateNodeOrLeaf(node, level, offset) {
              return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
            }
            function iterateLeaf(node, offset) {
              var array = offset === tailPos ? tail && tail.array : node && node.array;
              var from = offset > left ? 0 : left - offset;
              var to = right - offset;
              if (to > SIZE) {
                to = SIZE;
              }
              return function () {
                if (from === to) {
                  return DONE;
                }
                var idx = reverse ? --to : from++;
                return array && array[idx];
              };
            }
            function iterateNode(node, level, offset) {
              var values;
              var array = node && node.array;
              var from = offset > left ? 0 : left - offset >> level;
              var to = (right - offset >> level) + 1;
              if (to > SIZE) {
                to = SIZE;
              }
              return function () {
                do {
                  if (values) {
                    var value = values();
                    if (value !== DONE) {
                      return value;
                    }
                    values = null;
                  }
                  if (from === to) {
                    return DONE;
                  }
                  var idx = reverse ? --to : from++;
                  values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
                } while (true);
              };
            }
          }
          function makeList(origin, capacity, level, root, tail, ownerID, hash) {
            var list = Object.create(ListPrototype);
            list.size = capacity - origin;
            list._origin = origin;
            list._capacity = capacity;
            list._level = level;
            list._root = root;
            list._tail = tail;
            list.__ownerID = ownerID;
            list.__hash = hash;
            list.__altered = false;
            return list;
          }
          var EMPTY_LIST;
          function emptyList() {
            return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
          }
          function updateList(list, index, value) {
            index = wrapIndex(list, index);
            if (index !== index) {
              return list;
            }
            if (index >= list.size || index < 0) {
              return list.withMutations(function (list) {
                index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
              });
            }
            index += list._origin;
            var newTail = list._tail;
            var newRoot = list._root;
            var didAlter = MakeRef(DID_ALTER);
            if (index >= getTailOffset(list._capacity)) {
              newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
            } else {
              newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
            }
            if (!didAlter.value) {
              return list;
            }
            if (list.__ownerID) {
              list._root = newRoot;
              list._tail = newTail;
              list.__hash = undefined;
              list.__altered = true;
              return list;
            }
            return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
          }
          function updateVNode(node, ownerID, level, index, value, didAlter) {
            var idx = index >>> level & MASK;
            var nodeHas = node && idx < node.array.length;
            if (!nodeHas && value === undefined) {
              return node;
            }
            var newNode;
            if (level > 0) {
              var lowerNode = node && node.array[idx];
              var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
              if (newLowerNode === lowerNode) {
                return node;
              }
              newNode = editableVNode(node, ownerID);
              newNode.array[idx] = newLowerNode;
              return newNode;
            }
            if (nodeHas && node.array[idx] === value) {
              return node;
            }
            SetRef(didAlter);
            newNode = editableVNode(node, ownerID);
            if (value === undefined && idx === newNode.array.length - 1) {
              newNode.array.pop();
            } else {
              newNode.array[idx] = value;
            }
            return newNode;
          }
          function editableVNode(node, ownerID) {
            if (ownerID && node && ownerID === node.ownerID) {
              return node;
            }
            return new VNode(node ? node.array.slice() : [], ownerID);
          }
          function listNodeFor(list, rawIndex) {
            if (rawIndex >= getTailOffset(list._capacity)) {
              return list._tail;
            }
            if (rawIndex < 1 << list._level + SHIFT) {
              var node = list._root;
              var level = list._level;
              while (node && level > 0) {
                node = node.array[rawIndex >>> level & MASK];
                level -= SHIFT;
              }
              return node;
            }
          }
          function setListBounds(list, begin, end) {
            // Sanitize begin & end using this shorthand for ToInt32(argument)
            // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
            if (begin !== undefined) {
              begin = begin | 0;
            }
            if (end !== undefined) {
              end = end | 0;
            }
            var owner = list.__ownerID || new OwnerID();
            var oldOrigin = list._origin;
            var oldCapacity = list._capacity;
            var newOrigin = oldOrigin + begin;
            var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
            if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
              return list;
            }

            // If it's going to end after it starts, it's empty.
            if (newOrigin >= newCapacity) {
              return list.clear();
            }
            var newLevel = list._level;
            var newRoot = list._root;

            // New origin might need creating a higher root.
            var offsetShift = 0;
            while (newOrigin + offsetShift < 0) {
              newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
              newLevel += SHIFT;
              offsetShift += 1 << newLevel;
            }
            if (offsetShift) {
              newOrigin += offsetShift;
              oldOrigin += offsetShift;
              newCapacity += offsetShift;
              oldCapacity += offsetShift;
            }
            var oldTailOffset = getTailOffset(oldCapacity);
            var newTailOffset = getTailOffset(newCapacity);

            // New size might need creating a higher root.
            while (newTailOffset >= 1 << newLevel + SHIFT) {
              newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
              newLevel += SHIFT;
            }

            // Locate or create the new tail.
            var oldTail = list._tail;
            var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

            // Merge Tail into tree.
            if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
              newRoot = editableVNode(newRoot, owner);
              var node = newRoot;
              for (var level = newLevel; level > SHIFT; level -= SHIFT) {
                var idx = oldTailOffset >>> level & MASK;
                node = node.array[idx] = editableVNode(node.array[idx], owner);
              }
              node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
            }

            // If the size has been reduced, there's a chance the tail needs to be trimmed.
            if (newCapacity < oldCapacity) {
              newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
            }

            // If the new origin is within the tail, then we do not need a root.
            if (newOrigin >= newTailOffset) {
              newOrigin -= newTailOffset;
              newCapacity -= newTailOffset;
              newLevel = SHIFT;
              newRoot = null;
              newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

              // Otherwise, if the root has been trimmed, garbage collect.
            } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
              offsetShift = 0;

              // Identify the new top root node of the subtree of the old root.
              while (newRoot) {
                var beginIndex = newOrigin >>> newLevel & MASK;
                if (beginIndex !== newTailOffset >>> newLevel & MASK) {
                  break;
                }
                if (beginIndex) {
                  offsetShift += (1 << newLevel) * beginIndex;
                }
                newLevel -= SHIFT;
                newRoot = newRoot.array[beginIndex];
              }

              // Trim the new sides of the new root.
              if (newRoot && newOrigin > oldOrigin) {
                newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
              }
              if (newRoot && newTailOffset < oldTailOffset) {
                newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
              }
              if (offsetShift) {
                newOrigin -= offsetShift;
                newCapacity -= offsetShift;
              }
            }
            if (list.__ownerID) {
              list.size = newCapacity - newOrigin;
              list._origin = newOrigin;
              list._capacity = newCapacity;
              list._level = newLevel;
              list._root = newRoot;
              list._tail = newTail;
              list.__hash = undefined;
              list.__altered = true;
              return list;
            }
            return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
          }
          function mergeIntoListWith(list, merger, iterables) {
            var iters = [];
            var maxSize = 0;
            for (var ii = 0; ii < iterables.length; ii++) {
              var value = iterables[ii];
              var iter = IndexedIterable(value);
              if (iter.size > maxSize) {
                maxSize = iter.size;
              }
              if (!isIterable(value)) {
                iter = iter.map(function (v) {
                  return fromJS(v);
                });
              }
              iters.push(iter);
            }
            if (maxSize > list.size) {
              list = list.setSize(maxSize);
            }
            return mergeIntoCollectionWith(list, merger, iters);
          }
          function getTailOffset(size) {
            return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
          }
          createClass(OrderedMap, Map);

          // @pragma Construction

          function OrderedMap(value) {
            return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function (map) {
              var iter = KeyedIterable(value);
              assertNotInfinite(iter.size);
              iter.forEach(function (v, k) {
                return map.set(k, v);
              });
            });
          }
          OrderedMap.of = function /*...values*/
          () {
            return this(arguments);
          };
          OrderedMap.prototype.toString = function () {
            return this.__toString('OrderedMap {', '}');
          };

          // @pragma Access

          OrderedMap.prototype.get = function (k, notSetValue) {
            var index = this._map.get(k);
            return index !== undefined ? this._list.get(index)[1] : notSetValue;
          };

          // @pragma Modification

          OrderedMap.prototype.clear = function () {
            if (this.size === 0) {
              return this;
            }
            if (this.__ownerID) {
              this.size = 0;
              this._map.clear();
              this._list.clear();
              return this;
            }
            return emptyOrderedMap();
          };
          OrderedMap.prototype.set = function (k, v) {
            return updateOrderedMap(this, k, v);
          };
          OrderedMap.prototype.remove = function (k) {
            return updateOrderedMap(this, k, NOT_SET);
          };
          OrderedMap.prototype.wasAltered = function () {
            return this._map.wasAltered() || this._list.wasAltered();
          };
          OrderedMap.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            return this._list.__iterate(function (entry) {
              return entry && fn(entry[1], entry[0], this$0);
            }, reverse);
          };
          OrderedMap.prototype.__iterator = function (type, reverse) {
            return this._list.fromEntrySeq().__iterator(type, reverse);
          };
          OrderedMap.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            var newMap = this._map.__ensureOwner(ownerID);
            var newList = this._list.__ensureOwner(ownerID);
            if (!ownerID) {
              this.__ownerID = ownerID;
              this._map = newMap;
              this._list = newList;
              return this;
            }
            return makeOrderedMap(newMap, newList, ownerID, this.__hash);
          };
          function isOrderedMap(maybeOrderedMap) {
            return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
          }
          OrderedMap.isOrderedMap = isOrderedMap;
          OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
          OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
          function makeOrderedMap(map, list, ownerID, hash) {
            var omap = Object.create(OrderedMap.prototype);
            omap.size = map ? map.size : 0;
            omap._map = map;
            omap._list = list;
            omap.__ownerID = ownerID;
            omap.__hash = hash;
            return omap;
          }
          var EMPTY_ORDERED_MAP;
          function emptyOrderedMap() {
            return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
          }
          function updateOrderedMap(omap, k, v) {
            var map = omap._map;
            var list = omap._list;
            var i = map.get(k);
            var has = i !== undefined;
            var newMap;
            var newList;
            if (v === NOT_SET) {
              // removed
              if (!has) {
                return omap;
              }
              if (list.size >= SIZE && list.size >= map.size * 2) {
                newList = list.filter(function (entry, idx) {
                  return entry !== undefined && i !== idx;
                });
                newMap = newList.toKeyedSeq().map(function (entry) {
                  return entry[0];
                }).flip().toMap();
                if (omap.__ownerID) {
                  newMap.__ownerID = newList.__ownerID = omap.__ownerID;
                }
              } else {
                newMap = map.remove(k);
                newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
              }
            } else {
              if (has) {
                if (v === list.get(i)[1]) {
                  return omap;
                }
                newMap = map;
                newList = list.set(i, [k, v]);
              } else {
                newMap = map.set(k, list.size);
                newList = list.set(list.size, [k, v]);
              }
            }
            if (omap.__ownerID) {
              omap.size = newMap.size;
              omap._map = newMap;
              omap._list = newList;
              omap.__hash = undefined;
              return omap;
            }
            return makeOrderedMap(newMap, newList);
          }
          createClass(ToKeyedSequence, KeyedSeq);
          function ToKeyedSequence(indexed, useKeys) {
            this._iter = indexed;
            this._useKeys = useKeys;
            this.size = indexed.size;
          }
          ToKeyedSequence.prototype.get = function (key, notSetValue) {
            return this._iter.get(key, notSetValue);
          };
          ToKeyedSequence.prototype.has = function (key) {
            return this._iter.has(key);
          };
          ToKeyedSequence.prototype.valueSeq = function () {
            return this._iter.valueSeq();
          };
          ToKeyedSequence.prototype.reverse = function () {
            var this$0 = this;
            var reversedSequence = reverseFactory(this, true);
            if (!this._useKeys) {
              reversedSequence.valueSeq = function () {
                return this$0._iter.toSeq().reverse();
              };
            }
            return reversedSequence;
          };
          ToKeyedSequence.prototype.map = function (mapper, context) {
            var this$0 = this;
            var mappedSequence = mapFactory(this, mapper, context);
            if (!this._useKeys) {
              mappedSequence.valueSeq = function () {
                return this$0._iter.toSeq().map(mapper, context);
              };
            }
            return mappedSequence;
          };
          ToKeyedSequence.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            var ii;
            return this._iter.__iterate(this._useKeys ? function (v, k) {
              return fn(v, k, this$0);
            } : (ii = reverse ? resolveSize(this) : 0, function (v) {
              return fn(v, reverse ? --ii : ii++, this$0);
            }), reverse);
          };
          ToKeyedSequence.prototype.__iterator = function (type, reverse) {
            if (this._useKeys) {
              return this._iter.__iterator(type, reverse);
            }
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            var ii = reverse ? resolveSize(this) : 0;
            return new Iterator(function () {
              var step = iterator.next();
              return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
            });
          };
          ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
          createClass(ToIndexedSequence, IndexedSeq);
          function ToIndexedSequence(iter) {
            this._iter = iter;
            this.size = iter.size;
          }
          ToIndexedSequence.prototype.includes = function (value) {
            return this._iter.includes(value);
          };
          ToIndexedSequence.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            return this._iter.__iterate(function (v) {
              return fn(v, iterations++, this$0);
            }, reverse);
          };
          ToIndexedSequence.prototype.__iterator = function (type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            var iterations = 0;
            return new Iterator(function () {
              var step = iterator.next();
              return step.done ? step : iteratorValue(type, iterations++, step.value, step);
            });
          };
          createClass(ToSetSequence, SetSeq);
          function ToSetSequence(iter) {
            this._iter = iter;
            this.size = iter.size;
          }
          ToSetSequence.prototype.has = function (key) {
            return this._iter.includes(key);
          };
          ToSetSequence.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            return this._iter.__iterate(function (v) {
              return fn(v, v, this$0);
            }, reverse);
          };
          ToSetSequence.prototype.__iterator = function (type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            return new Iterator(function () {
              var step = iterator.next();
              return step.done ? step : iteratorValue(type, step.value, step.value, step);
            });
          };
          createClass(FromEntriesSequence, KeyedSeq);
          function FromEntriesSequence(entries) {
            this._iter = entries;
            this.size = entries.size;
          }
          FromEntriesSequence.prototype.entrySeq = function () {
            return this._iter.toSeq();
          };
          FromEntriesSequence.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            return this._iter.__iterate(function (entry) {
              // Check if entry exists first so array access doesn't throw for holes
              // in the parent iteration.
              if (entry) {
                validateEntry(entry);
                var indexedIterable = isIterable(entry);
                return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
              }
            }, reverse);
          };
          FromEntriesSequence.prototype.__iterator = function (type, reverse) {
            var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
            return new Iterator(function () {
              while (true) {
                var step = iterator.next();
                if (step.done) {
                  return step;
                }
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                  validateEntry(entry);
                  var indexedIterable = isIterable(entry);
                  return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
                }
              }
            });
          };
          ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
          function flipFactory(iterable) {
            var flipSequence = makeSequence(iterable);
            flipSequence._iter = iterable;
            flipSequence.size = iterable.size;
            flipSequence.flip = function () {
              return iterable;
            };
            flipSequence.reverse = function () {
              var reversedSequence = iterable.reverse.apply(this); // super.reverse()
              reversedSequence.flip = function () {
                return iterable.reverse();
              };
              return reversedSequence;
            };
            flipSequence.has = function (key) {
              return iterable.includes(key);
            };
            flipSequence.includes = function (key) {
              return iterable.has(key);
            };
            flipSequence.cacheResult = cacheResultThrough;
            flipSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              return iterable.__iterate(function (v, k) {
                return fn(k, v, this$0) !== false;
              }, reverse);
            };
            flipSequence.__iteratorUncached = function (type, reverse) {
              if (type === ITERATE_ENTRIES) {
                var iterator = iterable.__iterator(type, reverse);
                return new Iterator(function () {
                  var step = iterator.next();
                  if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                  }
                  return step;
                });
              }
              return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
            };
            return flipSequence;
          }
          function mapFactory(iterable, mapper, context) {
            var mappedSequence = makeSequence(iterable);
            mappedSequence.size = iterable.size;
            mappedSequence.has = function (key) {
              return iterable.has(key);
            };
            mappedSequence.get = function (key, notSetValue) {
              var v = iterable.get(key, NOT_SET);
              return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
            };
            mappedSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              return iterable.__iterate(function (v, k, c) {
                return fn(mapper.call(context, v, k, c), k, this$0) !== false;
              }, reverse);
            };
            mappedSequence.__iteratorUncached = function (type, reverse) {
              var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
              return new Iterator(function () {
                var step = iterator.next();
                if (step.done) {
                  return step;
                }
                var entry = step.value;
                var key = entry[0];
                return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
              });
            };
            return mappedSequence;
          }
          function reverseFactory(iterable, useKeys) {
            var reversedSequence = makeSequence(iterable);
            reversedSequence._iter = iterable;
            reversedSequence.size = iterable.size;
            reversedSequence.reverse = function () {
              return iterable;
            };
            if (iterable.flip) {
              reversedSequence.flip = function () {
                var flipSequence = flipFactory(iterable);
                flipSequence.reverse = function () {
                  return iterable.flip();
                };
                return flipSequence;
              };
            }
            reversedSequence.get = function (key, notSetValue) {
              return iterable.get(useKeys ? key : -1 - key, notSetValue);
            };
            reversedSequence.has = function (key) {
              return iterable.has(useKeys ? key : -1 - key);
            };
            reversedSequence.includes = function (value) {
              return iterable.includes(value);
            };
            reversedSequence.cacheResult = cacheResultThrough;
            reversedSequence.__iterate = function (fn, reverse) {
              var this$0 = this;
              return iterable.__iterate(function (v, k) {
                return fn(v, k, this$0);
              }, !reverse);
            };
            reversedSequence.__iterator = function (type, reverse) {
              return iterable.__iterator(type, !reverse);
            };
            return reversedSequence;
          }
          function filterFactory(iterable, predicate, context, useKeys) {
            var filterSequence = makeSequence(iterable);
            if (useKeys) {
              filterSequence.has = function (key) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
              };
              filterSequence.get = function (key, notSetValue) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
              };
            }
            filterSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              var iterations = 0;
              iterable.__iterate(function (v, k, c) {
                if (predicate.call(context, v, k, c)) {
                  iterations++;
                  return fn(v, useKeys ? k : iterations - 1, this$0);
                }
              }, reverse);
              return iterations;
            };
            filterSequence.__iteratorUncached = function (type, reverse) {
              var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
              var iterations = 0;
              return new Iterator(function () {
                while (true) {
                  var step = iterator.next();
                  if (step.done) {
                    return step;
                  }
                  var entry = step.value;
                  var key = entry[0];
                  var value = entry[1];
                  if (predicate.call(context, value, key, iterable)) {
                    return iteratorValue(type, useKeys ? key : iterations++, value, step);
                  }
                }
              });
            };
            return filterSequence;
          }
          function countByFactory(iterable, grouper, context) {
            var groups = Map().asMutable();
            iterable.__iterate(function (v, k) {
              groups.update(grouper.call(context, v, k, iterable), 0, function (a) {
                return a + 1;
              });
            });
            return groups.asImmutable();
          }
          function groupByFactory(iterable, grouper, context) {
            var isKeyedIter = isKeyed(iterable);
            var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
            iterable.__iterate(function (v, k) {
              groups.update(grouper.call(context, v, k, iterable), function (a) {
                return a = a || [], a.push(isKeyedIter ? [k, v] : v), a;
              });
            });
            var coerce = iterableClass(iterable);
            return groups.map(function (arr) {
              return reify(iterable, coerce(arr));
            });
          }
          function sliceFactory(iterable, begin, end, useKeys) {
            var originalSize = iterable.size;

            // Sanitize begin & end using this shorthand for ToInt32(argument)
            // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
            if (begin !== undefined) {
              begin = begin | 0;
            }
            if (end !== undefined) {
              if (end === Infinity) {
                end = originalSize;
              } else {
                end = end | 0;
              }
            }
            if (wholeSlice(begin, end, originalSize)) {
              return iterable;
            }
            var resolvedBegin = resolveBegin(begin, originalSize);
            var resolvedEnd = resolveEnd(end, originalSize);

            // begin or end will be NaN if they were provided as negative numbers and
            // this iterable's size is unknown. In that case, cache first so there is
            // a known size and these do not resolve to NaN.
            if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
              return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
            }

            // Note: resolvedEnd is undefined when the original sequence's length is
            // unknown and this slice did not supply an end and should contain all
            // elements after resolvedBegin.
            // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
            var resolvedSize = resolvedEnd - resolvedBegin;
            var sliceSize;
            if (resolvedSize === resolvedSize) {
              sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
            }
            var sliceSeq = makeSequence(iterable);

            // If iterable.size is undefined, the size of the realized sliceSeq is
            // unknown at this point unless the number of items to slice is 0
            sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
            if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
              sliceSeq.get = function (index, notSetValue) {
                index = wrapIndex(this, index);
                return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
              };
            }
            sliceSeq.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              if (sliceSize === 0) {
                return 0;
              }
              if (reverse) {
                return this.cacheResult().__iterate(fn, reverse);
              }
              var skipped = 0;
              var isSkipping = true;
              var iterations = 0;
              iterable.__iterate(function (v, k) {
                if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                  iterations++;
                  return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
                }
              });
              return iterations;
            };
            sliceSeq.__iteratorUncached = function (type, reverse) {
              if (sliceSize !== 0 && reverse) {
                return this.cacheResult().__iterator(type, reverse);
              }
              // Don't bother instantiating parent iterator if taking 0.
              var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
              var skipped = 0;
              var iterations = 0;
              return new Iterator(function () {
                while (skipped++ < resolvedBegin) {
                  iterator.next();
                }
                if (++iterations > sliceSize) {
                  return iteratorDone();
                }
                var step = iterator.next();
                if (useKeys || type === ITERATE_VALUES) {
                  return step;
                } else if (type === ITERATE_KEYS) {
                  return iteratorValue(type, iterations - 1, undefined, step);
                } else {
                  return iteratorValue(type, iterations - 1, step.value[1], step);
                }
              });
            };
            return sliceSeq;
          }
          function takeWhileFactory(iterable, predicate, context) {
            var takeSequence = makeSequence(iterable);
            takeSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              if (reverse) {
                return this.cacheResult().__iterate(fn, reverse);
              }
              var iterations = 0;
              iterable.__iterate(function (v, k, c) {
                return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
              });
              return iterations;
            };
            takeSequence.__iteratorUncached = function (type, reverse) {
              var this$0 = this;
              if (reverse) {
                return this.cacheResult().__iterator(type, reverse);
              }
              var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
              var iterating = true;
              return new Iterator(function () {
                if (!iterating) {
                  return iteratorDone();
                }
                var step = iterator.next();
                if (step.done) {
                  return step;
                }
                var entry = step.value;
                var k = entry[0];
                var v = entry[1];
                if (!predicate.call(context, v, k, this$0)) {
                  iterating = false;
                  return iteratorDone();
                }
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
              });
            };
            return takeSequence;
          }
          function skipWhileFactory(iterable, predicate, context, useKeys) {
            var skipSequence = makeSequence(iterable);
            skipSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              if (reverse) {
                return this.cacheResult().__iterate(fn, reverse);
              }
              var isSkipping = true;
              var iterations = 0;
              iterable.__iterate(function (v, k, c) {
                if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                  iterations++;
                  return fn(v, useKeys ? k : iterations - 1, this$0);
                }
              });
              return iterations;
            };
            skipSequence.__iteratorUncached = function (type, reverse) {
              var this$0 = this;
              if (reverse) {
                return this.cacheResult().__iterator(type, reverse);
              }
              var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
              var skipping = true;
              var iterations = 0;
              return new Iterator(function () {
                var step, k, v;
                do {
                  step = iterator.next();
                  if (step.done) {
                    if (useKeys || type === ITERATE_VALUES) {
                      return step;
                    } else if (type === ITERATE_KEYS) {
                      return iteratorValue(type, iterations++, undefined, step);
                    } else {
                      return iteratorValue(type, iterations++, step.value[1], step);
                    }
                  }
                  var entry = step.value;
                  k = entry[0];
                  v = entry[1];
                  skipping && (skipping = predicate.call(context, v, k, this$0));
                } while (skipping);
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
              });
            };
            return skipSequence;
          }
          function concatFactory(iterable, values) {
            var isKeyedIterable = isKeyed(iterable);
            var iters = [iterable].concat(values).map(function (v) {
              if (!isIterable(v)) {
                v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
              } else if (isKeyedIterable) {
                v = KeyedIterable(v);
              }
              return v;
            }).filter(function (v) {
              return v.size !== 0;
            });
            if (iters.length === 0) {
              return iterable;
            }
            if (iters.length === 1) {
              var singleton = iters[0];
              if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) {
                return singleton;
              }
            }
            var concatSeq = new ArraySeq(iters);
            if (isKeyedIterable) {
              concatSeq = concatSeq.toKeyedSeq();
            } else if (!isIndexed(iterable)) {
              concatSeq = concatSeq.toSetSeq();
            }
            concatSeq = concatSeq.flatten(true);
            concatSeq.size = iters.reduce(function (sum, seq) {
              if (sum !== undefined) {
                var size = seq.size;
                if (size !== undefined) {
                  return sum + size;
                }
              }
            }, 0);
            return concatSeq;
          }
          function flattenFactory(iterable, depth, useKeys) {
            var flatSequence = makeSequence(iterable);
            flatSequence.__iterateUncached = function (fn, reverse) {
              var iterations = 0;
              var stopped = false;
              function flatDeep(iter, currentDepth) {
                var this$0 = this;
                iter.__iterate(function (v, k) {
                  if ((!depth || currentDepth < depth) && isIterable(v)) {
                    flatDeep(v, currentDepth + 1);
                  } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
                    stopped = true;
                  }
                  return !stopped;
                }, reverse);
              }
              flatDeep(iterable, 0);
              return iterations;
            };
            flatSequence.__iteratorUncached = function (type, reverse) {
              var iterator = iterable.__iterator(type, reverse);
              var stack = [];
              var iterations = 0;
              return new Iterator(function () {
                while (iterator) {
                  var step = iterator.next();
                  if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                  }
                  var v = step.value;
                  if (type === ITERATE_ENTRIES) {
                    v = v[1];
                  }
                  if ((!depth || stack.length < depth) && isIterable(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                  } else {
                    return useKeys ? step : iteratorValue(type, iterations++, v, step);
                  }
                }
                return iteratorDone();
              });
            };
            return flatSequence;
          }
          function flatMapFactory(iterable, mapper, context) {
            var coerce = iterableClass(iterable);
            return iterable.toSeq().map(function (v, k) {
              return coerce(mapper.call(context, v, k, iterable));
            }).flatten(true);
          }
          function interposeFactory(iterable, separator) {
            var interposedSequence = makeSequence(iterable);
            interposedSequence.size = iterable.size && iterable.size * 2 - 1;
            interposedSequence.__iterateUncached = function (fn, reverse) {
              var this$0 = this;
              var iterations = 0;
              iterable.__iterate(function (v, k) {
                return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
              }, reverse);
              return iterations;
            };
            interposedSequence.__iteratorUncached = function (type, reverse) {
              var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
              var iterations = 0;
              var step;
              return new Iterator(function () {
                if (!step || iterations % 2) {
                  step = iterator.next();
                  if (step.done) {
                    return step;
                  }
                }
                return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
              });
            };
            return interposedSequence;
          }
          function sortFactory(iterable, comparator, mapper) {
            if (!comparator) {
              comparator = defaultComparator;
            }
            var isKeyedIterable = isKeyed(iterable);
            var index = 0;
            var entries = iterable.toSeq().map(function (v, k) {
              return [k, v, index++, mapper ? mapper(v, k, iterable) : v];
            }).toArray();
            entries.sort(function (a, b) {
              return comparator(a[3], b[3]) || a[2] - b[2];
            }).forEach(isKeyedIterable ? function (v, i) {
              entries[i].length = 2;
            } : function (v, i) {
              entries[i] = v[1];
            });
            return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
          }
          function maxFactory(iterable, comparator, mapper) {
            if (!comparator) {
              comparator = defaultComparator;
            }
            if (mapper) {
              var entry = iterable.toSeq().map(function (v, k) {
                return [v, mapper(v, k, iterable)];
              }).reduce(function (a, b) {
                return maxCompare(comparator, a[1], b[1]) ? b : a;
              });
              return entry && entry[0];
            } else {
              return iterable.reduce(function (a, b) {
                return maxCompare(comparator, a, b) ? b : a;
              });
            }
          }
          function maxCompare(comparator, a, b) {
            var comp = comparator(b, a);
            // b is considered the new max if the comparator declares them equal, but
            // they are not equal and b is in fact a nullish value.
            return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
          }
          function zipWithFactory(keyIter, zipper, iters) {
            var zipSequence = makeSequence(keyIter);
            zipSequence.size = new ArraySeq(iters).map(function (i) {
              return i.size;
            }).min();
            // Note: this a generic base implementation of __iterate in terms of
            // __iterator which may be more generically useful in the future.
            zipSequence.__iterate = function (fn, reverse) {
              /* generic:
              var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
              var step;
              var iterations = 0;
              while (!(step = iterator.next()).done) {
                iterations++;
                if (fn(step.value[1], step.value[0], this) === false) {
                  break;
                }
              }
              return iterations;
              */
              // indexed:
              var iterator = this.__iterator(ITERATE_VALUES, reverse);
              var step;
              var iterations = 0;
              while (!(step = iterator.next()).done) {
                if (fn(step.value, iterations++, this) === false) {
                  break;
                }
              }
              return iterations;
            };
            zipSequence.__iteratorUncached = function (type, reverse) {
              var iterators = iters.map(function (i) {
                return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
              });
              var iterations = 0;
              var isDone = false;
              return new Iterator(function () {
                var steps;
                if (!isDone) {
                  steps = iterators.map(function (i) {
                    return i.next();
                  });
                  isDone = steps.some(function (s) {
                    return s.done;
                  });
                }
                if (isDone) {
                  return iteratorDone();
                }
                return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function (s) {
                  return s.value;
                })));
              });
            };
            return zipSequence;
          }

          // #pragma Helper Functions

          function reify(iter, seq) {
            return isSeq(iter) ? seq : iter.constructor(seq);
          }
          function validateEntry(entry) {
            if (entry !== Object(entry)) {
              throw new TypeError('Expected [K, V] tuple: ' + entry);
            }
          }
          function resolveSize(iter) {
            assertNotInfinite(iter.size);
            return ensureSize(iter);
          }
          function iterableClass(iterable) {
            return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
          }
          function makeSequence(iterable) {
            return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
          }
          function cacheResultThrough() {
            if (this._iter.cacheResult) {
              this._iter.cacheResult();
              this.size = this._iter.size;
              return this;
            } else {
              return Seq.prototype.cacheResult.call(this);
            }
          }
          function defaultComparator(a, b) {
            return a > b ? 1 : a < b ? -1 : 0;
          }
          function forceIterator(keyPath) {
            var iter = getIterator(keyPath);
            if (!iter) {
              // Array might not be iterable in this environment, so we need a fallback
              // to our wrapped type.
              if (!isArrayLike(keyPath)) {
                throw new TypeError('Expected iterable or array-like: ' + keyPath);
              }
              iter = getIterator(Iterable(keyPath));
            }
            return iter;
          }
          createClass(Record, KeyedCollection);
          function Record(defaultValues, name) {
            var hasInitialized;
            var RecordType = function Record(values) {
              if (values instanceof RecordType) {
                return values;
              }
              if (!(this instanceof RecordType)) {
                return new RecordType(values);
              }
              if (!hasInitialized) {
                hasInitialized = true;
                var keys = Object.keys(defaultValues);
                setProps(RecordTypePrototype, keys);
                RecordTypePrototype.size = keys.length;
                RecordTypePrototype._name = name;
                RecordTypePrototype._keys = keys;
                RecordTypePrototype._defaultValues = defaultValues;
              }
              this._map = Map(values);
            };
            var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
            RecordTypePrototype.constructor = RecordType;
            return RecordType;
          }
          Record.prototype.toString = function () {
            return this.__toString(recordName(this) + ' {', '}');
          };

          // @pragma Access

          Record.prototype.has = function (k) {
            return this._defaultValues.hasOwnProperty(k);
          };
          Record.prototype.get = function (k, notSetValue) {
            if (!this.has(k)) {
              return notSetValue;
            }
            var defaultVal = this._defaultValues[k];
            return this._map ? this._map.get(k, defaultVal) : defaultVal;
          };

          // @pragma Modification

          Record.prototype.clear = function () {
            if (this.__ownerID) {
              this._map && this._map.clear();
              return this;
            }
            var RecordType = this.constructor;
            return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
          };
          Record.prototype.set = function (k, v) {
            if (!this.has(k)) {
              throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
            }
            if (this._map && !this._map.has(k)) {
              var defaultVal = this._defaultValues[k];
              if (v === defaultVal) {
                return this;
              }
            }
            var newMap = this._map && this._map.set(k, v);
            if (this.__ownerID || newMap === this._map) {
              return this;
            }
            return makeRecord(this, newMap);
          };
          Record.prototype.remove = function (k) {
            if (!this.has(k)) {
              return this;
            }
            var newMap = this._map && this._map.remove(k);
            if (this.__ownerID || newMap === this._map) {
              return this;
            }
            return makeRecord(this, newMap);
          };
          Record.prototype.wasAltered = function () {
            return this._map.wasAltered();
          };
          Record.prototype.__iterator = function (type, reverse) {
            var this$0 = this;
            return KeyedIterable(this._defaultValues).map(function (_, k) {
              return this$0.get(k);
            }).__iterator(type, reverse);
          };
          Record.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            return KeyedIterable(this._defaultValues).map(function (_, k) {
              return this$0.get(k);
            }).__iterate(fn, reverse);
          };
          Record.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            var newMap = this._map && this._map.__ensureOwner(ownerID);
            if (!ownerID) {
              this.__ownerID = ownerID;
              this._map = newMap;
              return this;
            }
            return makeRecord(this, newMap, ownerID);
          };
          var RecordPrototype = Record.prototype;
          RecordPrototype[DELETE] = RecordPrototype.remove;
          RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
          RecordPrototype.merge = MapPrototype.merge;
          RecordPrototype.mergeWith = MapPrototype.mergeWith;
          RecordPrototype.mergeIn = MapPrototype.mergeIn;
          RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
          RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
          RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
          RecordPrototype.setIn = MapPrototype.setIn;
          RecordPrototype.update = MapPrototype.update;
          RecordPrototype.updateIn = MapPrototype.updateIn;
          RecordPrototype.withMutations = MapPrototype.withMutations;
          RecordPrototype.asMutable = MapPrototype.asMutable;
          RecordPrototype.asImmutable = MapPrototype.asImmutable;
          function makeRecord(likeRecord, map, ownerID) {
            var record = Object.create(Object.getPrototypeOf(likeRecord));
            record._map = map;
            record.__ownerID = ownerID;
            return record;
          }
          function recordName(record) {
            return record._name || record.constructor.name || 'Record';
          }
          function setProps(prototype, names) {
            try {
              names.forEach(setProp.bind(undefined, prototype));
            } catch (error) {
              // Object.defineProperty failed. Probably IE8.
            }
          }
          function setProp(prototype, name) {
            Object.defineProperty(prototype, name, {
              get: function () {
                return this.get(name);
              },
              set: function (value) {
                invariant(this.__ownerID, 'Cannot set on an immutable record.');
                this.set(name, value);
              }
            });
          }
          createClass(Set, SetCollection);

          // @pragma Construction

          function Set(value) {
            return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function (set) {
              var iter = SetIterable(value);
              assertNotInfinite(iter.size);
              iter.forEach(function (v) {
                return set.add(v);
              });
            });
          }
          Set.of = function /*...values*/
          () {
            return this(arguments);
          };
          Set.fromKeys = function (value) {
            return this(KeyedIterable(value).keySeq());
          };
          Set.prototype.toString = function () {
            return this.__toString('Set {', '}');
          };

          // @pragma Access

          Set.prototype.has = function (value) {
            return this._map.has(value);
          };

          // @pragma Modification

          Set.prototype.add = function (value) {
            return updateSet(this, this._map.set(value, true));
          };
          Set.prototype.remove = function (value) {
            return updateSet(this, this._map.remove(value));
          };
          Set.prototype.clear = function () {
            return updateSet(this, this._map.clear());
          };

          // @pragma Composition

          Set.prototype.union = function () {
            var iters = SLICE$0.call(arguments, 0);
            iters = iters.filter(function (x) {
              return x.size !== 0;
            });
            if (iters.length === 0) {
              return this;
            }
            if (this.size === 0 && !this.__ownerID && iters.length === 1) {
              return this.constructor(iters[0]);
            }
            return this.withMutations(function (set) {
              for (var ii = 0; ii < iters.length; ii++) {
                SetIterable(iters[ii]).forEach(function (value) {
                  return set.add(value);
                });
              }
            });
          };
          Set.prototype.intersect = function () {
            var iters = SLICE$0.call(arguments, 0);
            if (iters.length === 0) {
              return this;
            }
            iters = iters.map(function (iter) {
              return SetIterable(iter);
            });
            var originalSet = this;
            return this.withMutations(function (set) {
              originalSet.forEach(function (value) {
                if (!iters.every(function (iter) {
                  return iter.includes(value);
                })) {
                  set.remove(value);
                }
              });
            });
          };
          Set.prototype.subtract = function () {
            var iters = SLICE$0.call(arguments, 0);
            if (iters.length === 0) {
              return this;
            }
            iters = iters.map(function (iter) {
              return SetIterable(iter);
            });
            var originalSet = this;
            return this.withMutations(function (set) {
              originalSet.forEach(function (value) {
                if (iters.some(function (iter) {
                  return iter.includes(value);
                })) {
                  set.remove(value);
                }
              });
            });
          };
          Set.prototype.merge = function () {
            return this.union.apply(this, arguments);
          };
          Set.prototype.mergeWith = function (merger) {
            var iters = SLICE$0.call(arguments, 1);
            return this.union.apply(this, iters);
          };
          Set.prototype.sort = function (comparator) {
            // Late binding
            return OrderedSet(sortFactory(this, comparator));
          };
          Set.prototype.sortBy = function (mapper, comparator) {
            // Late binding
            return OrderedSet(sortFactory(this, comparator, mapper));
          };
          Set.prototype.wasAltered = function () {
            return this._map.wasAltered();
          };
          Set.prototype.__iterate = function (fn, reverse) {
            var this$0 = this;
            return this._map.__iterate(function (_, k) {
              return fn(k, k, this$0);
            }, reverse);
          };
          Set.prototype.__iterator = function (type, reverse) {
            return this._map.map(function (_, k) {
              return k;
            }).__iterator(type, reverse);
          };
          Set.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            var newMap = this._map.__ensureOwner(ownerID);
            if (!ownerID) {
              this.__ownerID = ownerID;
              this._map = newMap;
              return this;
            }
            return this.__make(newMap, ownerID);
          };
          function isSet(maybeSet) {
            return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
          }
          Set.isSet = isSet;
          var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
          var SetPrototype = Set.prototype;
          SetPrototype[IS_SET_SENTINEL] = true;
          SetPrototype[DELETE] = SetPrototype.remove;
          SetPrototype.mergeDeep = SetPrototype.merge;
          SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
          SetPrototype.withMutations = MapPrototype.withMutations;
          SetPrototype.asMutable = MapPrototype.asMutable;
          SetPrototype.asImmutable = MapPrototype.asImmutable;
          SetPrototype.__empty = emptySet;
          SetPrototype.__make = makeSet;
          function updateSet(set, newMap) {
            if (set.__ownerID) {
              set.size = newMap.size;
              set._map = newMap;
              return set;
            }
            return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
          }
          function makeSet(map, ownerID) {
            var set = Object.create(SetPrototype);
            set.size = map ? map.size : 0;
            set._map = map;
            set.__ownerID = ownerID;
            return set;
          }
          var EMPTY_SET;
          function emptySet() {
            return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
          }
          createClass(OrderedSet, Set);

          // @pragma Construction

          function OrderedSet(value) {
            return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function (set) {
              var iter = SetIterable(value);
              assertNotInfinite(iter.size);
              iter.forEach(function (v) {
                return set.add(v);
              });
            });
          }
          OrderedSet.of = function /*...values*/
          () {
            return this(arguments);
          };
          OrderedSet.fromKeys = function (value) {
            return this(KeyedIterable(value).keySeq());
          };
          OrderedSet.prototype.toString = function () {
            return this.__toString('OrderedSet {', '}');
          };
          function isOrderedSet(maybeOrderedSet) {
            return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
          }
          OrderedSet.isOrderedSet = isOrderedSet;
          var OrderedSetPrototype = OrderedSet.prototype;
          OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
          OrderedSetPrototype.__empty = emptyOrderedSet;
          OrderedSetPrototype.__make = makeOrderedSet;
          function makeOrderedSet(map, ownerID) {
            var set = Object.create(OrderedSetPrototype);
            set.size = map ? map.size : 0;
            set._map = map;
            set.__ownerID = ownerID;
            return set;
          }
          var EMPTY_ORDERED_SET;
          function emptyOrderedSet() {
            return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
          }
          createClass(Stack, IndexedCollection);

          // @pragma Construction

          function Stack(value) {
            return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
          }
          Stack.of = function /*...values*/
          () {
            return this(arguments);
          };
          Stack.prototype.toString = function () {
            return this.__toString('Stack [', ']');
          };

          // @pragma Access

          Stack.prototype.get = function (index, notSetValue) {
            var head = this._head;
            index = wrapIndex(this, index);
            while (head && index--) {
              head = head.next;
            }
            return head ? head.value : notSetValue;
          };
          Stack.prototype.peek = function () {
            return this._head && this._head.value;
          };

          // @pragma Modification

          Stack.prototype.push = function /*...values*/
          () {
            if (arguments.length === 0) {
              return this;
            }
            var newSize = this.size + arguments.length;
            var head = this._head;
            for (var ii = arguments.length - 1; ii >= 0; ii--) {
              head = {
                value: arguments[ii],
                next: head
              };
            }
            if (this.__ownerID) {
              this.size = newSize;
              this._head = head;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return makeStack(newSize, head);
          };
          Stack.prototype.pushAll = function (iter) {
            iter = IndexedIterable(iter);
            if (iter.size === 0) {
              return this;
            }
            assertNotInfinite(iter.size);
            var newSize = this.size;
            var head = this._head;
            iter.reverse().forEach(function (value) {
              newSize++;
              head = {
                value: value,
                next: head
              };
            });
            if (this.__ownerID) {
              this.size = newSize;
              this._head = head;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return makeStack(newSize, head);
          };
          Stack.prototype.pop = function () {
            return this.slice(1);
          };
          Stack.prototype.unshift = function /*...values*/
          () {
            return this.push.apply(this, arguments);
          };
          Stack.prototype.unshiftAll = function (iter) {
            return this.pushAll(iter);
          };
          Stack.prototype.shift = function () {
            return this.pop.apply(this, arguments);
          };
          Stack.prototype.clear = function () {
            if (this.size === 0) {
              return this;
            }
            if (this.__ownerID) {
              this.size = 0;
              this._head = undefined;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return emptyStack();
          };
          Stack.prototype.slice = function (begin, end) {
            if (wholeSlice(begin, end, this.size)) {
              return this;
            }
            var resolvedBegin = resolveBegin(begin, this.size);
            var resolvedEnd = resolveEnd(end, this.size);
            if (resolvedEnd !== this.size) {
              // super.slice(begin, end);
              return IndexedCollection.prototype.slice.call(this, begin, end);
            }
            var newSize = this.size - resolvedBegin;
            var head = this._head;
            while (resolvedBegin--) {
              head = head.next;
            }
            if (this.__ownerID) {
              this.size = newSize;
              this._head = head;
              this.__hash = undefined;
              this.__altered = true;
              return this;
            }
            return makeStack(newSize, head);
          };

          // @pragma Mutability

          Stack.prototype.__ensureOwner = function (ownerID) {
            if (ownerID === this.__ownerID) {
              return this;
            }
            if (!ownerID) {
              this.__ownerID = ownerID;
              this.__altered = false;
              return this;
            }
            return makeStack(this.size, this._head, ownerID, this.__hash);
          };

          // @pragma Iteration

          Stack.prototype.__iterate = function (fn, reverse) {
            if (reverse) {
              return this.reverse().__iterate(fn);
            }
            var iterations = 0;
            var node = this._head;
            while (node) {
              if (fn(node.value, iterations++, this) === false) {
                break;
              }
              node = node.next;
            }
            return iterations;
          };
          Stack.prototype.__iterator = function (type, reverse) {
            if (reverse) {
              return this.reverse().__iterator(type);
            }
            var iterations = 0;
            var node = this._head;
            return new Iterator(function () {
              if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
              }
              return iteratorDone();
            });
          };
          function isStack(maybeStack) {
            return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
          }
          Stack.isStack = isStack;
          var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
          var StackPrototype = Stack.prototype;
          StackPrototype[IS_STACK_SENTINEL] = true;
          StackPrototype.withMutations = MapPrototype.withMutations;
          StackPrototype.asMutable = MapPrototype.asMutable;
          StackPrototype.asImmutable = MapPrototype.asImmutable;
          StackPrototype.wasAltered = MapPrototype.wasAltered;
          function makeStack(size, head, ownerID, hash) {
            var map = Object.create(StackPrototype);
            map.size = size;
            map._head = head;
            map.__ownerID = ownerID;
            map.__hash = hash;
            map.__altered = false;
            return map;
          }
          var EMPTY_STACK;
          function emptyStack() {
            return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
          }

          /**
           * Contributes additional methods to a constructor
           */
          function mixin(ctor, methods) {
            var keyCopier = function (key) {
              ctor.prototype[key] = methods[key];
            };
            Object.keys(methods).forEach(keyCopier);
            Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
            return ctor;
          }
          Iterable.Iterator = Iterator;
          mixin(Iterable, {
            // ### Conversion to other types

            toArray: function () {
              assertNotInfinite(this.size);
              var array = new Array(this.size || 0);
              this.valueSeq().__iterate(function (v, i) {
                array[i] = v;
              });
              return array;
            },
            toIndexedSeq: function () {
              return new ToIndexedSequence(this);
            },
            toJS: function () {
              return this.toSeq().map(function (value) {
                return value && typeof value.toJS === 'function' ? value.toJS() : value;
              }).__toJS();
            },
            toJSON: function () {
              return this.toSeq().map(function (value) {
                return value && typeof value.toJSON === 'function' ? value.toJSON() : value;
              }).__toJS();
            },
            toKeyedSeq: function () {
              return new ToKeyedSequence(this, true);
            },
            toMap: function () {
              // Use Late Binding here to solve the circular dependency.
              return Map(this.toKeyedSeq());
            },
            toObject: function () {
              assertNotInfinite(this.size);
              var object = {};
              this.__iterate(function (v, k) {
                object[k] = v;
              });
              return object;
            },
            toOrderedMap: function () {
              // Use Late Binding here to solve the circular dependency.
              return OrderedMap(this.toKeyedSeq());
            },
            toOrderedSet: function () {
              // Use Late Binding here to solve the circular dependency.
              return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
            },
            toSet: function () {
              // Use Late Binding here to solve the circular dependency.
              return Set(isKeyed(this) ? this.valueSeq() : this);
            },
            toSetSeq: function () {
              return new ToSetSequence(this);
            },
            toSeq: function () {
              return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
            },
            toStack: function () {
              // Use Late Binding here to solve the circular dependency.
              return Stack(isKeyed(this) ? this.valueSeq() : this);
            },
            toList: function () {
              // Use Late Binding here to solve the circular dependency.
              return List(isKeyed(this) ? this.valueSeq() : this);
            },
            // ### Common JavaScript methods and properties

            toString: function () {
              return '[Iterable]';
            },
            __toString: function (head, tail) {
              if (this.size === 0) {
                return head + tail;
              }
              return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
            },
            // ### ES6 Collection methods (ES6 Array and Map)

            concat: function () {
              var values = SLICE$0.call(arguments, 0);
              return reify(this, concatFactory(this, values));
            },
            includes: function (searchValue) {
              return this.some(function (value) {
                return is(value, searchValue);
              });
            },
            entries: function () {
              return this.__iterator(ITERATE_ENTRIES);
            },
            every: function (predicate, context) {
              assertNotInfinite(this.size);
              var returnValue = true;
              this.__iterate(function (v, k, c) {
                if (!predicate.call(context, v, k, c)) {
                  returnValue = false;
                  return false;
                }
              });
              return returnValue;
            },
            filter: function (predicate, context) {
              return reify(this, filterFactory(this, predicate, context, true));
            },
            find: function (predicate, context, notSetValue) {
              var entry = this.findEntry(predicate, context);
              return entry ? entry[1] : notSetValue;
            },
            forEach: function (sideEffect, context) {
              assertNotInfinite(this.size);
              return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
            },
            join: function (separator) {
              assertNotInfinite(this.size);
              separator = separator !== undefined ? '' + separator : ',';
              var joined = '';
              var isFirst = true;
              this.__iterate(function (v) {
                isFirst ? isFirst = false : joined += separator;
                joined += v !== null && v !== undefined ? v.toString() : '';
              });
              return joined;
            },
            keys: function () {
              return this.__iterator(ITERATE_KEYS);
            },
            map: function (mapper, context) {
              return reify(this, mapFactory(this, mapper, context));
            },
            reduce: function (reducer, initialReduction, context) {
              assertNotInfinite(this.size);
              var reduction;
              var useFirst;
              if (arguments.length < 2) {
                useFirst = true;
              } else {
                reduction = initialReduction;
              }
              this.__iterate(function (v, k, c) {
                if (useFirst) {
                  useFirst = false;
                  reduction = v;
                } else {
                  reduction = reducer.call(context, reduction, v, k, c);
                }
              });
              return reduction;
            },
            reduceRight: function (reducer, initialReduction, context) {
              var reversed = this.toKeyedSeq().reverse();
              return reversed.reduce.apply(reversed, arguments);
            },
            reverse: function () {
              return reify(this, reverseFactory(this, true));
            },
            slice: function (begin, end) {
              return reify(this, sliceFactory(this, begin, end, true));
            },
            some: function (predicate, context) {
              return !this.every(not(predicate), context);
            },
            sort: function (comparator) {
              return reify(this, sortFactory(this, comparator));
            },
            values: function () {
              return this.__iterator(ITERATE_VALUES);
            },
            // ### More sequential methods

            butLast: function () {
              return this.slice(0, -1);
            },
            isEmpty: function () {
              return this.size !== undefined ? this.size === 0 : !this.some(function () {
                return true;
              });
            },
            count: function (predicate, context) {
              return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
            },
            countBy: function (grouper, context) {
              return countByFactory(this, grouper, context);
            },
            equals: function (other) {
              return deepEqual(this, other);
            },
            entrySeq: function () {
              var iterable = this;
              if (iterable._cache) {
                // We cache as an entries array, so we can just return the cache!
                return new ArraySeq(iterable._cache);
              }
              var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
              entriesSequence.fromEntrySeq = function () {
                return iterable.toSeq();
              };
              return entriesSequence;
            },
            filterNot: function (predicate, context) {
              return this.filter(not(predicate), context);
            },
            findEntry: function (predicate, context, notSetValue) {
              var found = notSetValue;
              this.__iterate(function (v, k, c) {
                if (predicate.call(context, v, k, c)) {
                  found = [k, v];
                  return false;
                }
              });
              return found;
            },
            findKey: function (predicate, context) {
              var entry = this.findEntry(predicate, context);
              return entry && entry[0];
            },
            findLast: function (predicate, context, notSetValue) {
              return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
            },
            findLastEntry: function (predicate, context, notSetValue) {
              return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
            },
            findLastKey: function (predicate, context) {
              return this.toKeyedSeq().reverse().findKey(predicate, context);
            },
            first: function () {
              return this.find(returnTrue);
            },
            flatMap: function (mapper, context) {
              return reify(this, flatMapFactory(this, mapper, context));
            },
            flatten: function (depth) {
              return reify(this, flattenFactory(this, depth, true));
            },
            fromEntrySeq: function () {
              return new FromEntriesSequence(this);
            },
            get: function (searchKey, notSetValue) {
              return this.find(function (_, key) {
                return is(key, searchKey);
              }, undefined, notSetValue);
            },
            getIn: function (searchKeyPath, notSetValue) {
              var nested = this;
              // Note: in an ES6 environment, we would prefer:
              // for (var key of searchKeyPath) {
              var iter = forceIterator(searchKeyPath);
              var step;
              while (!(step = iter.next()).done) {
                var key = step.value;
                nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
                if (nested === NOT_SET) {
                  return notSetValue;
                }
              }
              return nested;
            },
            groupBy: function (grouper, context) {
              return groupByFactory(this, grouper, context);
            },
            has: function (searchKey) {
              return this.get(searchKey, NOT_SET) !== NOT_SET;
            },
            hasIn: function (searchKeyPath) {
              return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
            },
            isSubset: function (iter) {
              iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
              return this.every(function (value) {
                return iter.includes(value);
              });
            },
            isSuperset: function (iter) {
              iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
              return iter.isSubset(this);
            },
            keyOf: function (searchValue) {
              return this.findKey(function (value) {
                return is(value, searchValue);
              });
            },
            keySeq: function () {
              return this.toSeq().map(keyMapper).toIndexedSeq();
            },
            last: function () {
              return this.toSeq().reverse().first();
            },
            lastKeyOf: function (searchValue) {
              return this.toKeyedSeq().reverse().keyOf(searchValue);
            },
            max: function (comparator) {
              return maxFactory(this, comparator);
            },
            maxBy: function (mapper, comparator) {
              return maxFactory(this, comparator, mapper);
            },
            min: function (comparator) {
              return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
            },
            minBy: function (mapper, comparator) {
              return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
            },
            rest: function () {
              return this.slice(1);
            },
            skip: function (amount) {
              return this.slice(Math.max(0, amount));
            },
            skipLast: function (amount) {
              return reify(this, this.toSeq().reverse().skip(amount).reverse());
            },
            skipWhile: function (predicate, context) {
              return reify(this, skipWhileFactory(this, predicate, context, true));
            },
            skipUntil: function (predicate, context) {
              return this.skipWhile(not(predicate), context);
            },
            sortBy: function (mapper, comparator) {
              return reify(this, sortFactory(this, comparator, mapper));
            },
            take: function (amount) {
              return this.slice(0, Math.max(0, amount));
            },
            takeLast: function (amount) {
              return reify(this, this.toSeq().reverse().take(amount).reverse());
            },
            takeWhile: function (predicate, context) {
              return reify(this, takeWhileFactory(this, predicate, context));
            },
            takeUntil: function (predicate, context) {
              return this.takeWhile(not(predicate), context);
            },
            valueSeq: function () {
              return this.toIndexedSeq();
            },
            // ### Hashable Object

            hashCode: function () {
              return this.__hash || (this.__hash = hashIterable(this));
            }

            // ### Internal

            // abstract __iterate(fn, reverse)

            // abstract __iterator(type, reverse)
          });

          // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
          // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
          // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
          // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

          var IterablePrototype = Iterable.prototype;
          IterablePrototype[IS_ITERABLE_SENTINEL] = true;
          IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
          IterablePrototype.__toJS = IterablePrototype.toArray;
          IterablePrototype.__toStringMapper = quoteString;
          IterablePrototype.inspect = IterablePrototype.toSource = function () {
            return this.toString();
          };
          IterablePrototype.chain = IterablePrototype.flatMap;
          IterablePrototype.contains = IterablePrototype.includes;
          mixin(KeyedIterable, {
            // ### More sequential methods

            flip: function () {
              return reify(this, flipFactory(this));
            },
            mapEntries: function (mapper, context) {
              var this$0 = this;
              var iterations = 0;
              return reify(this, this.toSeq().map(function (v, k) {
                return mapper.call(context, [k, v], iterations++, this$0);
              }).fromEntrySeq());
            },
            mapKeys: function (mapper, context) {
              var this$0 = this;
              return reify(this, this.toSeq().flip().map(function (k, v) {
                return mapper.call(context, k, v, this$0);
              }).flip());
            }
          });
          var KeyedIterablePrototype = KeyedIterable.prototype;
          KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
          KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
          KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
          KeyedIterablePrototype.__toStringMapper = function (v, k) {
            return JSON.stringify(k) + ': ' + quoteString(v);
          };
          mixin(IndexedIterable, {
            // ### Conversion to other types

            toKeyedSeq: function () {
              return new ToKeyedSequence(this, false);
            },
            // ### ES6 Collection methods (ES6 Array and Map)

            filter: function (predicate, context) {
              return reify(this, filterFactory(this, predicate, context, false));
            },
            findIndex: function (predicate, context) {
              var entry = this.findEntry(predicate, context);
              return entry ? entry[0] : -1;
            },
            indexOf: function (searchValue) {
              var key = this.keyOf(searchValue);
              return key === undefined ? -1 : key;
            },
            lastIndexOf: function (searchValue) {
              var key = this.lastKeyOf(searchValue);
              return key === undefined ? -1 : key;
            },
            reverse: function () {
              return reify(this, reverseFactory(this, false));
            },
            slice: function (begin, end) {
              return reify(this, sliceFactory(this, begin, end, false));
            },
            splice: function (index, removeNum /*, ...values*/) {
              var numArgs = arguments.length;
              removeNum = Math.max(removeNum | 0, 0);
              if (numArgs === 0 || numArgs === 2 && !removeNum) {
                return this;
              }
              // If index is negative, it should resolve relative to the size of the
              // collection. However size may be expensive to compute if not cached, so
              // only call count() if the number is in fact negative.
              index = resolveBegin(index, index < 0 ? this.count() : this.size);
              var spliced = this.slice(0, index);
              return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
            },
            // ### More collection methods

            findLastIndex: function (predicate, context) {
              var entry = this.findLastEntry(predicate, context);
              return entry ? entry[0] : -1;
            },
            first: function () {
              return this.get(0);
            },
            flatten: function (depth) {
              return reify(this, flattenFactory(this, depth, false));
            },
            get: function (index, notSetValue) {
              index = wrapIndex(this, index);
              return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function (_, key) {
                return key === index;
              }, undefined, notSetValue);
            },
            has: function (index) {
              index = wrapIndex(this, index);
              return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
            },
            interpose: function (separator) {
              return reify(this, interposeFactory(this, separator));
            },
            interleave: function /*...iterables*/
            () {
              var iterables = [this].concat(arrCopy(arguments));
              var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
              var interleaved = zipped.flatten(true);
              if (zipped.size) {
                interleaved.size = zipped.size * iterables.length;
              }
              return reify(this, interleaved);
            },
            keySeq: function () {
              return Range(0, this.size);
            },
            last: function () {
              return this.get(-1);
            },
            skipWhile: function (predicate, context) {
              return reify(this, skipWhileFactory(this, predicate, context, false));
            },
            zip: function /*, ...iterables */
            () {
              var iterables = [this].concat(arrCopy(arguments));
              return reify(this, zipWithFactory(this, defaultZipper, iterables));
            },
            zipWith: function (zipper /*, ...iterables */) {
              var iterables = arrCopy(arguments);
              iterables[0] = this;
              return reify(this, zipWithFactory(this, zipper, iterables));
            }
          });
          IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
          IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
          mixin(SetIterable, {
            // ### ES6 Collection methods (ES6 Array and Map)

            get: function (value, notSetValue) {
              return this.has(value) ? value : notSetValue;
            },
            includes: function (value) {
              return this.has(value);
            },
            // ### More sequential methods

            keySeq: function () {
              return this.valueSeq();
            }
          });
          SetIterable.prototype.has = IterablePrototype.includes;
          SetIterable.prototype.contains = SetIterable.prototype.includes;

          // Mixin subclasses

          mixin(KeyedSeq, KeyedIterable.prototype);
          mixin(IndexedSeq, IndexedIterable.prototype);
          mixin(SetSeq, SetIterable.prototype);
          mixin(KeyedCollection, KeyedIterable.prototype);
          mixin(IndexedCollection, IndexedIterable.prototype);
          mixin(SetCollection, SetIterable.prototype);

          // #pragma Helper functions

          function keyMapper(v, k) {
            return k;
          }
          function entryMapper(v, k) {
            return [k, v];
          }
          function not(predicate) {
            return function () {
              return !predicate.apply(this, arguments);
            };
          }
          function neg(predicate) {
            return function () {
              return -predicate.apply(this, arguments);
            };
          }
          function quoteString(value) {
            return typeof value === 'string' ? JSON.stringify(value) : String(value);
          }
          function defaultZipper() {
            return arrCopy(arguments);
          }
          function defaultNegComparator(a, b) {
            return a < b ? 1 : a > b ? -1 : 0;
          }
          function hashIterable(iterable) {
            if (iterable.size === Infinity) {
              return 0;
            }
            var ordered = isOrdered(iterable);
            var keyed = isKeyed(iterable);
            var h = ordered ? 1 : 0;
            var size = iterable.__iterate(keyed ? ordered ? function (v, k) {
              h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
            } : function (v, k) {
              h = h + hashMerge(hash(v), hash(k)) | 0;
            } : ordered ? function (v) {
              h = 31 * h + hash(v) | 0;
            } : function (v) {
              h = h + hash(v) | 0;
            });
            return murmurHashOfSize(size, h);
          }
          function murmurHashOfSize(size, h) {
            h = imul(h, 0xCC9E2D51);
            h = imul(h << 15 | h >>> -15, 0x1B873593);
            h = imul(h << 13 | h >>> -13, 5);
            h = (h + 0xE6546B64 | 0) ^ size;
            h = imul(h ^ h >>> 16, 0x85EBCA6B);
            h = imul(h ^ h >>> 13, 0xC2B2AE35);
            h = smi(h ^ h >>> 16);
            return h;
          }
          function hashMerge(a, b) {
            return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
          }

          var Immutable = {
            Iterable: Iterable,
            Seq: Seq,
            Collection: Collection,
            Map: Map,
            OrderedMap: OrderedMap,
            List: List,
            Stack: Stack,
            Set: Set,
            OrderedSet: OrderedSet,
            Record: Record,
            Range: Range,
            Repeat: Repeat,
            is: is,
            fromJS: fromJS
          };
          return Immutable;
        });

        /***/
      }, /* 19 */
      /***/function (module, exports) {
        'use strict';

        var isFunction = function isFunction(functionToCheck) {
          var getType = {};
          return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
        };
        module.exports = isFunction;

        /***/
      }, /* 20 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(140);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      }, /* 21 */
      17, /* 22 */
      /***/function (module, exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(59),
          getPrototype = __webpack_require__(293),
          isObjectLike = __webpack_require__(35);

        /** `Object#toString` result references. */
        var objectTag = '[object Object]';

        /** Used for built-in method references. */
        var funcProto = Function.prototype,
          objectProto = Object.prototype;

        /** Used to resolve the decompiled source of functions. */
        var funcToString = funcProto.toString;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /** Used to infer the `Object` constructor. */
        var objectCtorString = funcToString.call(Object);

        /**
         * Checks if `value` is a plain object, that is, an object created by the
         * `Object` constructor or one with a `[[Prototype]]` of `null`.
         *
         * @static
         * @memberOf _
         * @since 0.8.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * _.isPlainObject(new Foo);
         * // => false
         *
         * _.isPlainObject([1, 2, 3]);
         * // => false
         *
         * _.isPlainObject({ 'x': 0, 'y': 0 });
         * // => true
         *
         * _.isPlainObject(Object.create(null));
         * // => true
         */
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
          return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        module.exports = isPlainObject;

        /***/
      }, /* 23 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _DragDropContext = __webpack_require__(177);
        Object.defineProperty(exports, 'DragDropContext', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_DragDropContext).default;
          }
        });
        var _DragDropContextProvider = __webpack_require__(349);
        Object.defineProperty(exports, 'DragDropContextProvider', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_DragDropContextProvider).default;
          }
        });
        var _DragLayer = __webpack_require__(350);
        Object.defineProperty(exports, 'DragLayer', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_DragLayer).default;
          }
        });
        var _DragSource = __webpack_require__(351);
        Object.defineProperty(exports, 'DragSource', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_DragSource).default;
          }
        });
        var _DropTarget = __webpack_require__(352);
        Object.defineProperty(exports, 'DropTarget', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_DropTarget).default;
          }
        });
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        /***/
      }, /* 24 */
      [1595, 399, 423],, /* 26 */
      /***/function (module, exports, __webpack_require__) {
        var identity = __webpack_require__(166),
          overRest = __webpack_require__(320),
          setToString = __webpack_require__(323);

        /**
         * The base implementation of `_.rest` which doesn't validate or coerce arguments.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         */
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + '');
        }
        module.exports = baseRest;

        /***/
      }, /* 27 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.MENU_HIDE = exports.MENU_SHOW = undefined;
        exports.dispatchGlobalEvent = dispatchGlobalEvent;
        exports.showMenu = showMenu;
        exports.hideMenu = hideMenu;
        var _objectAssign = __webpack_require__(36);
        var _objectAssign2 = _interopRequireDefault(_objectAssign);
        var _helpers = __webpack_require__(28);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var MENU_SHOW = exports.MENU_SHOW = 'REACT_CONTEXTMENU_SHOW';
        var MENU_HIDE = exports.MENU_HIDE = 'REACT_CONTEXTMENU_HIDE';
        function dispatchGlobalEvent(eventName, opts) {
          var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;

          // Compatibale with IE
          // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
          var event = void 0;
          if (typeof window.CustomEvent === 'function') {
            event = new window.CustomEvent(eventName, {
              detail: opts
            });
          } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, false, true, opts);
          }
          if (target) {
            target.dispatchEvent(event);
            (0, _objectAssign2.default)(_helpers.store, opts);
          }
        }
        function showMenu() {
          var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var target = arguments[1];
          dispatchGlobalEvent(MENU_SHOW, (0, _objectAssign2.default)({}, opts, {
            type: MENU_SHOW
          }), target);
        }
        function hideMenu() {
          var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var target = arguments[1];
          dispatchGlobalEvent(MENU_HIDE, (0, _objectAssign2.default)({}, opts, {
            type: MENU_HIDE
          }), target);
        }

        /***/
      }, /* 28 */
      /***/function (module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.callIfExists = callIfExists;
        exports.hasOwnProp = hasOwnProp;
        exports.uniqueId = uniqueId;
        function callIfExists(func) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          return typeof func === 'function' && func.apply(undefined, args);
        }
        function hasOwnProp(obj, prop) {
          return Object.prototype.hasOwnProperty.call(obj, prop);
        }
        function uniqueId() {
          return Math.random().toString(36).substring(7);
        }
        var cssClasses = exports.cssClasses = {
          menu: 'react-contextmenu',
          menuVisible: 'react-contextmenu--visible',
          menuWrapper: 'react-contextmenu-wrapper',
          menuItem: 'react-contextmenu-item',
          menuItemActive: 'react-contextmenu-item--active',
          menuItemDisabled: 'react-contextmenu-item--disabled',
          menuItemDivider: 'react-contextmenu-item--divider',
          menuItemSelected: 'react-contextmenu-item--selected',
          subMenu: 'react-contextmenu-submenu'
        };
        var store = exports.store = {};
        var canUseDOM = exports.canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);

        /***/
      }, /* 29 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(142);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      }, /* 30 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _keymirror = __webpack_require__(145);
        var _keymirror2 = _interopRequireDefault(_keymirror);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var constants = {
          UpdateActions: (0, _keymirror2['default'])({
            CELL_UPDATE: null,
            COLUMN_FILL: null,
            COPY_PASTE: null,
            CELL_DRAG: null
          }),
          DragItemTypes: {
            Column: 'column'
          },
          CellExpand: {
            DOWN_TRIANGLE: String.fromCharCode('9660'),
            RIGHT_TRIANGLE: String.fromCharCode('9654')
          }
        };
        module.exports = constants;

        /***/
      }, /* 31 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var shallowCloneObject = __webpack_require__(52);
        var sameColumn = __webpack_require__(108);
        var ColumnUtils = __webpack_require__(6);
        var getScrollbarSize = __webpack_require__(32);
        var isColumnsImmutable = __webpack_require__(54);
        function setColumnWidths(columns, totalWidth) {
          return columns.map(function (column) {
            var colInfo = Object.assign({}, column);
            if (column.width) {
              if (/^([0-9]+)%$/.exec(column.width.toString())) {
                colInfo.width = Math.floor(column.width / 100 * totalWidth);
              }
            }
            return colInfo;
          });
        }
        function setDefferedColumnWidths(columns, unallocatedWidth, minColumnWidth) {
          var defferedColumns = columns.filter(function (c) {
            return !c.width;
          });
          return columns.map(function (column) {
            if (!column.width && column.width !== 0) {
              if (unallocatedWidth <= 0) {
                column.width = minColumnWidth;
              } else {
                var columnWidth = Math.floor(unallocatedWidth / ColumnUtils.getSize(defferedColumns));
                if (columnWidth < minColumnWidth) {
                  column.width = minColumnWidth;
                } else {
                  column.width = columnWidth;
                }
              }
            }
            return column;
          });
        }
        function setColumnOffsets(columns) {
          var left = 0;
          return columns.map(function (column) {
            column.left = left;
            left += column.width;
            return column;
          });
        }

        /**
         * Update column metrics calculation.
         *
         * @param {ColumnMetricsType} metrics
         */
        function recalculate(metrics) {
          // compute width for columns which specify width
          var columns = setColumnWidths(metrics.columns, metrics.totalWidth);
          var unallocatedWidth = columns.filter(function (c) {
            return c.width;
          }).reduce(function (w, column) {
            return w - column.width;
          }, metrics.totalWidth);
          unallocatedWidth -= getScrollbarSize();
          var width = columns.filter(function (c) {
            return c.width;
          }).reduce(function (w, column) {
            return w + column.width;
          }, 0);

          // compute width for columns which doesn't specify width
          columns = setDefferedColumnWidths(columns, unallocatedWidth, metrics.minColumnWidth);

          // compute left offset
          columns = setColumnOffsets(columns);
          return {
            columns: columns,
            width: width,
            totalWidth: metrics.totalWidth,
            minColumnWidth: metrics.minColumnWidth
          };
        }

        /**
         * Update column metrics calculation by resizing a column.
         *
         * @param {ColumnMetricsType} metrics
         * @param {Column} column
         * @param {number} width
         */
        function resizeColumn(metrics, index, width) {
          var column = ColumnUtils.getColumn(metrics.columns, index);
          var metricsClone = shallowCloneObject(metrics);
          metricsClone.columns = metrics.columns.slice(0);
          var updatedColumn = shallowCloneObject(column);
          updatedColumn.width = Math.max(width, metricsClone.minColumnWidth);
          metricsClone = ColumnUtils.spliceColumn(metricsClone, index, updatedColumn);
          return recalculate(metricsClone);
        }
        function areColumnsImmutable(prevColumns, nextColumns) {
          return isColumnsImmutable(prevColumns) && isColumnsImmutable(nextColumns);
        }
        function compareEachColumn(prevColumns, nextColumns, isSameColumn) {
          var i = void 0;
          var len = void 0;
          var column = void 0;
          var prevColumnsByKey = {};
          var nextColumnsByKey = {};
          if (ColumnUtils.getSize(prevColumns) !== ColumnUtils.getSize(nextColumns)) {
            return false;
          }
          for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
            column = prevColumns[i];
            prevColumnsByKey[column.key] = column;
          }
          for (i = 0, len = ColumnUtils.getSize(nextColumns); i < len; i++) {
            column = nextColumns[i];
            nextColumnsByKey[column.key] = column;
            var prevColumn = prevColumnsByKey[column.key];
            if (prevColumn === undefined || !isSameColumn(prevColumn, column)) {
              return false;
            }
          }
          for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
            column = prevColumns[i];
            var nextColumn = nextColumnsByKey[column.key];
            if (nextColumn === undefined) {
              return false;
            }
          }
          return true;
        }
        function sameColumns(prevColumns, nextColumns, isSameColumn) {
          if (areColumnsImmutable(prevColumns, nextColumns)) {
            return prevColumns === nextColumns;
          }
          return compareEachColumn(prevColumns, nextColumns, isSameColumn);
        }
        module.exports = {
          recalculate: recalculate,
          resizeColumn: resizeColumn,
          sameColumn: sameColumn,
          sameColumns: sameColumns
        };

        /***/
      }, /* 32 */
      /***/function (module, exports) {
        'use strict';

        var size = void 0;
        function getScrollbarSize() {
          if (size === undefined) {
            var outer = document.createElement('div');
            outer.style.width = '50px';
            outer.style.height = '50px';
            outer.style.position = 'absolute';
            outer.style.top = '-200px';
            outer.style.left = '-200px';
            var inner = document.createElement('div');
            inner.style.height = '100px';
            inner.style.width = '100%';
            outer.appendChild(inner);
            document.body.appendChild(outer);
            var outerWidth = outer.clientWidth;
            outer.style.overflowY = 'scroll';
            var innerWidth = inner.clientWidth;
            document.body.removeChild(outer);
            size = outerWidth - innerWidth;
          }
          return size;
        }
        module.exports = getScrollbarSize;

        /***/
      }, /* 33 */
      [1648, 163], /* 34 */
      /***/function (module, exports) {
        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == 'object' || type == 'function');
        }
        module.exports = isObject;

        /***/
      }, /* 35 */
      /***/function (module, exports) {
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */
        function isObjectLike(value) {
          return value != null && typeof value == 'object';
        }
        module.exports = isObjectLike;

        /***/
      }, /* 36 */
      /***/function (module, exports) {
        /*
        object-assign
        (c) Sindre Sorhus
        @license MIT
        */

        'use strict';

        /* eslint-disable no-unused-vars */
        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var propIsEnumerable = Object.prototype.propertyIsEnumerable;
        function toObject(val) {
          if (val === null || val === undefined) {
            throw new TypeError('Object.assign cannot be called with null or undefined');
          }
          return Object(val);
        }
        function shouldUseNative() {
          try {
            if (!Object.assign) {
              return false;
            }

            // Detect buggy property enumeration order in older V8 versions.

            // https://bugs.chromium.org/p/v8/issues/detail?id=4118
            var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
            test1[5] = 'de';
            if (Object.getOwnPropertyNames(test1)[0] === '5') {
              return false;
            }

            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test2 = {};
            for (var i = 0; i < 10; i++) {
              test2['_' + String.fromCharCode(i)] = i;
            }
            var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
              return test2[n];
            });
            if (order2.join('') !== '0123456789') {
              return false;
            }

            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test3 = {};
            'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
              test3[letter] = letter;
            });
            if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
              return false;
            }
            return true;
          } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false;
          }
        }
        module.exports = shouldUseNative() ? Object.assign : function (target, source) {
          var from;
          var to = toObject(target);
          var symbols;
          for (var s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);
            for (var key in from) {
              if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
              }
            }
            if (getOwnPropertySymbols) {
              symbols = getOwnPropertySymbols(from);
              for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                  to[symbols[i]] = from[symbols[i]];
                }
              }
            }
          }
          return to;
        };

        /***/
      }, /* 37 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(138);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      }, /* 38 */
      [1573, 72, 420, 447], /* 39 */
      35, /* 40 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _underscore = __webpack_require__(78);
        var _underscore2 = _interopRequireDefault(_underscore);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _CellAction = __webpack_require__(105);
        var _CellAction2 = _interopRequireDefault(_CellAction);
        var _CellExpand = __webpack_require__(106);
        var _CellExpand2 = _interopRequireDefault(_CellExpand);
        var _ChildRowDeleteButton = __webpack_require__(107);
        var _ChildRowDeleteButton2 = _interopRequireDefault(_ChildRowDeleteButton);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var joinClasses = __webpack_require__(5);
        var EditorContainer = __webpack_require__(124);
        var ExcelColumn = __webpack_require__(12);
        var isFunction = __webpack_require__(19);
        var CellMetaDataShape = __webpack_require__(11);
        var SimpleCellFormatter = __webpack_require__(51);
        var ColumnUtils = __webpack_require__(6);
        var createObjectWithProperties = __webpack_require__(14);
        __webpack_require__(37);

        // The list of the propTypes that we want to include in the Cell div
        var knownDivPropertyKeys = ['height', 'tabIndex', 'value'];
        var Cell = function (_React$Component) {
          _inherits(Cell, _React$Component);
          function Cell() {
            var _temp, _this, _ret;
            _classCallCheck(this, Cell);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              isCellValueChanging: false,
              isLockChanging: false
            }, _this.onCellClick = function (e) {
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onCellClick && typeof meta.onCellClick === 'function') {
                meta.onCellClick({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx
                }, e);
              }
            }, _this.onCellFocus = function () {
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onCellFocus && typeof meta.onCellFocus === 'function') {
                meta.onCellFocus({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx
                });
              }
            }, _this.onCellContextMenu = function () {
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onCellContextMenu && typeof meta.onCellContextMenu === 'function') {
                meta.onCellContextMenu({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx
                });
              }
            }, _this.onCellDoubleClick = function (e) {
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onCellDoubleClick && typeof meta.onCellDoubleClick === 'function') {
                meta.onCellDoubleClick({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx
                }, e);
              }
            }, _this.onCellExpand = function (e) {
              e.stopPropagation();
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onCellExpand != null) {
                meta.onCellExpand({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx,
                  rowData: _this.props.rowData,
                  expandArgs: _this.props.expandableOptions
                });
              }
            }, _this.onCellKeyDown = function (e) {
              if (_this.canExpand() && e.key === 'Enter') {
                _this.onCellExpand(e);
              }
            }, _this.onDeleteSubRow = function () {
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onDeleteSubRow != null) {
                meta.onDeleteSubRow({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx,
                  rowData: _this.props.rowData,
                  expandArgs: _this.props.expandableOptions
                });
              }
            }, _this.onDragHandleDoubleClick = function (e) {
              e.stopPropagation();
              var meta = _this.props.cellMetaData;
              if (meta != null && meta.onDragHandleDoubleClick && typeof meta.onDragHandleDoubleClick === 'function') {
                meta.onDragHandleDoubleClick({
                  rowIdx: _this.props.rowIdx,
                  idx: _this.props.idx,
                  rowData: _this.getRowData(),
                  e: e
                });
              }
            }, _this.onDragOver = function (e) {
              e.preventDefault();
            }, _this.getStyle = function () {
              var style = {
                position: 'absolute',
                width: _this.props.column.width,
                height: _this.props.height,
                left: _this.props.column.left
              };
              return style;
            }, _this.getFormatter = function () {
              var col = _this.props.column;
              if (_this.isActive()) {
                return React.createElement(EditorContainer, {
                  rowData: _this.getRowData(),
                  rowIdx: _this.props.rowIdx,
                  value: _this.props.value,
                  idx: _this.props.idx,
                  cellMetaData: _this.props.cellMetaData,
                  column: col,
                  height: _this.props.height
                });
              }
              return _this.props.column.formatter;
            }, _this.getRowData = function () {
              var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
              return props.rowData.toJSON ? props.rowData.toJSON() : props.rowData;
            }, _this.getFormatterDependencies = function () {
              // convention based method to get corresponding Id or Name of any Name or Id property
              if (typeof _this.props.column.getRowMetaData === 'function') {
                return _this.props.column.getRowMetaData(_this.getRowData(), _this.props.column);
              }
            }, _this.getCellClass = function () {
              var className = joinClasses(_this.props.column.cellClass, 'react-grid-Cell', _this.props.className, _this.props.column.locked ? 'react-grid-Cell--locked' : null);
              var extraClasses = joinClasses({
                'row-selected': _this.props.isRowSelected,
                editing: _this.isActive(),
                copied: _this.isCopied() || _this.wasDraggedOver() || _this.isDraggedOverUpwards() || _this.isDraggedOverDownwards(),
                'is-dragged-over-up': _this.isDraggedOverUpwards(),
                'is-dragged-over-down': _this.isDraggedOverDownwards(),
                'was-dragged-over': _this.wasDraggedOver(),
                'cell-tooltip': _this.props.tooltip ? true : false,
                'rdg-child-cell': _this.props.expandableOptions && _this.props.expandableOptions.subRowDetails && _this.props.expandableOptions.treeDepth > 0,
                'last-column': _this.props.column.isLastColumn
              });
              return joinClasses(className, extraClasses);
            }, _this.getUpdateCellClass = function () {
              return _this.props.column.getUpdateCellClass ? _this.props.column.getUpdateCellClass(_this.props.selectedColumn, _this.props.column, _this.state.isCellValueChanging) : '';
            }, _this.isColumnSelected = function () {
              var meta = _this.props.cellMetaData;
              if (meta == null) {
                return false;
              }
              return meta.selected && meta.selected.idx === _this.props.idx;
            }, _this.isSelected = function () {
              var meta = _this.props.cellMetaData;
              if (meta == null) {
                return false;
              }
              return meta.selected && meta.selected.rowIdx === _this.props.rowIdx && meta.selected.idx === _this.props.idx;
            }, _this.isActive = function () {
              var meta = _this.props.cellMetaData;
              if (meta == null) {
                return false;
              }
              return _this.isSelected() && meta.selected.active === true;
            }, _this.isCellSelectionChanging = function (nextProps) {
              var meta = _this.props.cellMetaData;
              if (meta == null) {
                return false;
              }
              var nextSelected = nextProps.cellMetaData.selected;
              if (meta.selected && nextSelected) {
                return _this.props.idx === nextSelected.idx || _this.props.idx === meta.selected.idx;
              }
              return true;
            }, _this.isCellSelectEnabled = function () {
              var meta = _this.props.cellMetaData;
              if (meta == null) {
                return false;
              }
              return meta.enableCellSelect;
            }, _this.hasChangedDependentValues = function (nextProps) {
              var currentColumn = _this.props.column;
              var hasChangedDependentValues = false;
              if (currentColumn.getRowMetaData) {
                var currentRowMetaData = currentColumn.getRowMetaData(_this.getRowData(), currentColumn);
                var nextColumn = nextProps.column;
                var nextRowMetaData = nextColumn.getRowMetaData(_this.getRowData(nextProps), nextColumn);
                hasChangedDependentValues = !_underscore2['default'].isEqual(currentRowMetaData, nextRowMetaData);
              }
              return hasChangedDependentValues;
            }, _this.applyUpdateClass = function () {
              var updateCellClass = _this.getUpdateCellClass();
              // -> removing the class
              if (updateCellClass != null && updateCellClass !== '') {
                var cellDOMNode = _this.node;
                if (cellDOMNode.classList) {
                  cellDOMNode.classList.remove(updateCellClass);
                  // -> and re-adding the class
                  cellDOMNode.classList.add(updateCellClass);
                } else if (cellDOMNode.className.indexOf(updateCellClass) === -1) {
                  // IE9 doesn't support classList, nor (I think) altering element.className
                  // without replacing it wholesale.
                  cellDOMNode.className = cellDOMNode.className + ' ' + updateCellClass;
                }
              }
            }, _this.setScrollLeft = function (scrollLeft) {
              var node = _this.node;
              if (node) {
                var transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
                node.style.webkitTransform = transform;
                node.style.transform = transform;
              }
            }, _this.removeScroll = function () {
              var node = _this.node;
              if (node) {
                node.style.webkitTransform = null;
                node.style.transform = null;
              }
            }, _this.isCopied = function () {
              var copied = _this.props.cellMetaData.copied;
              return copied && copied.rowIdx === _this.props.rowIdx && copied.idx === _this.props.idx;
            }, _this.isDraggedOver = function () {
              var dragged = _this.props.cellMetaData.dragged;
              return dragged && dragged.overRowIdx === _this.props.rowIdx && dragged.idx === _this.props.idx;
            }, _this.wasDraggedOver = function () {
              var dragged = _this.props.cellMetaData.dragged;
              return dragged && (dragged.overRowIdx < _this.props.rowIdx && _this.props.rowIdx < dragged.rowIdx || dragged.overRowIdx > _this.props.rowIdx && _this.props.rowIdx > dragged.rowIdx) && dragged.idx === _this.props.idx;
            }, _this.isDraggedCellChanging = function (nextProps) {
              var isChanging = void 0;
              var dragged = _this.props.cellMetaData.dragged;
              var nextDragged = nextProps.cellMetaData.dragged;
              if (dragged) {
                isChanging = nextDragged && _this.props.idx === nextDragged.idx || dragged && _this.props.idx === dragged.idx;
                return isChanging;
              }
              return false;
            }, _this.isCopyCellChanging = function (nextProps) {
              var isChanging = void 0;
              var copied = _this.props.cellMetaData.copied;
              var nextCopied = nextProps.cellMetaData.copied;
              if (copied) {
                isChanging = nextCopied && _this.props.idx === nextCopied.idx || copied && _this.props.idx === copied.idx;
                return isChanging;
              }
              return false;
            }, _this.isDraggedOverUpwards = function () {
              var dragged = _this.props.cellMetaData.dragged;
              return !_this.isSelected() && _this.isDraggedOver() && _this.props.rowIdx < dragged.rowIdx;
            }, _this.isDraggedOverDownwards = function () {
              var dragged = _this.props.cellMetaData.dragged;
              return !_this.isSelected() && _this.isDraggedOver() && _this.props.rowIdx > dragged.rowIdx;
            }, _this.isFocusedOnBody = function () {
              return document.activeElement == null || document.activeElement.nodeName && typeof document.activeElement.nodeName === 'string' && document.activeElement.nodeName.toLowerCase() === 'body';
            }, _this.isFocusedOnCell = function () {
              return document.activeElement && document.activeElement.className.indexOf('react-grid-Cell') !== -1;
            }, _this.checkFocus = function () {
              if (_this.isSelected() && !_this.isActive()) {
                if (_this.props.isScrolling && !_this.props.cellMetaData.isScrollingVerticallyWithKeyboard && !_this.props.cellMetaData.isScrollingHorizontallyWithKeyboard) {
                  return;
                }
                // If the enableCellAutoFocus is set in the ReactDataGrid props, it will allow the cell to take focus when the browser is focused on the body.
                // Otherwise, only focus to the current cell if the currently active node in the document is within the data grid.
                // Meaning focus should not be stolen from elements that the grid doesnt control.
                var cellAutoFocusEnabled = _this.props.cellMetaData && _this.props.cellMetaData.enableCellAutoFocus;
                var dataGridDOMNode = _this.props.cellMetaData && _this.props.cellMetaData.getDataGridDOMNode ? _this.props.cellMetaData.getDataGridDOMNode() : null;
                if (_this.isFocusedOnCell() || cellAutoFocusEnabled && _this.isFocusedOnBody() || dataGridDOMNode && dataGridDOMNode.contains(document.activeElement)) {
                  var cellDOMNode = _this.node;
                  if (cellDOMNode) {
                    cellDOMNode.focus();
                  }
                }
              }
            }, _this.canEdit = function () {
              return _this.props.column.editor != null || _this.props.column.editable;
            }, _this.canExpand = function () {
              return _this.props.expandableOptions && _this.props.expandableOptions.canExpand;
            }, _this.createColumEventCallBack = function (onColumnEvent, info) {
              return function (e) {
                onColumnEvent(e, info);
              };
            }, _this.createCellEventCallBack = function (gridEvent, columnEvent) {
              return function (e) {
                gridEvent(e);
                columnEvent(e);
              };
            }, _this.createEventDTO = function (gridEvents, columnEvents, onColumnEvent) {
              var allEvents = Object.assign({}, gridEvents);
              for (var eventKey in columnEvents) {
                if (columnEvents.hasOwnProperty(eventKey)) {
                  var event = columnEvents[event];
                  var eventInfo = {
                    idx: _this.props.idx,
                    rowIdx: _this.props.rowIdx,
                    rowId: _this.props.rowData[_this.props.cellMetaData.rowKey],
                    name: eventKey
                  };
                  var eventCallback = _this.createColumEventCallBack(onColumnEvent, eventInfo);
                  if (allEvents.hasOwnProperty(eventKey)) {
                    var currentEvent = allEvents[eventKey];
                    allEvents[eventKey] = _this.createCellEventCallBack(currentEvent, eventCallback);
                  } else {
                    allEvents[eventKey] = eventCallback;
                  }
                }
              }
              return allEvents;
            }, _this.getEvents = function () {
              var columnEvents = _this.props.column ? Object.assign({}, _this.props.column.events) : undefined;
              var onColumnEvent = _this.props.cellMetaData ? _this.props.cellMetaData.onColumnEvent : undefined;
              var gridEvents = {
                onClick: _this.onCellClick,
                onFocus: _this.onCellFocus,
                onDoubleClick: _this.onCellDoubleClick,
                onContextMenu: _this.onCellContextMenu,
                onDragOver: _this.onDragOver
              };
              if (!columnEvents || !onColumnEvent) {
                return gridEvents;
              }
              return _this.createEventDTO(gridEvents, columnEvents, onColumnEvent);
            }, _this.getKnownDivProps = function () {
              return createObjectWithProperties(_this.props, knownDivPropertyKeys);
            }, _this.renderCellContent = function (props) {
              var CellContent = void 0;
              var Formatter = _this.getFormatter();
              if (React.isValidElement(Formatter)) {
                props.dependentValues = _this.getFormatterDependencies();
                CellContent = React.cloneElement(Formatter, props);
              } else if (isFunction(Formatter)) {
                CellContent = React.createElement(Formatter, {
                  value: _this.props.value,
                  dependentValues: _this.getFormatterDependencies()
                });
              } else {
                CellContent = React.createElement(SimpleCellFormatter, {
                  value: _this.props.value
                });
              }
              var isExpandCell = _this.props.expandableOptions ? _this.props.expandableOptions.field === _this.props.column.key : false;
              var treeDepth = _this.props.expandableOptions ? _this.props.expandableOptions.treeDepth : 0;
              var marginLeft = _this.props.expandableOptions && isExpandCell ? _this.props.expandableOptions.treeDepth * 30 : 0;
              var cellExpander = void 0;
              var cellDeleter = void 0;
              if (_this.canExpand()) {
                cellExpander = React.createElement(_CellExpand2['default'], {
                  expandableOptions: _this.props.expandableOptions,
                  onCellExpand: _this.onCellExpand
                });
              }
              var isDeleteSubRowEnabled = _this.props.cellMetaData.onDeleteSubRow ? true : false;
              if (treeDepth > 0 && isExpandCell) {
                cellDeleter = React.createElement(_ChildRowDeleteButton2['default'], {
                  treeDepth: treeDepth,
                  cellHeight: _this.props.height,
                  siblingIndex: _this.props.expandableOptions.subRowDetails.siblingIndex,
                  numberSiblings: _this.props.expandableOptions.subRowDetails.numberSiblings,
                  onDeleteSubRow: _this.onDeleteSubRow,
                  isDeleteSubRowEnabled: isDeleteSubRowEnabled
                });
              }
              return React.createElement('div', {
                className: 'react-grid-Cell__value'
              }, cellDeleter, React.createElement('div', {
                style: {
                  marginLeft: marginLeft
                }
              }, React.createElement('span', null, CellContent), ' ', _this.props.cellControls, ' ', cellExpander));
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Cell.prototype.componentDidMount = function componentDidMount() {
            this.checkFocus();
          };
          Cell.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            this.setState({
              isCellValueChanging: this.props.isCellValueChanging(this.props.value, nextProps.value),
              isLockChanging: this.props.column.locked !== nextProps.column.locked
            });
          };
          Cell.prototype.componentDidUpdate = function componentDidUpdate() {
            this.checkFocus();
            var dragged = this.props.cellMetaData.dragged;
            if (dragged && dragged.complete === true) {
              this.props.cellMetaData.handleTerminateDrag();
            }
            if (this.state.isCellValueChanging && this.props.selectedColumn != null) {
              this.applyUpdateClass();
            }
            if (this.state.isLockChanging && !this.props.column.locked) {
              this.removeScroll();
            }
          };
          Cell.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            var shouldUpdate = this.props.column.width !== nextProps.column.width || this.props.column.left !== nextProps.column.left || this.props.column.cellClass !== nextProps.column.cellClass || this.props.height !== nextProps.height || this.props.rowIdx !== nextProps.rowIdx || this.isCellSelectionChanging(nextProps) || this.isDraggedCellChanging(nextProps) || this.isCopyCellChanging(nextProps) || this.props.isRowSelected !== nextProps.isRowSelected || this.isSelected() || this.props.isCellValueChanging(this.props.value, nextProps.value) || this.props.forceUpdate === true || this.props.className !== nextProps.className || this.props.expandableOptions !== nextProps.expandableOptions || this.hasChangedDependentValues(nextProps) || this.props.column.locked !== nextProps.column.locked;
            return shouldUpdate;
          };
          Cell.prototype.getCellActions = function getCellActions() {
            var _props = this.props,
              cellMetaData = _props.cellMetaData,
              column = _props.column,
              rowData = _props.rowData;
            if (cellMetaData && cellMetaData.getCellActions) {
              var cellActions = cellMetaData.getCellActions(column, rowData);
              if (cellActions && cellActions.length) {
                return cellActions.map(function (action, index) {
                  return React.createElement(_CellAction2['default'], {
                    key: index,
                    action: action,
                    isFirst: index === 0
                  });
                });
              }
              return null;
            }
            return null;
          };
          Cell.prototype.render = function render() {
            var _this2 = this;
            if (this.props.column.hidden) {
              return null;
            }
            var style = this.getStyle();
            var className = this.getCellClass();
            var cellActions = this.getCellActions();
            var cellContent = this.props.children || this.renderCellContent({
              value: this.props.value,
              column: this.props.column,
              rowIdx: this.props.rowIdx,
              isExpanded: this.props.isExpanded
            });
            var dragHandle = !this.isActive() && ColumnUtils.canEdit(this.props.column, this.props.rowData, this.props.cellMetaData.enableCellSelect) ? React.createElement('div', {
              className: 'drag-handle',
              draggable: 'true',
              onDoubleClick: this.onDragHandleDoubleClick
            }, React.createElement('span', {
              style: {
                display: 'none'
              }
            })) : null;
            var events = this.getEvents();
            var tooltip = this.props.tooltip ? React.createElement('span', {
              className: 'cell-tooltip-text'
            }, this.props.tooltip) : null;
            return React.createElement('div', _extends({}, this.getKnownDivProps(), {
              className: className,
              style: style
            }, events, {
              ref: function ref(node) {
                _this2.node = node;
              }
            }), cellActions, cellContent, dragHandle, tooltip);
          };
          return Cell;
        }(React.Component);
        Cell.propTypes = {
          rowIdx: _propTypes2['default'].number.isRequired,
          idx: _propTypes2['default'].number.isRequired,
          selected: _propTypes2['default'].shape({
            idx: _propTypes2['default'].number.isRequired
          }),
          selectedColumn: _propTypes2['default'].object,
          height: _propTypes2['default'].number,
          tabIndex: _propTypes2['default'].number,
          column: _propTypes2['default'].shape(ExcelColumn).isRequired,
          value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].object, _propTypes2['default'].bool]),
          isExpanded: _propTypes2['default'].bool,
          isRowSelected: _propTypes2['default'].bool,
          cellMetaData: _propTypes2['default'].shape(CellMetaDataShape).isRequired,
          handleDragStart: _propTypes2['default'].func,
          className: _propTypes2['default'].string,
          cellControls: _propTypes2['default'].any,
          rowData: _propTypes2['default'].object.isRequired,
          forceUpdate: _propTypes2['default'].bool,
          expandableOptions: _propTypes2['default'].object.isRequired,
          isScrolling: _propTypes2['default'].bool.isRequired,
          tooltip: _propTypes2['default'].string,
          isCellValueChanging: _propTypes2['default'].func,
          children: _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(_propTypes2['default'].node), _propTypes2['default'].node])
        };
        Cell.defaultProps = {
          tabIndex: 0,
          isExpanded: false,
          value: '',
          isCellValueChanging: function isCellValueChanging(value, nextValue) {
            return value !== nextValue;
          }
        };
        module.exports = Cell;

        /***/
      }, /* 41 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var ReactDOM = __webpack_require__(9);
        var joinClasses = __webpack_require__(5);
        var ExcelColumn = __webpack_require__(12);
        var ResizeHandle = __webpack_require__(120);
        __webpack_require__(15);
        function simpleCellRenderer(objArgs) {
          var headerText = objArgs.column.rowType === 'header' ? objArgs.column.name : '';
          return React.createElement('div', {
            className: 'widget-HeaderCell__value'
          }, headerText);
        }
        var HeaderCell = function (_React$Component) {
          _inherits(HeaderCell, _React$Component);
          function HeaderCell() {
            var _temp, _this, _ret;
            _classCallCheck(this, HeaderCell);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              resizing: false
            }, _this.onDragStart = function (e) {
              _this.setState({
                resizing: true
              });
              // need to set dummy data for FF
              if (e && e.dataTransfer && e.dataTransfer.setData) e.dataTransfer.setData('text/plain', 'dummy');
            }, _this.onDrag = function (e) {
              var resize = _this.props.onResize || null; // for flows sake, doesnt recognise a null check direct
              if (resize) {
                var _width = _this.getWidthFromMouseEvent(e);
                if (_width > 0) {
                  resize(_this.props.column, _width);
                }
              }
            }, _this.onDragEnd = function (e) {
              var width = _this.getWidthFromMouseEvent(e);
              _this.props.onResizeEnd(_this.props.column, width);
              _this.setState({
                resizing: false
              });
            }, _this.getWidthFromMouseEvent = function (e) {
              var right = e.pageX || e.touches && e.touches[0] && e.touches[0].pageX || e.changedTouches && e.changedTouches[e.changedTouches.length - 1].pageX;
              var left = ReactDOM.findDOMNode(_this).getBoundingClientRect().left;
              return right - left;
            }, _this.getCell = function () {
              if (React.isValidElement(_this.props.renderer)) {
                // if it is a string, it's an HTML element, and column is not a valid property, so only pass height
                if (typeof _this.props.renderer.type === 'string') {
                  return React.cloneElement(_this.props.renderer, {
                    height: _this.props.height
                  });
                }
                return React.cloneElement(_this.props.renderer, {
                  column: _this.props.column,
                  height: _this.props.height
                });
              }
              return _this.props.renderer({
                column: _this.props.column
              });
            }, _this.getStyle = function () {
              return {
                width: _this.props.column.width,
                left: _this.props.column.left,
                display: 'inline-block',
                position: 'absolute',
                height: _this.props.height,
                margin: 0,
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              };
            }, _this.setScrollLeft = function (scrollLeft) {
              var node = ReactDOM.findDOMNode(_this);
              node.style.webkitTransform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
              node.style.transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
            }, _this.removeScroll = function () {
              var node = ReactDOM.findDOMNode(_this);
              if (node) {
                var transform = 'none';
                node.style.webkitTransform = transform;
                node.style.transform = transform;
              }
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          HeaderCell.prototype.render = function render() {
            var resizeHandle = void 0;
            if (this.props.column.resizable) {
              resizeHandle = React.createElement(ResizeHandle, {
                onDrag: this.onDrag,
                onDragStart: this.onDragStart,
                onDragEnd: this.onDragEnd
              });
            }
            var className = joinClasses({
              'react-grid-HeaderCell': true,
              'react-grid-HeaderCell--resizing': this.state.resizing,
              'react-grid-HeaderCell--locked': this.props.column.locked
            });
            className = joinClasses(className, this.props.className, this.props.column.cellClass);
            var cell = this.getCell();
            return React.createElement('div', {
              className: className,
              style: this.getStyle()
            }, cell, resizeHandle);
          };
          return HeaderCell;
        }(React.Component);
        HeaderCell.propTypes = {
          renderer: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].element]).isRequired,
          column: _propTypes2['default'].shape(ExcelColumn).isRequired,
          onResize: _propTypes2['default'].func.isRequired,
          height: _propTypes2['default'].number.isRequired,
          onResizeEnd: _propTypes2['default'].func.isRequired,
          className: _propTypes2['default'].string
        };
        HeaderCell.defaultProps = {
          renderer: simpleCellRenderer
        };
        module.exports = HeaderCell;

        /***/
      }, /* 42 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _OverflowCell = __webpack_require__(116);
        var _OverflowCell2 = _interopRequireDefault(_OverflowCell);
        var _RowComparer = __webpack_require__(43);
        var _RowComparer2 = _interopRequireDefault(_RowComparer);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var joinClasses = __webpack_require__(5);
        var Cell = __webpack_require__(40);
        var columnUtils = __webpack_require__(6);
        var cellMetaDataShape = __webpack_require__(11);
        var createObjectWithProperties = __webpack_require__(14);
        __webpack_require__(29);
        var CellExpander = function (_React$Component) {
          _inherits(CellExpander, _React$Component);
          function CellExpander() {
            _classCallCheck(this, CellExpander);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          CellExpander.prototype.render = function render() {
            return React.createElement(Cell, this.props);
          };
          return CellExpander;
        }(React.Component);

        // The list of the propTypes that we want to include in the Row div

        var knownDivPropertyKeys = ['height'];
        var Row = function (_React$Component2) {
          _inherits(Row, _React$Component2);
          function Row() {
            var _temp, _this2, _ret;
            _classCallCheck(this, Row);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this2), _this2.handleDragEnter = function () {
              var handleDragEnterRow = _this2.props.cellMetaData.handleDragEnterRow;
              if (handleDragEnterRow) {
                handleDragEnterRow(_this2.props.idx);
              }
            }, _this2.getSelectedColumn = function () {
              if (_this2.props.cellMetaData) {
                var selected = _this2.props.cellMetaData.selected;
                if (selected && selected.idx) {
                  return columnUtils.getColumn(_this2.props.columns, selected.idx);
                }
              }
            }, _this2.getCellRenderer = function (columnKey) {
              var CellRenderer = _this2.props.cellRenderer;
              if (_this2.props.subRowDetails && _this2.props.subRowDetails.field === columnKey) {
                return CellExpander;
              }
              return CellRenderer;
            }, _this2.getCell = function (column, i, selectedColumn) {
              var CellRenderer = _this2.props.cellRenderer;
              var _this2$props = _this2.props,
                colVisibleStart = _this2$props.colVisibleStart,
                colVisibleEnd = _this2$props.colVisibleEnd,
                idx = _this2$props.idx,
                cellMetaData = _this2$props.cellMetaData;
              var key = column.key,
                formatter = column.formatter,
                locked = column.locked;
              var baseCellProps = {
                key: key + '-' + idx,
                idx: i,
                rowIdx: idx,
                height: _this2.getRowHeight(),
                column: column,
                cellMetaData: cellMetaData
              };
              if ((i < colVisibleStart || i > colVisibleEnd) && !locked) {
                return React.createElement(_OverflowCell2['default'], _extends({
                  ref: function ref(node) {
                    return _this2[key] = node;
                  }
                }, baseCellProps));
              }
              var _this2$props2 = _this2.props,
                row = _this2$props2.row,
                isSelected = _this2$props2.isSelected;
              var cellProps = {
                ref: function ref(node) {
                  return _this2[key] = node;
                },
                value: _this2.getCellValue(key || i),
                rowData: row,
                isRowSelected: isSelected,
                expandableOptions: _this2.getExpandableOptions(key),
                selectedColumn: selectedColumn,
                formatter: formatter,
                isScrolling: _this2.props.isScrolling
              };
              return React.createElement(CellRenderer, _extends({}, baseCellProps, cellProps));
            }, _this2.getCells = function () {
              var cells = [];
              var lockedCells = [];
              var selectedColumn = _this2.getSelectedColumn();
              var lastColumnIdx = _this2.props.columns.size - 1;
              if (_this2.props.columns) {
                _this2.props.columns.forEach(function (column, i) {
                  if (i === lastColumnIdx) {
                    column.isLastColumn = true;
                  }
                  var cell = _this2.getCell(column, i, selectedColumn);
                  if (column.locked) {
                    lockedCells.push(cell);
                  } else {
                    cells.push(cell);
                  }
                });
              }
              return cells.concat(lockedCells);
            }, _this2.getRowHeight = function () {
              var rows = _this2.props.expandedRows || null;
              if (rows && _this2.props.idx) {
                var row = rows[_this2.props.idx] || null;
                if (row) {
                  return row.height;
                }
              }
              return _this2.props.height;
            }, _this2.getCellValue = function (key) {
              var val = void 0;
              if (key === 'select-row') {
                return _this2.props.isSelected;
              } else if (typeof _this2.props.row.get === 'function') {
                val = _this2.props.row.get(key);
              } else {
                val = _this2.props.row[key];
              }
              return val;
            }, _this2.isContextMenuDisplayed = function () {
              if (_this2.props.cellMetaData) {
                var selected = _this2.props.cellMetaData.selected;
                if (selected && selected.contextMenuDisplayed && selected.rowIdx === _this2.props.idx) {
                  return true;
                }
              }
              return false;
            }, _this2.getExpandableOptions = function (columnKey) {
              var subRowDetails = _this2.props.subRowDetails;
              if (subRowDetails) {
                return {
                  canExpand: subRowDetails && subRowDetails.field === columnKey && (subRowDetails.children && subRowDetails.children.length > 0 || subRowDetails.group === true),
                  field: subRowDetails.field,
                  expanded: subRowDetails && subRowDetails.expanded,
                  children: subRowDetails && subRowDetails.children,
                  treeDepth: subRowDetails ? subRowDetails.treeDepth : 0,
                  subRowDetails: subRowDetails
                };
              }
              return {};
            }, _this2.setScrollLeft = function (scrollLeft) {
              _this2.props.columns.forEach(function (column) {
                if (column.locked) {
                  if (!_this2[column.key]) return;
                  _this2[column.key].setScrollLeft(scrollLeft);
                }
              });
            }, _this2.getKnownDivProps = function () {
              return createObjectWithProperties(_this2.props, knownDivPropertyKeys);
            }, _this2.renderCell = function (props) {
              if (typeof _this2.props.cellRenderer === 'function') {
                _this2.props.cellRenderer.call(_this2, props);
              }
              if (React.isValidElement(_this2.props.cellRenderer)) {
                return React.cloneElement(_this2.props.cellRenderer, props);
              }
              return _this2.props.cellRenderer(props);
            }, _temp), _possibleConstructorReturn(_this2, _ret);
          }
          Row.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return (0, _RowComparer2['default'])(nextProps, this.props);
          };
          Row.prototype.render = function render() {
            var className = joinClasses('react-grid-Row', 'react-grid-Row--' + (this.props.idx % 2 === 0 ? 'even' : 'odd'), {
              'row-selected': this.props.isSelected,
              'row-context-menu': this.isContextMenuDisplayed()
            }, this.props.extraClasses);
            var style = {
              height: this.getRowHeight(this.props),
              overflow: 'hidden'
            };
            var cells = this.getCells();
            return React.createElement('div', _extends({}, this.getKnownDivProps(), {
              className: className,
              style: style,
              onDragEnter: this.handleDragEnter
            }), React.isValidElement(this.props.row) ? this.props.row : cells);
          };
          return Row;
        }(React.Component);
        Row.displayName = 'Row';
        Row.propTypes = {
          height: _propTypes2['default'].number.isRequired,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
          row: _propTypes2['default'].any.isRequired,
          cellRenderer: _propTypes2['default'].func,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
          isSelected: _propTypes2['default'].bool,
          idx: _propTypes2['default'].number.isRequired,
          expandedRows: _propTypes2['default'].arrayOf(_propTypes2['default'].object),
          extraClasses: _propTypes2['default'].string,
          forceUpdate: _propTypes2['default'].bool,
          subRowDetails: _propTypes2['default'].object,
          isRowHovered: _propTypes2['default'].bool,
          colVisibleStart: _propTypes2['default'].number.isRequired,
          colVisibleEnd: _propTypes2['default'].number.isRequired,
          colDisplayStart: _propTypes2['default'].number.isRequired,
          colDisplayEnd: _propTypes2['default'].number.isRequired,
          isScrolling: _propTypes2['default'].bool.isRequired
        };
        Row.defaultProps = {
          cellRenderer: Cell,
          isSelected: false,
          height: 35
        };
        module.exports = Row;

        /***/
      }, /* 43 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        exports.shouldRowUpdate = undefined;
        var _ColumnMetrics = __webpack_require__(31);
        var _ColumnMetrics2 = _interopRequireDefault(_ColumnMetrics);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function doesRowContainSelectedCell(props) {
          var selected = props.cellMetaData.selected;
          if (selected && selected.rowIdx === props.idx) {
            return true;
          }
          return false;
        }
        function willRowBeDraggedOver(props) {
          var dragged = props.cellMetaData.dragged;
          return dragged != null && (dragged.rowIdx >= 0 || dragged.complete === true);
        }
        function hasRowBeenCopied(props) {
          var copied = props.cellMetaData.copied;
          return copied != null && copied.rowIdx === props.idx;
        }
        var shouldRowUpdate = exports.shouldRowUpdate = function shouldRowUpdate(nextProps, currentProps) {
          return !_ColumnMetrics2['default'].sameColumns(currentProps.columns, nextProps.columns, _ColumnMetrics2['default'].sameColumn) || doesRowContainSelectedCell(currentProps) || doesRowContainSelectedCell(nextProps) || willRowBeDraggedOver(nextProps) || nextProps.row !== currentProps.row || currentProps.colDisplayStart !== nextProps.colDisplayStart || currentProps.colDisplayEnd !== nextProps.colDisplayEnd || currentProps.colVisibleStart !== nextProps.colVisibleStart || currentProps.colVisibleEnd !== nextProps.colVisibleEnd || hasRowBeenCopied(currentProps) || currentProps.isSelected !== nextProps.isSelected || nextProps.height !== currentProps.height || currentProps.isOver !== nextProps.isOver || currentProps.expandedRows !== nextProps.expandedRows || currentProps.canDrop !== nextProps.canDrop || currentProps.forceUpdate === true || currentProps.extraClasses !== nextProps.extraClasses;
        };
        exports['default'] = shouldRowUpdate;

        /***/
      }, /* 44 */
      /***/function (module, exports) {
        'use strict';

        var RowUtils = {
          get: function get(row, property) {
            if (typeof row.get === 'function') {
              return row.get(property);
            }
            return row[property];
          },
          isRowSelected: function isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx) {
            if (indexes && Object.prototype.toString.call(indexes) === '[object Array]') {
              return indexes.indexOf(rowIdx) > -1;
            } else if (keys && keys.rowKey && keys.values && Object.prototype.toString.call(keys.values) === '[object Array]') {
              return keys.values.indexOf(rowData[keys.rowKey]) > -1;
            } else if (isSelectedKey && rowData && typeof isSelectedKey === 'string') {
              return rowData[isSelectedKey];
            }
            return false;
          }
        };
        module.exports = RowUtils;

        /***/
      }, /* 45 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        exports.SimpleRowsContainer = exports.getNewContextMenuProps = exports.DEFAULT_CONTEXT_MENU_ID = undefined;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var DEFAULT_CONTEXT_MENU_ID = exports.DEFAULT_CONTEXT_MENU_ID = 'rgdContextMenu';
        var SimpleRowsContainer = function SimpleRowsContainer(props) {
          return _react2['default'].createElement('div', {
            key: 'rows-container'
          }, props.rows);
        };
        SimpleRowsContainer.propTypes = {
          width: _propTypes2['default'].number,
          rows: _propTypes2['default'].array
        };
        var getNewContextMenuProps = exports.getNewContextMenuProps = function getNewContextMenuProps(_ref) {
          var contextMenu = _ref.contextMenu,
            rowIdx = _ref.rowIdx,
            idx = _ref.idx;
          return {
            rowIdx: rowIdx,
            idx: idx,
            id: contextMenu.props.id || DEFAULT_CONTEXT_MENU_ID
          };
        };
        var RowsContainer = function (_React$Component) {
          _inherits(RowsContainer, _React$Component);
          function RowsContainer(props) {
            _classCallCheck(this, RowsContainer);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.plugins = props.window ? props.window.ReactDataGridPlugins : window.ReactDataGridPlugins;
            return _this;
          }
          RowsContainer.prototype.validatePlugin = function validatePlugin() {
            if (!this.plugins) {
              throw new Error('You need to include ReactDataGrid UiPlugins in order to initialise context menu');
            }
          };
          RowsContainer.prototype.hasContextMenu = function hasContextMenu() {
            return this.props.contextMenu && _react2['default'].isValidElement(this.props.contextMenu);
          };
          RowsContainer.prototype.renderRowsWithContextMenu = function renderRowsWithContextMenu() {
            var ContextMenuTrigger = this.plugins.Menu.ContextMenuTrigger;
            var newProps = getNewContextMenuProps(this.props);
            var contextMenu = _react2['default'].cloneElement(this.props.contextMenu, newProps);
            // Initialise the context menu if it is available
            return _react2['default'].createElement('div', null, _react2['default'].createElement(ContextMenuTrigger, {
              id: newProps.id
            }, _react2['default'].createElement(SimpleRowsContainer, this.props)), contextMenu);
          };
          RowsContainer.prototype.render = function render() {
            if (this.hasContextMenu()) {
              this.validatePlugin();
              return this.renderRowsWithContextMenu();
            }
            return _react2['default'].createElement(SimpleRowsContainer, this.props);
          };
          return RowsContainer;
        }(_react2['default'].Component);
        RowsContainer.propTypes = {
          contextMenu: _propTypes2['default'].element,
          rowIdx: _propTypes2['default'].number,
          idx: _propTypes2['default'].number,
          window: _propTypes2['default'].object
        };
        exports['default'] = RowsContainer;
        exports.SimpleRowsContainer = SimpleRowsContainer;

        /***/
      }, /* 46 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var joinClasses = __webpack_require__(5);
        var DEFINE_SORT = {
          ASC: 'ASC',
          DESC: 'DESC',
          NONE: 'NONE'
        };
        var SortableHeaderCell = function (_React$Component) {
          _inherits(SortableHeaderCell, _React$Component);
          function SortableHeaderCell() {
            var _temp, _this, _ret;
            _classCallCheck(this, SortableHeaderCell);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onClick = function () {
              var direction = void 0;
              var _this$props = _this.props,
                sortDirection = _this$props.sortDirection,
                sortDescendingFirst = _this$props.sortDescendingFirst;
              switch (sortDirection) {
                default:
                case null:
                case undefined:
                case DEFINE_SORT.NONE:
                  direction = sortDescendingFirst ? DEFINE_SORT.DESC : DEFINE_SORT.ASC;
                  break;
                case DEFINE_SORT.ASC:
                  direction = sortDescendingFirst ? DEFINE_SORT.NONE : DEFINE_SORT.DESC;
                  break;
                case DEFINE_SORT.DESC:
                  direction = sortDescendingFirst ? DEFINE_SORT.ASC : DEFINE_SORT.NONE;
                  break;
              }
              _this.props.onSort(_this.props.columnKey, direction);
            }, _this.getSortByText = function () {
              var unicodeKeys = {
                ASC: '9650',
                DESC: '9660'
              };
              return _this.props.sortDirection === 'NONE' ? '' : String.fromCharCode(unicodeKeys[_this.props.sortDirection]);
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          SortableHeaderCell.prototype.render = function render() {
            var className = joinClasses({
              'react-grid-HeaderCell-sortable': true,
              'react-grid-HeaderCell-sortable--ascending': this.props.sortDirection === 'ASC',
              'react-grid-HeaderCell-sortable--descending': this.props.sortDirection === 'DESC'
            });
            var content = this.props.headerRenderer ? this.props.headerRenderer : this.props.column.name;
            return React.createElement('div', {
              className: className,
              onClick: this.onClick,
              style: {
                cursor: 'pointer'
              }
            }, React.createElement('span', {
              className: 'pull-right'
            }, this.getSortByText()), content);
          };
          return SortableHeaderCell;
        }(React.Component);
        SortableHeaderCell.propTypes = {
          columnKey: _propTypes2['default'].string.isRequired,
          column: _propTypes2['default'].shape({
            name: _propTypes2['default'].node
          }),
          onSort: _propTypes2['default'].func.isRequired,
          sortDirection: _propTypes2['default'].oneOf(Object.keys(DEFINE_SORT)),
          headerRenderer: _propTypes2['default'].node,
          sortDescendingFirst: _propTypes2['default'].bool
        };
        module.exports = SortableHeaderCell;
        module.exports.DEFINE_SORT = DEFINE_SORT;

        /***/
      }, /* 47 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        __webpack_require__(70);
        var CheckboxEditor = function (_React$Component) {
          _inherits(CheckboxEditor, _React$Component);
          function CheckboxEditor() {
            var _temp, _this, _ret;
            _classCallCheck(this, CheckboxEditor);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleChange = function (e) {
              _this.props.column.onCellChange(_this.props.rowIdx, _this.props.column.key, _this.props.dependentValues, e);
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          CheckboxEditor.prototype.render = function render() {
            var checked = this.props.value != null ? this.props.value : false;
            var checkboxName = 'checkbox' + this.props.rowIdx;
            return React.createElement('div', {
              className: 'react-grid-checkbox-container checkbox-align',
              onClick: this.handleChange
            }, React.createElement('input', {
              className: 'react-grid-checkbox',
              type: 'checkbox',
              name: checkboxName,
              checked: checked
            }), React.createElement('label', {
              htmlFor: checkboxName,
              className: 'react-grid-checkbox-label'
            }));
          };
          return CheckboxEditor;
        }(React.Component);
        CheckboxEditor.propTypes = {
          value: _propTypes2['default'].bool,
          rowIdx: _propTypes2['default'].number,
          column: _propTypes2['default'].shape({
            key: _propTypes2['default'].string,
            onCellChange: _propTypes2['default'].func
          }),
          dependentValues: _propTypes2['default'].object
        };
        module.exports = CheckboxEditor;

        /***/
      }, /* 48 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var ReactDOM = __webpack_require__(9);
        var ExcelColumn = __webpack_require__(12);
        var EditorBase = function (_React$Component) {
          _inherits(EditorBase, _React$Component);
          function EditorBase() {
            _classCallCheck(this, EditorBase);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          EditorBase.prototype.getStyle = function getStyle() {
            return {
              width: '100%'
            };
          };
          EditorBase.prototype.getValue = function getValue() {
            var updated = {};
            updated[this.props.column.key] = this.getInputNode().value;
            return updated;
          };
          EditorBase.prototype.getInputNode = function getInputNode() {
            var domNode = ReactDOM.findDOMNode(this);
            if (domNode.tagName === 'INPUT') {
              return domNode;
            }
            return domNode.querySelector('input:not([type=hidden])');
          };
          EditorBase.prototype.inheritContainerStyles = function inheritContainerStyles() {
            return true;
          };
          return EditorBase;
        }(React.Component);
        EditorBase.propTypes = {
          onKeyDown: _propTypes2['default'].func.isRequired,
          value: _propTypes2['default'].any.isRequired,
          onBlur: _propTypes2['default'].func.isRequired,
          column: _propTypes2['default'].shape(ExcelColumn).isRequired,
          commit: _propTypes2['default'].func.isRequired
        };
        module.exports = EditorBase;

        /***/
      }, /* 49 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var EditorBase = __webpack_require__(48);
        var SimpleTextEditor = function (_EditorBase) {
          _inherits(SimpleTextEditor, _EditorBase);
          function SimpleTextEditor() {
            _classCallCheck(this, SimpleTextEditor);
            return _possibleConstructorReturn(this, _EditorBase.apply(this, arguments));
          }
          SimpleTextEditor.prototype.render = function render() {
            var _this2 = this;
            return React.createElement('input', {
              ref: function ref(node) {
                return _this2.input = node;
              },
              type: 'text',
              onBlur: this.props.onBlur,
              className: 'form-control',
              defaultValue: this.props.value
            });
          };
          return SimpleTextEditor;
        }(EditorBase);
        module.exports = SimpleTextEditor;

        /***/
      }, /* 50 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var SelectAll = function SelectAll(props) {
          return _react2['default'].createElement('div', {
            className: 'react-grid-checkbox-container checkbox-align'
          }, _react2['default'].createElement('input', {
            className: 'react-grid-checkbox',
            type: 'checkbox',
            name: 'select-all-checkbox',
            id: 'select-all-checkbox',
            ref: props.inputRef,
            onChange: props.onChange
          }), _react2['default'].createElement('label', {
            htmlFor: 'select-all-checkbox',
            className: 'react-grid-checkbox-label'
          }));
        };
        SelectAll.propTypes = {
          onChange: _propTypes2['default'].func,
          inputRef: _propTypes2['default'].func
        };
        exports['default'] = SelectAll;

        /***/
      }, /* 51 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var SimpleCellFormatter = function (_React$Component) {
          _inherits(SimpleCellFormatter, _React$Component);
          function SimpleCellFormatter() {
            _classCallCheck(this, SimpleCellFormatter);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          SimpleCellFormatter.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return nextProps.value !== this.props.value;
          };
          SimpleCellFormatter.prototype.render = function render() {
            return React.createElement('div', {
              title: this.props.value
            }, this.props.value);
          };
          return SimpleCellFormatter;
        }(React.Component);
        SimpleCellFormatter.propTypes = {
          value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].object, _propTypes2['default'].bool]).isRequired
        };
        module.exports = SimpleCellFormatter;

        /***/
      }, /* 52 */
      /***/function (module, exports) {
        "use strict";

        function shallowCloneObject(obj) {
          var result = {};
          for (var k in obj) {
            if (obj.hasOwnProperty(k)) {
              result[k] = obj[k];
            }
          }
          return result;
        }
        module.exports = shallowCloneObject;

        /***/
      }, /* 53 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var _immutable = __webpack_require__(18);
        module.exports = {
          isEmptyArray: __webpack_require__(131),
          isEmptyObject: __webpack_require__(132),
          isFunction: __webpack_require__(19),
          isImmutableCollection: __webpack_require__(133),
          getMixedTypeValueRetriever: __webpack_require__(135),
          isColumnsImmutable: __webpack_require__(54),
          isImmutableMap: __webpack_require__(134),
          last: function last(arrayOrList) {
            if (arrayOrList == null) {
              throw new Error('arrayOrCollection is null');
            }
            if (_immutable.List.isList(arrayOrList)) {
              return arrayOrList.last();
            }
            if (Array.isArray(arrayOrList)) {
              return arrayOrList[arrayOrList.length - 1];
            }
            throw new Error('Cant get last of: ' + (typeof arrayOrList === 'undefined' ? 'undefined' : _typeof(arrayOrList)));
          }
        };

        /***/
      }, /* 54 */
      /***/function (module, exports) {
        'use strict';

        module.exports = function isColumnsImmutable(columns) {
          return typeof Immutable !== 'undefined' && columns instanceof Immutable.List;
        };

        /***/
      }, /* 55 */
      /***/function (module, exports) {
        'use strict';

        exports.__esModule = true;
        function isKeyPrintable(keycode) {
          var valid = keycode > 47 && keycode < 58 ||
          // number keys
          keycode === 32 || keycode === 13 ||
          // spacebar & return key(s) (if you want to allow carriage returns)
          keycode > 64 && keycode < 91 ||
          // letter keys
          keycode > 95 && keycode < 112 ||
          // numpad keys
          keycode > 185 && keycode < 193 ||
          // ;=,-./` (in order)
          keycode > 218 && keycode < 223; // [\]' (in order)

          return valid;
        }
        function isCtrlKeyHeldDown(e) {
          return (e.ctrlKey === true || e.metaKey === true) && e.key !== 'Control';
        }
        exports.isKeyPrintable = isKeyPrintable;
        exports.isCtrlKeyHeldDown = isCtrlKeyHeldDown;

        /***/
      }, /* 56 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        exports.beginDrag = beginDrag;
        exports.publishDragSource = publishDragSource;
        exports.hover = hover;
        exports.drop = drop;
        exports.endDrag = endDrag;
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        var _isArray = __webpack_require__(21);
        var _isArray2 = _interopRequireDefault(_isArray);
        var _isObject = __webpack_require__(34);
        var _isObject2 = _interopRequireDefault(_isObject);
        var _matchesType = __webpack_require__(155);
        var _matchesType2 = _interopRequireDefault(_matchesType);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
        var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
        var HOVER = exports.HOVER = 'dnd-core/HOVER';
        var DROP = exports.DROP = 'dnd-core/DROP';
        var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';
        function beginDrag(sourceIds) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            publishSource: true,
            clientOffset: null
          };
          var publishSource = options.publishSource,
            clientOffset = options.clientOffset,
            getSourceClientOffset = options.getSourceClientOffset;
          (0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');
          var monitor = this.getMonitor();
          var registry = this.getRegistry();
          (0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
          for (var i = 0; i < sourceIds.length; i++) {
            (0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
          }
          var sourceId = null;
          for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
            if (monitor.canDragSource(sourceIds[_i])) {
              sourceId = sourceIds[_i];
              break;
            }
          }
          if (sourceId === null) {
            return;
          }
          var sourceClientOffset = null;
          if (clientOffset) {
            (0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
            sourceClientOffset = getSourceClientOffset(sourceId);
          }
          var source = registry.getSource(sourceId);
          var item = source.beginDrag(monitor, sourceId);
          (0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');
          registry.pinSource(sourceId);
          var itemType = registry.getSourceType(sourceId);
          return {
            type: BEGIN_DRAG,
            itemType: itemType,
            item: item,
            sourceId: sourceId,
            clientOffset: clientOffset,
            sourceClientOffset: sourceClientOffset,
            isSourcePublic: publishSource
          };
        }
        function publishDragSource() {
          var monitor = this.getMonitor();
          if (!monitor.isDragging()) {
            return;
          }
          return {
            type: PUBLISH_DRAG_SOURCE
          };
        }
        function hover(targetIdsArg) {
          var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$clientOffset = _ref.clientOffset,
            clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
          (0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
          var targetIds = targetIdsArg.slice(0);
          var monitor = this.getMonitor();
          var registry = this.getRegistry();
          (0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
          (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');

          // First check invariants.
          for (var i = 0; i < targetIds.length; i++) {
            var targetId = targetIds[i];
            (0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
            var target = registry.getTarget(targetId);
            (0, _invariant2.default)(target, 'Expected targetIds to be registered.');
          }
          var draggedItemType = monitor.getItemType();

          // Remove those targetIds that don't match the targetType.  This
          // fixes shallow isOver which would only be non-shallow because of
          // non-matching targets.
          for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
            var _targetId = targetIds[_i2];
            var targetType = registry.getTargetType(_targetId);
            if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
              targetIds.splice(_i2, 1);
            }
          }

          // Finally call hover on all matching targets.
          for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
            var _targetId2 = targetIds[_i3];
            var _target = registry.getTarget(_targetId2);
            _target.hover(monitor, _targetId2);
          }
          return {
            type: HOVER,
            targetIds: targetIds,
            clientOffset: clientOffset
          };
        }
        function drop() {
          var _this = this;
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var monitor = this.getMonitor();
          var registry = this.getRegistry();
          (0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
          (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
          var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
          targetIds.reverse();
          targetIds.forEach(function (targetId, index) {
            var target = registry.getTarget(targetId);
            var dropResult = target.drop(monitor, targetId);
            (0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
            if (typeof dropResult === 'undefined') {
              dropResult = index === 0 ? {} : monitor.getDropResult();
            }
            _this.store.dispatch({
              type: DROP,
              dropResult: _extends({}, options, dropResult)
            });
          });
        }
        function endDrag() {
          var monitor = this.getMonitor();
          var registry = this.getRegistry();
          (0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
          var sourceId = monitor.getSourceId();
          var source = registry.getSource(sourceId, true);
          source.endDrag(monitor, sourceId);
          registry.unpinSource();
          return {
            type: END_DRAG
          };
        }

        /***/
      }, /* 57 */
      /***/function (module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.addSource = addSource;
        exports.addTarget = addTarget;
        exports.removeSource = removeSource;
        exports.removeTarget = removeTarget;
        var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
        var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
        var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
        var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
        function addSource(sourceId) {
          return {
            type: ADD_SOURCE,
            sourceId: sourceId
          };
        }
        function addTarget(targetId) {
          return {
            type: ADD_TARGET,
            targetId: targetId
          };
        }
        function removeSource(sourceId) {
          return {
            type: REMOVE_SOURCE,
            sourceId: sourceId
          };
        }
        function removeTarget(targetId) {
          return {
            type: REMOVE_TARGET,
            targetId: targetId
          };
        }

        /***/
      }, /* 58 */
      [1567, 63], /* 59 */
      [1573, 84, 294, 318], /* 60 */
      [1590, 303], /* 61 */
      [1595, 281, 295], /* 62 */
      [1642, 61], /* 63 */
      /***/function (module, exports) {
        /**
         * Performs a
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * comparison between two values to determine if they are equivalent.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.eq(object, object);
         * // => true
         *
         * _.eq(object, other);
         * // => false
         *
         * _.eq('a', 'a');
         * // => true
         *
         * _.eq('a', Object('a'));
         * // => false
         *
         * _.eq(NaN, NaN);
         * // => true
         */
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        module.exports = eq;

        /***/
      }, /* 64 */
      /***/function (module, exports, __webpack_require__) {
        var isArrayLike = __webpack_require__(90),
          isObjectLike = __webpack_require__(35);

        /**
         * This method is like `_.isArrayLike` except that it also checks if `value`
         * is an object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array-like object,
         *  else `false`.
         * @example
         *
         * _.isArrayLikeObject([1, 2, 3]);
         * // => true
         *
         * _.isArrayLikeObject(document.body.children);
         * // => true
         *
         * _.isArrayLikeObject('abc');
         * // => false
         *
         * _.isArrayLikeObject(_.noop);
         * // => false
         */
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        module.exports = isArrayLikeObject;

        /***/
      }, /* 65 */
      5, /* 66 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = checkDecoratorArguments;
        function checkDecoratorArguments(functionName, signature) {
          if (false) {
            var arg, i;
          }
        }

        /***/
      }, /* 67 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }; /*!
             Copyright (c) 2018 Jed Watson.
             Licensed under the MIT License (MIT), see
             http://jedwatson.github.io/react-select
           */

        var _reactInputAutosize = __webpack_require__(366);
        var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
        var _classnames = __webpack_require__(68);
        var _classnames2 = _interopRequireDefault(_classnames);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _reactDom = __webpack_require__(9);
        var _defaultArrowRenderer = __webpack_require__(187);
        var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
        var _defaultClearRenderer = __webpack_require__(188);
        var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
        var _defaultFilterOptions = __webpack_require__(94);
        var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
        var _defaultMenuRenderer = __webpack_require__(95);
        var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
        var _Option = __webpack_require__(185);
        var _Option2 = _interopRequireDefault(_Option);
        var _Value = __webpack_require__(186);
        var _Value2 = _interopRequireDefault(_Value);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _objectWithoutProperties(obj, keys) {
          var target = {};
          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }
          return target;
        }
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var stringifyValue = function stringifyValue(value) {
          return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
        };
        var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
        var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
        var instanceId = 1;
        var shouldShowValue = function shouldShowValue(state, props) {
          var inputValue = state.inputValue,
            isPseudoFocused = state.isPseudoFocused,
            isFocused = state.isFocused;
          var onSelectResetsInput = props.onSelectResetsInput;
          if (!inputValue) return true;
          if (!onSelectResetsInput) {
            return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
          }
          return false;
        };
        var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
          var inputValue = state.inputValue,
            isPseudoFocused = state.isPseudoFocused,
            isFocused = state.isFocused;
          var onSelectResetsInput = props.onSelectResetsInput;
          return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
        };

        /**
         * Retrieve a value from the given options and valueKey
         * @param {String|Number|Array} value	- the selected value(s)
         * @param {Object}		 props	- the Select component's props (or nextProps)
         */
        var expandValue = function expandValue(value, props) {
          var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
          if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
          var options = props.options,
            valueKey = props.valueKey;
          if (!options) return;
          for (var i = 0; i < options.length; i++) {
            if (String(options[i][valueKey]) === String(value)) return options[i];
          }
        };
        var handleRequired = function handleRequired(value, multi) {
          if (!value) return true;
          return multi ? value.length === 0 : Object.keys(value).length === 0;
        };
        var Select = function (_React$Component) {
          _inherits(Select, _React$Component);
          function Select(props) {
            _classCallCheck(this, Select);
            var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
            ['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
              return _this[fn] = _this[fn].bind(_this);
            });
            _this.state = {
              inputValue: '',
              isFocused: false,
              isOpen: false,
              isPseudoFocused: false,
              required: false
            };
            return _this;
          }
          _createClass(Select, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
              this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
              var valueArray = this.getValueArray(this.props.value);
              if (this.props.required) {
                this.setState({
                  required: handleRequired(valueArray[0], this.props.multi)
                });
              }
            }
          }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
              if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
                console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
              }
              if (this.props.autoFocus || this.props.autofocus) {
                this.focus();
              }
            }
          }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
              var valueArray = this.getValueArray(nextProps.value, nextProps);
              if (nextProps.required) {
                this.setState({
                  required: handleRequired(valueArray[0], nextProps.multi)
                });
              } else if (this.props.required) {
                // Used to be required but it's not any more
                this.setState({
                  required: false
                });
              }
              if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
                this.setState({
                  inputValue: this.handleInputValueChange('')
                });
              }
            }
          }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
              // focus to the selected option
              if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
                var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
                var menuNode = (0, _reactDom.findDOMNode)(this.menu);
                var scrollTop = menuNode.scrollTop;
                var scrollBottom = scrollTop + menuNode.offsetHeight;
                var optionTop = focusedOptionNode.offsetTop;
                var optionBottom = optionTop + focusedOptionNode.offsetHeight;
                if (scrollTop > optionTop || scrollBottom < optionBottom) {
                  menuNode.scrollTop = focusedOptionNode.offsetTop;
                }

                // We still set hasScrolledToOption to true even if we didn't
                // actually need to scroll, as we've still confirmed that the
                // option is in view.
                this.hasScrolledToOption = true;
              } else if (!this.state.isOpen) {
                this.hasScrolledToOption = false;
              }
              if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
                this._scrollToFocusedOptionOnUpdate = false;
                var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
                var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
                var focusedRect = focusedDOM.getBoundingClientRect();
                var menuRect = menuDOM.getBoundingClientRect();
                if (focusedRect.bottom > menuRect.bottom) {
                  menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
                } else if (focusedRect.top < menuRect.top) {
                  menuDOM.scrollTop = focusedDOM.offsetTop;
                }
              }
              if (this.props.scrollMenuIntoView && this.menuContainer) {
                var menuContainerRect = this.menuContainer.getBoundingClientRect();
                if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
                  window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
                }
              }
              if (prevProps.disabled !== this.props.disabled) {
                this.setState({
                  isFocused: false
                }); // eslint-disable-line react/no-did-update-set-state
                this.closeMenu();
              }
              if (prevState.isOpen !== this.state.isOpen) {
                this.toggleTouchOutsideEvent(this.state.isOpen);
                var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
                handler && handler();
              }
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              this.toggleTouchOutsideEvent(false);
            }
          }, {
            key: 'toggleTouchOutsideEvent',
            value: function toggleTouchOutsideEvent(enabled) {
              if (enabled) {
                if (!document.addEventListener && document.attachEvent) {
                  document.attachEvent('ontouchstart', this.handleTouchOutside);
                } else {
                  document.addEventListener('touchstart', this.handleTouchOutside);
                }
              } else {
                if (!document.removeEventListener && document.detachEvent) {
                  document.detachEvent('ontouchstart', this.handleTouchOutside);
                } else {
                  document.removeEventListener('touchstart', this.handleTouchOutside);
                }
              }
            }
          }, {
            key: 'handleTouchOutside',
            value: function handleTouchOutside(event) {
              // handle touch outside on ios to dismiss menu
              if (this.wrapper && !this.wrapper.contains(event.target)) {
                this.closeMenu();
              }
            }
          }, {
            key: 'focus',
            value: function focus() {
              if (!this.input) return;
              this.input.focus();
            }
          }, {
            key: 'blurInput',
            value: function blurInput() {
              if (!this.input) return;
              this.input.blur();
            }
          }, {
            key: 'handleTouchMove',
            value: function handleTouchMove() {
              // Set a flag that the view is being dragged
              this.dragging = true;
            }
          }, {
            key: 'handleTouchStart',
            value: function handleTouchStart() {
              // Set a flag that the view is not being dragged
              this.dragging = false;
            }
          }, {
            key: 'handleTouchEnd',
            value: function handleTouchEnd(event) {
              // Check if the view is being dragged, In this case
              // we don't want to fire the click event (because the user only wants to scroll)
              if (this.dragging) return;

              // Fire the mouse events
              this.handleMouseDown(event);
            }
          }, {
            key: 'handleTouchEndClearValue',
            value: function handleTouchEndClearValue(event) {
              // Check if the view is being dragged, In this case
              // we don't want to fire the click event (because the user only wants to scroll)
              if (this.dragging) return;

              // Clear the value
              this.clearValue(event);
            }
          }, {
            key: 'handleMouseDown',
            value: function handleMouseDown(event) {
              // if the event was triggered by a mousedown and not the primary
              // button, or if the component is disabled, ignore it.
              if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
                return;
              }
              if (event.target.tagName === 'INPUT') {
                if (!this.state.isFocused) {
                  this._openAfterFocus = this.props.openOnClick;
                  this.focus();
                } else if (!this.state.isOpen) {
                  this.setState({
                    isOpen: true,
                    isPseudoFocused: false
                  });
                }
                return;
              }

              // prevent default event handlers
              event.preventDefault();

              // for the non-searchable select, toggle the menu
              if (!this.props.searchable) {
                // This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
                this.focus();
                return this.setState({
                  isOpen: !this.state.isOpen
                });
              }
              if (this.state.isFocused) {
                // On iOS, we can get into a state where we think the input is focused but it isn't really,
                // since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
                // Call focus() again here to be safe.
                this.focus();
                var input = this.input;
                var toOpen = true;
                if (typeof input.getInput === 'function') {
                  // Get the actual DOM input if the ref is an <AutosizeInput /> component
                  input = input.getInput();
                }

                // clears the value so that the cursor will be at the end of input when the component re-renders
                input.value = '';
                if (this._focusAfterClear) {
                  toOpen = false;
                  this._focusAfterClear = false;
                }

                // if the input is focused, ensure the menu is open
                this.setState({
                  isOpen: toOpen,
                  isPseudoFocused: false,
                  focusedOption: null
                });
              } else {
                // otherwise, focus the input and open the menu
                this._openAfterFocus = this.props.openOnClick;
                this.focus();
                this.setState({
                  focusedOption: null
                });
              }
            }
          }, {
            key: 'handleMouseDownOnArrow',
            value: function handleMouseDownOnArrow(event) {
              // if the event was triggered by a mousedown and not the primary
              // button, or if the component is disabled, ignore it.
              if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
                return;
              }
              if (this.state.isOpen) {
                // prevent default event handlers
                event.stopPropagation();
                event.preventDefault();
                // close the menu
                this.closeMenu();
              } else {
                // If the menu isn't open, let the event bubble to the main handleMouseDown
                this.setState({
                  isOpen: true
                });
              }
            }
          }, {
            key: 'handleMouseDownOnMenu',
            value: function handleMouseDownOnMenu(event) {
              // if the event was triggered by a mousedown and not the primary
              // button, or if the component is disabled, ignore it.
              if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
                return;
              }
              event.stopPropagation();
              event.preventDefault();
              this._openAfterFocus = true;
              this.focus();
            }
          }, {
            key: 'closeMenu',
            value: function closeMenu() {
              if (this.props.onCloseResetsInput) {
                this.setState({
                  inputValue: this.handleInputValueChange(''),
                  isOpen: false,
                  isPseudoFocused: this.state.isFocused && !this.props.multi
                });
              } else {
                this.setState({
                  isOpen: false,
                  isPseudoFocused: this.state.isFocused && !this.props.multi
                });
              }
              this.hasScrolledToOption = false;
            }
          }, {
            key: 'handleInputFocus',
            value: function handleInputFocus(event) {
              if (this.props.disabled) return;
              var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
              toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

              if (this.props.onFocus) {
                this.props.onFocus(event);
              }
              this.setState({
                isFocused: true,
                isOpen: !!toOpen
              });
              this._focusAfterClear = false;
              this._openAfterFocus = false;
            }
          }, {
            key: 'handleInputBlur',
            value: function handleInputBlur(event) {
              // The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
              if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
                this.focus();
                return;
              }
              if (this.props.onBlur) {
                this.props.onBlur(event);
              }
              var onBlurredState = {
                isFocused: false,
                isOpen: false,
                isPseudoFocused: false
              };
              if (this.props.onBlurResetsInput) {
                onBlurredState.inputValue = this.handleInputValueChange('');
              }
              this.setState(onBlurredState);
            }
          }, {
            key: 'handleInputChange',
            value: function handleInputChange(event) {
              var newInputValue = event.target.value;
              if (this.state.inputValue !== event.target.value) {
                newInputValue = this.handleInputValueChange(newInputValue);
              }
              this.setState({
                inputValue: newInputValue,
                isOpen: true,
                isPseudoFocused: false
              });
            }
          }, {
            key: 'setInputValue',
            value: function setInputValue(newValue) {
              if (this.props.onInputChange) {
                var nextState = this.props.onInputChange(newValue);
                if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
                  newValue = '' + nextState;
                }
              }
              this.setState({
                inputValue: newValue
              });
            }
          }, {
            key: 'handleInputValueChange',
            value: function handleInputValueChange(newValue) {
              if (this.props.onInputChange) {
                var nextState = this.props.onInputChange(newValue);
                // Note: != used deliberately here to catch undefined and null
                if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
                  newValue = '' + nextState;
                }
              }
              return newValue;
            }
          }, {
            key: 'handleKeyDown',
            value: function handleKeyDown(event) {
              if (this.props.disabled) return;
              if (typeof this.props.onInputKeyDown === 'function') {
                this.props.onInputKeyDown(event);
                if (event.defaultPrevented) {
                  return;
                }
              }
              switch (event.keyCode) {
                case 8:
                  // backspace
                  if (!this.state.inputValue && this.props.backspaceRemoves) {
                    event.preventDefault();
                    this.popValue();
                  }
                  break;
                case 9:
                  // tab
                  if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
                    break;
                  }
                  event.preventDefault();
                  this.selectFocusedOption();
                  break;
                case 13:
                  // enter
                  event.preventDefault();
                  event.stopPropagation();
                  if (this.state.isOpen) {
                    this.selectFocusedOption();
                  } else {
                    this.focusNextOption();
                  }
                  break;
                case 27:
                  // escape
                  event.preventDefault();
                  if (this.state.isOpen) {
                    this.closeMenu();
                    event.stopPropagation();
                  } else if (this.props.clearable && this.props.escapeClearsValue) {
                    this.clearValue(event);
                    event.stopPropagation();
                  }
                  break;
                case 32:
                  // space
                  if (this.props.searchable) {
                    break;
                  }
                  event.preventDefault();
                  if (!this.state.isOpen) {
                    this.focusNextOption();
                    break;
                  }
                  event.stopPropagation();
                  this.selectFocusedOption();
                  break;
                case 38:
                  // up
                  event.preventDefault();
                  this.focusPreviousOption();
                  break;
                case 40:
                  // down
                  event.preventDefault();
                  this.focusNextOption();
                  break;
                case 33:
                  // page up
                  event.preventDefault();
                  this.focusPageUpOption();
                  break;
                case 34:
                  // page down
                  event.preventDefault();
                  this.focusPageDownOption();
                  break;
                case 35:
                  // end key
                  if (event.shiftKey) {
                    break;
                  }
                  event.preventDefault();
                  this.focusEndOption();
                  break;
                case 36:
                  // home key
                  if (event.shiftKey) {
                    break;
                  }
                  event.preventDefault();
                  this.focusStartOption();
                  break;
                case 46:
                  // delete
                  if (!this.state.inputValue && this.props.deleteRemoves) {
                    event.preventDefault();
                    this.popValue();
                  }
                  break;
              }
            }
          }, {
            key: 'handleValueClick',
            value: function handleValueClick(option, event) {
              if (!this.props.onValueClick) return;
              this.props.onValueClick(option, event);
            }
          }, {
            key: 'handleMenuScroll',
            value: function handleMenuScroll(event) {
              if (!this.props.onMenuScrollToBottom) return;
              var target = event.target;
              if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
                this.props.onMenuScrollToBottom();
              }
            }
          }, {
            key: 'getOptionLabel',
            value: function getOptionLabel(op) {
              return op[this.props.labelKey];
            }

            /**
             * Turns a value into an array from the given options
             * @param {String|Number|Array} value		- the value of the select input
             * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
             * @returns	{Array}	the value of the select represented in an array
             */
          }, {
            key: 'getValueArray',
            value: function getValueArray(value) {
              var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

              /** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
              var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
              if (props.multi) {
                if (typeof value === 'string') {
                  value = value.split(props.delimiter);
                }
                if (!Array.isArray(value)) {
                  if (value === null || value === undefined) return [];
                  value = [value];
                }
                return value.map(function (value) {
                  return expandValue(value, props);
                }).filter(function (i) {
                  return i;
                });
              }
              var expandedValue = expandValue(value, props);
              return expandedValue ? [expandedValue] : [];
            }
          }, {
            key: 'setValue',
            value: function setValue(value) {
              var _this2 = this;
              if (this.props.autoBlur) {
                this.blurInput();
              }
              if (this.props.required) {
                var required = handleRequired(value, this.props.multi);
                this.setState({
                  required: required
                });
              }
              if (this.props.simpleValue && value) {
                value = this.props.multi ? value.map(function (i) {
                  return i[_this2.props.valueKey];
                }).join(this.props.delimiter) : value[this.props.valueKey];
              }
              if (this.props.onChange) {
                this.props.onChange(value);
              }
            }
          }, {
            key: 'selectValue',
            value: function selectValue(value) {
              var _this3 = this;

              // NOTE: we actually add/set the value in a callback to make sure the
              // input value is empty to avoid styling issues in Chrome
              if (this.props.closeOnSelect) {
                this.hasScrolledToOption = false;
              }
              var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
              if (this.props.multi) {
                this.setState({
                  focusedIndex: null,
                  inputValue: this.handleInputValueChange(updatedValue),
                  isOpen: !this.props.closeOnSelect
                }, function () {
                  var valueArray = _this3.getValueArray(_this3.props.value);
                  if (valueArray.some(function (i) {
                    return i[_this3.props.valueKey] === value[_this3.props.valueKey];
                  })) {
                    _this3.removeValue(value);
                  } else {
                    _this3.addValue(value);
                  }
                });
              } else {
                this.setState({
                  inputValue: this.handleInputValueChange(updatedValue),
                  isOpen: !this.props.closeOnSelect,
                  isPseudoFocused: this.state.isFocused
                }, function () {
                  _this3.setValue(value);
                });
              }
            }
          }, {
            key: 'addValue',
            value: function addValue(value) {
              var valueArray = this.getValueArray(this.props.value);
              var visibleOptions = this._visibleOptions.filter(function (val) {
                return !val.disabled;
              });
              var lastValueIndex = visibleOptions.indexOf(value);
              this.setValue(valueArray.concat(value));
              if (visibleOptions.length - 1 === lastValueIndex) {
                // the last option was selected; focus the second-last one
                this.focusOption(visibleOptions[lastValueIndex - 1]);
              } else if (visibleOptions.length > lastValueIndex) {
                // focus the option below the selected one
                this.focusOption(visibleOptions[lastValueIndex + 1]);
              }
            }
          }, {
            key: 'popValue',
            value: function popValue() {
              var valueArray = this.getValueArray(this.props.value);
              if (!valueArray.length) return;
              if (valueArray[valueArray.length - 1].clearableValue === false) return;
              this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
            }
          }, {
            key: 'removeValue',
            value: function removeValue(value) {
              var _this4 = this;
              var valueArray = this.getValueArray(this.props.value);
              this.setValue(valueArray.filter(function (i) {
                return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
              }));
              this.focus();
            }
          }, {
            key: 'clearValue',
            value: function clearValue(event) {
              // if the event was triggered by a mousedown and not the primary
              // button, ignore it.
              if (event && event.type === 'mousedown' && event.button !== 0) {
                return;
              }
              event.preventDefault();
              this.setValue(this.getResetValue());
              this.setState({
                inputValue: this.handleInputValueChange(''),
                isOpen: false
              }, this.focus);
              this._focusAfterClear = true;
            }
          }, {
            key: 'getResetValue',
            value: function getResetValue() {
              if (this.props.resetValue !== undefined) {
                return this.props.resetValue;
              } else if (this.props.multi) {
                return [];
              } else {
                return null;
              }
            }
          }, {
            key: 'focusOption',
            value: function focusOption(option) {
              this.setState({
                focusedOption: option
              });
            }
          }, {
            key: 'focusNextOption',
            value: function focusNextOption() {
              this.focusAdjacentOption('next');
            }
          }, {
            key: 'focusPreviousOption',
            value: function focusPreviousOption() {
              this.focusAdjacentOption('previous');
            }
          }, {
            key: 'focusPageUpOption',
            value: function focusPageUpOption() {
              this.focusAdjacentOption('page_up');
            }
          }, {
            key: 'focusPageDownOption',
            value: function focusPageDownOption() {
              this.focusAdjacentOption('page_down');
            }
          }, {
            key: 'focusStartOption',
            value: function focusStartOption() {
              this.focusAdjacentOption('start');
            }
          }, {
            key: 'focusEndOption',
            value: function focusEndOption() {
              this.focusAdjacentOption('end');
            }
          }, {
            key: 'focusAdjacentOption',
            value: function focusAdjacentOption(dir) {
              var options = this._visibleOptions.map(function (option, index) {
                return {
                  option: option,
                  index: index
                };
              }).filter(function (option) {
                return !option.option.disabled;
              });
              this._scrollToFocusedOptionOnUpdate = true;
              if (!this.state.isOpen) {
                var newState = {
                  focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
                  isOpen: true
                };
                if (this.props.onSelectResetsInput) {
                  newState.inputValue = '';
                }
                this.setState(newState);
                return;
              }
              if (!options.length) return;
              var focusedIndex = -1;
              for (var i = 0; i < options.length; i++) {
                if (this._focusedOption === options[i].option) {
                  focusedIndex = i;
                  break;
                }
              }
              if (dir === 'next' && focusedIndex !== -1) {
                focusedIndex = (focusedIndex + 1) % options.length;
              } else if (dir === 'previous') {
                if (focusedIndex > 0) {
                  focusedIndex = focusedIndex - 1;
                } else {
                  focusedIndex = options.length - 1;
                }
              } else if (dir === 'start') {
                focusedIndex = 0;
              } else if (dir === 'end') {
                focusedIndex = options.length - 1;
              } else if (dir === 'page_up') {
                var potentialIndex = focusedIndex - this.props.pageSize;
                if (potentialIndex < 0) {
                  focusedIndex = 0;
                } else {
                  focusedIndex = potentialIndex;
                }
              } else if (dir === 'page_down') {
                var _potentialIndex = focusedIndex + this.props.pageSize;
                if (_potentialIndex > options.length - 1) {
                  focusedIndex = options.length - 1;
                } else {
                  focusedIndex = _potentialIndex;
                }
              }
              if (focusedIndex === -1) {
                focusedIndex = 0;
              }
              this.setState({
                focusedIndex: options[focusedIndex].index,
                focusedOption: options[focusedIndex].option
              });
            }
          }, {
            key: 'getFocusedOption',
            value: function getFocusedOption() {
              return this._focusedOption;
            }
          }, {
            key: 'selectFocusedOption',
            value: function selectFocusedOption() {
              if (this._focusedOption) {
                return this.selectValue(this._focusedOption);
              }
            }
          }, {
            key: 'renderLoading',
            value: function renderLoading() {
              if (!this.props.isLoading) return;
              return _react2.default.createElement('span', {
                className: 'Select-loading-zone',
                'aria-hidden': 'true'
              }, _react2.default.createElement('span', {
                className: 'Select-loading'
              }));
            }
          }, {
            key: 'renderValue',
            value: function renderValue(valueArray, isOpen) {
              var _this5 = this;
              var renderLabel = this.props.valueRenderer || this.getOptionLabel;
              var ValueComponent = this.props.valueComponent;
              if (!valueArray.length) {
                var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
                return showPlaceholder ? _react2.default.createElement('div', {
                  className: 'Select-placeholder'
                }, this.props.placeholder) : null;
              }
              var onClick = this.props.onValueClick ? this.handleValueClick : null;
              if (this.props.multi) {
                return valueArray.map(function (value, i) {
                  return _react2.default.createElement(ValueComponent, {
                    disabled: _this5.props.disabled || value.clearableValue === false,
                    id: _this5._instancePrefix + '-value-' + i,
                    instancePrefix: _this5._instancePrefix,
                    key: 'value-' + i + '-' + value[_this5.props.valueKey],
                    onClick: onClick,
                    onRemove: _this5.removeValue,
                    placeholder: _this5.props.placeholder,
                    value: value
                  }, renderLabel(value, i), _react2.default.createElement('span', {
                    className: 'Select-aria-only'
                  }, '\xA0'));
                });
              } else if (shouldShowValue(this.state, this.props)) {
                if (isOpen) onClick = null;
                return _react2.default.createElement(ValueComponent, {
                  disabled: this.props.disabled,
                  id: this._instancePrefix + '-value-item',
                  instancePrefix: this._instancePrefix,
                  onClick: onClick,
                  placeholder: this.props.placeholder,
                  value: valueArray[0]
                }, renderLabel(valueArray[0]));
              }
            }
          }, {
            key: 'renderInput',
            value: function renderInput(valueArray, focusedOptionIndex) {
              var _classNames,
                _this6 = this;
              var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
              var isOpen = this.state.isOpen;
              var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
              var value = this.state.inputValue;
              if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
                // it hides input value when it is not focused and was not reset on select
                value = '';
              }
              var inputProps = _extends({}, this.props.inputProps, {
                'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
                'aria-describedby': this.props['aria-describedby'],
                'aria-expanded': '' + isOpen,
                'aria-haspopup': '' + isOpen,
                'aria-label': this.props['aria-label'],
                'aria-labelledby': this.props['aria-labelledby'],
                'aria-owns': ariaOwns,
                className: className,
                onBlur: this.handleInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.handleInputFocus,
                ref: function ref(_ref) {
                  return _this6.input = _ref;
                },
                role: 'combobox',
                required: this.state.required,
                tabIndex: this.props.tabIndex,
                value: value
              });
              if (this.props.inputRenderer) {
                return this.props.inputRenderer(inputProps);
              }
              if (this.props.disabled || !this.props.searchable) {
                var divProps = _objectWithoutProperties(this.props.inputProps, []);
                var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
                return _react2.default.createElement('div', _extends({}, divProps, {
                  'aria-expanded': isOpen,
                  'aria-owns': _ariaOwns,
                  'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
                  'aria-disabled': '' + this.props.disabled,
                  'aria-label': this.props['aria-label'],
                  'aria-labelledby': this.props['aria-labelledby'],
                  className: className,
                  onBlur: this.handleInputBlur,
                  onFocus: this.handleInputFocus,
                  ref: function ref(_ref2) {
                    return _this6.input = _ref2;
                  },
                  role: 'combobox',
                  style: {
                    border: 0,
                    width: 1,
                    display: 'inline-block'
                  },
                  tabIndex: this.props.tabIndex || 0
                }));
              }
              if (this.props.autosize) {
                return _react2.default.createElement(_reactInputAutosize2.default, _extends({
                  id: this.props.id
                }, inputProps, {
                  minWidth: '5'
                }));
              }
              return _react2.default.createElement('div', {
                className: className,
                key: 'input-wrap',
                style: {
                  display: 'inline-block'
                }
              }, _react2.default.createElement('input', _extends({
                id: this.props.id
              }, inputProps)));
            }
          }, {
            key: 'renderClear',
            value: function renderClear() {
              var valueArray = this.getValueArray(this.props.value);
              if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
              var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
              var clear = this.props.clearRenderer();
              return _react2.default.createElement('span', {
                'aria-label': ariaLabel,
                className: 'Select-clear-zone',
                onMouseDown: this.clearValue,
                onTouchEnd: this.handleTouchEndClearValue,
                onTouchMove: this.handleTouchMove,
                onTouchStart: this.handleTouchStart,
                title: ariaLabel
              }, clear);
            }
          }, {
            key: 'renderArrow',
            value: function renderArrow() {
              if (!this.props.arrowRenderer) return;
              var onMouseDown = this.handleMouseDownOnArrow;
              var isOpen = this.state.isOpen;
              var arrow = this.props.arrowRenderer({
                onMouseDown: onMouseDown,
                isOpen: isOpen
              });
              if (!arrow) {
                return null;
              }
              return _react2.default.createElement('span', {
                className: 'Select-arrow-zone',
                onMouseDown: onMouseDown
              }, arrow);
            }
          }, {
            key: 'filterOptions',
            value: function filterOptions(excludeOptions) {
              var filterValue = this.state.inputValue;
              var options = this.props.options || [];
              if (this.props.filterOptions) {
                // Maintain backwards compatibility with boolean attribute
                var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
                return filterOptions(options, filterValue, excludeOptions, {
                  filterOption: this.props.filterOption,
                  ignoreAccents: this.props.ignoreAccents,
                  ignoreCase: this.props.ignoreCase,
                  labelKey: this.props.labelKey,
                  matchPos: this.props.matchPos,
                  matchProp: this.props.matchProp,
                  trimFilter: this.props.trimFilter,
                  valueKey: this.props.valueKey
                });
              } else {
                return options;
              }
            }
          }, {
            key: 'onOptionRef',
            value: function onOptionRef(ref, isFocused) {
              if (isFocused) {
                this.focused = ref;
              }
            }
          }, {
            key: 'renderMenu',
            value: function renderMenu(options, valueArray, focusedOption) {
              if (options && options.length) {
                return this.props.menuRenderer({
                  focusedOption: focusedOption,
                  focusOption: this.focusOption,
                  inputValue: this.state.inputValue,
                  instancePrefix: this._instancePrefix,
                  labelKey: this.props.labelKey,
                  onFocus: this.focusOption,
                  onOptionRef: this.onOptionRef,
                  onSelect: this.selectValue,
                  optionClassName: this.props.optionClassName,
                  optionComponent: this.props.optionComponent,
                  optionRenderer: this.props.optionRenderer || this.getOptionLabel,
                  options: options,
                  removeValue: this.removeValue,
                  selectValue: this.selectValue,
                  valueArray: valueArray,
                  valueKey: this.props.valueKey
                });
              } else if (this.props.noResultsText) {
                return _react2.default.createElement('div', {
                  className: 'Select-noresults'
                }, this.props.noResultsText);
              } else {
                return null;
              }
            }
          }, {
            key: 'renderHiddenField',
            value: function renderHiddenField(valueArray) {
              var _this7 = this;
              if (!this.props.name) return;
              if (this.props.joinValues) {
                var value = valueArray.map(function (i) {
                  return stringifyValue(i[_this7.props.valueKey]);
                }).join(this.props.delimiter);
                return _react2.default.createElement('input', {
                  disabled: this.props.disabled,
                  name: this.props.name,
                  ref: function ref(_ref3) {
                    return _this7.value = _ref3;
                  },
                  type: 'hidden',
                  value: value
                });
              }
              return valueArray.map(function (item, index) {
                return _react2.default.createElement('input', {
                  disabled: _this7.props.disabled,
                  key: 'hidden.' + index,
                  name: _this7.props.name,
                  ref: 'value' + index,
                  type: 'hidden',
                  value: stringifyValue(item[_this7.props.valueKey])
                });
              });
            }
          }, {
            key: 'getFocusableOptionIndex',
            value: function getFocusableOptionIndex(selectedOption) {
              var options = this._visibleOptions;
              if (!options.length) return null;
              var valueKey = this.props.valueKey;
              var focusedOption = this.state.focusedOption || selectedOption;
              if (focusedOption && !focusedOption.disabled) {
                var focusedOptionIndex = -1;
                options.some(function (option, index) {
                  var isOptionEqual = option[valueKey] === focusedOption[valueKey];
                  if (isOptionEqual) {
                    focusedOptionIndex = index;
                  }
                  return isOptionEqual;
                });
                if (focusedOptionIndex !== -1) {
                  return focusedOptionIndex;
                }
              }
              for (var i = 0; i < options.length; i++) {
                if (!options[i].disabled) return i;
              }
              return null;
            }
          }, {
            key: 'renderOuter',
            value: function renderOuter(options, valueArray, focusedOption) {
              var _this8 = this;
              var menu = this.renderMenu(options, valueArray, focusedOption);
              if (!menu) {
                return null;
              }
              return _react2.default.createElement('div', {
                ref: function ref(_ref5) {
                  return _this8.menuContainer = _ref5;
                },
                className: 'Select-menu-outer',
                style: this.props.menuContainerStyle
              }, _react2.default.createElement('div', {
                className: 'Select-menu',
                id: this._instancePrefix + '-list',
                onMouseDown: this.handleMouseDownOnMenu,
                onScroll: this.handleMenuScroll,
                ref: function ref(_ref4) {
                  return _this8.menu = _ref4;
                },
                role: 'listbox',
                style: this.props.menuStyle,
                tabIndex: -1
              }, menu));
            }
          }, {
            key: 'render',
            value: function render() {
              var _this9 = this;
              var valueArray = this.getValueArray(this.props.value);
              var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
              var isOpen = this.state.isOpen;
              if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
              var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
              var focusedOption = null;
              if (focusedOptionIndex !== null) {
                focusedOption = this._focusedOption = options[focusedOptionIndex];
              } else {
                focusedOption = this._focusedOption = null;
              }
              var className = (0, _classnames2.default)('Select', this.props.className, {
                'has-value': valueArray.length,
                'is-clearable': this.props.clearable,
                'is-disabled': this.props.disabled,
                'is-focused': this.state.isFocused,
                'is-loading': this.props.isLoading,
                'is-open': isOpen,
                'is-pseudo-focused': this.state.isPseudoFocused,
                'is-searchable': this.props.searchable,
                'Select--multi': this.props.multi,
                'Select--rtl': this.props.rtl,
                'Select--single': !this.props.multi
              });
              var removeMessage = null;
              if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
                removeMessage = _react2.default.createElement('span', {
                  id: this._instancePrefix + '-backspace-remove-message',
                  className: 'Select-aria-only',
                  'aria-live': 'assertive'
                }, this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey]));
              }
              return _react2.default.createElement('div', {
                ref: function ref(_ref7) {
                  return _this9.wrapper = _ref7;
                },
                className: className,
                style: this.props.wrapperStyle
              }, this.renderHiddenField(valueArray), _react2.default.createElement('div', {
                ref: function ref(_ref6) {
                  return _this9.control = _ref6;
                },
                className: 'Select-control',
                onKeyDown: this.handleKeyDown,
                onMouseDown: this.handleMouseDown,
                onTouchEnd: this.handleTouchEnd,
                onTouchMove: this.handleTouchMove,
                onTouchStart: this.handleTouchStart,
                style: this.props.style
              }, _react2.default.createElement('span', {
                className: 'Select-multi-value-wrapper',
                id: this._instancePrefix + '-value'
              }, this.renderValue(valueArray, isOpen), this.renderInput(valueArray, focusedOptionIndex)), removeMessage, this.renderLoading(), this.renderClear(), this.renderArrow()), isOpen ? this.renderOuter(options, valueArray, focusedOption) : null);
            }
          }]);
          return Select;
        }(_react2.default.Component);
        Select.propTypes = {
          'aria-describedby': _propTypes2.default.string,
          // html id(s) of element(s) that should be used to describe this input (for assistive tech)
          'aria-label': _propTypes2.default.string,
          // aria label (for assistive tech)
          'aria-labelledby': _propTypes2.default.string,
          // html id of an element that should be used as the label (for assistive tech)
          arrowRenderer: _propTypes2.default.func,
          // create the drop-down caret element
          autoBlur: _propTypes2.default.bool,
          // automatically blur the component when an option is selected
          autoFocus: _propTypes2.default.bool,
          // autofocus the component on mount
          autofocus: _propTypes2.default.bool,
          // deprecated; use autoFocus instead
          autosize: _propTypes2.default.bool,
          // whether to enable autosizing or not
          backspaceRemoves: _propTypes2.default.bool,
          // whether backspace removes an item if there is no text input
          backspaceToRemoveMessage: _propTypes2.default.string,
          // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
          className: _propTypes2.default.string,
          // className for the outer element
          clearAllText: stringOrNode,
          // title for the "clear" control when multi: true
          clearRenderer: _propTypes2.default.func,
          // create clearable x element
          clearValueText: stringOrNode,
          // title for the "clear" control
          clearable: _propTypes2.default.bool,
          // should it be possible to reset value
          closeOnSelect: _propTypes2.default.bool,
          // whether to close the menu when a value is selected
          deleteRemoves: _propTypes2.default.bool,
          // whether delete removes an item if there is no text input
          delimiter: _propTypes2.default.string,
          // delimiter to use to join multiple values for the hidden field value
          disabled: _propTypes2.default.bool,
          // whether the Select is disabled or not
          escapeClearsValue: _propTypes2.default.bool,
          // whether escape clears the value when the menu is closed
          filterOption: _propTypes2.default.func,
          // method to filter a single option (option, filterString)
          filterOptions: _propTypes2.default.any,
          // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
          id: _propTypes2.default.string,
          // html id to set on the input element for accessibility or tests
          ignoreAccents: _propTypes2.default.bool,
          // whether to strip diacritics when filtering
          ignoreCase: _propTypes2.default.bool,
          // whether to perform case-insensitive filtering
          inputProps: _propTypes2.default.object,
          // custom attributes for the Input
          inputRenderer: _propTypes2.default.func,
          // returns a custom input component
          instanceId: _propTypes2.default.string,
          // set the components instanceId
          isLoading: _propTypes2.default.bool,
          // whether the Select is loading externally or not (such as options being loaded)
          joinValues: _propTypes2.default.bool,
          // joins multiple values into a single form field with the delimiter (legacy mode)
          labelKey: _propTypes2.default.string,
          // path of the label value in option objects
          matchPos: _propTypes2.default.string,
          // (any|start) match the start or entire string when filtering
          matchProp: _propTypes2.default.string,
          // (any|label|value) which option property to filter on
          menuBuffer: _propTypes2.default.number,
          // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
          menuContainerStyle: _propTypes2.default.object,
          // optional style to apply to the menu container
          menuRenderer: _propTypes2.default.func,
          // renders a custom menu with options
          menuStyle: _propTypes2.default.object,
          // optional style to apply to the menu
          multi: _propTypes2.default.bool,
          // multi-value input
          name: _propTypes2.default.string,
          // generates a hidden <input /> tag with this field name for html forms
          noResultsText: stringOrNode,
          // placeholder displayed when there are no matching search results
          onBlur: _propTypes2.default.func,
          // onBlur handler: function (event) {}
          onBlurResetsInput: _propTypes2.default.bool,
          // whether input is cleared on blur
          onChange: _propTypes2.default.func,
          // onChange handler: function (newValue) {}
          onClose: _propTypes2.default.func,
          // fires when the menu is closed
          onCloseResetsInput: _propTypes2.default.bool,
          // whether input is cleared when menu is closed through the arrow
          onFocus: _propTypes2.default.func,
          // onFocus handler: function (event) {}
          onInputChange: _propTypes2.default.func,
          // onInputChange handler: function (inputValue) {}
          onInputKeyDown: _propTypes2.default.func,
          // input keyDown handler: function (event) {}
          onMenuScrollToBottom: _propTypes2.default.func,
          // fires when the menu is scrolled to the bottom; can be used to paginate options
          onOpen: _propTypes2.default.func,
          // fires when the menu is opened
          onSelectResetsInput: _propTypes2.default.bool,
          // whether input is cleared on select (works only for multiselect)
          onValueClick: _propTypes2.default.func,
          // onClick handler for value labels: function (value, event) {}
          openOnClick: _propTypes2.default.bool,
          // boolean to control opening the menu when the control is clicked
          openOnFocus: _propTypes2.default.bool,
          // always open options menu on focus
          optionClassName: _propTypes2.default.string,
          // additional class(es) to apply to the <Option /> elements
          optionComponent: _propTypes2.default.func,
          // option component to render in dropdown
          optionRenderer: _propTypes2.default.func,
          // optionRenderer: function (option) {}
          options: _propTypes2.default.array,
          // array of options
          pageSize: _propTypes2.default.number,
          // number of entries to page when using page up/down keys
          placeholder: stringOrNode,
          // field placeholder, displayed when there's no value
          removeSelected: _propTypes2.default.bool,
          // whether the selected option is removed from the dropdown on multi selects
          required: _propTypes2.default.bool,
          // applies HTML5 required attribute when needed
          resetValue: _propTypes2.default.any,
          // value to use when you clear the control
          rtl: _propTypes2.default.bool,
          // set to true in order to use react-select in right-to-left direction
          scrollMenuIntoView: _propTypes2.default.bool,
          // boolean to enable the viewport to shift so that the full menu fully visible when engaged
          searchable: _propTypes2.default.bool,
          // whether to enable searching feature or not
          simpleValue: _propTypes2.default.bool,
          // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
          style: _propTypes2.default.object,
          // optional style to apply to the control
          tabIndex: stringOrNumber,
          // optional tab index of the control
          tabSelectsValue: _propTypes2.default.bool,
          // whether to treat tabbing out while focused to be value selection
          trimFilter: _propTypes2.default.bool,
          // whether to trim whitespace around filter value
          value: _propTypes2.default.any,
          // initial field value
          valueComponent: _propTypes2.default.func,
          // value component to render
          valueKey: _propTypes2.default.string,
          // path of the label value in option objects
          valueRenderer: _propTypes2.default.func,
          // valueRenderer: function (option) {}
          wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
        };

        Select.defaultProps = {
          arrowRenderer: _defaultArrowRenderer2.default,
          autosize: true,
          backspaceRemoves: true,
          backspaceToRemoveMessage: 'Press backspace to remove {label}',
          clearable: true,
          clearAllText: 'Clear all',
          clearRenderer: _defaultClearRenderer2.default,
          clearValueText: 'Clear value',
          closeOnSelect: true,
          deleteRemoves: true,
          delimiter: ',',
          disabled: false,
          escapeClearsValue: true,
          filterOptions: _defaultFilterOptions2.default,
          ignoreAccents: true,
          ignoreCase: true,
          inputProps: {},
          isLoading: false,
          joinValues: false,
          labelKey: 'label',
          matchPos: 'any',
          matchProp: 'any',
          menuBuffer: 0,
          menuRenderer: _defaultMenuRenderer2.default,
          multi: false,
          noResultsText: 'No results found',
          onBlurResetsInput: true,
          onCloseResetsInput: true,
          onSelectResetsInput: true,
          openOnClick: true,
          optionComponent: _Option2.default,
          pageSize: 5,
          placeholder: 'Select...',
          removeSelected: true,
          required: false,
          rtl: false,
          scrollMenuIntoView: true,
          searchable: true,
          simpleValue: false,
          tabSelectsValue: true,
          trimFilter: true,
          valueComponent: _Value2.default,
          valueKey: 'value'
        };
        exports.default = Select;

        /***/
      }, /* 68 */
      5, /* 69 */
      /***/function (module, exports) {
        module.exports = function shallowEqual(objA, objB, compare, compareContext) {
          var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
          if (ret !== void 0) {
            return !!ret;
          }
          if (objA === objB) {
            return true;
          }
          if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
            return false;
          }
          var keysA = Object.keys(objA);
          var keysB = Object.keys(objB);
          if (keysA.length !== keysB.length) {
            return false;
          }
          var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

          // Test for A's keys different from B.
          for (var idx = 0; idx < keysA.length; idx++) {
            var key = keysA[idx];
            if (!bHasOwnProperty(key)) {
              return false;
            }
            var valueA = objA[key];
            var valueB = objB[key];
            ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
            if (ret === false || ret === void 0 && valueA !== valueB) {
              return false;
            }
          }
          return true;
        };

        /***/
      }, /* 70 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(139);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      }, /* 71 */
      [1545, 433, 434, 435, 436, 437], /* 72 */
      [1560, 16], /* 73 */
      [1567, 201], /* 74 */
      [1590, 430], /* 75 */
      [1642, 24], /* 76 */
      /***/function (module, exports, __webpack_require__) {
        var isSymbol = __webpack_require__(101);

        /** Used as references for various `Number` constants. */
        var INFINITY = 1 / 0;

        /**
         * Converts `value` to a string key if it's not a string or symbol.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {string|symbol} Returns the key.
         */
        function toKey(value) {
          if (typeof value == 'string' || isSymbol(value)) {
            return value;
          }
          var result = value + '';
          return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        module.exports = toKey;

        /***/
      },, /* 78 */
      /***/function (module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; //     Underscore.js 1.8.3
        //     http://underscorejs.org
        //     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
        //     Underscore may be freely distributed under the MIT license.

        (function () {
          // Baseline setup
          // --------------

          // Establish the root object, `window` in the browser, or `exports` on the server.
          var root = this;

          // Save the previous value of the `_` variable.
          var previousUnderscore = root._;

          // Save bytes in the minified (but not gzipped) version:
          var ArrayProto = Array.prototype,
            ObjProto = Object.prototype,
            FuncProto = Function.prototype;

          // Create quick reference variables for speed access to core prototypes.
          var push = ArrayProto.push,
            slice = ArrayProto.slice,
            toString = ObjProto.toString,
            hasOwnProperty = ObjProto.hasOwnProperty;

          // All **ECMAScript 5** native function implementations that we hope to use
          // are declared here.
          var nativeIsArray = Array.isArray,
            nativeKeys = Object.keys,
            nativeBind = FuncProto.bind,
            nativeCreate = Object.create;

          // Naked function reference for surrogate-prototype-swapping.
          var Ctor = function () {};

          // Create a safe reference to the Underscore object for use below.
          var _ = function (obj) {
            if (obj instanceof _) return obj;
            if (!(this instanceof _)) return new _(obj);
            this._wrapped = obj;
          };

          // Export the Underscore object for **Node.js**, with
          // backwards-compatibility for the old `require()` API. If we're in
          // the browser, add `_` as a global object.
          if (true) {
            if (typeof module !== 'undefined' && module.exports) {
              exports = module.exports = _;
            }
            exports._ = _;
          } else {}

          // Current version.
          _.VERSION = '1.8.3';

          // Internal function that returns an efficient (for current engines) version
          // of the passed-in callback, to be repeatedly applied in other Underscore
          // functions.
          var optimizeCb = function (func, context, argCount) {
            if (context === void 0) return func;
            switch (argCount == null ? 3 : argCount) {
              case 1:
                return function (value) {
                  return func.call(context, value);
                };
              case 2:
                return function (value, other) {
                  return func.call(context, value, other);
                };
              case 3:
                return function (value, index, collection) {
                  return func.call(context, value, index, collection);
                };
              case 4:
                return function (accumulator, value, index, collection) {
                  return func.call(context, accumulator, value, index, collection);
                };
            }
            return function () {
              return func.apply(context, arguments);
            };
          };

          // A mostly-internal function to generate callbacks that can be applied
          // to each element in a collection, returning the desired result — either
          // identity, an arbitrary callback, a property matcher, or a property accessor.
          var cb = function (value, context, argCount) {
            if (value == null) return _.identity;
            if (_.isFunction(value)) return optimizeCb(value, context, argCount);
            if (_.isObject(value)) return _.matcher(value);
            return _.property(value);
          };
          _.iteratee = function (value, context) {
            return cb(value, context, Infinity);
          };

          // An internal function for creating assigner functions.
          var createAssigner = function (keysFunc, undefinedOnly) {
            return function (obj) {
              var length = arguments.length;
              if (length < 2 || obj == null) return obj;
              for (var index = 1; index < length; index++) {
                var source = arguments[index],
                  keys = keysFunc(source),
                  l = keys.length;
                for (var i = 0; i < l; i++) {
                  var key = keys[i];
                  if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
                }
              }
              return obj;
            };
          };

          // An internal function for creating a new object that inherits from another.
          var baseCreate = function (prototype) {
            if (!_.isObject(prototype)) return {};
            if (nativeCreate) return nativeCreate(prototype);
            Ctor.prototype = prototype;
            var result = new Ctor();
            Ctor.prototype = null;
            return result;
          };
          var property = function (key) {
            return function (obj) {
              return obj == null ? void 0 : obj[key];
            };
          };

          // Helper for collection methods to determine whether a collection
          // should be iterated as an array or as an object
          // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
          // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
          var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
          var getLength = property('length');
          var isArrayLike = function (collection) {
            var length = getLength(collection);
            return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
          };

          // Collection Functions
          // --------------------

          // The cornerstone, an `each` implementation, aka `forEach`.
          // Handles raw objects in addition to array-likes. Treats all
          // sparse array-likes as if they were dense.
          _.each = _.forEach = function (obj, iteratee, context) {
            iteratee = optimizeCb(iteratee, context);
            var i, length;
            if (isArrayLike(obj)) {
              for (i = 0, length = obj.length; i < length; i++) {
                iteratee(obj[i], i, obj);
              }
            } else {
              var keys = _.keys(obj);
              for (i = 0, length = keys.length; i < length; i++) {
                iteratee(obj[keys[i]], keys[i], obj);
              }
            }
            return obj;
          };

          // Return the results of applying the iteratee to each element.
          _.map = _.collect = function (obj, iteratee, context) {
            iteratee = cb(iteratee, context);
            var keys = !isArrayLike(obj) && _.keys(obj),
              length = (keys || obj).length,
              results = Array(length);
            for (var index = 0; index < length; index++) {
              var currentKey = keys ? keys[index] : index;
              results[index] = iteratee(obj[currentKey], currentKey, obj);
            }
            return results;
          };

          // Create a reducing function iterating left or right.
          function createReduce(dir) {
            // Optimized iterator function as using arguments.length
            // in the main function will deoptimize the, see #1991.
            function iterator(obj, iteratee, memo, keys, index, length) {
              for (; index >= 0 && index < length; index += dir) {
                var currentKey = keys ? keys[index] : index;
                memo = iteratee(memo, obj[currentKey], currentKey, obj);
              }
              return memo;
            }
            return function (obj, iteratee, memo, context) {
              iteratee = optimizeCb(iteratee, context, 4);
              var keys = !isArrayLike(obj) && _.keys(obj),
                length = (keys || obj).length,
                index = dir > 0 ? 0 : length - 1;
              // Determine the initial value if none is provided.
              if (arguments.length < 3) {
                memo = obj[keys ? keys[index] : index];
                index += dir;
              }
              return iterator(obj, iteratee, memo, keys, index, length);
            };
          }

          // **Reduce** builds up a single result from a list of values, aka `inject`,
          // or `foldl`.
          _.reduce = _.foldl = _.inject = createReduce(1);

          // The right-associative version of reduce, also known as `foldr`.
          _.reduceRight = _.foldr = createReduce(-1);

          // Return the first value which passes a truth test. Aliased as `detect`.
          _.find = _.detect = function (obj, predicate, context) {
            var key;
            if (isArrayLike(obj)) {
              key = _.findIndex(obj, predicate, context);
            } else {
              key = _.findKey(obj, predicate, context);
            }
            if (key !== void 0 && key !== -1) return obj[key];
          };

          // Return all the elements that pass a truth test.
          // Aliased as `select`.
          _.filter = _.select = function (obj, predicate, context) {
            var results = [];
            predicate = cb(predicate, context);
            _.each(obj, function (value, index, list) {
              if (predicate(value, index, list)) results.push(value);
            });
            return results;
          };

          // Return all the elements for which a truth test fails.
          _.reject = function (obj, predicate, context) {
            return _.filter(obj, _.negate(cb(predicate)), context);
          };

          // Determine whether all of the elements match a truth test.
          // Aliased as `all`.
          _.every = _.all = function (obj, predicate, context) {
            predicate = cb(predicate, context);
            var keys = !isArrayLike(obj) && _.keys(obj),
              length = (keys || obj).length;
            for (var index = 0; index < length; index++) {
              var currentKey = keys ? keys[index] : index;
              if (!predicate(obj[currentKey], currentKey, obj)) return false;
            }
            return true;
          };

          // Determine if at least one element in the object matches a truth test.
          // Aliased as `any`.
          _.some = _.any = function (obj, predicate, context) {
            predicate = cb(predicate, context);
            var keys = !isArrayLike(obj) && _.keys(obj),
              length = (keys || obj).length;
            for (var index = 0; index < length; index++) {
              var currentKey = keys ? keys[index] : index;
              if (predicate(obj[currentKey], currentKey, obj)) return true;
            }
            return false;
          };

          // Determine if the array or object contains a given item (using `===`).
          // Aliased as `includes` and `include`.
          _.contains = _.includes = _.include = function (obj, item, fromIndex, guard) {
            if (!isArrayLike(obj)) obj = _.values(obj);
            if (typeof fromIndex != 'number' || guard) fromIndex = 0;
            return _.indexOf(obj, item, fromIndex) >= 0;
          };

          // Invoke a method (with arguments) on every item in a collection.
          _.invoke = function (obj, method) {
            var args = slice.call(arguments, 2);
            var isFunc = _.isFunction(method);
            return _.map(obj, function (value) {
              var func = isFunc ? method : value[method];
              return func == null ? func : func.apply(value, args);
            });
          };

          // Convenience version of a common use case of `map`: fetching a property.
          _.pluck = function (obj, key) {
            return _.map(obj, _.property(key));
          };

          // Convenience version of a common use case of `filter`: selecting only objects
          // containing specific `key:value` pairs.
          _.where = function (obj, attrs) {
            return _.filter(obj, _.matcher(attrs));
          };

          // Convenience version of a common use case of `find`: getting the first object
          // containing specific `key:value` pairs.
          _.findWhere = function (obj, attrs) {
            return _.find(obj, _.matcher(attrs));
          };

          // Return the maximum element (or element-based computation).
          _.max = function (obj, iteratee, context) {
            var result = -Infinity,
              lastComputed = -Infinity,
              value,
              computed;
            if (iteratee == null && obj != null) {
              obj = isArrayLike(obj) ? obj : _.values(obj);
              for (var i = 0, length = obj.length; i < length; i++) {
                value = obj[i];
                if (value > result) {
                  result = value;
                }
              }
            } else {
              iteratee = cb(iteratee, context);
              _.each(obj, function (value, index, list) {
                computed = iteratee(value, index, list);
                if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                  result = value;
                  lastComputed = computed;
                }
              });
            }
            return result;
          };

          // Return the minimum element (or element-based computation).
          _.min = function (obj, iteratee, context) {
            var result = Infinity,
              lastComputed = Infinity,
              value,
              computed;
            if (iteratee == null && obj != null) {
              obj = isArrayLike(obj) ? obj : _.values(obj);
              for (var i = 0, length = obj.length; i < length; i++) {
                value = obj[i];
                if (value < result) {
                  result = value;
                }
              }
            } else {
              iteratee = cb(iteratee, context);
              _.each(obj, function (value, index, list) {
                computed = iteratee(value, index, list);
                if (computed < lastComputed || computed === Infinity && result === Infinity) {
                  result = value;
                  lastComputed = computed;
                }
              });
            }
            return result;
          };

          // Shuffle a collection, using the modern version of the
          // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
          _.shuffle = function (obj) {
            var set = isArrayLike(obj) ? obj : _.values(obj);
            var length = set.length;
            var shuffled = Array(length);
            for (var index = 0, rand; index < length; index++) {
              rand = _.random(0, index);
              if (rand !== index) shuffled[index] = shuffled[rand];
              shuffled[rand] = set[index];
            }
            return shuffled;
          };

          // Sample **n** random values from a collection.
          // If **n** is not specified, returns a single random element.
          // The internal `guard` argument allows it to work with `map`.
          _.sample = function (obj, n, guard) {
            if (n == null || guard) {
              if (!isArrayLike(obj)) obj = _.values(obj);
              return obj[_.random(obj.length - 1)];
            }
            return _.shuffle(obj).slice(0, Math.max(0, n));
          };

          // Sort the object's values by a criterion produced by an iteratee.
          _.sortBy = function (obj, iteratee, context) {
            iteratee = cb(iteratee, context);
            return _.pluck(_.map(obj, function (value, index, list) {
              return {
                value: value,
                index: index,
                criteria: iteratee(value, index, list)
              };
            }).sort(function (left, right) {
              var a = left.criteria;
              var b = right.criteria;
              if (a !== b) {
                if (a > b || a === void 0) return 1;
                if (a < b || b === void 0) return -1;
              }
              return left.index - right.index;
            }), 'value');
          };

          // An internal function used for aggregate "group by" operations.
          var group = function (behavior) {
            return function (obj, iteratee, context) {
              var result = {};
              iteratee = cb(iteratee, context);
              _.each(obj, function (value, index) {
                var key = iteratee(value, index, obj);
                behavior(result, value, key);
              });
              return result;
            };
          };

          // Groups the object's values by a criterion. Pass either a string attribute
          // to group by, or a function that returns the criterion.
          _.groupBy = group(function (result, value, key) {
            if (_.has(result, key)) result[key].push(value);else result[key] = [value];
          });

          // Indexes the object's values by a criterion, similar to `groupBy`, but for
          // when you know that your index values will be unique.
          _.indexBy = group(function (result, value, key) {
            result[key] = value;
          });

          // Counts instances of an object that group by a certain criterion. Pass
          // either a string attribute to count by, or a function that returns the
          // criterion.
          _.countBy = group(function (result, value, key) {
            if (_.has(result, key)) result[key]++;else result[key] = 1;
          });

          // Safely create a real, live array from anything iterable.
          _.toArray = function (obj) {
            if (!obj) return [];
            if (_.isArray(obj)) return slice.call(obj);
            if (isArrayLike(obj)) return _.map(obj, _.identity);
            return _.values(obj);
          };

          // Return the number of elements in an object.
          _.size = function (obj) {
            if (obj == null) return 0;
            return isArrayLike(obj) ? obj.length : _.keys(obj).length;
          };

          // Split a collection into two arrays: one whose elements all satisfy the given
          // predicate, and one whose elements all do not satisfy the predicate.
          _.partition = function (obj, predicate, context) {
            predicate = cb(predicate, context);
            var pass = [],
              fail = [];
            _.each(obj, function (value, key, obj) {
              (predicate(value, key, obj) ? pass : fail).push(value);
            });
            return [pass, fail];
          };

          // Array Functions
          // ---------------

          // Get the first element of an array. Passing **n** will return the first N
          // values in the array. Aliased as `head` and `take`. The **guard** check
          // allows it to work with `_.map`.
          _.first = _.head = _.take = function (array, n, guard) {
            if (array == null) return void 0;
            if (n == null || guard) return array[0];
            return _.initial(array, array.length - n);
          };

          // Returns everything but the last entry of the array. Especially useful on
          // the arguments object. Passing **n** will return all the values in
          // the array, excluding the last N.
          _.initial = function (array, n, guard) {
            return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
          };

          // Get the last element of an array. Passing **n** will return the last N
          // values in the array.
          _.last = function (array, n, guard) {
            if (array == null) return void 0;
            if (n == null || guard) return array[array.length - 1];
            return _.rest(array, Math.max(0, array.length - n));
          };

          // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
          // Especially useful on the arguments object. Passing an **n** will return
          // the rest N values in the array.
          _.rest = _.tail = _.drop = function (array, n, guard) {
            return slice.call(array, n == null || guard ? 1 : n);
          };

          // Trim out all falsy values from an array.
          _.compact = function (array) {
            return _.filter(array, _.identity);
          };

          // Internal implementation of a recursive `flatten` function.
          var flatten = function (input, shallow, strict, startIndex) {
            var output = [],
              idx = 0;
            for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
              var value = input[i];
              if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
                //flatten current level of array or arguments object
                if (!shallow) value = flatten(value, shallow, strict);
                var j = 0,
                  len = value.length;
                output.length += len;
                while (j < len) {
                  output[idx++] = value[j++];
                }
              } else if (!strict) {
                output[idx++] = value;
              }
            }
            return output;
          };

          // Flatten out an array, either recursively (by default), or just one level.
          _.flatten = function (array, shallow) {
            return flatten(array, shallow, false);
          };

          // Return a version of the array that does not contain the specified value(s).
          _.without = function (array) {
            return _.difference(array, slice.call(arguments, 1));
          };

          // Produce a duplicate-free version of the array. If the array has already
          // been sorted, you have the option of using a faster algorithm.
          // Aliased as `unique`.
          _.uniq = _.unique = function (array, isSorted, iteratee, context) {
            if (!_.isBoolean(isSorted)) {
              context = iteratee;
              iteratee = isSorted;
              isSorted = false;
            }
            if (iteratee != null) iteratee = cb(iteratee, context);
            var result = [];
            var seen = [];
            for (var i = 0, length = getLength(array); i < length; i++) {
              var value = array[i],
                computed = iteratee ? iteratee(value, i, array) : value;
              if (isSorted) {
                if (!i || seen !== computed) result.push(value);
                seen = computed;
              } else if (iteratee) {
                if (!_.contains(seen, computed)) {
                  seen.push(computed);
                  result.push(value);
                }
              } else if (!_.contains(result, value)) {
                result.push(value);
              }
            }
            return result;
          };

          // Produce an array that contains the union: each distinct element from all of
          // the passed-in arrays.
          _.union = function () {
            return _.uniq(flatten(arguments, true, true));
          };

          // Produce an array that contains every item shared between all the
          // passed-in arrays.
          _.intersection = function (array) {
            var result = [];
            var argsLength = arguments.length;
            for (var i = 0, length = getLength(array); i < length; i++) {
              var item = array[i];
              if (_.contains(result, item)) continue;
              for (var j = 1; j < argsLength; j++) {
                if (!_.contains(arguments[j], item)) break;
              }
              if (j === argsLength) result.push(item);
            }
            return result;
          };

          // Take the difference between one array and a number of other arrays.
          // Only the elements present in just the first array will remain.
          _.difference = function (array) {
            var rest = flatten(arguments, true, true, 1);
            return _.filter(array, function (value) {
              return !_.contains(rest, value);
            });
          };

          // Zip together multiple lists into a single array -- elements that share
          // an index go together.
          _.zip = function () {
            return _.unzip(arguments);
          };

          // Complement of _.zip. Unzip accepts an array of arrays and groups
          // each array's elements on shared indices
          _.unzip = function (array) {
            var length = array && _.max(array, getLength).length || 0;
            var result = Array(length);
            for (var index = 0; index < length; index++) {
              result[index] = _.pluck(array, index);
            }
            return result;
          };

          // Converts lists into objects. Pass either a single array of `[key, value]`
          // pairs, or two parallel arrays of the same length -- one of keys, and one of
          // the corresponding values.
          _.object = function (list, values) {
            var result = {};
            for (var i = 0, length = getLength(list); i < length; i++) {
              if (values) {
                result[list[i]] = values[i];
              } else {
                result[list[i][0]] = list[i][1];
              }
            }
            return result;
          };

          // Generator function to create the findIndex and findLastIndex functions
          function createPredicateIndexFinder(dir) {
            return function (array, predicate, context) {
              predicate = cb(predicate, context);
              var length = getLength(array);
              var index = dir > 0 ? 0 : length - 1;
              for (; index >= 0 && index < length; index += dir) {
                if (predicate(array[index], index, array)) return index;
              }
              return -1;
            };
          }

          // Returns the first index on an array-like that passes a predicate test
          _.findIndex = createPredicateIndexFinder(1);
          _.findLastIndex = createPredicateIndexFinder(-1);

          // Use a comparator function to figure out the smallest index at which
          // an object should be inserted so as to maintain order. Uses binary search.
          _.sortedIndex = function (array, obj, iteratee, context) {
            iteratee = cb(iteratee, context, 1);
            var value = iteratee(obj);
            var low = 0,
              high = getLength(array);
            while (low < high) {
              var mid = Math.floor((low + high) / 2);
              if (iteratee(array[mid]) < value) low = mid + 1;else high = mid;
            }
            return low;
          };

          // Generator function to create the indexOf and lastIndexOf functions
          function createIndexFinder(dir, predicateFind, sortedIndex) {
            return function (array, item, idx) {
              var i = 0,
                length = getLength(array);
              if (typeof idx == 'number') {
                if (dir > 0) {
                  i = idx >= 0 ? idx : Math.max(idx + length, i);
                } else {
                  length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
                }
              } else if (sortedIndex && idx && length) {
                idx = sortedIndex(array, item);
                return array[idx] === item ? idx : -1;
              }
              if (item !== item) {
                idx = predicateFind(slice.call(array, i, length), _.isNaN);
                return idx >= 0 ? idx + i : -1;
              }
              for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
                if (array[idx] === item) return idx;
              }
              return -1;
            };
          }

          // Return the position of the first occurrence of an item in an array,
          // or -1 if the item is not included in the array.
          // If the array is large and already in sort order, pass `true`
          // for **isSorted** to use binary search.
          _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
          _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

          // Generate an integer Array containing an arithmetic progression. A port of
          // the native Python `range()` function. See
          // [the Python documentation](http://docs.python.org/library/functions.html#range).
          _.range = function (start, stop, step) {
            if (stop == null) {
              stop = start || 0;
              start = 0;
            }
            step = step || 1;
            var length = Math.max(Math.ceil((stop - start) / step), 0);
            var range = Array(length);
            for (var idx = 0; idx < length; idx++, start += step) {
              range[idx] = start;
            }
            return range;
          };

          // Function (ahem) Functions
          // ------------------

          // Determines whether to execute a function as a constructor
          // or a normal function with the provided arguments
          var executeBound = function (sourceFunc, boundFunc, context, callingContext, args) {
            if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
            var self = baseCreate(sourceFunc.prototype);
            var result = sourceFunc.apply(self, args);
            if (_.isObject(result)) return result;
            return self;
          };

          // Create a function bound to a given object (assigning `this`, and arguments,
          // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
          // available.
          _.bind = function (func, context) {
            if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
            if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
            var args = slice.call(arguments, 2);
            var bound = function () {
              return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
            };
            return bound;
          };

          // Partially apply a function by creating a version that has had some of its
          // arguments pre-filled, without changing its dynamic `this` context. _ acts
          // as a placeholder, allowing any combination of arguments to be pre-filled.
          _.partial = function (func) {
            var boundArgs = slice.call(arguments, 1);
            var bound = function () {
              var position = 0,
                length = boundArgs.length;
              var args = Array(length);
              for (var i = 0; i < length; i++) {
                args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
              }
              while (position < arguments.length) args.push(arguments[position++]);
              return executeBound(func, bound, this, this, args);
            };
            return bound;
          };

          // Bind a number of an object's methods to that object. Remaining arguments
          // are the method names to be bound. Useful for ensuring that all callbacks
          // defined on an object belong to it.
          _.bindAll = function (obj) {
            var i,
              length = arguments.length,
              key;
            if (length <= 1) throw new Error('bindAll must be passed function names');
            for (i = 1; i < length; i++) {
              key = arguments[i];
              obj[key] = _.bind(obj[key], obj);
            }
            return obj;
          };

          // Memoize an expensive function by storing its results.
          _.memoize = function (func, hasher) {
            var memoize = function (key) {
              var cache = memoize.cache;
              var address = '' + (hasher ? hasher.apply(this, arguments) : key);
              if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
              return cache[address];
            };
            memoize.cache = {};
            return memoize;
          };

          // Delays a function for the given number of milliseconds, and then calls
          // it with the arguments supplied.
          _.delay = function (func, wait) {
            var args = slice.call(arguments, 2);
            return setTimeout(function () {
              return func.apply(null, args);
            }, wait);
          };

          // Defers a function, scheduling it to run after the current call stack has
          // cleared.
          _.defer = _.partial(_.delay, _, 1);

          // Returns a function, that, when invoked, will only be triggered at most once
          // during a given window of time. Normally, the throttled function will run
          // as much as it can, without ever going more than once per `wait` duration;
          // but if you'd like to disable the execution on the leading edge, pass
          // `{leading: false}`. To disable execution on the trailing edge, ditto.
          _.throttle = function (func, wait, options) {
            var context, args, result;
            var timeout = null;
            var previous = 0;
            if (!options) options = {};
            var later = function () {
              previous = options.leading === false ? 0 : _.now();
              timeout = null;
              result = func.apply(context, args);
              if (!timeout) context = args = null;
            };
            return function () {
              var now = _.now();
              if (!previous && options.leading === false) previous = now;
              var remaining = wait - (now - previous);
              context = this;
              args = arguments;
              if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                  clearTimeout(timeout);
                  timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
              } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
              }
              return result;
            };
          };

          // Returns a function, that, as long as it continues to be invoked, will not
          // be triggered. The function will be called after it stops being called for
          // N milliseconds. If `immediate` is passed, trigger the function on the
          // leading edge, instead of the trailing.
          _.debounce = function (func, wait, immediate) {
            var timeout, args, context, timestamp, result;
            var later = function () {
              var last = _.now() - timestamp;
              if (last < wait && last >= 0) {
                timeout = setTimeout(later, wait - last);
              } else {
                timeout = null;
                if (!immediate) {
                  result = func.apply(context, args);
                  if (!timeout) context = args = null;
                }
              }
            };
            return function () {
              context = this;
              args = arguments;
              timestamp = _.now();
              var callNow = immediate && !timeout;
              if (!timeout) timeout = setTimeout(later, wait);
              if (callNow) {
                result = func.apply(context, args);
                context = args = null;
              }
              return result;
            };
          };

          // Returns the first function passed as an argument to the second,
          // allowing you to adjust arguments, run code before and after, and
          // conditionally execute the original function.
          _.wrap = function (func, wrapper) {
            return _.partial(wrapper, func);
          };

          // Returns a negated version of the passed-in predicate.
          _.negate = function (predicate) {
            return function () {
              return !predicate.apply(this, arguments);
            };
          };

          // Returns a function that is the composition of a list of functions, each
          // consuming the return value of the function that follows.
          _.compose = function () {
            var args = arguments;
            var start = args.length - 1;
            return function () {
              var i = start;
              var result = args[start].apply(this, arguments);
              while (i--) result = args[i].call(this, result);
              return result;
            };
          };

          // Returns a function that will only be executed on and after the Nth call.
          _.after = function (times, func) {
            return function () {
              if (--times < 1) {
                return func.apply(this, arguments);
              }
            };
          };

          // Returns a function that will only be executed up to (but not including) the Nth call.
          _.before = function (times, func) {
            var memo;
            return function () {
              if (--times > 0) {
                memo = func.apply(this, arguments);
              }
              if (times <= 1) func = null;
              return memo;
            };
          };

          // Returns a function that will be executed at most one time, no matter how
          // often you call it. Useful for lazy initialization.
          _.once = _.partial(_.before, 2);

          // Object Functions
          // ----------------

          // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
          var hasEnumBug = !{
            toString: null
          }.propertyIsEnumerable('toString');
          var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
          function collectNonEnumProps(obj, keys) {
            var nonEnumIdx = nonEnumerableProps.length;
            var constructor = obj.constructor;
            var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

            // Constructor is a special case.
            var prop = 'constructor';
            if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
            while (nonEnumIdx--) {
              prop = nonEnumerableProps[nonEnumIdx];
              if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
                keys.push(prop);
              }
            }
          }

          // Retrieve the names of an object's own properties.
          // Delegates to **ECMAScript 5**'s native `Object.keys`
          _.keys = function (obj) {
            if (!_.isObject(obj)) return [];
            if (nativeKeys) return nativeKeys(obj);
            var keys = [];
            for (var key in obj) if (_.has(obj, key)) keys.push(key);
            // Ahem, IE < 9.
            if (hasEnumBug) collectNonEnumProps(obj, keys);
            return keys;
          };

          // Retrieve all the property names of an object.
          _.allKeys = function (obj) {
            if (!_.isObject(obj)) return [];
            var keys = [];
            for (var key in obj) keys.push(key);
            // Ahem, IE < 9.
            if (hasEnumBug) collectNonEnumProps(obj, keys);
            return keys;
          };

          // Retrieve the values of an object's properties.
          _.values = function (obj) {
            var keys = _.keys(obj);
            var length = keys.length;
            var values = Array(length);
            for (var i = 0; i < length; i++) {
              values[i] = obj[keys[i]];
            }
            return values;
          };

          // Returns the results of applying the iteratee to each element of the object
          // In contrast to _.map it returns an object
          _.mapObject = function (obj, iteratee, context) {
            iteratee = cb(iteratee, context);
            var keys = _.keys(obj),
              length = keys.length,
              results = {},
              currentKey;
            for (var index = 0; index < length; index++) {
              currentKey = keys[index];
              results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
            }
            return results;
          };

          // Convert an object into a list of `[key, value]` pairs.
          _.pairs = function (obj) {
            var keys = _.keys(obj);
            var length = keys.length;
            var pairs = Array(length);
            for (var i = 0; i < length; i++) {
              pairs[i] = [keys[i], obj[keys[i]]];
            }
            return pairs;
          };

          // Invert the keys and values of an object. The values must be serializable.
          _.invert = function (obj) {
            var result = {};
            var keys = _.keys(obj);
            for (var i = 0, length = keys.length; i < length; i++) {
              result[obj[keys[i]]] = keys[i];
            }
            return result;
          };

          // Return a sorted list of the function names available on the object.
          // Aliased as `methods`
          _.functions = _.methods = function (obj) {
            var names = [];
            for (var key in obj) {
              if (_.isFunction(obj[key])) names.push(key);
            }
            return names.sort();
          };

          // Extend a given object with all the properties in passed-in object(s).
          _.extend = createAssigner(_.allKeys);

          // Assigns a given object with all the own properties in the passed-in object(s)
          // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
          _.extendOwn = _.assign = createAssigner(_.keys);

          // Returns the first key on an object that passes a predicate test
          _.findKey = function (obj, predicate, context) {
            predicate = cb(predicate, context);
            var keys = _.keys(obj),
              key;
            for (var i = 0, length = keys.length; i < length; i++) {
              key = keys[i];
              if (predicate(obj[key], key, obj)) return key;
            }
          };

          // Return a copy of the object only containing the whitelisted properties.
          _.pick = function (object, oiteratee, context) {
            var result = {},
              obj = object,
              iteratee,
              keys;
            if (obj == null) return result;
            if (_.isFunction(oiteratee)) {
              keys = _.allKeys(obj);
              iteratee = optimizeCb(oiteratee, context);
            } else {
              keys = flatten(arguments, false, false, 1);
              iteratee = function (value, key, obj) {
                return key in obj;
              };
              obj = Object(obj);
            }
            for (var i = 0, length = keys.length; i < length; i++) {
              var key = keys[i];
              var value = obj[key];
              if (iteratee(value, key, obj)) result[key] = value;
            }
            return result;
          };

          // Return a copy of the object without the blacklisted properties.
          _.omit = function (obj, iteratee, context) {
            if (_.isFunction(iteratee)) {
              iteratee = _.negate(iteratee);
            } else {
              var keys = _.map(flatten(arguments, false, false, 1), String);
              iteratee = function (value, key) {
                return !_.contains(keys, key);
              };
            }
            return _.pick(obj, iteratee, context);
          };

          // Fill in a given object with default properties.
          _.defaults = createAssigner(_.allKeys, true);

          // Creates an object that inherits from the given prototype object.
          // If additional properties are provided then they will be added to the
          // created object.
          _.create = function (prototype, props) {
            var result = baseCreate(prototype);
            if (props) _.extendOwn(result, props);
            return result;
          };

          // Create a (shallow-cloned) duplicate of an object.
          _.clone = function (obj) {
            if (!_.isObject(obj)) return obj;
            return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
          };

          // Invokes interceptor with the obj, and then returns obj.
          // The primary purpose of this method is to "tap into" a method chain, in
          // order to perform operations on intermediate results within the chain.
          _.tap = function (obj, interceptor) {
            interceptor(obj);
            return obj;
          };

          // Returns whether an object has a given set of `key:value` pairs.
          _.isMatch = function (object, attrs) {
            var keys = _.keys(attrs),
              length = keys.length;
            if (object == null) return !length;
            var obj = Object(object);
            for (var i = 0; i < length; i++) {
              var key = keys[i];
              if (attrs[key] !== obj[key] || !(key in obj)) return false;
            }
            return true;
          };

          // Internal recursive comparison function for `isEqual`.
          var eq = function (a, b, aStack, bStack) {
            // Identical objects are equal. `0 === -0`, but they aren't identical.
            // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
            if (a === b) return a !== 0 || 1 / a === 1 / b;
            // A strict comparison is necessary because `null == undefined`.
            if (a == null || b == null) return a === b;
            // Unwrap any wrapped objects.
            if (a instanceof _) a = a._wrapped;
            if (b instanceof _) b = b._wrapped;
            // Compare `[[Class]]` names.
            var className = toString.call(a);
            if (className !== toString.call(b)) return false;
            switch (className) {
              // Strings, numbers, regular expressions, dates, and booleans are compared by value.
              case '[object RegExp]':
              // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
              case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                return '' + a === '' + b;
              case '[object Number]':
                // `NaN`s are equivalent, but non-reflexive.
                // Object(NaN) is equivalent to NaN
                if (+a !== +a) return +b !== +b;
                // An `egal` comparison is performed for other numeric values.
                return +a === 0 ? 1 / +a === 1 / b : +a === +b;
              case '[object Date]':
              case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                return +a === +b;
            }
            var areArrays = className === '[object Array]';
            if (!areArrays) {
              if (typeof a != 'object' || typeof b != 'object') return false;

              // Objects with different constructors are not equivalent, but `Object`s or `Array`s
              // from different frames are.
              var aCtor = a.constructor,
                bCtor = b.constructor;
              if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
                return false;
              }
            }
            // Assume equality for cyclic structures. The algorithm for detecting cyclic
            // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

            // Initializing stack of traversed objects.
            // It's done here since we only need them for objects and arrays comparison.
            aStack = aStack || [];
            bStack = bStack || [];
            var length = aStack.length;
            while (length--) {
              // Linear search. Performance is inversely proportional to the number of
              // unique nested structures.
              if (aStack[length] === a) return bStack[length] === b;
            }

            // Add the first object to the stack of traversed objects.
            aStack.push(a);
            bStack.push(b);

            // Recursively compare objects and arrays.
            if (areArrays) {
              // Compare array lengths to determine if a deep comparison is necessary.
              length = a.length;
              if (length !== b.length) return false;
              // Deep compare the contents, ignoring non-numeric properties.
              while (length--) {
                if (!eq(a[length], b[length], aStack, bStack)) return false;
              }
            } else {
              // Deep compare objects.
              var keys = _.keys(a),
                key;
              length = keys.length;
              // Ensure that both objects contain the same number of properties before comparing deep equality.
              if (_.keys(b).length !== length) return false;
              while (length--) {
                // Deep compare each member
                key = keys[length];
                if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
              }
            }
            // Remove the first object from the stack of traversed objects.
            aStack.pop();
            bStack.pop();
            return true;
          };

          // Perform a deep comparison to check if two objects are equal.
          _.isEqual = function (a, b) {
            return eq(a, b);
          };

          // Is a given array, string, or object empty?
          // An "empty" object has no enumerable own-properties.
          _.isEmpty = function (obj) {
            if (obj == null) return true;
            if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
            return _.keys(obj).length === 0;
          };

          // Is a given value a DOM element?
          _.isElement = function (obj) {
            return !!(obj && obj.nodeType === 1);
          };

          // Is a given value an array?
          // Delegates to ECMA5's native Array.isArray
          _.isArray = nativeIsArray || function (obj) {
            return toString.call(obj) === '[object Array]';
          };

          // Is a given variable an object?
          _.isObject = function (obj) {
            var type = typeof obj;
            return type === 'function' || type === 'object' && !!obj;
          };

          // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
          _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function (name) {
            _['is' + name] = function (obj) {
              return toString.call(obj) === '[object ' + name + ']';
            };
          });

          // Define a fallback version of the method in browsers (ahem, IE < 9), where
          // there isn't any inspectable "Arguments" type.
          if (!_.isArguments(arguments)) {
            _.isArguments = function (obj) {
              return _.has(obj, 'callee');
            };
          }

          // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
          // IE 11 (#1621), and in Safari 8 (#1929).
          if (true && typeof Int8Array != 'object') {
            _.isFunction = function (obj) {
              return typeof obj == 'function' || false;
            };
          }

          // Is a given object a finite number?
          _.isFinite = function (obj) {
            return isFinite(obj) && !isNaN(parseFloat(obj));
          };

          // Is the given value `NaN`? (NaN is the only number which does not equal itself).
          _.isNaN = function (obj) {
            return _.isNumber(obj) && obj !== +obj;
          };

          // Is a given value a boolean?
          _.isBoolean = function (obj) {
            return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
          };

          // Is a given value equal to null?
          _.isNull = function (obj) {
            return obj === null;
          };

          // Is a given variable undefined?
          _.isUndefined = function (obj) {
            return obj === void 0;
          };

          // Shortcut function for checking if an object has a given property directly
          // on itself (in other words, not on a prototype).
          _.has = function (obj, key) {
            return obj != null && hasOwnProperty.call(obj, key);
          };

          // Utility Functions
          // -----------------

          // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
          // previous owner. Returns a reference to the Underscore object.
          _.noConflict = function () {
            root._ = previousUnderscore;
            return this;
          };

          // Keep the identity function around for default iteratees.
          _.identity = function (value) {
            return value;
          };

          // Predicate-generating functions. Often useful outside of Underscore.
          _.constant = function (value) {
            return function () {
              return value;
            };
          };
          _.noop = function () {};
          _.property = property;

          // Generates a function for a given object that returns a given property.
          _.propertyOf = function (obj) {
            return obj == null ? function () {} : function (key) {
              return obj[key];
            };
          };

          // Returns a predicate for checking whether an object has a given set of
          // `key:value` pairs.
          _.matcher = _.matches = function (attrs) {
            attrs = _.extendOwn({}, attrs);
            return function (obj) {
              return _.isMatch(obj, attrs);
            };
          };

          // Run a function **n** times.
          _.times = function (n, iteratee, context) {
            var accum = Array(Math.max(0, n));
            iteratee = optimizeCb(iteratee, context, 1);
            for (var i = 0; i < n; i++) accum[i] = iteratee(i);
            return accum;
          };

          // Return a random integer between min and max (inclusive).
          _.random = function (min, max) {
            if (max == null) {
              max = min;
              min = 0;
            }
            return min + Math.floor(Math.random() * (max - min + 1));
          };

          // A (possibly faster) way to get the current timestamp as an integer.
          _.now = Date.now || function () {
            return new Date().getTime();
          };

          // List of HTML entities for escaping.
          var escapeMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            '`': '&#x60;'
          };
          var unescapeMap = _.invert(escapeMap);

          // Functions for escaping and unescaping strings to/from HTML interpolation.
          var createEscaper = function (map) {
            var escaper = function (match) {
              return map[match];
            };
            // Regexes for identifying a key that needs to be escaped
            var source = '(?:' + _.keys(map).join('|') + ')';
            var testRegexp = RegExp(source);
            var replaceRegexp = RegExp(source, 'g');
            return function (string) {
              string = string == null ? '' : '' + string;
              return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
            };
          };
          _.escape = createEscaper(escapeMap);
          _.unescape = createEscaper(unescapeMap);

          // If the value of the named `property` is a function then invoke it with the
          // `object` as context; otherwise, return it.
          _.result = function (object, property, fallback) {
            var value = object == null ? void 0 : object[property];
            if (value === void 0) {
              value = fallback;
            }
            return _.isFunction(value) ? value.call(object) : value;
          };

          // Generate a unique integer id (unique within the entire client session).
          // Useful for temporary DOM ids.
          var idCounter = 0;
          _.uniqueId = function (prefix) {
            var id = ++idCounter + '';
            return prefix ? prefix + id : id;
          };

          // By default, Underscore uses ERB-style template delimiters, change the
          // following template settings to use alternative delimiters.
          _.templateSettings = {
            evaluate: /<%([\s\S]+?)%>/g,
            interpolate: /<%=([\s\S]+?)%>/g,
            escape: /<%-([\s\S]+?)%>/g
          };

          // When customizing `templateSettings`, if you don't want to define an
          // interpolation, evaluation or escaping regex, we need one that is
          // guaranteed not to match.
          var noMatch = /(.)^/;

          // Certain characters need to be escaped so that they can be put into a
          // string literal.
          var escapes = {
            "'": "'",
            '\\': '\\',
            '\r': 'r',
            '\n': 'n',
            '\u2028': 'u2028',
            '\u2029': 'u2029'
          };
          var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
          var escapeChar = function (match) {
            return '\\' + escapes[match];
          };

          // JavaScript micro-templating, similar to John Resig's implementation.
          // Underscore templating handles arbitrary delimiters, preserves whitespace,
          // and correctly escapes quotes within interpolated code.
          // NB: `oldSettings` only exists for backwards compatibility.
          _.template = function (text, settings, oldSettings) {
            if (!settings && oldSettings) settings = oldSettings;
            settings = _.defaults({}, settings, _.templateSettings);

            // Combine delimiters into one regular expression via alternation.
            var matcher = RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join('|') + '|$', 'g');

            // Compile the template source, escaping string literals appropriately.
            var index = 0;
            var source = "__p+='";
            text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
              source += text.slice(index, offset).replace(escaper, escapeChar);
              index = offset + match.length;
              if (escape) {
                source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
              } else if (interpolate) {
                source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
              } else if (evaluate) {
                source += "';\n" + evaluate + "\n__p+='";
              }

              // Adobe VMs need the match returned to produce the correct offest.
              return match;
            });
            source += "';\n";

            // If a variable is not specified, place data values in local scope.
            if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
            source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
            try {
              var render = new Function(settings.variable || 'obj', '_', source);
            } catch (e) {
              e.source = source;
              throw e;
            }
            var template = function (data) {
              return render.call(this, data, _);
            };

            // Provide the compiled source as a convenience for precompilation.
            var argument = settings.variable || 'obj';
            template.source = 'function(' + argument + '){\n' + source + '}';
            return template;
          };

          // Add a "chain" function. Start chaining a wrapped Underscore object.
          _.chain = function (obj) {
            var instance = _(obj);
            instance._chain = true;
            return instance;
          };

          // OOP
          // ---------------
          // If Underscore is called as a function, it returns a wrapped object that
          // can be used OO-style. This wrapper holds altered versions of all the
          // underscore functions. Wrapped objects may be chained.

          // Helper function to continue chaining intermediate results.
          var result = function (instance, obj) {
            return instance._chain ? _(obj).chain() : obj;
          };

          // Add your own custom functions to the Underscore object.
          _.mixin = function (obj) {
            _.each(_.functions(obj), function (name) {
              var func = _[name] = obj[name];
              _.prototype[name] = function () {
                var args = [this._wrapped];
                push.apply(args, arguments);
                return result(this, func.apply(_, args));
              };
            });
          };

          // Add all of the Underscore functions to the wrapper object.
          _.mixin(_);

          // Add all mutator Array functions to the wrapper.
          _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
            var method = ArrayProto[name];
            _.prototype[name] = function () {
              var obj = this._wrapped;
              method.apply(obj, arguments);
              if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
              return result(this, obj);
            };
          });

          // Add all accessor Array functions to the wrapper.
          _.each(['concat', 'join', 'slice'], function (name) {
            var method = ArrayProto[name];
            _.prototype[name] = function () {
              return result(this, method.apply(this._wrapped, arguments));
            };
          });

          // Extracts the result from a wrapped and chained object.
          _.prototype.value = function () {
            return this._wrapped;
          };

          // Provide unwrapping proxy for some methods used in engine operations
          // such as arithmetic and JSON stringification.
          _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
          _.prototype.toString = function () {
            return '' + this._wrapped;
          };

          // AMD registration happens at the end for compatibility with AMD loaders
          // that may not enforce next-turn semantics on modules. Even though general
          // practice for AMD registration is to be anonymous, underscore registers
          // as a named module because, like jQuery, it is a base library that is
          // popular enough to be bundled in a third party lib, but not be part of
          // an AMD load request. Those cases could generate an error when an
          // anonymous define() is called outside of a loader request.
          if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return _;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          }
        }).call(this);

        /***/
      },, /* 80 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        __webpack_require__(370);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _reactSelect = __webpack_require__(363);
        var _reactSelect2 = _interopRequireDefault(_reactSelect);
        var _reactDataGrid = __webpack_require__(4);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var isEmptyArray = _reactDataGrid.utils.isEmptyArray;
        var ExcelColumn = _reactDataGrid.shapes.ExcelColumn;
        var AutoCompleteFilter = function (_React$Component) {
          _inherits(AutoCompleteFilter, _React$Component);
          function AutoCompleteFilter(props) {
            _classCallCheck(this, AutoCompleteFilter);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.getOptions = _this.getOptions.bind(_this);
            _this.handleChange = _this.handleChange.bind(_this);
            _this.filterValues = _this.filterValues.bind(_this);
            _this.state = {
              options: _this.getOptions(),
              rawValue: '',
              placeholder: 'Search'
            };
            return _this;
          }
          AutoCompleteFilter.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
            this.setState({
              options: this.getOptions(newProps)
            });
          };
          AutoCompleteFilter.prototype.getOptions = function getOptions(newProps) {
            var props = newProps || this.props;
            var options = props.getValidFilterValues(props.column.key);
            options = options.map(function (o) {
              if (typeof o === 'string') {
                return {
                  value: o,
                  label: o
                };
              }
              return o;
            });
            return options;
          };
          AutoCompleteFilter.prototype.columnValueContainsSearchTerms = function columnValueContainsSearchTerms(columnValue, filterTermValue) {
            if (columnValue !== undefined && filterTermValue !== undefined) {
              var strColumnValue = columnValue.toString();
              var strFilterTermValue = filterTermValue.toString();
              var checkValueIndex = strColumnValue.trim().toLowerCase().indexOf(strFilterTermValue.trim().toLowerCase());
              return checkValueIndex !== -1 && (checkValueIndex !== 0 || strColumnValue === strFilterTermValue);
            }
            return false;
          };
          AutoCompleteFilter.prototype.filterValues = function filterValues(row, columnFilter, columnKey) {
            var _this2 = this;
            var include = true;
            if (columnFilter === null) {
              include = false;
            } else if (columnFilter.filterTerm && !isEmptyArray(columnFilter.filterTerm)) {
              if (columnFilter.filterTerm.length) {
                include = columnFilter.filterTerm.some(function (filterTerm) {
                  return _this2.columnValueContainsSearchTerms(row[columnKey], filterTerm.value) === true;
                });
              } else {
                include = this.columnValueContainsSearchTerms(row[columnKey], columnFilter.filterTerm.value);
              }
            }
            return include;
          };
          AutoCompleteFilter.prototype.handleChange = function handleChange(value) {
            var filters = value;
            this.setState({
              filters: filters
            });
            this.props.onChange({
              filterTerm: filters,
              column: this.props.column,
              rawValue: value,
              filterValues: this.filterValues
            });
          };
          AutoCompleteFilter.prototype.render = function render() {
            return _react2['default'].createElement(_reactSelect2['default'], {
              autosize: false,
              name: 'filter-' + this.props.column.key,
              options: this.state.options,
              placeholder: this.state.placeholder,
              onChange: this.handleChange,
              escapeClearsValue: true,
              multi: this.props.multiSelection !== undefined && this.props.multiSelection !== null ? this.props.multiSelection : true,
              value: this.state.filters
            });
          };
          return AutoCompleteFilter;
        }(_react2['default'].Component);
        AutoCompleteFilter.propTypes = {
          onChange: _propTypes2['default'].func.isRequired,
          column: _propTypes2['default'].shape(ExcelColumn),
          getValidFilterValues: _propTypes2['default'].func,
          multiSelection: _propTypes2['default'].bool
        };
        exports['default'] = AutoCompleteFilter;

        /***/
      }, /* 81 */
      /***/function (module, exports) {
        'use strict';

        exports.__esModule = true;
        exports['default'] = isDisposable;
        function isDisposable(obj) {
          return Boolean(obj && typeof obj.dispose === 'function');
        }
        module.exports = exports['default'];

        /***/
      }, /* 82 */
      /***/function (module, exports) {
        /**
         * Copyright 2015, Yahoo! Inc.
         * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
         */
        'use strict';

        var REACT_STATICS = {
          childContextTypes: true,
          contextTypes: true,
          defaultProps: true,
          displayName: true,
          getDefaultProps: true,
          mixins: true,
          propTypes: true,
          type: true
        };
        var KNOWN_STATICS = {
          name: true,
          length: true,
          prototype: true,
          caller: true,
          callee: true,
          arguments: true,
          arity: true
        };
        var defineProperty = Object.defineProperty;
        var getOwnPropertyNames = Object.getOwnPropertyNames;
        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var getPrototypeOf = Object.getPrototypeOf;
        var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
        module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
          if (typeof sourceComponent !== 'string') {
            // don't hoist over string (html) components

            if (objectPrototype) {
              var inheritedComponent = getPrototypeOf(sourceComponent);
              if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
              }
            }
            var keys = getOwnPropertyNames(sourceComponent);
            if (getOwnPropertySymbols) {
              keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            for (var i = 0; i < keys.length; ++i) {
              var key = keys[i];
              if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                  // Avoid failures from read-only properties
                  defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
              }
            }
            return targetComponent;
          }
          return targetComponent;
        };

        /***/
      }, /* 83 */
      [1559, 156, 321, 322], /* 84 */
      [1560, 33], /* 85 */
      /***/function (module, exports, __webpack_require__) {
        var baseIndexOf = __webpack_require__(277);

        /**
         * A specialized version of `_.includes` for arrays without support for
         * specifying an index to search from.
         *
         * @private
         * @param {Array} [array] The array to inspect.
         * @param {*} target The value to search for.
         * @returns {boolean} Returns `true` if `target` is found, else `false`.
         */
        function arrayIncludes(array, value) {
          var length = array == null ? 0 : array.length;
          return !!length && baseIndexOf(array, value, 0) > -1;
        }
        module.exports = arrayIncludes;

        /***/
      }, /* 86 */
      /***/function (module, exports) {
        /**
         * This function is like `arrayIncludes` except that it accepts a comparator.
         *
         * @private
         * @param {Array} [array] The array to inspect.
         * @param {*} target The value to search for.
         * @param {Function} comparator The comparator invoked per element.
         * @returns {boolean} Returns `true` if `target` is found, else `false`.
         */
        function arrayIncludesWith(array, value, comparator) {
          var index = -1,
            length = array == null ? 0 : array.length;
          while (++index < length) {
            if (comparator(value, array[index])) {
              return true;
            }
          }
          return false;
        }
        module.exports = arrayIncludesWith;

        /***/
      }, /* 87 */
      /***/function (module, exports) {
        /**
         * A specialized version of `_.map` for arrays without support for iteratee
         * shorthands.
         *
         * @private
         * @param {Array} [array] The array to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the new mapped array.
         */
        function arrayMap(array, iteratee) {
          var index = -1,
            length = array == null ? 0 : array.length,
            result = Array(length);
          while (++index < length) {
            result[index] = iteratee(array[index], index, array);
          }
          return result;
        }
        module.exports = arrayMap;

        /***/
      }, /* 88 */
      /***/function (module, exports) {
        /**
         * The base implementation of `_.unary` without support for storing metadata.
         *
         * @private
         * @param {Function} func The function to cap arguments for.
         * @returns {Function} Returns the new capped function.
         */
        function baseUnary(func) {
          return function (value) {
            return func(value);
          };
        }
        module.exports = baseUnary;

        /***/
      }, /* 89 */
      /***/function (module, exports) {
        /**
         * Checks if a `cache` value for `key` exists.
         *
         * @private
         * @param {Object} cache The cache to query.
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function cacheHas(cache, key) {
          return cache.has(key);
        }
        module.exports = cacheHas;

        /***/
      }, /* 90 */
      [1653, 168, 169], /* 91 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _actions = __webpack_require__(27);
        var _helpers = __webpack_require__(28);
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var GlobalEventListener = function GlobalEventListener() {
          var _this = this;
          _classCallCheck(this, GlobalEventListener);
          this.handleShowEvent = function (event) {
            for (var id in _this.callbacks) {
              if ((0, _helpers.hasOwnProp)(_this.callbacks, id)) _this.callbacks[id].show(event);
            }
          };
          this.handleHideEvent = function (event) {
            for (var id in _this.callbacks) {
              if ((0, _helpers.hasOwnProp)(_this.callbacks, id)) _this.callbacks[id].hide(event);
            }
          };
          this.register = function (showCallback, hideCallback) {
            var id = (0, _helpers.uniqueId)();
            _this.callbacks[id] = {
              show: showCallback,
              hide: hideCallback
            };
            return id;
          };
          this.unregister = function (id) {
            if (id && _this.callbacks[id]) {
              delete _this.callbacks[id];
            }
          };
          this.callbacks = {};
          if (_helpers.canUseDOM) {
            window.addEventListener(_actions.MENU_SHOW, this.handleShowEvent);
            window.addEventListener(_actions.MENU_HIDE, this.handleHideEvent);
          }
        };
        exports.default = new GlobalEventListener();

        /***/
      }, /* 92 */
      /***/function (module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var FILE = exports.FILE = '__NATIVE_FILE__';
        var URL = exports.URL = '__NATIVE_URL__';
        var TEXT = exports.TEXT = '__NATIVE_TEXT__';

        /***/
      }, /* 93 */
      /***/function (module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = shallowEqual;
        function shallowEqual(objA, objB) {
          if (objA === objB) {
            return true;
          }
          var keysA = Object.keys(objA);
          var keysB = Object.keys(objB);
          if (keysA.length !== keysB.length) {
            return false;
          }

          // Test for A's keys different from B.
          var hasOwn = Object.prototype.hasOwnProperty;
          for (var i = 0; i < keysA.length; i += 1) {
            if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
              return false;
            }
            var valA = objA[keysA[i]];
            var valB = objB[keysA[i]];
            if (valA !== valB) {
              return false;
            }
          }
          return true;
        }

        /***/
      }, /* 94 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _stripDiacritics = __webpack_require__(189);
        var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
        var _trim = __webpack_require__(365);
        var _trim2 = _interopRequireDefault(_trim);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var isValid = function isValid(value) {
          return typeof value !== 'undefined' && value !== null && value !== '';
        };
        var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
          if (props.ignoreAccents) {
            filterValue = (0, _stripDiacritics2.default)(filterValue);
          }
          if (props.ignoreCase) {
            filterValue = filterValue.toLowerCase();
          }
          if (props.trimFilter) {
            filterValue = (0, _trim2.default)(filterValue);
          }
          if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
            return i[props.valueKey];
          });
          return options.filter(function (option) {
            if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
            if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
            if (!filterValue) return true;
            var value = option[props.valueKey];
            var label = option[props.labelKey];
            var hasValue = isValid(value);
            var hasLabel = isValid(label);
            if (!hasValue && !hasLabel) {
              return false;
            }
            var valueTest = hasValue ? String(value) : null;
            var labelTest = hasLabel ? String(label) : null;
            if (props.ignoreAccents) {
              if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
              if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
            }
            if (props.ignoreCase) {
              if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
              if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
            }
            return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
          });
        };
        exports.default = filterOptions;

        /***/
      }, /* 95 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _classnames = __webpack_require__(68);
        var _classnames2 = _interopRequireDefault(_classnames);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var menuRenderer = function menuRenderer(_ref) {
          var focusedOption = _ref.focusedOption,
            focusOption = _ref.focusOption,
            inputValue = _ref.inputValue,
            instancePrefix = _ref.instancePrefix,
            onFocus = _ref.onFocus,
            onOptionRef = _ref.onOptionRef,
            onSelect = _ref.onSelect,
            optionClassName = _ref.optionClassName,
            optionComponent = _ref.optionComponent,
            optionRenderer = _ref.optionRenderer,
            options = _ref.options,
            removeValue = _ref.removeValue,
            selectValue = _ref.selectValue,
            valueArray = _ref.valueArray,
            valueKey = _ref.valueKey;
          var Option = optionComponent;
          return options.map(function (option, i) {
            var isSelected = valueArray && valueArray.some(function (x) {
              return x[valueKey] === option[valueKey];
            });
            var isFocused = option === focusedOption;
            var optionClass = (0, _classnames2.default)(optionClassName, {
              'Select-option': true,
              'is-selected': isSelected,
              'is-focused': isFocused,
              'is-disabled': option.disabled
            });
            return _react2.default.createElement(Option, {
              className: optionClass,
              focusOption: focusOption,
              inputValue: inputValue,
              instancePrefix: instancePrefix,
              isDisabled: option.disabled,
              isFocused: isFocused,
              isSelected: isSelected,
              key: 'option-' + i + '-' + option[valueKey],
              onFocus: onFocus,
              onSelect: onSelect,
              option: option,
              optionIndex: i,
              ref: function ref(_ref2) {
                onOptionRef(_ref2, isFocused);
              },
              removeValue: removeValue,
              selectValue: selectValue
            }, optionRenderer(option, i, inputValue));
          });
        };
        menuRenderer.propTypes = {
          focusOption: _propTypes2.default.func,
          focusedOption: _propTypes2.default.object,
          inputValue: _propTypes2.default.string,
          instancePrefix: _propTypes2.default.string,
          onFocus: _propTypes2.default.func,
          onOptionRef: _propTypes2.default.func,
          onSelect: _propTypes2.default.func,
          optionClassName: _propTypes2.default.string,
          optionComponent: _propTypes2.default.func,
          optionRenderer: _propTypes2.default.func,
          options: _propTypes2.default.array,
          removeValue: _propTypes2.default.func,
          selectValue: _propTypes2.default.func,
          valueArray: _propTypes2.default.array,
          valueKey: _propTypes2.default.string
        };
        exports.default = menuRenderer;

        /***/
      }, /* 96 */
      [1548, 24, 16], /* 97 */
      [1551, 438, 439, 440, 441, 442], /* 98 */
      /***/function (module, exports, __webpack_require__) {
        var isArray = __webpack_require__(17),
          isSymbol = __webpack_require__(101);

        /** Used to match property names within property paths. */
        var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          reIsPlainProp = /^\w*$/;

        /**
         * Checks if `value` is a property name and not a property path.
         *
         * @private
         * @param {*} value The value to check.
         * @param {Object} [object] The object to query keys on.
         * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
         */
        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
        }
        module.exports = isKey;

        /***/
      }, /* 99 */
      /***/function (module, exports) {
        /** Used as references for various `Number` constants. */
        var MAX_SAFE_INTEGER = 9007199254740991;

        /**
         * Checks if `value` is a valid array-like length.
         *
         * **Note:** This method is loosely based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
         * @example
         *
         * _.isLength(3);
         * // => true
         *
         * _.isLength(Number.MIN_VALUE);
         * // => false
         *
         * _.isLength(Infinity);
         * // => false
         *
         * _.isLength('3');
         * // => false
         */
        function isLength(value) {
          return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        module.exports = isLength;

        /***/
      }, /* 100 */
      34, /* 101 */
      /***/function (module, exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(38),
          isObjectLike = __webpack_require__(39);

        /** `Object#toString` result references. */
        var symbolTag = '[object Symbol]';

        /**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */
        function isSymbol(value) {
          return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        module.exports = isSymbol;

        /***/
      }, /* 102 */
      /***/function (module, exports, __webpack_require__) {
        var arrayLikeKeys = __webpack_require__(385),
          baseKeys = __webpack_require__(402),
          isArrayLike = __webpack_require__(203);

        /**
         * Creates an array of the own enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects. See the
         * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * for more details.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keys(new Foo);
         * // => ['a', 'b'] (iteration order is not guaranteed)
         *
         * _.keys('hi');
         * // => ['0', '1']
         */
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        module.exports = keys;

        /***/
      },, /* 104 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _scrollUtils = __webpack_require__(136);
        var _shallowequal = __webpack_require__(69);
        var _shallowequal2 = _interopRequireDefault(_shallowequal);
        var _RowsContainer = __webpack_require__(45);
        var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
        var _RowGroup = __webpack_require__(121);
        var _RowGroup2 = _interopRequireDefault(_RowGroup);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var joinClasses = __webpack_require__(5);
        var Row = __webpack_require__(42);
        var cellMetaDataShape = __webpack_require__(11);
        var RowUtils = __webpack_require__(44);
        __webpack_require__(20);
        var Canvas = function (_React$Component) {
          _inherits(Canvas, _React$Component);
          function Canvas() {
            var _temp, _this, _ret;
            _classCallCheck(this, Canvas);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              displayStart: _this.props.displayStart,
              displayEnd: _this.props.displayEnd,
              scrollingTimeout: null
            }, _this._currentRowsLength = 0, _this._currentRowsRange = {
              start: 0,
              end: 0
            }, _this._scroll = {
              scrollTop: 0,
              scrollLeft: 0
            }, _this.appendScrollShim = function () {
              if (!_this._scrollShim) {
                var size = _this._scrollShimSize();
                var shim = (0, _scrollUtils.createScrollShim)(size);
                _this.canvas.appendChild(shim);
                _this._scrollShim = shim;
              }
              _this._scheduleRemoveScrollShim();
            }, _this._scrollShimSize = function () {
              return {
                width: _this.props.width,
                height: _this.props.length * _this.props.rowHeight
              };
            }, _this._scheduleRemoveScrollShim = function () {
              if (_this._scheduleRemoveScrollShimTimer) {
                clearTimeout(_this._scheduleRemoveScrollShimTimer);
              }
              _this._scheduleRemoveScrollShimTimer = setTimeout(_this._removeScrollShim, 200);
            }, _this._removeScrollShim = function () {
              if (_this._scrollShim) {
                _this._scrollShim.parentNode.removeChild(_this._scrollShim);
                _this._scrollShim = undefined;
              }
            }, _this.onRows = function () {
              if (_this._currentRowsRange !== {
                start: 0,
                end: 0
              }) {
                _this.props.onRows(_this._currentRowsRange);
                _this._currentRowsRange = {
                  start: 0,
                  end: 0
                };
              }
            }, _this.onScroll = function (e) {
              if (_this.canvas !== e.target) {
                return;
              }
              _this.appendScrollShim();
              var scrollLeft = e.target.scrollLeft;
              var scrollTop = e.target.scrollTop;
              var scroll = {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft
              };
              _this._scroll = scroll;
              _this.props.onScroll(scroll);
            }, _this.getRows = function (displayStart, displayEnd) {
              _this._currentRowsRange = {
                start: displayStart,
                end: displayEnd
              };
              if (Array.isArray(_this.props.rowGetter)) {
                return _this.props.rowGetter.slice(displayStart, displayEnd);
              }
              var rows = [];
              var i = displayStart;
              while (i < displayEnd) {
                var row = _this.props.rowGetter(i);
                var subRowDetails = {};
                if (_this.props.getSubRowDetails) {
                  subRowDetails = _this.props.getSubRowDetails(row);
                }
                rows.push({
                  row: row,
                  subRowDetails: subRowDetails
                });
                i++;
              }
              return rows;
            }, _this.getScrollbarWidth = function () {
              // Get the scrollbar width
              var scrollbarWidth = _this.canvas.offsetWidth - _this.canvas.clientWidth;
              return scrollbarWidth;
            }, _this.getScroll = function () {
              var _this$canvas = _this.canvas,
                scrollTop = _this$canvas.scrollTop,
                scrollLeft = _this$canvas.scrollLeft;
              return {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft
              };
            }, _this.isRowSelected = function (idx, row) {
              // Use selectedRows if set
              if (_this.props.selectedRows !== null) {
                var selectedRows = _this.props.selectedRows.filter(function (r) {
                  var rowKeyValue = row.get ? row.get(_this.props.rowKey) : row[_this.props.rowKey];
                  return r[_this.props.rowKey] === rowKeyValue;
                });
                return selectedRows.length > 0 && selectedRows[0].isSelected;
              }

              // Else use new rowSelection props
              if (_this.props.rowSelection) {
                var _this$props$rowSelect = _this.props.rowSelection,
                  keys = _this$props$rowSelect.keys,
                  indexes = _this$props$rowSelect.indexes,
                  isSelectedKey = _this$props$rowSelect.isSelectedKey;
                return RowUtils.isRowSelected(keys, indexes, isSelectedKey, row, idx);
              }
              return false;
            }, _this.setScrollLeft = function (scrollLeft) {
              if (_this._currentRowsLength !== 0) {
                if (!_this.rows) return;
                for (var i = 0, len = _this._currentRowsLength; i < len; i++) {
                  if (_this.rows[i]) {
                    var row = _this.getRowByRef(i);
                    if (row && row.setScrollLeft) {
                      row.setScrollLeft(scrollLeft);
                    }
                  }
                }
              }
            }, _this.getRowByRef = function (i) {
              // check if wrapped with React DND drop target
              var wrappedRow = _this.rows[i].getDecoratedComponentInstance ? _this.rows[i].getDecoratedComponentInstance(i) : null;
              if (wrappedRow) {
                return wrappedRow.row;
              }
              return _this.rows[i];
            }, _this.renderRow = function (props) {
              var row = props.row;
              if (row.__metaData && row.__metaData.getRowRenderer) {
                return row.__metaData.getRowRenderer(_this.props, props.idx);
              }
              if (row.__metaData && row.__metaData.isGroup) {
                return React.createElement(_RowGroup2['default'], _extends({}, props, row.__metaData, {
                  name: row.name,
                  renderer: _this.props.rowGroupRenderer
                }));
              }
              var RowsRenderer = _this.props.rowRenderer;
              if (typeof RowsRenderer === 'function') {
                return React.createElement(RowsRenderer, props);
              }
              if (React.isValidElement(_this.props.rowRenderer)) {
                return React.cloneElement(_this.props.rowRenderer, props);
              }
            }, _this.renderPlaceholder = function (key, height) {
              // just renders empty cells
              // if we wanted to show gridlines, we'd need classes and position as with renderScrollingPlaceholder
              return React.createElement('div', {
                key: key,
                style: {
                  height: height
                }
              }, _this.props.columns.map(function (column, idx) {
                return React.createElement('div', {
                  style: {
                    width: column.width
                  },
                  key: idx
                });
              }));
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Canvas.prototype.componentWillMount = function componentWillMount() {
            this.rows = [];
            this._currentRowsLength = 0;
            this._currentRowsRange = {
              start: 0,
              end: 0
            };
            this._scroll = {
              scrollTop: 0,
              scrollLeft: 0
            };
          };
          Canvas.prototype.componentDidMount = function componentDidMount() {
            this.onRows();
          };
          Canvas.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (nextProps.displayStart !== this.state.displayStart || nextProps.displayEnd !== this.state.displayEnd) {
              this.setState({
                displayStart: nextProps.displayStart,
                displayEnd: nextProps.displayEnd
              });
            }
          };
          Canvas.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            var shouldUpdate = nextState.displayStart !== this.state.displayStart || nextState.displayEnd !== this.state.displayEnd || nextState.scrollingTimeout !== this.state.scrollingTimeout || this.props.scrollToRowIndex !== nextProps.scrollToRowIndex || nextProps.rowsCount !== this.props.rowsCount || nextProps.rowHeight !== this.props.rowHeight || nextProps.columns !== this.props.columns || nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.cellMetaData !== this.props.cellMetaData || this.props.colDisplayStart !== nextProps.colDisplayStart || this.props.colDisplayEnd !== nextProps.colDisplayEnd || this.props.colVisibleStart !== nextProps.colVisibleStart || this.props.colVisibleEnd !== nextProps.colVisibleEnd || !(0, _shallowequal2['default'])(nextProps.style, this.props.style) || this.props.isScrolling !== nextProps.isScrolling;
            return shouldUpdate;
          };
          Canvas.prototype.componentWillUnmount = function componentWillUnmount() {
            this._currentRowsLength = 0;
            this._currentRowsRange = {
              start: 0,
              end: 0
            };
            this._scroll = {
              scrollTop: 0,
              scrollLeft: 0
            };
          };
          Canvas.prototype.componentDidUpdate = function componentDidUpdate() {
            if (this._scroll.scrollTop !== 0 && this._scroll.scrollLeft !== 0) {
              this.setScrollLeft(this._scroll.scrollLeft);
            }
            if (this.props.scrollToRowIndex !== 0) {
              this.canvas.scrollTop = Math.min(this.props.scrollToRowIndex * this.props.rowHeight, this.props.rowsCount * this.props.rowHeight - this.props.height);
            }
            this.onRows();
          };
          Canvas.prototype.render = function render() {
            var _this2 = this;
            var _state = this.state,
              displayStart = _state.displayStart,
              displayEnd = _state.displayEnd;
            var _props = this.props,
              rowHeight = _props.rowHeight,
              rowsCount = _props.rowsCount;
            var rows = this.getRows(displayStart, displayEnd).map(function (r, idx) {
              return _this2.renderRow({
                key: 'row-' + (displayStart + idx),
                ref: function ref(node) {
                  return _this2.rows[idx] = node;
                },
                idx: displayStart + idx,
                visibleStart: _this2.props.visibleStart,
                visibleEnd: _this2.props.visibleEnd,
                row: r.row,
                height: rowHeight,
                onMouseOver: _this2.onMouseOver,
                columns: _this2.props.columns,
                isSelected: _this2.isRowSelected(displayStart + idx, r.row, displayStart, displayEnd),
                expandedRows: _this2.props.expandedRows,
                cellMetaData: _this2.props.cellMetaData,
                subRowDetails: r.subRowDetails,
                colVisibleStart: _this2.props.colVisibleStart,
                colVisibleEnd: _this2.props.colVisibleEnd,
                colDisplayStart: _this2.props.colDisplayStart,
                colDisplayEnd: _this2.props.colDisplayEnd,
                isScrolling: _this2.props.isScrolling
              });
            });
            this._currentRowsLength = rows.length;
            if (displayStart > 0) {
              rows.unshift(this.renderPlaceholder('top', displayStart * rowHeight));
            }
            if (rowsCount - displayEnd > 0) {
              rows.push(this.renderPlaceholder('bottom', (rowsCount - displayEnd) * rowHeight));
            }
            var style = {
              position: 'absolute',
              top: 0,
              left: 0,
              overflowX: 'auto',
              overflowY: 'scroll',
              width: this.props.totalWidth,
              height: this.props.height
            };
            return React.createElement('div', {
              ref: function ref(div) {
                _this2.canvas = div;
              },
              style: style,
              onScroll: this.onScroll,
              className: joinClasses('react-grid-Canvas', this.props.className, {
                opaque: this.props.cellMetaData.selected && this.props.cellMetaData.selected.active
              })
            }, React.createElement(_RowsContainer2['default'], {
              width: this.props.width,
              rows: rows,
              contextMenu: this.props.contextMenu,
              rowIdx: this.props.cellMetaData.selected.rowIdx,
              idx: this.props.cellMetaData.selected.idx
            }));
          };
          return Canvas;
        }(React.Component);
        Canvas.displayName = 'Canvas';
        Canvas.propTypes = {
          rowRenderer: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].element]),
          rowHeight: _propTypes2['default'].number.isRequired,
          height: _propTypes2['default'].number.isRequired,
          width: _propTypes2['default'].number,
          totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
          style: _propTypes2['default'].string,
          className: _propTypes2['default'].string,
          displayStart: _propTypes2['default'].number.isRequired,
          displayEnd: _propTypes2['default'].number.isRequired,
          visibleStart: _propTypes2['default'].number.isRequired,
          visibleEnd: _propTypes2['default'].number.isRequired,
          colVisibleStart: _propTypes2['default'].number.isRequired,
          colVisibleEnd: _propTypes2['default'].number.isRequired,
          colDisplayStart: _propTypes2['default'].number.isRequired,
          colDisplayEnd: _propTypes2['default'].number.isRequired,
          rowsCount: _propTypes2['default'].number.isRequired,
          rowGetter: _propTypes2['default'].oneOfType([_propTypes2['default'].func.isRequired, _propTypes2['default'].array.isRequired]),
          expandedRows: _propTypes2['default'].array,
          onRows: _propTypes2['default'].func,
          onScroll: _propTypes2['default'].func,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape).isRequired,
          selectedRows: _propTypes2['default'].array,
          rowKey: _propTypes2['default'].string,
          rowScrollTimeout: _propTypes2['default'].number,
          scrollToRowIndex: _propTypes2['default'].number,
          contextMenu: _propTypes2['default'].element,
          getSubRowDetails: _propTypes2['default'].func,
          rowSelection: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
            indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
          }), _propTypes2['default'].shape({
            isSelectedKey: _propTypes2['default'].string.isRequired
          }), _propTypes2['default'].shape({
            keys: _propTypes2['default'].shape({
              values: _propTypes2['default'].array.isRequired,
              rowKey: _propTypes2['default'].string.isRequired
            }).isRequired
          })]),
          rowGroupRenderer: _propTypes2['default'].func,
          isScrolling: _propTypes2['default'].bool,
          length: _propTypes2['default'].number
        };
        Canvas.defaultProps = {
          rowRenderer: Row,
          onRows: function onRows() {},
          selectedRows: [],
          rowScrollTimeout: 0
        };
        module.exports = Canvas;

        /***/
      }, /* 105 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _classnames = __webpack_require__(5);
        var _classnames2 = _interopRequireDefault(_classnames);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _CellActionShape = __webpack_require__(117);
        var _CellActionShape2 = _interopRequireDefault(_CellActionShape);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var CellAction = function (_React$Component) {
          _inherits(CellAction, _React$Component);
          function CellAction() {
            var _temp, _this, _ret;
            _classCallCheck(this, CellAction);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              isMenuOpen: false
            }, _this.onToggleMenu = function () {
              _this.setState(function (prevState) {
                return {
                  isMenuOpen: !prevState.isMenuOpen
                };
              });
            }, _this.onHideMenu = function () {
              _this.setState({
                isMenuOpen: false
              });
            }, _this.onGetMenuOptions = function () {
              return _this.props.action.actions.map(function (action, index) {
                return _react2['default'].createElement('span', {
                  key: index,
                  onClick: action.callback
                }, action.text);
              });
            }, _this.isActionMenu = function () {
              return !_this.props.action.callback && _this.props.action.actions && _this.props.action.actions.length;
            }, _this.onActionButtonBlur = function () {
              if (_this.isActionMenu()) {
                _this.onHideMenu();
              }
            }, _this.onActionIconClick = function () {
              if (!_this.isActionMenu()) {
                _this.props.action.callback();
              } else if (_this.props.action.actions && _this.props.action.actions.length) {
                _this.onToggleMenu();
              }
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          CellAction.prototype.render = function render() {
            var isActionMenu = this.isActionMenu();
            var cellActionClasses = (0, _classnames2['default'])('rdg-cell-action', {
              'rdg-cell-action-last': this.props.isFirst
            });
            var actionButtonClasses = (0, _classnames2['default'])('rdg-cell-action-button', {
              'rdg-cell-action-button-toggled': this.state.isMenuOpen
            });
            return _react2['default'].createElement('div', {
              className: cellActionClasses,
              onMouseLeave: this.onActionButtonBlur
            }, _react2['default'].createElement('div', {
              className: actionButtonClasses,
              onClick: this.onActionIconClick
            }, _react2['default'].createElement('span', {
              className: this.props.action.icon
            })), isActionMenu && this.state.isMenuOpen && _react2['default'].createElement('div', {
              className: 'rdg-cell-action-menu'
            }, this.onGetMenuOptions()));
          };
          return CellAction;
        }(_react2['default'].Component);
        CellAction.propTypes = {
          action: _propTypes2['default'].shape(_CellActionShape2['default']).isRequired,
          isFirst: _propTypes2['default'].bool.isRequired
        };
        exports['default'] = CellAction;

        /***/
      }, /* 106 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _AppConstants = __webpack_require__(30);
        var _AppConstants2 = _interopRequireDefault(_AppConstants);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var CellExpand = function (_React$Component) {
          _inherits(CellExpand, _React$Component);
          function CellExpand(props) {
            _classCallCheck(this, CellExpand);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.onCellExpand = function (e) {
              _this.setState({
                expanded: !_this.state.expanded
              });
              _this.props.onCellExpand(e);
            };
            var expanded = props.expandableOptions && props.expandableOptions.expanded;
            _this.state = {
              expanded: expanded
            };
            return _this;
          }
          CellExpand.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var expanded = nextProps.expandableOptions && nextProps.expandableOptions.expanded;
            if (this.state.expanded !== expanded) {
              this.setState({
                expanded: expanded
              });
            }
          };
          CellExpand.prototype.render = function render() {
            return _react2['default'].createElement('span', {
              className: 'rdg-cell-expand',
              onClick: this.onCellExpand
            }, this.state.expanded ? _AppConstants2['default'].CellExpand.DOWN_TRIANGLE : _AppConstants2['default'].CellExpand.RIGHT_TRIANGLE);
          };
          return CellExpand;
        }(_react2['default'].Component);
        CellExpand.propTypes = {
          expandableOptions: _propTypes2['default'].object.isRequired,
          onCellExpand: _propTypes2['default'].func.isRequired
        };
        exports['default'] = CellExpand;

        /***/
      }, /* 107 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _classnames = __webpack_require__(5);
        var _classnames2 = _interopRequireDefault(_classnames);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var ChildRowDeleteButton = function ChildRowDeleteButton(_ref) {
          var treeDepth = _ref.treeDepth,
            cellHeight = _ref.cellHeight,
            siblingIndex = _ref.siblingIndex,
            numberSiblings = _ref.numberSiblings,
            onDeleteSubRow = _ref.onDeleteSubRow,
            isDeleteSubRowEnabled = _ref.isDeleteSubRowEnabled,
            _ref$allowAddChildRow = _ref.allowAddChildRow,
            allowAddChildRow = _ref$allowAddChildRow === undefined ? true : _ref$allowAddChildRow;
          var lastSibling = siblingIndex === numberSiblings - 1;
          var className = (0, _classnames2['default'])({
            'rdg-child-row-action-cross': allowAddChildRow === true || !lastSibling
          }, {
            'rdg-child-row-action-cross-last': allowAddChildRow === false && (lastSibling || numberSiblings === 1)
          });
          var height = 12;
          var width = 12;
          var left = treeDepth * 15;
          var top = (cellHeight - 12) / 2;
          return _react2['default'].createElement('div', null, _react2['default'].createElement('div', {
            className: className
          }), isDeleteSubRowEnabled && _react2['default'].createElement('div', {
            style: {
              left: left,
              top: top,
              width: width,
              height: height
            },
            className: 'rdg-child-row-btn',
            onClick: onDeleteSubRow
          }, _react2['default'].createElement('div', {
            className: 'glyphicon glyphicon-remove-sign'
          })));
        };
        exports['default'] = ChildRowDeleteButton;

        /***/
      }, /* 108 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var isValidElement = __webpack_require__(2).isValidElement;
        module.exports = function sameColumn(a, b) {
          var k = void 0;
          for (k in a) {
            if (a.hasOwnProperty(k)) {
              if (typeof a[k] === 'function' && typeof b[k] === 'function' || isValidElement(a[k]) && isValidElement(b[k])) {
                continue;
              }
              if (!b.hasOwnProperty(k) || a[k] !== b[k]) {
                return false;
              }
            }
          }
          for (k in b) {
            if (b.hasOwnProperty(k) && !a.hasOwnProperty(k)) {
              return false;
            }
          }
          return true;
        };

        /***/
      }, /* 109 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var createObjectWithProperties = __webpack_require__(14);
        __webpack_require__(15);

        // The list of the propTypes that we want to include in the Draggable div
        var knownDivPropertyKeys = ['onDragStart', 'onDragEnd', 'onDrag', 'style'];
        var Draggable = function (_React$Component) {
          _inherits(Draggable, _React$Component);
          function Draggable() {
            var _temp, _this, _ret;
            _classCallCheck(this, Draggable);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              drag: null
            }, _this.onMouseDown = function (e) {
              var drag = _this.props.onDragStart(e);
              if (e.preventDefault) {
                e.preventDefault();
              }
              if (drag === null && e.button !== 0) {
                return;
              }
              window.addEventListener('mouseup', _this.onMouseUp);
              window.addEventListener('mousemove', _this.onMouseMove);
              window.addEventListener('touchend', _this.onMouseUp);
              window.addEventListener('touchmove', _this.onMouseMove);
              _this.setState({
                drag: drag
              });
            }, _this.onMouseMove = function (e) {
              if (_this.state.drag === null) {
                return;
              }
              if (e.preventDefault) {
                e.preventDefault();
              }
              _this.props.onDrag(e);
            }, _this.onMouseUp = function (e) {
              _this.cleanUp();
              _this.props.onDragEnd(e, _this.state.drag);
              _this.setState({
                drag: null
              });
            }, _this.cleanUp = function () {
              window.removeEventListener('mouseup', _this.onMouseUp);
              window.removeEventListener('mousemove', _this.onMouseMove);
              window.removeEventListener('touchend', _this.onMouseUp);
              window.removeEventListener('touchmove', _this.onMouseMove);
            }, _this.getKnownDivProps = function () {
              return createObjectWithProperties(_this.props, knownDivPropertyKeys);
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Draggable.prototype.componentWillUnmount = function componentWillUnmount() {
            this.cleanUp();
          };
          Draggable.prototype.render = function render() {
            return React.createElement('div', _extends({}, this.getKnownDivProps(), {
              onMouseDown: this.onMouseDown,
              onTouchStart: this.onMouseDown,
              className: 'react-grid-HeaderCell__draggable'
            }));
          };
          return Draggable;
        }(React.Component);
        Draggable.propTypes = {
          onDragStart: _propTypes2['default'].func,
          onDragEnd: _propTypes2['default'].func,
          onDrag: _propTypes2['default'].func,
          component: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].constructor]),
          style: _propTypes2['default'].object
        };
        Draggable.defaultProps = {
          onDragStart: function onDragStart() {
            return true;
          },
          onDragEnd: function onDragEnd() {},
          onDrag: function onDrag() {}
        };
        module.exports = Draggable;

        /***/
      }, /* 110 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _ColumnUtils = __webpack_require__(6);
        var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var EmptyChildRow = function (_React$Component) {
          _inherits(EmptyChildRow, _React$Component);
          function EmptyChildRow() {
            _classCallCheck(this, EmptyChildRow);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this));
            _this.onAddSubRow = _this.onAddSubRow.bind(_this);
            return _this;
          }
          EmptyChildRow.prototype.onAddSubRow = function onAddSubRow() {
            this.props.onAddSubRow(this.props.parentRowId);
          };
          EmptyChildRow.prototype.getFixedColumnsWidth = function getFixedColumnsWidth() {
            var fixedWidth = 0;
            var size = _ColumnUtils2['default'].getSize(this.props.columns);
            for (var i = 0; i < size; i++) {
              var column = _ColumnUtils2['default'].getColumn(this.props.columns, i);
              if (column) {
                if (_ColumnUtils2['default'].getValue(column, 'locked')) {
                  fixedWidth += _ColumnUtils2['default'].getValue(column, 'width');
                }
              }
            }
            return fixedWidth;
          };
          EmptyChildRow.prototype.render = function render() {
            var _this2 = this;
            var _props = this.props,
              cellHeight = _props.cellHeight,
              treeDepth = _props.treeDepth;
            var height = 12;
            var width = 12;
            var left = treeDepth * 15;
            var top = (cellHeight - 12) / 2;
            var style = {
              height: cellHeight,
              borderBottom: '1px solid #dddddd'
            };
            var expandColumn = _ColumnUtils2['default'].getColumn(this.props.columns.filter(function (c) {
              return c.key === _this2.props.expandColumnKey;
            }), 0);
            var cellLeft = expandColumn ? expandColumn.left : 0;
            return _react2['default'].createElement('div', {
              className: 'react-grid-Row rdg-add-child-row-container',
              style: style
            }, _react2['default'].createElement('div', {
              className: 'react-grid-Cell',
              style: {
                position: 'absolute',
                height: cellHeight,
                width: '100%',
                left: cellLeft
              }
            }, _react2['default'].createElement('div', {
              className: 'rdg-empty-child-row',
              style: {
                marginLeft: '30px',
                lineHeight: cellHeight + 'px'
              }
            }, _react2['default'].createElement('div', {
              className: '\'rdg-child-row-action-cross rdg-child-row-action-cross-last'
            }), _react2['default'].createElement('div', {
              style: {
                left: left,
                top: top,
                width: width,
                height: height
              },
              className: 'rdg-child-row-btn',
              onClick: this.onAddSubRow
            }, _react2['default'].createElement('div', {
              className: 'glyphicon glyphicon-plus-sign'
            })))));
          };
          return EmptyChildRow;
        }(_react2['default'].Component);
        EmptyChildRow.propTypes = {
          treeDepth: _propTypes2['default'].number.isRequired,
          cellHeight: _propTypes2['default'].number.isRequired,
          onAddSubRow: _propTypes2['default'].func.isRequired,
          parentRowId: _propTypes2['default'].number,
          columns: _propTypes2['default'].array.isRequired,
          expandColumnKey: _propTypes2['default'].string.isRequired
        };
        exports['default'] = EmptyChildRow;

        /***/
      }, /* 111 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var ReactDOM = __webpack_require__(9);
        var Header = __webpack_require__(112);
        var Viewport = __webpack_require__(122);
        var cellMetaDataShape = __webpack_require__(11);
        __webpack_require__(20);
        var Grid = function (_React$Component) {
          _inherits(Grid, _React$Component);
          function Grid() {
            var _temp, _this, _ret;
            _classCallCheck(this, Grid);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getStyle = function () {
              return {
                overflow: 'hidden',
                outline: 0,
                position: 'relative',
                minHeight: _this.props.minHeight
              };
            }, _this._onScroll = function () {
              if (_this._scrollLeft !== undefined) {
                _this.header.setScrollLeft(_this._scrollLeft);
                if (_this.viewport) {
                  _this.viewport.setScrollLeft(_this._scrollLeft);
                }
              }
            }, _this.onScroll = function (props) {
              if (_this._scrollLeft !== props.scrollLeft) {
                _this._scrollLeft = props.scrollLeft;
                _this._onScroll();
              }
            }, _this.onHeaderScroll = function (e) {
              var scrollLeft = e.target.scrollLeft;
              if (_this._scrollLeft !== scrollLeft) {
                _this._scrollLeft = scrollLeft;
                _this.header.setScrollLeft(scrollLeft);
                var canvas = ReactDOM.findDOMNode(_this.viewport.canvas);
                canvas.scrollLeft = scrollLeft;
                _this.viewport.canvas.setScrollLeft(scrollLeft);
              }
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Grid.prototype.componentDidMount = function componentDidMount() {
            this._scrollLeft = this.viewport ? this.viewport.getScroll().scrollLeft : 0;
            this._onScroll();
          };
          Grid.prototype.componentDidUpdate = function componentDidUpdate() {
            this._onScroll();
          };
          Grid.prototype.componentWillMount = function componentWillMount() {
            this._scrollLeft = undefined;
          };
          Grid.prototype.componentWillUnmount = function componentWillUnmount() {
            this._scrollLeft = undefined;
          };
          Grid.prototype.render = function render() {
            var _this2 = this;
            var headerRows = this.props.headerRows || [{
              ref: function ref(node) {
                return _this2.row = node;
              }
            }];
            var EmptyRowsView = this.props.emptyRowsView;
            return React.createElement('div', {
              style: this.getStyle(),
              className: 'react-grid-Grid'
            }, React.createElement(Header, {
              ref: function ref(input) {
                _this2.header = input;
              },
              columnMetrics: this.props.columnMetrics,
              onColumnResize: this.props.onColumnResize,
              height: this.props.rowHeight,
              totalWidth: this.props.totalWidth,
              headerRows: headerRows,
              sortColumn: this.props.sortColumn,
              sortDirection: this.props.sortDirection,
              draggableHeaderCell: this.props.draggableHeaderCell,
              onSort: this.props.onSort,
              onHeaderDrop: this.props.onHeaderDrop,
              onScroll: this.onHeaderScroll,
              getValidFilterValues: this.props.getValidFilterValues,
              cellMetaData: this.props.cellMetaData
            }), this.props.rowsCount >= 1 || this.props.rowsCount === 0 && !this.props.emptyRowsView ? React.createElement('div', {
              ref: function ref(node) {
                _this2.viewPortContainer = node;
              },
              tabIndex: this.props.tabIndex,
              onKeyDown: this.props.onViewportKeydown,
              onKeyUp: this.props.onViewportKeyup,
              onClick: this.props.onViewportClick,
              onDoubleClick: this.props.onViewportDoubleClick,
              onDragStart: this.props.onViewportDragStart,
              onDragEnd: this.props.onViewportDragEnd
            }, React.createElement(Viewport, {
              ref: function ref(node) {
                _this2.viewport = node;
              },
              rowKey: this.props.rowKey,
              width: this.props.columnMetrics.width,
              rowHeight: this.props.rowHeight,
              rowRenderer: this.props.rowRenderer,
              rowGetter: this.props.rowGetter,
              rowsCount: this.props.rowsCount,
              selectedRows: this.props.selectedRows,
              expandedRows: this.props.expandedRows,
              columnMetrics: this.props.columnMetrics,
              totalWidth: this.props.totalWidth,
              onScroll: this.onScroll,
              onRows: this.props.onRows,
              cellMetaData: this.props.cellMetaData,
              rowOffsetHeight: this.props.rowOffsetHeight || this.props.rowHeight * headerRows.length,
              minHeight: this.props.minHeight,
              rowScrollTimeout: this.props.rowScrollTimeout,
              scrollToRowIndex: this.props.scrollToRowIndex,
              contextMenu: this.props.contextMenu,
              rowSelection: this.props.rowSelection,
              getSubRowDetails: this.props.getSubRowDetails,
              rowGroupRenderer: this.props.rowGroupRenderer,
              overScan: this.props.overScan
            })) : React.createElement('div', {
              ref: function ref(node) {
                _this2.emptyView = node;
              },
              className: 'react-grid-Empty'
            }, React.createElement(EmptyRowsView, null)));
          };
          return Grid;
        }(React.Component);
        Grid.displayName = 'Grid';
        Grid.propTypes = {
          rowGetter: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]).isRequired,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].object]),
          tabIndex: _propTypes2['default'].number,
          columnMetrics: _propTypes2['default'].object,
          minHeight: _propTypes2['default'].number,
          totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
          headerRows: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]),
          rowHeight: _propTypes2['default'].number,
          rowRenderer: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].func]),
          emptyRowsView: _propTypes2['default'].func,
          expandedRows: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]),
          selectedRows: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]),
          rowSelection: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
            indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
          }), _propTypes2['default'].shape({
            isSelectedKey: _propTypes2['default'].string.isRequired
          }), _propTypes2['default'].shape({
            keys: _propTypes2['default'].shape({
              values: _propTypes2['default'].array.isRequired,
              rowKey: _propTypes2['default'].string.isRequired
            }).isRequired
          })]),
          rowsCount: _propTypes2['default'].number,
          onRows: _propTypes2['default'].func,
          sortColumn: _propTypes2['default'].string,
          sortDirection: _propTypes2['default'].oneOf(['ASC', 'DESC', 'NONE']),
          rowOffsetHeight: _propTypes2['default'].number.isRequired,
          onViewportKeydown: _propTypes2['default'].func.isRequired,
          onViewportKeyup: _propTypes2['default'].func,
          onViewportDragStart: _propTypes2['default'].func.isRequired,
          onViewportDragEnd: _propTypes2['default'].func.isRequired,
          onViewportClick: _propTypes2['default'].func.isRequired,
          onViewportDoubleClick: _propTypes2['default'].func.isRequired,
          onColumnResize: _propTypes2['default'].func,
          onSort: _propTypes2['default'].func,
          onHeaderDrop: _propTypes2['default'].func,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
          rowKey: _propTypes2['default'].string.isRequired,
          rowScrollTimeout: _propTypes2['default'].number,
          scrollToRowIndex: _propTypes2['default'].number,
          contextMenu: _propTypes2['default'].element,
          getSubRowDetails: _propTypes2['default'].func,
          draggableHeaderCell: _propTypes2['default'].func,
          getValidFilterValues: _propTypes2['default'].func,
          rowGroupRenderer: _propTypes2['default'].func,
          overScan: _propTypes2['default'].object
        };
        Grid.defaultProps = {
          rowHeight: 35,
          minHeight: 350,
          tabIndex: 0
        };
        module.exports = Grid;

        /***/
      }, /* 112 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var ReactDOM = __webpack_require__(9);
        var joinClasses = __webpack_require__(5);
        var shallowCloneObject = __webpack_require__(52);
        var ColumnMetrics = __webpack_require__(31);
        var ColumnUtils = __webpack_require__(6);
        var HeaderRow = __webpack_require__(114);
        var getScrollbarSize = __webpack_require__(32);
        var createObjectWithProperties = __webpack_require__(14);
        var cellMetaDataShape = __webpack_require__(11);
        __webpack_require__(15);

        // The list of the propTypes that we want to include in the Header div
        var knownDivPropertyKeys = ['height', 'onScroll'];
        var Header = function (_React$Component) {
          _inherits(Header, _React$Component);
          function Header() {
            var _temp, _this, _ret;
            _classCallCheck(this, Header);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              resizing: null
            }, _this.onColumnResize = function (column, width) {
              var state = _this.state.resizing || _this.props;
              var pos = _this.getColumnPosition(column);
              if (pos != null) {
                var _resizing = {
                  columnMetrics: shallowCloneObject(state.columnMetrics)
                };
                _resizing.columnMetrics = ColumnMetrics.resizeColumn(_resizing.columnMetrics, pos, width);

                // we don't want to influence scrollLeft while resizing
                if (_resizing.columnMetrics.totalWidth < state.columnMetrics.totalWidth) {
                  _resizing.columnMetrics.totalWidth = state.columnMetrics.totalWidth;
                }
                _resizing.column = ColumnUtils.getColumn(_resizing.columnMetrics.columns, pos);
                _this.setState({
                  resizing: _resizing
                });
              }
            }, _this.onColumnResizeEnd = function (column, width) {
              var pos = _this.getColumnPosition(column);
              if (pos !== null && _this.props.onColumnResize) {
                _this.props.onColumnResize(pos, width || column.width);
              }
            }, _this.getHeaderRows = function () {
              var columnMetrics = _this.getColumnMetrics();
              var resizeColumn = void 0;
              if (_this.state.resizing) {
                resizeColumn = _this.state.resizing.column;
              }
              var headerRows = [];
              _this.props.headerRows.forEach(function (row, index) {
                // To allow header filters to be visible
                var rowHeight = 'auto';
                if (row.rowType === 'filter') {
                  rowHeight = '500px';
                }
                var scrollbarSize = getScrollbarSize() > 0 ? getScrollbarSize() : 0;
                var updatedWidth = isNaN(_this.props.totalWidth - scrollbarSize) ? _this.props.totalWidth : _this.props.totalWidth - scrollbarSize;
                var headerRowStyle = {
                  position: 'absolute',
                  top: _this.getCombinedHeaderHeights(index),
                  left: 0,
                  width: updatedWidth,
                  overflowX: 'hidden',
                  minHeight: rowHeight
                };
                headerRows.push(React.createElement(HeaderRow, {
                  key: row.ref,
                  ref: function ref(node) {
                    return row.rowType === 'filter' ? _this.filterRow = node : _this.row = node;
                  },
                  rowType: row.rowType,
                  style: headerRowStyle,
                  onColumnResize: _this.onColumnResize,
                  onColumnResizeEnd: _this.onColumnResizeEnd,
                  width: columnMetrics.width,
                  height: row.height || _this.props.height,
                  columns: columnMetrics.columns,
                  resizing: resizeColumn,
                  draggableHeaderCell: _this.props.draggableHeaderCell,
                  filterable: row.filterable,
                  onFilterChange: row.onFilterChange,
                  onHeaderDrop: _this.props.onHeaderDrop,
                  sortColumn: _this.props.sortColumn,
                  sortDirection: _this.props.sortDirection,
                  onSort: _this.props.onSort,
                  onScroll: _this.props.onScroll,
                  getValidFilterValues: _this.props.getValidFilterValues
                }));
              });
              return headerRows;
            }, _this.getColumnMetrics = function () {
              var columnMetrics = void 0;
              if (_this.state.resizing) {
                columnMetrics = _this.state.resizing.columnMetrics;
              } else {
                columnMetrics = _this.props.columnMetrics;
              }
              return columnMetrics;
            }, _this.getColumnPosition = function (column) {
              var columnMetrics = _this.getColumnMetrics();
              var pos = -1;
              columnMetrics.columns.forEach(function (c, idx) {
                if (c.key === column.key) {
                  pos = idx;
                }
              });
              return pos === -1 ? null : pos;
            }, _this.getCombinedHeaderHeights = function (until) {
              var stopAt = _this.props.headerRows.length;
              if (typeof until !== 'undefined') {
                stopAt = until;
              }
              var height = 0;
              for (var index = 0; index < stopAt; index++) {
                height += _this.props.headerRows[index].height || _this.props.height;
              }
              return height;
            }, _this.getStyle = function () {
              return {
                position: 'relative',
                height: _this.getCombinedHeaderHeights()
              };
            }, _this.setScrollLeft = function (scrollLeft) {
              var node = ReactDOM.findDOMNode(_this.row);
              node.scrollLeft = scrollLeft;
              _this.row.setScrollLeft(scrollLeft);
              if (_this.filterRow) {
                var nodeFilters = ReactDOM.findDOMNode(_this.filterRow);
                nodeFilters.scrollLeft = scrollLeft;
                _this.filterRow.setScrollLeft(scrollLeft);
              }
            }, _this.getKnownDivProps = function () {
              return createObjectWithProperties(_this.props, knownDivPropertyKeys);
            }, _this.onHeaderClick = function () {
              _this.props.cellMetaData.onCellClick({
                rowIdx: -1,
                idx: -1
              });
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Header.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
            this.setState({
              resizing: null
            });
          };
          Header.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            var update = !ColumnMetrics.sameColumns(this.props.columnMetrics.columns, nextProps.columnMetrics.columns, ColumnMetrics.sameColumn) || this.props.totalWidth !== nextProps.totalWidth || this.props.headerRows.length !== nextProps.headerRows.length || this.state.resizing !== nextState.resizing || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
            return update;
          };

          // Set the cell selection to -1 x -1 when clicking on the header

          Header.prototype.render = function render() {
            var className = joinClasses({
              'react-grid-Header': true,
              'react-grid-Header--resizing': !!this.state.resizing
            });
            var headerRows = this.getHeaderRows();
            return React.createElement('div', _extends({}, this.getKnownDivProps(), {
              style: this.getStyle(),
              className: className,
              onClick: this.onHeaderClick
            }), headerRows);
          };
          return Header;
        }(React.Component);
        Header.propTypes = {
          columnMetrics: _propTypes2['default'].shape({
            width: _propTypes2['default'].number.isRequired,
            columns: _propTypes2['default'].any
          }).isRequired,
          totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
          height: _propTypes2['default'].number.isRequired,
          headerRows: _propTypes2['default'].array.isRequired,
          sortColumn: _propTypes2['default'].string,
          sortDirection: _propTypes2['default'].oneOf(['ASC', 'DESC', 'NONE']),
          onSort: _propTypes2['default'].func,
          onColumnResize: _propTypes2['default'].func,
          onScroll: _propTypes2['default'].func,
          onHeaderDrop: _propTypes2['default'].func,
          draggableHeaderCell: _propTypes2['default'].func,
          getValidFilterValues: _propTypes2['default'].func,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape)
        };
        module.exports = Header;

        /***/
      }, /* 113 */
      /***/function (module, exports) {
        "use strict";

        var HeaderCellType = {
          SORTABLE: 0,
          FILTERABLE: 1,
          NONE: 2,
          CHECKBOX: 3
        };
        module.exports = HeaderCellType;

        /***/
      }, /* 114 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var shallowEqual = __webpack_require__(69);
        var BaseHeaderCell = __webpack_require__(41);
        var getScrollbarSize = __webpack_require__(32);
        var ExcelColumn = __webpack_require__(12);
        var columnUtils = __webpack_require__(6);
        var SortableHeaderCell = __webpack_require__(46);
        var FilterableHeaderCell = __webpack_require__(123);
        var HeaderCellType = __webpack_require__(113);
        var createObjectWithProperties = __webpack_require__(14);
        __webpack_require__(15);
        var HeaderRowStyle = {
          overflow: _propTypes2['default'].string,
          width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
          height: _propTypes2['default'].number,
          position: _propTypes2['default'].string
        };

        // The list of the propTypes that we want to include in the HeaderRow div
        var knownDivPropertyKeys = ['width', 'height', 'style', 'onScroll'];
        var HeaderRow = function (_React$Component) {
          _inherits(HeaderRow, _React$Component);
          function HeaderRow() {
            var _temp, _this, _ret;
            _classCallCheck(this, HeaderRow);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.getHeaderCellType = function (column) {
              if (column.filterable) {
                if (_this.props.filterable) return HeaderCellType.FILTERABLE;
              }
              if (column.sortable && column.rowType !== 'filter') return HeaderCellType.SORTABLE;
              return HeaderCellType.NONE;
            }, _this.getFilterableHeaderCell = function (column) {
              var FilterRenderer = FilterableHeaderCell;
              if (column.filterRenderer !== undefined) {
                FilterRenderer = column.filterRenderer;
              }
              return React.createElement(FilterRenderer, _extends({}, _this.props, {
                onChange: _this.props.onFilterChange
              }));
            }, _this.getSortableHeaderCell = function (column) {
              var sortDirection = _this.props.sortColumn === column.key ? _this.props.sortDirection : SortableHeaderCell.DEFINE_SORT.NONE;
              var sortDescendingFirst = column.sortDescendingFirst === undefined ? false : column.sortDescendingFirst;
              return React.createElement(SortableHeaderCell, {
                columnKey: column.key,
                onSort: _this.props.onSort,
                sortDirection: sortDirection,
                sortDescendingFirst: sortDescendingFirst,
                headerRenderer: column.headerRenderer
              });
            }, _this.getHeaderRenderer = function (column) {
              var renderer = void 0;
              if (column.headerRenderer && !column.sortable && !_this.props.filterable) {
                renderer = column.headerRenderer;
              } else {
                var headerCellType = _this.getHeaderCellType(column);
                switch (headerCellType) {
                  case HeaderCellType.SORTABLE:
                    renderer = _this.getSortableHeaderCell(column);
                    break;
                  case HeaderCellType.FILTERABLE:
                    renderer = _this.getFilterableHeaderCell(column);
                    break;
                  default:
                    break;
                }
              }
              return renderer;
            }, _this.getStyle = function () {
              return {
                overflow: 'hidden',
                width: '100%',
                height: _this.props.height,
                position: 'absolute'
              };
            }, _this.getCells = function () {
              var cells = [];
              var lockedCells = [];
              var _loop = function _loop(i, len) {
                var column = Object.assign({
                  rowType: _this.props.rowType
                }, columnUtils.getColumn(_this.props.columns, i));
                var _renderer = _this.getHeaderRenderer(column);
                if (column.key === 'select-row' && _this.props.rowType === 'filter') {
                  _renderer = React.createElement('div', null);
                }
                var HeaderCell = column.draggable ? _this.props.draggableHeaderCell : BaseHeaderCell;
                var cell = React.createElement(HeaderCell, {
                  ref: function ref(node) {
                    return _this.cells[i] = node;
                  },
                  key: i,
                  height: _this.props.height,
                  column: column,
                  renderer: _renderer,
                  resizing: _this.props.resizing === column,
                  onResize: _this.props.onColumnResize,
                  onResizeEnd: _this.props.onColumnResizeEnd,
                  onHeaderDrop: _this.props.onHeaderDrop
                });
                if (column.locked) {
                  lockedCells.push(cell);
                } else {
                  cells.push(cell);
                }
              };
              for (var i = 0, len = columnUtils.getSize(_this.props.columns); i < len; i++) {
                _loop(i, len);
              }
              return cells.concat(lockedCells);
            }, _this.setScrollLeft = function (scrollLeft) {
              _this.props.columns.forEach(function (column, i) {
                if (column.locked) {
                  _this.cells[i].setScrollLeft(scrollLeft);
                } else {
                  if (_this.cells[i] && _this.cells[i].removeScroll) {
                    _this.cells[i].removeScroll();
                  }
                }
              });
            }, _this.getKnownDivProps = function () {
              return createObjectWithProperties(_this.props, knownDivPropertyKeys);
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          HeaderRow.prototype.componentWillMount = function componentWillMount() {
            this.cells = [];
          };
          HeaderRow.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.columns !== this.props.columns || !shallowEqual(nextProps.style, this.props.style) || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
          };
          HeaderRow.prototype.render = function render() {
            var cellsStyle = {
              width: this.props.width ? this.props.width + getScrollbarSize() : '100%',
              height: this.props.height,
              whiteSpace: 'nowrap',
              overflowX: 'hidden',
              overflowY: 'hidden'
            };
            var cells = this.getCells();
            return React.createElement('div', _extends({}, this.getKnownDivProps(), {
              className: 'react-grid-HeaderRow'
            }), React.createElement('div', {
              style: cellsStyle
            }, cells));
          };
          return HeaderRow;
        }(React.Component);
        HeaderRow.displayName = 'HeaderRow';
        HeaderRow.propTypes = {
          width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
          height: _propTypes2['default'].number.isRequired,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].object]).isRequired,
          onColumnResize: _propTypes2['default'].func,
          onSort: _propTypes2['default'].func.isRequired,
          onColumnResizeEnd: _propTypes2['default'].func,
          style: _propTypes2['default'].shape(HeaderRowStyle),
          sortColumn: _propTypes2['default'].string,
          sortDirection: _propTypes2['default'].oneOf(Object.keys(SortableHeaderCell.DEFINE_SORT)),
          cellRenderer: _propTypes2['default'].func,
          headerCellRenderer: _propTypes2['default'].func,
          filterable: _propTypes2['default'].bool,
          onFilterChange: _propTypes2['default'].func,
          resizing: _propTypes2['default'].object,
          onScroll: _propTypes2['default'].func,
          rowType: _propTypes2['default'].string,
          draggableHeaderCell: _propTypes2['default'].func,
          onHeaderDrop: _propTypes2['default'].func
        };
        module.exports = HeaderRow;

        /***/
      }, /* 115 */
      /***/function (module, exports) {
        "use strict";

        module.exports = {
          Backspace: 8,
          Tab: 9,
          Enter: 13,
          Shift: 16,
          Ctrl: 17,
          Alt: 18,
          PauseBreak: 19,
          CapsLock: 20,
          Escape: 27,
          PageUp: 33,
          PageDown: 34,
          End: 35,
          Home: 36,
          LeftArrow: 37,
          UpArrow: 38,
          RightArrow: 39,
          DownArrow: 40,
          Insert: 45,
          Delete: 46,
          0: 48,
          1: 49,
          2: 50,
          3: 51,
          4: 52,
          5: 53,
          6: 54,
          7: 55,
          8: 56,
          9: 57,
          a: 65,
          b: 66,
          c: 67,
          d: 68,
          e: 69,
          f: 70,
          g: 71,
          h: 72,
          i: 73,
          j: 74,
          k: 75,
          l: 76,
          m: 77,
          n: 78,
          o: 79,
          p: 80,
          q: 81,
          r: 82,
          s: 83,
          t: 84,
          u: 85,
          v: 86,
          w: 87,
          x: 88,
          y: 89,
          z: 90,
          LeftWindowKey: 91,
          RightWindowKey: 92,
          SelectKey: 93,
          NumPad0: 96,
          NumPad1: 97,
          NumPad2: 98,
          NumPad3: 99,
          NumPad4: 100,
          NumPad5: 101,
          NumPad6: 102,
          NumPad7: 103,
          NumPad8: 104,
          NumPad9: 105,
          Multiply: 106,
          Add: 107,
          Subtract: 109,
          DecimalPoint: 110,
          Divide: 111,
          F1: 112,
          F2: 113,
          F3: 114,
          F4: 115,
          F5: 116,
          F6: 117,
          F7: 118,
          F8: 119,
          F9: 120,
          F10: 121,
          F12: 123,
          NumLock: 144,
          ScrollLock: 145,
          SemiColon: 186,
          EqualSign: 187,
          Comma: 188,
          Dash: 189,
          Period: 190,
          ForwardSlash: 191,
          GraveAccent: 192,
          OpenBracket: 219,
          BackSlash: 220,
          CloseBracket: 221,
          SingleQuote: 222
        };

        /***/
      }, /* 116 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        exports.OverflowCellComponent = undefined;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _focusableComponentWrapper = __webpack_require__(126);
        var _focusableComponentWrapper2 = _interopRequireDefault(_focusableComponentWrapper);
        __webpack_require__(37);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var OverflowCell = function (_React$Component) {
          _inherits(OverflowCell, _React$Component);
          function OverflowCell() {
            _classCallCheck(this, OverflowCell);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          OverflowCell.prototype.getStyle = function getStyle() {
            var style = {
              position: 'absolute',
              width: this.props.column.width,
              height: this.props.height,
              left: this.props.column.left,
              border: '1px solid #eee'
            };
            return style;
          };
          OverflowCell.prototype.render = function render() {
            return _react2['default'].createElement('div', {
              tabIndex: '-1',
              style: this.getStyle(),
              width: '100%',
              className: 'react-grid-Cell'
            });
          };
          return OverflowCell;
        }(_react2['default'].Component);
        OverflowCell.isSelected = function (props) {
          var cellMetaData = props.cellMetaData,
            rowIdx = props.rowIdx,
            idx = props.idx;
          if (cellMetaData == null) {
            return false;
          }
          var selected = cellMetaData.selected;
          return selected && selected.rowIdx === rowIdx && selected.idx === idx;
        };
        OverflowCell.isScrolling = function (props) {
          return props.cellMetaData.isScrollingHorizontallyWithKeyboard;
        };
        OverflowCell.propTypes = {
          rowIdx: _propTypes2['default'].number,
          idx: _propTypes2['default'].number,
          height: _propTypes2['default'].number,
          column: _propTypes2['default'].object,
          cellMetaData: _propTypes2['default'].object
        };
        OverflowCell.displayName = 'Cell';
        var OverflowCellComponent = OverflowCell;
        exports['default'] = (0, _focusableComponentWrapper2['default'])(OverflowCell);
        exports.OverflowCellComponent = OverflowCellComponent;

        /***/
      }, /* 117 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var CellActionShape = {
          icon: _propTypes2['default'].string.isRequired,
          callback: _propTypes2['default'].func,
          actions: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
            text: _propTypes2['default'].string,
            callback: _propTypes2['default'].func
          }))
        };
        exports['default'] = CellActionShape;

        /***/
      }, /* 118 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _ExcelColumn = __webpack_require__(12);
        var _ExcelColumn2 = _interopRequireDefault(_ExcelColumn);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        exports['default'] = {
          ExcelColumn: _ExcelColumn2['default']
        };

        /***/
      }, /* 119 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _SelectAll = __webpack_require__(50);
        var _SelectAll2 = _interopRequireDefault(_SelectAll);
        var _AppConstants = __webpack_require__(30);
        var _AppConstants2 = _interopRequireDefault(_AppConstants);
        var _SortableHeaderCell = __webpack_require__(46);
        var _keyboardUtils = __webpack_require__(55);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var BaseGrid = __webpack_require__(111);
        var CheckboxEditor = __webpack_require__(47);
        var RowUtils = __webpack_require__(44);
        var ColumnUtils = __webpack_require__(6);
        var KeyCodes = __webpack_require__(115);
        var isFunction = __webpack_require__(19);
        var ColumnMetrics = __webpack_require__(31);
        __webpack_require__(20);
        __webpack_require__(70);
        if (!Object.assign) {
          Object.assign = __webpack_require__(146);
        }
        var ReactDataGrid = function (_React$Component) {
          _inherits(ReactDataGrid, _React$Component);
          function ReactDataGrid(props, context) {
            _classCallCheck(this, ReactDataGrid);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
            _initialiseProps.call(_this);
            var columnMetrics = _this.createColumnMetrics();
            var initialState = {
              columnMetrics: columnMetrics,
              selectedRows: [],
              copied: null,
              expandedRows: [],
              canFilter: false,
              columnFilters: {},
              sortDirection: null,
              sortColumn: null,
              dragged: null,
              scrollOffset: 0,
              lastRowIdxUiSelected: -1
            };
            if (props.enableCellSelect) {
              initialState.selected = {
                rowIdx: 0,
                idx: 0
              };
            } else {
              initialState.selected = {
                rowIdx: -1,
                idx: -1
              };
            }
            if (_this.props.sortColumn && _this.props.sortDirection) {
              initialState.sortColumn = _this.props.sortColumn;
              initialState.sortDirection = _this.props.sortDirection;
            }
            _this.state = initialState;
            return _this;
          }
          ReactDataGrid.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
          };
          ReactDataGrid.prototype.componentDidMount = function componentDidMount() {
            if (window.addEventListener) {
              window.addEventListener('resize', this.metricsUpdated);
            } else {
              window.attachEvent('resize', this.metricsUpdated);
            }
            this.metricsUpdated();
          };
          ReactDataGrid.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            window.removeEventListener('resize', this.metricsUpdated);
          };
          ReactDataGrid.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (nextProps.columns) {
              if (!ColumnMetrics.sameColumns(this.props.columns, nextProps.columns, this.props.columnEquality) || nextProps.minWidth !== this.props.minWidth) {
                var columnMetrics = this.createColumnMetrics(nextProps);
                this.setState({
                  columnMetrics: columnMetrics
                });
              }
            }
          };

          // return false if not a shift select so can be handled as normal row selection

          // columnKey not used here as this function will select the whole row,
          // but needed to match the function signature in the CheckboxEditor

          ReactDataGrid.prototype.render = function render() {
            var _this2 = this;
            var cellMetaData = {
              rowKey: this.props.rowKey,
              selected: this.state.selected,
              dragged: this.state.dragged,
              hoveredRowIdx: this.state.hoveredRowIdx,
              onCellClick: this.onCellClick,
              onCellFocus: this.onCellFocus,
              onCellContextMenu: this.onCellContextMenu,
              onCellDoubleClick: this.onCellDoubleClick,
              onCommit: this.onCellCommit,
              onCommitCancel: this.setInactive,
              copied: this.state.copied,
              handleDragEnterRow: this.handleDragEnter,
              handleTerminateDrag: this.handleTerminateDrag,
              enableCellSelect: this.props.enableCellSelect,
              onColumnEvent: this.onColumnEvent,
              openCellEditor: this.openCellEditor,
              onDragHandleDoubleClick: this.onDragHandleDoubleClick,
              onCellExpand: this.onCellExpand,
              onRowExpandToggle: this.onRowExpandToggle,
              onRowHover: this.onRowHover,
              getDataGridDOMNode: this.getDataGridDOMNode,
              getCellActions: this.props.getCellActions,
              onDeleteSubRow: this.props.onDeleteSubRow,
              onAddSubRow: this.props.onAddSubRow,
              isScrollingVerticallyWithKeyboard: this.isKeyDown(KeyCodes.DownArrow) || this.isKeyDown(KeyCodes.UpArrow),
              isScrollingHorizontallyWithKeyboard: this.isKeyDown(KeyCodes.LeftArrow) || this.isKeyDown(KeyCodes.RightArrow) || this.isKeyDown(KeyCodes.Tab),
              enableCellAutoFocus: this.props.enableCellAutoFocus
            };
            var toolbar = this.renderToolbar();
            var containerWidth = this.props.minWidth || this.gridWidth();
            var gridWidth = containerWidth - this.state.scrollOffset;

            // depending on the current lifecycle stage, gridWidth() may not initialize correctly
            // this also handles cases where it always returns undefined -- such as when inside a div with display:none
            // eg Bootstrap tabs and collapses
            if (typeof containerWidth === 'undefined' || isNaN(containerWidth) || containerWidth === 0) {
              containerWidth = '100%';
            }
            if (typeof gridWidth === 'undefined' || isNaN(gridWidth) || gridWidth === 0) {
              gridWidth = '100%';
            }
            return React.createElement('div', {
              className: 'react-grid-Container',
              style: {
                width: containerWidth
              },
              ref: function ref(node) {
                _this2.grid = node;
              }
            }, toolbar, React.createElement('div', {
              className: 'react-grid-Main'
            }, React.createElement(BaseGrid, _extends({
              ref: function ref(node) {
                return _this2.base = node;
              }
            }, this.props, {
              rowKey: this.props.rowKey,
              headerRows: this.getHeaderRows(),
              columnMetrics: this.state.columnMetrics,
              rowGetter: this.props.rowGetter,
              rowsCount: this.props.rowsCount,
              rowHeight: this.props.rowHeight,
              cellMetaData: cellMetaData,
              selectedRows: this.getSelectedRows(),
              rowSelection: this.getRowSelectionProps(),
              expandedRows: this.state.expandedRows,
              rowOffsetHeight: this.getRowOffsetHeight(),
              sortColumn: this.state.sortColumn,
              sortDirection: this.state.sortDirection,
              onSort: this.handleSort,
              minHeight: this.props.minHeight,
              totalWidth: gridWidth,
              onViewportKeydown: this.onKeyDown,
              onViewportKeyup: this.onKeyUp,
              onViewportDragStart: this.onDragStart,
              onViewportDragEnd: this.handleDragEnd,
              onViewportClick: this.deselect,
              onViewportDoubleClick: this.deselect,
              onColumnResize: this.onColumnResize,
              rowScrollTimeout: this.props.rowScrollTimeout,
              scrollToRowIndex: this.props.scrollToRowIndex,
              contextMenu: this.props.contextMenu,
              overScan: this.props.overScan
            }))));
          };
          return ReactDataGrid;
        }(React.Component);
        ReactDataGrid.displayName = 'ReactDataGrid';
        ReactDataGrid.propTypes = {
          rowHeight: _propTypes2['default'].number.isRequired,
          headerRowHeight: _propTypes2['default'].number,
          headerFiltersHeight: _propTypes2['default'].number,
          minHeight: _propTypes2['default'].number.isRequired,
          minWidth: _propTypes2['default'].number,
          enableRowSelect: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].string]),
          onRowUpdated: _propTypes2['default'].func,
          rowGetter: _propTypes2['default'].func.isRequired,
          rowsCount: _propTypes2['default'].number.isRequired,
          toolbar: _propTypes2['default'].element,
          enableCellSelect: _propTypes2['default'].bool,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
          onFilter: _propTypes2['default'].func,
          onCellCopyPaste: _propTypes2['default'].func,
          onCellsDragged: _propTypes2['default'].func,
          getCellActions: _propTypes2['default'].func,
          onAddFilter: _propTypes2['default'].func,
          onGridSort: _propTypes2['default'].func,
          sortColumn: _propTypes2['default'].string,
          sortDirection: _propTypes2['default'].oneOf(Object.keys(_SortableHeaderCell.DEFINE_SORT)),
          onDragHandleDoubleClick: _propTypes2['default'].func,
          onGridRowsUpdated: _propTypes2['default'].func,
          onRowSelect: _propTypes2['default'].func,
          rowKey: _propTypes2['default'].string,
          rowScrollTimeout: _propTypes2['default'].number,
          scrollToRowIndex: _propTypes2['default'].number,
          onClearFilters: _propTypes2['default'].func,
          contextMenu: _propTypes2['default'].element,
          cellNavigationMode: _propTypes2['default'].oneOf(['none', 'loopOverRow', 'changeRow']),
          onCellSelected: _propTypes2['default'].func,
          onCellDeSelected: _propTypes2['default'].func,
          onCellExpand: _propTypes2['default'].func,
          enableDragAndDrop: _propTypes2['default'].bool,
          tabIndex: _propTypes2['default'].number,
          onRowExpandToggle: _propTypes2['default'].func,
          draggableHeaderCell: _propTypes2['default'].func,
          getValidFilterValues: _propTypes2['default'].func,
          rowSelection: _propTypes2['default'].shape({
            enableShiftSelect: _propTypes2['default'].bool,
            onRowsSelected: _propTypes2['default'].func,
            onRowsDeselected: _propTypes2['default'].func,
            showCheckbox: _propTypes2['default'].bool,
            selectBy: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
              indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
            }), _propTypes2['default'].shape({
              isSelectedKey: _propTypes2['default'].string.isRequired
            }), _propTypes2['default'].shape({
              keys: _propTypes2['default'].shape({
                values: _propTypes2['default'].array.isRequired,
                rowKey: _propTypes2['default'].string.isRequired
              }).isRequired
            })]).isRequired
          }),
          onRowClick: _propTypes2['default'].func,
          onRowDoubleClick: _propTypes2['default'].func,
          onGridKeyUp: _propTypes2['default'].func,
          onGridKeyDown: _propTypes2['default'].func,
          rowGroupRenderer: _propTypes2['default'].func,
          rowActionsCell: _propTypes2['default'].func,
          onCheckCellIsEditable: _propTypes2['default'].func,
          /* called before cell is set active, returns a boolean to determine whether cell is editable */
          overScan: _propTypes2['default'].object,
          onDeleteSubRow: _propTypes2['default'].func,
          onAddSubRow: _propTypes2['default'].func,
          enableCellAutoFocus: _propTypes2['default'].bool,
          onBeforeEdit: _propTypes2['default'].func,
          selectAllRenderer: _propTypes2['default'].object,
          minColumnWidth: _propTypes2['default'].number,
          columnEquality: _propTypes2['default'].func,
          onColumnResize: _propTypes2['default'].func
        };
        ReactDataGrid.defaultProps = {
          enableCellSelect: false,
          tabIndex: -1,
          rowHeight: 35,
          headerFiltersHeight: 45,
          enableRowSelect: false,
          minHeight: 350,
          rowKey: 'id',
          rowScrollTimeout: 0,
          scrollToRowIndex: 0,
          cellNavigationMode: 'none',
          overScan: {
            colsStart: 5,
            colsEnd: 5,
            rowsStart: 5,
            rowsEnd: 5
          },
          enableCellAutoFocus: true,
          onBeforeEdit: function onBeforeEdit() {},
          minColumnWidth: 80,
          columnEquality: ColumnMetrics.sameColumn
        };
        var _initialiseProps = function _initialiseProps() {
          var _this3 = this;
          this.gridWidth = function () {
            return _this3.grid ? _this3.grid.parentElement.offsetWidth : 0;
          };
          this.getTotalWidth = function () {
            var totalWidth = 0;
            if (_this3._mounted) {
              totalWidth = _this3.gridWidth();
            } else {
              totalWidth = ColumnUtils.getSize(_this3.props.columns) * _this3.props.minColumnWidth;
            }
            return totalWidth;
          };
          this.getColumnMetricsType = function (metrics) {
            var totalWidth = metrics.totalWidth || _this3.getTotalWidth();
            var currentMetrics = {
              columns: metrics.columns,
              totalWidth: totalWidth,
              minColumnWidth: metrics.minColumnWidth
            };
            var updatedMetrics = ColumnMetrics.recalculate(currentMetrics);
            return updatedMetrics;
          };
          this.getColumn = function (idx) {
            var columns = _this3.state.columnMetrics.columns;
            if (Array.isArray(columns)) {
              return columns[idx];
            } else if (typeof Immutable !== 'undefined') {
              return columns.get(idx);
            }
          };
          this.getSize = function () {
            var columns = _this3.state.columnMetrics.columns;
            if (Array.isArray(columns)) {
              return columns.length;
            } else if (typeof Immutable !== 'undefined') {
              return columns.size;
            }
          };
          this.metricsUpdated = function () {
            var columnMetrics = _this3.createColumnMetrics();
            _this3.setState({
              columnMetrics: columnMetrics
            });
          };
          this.createColumnMetrics = function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;
            var gridColumns = _this3.setupGridColumns(props);
            return _this3.getColumnMetricsType({
              columns: gridColumns,
              minColumnWidth: _this3.props.minColumnWidth,
              totalWidth: props.minWidth
            });
          };
          this.onColumnResize = function (index, width) {
            var columnMetrics = ColumnMetrics.resizeColumn(_this3.state.columnMetrics, index, width);
            _this3.setState({
              columnMetrics: columnMetrics
            });
            if (_this3.props.onColumnResize) {
              _this3.props.onColumnResize(index, width);
            }
          };
          this.onKeyDown = function (e) {
            if ((0, _keyboardUtils.isCtrlKeyHeldDown)(e)) {
              _this3.checkAndCall('onPressKeyWithCtrl', e);
            } else if (_this3.isKeyExplicitlyHandled(e.key)) {
              // break up individual keyPress events to have their own specific callbacks
              var callBack = 'onPress' + e.key;
              _this3.checkAndCall(callBack, e);
            } else if ((0, _keyboardUtils.isKeyPrintable)(e.keyCode)) {
              _this3.checkAndCall('onPressChar', e);
            }

            // Track which keys are currently down for shift clicking etc
            _this3._keysDown = _this3._keysDown || {};
            _this3._keysDown[e.keyCode] = true;
            if (isFunction(_this3.props.onGridKeyDown)) {
              _this3.props.onGridKeyDown(e);
            }
          };
          this.onKeyUp = function (e) {
            // Track which keys are currently down for shift clicking etc
            _this3._keysDown = _this3._keysDown || {};
            delete _this3._keysDown[e.keyCode];
            if (isFunction(_this3.props.onGridKeyUp)) {
              _this3.props.onGridKeyUp(e);
            }
          };
          this.isKeyDown = function (keyCode) {
            if (!_this3._keysDown) return false;
            return keyCode in _this3._keysDown;
          };
          this.isSingleKeyDown = function (keyCode) {
            if (!_this3._keysDown) return false;
            return keyCode in _this3._keysDown && Object.keys(_this3._keysDown).length === 1;
          };
          this.checkAndCall = function (methodName, args) {
            if (typeof _this3[methodName] === 'function') {
              _this3[methodName](args);
            }
          };
          this.isKeyExplicitlyHandled = function (key) {
            return typeof _this3['onPress' + key] === 'function';
          };
          this.hasSelectedCellChanged = function (selected) {
            var previouslySelected = Object.assign({}, _this3.state.selected);
            return previouslySelected.rowIdx !== selected.rowIdx || previouslySelected.idx !== selected.idx || previouslySelected.active === false;
          };
          this.onContextMenuHide = function () {
            document.removeEventListener('click', _this3.onContextMenuHide);
            var newSelected = Object.assign({}, _this3.state.selected, {
              contextMenuDisplayed: false
            });
            _this3.setState({
              selected: newSelected
            });
          };
          this.onColumnEvent = function (ev, columnEvent) {
            var idx = columnEvent.idx,
              name = columnEvent.name;
            if (name && typeof idx !== 'undefined') {
              var column = _this3.getColumn(idx);
              if (column && column.events && column.events[name] && typeof column.events[name] === 'function') {
                var eventArgs = {
                  idx: idx,
                  rowIdx: columnEvent.rowIdx,
                  rowId: columnEvent.rowId,
                  column: column
                };
                column.events[name](ev, eventArgs);
              }
            }
          };
          this.onSelect = function (selected) {
            if (_this3.state.selected.rowIdx !== selected.rowIdx || _this3.state.selected.idx !== selected.idx || _this3.state.selected.active === false) {
              var _idx = selected.idx;
              var _rowIdx = selected.rowIdx;
              if (_this3.isCellWithinBounds(selected)) {
                var oldSelection = _this3.state.selected;
                _this3.setState({
                  selected: selected
                }, function () {
                  if (typeof _this3.props.onCellDeSelected === 'function') {
                    _this3.props.onCellDeSelected(oldSelection);
                  }
                  if (typeof _this3.props.onCellSelected === 'function') {
                    _this3.props.onCellSelected(selected);
                  }
                });
              } else if (_rowIdx === -1 && _idx === -1) {
                // When it's outside of the grid, set rowIdx anyway
                _this3.setState({
                  selected: {
                    idx: _idx,
                    rowIdx: _rowIdx
                  }
                });
              }
            }
          };
          this.onCellClick = function (cell, e) {
            _this3.onSelect({
              rowIdx: cell.rowIdx,
              idx: cell.idx
            });
            if (_this3.props.onRowClick && typeof _this3.props.onRowClick === 'function') {
              _this3.props.onRowClick(cell.rowIdx, _this3.props.rowGetter(cell.rowIdx), _this3.getColumn(cell.idx));
            }
            if (e) {
              e.stopPropagation();
            }
          };
          this.onCellFocus = function (cell) {
            _this3.onSelect(cell);
          };
          this.onCellContextMenu = function (cell) {
            _this3.onSelect({
              rowIdx: cell.rowIdx,
              idx: cell.idx,
              contextMenuDisplayed: _this3.props.contextMenu
            });
            if (_this3.props.contextMenu) {
              document.addEventListener('click', _this3.onContextMenuHide);
            }
          };
          this.onCellDoubleClick = function (cell, e) {
            _this3.onSelect({
              rowIdx: cell.rowIdx,
              idx: cell.idx
            });
            if (_this3.props.onRowDoubleClick && typeof _this3.props.onRowDoubleClick === 'function') {
              _this3.props.onRowDoubleClick(cell.rowIdx, _this3.props.rowGetter(cell.rowIdx), _this3.getColumn(cell.idx));
            }
            _this3.setActive();
            if (e) {
              e.stopPropagation();
            }
          };
          this.onPressArrowUp = function (e) {
            _this3.moveSelectedCell(e, -1, 0);
          };
          this.onPressArrowDown = function (e) {
            _this3.moveSelectedCell(e, 1, 0);
          };
          this.onPressArrowLeft = function (e) {
            _this3.moveSelectedCell(e, 0, -1);
          };
          this.onPressArrowRight = function (e) {
            _this3.moveSelectedCell(e, 0, 1);
          };
          this.isFocusedOnCell = function () {
            return document.activeElement && document.activeElement.classList && document.activeElement.classList.contains('react-grid-Cell');
          };
          this.isFocusedOnTable = function () {
            var domNode = _this3.getDataGridDOMNode();
            return domNode && domNode.contains(document.activeElement);
          };
          this.exitGrid = function (oldSelectedCell, newSelectedValue) {
            _this3.setState({
              selected: newSelectedValue
            }, function () {
              if (typeof _this3.props.onCellDeSelected === 'function') {
                _this3.props.onCellDeSelected(oldSelectedCell);
              }
            });
          };
          this.enterGrid = function (newSelectedValue) {
            _this3.setState({
              selected: newSelectedValue
            }, function () {
              if (typeof _this3.props.onCellSelected === 'function') {
                _this3.props.onCellSelected(newSelectedValue);
              }
            });
          };
          this.onPressTab = function (e) {
            // Scenario 0a: When there are no rows in the grid, pressing tab needs to allow the browser to handle it
            if (_this3.props.rowsCount === 0) {
              return;
            }
            // Scenario 0b: When we're editing a cell
            var idx = _this3.state.selected.idx;
            var rowIdx = _this3.state.selected.rowIdx;
            if (_this3.state.selected.active === true) {
              // if we are in a position to leave the grid, stop editing but stay in that cell
              if (_this3.canExitGrid(e)) {
                _this3.moveSelectedCell(e, 0, 0);
                return;
              }
              // otherwise move left or right as appropriate
              _this3.moveSelectedCell(e, 0, e.shiftKey ? -1 : 1);
              return;
            }
            var shift = e.shiftKey === true;
            // Scenario 1: we're at a cell where we can exit the grid
            if (_this3.canExitGrid(e) && _this3.isFocusedOnCell()) {
              if (shift && idx >= 0) {
                _this3.exitGrid({
                  idx: idx,
                  rowIdx: rowIdx
                }, {
                  idx: -1,
                  rowIdx: rowIdx,
                  exitedLeft: true
                });
                return;
              } else if (!shift && idx >= 0) {
                _this3.exitGrid({
                  idx: idx,
                  rowIdx: rowIdx
                }, {
                  idx: -1,
                  rowIdx: rowIdx
                });
                return;
              }
            }
            // Scenario 2: we're on the div surrounding the grid and press shift+Tab
            // and we just exited left, so we want to let the browser handle it
            // KNOWN ISSUE: Focus on the table can come from either side and at this point we can't know how
            // they user arrived, so it is possible that exitLeft gets set and then the user clicks out of the table
            // and they won't be able to Shift+Tab around the site to re-enter the table from the right.
            if (_this3.isFocusedOnTable() && !_this3.isFocusedOnCell() && shift && _this3.state.selected.exitedLeft) {
              _this3.enterGrid({
                idx: idx,
                rowIdx: rowIdx
              });
              return;
            }
            // Scenario 3: we're on the div surrounding the grid and we want to enter the grid
            if (!_this3.isFocusedOnCell()) {
              // Scenario 3A: idx has been set to -1 (eg can happen when clicking into the filter box)
              // we want to go to the first cell in the row if we press Tab
              // we want to go to the last cell in the row if we press Shift+Tab
              if (idx === -1) {
                _this3.moveSelectedCell(e, rowIdx === -1 ? 1 : 0, shift ? _this3.getNbrColumns() : 1);
                return;
              }
              // otherwise, there is a selected cell in the table already, and
              // we want to trigger it to focus - setting selected in state will update
              // the cell props, and checkFocus will be called
              _this3.enterGrid({
                idx: idx,
                rowIdx: rowIdx,
                changeSomething: true
              });
              // make sure the browser doesn't handle it
              e.preventDefault();
              return;
            }
            _this3.moveSelectedCell(e, 0, e.shiftKey ? -1 : 1);
          };
          this.onPressEnter = function (e) {
            _this3.setActive(e.key);
          };
          this.onPressDelete = function (e) {
            _this3.setActive(e.key);
          };
          this.onPressEscape = function (e) {
            _this3.setInactive(e.key);
            _this3.handleCancelCopy();
          };
          this.onPressBackspace = function (e) {
            _this3.setActive(e.key);
          };
          this.onPressChar = function (e) {
            if ((0, _keyboardUtils.isKeyPrintable)(e.keyCode)) {
              _this3.setActive(e.keyCode);
            }
          };
          this.onPressKeyWithCtrl = function (e) {
            var keys = {
              KeyCode_c: 99,
              KeyCode_C: 67,
              KeyCode_V: 86,
              KeyCode_v: 118
            };
            var rowIdx = _this3.state.selected.rowIdx;
            var row = _this3.props.rowGetter(rowIdx);
            var idx = _this3.state.selected.idx;
            var col = _this3.getColumn(idx);
            if (ColumnUtils.canEdit(col, row, _this3.props.enableCellSelect)) {
              if (e.keyCode === keys.KeyCode_c || e.keyCode === keys.KeyCode_C) {
                var _value = _this3.getSelectedValue();
                _this3.handleCopy({
                  value: _value
                });
              } else if (e.keyCode === keys.KeyCode_v || e.keyCode === keys.KeyCode_V) {
                _this3.handlePaste();
              }
            }
          };
          this.onGridRowsUpdated = function (cellKey, fromRow, toRow, updated, action, originRow) {
            var rowIds = [];
            for (var i = fromRow; i <= toRow; i++) {
              rowIds.push(_this3.props.rowGetter(i)[_this3.props.rowKey]);
            }
            var fromRowData = _this3.props.rowGetter(action === 'COPY_PASTE' ? originRow : fromRow);
            var fromRowId = fromRowData[_this3.props.rowKey];
            var toRowId = _this3.props.rowGetter(toRow)[_this3.props.rowKey];
            _this3.props.onGridRowsUpdated({
              cellKey: cellKey,
              fromRow: fromRow,
              toRow: toRow,
              fromRowId: fromRowId,
              toRowId: toRowId,
              rowIds: rowIds,
              updated: updated,
              action: action,
              fromRowData: fromRowData
            });
          };
          this.onCellCommit = function (commit) {
            var selected = Object.assign({}, _this3.state.selected);
            selected.active = false;
            var expandedRows = _this3.state.expandedRows;
            // if(commit.changed && commit.changed.expandedHeight){
            //   expandedRows = this.expandRow(commit.rowIdx, commit.changed.expandedHeight);
            // }
            _this3.setState({
              selected: selected,
              expandedRows: expandedRows
            });
            if (_this3.props.onRowUpdated) {
              _this3.props.onRowUpdated(commit);
            }
            var targetRow = commit.rowIdx;
            if (_this3.props.onGridRowsUpdated) {
              _this3.onGridRowsUpdated(commit.cellKey, targetRow, targetRow, commit.updated, _AppConstants2['default'].UpdateActions.CELL_UPDATE);
            }
          };
          this.onDragStart = function (e) {
            var idx = _this3.state.selected.idx;
            // To prevent dragging down/up when reordering rows.
            var isViewportDragging = e && e.target && e.target.className;
            if (idx > -1 && isViewportDragging) {
              var _value2 = _this3.getSelectedValue();
              _this3.handleDragStart({
                idx: _this3.state.selected.idx,
                rowIdx: _this3.state.selected.rowIdx,
                value: _value2
              });
              // need to set dummy data for FF
              if (e && e.dataTransfer) {
                if (e.dataTransfer.setData) {
                  e.dataTransfer.dropEffect = 'move';
                  e.dataTransfer.effectAllowed = 'move';
                  e.dataTransfer.setData('text/plain', '');
                }
              }
            }
          };
          this.onToggleFilter = function () {
            // setState() does not immediately mutate this.state but creates a pending state transition.
            // Therefore if you want to do something after the state change occurs, pass it in as a callback function.
            _this3.setState({
              canFilter: !_this3.state.canFilter
            }, function () {
              if (_this3.state.canFilter === false && _this3.props.onClearFilters) {
                _this3.props.onClearFilters();
              }
            });
          };
          this.onDragHandleDoubleClick = function (e) {
            if (_this3.props.onDragHandleDoubleClick) {
              _this3.props.onDragHandleDoubleClick(e);
            }
            if (_this3.props.onGridRowsUpdated) {
              var _this3$onGridRowsUpda;
              var cellKey = _this3.getColumn(e.idx).key;
              _this3.onGridRowsUpdated(cellKey, e.rowIdx, _this3.props.rowsCount - 1, (_this3$onGridRowsUpda = {}, _this3$onGridRowsUpda[cellKey] = e.rowData[cellKey], _this3$onGridRowsUpda), _AppConstants2['default'].UpdateActions.COLUMN_FILL);
            }
          };
          this.onCellExpand = function (args) {
            if (_this3.props.onCellExpand) {
              _this3.props.onCellExpand(args);
            }
          };
          this.onRowExpandToggle = function (args) {
            if (typeof _this3.props.onRowExpandToggle === 'function') {
              _this3.props.onRowExpandToggle(args);
            }
          };
          this.isCellWithinBounds = function (_ref) {
            var idx = _ref.idx,
              rowIdx = _ref.rowIdx;
            return idx >= 0 && rowIdx >= 0 && idx < ColumnUtils.getSize(_this3.state.columnMetrics.columns) && rowIdx < _this3.props.rowsCount;
          };
          this.handleDragStart = function (dragged) {
            if (!_this3.dragEnabled()) {
              return;
            }
            if (_this3.isCellWithinBounds(dragged)) {
              _this3.setState({
                dragged: dragged
              });
            }
          };
          this.handleDragEnd = function () {
            if (!_this3.dragEnabled()) {
              return;
            }
            var _state = _this3.state,
              selected = _state.selected,
              dragged = _state.dragged;
            var column = _this3.getColumn(_this3.state.selected.idx);
            if (selected && dragged && column) {
              var cellKey = column.key;
              var fromRow = selected.rowIdx < dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
              var toRow = selected.rowIdx > dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
              if (_this3.props.onCellsDragged) {
                _this3.props.onCellsDragged({
                  cellKey: cellKey,
                  fromRow: fromRow,
                  toRow: toRow,
                  value: dragged.value
                });
              }
              if (_this3.props.onGridRowsUpdated) {
                var _this3$onGridRowsUpda2;
                _this3.onGridRowsUpdated(cellKey, fromRow, toRow, (_this3$onGridRowsUpda2 = {}, _this3$onGridRowsUpda2[cellKey] = dragged.value, _this3$onGridRowsUpda2), _AppConstants2['default'].UpdateActions.CELL_DRAG);
              }
            }
            _this3.setState({
              dragged: {
                complete: true
              }
            });
          };
          this.handleDragEnter = function (row) {
            if (!_this3.dragEnabled() || _this3.state.dragged == null) {
              return;
            }
            var dragged = _this3.state.dragged;
            dragged.overRowIdx = row;
            _this3.setState({
              dragged: dragged
            });
          };
          this.handleTerminateDrag = function () {
            if (!_this3.dragEnabled()) {
              return;
            }
            _this3.setState({
              dragged: null
            });
          };
          this.handlePaste = function () {
            if (!_this3.copyPasteEnabled() || !_this3.state.copied) {
              return;
            }
            var selected = _this3.state.selected;
            var cellKey = _this3.getColumn(_this3.state.selected.idx).key;
            var textToCopy = _this3.state.textToCopy;
            var fromRow = _this3.state.copied.rowIdx;
            var toRow = selected.rowIdx;
            if (_this3.props.onCellCopyPaste) {
              _this3.props.onCellCopyPaste({
                cellKey: cellKey,
                rowIdx: toRow,
                value: textToCopy,
                fromRow: fromRow,
                toRow: toRow
              });
            }
            if (_this3.props.onGridRowsUpdated) {
              var _this3$onGridRowsUpda3;
              _this3.onGridRowsUpdated(cellKey, toRow, toRow, (_this3$onGridRowsUpda3 = {}, _this3$onGridRowsUpda3[cellKey] = textToCopy, _this3$onGridRowsUpda3), _AppConstants2['default'].UpdateActions.COPY_PASTE, fromRow);
            }
          };
          this.handleCancelCopy = function () {
            _this3.setState({
              copied: null
            });
          };
          this.handleCopy = function (args) {
            if (!_this3.copyPasteEnabled()) {
              return;
            }
            var textToCopy = args.value;
            var selected = _this3.state.selected;
            var copied = {
              idx: selected.idx,
              rowIdx: selected.rowIdx
            };
            _this3.setState({
              textToCopy: textToCopy,
              copied: copied
            });
          };
          this.handleSort = function (columnKey, direction) {
            _this3.setState({
              sortDirection: direction,
              sortColumn: columnKey
            }, function () {
              this.props.onGridSort(columnKey, direction);
            });
          };
          this.getSelectedRow = function (rows, key) {
            var selectedRow = rows.filter(function (r) {
              if (r[_this3.props.rowKey] === key) {
                return true;
              }
              return false;
            });
            if (selectedRow.length > 0) {
              return selectedRow[0];
            }
          };
          this.useNewRowSelection = function () {
            return _this3.props.rowSelection && _this3.props.rowSelection.selectBy;
          };
          this.handleShiftSelect = function (rowIdx) {
            if (_this3.state.lastRowIdxUiSelected > -1 && _this3.isSingleKeyDown(KeyCodes.Shift)) {
              var _props$rowSelection$s = _this3.props.rowSelection.selectBy,
                keys = _props$rowSelection$s.keys,
                indexes = _props$rowSelection$s.indexes,
                isSelectedKey = _props$rowSelection$s.isSelectedKey;
              var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, _this3.props.rowGetter(rowIdx), rowIdx);
              if (isPreviouslySelected) return false;
              var handled = false;
              if (rowIdx > _this3.state.lastRowIdxUiSelected) {
                var rowsSelected = [];
                for (var i = _this3.state.lastRowIdxUiSelected + 1; i <= rowIdx; i++) {
                  rowsSelected.push({
                    rowIdx: i,
                    row: _this3.props.rowGetter(i)
                  });
                }
                if (typeof _this3.props.rowSelection.onRowsSelected === 'function') {
                  _this3.props.rowSelection.onRowsSelected(rowsSelected);
                }
                handled = true;
              } else if (rowIdx < _this3.state.lastRowIdxUiSelected) {
                var _rowsSelected = [];
                for (var _i = rowIdx; _i <= _this3.state.lastRowIdxUiSelected - 1; _i++) {
                  _rowsSelected.push({
                    rowIdx: _i,
                    row: _this3.props.rowGetter(_i)
                  });
                }
                if (typeof _this3.props.rowSelection.onRowsSelected === 'function') {
                  _this3.props.rowSelection.onRowsSelected(_rowsSelected);
                }
                handled = true;
              }
              if (handled) {
                _this3.setState({
                  lastRowIdxUiSelected: rowIdx
                });
              }
              return handled;
            }
            return false;
          };
          this.handleNewRowSelect = function (rowIdx, rowData) {
            if (_this3.selectAllCheckbox && _this3.selectAllCheckbox.checked === true) {
              _this3.selectAllCheckbox.checked = false;
            }
            var _props$rowSelection$s2 = _this3.props.rowSelection.selectBy,
              keys = _props$rowSelection$s2.keys,
              indexes = _props$rowSelection$s2.indexes,
              isSelectedKey = _props$rowSelection$s2.isSelectedKey;
            var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx);
            _this3.setState({
              lastRowIdxUiSelected: isPreviouslySelected ? -1 : rowIdx,
              selected: {
                rowIdx: rowIdx,
                idx: 0
              }
            });
            if (isPreviouslySelected && typeof _this3.props.rowSelection.onRowsDeselected === 'function') {
              _this3.props.rowSelection.onRowsDeselected([{
                rowIdx: rowIdx,
                row: rowData
              }]);
            } else if (!isPreviouslySelected && typeof _this3.props.rowSelection.onRowsSelected === 'function') {
              _this3.props.rowSelection.onRowsSelected([{
                rowIdx: rowIdx,
                row: rowData
              }]);
            }
          };
          this.handleRowSelect = function (rowIdx, columnKey, rowData, e) {
            e.stopPropagation();
            if (_this3.useNewRowSelection()) {
              if (_this3.props.rowSelection.enableShiftSelect === true) {
                if (!_this3.handleShiftSelect(rowIdx)) {
                  _this3.handleNewRowSelect(rowIdx, rowData);
                }
              } else {
                _this3.handleNewRowSelect(rowIdx, rowData);
              }
            } else {
              // Fallback to old onRowSelect handler
              var selectedRows = _this3.props.enableRowSelect === 'single' ? [] : _this3.state.selectedRows.slice(0);
              var selectedRow = _this3.getSelectedRow(selectedRows, rowData[_this3.props.rowKey]);
              if (selectedRow) {
                selectedRow.isSelected = !selectedRow.isSelected;
              } else {
                rowData.isSelected = true;
                selectedRows.push(rowData);
              }
              _this3.setState({
                selectedRows: selectedRows,
                selected: {
                  rowIdx: rowIdx,
                  idx: 0
                }
              });
              if (_this3.props.onRowSelect) {
                _this3.props.onRowSelect(selectedRows.filter(function (r) {
                  return r.isSelected === true;
                }));
              }
            }
          };
          this.handleCheckboxChange = function (e) {
            var allRowsSelected = void 0;
            if (e.currentTarget instanceof HTMLInputElement && e.currentTarget.checked === true) {
              allRowsSelected = true;
            } else {
              allRowsSelected = false;
            }
            if (_this3.useNewRowSelection()) {
              var _props$rowSelection$s3 = _this3.props.rowSelection.selectBy,
                keys = _props$rowSelection$s3.keys,
                indexes = _props$rowSelection$s3.indexes,
                isSelectedKey = _props$rowSelection$s3.isSelectedKey;
              if (allRowsSelected && typeof _this3.props.rowSelection.onRowsSelected === 'function') {
                var selectedRows = [];
                for (var i = 0; i < _this3.props.rowsCount; i++) {
                  var rowData = _this3.props.rowGetter(i);
                  if (!RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, i)) {
                    selectedRows.push({
                      rowIdx: i,
                      row: rowData
                    });
                  }
                }
                if (selectedRows.length > 0) {
                  _this3.props.rowSelection.onRowsSelected(selectedRows);
                }
              } else if (!allRowsSelected && typeof _this3.props.rowSelection.onRowsDeselected === 'function') {
                var deselectedRows = [];
                for (var _i2 = 0; _i2 < _this3.props.rowsCount; _i2++) {
                  var _rowData = _this3.props.rowGetter(_i2);
                  if (RowUtils.isRowSelected(keys, indexes, isSelectedKey, _rowData, _i2)) {
                    deselectedRows.push({
                      rowIdx: _i2,
                      row: _rowData
                    });
                  }
                }
                if (deselectedRows.length > 0) {
                  _this3.props.rowSelection.onRowsDeselected(deselectedRows);
                }
              }
            } else {
              var _selectedRows = [];
              for (var _i3 = 0; _i3 < _this3.props.rowsCount; _i3++) {
                var row = Object.assign({}, _this3.props.rowGetter(_i3), {
                  isSelected: allRowsSelected
                });
                _selectedRows.push(row);
              }
              _this3.setState({
                selectedRows: _selectedRows
              });
              if (typeof _this3.props.onRowSelect === 'function') {
                _this3.props.onRowSelect(_selectedRows.filter(function (r) {
                  return r.isSelected === true;
                }));
              }
            }
          };
          this.getScrollOffSet = function () {
            var scrollOffset = 0;
            if (_this3.grid) {
              var canvas = _this3.grid.querySelector('.react-grid-Canvas');
              if (canvas) {
                scrollOffset = canvas.offsetWidth - canvas.clientWidth;
              }
            }
            _this3.setState({
              scrollOffset: scrollOffset
            });
          };
          this.getRowOffsetHeight = function () {
            var offsetHeight = 0;
            _this3.getHeaderRows().forEach(function (row) {
              return offsetHeight += parseFloat(row.height, 10);
            });
            return offsetHeight;
          };
          this.getHeaderRows = function () {
            var rows = [{
              ref: function ref(node) {
                return _this3.row = node;
              },
              height: _this3.props.headerRowHeight || _this3.props.rowHeight,
              rowType: 'header'
            }];
            if (_this3.state.canFilter === true) {
              rows.push({
                ref: function ref(node) {
                  return _this3.filterRow = node;
                },
                filterable: true,
                onFilterChange: _this3.props.onAddFilter,
                height: _this3.props.headerFiltersHeight,
                rowType: 'filter'
              });
            }
            return rows;
          };
          this.getInitialSelectedRows = function () {
            var selectedRows = [];
            for (var i = 0; i < _this3.props.rowsCount; i++) {
              selectedRows.push(false);
            }
            return selectedRows;
          };
          this.getRowSelectionProps = function () {
            if (_this3.props.rowSelection) {
              return _this3.props.rowSelection.selectBy;
            }
            return null;
          };
          this.getSelectedRows = function () {
            if (_this3.props.rowSelection) {
              return null;
            }
            return _this3.state.selectedRows.filter(function (r) {
              return r.isSelected === true;
            });
          };
          this.getSelectedValue = function () {
            var rowIdx = _this3.state.selected.rowIdx;
            var idx = _this3.state.selected.idx;
            var cellKey = _this3.getColumn(idx).key;
            var row = _this3.props.rowGetter(rowIdx);
            return RowUtils.get(row, cellKey);
          };
          this.canExitGrid = function (e) {
            // When the cellNavigationMode is 'none', you can exit the grid if you're at the start or end of the row
            // When the cellNavigationMode is 'changeRow', you can exit the grid if you're at the first or last cell of the grid
            // When the cellNavigationMode is 'loopOverRow', there is no logical exit point so you can't exit the grid
            var atLastCellInRow = _this3.isAtLastCellInRow(_this3.getNbrColumns());
            var atFirstCellInRow = _this3.isAtFirstCellInRow();
            var atLastRow = _this3.isAtLastRow();
            var atFirstRow = _this3.isAtFirstRow();
            var shift = e.shiftKey === true;
            var cellNavigationMode = _this3.props.cellNavigationMode;
            if (shift) {
              if (cellNavigationMode === 'none') {
                if (atFirstCellInRow) {
                  return true;
                }
              } else if (cellNavigationMode === 'changeRow') {
                if (atFirstCellInRow && atFirstRow) {
                  return true;
                }
              }
            } else {
              if (cellNavigationMode === 'none') {
                if (atLastCellInRow) {
                  return true;
                }
              } else if (cellNavigationMode === 'changeRow') {
                if (atLastCellInRow && atLastRow) {
                  return true;
                }
              }
            }
            return false;
          };
          this.moveSelectedCell = function (e, rowDelta, cellDelta) {
            // we need to prevent default as we control grid scroll
            // otherwise it moves every time you left/right which is janky
            e.preventDefault();
            var rowIdx = void 0;
            var idx = void 0;
            var cellNavigationMode = _this3.props.cellNavigationMode;
            if (cellNavigationMode !== 'none') {
              var _calculateNextSelecti = _this3.calculateNextSelectionPosition(cellNavigationMode, cellDelta, rowDelta);
              idx = _calculateNextSelecti.idx;
              rowIdx = _calculateNextSelecti.rowIdx;
            } else {
              rowIdx = _this3.state.selected.rowIdx + rowDelta;
              idx = _this3.state.selected.idx + cellDelta;
            }
            _this3.scrollToColumn(idx);
            _this3.onSelect({
              idx: idx,
              rowIdx: rowIdx
            });
          };
          this.getNbrColumns = function () {
            var _props = _this3.props,
              columns = _props.columns,
              enableRowSelect = _props.enableRowSelect;
            return enableRowSelect ? columns.length + 1 : columns.length;
          };
          this.getDataGridDOMNode = function () {
            return _this3.grid;
          };
          this.calculateNextSelectionPosition = function (cellNavigationMode, cellDelta, rowDelta) {
            var _rowDelta = rowDelta;
            var idx = _this3.state.selected.idx + cellDelta;
            var nbrColumns = _this3.getNbrColumns();
            if (cellDelta > 0) {
              if (_this3.isAtLastCellInRow(nbrColumns)) {
                if (cellNavigationMode === 'changeRow') {
                  _rowDelta = _this3.isAtLastRow() ? rowDelta : rowDelta + 1;
                  idx = _this3.isAtLastRow() ? idx : 0;
                } else {
                  idx = 0;
                }
              }
            } else if (cellDelta < 0) {
              if (_this3.isAtFirstCellInRow()) {
                if (cellNavigationMode === 'changeRow') {
                  _rowDelta = _this3.isAtFirstRow() ? rowDelta : rowDelta - 1;
                  idx = _this3.isAtFirstRow() ? 0 : nbrColumns - 1;
                } else {
                  idx = nbrColumns - 1;
                }
              }
            }
            var rowIdx = _this3.state.selected.rowIdx + _rowDelta;
            return {
              idx: idx,
              rowIdx: rowIdx
            };
          };
          this.isAtLastCellInRow = function (nbrColumns) {
            return _this3.state.selected.idx === nbrColumns - 1;
          };
          this.isAtLastRow = function () {
            return _this3.state.selected.rowIdx === _this3.props.rowsCount - 1;
          };
          this.isAtFirstCellInRow = function () {
            return _this3.state.selected.idx === 0;
          };
          this.isAtFirstRow = function () {
            return _this3.state.selected.rowIdx === 0;
          };
          this.openCellEditor = function (rowIdx, idx) {
            var row = _this3.props.rowGetter(rowIdx);
            var col = _this3.getColumn(idx);
            if (!ColumnUtils.canEdit(col, row, _this3.props.enableCellSelect)) {
              return;
            }
            var selected = {
              rowIdx: rowIdx,
              idx: idx
            };
            if (_this3.hasSelectedCellChanged(selected)) {
              _this3.setState({
                selected: selected
              }, function () {
                _this3.setActive('Enter');
              });
            } else {
              _this3.setActive('Enter');
            }
          };
          this.scrollToColumn = function (colIdx) {
            if (_this3.grid) {
              var canvas = _this3.grid.querySelector('.react-grid-Canvas');
              if (canvas) {
                var left = 0;
                var locked = 0;
                for (var i = 0; i < colIdx; i++) {
                  var column = _this3.getColumn(i);
                  if (column) {
                    if (column.width) {
                      left += column.width;
                    }
                    if (column.locked) {
                      locked += column.width;
                    }
                  }
                }
                var selectedColumn = _this3.getColumn(colIdx);
                if (selectedColumn) {
                  var scrollLeft = left - locked - canvas.scrollLeft;
                  var scrollRight = left + selectedColumn.width - canvas.scrollLeft;
                  if (scrollLeft < 0) {
                    canvas.scrollLeft += scrollLeft;
                  } else if (scrollRight > canvas.clientWidth) {
                    var scrollAmount = scrollRight - canvas.clientWidth;
                    canvas.scrollLeft += scrollAmount;
                  }
                }
              }
            }
          };
          this.deselect = function () {
            var selected = {
              rowIdx: -1,
              idx: -1
            };
            _this3.setState({
              selected: selected
            });
          };
          this.setActive = function (keyPressed) {
            var rowIdx = _this3.state.selected.rowIdx;
            var row = _this3.props.rowGetter(rowIdx);
            var idx = _this3.state.selected.idx;
            var column = _this3.getColumn(idx);
            if (ColumnUtils.canEdit(column, row, _this3.props.enableCellSelect) && !_this3.isActive()) {
              var selected = Object.assign({}, _this3.state.selected, {
                idx: idx,
                rowIdx: rowIdx,
                active: true,
                initialKeyCode: keyPressed
              });
              var showEditor = true;
              if (typeof _this3.props.onCheckCellIsEditable === 'function') {
                var args = Object.assign({}, {
                  row: row,
                  column: column
                }, selected);
                showEditor = _this3.props.onCheckCellIsEditable(args);
              }
              if (showEditor !== false) {
                if (column.locked) {
                  _this3.setState({
                    selected: selected
                  });
                } else {
                  _this3.setState({
                    selected: selected
                  }, function () {
                    _this3.scrollToColumn(idx);
                  });
                }
                _this3.props.onBeforeEdit();
                _this3.handleCancelCopy();
              }
            }
          };
          this.setInactive = function () {
            var rowIdx = _this3.state.selected.rowIdx;
            var row = _this3.props.rowGetter(rowIdx);
            var idx = _this3.state.selected.idx;
            var col = _this3.getColumn(idx);
            if (ColumnUtils.canEdit(col, row, _this3.props.enableCellSelect) && _this3.isActive()) {
              var selected = Object.assign({}, _this3.state.selected, {
                idx: idx,
                rowIdx: rowIdx,
                active: false
              });
              _this3.setState({
                selected: selected
              });
            }
          };
          this.isActive = function () {
            return _this3.state.selected.active === true;
          };
          this.setupGridColumns = function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props;
            var columns = props.columns;
            if (_this3._cachedColumns === columns) {
              return _this3._cachedComputedColumns;
            }
            _this3._cachedColumns = columns;
            var cols = columns.slice(0);
            var unshiftedCols = {};
            if (_this3.props.rowActionsCell || props.enableRowSelect && !_this3.props.rowSelection || props.rowSelection && props.rowSelection.showCheckbox !== false) {
              var SelectAllComponent = _this3.props.selectAllRenderer || _SelectAll2['default'];
              var SelectAllRenderer = React.createElement(SelectAllComponent, {
                onChange: _this3.handleCheckboxChange,
                inputRef: function inputRef(grid) {
                  return _this3.selectAllCheckbox = grid;
                }
              });
              var headerRenderer = props.enableRowSelect === 'single' ? null : SelectAllRenderer;
              var Formatter = _this3.props.rowActionsCell ? _this3.props.rowActionsCell : CheckboxEditor;
              var selectColumn = {
                key: 'select-row',
                name: '',
                formatter: React.createElement(Formatter, {
                  rowSelection: _this3.props.rowSelection
                }),
                onCellChange: _this3.handleRowSelect,
                filterable: false,
                headerRenderer: headerRenderer,
                width: 60,
                locked: true,
                getRowMetaData: function getRowMetaData(rowData) {
                  return rowData;
                },
                cellClass: _this3.props.rowActionsCell ? 'rdg-row-actions-cell' : ''
              };
              unshiftedCols = cols.unshift(selectColumn);
              cols = unshiftedCols > 0 ? cols : unshiftedCols;
            }
            _this3._cachedComputedColumns = cols;
            return _this3._cachedComputedColumns;
          };
          this.copyPasteEnabled = function () {
            return _this3.props.onCellCopyPaste !== null;
          };
          this.dragEnabled = function () {
            return _this3.props.onGridRowsUpdated !== undefined || _this3.props.onCellsDragged !== undefined;
          };
          this.renderToolbar = function () {
            var Toolbar = _this3.props.toolbar;
            var toolBarProps = {
              columns: _this3.props.columns,
              onToggleFilter: _this3.onToggleFilter,
              numberOfRows: _this3.props.rowsCount
            };
            if (React.isValidElement(Toolbar)) {
              return React.cloneElement(Toolbar, toolBarProps);
            } else if (isFunction(Toolbar)) {
              return React.createElement(Toolbar, toolBarProps);
            }
          };
        };
        module.exports = ReactDataGrid;

        /***/
      }, /* 120 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var Draggable = __webpack_require__(109);
        __webpack_require__(15);
        var style = {
          position: 'absolute',
          top: 0,
          right: 0,
          width: 6,
          height: '100%'
        };
        var ResizeHandle = function (_React$Component) {
          _inherits(ResizeHandle, _React$Component);
          function ResizeHandle() {
            _classCallCheck(this, ResizeHandle);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          ResizeHandle.prototype.render = function render() {
            return React.createElement(Draggable, _extends({}, this.props, {
              className: 'react-grid-HeaderCell__resizeHandle',
              style: style
            }));
          };
          return ResizeHandle;
        }(React.Component);
        module.exports = ResizeHandle;

        /***/
      }, /* 121 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _utils = __webpack_require__(53);
        var _utils2 = _interopRequireDefault(_utils);
        __webpack_require__(29);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var cellMetaDataShape = __webpack_require__(11);
        var RowGroup = function (_Component) {
          _inherits(RowGroup, _Component);
          function RowGroup(props) {
            _classCallCheck(this, RowGroup);
            var _this = _possibleConstructorReturn(this, _Component.call(this, props));
            _this.onRowExpandToggle = _this.onRowExpandToggle.bind(_this);
            _this.onRowExpandClick = _this.onRowExpandClick.bind(_this);
            _this.setScrollLeft = _this.setScrollLeft.bind(_this);
            return _this;
          }
          RowGroup.prototype.onRowExpandToggle = function onRowExpandToggle(expand) {
            var shouldExpand = expand == null ? !this.props.isExpanded : expand;
            var meta = this.props.cellMetaData;
            if (meta != null && meta.onRowExpandToggle && typeof meta.onRowExpandToggle === 'function') {
              meta.onRowExpandToggle({
                rowIdx: this.props.idx,
                shouldExpand: shouldExpand,
                columnGroupName: this.props.columnGroupName,
                name: this.props.name
              });
            }
          };
          RowGroup.prototype.onRowExpandClick = function onRowExpandClick() {
            this.onRowExpandToggle(!this.props.isExpanded);
          };
          RowGroup.prototype.setScrollLeft = function setScrollLeft(scrollLeft) {
            if (this.rowGroupRenderer) {
              this.rowGroupRenderer.setScrollLeft ? this.rowGroupRenderer.setScrollLeft(scrollLeft) : null;
            }
          };
          RowGroup.prototype.render = function render() {
            var _this2 = this;
            var lastColumn = _utils2['default'].last(this.props.columns);
            var style = {
              width: lastColumn.left + lastColumn.width
            };
            return _react2['default'].createElement('div', {
              style: style,
              className: 'react-grid-row-group'
            }, _react2['default'].createElement(this.props.renderer, _extends({
              ref: function ref(node) {
                _this2.rowGroupRenderer = node;
              }
            }, this.props, {
              onRowExpandClick: this.onRowExpandClick,
              onRowExpandToggle: this.onRowExpandToggle
            })));
          };
          return RowGroup;
        }(_react.Component);
        RowGroup.propTypes = {
          height: _propTypes2['default'].number.isRequired,
          columns: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]).isRequired,
          row: _propTypes2['default'].any.isRequired,
          cellRenderer: _propTypes2['default'].func,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
          isSelected: _propTypes2['default'].bool,
          idx: _propTypes2['default'].number.isRequired,
          expandedRows: _propTypes2['default'].arrayOf(_propTypes2['default'].object),
          extraClasses: _propTypes2['default'].string,
          forceUpdate: _propTypes2['default'].bool,
          subRowDetails: _propTypes2['default'].object,
          isRowHovered: _propTypes2['default'].bool,
          colVisibleStart: _propTypes2['default'].number.isRequired,
          colVisibleEnd: _propTypes2['default'].number.isRequired,
          colDisplayStart: _propTypes2['default'].number.isRequired,
          colDisplayEnd: _propTypes2['default'].number.isRequired,
          isScrolling: _propTypes2['default'].bool.isRequired,
          columnGroupName: _propTypes2['default'].string.isRequired,
          isExpanded: _propTypes2['default'].bool.isRequired,
          treeDepth: _propTypes2['default'].number.isRequired,
          name: _propTypes2['default'].string.isRequired,
          renderer: _propTypes2['default'].func
        };
        var DefaultRowGroupRenderer = function DefaultRowGroupRenderer(props) {
          var treeDepth = props.treeDepth || 0;
          var marginLeft = treeDepth * 20;
          var style = {
            height: '50px',
            border: '1px solid #dddddd',
            paddingTop: '15px',
            paddingLeft: '5px'
          };
          var onKeyDown = function onKeyDown(e) {
            if (e.key === 'ArrowLeft') {
              props.onRowExpandToggle(false);
            }
            if (e.key === 'ArrowRight') {
              props.onRowExpandToggle(true);
            }
            if (e.key === 'Enter') {
              props.onRowExpandToggle(!props.isExpanded);
            }
          };
          return _react2['default'].createElement('div', {
            style: style,
            onKeyDown: onKeyDown,
            tabIndex: 0
          }, _react2['default'].createElement('span', {
            className: 'row-expand-icon',
            style: {
              float: 'left',
              marginLeft: marginLeft,
              cursor: 'pointer'
            },
            onClick: props.onRowExpandClick
          }, props.isExpanded ? String.fromCharCode('9660') : String.fromCharCode('9658')), _react2['default'].createElement('strong', null, props.columnGroupName, ': ', props.name));
        };
        DefaultRowGroupRenderer.propTypes = {
          onRowExpandClick: _propTypes2['default'].func.isRequired,
          onRowExpandToggle: _propTypes2['default'].func.isRequired,
          isExpanded: _propTypes2['default'].bool.isRequired,
          treeDepth: _propTypes2['default'].number.isRequired,
          name: _propTypes2['default'].string.isRequired,
          columnGroupName: _propTypes2['default'].string.isRequired,
          hideColumnName: _propTypes2['default'].bool
        };
        RowGroup.defaultProps = {
          renderer: DefaultRowGroupRenderer
        };
        exports['default'] = RowGroup;

        /***/
      }, /* 122 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _ColumnUtils = __webpack_require__(6);
        var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);
        var _viewportUtils = __webpack_require__(137);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var Canvas = __webpack_require__(104);
        var cellMetaDataShape = __webpack_require__(11);
        var Viewport = function (_React$Component) {
          _inherits(Viewport, _React$Component);
          function Viewport() {
            var _temp, _this, _ret;
            _classCallCheck(this, Viewport);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = (0, _viewportUtils.getGridState)(_this.props), _this.onScroll = function (scroll) {
              _this.updateScroll(scroll.scrollTop, scroll.scrollLeft, _this.state.height, _this.props.rowHeight, _this.props.rowsCount);
              if (_this.props.onScroll) {
                _this.props.onScroll({
                  scrollTop: scroll.scrollTop,
                  scrollLeft: scroll.scrollLeft
                });
              }
            }, _this.getScroll = function () {
              return _this.canvas.getScroll();
            }, _this.setScrollLeft = function (scrollLeft) {
              _this.canvas.setScrollLeft(scrollLeft);
            }, _this.getDOMNodeOffsetWidth = function () {
              return _this.viewport ? _this.viewport.offsetWidth : 0;
            }, _this.clearScrollTimer = function () {
              if (_this.resetScrollStateTimeoutId) {
                clearTimeout(_this.resetScrollStateTimeoutId);
              }
            }, _this.resetScrollStateAfterDelay = function () {
              _this.clearScrollTimer();
              _this.resetScrollStateTimeoutId = setTimeout(_this.resetScrollStateAfterDelayCallback, 500);
            }, _this.resetScrollStateAfterDelayCallback = function () {
              _this.resetScrollStateTimeoutId = null;
              _this.setState({
                isScrolling: false
              });
            }, _this.updateScroll = function (scrollTop, scrollLeft, height, rowHeight, length, width) {
              _this.resetScrollStateAfterDelay();
              var nextScrollState = (0, _viewportUtils.getNextScrollState)(_this.props, _this.getDOMNodeOffsetWidth, scrollTop, scrollLeft, height, rowHeight, length, width);
              _this.setState(nextScrollState);
            }, _this.metricsUpdated = function () {
              var height = _this.viewportHeight();
              var width = _this.viewportWidth();
              if (height) {
                _this.updateScroll(_this.state.scrollTop, _this.state.scrollLeft, height, _this.props.rowHeight, _this.props.rowsCount, width);
              }
            }, _this.viewportHeight = function () {
              return _this.viewport ? _this.viewport.offsetHeight : 0;
            }, _this.viewportWidth = function () {
              return _this.viewport ? _this.viewport.offsetWidth : 0;
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Viewport.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.rowHeight !== nextProps.rowHeight || this.props.minHeight !== nextProps.minHeight) {
              var newState = (0, _viewportUtils.getGridState)(nextProps);
              this.updateScroll(newState.scrollTop, newState.scrollLeft, newState.height, nextProps.rowHeight, nextProps.rowsCount);
            } else if (_ColumnUtils2['default'].getSize(this.props.columnMetrics.columns) !== _ColumnUtils2['default'].getSize(nextProps.columnMetrics.columns)) {
              this.setState((0, _viewportUtils.getGridState)(nextProps));
            } else if (this.props.rowsCount !== nextProps.rowsCount) {
              this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height, nextProps.rowHeight, nextProps.rowsCount);
              // Added to fix the hiding of the bottom scrollbar when showing the filters.
            } else if (this.props.rowOffsetHeight !== nextProps.rowOffsetHeight) {
              // The value of height can be positive or negative and will be added to the current height to cater for changes in the header height (due to the filer)
              var height = this.props.rowOffsetHeight - nextProps.rowOffsetHeight;
              this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height + height, nextProps.rowHeight, nextProps.rowsCount);
            }
          };
          Viewport.prototype.componentDidMount = function componentDidMount() {
            if (window.addEventListener) {
              window.addEventListener('resize', this.metricsUpdated);
            } else {
              window.attachEvent('resize', this.metricsUpdated);
            }
            this.metricsUpdated();
          };
          Viewport.prototype.componentWillUnmount = function componentWillUnmount() {
            window.removeEventListener('resize', this.metricsUpdated);
            this.clearScrollTimer();
          };
          Viewport.prototype.render = function render() {
            var _this2 = this;
            var style = {
              padding: 0,
              bottom: 0,
              left: 0,
              right: 0,
              overflow: 'hidden',
              position: 'absolute',
              top: this.props.rowOffsetHeight
            };
            return React.createElement('div', {
              className: 'react-grid-Viewport',
              style: style,
              ref: function ref(node) {
                _this2.viewport = node;
              }
            }, React.createElement(Canvas, {
              ref: function ref(node) {
                return _this2.canvas = node;
              },
              rowKey: this.props.rowKey,
              totalWidth: this.props.totalWidth,
              width: this.props.columnMetrics.width,
              rowGetter: this.props.rowGetter,
              rowsCount: this.props.rowsCount,
              selectedRows: this.props.selectedRows,
              expandedRows: this.props.expandedRows,
              columns: this.props.columnMetrics.columns,
              rowRenderer: this.props.rowRenderer,
              displayStart: this.state.displayStart,
              displayEnd: this.state.displayEnd,
              visibleStart: this.state.visibleStart,
              visibleEnd: this.state.visibleEnd,
              colVisibleStart: this.state.colVisibleStart,
              colVisibleEnd: this.state.colVisibleEnd,
              colDisplayStart: this.state.colDisplayStart,
              colDisplayEnd: this.state.colDisplayEnd,
              cellMetaData: this.props.cellMetaData,
              height: this.state.height,
              rowHeight: this.props.rowHeight,
              onScroll: this.onScroll,
              onRows: this.props.onRows,
              rowScrollTimeout: this.props.rowScrollTimeout,
              scrollToRowIndex: this.props.scrollToRowIndex,
              contextMenu: this.props.contextMenu,
              rowSelection: this.props.rowSelection,
              getSubRowDetails: this.props.getSubRowDetails,
              rowGroupRenderer: this.props.rowGroupRenderer,
              isScrolling: this.state.isScrolling || false
            }));
          };
          return Viewport;
        }(React.Component);
        Viewport.displayName = 'Viewport';
        Viewport.propTypes = {
          rowOffsetHeight: _propTypes2['default'].number.isRequired,
          totalWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]).isRequired,
          columnMetrics: _propTypes2['default'].object.isRequired,
          rowGetter: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].func]).isRequired,
          selectedRows: _propTypes2['default'].array,
          rowSelection: _propTypes2['default'].oneOfType([_propTypes2['default'].shape({
            indexes: _propTypes2['default'].arrayOf(_propTypes2['default'].number).isRequired
          }), _propTypes2['default'].shape({
            isSelectedKey: _propTypes2['default'].string.isRequired
          }), _propTypes2['default'].shape({
            keys: _propTypes2['default'].shape({
              values: _propTypes2['default'].array.isRequired,
              rowKey: _propTypes2['default'].string.isRequired
            }).isRequired
          })]),
          expandedRows: _propTypes2['default'].array,
          rowRenderer: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].func]),
          rowsCount: _propTypes2['default'].number.isRequired,
          rowHeight: _propTypes2['default'].number.isRequired,
          onRows: _propTypes2['default'].func,
          onScroll: _propTypes2['default'].func,
          minHeight: _propTypes2['default'].number,
          cellMetaData: _propTypes2['default'].shape(cellMetaDataShape),
          rowKey: _propTypes2['default'].string.isRequired,
          rowScrollTimeout: _propTypes2['default'].number,
          scrollToRowIndex: _propTypes2['default'].number,
          contextMenu: _propTypes2['default'].element,
          getSubRowDetails: _propTypes2['default'].func,
          rowGroupRenderer: _propTypes2['default'].func
        };
        Viewport.defaultProps = {
          rowHeight: 30
        };
        module.exports = Viewport;

        /***/
      }, /* 123 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var ExcelColumn = __webpack_require__(12);
        var FilterableHeaderCell = function (_React$Component) {
          _inherits(FilterableHeaderCell, _React$Component);
          function FilterableHeaderCell() {
            var _temp, _this, _ret;
            _classCallCheck(this, FilterableHeaderCell);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              filterTerm: ''
            }, _this.handleChange = function (e) {
              var val = e.target.value;
              _this.setState({
                filterTerm: val
              });
              _this.props.onChange({
                filterTerm: val,
                column: _this.props.column
              });
            }, _this.renderInput = function () {
              if (_this.props.column.filterable === false) {
                return React.createElement('span', null);
              }
              var inputKey = 'header-filter-' + _this.props.column.key;
              return React.createElement('input', {
                key: inputKey,
                type: 'text',
                className: 'form-control input-sm',
                placeholder: 'Search',
                value: _this.state.filterTerm,
                onChange: _this.handleChange
              });
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          FilterableHeaderCell.prototype.render = function render() {
            return React.createElement('div', null, React.createElement('div', {
              className: 'form-group'
            }, this.renderInput()));
          };
          return FilterableHeaderCell;
        }(React.Component);
        FilterableHeaderCell.propTypes = {
          onChange: _propTypes2['default'].func.isRequired,
          column: _propTypes2['default'].shape(ExcelColumn)
        };
        module.exports = FilterableHeaderCell;

        /***/
      }, /* 124 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _keyboardUtils = __webpack_require__(55);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var joinClasses = __webpack_require__(5);
        var SimpleTextEditor = __webpack_require__(49);
        var isFunction = __webpack_require__(19);
        __webpack_require__(20);
        var EditorContainer = function (_React$Component) {
          _inherits(EditorContainer, _React$Component);
          function EditorContainer() {
            var _temp, _this, _ret;
            _classCallCheck(this, EditorContainer);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
          }
          EditorContainer.prototype.componentDidMount = function componentDidMount() {
            var inputNode = this.getInputNode();
            if (inputNode !== undefined) {
              this.setTextInputFocus();
              if (!this.getEditor().disableContainerStyles) {
                inputNode.className += ' editor-main';
                inputNode.style.height = this.props.height - 1 + 'px';
              }
            }
          };
          EditorContainer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (!this.changeCommitted && !this.changeCanceled) {
              this.commit({
                key: 'Enter'
              });
            }
          };
          EditorContainer.prototype.render = function render() {
            return React.createElement('div', {
              className: this.getContainerClass(),
              onBlur: this.handleBlur,
              onKeyDown: this.onKeyDown,
              onContextMenu: this.handleRightClick
            }, this.createEditor(), this.renderStatusIcon());
          };
          return EditorContainer;
        }(React.Component);
        EditorContainer.displayName = 'EditorContainer';
        EditorContainer.propTypes = {
          rowIdx: _propTypes2['default'].number,
          rowData: _propTypes2['default'].object.isRequired,
          value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].object, _propTypes2['default'].bool]).isRequired,
          cellMetaData: _propTypes2['default'].shape({
            selected: _propTypes2['default'].object.isRequired,
            copied: _propTypes2['default'].object,
            dragged: _propTypes2['default'].object,
            onCellClick: _propTypes2['default'].func,
            onCellDoubleClick: _propTypes2['default'].func,
            onCommitCancel: _propTypes2['default'].func,
            onCommit: _propTypes2['default'].func
          }).isRequired,
          column: _propTypes2['default'].object.isRequired,
          height: _propTypes2['default'].number.isRequired,
          onGridKeyDown: _propTypes2['default'].func
        };
        var _initialiseProps = function _initialiseProps() {
          var _this2 = this;
          this.state = {
            isInvalid: false
          };
          this.changeCommitted = false;
          this.changeCanceled = false;
          this.isKeyExplicitlyHandled = function (key) {
            return isFunction(_this2['onPress' + key]);
          };
          this.checkAndCall = function (methodName, args) {
            if (isFunction(_this2[methodName])) {
              _this2[methodName](args);
            }
          };
          this.onKeyDown = function (e) {
            if ((0, _keyboardUtils.isCtrlKeyHeldDown)(e)) {
              _this2.checkAndCall('onPressKeyWithCtrl', e);
            } else if (_this2.isKeyExplicitlyHandled(e.key)) {
              // break up individual keyPress events to have their own specific callbacks
              var callBack = 'onPress' + e.key;
              _this2.checkAndCall(callBack, e);
            } else if ((0, _keyboardUtils.isKeyPrintable)(e.keyCode)) {
              _this2.checkAndCall('onPressChar', e);
            }

            // Track which keys are currently down for shift clicking etc
            _this2._keysDown = _this2._keysDown || {};
            _this2._keysDown[e.keyCode] = true;
            if (isFunction(_this2.props.onGridKeyDown)) {
              _this2.props.onGridKeyDown(e);
            }
          };
          this.createEditorRef = function (ref) {
            _this2.editor = ref;
          };
          this.createEditor = function () {
            var editorProps = {
              ref: _this2.createEditorRef,
              column: _this2.props.column,
              value: _this2.getInitialValue(),
              onCommit: _this2.commit,
              onCommitCancel: _this2.commitCancel,
              rowMetaData: _this2.getRowMetaData(),
              rowData: _this2.props.rowData,
              height: _this2.props.height,
              onBlur: _this2.commit,
              onOverrideKeyDown: _this2.onKeyDown
            };
            var CustomEditor = _this2.props.column.editor;
            // return custom column editor or SimpleEditor if none specified
            if (React.isValidElement(CustomEditor)) {
              return React.cloneElement(CustomEditor, editorProps);
            }
            if (isFunction(CustomEditor)) {
              return React.createElement(CustomEditor, _extends({
                ref: _this2.createEditorRef
              }, editorProps));
            }
            return React.createElement(SimpleTextEditor, {
              ref: _this2.createEditorRef,
              column: _this2.props.column,
              value: _this2.getInitialValue(),
              onBlur: _this2.commit,
              rowMetaData: _this2.getRowMetaData(),
              onKeyDown: function onKeyDown() {},
              commit: function commit() {}
            });
          };
          this.onPressEnter = function () {
            _this2.commit({
              key: 'Enter'
            });
          };
          this.onPressTab = function () {
            _this2.commit({
              key: 'Tab'
            });
          };
          this.onPressEscape = function (e) {
            if (!_this2.editorIsSelectOpen()) {
              _this2.commitCancel();
            } else {
              // prevent event from bubbling if editor has results to select
              e.stopPropagation();
            }
          };
          this.onPressArrowDown = function (e) {
            if (_this2.editorHasResults()) {
              // dont want to propogate as that then moves us round the grid
              e.stopPropagation();
            } else {
              _this2.commit(e);
            }
          };
          this.onPressArrowUp = function (e) {
            if (_this2.editorHasResults()) {
              // dont want to propogate as that then moves us round the grid
              e.stopPropagation();
            } else {
              _this2.commit(e);
            }
          };
          this.onPressArrowLeft = function (e) {
            // prevent event propogation. this disables left cell navigation
            if (!_this2.isCaretAtBeginningOfInput()) {
              e.stopPropagation();
            } else {
              _this2.commit(e);
            }
          };
          this.onPressArrowRight = function (e) {
            // prevent event propogation. this disables right cell navigation
            if (!_this2.isCaretAtEndOfInput()) {
              e.stopPropagation();
            } else {
              _this2.commit(e);
            }
          };
          this.editorHasResults = function () {
            if (isFunction(_this2.getEditor().hasResults)) {
              return _this2.getEditor().hasResults();
            }
            return false;
          };
          this.editorIsSelectOpen = function () {
            if (isFunction(_this2.getEditor().isSelectOpen)) {
              return _this2.getEditor().isSelectOpen();
            }
            return false;
          };
          this.getRowMetaData = function () {
            // clone row data so editor cannot actually change this
            // convention based method to get corresponding Id or Name of any Name or Id property
            if (typeof _this2.props.column.getRowMetaData === 'function') {
              return _this2.props.column.getRowMetaData(_this2.props.rowData, _this2.props.column);
            }
          };
          this.getEditor = function () {
            return _this2.editor;
          };
          this.getInputNode = function () {
            return _this2.getEditor().getInputNode();
          };
          this.getInitialValue = function () {
            var selected = _this2.props.cellMetaData.selected;
            var keyCode = selected.initialKeyCode;
            if (keyCode === 'Delete' || keyCode === 'Backspace') {
              return '';
            } else if (keyCode === 'Enter') {
              return _this2.props.value;
            }
            var text = keyCode ? String.fromCharCode(keyCode) : _this2.props.value;
            return text;
          };
          this.getContainerClass = function () {
            return joinClasses({
              'has-error': _this2.state.isInvalid === true
            });
          };
          this.commit = function (args) {
            var opts = args || {};
            var updated = _this2.getEditor().getValue();
            if (_this2.isNewValueValid(updated)) {
              _this2.changeCommitted = true;
              var cellKey = _this2.props.column.key;
              _this2.props.cellMetaData.onCommit({
                cellKey: cellKey,
                rowIdx: _this2.props.rowIdx,
                updated: updated,
                key: opts.key
              });
            }
          };
          this.commitCancel = function () {
            _this2.changeCanceled = true;
            _this2.props.cellMetaData.onCommitCancel();
          };
          this.isNewValueValid = function (value) {
            if (isFunction(_this2.getEditor().validate)) {
              var isValid = _this2.getEditor().validate(value);
              _this2.setState({
                isInvalid: !isValid
              });
              return isValid;
            }
            return true;
          };
          this.setCaretAtEndOfInput = function () {
            var input = _this2.getInputNode();
            // taken from http://stackoverflow.com/questions/511088/use-javascript-to-place-cursor-at-end-of-text-in-text-input-element
            var txtLength = input.value.length;
            if (input.setSelectionRange) {
              input.setSelectionRange(txtLength, txtLength);
            } else if (input.createTextRange) {
              var fieldRange = input.createTextRange();
              fieldRange.moveStart('character', txtLength);
              fieldRange.collapse();
              fieldRange.select();
            }
          };
          this.isCaretAtBeginningOfInput = function () {
            var inputNode = _this2.getInputNode();
            return inputNode.selectionStart === inputNode.selectionEnd && inputNode.selectionStart === 0;
          };
          this.isCaretAtEndOfInput = function () {
            var inputNode = _this2.getInputNode();
            return inputNode.selectionStart === inputNode.value.length;
          };
          this.isBodyClicked = function (e) {
            var relatedTarget = _this2.getRelatedTarget(e);
            return relatedTarget === null;
          };
          this.isViewportClicked = function (e) {
            var relatedTarget = _this2.getRelatedTarget(e);
            return relatedTarget.className.indexOf('react-grid-Viewport') > -1;
          };
          this.isClickInsideEditor = function (e) {
            var relatedTarget = _this2.getRelatedTarget(e);
            return e.currentTarget.contains(relatedTarget) || relatedTarget.className.indexOf('editing') > -1 || relatedTarget.className.indexOf('react-grid-Cell') > -1;
          };
          this.getRelatedTarget = function (e) {
            return e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
          };

          this.handleRightClick = function (e) {
            e.stopPropagation();
          };
          this.handleBlur = function (e) {
            e.stopPropagation();
            if (_this2.isBodyClicked(e)) {
              _this2.commit(e);
            }
            if (!_this2.isBodyClicked(e)) {
              // prevent null reference
              if (_this2.isViewportClicked(e) || !_this2.isClickInsideEditor(e)) {
                _this2.commit(e);
              }
            }
          };
          this.setTextInputFocus = function () {
            var selected = _this2.props.cellMetaData.selected;
            var keyCode = selected.initialKeyCode;
            var inputNode = _this2.getInputNode();
            inputNode.focus();
            if (inputNode.tagName === 'INPUT') {
              if (!(0, _keyboardUtils.isKeyPrintable)(keyCode)) {
                inputNode.focus();
                inputNode.select();
              } else {
                inputNode.select();
              }
            }
          };
          this.renderStatusIcon = function () {
            if (_this2.state.isInvalid === true) {
              return React.createElement('span', {
                className: 'glyphicon glyphicon-remove form-control-feedback'
              });
            }
          };
        };
        module.exports = EditorContainer;

        /***/
      }, /* 125 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        module.exports = {
          CheckboxEditor: __webpack_require__(47),
          EditorBase: __webpack_require__(48),
          SimpleTextEditor: __webpack_require__(49)
        };

        /***/
      }, /* 126 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _reactDom = __webpack_require__(9);
        var _reactDom2 = _interopRequireDefault(_reactDom);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        } /* eslint-disable react/prop-types */

        var focusableComponentWrapper = function focusableComponentWrapper(WrappedComponent) {
          return function (_Component) {
            _inherits(ComponentWrapper, _Component);
            function ComponentWrapper() {
              _classCallCheck(this, ComponentWrapper);
              var _this = _possibleConstructorReturn(this, _Component.call(this));
              _this.checkFocus = _this.checkFocus.bind(_this);
              _this.state = {
                isScrolling: false
              };
              return _this;
            }
            ComponentWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
              return WrappedComponent.isSelected(this.props) !== WrappedComponent.isSelected(nextProps);
            };
            ComponentWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
              var isScrolling = WrappedComponent.isScrolling(nextProps);
              if (isScrolling && !this.state.isScrolling) {
                this.setState({
                  isScrolling: isScrolling
                });
              }
            };
            ComponentWrapper.prototype.componentDidMount = function componentDidMount() {
              this.checkFocus();
            };
            ComponentWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
              this.checkFocus();
            };
            ComponentWrapper.prototype.checkFocus = function checkFocus() {
              if (WrappedComponent.isSelected(this.props) && this.state.isScrolling) {
                this.focus();
                this.setState({
                  isScrolling: false
                });
              }
            };
            ComponentWrapper.prototype.focus = function focus() {
              _reactDom2['default'].findDOMNode(this).focus();
            };
            ComponentWrapper.prototype.render = function render() {
              return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, this.state));
            };
            return ComponentWrapper;
          }(_react.Component);
        };
        exports['default'] = focusableComponentWrapper;

        /***/
      }, /* 127 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        module.exports = {
          SimpleCellFormatter: __webpack_require__(51),
          SelectAll: __webpack_require__(50)
        };

        /***/
      }, /* 128 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _GridPropHelpers = __webpack_require__(129);
        var _GridPropHelpers2 = _interopRequireDefault(_GridPropHelpers);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        module.exports = {
          test: {
            GridPropHelpers: _GridPropHelpers2['default']
          }
        };

        /***/
      }, /* 129 */
      /***/function (module, exports) {
        'use strict';

        var _rows = [];
        for (var i = 0; i < 1000; i++) {
          _rows.push({
            id: i,
            title: 'Title ' + i,
            count: i * 1000
          });
        }
        module.exports = {
          columns: [{
            key: 'id',
            name: 'ID',
            width: 100
          }, {
            key: 'title',
            name: 'Title',
            width: 100
          }, {
            key: 'count',
            name: 'Count',
            width: 100
          }],
          rowGetter: function rowGetter(i) {
            return _rows[i];
          },
          rowsCount: function rowsCount() {
            return _rows.length;
          },
          cellMetaData: {
            selected: {
              idx: 2,
              rowIdx: 3
            },
            dragged: null,
            copied: null
          }
        };

        /***/
      }, /* 130 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _RowComparer = __webpack_require__(43);
        var _RowComparer2 = _interopRequireDefault(_RowComparer);
        var _RowsContainer = __webpack_require__(45);
        var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var Grid = __webpack_require__(119);
        module.exports = Grid;
        module.exports.Row = __webpack_require__(42);
        module.exports.Cell = __webpack_require__(40);
        module.exports.HeaderCell = __webpack_require__(41);
        module.exports.RowComparer = _RowComparer2['default'];
        module.exports.EmptyChildRow = __webpack_require__(110);
        module.exports.RowsContainer = _RowsContainer2['default'];
        module.exports.editors = __webpack_require__(125);
        module.exports.formatters = __webpack_require__(127);
        module.exports.utils = __webpack_require__(53);
        module.exports.shapes = __webpack_require__(118);
        module.exports._constants = __webpack_require__(30);
        module.exports._helpers = __webpack_require__(128);

        /***/
      }, /* 131 */
      /***/function (module, exports) {
        "use strict";

        var isEmptyArray = function isEmptyArray(obj) {
          return Array.isArray(obj) && obj.length === 0;
        };
        module.exports = isEmptyArray;

        /***/
      }, /* 132 */
      /***/function (module, exports) {
        "use strict";

        function isEmpty(obj) {
          return Object.keys(obj).length === 0 && obj.constructor === Object;
        }
        module.exports = isEmpty;

        /***/
      }, /* 133 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _immutable = __webpack_require__(18);
        var isImmutableCollection = function isImmutableCollection(objToVerify) {
          return _immutable.Iterable.isIterable(objToVerify);
        };
        module.exports = isImmutableCollection;

        /***/
      }, /* 134 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _immutable = __webpack_require__(18);
        module.exports = _immutable.Map.isMap;

        /***/
      }, /* 135 */
      /***/function (module, exports) {
        "use strict";

        var getMixedTypeValueRetriever = function getMixedTypeValueRetriever(isImmutable) {
          var retObj = {};
          var retriever = function retriever(item, key) {
            return item[key];
          };
          var immutableRetriever = function immutableRetriever(immutable, key) {
            return immutable.get(key);
          };
          retObj.getValue = isImmutable ? immutableRetriever : retriever;
          return retObj;
        };
        module.exports = getMixedTypeValueRetriever;

        /***/
      }, /* 136 */
      /***/function (module, exports) {
        'use strict';

        exports.__esModule = true;
        function createScrollShim(size) {
          var shim = document.createElement('div');
          if (shim.classList) {
            shim.classList.add('react-grid-ScrollShim'); // flow - not compatible with HTMLElement
          } else {
            shim.className += ' react-grid-ScrollShim';
          }
          shim.style.position = 'absolute';
          shim.style.top = 0;
          shim.style.left = 0;
          shim.style.width = size.width + 'px';
          shim.style.height = size.height + 'px';
          return shim;
        }
        exports.createScrollShim = createScrollShim;

        /***/
      }, /* 137 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        exports.getRenderedColumnCount = exports.getNextScrollState = exports.getGridState = undefined;
        var _ColumnUtils = __webpack_require__(6);
        var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var min = Math.min;
        var max = Math.max;
        var floor = Math.floor;
        var ceil = Math.ceil;
        function getGridState(props) {
          var totalNumberColumns = _ColumnUtils2['default'].getSize(props.columnMetrics.columns);
          var canvasHeight = props.minHeight - props.rowOffsetHeight;
          var renderedRowsCount = ceil((props.minHeight - props.rowHeight) / props.rowHeight);
          var totalRowCount = min(renderedRowsCount * 4, props.rowsCount);
          return {
            displayStart: 0,
            displayEnd: totalRowCount,
            visibleStart: 0,
            visibleEnd: totalRowCount,
            height: canvasHeight,
            scrollTop: 0,
            scrollLeft: 0,
            colVisibleStart: 0,
            colVisibleEnd: totalNumberColumns,
            colDisplayStart: 0,
            colDisplayEnd: totalNumberColumns
          };
        }
        function getRenderedColumnCount(props, getDOMNodeOffsetWidth, displayStart, width) {
          var remainingWidth = width && width > 0 ? width : props.columnMetrics.totalWidth;
          if (remainingWidth === 0) {
            remainingWidth = getDOMNodeOffsetWidth();
          }
          var columnIndex = displayStart;
          var columnCount = 0;
          while (remainingWidth > 0) {
            var column = _ColumnUtils2['default'].getColumn(props.columnMetrics.columns, columnIndex);
            if (!column) {
              break;
            }
            columnCount++;
            columnIndex++;
            remainingWidth -= column.width;
          }
          return columnCount;
        }
        function getVisibleColStart(props, scrollLeft) {
          var remainingScroll = scrollLeft;
          var columnIndex = -1;
          while (remainingScroll >= 0) {
            columnIndex++;
            remainingScroll -= _ColumnUtils2['default'].getColumn(props.columnMetrics.columns, columnIndex).width;
          }
          return columnIndex;
        }
        function getNextScrollState(props, getDOMNodeOffsetWidth, scrollTop, scrollLeft, height, rowHeight, length, width) {
          var isScrolling = true;
          var renderedRowsCount = ceil(height / rowHeight);
          var visibleStart = max(0, floor(scrollTop / rowHeight));
          var visibleEnd = min(visibleStart + renderedRowsCount, length);
          var displayStart = max(0, visibleStart - props.overScan.rowsStart);
          var displayEnd = min(visibleEnd + props.overScan.rowsEnd, length);
          var totalNumberColumns = _ColumnUtils2['default'].getSize(props.columnMetrics.columns);
          var colVisibleStart = totalNumberColumns > 0 ? max(0, getVisibleColStart(props, scrollLeft)) : 0;
          var renderedColumnCount = getRenderedColumnCount(props, getDOMNodeOffsetWidth, colVisibleStart, width);
          var colVisibleEnd = renderedColumnCount !== 0 ? colVisibleStart + renderedColumnCount : totalNumberColumns;
          var colDisplayStart = max(0, colVisibleStart - props.overScan.colsStart);
          var colDisplayEnd = min(colVisibleEnd + props.overScan.colsEnd, totalNumberColumns);
          var nextScrollState = {
            visibleStart: visibleStart,
            visibleEnd: visibleEnd,
            displayStart: displayStart,
            displayEnd: displayEnd,
            height: height,
            scrollTop: scrollTop,
            scrollLeft: scrollLeft,
            colVisibleStart: colVisibleStart,
            colVisibleEnd: colVisibleEnd,
            colDisplayStart: colDisplayStart,
            colDisplayEnd: colDisplayEnd,
            isScrolling: isScrolling
          };
          return nextScrollState;
        }
        exports.getGridState = getGridState;
        exports.getNextScrollState = getNextScrollState;
        exports.getRenderedColumnCount = getRenderedColumnCount;

        /***/
      }, /* 138 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".react-grid-Cell{background-color:#fff;padding-left:8px;padding-right:8px;border-right:1px solid #eee;border-bottom:1px solid #ddd}.react-grid-Cell:focus{outline:2px solid #66afe9;outline-offset:-2px}.react-grid-Cell--locked:focus{z-index:100}.react-grid-Cell:focus .drag-handle{position:absolute;bottom:-5px;right:-4px;background:#66afe9;width:8px;height:8px;border:1px solid #fff;border-right:0;border-bottom:0;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Cell:not(.editing) .react-grid-Cell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.react-grid-Cell:not(.editing):not(.rdg-child-cell) .react-grid-Cell__value{position:relative;top:50%;transform:translateY(-50%)}.rdg-child-cell .react-grid-Cell__value{line-height:35px}.react-grid-Cell.readonly{background-color:#000}.react-grid-Cell.copied{background:rgba(0,0,255,.2)!important}.react-grid-Cell--locked:last-of-type{border-right:1px solid #ddd;box-shadow:none}.react-grid-Cell:hover:focus .drag-handle .glyphicon-arrow-down{display:\"block\"}.react-grid-Cell.is-dragged-over-down{border-right:1px dashed #000;border-left:1px dashed #000;border-bottom:1px dashed #000}.react-grid-Cell.is-dragged-over-up{border-right:1px dashed #000;border-left:1px dashed #000;border-top:1px dashed #000}.react-grid-Cell.is-dragged-over-up .drag-handle{top:-5px}.react-grid-Cell:hover{background:#eee}.react-grid-cell .form-control-feedback{color:#a94442;position:absolute;top:0;right:10px;z-index:1000000;display:block;width:34px;height:34px}.react-grid-Cell.was-dragged-over{border-right:1px dashed #000;border-left:1px dashed #000}.react-grid-Cell:hover:focus .drag-handle{position:absolute;bottom:-8px;right:-7px;background:#fff;width:16px;height:16px;border:1px solid #66afe9;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Row.row-selected .react-grid-Cell{background-color:#dbecfa}.react-grid-Cell.editing{padding:0;overflow:visible!important}.react-grid-Cell--locked.editing{z-index:100}.react-grid-Cell.editing .has-error input{border:2px solid red!important;border-radius:2px!important}.react-grid-Cell__value ul{margin-top:0;margin-bottom:0;display:inline-block}.react-grid-Cell__value .btn-sm{padding:0}.cell-tooltip{position:relative;display:inline-block}.cell-tooltip:hover{z-index:101}.cell-tooltip .cell-tooltip-text{visibility:hidden;width:150px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;bottom:-150%;left:50%;margin-left:-60px;opacity:1s}.cell-tooltip:hover .cell-tooltip-text{visibility:visible;opacity:.8}.cell-tooltip .cell-tooltip-text:after{content:\" \";position:absolute;bottom:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #000}.react-grid-Canvas.opaque .react-grid-Cell.cell-tooltip:hover .cell-tooltip-text{visibility:hidden}.rdg-cell-expand{top:0;right:20px;position:absolute;cursor:pointer}.rdg-child-row-action-cross-last:before,.rdg-child-row-action-cross:before,rdg-child-row-action-cross-last:after,rdg-child-row-action-cross:after{content:\"\";position:absolute;background:grey;height:50%}.rdg-child-row-action-cross:before{left:21px;width:1px;height:35px}.rdg-child-row-action-cross-last:before{left:21px;width:1px}.rdg-child-row-action-cross-last:after,.rdg-child-row-action-cross:after{top:50%;left:20px;height:1px;width:15px;content:\"\";position:absolute;background:grey}.rdg-child-row-action-cross:hover{background:red}.rdg-child-row-btn{position:absolute;cursor:pointer;border:1px solid grey;border-radius:14px;z-index:3;background:#fff}.rdg-child-row-btn div{font-size:12px;text-align:center;line-height:19px;color:grey;height:20px;width:20px;position:absolute;top:60%;left:53%;margin-top:-10px;margin-left:-10px}.rdg-empty-child-row:hover .glyphicon-plus-sign,.rdg-empty-child-row:hover a{color:green}.rdg-child-row-btn .glyphicon-remove-sign:hover{color:red}.last-column .cell-tooltip-text{right:100%;left:0!important}.rdg-cell-action{float:right;height:100%}.rdg-cell-action-last{margin-right:-8px}.rdg-cell-action-button{width:35px;height:100%;text-align:center;position:relative;display:table}.rdg-cell-action-button>span{display:table-cell;vertical-align:middle}.rdg-cell-action-button:hover{background-color:#fff}.rdg-cell-action-button-toggled{background-color:#fff;border-right:1px solid #ccc;border-left:1px solid #ccc}.rdg-cell-action-button-toggled:after{content:\"\";height:1px;position:absolute;bottom:-1px;left:0;right:0;background:inherit;z-index:10001}.rdg-cell-action-menu{position:absolute;top:100%;right:0;z-index:1000;float:left;min-width:160px;padding:5px 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc}.rdg-cell-action-menu>span{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.rdg-cell-action-menu>span:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}", ""]);

        // exports

        /***/
      }, /* 139 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".radio-custom,.react-grid-checkbox{opacity:0;position:absolute}.radio-custom,.radio-custom-label,.react-grid-checkbox,.react-grid-checkbox-label{display:inline-block;vertical-align:middle;cursor:pointer}.radio-custom-label,.react-grid-checkbox-label{position:relative}.radio-custom+.radio-custom-label:before,.react-grid-checkbox+.react-grid-checkbox-label:before{content:\"\";background:#fff;border:2px solid #ddd;display:inline-block;vertical-align:middle;width:20px;height:20px;text-align:center}.react-grid-checkbox:checked+.react-grid-checkbox-label:before{background:#005295;box-shadow:inset 0 0 0 4px #fff}.radio-custom:focus+.radio-custom-label,.react-grid-checkbox:focus+.react-grid-checkbox-label{outline:1px solid #ddd}.react-grid-HeaderCell input[type=checkbox]{z-index:99999}.react-grid-HeaderCell>.react-grid-checkbox-container{padding:0 10px;height:100%}.react-grid-HeaderCell>.react-grid-checkbox-container>.react-grid-checkbox-label{margin:0;position:relative;top:50%;transform:translateY(-50%)}.radio-custom+.radio-custom-label:before{border-radius:50%}.radio-custom:checked+.radio-custom-label:before{background:#ccc;box-shadow:inset 0 0 0 4px #fff}.checkbox-align{text-align:center}", ""]);

        // exports

        /***/
      }, /* 140 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".react-grid-Container{clear:both;margin-top:0;padding:0}.react-grid-Main{background-color:#fff;color:inherit;padding:0;outline:1px solid #e7eaec;clear:both}.react-grid-Grid{border:1px solid #ddd}.react-grid-Canvas,.react-grid-Grid{background-color:#fff}.react-grid-Cell input.editor-main,select.editor-main{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}input.editor-main:focus,select.editor-main:focus{border-color:#66afe9;border:2px solid #66afe9;background:#eee;border-radius:4px}.react-grid-Cell input.editor-main::-moz-placeholder,select.editor-main::-moz-placeholder{color:#999;opacity:1}.react-grid-Cell input.editor-main:-ms-input-placeholder,select.editor-main:-ms-input-placeholder{color:#999}.react-grid-Cell input.editor-main::-webkit-input-placeholder,select.editor-main::-webkit-input-placeholder{color:#999}.react-grid-Cell input.editor-main[disabled],.react-grid-Cell input.editor-main[readonly],fieldset[disabled] .react-grid-Cell input.editor-main,fieldset[disabled] select.editor-main,select.editor-main[disabled],select.editor-main[readonly]{cursor:not-allowed;background-color:#eee;opacity:1}textarea.react-grid-Cell input.editor-main,textareaselect.editor-main{height:auto}.react-grid-ScrollShim{z-index:10002}", ""]);

        // exports

        /***/
      }, /* 141 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".react-grid-Header{box-shadow:0 0 4px 0 #ddd;background:#f9f9f9}.react-grid-Header--resizing{cursor:ew-resize}.react-grid-HeaderCell,.react-grid-HeaderRow{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.react-grid-HeaderCell{background:#f9f9f9;padding:8px;font-weight:700;border-right:1px solid #ddd;border-bottom:1px solid #ddd}.react-grid-HeaderCell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-HeaderCell__resizeHandle:hover{cursor:ew-resize;background:#ddd}.react-grid-HeaderCell--locked:last-of-type{box-shadow:none}.react-grid-HeaderCell--resizing .react-grid-HeaderCell__resizeHandle{background:#ddd}.react-grid-HeaderCell__draggable{cursor:col-resize}.rdg-can-drop>.react-grid-HeaderCell{background:#ececec}.react-grid-HeaderCell .Select{max-height:30px;font-size:12px;font-weight:400}.react-grid-HeaderCell .Select-control{max-height:30px;border:1px solid #ccc;color:#555;border-radius:3px}.react-grid-HeaderCell .is-focused:not(.is-open)>.Select-control{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.react-grid-HeaderCell .Select-control .Select-placeholder{line-height:20px;color:#999;padding:4px}.react-grid-HeaderCell .Select-control .Select-input{max-height:28px;padding:4px;margin-left:0}.react-grid-HeaderCell .Select-control .Select-input input{padding:0;height:100%}.react-grid-HeaderCell .Select-control .Select-arrow-zone .Select-arrow{border-color:gray transparent transparent;border-width:4px 4px 2.5px}.react-grid-HeaderCell .Select-control .Select-value{padding:4px;line-height:20px!important}.react-grid-HeaderCell .Select--multi .Select-control .Select-value{padding:0;line-height:16px!important;max-height:20px}.react-grid-HeaderCell .Select--multi .Select-control .Select-value .Select-value-icon,.react-grid-HeaderCell .Select--multi .Select-control .Select-value .Select-value-label{max-height:20px}.react-grid-HeaderCell .Select-control .Select-value .Select-value-label{color:#555!important}.react-grid-HeaderCell .Select-menu-outer .Select-option{padding:4px;line-height:20px}.react-grid-HeaderCell .Select-menu-outer .Select-menu .Select-option.is-focused,.react-grid-HeaderCell .Select-menu-outer .Select-menu .Select-option.is-selected{color:#555}", ""]);

        // exports

        /***/
      }, /* 142 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".react-grid-Row.row-context-menu .react-grid-Cell,.react-grid-Row:hover .react-grid-Cell{background-color:#f9f9f9}.react-grid-Row:hover .rdg-row-index{display:none}.react-grid-Row:hover .rdg-actions-checkbox{display:block}.react-grid-Row:hover .rdg-drag-row-handle{cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab;width:12px;height:30px;margin-left:0;background-image:url(\"data:image/svg+xml;base64, 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\");background-repeat:no-repeat}.react-grid-Row.row-selected,.react-grid-Row .row-selected{background-color:#dbecfa}.react-grid-row-group .row-expand-icon:hover{color:#777}.react-grid-row-index{padding:0 18px}.rdg-row-index{display:block;text-align:center}.rdg-row-actions-cell{padding:0}.rdg-actions-checkbox{display:none;text-align:center}.rdg-actions-checkbox.selected{display:block}.rdg-dragging{cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.rdg-dragged-row{border-bottom:1px solid #000}", ""]);

        // exports

        /***/
      }, /* 143 */
      /***/function (module, exports) {
        "use strict";

        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         * 
         */
        function makeEmptyFunction(arg) {
          return function () {
            return arg;
          };
        }

        /**
         * This function accepts and discards inputs; it has no side effects. This is
         * primarily useful idiomatically for overridable function endpoints which
         * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
         */
        var emptyFunction = function emptyFunction() {};
        emptyFunction.thatReturns = makeEmptyFunction;
        emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
        emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
        emptyFunction.thatReturnsNull = makeEmptyFunction(null);
        emptyFunction.thatReturnsThis = function () {
          return this;
        };
        emptyFunction.thatReturnsArgument = function (arg) {
          return arg;
        };
        module.exports = emptyFunction;

        /***/
      }, /* 144 */
      /***/function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         */

        'use strict';

        /**
         * Use invariant() to assert state which your program assumes to be true.
         *
         * Provide sprintf-style format (only %s is supported) and arguments
         * to provide information about what broke and what you were
         * expecting.
         *
         * The invariant message will be stripped in production, but the invariant
         * will remain to ensure logic does not differ in production.
         */
        var validateFormat = function validateFormat(format) {};
        if (false) {}
        function invariant(condition, format, a, b, c, d, e, f) {
          validateFormat(format);
          if (!condition) {
            var error;
            if (format === undefined) {
              error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
            } else {
              var args = [a, b, c, d, e, f];
              var argIndex = 0;
              error = new Error(format.replace(/%s/g, function () {
                return args[argIndex++];
              }));
              error.name = 'Invariant Violation';
            }
            error.framesToPop = 1; // we don't care about invariant's own frame
            throw error;
          }
        }
        module.exports = invariant;

        /***/
      }, /* 145 */
      /***/function (module, exports) {
        /**
         * Copyright 2013-2014 Facebook, Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         *
         */

        "use strict";

        /**
         * Constructs an enumeration with keys equal to their value.
         *
         * For example:
         *
         *   var COLORS = keyMirror({blue: null, red: null});
         *   var myColor = COLORS.blue;
         *   var isColorValid = !!COLORS[myColor];
         *
         * The last line could not be performed if the values of the generated enum were
         * not equal to their keys.
         *
         *   Input:  {key1: val1, key2: val2}
         *   Output: {key1: key1, key2: key2}
         *
         * @param {object} obj
         * @return {object}
         */
        var keyMirror = function (obj) {
          var ret = {};
          var key;
          if (!(obj instanceof Object && !Array.isArray(obj))) {
            throw new Error('keyMirror(...): Argument must be an object.');
          }
          for (key in obj) {
            if (!obj.hasOwnProperty(key)) {
              continue;
            }
            ret[key] = key;
          }
          return ret;
        };
        module.exports = keyMirror;

        /***/
      }, /* 146 */
      36, /* 147 */
      /***/function (module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        'use strict';

        var emptyFunction = __webpack_require__(143);
        var invariant = __webpack_require__(144);
        var ReactPropTypesSecret = __webpack_require__(148);
        module.exports = function () {
          function shim(props, propName, componentName, location, propFullName, secret) {
            if (secret === ReactPropTypesSecret) {
              // It is still safe when called from React.
              return;
            }
            invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          }
          ;
          shim.isRequired = shim;
          function getShim() {
            return shim;
          }
          ;
          // Important!
          // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
          var ReactPropTypes = {
            array: shim,
            bool: shim,
            func: shim,
            number: shim,
            object: shim,
            string: shim,
            symbol: shim,
            any: shim,
            arrayOf: getShim,
            element: shim,
            instanceOf: getShim,
            node: shim,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim
          };
          ReactPropTypes.checkPropTypes = emptyFunction;
          ReactPropTypes.PropTypes = ReactPropTypes;
          return ReactPropTypes;
        };

        /***/
      }, /* 148 */
      /***/function (module, exports) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        'use strict';

        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        module.exports = ReactPropTypesSecret;

        /***/
      }, /* 149 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _reselect = __webpack_require__(368);
        var _reactDataGrid = __webpack_require__(4);
        var isEmptyArray = _reactDataGrid.utils.isEmptyArray,
          isEmptyObject = _reactDataGrid.utils.isEmptyObject;
        var groupRows = __webpack_require__(217);
        var filterRows = __webpack_require__(216);
        var sortRows = __webpack_require__(219);
        var getInputRows = function getInputRows(state) {
          return state.rows;
        };
        var getFilters = function getFilters(state) {
          return state.filters;
        };
        var getFilteredRows = (0, _reselect.createSelector)([getFilters, getInputRows], function (filters) {
          var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          if (!filters || isEmptyObject(filters)) {
            return rows;
          }
          return filterRows(filters, rows);
        });
        var getSortColumn = function getSortColumn(state) {
          return state.sortColumn;
        };
        var getSortDirection = function getSortDirection(state) {
          return state.sortDirection;
        };
        var getSortedRows = (0, _reselect.createSelector)([getFilteredRows, getSortColumn, getSortDirection], function (rows, sortColumn, sortDirection) {
          if (!sortDirection && !sortColumn) {
            return rows;
          }
          return sortRows(rows, sortColumn, sortDirection);
        });
        var getGroupedColumns = function getGroupedColumns(state) {
          return state.groupBy;
        };
        var getExpandedRows = function getExpandedRows(state) {
          return state.expandedRows;
        };
        var getFlattenedGroupedRows = (0, _reselect.createSelector)([getSortedRows, getGroupedColumns, getExpandedRows], function (rows, groupedColumns) {
          var expandedRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (!groupedColumns || isEmptyObject(groupedColumns) || isEmptyArray(groupedColumns)) {
            return rows;
          }
          return groupRows(rows, groupedColumns, expandedRows);
        });
        var getSelectedKeys = function getSelectedKeys(state) {
          return state.selectedKeys;
        };
        var getRowKey = function getRowKey(state) {
          return state.rowKey;
        };
        var getSelectedRowsByKey = (0, _reselect.createSelector)([getRowKey, getSelectedKeys, getInputRows], function (rowKey, selectedKeys) {
          var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          return selectedKeys.map(function (k) {
            return rows.filter(function (r) {
              return r[rowKey] === k;
            })[0];
          });
        });
        var Selectors = {
          getRows: getFlattenedGroupedRows,
          getSelectedRowsByKey: getSelectedRowsByKey
        };
        module.exports = Selectors;

        /***/
      }, /* 150 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _reactDnd = __webpack_require__(23);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _reactDataGrid = __webpack_require__(4);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var DragItemTypes = _reactDataGrid._constants.DragItemTypes;
        var DraggableHeaderCell = function (_Component) {
          _inherits(DraggableHeaderCell, _Component);
          function DraggableHeaderCell() {
            _classCallCheck(this, DraggableHeaderCell);
            return _possibleConstructorReturn(this, _Component.apply(this, arguments));
          }
          DraggableHeaderCell.prototype.componentDidMount = function componentDidMount() {
            var connectDragPreview = this.props.connectDragPreview;
            var img = new Image();
            img.src = './assets/images/drag_column_full.png';
            img.onload = function () {
              connectDragPreview(img);
            };
          };
          DraggableHeaderCell.prototype.setScrollLeft = function setScrollLeft(scrollLeft) {
            var node = ReactDOM.findDOMNode(this);
            node.style.webkitTransform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
            node.style.transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
          };
          DraggableHeaderCell.prototype.render = function render() {
            var _props = this.props,
              connectDragSource = _props.connectDragSource,
              isDragging = _props.isDragging;
            if (isDragging) {
              return null;
            }
            return connectDragSource(_react2['default'].createElement('div', {
              style: {
                cursor: 'move'
              }
            }, _react2['default'].createElement(_reactDataGrid.HeaderCell, this.props)));
          };
          return DraggableHeaderCell;
        }(_react.Component);
        DraggableHeaderCell.propTypes = {
          connectDragSource: _propTypes2['default'].func.isRequired,
          connectDragPreview: _propTypes2['default'].func.isRequired,
          isDragging: _propTypes2['default'].bool.isRequired
        };
        function collect(connect, monitor) {
          return {
            connectDragSource: connect.dragSource(),
            isDragging: monitor.isDragging(),
            connectDragPreview: connect.dragPreview()
          };
        }
        var headerCellSource = {
          beginDrag: function beginDrag(props) {
            return props.column;
          },
          endDrag: function endDrag(props) {
            return props.column;
          }
        };
        exports['default'] = (0, _reactDnd.DragSource)(DragItemTypes.Column, headerCellSource, collect)(DraggableHeaderCell);

        /***/
      }, /* 151 */
      /***/function (module, exports) {
        'use strict';

        exports.__esModule = true;
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var OWNER_COMPONENT_KEY = 'Owner > component';
        var WASTED_TIME_KEY = 'Wasted time (ms)';
        var WASTED_INSTANCES_KEY = 'Instances';
        var SummaryItemModel = function () {
          function SummaryItemModel(summary) {
            _classCallCheck(this, SummaryItemModel);
            if ((typeof summary === 'undefined' ? 'undefined' : _typeof(summary)) === 'object') {
              this._createModel(summary);
            } else {
              this._createEmptyModel(summary);
            }
          }
          SummaryItemModel.prototype._createModel = function _createModel(summary) {
            var _getComponentAndOwner2 = this._getComponentAndOwner(summary),
              owner = _getComponentAndOwner2.owner,
              component = _getComponentAndOwner2.component;
            this.owner = owner;
            this.component = component;
            this.wastedInstances = summary[WASTED_INSTANCES_KEY];
            this.wastedTime = summary[WASTED_TIME_KEY];
          };
          SummaryItemModel.prototype._createEmptyModel = function _createEmptyModel(componentName) {
            this.owner = componentName;
            this.component = componentName;
            this.wastedInstances = 0;
            this.wastedTime = 0;
          };
          SummaryItemModel.prototype._getComponentAndOwner = function _getComponentAndOwner(summary) {
            var ownerAndComponent = summary[OWNER_COMPONENT_KEY];
            var splitOwnerComponent = ownerAndComponent.split('>');
            return {
              owner: splitOwnerComponent[0].trim(),
              component: splitOwnerComponent[1].trim()
            };
          };
          return SummaryItemModel;
        }();
        exports['default'] = SummaryItemModel;

        /***/
      }, /* 152 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _reactDnd = __webpack_require__(23);
        var _reactDndHtml5Backend = __webpack_require__(347);
        var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        exports['default'] = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2['default']);

        /***/
      }, /* 153 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = dirtyHandlerIds;
        exports.areDirty = areDirty;
        var _xor = __webpack_require__(337);
        var _xor2 = _interopRequireDefault(_xor);
        var _intersection = __webpack_require__(330);
        var _intersection2 = _interopRequireDefault(_intersection);
        var _dragDrop = __webpack_require__(56);
        var _registry = __webpack_require__(57);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var NONE = [];
        var ALL = [];
        function dirtyHandlerIds() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
          var action = arguments[1];
          var dragOperation = arguments[2];
          switch (action.type) {
            case _dragDrop.HOVER:
              break;
            case _registry.ADD_SOURCE:
            case _registry.ADD_TARGET:
            case _registry.REMOVE_TARGET:
            case _registry.REMOVE_SOURCE:
              return NONE;
            case _dragDrop.BEGIN_DRAG:
            case _dragDrop.PUBLISH_DRAG_SOURCE:
            case _dragDrop.END_DRAG:
            case _dragDrop.DROP:
            default:
              return ALL;
          }
          var targetIds = action.targetIds;
          var prevTargetIds = dragOperation.targetIds;
          var result = (0, _xor2.default)(targetIds, prevTargetIds);
          var didChange = false;
          if (result.length === 0) {
            for (var i = 0; i < targetIds.length; i++) {
              if (targetIds[i] !== prevTargetIds[i]) {
                didChange = true;
                break;
              }
            }
          } else {
            didChange = true;
          }
          if (!didChange) {
            return NONE;
          }
          var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
          var innermostTargetId = targetIds[targetIds.length - 1];
          if (prevInnermostTargetId !== innermostTargetId) {
            if (prevInnermostTargetId) {
              result.push(prevInnermostTargetId);
            }
            if (innermostTargetId) {
              result.push(innermostTargetId);
            }
          }
          return result;
        }
        function areDirty(state, handlerIds) {
          if (state === NONE) {
            return false;
          }
          if (state === ALL || typeof handlerIds === 'undefined') {
            return true;
          }
          return (0, _intersection2.default)(handlerIds, state).length > 0;
        }

        /***/
      }, /* 154 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        exports.default = dragOffset;
        exports.getSourceClientOffset = getSourceClientOffset;
        exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
        var _dragDrop = __webpack_require__(56);
        var initialState = {
          initialSourceClientOffset: null,
          initialClientOffset: null,
          clientOffset: null
        };
        function areOffsetsEqual(offsetA, offsetB) {
          if (offsetA === offsetB) {
            return true;
          }
          return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
        }
        function dragOffset() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments[1];
          switch (action.type) {
            case _dragDrop.BEGIN_DRAG:
              return {
                initialSourceClientOffset: action.sourceClientOffset,
                initialClientOffset: action.clientOffset,
                clientOffset: action.clientOffset
              };
            case _dragDrop.HOVER:
              if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
                return state;
              }
              return _extends({}, state, {
                clientOffset: action.clientOffset
              });
            case _dragDrop.END_DRAG:
            case _dragDrop.DROP:
              return initialState;
            default:
              return state;
          }
        }
        function getSourceClientOffset(state) {
          var clientOffset = state.clientOffset,
            initialClientOffset = state.initialClientOffset,
            initialSourceClientOffset = state.initialSourceClientOffset;
          if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
            return null;
          }
          return {
            x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
            y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
          };
        }
        function getDifferenceFromInitialOffset(state) {
          var clientOffset = state.clientOffset,
            initialClientOffset = state.initialClientOffset;
          if (!clientOffset || !initialClientOffset) {
            return null;
          }
          return {
            x: clientOffset.x - initialClientOffset.x,
            y: clientOffset.y - initialClientOffset.y
          };
        }

        /***/
      }, /* 155 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = matchesType;
        var _isArray = __webpack_require__(21);
        var _isArray2 = _interopRequireDefault(_isArray);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function matchesType(targetType, draggedItemType) {
          if ((0, _isArray2.default)(targetType)) {
            return targetType.some(function (t) {
              return t === draggedItemType;
            });
          } else {
            return targetType === draggedItemType;
          }
        }

        /***/
      }, /* 156 */
      [1551, 311, 312, 313, 314, 315], /* 157 */
      /***/function (module, exports) {
        /**
         * A faster alternative to `Function#apply`, this function invokes `func`
         * with the `this` binding of `thisArg` and the arguments of `args`.
         *
         * @private
         * @param {Function} func The function to invoke.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {Array} args The arguments to invoke `func` with.
         * @returns {*} Returns the result of `func`.
         */
        function apply(func, thisArg, args) {
          switch (args.length) {
            case 0:
              return func.call(thisArg);
            case 1:
              return func.call(thisArg, args[0]);
            case 2:
              return func.call(thisArg, args[0], args[1]);
            case 3:
              return func.call(thisArg, args[0], args[1], args[2]);
          }
          return func.apply(thisArg, args);
        }
        module.exports = apply;

        /***/
      }, /* 158 */
      [1570, 162], /* 159 */
      /***/function (module, exports, __webpack_require__) {
        var SetCache = __webpack_require__(83),
          arrayIncludes = __webpack_require__(85),
          arrayIncludesWith = __webpack_require__(86),
          arrayMap = __webpack_require__(87),
          baseUnary = __webpack_require__(88),
          cacheHas = __webpack_require__(89);

        /** Used as the size to enable large array optimizations. */
        var LARGE_ARRAY_SIZE = 200;

        /**
         * The base implementation of methods like `_.difference` without support
         * for excluding multiple arrays or iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Array} values The values to exclude.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         */
        function baseDifference(array, values, iteratee, comparator) {
          var index = -1,
            includes = arrayIncludes,
            isCommon = true,
            length = array.length,
            result = [],
            valuesLength = values.length;
          if (!length) {
            return result;
          }
          if (iteratee) {
            values = arrayMap(values, baseUnary(iteratee));
          }
          if (comparator) {
            includes = arrayIncludesWith;
            isCommon = false;
          } else if (values.length >= LARGE_ARRAY_SIZE) {
            includes = cacheHas;
            isCommon = false;
            values = new SetCache(values);
          }
          outer: while (++index < length) {
            var value = array[index],
              computed = iteratee == null ? value : iteratee(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result.push(value);
            } else if (!includes(values, computed, comparator)) {
              result.push(value);
            }
          }
          return result;
        }
        module.exports = baseDifference;

        /***/
      }, /* 160 */
      /***/function (module, exports, __webpack_require__) {
        var arrayPush = __webpack_require__(274),
          isFlattenable = __webpack_require__(301);

        /**
         * The base implementation of `_.flatten` with support for restricting flattening.
         *
         * @private
         * @param {Array} array The array to flatten.
         * @param {number} depth The maximum recursion depth.
         * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
         * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
         * @param {Array} [result=[]] The initial result value.
         * @returns {Array} Returns the new flattened array.
         */
        function baseFlatten(array, depth, predicate, isStrict, result) {
          var index = -1,
            length = array.length;
          predicate || (predicate = isFlattenable);
          result || (result = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                // Recursively flatten arrays (susceptible to call stack limits).
                baseFlatten(value, depth - 1, predicate, isStrict, result);
              } else {
                arrayPush(result, value);
              }
            } else if (!isStrict) {
              result[result.length] = value;
            }
          }
          return result;
        }
        module.exports = baseFlatten;

        /***/
      }, /* 161 */
      /***/function (module, exports, __webpack_require__) {
        var SetCache = __webpack_require__(83),
          arrayIncludes = __webpack_require__(85),
          arrayIncludesWith = __webpack_require__(86),
          cacheHas = __webpack_require__(89),
          createSet = __webpack_require__(291),
          setToArray = __webpack_require__(165);

        /** Used as the size to enable large array optimizations. */
        var LARGE_ARRAY_SIZE = 200;

        /**
         * The base implementation of `_.uniqBy` without support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         */
        function baseUniq(array, iteratee, comparator) {
          var index = -1,
            includes = arrayIncludes,
            length = array.length,
            isCommon = true,
            result = [],
            seen = result;
          if (comparator) {
            isCommon = false;
            includes = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set = iteratee ? null : createSet(array);
            if (set) {
              return setToArray(set);
            }
            isCommon = false;
            includes = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee ? [] : result;
          }
          outer: while (++index < length) {
            var value = array[index],
              computed = iteratee ? iteratee(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee) {
                seen.push(computed);
              }
              result.push(value);
            } else if (!includes(seen, computed, comparator)) {
              if (seen !== result) {
                seen.push(computed);
              }
              result.push(value);
            }
          }
          return result;
        }
        module.exports = baseUniq;

        /***/
      }, /* 162 */
      [1589, 61], /* 163 */
      /***/function (module, exports, __webpack_require__) {
        /** Detect free variable `global` from Node.js. */
        var freeGlobal = typeof window == 'object' && window && window.Object === Object && window;
        module.exports = freeGlobal;

        /***/
      }, /* 164 */
      /***/function (module, exports) {
        /** Used as references for various `Number` constants. */
        var MAX_SAFE_INTEGER = 9007199254740991;

        /** Used to detect unsigned integer values. */
        var reIsUint = /^(?:0|[1-9]\d*)$/;

        /**
         * Checks if `value` is a valid array-like index.
         *
         * @private
         * @param {*} value The value to check.
         * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
         * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
         */
        function isIndex(value, length) {
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        module.exports = isIndex;

        /***/
      }, /* 165 */
      /***/function (module, exports) {
        /**
         * Converts `set` to an array of its values.
         *
         * @private
         * @param {Object} set The set to convert.
         * @returns {Array} Returns the values.
         */
        function setToArray(set) {
          var index = -1,
            result = Array(set.size);
          set.forEach(function (value) {
            result[++index] = value;
          });
          return result;
        }
        module.exports = setToArray;

        /***/
      }, /* 166 */
      /***/function (module, exports) {
        /**
         * This method returns the first argument it receives.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {*} value Any value.
         * @returns {*} Returns `value`.
         * @example
         *
         * var object = { 'a': 1 };
         *
         * console.log(_.identity(object) === object);
         * // => true
         */
        function identity(value) {
          return value;
        }
        module.exports = identity;

        /***/
      }, /* 167 */
      [1652, 279, 35], /* 168 */
      [1661, 59, 34], /* 169 */
      99, /* 170 */
      /***/function (module, exports) {
        /**
         * This method returns `undefined`.
         *
         * @static
         * @memberOf _
         * @since 2.3.0
         * @category Util
         * @example
         *
         * _.times(2, _.noop);
         * // => [undefined, undefined]
         */
        function noop() {
          // No operation performed.
        }
        module.exports = noop;

        /***/
      }, /* 171 */
      /***/function (module, exports, __webpack_require__) {
        var baseDifference = __webpack_require__(159),
          baseRest = __webpack_require__(26),
          isArrayLikeObject = __webpack_require__(64);

        /**
         * Creates an array excluding all given values using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * **Note:** Unlike `_.pull`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...*} [values] The values to exclude.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.difference, _.xor
         * @example
         *
         * _.without([2, 1, 2, 3], 1, 2);
         * // => [3]
         */
        var without = baseRest(function (array, values) {
          return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        module.exports = without;

        /***/
      }, /* 172 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _MenuItem = __webpack_require__(174);
        var _MenuItem2 = _interopRequireDefault(_MenuItem);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var AbstractMenu = function (_Component) {
          _inherits(AbstractMenu, _Component);
          function AbstractMenu(props) {
            _classCallCheck(this, AbstractMenu);
            var _this = _possibleConstructorReturn(this, (AbstractMenu.__proto__ || Object.getPrototypeOf(AbstractMenu)).call(this, props));
            _initialiseProps.call(_this);
            _this.seletedItemRef = null;
            _this.state = {
              selectedItem: null,
              forceSubMenuOpen: false
            };
            return _this;
          }
          return AbstractMenu;
        }(_react.Component);
        AbstractMenu.propTypes = {
          children: _propTypes2.default.node.isRequired
        };
        var _initialiseProps = function _initialiseProps() {
          var _this2 = this;
          this.handleKeyNavigation = function (e) {
            // check for isVisible strictly here as it might be undefined when this code executes in the context of SubMenu
            // but we only need to check when it runs in the ContextMenu context
            if (_this2.state.isVisible === false) {
              return;
            }
            switch (e.keyCode) {
              case 37: // left arrow
              case 27:
                // escape
                e.preventDefault();
                _this2.hideMenu(e);
                break;
              case 38:
                // up arrow
                e.preventDefault();
                _this2.selectChildren(true);
                break;
              case 40:
                // down arrow
                e.preventDefault();
                _this2.selectChildren(false);
                break;
              case 39:
                // right arrow
                _this2.tryToOpenSubMenu(e);
                break;
              case 13:
                // enter
                e.preventDefault();
                _this2.tryToOpenSubMenu(e);
                {
                  // determine the selected item is disabled or not
                  var disabled = _this2.seletedItemRef && _this2.seletedItemRef.props && _this2.seletedItemRef.props.disabled;
                  if (_this2.seletedItemRef && _this2.seletedItemRef.ref instanceof HTMLElement && !disabled) {
                    _this2.seletedItemRef.ref.click();
                  } else {
                    _this2.hideMenu(e);
                  }
                }
                break;
              default:
              // do nothing
            }
          };

          this.handleForceClose = function () {
            _this2.setState({
              forceSubMenuOpen: false
            });
          };
          this.tryToOpenSubMenu = function (e) {
            if (_this2.state.selectedItem && _this2.state.selectedItem.type === _this2.getSubMenuType()) {
              e.preventDefault();
              _this2.setState({
                forceSubMenuOpen: true
              });
            }
          };
          this.selectChildren = function (forward) {
            var selectedItem = _this2.state.selectedItem;
            var children = [];
            var childCollector = function childCollector(child) {
              // child can be empty in case you do conditional rendering of components, in which
              // case it should not be accounted for as a real child
              if (!child) {
                return;
              }
              if ([_MenuItem2.default, _this2.getSubMenuType()].indexOf(child.type) < 0) {
                // Maybe the MenuItem or SubMenu is capsuled in a wrapper div or something else
                _react2.default.Children.forEach(child.props.children, childCollector);
              } else if (!child.props.divider) {
                children.push(child);
              }
            };
            _react2.default.Children.forEach(_this2.props.children, childCollector);
            var currentIndex = children.indexOf(selectedItem);
            if (currentIndex < 0) {
              _this2.setState({
                selectedItem: forward ? children[children.length - 1] : children[0],
                forceSubMenuOpen: false
              });
            } else if (forward) {
              _this2.setState({
                selectedItem: children[currentIndex - 1 < 0 ? children.length - 1 : currentIndex - 1],
                forceSubMenuOpen: false
              });
            } else {
              _this2.setState({
                selectedItem: children[currentIndex + 1 < children.length ? currentIndex + 1 : 0],
                forceSubMenuOpen: false
              });
            }
          };
          this.onChildMouseMove = function (child) {
            if (_this2.state.selectedItem !== child) {
              _this2.setState({
                selectedItem: child,
                forceSubMenuOpen: false
              });
            }
          };
          this.onChildMouseLeave = function () {
            _this2.setState({
              selectedItem: null,
              forceSubMenuOpen: false
            });
          };
          this.renderChildren = function (children) {
            return _react2.default.Children.map(children, function (child) {
              var props = {};
              if (!_react2.default.isValidElement(child)) return child;
              if ([_MenuItem2.default, _this2.getSubMenuType()].indexOf(child.type) < 0) {
                // Maybe the MenuItem or SubMenu is capsuled in a wrapper div or something else
                props.children = _this2.renderChildren(child.props.children);
                return _react2.default.cloneElement(child, props);
              }
              props.onMouseLeave = _this2.onChildMouseLeave.bind(_this2);
              if (child.type === _this2.getSubMenuType()) {
                // special props for SubMenu only
                props.forceOpen = _this2.state.forceSubMenuOpen && _this2.state.selectedItem === child;
                props.forceClose = _this2.handleForceClose;
                props.parentKeyNavigationHandler = _this2.handleKeyNavigation;
              }
              if (!child.props.divider && _this2.state.selectedItem === child) {
                // special props for selected item only
                props.selected = true;
                props.ref = function (ref) {
                  _this2.seletedItemRef = ref;
                };
                return _react2.default.cloneElement(child, props);
              }
              // onMouseMove is only needed for non selected items
              props.onMouseMove = function () {
                return _this2.onChildMouseMove(child);
              };
              return _react2.default.cloneElement(child, props);
            });
          };
        };
        exports.default = AbstractMenu;

        /***/
      }, /* 173 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _classnames = __webpack_require__(65);
        var _classnames2 = _interopRequireDefault(_classnames);
        var _objectAssign = __webpack_require__(36);
        var _objectAssign2 = _interopRequireDefault(_objectAssign);
        var _actions = __webpack_require__(27);
        var _helpers = __webpack_require__(28);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var ContextMenuTrigger = function (_Component) {
          _inherits(ContextMenuTrigger, _Component);
          function ContextMenuTrigger() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, ContextMenuTrigger);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContextMenuTrigger.__proto__ || Object.getPrototypeOf(ContextMenuTrigger)).call.apply(_ref, [this].concat(args))), _this), _this.touchHandled = false, _this.handleMouseDown = function (event) {
              if (_this.props.holdToDisplay >= 0 && event.button === 0) {
                event.persist();
                event.stopPropagation();
                _this.mouseDownTimeoutId = setTimeout(function () {
                  return _this.handleContextClick(event);
                }, _this.props.holdToDisplay);
              }
              (0, _helpers.callIfExists)(_this.props.attributes.onMouseDown, event);
            }, _this.handleMouseUp = function (event) {
              if (event.button === 0) {
                clearTimeout(_this.mouseDownTimeoutId);
              }
              (0, _helpers.callIfExists)(_this.props.attributes.onMouseUp, event);
            }, _this.handleMouseOut = function (event) {
              if (event.button === 0) {
                clearTimeout(_this.mouseDownTimeoutId);
              }
              (0, _helpers.callIfExists)(_this.props.attributes.onMouseOut, event);
            }, _this.handleTouchstart = function (event) {
              _this.touchHandled = false;
              if (_this.props.holdToDisplay >= 0) {
                event.persist();
                event.stopPropagation();
                _this.touchstartTimeoutId = setTimeout(function () {
                  _this.handleContextClick(event);
                  _this.touchHandled = true;
                }, _this.props.holdToDisplay);
              }
              (0, _helpers.callIfExists)(_this.props.attributes.onTouchStart, event);
            }, _this.handleTouchEnd = function (event) {
              if (_this.touchHandled) {
                event.preventDefault();
              }
              clearTimeout(_this.touchstartTimeoutId);
              (0, _helpers.callIfExists)(_this.props.attributes.onTouchEnd, event);
            }, _this.handleContextMenu = function (event) {
              _this.handleContextClick(event);
              (0, _helpers.callIfExists)(_this.props.attributes.onContextMenu, event);
            }, _this.handleContextClick = function (event) {
              if (_this.props.disable) return;
              event.preventDefault();
              event.stopPropagation();
              var x = event.clientX || event.touches && event.touches[0].pageX;
              var y = event.clientY || event.touches && event.touches[0].pageY;
              (0, _actions.hideMenu)();
              var data = (0, _helpers.callIfExists)(_this.props.collect, _this.props);
              var showMenuConfig = {
                position: {
                  x: x,
                  y: y
                },
                target: _this.elem,
                id: _this.props.id,
                data: data
              };
              if (data && typeof data.then === 'function') {
                // it's promise
                data.then(function (resp) {
                  showMenuConfig.data = resp;
                  (0, _actions.showMenu)(showMenuConfig);
                });
              } else {
                (0, _actions.showMenu)(showMenuConfig);
              }
            }, _this.elemRef = function (c) {
              _this.elem = c;
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          _createClass(ContextMenuTrigger, [{
            key: 'render',
            value: function render() {
              var _props = this.props,
                renderTag = _props.renderTag,
                attributes = _props.attributes,
                children = _props.children;
              var newAttrs = (0, _objectAssign2.default)({}, attributes, {
                className: (0, _classnames2.default)(_helpers.cssClasses.menuWrapper, attributes.className),
                onContextMenu: this.handleContextMenu,
                onMouseDown: this.handleMouseDown,
                onMouseUp: this.handleMouseUp,
                onTouchStart: this.handleTouchstart,
                onTouchEnd: this.handleTouchEnd,
                onMouseOut: this.handleMouseOut,
                ref: this.elemRef
              });
              return _react2.default.createElement(renderTag, newAttrs, children);
            }
          }]);
          return ContextMenuTrigger;
        }(_react.Component);
        ContextMenuTrigger.propTypes = {
          id: _propTypes2.default.string.isRequired,
          children: _propTypes2.default.node.isRequired,
          attributes: _propTypes2.default.object,
          collect: _propTypes2.default.func,
          disable: _propTypes2.default.bool,
          holdToDisplay: _propTypes2.default.number,
          renderTag: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
        };
        ContextMenuTrigger.defaultProps = {
          attributes: {},
          collect: function collect() {
            return null;
          },
          disable: false,
          holdToDisplay: 1000,
          renderTag: 'div'
        };
        exports.default = ContextMenuTrigger;

        /***/
      }, /* 174 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _classnames = __webpack_require__(65);
        var _classnames2 = _interopRequireDefault(_classnames);
        var _objectAssign = __webpack_require__(36);
        var _objectAssign2 = _interopRequireDefault(_objectAssign);
        var _actions = __webpack_require__(27);
        var _helpers = __webpack_require__(28);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var MenuItem = function (_Component) {
          _inherits(MenuItem, _Component);
          function MenuItem() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, MenuItem);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
              event.preventDefault();
              if (_this.props.disabled || _this.props.divider) return;
              (0, _helpers.callIfExists)(_this.props.onClick, event, (0, _objectAssign2.default)({}, _this.props.data, _helpers.store.data), _helpers.store.target);
              if (_this.props.preventClose) return;
              (0, _actions.hideMenu)();
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          _createClass(MenuItem, [{
            key: 'render',
            value: function render() {
              var _cx,
                _this2 = this;
              var _props = this.props,
                disabled = _props.disabled,
                divider = _props.divider,
                children = _props.children,
                attributes = _props.attributes,
                selected = _props.selected;
              var menuItemClassNames = (0, _classnames2.default)(_helpers.cssClasses.menuItem, attributes && attributes.className, (_cx = {}, _defineProperty(_cx, _helpers.cssClasses.menuItemDisabled, disabled), _defineProperty(_cx, _helpers.cssClasses.menuItemDivider, divider), _defineProperty(_cx, _helpers.cssClasses.menuItemSelected, selected), _cx));
              return _react2.default.createElement('div', _extends({}, attributes, {
                className: menuItemClassNames,
                role: 'menuitem',
                tabIndex: '-1',
                'aria-disabled': disabled ? 'true' : 'false',
                'aria-orientation': divider ? 'horizontal' : null,
                ref: function ref(_ref2) {
                  _this2.ref = _ref2;
                },
                onMouseMove: this.props.onMouseMove,
                onMouseLeave: this.props.onMouseLeave,
                onTouchEnd: this.handleClick,
                onClick: this.handleClick
              }), divider ? null : children);
            }
          }]);
          return MenuItem;
        }(_react.Component);
        MenuItem.propTypes = {
          children: _propTypes2.default.node,
          attributes: _propTypes2.default.object,
          data: _propTypes2.default.object,
          disabled: _propTypes2.default.bool,
          divider: _propTypes2.default.bool,
          preventClose: _propTypes2.default.bool,
          onClick: _propTypes2.default.func,
          selected: _propTypes2.default.bool,
          onMouseMove: _propTypes2.default.func,
          onMouseLeave: _propTypes2.default.func
        };
        MenuItem.defaultProps = {
          disabled: false,
          data: {},
          divider: false,
          attributes: {},
          preventClose: false,
          onClick: function onClick() {
            return null;
          },
          children: null,
          selected: false,
          onMouseMove: function onMouseMove() {
            return null;
          },
          onMouseLeave: function onMouseLeave() {
            return null;
          }
        };
        exports.default = MenuItem;

        /***/
      }, /* 175 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _classnames = __webpack_require__(65);
        var _classnames2 = _interopRequireDefault(_classnames);
        var _objectAssign = __webpack_require__(36);
        var _objectAssign2 = _interopRequireDefault(_objectAssign);
        var _AbstractMenu2 = __webpack_require__(172);
        var _AbstractMenu3 = _interopRequireDefault(_AbstractMenu2);
        var _actions = __webpack_require__(27);
        var _helpers = __webpack_require__(28);
        var _globalEventListener = __webpack_require__(91);
        var _globalEventListener2 = _interopRequireDefault(_globalEventListener);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var SubMenu = function (_AbstractMenu) {
          _inherits(SubMenu, _AbstractMenu);
          function SubMenu(props) {
            _classCallCheck(this, SubMenu);
            var _this = _possibleConstructorReturn(this, (SubMenu.__proto__ || Object.getPrototypeOf(SubMenu)).call(this, props));
            _this.getMenuPosition = function () {
              var _window = window,
                innerWidth = _window.innerWidth,
                innerHeight = _window.innerHeight;
              var rect = _this.subMenu.getBoundingClientRect();
              var position = {};
              if (rect.bottom > innerHeight) {
                position.bottom = 0;
              } else {
                position.top = 0;
              }
              if (rect.right < innerWidth) {
                position.left = '100%';
              } else {
                position.right = '100%';
              }
              return position;
            };
            _this.getRTLMenuPosition = function () {
              var _window2 = window,
                innerHeight = _window2.innerHeight;
              var rect = _this.subMenu.getBoundingClientRect();
              var position = {};
              if (rect.bottom > innerHeight) {
                position.bottom = 0;
              } else {
                position.top = 0;
              }
              if (rect.left < 0) {
                position.left = '100%';
              } else {
                position.right = '100%';
              }
              return position;
            };
            _this.hideMenu = function () {
              if (_this.props.forceOpen) {
                _this.props.forceClose();
              }
              _this.setState({
                visible: false,
                selectedItem: null
              });
              _this.unregisterHandlers();
            };
            _this.handleClick = function (event) {
              event.preventDefault();
              if (_this.props.disabled) return;
              (0, _helpers.callIfExists)(_this.props.onClick, event, (0, _objectAssign2.default)({}, _this.props.data, _helpers.store.data), _helpers.store.target);
              if (_this.props.preventClose) return;
              (0, _actions.hideMenu)();
            };
            _this.handleMouseEnter = function () {
              if (_this.closetimer) clearTimeout(_this.closetimer);
              if (_this.props.disabled || _this.state.visible) return;
              _this.opentimer = setTimeout(function () {
                return _this.setState({
                  visible: true,
                  selectedItem: null
                });
              }, _this.props.hoverDelay);
            };
            _this.handleMouseLeave = function () {
              if (_this.opentimer) clearTimeout(_this.opentimer);
              if (!_this.state.visible) return;
              _this.closetimer = setTimeout(function () {
                return _this.setState({
                  visible: false,
                  selectedItem: null
                });
              }, _this.props.hoverDelay);
            };
            _this.menuRef = function (c) {
              _this.menu = c;
            };
            _this.subMenuRef = function (c) {
              _this.subMenu = c;
            };
            _this.registerHandlers = function () {
              document.removeEventListener('keydown', _this.props.parentKeyNavigationHandler);
              document.addEventListener('keydown', _this.handleKeyNavigation);
            };
            _this.unregisterHandlers = function () {
              document.removeEventListener('keydown', _this.handleKeyNavigation);
              document.addEventListener('keydown', _this.props.parentKeyNavigationHandler);
            };
            _this.state = (0, _objectAssign2.default)({}, _this.state, {
              visible: false
            });
            return _this;
          }
          _createClass(SubMenu, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              this.listenId = _globalEventListener2.default.register(function () {}, this.hideMenu);
            }
          }, {
            key: 'getSubMenuType',
            value: function getSubMenuType() {
              // eslint-disable-line class-methods-use-this
              return SubMenu;
            }
          }, {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps, nextState) {
              this.isVisibilityChange = (this.state.visible !== nextState.visible || this.props.forceOpen !== nextProps.forceOpen) && !(this.state.visible && nextProps.forceOpen) && !(this.props.forceOpen && nextState.visible);
              return true;
            }
          }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
              var _this2 = this;
              if (!this.isVisibilityChange) return;
              if (this.props.forceOpen || this.state.visible) {
                var wrapper = window.requestAnimationFrame || setTimeout;
                wrapper(function () {
                  var styles = _this2.props.rtl ? _this2.getRTLMenuPosition() : _this2.getMenuPosition();
                  _this2.subMenu.style.removeProperty('top');
                  _this2.subMenu.style.removeProperty('bottom');
                  _this2.subMenu.style.removeProperty('left');
                  _this2.subMenu.style.removeProperty('right');
                  if ((0, _helpers.hasOwnProp)(styles, 'top')) _this2.subMenu.style.top = styles.top;
                  if ((0, _helpers.hasOwnProp)(styles, 'left')) _this2.subMenu.style.left = styles.left;
                  if ((0, _helpers.hasOwnProp)(styles, 'bottom')) _this2.subMenu.style.bottom = styles.bottom;
                  if ((0, _helpers.hasOwnProp)(styles, 'right')) _this2.subMenu.style.right = styles.right;
                  _this2.subMenu.classList.add(_helpers.cssClasses.menuVisible);
                  _this2.registerHandlers();
                  _this2.setState({
                    selectedItem: null
                  });
                });
              } else {
                var cleanup = function cleanup() {
                  _this2.subMenu.removeEventListener('transitionend', cleanup);
                  _this2.subMenu.style.removeProperty('bottom');
                  _this2.subMenu.style.removeProperty('right');
                  _this2.subMenu.style.top = 0;
                  _this2.subMenu.style.left = '100%';
                  _this2.unregisterHandlers();
                };
                this.subMenu.addEventListener('transitionend', cleanup);
                this.subMenu.classList.remove(_helpers.cssClasses.menuVisible);
              }
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              if (this.listenId) {
                _globalEventListener2.default.unregister(this.listenId);
              }
              if (this.opentimer) clearTimeout(this.opentimer);
              if (this.closetimer) clearTimeout(this.closetimer);
              this.unregisterHandlers();
            }
          }, {
            key: 'render',
            value: function render() {
              var _cx;
              var _props = this.props,
                children = _props.children,
                disabled = _props.disabled,
                title = _props.title,
                selected = _props.selected;
              var visible = this.state.visible;
              var menuProps = {
                ref: this.menuRef,
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave,
                className: (0, _classnames2.default)(_helpers.cssClasses.menuItem, _helpers.cssClasses.subMenu),
                style: {
                  position: 'relative'
                }
              };
              var menuItemProps = {
                className: (0, _classnames2.default)(_helpers.cssClasses.menuItem, (_cx = {}, _defineProperty(_cx, _helpers.cssClasses.menuItemDisabled, disabled), _defineProperty(_cx, _helpers.cssClasses.menuItemActive, visible), _defineProperty(_cx, _helpers.cssClasses.menuItemSelected, selected), _cx)),
                onMouseMove: this.props.onMouseMove,
                onMouseOut: this.props.onMouseOut,
                onClick: this.handleClick
              };
              var subMenuProps = {
                ref: this.subMenuRef,
                style: {
                  position: 'absolute',
                  transition: 'opacity 1ms',
                  // trigger transitionend event
                  top: 0,
                  left: '100%'
                },
                className: (0, _classnames2.default)(_helpers.cssClasses.menu, this.props.className)
              };
              return _react2.default.createElement('nav', _extends({}, menuProps, {
                role: 'menuitem',
                tabIndex: '-1',
                'aria-haspopup': 'true'
              }), _react2.default.createElement('div', menuItemProps, title), _react2.default.createElement('nav', _extends({}, subMenuProps, {
                role: 'menu',
                tabIndex: '-1'
              }), this.renderChildren(children)));
            }
          }]);
          return SubMenu;
        }(_AbstractMenu3.default);
        SubMenu.propTypes = {
          children: _propTypes2.default.node.isRequired,
          title: _propTypes2.default.node.isRequired,
          className: _propTypes2.default.string,
          disabled: _propTypes2.default.bool,
          hoverDelay: _propTypes2.default.number,
          rtl: _propTypes2.default.bool,
          selected: _propTypes2.default.bool,
          onMouseMove: _propTypes2.default.func,
          onMouseOut: _propTypes2.default.func,
          forceOpen: _propTypes2.default.bool,
          forceClose: _propTypes2.default.func,
          parentKeyNavigationHandler: _propTypes2.default.func
        };
        SubMenu.defaultProps = {
          disabled: false,
          hoverDelay: 500,
          className: '',
          rtl: false,
          selected: false,
          onMouseMove: function onMouseMove() {
            return null;
          },
          onMouseOut: function onMouseOut() {
            return null;
          },
          forceOpen: false,
          forceClose: function forceClose() {
            return null;
          },
          parentKeyNavigationHandler: function parentKeyNavigationHandler() {
            return null;
          }
        };
        exports.default = SubMenu;

        /***/
      }, /* 176 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.isSafari = exports.isFirefox = undefined;
        var _memoize = __webpack_require__(334);
        var _memoize2 = _interopRequireDefault(_memoize);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
          return /firefox/i.test(navigator.userAgent);
        });
        var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
          return Boolean(window.safari);
        });

        /***/
      }, /* 177 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        exports.default = DragDropContext;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _dndCore = __webpack_require__(262);
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        var _hoistNonReactStatics = __webpack_require__(82);
        var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
        var _checkDecoratorArguments = __webpack_require__(66);
        var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
          dragDropManager: _propTypes2.default.object.isRequired
        };
        var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
          return {
            dragDropManager: new _dndCore.DragDropManager(backend, context)
          };
        };
        var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
          // Auto-detect ES6 default export for people still using ES5
          var backend = backendOrModule;
          if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
            backend = backend.default;
          }
          (0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
          return backend;
        };
        function DragDropContext(backendOrModule) {
          _checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params

          var backend = unpackBackendForEs5Users(backendOrModule);
          var childContext = createChildContext(backend);
          return function decorateContext(DecoratedComponent) {
            var _class, _temp;
            var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
            var DragDropContextContainer = (_temp = _class = function (_Component) {
              _inherits(DragDropContextContainer, _Component);
              function DragDropContextContainer() {
                _classCallCheck(this, DragDropContextContainer);
                return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
              }
              _createClass(DragDropContextContainer, [{
                key: 'getDecoratedComponentInstance',
                value: function getDecoratedComponentInstance() {
                  (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
                  return this.child;
                }
              }, {
                key: 'getManager',
                value: function getManager() {
                  return childContext.dragDropManager;
                }
              }, {
                key: 'getChildContext',
                value: function getChildContext() {
                  return childContext;
                }
              }, {
                key: 'render',
                value: function render() {
                  var _this2 = this;
                  return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
                    ref: function ref(child) {
                      _this2.child = child;
                    }
                  }));
                }
              }]);
              return DragDropContextContainer;
            }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);
            return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
          };
        }

        /***/
      }, /* 178 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = areOptionsEqual;
        var _shallowEqual = __webpack_require__(93);
        var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function areOptionsEqual(nextOptions, currentOptions) {
          if (currentOptions === nextOptions) {
            return true;
          }
          return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
        }

        /***/
      }, /* 179 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        exports.default = decorateHandler;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _disposables = __webpack_require__(255);
        var _isPlainObject = __webpack_require__(22);
        var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        var _hoistNonReactStatics = __webpack_require__(82);
        var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
        var _shallowEqual = __webpack_require__(93);
        var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
        var _shallowEqualScalar = __webpack_require__(181);
        var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var isClassComponent = function isClassComponent(Comp) {
          return Boolean(Comp && Comp.prototype && typeof Comp.prototype.render === 'function');
        };
        function decorateHandler(_ref) {
          var _class, _temp;
          var DecoratedComponent = _ref.DecoratedComponent,
            createHandler = _ref.createHandler,
            createMonitor = _ref.createMonitor,
            createConnector = _ref.createConnector,
            registerHandler = _ref.registerHandler,
            containerDisplayName = _ref.containerDisplayName,
            getType = _ref.getType,
            collect = _ref.collect,
            options = _ref.options;
          var _options$arePropsEqua = options.arePropsEqual,
            arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
          var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
          var DragDropContainer = (_temp = _class = function (_Component) {
            _inherits(DragDropContainer, _Component);
            _createClass(DragDropContainer, [{
              key: 'getHandlerId',
              value: function getHandlerId() {
                return this.handlerId;
              }
            }, {
              key: 'getDecoratedComponentInstance',
              value: function getDecoratedComponentInstance() {
                return this.decoratedComponentInstance;
              }
            }, {
              key: 'shouldComponentUpdate',
              value: function shouldComponentUpdate(nextProps, nextState) {
                return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
              }
            }]);
            function DragDropContainer(props, context) {
              _classCallCheck(this, DragDropContainer);
              var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));
              _this.handleChange = _this.handleChange.bind(_this);
              _this.handleChildRef = _this.handleChildRef.bind(_this);
              (0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
              _this.manager = _this.context.dragDropManager;
              _this.handlerMonitor = createMonitor(_this.manager);
              _this.handlerConnector = createConnector(_this.manager.getBackend());
              _this.handler = createHandler(_this.handlerMonitor);
              _this.disposable = new _disposables.SerialDisposable();
              _this.receiveProps(props);
              _this.state = _this.getCurrentState();
              _this.dispose();
              return _this;
            }
            _createClass(DragDropContainer, [{
              key: 'componentDidMount',
              value: function componentDidMount() {
                this.isCurrentlyMounted = true;
                this.disposable = new _disposables.SerialDisposable();
                this.currentType = null;
                this.receiveProps(this.props);
                this.handleChange();
              }
            }, {
              key: 'componentWillReceiveProps',
              value: function componentWillReceiveProps(nextProps) {
                if (!arePropsEqual(nextProps, this.props)) {
                  this.receiveProps(nextProps);
                  this.handleChange();
                }
              }
            }, {
              key: 'componentWillUnmount',
              value: function componentWillUnmount() {
                this.dispose();
                this.isCurrentlyMounted = false;
              }
            }, {
              key: 'receiveProps',
              value: function receiveProps(props) {
                this.handler.receiveProps(props);
                this.receiveType(getType(props));
              }
            }, {
              key: 'receiveType',
              value: function receiveType(type) {
                if (type === this.currentType) {
                  return;
                }
                this.currentType = type;
                var _registerHandler = registerHandler(type, this.handler, this.manager),
                  handlerId = _registerHandler.handlerId,
                  unregister = _registerHandler.unregister;
                this.handlerId = handlerId;
                this.handlerMonitor.receiveHandlerId(handlerId);
                this.handlerConnector.receiveHandlerId(handlerId);
                var globalMonitor = this.manager.getMonitor();
                var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, {
                  handlerIds: [handlerId]
                });
                this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
              }
            }, {
              key: 'handleChange',
              value: function handleChange() {
                if (!this.isCurrentlyMounted) {
                  return;
                }
                var nextState = this.getCurrentState();
                if (!(0, _shallowEqual2.default)(nextState, this.state)) {
                  this.setState(nextState);
                }
              }
            }, {
              key: 'dispose',
              value: function dispose() {
                this.disposable.dispose();
                this.handlerConnector.receiveHandlerId(null);
              }
            }, {
              key: 'handleChildRef',
              value: function handleChildRef(component) {
                this.decoratedComponentInstance = component;
                this.handler.receiveComponent(component);
              }
            }, {
              key: 'getCurrentState',
              value: function getCurrentState() {
                var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);
                if (false) {}
                return nextState;
              }
            }, {
              key: 'render',
              value: function render() {
                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
                  ref: isClassComponent(DecoratedComponent) ? this.handleChildRef : null
                }));
              }
            }]);
            return DragDropContainer;
          }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
            dragDropManager: _propTypes2.default.object.isRequired
          }, _temp);
          return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
        }

        /***/
      }, /* 180 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        exports.default = isValidType;
        var _isArray = __webpack_require__(21);
        var _isArray2 = _interopRequireDefault(_isArray);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function isValidType(type, allowArray) {
          return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
            return isValidType(t, false);
          });
        }

        /***/
      }, /* 181 */
      /***/function (module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        exports.default = shallowEqualScalar;
        function shallowEqualScalar(objA, objB) {
          if (objA === objB) {
            return true;
          }
          if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
            return false;
          }
          var keysA = Object.keys(objA);
          var keysB = Object.keys(objB);
          if (keysA.length !== keysB.length) {
            return false;
          }

          // Test for A's keys different from B.
          var hasOwn = Object.prototype.hasOwnProperty;
          for (var i = 0; i < keysA.length; i += 1) {
            if (!hasOwn.call(objB, keysA[i])) {
              return false;
            }
            var valA = objA[keysA[i]];
            var valB = objB[keysA[i]];
            if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
              return false;
            }
          }
          return true;
        }

        /***/
      }, /* 182 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = wrapConnectorHooks;
        var _react = __webpack_require__(2);
        var _cloneWithRef = __webpack_require__(361);
        var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function throwIfCompositeComponentElement(element) {
          // Custom components can no longer be wrapped directly in React DnD 2.0
          // so that we don't need to depend on findDOMNode() from react-dom.
          if (typeof element.type === 'string') {
            return;
          }
          var displayName = element.type.displayName || element.type.name || 'the component';
          throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
        }
        function wrapHookToRecognizeElement(hook) {
          return function () {
            var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            // When passed a node, call the hook straight away.
            if (!(0, _react.isValidElement)(elementOrNode)) {
              var node = elementOrNode;
              hook(node, options);
              return undefined;
            }

            // If passed a ReactElement, clone it and attach this function as a ref.
            // This helps us achieve a neat API where user doesn't even know that refs
            // are being used under the hood.
            var element = elementOrNode;
            throwIfCompositeComponentElement(element);

            // When no options are passed, use the hook directly
            var ref = options ? function (node) {
              return hook(node, options);
            } : hook;
            return (0, _cloneWithRef2.default)(element, ref);
          };
        }
        function wrapConnectorHooks(hooks) {
          var wrappedHooks = {};
          Object.keys(hooks).forEach(function (key) {
            var hook = hooks[key];
            var wrappedHook = wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = function () {
              return wrappedHook;
            };
          });
          return wrappedHooks;
        }

        /***/
      }, /* 183 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _Select = __webpack_require__(67);
        var _Select2 = _interopRequireDefault(_Select);
        var _stripDiacritics = __webpack_require__(189);
        var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var propTypes = {
          autoload: _propTypes2.default.bool.isRequired,
          // automatically call the `loadOptions` prop on-mount; defaults to true
          cache: _propTypes2.default.any,
          // object to use to cache results; set to null/false to disable caching
          children: _propTypes2.default.func.isRequired,
          // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
          ignoreAccents: _propTypes2.default.bool,
          // strip diacritics when filtering; defaults to true
          ignoreCase: _propTypes2.default.bool,
          // perform case-insensitive filtering; defaults to true
          loadOptions: _propTypes2.default.func.isRequired,
          // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
          loadingPlaceholder: _propTypes2.default.oneOfType([
          // replaces the placeholder while options are loading
          _propTypes2.default.string, _propTypes2.default.node]),
          multi: _propTypes2.default.bool,
          // multi-value input
          noResultsText: _propTypes2.default.oneOfType([
          // field noResultsText, displayed when no options come back from the server
          _propTypes2.default.string, _propTypes2.default.node]),
          onChange: _propTypes2.default.func,
          // onChange handler: function (newValue) {}
          onInputChange: _propTypes2.default.func,
          // optional for keeping track of what is being typed
          options: _propTypes2.default.array.isRequired,
          // array of options
          placeholder: _propTypes2.default.oneOfType([
          // field placeholder, displayed when there's no value (shared with Select)
          _propTypes2.default.string, _propTypes2.default.node]),
          searchPromptText: _propTypes2.default.oneOfType([
          // label to prompt for search input
          _propTypes2.default.string, _propTypes2.default.node]),
          value: _propTypes2.default.any // initial field value
        };

        var defaultCache = {};
        var defaultChildren = function defaultChildren(props) {
          return _react2.default.createElement(_Select2.default, props);
        };
        var defaultProps = {
          autoload: true,
          cache: defaultCache,
          children: defaultChildren,
          ignoreAccents: true,
          ignoreCase: true,
          loadingPlaceholder: 'Loading...',
          options: [],
          searchPromptText: 'Type to search'
        };
        var Async = function (_Component) {
          _inherits(Async, _Component);
          function Async(props, context) {
            _classCallCheck(this, Async);
            var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
            _this._cache = props.cache === defaultCache ? {} : props.cache;
            _this.state = {
              inputValue: '',
              isLoading: false,
              options: props.options
            };
            _this.onInputChange = _this.onInputChange.bind(_this);
            return _this;
          }
          _createClass(Async, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              var autoload = this.props.autoload;
              if (autoload) {
                this.loadOptions('');
              }
            }
          }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
              if (nextProps.options !== this.props.options) {
                this.setState({
                  options: nextProps.options
                });
              }
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              this._callback = null;
            }
          }, {
            key: 'loadOptions',
            value: function loadOptions(inputValue) {
              var _this2 = this;
              var loadOptions = this.props.loadOptions;
              var cache = this._cache;
              if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
                this._callback = null;
                this.setState({
                  isLoading: false,
                  options: cache[inputValue]
                });
                return;
              }
              var callback = function callback(error, data) {
                var options = data && data.options || [];
                if (cache) {
                  cache[inputValue] = options;
                }
                if (callback === _this2._callback) {
                  _this2._callback = null;
                  _this2.setState({
                    isLoading: false,
                    options: options
                  });
                }
              };

              // Ignore all but the most recent request
              this._callback = callback;
              var promise = loadOptions(inputValue, callback);
              if (promise) {
                promise.then(function (data) {
                  return callback(null, data);
                }, function (error) {
                  return callback(error);
                });
              }
              if (this._callback && !this.state.isLoading) {
                this.setState({
                  isLoading: true
                });
              }
            }
          }, {
            key: 'onInputChange',
            value: function onInputChange(inputValue) {
              var _props = this.props,
                ignoreAccents = _props.ignoreAccents,
                ignoreCase = _props.ignoreCase,
                onInputChange = _props.onInputChange;
              var newInputValue = inputValue;
              if (onInputChange) {
                var value = onInputChange(newInputValue);
                // Note: != used deliberately here to catch undefined and null
                if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
                  newInputValue = '' + value;
                }
              }
              var transformedInputValue = newInputValue;
              if (ignoreAccents) {
                transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
              }
              if (ignoreCase) {
                transformedInputValue = transformedInputValue.toLowerCase();
              }
              this.setState({
                inputValue: newInputValue
              });
              this.loadOptions(transformedInputValue);

              // Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
              return newInputValue;
            }
          }, {
            key: 'noResultsText',
            value: function noResultsText() {
              var _props2 = this.props,
                loadingPlaceholder = _props2.loadingPlaceholder,
                noResultsText = _props2.noResultsText,
                searchPromptText = _props2.searchPromptText;
              var _state = this.state,
                inputValue = _state.inputValue,
                isLoading = _state.isLoading;
              if (isLoading) {
                return loadingPlaceholder;
              }
              if (inputValue && noResultsText) {
                return noResultsText;
              }
              return searchPromptText;
            }
          }, {
            key: 'focus',
            value: function focus() {
              this.select.focus();
            }
          }, {
            key: 'render',
            value: function render() {
              var _this3 = this;
              var _props3 = this.props,
                children = _props3.children,
                loadingPlaceholder = _props3.loadingPlaceholder,
                placeholder = _props3.placeholder;
              var _state2 = this.state,
                isLoading = _state2.isLoading,
                options = _state2.options;
              var props = {
                noResultsText: this.noResultsText(),
                placeholder: isLoading ? loadingPlaceholder : placeholder,
                options: isLoading && loadingPlaceholder ? [] : options,
                ref: function ref(_ref) {
                  return _this3.select = _ref;
                }
              };
              return children(_extends({}, this.props, props, {
                isLoading: isLoading,
                onInputChange: this.onInputChange
              }));
            }
          }]);
          return Async;
        }(_react.Component);
        exports.default = Async;
        Async.propTypes = propTypes;
        Async.defaultProps = defaultProps;

        /***/
      }, /* 184 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _defaultFilterOptions = __webpack_require__(94);
        var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
        var _defaultMenuRenderer = __webpack_require__(95);
        var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
        var _Select = __webpack_require__(67);
        var _Select2 = _interopRequireDefault(_Select);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _objectWithoutProperties(obj, keys) {
          var target = {};
          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }
          return target;
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var CreatableSelect = function (_React$Component) {
          _inherits(CreatableSelect, _React$Component);
          function CreatableSelect(props, context) {
            _classCallCheck(this, CreatableSelect);
            var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
            _this.filterOptions = _this.filterOptions.bind(_this);
            _this.menuRenderer = _this.menuRenderer.bind(_this);
            _this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
            _this.onInputChange = _this.onInputChange.bind(_this);
            _this.onOptionSelect = _this.onOptionSelect.bind(_this);
            return _this;
          }
          _createClass(CreatableSelect, [{
            key: 'createNewOption',
            value: function createNewOption() {
              var _props = this.props,
                isValidNewOption = _props.isValidNewOption,
                newOptionCreator = _props.newOptionCreator,
                onNewOptionClick = _props.onNewOptionClick,
                _props$options = _props.options,
                options = _props$options === undefined ? [] : _props$options;
              if (isValidNewOption({
                label: this.inputValue
              })) {
                var option = newOptionCreator({
                  label: this.inputValue,
                  labelKey: this.labelKey,
                  valueKey: this.valueKey
                });
                var _isOptionUnique = this.isOptionUnique({
                  option: option,
                  options: options
                });

                // Don't add the same option twice.
                if (_isOptionUnique) {
                  if (onNewOptionClick) {
                    onNewOptionClick(option);
                  } else {
                    options.unshift(option);
                    this.select.selectValue(option);
                  }
                }
              }
            }
          }, {
            key: 'filterOptions',
            value: function filterOptions() {
              var _props2 = this.props,
                filterOptions = _props2.filterOptions,
                isValidNewOption = _props2.isValidNewOption,
                promptTextCreator = _props2.promptTextCreator;

              // TRICKY Check currently selected options as well.
              // Don't display a create-prompt for a value that's selected.
              // This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

              var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
              var filteredOptions = filterOptions.apply(undefined, arguments) || [];
              if (isValidNewOption({
                label: this.inputValue
              })) {
                var _newOptionCreator = this.props.newOptionCreator;
                var option = _newOptionCreator({
                  label: this.inputValue,
                  labelKey: this.labelKey,
                  valueKey: this.valueKey
                });

                // TRICKY Compare to all options (not just filtered options) in case option has already been selected).
                // For multi-selects, this would remove it from the filtered list.
                var _isOptionUnique2 = this.isOptionUnique({
                  option: option,
                  options: excludeOptions.concat(filteredOptions)
                });
                if (_isOptionUnique2) {
                  var prompt = promptTextCreator(this.inputValue);
                  this._createPlaceholderOption = _newOptionCreator({
                    label: prompt,
                    labelKey: this.labelKey,
                    valueKey: this.valueKey
                  });
                  filteredOptions.unshift(this._createPlaceholderOption);
                }
              }
              return filteredOptions;
            }
          }, {
            key: 'isOptionUnique',
            value: function isOptionUnique(_ref) {
              var option = _ref.option,
                options = _ref.options;
              var isOptionUnique = this.props.isOptionUnique;
              options = options || this.props.options;
              return isOptionUnique({
                labelKey: this.labelKey,
                option: option,
                options: options,
                valueKey: this.valueKey
              });
            }
          }, {
            key: 'menuRenderer',
            value: function menuRenderer(params) {
              var menuRenderer = this.props.menuRenderer;
              return menuRenderer(_extends({}, params, {
                onSelect: this.onOptionSelect,
                selectValue: this.onOptionSelect
              }));
            }
          }, {
            key: 'onInputChange',
            value: function onInputChange(input) {
              var onInputChange = this.props.onInputChange;

              // This value may be needed in between Select mounts (when this.select is null)

              this.inputValue = input;
              if (onInputChange) {
                this.inputValue = onInputChange(input);
              }
              return this.inputValue;
            }
          }, {
            key: 'onInputKeyDown',
            value: function onInputKeyDown(event) {
              var _props3 = this.props,
                shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
                onInputKeyDown = _props3.onInputKeyDown;
              var focusedOption = this.select.getFocusedOption();
              if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({
                keyCode: event.keyCode
              })) {
                this.createNewOption();

                // Prevent decorated Select from doing anything additional with this keyDown event
                event.preventDefault();
              } else if (onInputKeyDown) {
                onInputKeyDown(event);
              }
            }
          }, {
            key: 'onOptionSelect',
            value: function onOptionSelect(option) {
              if (option === this._createPlaceholderOption) {
                this.createNewOption();
              } else {
                this.select.selectValue(option);
              }
            }
          }, {
            key: 'focus',
            value: function focus() {
              this.select.focus();
            }
          }, {
            key: 'render',
            value: function render() {
              var _this2 = this;
              var _props4 = this.props,
                refProp = _props4.ref,
                restProps = _objectWithoutProperties(_props4, ['ref']);
              var children = this.props.children;

              // We can't use destructuring default values to set the children,
              // because it won't apply work if `children` is null. A falsy check is
              // more reliable in real world use-cases.

              if (!children) {
                children = defaultChildren;
              }
              var props = _extends({}, restProps, {
                allowCreate: true,
                filterOptions: this.filterOptions,
                menuRenderer: this.menuRenderer,
                onInputChange: this.onInputChange,
                onInputKeyDown: this.onInputKeyDown,
                ref: function ref(_ref2) {
                  _this2.select = _ref2;

                  // These values may be needed in between Select mounts (when this.select is null)
                  if (_ref2) {
                    _this2.labelKey = _ref2.props.labelKey;
                    _this2.valueKey = _ref2.props.valueKey;
                  }
                  if (refProp) {
                    refProp(_ref2);
                  }
                }
              });
              return children(props);
            }
          }]);
          return CreatableSelect;
        }(_react2.default.Component);
        var defaultChildren = function defaultChildren(props) {
          return _react2.default.createElement(_Select2.default, props);
        };
        var isOptionUnique = function isOptionUnique(_ref3) {
          var option = _ref3.option,
            options = _ref3.options,
            labelKey = _ref3.labelKey,
            valueKey = _ref3.valueKey;
          if (!options || !options.length) {
            return true;
          }
          return options.filter(function (existingOption) {
            return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
          }).length === 0;
        };
        var isValidNewOption = function isValidNewOption(_ref4) {
          var label = _ref4.label;
          return !!label;
        };
        var newOptionCreator = function newOptionCreator(_ref5) {
          var label = _ref5.label,
            labelKey = _ref5.labelKey,
            valueKey = _ref5.valueKey;
          var option = {};
          option[valueKey] = label;
          option[labelKey] = label;
          option.className = 'Select-create-option-placeholder';
          return option;
        };
        var promptTextCreator = function promptTextCreator(label) {
          return 'Create option "' + label + '"';
        };
        var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
          var keyCode = _ref6.keyCode;
          switch (keyCode) {
            case 9: // TAB
            case 13: // ENTER
            case 188:
              // COMMA
              return true;
            default:
              return false;
          }
        };

        // Default prop methods
        CreatableSelect.isOptionUnique = isOptionUnique;
        CreatableSelect.isValidNewOption = isValidNewOption;
        CreatableSelect.newOptionCreator = newOptionCreator;
        CreatableSelect.promptTextCreator = promptTextCreator;
        CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
        CreatableSelect.defaultProps = {
          filterOptions: _defaultFilterOptions2.default,
          isOptionUnique: isOptionUnique,
          isValidNewOption: isValidNewOption,
          menuRenderer: _defaultMenuRenderer2.default,
          newOptionCreator: newOptionCreator,
          promptTextCreator: promptTextCreator,
          shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
        };
        CreatableSelect.propTypes = {
          // Child function responsible for creating the inner Select component
          // This component can be used to compose HOCs (eg Creatable and Async)
          // (props: Object): PropTypes.element
          children: _propTypes2.default.func,
          // See Select.propTypes.filterOptions
          filterOptions: _propTypes2.default.any,
          // Searches for any matching option within the set of options.
          // This function prevents duplicate options from being created.
          // ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
          isOptionUnique: _propTypes2.default.func,
          // Determines if the current input text represents a valid option.
          // ({ label: string }): boolean
          isValidNewOption: _propTypes2.default.func,
          // See Select.propTypes.menuRenderer
          menuRenderer: _propTypes2.default.any,
          // Factory to create new option.
          // ({ label: string, labelKey: string, valueKey: string }): Object
          newOptionCreator: _propTypes2.default.func,
          // input change handler: function (inputValue) {}
          onInputChange: _propTypes2.default.func,
          // input keyDown handler: function (event) {}
          onInputKeyDown: _propTypes2.default.func,
          // new option click handler: function (option) {}
          onNewOptionClick: _propTypes2.default.func,
          // See Select.propTypes.options
          options: _propTypes2.default.array,
          // Creates prompt/placeholder option text.
          // (filterText: string): string
          promptTextCreator: _propTypes2.default.func,
          ref: _propTypes2.default.func,
          // Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
          shouldKeyDownEventCreateNewOption: _propTypes2.default.func
        };
        exports.default = CreatableSelect;

        /***/
      }, /* 185 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _classnames = __webpack_require__(68);
        var _classnames2 = _interopRequireDefault(_classnames);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _blockEvent = __webpack_require__(364);
        var _blockEvent2 = _interopRequireDefault(_blockEvent);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var Option = function (_React$Component) {
          _inherits(Option, _React$Component);
          function Option(props) {
            _classCallCheck(this, Option);
            var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
            _this.handleMouseDown = _this.handleMouseDown.bind(_this);
            _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
            _this.handleMouseMove = _this.handleMouseMove.bind(_this);
            _this.handleTouchStart = _this.handleTouchStart.bind(_this);
            _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
            _this.handleTouchMove = _this.handleTouchMove.bind(_this);
            _this.onFocus = _this.onFocus.bind(_this);
            return _this;
          }
          _createClass(Option, [{
            key: 'handleMouseDown',
            value: function handleMouseDown(event) {
              event.preventDefault();
              event.stopPropagation();
              this.props.onSelect(this.props.option, event);
            }
          }, {
            key: 'handleMouseEnter',
            value: function handleMouseEnter(event) {
              this.onFocus(event);
            }
          }, {
            key: 'handleMouseMove',
            value: function handleMouseMove(event) {
              this.onFocus(event);
            }
          }, {
            key: 'handleTouchEnd',
            value: function handleTouchEnd(event) {
              // Check if the view is being dragged, In this case
              // we don't want to fire the click event (because the user only wants to scroll)
              if (this.dragging) return;
              this.handleMouseDown(event);
            }
          }, {
            key: 'handleTouchMove',
            value: function handleTouchMove() {
              // Set a flag that the view is being dragged
              this.dragging = true;
            }
          }, {
            key: 'handleTouchStart',
            value: function handleTouchStart() {
              // Set a flag that the view is not being dragged
              this.dragging = false;
            }
          }, {
            key: 'onFocus',
            value: function onFocus(event) {
              if (!this.props.isFocused) {
                this.props.onFocus(this.props.option, event);
              }
            }
          }, {
            key: 'render',
            value: function render() {
              var _props = this.props,
                option = _props.option,
                instancePrefix = _props.instancePrefix,
                optionIndex = _props.optionIndex;
              var className = (0, _classnames2.default)(this.props.className, option.className);
              return option.disabled ? _react2.default.createElement('div', {
                className: className,
                onMouseDown: _blockEvent2.default,
                onClick: _blockEvent2.default
              }, this.props.children) : _react2.default.createElement('div', {
                className: className,
                style: option.style,
                role: 'option',
                'aria-label': option.label,
                onMouseDown: this.handleMouseDown,
                onMouseEnter: this.handleMouseEnter,
                onMouseMove: this.handleMouseMove,
                onTouchStart: this.handleTouchStart,
                onTouchMove: this.handleTouchMove,
                onTouchEnd: this.handleTouchEnd,
                id: instancePrefix + '-option-' + optionIndex,
                title: option.title
              }, this.props.children);
            }
          }]);
          return Option;
        }(_react2.default.Component);
        Option.propTypes = {
          children: _propTypes2.default.node,
          className: _propTypes2.default.string,
          // className (based on mouse position)
          instancePrefix: _propTypes2.default.string.isRequired,
          // unique prefix for the ids (used for aria)
          isDisabled: _propTypes2.default.bool,
          // the option is disabled
          isFocused: _propTypes2.default.bool,
          // the option is focused
          isSelected: _propTypes2.default.bool,
          // the option is selected
          onFocus: _propTypes2.default.func,
          // method to handle mouseEnter on option element
          onSelect: _propTypes2.default.func,
          // method to handle click on option element
          onUnfocus: _propTypes2.default.func,
          // method to handle mouseLeave on option element
          option: _propTypes2.default.object.isRequired,
          // object that is base for that option
          optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
        };

        exports.default = Option;

        /***/
      }, /* 186 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _classnames = __webpack_require__(68);
        var _classnames2 = _interopRequireDefault(_classnames);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var Value = function (_React$Component) {
          _inherits(Value, _React$Component);
          function Value(props) {
            _classCallCheck(this, Value);
            var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
            _this.handleMouseDown = _this.handleMouseDown.bind(_this);
            _this.onRemove = _this.onRemove.bind(_this);
            _this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
            _this.handleTouchMove = _this.handleTouchMove.bind(_this);
            _this.handleTouchStart = _this.handleTouchStart.bind(_this);
            return _this;
          }
          _createClass(Value, [{
            key: 'handleMouseDown',
            value: function handleMouseDown(event) {
              if (event.type === 'mousedown' && event.button !== 0) {
                return;
              }
              if (this.props.onClick) {
                event.stopPropagation();
                this.props.onClick(this.props.value, event);
                return;
              }
              if (this.props.value.href) {
                event.stopPropagation();
              }
            }
          }, {
            key: 'onRemove',
            value: function onRemove(event) {
              event.preventDefault();
              event.stopPropagation();
              this.props.onRemove(this.props.value);
            }
          }, {
            key: 'handleTouchEndRemove',
            value: function handleTouchEndRemove(event) {
              // Check if the view is being dragged, In this case
              // we don't want to fire the click event (because the user only wants to scroll)
              if (this.dragging) return;

              // Fire the mouse events
              this.onRemove(event);
            }
          }, {
            key: 'handleTouchMove',
            value: function handleTouchMove() {
              // Set a flag that the view is being dragged
              this.dragging = true;
            }
          }, {
            key: 'handleTouchStart',
            value: function handleTouchStart() {
              // Set a flag that the view is not being dragged
              this.dragging = false;
            }
          }, {
            key: 'renderRemoveIcon',
            value: function renderRemoveIcon() {
              if (this.props.disabled || !this.props.onRemove) return;
              return _react2.default.createElement('span', {
                className: 'Select-value-icon',
                'aria-hidden': 'true',
                onMouseDown: this.onRemove,
                onTouchEnd: this.handleTouchEndRemove,
                onTouchStart: this.handleTouchStart,
                onTouchMove: this.handleTouchMove
              }, '\xD7');
            }
          }, {
            key: 'renderLabel',
            value: function renderLabel() {
              var className = 'Select-value-label';
              return this.props.onClick || this.props.value.href ? _react2.default.createElement('a', {
                className: className,
                href: this.props.value.href,
                target: this.props.value.target,
                onMouseDown: this.handleMouseDown,
                onTouchEnd: this.handleMouseDown
              }, this.props.children) : _react2.default.createElement('span', {
                className: className,
                role: 'option',
                'aria-selected': 'true',
                id: this.props.id
              }, this.props.children);
            }
          }, {
            key: 'render',
            value: function render() {
              return _react2.default.createElement('div', {
                className: (0, _classnames2.default)('Select-value', this.props.value.className),
                style: this.props.value.style,
                title: this.props.value.title
              }, this.renderRemoveIcon(), this.renderLabel());
            }
          }]);
          return Value;
        }(_react2.default.Component);
        Value.propTypes = {
          children: _propTypes2.default.node,
          disabled: _propTypes2.default.bool,
          // disabled prop passed to ReactSelect
          id: _propTypes2.default.string,
          // Unique id for the value - used for aria
          onClick: _propTypes2.default.func,
          // method to handle click on value label
          onRemove: _propTypes2.default.func,
          // method to handle removal of the value
          value: _propTypes2.default.object.isRequired // the option object for this value
        };

        exports.default = Value;

        /***/
      }, /* 187 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var arrowRenderer = function arrowRenderer(_ref) {
          var onMouseDown = _ref.onMouseDown;
          return _react2.default.createElement('span', {
            className: 'Select-arrow',
            onMouseDown: onMouseDown
          });
        };
        arrowRenderer.propTypes = {
          onMouseDown: _propTypes2.default.func
        };
        exports.default = arrowRenderer;

        /***/
      }, /* 188 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var clearRenderer = function clearRenderer() {
          return _react2.default.createElement('span', {
            className: 'Select-clear',
            dangerouslySetInnerHTML: {
              __html: '&times;'
            }
          });
        };
        exports.default = clearRenderer;

        /***/
      }, /* 189 */
      /***/function (module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var map = [{
          'base': 'A',
          'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
        }, {
          'base': 'AA',
          'letters': /[\uA732]/g
        }, {
          'base': 'AE',
          'letters': /[\u00C6\u01FC\u01E2]/g
        }, {
          'base': 'AO',
          'letters': /[\uA734]/g
        }, {
          'base': 'AU',
          'letters': /[\uA736]/g
        }, {
          'base': 'AV',
          'letters': /[\uA738\uA73A]/g
        }, {
          'base': 'AY',
          'letters': /[\uA73C]/g
        }, {
          'base': 'B',
          'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
        }, {
          'base': 'C',
          'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
        }, {
          'base': 'D',
          'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
        }, {
          'base': 'DZ',
          'letters': /[\u01F1\u01C4]/g
        }, {
          'base': 'Dz',
          'letters': /[\u01F2\u01C5]/g
        }, {
          'base': 'E',
          'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
        }, {
          'base': 'F',
          'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
        }, {
          'base': 'G',
          'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
        }, {
          'base': 'H',
          'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
        }, {
          'base': 'I',
          'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
        }, {
          'base': 'J',
          'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g
        }, {
          'base': 'K',
          'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
        }, {
          'base': 'L',
          'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
        }, {
          'base': 'LJ',
          'letters': /[\u01C7]/g
        }, {
          'base': 'Lj',
          'letters': /[\u01C8]/g
        }, {
          'base': 'M',
          'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
        }, {
          'base': 'N',
          'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
        }, {
          'base': 'NJ',
          'letters': /[\u01CA]/g
        }, {
          'base': 'Nj',
          'letters': /[\u01CB]/g
        }, {
          'base': 'O',
          'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
        }, {
          'base': 'OI',
          'letters': /[\u01A2]/g
        }, {
          'base': 'OO',
          'letters': /[\uA74E]/g
        }, {
          'base': 'OU',
          'letters': /[\u0222]/g
        }, {
          'base': 'P',
          'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
        }, {
          'base': 'Q',
          'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
        }, {
          'base': 'R',
          'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
        }, {
          'base': 'S',
          'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
        }, {
          'base': 'T',
          'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
        }, {
          'base': 'TZ',
          'letters': /[\uA728]/g
        }, {
          'base': 'U',
          'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
        }, {
          'base': 'V',
          'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
        }, {
          'base': 'VY',
          'letters': /[\uA760]/g
        }, {
          'base': 'W',
          'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
        }, {
          'base': 'X',
          'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
        }, {
          'base': 'Y',
          'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
        }, {
          'base': 'Z',
          'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
        }, {
          'base': 'a',
          'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
        }, {
          'base': 'aa',
          'letters': /[\uA733]/g
        }, {
          'base': 'ae',
          'letters': /[\u00E6\u01FD\u01E3]/g
        }, {
          'base': 'ao',
          'letters': /[\uA735]/g
        }, {
          'base': 'au',
          'letters': /[\uA737]/g
        }, {
          'base': 'av',
          'letters': /[\uA739\uA73B]/g
        }, {
          'base': 'ay',
          'letters': /[\uA73D]/g
        }, {
          'base': 'b',
          'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
        }, {
          'base': 'c',
          'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
        }, {
          'base': 'd',
          'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
        }, {
          'base': 'dz',
          'letters': /[\u01F3\u01C6]/g
        }, {
          'base': 'e',
          'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
        }, {
          'base': 'f',
          'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
        }, {
          'base': 'g',
          'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
        }, {
          'base': 'h',
          'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
        }, {
          'base': 'hv',
          'letters': /[\u0195]/g
        }, {
          'base': 'i',
          'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
        }, {
          'base': 'j',
          'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
        }, {
          'base': 'k',
          'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
        }, {
          'base': 'l',
          'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
        }, {
          'base': 'lj',
          'letters': /[\u01C9]/g
        }, {
          'base': 'm',
          'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
        }, {
          'base': 'n',
          'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
        }, {
          'base': 'nj',
          'letters': /[\u01CC]/g
        }, {
          'base': 'o',
          'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
        }, {
          'base': 'oi',
          'letters': /[\u01A3]/g
        }, {
          'base': 'ou',
          'letters': /[\u0223]/g
        }, {
          'base': 'oo',
          'letters': /[\uA74F]/g
        }, {
          'base': 'p',
          'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
        }, {
          'base': 'q',
          'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
        }, {
          'base': 'r',
          'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
        }, {
          'base': 's',
          'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
        }, {
          'base': 't',
          'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
        }, {
          'base': 'tz',
          'letters': /[\uA729]/g
        }, {
          'base': 'u',
          'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
        }, {
          'base': 'v',
          'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
        }, {
          'base': 'vy',
          'letters': /[\uA761]/g
        }, {
          'base': 'w',
          'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
        }, {
          'base': 'x',
          'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
        }, {
          'base': 'y',
          'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
        }, {
          'base': 'z',
          'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
        }];
        var stripDiacritics = function stripDiacritics(str) {
          for (var i = 0; i < map.length; i++) {
            str = str.replace(map[i].letters, map[i].base);
          }
          return str;
        };
        exports.default = stripDiacritics;

        /***/
      }, /* 190 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(250);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      }, /* 191 */
      /***/function (module, exports, __webpack_require__) {
        var ListCache = __webpack_require__(71),
          stackClear = __webpack_require__(452),
          stackDelete = __webpack_require__(453),
          stackGet = __webpack_require__(454),
          stackHas = __webpack_require__(455),
          stackSet = __webpack_require__(456);

        /**
         * Creates a stack cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }

        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        module.exports = Stack;

        /***/
      }, /* 192 */
      /***/function (module, exports, __webpack_require__) {
        var castPath = __webpack_require__(194),
          toKey = __webpack_require__(76);

        /**
         * The base implementation of `_.get` without support for default values.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @returns {*} Returns the resolved value.
         */
        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0,
            length = path.length;
          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }
          return index && index == length ? object : undefined;
        }
        module.exports = baseGet;

        /***/
      }, /* 193 */
      /***/function (module, exports, __webpack_require__) {
        var baseIsEqualDeep = __webpack_require__(397),
          isObjectLike = __webpack_require__(39);

        /**
         * The base implementation of `_.isEqual` which supports partial comparisons
         * and tracks traversed objects.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @param {boolean} bitmask The bitmask flags.
         *  1 - Unordered comparison
         *  2 - Partial comparison
         * @param {Function} [customizer] The function to customize comparisons.
         * @param {Object} [stack] Tracks traversed `value` and `other` objects.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         */
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        module.exports = baseIsEqual;

        /***/
      }, /* 194 */
      /***/function (module, exports, __webpack_require__) {
        var isArray = __webpack_require__(17),
          isKey = __webpack_require__(98),
          stringToPath = __webpack_require__(457),
          toString = __webpack_require__(466);

        /**
         * Casts `value` to a path array if it's not one.
         *
         * @private
         * @param {*} value The value to inspect.
         * @param {Object} [object] The object to query keys on.
         * @returns {Array} Returns the cast property path array.
         */
        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        module.exports = castPath;

        /***/
      }, /* 195 */
      /***/function (module, exports, __webpack_require__) {
        var SetCache = __webpack_require__(380),
          arraySome = __webpack_require__(388),
          cacheHas = __webpack_require__(410);

        /** Used to compose bitmasks for value comparisons. */
        var COMPARE_PARTIAL_FLAG = 1,
          COMPARE_UNORDERED_FLAG = 2;

        /**
         * A specialized version of `baseIsEqualDeep` for arrays with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Array} array The array to compare.
         * @param {Array} other The other array to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `array` and `other` objects.
         * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
         */
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
            arrLength = array.length,
            othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(array);
          if (stacked && stack.get(other)) {
            return stacked == other;
          }
          var index = -1,
            result = true,
            seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
          stack.set(array, other);
          stack.set(other, array);

          // Ignore non-index properties.
          while (++index < arrLength) {
            var arrValue = array[index],
              othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined) {
              if (compared) {
                continue;
              }
              result = false;
              break;
            }
            // Recursively compare arrays (susceptible to call stack limits).
            if (seen) {
              if (!arraySome(other, function (othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result = false;
              break;
            }
          }
          stack['delete'](array);
          stack['delete'](other);
          return result;
        }
        module.exports = equalArrays;

        /***/
      }, /* 196 */
      163, /* 197 */
      164, /* 198 */
      /***/function (module, exports, __webpack_require__) {
        var isObject = __webpack_require__(100);

        /**
         * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` if suitable for strict
         *  equality comparisons, else `false`.
         */
        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }
        module.exports = isStrictComparable;

        /***/
      }, /* 199 */
      /***/function (module, exports) {
        /**
         * A specialized version of `matchesProperty` for source values suitable
         * for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {string} key The key of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */
        function matchesStrictComparable(key, srcValue) {
          return function (object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
          };
        }
        module.exports = matchesStrictComparable;

        /***/
      }, /* 200 */
      /***/function (module, exports) {
        /** Used for built-in method references. */
        var funcProto = Function.prototype;

        /** Used to resolve the decompiled source of functions. */
        var funcToString = funcProto.toString;

        /**
         * Converts `func` to its source code.
         *
         * @private
         * @param {Function} func The function to convert.
         * @returns {string} Returns the source code.
         */
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {}
            try {
              return func + '';
            } catch (e) {}
          }
          return '';
        }
        module.exports = toSource;

        /***/
      }, /* 201 */
      63, /* 202 */
      [1652, 396, 39], /* 203 */
      [1653, 205, 99], /* 204 */
      [1657, 16, 465], /* 205 */
      [1661, 38, 100], /* 206 */
      [1662, 400, 409, 446],,,, /* 210 */
      /***/function (module, exports, __webpack_require__) {
        "use strict";

        // rawAsap provides everything we need except exception management.
        var rawAsap = __webpack_require__(211);
        // RawTasks are recycled to reduce GC churn.
        var freeTasks = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        var pendingErrors = [];
        var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
        function throwFirstError() {
          if (pendingErrors.length) {
            throw pendingErrors.shift();
          }
        }

        /**
         * Calls a task as soon as possible after returning, in its own event, with priority
         * over other events like animation, reflow, and repaint. An error thrown from an
         * event will not interrupt, nor even substantially slow down the processing of
         * other events, but will be rather postponed to a lower priority event.
         * @param {{call}} task A callable object, typically a function that takes no
         * arguments.
         */
        module.exports = asap;
        function asap(task) {
          var rawTask;
          if (freeTasks.length) {
            rawTask = freeTasks.pop();
          } else {
            rawTask = new RawTask();
          }
          rawTask.task = task;
          rawAsap(rawTask);
        }

        // We wrap tasks with recyclable task objects.  A task object implements
        // `call`, just like a function.
        function RawTask() {
          this.task = null;
        }

        // The sole purpose of wrapping the task is to catch the exception and recycle
        // the task object after its single use.
        RawTask.prototype.call = function () {
          try {
            this.task.call();
          } catch (error) {
            if (asap.onerror) {
              // This hook exists purely for testing purposes.
              // Its name will be periodically randomized to break any code that
              // depends on its existence.
              asap.onerror(error);
            } else {
              // In a web browser, exceptions are not fatal. However, to avoid
              // slowing down the queue of pending tasks, we rethrow the error in a
              // lower priority turn.
              pendingErrors.push(error);
              requestErrorThrow();
            }
          } finally {
            this.task = null;
            freeTasks[freeTasks.length] = this;
          }
        };

        /***/
      }, /* 211 */
      /***/function (module, exports, __webpack_require__) {
        "use strict";

        // Use the fastest means possible to execute a task in its own turn, with
        // priority over other events including IO, animation, reflow, and redraw
        // events in browsers.
        //
        // An exception thrown by a task will permanently interrupt the processing of
        // subsequent tasks. The higher level `asap` function ensures that if an
        // exception is thrown by a task, that the task queue will continue flushing as
        // soon as possible, but if you use `rawAsap` directly, you are responsible to
        // either ensure that no exceptions are thrown from your task, or to manually
        // call `rawAsap.requestFlush` if an exception is thrown.
        module.exports = rawAsap;
        function rawAsap(task) {
          if (!queue.length) {
            requestFlush();
            flushing = true;
          }
          // Equivalent to push, but avoids a function call.
          queue[queue.length] = task;
        }
        var queue = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        var flushing = false;
        // `requestFlush` is an implementation-specific method that attempts to kick
        // off a `flush` event as quickly as possible. `flush` will attempt to exhaust
        // the event queue before yielding to the browser's own event loop.
        var requestFlush;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        var index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        var capacity = 1024;

        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        function flush() {
          while (index < queue.length) {
            var currentIndex = index;
            // Advance the index before calling the task. This ensures that we will
            // begin flushing on the next task the task throws an error.
            index = index + 1;
            queue[currentIndex].call();
            // Prevent leaking memory for long chains of recursive calls to `asap`.
            // If we call `asap` within tasks scheduled by `asap`, the queue will
            // grow, but to avoid an O(n) walk for every task we execute, we don't
            // shift tasks off the queue after they have been executed.
            // Instead, we periodically shift 1024 tasks off the queue.
            if (index > capacity) {
              // Manually shift all values starting at the index back to the
              // beginning of the queue.
              for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
              }
              queue.length -= index;
              index = 0;
            }
          }
          queue.length = 0;
          index = 0;
          flushing = false;
        }

        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

        // Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
        // have WebKitMutationObserver but not un-prefixed MutationObserver.
        // Must use `global` or `self` instead of `window` to work in both frames and web
        // workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

        /* globals self */
        var scope = typeof window !== "undefined" ? window : self;
        var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

        // MutationObservers are desirable because they have high priority and work
        // reliably everywhere they are implemented.
        // They are implemented in all modern browsers.
        //
        // - Android 4-4.3
        // - Chrome 26-34
        // - Firefox 14-29
        // - Internet Explorer 11
        // - iPad Safari 6-7.1
        // - iPhone Safari 7-7.1
        // - Safari 6-7
        if (typeof BrowserMutationObserver === "function") {
          requestFlush = makeRequestCallFromMutationObserver(flush);

          // MessageChannels are desirable because they give direct access to the HTML
          // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
          // 11-12, and in web workers in many engines.
          // Although message channels yield to any queued rendering and IO tasks, they
          // would be better than imposing the 4ms delay of timers.
          // However, they do not work reliably in Internet Explorer or Safari.

          // Internet Explorer 10 is the only browser that has setImmediate but does
          // not have MutationObservers.
          // Although setImmediate yields to the browser's renderer, it would be
          // preferrable to falling back to setTimeout since it does not have
          // the minimum 4ms penalty.
          // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
          // Desktop to a lesser extent) that renders both setImmediate and
          // MessageChannel useless for the purposes of ASAP.
          // https://github.com/kriskowal/q/issues/396

          // Timers are implemented universally.
          // We fall back to timers in workers in most engines, and in foreground
          // contexts in the following browsers.
          // However, note that even this simple case requires nuances to operate in a
          // broad spectrum of browsers.
          //
          // - Firefox 3-13
          // - Internet Explorer 6-9
          // - iPad Safari 4.3
          // - Lynx 2.8.7
        } else {
          requestFlush = makeRequestCallFromTimer(flush);
        }

        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        rawAsap.requestFlush = requestFlush;

        // To request a high priority event, we induce a mutation observer by toggling
        // the text of a text node between "1" and "-1".
        function makeRequestCallFromMutationObserver(callback) {
          var toggle = 1;
          var observer = new BrowserMutationObserver(callback);
          var node = document.createTextNode("");
          observer.observe(node, {
            characterData: true
          });
          return function requestCall() {
            toggle = -toggle;
            node.data = toggle;
          };
        }

        // The message channel technique was discovered by Malte Ubl and was the
        // original foundation for this library.
        // http://www.nonblocking.io/2011/06/windownexttick.html

        // Safari 6.0.5 (at least) intermittently fails to create message ports on a
        // page's first load. Thankfully, this version of Safari supports
        // MutationObservers, so we don't need to fall back in that case.

        // function makeRequestCallFromMessageChannel(callback) {
        //     var channel = new MessageChannel();
        //     channel.port1.onmessage = callback;
        //     return function requestCall() {
        //         channel.port2.postMessage(0);
        //     };
        // }

        // For reasons explained above, we are also unable to use `setImmediate`
        // under any circumstances.
        // Even if we were, there is another bug in Internet Explorer 10.
        // It is not sufficient to assign `setImmediate` to `requestFlush` because
        // `setImmediate` must be called *by name* and therefore must be wrapped in a
        // closure.
        // Never forget.

        // function makeRequestCallFromSetImmediate(callback) {
        //     return function requestCall() {
        //         setImmediate(callback);
        //     };
        // }

        // Safari 6.0 has a problem where timers will get lost while the user is
        // scrolling. This problem does not impact ASAP because Safari 6.0 supports
        // mutation observers, so that implementation is used instead.
        // However, if we ever elect to use timers in Safari, the prevalent work-around
        // is to add a scroll event listener that calls for a flush.

        // `setTimeout` does not call the passed callback if the delay is less than
        // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
        // even then.

        function makeRequestCallFromTimer(callback) {
          return function requestCall() {
            // We dispatch a timeout with a specified delay of 0 for engines that
            // can reliably accommodate that request. This will usually be snapped
            // to a 4 milisecond delay, but once we're flushing, there's no delay
            // between events.
            var timeoutHandle = setTimeout(handleTimer, 0);
            // However, since this timer gets frequently dropped in Firefox
            // workers, we enlist an interval handle that will try to fire
            // an event 20 times per second until it succeeds.
            var intervalHandle = setInterval(handleTimer, 50);
            function handleTimer() {
              // Whichever timer succeeds will cancel both timers and
              // execute the callback.
              clearTimeout(timeoutHandle);
              clearInterval(intervalHandle);
              callback();
            }
          };
        }

        // This is for `asap.js` only.
        // Its name will be periodically randomized to break any code that depends on
        // its existence.
        rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

        // ASAP was originally a nextTick shim included in Q. This was factored out
        // into this ASAP package. It was later adapted to RSVP which made further
        // amendments. These decisions, particularly to marginalize MessageChannel and
        // to capture the MutationObserver implementation in a closure, were integrated
        // back into ASAP proper.
        // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

        /***/
      }, /* 212 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _AutoCompleteFilter = __webpack_require__(80);
        var _AutoCompleteFilter2 = _interopRequireDefault(_AutoCompleteFilter);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        exports['default'] = function (props) {
          return _react2['default'].createElement(_AutoCompleteFilter2['default'], _extends({}, props, {
            multiSelection: true
          }));
        };

        /***/
      }, /* 213 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _reactDataGrid = __webpack_require__(4);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var ExcelColumn = _reactDataGrid.shapes.ExcelColumn;
        var RuleType = {
          Number: 1,
          Range: 2,
          GreaterThen: 3,
          LessThen: 4
        };
        var NumericFilter = function (_React$Component) {
          _inherits(NumericFilter, _React$Component);
          function NumericFilter(props) {
            _classCallCheck(this, NumericFilter);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.handleChange = _this.handleChange.bind(_this);
            _this.handleKeyPress = _this.handleKeyPress.bind(_this);
            _this.getRules = _this.getRules.bind(_this);
            return _this;
          }
          NumericFilter.prototype.filterValues = function filterValues(row, columnFilter, columnKey) {
            if (columnFilter.filterTerm == null) {
              return true;
            }
            var result = false;
            // implement default filter logic
            var value = parseInt(row[columnKey], 10);
            for (var ruleKey in columnFilter.filterTerm) {
              if (!columnFilter.filterTerm.hasOwnProperty(ruleKey)) {
                continue;
              }
              var rule = columnFilter.filterTerm[ruleKey];
              switch (rule.type) {
                case RuleType.Number:
                  if (rule.value === value) {
                    result = true;
                  }
                  break;
                case RuleType.GreaterThen:
                  if (rule.value <= value) {
                    result = true;
                  }
                  break;
                case RuleType.LessThen:
                  if (rule.value >= value) {
                    result = true;
                  }
                  break;
                case RuleType.Range:
                  if (rule.begin <= value && rule.end >= value) {
                    result = true;
                  }
                  break;
                default:
                  // do nothing
                  break;
              }
            }
            return result;
          };
          NumericFilter.prototype.getRules = function getRules(value) {
            var rules = [];
            if (value === '') {
              return rules;
            }
            // check comma
            var list = value.split(',');
            if (list.length > 0) {
              // handle each value with comma
              for (var key in list) {
                if (!list.hasOwnProperty(key)) {
                  continue;
                }
                var obj = list[key];
                if (obj.indexOf('-') > 0) {
                  // handle dash
                  var begin = parseInt(obj.split('-')[0], 10);
                  var end = parseInt(obj.split('-')[1], 10);
                  rules.push({
                    type: RuleType.Range,
                    begin: begin,
                    end: end
                  });
                } else if (obj.indexOf('>') > -1) {
                  // handle greater then
                  var _begin = parseInt(obj.split('>')[1], 10);
                  rules.push({
                    type: RuleType.GreaterThen,
                    value: _begin
                  });
                } else if (obj.indexOf('<') > -1) {
                  // handle less then
                  var _end = parseInt(obj.split('<')[1], 10);
                  rules.push({
                    type: RuleType.LessThen,
                    value: _end
                  });
                } else {
                  // handle normal values
                  var numericValue = parseInt(obj, 10);
                  rules.push({
                    type: RuleType.Number,
                    value: numericValue
                  });
                }
              }
            }
            return rules;
          };
          NumericFilter.prototype.handleKeyPress = function handleKeyPress(e) {
            // Validate the input
            var regex = '>|<|-|,|([0-9])';
            var result = RegExp(regex).test(e.key);
            if (result === false) {
              e.preventDefault();
            }
          };
          NumericFilter.prototype.handleChange = function handleChange(e) {
            var value = e.target.value;
            var filters = this.getRules(value);
            this.props.onChange({
              filterTerm: filters.length > 0 ? filters : null,
              column: this.props.column,
              rawValue: value,
              filterValues: this.filterValues
            });
          };
          NumericFilter.prototype.render = function render() {
            var inputKey = 'header-filter-' + this.props.column.key;
            var columnStyle = {
              float: 'left',
              marginRight: 5,
              maxWidth: '80%'
            };
            var badgeStyle = {
              cursor: 'help'
            };
            var tooltipText = 'Input Methods: Range (x-y), Greater Then (>x), Less Then (<y)';
            return _react2['default'].createElement('div', null, _react2['default'].createElement('div', {
              style: columnStyle
            }, _react2['default'].createElement('input', {
              key: inputKey,
              type: 'text',
              placeholder: 'e.g. 3,10-15,>20',
              className: 'form-control input-sm',
              onChange: this.handleChange,
              onKeyPress: this.handleKeyPress
            })), _react2['default'].createElement('div', {
              className: 'input-sm'
            }, _react2['default'].createElement('span', {
              className: 'badge',
              style: badgeStyle,
              title: tooltipText
            }, '?')));
          };
          return NumericFilter;
        }(_react2['default'].Component);
        NumericFilter.propTypes = {
          onChange: _propTypes2['default'].func.isRequired,
          column: _propTypes2['default'].shape(ExcelColumn)
        };
        module.exports = NumericFilter;

        /***/
      }, /* 214 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _AutoCompleteFilter = __webpack_require__(80);
        var _AutoCompleteFilter2 = _interopRequireDefault(_AutoCompleteFilter);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        exports['default'] = function (props) {
          return _react2['default'].createElement(_AutoCompleteFilter2['default'], _extends({}, props, {
            multiSelection: false
          }));
        };

        /***/
      }, /* 215 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _NumericFilter = __webpack_require__(213);
        var _NumericFilter2 = _interopRequireDefault(_NumericFilter);
        var _AutoCompleteFilter = __webpack_require__(80);
        var _AutoCompleteFilter2 = _interopRequireDefault(_AutoCompleteFilter);
        var _MultiSelectFilter = __webpack_require__(212);
        var _MultiSelectFilter2 = _interopRequireDefault(_MultiSelectFilter);
        var _SingleSelectFilter = __webpack_require__(214);
        var _SingleSelectFilter2 = _interopRequireDefault(_SingleSelectFilter);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var Filters = {
          NumericFilter: _NumericFilter2['default'],
          AutoCompleteFilter: _AutoCompleteFilter2['default'],
          MultiSelectFilter: _MultiSelectFilter2['default'],
          SingleSelectFilter: _SingleSelectFilter2['default']
        };
        module.exports = Filters;

        /***/
      }, /* 216 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _reactDataGrid = __webpack_require__(4);
        var getMixedTypeValueRetriever = _reactDataGrid.utils.getMixedTypeValueRetriever,
          isImmutableCollection = _reactDataGrid.utils.isImmutableCollection;
        var filterRows = function filterRows(filters) {
          var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          return rows.filter(function (r) {
            var retriever = getMixedTypeValueRetriever(isImmutableCollection(r));
            var include = true;
            for (var columnKey in filters) {
              if (filters.hasOwnProperty(columnKey)) {
                var colFilter = filters[columnKey];
                // check if custom filter function exists
                if (colFilter.filterValues && typeof colFilter.filterValues === 'function') {
                  include = include & colFilter.filterValues(r, colFilter, columnKey);
                } else if (typeof colFilter.filterTerm === 'string') {
                  // default filter action
                  var rowValue = retriever.getValue(r, columnKey);
                  if (rowValue !== undefined && rowValue !== null) {
                    if (rowValue.toString().toLowerCase().indexOf(colFilter.filterTerm.toLowerCase()) === -1) {
                      include = include & false;
                    }
                  } else {
                    include = include & false;
                  }
                }
              }
            }
            return Boolean(include);
          });
        };
        module.exports = filterRows;

        /***/
      }, /* 217 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _reactDataGrid = __webpack_require__(4);
        var _RowGrouperResolver = __webpack_require__(218);
        var _RowGrouperResolver2 = _interopRequireDefault(_RowGrouperResolver);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var isImmutableCollection = _reactDataGrid.utils.isImmutableCollection;
        var RowGrouper = function () {
          function RowGrouper(columns, expandedRows) {
            var isImmutable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            _classCallCheck(this, RowGrouper);
            this.columns = columns.slice(0);
            this.expandedRows = expandedRows;
            this.resolver = new _RowGrouperResolver2['default'](isImmutable);
          }
          RowGrouper.prototype.isRowExpanded = function isRowExpanded(columnName, name) {
            var isExpanded = true;
            var expandedRowGroup = this.expandedRows[columnName];
            if (expandedRowGroup && expandedRowGroup[name]) {
              isExpanded = expandedRowGroup[name].isExpanded;
            }
            return isExpanded;
          };
          RowGrouper.prototype.groupRowsByColumn = function groupRowsByColumn(rows) {
            var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var nextColumnIndex = columnIndex;
            var columnName = this.columns.length > 0 && typeof this.columns[columnIndex] === 'string' ? this.columns[columnIndex] : this.columns[columnIndex].key;
            var groupedRows = this.resolver.getGroupedRows(rows, columnName);
            var keys = this.resolver.getGroupKeys(groupedRows);
            var dataviewRows = this.resolver.initRowsCollection();
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var isExpanded = this.isRowExpanded(columnName, key);
              var rowGroupHeader = {
                name: key,
                __metaData: {
                  isGroup: true,
                  treeDepth: columnIndex,
                  isExpanded: isExpanded,
                  columnGroupName: columnName
                }
              };
              dataviewRows = this.resolver.addHeaderRow(rowGroupHeader, dataviewRows);
              if (isExpanded) {
                nextColumnIndex = columnIndex + 1;
                if (this.columns.length > nextColumnIndex) {
                  dataviewRows = dataviewRows.concat(this.groupRowsByColumn(this.resolver.getRowObj(groupedRows, key), nextColumnIndex));
                  nextColumnIndex = columnIndex - 1;
                } else {
                  dataviewRows = dataviewRows.concat(this.resolver.getRowObj(groupedRows, key));
                }
              }
            }
            return dataviewRows;
          };
          return RowGrouper;
        }();
        var groupRows = function groupRows(rows, groupedColumns, expandedRows) {
          var rowGrouper = new RowGrouper(groupedColumns, expandedRows, isImmutableCollection(rows));
          return rowGrouper.groupRowsByColumn(rows, 0);
        };
        module.exports = groupRows;

        /***/
      }, /* 218 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _immutable = __webpack_require__(18);
        var _groupBy = __webpack_require__(459);
        var _groupBy2 = _interopRequireDefault(_groupBy);
        var _reactDataGrid = __webpack_require__(4);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var getMixedTypeValueRetriever = _reactDataGrid.utils.getMixedTypeValueRetriever,
          isImmutableMap = _reactDataGrid.utils.isImmutableMap;
        var RowGrouperResolver = function () {
          function RowGrouperResolver(isImmutable) {
            _classCallCheck(this, RowGrouperResolver);
            this.isImmutable = isImmutable;
            this.getRowObj = getMixedTypeValueRetriever(isImmutable).getValue;
          }
          RowGrouperResolver.prototype.initRowsCollection = function initRowsCollection() {
            return this.isImmutable ? new _immutable.List() : [];
          };
          RowGrouperResolver.prototype.getGroupedRows = function getGroupedRows(rows, columnName) {
            return this.isImmutable ? rows.groupBy(function (x) {
              return isImmutableMap(x) ? x.get(columnName) : x[columnName];
            }) : (0, _groupBy2['default'])(rows, columnName);
          };
          RowGrouperResolver.prototype.getGroupKeys = function getGroupKeys(groupedRows) {
            var getKeys = Object.keys;
            if (this.isImmutable) {
              getKeys = function getKeys(col) {
                var keys = [];
                var iterator = col.keys();
                var item = iterator.next();
                while (!item.done) {
                  keys.push(item.value);
                  item = iterator.next();
                }
                return keys;
              };
            }
            return getKeys(groupedRows);
          };
          RowGrouperResolver.prototype.addHeaderRow = function addHeaderRow(rowGroupHeader, dataviewRows) {
            var rows = dataviewRows;
            var dvRows = rows.push(rowGroupHeader);
            if (this.isImmutable) {
              return dvRows;
            }
            return rows;
          };
          return RowGrouperResolver;
        }();
        exports['default'] = RowGrouperResolver;

        /***/
      }, /* 219 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _reactDataGrid = __webpack_require__(4);
        var getMixedTypeValueRetriever = _reactDataGrid.utils.getMixedTypeValueRetriever,
          isImmutableCollection = _reactDataGrid.utils.isImmutableCollection;
        var comparer = function comparer(a, b) {
          if (a > b) {
            return 1;
          } else if (a < b) {
            return -1;
          }
          return 0;
        };
        var sortRows = function sortRows(rows, sortColumn, sortDirection) {
          var retriever = getMixedTypeValueRetriever(isImmutableCollection(rows));
          var sortDirectionSign = sortDirection === 'ASC' ? 1 : -1;
          var rowComparer = function rowComparer(a, b) {
            return sortDirectionSign * comparer(retriever.getValue(a, sortColumn), retriever.getValue(b, sortColumn));
          };
          if (sortDirection === 'NONE') {
            return rows;
          }
          return rows.slice().sort(rowComparer);
        };
        module.exports = sortRows;
        module.exports.comparer = comparer;

        /***/
      }, /* 220 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        module.exports = {
          Selectors: __webpack_require__(149)
        };

        /***/
      }, /* 221 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _html5DragDropContext = __webpack_require__(152);
        var _html5DragDropContext2 = _interopRequireDefault(_html5DragDropContext);
        var _DraggableHeaderCell = __webpack_require__(222);
        var _DraggableHeaderCell2 = _interopRequireDefault(_DraggableHeaderCell);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var DraggableContainer = function (_React$Component) {
          _inherits(DraggableContainer, _React$Component);
          function DraggableContainer() {
            _classCallCheck(this, DraggableContainer);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          DraggableContainer.prototype.renderGrid = function renderGrid() {
            return _react2['default'].Children.map(this.props.children, function (child) {
              return _react2['default'].cloneElement(child, {
                draggableHeaderCell: _DraggableHeaderCell2['default']
              });
            })[0];
          };
          DraggableContainer.prototype.render = function render() {
            var grid = this.renderGrid();
            return _react2['default'].createElement('div', null, _react2['default'].cloneElement(grid, this.props));
          };
          return DraggableContainer;
        }(_react2['default'].Component);
        DraggableContainer.propTypes = {
          children: _propTypes2['default'].element
        };
        exports['default'] = (0, _html5DragDropContext2['default'])(DraggableContainer);

        /***/
      }, /* 222 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _reactDnd = __webpack_require__(23);
        var _reactDataGrid = __webpack_require__(4);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var DraggableHeaderCell = function (_React$Component) {
          _inherits(DraggableHeaderCell, _React$Component);
          function DraggableHeaderCell() {
            _classCallCheck(this, DraggableHeaderCell);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          DraggableHeaderCell.prototype.render = function render() {
            var _props = this.props,
              connectDragSource = _props.connectDragSource,
              connectDropTarget = _props.connectDropTarget,
              isDragging = _props.isDragging,
              isOver = _props.isOver,
              canDrop = _props.canDrop;
            var opacity = 1;
            if (isDragging) {
              opacity = 0.2;
            }

            // set drag source and drop target on header cell
            // width: 0 - otherwise drag clone was wrongly positioned
            return connectDragSource(connectDropTarget(_react2['default'].createElement('div', {
              style: {
                width: 0,
                cursor: 'move',
                opacity: opacity
              },
              className: isOver && canDrop ? 'rdg-can-drop' : ''
            }, _react2['default'].createElement(_reactDataGrid.HeaderCell, this.props))));
          };
          return DraggableHeaderCell;
        }(_react2['default'].Component);

        // drop source

        function collect(connect, monitor) {
          return {
            connectDragSource: connect.dragSource(),
            isDragging: monitor.isDragging()
          };
        }
        var headerCellSource = {
          beginDrag: function beginDrag(props) {
            return {
              // source column
              key: props.column.key
            };
          },
          endDrag: function endDrag(props, monitor) {
            // check if drop was made in droppable zone
            if (monitor.didDrop()) {
              var source = monitor.getDropResult().source;
              var _target = monitor.getDropResult().target;
              return props.onHeaderDrop(source, _target);
            }
          }
        };

        // drop target
        var target = {
          drop: function drop(props, monitor) {
            var source = monitor.getItem().key;
            var targetKey = props.column.key;
            return {
              source: source,
              target: targetKey
            };
          }
        };
        function targetCollect(connect, monitor) {
          return {
            connectDropTarget: connect.dropTarget(),
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
            draggedHeader: monitor.getItem()
          };
        }
        DraggableHeaderCell.propTypes = {
          connectDragSource: _propTypes2['default'].func.isRequired,
          connectDropTarget: _propTypes2['default'].func.isRequired,
          isDragging: _propTypes2['default'].bool.isRequired,
          isOver: _propTypes2['default'].bool,
          canDrop: _propTypes2['default'].bool
        };
        DraggableHeaderCell = (0, _reactDnd.DropTarget)('Column', target, targetCollect)(DraggableHeaderCell);
        DraggableHeaderCell = (0, _reactDnd.DragSource)('Column', headerCellSource, collect)(DraggableHeaderCell);
        exports['default'] = DraggableHeaderCell;

        /***/
      }, /* 223 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _DraggableContainer = __webpack_require__(221);
        var _DraggableContainer2 = _interopRequireDefault(_DraggableContainer);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        module.exports = {
          DraggableContainer: _DraggableContainer2['default']
        };

        /***/
      }, /* 224 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _html5DragDropContext = __webpack_require__(152);
        var _html5DragDropContext2 = _interopRequireDefault(_html5DragDropContext);
        var _DraggableHeaderCell = __webpack_require__(150);
        var _DraggableHeaderCell2 = _interopRequireDefault(_DraggableHeaderCell);
        var _RowDragLayer = __webpack_require__(227);
        var _RowDragLayer2 = _interopRequireDefault(_RowDragLayer);
        var _reactDataGrid = __webpack_require__(4);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var isColumnsImmutable = _reactDataGrid.utils.isColumnsImmutable;
        var DraggableContainer = function (_Component) {
          _inherits(DraggableContainer, _Component);
          function DraggableContainer() {
            _classCallCheck(this, DraggableContainer);
            return _possibleConstructorReturn(this, _Component.apply(this, arguments));
          }
          DraggableContainer.prototype.getRows = function getRows(rowsCount, rowGetter) {
            var rows = [];
            for (var j = 0; j < rowsCount; j++) {
              rows.push(rowGetter(j));
            }
            return rows;
          };
          DraggableContainer.prototype.renderGrid = function renderGrid() {
            return _react2['default'].Children.map(this.props.children, function (child) {
              return _react2['default'].cloneElement(child, {
                draggableHeaderCell: _DraggableHeaderCell2['default']
              });
            })[0];
          };
          DraggableContainer.prototype.render = function render() {
            var grid = this.renderGrid();
            var rowGetter = this.props.getDragPreviewRow || grid.props.rowGetter;
            var rowsCount = grid.props.rowsCount;
            var columns = grid.props.columns;
            var rows = this.getRows(rowsCount, rowGetter);
            return _react2['default'].createElement('div', null, grid, _react2['default'].createElement(_RowDragLayer2['default'], {
              rowSelection: grid.props.rowSelection,
              rows: rows,
              columns: isColumnsImmutable(columns) ? columns.toArray() : columns
            }));
          };
          return DraggableContainer;
        }(_react.Component);
        DraggableContainer.propTypes = {
          children: _propTypes2['default'].element.isRequired,
          getDragPreviewRow: _propTypes2['default'].func
        };
        exports['default'] = (0, _html5DragDropContext2['default'])(DraggableContainer);

        /***/
      }, /* 225 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        __webpack_require__(371);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _reactDom = __webpack_require__(9);
        var _reactDom2 = _interopRequireDefault(_reactDom);
        var _reactDnd = __webpack_require__(23);
        var _reactDataGrid = __webpack_require__(4);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var rowDropTarget = function rowDropTarget(Row) {
          return function (_React$Component) {
            _inherits(_class, _React$Component);
            function _class() {
              _classCallCheck(this, _class);
              return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
            }
            _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
              return (0, _reactDataGrid.RowComparer)(nextProps, this.props);
            };
            _class.prototype.moveRow = function moveRow() {
              _reactDom2['default'].findDOMNode(this).classList.add('slideUp');
            };
            _class.prototype.render = function render() {
              var _this2 = this;
              var _props = this.props,
                connectDropTarget = _props.connectDropTarget,
                isOver = _props.isOver,
                canDrop = _props.canDrop;
              var overlayTop = this.props.idx * this.props.height;
              return connectDropTarget(_react2['default'].createElement('div', null, _react2['default'].createElement(Row, _extends({
                ref: function ref(node) {
                  return _this2.row = node;
                }
              }, this.props)), isOver && canDrop && _react2['default'].createElement('div', {
                style: {
                  position: 'absolute',
                  top: overlayTop,
                  left: 0,
                  height: this.props.height,
                  width: '100%',
                  zIndex: 1,
                  borderBottom: '1px solid black'
                }
              })));
            };
            return _class;
          }(_react2['default'].Component);
        };
        var target = {
          drop: function drop(props, monitor, component) {
            // Obtain the dragged item
            component.moveRow();
            var rowSource = monitor.getItem();
            var rowTarget = {
              idx: props.idx,
              data: props.row
            };
            props.onRowDrop({
              rowSource: rowSource,
              rowTarget: rowTarget
            });
          }
        };
        function collect(connect, monitor) {
          return {
            connectDropTarget: connect.dropTarget(),
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
            draggedRow: monitor.getItem()
          };
        }
        exports['default'] = function (Row) {
          return (0, _reactDnd.DropTarget)('Row', target, collect, {
            arePropsEqual: function arePropsEqual(nextProps, currentProps) {
              return !(0, _reactDataGrid.RowComparer)(nextProps, currentProps);
            }
          })(rowDropTarget(Row));
        };

        /***/
      }, /* 226 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        __webpack_require__(29);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _reactDnd = __webpack_require__(23);
        var _reactDataGrid = __webpack_require__(4);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var CheckboxEditor = _reactDataGrid.editors.CheckboxEditor;
        var RowActionsCell = function (_React$Component) {
          _inherits(RowActionsCell, _React$Component);
          function RowActionsCell() {
            _classCallCheck(this, RowActionsCell);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          RowActionsCell.prototype.renderRowIndex = function renderRowIndex() {
            return _react2['default'].createElement('div', {
              className: 'rdg-row-index'
            }, this.props.rowIdx + 1);
          };
          RowActionsCell.prototype.render = function render() {
            var _props = this.props,
              connectDragSource = _props.connectDragSource,
              rowSelection = _props.rowSelection;
            var rowHandleStyle = rowSelection != null ? {
              position: 'absolute',
              marginTop: '5px'
            } : {};
            var isSelected = this.props.value;
            var editorClass = isSelected ? 'rdg-actions-checkbox selected' : 'rdg-actions-checkbox';
            return connectDragSource(_react2['default'].createElement('div', null, _react2['default'].createElement('div', {
              className: 'rdg-drag-row-handle',
              style: rowHandleStyle
            }), !isSelected ? this.renderRowIndex() : null, rowSelection != null && _react2['default'].createElement('div', {
              className: editorClass
            }, _react2['default'].createElement(CheckboxEditor, {
              column: this.props.column,
              rowIdx: this.props.rowIdx,
              dependentValues: this.props.dependentValues,
              value: this.props.value
            }))));
          };
          return RowActionsCell;
        }(_react2['default'].Component);
        RowActionsCell.propTypes = {
          rowIdx: _propTypes2['default'].number.isRequired,
          connectDragSource: _propTypes2['default'].func.isRequired,
          connectDragPreview: _propTypes2['default'].func.isRequired,
          isDragging: _propTypes2['default'].bool.isRequired,
          isRowHovered: _propTypes2['default'].bool,
          column: _propTypes2['default'].object,
          dependentValues: _propTypes2['default'].object,
          value: _propTypes2['default'].bool,
          rowSelection: _propTypes2['default'].object.isRequired
        };
        RowActionsCell.defaultProps = {
          rowIdx: 0
        };
        function collect(connect, monitor) {
          return {
            connectDragSource: connect.dragSource(),
            isDragging: monitor.isDragging(),
            connectDragPreview: connect.dragPreview()
          };
        }
        var rowIndexSource = {
          beginDrag: function beginDrag(props) {
            return {
              idx: props.rowIdx,
              data: props.dependentValues
            };
          },
          endDrag: function endDrag(props) {
            return {
              idx: props.rowIdx,
              data: props.dependentValues
            };
          }
        };
        exports['default'] = (0, _reactDnd.DragSource)('Row', rowIndexSource, collect)(RowActionsCell);

        /***/
      }, /* 227 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _reactDnd = __webpack_require__(23);
        var _Selectors = __webpack_require__(149);
        var _Selectors2 = _interopRequireDefault(_Selectors);
        __webpack_require__(37);
        __webpack_require__(29);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var layerStyles = {
          cursor: '-webkit-grabbing',
          position: 'fixed',
          pointerEvents: 'none',
          zIndex: 100,
          left: 0,
          top: 0,
          width: '100%',
          height: '100%'
        };
        function getItemStyles(props) {
          var currentOffset = props.currentOffset;
          if (!currentOffset) {
            return {
              display: 'none'
            };
          }
          var x = currentOffset.x,
            y = currentOffset.y;
          var transform = 'translate(' + x + 'px, ' + y + 'px)';
          return {
            transform: transform,
            WebkitTransform: transform
          };
        }
        var CustomDragLayer = function (_Component) {
          _inherits(CustomDragLayer, _Component);
          function CustomDragLayer() {
            _classCallCheck(this, CustomDragLayer);
            return _possibleConstructorReturn(this, _Component.apply(this, arguments));
          }
          CustomDragLayer.prototype.isDraggedRowSelected = function isDraggedRowSelected(selectedRows) {
            var _props = this.props,
              item = _props.item,
              rowSelection = _props.rowSelection;
            if (selectedRows && selectedRows.length > 0) {
              var key = rowSelection.selectBy.keys.rowKey;
              return selectedRows.filter(function (r) {
                return r[key] === item.data[key];
              }).length > 0;
            }
            return false;
          };
          CustomDragLayer.prototype.getDraggedRows = function getDraggedRows() {
            var draggedRows = void 0;
            var rowSelection = this.props.rowSelection;
            if (rowSelection && rowSelection.selectBy.keys) {
              var rows = this.props.rows;
              var _rowSelection$selectB = rowSelection.selectBy.keys,
                rowKey = _rowSelection$selectB.rowKey,
                values = _rowSelection$selectB.values;
              var selectedRows = _Selectors2['default'].getSelectedRowsByKey({
                rowKey: rowKey,
                selectedKeys: values,
                rows: rows
              });
              draggedRows = this.isDraggedRowSelected(selectedRows) ? selectedRows : [this.props.rows[this.props.item.idx]];
            } else {
              draggedRows = [this.props.rows[this.props.item.idx]];
            }
            return draggedRows;
          };
          CustomDragLayer.prototype.renderDraggedRows = function renderDraggedRows() {
            var _this2 = this;
            var columns = this.props.columns;
            return this.getDraggedRows().map(function (r, i) {
              return _react2['default'].createElement('tr', {
                key: 'dragged-row-' + i
              }, _this2.renderDraggedCells(r, i, columns));
            });
          };
          CustomDragLayer.prototype.renderDraggedCells = function renderDraggedCells(item, rowIdx, columns) {
            var cells = [];
            if (item != null) {
              columns.forEach(function (c) {
                if (item.hasOwnProperty(c.key)) {
                  if (c.formatter) {
                    var Formatter = c.formatter;
                    var dependentValues = typeof c.getRowMetaData === 'function' ? c.getRowMetaData(item, c) : {};
                    cells.push(_react2['default'].createElement('td', {
                      key: 'dragged-cell-' + rowIdx + '-' + c.key,
                      className: 'react-grid-Cell',
                      style: {
                        padding: '5px'
                      }
                    }, _react2['default'].createElement(Formatter, {
                      dependentValues: dependentValues,
                      value: item[c.key]
                    })));
                  } else {
                    cells.push(_react2['default'].createElement('td', {
                      key: 'dragged-cell-' + rowIdx + '-' + c.key,
                      className: 'react-grid-Cell',
                      style: {
                        padding: '5px'
                      }
                    }, item[c.key]));
                  }
                }
              });
            }
            return cells;
          };
          CustomDragLayer.prototype.render = function render() {
            var isDragging = this.props.isDragging;
            if (!isDragging) {
              return null;
            }
            var draggedRows = this.renderDraggedRows();
            return _react2['default'].createElement('div', {
              style: layerStyles,
              className: 'rdg-dragging'
            }, _react2['default'].createElement('div', {
              style: getItemStyles(this.props),
              className: 'rdg-dragging'
            }, _react2['default'].createElement('table', null, _react2['default'].createElement('tbody', null, draggedRows))));
          };
          return CustomDragLayer;
        }(_react.Component);
        CustomDragLayer.propTypes = {
          item: _propTypes2['default'].object,
          itemType: _propTypes2['default'].string,
          currentOffset: _propTypes2['default'].shape({
            x: _propTypes2['default'].number.isRequired,
            y: _propTypes2['default'].number.isRequired
          }),
          isDragging: _propTypes2['default'].bool.isRequired,
          rowSelection: _propTypes2['default'].object,
          rows: _propTypes2['default'].array.isRequired,
          columns: _propTypes2['default'].array.isRequired
        };
        function collect(monitor) {
          return {
            item: monitor.getItem(),
            itemType: monitor.getItemType(),
            currentOffset: monitor.getSourceClientOffset(),
            isDragging: monitor.isDragging()
          };
        }
        exports['default'] = (0, _reactDnd.DragLayer)(collect)(CustomDragLayer);

        /***/
      }, /* 228 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _DragDropContainer = __webpack_require__(224);
        var _DragDropContainer2 = _interopRequireDefault(_DragDropContainer);
        var _DraggableHeaderCell = __webpack_require__(150);
        var _DraggableHeaderCell2 = _interopRequireDefault(_DraggableHeaderCell);
        var _RowActionsCell = __webpack_require__(226);
        var _RowActionsCell2 = _interopRequireDefault(_RowActionsCell);
        var _DropTargetRowContainer = __webpack_require__(225);
        var _DropTargetRowContainer2 = _interopRequireDefault(_DropTargetRowContainer);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        module.exports = {
          Container: _DragDropContainer2['default'],
          DraggableHeaderCell: _DraggableHeaderCell2['default'],
          RowActionsCell: _RowActionsCell2['default'],
          DropTargetRowContainer: _DropTargetRowContainer2['default']
        };

        /***/
      }, /* 229 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var ReactDOM = __webpack_require__(9);
        var ReactAutocomplete = __webpack_require__(369);
        var _require = __webpack_require__(4),
          ExcelColumn = _require.shapes.ExcelColumn;
        __webpack_require__(373);
        var optionPropType = _propTypes2['default'].shape({
          id: _propTypes2['default'].required,
          title: _propTypes2['default'].string
        });
        var AutoCompleteEditor = function (_React$Component) {
          _inherits(AutoCompleteEditor, _React$Component);
          function AutoCompleteEditor() {
            var _temp, _this, _ret;
            _classCallCheck(this, AutoCompleteEditor);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleChange = function () {
              _this.props.onCommit();
            }, _this.getValue = function () {
              var value = void 0;
              var updated = {};
              if (_this.hasResults() && _this.isFocusedOnSuggestion()) {
                value = _this.getLabel(_this.autoComplete.state.focusedValue);
                if (_this.props.valueParams) {
                  value = _this.constuctValueFromParams(_this.autoComplete.state.focusedValue, _this.props.valueParams);
                }
              } else {
                value = _this.autoComplete.state.searchTerm;
              }
              updated[_this.props.column.key] = value;
              return updated;
            }, _this.getEditorDisplayValue = function () {
              var displayValue = {
                title: ''
              };
              var _this$props = _this.props,
                column = _this$props.column,
                value = _this$props.value,
                editorDisplayValue = _this$props.editorDisplayValue;
              if (editorDisplayValue && typeof editorDisplayValue === 'function') {
                displayValue.title = editorDisplayValue(column, value);
              } else {
                displayValue.title = value;
              }
              return displayValue;
            }, _this.getInputNode = function () {
              return ReactDOM.findDOMNode(_this).getElementsByTagName('input')[0];
            }, _this.getLabel = function (item) {
              var label = _this.props.label != null ? _this.props.label : 'title';
              if (typeof label === 'function') {
                return label(item);
              } else if (typeof label === 'string') {
                return item[label];
              }
            }, _this.hasResults = function () {
              return _this.autoComplete.state.results.length > 0;
            }, _this.isFocusedOnSuggestion = function () {
              var autoComplete = _this.autoComplete;
              return autoComplete.state.focusedValue != null;
            }, _this.constuctValueFromParams = function (obj, props) {
              if (!props) {
                return '';
              }
              var ret = [];
              for (var i = 0, ii = props.length; i < ii; i++) {
                ret.push(obj[props[i]]);
              }
              return ret.join('|');
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          AutoCompleteEditor.prototype.render = function render() {
            var _this2 = this;
            var label = this.props.label != null ? this.props.label : 'title';
            return React.createElement('div', {
              height: this.props.height,
              onKeyDown: this.props.onKeyDown
            }, React.createElement(ReactAutocomplete, {
              search: this.props.search,
              ref: function ref(node) {
                return _this2.autoComplete = node;
              },
              label: label,
              onChange: this.handleChange,
              onFocus: this.props.onFocus,
              resultIdentifier: this.props.resultIdentifier,
              options: this.props.options,
              value: this.getEditorDisplayValue()
            }));
          };
          return AutoCompleteEditor;
        }(React.Component);
        AutoCompleteEditor.propTypes = {
          onCommit: _propTypes2['default'].func,
          options: _propTypes2['default'].arrayOf(optionPropType),
          label: _propTypes2['default'].any,
          value: _propTypes2['default'].any,
          height: _propTypes2['default'].number,
          valueParams: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
          column: _propTypes2['default'].shape(ExcelColumn),
          resultIdentifier: _propTypes2['default'].string,
          search: _propTypes2['default'].string,
          onKeyDown: _propTypes2['default'].func,
          onFocus: _propTypes2['default'].func,
          editorDisplayValue: _propTypes2['default'].func
        };
        AutoCompleteEditor.defaultProps = {
          resultIdentifier: 'id'
        };
        module.exports = AutoCompleteEditor;

        /***/
      }, /* 230 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        // Wrapper HOC used when having an editor which is a redux container.
        // Required since react-data-grid requires access to getInputNode, getValue,
        // howvever when doing this.getEditor() in react-data-grid we get a react
        // componenet wrapped by the redux connect function and thus wont have access
        // to the required methods.
        module.exports = function (ContainerEditor) {
          return function (_Component) {
            _inherits(ContainerEditorWrapper, _Component);
            function ContainerEditorWrapper() {
              var _temp, _this, _ret;
              _classCallCheck(this, ContainerEditorWrapper);
              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.createRef = function (ref) {
                _this.editorRef = ref;
              }, _temp), _possibleConstructorReturn(_this, _ret);
            }
            ContainerEditorWrapper.prototype.getInputNode = function getInputNode() {
              return this.editorRef.getInputNode();
            };
            ContainerEditorWrapper.prototype.getValue = function getValue() {
              return this.editorRef.getValue();
            };
            ContainerEditorWrapper.prototype.render = function render() {
              return _react2['default'].createElement(ContainerEditor, _extends({
                refCallback: this.createRef
              }, this.props));
            };
            return ContainerEditorWrapper;
          }(_react.Component);
        };

        /***/
      }, /* 231 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _reactDom = __webpack_require__(9);
        var _reactDom2 = _interopRequireDefault(_reactDom);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        var _require = __webpack_require__(4),
          EditorBase = _require.editors.EditorBase;
        var DropDownEditor = function (_EditorBase) {
          _inherits(DropDownEditor, _EditorBase);
          function DropDownEditor() {
            _classCallCheck(this, DropDownEditor);
            return _possibleConstructorReturn(this, _EditorBase.apply(this, arguments));
          }
          DropDownEditor.prototype.getInputNode = function getInputNode() {
            return _reactDom2['default'].findDOMNode(this);
          };
          DropDownEditor.prototype.onClick = function onClick() {
            this.getInputNode().focus();
          };
          DropDownEditor.prototype.onDoubleClick = function onDoubleClick() {
            this.getInputNode().focus();
          };
          DropDownEditor.prototype.render = function render() {
            return React.createElement('select', {
              style: this.getStyle(),
              defaultValue: this.props.value,
              onBlur: this.props.onBlur,
              onChange: this.onChange
            }, this.renderOptions());
          };
          DropDownEditor.prototype.renderOptions = function renderOptions() {
            var options = [];
            this.props.options.forEach(function (name) {
              if (typeof name === 'string') {
                options.push(React.createElement('option', {
                  key: name,
                  value: name
                }, name));
              } else {
                options.push(React.createElement('option', {
                  key: name.id,
                  value: name.value,
                  title: name.title
                }, name.text || name.value));
              }
            }, this);
            return options;
          };
          return DropDownEditor;
        }(EditorBase);
        DropDownEditor.propTypes = {
          options: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].shape({
            id: _propTypes2['default'].string,
            title: _propTypes2['default'].string,
            value: _propTypes2['default'].string,
            text: _propTypes2['default'].string
          })])).isRequired
        };
        module.exports = DropDownEditor;

        /***/
      }, /* 232 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _require = __webpack_require__(4),
          _require$editors = _require.editors,
          SimpleTextEditor = _require$editors.SimpleTextEditor,
          CheckboxEditor = _require$editors.CheckboxEditor;
        var Editors = {
          AutoComplete: __webpack_require__(229),
          DropDownEditor: __webpack_require__(231),
          ContainerEditorWrapper: __webpack_require__(230),
          SimpleTextEditor: SimpleTextEditor,
          CheckboxEditor: CheckboxEditor
        };
        module.exports = Editors;

        /***/
      }, /* 233 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        // Used for displaying the value of a dropdown (using DropDownEditor) when not editing it.
        // Accepts the same parameters as the DropDownEditor.
        var React = __webpack_require__(2);
        var DropDownFormatter = function (_React$Component) {
          _inherits(DropDownFormatter, _React$Component);
          function DropDownFormatter() {
            _classCallCheck(this, DropDownFormatter);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          DropDownFormatter.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return nextProps.value !== this.props.value;
          };
          DropDownFormatter.prototype.render = function render() {
            var value = this.props.value;
            var option = this.props.options.filter(function (v) {
              return v === value || v.value === value;
            })[0];
            if (!option) {
              option = value;
            }
            var title = option.title || option.value || option;
            var text = option.text || option.value || option;
            return React.createElement('div', {
              title: title
            }, text);
          };
          return DropDownFormatter;
        }(React.Component);
        DropDownFormatter.propTypes = {
          options: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].shape({
            id: _propTypes2['default'].string,
            title: _propTypes2['default'].string,
            value: _propTypes2['default'].string,
            text: _propTypes2['default'].string
          })])).isRequired,
          value: _propTypes2['default'].string.isRequired
        };
        module.exports = DropDownFormatter;

        /***/
      }, /* 234 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        __webpack_require__(372);
        var PendingPool = {};
        var ReadyPool = {};
        var ImageFormatter = function (_React$Component) {
          _inherits(ImageFormatter, _React$Component);
          function ImageFormatter() {
            var _temp, _this, _ret;
            _classCallCheck(this, ImageFormatter);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
              ready: false
            }, _this._load = function (src) {
              var imageSrc = src;
              if (ReadyPool[imageSrc]) {
                _this.setState({
                  value: imageSrc
                });
                return;
              }
              if (PendingPool[imageSrc]) {
                PendingPool[imageSrc].push(_this._onLoad);
                return;
              }
              PendingPool[imageSrc] = [_this._onLoad];
              var img = new Image();
              img.onload = function () {
                PendingPool[imageSrc].forEach(function (callback) {
                  callback(imageSrc);
                });
                delete PendingPool[imageSrc];
                img.onload = null;
                imageSrc = undefined;
              };
              img.src = imageSrc;
            }, _this._onLoad = function (src) {
              if (_this._isMounted && src === _this.props.value) {
                _this.setState({
                  value: src
                });
              }
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          ImageFormatter.prototype.componentWillMount = function componentWillMount() {
            this._load(this.props.value);
          };
          ImageFormatter.prototype.componentDidMount = function componentDidMount() {
            this._isMounted = true;
          };
          ImageFormatter.prototype.componentWillUnmount = function componentWillUnmount() {
            this._isMounted = false;
          };
          ImageFormatter.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (nextProps.value !== this.props.value) {
              this.setState({
                value: null
              });
              this._load(nextProps.value);
            }
          };
          ImageFormatter.prototype.render = function render() {
            var style = this.state.value ? {
              backgroundImage: 'url(' + this.state.value + ')'
            } : undefined;
            return React.createElement('div', {
              className: 'react-grid-image',
              style: style
            });
          };
          return ImageFormatter;
        }(React.Component);
        ImageFormatter.propTypes = {
          value: _propTypes2['default'].string.isRequired
        };
        module.exports = ImageFormatter;

        /***/
      }, /* 235 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        // not including this
        // it currently requires the whole of moment, which we dont want to take as a dependency
        var ImageFormatter = __webpack_require__(234);
        var DropDownFormatter = __webpack_require__(233);
        var Formatters = {
          ImageFormatter: ImageFormatter,
          DropDownFormatter: DropDownFormatter
        };
        module.exports = Formatters;

        /***/
      }, /* 236 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var Editors = __webpack_require__(232);
        var Formatters = __webpack_require__(235);
        var Toolbar = __webpack_require__(245);
        var ToolsPanel = __webpack_require__(246);
        var Data = __webpack_require__(220);
        var Menu = __webpack_require__(238);
        var Draggable = __webpack_require__(228);
        var DraggableHeader = __webpack_require__(223);
        var Filters = __webpack_require__(215);
        var _require = __webpack_require__(4),
          rowComparer = _require.RowComparer;
        var performance = __webpack_require__(240);
        var Utils = {
          rowComparer: rowComparer,
          performance: performance
        };
        window.ReactDataGridPlugins = {
          Editors: Editors,
          Formatters: Formatters,
          Toolbar: Toolbar,
          Menu: Menu,
          Data: Data,
          ToolsPanel: ToolsPanel,
          Draggable: Draggable,
          DraggableHeader: DraggableHeader,
          Filters: Filters,
          Utils: Utils
        };
        module.exports = {
          Editors: Editors,
          Formatters: Formatters,
          Toolbar: Toolbar,
          Menu: Menu,
          Data: Data,
          ToolsPanel: ToolsPanel,
          Draggable: Draggable,
          DraggableHeader: DraggableHeader,
          Filters: Filters,
          Utils: Utils
        };

        /***/
      }, /* 237 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var MenuHeader = function (_React$Component) {
          _inherits(MenuHeader, _React$Component);
          function MenuHeader() {
            _classCallCheck(this, MenuHeader);
            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
          }
          MenuHeader.prototype.render = function render() {
            return _react2['default'].createElement('div', {
              className: 'react-context-menu-header'
            }, this.props.children);
          };
          return MenuHeader;
        }(_react2['default'].Component);
        MenuHeader.propTypes = {
          children: _propTypes2['default'].any
        };
        exports['default'] = MenuHeader;

        /***/
      }, /* 238 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        exports.ContextMenuTrigger = exports.connect = exports.SubMenu = exports.monitor = exports.MenuItem = exports.MenuHeader = exports.ContextMenu = undefined;
        var _reactContextmenu = __webpack_require__(340);
        var _MenuHeader = __webpack_require__(237);
        var _MenuHeader2 = _interopRequireDefault(_MenuHeader);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        exports.ContextMenu = _reactContextmenu.ContextMenu;
        exports.MenuHeader = _MenuHeader2['default'];
        exports.MenuItem = _reactContextmenu.MenuItem;
        exports.monitor = _reactContextmenu.monitor;
        exports.SubMenu = _reactContextmenu.SubMenu;
        exports.connect = _reactContextmenu.connect;
        exports.ContextMenuTrigger = _reactContextmenu.ContextMenuTrigger;

        /***/
      }, /* 239 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _SummaryItemModel = __webpack_require__(151);
        var _SummaryItemModel2 = _interopRequireDefault(_SummaryItemModel);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var SummaryParser = function () {
          function SummaryParser(summary) {
            _classCallCheck(this, SummaryParser);
            this._summary = this._parseSummary(summary);
            this.getByOwner = this.getByOwner.bind(this);
            this.getSumByOwner = this.getSumByOwner.bind(this);
            this.getByComponent = this.getByComponent.bind(this);
          }
          SummaryParser.prototype._parseSummary = function _parseSummary(summary) {
            return summary.map(function (s) {
              return new _SummaryItemModel2['default'](s);
            });
          };
          SummaryParser.prototype.getByOwner = function getByOwner(ownerName) {
            return this._summary.filter(function (s) {
              return s.owner === ownerName;
            });
          };
          SummaryParser.prototype.getSumByOwner = function getSumByOwner(ownerName) {
            var summaryItemsByOwner = this.getByOwner(ownerName);
            var summaryItem = new _SummaryItemModel2['default'](ownerName);
            summaryItemsByOwner.forEach(function (s) {
              var wastedTime = summaryItem.wastedTime,
                wastedInstances = summaryItem.wastedInstances;
              summaryItem.wastedTime = wastedTime + s.wastedTime;
              summaryItem.wastedInstances = wastedInstances + s.wastedInstances;
            });
            return summaryItem;
          };
          SummaryParser.prototype.getByComponent = function getByComponent(component) {
            var componentSummaryItem = this._summary.filter(function (s) {
              return s.component === component;
            });
            if (componentSummaryItem.length > 1) {
              throw new Error('More then 1 result retrived for ' + component);
            }
            if (componentSummaryItem.length === 0) {
              var emptySummary = new _SummaryItemModel2['default'](component);
              componentSummaryItem = [emptySummary];
            }
            return componentSummaryItem[0];
          };
          return SummaryParser;
        }();
        exports['default'] = SummaryParser;

        /***/
      }, /* 240 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _SummaryParser = __webpack_require__(239);
        var _SummaryParser2 = _interopRequireDefault(_SummaryParser);
        var _SummaryItemModel = __webpack_require__(151);
        var _SummaryItemModel2 = _interopRequireDefault(_SummaryItemModel);
        var _whyDidYouUpdate = __webpack_require__(241);
        var _whyDidYouUpdate2 = _interopRequireDefault(_whyDidYouUpdate);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        exports['default'] = {
          SummaryParser: _SummaryParser2['default'],
          SummaryItemModel: _SummaryItemModel2['default'],
          whyDidYouUpdate: _whyDidYouUpdate2['default']
        };

        /***/
      }, /* 241 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        exports.NOTIFY_LEVELS = undefined;
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _underscore = __webpack_require__(78);
        var _underscore2 = _interopRequireDefault(_underscore);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        } /* eslint-disable no-console */

        var isRequiredUpdateObject = function isRequiredUpdateObject(o) {
          return Array.isArray(o) || o && o.constructor === Object.prototype.constructor;
        };
        var NOTIFY_LEVELS = {
          DEBUG: 0,
          WARNING: 1,
          NONE: 2
        };
        var isLogEnabled = function isLogEnabled(lvl) {
          return lvl !== NOTIFY_LEVELS.NONE;
        };
        var isStatusTypeLoggable = function isStatusTypeLoggable(s, lvl) {
          return s <= lvl;
        };
        var deepDiff = function deepDiff(o1, o2, p, notifyLevel) {
          var notify = function notify(status, statusType) {
            if (isStatusTypeLoggable(statusType, notifyLevel)) {
              console.warn('Update %s', status);
              console.log('%cbefore', 'font-weight: bold', o1);
              console.log('%cafter ', 'font-weight: bold', o2);
            }
          };
          if (!_underscore2['default'].isEqual(o1, o2)) {
            console.group(p);
            if ([o1, o2].every(_underscore2['default'].isFunction)) {
              notify('avoidable?', NOTIFY_LEVELS.WARNING);
            } else if (![o1, o2].every(isRequiredUpdateObject)) {
              notify('required.', NOTIFY_LEVELS.DEBUG);
            } else {
              var keys = _underscore2['default'].union(_underscore2['default'].keys(o1), _underscore2['default'].keys(o2));
              for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;
                if (_isArray) {
                  if (_i >= _iterator.length) break;
                  _ref = _iterator[_i++];
                } else {
                  _i = _iterator.next();
                  if (_i.done) break;
                  _ref = _i.value;
                }
                var key = _ref;
                deepDiff(o1[key], o2[key], key);
              }
            }
            console.groupEnd();
          } else if (o1 !== o2) {
            console.group(p);
            notify('avoidable!', NOTIFY_LEVELS.WARNING);
            if (_underscore2['default'].isObject(o1) && _underscore2['default'].isObject(o2)) {
              var _keys = _underscore2['default'].union(_underscore2['default'].keys(o1), _underscore2['default'].keys(o2));
              for (var _iterator2 = _keys, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                var _ref2;
                if (_isArray2) {
                  if (_i2 >= _iterator2.length) break;
                  _ref2 = _iterator2[_i2++];
                } else {
                  _i2 = _iterator2.next();
                  if (_i2.done) break;
                  _ref2 = _i2.value;
                }
                var _key = _ref2;
                deepDiff(o1[_key], o2[_key], _key);
              }
            }
            console.groupEnd();
          }
        };
        var whyDidYouUpdate = function whyDidYouUpdate(WrappedComponent) {
          var notifyLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NOTIFY_LEVELS.NONE;
          return function (_Component) {
            _inherits(WhyDidYouUpdateComponentWrapper, _Component);
            function WhyDidYouUpdateComponentWrapper() {
              _classCallCheck(this, WhyDidYouUpdateComponentWrapper);
              return _possibleConstructorReturn(this, _Component.apply(this, arguments));
            }
            WhyDidYouUpdateComponentWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
              if (!isLogEnabled(notifyLevel)) {
                return;
              }
              deepDiff({
                props: prevProps,
                state: prevState
              }, {
                props: this.props,
                state: this.state
              }, WrappedComponent.displayName, notifyLevel);
            };
            WhyDidYouUpdateComponentWrapper.prototype.render = function render() {
              return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, this.state));
            };
            return WhyDidYouUpdateComponentWrapper;
          }(_react.Component);
        };
        exports['default'] = whyDidYouUpdate;
        exports.NOTIFY_LEVELS = NOTIFY_LEVELS;

        /***/
      }, /* 242 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        __webpack_require__(190);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var propTypes = {
          children: _propTypes2['default'].array
        };
        var defaultProps = {
          enableAddRow: true
        };
        var AdvancedToolbar = function (_Component) {
          _inherits(AdvancedToolbar, _Component);
          function AdvancedToolbar() {
            _classCallCheck(this, AdvancedToolbar);
            return _possibleConstructorReturn(this, _Component.apply(this, arguments));
          }
          AdvancedToolbar.prototype.render = function render() {
            return _react2['default'].createElement('div', {
              className: 'react-grid-Toolbar'
            }, this.props.children, _react2['default'].createElement('div', {
              className: 'tools'
            }));
          };
          return AdvancedToolbar;
        }(_react.Component);
        AdvancedToolbar.defaultProps = defaultProps;
        AdvancedToolbar.propTypes = propTypes;
        exports['default'] = AdvancedToolbar;

        /***/
      }, /* 243 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var GroupedColumnButton = function (_Component) {
          _inherits(GroupedColumnButton, _Component);
          function GroupedColumnButton() {
            _classCallCheck(this, GroupedColumnButton);
            return _possibleConstructorReturn(this, _Component.apply(this, arguments));
          }
          GroupedColumnButton.prototype.render = function render() {
            var style = {
              width: '80px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            };
            return _react2['default'].createElement('button', {
              className: 'btn grouped-col-btn btn-sm'
            }, _react2['default'].createElement('span', {
              style: style
            }, this.props.name), _react2['default'].createElement('span', {
              className: 'glyphicon glyphicon-trash',
              style: {
                float: 'right',
                paddingLeft: '5px'
              },
              onClick: this.props.onColumnGroupDeleted.bind(null, this.props.columnKey)
            }));
          };
          return GroupedColumnButton;
        }(_react.Component);
        exports['default'] = GroupedColumnButton;
        GroupedColumnButton.propTypes = {
          name: _propTypes2['default'].string.isRequired,
          onColumnGroupDeleted: _propTypes2['default'].func,
          columnKey: _propTypes2['default'].string.isRequired
        };

        /***/
      }, /* 244 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _reactDnd = __webpack_require__(23);
        var _GroupedColumnButton = __webpack_require__(243);
        var _GroupedColumnButton2 = _interopRequireDefault(_GroupedColumnButton);
        var _reactDataGrid = __webpack_require__(4);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var DragItemTypes = _reactDataGrid._constants.DragItemTypes;
        var propTypes = {
          isOver: _propTypes2['default'].bool.isRequired,
          connectDropTarget: _propTypes2['default'].func,
          canDrop: _propTypes2['default'].bool.isRequired,
          groupBy: _propTypes2['default'].array,
          noColumnsSelectedMessage: _propTypes2['default'].string,
          panelDescription: _propTypes2['default'].string,
          onColumnGroupDeleted: _propTypes2['default'].func
        };
        var defaultProps = {
          noColumnsSelectedMessage: 'Drag a column header here to group by that column',
          panelDescription: 'Drag a column header here to group by that column'
        };
        var GroupedColumnsPanel = function (_Component) {
          _inherits(GroupedColumnsPanel, _Component);
          function GroupedColumnsPanel() {
            _classCallCheck(this, GroupedColumnsPanel);
            return _possibleConstructorReturn(this, _Component.call(this));
          }
          GroupedColumnsPanel.prototype.getPanelInstructionMessage = function getPanelInstructionMessage() {
            var groupBy = this.props.groupBy;
            return groupBy && groupBy.length > 0 ? this.props.panelDescription : this.props.noColumnsSelectedMessage;
          };
          GroupedColumnsPanel.prototype.renderGroupedColumns = function renderGroupedColumns() {
            var _this2 = this;
            return this.props.groupBy.map(function (c) {
              var groupedColumnButtonProps = {
                columnKey: typeof c === 'string' ? c : c.key,
                name: typeof c === 'string' ? c : c.name,
                onColumnGroupDeleted: _this2.props.onColumnGroupDeleted,
                key: typeof c === 'string' ? c : c.key
              };
              return _react2['default'].createElement(_GroupedColumnButton2['default'], groupedColumnButtonProps);
            });
          };
          GroupedColumnsPanel.prototype.renderOverlay = function renderOverlay(color) {
            return _react2['default'].createElement('div', {
              style: {
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                zIndex: 1,
                opacity: 0.5,
                backgroundColor: color
              }
            });
          };
          GroupedColumnsPanel.prototype.render = function render() {
            var _props = this.props,
              connectDropTarget = _props.connectDropTarget,
              isOver = _props.isOver,
              canDrop = _props.canDrop;
            return connectDropTarget(_react2['default'].createElement('div', {
              style: {
                padding: '2px',
                position: 'relative',
                margin: '-10px',
                display: 'inline-block',
                border: '1px solid #eee'
              }
            }, this.renderGroupedColumns(), ' ', _react2['default'].createElement('span', null, this.getPanelInstructionMessage()), isOver && canDrop && this.renderOverlay('yellow'), !isOver && canDrop && this.renderOverlay('#DBECFA')));
          };
          return GroupedColumnsPanel;
        }(_react.Component);
        GroupedColumnsPanel.defaultProps = defaultProps;
        GroupedColumnsPanel.propTypes = propTypes;
        var columnTarget = {
          drop: function drop(props, monitor) {
            // Obtain the dragged item
            var item = monitor.getItem();
            if (typeof props.onColumnGroupAdded === 'function') {
              props.onColumnGroupAdded(item.key);
            }
          }
        };
        function collect(connect, monitor) {
          return {
            connectDropTarget: connect.dropTarget(),
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
            draggedolumn: monitor.getItem()
          };
        }
        exports['default'] = (0, _reactDnd.DropTarget)(DragItemTypes.Column, columnTarget, collect)(GroupedColumnsPanel);

        /***/
      }, /* 245 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var React = __webpack_require__(2);
        __webpack_require__(190);
        var Toolbar = function (_React$Component) {
          _inherits(Toolbar, _React$Component);
          function Toolbar() {
            var _temp, _this, _ret;
            _classCallCheck(this, Toolbar);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onAddRow = function () {
              if (_this.props.onAddRow !== null && _this.props.onAddRow instanceof Function) {
                _this.props.onAddRow({
                  newRowIndex: _this.props.numberOfRows
                });
              }
            }, _this.renderAddRowButton = function () {
              if (_this.props.onAddRow) {
                return React.createElement('button', {
                  type: 'button',
                  className: 'btn',
                  onClick: _this.onAddRow
                }, _this.props.addRowButtonText);
              }
            }, _this.renderToggleFilterButton = function () {
              if (_this.props.enableFilter) {
                return React.createElement('button', {
                  type: 'button',
                  className: 'btn',
                  onClick: _this.props.onToggleFilter
                }, _this.props.filterRowsButtonText);
              }
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }
          Toolbar.prototype.render = function render() {
            return React.createElement('div', {
              className: 'react-grid-Toolbar'
            }, React.createElement('div', {
              className: 'tools'
            }, this.renderAddRowButton(), this.renderToggleFilterButton(), this.props.children));
          };
          return Toolbar;
        }(React.Component);
        Toolbar.propTypes = {
          onAddRow: _propTypes2['default'].func,
          onToggleFilter: _propTypes2['default'].func,
          enableFilter: _propTypes2['default'].bool,
          numberOfRows: _propTypes2['default'].number,
          addRowButtonText: _propTypes2['default'].string,
          filterRowsButtonText: _propTypes2['default'].string,
          children: _propTypes2['default'].any
        };
        Toolbar.defaultProps = {
          enableAddRow: true,
          addRowButtonText: 'Add Row',
          filterRowsButtonText: 'Filter Rows'
        };
        module.exports = Toolbar;

        /***/
      }, /* 246 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        var _AdvancedToolbar = __webpack_require__(242);
        var _AdvancedToolbar2 = _interopRequireDefault(_AdvancedToolbar);
        var _GroupedColumnsPanel = __webpack_require__(244);
        var _GroupedColumnsPanel2 = _interopRequireDefault(_GroupedColumnsPanel);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        module.exports = {
          AdvancedToolbar: _AdvancedToolbar2['default'],
          GroupedColumnsPanel: _GroupedColumnsPanel2['default']
        };

        /***/
      }, /* 247 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".Select{position:relative}.Select input::-webkit-contacts-auto-fill-button,.Select input::-webkit-credentials-auto-fill-button{display:none!important}.Select input::-ms-clear,.Select input::-ms-reveal{display:none!important}.Select,.Select div,.Select input,.Select span{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.Select.is-searchable.is-focused:not(.is-open)>.Select-control,.Select.is-searchable.is-open>.Select-control{cursor:text}.Select.is-focused>.Select-control{background:#fff}.Select.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1);background:#fff}.Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff}.Select.has-value.is-pseudo-focused .Select-input{opacity:0}.Select.is-open .Select-arrow,.Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select.Select--rtl{direction:rtl;text-align:right}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none;background:#fff}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;-o-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;-o-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select--rtl .Select-arrow-zone{padding-right:0;padding-left:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.Select-control>:last-child{padding-right:5px}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;left:0;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:5px}.Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #c2e0ff;border-left:1px solid rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}", ""]);

        // exports

        /***/
      }, /* 248 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".slideUp{animation-name:slideUp;-webkit-animation-name:slideUp;animation-duration:1s;-webkit-animation-duration:1s;animation-timing-function:ease;-webkit-animation-timing-function:ease;visibility:visible!important}@keyframes slideUp{0%{transform:translateY(100%)}50%{transform:translateY(-8%)}65%{transform:translateY(4%)}80%{transform:translateY(-4%)}95%{transform:translateY(2%)}to{transform:translateY(0)}}@-webkit-keyframes slideUp{0%{-webkit-transform:translateY(100%)}50%{-webkit-transform:translateY(-8%)}65%{-webkit-transform:translateY(4%)}80%{-webkit-transform:translateY(-4%)}95%{-webkit-transform:translateY(2%)}to{-webkit-transform:translateY(0)}}", ""]);

        // exports

        /***/
      }, /* 249 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".react-grid-image{background:#efefef;background-size:100%;display:inline-block;height:40px;width:40px}", ""]);

        // exports

        /***/
      }, /* 250 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".react-grid-Toolbar{background-color:#fff;border-color:#e7eaec;border-image:none;border-style:solid solid none;border-width:1px;color:inherit;margin-bottom:0;padding:14px 15px 7px;height:48px}.react-grid-Toolbar .btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;color:inherit;background:#fff;border:1px solid #e7eaec}.react-grid-Toolbar .btn:hover{color:inherit;border:1px solid #d2d2d2}.react-grid-Toolbar .grouped-col-btn{background-color:#428bca;color:#fff}.react-grid-Toolbar .grouped-col-btn:hover{color:#fff}.react-grid-Toolbar .tools{display:inline-block;float:right;margin-top:0;position:relative;padding:0;margin-top:-6px}", ""]);

        // exports

        /***/
      }, /* 251 */
      /***/function (module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(7)();
        // imports

        // module
        exports.push([module.id, ".react-autocomplete-Autocomplete__search{display:block;width:100%;height:36px;padding:6px 12px;font-size:14px;line-height:1.6;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.react-autocomplete-Autocomplete__search:focus{border-color:#a21618;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(162,22,24,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(162,22,24,.6)}.react-autocomplete-Autocomplete__search::-moz-placeholder{color:#777;opacity:1}.react-autocomplete-Autocomplete__search:-ms-input-placeholder{color:#777}.react-autocomplete-Autocomplete__search::-webkit-input-placeholder{color:#777}.react-autocomplete-Autocomplete__search[disabled],.react-autocomplete-Autocomplete__search[readonly],fieldset[disabled] .react-autocomplete-Autocomplete__search{cursor:not-allowed;background-color:#eee;opacity:1}textarea.react-autocomplete-Autocomplete__search{height:auto}.react-autocomplete-Autocomplete__results{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box;min-width:250px;width:100%;max-height:200px;overflow:auto}.react-autocomplete-Autocomplete__results.pull-right{right:0;left:auto}.react-autocomplete-Autocomplete__results .divider{height:1px;margin:10px 0;overflow:hidden;background-color:#e5e5e5}.react-autocomplete-Autocomplete__results>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.6;color:#333;white-space:nowrap}.react-autocomplete-Autocomplete__results div.action-button{display:block!important;padding:4px}.react-autocomplete-Result{cursor:pointer}.react-autocomplete-Result>a{text-decoration:none}.react-autocomplete-Result--active{color:#262626;background-color:#f5f5f5}", ""]);

        // exports

        /***/
      }, /* 252 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }
        var _isDisposable = __webpack_require__(81);
        var _isDisposable2 = _interopRequireDefault(_isDisposable);

        /**
         * Represents a group of disposable resources that are disposed together.
         */

        var CompositeDisposable = function () {
          function CompositeDisposable() {
            for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
              disposables[_key] = arguments[_key];
            }
            _classCallCheck(this, CompositeDisposable);
            if (Array.isArray(disposables[0]) && disposables.length === 1) {
              disposables = disposables[0];
            }
            for (var i = 0; i < disposables.length; i++) {
              if (!_isDisposable2['default'](disposables[i])) {
                throw new Error('Expected a disposable');
              }
            }
            this.disposables = disposables;
            this.isDisposed = false;
          }

          /**
           * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
           * @param {Disposable} item Disposable to add.
           */

          CompositeDisposable.prototype.add = function add(item) {
            if (this.isDisposed) {
              item.dispose();
            } else {
              this.disposables.push(item);
            }
          };

          /**
           * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
           * @param {Disposable} item Disposable to remove.
           * @returns {Boolean} true if found; false otherwise.
           */

          CompositeDisposable.prototype.remove = function remove(item) {
            if (this.isDisposed) {
              return false;
            }
            var index = this.disposables.indexOf(item);
            if (index === -1) {
              return false;
            }
            this.disposables.splice(index, 1);
            item.dispose();
            return true;
          };

          /**
           * Disposes all disposables in the group and removes them from the group.
           */

          CompositeDisposable.prototype.dispose = function dispose() {
            if (this.isDisposed) {
              return;
            }
            var len = this.disposables.length;
            var currentDisposables = new Array(len);
            for (var i = 0; i < len; i++) {
              currentDisposables[i] = this.disposables[i];
            }
            this.isDisposed = true;
            this.disposables = [];
            this.length = 0;
            for (var i = 0; i < len; i++) {
              currentDisposables[i].dispose();
            }
          };
          return CompositeDisposable;
        }();
        exports['default'] = CompositeDisposable;
        module.exports = exports['default'];

        /***/
      }, /* 253 */
      /***/function (module, exports) {
        "use strict";

        exports.__esModule = true;
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var noop = function noop() {};

        /**
         * The basic disposable.
         */

        var Disposable = function () {
          _createClass(Disposable, null, [{
            key: "empty",
            value: {
              dispose: noop
            },
            enumerable: true
          }]);
          function Disposable(action) {
            _classCallCheck(this, Disposable);
            this.isDisposed = false;
            this.action = action || noop;
          }
          Disposable.prototype.dispose = function dispose() {
            if (!this.isDisposed) {
              this.action.call(null);
              this.isDisposed = true;
            }
          };
          return Disposable;
        }();
        exports["default"] = Disposable;
        module.exports = exports["default"];

        /***/
      }, /* 254 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }
        var _isDisposable = __webpack_require__(81);
        var _isDisposable2 = _interopRequireDefault(_isDisposable);
        var SerialDisposable = function () {
          function SerialDisposable() {
            _classCallCheck(this, SerialDisposable);
            this.isDisposed = false;
            this.current = null;
          }

          /**
           * Gets the underlying disposable.
           * @return The underlying disposable.
           */

          SerialDisposable.prototype.getDisposable = function getDisposable() {
            return this.current;
          };

          /**
           * Sets the underlying disposable.
           * @param {Disposable} value The new underlying disposable.
           */

          SerialDisposable.prototype.setDisposable = function setDisposable() {
            var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
            if (value != null && !_isDisposable2['default'](value)) {
              throw new Error('Expected either an empty value or a valid disposable');
            }
            var isDisposed = this.isDisposed;
            var previous = undefined;
            if (!isDisposed) {
              previous = this.current;
              this.current = value;
            }
            if (previous) {
              previous.dispose();
            }
            if (isDisposed && value) {
              value.dispose();
            }
          };

          /**
           * Disposes the underlying disposable as well as all future replacements.
           */

          SerialDisposable.prototype.dispose = function dispose() {
            if (this.isDisposed) {
              return;
            }
            this.isDisposed = true;
            var previous = this.current;
            this.current = null;
            if (previous) {
              previous.dispose();
            }
          };
          return SerialDisposable;
        }();
        exports['default'] = SerialDisposable;
        module.exports = exports['default'];

        /***/
      }, /* 255 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }
        var _isDisposable2 = __webpack_require__(81);
        var _isDisposable3 = _interopRequireDefault(_isDisposable2);
        exports.isDisposable = _isDisposable3['default'];
        var _Disposable2 = __webpack_require__(253);
        var _Disposable3 = _interopRequireDefault(_Disposable2);
        exports.Disposable = _Disposable3['default'];
        var _CompositeDisposable2 = __webpack_require__(252);
        var _CompositeDisposable3 = _interopRequireDefault(_CompositeDisposable2);
        exports.CompositeDisposable = _CompositeDisposable3['default'];
        var _SerialDisposable2 = __webpack_require__(254);
        var _SerialDisposable3 = _interopRequireDefault(_SerialDisposable2);
        exports.SerialDisposable = _SerialDisposable3['default'];

        /***/
      }, /* 256 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _createStore = __webpack_require__(367);
        var _createStore2 = _interopRequireDefault(_createStore);
        var _reducers = __webpack_require__(264);
        var _reducers2 = _interopRequireDefault(_reducers);
        var _dragDrop = __webpack_require__(56);
        var dragDropActions = _interopRequireWildcard(_dragDrop);
        var _DragDropMonitor = __webpack_require__(257);
        var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);
        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};
            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }
            newObj.default = obj;
            return newObj;
          }
        }
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var DragDropManager = function () {
          function DragDropManager(createBackend) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, DragDropManager);
            var store = (0, _createStore2.default)(_reducers2.default);
            this.context = context;
            this.store = store;
            this.monitor = new _DragDropMonitor2.default(store);
            this.registry = this.monitor.registry;
            this.backend = createBackend(this);
            store.subscribe(this.handleRefCountChange.bind(this));
          }
          _createClass(DragDropManager, [{
            key: 'handleRefCountChange',
            value: function handleRefCountChange() {
              var shouldSetUp = this.store.getState().refCount > 0;
              if (shouldSetUp && !this.isSetUp) {
                this.backend.setup();
                this.isSetUp = true;
              } else if (!shouldSetUp && this.isSetUp) {
                this.backend.teardown();
                this.isSetUp = false;
              }
            }
          }, {
            key: 'getContext',
            value: function getContext() {
              return this.context;
            }
          }, {
            key: 'getMonitor',
            value: function getMonitor() {
              return this.monitor;
            }
          }, {
            key: 'getBackend',
            value: function getBackend() {
              return this.backend;
            }
          }, {
            key: 'getRegistry',
            value: function getRegistry() {
              return this.registry;
            }
          }, {
            key: 'getActions',
            value: function getActions() {
              var manager = this;
              var dispatch = this.store.dispatch;
              function bindActionCreator(actionCreator) {
                return function () {
                  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }
                  var action = actionCreator.apply(manager, args);
                  if (typeof action !== 'undefined') {
                    dispatch(action);
                  }
                };
              }
              return Object.keys(dragDropActions).filter(function (key) {
                return typeof dragDropActions[key] === 'function';
              }).reduce(function (boundActions, key) {
                var action = dragDropActions[key];
                boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
                return boundActions;
              }, {});
            }
          }]);
          return DragDropManager;
        }();
        exports.default = DragDropManager;

        /***/
      }, /* 257 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        var _isArray = __webpack_require__(21);
        var _isArray2 = _interopRequireDefault(_isArray);
        var _matchesType = __webpack_require__(155);
        var _matchesType2 = _interopRequireDefault(_matchesType);
        var _HandlerRegistry = __webpack_require__(260);
        var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);
        var _dragOffset = __webpack_require__(154);
        var _dirtyHandlerIds = __webpack_require__(153);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var DragDropMonitor = function () {
          function DragDropMonitor(store) {
            _classCallCheck(this, DragDropMonitor);
            this.store = store;
            this.registry = new _HandlerRegistry2.default(store);
          }
          _createClass(DragDropMonitor, [{
            key: 'subscribeToStateChange',
            value: function subscribeToStateChange(listener) {
              var _this = this;
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var handlerIds = options.handlerIds;
              (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
              (0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');
              var prevStateId = this.store.getState().stateId;
              var handleChange = function handleChange() {
                var state = _this.store.getState();
                var currentStateId = state.stateId;
                try {
                  var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);
                  if (!canSkipListener) {
                    listener();
                  }
                } finally {
                  prevStateId = currentStateId;
                }
              };
              return this.store.subscribe(handleChange);
            }
          }, {
            key: 'subscribeToOffsetChange',
            value: function subscribeToOffsetChange(listener) {
              var _this2 = this;
              (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
              var previousState = this.store.getState().dragOffset;
              var handleChange = function handleChange() {
                var nextState = _this2.store.getState().dragOffset;
                if (nextState === previousState) {
                  return;
                }
                previousState = nextState;
                listener();
              };
              return this.store.subscribe(handleChange);
            }
          }, {
            key: 'canDragSource',
            value: function canDragSource(sourceId) {
              var source = this.registry.getSource(sourceId);
              (0, _invariant2.default)(source, 'Expected to find a valid source.');
              if (this.isDragging()) {
                return false;
              }
              return source.canDrag(this, sourceId);
            }
          }, {
            key: 'canDropOnTarget',
            value: function canDropOnTarget(targetId) {
              var target = this.registry.getTarget(targetId);
              (0, _invariant2.default)(target, 'Expected to find a valid target.');
              if (!this.isDragging() || this.didDrop()) {
                return false;
              }
              var targetType = this.registry.getTargetType(targetId);
              var draggedItemType = this.getItemType();
              return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
            }
          }, {
            key: 'isDragging',
            value: function isDragging() {
              return Boolean(this.getItemType());
            }
          }, {
            key: 'isDraggingSource',
            value: function isDraggingSource(sourceId) {
              var source = this.registry.getSource(sourceId, true);
              (0, _invariant2.default)(source, 'Expected to find a valid source.');
              if (!this.isDragging() || !this.isSourcePublic()) {
                return false;
              }
              var sourceType = this.registry.getSourceType(sourceId);
              var draggedItemType = this.getItemType();
              if (sourceType !== draggedItemType) {
                return false;
              }
              return source.isDragging(this, sourceId);
            }
          }, {
            key: 'isOverTarget',
            value: function isOverTarget(targetId) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                shallow: false
              };
              var shallow = options.shallow;
              if (!this.isDragging()) {
                return false;
              }
              var targetType = this.registry.getTargetType(targetId);
              var draggedItemType = this.getItemType();
              if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
                return false;
              }
              var targetIds = this.getTargetIds();
              if (!targetIds.length) {
                return false;
              }
              var index = targetIds.indexOf(targetId);
              if (shallow) {
                return index === targetIds.length - 1;
              } else {
                return index > -1;
              }
            }
          }, {
            key: 'getItemType',
            value: function getItemType() {
              return this.store.getState().dragOperation.itemType;
            }
          }, {
            key: 'getItem',
            value: function getItem() {
              return this.store.getState().dragOperation.item;
            }
          }, {
            key: 'getSourceId',
            value: function getSourceId() {
              return this.store.getState().dragOperation.sourceId;
            }
          }, {
            key: 'getTargetIds',
            value: function getTargetIds() {
              return this.store.getState().dragOperation.targetIds;
            }
          }, {
            key: 'getDropResult',
            value: function getDropResult() {
              return this.store.getState().dragOperation.dropResult;
            }
          }, {
            key: 'didDrop',
            value: function didDrop() {
              return this.store.getState().dragOperation.didDrop;
            }
          }, {
            key: 'isSourcePublic',
            value: function isSourcePublic() {
              return this.store.getState().dragOperation.isSourcePublic;
            }
          }, {
            key: 'getInitialClientOffset',
            value: function getInitialClientOffset() {
              return this.store.getState().dragOffset.initialClientOffset;
            }
          }, {
            key: 'getInitialSourceClientOffset',
            value: function getInitialSourceClientOffset() {
              return this.store.getState().dragOffset.initialSourceClientOffset;
            }
          }, {
            key: 'getClientOffset',
            value: function getClientOffset() {
              return this.store.getState().dragOffset.clientOffset;
            }
          }, {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset() {
              return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
            }
          }, {
            key: 'getDifferenceFromInitialOffset',
            value: function getDifferenceFromInitialOffset() {
              return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
            }
          }]);
          return DragDropMonitor;
        }();
        exports.default = DragDropMonitor;

        /***/
      }, /* 258 */
      /***/function (module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var DragSource = function () {
          function DragSource() {
            _classCallCheck(this, DragSource);
          }
          _createClass(DragSource, [{
            key: "canDrag",
            value: function canDrag() {
              return true;
            }
          }, {
            key: "isDragging",
            value: function isDragging(monitor, handle) {
              return handle === monitor.getSourceId();
            }
          }, {
            key: "endDrag",
            value: function endDrag() {}
          }]);
          return DragSource;
        }();
        exports.default = DragSource;

        /***/
      }, /* 259 */
      /***/function (module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var DropTarget = function () {
          function DropTarget() {
            _classCallCheck(this, DropTarget);
          }
          _createClass(DropTarget, [{
            key: "canDrop",
            value: function canDrop() {
              return true;
            }
          }, {
            key: "hover",
            value: function hover() {}
          }, {
            key: "drop",
            value: function drop() {}
          }]);
          return DropTarget;
        }();
        exports.default = DropTarget;

        /***/
      }, /* 260 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        var _isArray = __webpack_require__(21);
        var _isArray2 = _interopRequireDefault(_isArray);
        var _asap = __webpack_require__(210);
        var _asap2 = _interopRequireDefault(_asap);
        var _registry = __webpack_require__(57);
        var _getNextUniqueId = __webpack_require__(267);
        var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var HandlerRoles = {
          SOURCE: 'SOURCE',
          TARGET: 'TARGET'
        };
        function validateSourceContract(source) {
          (0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
          (0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
          (0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
        }
        function validateTargetContract(target) {
          (0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
          (0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
          (0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
        }
        function validateType(type, allowArray) {
          if (allowArray && (0, _isArray2.default)(type)) {
            type.forEach(function (t) {
              return validateType(t, false);
            });
            return;
          }
          (0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
        }
        function getNextHandlerId(role) {
          var id = (0, _getNextUniqueId2.default)().toString();
          switch (role) {
            case HandlerRoles.SOURCE:
              return 'S' + id;
            case HandlerRoles.TARGET:
              return 'T' + id;
            default:
              (0, _invariant2.default)(false, 'Unknown role: ' + role);
          }
        }
        function parseRoleFromHandlerId(handlerId) {
          switch (handlerId[0]) {
            case 'S':
              return HandlerRoles.SOURCE;
            case 'T':
              return HandlerRoles.TARGET;
            default:
              (0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
          }
        }
        var HandlerRegistry = function () {
          function HandlerRegistry(store) {
            _classCallCheck(this, HandlerRegistry);
            this.store = store;
            this.types = {};
            this.handlers = {};
            this.pinnedSourceId = null;
            this.pinnedSource = null;
          }
          _createClass(HandlerRegistry, [{
            key: 'addSource',
            value: function addSource(type, source) {
              validateType(type);
              validateSourceContract(source);
              var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
              this.store.dispatch((0, _registry.addSource)(sourceId));
              return sourceId;
            }
          }, {
            key: 'addTarget',
            value: function addTarget(type, target) {
              validateType(type, true);
              validateTargetContract(target);
              var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
              this.store.dispatch((0, _registry.addTarget)(targetId));
              return targetId;
            }
          }, {
            key: 'addHandler',
            value: function addHandler(role, type, handler) {
              var id = getNextHandlerId(role);
              this.types[id] = type;
              this.handlers[id] = handler;
              return id;
            }
          }, {
            key: 'containsHandler',
            value: function containsHandler(handler) {
              var _this = this;
              return Object.keys(this.handlers).some(function (key) {
                return _this.handlers[key] === handler;
              });
            }
          }, {
            key: 'getSource',
            value: function getSource(sourceId, includePinned) {
              (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
              var isPinned = includePinned && sourceId === this.pinnedSourceId;
              var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
              return source;
            }
          }, {
            key: 'getTarget',
            value: function getTarget(targetId) {
              (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
              return this.handlers[targetId];
            }
          }, {
            key: 'getSourceType',
            value: function getSourceType(sourceId) {
              (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
              return this.types[sourceId];
            }
          }, {
            key: 'getTargetType',
            value: function getTargetType(targetId) {
              (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
              return this.types[targetId];
            }
          }, {
            key: 'isSourceId',
            value: function isSourceId(handlerId) {
              var role = parseRoleFromHandlerId(handlerId);
              return role === HandlerRoles.SOURCE;
            }
          }, {
            key: 'isTargetId',
            value: function isTargetId(handlerId) {
              var role = parseRoleFromHandlerId(handlerId);
              return role === HandlerRoles.TARGET;
            }
          }, {
            key: 'removeSource',
            value: function removeSource(sourceId) {
              var _this2 = this;
              (0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
              this.store.dispatch((0, _registry.removeSource)(sourceId));
              (0, _asap2.default)(function () {
                delete _this2.handlers[sourceId];
                delete _this2.types[sourceId];
              });
            }
          }, {
            key: 'removeTarget',
            value: function removeTarget(targetId) {
              var _this3 = this;
              (0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
              this.store.dispatch((0, _registry.removeTarget)(targetId));
              (0, _asap2.default)(function () {
                delete _this3.handlers[targetId];
                delete _this3.types[targetId];
              });
            }
          }, {
            key: 'pinSource',
            value: function pinSource(sourceId) {
              var source = this.getSource(sourceId);
              (0, _invariant2.default)(source, 'Expected an existing source.');
              this.pinnedSourceId = sourceId;
              this.pinnedSource = source;
            }
          }, {
            key: 'unpinSource',
            value: function unpinSource() {
              (0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');
              this.pinnedSourceId = null;
              this.pinnedSource = null;
            }
          }]);
          return HandlerRegistry;
        }();
        exports.default = HandlerRegistry;

        /***/
      }, /* 261 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        exports.default = createBackend;
        var _noop = __webpack_require__(170);
        var _noop2 = _interopRequireDefault(_noop);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var TestBackend = function () {
          function TestBackend(manager) {
            _classCallCheck(this, TestBackend);
            this.actions = manager.getActions();
          }
          _createClass(TestBackend, [{
            key: 'setup',
            value: function setup() {
              this.didCallSetup = true;
            }
          }, {
            key: 'teardown',
            value: function teardown() {
              this.didCallTeardown = true;
            }
          }, {
            key: 'connectDragSource',
            value: function connectDragSource() {
              return _noop2.default;
            }
          }, {
            key: 'connectDragPreview',
            value: function connectDragPreview() {
              return _noop2.default;
            }
          }, {
            key: 'connectDropTarget',
            value: function connectDropTarget() {
              return _noop2.default;
            }
          }, {
            key: 'simulateBeginDrag',
            value: function simulateBeginDrag(sourceIds, options) {
              this.actions.beginDrag(sourceIds, options);
            }
          }, {
            key: 'simulatePublishDragSource',
            value: function simulatePublishDragSource() {
              this.actions.publishDragSource();
            }
          }, {
            key: 'simulateHover',
            value: function simulateHover(targetIds, options) {
              this.actions.hover(targetIds, options);
            }
          }, {
            key: 'simulateDrop',
            value: function simulateDrop() {
              this.actions.drop();
            }
          }, {
            key: 'simulateEndDrag',
            value: function simulateEndDrag() {
              this.actions.endDrag();
            }
          }]);
          return TestBackend;
        }();
        function createBackend(manager) {
          return new TestBackend(manager);
        }

        /***/
      }, /* 262 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _DragDropManager = __webpack_require__(256);
        Object.defineProperty(exports, 'DragDropManager', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_DragDropManager).default;
          }
        });
        var _DragSource = __webpack_require__(258);
        Object.defineProperty(exports, 'DragSource', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_DragSource).default;
          }
        });
        var _DropTarget = __webpack_require__(259);
        Object.defineProperty(exports, 'DropTarget', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_DropTarget).default;
          }
        });
        var _createTestBackend = __webpack_require__(261);
        Object.defineProperty(exports, 'createTestBackend', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_createTestBackend).default;
          }
        });
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        /***/
      }, /* 263 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        exports.default = dragOperation;
        var _without = __webpack_require__(171);
        var _without2 = _interopRequireDefault(_without);
        var _dragDrop = __webpack_require__(56);
        var _registry = __webpack_require__(57);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        var initialState = {
          itemType: null,
          item: null,
          sourceId: null,
          targetIds: [],
          dropResult: null,
          didDrop: false,
          isSourcePublic: null
        };
        function dragOperation() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments[1];
          switch (action.type) {
            case _dragDrop.BEGIN_DRAG:
              return _extends({}, state, {
                itemType: action.itemType,
                item: action.item,
                sourceId: action.sourceId,
                isSourcePublic: action.isSourcePublic,
                dropResult: null,
                didDrop: false
              });
            case _dragDrop.PUBLISH_DRAG_SOURCE:
              return _extends({}, state, {
                isSourcePublic: true
              });
            case _dragDrop.HOVER:
              return _extends({}, state, {
                targetIds: action.targetIds
              });
            case _registry.REMOVE_TARGET:
              if (state.targetIds.indexOf(action.targetId) === -1) {
                return state;
              }
              return _extends({}, state, {
                targetIds: (0, _without2.default)(state.targetIds, action.targetId)
              });
            case _dragDrop.DROP:
              return _extends({}, state, {
                dropResult: action.dropResult,
                didDrop: true,
                targetIds: []
              });
            case _dragDrop.END_DRAG:
              return _extends({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
              });
            default:
              return state;
          }
        }

        /***/
      }, /* 264 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = reduce;
        var _dragOffset = __webpack_require__(154);
        var _dragOffset2 = _interopRequireDefault(_dragOffset);
        var _dragOperation = __webpack_require__(263);
        var _dragOperation2 = _interopRequireDefault(_dragOperation);
        var _refCount = __webpack_require__(265);
        var _refCount2 = _interopRequireDefault(_refCount);
        var _dirtyHandlerIds = __webpack_require__(153);
        var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);
        var _stateId = __webpack_require__(266);
        var _stateId2 = _interopRequireDefault(_stateId);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function reduce() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var action = arguments[1];
          return {
            dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
            dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
            refCount: (0, _refCount2.default)(state.refCount, action),
            dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
            stateId: (0, _stateId2.default)(state.stateId)
          };
        }

        /***/
      }, /* 265 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = refCount;
        var _registry = __webpack_require__(57);
        function refCount() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          var action = arguments[1];
          switch (action.type) {
            case _registry.ADD_SOURCE:
            case _registry.ADD_TARGET:
              return state + 1;
            case _registry.REMOVE_SOURCE:
            case _registry.REMOVE_TARGET:
              return state - 1;
            default:
              return state;
          }
        }

        /***/
      }, /* 266 */
      /***/function (module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = stateId;
        function stateId() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          return state + 1;
        }

        /***/
      }, /* 267 */
      /***/function (module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = getNextUniqueId;
        var nextUniqueId = 0;
        function getNextUniqueId() {
          return nextUniqueId++;
        }

        /***/
      }, /* 268 */
      [1544, 296, 297, 298, 299, 300], /* 269 */
      [1545, 306, 307, 308, 309, 310], /* 270 */
      [1548, 61, 33], /* 271 */
      [1554, 61, 33], /* 272 */
      /***/function (module, exports) {
        /**
         * A specialized version of `_.filter` for arrays without support for
         * iteratee shorthands.
         *
         * @private
         * @param {Array} [array] The array to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         */
        function arrayFilter(array, predicate) {
          var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result[resIndex++] = value;
            }
          }
          return result;
        }
        module.exports = arrayFilter;

        /***/
      }, /* 273 */
      [1563, 285, 167, 21, 331, 164, 332], /* 274 */
      /***/function (module, exports) {
        /**
         * Appends the elements of `values` to `array`.
         *
         * @private
         * @param {Array} array The array to modify.
         * @param {Array} values The values to append.
         * @returns {Array} Returns `array`.
         */
        function arrayPush(array, values) {
          var index = -1,
            length = values.length,
            offset = array.length;
          while (++index < length) {
            array[offset + index] = values[index];
          }
          return array;
        }
        module.exports = arrayPush;

        /***/
      }, /* 275 */
      /***/function (module, exports, __webpack_require__) {
        var baseAssignValue = __webpack_require__(158),
          eq = __webpack_require__(63);

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * Assigns `value` to `key` of `object` if the existing value is not equivalent
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        module.exports = assignValue;

        /***/
      }, /* 276 */
      /***/function (module, exports) {
        /**
         * The base implementation of `_.findIndex` and `_.findLastIndex` without
         * support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Function} predicate The function invoked per iteration.
         * @param {number} fromIndex The index to search from.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */
        function baseFindIndex(array, predicate, fromIndex, fromRight) {
          var length = array.length,
            index = fromIndex + (fromRight ? 1 : -1);
          while (fromRight ? index-- : ++index < length) {
            if (predicate(array[index], index, array)) {
              return index;
            }
          }
          return -1;
        }
        module.exports = baseFindIndex;

        /***/
      }, /* 277 */
      /***/function (module, exports, __webpack_require__) {
        var baseFindIndex = __webpack_require__(276),
          baseIsNaN = __webpack_require__(280),
          strictIndexOf = __webpack_require__(325);

        /**
         * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} fromIndex The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */
        function baseIndexOf(array, value, fromIndex) {
          return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
        }
        module.exports = baseIndexOf;

        /***/
      }, /* 278 */
      /***/function (module, exports, __webpack_require__) {
        var SetCache = __webpack_require__(83),
          arrayIncludes = __webpack_require__(85),
          arrayIncludesWith = __webpack_require__(86),
          arrayMap = __webpack_require__(87),
          baseUnary = __webpack_require__(88),
          cacheHas = __webpack_require__(89);

        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeMin = Math.min;

        /**
         * The base implementation of methods like `_.intersection`, without support
         * for iteratee shorthands, that accepts an array of arrays to inspect.
         *
         * @private
         * @param {Array} arrays The arrays to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of shared values.
         */
        function baseIntersection(arrays, iteratee, comparator) {
          var includes = comparator ? arrayIncludesWith : arrayIncludes,
            length = arrays[0].length,
            othLength = arrays.length,
            othIndex = othLength,
            caches = Array(othLength),
            maxLength = Infinity,
            result = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee) {
              array = arrayMap(array, baseUnary(iteratee));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
          }
          array = arrays[0];
          var index = -1,
            seen = caches[0];
          outer: while (++index < length && result.length < maxLength) {
            var value = array[index],
              computed = iteratee ? iteratee(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result.push(value);
            }
          }
          return result;
        }
        module.exports = baseIntersection;

        /***/
      }, /* 279 */
      [1576, 59, 35], /* 280 */
      /***/function (module, exports) {
        /**
         * The base implementation of `_.isNaN` without support for number objects.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
         */
        function baseIsNaN(value) {
          return value !== value;
        }
        module.exports = baseIsNaN;

        /***/
      }, /* 281 */
      [1578, 168, 304, 34, 326], /* 282 */
      [1581, 59, 169, 35], /* 283 */
      /***/function (module, exports, __webpack_require__) {
        var isObject = __webpack_require__(34),
          isPrototype = __webpack_require__(305),
          nativeKeysIn = __webpack_require__(316);

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */
        function baseKeysIn(object) {
          if (!isObject(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object),
            result = [];
          for (var key in object) {
            if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
              result.push(key);
            }
          }
          return result;
        }
        module.exports = baseKeysIn;

        /***/
      }, /* 284 */
      /***/function (module, exports, __webpack_require__) {
        var constant = __webpack_require__(328),
          defineProperty = __webpack_require__(162),
          identity = __webpack_require__(166);

        /**
         * The base implementation of `setToString` without support for hot loop shorting.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */
        var baseSetToString = !defineProperty ? identity : function (func, string) {
          return defineProperty(func, 'toString', {
            'configurable': true,
            'enumerable': false,
            'value': constant(string),
            'writable': true
          });
        };
        module.exports = baseSetToString;

        /***/
      }, /* 285 */
      /***/function (module, exports) {
        /**
         * The base implementation of `_.times` without support for iteratee shorthands
         * or max array length checks.
         *
         * @private
         * @param {number} n The number of times to invoke `iteratee`.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the array of results.
         */
        function baseTimes(n, iteratee) {
          var index = -1,
            result = Array(n);
          while (++index < n) {
            result[index] = iteratee(index);
          }
          return result;
        }
        module.exports = baseTimes;

        /***/
      }, /* 286 */
      /***/function (module, exports, __webpack_require__) {
        var baseDifference = __webpack_require__(159),
          baseFlatten = __webpack_require__(160),
          baseUniq = __webpack_require__(161);

        /**
         * The base implementation of methods like `_.xor`, without support for
         * iteratee shorthands, that accepts an array of arrays to inspect.
         *
         * @private
         * @param {Array} arrays The arrays to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of values.
         */
        function baseXor(arrays, iteratee, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1,
            result = Array(length);
          while (++index < length) {
            var array = arrays[index],
              othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        module.exports = baseXor;

        /***/
      }, /* 287 */
      /***/function (module, exports, __webpack_require__) {
        var isArrayLikeObject = __webpack_require__(64);

        /**
         * Casts `value` to an empty array if it's not an array like object.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {Array|Object} Returns the cast array-like object.
         */
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        module.exports = castArrayLikeObject;

        /***/
      }, /* 288 */
      /***/function (module, exports, __webpack_require__) {
        var assignValue = __webpack_require__(275),
          baseAssignValue = __webpack_require__(158);

        /**
         * Copies properties of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy properties from.
         * @param {Array} props The property identifiers to copy.
         * @param {Object} [object={}] The object to copy properties to.
         * @param {Function} [customizer] The function to customize copied values.
         * @returns {Object} Returns `object`.
         */
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1,
            length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
            if (newValue === undefined) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        module.exports = copyObject;

        /***/
      }, /* 289 */
      [1586, 33], /* 290 */
      /***/function (module, exports, __webpack_require__) {
        var baseRest = __webpack_require__(26),
          isIterateeCall = __webpack_require__(302);

        /**
         * Creates a function like `_.assign`.
         *
         * @private
         * @param {Function} assigner The function to assign values.
         * @returns {Function} Returns the new assigner function.
         */
        function createAssigner(assigner) {
          return baseRest(function (object, sources) {
            var index = -1,
              length = sources.length,
              customizer = length > 1 ? sources[length - 1] : undefined,
              guard = length > 2 ? sources[2] : undefined;
            customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined : customizer;
              length = 1;
            }
            object = Object(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, index, customizer);
              }
            }
            return object;
          });
        }
        module.exports = createAssigner;

        /***/
      }, /* 291 */
      /***/function (module, exports, __webpack_require__) {
        var Set = __webpack_require__(271),
          noop = __webpack_require__(170),
          setToArray = __webpack_require__(165);

        /** Used as references for various `Number` constants. */
        var INFINITY = 1 / 0;

        /**
         * Creates a set object of `values`.
         *
         * @private
         * @param {Array} values The values to add to the set.
         * @returns {Object} Returns the new set.
         */
        var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
          return new Set(values);
        };
        module.exports = createSet;

        /***/
      }, /* 292 */
      /***/function (module, exports, __webpack_require__) {
        var eq = __webpack_require__(63);

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
         * of source objects to the destination object for all destination properties
         * that resolve to `undefined`.
         *
         * @private
         * @param {*} objValue The destination value.
         * @param {*} srcValue The source value.
         * @param {string} key The key of the property to assign.
         * @param {Object} object The parent object of `objValue`.
         * @returns {*} Returns the value to assign.
         */
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        module.exports = customDefaultsAssignIn;

        /***/
      }, /* 293 */
      /***/function (module, exports, __webpack_require__) {
        var overArg = __webpack_require__(319);

        /** Built-in value references. */
        var getPrototype = overArg(Object.getPrototypeOf, Object);
        module.exports = getPrototype;

        /***/
      }, /* 294 */
      [1596, 84], /* 295 */
      /***/function (module, exports) {
        /**
         * Gets the value at `key` of `object`.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {string} key The key of the property to get.
         * @returns {*} Returns the property value.
         */
        function getValue(object, key) {
          return object == null ? undefined : object[key];
        }
        module.exports = getValue;

        /***/
      }, /* 296 */
      [1599, 62], /* 297 */
      /***/function (module, exports) {
        /**
         * Removes `key` and its value from the hash.
         *
         * @private
         * @name delete
         * @memberOf Hash
         * @param {Object} hash The hash to modify.
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function hashDelete(key) {
          var result = this.has(key) && delete this.__data__[key];
          this.size -= result ? 1 : 0;
          return result;
        }
        module.exports = hashDelete;

        /***/
      }, /* 298 */
      [1603, 62], /* 299 */
      [1607, 62], /* 300 */
      [1610, 62], /* 301 */
      /***/function (module, exports, __webpack_require__) {
        var Symbol = __webpack_require__(84),
          isArguments = __webpack_require__(167),
          isArray = __webpack_require__(21);

        /** Built-in value references. */
        var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

        /**
         * Checks if `value` is a flattenable `arguments` object or array.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
         */
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        module.exports = isFlattenable;

        /***/
      }, /* 302 */
      /***/function (module, exports, __webpack_require__) {
        var eq = __webpack_require__(63),
          isArrayLike = __webpack_require__(90),
          isIndex = __webpack_require__(164),
          isObject = __webpack_require__(34);

        /**
         * Checks if the given arguments are from an iteratee call.
         *
         * @private
         * @param {*} value The potential iteratee value argument.
         * @param {*} index The potential iteratee index or key argument.
         * @param {*} object The potential iteratee object argument.
         * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
         *  else `false`.
         */
        function isIterateeCall(value, index, object) {
          if (!isObject(object)) {
            return false;
          }
          var type = typeof index;
          if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
            return eq(object[index], value);
          }
          return false;
        }
        module.exports = isIterateeCall;

        /***/
      }, /* 303 */
      /***/function (module, exports) {
        /**
         * Checks if `value` is suitable for use as unique object key.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
         */
        function isKeyable(value) {
          var type = typeof value;
          return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        module.exports = isKeyable;

        /***/
      }, /* 304 */
      [1612, 289], /* 305 */
      /***/function (module, exports) {
        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /**
         * Checks if `value` is likely a prototype object.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
         */
        function isPrototype(value) {
          var Ctor = value && value.constructor,
            proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
          return value === proto;
        }
        module.exports = isPrototype;

        /***/
      }, /* 306 */
      /***/function (module, exports) {
        /**
         * Removes all key-value entries from the list cache.
         *
         * @private
         * @name clear
         * @memberOf ListCache
         */
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        module.exports = listCacheClear;

        /***/
      }, /* 307 */
      [1615, 58], /* 308 */
      [1618, 58], /* 309 */
      [1620, 58], /* 310 */
      [1623, 58], /* 311 */
      [1628, 268, 269, 270], /* 312 */
      [1631, 60], /* 313 */
      [1633, 60], /* 314 */
      [1635, 60], /* 315 */
      [1639, 60], /* 316 */
      /***/function (module, exports) {
        /**
         * This function is like
         * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * except that it includes inherited enumerable properties.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */
        function nativeKeysIn(object) {
          var result = [];
          if (object != null) {
            for (var key in Object(object)) {
              result.push(key);
            }
          }
          return result;
        }
        module.exports = nativeKeysIn;

        /***/
      }, /* 317 */
      [1644, 163], /* 318 */
      /***/function (module, exports) {
        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */
        var nativeObjectToString = objectProto.toString;

        /**
         * Converts `value` to a string using `Object.prototype.toString`.
         *
         * @private
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         */
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        module.exports = objectToString;

        /***/
      }, /* 319 */
      /***/function (module, exports) {
        /**
         * Creates a unary function that invokes `func` with its argument transformed.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {Function} transform The argument transform.
         * @returns {Function} Returns the new function.
         */
        function overArg(func, transform) {
          return function (arg) {
            return func(transform(arg));
          };
        }
        module.exports = overArg;

        /***/
      }, /* 320 */
      /***/function (module, exports, __webpack_require__) {
        var apply = __webpack_require__(157);

        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeMax = Math.max;

        /**
         * A specialized version of `baseRest` which transforms the rest array.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @param {Function} transform The rest array transform.
         * @returns {Function} Returns the new function.
         */
        function overRest(func, start, transform) {
          start = nativeMax(start === undefined ? func.length - 1 : start, 0);
          return function () {
            var args = arguments,
              index = -1,
              length = nativeMax(args.length - start, 0),
              array = Array(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform(array);
            return apply(func, this, otherArgs);
          };
        }
        module.exports = overRest;

        /***/
      }, /* 321 */
      /***/function (module, exports) {
        /** Used to stand-in for `undefined` hash values. */
        var HASH_UNDEFINED = '__lodash_hash_undefined__';

        /**
         * Adds `value` to the array cache.
         *
         * @private
         * @name add
         * @memberOf SetCache
         * @alias push
         * @param {*} value The value to cache.
         * @returns {Object} Returns the cache instance.
         */
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        module.exports = setCacheAdd;

        /***/
      }, /* 322 */
      /***/function (module, exports) {
        /**
         * Checks if `value` is in the array cache.
         *
         * @private
         * @name has
         * @memberOf SetCache
         * @param {*} value The value to search for.
         * @returns {number} Returns `true` if `value` is found, else `false`.
         */
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        module.exports = setCacheHas;

        /***/
      }, /* 323 */
      /***/function (module, exports, __webpack_require__) {
        var baseSetToString = __webpack_require__(284),
          shortOut = __webpack_require__(324);

        /**
         * Sets the `toString` method of `func` to return `string`.
         *
         * @private
         * @param {Function} func The function to modify.
         * @param {Function} string The `toString` result.
         * @returns {Function} Returns `func`.
         */
        var setToString = shortOut(baseSetToString);
        module.exports = setToString;

        /***/
      }, /* 324 */
      /***/function (module, exports) {
        /** Used to detect hot functions by number of calls within a span of milliseconds. */
        var HOT_COUNT = 800,
          HOT_SPAN = 16;

        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeNow = Date.now;

        /**
         * Creates a function that'll short out and invoke `identity` instead
         * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
         * milliseconds.
         *
         * @private
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new shortable function.
         */
        function shortOut(func) {
          var count = 0,
            lastCalled = 0;
          return function () {
            var stamp = nativeNow(),
              remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined, arguments);
          };
        }
        module.exports = shortOut;

        /***/
      }, /* 325 */
      /***/function (module, exports) {
        /**
         * A specialized version of `_.indexOf` which performs strict equality
         * comparisons of values, i.e. `===`.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} fromIndex The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */
        function strictIndexOf(array, value, fromIndex) {
          var index = fromIndex - 1,
            length = array.length;
          while (++index < length) {
            if (array[index] === value) {
              return index;
            }
          }
          return -1;
        }
        module.exports = strictIndexOf;

        /***/
      }, /* 326 */
      200, /* 327 */
      /***/function (module, exports, __webpack_require__) {
        var copyObject = __webpack_require__(288),
          createAssigner = __webpack_require__(290),
          keysIn = __webpack_require__(333);

        /**
         * This method is like `_.assignIn` except that it accepts `customizer`
         * which is invoked to produce the assigned values. If `customizer` returns
         * `undefined`, assignment is handled by the method instead. The `customizer`
         * is invoked with five arguments: (objValue, srcValue, key, object, source).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias extendWith
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} sources The source objects.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @see _.assignWith
         * @example
         *
         * function customizer(objValue, srcValue) {
         *   return _.isUndefined(objValue) ? srcValue : objValue;
         * }
         *
         * var defaults = _.partialRight(_.assignInWith, customizer);
         *
         * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */
        var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        module.exports = assignInWith;

        /***/
      }, /* 328 */
      /***/function (module, exports) {
        /**
         * Creates a function that returns `value`.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {*} value The value to return from the new function.
         * @returns {Function} Returns the new constant function.
         * @example
         *
         * var objects = _.times(2, _.constant({ 'a': 1 }));
         *
         * console.log(objects);
         * // => [{ 'a': 1 }, { 'a': 1 }]
         *
         * console.log(objects[0] === objects[1]);
         * // => true
         */
        function constant(value) {
          return function () {
            return value;
          };
        }
        module.exports = constant;

        /***/
      }, /* 329 */
      /***/function (module, exports, __webpack_require__) {
        var apply = __webpack_require__(157),
          assignInWith = __webpack_require__(327),
          baseRest = __webpack_require__(26),
          customDefaultsAssignIn = __webpack_require__(292);

        /**
         * Assigns own and inherited enumerable string keyed properties of source
         * objects to the destination object for all destination properties that
         * resolve to `undefined`. Source objects are applied from left to right.
         * Once a property is set, additional values of the same property are ignored.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.defaultsDeep
         * @example
         *
         * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */
        var defaults = baseRest(function (args) {
          args.push(undefined, customDefaultsAssignIn);
          return apply(assignInWith, undefined, args);
        });
        module.exports = defaults;

        /***/
      }, /* 330 */
      /***/function (module, exports, __webpack_require__) {
        var arrayMap = __webpack_require__(87),
          baseIntersection = __webpack_require__(278),
          baseRest = __webpack_require__(26),
          castArrayLikeObject = __webpack_require__(287);

        /**
         * Creates an array of unique values that are included in all given arrays
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. The order and references of result values are
         * determined by the first array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of intersecting values.
         * @example
         *
         * _.intersection([2, 1], [2, 3]);
         * // => [2]
         */
        var intersection = baseRest(function (arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        module.exports = intersection;

        /***/
      }, /* 331 */
      [1657, 33, 335], /* 332 */
      [1662, 282, 88, 317], /* 333 */
      /***/function (module, exports, __webpack_require__) {
        var arrayLikeKeys = __webpack_require__(273),
          baseKeysIn = __webpack_require__(283),
          isArrayLike = __webpack_require__(90);

        /**
         * Creates an array of the own and inherited enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keysIn(new Foo);
         * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
         */
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        module.exports = keysIn;

        /***/
      }, /* 334 */
      [1667, 156], /* 335 */
      /***/function (module, exports) {
        /**
         * This method returns `false`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `false`.
         * @example
         *
         * _.times(2, _.stubFalse);
         * // => [false, false]
         */
        function stubFalse() {
          return false;
        }
        module.exports = stubFalse;

        /***/
      }, /* 336 */
      /***/function (module, exports, __webpack_require__) {
        var baseFlatten = __webpack_require__(160),
          baseRest = __webpack_require__(26),
          baseUniq = __webpack_require__(161),
          isArrayLikeObject = __webpack_require__(64);

        /**
         * Creates an array of unique values, in order, from all given arrays using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of combined values.
         * @example
         *
         * _.union([2], [1, 2]);
         * // => [2, 1]
         */
        var union = baseRest(function (arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        module.exports = union;

        /***/
      }, /* 337 */
      /***/function (module, exports, __webpack_require__) {
        var arrayFilter = __webpack_require__(272),
          baseRest = __webpack_require__(26),
          baseXor = __webpack_require__(286),
          isArrayLikeObject = __webpack_require__(64);

        /**
         * Creates an array of unique values that is the
         * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
         * of the given arrays. The order of result values is determined by the order
         * they occur in the arrays.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.difference, _.without
         * @example
         *
         * _.xor([2, 1], [2, 3]);
         * // => [1, 3]
         */
        var xor = baseRest(function (arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        module.exports = xor;

        /***/
      }, /* 338 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _classnames = __webpack_require__(65);
        var _classnames2 = _interopRequireDefault(_classnames);
        var _objectAssign = __webpack_require__(36);
        var _objectAssign2 = _interopRequireDefault(_objectAssign);
        var _globalEventListener = __webpack_require__(91);
        var _globalEventListener2 = _interopRequireDefault(_globalEventListener);
        var _AbstractMenu2 = __webpack_require__(172);
        var _AbstractMenu3 = _interopRequireDefault(_AbstractMenu2);
        var _SubMenu = __webpack_require__(175);
        var _SubMenu2 = _interopRequireDefault(_SubMenu);
        var _actions = __webpack_require__(27);
        var _helpers = __webpack_require__(28);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var ContextMenu = function (_AbstractMenu) {
          _inherits(ContextMenu, _AbstractMenu);
          function ContextMenu(props) {
            _classCallCheck(this, ContextMenu);
            var _this = _possibleConstructorReturn(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).call(this, props));
            _this.registerHandlers = function () {
              document.addEventListener('mousedown', _this.handleOutsideClick);
              document.addEventListener('ontouchstart', _this.handleOutsideClick);
              document.addEventListener('scroll', _this.handleHide);
              document.addEventListener('contextmenu', _this.handleHide);
              document.addEventListener('keydown', _this.handleKeyNavigation);
              window.addEventListener('resize', _this.handleHide);
            };
            _this.unregisterHandlers = function () {
              document.removeEventListener('mousedown', _this.handleOutsideClick);
              document.removeEventListener('ontouchstart', _this.handleOutsideClick);
              document.removeEventListener('scroll', _this.handleHide);
              document.removeEventListener('contextmenu', _this.handleHide);
              document.removeEventListener('keydown', _this.handleKeyNavigation);
              window.removeEventListener('resize', _this.handleHide);
            };
            _this.handleShow = function (e) {
              if (e.detail.id !== _this.props.id || _this.state.isVisible) return;
              var _e$detail$position = e.detail.position,
                x = _e$detail$position.x,
                y = _e$detail$position.y;
              _this.setState({
                isVisible: true,
                x: x,
                y: y
              });
              _this.registerHandlers();
              (0, _helpers.callIfExists)(_this.props.onShow, e);
            };
            _this.handleHide = function (e) {
              if (_this.state.isVisible && (!e.detail || !e.detail.id || e.detail.id === _this.props.id)) {
                _this.unregisterHandlers();
                _this.setState({
                  isVisible: false,
                  selectedItem: null,
                  forceSubMenuOpen: false
                });
                (0, _helpers.callIfExists)(_this.props.onHide, e);
              }
            };
            _this.handleOutsideClick = function (e) {
              if (!_this.menu.contains(e.target)) (0, _actions.hideMenu)();
            };
            _this.handleMouseLeave = function (event) {
              event.preventDefault();
              (0, _helpers.callIfExists)(_this.props.onMouseLeave, event, (0, _objectAssign2.default)({}, _this.props.data, _helpers.store.data), _helpers.store.target);
              if (_this.props.hideOnLeave) (0, _actions.hideMenu)();
            };
            _this.handleContextMenu = function (e) {
              if (true) {
                e.preventDefault();
              }
              _this.handleHide(e);
            };
            _this.hideMenu = function (e) {
              if (e.keyCode === 27 || e.keyCode === 13) {
                // ECS or enter
                (0, _actions.hideMenu)();
              }
            };
            _this.getMenuPosition = function () {
              var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var menuStyles = {
                top: y,
                left: x
              };
              if (!_this.menu) return menuStyles;
              var _window = window,
                innerWidth = _window.innerWidth,
                innerHeight = _window.innerHeight;
              var rect = _this.menu.getBoundingClientRect();
              if (y + rect.height > innerHeight) {
                menuStyles.top -= rect.height;
              }
              if (x + rect.width > innerWidth) {
                menuStyles.left -= rect.width;
              }
              if (menuStyles.top < 0) {
                menuStyles.top = rect.height < innerHeight ? (innerHeight - rect.height) / 2 : 0;
              }
              if (menuStyles.left < 0) {
                menuStyles.left = rect.width < innerWidth ? (innerWidth - rect.width) / 2 : 0;
              }
              return menuStyles;
            };
            _this.menuRef = function (c) {
              _this.menu = c;
            };
            _this.state = (0, _objectAssign2.default)({}, _this.state, {
              x: 0,
              y: 0,
              isVisible: false
            });
            return _this;
          }
          _createClass(ContextMenu, [{
            key: 'getSubMenuType',
            value: function getSubMenuType() {
              // eslint-disable-line class-methods-use-this
              return _SubMenu2.default;
            }
          }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
              this.listenId = _globalEventListener2.default.register(this.handleShow, this.handleHide);
            }
          }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
              var _this2 = this;
              if (this.state.isVisible) {
                var wrapper = window.requestAnimationFrame || setTimeout;
                wrapper(function () {
                  var _state = _this2.state,
                    x = _state.x,
                    y = _state.y;
                  var _getMenuPosition = _this2.getMenuPosition(x, y),
                    top = _getMenuPosition.top,
                    left = _getMenuPosition.left;
                  wrapper(function () {
                    if (!_this2.menu) return;
                    _this2.menu.style.top = top + 'px';
                    _this2.menu.style.left = left + 'px';
                    _this2.menu.style.opacity = 1;
                    _this2.menu.style.pointerEvents = 'auto';
                  });
                });
              } else {
                if (!this.menu) return;
                this.menu.style.opacity = 0;
                this.menu.style.pointerEvents = 'none';
              }
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              if (this.listenId) {
                _globalEventListener2.default.unregister(this.listenId);
              }
              this.unregisterHandlers();
            }
          }, {
            key: 'render',
            value: function render() {
              var _props = this.props,
                children = _props.children,
                className = _props.className,
                style = _props.style;
              var isVisible = this.state.isVisible;
              var inlineStyle = (0, _objectAssign2.default)({}, style, {
                position: 'fixed',
                opacity: 0,
                pointerEvents: 'none'
              });
              var menuClassnames = (0, _classnames2.default)(_helpers.cssClasses.menu, className, _defineProperty({}, _helpers.cssClasses.menuVisible, isVisible));
              return _react2.default.createElement('nav', {
                role: 'menu',
                tabIndex: '-1',
                ref: this.menuRef,
                style: inlineStyle,
                className: menuClassnames,
                onContextMenu: this.handleContextMenu,
                onMouseLeave: this.handleMouseLeave
              }, this.renderChildren(children));
            }
          }]);
          return ContextMenu;
        }(_AbstractMenu3.default);
        ContextMenu.propTypes = {
          id: _propTypes2.default.string.isRequired,
          children: _propTypes2.default.node.isRequired,
          data: _propTypes2.default.object,
          className: _propTypes2.default.string,
          hideOnLeave: _propTypes2.default.bool,
          onHide: _propTypes2.default.func,
          onMouseLeave: _propTypes2.default.func,
          onShow: _propTypes2.default.func,
          style: _propTypes2.default.object
        };
        ContextMenu.defaultProps = {
          className: '',
          data: {},
          hideOnLeave: false,
          onHide: function onHide() {
            return null;
          },
          onMouseLeave: function onMouseLeave() {
            return null;
          },
          onShow: function onShow() {
            return null;
          },
          style: {}
        };
        exports.default = ContextMenu;

        /***/
      }, /* 339 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        exports.default = function (menuId) {
          // expect menu component to connect as inner parameter
          // <Child/> is presumably a wrapper of <ContextMenu/>
          return function (Child) {
            // return wrapper for <Child/> that forwards the ContextMenuTrigger's additional props
            return function (_Component) {
              _inherits(ConnectMenu, _Component);
              function ConnectMenu(props) {
                _classCallCheck(this, ConnectMenu);
                var _this = _possibleConstructorReturn(this, (ConnectMenu.__proto__ || Object.getPrototypeOf(ConnectMenu)).call(this, props));
                _this.handleShow = function (e) {
                  if (e.detail.id !== menuId) return;

                  // the onShow event's detail.data object holds all ContextMenuTrigger props
                  var data = e.detail.data;
                  var filteredData = {};
                  for (var key in data) {
                    // exclude props the ContextMenuTrigger is expecting itself
                    if (!ignoredTriggerProps.includes(key)) {
                      filteredData[key] = data[key];
                    }
                  }
                  _this.setState({
                    trigger: filteredData
                  });
                };
                _this.handleHide = function () {
                  _this.setState({
                    trigger: null
                  });
                };
                _this.state = {
                  trigger: null
                };
                return _this;
              }
              _createClass(ConnectMenu, [{
                key: 'componentDidMount',
                value: function componentDidMount() {
                  this.listenId = _globalEventListener2.default.register(this.handleShow, this.handleHide);
                }
              }, {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                  if (this.listenId) {
                    _globalEventListener2.default.unregister(this.listenId);
                  }
                }
              }, {
                key: 'render',
                value: function render() {
                  return _react2.default.createElement(Child, _extends({}, this.props, {
                    id: menuId,
                    trigger: this.state.trigger
                  }));
                }
              }]);
              return ConnectMenu;
            }(_react.Component);
          };
        };
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _ContextMenuTrigger = __webpack_require__(173);
        var _ContextMenuTrigger2 = _interopRequireDefault(_ContextMenuTrigger);
        var _globalEventListener = __webpack_require__(91);
        var _globalEventListener2 = _interopRequireDefault(_globalEventListener);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        function _toConsumableArray(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }
            return arr2;
          } else {
            return Array.from(arr);
          }
        }

        // collect ContextMenuTrigger's expected props to NOT pass them on as part of the context
        var ignoredTriggerProps = [].concat(_toConsumableArray(Object.keys(_ContextMenuTrigger2.default.propTypes)), ['children']);

        // expect the id of the menu to be responsible for as outer parameter

        /***/
      }, /* 340 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _ContextMenu = __webpack_require__(338);
        Object.defineProperty(exports, 'ContextMenu', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_ContextMenu).default;
          }
        });
        var _ContextMenuTrigger = __webpack_require__(173);
        Object.defineProperty(exports, 'ContextMenuTrigger', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_ContextMenuTrigger).default;
          }
        });
        var _MenuItem = __webpack_require__(174);
        Object.defineProperty(exports, 'MenuItem', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_MenuItem).default;
          }
        });
        var _SubMenu = __webpack_require__(175);
        Object.defineProperty(exports, 'SubMenu', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_SubMenu).default;
          }
        });
        var _connectMenu = __webpack_require__(339);
        Object.defineProperty(exports, 'connectMenu', {
          enumerable: true,
          get: function get() {
            return _interopRequireDefault(_connectMenu).default;
          }
        });
        var _actions = __webpack_require__(27);
        Object.defineProperty(exports, 'hideMenu', {
          enumerable: true,
          get: function get() {
            return _actions.hideMenu;
          }
        });
        Object.defineProperty(exports, 'showMenu', {
          enumerable: true,
          get: function get() {
            return _actions.showMenu;
          }
        });
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        /***/
      }, /* 341 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _union = __webpack_require__(336);
        var _union2 = _interopRequireDefault(_union);
        var _without = __webpack_require__(171);
        var _without2 = _interopRequireDefault(_without);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var EnterLeaveCounter = function () {
          function EnterLeaveCounter() {
            _classCallCheck(this, EnterLeaveCounter);
            this.entered = [];
          }
          _createClass(EnterLeaveCounter, [{
            key: 'enter',
            value: function enter(enteringNode) {
              var previousLength = this.entered.length;
              var isNodeEntered = function isNodeEntered(node) {
                return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
              };
              this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);
              return previousLength === 0 && this.entered.length > 0;
            }
          }, {
            key: 'leave',
            value: function leave(leavingNode) {
              var previousLength = this.entered.length;
              this.entered = (0, _without2.default)(this.entered.filter(function (node) {
                return document.documentElement.contains(node);
              }), leavingNode);
              return previousLength > 0 && this.entered.length === 0;
            }
          }, {
            key: 'reset',
            value: function reset() {
              this.entered = [];
            }
          }]);
          return EnterLeaveCounter;
        }();
        exports.default = EnterLeaveCounter;

        /***/
      }, /* 342 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }(); /* eslint-disable no-underscore-dangle */

        var _defaults = __webpack_require__(329);
        var _defaults2 = _interopRequireDefault(_defaults);
        var _shallowEqual = __webpack_require__(348);
        var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
        var _EnterLeaveCounter = __webpack_require__(341);
        var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);
        var _BrowserDetector = __webpack_require__(176);
        var _OffsetUtils = __webpack_require__(345);
        var _NativeDragSources = __webpack_require__(344);
        var _NativeTypes = __webpack_require__(92);
        var NativeTypes = _interopRequireWildcard(_NativeTypes);
        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};
            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }
            newObj.default = obj;
            return newObj;
          }
        }
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var HTML5Backend = function () {
          function HTML5Backend(manager) {
            _classCallCheck(this, HTML5Backend);
            this.actions = manager.getActions();
            this.monitor = manager.getMonitor();
            this.registry = manager.getRegistry();
            this.context = manager.getContext();
            this.sourcePreviewNodes = {};
            this.sourcePreviewNodeOptions = {};
            this.sourceNodes = {};
            this.sourceNodeOptions = {};
            this.enterLeaveCounter = new _EnterLeaveCounter2.default();
            this.dragStartSourceIds = [];
            this.dropTargetIds = [];
            this.dragEnterTargetIds = [];
            this.currentNativeSource = null;
            this.currentNativeHandle = null;
            this.currentDragSourceNode = null;
            this.currentDragSourceNodeOffset = null;
            this.currentDragSourceNodeOffsetChanged = false;
            this.altKeyPressed = false;
            this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
            this.handleTopDragStart = this.handleTopDragStart.bind(this);
            this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
            this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
            this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
            this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
            this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
            this.handleTopDragOver = this.handleTopDragOver.bind(this);
            this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
            this.handleTopDrop = this.handleTopDrop.bind(this);
            this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
            this.handleSelectStart = this.handleSelectStart.bind(this);
            this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
            this.endDragNativeItem = this.endDragNativeItem.bind(this);
            this.asyncEndDragNativeItem = this.asyncEndDragNativeItem.bind(this);
            this.isNodeInDocument = this.isNodeInDocument.bind(this);
          }
          _createClass(HTML5Backend, [{
            key: 'setup',
            value: function setup() {
              if (this.window === undefined) {
                return;
              }
              if (this.window.__isReactDndBackendSetUp) {
                throw new Error('Cannot have two HTML5 backends at the same time.');
              }
              this.window.__isReactDndBackendSetUp = true;
              this.addEventListeners(this.window);
            }
          }, {
            key: 'teardown',
            value: function teardown() {
              if (this.window === undefined) {
                return;
              }
              this.window.__isReactDndBackendSetUp = false;
              this.removeEventListeners(this.window);
              this.clearCurrentDragSourceNode();
              if (this.asyncEndDragFrameId) {
                this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
              }
            }
          }, {
            key: 'addEventListeners',
            value: function addEventListeners(target) {
              // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
              if (!target.addEventListener) {
                return;
              }
              target.addEventListener('dragstart', this.handleTopDragStart);
              target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
              target.addEventListener('dragend', this.handleTopDragEndCapture, true);
              target.addEventListener('dragenter', this.handleTopDragEnter);
              target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
              target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
              target.addEventListener('dragover', this.handleTopDragOver);
              target.addEventListener('dragover', this.handleTopDragOverCapture, true);
              target.addEventListener('drop', this.handleTopDrop);
              target.addEventListener('drop', this.handleTopDropCapture, true);
            }
          }, {
            key: 'removeEventListeners',
            value: function removeEventListeners(target) {
              // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
              if (!target.removeEventListener) {
                return;
              }
              target.removeEventListener('dragstart', this.handleTopDragStart);
              target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
              target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
              target.removeEventListener('dragenter', this.handleTopDragEnter);
              target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
              target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
              target.removeEventListener('dragover', this.handleTopDragOver);
              target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
              target.removeEventListener('drop', this.handleTopDrop);
              target.removeEventListener('drop', this.handleTopDropCapture, true);
            }
          }, {
            key: 'connectDragPreview',
            value: function connectDragPreview(sourceId, node, options) {
              var _this = this;
              this.sourcePreviewNodeOptions[sourceId] = options;
              this.sourcePreviewNodes[sourceId] = node;
              return function () {
                delete _this.sourcePreviewNodes[sourceId];
                delete _this.sourcePreviewNodeOptions[sourceId];
              };
            }
          }, {
            key: 'connectDragSource',
            value: function connectDragSource(sourceId, node, options) {
              var _this2 = this;
              this.sourceNodes[sourceId] = node;
              this.sourceNodeOptions[sourceId] = options;
              var handleDragStart = function handleDragStart(e) {
                return _this2.handleDragStart(e, sourceId);
              };
              var handleSelectStart = function handleSelectStart(e) {
                return _this2.handleSelectStart(e, sourceId);
              };
              node.setAttribute('draggable', true);
              node.addEventListener('dragstart', handleDragStart);
              node.addEventListener('selectstart', handleSelectStart);
              return function () {
                delete _this2.sourceNodes[sourceId];
                delete _this2.sourceNodeOptions[sourceId];
                node.removeEventListener('dragstart', handleDragStart);
                node.removeEventListener('selectstart', handleSelectStart);
                node.setAttribute('draggable', false);
              };
            }
          }, {
            key: 'connectDropTarget',
            value: function connectDropTarget(targetId, node) {
              var _this3 = this;
              var handleDragEnter = function handleDragEnter(e) {
                return _this3.handleDragEnter(e, targetId);
              };
              var handleDragOver = function handleDragOver(e) {
                return _this3.handleDragOver(e, targetId);
              };
              var handleDrop = function handleDrop(e) {
                return _this3.handleDrop(e, targetId);
              };
              node.addEventListener('dragenter', handleDragEnter);
              node.addEventListener('dragover', handleDragOver);
              node.addEventListener('drop', handleDrop);
              return function () {
                node.removeEventListener('dragenter', handleDragEnter);
                node.removeEventListener('dragover', handleDragOver);
                node.removeEventListener('drop', handleDrop);
              };
            }
          }, {
            key: 'getCurrentSourceNodeOptions',
            value: function getCurrentSourceNodeOptions() {
              var sourceId = this.monitor.getSourceId();
              var sourceNodeOptions = this.sourceNodeOptions[sourceId];
              return (0, _defaults2.default)(sourceNodeOptions || {}, {
                dropEffect: this.altKeyPressed ? 'copy' : 'move'
              });
            }
          }, {
            key: 'getCurrentDropEffect',
            value: function getCurrentDropEffect() {
              if (this.isDraggingNativeItem()) {
                // It makes more sense to default to 'copy' for native resources
                return 'copy';
              }
              return this.getCurrentSourceNodeOptions().dropEffect;
            }
          }, {
            key: 'getCurrentSourcePreviewNodeOptions',
            value: function getCurrentSourcePreviewNodeOptions() {
              var sourceId = this.monitor.getSourceId();
              var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
              return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
                anchorX: 0.5,
                anchorY: 0.5,
                captureDraggingState: false
              });
            }
          }, {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset(sourceId) {
              return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
            }
          }, {
            key: 'isDraggingNativeItem',
            value: function isDraggingNativeItem() {
              var itemType = this.monitor.getItemType();
              return Object.keys(NativeTypes).some(function (key) {
                return NativeTypes[key] === itemType;
              });
            }
          }, {
            key: 'beginDragNativeItem',
            value: function beginDragNativeItem(type) {
              this.clearCurrentDragSourceNode();
              var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
              this.currentNativeSource = new SourceType();
              this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
              this.actions.beginDrag([this.currentNativeHandle]);

              // On Firefox, if mouseover fires, the drag is over but browser failed to tell us.
              // See https://bugzilla.mozilla.org/show_bug.cgi?id=656164
              // This is not true for other browsers.
              if ((0, _BrowserDetector.isFirefox)()) {
                this.window.addEventListener('mouseover', this.asyncEndDragNativeItem, true);
              }
            }
          }, {
            key: 'asyncEndDragNativeItem',
            value: function asyncEndDragNativeItem() {
              this.asyncEndDragFrameId = this.window.requestAnimationFrame(this.endDragNativeItem);
              if ((0, _BrowserDetector.isFirefox)()) {
                this.window.removeEventListener('mouseover', this.asyncEndDragNativeItem, true);
                this.enterLeaveCounter.reset();
              }
            }
          }, {
            key: 'endDragNativeItem',
            value: function endDragNativeItem() {
              if (!this.isDraggingNativeItem()) {
                return;
              }
              this.actions.endDrag();
              this.registry.removeSource(this.currentNativeHandle);
              this.currentNativeHandle = null;
              this.currentNativeSource = null;
            }
          }, {
            key: 'isNodeInDocument',
            value: function isNodeInDocument(node) {
              // Check the node either in the main document or in the current context
              return document.body.contains(node) || this.window ? this.window.document.body.contains(node) : false;
            }
          }, {
            key: 'endDragIfSourceWasRemovedFromDOM',
            value: function endDragIfSourceWasRemovedFromDOM() {
              var node = this.currentDragSourceNode;
              if (this.isNodeInDocument(node)) {
                return;
              }
              if (this.clearCurrentDragSourceNode()) {
                this.actions.endDrag();
              }
            }
          }, {
            key: 'setCurrentDragSourceNode',
            value: function setCurrentDragSourceNode(node) {
              this.clearCurrentDragSourceNode();
              this.currentDragSourceNode = node;
              this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
              this.currentDragSourceNodeOffsetChanged = false;

              // Receiving a mouse event in the middle of a dragging operation
              // means it has ended and the drag source node disappeared from DOM,
              // so the browser didn't dispatch the dragend event.
              this.window.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
            }
          }, {
            key: 'clearCurrentDragSourceNode',
            value: function clearCurrentDragSourceNode() {
              if (this.currentDragSourceNode) {
                this.currentDragSourceNode = null;
                this.currentDragSourceNodeOffset = null;
                this.currentDragSourceNodeOffsetChanged = false;
                this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
                return true;
              }
              return false;
            }
          }, {
            key: 'checkIfCurrentDragSourceRectChanged',
            value: function checkIfCurrentDragSourceRectChanged() {
              var node = this.currentDragSourceNode;
              if (!node) {
                return false;
              }
              if (this.currentDragSourceNodeOffsetChanged) {
                return true;
              }
              this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);
              return this.currentDragSourceNodeOffsetChanged;
            }
          }, {
            key: 'handleTopDragStartCapture',
            value: function handleTopDragStartCapture() {
              this.clearCurrentDragSourceNode();
              this.dragStartSourceIds = [];
            }
          }, {
            key: 'handleDragStart',
            value: function handleDragStart(e, sourceId) {
              this.dragStartSourceIds.unshift(sourceId);
            }
          }, {
            key: 'handleTopDragStart',
            value: function handleTopDragStart(e) {
              var _this4 = this;
              var dragStartSourceIds = this.dragStartSourceIds;
              this.dragStartSourceIds = null;
              var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);

              // Avoid crashing if we missed a drop event or our previous drag died
              if (this.monitor.isDragging()) {
                this.actions.endDrag();
              }

              // Don't publish the source just yet (see why below)
              this.actions.beginDrag(dragStartSourceIds, {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset: clientOffset
              });
              var dataTransfer = e.dataTransfer;
              var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
              if (this.monitor.isDragging()) {
                if (typeof dataTransfer.setDragImage === 'function') {
                  // Use custom drag image if user specifies it.
                  // If child drag source refuses drag but parent agrees,
                  // use parent's node as drag image. Neither works in IE though.
                  var sourceId = this.monitor.getSourceId();
                  var sourceNode = this.sourceNodes[sourceId];
                  var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
                  var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
                    anchorX = _getCurrentSourcePrev.anchorX,
                    anchorY = _getCurrentSourcePrev.anchorY,
                    offsetX = _getCurrentSourcePrev.offsetX,
                    offsetY = _getCurrentSourcePrev.offsetY;
                  var anchorPoint = {
                    anchorX: anchorX,
                    anchorY: anchorY
                  };
                  var offsetPoint = {
                    offsetX: offsetX,
                    offsetY: offsetY
                  };
                  var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                  dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                }
                try {
                  // Firefox won't drag without setting data
                  dataTransfer.setData('application/json', {});
                } catch (err) {}
                // IE doesn't support MIME types in setData

                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);

                // Now we are ready to publish the drag source.. or are we not?

                var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
                  captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;
                if (!captureDraggingState) {
                  // Usually we want to publish it in the next tick so that browser
                  // is able to screenshot the current (not yet dragging) state.
                  //
                  // It also neatly avoids a situation where render() returns null
                  // in the same tick for the source element, and browser freaks out.
                  setTimeout(function () {
                    return _this4.actions.publishDragSource();
                  });
                } else {
                  // In some cases the user may want to override this behavior, e.g.
                  // to work around IE not supporting custom drag previews.
                  //
                  // When using a custom drag layer, the only way to prevent
                  // the default drag preview from drawing in IE is to screenshot
                  // the dragging state in which the node itself has zero opacity
                  // and height. In this case, though, returning null from render()
                  // will abruptly end the dragging, which is not obvious.
                  //
                  // This is the reason such behavior is strictly opt-in.
                  this.actions.publishDragSource();
                }
              } else if (nativeType) {
                // A native item (such as URL) dragged from inside the document
                this.beginDragNativeItem(nativeType);
              } else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
                // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
                // Just let it drag. It's a native type (URL or text) and will be picked up in
                // dragenter handler.
                return; // eslint-disable-line no-useless-return
              } else {
                // If by this time no drag source reacted, tell browser not to drag.
                e.preventDefault();
              }
            }
          }, {
            key: 'handleTopDragEndCapture',
            value: function handleTopDragEndCapture() {
              if (this.clearCurrentDragSourceNode()) {
                // Firefox can dispatch this event in an infinite loop
                // if dragend handler does something like showing an alert.
                // Only proceed if we have not handled it already.
                this.actions.endDrag();
              }
            }
          }, {
            key: 'handleTopDragEnterCapture',
            value: function handleTopDragEnterCapture(e) {
              this.dragEnterTargetIds = [];
              var isFirstEnter = this.enterLeaveCounter.enter(e.target);
              if (!isFirstEnter || this.monitor.isDragging()) {
                return;
              }
              var dataTransfer = e.dataTransfer;
              var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
              if (nativeType) {
                // A native item (such as file or URL) dragged from outside the document
                this.beginDragNativeItem(nativeType);
              }
            }
          }, {
            key: 'handleDragEnter',
            value: function handleDragEnter(e, targetId) {
              this.dragEnterTargetIds.unshift(targetId);
            }
          }, {
            key: 'handleTopDragEnter',
            value: function handleTopDragEnter(e) {
              var _this5 = this;
              var dragEnterTargetIds = this.dragEnterTargetIds;
              this.dragEnterTargetIds = [];
              if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                return;
              }
              this.altKeyPressed = e.altKey;
              if (!(0, _BrowserDetector.isFirefox)()) {
                // Don't emit hover in `dragenter` on Firefox due to an edge case.
                // If the target changes position as the result of `dragenter`, Firefox
                // will still happily dispatch `dragover` despite target being no longer
                // there. The easy solution is to only fire `hover` in `dragover` on FF.
                this.actions.hover(dragEnterTargetIds, {
                  clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
                });
              }
              var canDrop = dragEnterTargetIds.some(function (targetId) {
                return _this5.monitor.canDropOnTarget(targetId);
              });
              if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                e.dataTransfer.dropEffect = this.getCurrentDropEffect();
              }
            }
          }, {
            key: 'handleTopDragOverCapture',
            value: function handleTopDragOverCapture() {
              this.dragOverTargetIds = [];
            }
          }, {
            key: 'handleDragOver',
            value: function handleDragOver(e, targetId) {
              this.dragOverTargetIds.unshift(targetId);
            }
          }, {
            key: 'handleTopDragOver',
            value: function handleTopDragOver(e) {
              var _this6 = this;
              var dragOverTargetIds = this.dragOverTargetIds;
              this.dragOverTargetIds = [];
              if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                e.dataTransfer.dropEffect = 'none';
                return;
              }
              this.altKeyPressed = e.altKey;
              this.actions.hover(dragOverTargetIds, {
                clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
              });
              var canDrop = dragOverTargetIds.some(function (targetId) {
                return _this6.monitor.canDropOnTarget(targetId);
              });
              if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                e.dataTransfer.dropEffect = this.getCurrentDropEffect();
              } else if (this.isDraggingNativeItem()) {
                // Don't show a nice cursor but still prevent default
                // "drop and blow away the whole document" action.
                e.preventDefault();
                e.dataTransfer.dropEffect = 'none';
              } else if (this.checkIfCurrentDragSourceRectChanged()) {
                // Prevent animating to incorrect position.
                // Drop effect must be other than 'none' to prevent animation.
                e.preventDefault();
                e.dataTransfer.dropEffect = 'move';
              }
            }
          }, {
            key: 'handleTopDragLeaveCapture',
            value: function handleTopDragLeaveCapture(e) {
              if (this.isDraggingNativeItem()) {
                e.preventDefault();
              }
              var isLastLeave = this.enterLeaveCounter.leave(e.target);
              if (!isLastLeave) {
                return;
              }
              if (this.isDraggingNativeItem()) {
                this.endDragNativeItem();
              }
            }
          }, {
            key: 'handleTopDropCapture',
            value: function handleTopDropCapture(e) {
              this.dropTargetIds = [];
              e.preventDefault();
              if (this.isDraggingNativeItem()) {
                this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
              }
              this.enterLeaveCounter.reset();
            }
          }, {
            key: 'handleDrop',
            value: function handleDrop(e, targetId) {
              this.dropTargetIds.unshift(targetId);
            }
          }, {
            key: 'handleTopDrop',
            value: function handleTopDrop(e) {
              var dropTargetIds = this.dropTargetIds;
              this.dropTargetIds = [];
              this.actions.hover(dropTargetIds, {
                clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
              });
              this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
              });
              if (this.isDraggingNativeItem()) {
                this.endDragNativeItem();
              } else {
                this.endDragIfSourceWasRemovedFromDOM();
              }
            }
          }, {
            key: 'handleSelectStart',
            value: function handleSelectStart(e) {
              var target = e.target;

              // Only IE requires us to explicitly say
              // we want drag drop operation to start

              if (typeof target.dragDrop !== 'function') {
                return;
              }

              // Inputs and textareas should be selectable
              if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
                return;
              }

              // For other targets, ask IE
              // to enable drag and drop
              e.preventDefault();
              target.dragDrop();
            }
          }, {
            key: 'window',
            get: function get() {
              if (this.context && this.context.window) {
                return this.context.window;
              } else if (typeof window !== 'undefined') {
                return window;
              }
              return undefined;
            }
          }]);
          return HTML5Backend;
        }();
        exports.default = HTML5Backend;

        /***/
      }, /* 343 */
      /***/function (module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        /* eslint
           no-plusplus: off,
           no-mixed-operators: off
        */
        var MonotonicInterpolant = function () {
          function MonotonicInterpolant(xs, ys) {
            _classCallCheck(this, MonotonicInterpolant);
            var length = xs.length;

            // Rearrange xs and ys so that xs is sorted
            var indexes = [];
            for (var i = 0; i < length; i++) {
              indexes.push(i);
            }
            indexes.sort(function (a, b) {
              return xs[a] < xs[b] ? -1 : 1;
            });

            // Get consecutive differences and slopes
            var dys = [];
            var dxs = [];
            var ms = [];
            var dx = void 0;
            var dy = void 0;
            for (var _i = 0; _i < length - 1; _i++) {
              dx = xs[_i + 1] - xs[_i];
              dy = ys[_i + 1] - ys[_i];
              dxs.push(dx);
              dys.push(dy);
              ms.push(dy / dx);
            }

            // Get degree-1 coefficients
            var c1s = [ms[0]];
            for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
              var _m = ms[_i2];
              var mNext = ms[_i2 + 1];
              if (_m * mNext <= 0) {
                c1s.push(0);
              } else {
                dx = dxs[_i2];
                var dxNext = dxs[_i2 + 1];
                var common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
              }
            }
            c1s.push(ms[ms.length - 1]);

            // Get degree-2 and degree-3 coefficients
            var c2s = [];
            var c3s = [];
            var m = void 0;
            for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
              m = ms[_i3];
              var c1 = c1s[_i3];
              var invDx = 1 / dxs[_i3];
              var _common = c1 + c1s[_i3 + 1] - m - m;
              c2s.push((m - c1 - _common) * invDx);
              c3s.push(_common * invDx * invDx);
            }
            this.xs = xs;
            this.ys = ys;
            this.c1s = c1s;
            this.c2s = c2s;
            this.c3s = c3s;
          }
          _createClass(MonotonicInterpolant, [{
            key: "interpolate",
            value: function interpolate(x) {
              var xs = this.xs,
                ys = this.ys,
                c1s = this.c1s,
                c2s = this.c2s,
                c3s = this.c3s;

              // The rightmost point in the dataset should give an exact result

              var i = xs.length - 1;
              if (x === xs[i]) {
                return ys[i];
              }

              // Search for the interval x is in, returning the corresponding y if x is one of the original xs
              var low = 0;
              var high = c3s.length - 1;
              var mid = void 0;
              while (low <= high) {
                mid = Math.floor(0.5 * (low + high));
                var xHere = xs[mid];
                if (xHere < x) {
                  low = mid + 1;
                } else if (xHere > x) {
                  high = mid - 1;
                } else {
                  return ys[mid];
                }
              }
              i = Math.max(0, high);

              // Interpolate
              var diff = x - xs[i];
              var diffSq = diff * diff;
              return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
            }
          }]);
          return MonotonicInterpolant;
        }();
        exports.default = MonotonicInterpolant;

        /***/
      }, /* 344 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _nativeTypesConfig;
        exports.createNativeDragSource = createNativeDragSource;
        exports.matchNativeItemType = matchNativeItemType;
        var _NativeTypes = __webpack_require__(92);
        var NativeTypes = _interopRequireWildcard(_NativeTypes);
        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};
            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }
            newObj.default = obj;
            return newObj;
          }
        }
        function _defineEnumerableProperties(obj, descs) {
          for (var key in descs) {
            var desc = descs[key];
            desc.configurable = desc.enumerable = true;
            if ("value" in desc) desc.writable = true;
            Object.defineProperty(obj, key, desc);
          }
          return obj;
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
          var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
            return resultSoFar || dataTransfer.getData(typeToTry);
          }, null);
          return result != null // eslint-disable-line eqeqeq
          ? result : defaultValue;
        }
        var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
          exposeProperty: 'files',
          matchesTypes: ['Files'],
          getData: function getData(dataTransfer) {
            return Array.prototype.slice.call(dataTransfer.files);
          }
        }), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
          exposeProperty: 'urls',
          matchesTypes: ['Url', 'text/uri-list'],
          getData: function getData(dataTransfer, matchesTypes) {
            return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
          }
        }), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
          exposeProperty: 'text',
          matchesTypes: ['Text', 'text/plain'],
          getData: function getData(dataTransfer, matchesTypes) {
            return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
          }
        }), _nativeTypesConfig);
        function createNativeDragSource(type) {
          var _nativeTypesConfig$ty = nativeTypesConfig[type],
            exposeProperty = _nativeTypesConfig$ty.exposeProperty,
            matchesTypes = _nativeTypesConfig$ty.matchesTypes,
            getData = _nativeTypesConfig$ty.getData;
          return function () {
            function NativeDragSource() {
              var _item, _mutatorMap;
              _classCallCheck(this, NativeDragSource);
              this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
                // eslint-disable-next-line no-console
                console.warn('Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
                return null;
              }, _defineEnumerableProperties(_item, _mutatorMap), _item);
            }
            _createClass(NativeDragSource, [{
              key: 'mutateItemByReadingDataTransfer',
              value: function mutateItemByReadingDataTransfer(dataTransfer) {
                delete this.item[exposeProperty];
                this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
              }
            }, {
              key: 'canDrag',
              value: function canDrag() {
                return true;
              }
            }, {
              key: 'beginDrag',
              value: function beginDrag() {
                return this.item;
              }
            }, {
              key: 'isDragging',
              value: function isDragging(monitor, handle) {
                return handle === monitor.getSourceId();
              }
            }, {
              key: 'endDrag',
              value: function endDrag() {}
            }]);
            return NativeDragSource;
          }();
        }
        function matchNativeItemType(dataTransfer) {
          var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
          return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
            var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
            return matchesTypes.some(function (t) {
              return dataTransferTypes.indexOf(t) > -1;
            });
          })[0] || null;
        }

        /***/
      }, /* 345 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.getNodeClientOffset = getNodeClientOffset;
        exports.getEventClientOffset = getEventClientOffset;
        exports.getDragPreviewOffset = getDragPreviewOffset;
        var _BrowserDetector = __webpack_require__(176);
        var _MonotonicInterpolant = __webpack_require__(343);
        var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        /* eslint
           no-mixed-operators: off
        */
        var ELEMENT_NODE = 1;
        function getNodeClientOffset(node) {
          var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
          if (!el) {
            return null;
          }
          var _el$getBoundingClient = el.getBoundingClientRect(),
            top = _el$getBoundingClient.top,
            left = _el$getBoundingClient.left;
          return {
            x: left,
            y: top
          };
        }
        function getEventClientOffset(e) {
          return {
            x: e.clientX,
            y: e.clientY
          };
        }
        function isImageNode(node) {
          return node.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(node));
        }
        function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
          var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
          var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;

          // Work around @2x coordinate discrepancies in browsers
          if ((0, _BrowserDetector.isSafari)() && isImage) {
            dragPreviewHeight /= window.devicePixelRatio;
            dragPreviewWidth /= window.devicePixelRatio;
          }
          return {
            dragPreviewWidth: dragPreviewWidth,
            dragPreviewHeight: dragPreviewHeight
          };
        }
        function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
          // The browsers will use the image intrinsic size under different conditions.
          // Firefox only cares if it's an image, but WebKit also wants it to be detached.
          var isImage = isImageNode(dragPreview);
          var dragPreviewNode = isImage ? sourceNode : dragPreview;
          var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
          var offsetFromDragPreview = {
            x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
            y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
          };
          var sourceWidth = sourceNode.offsetWidth,
            sourceHeight = sourceNode.offsetHeight;
          var anchorX = anchorPoint.anchorX,
            anchorY = anchorPoint.anchorY;
          var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
            dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
            dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
          var calculateYOffset = function calculateYOffset() {
            var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
            var y = interpolantY.interpolate(anchorY);
            // Work around Safari 8 positioning bug
            if ((0, _BrowserDetector.isSafari)() && isImage) {
              // We'll have to wait for @3x to see if this is entirely correct
              y += (window.devicePixelRatio - 1) * dragPreviewHeight;
            }
            return y;
          };
          var calculateXOffset = function calculateXOffset() {
            // Interpolate coordinates depending on anchor point
            // If you know a simpler way to do this, let me know
            var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
            return interpolantX.interpolate(anchorX);
          };

          // Force offsets if specified in the options.
          var offsetX = offsetPoint.offsetX,
            offsetY = offsetPoint.offsetY;
          var isManualOffsetX = offsetX === 0 || offsetX;
          var isManualOffsetY = offsetY === 0 || offsetY;
          return {
            x: isManualOffsetX ? offsetX : calculateXOffset(),
            y: isManualOffsetY ? offsetY : calculateYOffset()
          };
        }

        /***/
      }, /* 346 */
      /***/function (module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = getEmptyImage;
        var emptyImage = void 0;
        function getEmptyImage() {
          if (!emptyImage) {
            emptyImage = new Image();
            emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
          }
          return emptyImage;
        }

        /***/
      }, /* 347 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.getEmptyImage = exports.NativeTypes = undefined;
        exports.default = createHTML5Backend;
        var _HTML5Backend = __webpack_require__(342);
        var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);
        var _getEmptyImage = __webpack_require__(346);
        var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);
        var _NativeTypes = __webpack_require__(92);
        var NativeTypes = _interopRequireWildcard(_NativeTypes);
        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};
            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
              }
            }
            newObj.default = obj;
            return newObj;
          }
        }
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        exports.NativeTypes = NativeTypes;
        exports.getEmptyImage = _getEmptyImage2.default;
        function createHTML5Backend(manager) {
          return new _HTML5Backend2.default(manager);
        }

        /***/
      }, /* 348 */
      93, /* 349 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = undefined;
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _class, _temp;
        var _react = __webpack_require__(2);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _DragDropContext = __webpack_require__(177);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        /**
         * This class is a React-Component based version of the DragDropContext.
         * This is an alternative to decorating an application component with an ES7 decorator.
         */
        var DragDropContextProvider = (_temp = _class = function (_Component) {
          _inherits(DragDropContextProvider, _Component);
          function DragDropContextProvider(props, context) {
            _classCallCheck(this, DragDropContextProvider);

            /**
               * This property determines which window global to use for creating the DragDropManager.
               * If a window has been injected explicitly via props, that is used first. If it is available
               * as a context value, then use that, otherwise use the browser global.
               */
            var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));
            var getWindow = function getWindow() {
              if (props && props.window) {
                return props.window;
              } else if (context && context.window) {
                return context.window;
              } else if (typeof window !== 'undefined') {
                return window;
              }
              return undefined;
            };
            _this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
            _this.childContext = (0, _DragDropContext.createChildContext)(_this.backend, {
              window: getWindow()
            });
            return _this;
          }
          _createClass(DragDropContextProvider, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
              if (nextProps.backend !== this.props.backend || nextProps.window !== this.props.window) {
                throw new Error('DragDropContextProvider backend and window props must not change.');
              }
            }
          }, {
            key: 'getChildContext',
            value: function getChildContext() {
              return this.childContext;
            }
          }, {
            key: 'render',
            value: function render() {
              return _react.Children.only(this.props.children);
            }
          }]);
          return DragDropContextProvider;
        }(_react.Component), _class.propTypes = {
          backend: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]).isRequired,
          children: _propTypes2.default.element.isRequired,
          window: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
        }, _class.defaultProps = {
          window: undefined
        }, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
          window: _propTypes2.default.object
        }, _temp);
        exports.default = DragDropContextProvider;

        /***/
      }, /* 350 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        exports.default = DragLayer;
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _hoistNonReactStatics = __webpack_require__(82);
        var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
        var _isPlainObject = __webpack_require__(22);
        var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        var _shallowEqual = __webpack_require__(93);
        var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
        var _shallowEqualScalar = __webpack_require__(181);
        var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
        var _checkDecoratorArguments = __webpack_require__(66);
        var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        function DragLayer(collect) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          _checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
          (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
          (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);
          return function decorateLayer(DecoratedComponent) {
            var _class, _temp;
            var _options$arePropsEqua = options.arePropsEqual,
              arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
            var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
            var DragLayerContainer = (_temp = _class = function (_Component) {
              _inherits(DragLayerContainer, _Component);
              _createClass(DragLayerContainer, [{
                key: 'getDecoratedComponentInstance',
                value: function getDecoratedComponentInstance() {
                  (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
                  return this.child;
                }
              }, {
                key: 'shouldComponentUpdate',
                value: function shouldComponentUpdate(nextProps, nextState) {
                  return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
                }
              }]);
              function DragLayerContainer(props, context) {
                _classCallCheck(this, DragLayerContainer);
                var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));
                _this.handleChange = _this.handleChange.bind(_this);
                _this.manager = context.dragDropManager;
                (0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
                _this.state = _this.getCurrentState();
                return _this;
              }
              _createClass(DragLayerContainer, [{
                key: 'componentDidMount',
                value: function componentDidMount() {
                  this.isCurrentlyMounted = true;
                  var monitor = this.manager.getMonitor();
                  this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
                  this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
                  this.handleChange();
                }
              }, {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                  this.isCurrentlyMounted = false;
                  this.unsubscribeFromOffsetChange();
                  this.unsubscribeFromStateChange();
                }
              }, {
                key: 'handleChange',
                value: function handleChange() {
                  if (!this.isCurrentlyMounted) {
                    return;
                  }
                  var nextState = this.getCurrentState();
                  if (!(0, _shallowEqual2.default)(nextState, this.state)) {
                    this.setState(nextState);
                  }
                }
              }, {
                key: 'getCurrentState',
                value: function getCurrentState() {
                  var monitor = this.manager.getMonitor();
                  return collect(monitor);
                }
              }, {
                key: 'render',
                value: function render() {
                  var _this2 = this;
                  return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
                    ref: function ref(child) {
                      _this2.child = child;
                    }
                  }));
                }
              }]);
              return DragLayerContainer;
            }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
              dragDropManager: _propTypes2.default.object.isRequired
            }, _temp);
            return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
          };
        }

        /***/
      }, /* 351 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = DragSource;
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        var _isPlainObject = __webpack_require__(22);
        var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
        var _checkDecoratorArguments = __webpack_require__(66);
        var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
        var _decorateHandler = __webpack_require__(179);
        var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
        var _registerSource = __webpack_require__(359);
        var _registerSource2 = _interopRequireDefault(_registerSource);
        var _createSourceFactory = __webpack_require__(354);
        var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);
        var _createSourceMonitor = __webpack_require__(355);
        var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);
        var _createSourceConnector = __webpack_require__(353);
        var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);
        var _isValidType = __webpack_require__(180);
        var _isValidType2 = _interopRequireDefault(_isValidType);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function DragSource(type, spec, collect) {
          var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          _checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
          var getType = type;
          if (typeof type !== 'function') {
            (0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
            getType = function getType() {
              return type;
            };
          }
          (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
          var createSource = (0, _createSourceFactory2.default)(spec);
          (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
          (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
          return function decorateSource(DecoratedComponent) {
            return (0, _decorateHandler2.default)({
              connectBackend: function connectBackend(backend, sourceId) {
                return backend.connectDragSource(sourceId);
              },
              containerDisplayName: 'DragSource',
              createHandler: createSource,
              registerHandler: _registerSource2.default,
              createMonitor: _createSourceMonitor2.default,
              createConnector: _createSourceConnector2.default,
              DecoratedComponent: DecoratedComponent,
              getType: getType,
              collect: collect,
              options: options
            });
          };
        }

        /***/
      }, /* 352 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = DropTarget;
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        var _isPlainObject = __webpack_require__(22);
        var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
        var _checkDecoratorArguments = __webpack_require__(66);
        var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
        var _decorateHandler = __webpack_require__(179);
        var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
        var _registerTarget = __webpack_require__(360);
        var _registerTarget2 = _interopRequireDefault(_registerTarget);
        var _createTargetFactory = __webpack_require__(357);
        var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);
        var _createTargetMonitor = __webpack_require__(358);
        var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);
        var _createTargetConnector = __webpack_require__(356);
        var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);
        var _isValidType = __webpack_require__(180);
        var _isValidType2 = _interopRequireDefault(_isValidType);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function DropTarget(type, spec, collect) {
          var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          _checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
          var getType = type;
          if (typeof type !== 'function') {
            (0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
            getType = function getType() {
              return type;
            };
          }
          (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
          var createTarget = (0, _createTargetFactory2.default)(spec);
          (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
          (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
          return function decorateTarget(DecoratedComponent) {
            return (0, _decorateHandler2.default)({
              connectBackend: function connectBackend(backend, targetId) {
                return backend.connectDropTarget(targetId);
              },
              containerDisplayName: 'DropTarget',
              createHandler: createTarget,
              registerHandler: _registerTarget2.default,
              createMonitor: _createTargetMonitor2.default,
              createConnector: _createTargetConnector2.default,
              DecoratedComponent: DecoratedComponent,
              getType: getType,
              collect: collect,
              options: options
            });
          };
        }

        /***/
      }, /* 353 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = createSourceConnector;
        var _wrapConnectorHooks = __webpack_require__(182);
        var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
        var _areOptionsEqual = __webpack_require__(178);
        var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function createSourceConnector(backend) {
          var currentHandlerId = void 0;
          var currentDragSourceNode = void 0;
          var currentDragSourceOptions = void 0;
          var disconnectCurrentDragSource = void 0;
          var currentDragPreviewNode = void 0;
          var currentDragPreviewOptions = void 0;
          var disconnectCurrentDragPreview = void 0;
          function reconnectDragSource() {
            if (disconnectCurrentDragSource) {
              disconnectCurrentDragSource();
              disconnectCurrentDragSource = null;
            }
            if (currentHandlerId && currentDragSourceNode) {
              disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
            }
          }
          function reconnectDragPreview() {
            if (disconnectCurrentDragPreview) {
              disconnectCurrentDragPreview();
              disconnectCurrentDragPreview = null;
            }
            if (currentHandlerId && currentDragPreviewNode) {
              disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
            }
          }
          function receiveHandlerId(handlerId) {
            if (handlerId === currentHandlerId) {
              return;
            }
            currentHandlerId = handlerId;
            reconnectDragSource();
            reconnectDragPreview();
          }
          var hooks = (0, _wrapConnectorHooks2.default)({
            dragSource: function connectDragSource(node, options) {
              if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
                return;
              }
              currentDragSourceNode = node;
              currentDragSourceOptions = options;
              reconnectDragSource();
            },
            dragPreview: function connectDragPreview(node, options) {
              if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
                return;
              }
              currentDragPreviewNode = node;
              currentDragPreviewOptions = options;
              reconnectDragPreview();
            }
          });
          return {
            receiveHandlerId: receiveHandlerId,
            hooks: hooks
          };
        }

        /***/
      }, /* 354 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        exports.default = createSourceFactory;
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        var _isPlainObject = __webpack_require__(22);
        var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
        var REQUIRED_SPEC_METHODS = ['beginDrag'];
        function createSourceFactory(spec) {
          Object.keys(spec).forEach(function (key) {
            (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
            (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
          });
          REQUIRED_SPEC_METHODS.forEach(function (key) {
            (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
          });
          var Source = function () {
            function Source(monitor) {
              _classCallCheck(this, Source);
              this.monitor = monitor;
              this.props = null;
              this.component = null;
            }
            _createClass(Source, [{
              key: 'receiveProps',
              value: function receiveProps(props) {
                this.props = props;
              }
            }, {
              key: 'receiveComponent',
              value: function receiveComponent(component) {
                this.component = component;
              }
            }, {
              key: 'canDrag',
              value: function canDrag() {
                if (!spec.canDrag) {
                  return true;
                }
                return spec.canDrag(this.props, this.monitor);
              }
            }, {
              key: 'isDragging',
              value: function isDragging(globalMonitor, sourceId) {
                if (!spec.isDragging) {
                  return sourceId === globalMonitor.getSourceId();
                }
                return spec.isDragging(this.props, this.monitor);
              }
            }, {
              key: 'beginDrag',
              value: function beginDrag() {
                var item = spec.beginDrag(this.props, this.monitor, this.component);
                if (false) {}
                return item;
              }
            }, {
              key: 'endDrag',
              value: function endDrag() {
                if (!spec.endDrag) {
                  return;
                }
                spec.endDrag(this.props, this.monitor, this.component);
              }
            }]);
            return Source;
          }();
          return function createSource(monitor) {
            return new Source(monitor);
          };
        }

        /***/
      }, /* 355 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        exports.default = createSourceMonitor;
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var isCallingCanDrag = false;
        var isCallingIsDragging = false;
        var SourceMonitor = function () {
          function SourceMonitor(manager) {
            _classCallCheck(this, SourceMonitor);
            this.internalMonitor = manager.getMonitor();
          }
          _createClass(SourceMonitor, [{
            key: 'receiveHandlerId',
            value: function receiveHandlerId(sourceId) {
              this.sourceId = sourceId;
            }
          }, {
            key: 'canDrag',
            value: function canDrag() {
              (0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
              try {
                isCallingCanDrag = true;
                return this.internalMonitor.canDragSource(this.sourceId);
              } finally {
                isCallingCanDrag = false;
              }
            }
          }, {
            key: 'isDragging',
            value: function isDragging() {
              (0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
              try {
                isCallingIsDragging = true;
                return this.internalMonitor.isDraggingSource(this.sourceId);
              } finally {
                isCallingIsDragging = false;
              }
            }
          }, {
            key: 'getItemType',
            value: function getItemType() {
              return this.internalMonitor.getItemType();
            }
          }, {
            key: 'getItem',
            value: function getItem() {
              return this.internalMonitor.getItem();
            }
          }, {
            key: 'getDropResult',
            value: function getDropResult() {
              return this.internalMonitor.getDropResult();
            }
          }, {
            key: 'didDrop',
            value: function didDrop() {
              return this.internalMonitor.didDrop();
            }
          }, {
            key: 'getInitialClientOffset',
            value: function getInitialClientOffset() {
              return this.internalMonitor.getInitialClientOffset();
            }
          }, {
            key: 'getInitialSourceClientOffset',
            value: function getInitialSourceClientOffset() {
              return this.internalMonitor.getInitialSourceClientOffset();
            }
          }, {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset() {
              return this.internalMonitor.getSourceClientOffset();
            }
          }, {
            key: 'getClientOffset',
            value: function getClientOffset() {
              return this.internalMonitor.getClientOffset();
            }
          }, {
            key: 'getDifferenceFromInitialOffset',
            value: function getDifferenceFromInitialOffset() {
              return this.internalMonitor.getDifferenceFromInitialOffset();
            }
          }]);
          return SourceMonitor;
        }();
        function createSourceMonitor(manager) {
          return new SourceMonitor(manager);
        }

        /***/
      }, /* 356 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = createTargetConnector;
        var _wrapConnectorHooks = __webpack_require__(182);
        var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
        var _areOptionsEqual = __webpack_require__(178);
        var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function createTargetConnector(backend) {
          var currentHandlerId = void 0;
          var currentDropTargetNode = void 0;
          var currentDropTargetOptions = void 0;
          var disconnectCurrentDropTarget = void 0;
          function reconnectDropTarget() {
            if (disconnectCurrentDropTarget) {
              disconnectCurrentDropTarget();
              disconnectCurrentDropTarget = null;
            }
            if (currentHandlerId && currentDropTargetNode) {
              disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
            }
          }
          function receiveHandlerId(handlerId) {
            if (handlerId === currentHandlerId) {
              return;
            }
            currentHandlerId = handlerId;
            reconnectDropTarget();
          }
          var hooks = (0, _wrapConnectorHooks2.default)({
            dropTarget: function connectDropTarget(node, options) {
              if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
                return;
              }
              currentDropTargetNode = node;
              currentDropTargetOptions = options;
              reconnectDropTarget();
            }
          });
          return {
            receiveHandlerId: receiveHandlerId,
            hooks: hooks
          };
        }

        /***/
      }, /* 357 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        exports.default = createTargetFactory;
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        var _isPlainObject = __webpack_require__(22);
        var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
        function createTargetFactory(spec) {
          Object.keys(spec).forEach(function (key) {
            (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
            (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
          });
          var Target = function () {
            function Target(monitor) {
              _classCallCheck(this, Target);
              this.monitor = monitor;
              this.props = null;
              this.component = null;
            }
            _createClass(Target, [{
              key: 'receiveProps',
              value: function receiveProps(props) {
                this.props = props;
              }
            }, {
              key: 'receiveMonitor',
              value: function receiveMonitor(monitor) {
                this.monitor = monitor;
              }
            }, {
              key: 'receiveComponent',
              value: function receiveComponent(component) {
                this.component = component;
              }
            }, {
              key: 'canDrop',
              value: function canDrop() {
                if (!spec.canDrop) {
                  return true;
                }
                return spec.canDrop(this.props, this.monitor);
              }
            }, {
              key: 'hover',
              value: function hover() {
                if (!spec.hover) {
                  return;
                }
                spec.hover(this.props, this.monitor, this.component);
              }
            }, {
              key: 'drop',
              value: function drop() {
                if (!spec.drop) {
                  return undefined;
                }
                var dropResult = spec.drop(this.props, this.monitor, this.component);
                if (false) {}
                return dropResult;
              }
            }]);
            return Target;
          }();
          return function createTarget(monitor) {
            return new Target(monitor);
          };
        }

        /***/
      }, /* 358 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        exports.default = createTargetMonitor;
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var isCallingCanDrop = false;
        var TargetMonitor = function () {
          function TargetMonitor(manager) {
            _classCallCheck(this, TargetMonitor);
            this.internalMonitor = manager.getMonitor();
          }
          _createClass(TargetMonitor, [{
            key: 'receiveHandlerId',
            value: function receiveHandlerId(targetId) {
              this.targetId = targetId;
            }
          }, {
            key: 'canDrop',
            value: function canDrop() {
              (0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');
              try {
                isCallingCanDrop = true;
                return this.internalMonitor.canDropOnTarget(this.targetId);
              } finally {
                isCallingCanDrop = false;
              }
            }
          }, {
            key: 'isOver',
            value: function isOver(options) {
              return this.internalMonitor.isOverTarget(this.targetId, options);
            }
          }, {
            key: 'getItemType',
            value: function getItemType() {
              return this.internalMonitor.getItemType();
            }
          }, {
            key: 'getItem',
            value: function getItem() {
              return this.internalMonitor.getItem();
            }
          }, {
            key: 'getDropResult',
            value: function getDropResult() {
              return this.internalMonitor.getDropResult();
            }
          }, {
            key: 'didDrop',
            value: function didDrop() {
              return this.internalMonitor.didDrop();
            }
          }, {
            key: 'getInitialClientOffset',
            value: function getInitialClientOffset() {
              return this.internalMonitor.getInitialClientOffset();
            }
          }, {
            key: 'getInitialSourceClientOffset',
            value: function getInitialSourceClientOffset() {
              return this.internalMonitor.getInitialSourceClientOffset();
            }
          }, {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset() {
              return this.internalMonitor.getSourceClientOffset();
            }
          }, {
            key: 'getClientOffset',
            value: function getClientOffset() {
              return this.internalMonitor.getClientOffset();
            }
          }, {
            key: 'getDifferenceFromInitialOffset',
            value: function getDifferenceFromInitialOffset() {
              return this.internalMonitor.getDifferenceFromInitialOffset();
            }
          }]);
          return TargetMonitor;
        }();
        function createTargetMonitor(manager) {
          return new TargetMonitor(manager);
        }

        /***/
      }, /* 359 */
      /***/function (module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = registerSource;
        function registerSource(type, source, manager) {
          var registry = manager.getRegistry();
          var sourceId = registry.addSource(type, source);
          function unregisterSource() {
            registry.removeSource(sourceId);
          }
          return {
            handlerId: sourceId,
            unregister: unregisterSource
          };
        }

        /***/
      }, /* 360 */
      /***/function (module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = registerTarget;
        function registerTarget(type, target, manager) {
          var registry = manager.getRegistry();
          var targetId = registry.addTarget(type, target);
          function unregisterTarget() {
            registry.removeTarget(targetId);
          }
          return {
            handlerId: targetId,
            unregister: unregisterTarget
          };
        }

        /***/
      }, /* 361 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = cloneWithRef;
        var _invariant = __webpack_require__(10);
        var _invariant2 = _interopRequireDefault(_invariant);
        var _react = __webpack_require__(2);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function cloneWithRef(element, newRef) {
          var previousRef = element.ref;
          (0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
          if (!previousRef) {
            // When there is no ref on the element, use the new ref directly
            return (0, _react.cloneElement)(element, {
              ref: newRef
            });
          }
          return (0, _react.cloneElement)(element, {
            ref: function ref(node) {
              newRef(node);
              if (previousRef) {
                previousRef(node);
              }
            }
          });
        }

        /***/
      }, /* 362 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _Async = __webpack_require__(183);
        var _Async2 = _interopRequireDefault(_Async);
        var _Creatable = __webpack_require__(184);
        var _Creatable2 = _interopRequireDefault(_Creatable);
        var _Select = __webpack_require__(67);
        var _Select2 = _interopRequireDefault(_Select);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _objectWithoutProperties(obj, keys) {
          var target = {};
          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }
          return target;
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var AsyncCreatableSelect = function (_React$Component) {
          _inherits(AsyncCreatableSelect, _React$Component);
          function AsyncCreatableSelect() {
            _classCallCheck(this, AsyncCreatableSelect);
            return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
          }
          _createClass(AsyncCreatableSelect, [{
            key: 'focus',
            value: function focus() {
              this.select.focus();
            }
          }, {
            key: 'render',
            value: function render() {
              var _this2 = this;
              return _react2.default.createElement(_Async2.default, this.props, function (_ref) {
                var ref = _ref.ref,
                  asyncProps = _objectWithoutProperties(_ref, ['ref']);
                var asyncRef = ref;
                return _react2.default.createElement(_Creatable2.default, asyncProps, function (_ref2) {
                  var ref = _ref2.ref,
                    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
                  var creatableRef = ref;
                  return _this2.props.children(_extends({}, creatableProps, {
                    ref: function ref(select) {
                      creatableRef(select);
                      asyncRef(select);
                      _this2.select = select;
                    }
                  }));
                });
              });
            }
          }]);
          return AsyncCreatableSelect;
        }(_react2.default.Component);
        var defaultChildren = function defaultChildren(props) {
          return _react2.default.createElement(_Select2.default, props);
        };
        AsyncCreatableSelect.propTypes = {
          children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
        };

        AsyncCreatableSelect.defaultProps = {
          children: defaultChildren
        };
        exports.default = AsyncCreatableSelect;

        /***/
      }, /* 363 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
        var _Select = __webpack_require__(67);
        var _Select2 = _interopRequireDefault(_Select);
        var _Async = __webpack_require__(183);
        var _Async2 = _interopRequireDefault(_Async);
        var _AsyncCreatable = __webpack_require__(362);
        var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
        var _Creatable = __webpack_require__(184);
        var _Creatable2 = _interopRequireDefault(_Creatable);
        var _Value = __webpack_require__(186);
        var _Value2 = _interopRequireDefault(_Value);
        var _Option = __webpack_require__(185);
        var _Option2 = _interopRequireDefault(_Option);
        var _defaultMenuRenderer = __webpack_require__(95);
        var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
        var _defaultArrowRenderer = __webpack_require__(187);
        var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
        var _defaultClearRenderer = __webpack_require__(188);
        var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
        var _defaultFilterOptions = __webpack_require__(94);
        var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        _Select2.default.Async = _Async2.default;
        _Select2.default.AsyncCreatable = _AsyncCreatable2.default;
        _Select2.default.Creatable = _Creatable2.default;
        _Select2.default.Value = _Value2.default;
        _Select2.default.Option = _Option2.default;
        exports.default = _Select2.default;
        exports.Async = _Async2.default;
        exports.AsyncCreatable = _AsyncCreatable2.default;
        exports.Creatable = _Creatable2.default;
        exports.Value = _Value2.default;
        exports.Option = _Option2.default;
        exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
        exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
        exports.defaultClearRenderer = _defaultClearRenderer2.default;
        exports.defaultFilterOptions = _defaultFilterOptions2.default;

        /***/
      }, /* 364 */
      /***/function (module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (event.target.tagName !== 'A' || !('href' in event.target)) {
            return;
          }
          if (event.target.target) {
            window.open(event.target.href, event.target.target);
          } else {
            window.location.href = event.target.href;
          }
        };

        /***/
      }, /* 365 */
      /***/function (module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var trim = function trim(str) {
          return str.replace(/^\s+|\s+$/g, '');
        };
        exports.default = trim;

        /***/
      }, /* 366 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        var _react = __webpack_require__(2);
        var _react2 = _interopRequireDefault(_react);
        var _propTypes = __webpack_require__(3);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        function _objectWithoutProperties(obj, keys) {
          var target = {};
          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }
          return target;
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        var sizerStyle = {
          position: 'absolute',
          top: 0,
          left: 0,
          visibility: 'hidden',
          height: 0,
          overflow: 'scroll',
          whiteSpace: 'pre'
        };
        var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
        var cleanInputProps = function cleanInputProps(inputProps) {
          INPUT_PROPS_BLACKLIST.forEach(function (field) {
            return delete inputProps[field];
          });
          return inputProps;
        };
        var copyStyles = function copyStyles(styles, node) {
          node.style.fontSize = styles.fontSize;
          node.style.fontFamily = styles.fontFamily;
          node.style.fontWeight = styles.fontWeight;
          node.style.fontStyle = styles.fontStyle;
          node.style.letterSpacing = styles.letterSpacing;
          node.style.textTransform = styles.textTransform;
        };
        var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
        var generateId = function generateId() {
          // we only need an auto-generated ID for stylesheet injection, which is only
          // used for IE. so if the browser is not IE, this should return undefined.
          return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
        };
        var AutosizeInput = function (_Component) {
          _inherits(AutosizeInput, _Component);
          function AutosizeInput(props) {
            _classCallCheck(this, AutosizeInput);
            var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
            _this.inputRef = function (el) {
              _this.input = el;
              if (typeof _this.props.inputRef === 'function') {
                _this.props.inputRef(el);
              }
            };
            _this.placeHolderSizerRef = function (el) {
              _this.placeHolderSizer = el;
            };
            _this.sizerRef = function (el) {
              _this.sizer = el;
            };
            _this.state = {
              inputWidth: props.minWidth,
              inputId: props.id || generateId()
            };
            return _this;
          }
          _createClass(AutosizeInput, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              this.mounted = true;
              this.copyInputStyles();
              this.updateInputWidth();
            }
          }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
              var id = nextProps.id;
              if (id !== this.props.id) {
                this.setState({
                  inputId: id || generateId()
                });
              }
            }
          }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
              if (prevState.inputWidth !== this.state.inputWidth) {
                if (typeof this.props.onAutosize === 'function') {
                  this.props.onAutosize(this.state.inputWidth);
                }
              }
              this.updateInputWidth();
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              this.mounted = false;
            }
          }, {
            key: 'copyInputStyles',
            value: function copyInputStyles() {
              if (!this.mounted || !window.getComputedStyle) {
                return;
              }
              var inputStyles = this.input && window.getComputedStyle(this.input);
              if (!inputStyles) {
                return;
              }
              copyStyles(inputStyles, this.sizer);
              if (this.placeHolderSizer) {
                copyStyles(inputStyles, this.placeHolderSizer);
              }
            }
          }, {
            key: 'updateInputWidth',
            value: function updateInputWidth() {
              if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
                return;
              }
              var newInputWidth = void 0;
              if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
                newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
              } else {
                newInputWidth = this.sizer.scrollWidth + 2;
              }
              // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
              var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
              newInputWidth += extraWidth;
              if (newInputWidth < this.props.minWidth) {
                newInputWidth = this.props.minWidth;
              }
              if (newInputWidth !== this.state.inputWidth) {
                this.setState({
                  inputWidth: newInputWidth
                });
              }
            }
          }, {
            key: 'getInput',
            value: function getInput() {
              return this.input;
            }
          }, {
            key: 'focus',
            value: function focus() {
              this.input.focus();
            }
          }, {
            key: 'blur',
            value: function blur() {
              this.input.blur();
            }
          }, {
            key: 'select',
            value: function select() {
              this.input.select();
            }
          }, {
            key: 'renderStyles',
            value: function renderStyles() {
              // this method injects styles to hide IE's clear indicator, which messes
              // with input size detection. the stylesheet is only injected when the
              // browser is IE, and can also be disabled by the `injectStyles` prop.
              var injectStyles = this.props.injectStyles;
              return isIE && injectStyles ? _react2.default.createElement('style', {
                dangerouslySetInnerHTML: {
                  __html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
                }
              }) : null;
            }
          }, {
            key: 'render',
            value: function render() {
              var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
                if (previousValue !== null && previousValue !== undefined) {
                  return previousValue;
                }
                return currentValue;
              });
              var wrapperStyle = _extends({}, this.props.style);
              if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
              var inputStyle = _extends({
                boxSizing: 'content-box',
                width: this.state.inputWidth + 'px'
              }, this.props.inputStyle);
              var inputProps = _objectWithoutProperties(this.props, []);
              cleanInputProps(inputProps);
              inputProps.className = this.props.inputClassName;
              inputProps.id = this.state.inputId;
              inputProps.style = inputStyle;
              return _react2.default.createElement('div', {
                className: this.props.className,
                style: wrapperStyle
              }, this.renderStyles(), _react2.default.createElement('input', _extends({}, inputProps, {
                ref: this.inputRef
              })), _react2.default.createElement('div', {
                ref: this.sizerRef,
                style: sizerStyle
              }, sizerValue), this.props.placeholder ? _react2.default.createElement('div', {
                ref: this.placeHolderSizerRef,
                style: sizerStyle
              }, this.props.placeholder) : null);
            }
          }]);
          return AutosizeInput;
        }(_react.Component);
        AutosizeInput.propTypes = {
          className: _propTypes2.default.string,
          // className for the outer element
          defaultValue: _propTypes2.default.any,
          // default field value
          extraWidth: _propTypes2.default.oneOfType([
          // additional width for input element
          _propTypes2.default.number, _propTypes2.default.string]),
          id: _propTypes2.default.string,
          // id to use for the input, can be set for consistent snapshots
          injectStyles: _propTypes2.default.bool,
          // inject the custom stylesheet to hide clear UI, defaults to true
          inputClassName: _propTypes2.default.string,
          // className for the input element
          inputRef: _propTypes2.default.func,
          // ref callback for the input element
          inputStyle: _propTypes2.default.object,
          // css styles for the input element
          minWidth: _propTypes2.default.oneOfType([
          // minimum width for input element
          _propTypes2.default.number, _propTypes2.default.string]),
          onAutosize: _propTypes2.default.func,
          // onAutosize handler: function(newWidth) {}
          onChange: _propTypes2.default.func,
          // onChange handler: function(event) {}
          placeholder: _propTypes2.default.string,
          // placeholder text
          placeholderIsMinWidth: _propTypes2.default.bool,
          // don't collapse size to less than the placeholder
          style: _propTypes2.default.object,
          // css styles for the outer element
          value: _propTypes2.default.any // field value
        };

        AutosizeInput.defaultProps = {
          minWidth: 1,
          injectStyles: true
        };
        exports.default = AutosizeInput;

        /***/
      }, /* 367 */
      /***/function (module, exports, __webpack_require__) {
        'use strict';

        exports.__esModule = true;
        exports.ActionTypes = undefined;
        exports['default'] = createStore;
        var _isPlainObject = __webpack_require__(22);
        var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
        var _symbolObservable = __webpack_require__(374);
        var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            'default': obj
          };
        }

        /**
         * These are private action types reserved by Redux.
         * For any unknown actions, you must return the current state.
         * If the current state is undefined, you must return the initial state.
         * Do not reference these action types directly in your code.
         */
        var ActionTypes = exports.ActionTypes = {
          INIT: '@@redux/INIT'

          /**
           * Creates a Redux store that holds the state tree.
           * The only way to change the data in the store is to call `dispatch()` on it.
           *
           * There should only be a single store in your app. To specify how different
           * parts of the state tree respond to actions, you may combine several reducers
           * into a single reducer function by using `combineReducers`.
           *
           * @param {Function} reducer A function that returns the next state tree, given
           * the current state tree and the action to handle.
           *
           * @param {any} [preloadedState] The initial state. You may optionally specify it
           * to hydrate the state from the server in universal apps, or to restore a
           * previously serialized user session.
           * If you use `combineReducers` to produce the root reducer function, this must be
           * an object with the same shape as `combineReducers` keys.
           *
           * @param {Function} [enhancer] The store enhancer. You may optionally specify it
           * to enhance the store with third-party capabilities such as middleware,
           * time travel, persistence, etc. The only store enhancer that ships with Redux
           * is `applyMiddleware()`.
           *
           * @returns {Store} A Redux store that lets you read the state, dispatch actions
           * and subscribe to changes.
           */
        };
        function createStore(reducer, preloadedState, enhancer) {
          var _ref2;
          if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
            enhancer = preloadedState;
            preloadedState = undefined;
          }
          if (typeof enhancer !== 'undefined') {
            if (typeof enhancer !== 'function') {
              throw new Error('Expected the enhancer to be a function.');
            }
            return enhancer(createStore)(reducer, preloadedState);
          }
          if (typeof reducer !== 'function') {
            throw new Error('Expected the reducer to be a function.');
          }
          var currentReducer = reducer;
          var currentState = preloadedState;
          var currentListeners = [];
          var nextListeners = currentListeners;
          var isDispatching = false;
          function ensureCanMutateNextListeners() {
            if (nextListeners === currentListeners) {
              nextListeners = currentListeners.slice();
            }
          }

          /**
           * Reads the state tree managed by the store.
           *
           * @returns {any} The current state tree of your application.
           */
          function getState() {
            return currentState;
          }

          /**
           * Adds a change listener. It will be called any time an action is dispatched,
           * and some part of the state tree may potentially have changed. You may then
           * call `getState()` to read the current state tree inside the callback.
           *
           * You may call `dispatch()` from a change listener, with the following
           * caveats:
           *
           * 1. The subscriptions are snapshotted just before every `dispatch()` call.
           * If you subscribe or unsubscribe while the listeners are being invoked, this
           * will not have any effect on the `dispatch()` that is currently in progress.
           * However, the next `dispatch()` call, whether nested or not, will use a more
           * recent snapshot of the subscription list.
           *
           * 2. The listener should not expect to see all state changes, as the state
           * might have been updated multiple times during a nested `dispatch()` before
           * the listener is called. It is, however, guaranteed that all subscribers
           * registered before the `dispatch()` started will be called with the latest
           * state by the time it exits.
           *
           * @param {Function} listener A callback to be invoked on every dispatch.
           * @returns {Function} A function to remove this change listener.
           */
          function subscribe(listener) {
            if (typeof listener !== 'function') {
              throw new Error('Expected listener to be a function.');
            }
            var isSubscribed = true;
            ensureCanMutateNextListeners();
            nextListeners.push(listener);
            return function unsubscribe() {
              if (!isSubscribed) {
                return;
              }
              isSubscribed = false;
              ensureCanMutateNextListeners();
              var index = nextListeners.indexOf(listener);
              nextListeners.splice(index, 1);
            };
          }

          /**
           * Dispatches an action. It is the only way to trigger a state change.
           *
           * The `reducer` function, used to create the store, will be called with the
           * current state tree and the given `action`. Its return value will
           * be considered the **next** state of the tree, and the change listeners
           * will be notified.
           *
           * The base implementation only supports plain object actions. If you want to
           * dispatch a Promise, an Observable, a thunk, or something else, you need to
           * wrap your store creating function into the corresponding middleware. For
           * example, see the documentation for the `redux-thunk` package. Even the
           * middleware will eventually dispatch plain object actions using this method.
           *
           * @param {Object} action A plain object representing “what changed”. It is
           * a good idea to keep actions serializable so you can record and replay user
           * sessions, or use the time travelling `redux-devtools`. An action must have
           * a `type` property which may not be `undefined`. It is a good idea to use
           * string constants for action types.
           *
           * @returns {Object} For convenience, the same action object you dispatched.
           *
           * Note that, if you use a custom middleware, it may wrap `dispatch()` to
           * return something else (for example, a Promise you can await).
           */
          function dispatch(action) {
            if (!(0, _isPlainObject2['default'])(action)) {
              throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
            }
            if (typeof action.type === 'undefined') {
              throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
            }
            if (isDispatching) {
              throw new Error('Reducers may not dispatch actions.');
            }
            try {
              isDispatching = true;
              currentState = currentReducer(currentState, action);
            } finally {
              isDispatching = false;
            }
            var listeners = currentListeners = nextListeners;
            for (var i = 0; i < listeners.length; i++) {
              var listener = listeners[i];
              listener();
            }
            return action;
          }

          /**
           * Replaces the reducer currently used by the store to calculate the state.
           *
           * You might need this if your app implements code splitting and you want to
           * load some of the reducers dynamically. You might also need this if you
           * implement a hot reloading mechanism for Redux.
           *
           * @param {Function} nextReducer The reducer for the store to use instead.
           * @returns {void}
           */
          function replaceReducer(nextReducer) {
            if (typeof nextReducer !== 'function') {
              throw new Error('Expected the nextReducer to be a function.');
            }
            currentReducer = nextReducer;
            dispatch({
              type: ActionTypes.INIT
            });
          }

          /**
           * Interoperability point for observable/reactive libraries.
           * @returns {observable} A minimal observable of state changes.
           * For more information, see the observable proposal:
           * https://github.com/tc39/proposal-observable
           */
          function observable() {
            var _ref;
            var outerSubscribe = subscribe;
            return _ref = {
              /**
               * The minimal observable subscription method.
               * @param {Object} observer Any object that can be used as an observer.
               * The observer object should have a `next` method.
               * @returns {subscription} An object with an `unsubscribe` method that can
               * be used to unsubscribe the observable from the store, and prevent further
               * emission of values from the observable.
               */
              subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') {
                  throw new TypeError('Expected the observer to be an object.');
                }
                function observeState() {
                  if (observer.next) {
                    observer.next(getState());
                  }
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                  unsubscribe: unsubscribe
                };
              }
            }, _ref[_symbolObservable2['default']] = function () {
              return this;
            }, _ref;
          }

          // When a store is created, an "INIT" action is dispatched so that every
          // reducer returns their initial state. This effectively populates
          // the initial state tree.
          dispatch({
            type: ActionTypes.INIT
          });
          return _ref2 = {
            dispatch: dispatch,
            subscribe: subscribe,
            getState: getState,
            replaceReducer: replaceReducer
          }, _ref2[_symbolObservable2['default']] = observable, _ref2;
        }

        /***/
      }, /* 368 */
      /***/function (module, exports) {
        'use strict';

        exports.__esModule = true;
        exports.defaultMemoize = defaultMemoize;
        exports.createSelectorCreator = createSelectorCreator;
        exports.createStructuredSelector = createStructuredSelector;
        function _toConsumableArray(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }
            return arr2;
          } else {
            return Array.from(arr);
          }
        }
        function defaultEqualityCheck(a, b) {
          return a === b;
        }
        function defaultMemoize(func) {
          var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];
          var lastArgs = null;
          var lastResult = null;
          return function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
              return equalityCheck(value, lastArgs[index]);
            })) {
              lastResult = func.apply(undefined, args);
            }
            lastArgs = args;
            return lastResult;
          };
        }
        function getDependencies(funcs) {
          var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
          if (!dependencies.every(function (dep) {
            return typeof dep === 'function';
          })) {
            var dependencyTypes = dependencies.map(function (dep) {
              return typeof dep;
            }).join(', ');
            throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
          }
          return dependencies;
        }
        function createSelectorCreator(memoize) {
          for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            memoizeOptions[_key2 - 1] = arguments[_key2];
          }
          return function () {
            for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              funcs[_key3] = arguments[_key3];
            }
            var recomputations = 0;
            var resultFunc = funcs.pop();
            var dependencies = getDependencies(funcs);
            var memoizedResultFunc = memoize.apply(undefined, [function () {
              recomputations++;
              return resultFunc.apply(undefined, arguments);
            }].concat(memoizeOptions));
            var selector = function selector(state, props) {
              for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
                args[_key4 - 2] = arguments[_key4];
              }
              var params = dependencies.map(function (dependency) {
                return dependency.apply(undefined, [state, props].concat(args));
              });
              return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
            };
            selector.resultFunc = resultFunc;
            selector.recomputations = function () {
              return recomputations;
            };
            selector.resetRecomputations = function () {
              return recomputations = 0;
            };
            return selector;
          };
        }
        var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
        function createStructuredSelector(selectors) {
          var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];
          if (typeof selectors !== 'object') {
            throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
          }
          var objectKeys = Object.keys(selectors);
          return selectorCreator(objectKeys.map(function (key) {
            return selectors[key];
          }), function () {
            for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              values[_key5] = arguments[_key5];
            }
            return values.reduce(function (composition, value, index) {
              composition[objectKeys[index]] = value;
              return composition;
            }, {});
          });
        }

        /***/
      }, /* 369 */
      /***/function (module, exports, __webpack_require__) {
        (function webpackUniversalModuleDefinition(root, factory) {
          if (true) module.exports = factory(__webpack_require__(2), __webpack_require__(9));else {}
        })(this, function (__WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__) {
          return (/******/function (modules) {
              // webpackBootstrap
              /******/ // The module cache
              /******/
              var installedModules = {};

              /******/ // The require function
              /******/
              function __webpack_require__(moduleId) {
                /******/ // Check if module is in cache
                /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;

                /******/ // Create a new module (and put it into the cache)
                /******/
                var module = installedModules[moduleId] = {
                  /******/exports: {},
                  /******/id: moduleId,
                  /******/loaded: false
                  /******/
                };

                /******/ // Execute the module function
                /******/
                modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

                /******/ // Flag the module as loaded
                /******/
                module.loaded = true;

                /******/ // Return the exports of the module
                /******/
                return module.exports;
                /******/
              }

              /******/ // expose the modules object (__webpack_modules__)
              /******/
              __webpack_require__.m = modules;

              /******/ // expose the module cache
              /******/
              __webpack_require__.c = installedModules;

              /******/ // __webpack_public_path__
              /******/
              __webpack_require__.p = "";

              /******/ // Load entry module and return exports
              /******/
              return __webpack_require__(0);
              /******/
            }
            /************************************************************************/
            /******/([/* 0 */
            /***/function (module, exports, __webpack_require__) {
              'use strict';

              var _createClass = function () {
                function defineProperties(target, props) {
                  for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                  }
                }
                return function (Constructor, protoProps, staticProps) {
                  if (protoProps) defineProperties(Constructor.prototype, protoProps);
                  if (staticProps) defineProperties(Constructor, staticProps);
                  return Constructor;
                };
              }();
              function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                  throw new TypeError("Cannot call a class as a function");
                }
              }
              function _possibleConstructorReturn(self, call) {
                if (!self) {
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
              }
              function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                  throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                  constructor: {
                    value: subClass,
                    enumerable: false,
                    writable: true,
                    configurable: true
                  }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
              }
              var PropTypes = __webpack_require__(5);
              var React = __webpack_require__(7);
              var ReactDOM = __webpack_require__(8);
              var classnames = __webpack_require__(1);
              var Autocomplete = function (_React$Component) {
                _inherits(Autocomplete, _React$Component);
                function Autocomplete(props) {
                  _classCallCheck(this, Autocomplete);
                  var _this = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));
                  _initialiseProps.call(_this);
                  var searchTerm = props.searchTerm ? props.searchTerm : props.value ? props.value.title : '';
                  _this.state = {
                    results: [],
                    showResults: false,
                    showResultsInProgress: false,
                    searchTerm: searchTerm,
                    focusedValue: null
                  };
                  return _this;
                }
                _createClass(Autocomplete, [{
                  key: 'render',
                  value: function render() {
                    var className = classnames(this.props.className, 'react-autocomplete-Autocomplete', this.state.showResults ? 'react-autocomplete-Autocomplete--resultsShown' : undefined);
                    var style = {
                      position: 'relative',
                      outline: 'none'
                    };
                    return React.createElement('div', {
                      tabIndex: '1',
                      className: className,
                      onFocus: this.onFocus,
                      onBlur: this.onBlur,
                      style: style
                    }, React.createElement('input', {
                      ref: 'search',
                      className: 'react-autocomplete-Autocomplete__search',
                      style: {
                        width: '100%'
                      },
                      onClick: this.showAllResults,
                      onChange: this.onQueryChange,
                      onFocus: this.onSearchInputFocus,
                      onBlur: this.onQueryBlur,
                      onKeyDown: this.onQueryKeyDown,
                      value: this.state.searchTerm
                    }), React.createElement(Results, {
                      className: 'react-autocomplete-Autocomplete__results',
                      onSelect: this.onValueChange,
                      onFocus: this.onValueFocus,
                      results: this.state.results,
                      focusedValue: this.state.focusedValue,
                      show: this.state.showResults,
                      renderer: this.props.resultRenderer,
                      label: this.props.label,
                      resultIdentifier: this.props.resultIdentifier
                    }));
                  }
                }, {
                  key: 'componentWillReceiveProps',
                  value: function componentWillReceiveProps(nextProps) {
                    var searchTerm = nextProps.searchTerm ? nextProps.searchTerm : nextProps.value ? nextProps.value.title : '';
                    this.setState({
                      searchTerm: searchTerm
                    });
                  }
                }, {
                  key: 'componentWillMount',
                  value: function componentWillMount() {
                    this.blurTimer = null;
                  }

                  /**
                    * Show results for a search term value.
                    *
                    * This method doesn't update search term value itself.
                    *
                    * @param {Search} searchTerm
                    */
                }]);

                return Autocomplete;
              }(React.Component);
              Autocomplete.displayName = 'Autocomplete';
              Autocomplete.propTypes = {
                options: PropTypes.any,
                search: PropTypes.func,
                resultRenderer: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
                value: PropTypes.object,
                onChange: PropTypes.func,
                onError: PropTypes.func,
                onFocus: PropTypes.func
              };
              Autocomplete.defaultProps = {
                search: searchArray
              };
              var _initialiseProps = function _initialiseProps() {
                var _this4 = this;
                this.getResultIdentifier = function (result) {
                  if (_this4.props.resultIdentifier === undefined) {
                    return result.id;
                  } else {
                    return result[_this4.props.resultIdentifier];
                  }
                };
                this.showResults = function (searchTerm) {
                  _this4.setState({
                    showResultsInProgress: true
                  });
                  _this4.props.search(_this4.props.options, searchTerm.trim(), _this4.onSearchComplete);
                };
                this.showAllResults = function () {
                  if (!_this4.state.showResultsInProgress && !_this4.state.showResults) {
                    _this4.showResults('');
                  }
                };
                this.onValueChange = function (value) {
                  var state = {
                    value: value,
                    showResults: false
                  };
                  if (value) {
                    state.searchTerm = value.title;
                  }
                  _this4.setState(state);
                  if (_this4.props.onChange) {
                    _this4.props.onChange(value);
                  }
                };
                this.onSearchComplete = function (err, results) {
                  if (err) {
                    if (_this4.props.onError) {
                      _this4.props.onError(err);
                    } else {
                      throw err;
                    }
                  }
                  _this4.setState({
                    showResultsInProgress: false,
                    showResults: true,
                    results: results
                  });
                };
                this.onValueFocus = function (value) {
                  _this4.setState({
                    focusedValue: value
                  });
                };
                this.onQueryChange = function (e) {
                  var searchTerm = e.target.value;
                  _this4.setState({
                    searchTerm: searchTerm,
                    focusedValue: null
                  });
                  _this4.showResults(searchTerm);
                };
                this.onFocus = function () {
                  if (_this4.blurTimer) {
                    clearTimeout(_this4.blurTimer);
                    _this4.blurTimer = null;
                  }
                  _this4.refs.search.focus();
                };
                this.onSearchInputFocus = function () {
                  if (_this4.props.onFocus) {
                    _this4.props.onFocus();
                  }
                  _this4.showAllResults();
                };
                this.onBlur = function () {
                  // wrap in setTimeout so we can catch a click on results
                  _this4.blurTimer = setTimeout(function () {
                    _this4.setState({
                      showResults: false
                    });
                  }, 100);
                };
                this.onQueryKeyDown = function (e) {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    if (_this4.state.focusedValue) {
                      _this4.onValueChange(_this4.state.focusedValue);
                    }
                  } else if (e.key === 'ArrowUp' && _this4.state.showResults) {
                    e.preventDefault();
                    var prevIdx = Math.max(_this4.focusedValueIndex() - 1, 0);
                    _this4.setState({
                      focusedValue: _this4.state.results[prevIdx]
                    });
                  } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    if (_this4.state.showResults) {
                      var nextIdx = Math.min(_this4.focusedValueIndex() + (_this4.state.showResults ? 1 : 0), _this4.state.results.length - 1);
                      _this4.setState({
                        showResults: true,
                        focusedValue: _this4.state.results[nextIdx]
                      });
                    } else {
                      _this4.showAllResults();
                    }
                  }
                };
                this.focusedValueIndex = function () {
                  if (!_this4.state.focusedValue) {
                    return -1;
                  }
                  for (var i = 0, len = _this4.state.results.length; i < len; i++) {
                    if (_this4.getResultIdentifier(_this4.state.results[i]) === _this4.getResultIdentifier(_this4.state.focusedValue)) {
                      return i;
                    }
                  }
                  return -1;
                };
              };
              var Results = function (_React$Component2) {
                _inherits(Results, _React$Component2);
                function Results() {
                  var _ref;
                  var _temp, _this2, _ret;
                  _classCallCheck(this, Results);
                  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }
                  return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Results.__proto__ || Object.getPrototypeOf(Results)).call.apply(_ref, [this].concat(args))), _this2), _this2.getResultIdentifier = function (result) {
                    if (_this2.props.resultIdentifier === undefined) {
                      if (!result.id) {
                        throw Error("id property not found on result. You must specify a resultIdentifier and pass as props to autocomplete component");
                      }
                      return result.id;
                    } else {
                      return result[_this2.props.resultIdentifier];
                    }
                  }, _this2.renderResult = function (result) {
                    var focused = _this2.props.focusedValue && _this2.getResultIdentifier(_this2.props.focusedValue) === _this2.getResultIdentifier(result);
                    var Renderer = _this2.props.renderer || Result;
                    return React.createElement(Renderer, {
                      ref: focused ? "focused" : undefined,
                      key: _this2.getResultIdentifier(result),
                      result: result,
                      focused: focused,
                      onMouseEnter: _this2.onMouseEnterResult,
                      onClick: _this2.props.onSelect,
                      label: _this2.props.label
                    });
                  }, _this2.scrollToFocused = function () {
                    var focused = _this2.refs && _this2.refs.focused;
                    if (focused) {
                      var containerNode = ReactDOM.findDOMNode(_this2);
                      var scroll = containerNode.scrollTop;
                      var height = containerNode.offsetHeight;
                      var node = ReactDOM.findDOMNode(focused);
                      var top = node.offsetTop;
                      var bottom = top + node.offsetHeight;

                      // we update ignoreFocus to true if we change the scroll position so
                      // the mouseover event triggered because of that won't have an
                      // effect
                      if (top < scroll) {
                        _this2.ignoreFocus = true;
                        containerNode.scrollTop = top;
                      } else if (bottom - scroll > height) {
                        _this2.ignoreFocus = true;
                        containerNode.scrollTop = bottom - height;
                      }
                    }
                  }, _this2.onMouseEnterResult = function (e, result) {
                    // check if we need to prevent the next onFocus event because it was
                    // probably caused by a mouseover due to scroll position change
                    if (_this2.ignoreFocus) {
                      _this2.ignoreFocus = false;
                    } else {
                      // we need to make sure focused node is visible
                      // for some reason mouse events fire on visible nodes due to
                      // box-shadow
                      var containerNode = ReactDOM.findDOMNode(_this2);
                      var scroll = containerNode.scrollTop;
                      var height = containerNode.offsetHeight;
                      var node = e.target;
                      var top = node.offsetTop;
                      var bottom = top + node.offsetHeight;
                      if (bottom > scroll && top < scroll + height) {
                        _this2.props.onFocus(result);
                      }
                    }
                  }, _temp), _possibleConstructorReturn(_this2, _ret);
                }
                _createClass(Results, [{
                  key: 'render',
                  value: function render() {
                    var style = {
                      display: this.props.show ? 'block' : 'none',
                      position: 'absolute',
                      listStyleType: 'none'
                    };
                    var className = this.props.className;
                    return React.createElement('ul', {
                      style: style,
                      className: className + " react-autocomplete-Results"
                    }, this.props.results.map(this.renderResult));
                  }
                }, {
                  key: 'componentDidUpdate',
                  value: function componentDidUpdate() {
                    this.scrollToFocused();
                  }
                }, {
                  key: 'componentDidMount',
                  value: function componentDidMount() {
                    this.scrollToFocused();
                  }
                }, {
                  key: 'componentWillMount',
                  value: function componentWillMount() {
                    this.ignoreFocus = false;
                  }
                }]);
                return Results;
              }(React.Component);
              var Result = function (_React$Component3) {
                _inherits(Result, _React$Component3);
                function Result() {
                  var _ref2;
                  var _temp2, _this3, _ret2;
                  _classCallCheck(this, Result);
                  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                  }
                  return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = Result.__proto__ || Object.getPrototypeOf(Result)).call.apply(_ref2, [this].concat(args))), _this3), _this3.getLabel = function (result) {
                    if (typeof _this3.props.label === 'function') {
                      return _this3.props.label(result);
                    } else if (typeof _this3.props.label === 'string') {
                      return result[_this3.props.label];
                    }
                  }, _this3.onClick = function () {
                    _this3.props.onClick(_this3.props.result);
                  }, _this3.onMouseEnter = function (e) {
                    if (_this3.props.onMouseEnter) {
                      _this3.props.onMouseEnter(e, _this3.props.result);
                    }
                  }, _temp2), _possibleConstructorReturn(_this3, _ret2);
                }
                _createClass(Result, [{
                  key: 'render',
                  value: function render() {
                    var className = classnames({
                      'react-autocomplete-Result': true,
                      'react-autocomplete-Result--active': this.props.focused
                    });
                    return React.createElement('li', {
                      style: {
                        listStyleType: 'none'
                      },
                      className: className,
                      onClick: this.onClick,
                      onMouseEnter: this.onMouseEnter
                    }, React.createElement('a', null, this.getLabel(this.props.result)));
                  }
                }, {
                  key: 'shouldComponentUpdate',
                  value: function shouldComponentUpdate(nextProps) {
                    return nextProps.result.id !== this.props.result.id || nextProps.focused !== this.props.focused;
                  }
                }]);
                return Result;
              }(React.Component);

              /**
              * Search options using specified search term treating options as an array
              * of candidates.
              *
              * @param {Array.<Object>} options
              * @param {String} searchTerm
              * @param {Callback} cb
              */

              Result.defaultProps = {
                label: function label(result) {
                  return result.title;
                }
              };
              function searchArray(options, searchTerm, cb) {
                if (!options) {
                  return cb(null, []);
                }
                searchTerm = new RegExp(searchTerm, 'i');
                var results = [];
                for (var i = 0, len = options.length; i < len; i++) {
                  if (searchTerm.exec(options[i].title)) {
                    results.push(options[i]);
                  }
                }
                cb(null, results);
              }
              module.exports = Autocomplete;

              /***/
            }, /* 1 */
            /***/function (module, exports, __webpack_require__) {
              var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                               Copyright (c) 2015 Jed Watson.
                                                                               Licensed under the MIT License (MIT), see
                                                                               http://jedwatson.github.io/classnames
                                                                               */

              function classNames() {
                var classes = '';
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                  arg = arguments[i];
                  if (!arg) {
                    continue;
                  }
                  if ('string' === typeof arg || 'number' === typeof arg) {
                    classes += ' ' + arg;
                  } else if (Object.prototype.toString.call(arg) === '[object Array]') {
                    classes += ' ' + classNames.apply(null, arg);
                  } else if ('object' === typeof arg) {
                    for (var key in arg) {
                      if (!arg.hasOwnProperty(key) || !arg[key]) {
                        continue;
                      }
                      classes += ' ' + key;
                    }
                  }
                }
                return classes.substr(1);
              }

              // safely export classNames for node / browserify
              if (typeof module !== 'undefined' && module.exports) {
                module.exports = classNames;
              }

              // safely export classNames for RequireJS
              if (true) {
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
                  return classNames;
                }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
              }

              /***/
            }, /* 2 */
            /***/function (module, exports) {
              "use strict";

              /**
               * Copyright (c) 2013-present, Facebook, Inc.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               *
               * 
               */
              function makeEmptyFunction(arg) {
                return function () {
                  return arg;
                };
              }

              /**
               * This function accepts and discards inputs; it has no side effects. This is
               * primarily useful idiomatically for overridable function endpoints which
               * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
               */
              var emptyFunction = function emptyFunction() {};
              emptyFunction.thatReturns = makeEmptyFunction;
              emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
              emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
              emptyFunction.thatReturnsNull = makeEmptyFunction(null);
              emptyFunction.thatReturnsThis = function () {
                return this;
              };
              emptyFunction.thatReturnsArgument = function (arg) {
                return arg;
              };
              module.exports = emptyFunction;

              /***/
            }, /* 3 */
            /***/function (module, exports, __webpack_require__) {
              /**
               * Copyright (c) 2013-present, Facebook, Inc.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               *
               */

              'use strict';

              /**
               * Use invariant() to assert state which your program assumes to be true.
               *
               * Provide sprintf-style format (only %s is supported) and arguments
               * to provide information about what broke and what you were
               * expecting.
               *
               * The invariant message will be stripped in production, but the invariant
               * will remain to ensure logic does not differ in production.
               */
              var validateFormat = function validateFormat(format) {};
              if (false) {}
              function invariant(condition, format, a, b, c, d, e, f) {
                validateFormat(format);
                if (!condition) {
                  var error;
                  if (format === undefined) {
                    error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
                  } else {
                    var args = [a, b, c, d, e, f];
                    var argIndex = 0;
                    error = new Error(format.replace(/%s/g, function () {
                      return args[argIndex++];
                    }));
                    error.name = 'Invariant Violation';
                  }
                  error.framesToPop = 1; // we don't care about invariant's own frame
                  throw error;
                }
              }
              module.exports = invariant;

              /***/
            }, /* 4 */
            /***/function (module, exports, __webpack_require__) {
              /**
               * Copyright (c) 2013-present, Facebook, Inc.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */

              'use strict';

              var emptyFunction = __webpack_require__(2);
              var invariant = __webpack_require__(3);
              var ReactPropTypesSecret = __webpack_require__(6);
              module.exports = function () {
                function shim(props, propName, componentName, location, propFullName, secret) {
                  if (secret === ReactPropTypesSecret) {
                    // It is still safe when called from React.
                    return;
                  }
                  invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
                }
                ;
                shim.isRequired = shim;
                function getShim() {
                  return shim;
                }
                ;
                // Important!
                // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
                var ReactPropTypes = {
                  array: shim,
                  bool: shim,
                  func: shim,
                  number: shim,
                  object: shim,
                  string: shim,
                  symbol: shim,
                  any: shim,
                  arrayOf: getShim,
                  element: shim,
                  instanceOf: getShim,
                  node: shim,
                  objectOf: getShim,
                  oneOf: getShim,
                  oneOfType: getShim,
                  shape: getShim,
                  exact: getShim
                };
                ReactPropTypes.checkPropTypes = emptyFunction;
                ReactPropTypes.PropTypes = ReactPropTypes;
                return ReactPropTypes;
              };

              /***/
            }, /* 5 */
            /***/function (module, exports, __webpack_require__) {
              /**
               * Copyright (c) 2013-present, Facebook, Inc.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */

              if (false) {
                var throwOnDirectAccess, isValidElement, REACT_ELEMENT_TYPE;
              } else {
                // By explicitly using `prop-types` you are opting into new production behavior.
                // http://fb.me/prop-types-in-prod
                module.exports = __webpack_require__(4)();
              }

              /***/
            }, /* 6 */
            /***/function (module, exports) {
              /**
               * Copyright (c) 2013-present, Facebook, Inc.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */

              'use strict';

              var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
              module.exports = ReactPropTypesSecret;

              /***/
            }, /* 7 */
            /***/function (module, exports) {
              module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

              /***/
            }, /* 8 */
            /***/function (module, exports) {
              module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

              /***/
            }
            /******/])
          );
        });

        ;

        /***/
      }, /* 370 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(247);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      }, /* 371 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(248);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      }, /* 372 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(249);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      }, /* 373 */
      /***/function (module, exports, __webpack_require__) {
        // style-loader: Adds some css to the DOM by adding a <style> tag

        // load the styles
        var content = __webpack_require__(251);
        if (typeof content === 'string') content = [[module.id, content, '']];
        // add the styles to the DOM
        var update = __webpack_require__(8)(content, {});
        if (content.locals) module.exports = content.locals;
        // Hot Module Replacement
        if (false) {}

        /***/
      }, /* 374 */
      /***/function (module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */(function (module) {
          'use strict';

          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          var _ponyfill = __webpack_require__(375);
          var _ponyfill2 = _interopRequireDefault(_ponyfill);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              'default': obj
            };
          }
          var root; /* global window */

          if (typeof self !== 'undefined') {
            root = self;
          } else if (typeof window !== 'undefined') {
            root = window;
          } else if (typeof window !== 'undefined') {
            root = window;
          } else if (true) {
            root = module;
          } else {}
          var result = (0, _ponyfill2['default'])(root);
          exports['default'] = result;
          /* WEBPACK VAR INJECTION */
        }).call(exports, __webpack_require__(1)(module));

        /***/
      }, /* 375 */
      /***/function (module, exports) {
        'use strict';

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports['default'] = symbolObservablePonyfill;
        function symbolObservablePonyfill(root) {
          var result;
          var _Symbol = root.Symbol;
          if (typeof _Symbol === 'function') {
            if (_Symbol.observable) {
              result = _Symbol.observable;
            } else {
              result = _Symbol('observable');
              _Symbol.observable = result;
            }
          } else {
            result = '@@observable';
          }
          return result;
        }
        ;

        /***/
      }, /* 376 */
      /***/function (module, exports, __webpack_require__) {
        var getNative = __webpack_require__(24),
          root = __webpack_require__(16);

        /* Built-in method references that are verified to be native. */
        var DataView = getNative(root, 'DataView');
        module.exports = DataView;

        /***/
      }, /* 377 */
      [1544, 425, 426, 427, 428, 429], /* 378 */
      /***/function (module, exports, __webpack_require__) {
        var getNative = __webpack_require__(24),
          root = __webpack_require__(16);

        /* Built-in method references that are verified to be native. */
        var Promise = getNative(root, 'Promise');
        module.exports = Promise;

        /***/
      }, /* 379 */
      [1554, 24, 16], /* 380 */
      [1559, 97, 449, 450], /* 381 */
      /***/function (module, exports, __webpack_require__) {
        var root = __webpack_require__(16);

        /** Built-in value references. */
        var Uint8Array = root.Uint8Array;
        module.exports = Uint8Array;

        /***/
      }, /* 382 */
      /***/function (module, exports, __webpack_require__) {
        var getNative = __webpack_require__(24),
          root = __webpack_require__(16);

        /* Built-in method references that are verified to be native. */
        var WeakMap = getNative(root, 'WeakMap');
        module.exports = WeakMap;

        /***/
      }, /* 383 */
      /***/function (module, exports) {
        /**
         * A specialized version of `baseAggregator` for arrays.
         *
         * @private
         * @param {Array} [array] The array to iterate over.
         * @param {Function} setter The function to set `accumulator` values.
         * @param {Function} iteratee The iteratee to transform keys.
         * @param {Object} accumulator The initial aggregated object.
         * @returns {Function} Returns `accumulator`.
         */
        function arrayAggregator(array, setter, iteratee, accumulator) {
          var index = -1,
            length = array == null ? 0 : array.length;
          while (++index < length) {
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
          }
          return accumulator;
        }
        module.exports = arrayAggregator;

        /***/
      }, /* 384 */
      272, /* 385 */
      [1563, 407, 202, 17, 204, 197, 206], /* 386 */
      87, /* 387 */
      274, /* 388 */
      /***/function (module, exports) {
        /**
         * A specialized version of `_.some` for arrays without support for iteratee
         * shorthands.
         *
         * @private
         * @param {Array} [array] The array to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {boolean} Returns `true` if any element passes the predicate check,
         *  else `false`.
         */
        function arraySome(array, predicate) {
          var index = -1,
            length = array == null ? 0 : array.length;
          while (++index < length) {
            if (predicate(array[index], index, array)) {
              return true;
            }
          }
          return false;
        }
        module.exports = arraySome;

        /***/
      }, /* 389 */
      /***/function (module, exports, __webpack_require__) {
        var baseEach = __webpack_require__(391);

        /**
         * Aggregates elements of `collection` on `accumulator` with keys transformed
         * by `iteratee` and values set by `setter`.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} setter The function to set `accumulator` values.
         * @param {Function} iteratee The iteratee to transform keys.
         * @param {Object} accumulator The initial aggregated object.
         * @returns {Function} Returns `accumulator`.
         */
        function baseAggregator(collection, setter, iteratee, accumulator) {
          baseEach(collection, function (value, key, collection) {
            setter(accumulator, value, iteratee(value), collection);
          });
          return accumulator;
        }
        module.exports = baseAggregator;

        /***/
      }, /* 390 */
      [1570, 415], /* 391 */
      /***/function (module, exports, __webpack_require__) {
        var baseForOwn = __webpack_require__(393),
          createBaseEach = __webpack_require__(413);

        /**
         * The base implementation of `_.forEach` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         */
        var baseEach = createBaseEach(baseForOwn);
        module.exports = baseEach;

        /***/
      }, /* 392 */
      /***/function (module, exports, __webpack_require__) {
        var createBaseFor = __webpack_require__(414);

        /**
         * The base implementation of `baseForOwn` which iterates over `object`
         * properties returned by `keysFunc` and invokes `iteratee` for each property.
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @returns {Object} Returns `object`.
         */
        var baseFor = createBaseFor();
        module.exports = baseFor;

        /***/
      }, /* 393 */
      /***/function (module, exports, __webpack_require__) {
        var baseFor = __webpack_require__(392),
          keys = __webpack_require__(102);

        /**
         * The base implementation of `_.forOwn` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Object} Returns `object`.
         */
        function baseForOwn(object, iteratee) {
          return object && baseFor(object, iteratee, keys);
        }
        module.exports = baseForOwn;

        /***/
      }, /* 394 */
      /***/function (module, exports, __webpack_require__) {
        var arrayPush = __webpack_require__(387),
          isArray = __webpack_require__(17);

        /**
         * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
         * `keysFunc` and `symbolsFunc` to get the enumerable property names and
         * symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @param {Function} symbolsFunc The function to get the symbols of `object`.
         * @returns {Array} Returns the array of property names and symbols.
         */
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result = keysFunc(object);
          return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        module.exports = baseGetAllKeys;

        /***/
      }, /* 395 */
      /***/function (module, exports) {
        /**
         * The base implementation of `_.hasIn` without support for deep paths.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {Array|string} key The key to check.
         * @returns {boolean} Returns `true` if `key` exists, else `false`.
         */
        function baseHasIn(object, key) {
          return object != null && key in Object(object);
        }
        module.exports = baseHasIn;

        /***/
      }, /* 396 */
      [1576, 38, 39], /* 397 */
      /***/function (module, exports, __webpack_require__) {
        var Stack = __webpack_require__(191),
          equalArrays = __webpack_require__(195),
          equalByTag = __webpack_require__(416),
          equalObjects = __webpack_require__(417),
          getTag = __webpack_require__(422),
          isArray = __webpack_require__(17),
          isBuffer = __webpack_require__(204),
          isTypedArray = __webpack_require__(206);

        /** Used to compose bitmasks for value comparisons. */
        var COMPARE_PARTIAL_FLAG = 1;

        /** `Object#toString` result references. */
        var argsTag = '[object Arguments]',
          arrayTag = '[object Array]',
          objectTag = '[object Object]';

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * A specialized version of `baseIsEqual` for arrays and objects which performs
         * deep comparisons and tracks traversed objects enabling objects with circular
         * references to be compared.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} [stack] Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object),
            othIsArr = isArray(other),
            objTag = objIsArr ? arrayTag : getTag(object),
            othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag,
            othIsObj = othTag == objectTag,
            isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
              othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object,
                othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        module.exports = baseIsEqualDeep;

        /***/
      }, /* 398 */
      /***/function (module, exports, __webpack_require__) {
        var Stack = __webpack_require__(191),
          baseIsEqual = __webpack_require__(193);

        /** Used to compose bitmasks for value comparisons. */
        var COMPARE_PARTIAL_FLAG = 1,
          COMPARE_UNORDERED_FLAG = 2;

        /**
         * The base implementation of `_.isMatch` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @param {Array} matchData The property names, values, and compare flags to match.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         */
        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length,
            length = index,
            noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object(object);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0],
              objValue = object[key],
              srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
                return false;
              }
            }
          }
          return true;
        }
        module.exports = baseIsMatch;

        /***/
      }, /* 399 */
      [1578, 205, 431, 100, 200], /* 400 */
      [1581, 38, 99, 39], /* 401 */
      /***/function (module, exports, __webpack_require__) {
        var baseMatches = __webpack_require__(403),
          baseMatchesProperty = __webpack_require__(404),
          identity = __webpack_require__(461),
          isArray = __webpack_require__(17),
          property = __webpack_require__(463);

        /**
         * The base implementation of `_.iteratee`.
         *
         * @private
         * @param {*} [value=_.identity] The value to convert to an iteratee.
         * @returns {Function} Returns the iteratee.
         */
        function baseIteratee(value) {
          // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
          // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
          if (typeof value == 'function') {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == 'object') {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        module.exports = baseIteratee;

        /***/
      }, /* 402 */
      /***/function (module, exports, __webpack_require__) {
        var isPrototype = __webpack_require__(432),
          nativeKeys = __webpack_require__(445);

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result = [];
          for (var key in Object(object)) {
            if (hasOwnProperty.call(object, key) && key != 'constructor') {
              result.push(key);
            }
          }
          return result;
        }
        module.exports = baseKeys;

        /***/
      }, /* 403 */
      /***/function (module, exports, __webpack_require__) {
        var baseIsMatch = __webpack_require__(398),
          getMatchData = __webpack_require__(419),
          matchesStrictComparable = __webpack_require__(199);

        /**
         * The base implementation of `_.matches` which doesn't clone `source`.
         *
         * @private
         * @param {Object} source The object of property values to match.
         * @returns {Function} Returns the new spec function.
         */
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function (object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        module.exports = baseMatches;

        /***/
      }, /* 404 */
      /***/function (module, exports, __webpack_require__) {
        var baseIsEqual = __webpack_require__(193),
          get = __webpack_require__(458),
          hasIn = __webpack_require__(460),
          isKey = __webpack_require__(98),
          isStrictComparable = __webpack_require__(198),
          matchesStrictComparable = __webpack_require__(199),
          toKey = __webpack_require__(76);

        /** Used to compose bitmasks for value comparisons. */
        var COMPARE_PARTIAL_FLAG = 1,
          COMPARE_UNORDERED_FLAG = 2;

        /**
         * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
         *
         * @private
         * @param {string} path The path of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function (object) {
            var objValue = get(object, path);
            return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        module.exports = baseMatchesProperty;

        /***/
      }, /* 405 */
      /***/function (module, exports) {
        /**
         * The base implementation of `_.property` without support for deep paths.
         *
         * @private
         * @param {string} key The key of the property to get.
         * @returns {Function} Returns the new accessor function.
         */
        function baseProperty(key) {
          return function (object) {
            return object == null ? undefined : object[key];
          };
        }
        module.exports = baseProperty;

        /***/
      }, /* 406 */
      /***/function (module, exports, __webpack_require__) {
        var baseGet = __webpack_require__(192);

        /**
         * A specialized version of `baseProperty` which supports deep paths.
         *
         * @private
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         */
        function basePropertyDeep(path) {
          return function (object) {
            return baseGet(object, path);
          };
        }
        module.exports = basePropertyDeep;

        /***/
      }, /* 407 */
      285, /* 408 */
      /***/function (module, exports, __webpack_require__) {
        var Symbol = __webpack_require__(72),
          arrayMap = __webpack_require__(386),
          isArray = __webpack_require__(17),
          isSymbol = __webpack_require__(101);

        /** Used as references for various `Number` constants. */
        var INFINITY = 1 / 0;

        /** Used to convert symbols to primitives and strings. */
        var symbolProto = Symbol ? Symbol.prototype : undefined,
          symbolToString = symbolProto ? symbolProto.toString : undefined;

        /**
         * The base implementation of `_.toString` which doesn't convert nullish
         * values to empty strings.
         *
         * @private
         * @param {*} value The value to process.
         * @returns {string} Returns the string.
         */
        function baseToString(value) {
          // Exit early for strings to avoid a performance hit in some environments.
          if (typeof value == 'string') {
            return value;
          }
          if (isArray(value)) {
            // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : '';
          }
          var result = value + '';
          return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        module.exports = baseToString;

        /***/
      }, /* 409 */
      88, /* 410 */
      89, /* 411 */
      [1586, 16], /* 412 */
      /***/function (module, exports, __webpack_require__) {
        var arrayAggregator = __webpack_require__(383),
          baseAggregator = __webpack_require__(389),
          baseIteratee = __webpack_require__(401),
          isArray = __webpack_require__(17);

        /**
         * Creates a function like `_.groupBy`.
         *
         * @private
         * @param {Function} setter The function to set accumulator values.
         * @param {Function} [initializer] The accumulator object initializer.
         * @returns {Function} Returns the new aggregator function.
         */
        function createAggregator(setter, initializer) {
          return function (collection, iteratee) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator,
              accumulator = initializer ? initializer() : {};
            return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
          };
        }
        module.exports = createAggregator;

        /***/
      }, /* 413 */
      /***/function (module, exports, __webpack_require__) {
        var isArrayLike = __webpack_require__(203);

        /**
         * Creates a `baseEach` or `baseEachRight` function.
         *
         * @private
         * @param {Function} eachFunc The function to iterate over a collection.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */
        function createBaseEach(eachFunc, fromRight) {
          return function (collection, iteratee) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee);
            }
            var length = collection.length,
              index = fromRight ? length : -1,
              iterable = Object(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        module.exports = createBaseEach;

        /***/
      }, /* 414 */
      /***/function (module, exports) {
        /**
         * Creates a base function for methods like `_.forIn` and `_.forOwn`.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */
        function createBaseFor(fromRight) {
          return function (object, iteratee, keysFunc) {
            var index = -1,
              iterable = Object(object),
              props = keysFunc(object),
              length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        module.exports = createBaseFor;

        /***/
      }, /* 415 */
      [1589, 24], /* 416 */
      /***/function (module, exports, __webpack_require__) {
        var Symbol = __webpack_require__(72),
          Uint8Array = __webpack_require__(381),
          eq = __webpack_require__(201),
          equalArrays = __webpack_require__(195),
          mapToArray = __webpack_require__(443),
          setToArray = __webpack_require__(451);

        /** Used to compose bitmasks for value comparisons. */
        var COMPARE_PARTIAL_FLAG = 1,
          COMPARE_UNORDERED_FLAG = 2;

        /** `Object#toString` result references. */
        var boolTag = '[object Boolean]',
          dateTag = '[object Date]',
          errorTag = '[object Error]',
          mapTag = '[object Map]',
          numberTag = '[object Number]',
          regexpTag = '[object RegExp]',
          setTag = '[object Set]',
          stringTag = '[object String]',
          symbolTag = '[object Symbol]';
        var arrayBufferTag = '[object ArrayBuffer]',
          dataViewTag = '[object DataView]';

        /** Used to convert symbols to primitives and strings. */
        var symbolProto = Symbol ? Symbol.prototype : undefined,
          symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

        /**
         * A specialized version of `baseIsEqualDeep` for comparing objects of
         * the same `toStringTag`.
         *
         * **Note:** This function only supports comparing values with tags of
         * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {string} tag The `toStringTag` of the objects to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              // Coerce booleans to `1` or `0` and dates to milliseconds.
              // Invalid dates are coerced to `NaN`.
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              // Coerce regexes to strings and treat strings, primitives and objects,
              // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
              // for more details.
              return object == other + '';
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              // Assume cyclic values are equal.
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;

              // Recursively compare objects (susceptible to call stack limits).
              stack.set(object, other);
              var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack['delete'](object);
              return result;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        module.exports = equalByTag;

        /***/
      }, /* 417 */
      /***/function (module, exports, __webpack_require__) {
        var getAllKeys = __webpack_require__(418);

        /** Used to compose bitmasks for value comparisons. */
        var COMPARE_PARTIAL_FLAG = 1;

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * A specialized version of `baseIsEqualDeep` for objects with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
            objProps = getAllKeys(object),
            objLength = objProps.length,
            othProps = getAllKeys(other),
            othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked && stack.get(other)) {
            return stacked == other;
          }
          var result = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key],
              othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            // Recursively compare objects (susceptible to call stack limits).
            if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result = false;
              break;
            }
            skipCtor || (skipCtor = key == 'constructor');
          }
          if (result && !skipCtor) {
            var objCtor = object.constructor,
              othCtor = other.constructor;

            // Non `Object` object instances with different constructors are not equal.
            if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
              result = false;
            }
          }
          stack['delete'](object);
          stack['delete'](other);
          return result;
        }
        module.exports = equalObjects;

        /***/
      }, /* 418 */
      /***/function (module, exports, __webpack_require__) {
        var baseGetAllKeys = __webpack_require__(394),
          getSymbols = __webpack_require__(421),
          keys = __webpack_require__(102);

        /**
         * Creates an array of own enumerable property names and symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names and symbols.
         */
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        module.exports = getAllKeys;

        /***/
      }, /* 419 */
      /***/function (module, exports, __webpack_require__) {
        var isStrictComparable = __webpack_require__(198),
          keys = __webpack_require__(102);

        /**
         * Gets the property names, values, and compare flags of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the match data of `object`.
         */
        function getMatchData(object) {
          var result = keys(object),
            length = result.length;
          while (length--) {
            var key = result[length],
              value = object[key];
            result[length] = [key, value, isStrictComparable(value)];
          }
          return result;
        }
        module.exports = getMatchData;

        /***/
      }, /* 420 */
      [1596, 72], /* 421 */
      /***/function (module, exports, __webpack_require__) {
        var arrayFilter = __webpack_require__(384),
          stubArray = __webpack_require__(464);

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Built-in value references. */
        var propertyIsEnumerable = objectProto.propertyIsEnumerable;

        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeGetSymbols = Object.getOwnPropertySymbols;

        /**
         * Creates an array of the own enumerable symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of symbols.
         */
        var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
          if (object == null) {
            return [];
          }
          object = Object(object);
          return arrayFilter(nativeGetSymbols(object), function (symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        module.exports = getSymbols;

        /***/
      }, /* 422 */
      /***/function (module, exports, __webpack_require__) {
        var DataView = __webpack_require__(376),
          Map = __webpack_require__(96),
          Promise = __webpack_require__(378),
          Set = __webpack_require__(379),
          WeakMap = __webpack_require__(382),
          baseGetTag = __webpack_require__(38),
          toSource = __webpack_require__(200);

        /** `Object#toString` result references. */
        var mapTag = '[object Map]',
          objectTag = '[object Object]',
          promiseTag = '[object Promise]',
          setTag = '[object Set]',
          weakMapTag = '[object WeakMap]';
        var dataViewTag = '[object DataView]';

        /** Used to detect maps, sets, and weakmaps. */
        var dataViewCtorString = toSource(DataView),
          mapCtorString = toSource(Map),
          promiseCtorString = toSource(Promise),
          setCtorString = toSource(Set),
          weakMapCtorString = toSource(WeakMap);

        /**
         * Gets the `toStringTag` of `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */
        var getTag = baseGetTag;

        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
          getTag = function (value) {
            var result = baseGetTag(value),
              Ctor = result == objectTag ? value.constructor : undefined,
              ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result;
          };
        }
        module.exports = getTag;

        /***/
      }, /* 423 */
      295, /* 424 */
      /***/function (module, exports, __webpack_require__) {
        var castPath = __webpack_require__(194),
          isArguments = __webpack_require__(202),
          isArray = __webpack_require__(17),
          isIndex = __webpack_require__(197),
          isLength = __webpack_require__(99),
          toKey = __webpack_require__(76);

        /**
         * Checks if `path` exists on `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @param {Function} hasFunc The function to check properties.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         */
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1,
            length = path.length,
            result = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result || ++index != length) {
            return result;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        module.exports = hasPath;

        /***/
      }, /* 425 */
      [1599, 75], /* 426 */
      297, /* 427 */
      [1603, 75], /* 428 */
      [1607, 75], /* 429 */
      [1610, 75], /* 430 */
      303, /* 431 */
      [1612, 411], /* 432 */
      305, /* 433 */
      306, /* 434 */
      [1615, 73], /* 435 */
      [1618, 73], /* 436 */
      [1620, 73], /* 437 */
      [1623, 73], /* 438 */
      [1628, 377, 71, 96], /* 439 */
      [1631, 74], /* 440 */
      [1633, 74], /* 441 */
      [1635, 74], /* 442 */
      [1639, 74], /* 443 */
      /***/function (module, exports) {
        /**
         * Converts `map` to its key-value pairs.
         *
         * @private
         * @param {Object} map The map to convert.
         * @returns {Array} Returns the key-value pairs.
         */
        function mapToArray(map) {
          var index = -1,
            result = Array(map.size);
          map.forEach(function (value, key) {
            result[++index] = [key, value];
          });
          return result;
        }
        module.exports = mapToArray;

        /***/
      }, /* 444 */
      /***/function (module, exports, __webpack_require__) {
        var memoize = __webpack_require__(462);

        /** Used as the maximum memoize cache size. */
        var MAX_MEMOIZE_SIZE = 500;

        /**
         * A specialized version of `_.memoize` which clears the memoized function's
         * cache when it exceeds `MAX_MEMOIZE_SIZE`.
         *
         * @private
         * @param {Function} func The function to have its output memoized.
         * @returns {Function} Returns the new memoized function.
         */
        function memoizeCapped(func) {
          var result = memoize(func, function (key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result.cache;
          return result;
        }
        module.exports = memoizeCapped;

        /***/
      }, /* 445 */
      /***/function (module, exports, __webpack_require__) {
        var overArg = __webpack_require__(448);

        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeKeys = overArg(Object.keys, Object);
        module.exports = nativeKeys;

        /***/
      }, /* 446 */
      [1644, 196], /* 447 */
      318, /* 448 */
      319, /* 449 */
      321, /* 450 */
      322, /* 451 */
      165, /* 452 */
      /***/function (module, exports, __webpack_require__) {
        var ListCache = __webpack_require__(71);

        /**
         * Removes all key-value entries from the stack.
         *
         * @private
         * @name clear
         * @memberOf Stack
         */
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        module.exports = stackClear;

        /***/
      }, /* 453 */
      /***/function (module, exports) {
        /**
         * Removes `key` and its value from the stack.
         *
         * @private
         * @name delete
         * @memberOf Stack
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function stackDelete(key) {
          var data = this.__data__,
            result = data['delete'](key);
          this.size = data.size;
          return result;
        }
        module.exports = stackDelete;

        /***/
      }, /* 454 */
      /***/function (module, exports) {
        /**
         * Gets the stack value for `key`.
         *
         * @private
         * @name get
         * @memberOf Stack
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function stackGet(key) {
          return this.__data__.get(key);
        }
        module.exports = stackGet;

        /***/
      }, /* 455 */
      /***/function (module, exports) {
        /**
         * Checks if a stack value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Stack
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function stackHas(key) {
          return this.__data__.has(key);
        }
        module.exports = stackHas;

        /***/
      }, /* 456 */
      /***/function (module, exports, __webpack_require__) {
        var ListCache = __webpack_require__(71),
          Map = __webpack_require__(96),
          MapCache = __webpack_require__(97);

        /** Used as the size to enable large array optimizations. */
        var LARGE_ARRAY_SIZE = 200;

        /**
         * Sets the stack `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Stack
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the stack cache instance.
         */
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        module.exports = stackSet;

        /***/
      }, /* 457 */
      /***/function (module, exports, __webpack_require__) {
        var memoizeCapped = __webpack_require__(444);

        /** Used to match property names within property paths. */
        var reLeadingDot = /^\./,
          rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

        /** Used to match backslashes in property paths. */
        var reEscapeChar = /\\(\\)?/g;

        /**
         * Converts `string` to a property path array.
         *
         * @private
         * @param {string} string The string to convert.
         * @returns {Array} Returns the property path array.
         */
        var stringToPath = memoizeCapped(function (string) {
          var result = [];
          if (reLeadingDot.test(string)) {
            result.push('');
          }
          string.replace(rePropName, function (match, number, quote, string) {
            result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
          });
          return result;
        });
        module.exports = stringToPath;

        /***/
      }, /* 458 */
      /***/function (module, exports, __webpack_require__) {
        var baseGet = __webpack_require__(192);

        /**
         * Gets the value at `path` of `object`. If the resolved value is
         * `undefined`, the `defaultValue` is returned in its place.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @param {*} [defaultValue] The value returned for `undefined` resolved values.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.get(object, 'a[0].b.c');
         * // => 3
         *
         * _.get(object, ['a', '0', 'b', 'c']);
         * // => 3
         *
         * _.get(object, 'a.b.c', 'default');
         * // => 'default'
         */
        function get(object, path, defaultValue) {
          var result = object == null ? undefined : baseGet(object, path);
          return result === undefined ? defaultValue : result;
        }
        module.exports = get;

        /***/
      }, /* 459 */
      /***/function (module, exports, __webpack_require__) {
        var baseAssignValue = __webpack_require__(390),
          createAggregator = __webpack_require__(412);

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The order of grouped values
         * is determined by the order they occur in `collection`. The corresponding
         * value of each key is an array of elements responsible for generating the
         * key. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * _.groupBy([6.1, 4.2, 6.3], Math.floor);
         * // => { '4': [4.2], '6': [6.1, 6.3] }
         *
         * // The `_.property` iteratee shorthand.
         * _.groupBy(['one', 'two', 'three'], 'length');
         * // => { '3': ['one', 'two'], '5': ['three'] }
         */
        var groupBy = createAggregator(function (result, value, key) {
          if (hasOwnProperty.call(result, key)) {
            result[key].push(value);
          } else {
            baseAssignValue(result, key, [value]);
          }
        });
        module.exports = groupBy;

        /***/
      }, /* 460 */
      /***/function (module, exports, __webpack_require__) {
        var baseHasIn = __webpack_require__(395),
          hasPath = __webpack_require__(424);

        /**
         * Checks if `path` is a direct or inherited property of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         * @example
         *
         * var object = _.create({ 'a': _.create({ 'b': 2 }) });
         *
         * _.hasIn(object, 'a');
         * // => true
         *
         * _.hasIn(object, 'a.b');
         * // => true
         *
         * _.hasIn(object, ['a', 'b']);
         * // => true
         *
         * _.hasIn(object, 'b');
         * // => false
         */
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        module.exports = hasIn;

        /***/
      }, /* 461 */
      166, /* 462 */
      [1667, 97], /* 463 */
      /***/function (module, exports, __webpack_require__) {
        var baseProperty = __webpack_require__(405),
          basePropertyDeep = __webpack_require__(406),
          isKey = __webpack_require__(98),
          toKey = __webpack_require__(76);

        /**
         * Creates a function that returns the value at `path` of a given object.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         * @example
         *
         * var objects = [
         *   { 'a': { 'b': 2 } },
         *   { 'a': { 'b': 1 } }
         * ];
         *
         * _.map(objects, _.property('a.b'));
         * // => [2, 1]
         *
         * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
         * // => [1, 2]
         */
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        module.exports = property;

        /***/
      }, /* 464 */
      /***/function (module, exports) {
        /**
         * This method returns a new empty array.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {Array} Returns the new empty array.
         * @example
         *
         * var arrays = _.times(2, _.stubArray);
         *
         * console.log(arrays);
         * // => [[], []]
         *
         * console.log(arrays[0] === arrays[1]);
         * // => false
         */
        function stubArray() {
          return [];
        }
        module.exports = stubArray;

        /***/
      }, /* 465 */
      335, /* 466 */
      /***/function (module, exports, __webpack_require__) {
        var baseToString = __webpack_require__(408);

        /**
         * Converts `value` to a string. An empty string is returned for `null`
         * and `undefined` values. The sign of `-0` is preserved.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.toString(null);
         * // => ''
         *
         * _.toString(-0);
         * // => '-0'
         *
         * _.toString([1, 2, 3]);
         * // => '1,2,3'
         */
        function toString(value) {
          return value == null ? '' : baseToString(value);
        }
        module.exports = toString;

        /***/
      },,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, /* 1544 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {
        var hashClear = __webpack_require__(__webpack_module_template_argument_0__),
          hashDelete = __webpack_require__(__webpack_module_template_argument_1__),
          hashGet = __webpack_require__(__webpack_module_template_argument_2__),
          hashHas = __webpack_require__(__webpack_module_template_argument_3__),
          hashSet = __webpack_require__(__webpack_module_template_argument_4__);

        /**
         * Creates a hash object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function Hash(entries) {
          var index = -1,
            length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }

        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        module.exports = Hash;

        /***/
      }, /* 1545 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {
        var listCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
          listCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
          listCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
          listCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
          listCacheSet = __webpack_require__(__webpack_module_template_argument_4__);

        /**
         * Creates an list cache object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function ListCache(entries) {
          var index = -1,
            length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }

        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        module.exports = ListCache;

        /***/
      },,, /* 1548 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
        var getNative = __webpack_require__(__webpack_module_template_argument_0__),
          root = __webpack_require__(__webpack_module_template_argument_1__);

        /* Built-in method references that are verified to be native. */
        var Map = getNative(root, 'Map');
        module.exports = Map;

        /***/
      },,, /* 1551 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {
        var mapCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
          mapCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
          mapCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
          mapCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
          mapCacheSet = __webpack_require__(__webpack_module_template_argument_4__);

        /**
         * Creates a map cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */
        function MapCache(entries) {
          var index = -1,
            length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }

        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        module.exports = MapCache;

        /***/
      },,, /* 1554 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
        var getNative = __webpack_require__(__webpack_module_template_argument_0__),
          root = __webpack_require__(__webpack_module_template_argument_1__);

        /* Built-in method references that are verified to be native. */
        var Set = getNative(root, 'Set');
        module.exports = Set;

        /***/
      },,,,, /* 1559 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
        var MapCache = __webpack_require__(__webpack_module_template_argument_0__),
          setCacheAdd = __webpack_require__(__webpack_module_template_argument_1__),
          setCacheHas = __webpack_require__(__webpack_module_template_argument_2__);

        /**
         *
         * Creates an array cache object to store unique values.
         *
         * @private
         * @constructor
         * @param {Array} [values] The values to cache.
         */
        function SetCache(values) {
          var index = -1,
            length = values == null ? 0 : values.length;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.add(values[index]);
          }
        }

        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        module.exports = SetCache;

        /***/
      }, /* 1560 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var root = __webpack_require__(__webpack_module_template_argument_0__);

        /** Built-in value references. */
        var Symbol = root.Symbol;
        module.exports = Symbol;

        /***/
      },,, /* 1563 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {
        var baseTimes = __webpack_require__(__webpack_module_template_argument_0__),
          isArguments = __webpack_require__(__webpack_module_template_argument_1__),
          isArray = __webpack_require__(__webpack_module_template_argument_2__),
          isBuffer = __webpack_require__(__webpack_module_template_argument_3__),
          isIndex = __webpack_require__(__webpack_module_template_argument_4__),
          isTypedArray = __webpack_require__(__webpack_module_template_argument_5__);

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * Creates an array of the enumerable property names of the array-like `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @param {boolean} inherited Specify returning inherited property names.
         * @returns {Array} Returns the array of property names.
         */
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value),
            isArg = !isArr && isArguments(value),
            isBuff = !isArr && !isArg && isBuffer(value),
            isType = !isArr && !isArg && !isBuff && isTypedArray(value),
            skipIndexes = isArr || isArg || isBuff || isType,
            result = skipIndexes ? baseTimes(value.length, String) : [],
            length = result.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
            // Safari 9 has enumerable `arguments.length` in strict mode.
            key == 'length' ||
            // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') ||
            // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
            // Skip index properties.
            isIndex(key, length)))) {
              result.push(key);
            }
          }
          return result;
        }
        module.exports = arrayLikeKeys;

        /***/
      },,,, /* 1567 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var eq = __webpack_require__(__webpack_module_template_argument_0__);

        /**
         * Gets the index at which the `key` is found in `array` of key-value pairs.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {*} key The key to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        module.exports = assocIndexOf;

        /***/
      },,, /* 1570 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var defineProperty = __webpack_require__(__webpack_module_template_argument_0__);

        /**
         * The base implementation of `assignValue` and `assignMergeValue` without
         * value checks.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */
        function baseAssignValue(object, key, value) {
          if (key == '__proto__' && defineProperty) {
            defineProperty(object, key, {
              'configurable': true,
              'enumerable': true,
              'value': value,
              'writable': true
            });
          } else {
            object[key] = value;
          }
        }
        module.exports = baseAssignValue;

        /***/
      },,, /* 1573 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
        var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
          getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
          objectToString = __webpack_require__(__webpack_module_template_argument_2__);

        /** `Object#toString` result references. */
        var nullTag = '[object Null]',
          undefinedTag = '[object Undefined]';

        /** Built-in value references. */
        var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

        /**
         * The base implementation of `getTag` without fallbacks for buggy environments.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
        }
        module.exports = baseGetTag;

        /***/
      },,, /* 1576 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
        var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
          isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);

        /** `Object#toString` result references. */
        var argsTag = '[object Arguments]';

        /**
         * The base implementation of `_.isArguments`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         */
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        module.exports = baseIsArguments;

        /***/
      },, /* 1578 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {
        var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
          isMasked = __webpack_require__(__webpack_module_template_argument_1__),
          isObject = __webpack_require__(__webpack_module_template_argument_2__),
          toSource = __webpack_require__(__webpack_module_template_argument_3__);

        /**
         * Used to match `RegExp`
         * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
         */
        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

        /** Used to detect host constructors (Safari). */
        var reIsHostCtor = /^\[object .+?Constructor\]$/;

        /** Used for built-in method references. */
        var funcProto = Function.prototype,
          objectProto = Object.prototype;

        /** Used to resolve the decompiled source of functions. */
        var funcToString = funcProto.toString;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /** Used to detect if a method is native. */
        var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

        /**
         * The base implementation of `_.isNative` without bad shim checks.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a native function,
         *  else `false`.
         */
        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        module.exports = baseIsNative;

        /***/
      },,, /* 1581 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
        var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
          isLength = __webpack_require__(__webpack_module_template_argument_1__),
          isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);

        /** `Object#toString` result references. */
        var argsTag = '[object Arguments]',
          arrayTag = '[object Array]',
          boolTag = '[object Boolean]',
          dateTag = '[object Date]',
          errorTag = '[object Error]',
          funcTag = '[object Function]',
          mapTag = '[object Map]',
          numberTag = '[object Number]',
          objectTag = '[object Object]',
          regexpTag = '[object RegExp]',
          setTag = '[object Set]',
          stringTag = '[object String]',
          weakMapTag = '[object WeakMap]';
        var arrayBufferTag = '[object ArrayBuffer]',
          dataViewTag = '[object DataView]',
          float32Tag = '[object Float32Array]',
          float64Tag = '[object Float64Array]',
          int8Tag = '[object Int8Array]',
          int16Tag = '[object Int16Array]',
          int32Tag = '[object Int32Array]',
          uint8Tag = '[object Uint8Array]',
          uint8ClampedTag = '[object Uint8ClampedArray]',
          uint16Tag = '[object Uint16Array]',
          uint32Tag = '[object Uint32Array]';

        /** Used to identify `toStringTag` values of typed arrays. */
        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

        /**
         * The base implementation of `_.isTypedArray` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         */
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        module.exports = baseIsTypedArray;

        /***/
      },,,,, /* 1586 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var root = __webpack_require__(__webpack_module_template_argument_0__);

        /** Used to detect overreaching core-js shims. */
        var coreJsData = root['__core-js_shared__'];
        module.exports = coreJsData;

        /***/
      },,, /* 1589 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var getNative = __webpack_require__(__webpack_module_template_argument_0__);
        var defineProperty = function () {
          try {
            var func = getNative(Object, 'defineProperty');
            func({}, '', {});
            return func;
          } catch (e) {}
        }();
        module.exports = defineProperty;

        /***/
      }, /* 1590 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var isKeyable = __webpack_require__(__webpack_module_template_argument_0__);

        /**
         * Gets the data for `map`.
         *
         * @private
         * @param {Object} map The map to query.
         * @param {string} key The reference key.
         * @returns {*} Returns the map data.
         */
        function getMapData(map, key) {
          var data = map.__data__;
          return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        module.exports = getMapData;

        /***/
      },,,,, /* 1595 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
        var baseIsNative = __webpack_require__(__webpack_module_template_argument_0__),
          getValue = __webpack_require__(__webpack_module_template_argument_1__);

        /**
         * Gets the native function at `key` of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {string} key The key of the method to get.
         * @returns {*} Returns the function if it's native, else `undefined`.
         */
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined;
        }
        module.exports = getNative;

        /***/
      }, /* 1596 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var Symbol = __webpack_require__(__webpack_module_template_argument_0__);

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */
        var nativeObjectToString = objectProto.toString;

        /** Built-in value references. */
        var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

        /**
         * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the raw `toStringTag`.
         */
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag),
            tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined;
            var unmasked = true;
          } catch (e) {}
          var result = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result;
        }
        module.exports = getRawTag;

        /***/
      },,, /* 1599 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);

        /**
         * Removes all key-value entries from the hash.
         *
         * @private
         * @name clear
         * @memberOf Hash
         */
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        module.exports = hashClear;

        /***/
      },,,, /* 1603 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);

        /** Used to stand-in for `undefined` hash values. */
        var HASH_UNDEFINED = '__lodash_hash_undefined__';

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * Gets the hash value for `key`.
         *
         * @private
         * @name get
         * @memberOf Hash
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        module.exports = hashGet;

        /***/
      },,,, /* 1607 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * Checks if a hash value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Hash
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        module.exports = hashHas;

        /***/
      },,, /* 1610 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);

        /** Used to stand-in for `undefined` hash values. */
        var HASH_UNDEFINED = '__lodash_hash_undefined__';

        /**
         * Sets the hash `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Hash
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the hash instance.
         */
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
          return this;
        }
        module.exports = hashSet;

        /***/
      },, /* 1612 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var coreJsData = __webpack_require__(__webpack_module_template_argument_0__);

        /** Used to detect methods masquerading as native. */
        var maskSrcKey = function () {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
          return uid ? 'Symbol(src)_1.' + uid : '';
        }();

        /**
         * Checks if `func` has its source masked.
         *
         * @private
         * @param {Function} func The function to check.
         * @returns {boolean} Returns `true` if `func` is masked, else `false`.
         */
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        module.exports = isMasked;

        /***/
      },,, /* 1615 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);

        /** Used for built-in method references. */
        var arrayProto = Array.prototype;

        /** Built-in value references. */
        var splice = arrayProto.splice;

        /**
         * Removes `key` and its value from the list cache.
         *
         * @private
         * @name delete
         * @memberOf ListCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function listCacheDelete(key) {
          var data = this.__data__,
            index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }
        module.exports = listCacheDelete;

        /***/
      },,, /* 1618 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);

        /**
         * Gets the list cache value for `key`.
         *
         * @private
         * @name get
         * @memberOf ListCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function listCacheGet(key) {
          var data = this.__data__,
            index = assocIndexOf(data, key);
          return index < 0 ? undefined : data[index][1];
        }
        module.exports = listCacheGet;

        /***/
      },, /* 1620 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);

        /**
         * Checks if a list cache value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf ListCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        module.exports = listCacheHas;

        /***/
      },,, /* 1623 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);

        /**
         * Sets the list cache `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf ListCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the list cache instance.
         */
        function listCacheSet(key, value) {
          var data = this.__data__,
            index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }
          return this;
        }
        module.exports = listCacheSet;

        /***/
      },,,,, /* 1628 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
        var Hash = __webpack_require__(__webpack_module_template_argument_0__),
          ListCache = __webpack_require__(__webpack_module_template_argument_1__),
          Map = __webpack_require__(__webpack_module_template_argument_2__);

        /**
         * Removes all key-value entries from the map.
         *
         * @private
         * @name clear
         * @memberOf MapCache
         */
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            'hash': new Hash(),
            'map': new (Map || ListCache)(),
            'string': new Hash()
          };
        }
        module.exports = mapCacheClear;

        /***/
      },,, /* 1631 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var getMapData = __webpack_require__(__webpack_module_template_argument_0__);

        /**
         * Removes `key` and its value from the map.
         *
         * @private
         * @name delete
         * @memberOf MapCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */
        function mapCacheDelete(key) {
          var result = getMapData(this, key)['delete'](key);
          this.size -= result ? 1 : 0;
          return result;
        }
        module.exports = mapCacheDelete;

        /***/
      },, /* 1633 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var getMapData = __webpack_require__(__webpack_module_template_argument_0__);

        /**
         * Gets the map value for `key`.
         *
         * @private
         * @name get
         * @memberOf MapCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        module.exports = mapCacheGet;

        /***/
      },, /* 1635 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var getMapData = __webpack_require__(__webpack_module_template_argument_0__);

        /**
         * Checks if a map value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf MapCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        module.exports = mapCacheHas;

        /***/
      },,,, /* 1639 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var getMapData = __webpack_require__(__webpack_module_template_argument_0__);

        /**
         * Sets the map `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf MapCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the map cache instance.
         */
        function mapCacheSet(key, value) {
          var data = getMapData(this, key),
            size = data.size;
          data.set(key, value);
          this.size += data.size == size ? 0 : 1;
          return this;
        }
        module.exports = mapCacheSet;

        /***/
      },,, /* 1642 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var getNative = __webpack_require__(__webpack_module_template_argument_0__);

        /* Built-in method references that are verified to be native. */
        var nativeCreate = getNative(Object, 'create');
        module.exports = nativeCreate;

        /***/
      },, /* 1644 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        /* WEBPACK VAR INJECTION */(function (module) {
          var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);

          /** Detect free variable `exports`. */
          var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

          /** Detect free variable `module`. */
          var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

          /** Detect the popular CommonJS extension `module.exports`. */
          var moduleExports = freeModule && freeModule.exports === freeExports;

          /** Detect free variable `process` from Node.js. */
          var freeProcess = moduleExports && freeGlobal.process;

          /** Used to access faster Node.js helpers. */
          var nodeUtil = function () {
            try {
              return freeProcess && freeProcess.binding && freeProcess.binding('util');
            } catch (e) {}
          }();
          module.exports = nodeUtil;

          /* WEBPACK VAR INJECTION */
        }).call(exports, __webpack_require__(1)(module));

        /***/
      },,,, /* 1648 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);

        /** Detect free variable `self`. */
        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

        /** Used as a reference to the global object. */
        var root = freeGlobal || freeSelf || Function('return this')();
        module.exports = root;

        /***/
      },,,, /* 1652 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
        var baseIsArguments = __webpack_require__(__webpack_module_template_argument_0__),
          isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /** Built-in value references. */
        var propertyIsEnumerable = objectProto.propertyIsEnumerable;

        /**
         * Checks if `value` is likely an `arguments` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         *  else `false`.
         * @example
         *
         * _.isArguments(function() { return arguments; }());
         * // => true
         *
         * _.isArguments([1, 2, 3]);
         * // => false
         */
        var isArguments = baseIsArguments(function () {
          return arguments;
        }()) ? baseIsArguments : function (value) {
          return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        module.exports = isArguments;

        /***/
      }, /* 1653 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
        var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
          isLength = __webpack_require__(__webpack_module_template_argument_1__);

        /**
         * Checks if `value` is array-like. A value is considered array-like if it's
         * not a function and has a `value.length` that's an integer greater than or
         * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
         * @example
         *
         * _.isArrayLike([1, 2, 3]);
         * // => true
         *
         * _.isArrayLike(document.body.children);
         * // => true
         *
         * _.isArrayLike('abc');
         * // => true
         *
         * _.isArrayLike(_.noop);
         * // => false
         */
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        module.exports = isArrayLike;

        /***/
      },,,, /* 1657 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
        /* WEBPACK VAR INJECTION */(function (module) {
          var root = __webpack_require__(__webpack_module_template_argument_0__),
            stubFalse = __webpack_require__(__webpack_module_template_argument_1__);

          /** Detect free variable `exports`. */
          var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

          /** Detect free variable `module`. */
          var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

          /** Detect the popular CommonJS extension `module.exports`. */
          var moduleExports = freeModule && freeModule.exports === freeExports;

          /** Built-in value references. */
          var Buffer = moduleExports ? root.Buffer : undefined;

          /* Built-in method references for those with the same name as other `lodash` methods. */
          var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

          /**
           * Checks if `value` is a buffer.
           *
           * @static
           * @memberOf _
           * @since 4.3.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
           * @example
           *
           * _.isBuffer(new Buffer(2));
           * // => true
           *
           * _.isBuffer(new Uint8Array(2));
           * // => false
           */
          var isBuffer = nativeIsBuffer || stubFalse;
          module.exports = isBuffer;

          /* WEBPACK VAR INJECTION */
        }).call(exports, __webpack_require__(1)(module));

        /***/
      },,,, /* 1661 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
        var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
          isObject = __webpack_require__(__webpack_module_template_argument_1__);

        /** `Object#toString` result references. */
        var asyncTag = '[object AsyncFunction]',
          funcTag = '[object Function]',
          genTag = '[object GeneratorFunction]',
          proxyTag = '[object Proxy]';

        /**
         * Checks if `value` is classified as a `Function` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a function, else `false`.
         * @example
         *
         * _.isFunction(_);
         * // => true
         *
         * _.isFunction(/abc/);
         * // => false
         */
        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          }
          // The use of `Object#toString` avoids issues with the `typeof` operator
          // in Safari 9 which returns 'object' for typed arrays and other constructors.
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        module.exports = isFunction;

        /***/
      }, /* 1662 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
        var baseIsTypedArray = __webpack_require__(__webpack_module_template_argument_0__),
          baseUnary = __webpack_require__(__webpack_module_template_argument_1__),
          nodeUtil = __webpack_require__(__webpack_module_template_argument_2__);

        /* Node.js helper references. */
        var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

        /**
         * Checks if `value` is classified as a typed array.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         * @example
         *
         * _.isTypedArray(new Uint8Array);
         * // => true
         *
         * _.isTypedArray([]);
         * // => false
         */
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        module.exports = isTypedArray;

        /***/
      },,,,, /* 1667 */
      /***/function (module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
        var MapCache = __webpack_require__(__webpack_module_template_argument_0__);

        /** Error message constants. */
        var FUNC_ERROR_TEXT = 'Expected a function';

        /**
         * Creates a function that memoizes the result of `func`. If `resolver` is
         * provided, it determines the cache key for storing the result based on the
         * arguments provided to the memoized function. By default, the first argument
         * provided to the memoized function is used as the map cache key. The `func`
         * is invoked with the `this` binding of the memoized function.
         *
         * **Note:** The cache is exposed as the `cache` property on the memoized
         * function. Its creation may be customized by replacing the `_.memoize.Cache`
         * constructor with one whose instances implement the
         * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
         * method interface of `clear`, `delete`, `get`, `has`, and `set`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to have its output memoized.
         * @param {Function} [resolver] The function to resolve the cache key.
         * @returns {Function} Returns the new memoized function.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         * var other = { 'c': 3, 'd': 4 };
         *
         * var values = _.memoize(_.values);
         * values(object);
         * // => [1, 2]
         *
         * values(other);
         * // => [3, 4]
         *
         * object.a = 2;
         * values(object);
         * // => [1, 2]
         *
         * // Modify the result cache.
         * values.cache.set(object, ['a', 'b']);
         * values(object);
         * // => ['a', 'b']
         *
         * // Replace `_.memoize.Cache`.
         * _.memoize.Cache = WeakMap;
         */
        function memoize(func, resolver) {
          if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          var memoized = function () {
            var args = arguments,
              key = resolver ? resolver.apply(this, args) : args[0],
              cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result) || cache;
            return result;
          };
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }

        // Expose `MapCache`.
        memoize.Cache = MapCache;
        module.exports = memoize;

        /***/
      }
      /******/]))
    );
  });

  ;

  /***/
}, /* 462 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = TikTokVideo;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function TikTokVideo(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      muted = props.muted,
      controls = props.controls;
    var primaryText = socialValues.primaryText,
      video = socialValues.video,
      cta = socialValues.cta,
      adStudioIframe = socialValues.adStudioIframe;
    var isMuted = muted;
    var hasVideo = video && (video === null || video === void 0 ? void 0 : video.src);
    var content = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
      message: "No TikTok Video"
    });
    if (typeof muted !== 'boolean') {
      isMuted = autoPlay;
    }
    if (hasVideo) {
      content = /*#__PURE__*/_react["default"].createElement("div", {
        className: "main-content"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-controls"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "following"
      }, "Following"), "|", /*#__PURE__*/_react["default"].createElement("p", {
        className: "for-you"
      }, "For You")), /*#__PURE__*/_react["default"].createElement(RenderCircleIcons, {
        className: "right-side"
      }), /*#__PURE__*/_react["default"].createElement("video", {
        className: "tiktok",
        autoPlay: autoPlay,
        muted: isMuted,
        controls: controls
      }, /*#__PURE__*/_react["default"].createElement("source", {
        src: video.src
      })));
    }
    if (adStudioIframe) {
      content = adStudioIframe;
    }
    function RenderCircleIcons(_ref) {
      var className = _ref.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(className, " circle-icon-bar")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "circle-icon"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "circle-icon"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "circle-icon"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "circle-icon"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "circle-icon"
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      className: "tiktok-preview"
    }, content, /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-content-container ".concat(hasVideo ? "" : "missing-media")
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText), /*#__PURE__*/_react["default"].createElement("span", {
      className: "sponsored"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, "Sponsored")), /*#__PURE__*/_react["default"].createElement("p", {
      className: "promoted-music"
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fas fa-music"
    }), "Promoted Music"), cta && /*#__PURE__*/_react["default"].createElement("div", {
      className: "cta"
    }, /*#__PURE__*/_react["default"].createElement("span", null, cta))), /*#__PURE__*/_react["default"].createElement(RenderCircleIcons, {
      className: "lower"
    }));
  }
  TikTokVideo.displayName = "TikTokVideo";
  TikTokVideo.defaultProps = {
    socialValues: {},
    autoPlay: true,
    controls: false
  };
  TikTokVideo.propTypes = {
    socialValues: _propTypes["default"].shape({
      primaryText: _propTypes["default"].string,
      video: _propTypes["default"].object,
      landingPage: _propTypes["default"].string,
      cta: _propTypes["default"].string,
      thumbnail: _propTypes["default"].object
    }),
    autoPlay: _propTypes["default"].bool,
    muted: _propTypes["default"].bool,
    controls: _propTypes["default"].bool
  };

  /***/
}, /* 463 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
  var $keys = __webpack_require__(520);
  var enumBugKeys = __webpack_require__(482);
  module.exports = Object.keys || function keys(O) {
    return $keys(O, enumBugKeys);
  };

  /***/
}, /* 464 */
/***/function (module, exports) {
  module.exports = true;

  /***/
}, /* 465 */
/***/function (module, exports) {
  var id = 0;
  var px = Math.random();
  module.exports = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };

  /***/
}, /* 466 */
/***/function (module, exports) {
  exports.f = {}.propertyIsEnumerable;

  /***/
}, /* 467 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  var SimpleErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inherits(SimpleErrorBoundary, _React$Component);
    var _super = _createSuper(SimpleErrorBoundary);
    function SimpleErrorBoundary(props) {
      var _this;
      _classCallCheck(this, SimpleErrorBoundary);
      _this = _super.call(this, props);
      _this.state = {
        hasError: false
      };
      return _this;
    }
    _createClass(SimpleErrorBoundary, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error, errorInfo) {
        console.error("Caught by SimpleErrorBoundary:", error, errorInfo);
      }
    }, {
      key: "render",
      value: function render() {
        if (this.state.hasError) {
          return /*#__PURE__*/_react["default"].createElement("span", null, "Something broke :(");
        }
        return this.props.children;
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
          hasError: true
        };
      }
    }]);
    return SimpleErrorBoundary;
  }(_react["default"].Component);
  exports["default"] = SimpleErrorBoundary;

  /***/
}, /* 468 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FacebookCarousel;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _FacebookCarouselCards = _interopRequireDefault(__webpack_require__(496));
  var _FacebookReelsCarousel = _interopRequireDefault(__webpack_require__(498));
  var _InstagramFeedsCarousel = _interopRequireDefault(__webpack_require__(500));
  var _FacebookFeedsCarousel = _interopRequireDefault(__webpack_require__(502));
  var _InstagramStoriesCarousel = _interopRequireDefault(__webpack_require__(504));
  var _FacebookStoriesCarousel = _interopRequireDefault(__webpack_require__(506));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  var cardIncrement = 304; //includes margin

  function Reels(props) {
    return /*#__PURE__*/_react["default"].createElement(_FacebookReelsCarousel["default"], _extends({}, props, {
      key: props.partner
    }));
  }
  function Feeds(props) {
    var partner = props.partner;
    if (/instagram/i.test(partner)) {
      return /*#__PURE__*/_react["default"].createElement(_InstagramFeedsCarousel["default"], props);
    }
    return /*#__PURE__*/_react["default"].createElement(_FacebookFeedsCarousel["default"], props);
  }
  function Stories(props) {
    var partner = props.partner;
    if (/instagram/i.test(partner)) {
      return /*#__PURE__*/_react["default"].createElement(_InstagramStoriesCarousel["default"], props);
    }
    return /*#__PURE__*/_react["default"].createElement(_FacebookStoriesCarousel["default"], props);
  }
  function FacebookCarousel(props) {
    var socialValues = props.socialValues,
      adType = props.adType,
      baseDomain = props.baseDomain,
      fbPreviewVersion = props.fbPreviewVersion,
      placement = props.placement,
      primaryText = socialValues.primaryText,
      cards = socialValues.cards;
    if (fbPreviewVersion > 1) {
      if (/reels?/i.test(placement)) {
        return /*#__PURE__*/_react["default"].createElement(Reels, props);
      } else if (/feeds?/i.test(placement)) {
        return /*#__PURE__*/_react["default"].createElement(Feeds, props);
      } else if (/story|stories/i.test(placement)) {
        return /*#__PURE__*/_react["default"].createElement(Stories, props);
      }
    }
    var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentCard = _useState2[0],
      setCurrentCard = _useState2[1];
    var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      left = _useState4[0],
      setLeft = _useState4[1];
    function toNextCard() {
      if (currentCard < cards.length - 1) {
        setCurrentCard(currentCard + 1);
        setLeft(left - cardIncrement);
      }
    }
    function toPrevCard() {
      if (currentCard >= 1) {
        setCurrentCard(currentCard - 1);
        setLeft(left + cardIncrement);
      }
    }
    var minCardLength = 2;
    var noCards = !(cards !== null && cards !== void 0 && cards.length) || cards.length < minCardLength;
    var fbCarouselProps = _objectSpread(_objectSpread({}, socialValues), {}, {
      noCards: noCards,
      baseDomain: baseDomain,
      adType: adType
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview carousel ".concat(noCards ? "no-cards" : "")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "hero-text"
    }, /*#__PURE__*/_react["default"].createElement("span", null, primaryText)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      onClick: toNextCard,
      className: "direction-btn next rectangle-40 ".concat(left === -(cards.length - 1) * cardIncrement ? "hidden" : ""),
      name: "far fa-chevron-right"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "carousel-container",
      style: {
        left: left
      }
    }, /*#__PURE__*/_react["default"].createElement(_FacebookCarouselCards["default"], fbCarouselProps)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      onClick: toPrevCard,
      className: "direction-btn prev rectangle-40 ".concat(left === 0 ? "hidden" : ""),
      name: "far fa-chevron-left"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "bottom-section"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    })));
  }
  FacebookCarousel.displayName = "FacebookCarousel";
  FacebookCarousel.defaultProps = {
    socialValues: {},
    fbPreviewVersion: 1,
    autoPlay: false,
    controls: true
  };
  FacebookCarousel.propTypes = {
    socialValues: _propTypes["default"].object,
    fbPreviewVersion: _propTypes["default"].number,
    autoPlay: _propTypes["default"].bool,
    controls: _propTypes["default"].bool
  };

  /***/
}, /* 469 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = GoogleDiscovery;
  exports.filteredImgs = filteredImgs;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _socialHelpers = __webpack_require__(46);
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function filteredImgs(images, placementType) {
    var _images$filter;
    return (images === null || images === void 0 ? void 0 : (_images$filter = images.filter) === null || _images$filter === void 0 ? void 0 : _images$filter.call(images, function (img) {
      return img.aspectRatio === placementType;
    })) || [];
  }
  function GoogleDiscovery(props) {
    var _values$image2, _values$image3, _values$logo, _values$logo2, _values$logo3, _values$headline, _values$description;
    var socialValues = props.socialValues,
      placementType = props.placementType,
      images = socialValues.images,
      businessName = socialValues.businessName,
      headlines = socialValues.headlines,
      descriptions = socialValues.descriptions,
      logos = socialValues.logos,
      cta = socialValues.cta;
    var selectedImages = (0, _react.useMemo)(function () {
      return filteredImgs(images, placementType);
    }, [images, placementType]);
    var _useState = (0, _react.useState)({
        image: (0, _socialHelpers.getRandomArrayItem)(selectedImages),
        logo: (0, _socialHelpers.getRandomArrayItem)(logos),
        headline: (0, _socialHelpers.getRandomArrayItem)(headlines),
        description: (0, _socialHelpers.getRandomArrayItem)(descriptions)
      }),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];
    (0, _react.useEffect)(function () {
      var _values$image;
      //update image on change of placementType
      if (((_values$image = values.image) === null || _values$image === void 0 ? void 0 : _values$image.aspectRatio) !== placementType) {
        setValues(_objectSpread(_objectSpread({}, values), {}, {
          image: (0, _socialHelpers.getRandomArrayItem)(selectedImages)
        }));
      }
    }, [placementType]);
    var renderedImg = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
      className: (_values$image2 = values.image) === null || _values$image2 === void 0 ? void 0 : _values$image2.aspectRatio
    });
    if ((_values$image3 = values.image) !== null && _values$image3 !== void 0 && _values$image3.src) {
      var _values$image4 = values === null || values === void 0 ? void 0 : values.image,
        src = _values$image4.src,
        name = _values$image4.name,
        id = _values$image4.id,
        aspectRatio = _values$image4.aspectRatio;
      renderedImg = /*#__PURE__*/_react["default"].createElement("img", {
        src: src,
        alt: name,
        key: id,
        className: "media ".concat(aspectRatio, "-ar")
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "google-discovery-preview"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "google-discovery-main-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "google-discovery-header"
    }, (_values$logo = values.logo) !== null && _values$logo !== void 0 && _values$logo.src ? /*#__PURE__*/_react["default"].createElement("img", {
      className: "logo",
      alt: (_values$logo2 = values.logo) === null || _values$logo2 === void 0 ? void 0 : _values$logo2.name,
      src: (_values$logo3 = values.logo) === null || _values$logo3 === void 0 ? void 0 : _values$logo3.src
    }) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-30 h-30"
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: "header-text"
    }, businessName || "Missing Business Name")), renderedImg, /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-content"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "headline"
    }, ((_values$headline = values.headline) === null || _values$headline === void 0 ? void 0 : _values$headline.name) || "Missing Headline"), /*#__PURE__*/_react["default"].createElement("p", {
      className: "description"
    }, ((_values$description = values.description) === null || _values$description === void 0 ? void 0 : _values$description.name) || "Missing Description"), /*#__PURE__*/_react["default"].createElement("span", {
      className: "cta"
    }, (cta === null || cta === void 0 ? void 0 : cta.name) || "Missing CTA"))));
  }
  GoogleDiscovery.displayName = "GoogleDiscovery";
  GoogleDiscovery.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  GoogleDiscovery.propTypes = {
    socialValues: _propTypes["default"].shape({
      images: _propTypes["default"].arrayOf(_propTypes["default"].object),
      logos: _propTypes["default"].arrayOf(_propTypes["default"].object),
      headlines: _propTypes["default"].arrayOf(_propTypes["default"].object),
      descriptions: _propTypes["default"].arrayOf(_propTypes["default"].object),
      businessName: _propTypes["default"].string,
      landingPage: _propTypes["default"].string,
      cta: _propTypes["default"].object
    }),
    placementType: _propTypes["default"].string
  };

  /***/
}, /* 470 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = GoogleDiscoveryCarousel;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _socialHelpers = __webpack_require__(46);
  var _YtMobileCarousel = _interopRequireDefault(__webpack_require__(508));
  var _VerticalCarousel = _interopRequireDefault(__webpack_require__(509));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function GoogleDiscoveryCarousel(props) {
    var placementType = props.placementType,
      YOUTUBE_MOBILE = _socialHelpers.GOOGLE_DISC_CAROUSEL_ASPECT_RATIOS.YOUTUBE_MOBILE,
      VERTICAL = _socialHelpers.GOOGLE_DISC_CAROUSEL_ASPECT_RATIOS.VERTICAL;
    var renderedCarouselType = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
      message: "Missing or Invalid Slides"
    });
    if (placementType === YOUTUBE_MOBILE.SQUARE || placementType === YOUTUBE_MOBILE.HORIZONTAL) {
      renderedCarouselType = /*#__PURE__*/_react["default"].createElement(_YtMobileCarousel["default"], props);
    } else if (placementType === VERTICAL) {
      renderedCarouselType = /*#__PURE__*/_react["default"].createElement(_VerticalCarousel["default"], props);
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      className: "google-discovery-preview carousel ".concat(placementType, "-ar")
    }, renderedCarouselType);
  }
  GoogleDiscoveryCarousel.displayName = "GoogleDiscoveryCarousel";
  GoogleDiscoveryCarousel.defaultValues = {
    placementType: ""
  };
  GoogleDiscoveryCarousel.propTypes = {
    placementType: _propTypes["default"].string
  };

  /***/
}, /* 471 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = LinkedInCarousel;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _useCarousel2 = _interopRequireDefault(__webpack_require__(176));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _LinkedInCarouselCards = _interopRequireDefault(__webpack_require__(511));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function LinkedInCarousel(props) {
    var socialValues = props.socialValues,
      introDescription = socialValues.introDescription,
      cards = socialValues.cards;
    var cardIncrement = 322; // includes margin;
    var minCardsLength = 2;
    var _useCarousel = (0, _useCarousel2["default"])(cards, cardIncrement),
      nextCard = _useCarousel.nextCard,
      prevCard = _useCarousel.prevCard,
      currentCard = _useCarousel.currentCard,
      left = _useCarousel.left;
    function directionalArrows() {
      if ((cards === null || cards === void 0 ? void 0 : cards.length) < minCardsLength) {
        return;
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        onClick: function onClick() {
          return nextCard();
        },
        className: "direction-btn next ".concat(currentCard === cards.length - 1 ? "hidden" : ""),
        name: "far fa-chevron-right"
      }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        onClick: function onClick() {
          return prevCard();
        },
        className: "direction-btn prev ".concat(currentCard === 0 ? "hidden" : ""),
        name: "far fa-chevron-left"
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      className: "linkedin-preview border carousel"
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: "linkedin-main-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "header-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "upper"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "square w-32 h-32 item1"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "right-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-150 h-10 item2"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-100 h-10 item3"
    }))), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "article-text"
    }, introDescription || '[Missing Intro]')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "linkedin-media-container"
    }, directionalArrows(), /*#__PURE__*/_react["default"].createElement("div", {
      className: "carousel-container",
      style: {
        left: left
      }
    }, /*#__PURE__*/_react["default"].createElement(_LinkedInCarouselCards["default"], socialValues))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "action-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-2"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-3"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "action",
      key: "action-4"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-18 h-18"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-50 h-10"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "reactions"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "react"
    }, "Be the first to react")))));
  }
  LinkedInCarousel.displayName = "LinkedInCarousel";
  LinkedInCarousel.defaultProps = {
    socialValues: {
      introDescription: "",
      landingPage: "",
      cards: []
    }
  };
  LinkedInCarousel.propTypes = {
    socialValues: _propTypes["default"].shape({
      introDescription: _propTypes["default"].string.isRequired,
      landingPage: _propTypes["default"].string.isRequired,
      cards: _propTypes["default"].array.isRequired
    })
  };

  /***/
}, /* 472 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = PinterestCarousel;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = __webpack_require__(0);
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _PinterestCarouselCards = _interopRequireDefault(__webpack_require__(512));
  var _useCarousel2 = _interopRequireDefault(__webpack_require__(176));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function PinterestCarousel(props) {
    var socialValues = props.socialValues,
      cards = socialValues.cards;
    var cardIncrement = 236;
    var _useCarousel = (0, _useCarousel2["default"])(cards, cardIncrement),
      nextCard = _useCarousel.nextCard,
      prevCard = _useCarousel.prevCard,
      selectCard = _useCarousel.selectCard,
      left = _useCarousel.left,
      currentCard = _useCarousel.currentCard;
    var numericPaginator = "".concat(currentCard + 1, "/").concat(cards.length);
    function paginator() {
      var numOfCards = cards === null || cards === void 0 ? void 0 : cards.map(function (card) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          onClick: function onClick() {
            return selectCard(card);
          },
          key: card.order,
          className: "card-indicator ".concat(card.order === currentCard ? "active" : "")
        });
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "paginator"
      }, numOfCards);
    }
    return /*#__PURE__*/_react["default"].createElement("article", {
      className: "pinterest-preview carousel"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "numeric-paginator"
    }, numericPaginator), /*#__PURE__*/_react["default"].createElement("div", {
      className: "card-container",
      style: {
        left: left
      }
    }, /*#__PURE__*/_react["default"].createElement(_PinterestCarouselCards["default"], {
      cards: cards
    })), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      onClick: function onClick() {
        return nextCard();
      },
      className: "direction-btn next ".concat(currentCard === cards.length - 1 ? "hidden" : ""),
      name: "far fa-chevron-right"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      onClick: function onClick() {
        return prevCard();
      },
      className: "direction-btn prev ".concat(currentCard === 0 ? "hidden" : ""),
      name: "far fa-chevron-left"
    }), paginator(), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "shape-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-32 h-32"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "shape-grid"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-130 h-10"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle w-100 h-10"
    })), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h"
    })))));
  }
  PinterestCarousel.displayName = "PinterestCarousel";
  PinterestCarousel.propTypes = {
    socialValues: _propTypes.PropTypes.object
  };
  PinterestCarousel.defaultProps = {
    socialValues: {}
  };

  /***/
}, /* 473 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var _iterator = __webpack_require__(560);
  var _iterator2 = _interopRequireDefault(_iterator);
  var _symbol = __webpack_require__(570);
  var _symbol2 = _interopRequireDefault(_symbol);
  var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
  };
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
  };

  /***/
}, /* 474 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  var _getPrototypeOf = __webpack_require__(587);
  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
  var _getOwnPropertyDescriptor = __webpack_require__(590);
  var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.default = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
    if (desc === undefined) {
      var parent = (0, _getPrototypeOf2.default)(object);
      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;
      if (getter === undefined) {
        return undefined;
      }
      return getter.call(receiver);
    }
  };

  /***/
}, /* 475 */
/***/function (module, exports, __webpack_require__) {
  // optional / simple context binding
  var aFunction = __webpack_require__(554);
  module.exports = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined) return fn;
    switch (length) {
      case 1:
        return function (a) {
          return fn.call(that, a);
        };
      case 2:
        return function (a, b) {
          return fn.call(that, a, b);
        };
      case 3:
        return function (a, b, c) {
          return fn.call(that, a, b, c);
        };
    }
    return function /* ...args */
    () {
      return fn.apply(that, arguments);
    };
  };

  /***/
}, /* 476 */
/***/function (module, exports, __webpack_require__) {
  // 7.1.1 ToPrimitive(input [, PreferredType])
  var isObject = __webpack_require__(429);
  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  module.exports = function (it, S) {
    if (!isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };

  /***/
}, /* 477 */
/***/function (module, exports) {
  var toString = {}.toString;
  module.exports = function (it) {
    return toString.call(it).slice(8, -1);
  };

  /***/
}, /* 478 */
/***/function (module, exports) {
  // 7.2.1 RequireObjectCoercible(argument)
  module.exports = function (it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
  };

  /***/
}, /* 479 */
/***/function (module, exports) {
  // 7.1.4 ToInteger
  var ceil = Math.ceil;
  var floor = Math.floor;
  module.exports = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };

  /***/
}, /* 480 */
/***/function (module, exports, __webpack_require__) {
  var shared = __webpack_require__(481)('keys');
  var uid = __webpack_require__(465);
  module.exports = function (key) {
    return shared[key] || (shared[key] = uid(key));
  };

  /***/
}, /* 481 */
/***/function (module, exports, __webpack_require__) {
  var core = __webpack_require__(238);
  var global = __webpack_require__(394);
  var SHARED = '__core-js_shared__';
  var store = global[SHARED] || (global[SHARED] = {});
  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: core.version,
    mode: __webpack_require__(464) ? 'pure' : 'global',
    copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
  });

  /***/
}, /* 482 */
/***/function (module, exports) {
  // IE 8- don't enum bug keys
  module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

  /***/
}, /* 483 */
/***/function (module, exports) {
  exports.f = Object.getOwnPropertySymbols;

  /***/
}, /* 484 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  var anObject = __webpack_require__(428);
  var dPs = __webpack_require__(564);
  var enumBugKeys = __webpack_require__(482);
  var IE_PROTO = __webpack_require__(480)('IE_PROTO');
  var Empty = function () {/* empty */};
  var PROTOTYPE = 'prototype';

  // Create object with fake `null` prototype: use iframe Object with cleared prototype
  var createDict = function () {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = __webpack_require__(519)('iframe');
    var i = enumBugKeys.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    __webpack_require__(565).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
    return createDict();
  };
  module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
      Empty[PROTOTYPE] = anObject(O);
      result = new Empty();
      Empty[PROTOTYPE] = null;
      // add "__proto__" for Object.getPrototypeOf polyfill
      result[IE_PROTO] = O;
    } else result = createDict();
    return Properties === undefined ? result : dPs(result, Properties);
  };

  /***/
}, /* 485 */
/***/function (module, exports, __webpack_require__) {
  var def = __webpack_require__(395).f;
  var has = __webpack_require__(412);
  var TAG = __webpack_require__(249)('toStringTag');
  module.exports = function (it, tag, stat) {
    if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
      configurable: true,
      value: tag
    });
  };

  /***/
}, /* 486 */
/***/function (module, exports, __webpack_require__) {
  exports.f = __webpack_require__(249);

  /***/
}, /* 487 */
/***/function (module, exports, __webpack_require__) {
  var global = __webpack_require__(394);
  var core = __webpack_require__(238);
  var LIBRARY = __webpack_require__(464);
  var wksExt = __webpack_require__(486);
  var defineProperty = __webpack_require__(395).f;
  module.exports = function (name) {
    var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
      value: wksExt.f(name)
    });
  };

  /***/
}, /* 488 */
/***/function (module, exports, __webpack_require__) {
  var pIE = __webpack_require__(466);
  var createDesc = __webpack_require__(457);
  var toIObject = __webpack_require__(413);
  var toPrimitive = __webpack_require__(476);
  var has = __webpack_require__(412);
  var IE8_DOM_DEFINE = __webpack_require__(518);
  var gOPD = Object.getOwnPropertyDescriptor;
  exports.f = __webpack_require__(396) ? gOPD : function getOwnPropertyDescriptor(O, P) {
    O = toIObject(O);
    P = toPrimitive(P, true);
    if (IE8_DOM_DEFINE) try {
      return gOPD(O, P);
    } catch (e) {/* empty */}
    if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
  };

  /***/
}, /* 489 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = _default;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _reactAriaModal = _interopRequireDefault(__webpack_require__(212));
  var _Button = _interopRequireDefault(__webpack_require__(61));
  var _ModalHeader = _interopRequireDefault(__webpack_require__(141));
  var _ModalFooter = _interopRequireDefault(__webpack_require__(142));
  var FILTERS = _interopRequireWildcard(__webpack_require__(605));
  var _functions = __webpack_require__(33);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var COL_HEIGHT = 25,
    FILTER_MODAL_WIDTH = 475,
    RIGHT_PADDING = 25;
  var modalId = 0;
  function _default(Composed) {
    var _class, _class2;
    return _class = (_class2 = /*#__PURE__*/function (_Component) {
      _inherits(FilterModalLauncher, _Component);
      var _super = _createSuper(FilterModalLauncher);
      function FilterModalLauncher(props) {
        var _this;
        _classCallCheck(this, FilterModalLauncher);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "state", {
          isFilterOpen: false,
          canApply: false,
          canClear: false,
          values: null,
          currentLevel: null,
          styles: {}
        });
        modalId += 1;
        _this.modalId = "filter-modal-".concat(modalId);
        return _this;
      }
      _createClass(FilterModalLauncher, [{
        key: "openFilter",
        value: function openFilter(e) {
          var props = this.props,
            windowWidth = window.innerWidth,
            cellHeader = (0, _functions.findParent)(e.currentTarget, ".react-grid-HeaderCell"),
            bbox = e.currentTarget.getBoundingClientRect(),
            styles = {
              position: "absolute",
              top: bbox.top + props.colHeight
            },
            values = props.filterOptions.selected ? props.filterOptions.selected : null;
          e.preventDefault();
          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
          if (cellHeader) {
            bbox = cellHeader.getBoundingClientRect();
            styles.top = bbox.top + props.colHeight;
            if (bbox.left + props.filterModalWidth > windowWidth - props.rightPadding) {
              styles.right = windowWidth - bbox.right;
            } else {
              styles.left = bbox.left;
            }
          } else {
            styles.top = bbox.bottom;
            if (bbox.left + props.filterModalWidth < windowWidth - props.rightPadding) {
              styles.left = bbox.left;
            } else {
              styles.right = windowWidth - bbox.right;
            }
          }
          this.setState({
            styles: styles,
            values: values,
            isFilterOpen: true,
            canApply: false,
            canClear: !!values
          });
        }
      }, {
        key: "closeFilter",
        value: function closeFilter(e) {
          this.setState({
            isFilterOpen: false,
            canApply: false
          });
        }
      }, {
        key: "applyFilters",
        value: function applyFilters() {
          var props = this.props,
            state = this.state,
            closeFilter = this.closeFilter,
            currentLevel = state.currentLevel,
            values = state.values;
          if (currentLevel && currentLevel.value) {
            currentLevel = currentLevel.value;
          } else {
            var _props$filterOptions$ = _slicedToArray(props.filterOptions.filterLevel, 1);
            currentLevel = _props$filterOptions$[0];
          }
          closeFilter();
          props.onChange({
            values: values,
            currentLevel: currentLevel,
            columnKey: props.column,
            type: props.filterType
          });
        }
      }, {
        key: "clearFilters",
        value: function clearFilters() {
          var props = this.props,
            setState = this.setState,
            filterOptions = props.filterOptions,
            filterType = props.filterType,
            values;
          switch (filterType) {
            case "Range":
              values = filterOptions.items;
              break;
            case "String":
              values = "";
              break;
            case "Checkbox":
              values = [];
              break;
            case "Date":
              values = {
                startDate: null,
                endDate: null
              };
              break;
          }
          setState({
            values: values,
            canApply: true,
            canClear: false
          });
        }
      }, {
        key: "buildFilterProps",
        value: function buildFilterProps() {
          var _filterProps$marks,
            _this2 = this;
          var props = this.props,
            state = this.state,
            onFilterChange = this.onFilterChange,
            values = state.values,
            filterProps = {
              onChange: onFilterChange
            };
          switch (props.filterType) {
            case "Range":
              filterProps.defaultValue = [props.filterOptions.items.min, props.filterOptions.items.max];
              filterProps.value = values;
              filterProps.min = props.filterOptions.items.min;
              filterProps.max = props.filterOptions.items.max;
              filterProps.marks = (_filterProps$marks = {}, _defineProperty(_filterProps$marks, filterProps.min, filterProps.min), _defineProperty(_filterProps$marks, filterProps.max, filterProps.max), _filterProps$marks);
              if (!filterProps.value) {
                var val = [filterProps.min, filterProps.max];
                filterProps.value = val;
                filterProps.defaultValue = val;
              }
              break;
            case "String":
              filterProps.value = values ? values : "";
              break;
            case "Checkbox":
              filterProps.value = values ? values : [];
              filterProps.onChange = function (name, vals) {
                _this2.onFilterChange(vals);
              };
              break;
            case "Date":
              filterProps.value = values;
              break;
          }
          return filterProps;
        }
      }, {
        key: "onFilterChange",
        value: function onFilterChange(values) {
          this.setState({
            values: values,
            canApply: true,
            canClear: true
          });
        }
      }, {
        key: "_renderModal",
        value: function _renderModal() {
          if (!this.state.isFilterOpen) {
            return null;
          }
          var FilterType = function FilterType() {
              return null;
            },
            props = this.props,
            state = this.state,
            modalId = this.modalId,
            buildFilterProps = this.buildFilterProps,
            closeFilter = this.closeFilter,
            applyFilters = this.applyFilters,
            fProps = buildFilterProps(),
            filterProps = _objectSpread(_objectSpread(_objectSpread({}, props.filterOptions), fProps), {}, {
              userLocale: props.userLocale
            }),
            exit = function exit() {
              closeFilter();
            },
            shouldPauseFocusTrap = props.shouldPauseFocusTrap,
            title = props.title || "".concat(props.name, " Column Filtering");
          try {
            FilterType = FILTERS["".concat(props.filterType, "Filter")];
          } catch (error) {
            console.error("Invalid Filter Type", error);
          }
          return /*#__PURE__*/_react["default"].createElement(_reactAriaModal["default"], {
            dialogClass: "c-modal u-modal-responsive filter-modal ".concat(props.filterType.toLowerCase(), "-filter-modal ").concat(props.className),
            dialogStyle: state.styles,
            verticallyCenter: false,
            onEnter: _functions.noop,
            onExit: exit,
            titleText: title,
            underlayClickExits: true,
            underlayColor: false,
            dialogId: modalId,
            focusTrapPaused: shouldPauseFocusTrap
          }, /*#__PURE__*/_react["default"].createElement(_ModalHeader["default"], {
            title: title,
            allowFullScreen: false,
            onClose: exit,
            xClose: true
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: "c-modal__content c-modal__content--footer u-margin-around--small"
          }, /*#__PURE__*/_react["default"].createElement(FilterType, filterProps)), /*#__PURE__*/_react["default"].createElement(_ModalFooter["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
            theme: "default",
            size: "small",
            style: null,
            onClick: closeFilter
          }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
            theme: "green",
            size: "small",
            style: null,
            onClick: applyFilters,
            disabled: !state.canApply
          }, props.applyLabel)));
        }
      }, {
        key: "render",
        value: function render() {
          var _this3 = this;
          var enabledFilter = this.props.isFiltered ? "filter-enabled" : "";
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "".concat(enabledFilter, " filter-container"),
            onClick: function onClick(e) {
              return e.stopPropagation();
            }
          }, /*#__PURE__*/_react["default"].createElement("span", {
            onClick: this.openFilter
          }, /*#__PURE__*/_react["default"].createElement(Composed, _extends({
            ref: function ref(cmp) {
              return _this3.composedComponent = cmp;
            },
            isFiltered: this.props.isFiltered
          }, this.props))), this._renderModal());
        }
      }]);
      return FilterModalLauncher;
    }(_react.Component), _defineProperty(_class2, "propTypes", {
      filterType: _propTypes["default"].oneOf(["String", "Range", "Date", "Checkbox"]),
      onChange: _propTypes["default"].func.isRequired
    }), _defineProperty(_class2, "defaultProps", {
      applyLabel: "Apply",
      filterType: "String",
      isEnabled: false,
      shouldPauseFocusTrap: false,
      colHeight: COL_HEIGHT,
      filterModalWidth: FILTER_MODAL_WIDTH,
      rightPadding: RIGHT_PADDING,
      title: "Column Filtering"
    }), _class2), (_applyDecoratedDescriptor(_class.prototype, "openFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "openFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "closeFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applyFilters", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "applyFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearFilters", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "clearFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "buildFilterProps", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "buildFilterProps"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onFilterChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onFilterChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderModal", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderModal"), _class.prototype)), _class; // end return class FilterModalLauncher
  } //end function(Composed)

  /***/
}, /* 490 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = Portal;
  var _reactDom = _interopRequireDefault(__webpack_require__(15));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  var rootID = "action-menu-portal";
  function Portal(_ref) {
    var children = _ref.children;
    var rootNode = document.getElementById(rootID);
    if (!rootNode) {
      var newNode = document.createElement("div");
      newNode.id = rootID;
      document.body.appendChild(newNode);
      rootNode = newNode;
    }
    return /*#__PURE__*/_reactDom["default"].createPortal(children, rootNode);
  }

  /***/
}, /* 491 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = Trigger;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _reactContextmenu = __webpack_require__(109);
  var _romeo = __webpack_require__(460);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function Trigger(_ref) {
    var iconName = _ref.iconName,
      id = _ref.id;
    return /*#__PURE__*/_react["default"].createElement(_reactContextmenu.ContextMenuTrigger, {
      id: id,
      holdToDisplay: 0
    }, /*#__PURE__*/_react["default"].createElement(_romeo.Icon, {
      name: iconName
    }));
  }

  /***/
}, /* 492 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = CreativeLabels;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _functions = __webpack_require__(33);
  var _LabelList = _interopRequireDefault(__webpack_require__(493));
  var _NewCard = _interopRequireDefault(__webpack_require__(245));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function CreativeLabels(props) {
    var labels = props.labels,
      labelValue = props.labelValue,
      allowRemove = props.allowRemove,
      group = props.group,
      header = props.header,
      isOpen = props.isOpen,
      onRemove = props.onRemove,
      theme = props.theme;
    if (!(labels !== null && labels !== void 0 && labels.length)) {
      return null;
    } //guard clause - if theres no shownTags we dont want to render anything

    return /*#__PURE__*/_react["default"].createElement(_NewCard["default"], {
      header: header,
      className: "creative-labels",
      isOpen: isOpen
    }, /*#__PURE__*/_react["default"].createElement(_LabelList["default"], {
      labels: labels,
      labelValue: labelValue,
      allowRemove: allowRemove,
      group: group,
      onRemove: onRemove,
      theme: theme
    }));
  }
  CreativeLabels.displayName = "CreativeLabels";
  CreativeLabels.defaultProps = {
    allowRemove: true,
    labels: [],
    labelValue: "name",
    header: "",
    theme: null,
    group: "",
    isOpen: true,
    onRemove: _functions.noop
  };
  CreativeLabels.propTypes = {
    /** Whether or not rendered <Tag> is removable (always true in this case) */
    allowRemove: _propTypes["default"].bool.isRequired,
    /** Text for each <Tag/> we want to render */
    labels: _propTypes["default"].array.isRequired,
    /** Header text of <CreativeLabels/> */
    header: _propTypes["default"].string,
    /** Color of <Tag/>(s) (pink, teal, purple, or grey) */
    theme: _propTypes["default"].string,
    /** <CreativeLabel/> group name (advertiser, vertical: {x}, GeneralContent, Design) */
    group: _propTypes["default"].string,
    /** Whether or not <CreativeLabels/> is initially open */
    isOpen: _propTypes["default"].bool,
    /** Function called when a <Tag/>'s remove icon is clicked */
    onRemove: _propTypes["default"].func.isRequired
  };

  /***/
}, /* 493 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.LabelTag = LabelTag;
  exports["default"] = LabelList;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _classnames2 = _interopRequireDefault(__webpack_require__(6));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _functions = __webpack_require__(33);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var labelColors = {
    Advertiser: "pink",
    Vertical: "teal",
    "General Content": "purple",
    Design: "grey"
  };
  function LabelList(props) {
    var group = props.group,
      allowRemove = props.allowRemove,
      onRemove = props.onRemove,
      labels = props.labels,
      theme = props.theme,
      labelValue = props.labelValue;
    var colorTheme = labelColors[group];
    if (/Vertical\:/i.test(group)) {
      colorTheme = labelColors.Vertical;
    }
    if (theme) {
      colorTheme = theme;
    }
    return labels === null || labels === void 0 ? void 0 : labels.map(function (value) {
      return /*#__PURE__*/_react["default"].createElement(LabelTag, {
        allowRemove: allowRemove,
        label: value[labelValue],
        id: value.id,
        key: value.id,
        onRemove: onRemove,
        theme: colorTheme
      });
    });
  }
  LabelList.displayName = "LabelList";
  LabelList.defaultProps = {
    labelValue: "name",
    labels: [],
    onRemove: _functions.noop,
    theme: null
  };
  function LabelTag(props) {
    var _classnames;
    var size = props.size,
      theme = props.theme,
      allowRemove = props.allowRemove,
      onRemove = props.onRemove,
      label = props.label,
      id = props.id,
      badgeCls = (0, _classnames2["default"])((_classnames = {
        "c-tag": true,
        "c-tag--removable": allowRemove,
        "c-badge": true,
        "flex-center": true
      }, _defineProperty(_classnames, "t-badge--".concat(theme), true), _defineProperty(_classnames, "c-badge--".concat(size), true), _classnames)),
      remove = null;
    if (allowRemove) {
      remove = /*#__PURE__*/_react["default"].createElement("span", {
        className: "c-tag-remove",
        "aria-hidden": true,
        title: "Remove",
        onClick: function onClick(event) {
          return onRemove({
            id: id
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "clearCircle"
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: badgeCls
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "c-tag-label",
      title: label
    }, label), remove);
  }
  LabelTag.displayName = "LabelTag";
  LabelTag.defaultProps = {
    size: "small"
  };

  /***/
}, /* 494 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.BLADE_REDUX = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _reactAriaModal = _interopRequireDefault(__webpack_require__(212));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _ModalHeader = _interopRequireDefault(__webpack_require__(141));
  var _ModalFooter = _interopRequireDefault(__webpack_require__(142));
  var _functions = __webpack_require__(33);
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var Blade = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    _inherits(Blade, _React$Component);
    var _super = _createSuper(Blade);
    function Blade() {
      _classCallCheck(this, Blade);
      return _super.apply(this, arguments);
    }
    _createClass(Blade, [{
      key: "onCancel",
      value: function onCancel() {
        var _this$props = this.props,
          onCancel = _this$props.onCancel,
          closeModal = _this$props.closeModal,
          onClose = _this$props.onClose;
        if (onCancel) {
          onCancel();
        }
        closeModal();
        if (onClose) {
          onClose();
        }
      }
    }, {
      key: "_renderContent",
      value: function _renderContent() {
        var props = this.props,
          classes = {
            "c-modal__content": true,
            "c-modal__content--footer": props.renderFooter
          };
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])(classes)
        }, props.renderContent());
      }
    }, {
      key: "_renderFooter",
      value: function _renderFooter() {
        var props = this.props;
        if (!props.renderFooter) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement(_ModalFooter["default"], null, props.renderFooter());
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
          headerProps = _objectSpread({
            title: props.title,
            allowFullScreen: props.allowFullScreen,
            isFullScreen: props.isFullScreen,
            onToggleFullScreen: props.onToggleFullScreen,
            xClose: props.xClose,
            onClose: this.onCancel
          }, props.headerProps),
          classes = ["c-modal", "u-modal-responsive", props.className],
          extraClasses = {
            "blade-modal": props.type === "blade",
            "is-loading": props.isLoading,
            "full-screen": props.isFullScreen
          };
        return /*#__PURE__*/_react["default"].createElement(_reactAriaModal["default"], _extends({
          dialogClass: (0, _classnames["default"])(classes, extraClasses),
          onExit: props.onClose,
          titleText: props.title,
          underlayClickExits: false
        }, props.bladeProps), /*#__PURE__*/_react["default"].createElement(_ModalHeader["default"], headerProps), this._renderContent(), this._renderFooter());
      }
    }]);
    return Blade;
  }(_react["default"].Component), _defineProperty(_class2, "defaultProps", {
    type: "blade",
    title: "",
    className: "",
    allowFullScreen: true,
    xClose: true,
    renderFooter: null,
    renderContent: _functions.noop,
    onClose: _functions.noop,
    bladeProps: {},
    closeModal: _functions.noop,
    setAppTitle: true,
    headerProps: {}
  }), _defineProperty(_class2, "propTypes", {
    type: _propTypes["default"].oneOf(["blade", "modal"]),
    title: _propTypes["default"].string.isRequired,
    bladeProps: _propTypes["default"].object,
    allowFullScreen: _propTypes["default"].bool.isRequired,
    xClose: _propTypes["default"].bool,
    onClose: _propTypes["default"].func.isRequired,
    onCancel: _propTypes["default"].func,
    onToggleFullScreen: _propTypes["default"].func,
    renderContent: _propTypes["default"].func.isRequired,
    renderFooter: _propTypes["default"].func,
    headerProps: _propTypes["default"].object
  }), _class2), (_applyDecoratedDescriptor(_class.prototype, "onCancel", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onCancel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderContent", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderContent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_renderFooter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderFooter"), _class.prototype)), _class);
  exports["default"] = Blade;
  var BLADE_ACTIONS = {
    TOGGLE_FULLSCREEN: "TOGGLE_FULLSCREEN"
  };
  function toggleFullScreen(modal) {
    return function (dispatch, getState) {
      var currentState = getState().modalSettings[modal];
      return dispatch({
        type: BLADE_ACTIONS.TOGGLE_FULL_SCREEN,
        payload: {
          modal: modal,
          isFullScreen: !currentState.isFullScreen
        }
      });
    };
  }
  function setIsFullScreen(state, action) {
    var _action$payload = action.payload,
      modal = _action$payload.modal,
      isFullScreen = _action$payload.isFullScreen;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, modal, _objectSpread(_objectSpread({}, state[modal]), {}, {
      isFullScreen: isFullScreen
    })));
  }
  var HANDLERS = _defineProperty({}, BLADE_ACTIONS.TOGGLE_FULL_SCREEN, setIsFullScreen);
  var BLADE_REDUX = {
    BLADE_ACTIONS: BLADE_ACTIONS,
    toggleFullScreen: toggleFullScreen,
    setIsFullScreen: setIsFullScreen,
    HANDLERS: HANDLERS
  };
  exports.BLADE_REDUX = BLADE_REDUX;

  /***/
}, /* 495 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = SocialPreview;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _constants = __webpack_require__(59);
  var _socialHelpers = __webpack_require__(46);
  var _FacebookImage = _interopRequireDefault(__webpack_require__(433));
  var _FacebookVideo = _interopRequireDefault(__webpack_require__(434));
  var _FacebookCarousel = _interopRequireDefault(__webpack_require__(468));
  var _GoogleDiscovery = _interopRequireDefault(__webpack_require__(469));
  var _GoogleDiscoveryCarousel = _interopRequireDefault(__webpack_require__(470));
  var _GoogleDemandGenVideo = _interopRequireDefault(__webpack_require__(510));
  var _LinkedInImage = _interopRequireDefault(__webpack_require__(435));
  var _LinkedInVideo = _interopRequireDefault(__webpack_require__(436));
  var _LinkedInCarousel = _interopRequireDefault(__webpack_require__(471));
  var _PinterestImage = _interopRequireDefault(__webpack_require__(437));
  var _PinterestVideo = _interopRequireDefault(__webpack_require__(438));
  var _PinterestCarousel = _interopRequireDefault(__webpack_require__(472));
  var _SnapchatImage = _interopRequireDefault(__webpack_require__(439));
  var _SnapchatVideo = _interopRequireDefault(__webpack_require__(440));
  var _TikTokVideo = _interopRequireDefault(__webpack_require__(462));
  var _TwitterImage = _interopRequireDefault(__webpack_require__(441));
  var _TwitterVideo = _interopRequireDefault(__webpack_require__(442));
  var _YouTubeDiscovery = _interopRequireDefault(__webpack_require__(443));
  var _YouTubeInStream = _interopRequireDefault(__webpack_require__(444));
  var _PreviewError = _interopRequireDefault(__webpack_require__(445));
  var _socialHelpers2 = __webpack_require__(46);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function SocialPreview(props) {
    var adType = props.adType,
      socialValues = props.socialValues,
      baseDomain = props.baseDomain,
      placementType = props.placementType;
    var updatedProps = Object.assign({}, props, {
      socialValues: (0, _socialHelpers.buildFullyQualifiedUrls)(socialValues, baseDomain),
      placementInfo: (0, _socialHelpers.buildFullyQualifiedUrls)((0, _socialHelpers2.getPlacementInfo)(socialValues.placements, placementType), baseDomain)
    });
    switch (adType) {
      case _constants.SOCIAL_AD_TYPES.FACEBOOK_IMAGE:
      case _constants.SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO:
        return /*#__PURE__*/_react["default"].createElement(_FacebookImage["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.FACEBOOK_VIDEO:
      case _constants.SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO:
        return /*#__PURE__*/_react["default"].createElement(_FacebookVideo["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL:
      case _constants.SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO:
        return /*#__PURE__*/_react["default"].createElement(_FacebookCarousel["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_IMAGE:
        return /*#__PURE__*/_react["default"].createElement(_GoogleDiscovery["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_CAROUSEL:
        return /*#__PURE__*/_react["default"].createElement(_GoogleDiscoveryCarousel["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_VIDEO:
        return /*#__PURE__*/_react["default"].createElement(_GoogleDemandGenVideo["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.LINKEDIN_IMAGE:
        return /*#__PURE__*/_react["default"].createElement(_LinkedInImage["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.LINKEDIN_VIDEO:
        return /*#__PURE__*/_react["default"].createElement(_LinkedInVideo["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL:
        return /*#__PURE__*/_react["default"].createElement(_LinkedInCarousel["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.PINTEREST_IMAGE:
        return /*#__PURE__*/_react["default"].createElement(_PinterestImage["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.PINTEREST_VIDEO:
      case _constants.SOCIAL_AD_TYPES.PINTEREST_MAX_W_VIDEO:
        return /*#__PURE__*/_react["default"].createElement(_PinterestVideo["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.PINTEREST_CAROUSEL:
        return /*#__PURE__*/_react["default"].createElement(_PinterestCarousel["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.SNAPCHAT_IMAGE:
        return /*#__PURE__*/_react["default"].createElement(_SnapchatImage["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.SNAPCHAT_VIDEO:
        return /*#__PURE__*/_react["default"].createElement(_SnapchatVideo["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.TIKTOK_VIDEO:
        return /*#__PURE__*/_react["default"].createElement(_TikTokVideo["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.TWITTER_IMAGE:
        return /*#__PURE__*/_react["default"].createElement(_TwitterImage["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.TWITTER_VIDEO:
        return /*#__PURE__*/_react["default"].createElement(_TwitterVideo["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.YOUTUBE_DISCOVERY:
        return /*#__PURE__*/_react["default"].createElement(_YouTubeDiscovery["default"], updatedProps);
      case _constants.SOCIAL_AD_TYPES.YOUTUBE_INSTREAM:
        return /*#__PURE__*/_react["default"].createElement(_YouTubeInStream["default"], updatedProps);
      default:
        if (!adType) {
          return /*#__PURE__*/_react["default"].createElement(_PreviewError["default"], {
            message: "Ad type is missing"
          });
        }
        return /*#__PURE__*/_react["default"].createElement(_PreviewError["default"], {
          message: "Oops, \"".concat(adType, "\" is not a supported social ad type")
        });
    }
  }
  SocialPreview.displayName = "SocialPreview";
  SocialPreview.defaultProps = {
    socialValues: {},
    controls: true
  };
  SocialPreview.propTypes = {
    socialValues: _propTypes["default"].object,
    adType: _propTypes["default"].string,
    baseDomain: _propTypes["default"].string
  };

  /***/
}, /* 496 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FacebookCarouselCards;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = __webpack_require__(0);
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _FBCarouselMedia = _interopRequireDefault(__webpack_require__(497));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function FacebookCarouselCards(props) {
    var cards = props.cards,
      cta = props.cta,
      adType = props.adType,
      noCards = props.noCards;
    if (noCards) {
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Please add at least 2 carousel cards"
      });
    }
    var ctaButton = cta ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "cta-label"
    }, /*#__PURE__*/_react["default"].createElement("span", null, cta === null || cta === void 0 ? void 0 : cta.name)) : null;
    return cards.map(function (card) {
      var id = card.id,
        headline = card.headline,
        description = card.description;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: id,
        className: "facebook-carousel-card"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hero-media"
      }, /*#__PURE__*/_react["default"].createElement(_FBCarouselMedia["default"], _extends({}, card, {
        adType: adType
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "lower-grey-box"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "grey-text"
      }, headline ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "grey-text-2"
      }, headline) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "headline-skeleton"
      }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
        className: "grey-text-3"
      }, description)), ctaButton));
    });
  }
  FacebookCarouselCards.displayName = "FacebookCarouselCards";
  FacebookCarouselCards.propTypes = {
    noCards: _propTypes.PropTypes.bool
  };
  FacebookCarouselCards.defaultProps = {
    noCards: true
  };

  /***/
}, /* 497 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = CarouselMedia;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _ScaledImage = _interopRequireDefault(__webpack_require__(174));
  var _ScaledVideo = _interopRequireDefault(__webpack_require__(175));
  var _constants = __webpack_require__(59);
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function CarouselMedia(props) {
    var type = props.type,
      adType = props.adType;
    if (adType !== _constants.SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL && adType !== _constants.SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO) {
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing adtype"
      });
    }
    switch (type) {
      case "image":
        return /*#__PURE__*/_react["default"].createElement(ImageContent, props);
      case "video":
        return /*#__PURE__*/_react["default"].createElement(VideoContent, props);
    }
  }
  function ImageContent(props) {
    var image = props.image;
    if (!image) {
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Image Asset"
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_ScaledImage["default"], props);
  }
  function VideoContent(props) {
    if (!props.video) {
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Video Asset"
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_ScaledVideo["default"], props);
  }

  /***/
}, /* 498 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FacebookReelsCarousel;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _useCarousel2 = _interopRequireDefault(__webpack_require__(176));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _ChangeCard = _interopRequireDefault(__webpack_require__(417));
  var _socialHelpers = __webpack_require__(46);
  var _FacebookReelsCards = _interopRequireDefault(__webpack_require__(499));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function FacebookReelsCarousel(props) {
    var socialValues = props.socialValues;
    var primaryText = socialValues.primaryText,
      cards = socialValues.cards;
    var imageCards = cards.filter(function (card) {
      return card.type === "image";
    });
    var _useCarousel = (0, _useCarousel2["default"])(imageCards, _socialHelpers.CAROUSEL_CARD_INCREMENT),
      nextCard = _useCarousel.nextCard,
      prevCard = _useCarousel.prevCard,
      currentCard = _useCarousel.currentCard,
      left = _useCarousel.left;
    var cardSelectorProps = {
      cards: imageCards,
      currentCard: currentCard,
      prevCard: prevCard,
      nextCard: nextCard
    };
    var cardProps = _objectSpread(_objectSpread({}, socialValues), {}, {
      cards: imageCards
    });
    function RenderContent() {
      if (cards.length >= _socialHelpers.MIN_CAROUSEL_CARDS_LENGTH) {
        return /*#__PURE__*/_react["default"].createElement(_FacebookReelsCards["default"], cardProps);
      }
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Please add at least 2 cards"
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 reels square reel carousel"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "vertical-icon-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    })), /*#__PURE__*/_react["default"].createElement(_ChangeCard["default"], cardSelectorProps), /*#__PURE__*/_react["default"].createElement("div", {
      className: "carousel-container",
      style: {
        left: left
      }
    }, RenderContent()), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "footer-placeholder-shapes"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "primary-text"
    }, primaryText || "[Missing Primary Text]")));
  }
  FacebookReelsCarousel.displayName = "FacebookReelsCarousel";
  FacebookReelsCarousel.defaultProps = {
    socialValues: {
      cards: [],
      primaryText: ""
    }
  };
  FacebookReelsCarousel.propTypes = {
    socialValues: _propTypes["default"].object
  };

  /***/
}, /* 499 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FacebookReelsCards;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _RenderMedia = _interopRequireDefault(__webpack_require__(391));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function FacebookReelsCards(props) {
    var cards = props.cards,
      cta = props.cta;
    var $cta = null;
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta"
      }, cta.name));
    }
    return cards.map(function (card) {
      var id = card.id;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: id,
        className: "carousel-card reels"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "media square"
      }, (0, _RenderMedia["default"])(card)), $cta);
    });
  }

  /***/
}, /* 500 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramFeedsCarousel;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _InstagramFeedsCards = _interopRequireDefault(__webpack_require__(501));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _ChangeCard = _interopRequireDefault(__webpack_require__(417));
  var _useCarousel2 = _interopRequireDefault(__webpack_require__(176));
  var _socialHelpers = __webpack_require__(46);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function InstagramFeedsCarousel(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      controls = props.controls,
      muted = props.muted;
    var primaryText = socialValues.primaryText,
      cards = socialValues.cards,
      cta = socialValues.cta;
    var _useCarousel = (0, _useCarousel2["default"])(cards, _socialHelpers.CAROUSEL_CARD_INCREMENT),
      nextCard = _useCarousel.nextCard,
      prevCard = _useCarousel.prevCard,
      currentCard = _useCarousel.currentCard,
      left = _useCarousel.left,
      selectCard = _useCarousel.selectCard;
    function paginator() {
      var numOfCards = cards === null || cards === void 0 ? void 0 : cards.map(function (card) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          onClick: function onClick() {
            return selectCard(card);
          },
          key: card.order,
          className: "card-indicator ".concat(card.order === currentCard ? "active" : "")
        });
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "paginator"
      }, numOfCards);
    }
    var $cta = /*#__PURE__*/_react["default"].createElement("div", {
      className: "missing-cta"
    });
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "cta-name"
      }, cta.name), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-right",
        className: "chevron-right cta"
      }));
    }
    function RenderContent() {
      if (cards.length >= _socialHelpers.MIN_CAROUSEL_CARDS_LENGTH) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramFeedsCards["default"], _extends({}, socialValues, {
          videoProps: {
            muted: muted,
            controls: controls,
            autoPlay: autoPlay
          }
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Please add at least 2 carousel cards"
      });
    }
    var changeCardProps = {
      cards: cards,
      currentCard: currentCard,
      prevCard: prevCard,
      nextCard: nextCard
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 square feeds instagram carousel"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "top-bar"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }))), /*#__PURE__*/_react["default"].createElement(_ChangeCard["default"], changeCardProps), /*#__PURE__*/_react["default"].createElement("div", {
      className: "carousel-container",
      style: {
        left: left
      }
    }, RenderContent()), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, $cta, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval-container ".concat(cta ? "border" : "")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "left-side"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    })), paginator(), /*#__PURE__*/_react["default"].createElement("div", {
      className: "right-side"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }))), /*#__PURE__*/_react["default"].createElement("p", {
      className: "facebook-footer-text"
    }, primaryText || "[Missing Primary Text]")));
  }
  InstagramFeedsCarousel.displayName = "InstagramFeedsCarousel";
  InstagramFeedsCarousel.defaultProps = {
    socialValues: {
      cards: [],
      primaryText: ""
    }
  };
  InstagramFeedsCarousel.propTypes = {
    socialValues: _propTypes["default"].object
  };

  /***/
}, /* 501 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramFeedsCards;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _RenderMedia = _interopRequireDefault(__webpack_require__(391));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function InstagramFeedsCards(props) {
    var cards = props.cards,
      videoProps = props.videoProps;
    return cards.map(function (card) {
      var id = card.id;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: id,
        className: "carousel-card feeds instagram"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "media square"
      }, (0, _RenderMedia["default"])(card, videoProps)));
    });
  }

  /***/
}, /* 502 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FacebookFeedsCarousel;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _FacebookFeedsCards = _interopRequireDefault(__webpack_require__(503));
  var _useCarousel2 = _interopRequireDefault(__webpack_require__(176));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _socialHelpers = __webpack_require__(46);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function FacebookFeedsCarousel(props) {
    var socialValues = props.socialValues,
      muted = props.muted,
      autoPlay = props.autoPlay,
      controls = props.controls;
    var primaryText = socialValues.primaryText,
      cards = socialValues.cards,
      cta = socialValues.cta;
    var cardIncrement = 235;
    var _useCarousel = (0, _useCarousel2["default"])(cards, cardIncrement),
      nextCard = _useCarousel.nextCard,
      prevCard = _useCarousel.prevCard,
      currentCard = _useCarousel.currentCard,
      left = _useCarousel.left;
    var videoProps = {
      autoPlay: autoPlay,
      controls: controls,
      muted: muted
    };
    var cardProps = {
      cards: cards,
      nextCard: nextCard,
      prevCard: prevCard,
      currentCard: currentCard,
      videoProps: videoProps,
      cta: cta
    };
    function changeCard() {
      if (cards.length < _socialHelpers.MIN_CAROUSEL_CARDS_LENGTH) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "next-card ".concat(currentCard === cards.length - 1 ? "hidden" : ""),
        onClick: nextCard
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "prev-card ".concat(currentCard === 0 ? "hidden" : ""),
        onClick: prevCard
      }));
    }
    function RenderContent() {
      if (cards.length >= _socialHelpers.MIN_CAROUSEL_CARDS_LENGTH) {
        return /*#__PURE__*/_react["default"].createElement(_FacebookFeedsCards["default"], cardProps);
      }
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        className: "no-card",
        message: "Please add at least 2 carousel cards"
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 feeds vertical carousel"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "facebook-header-text"
    }, primaryText || "[Missing Primary Text]")), changeCard(), /*#__PURE__*/_react["default"].createElement("div", {
      className: "right-border"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "carousel-container",
      style: {
        left: left
      }
    }, RenderContent()), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-footer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "border-bottom"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "bottom-section"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "small-oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-50 facebook-placeholder"
    }))));
  }
  FacebookFeedsCarousel.displayName = "FacebookFeedsCarousel";
  FacebookFeedsCarousel.defaultProps = {
    socialValues: {
      cards: [],
      primaryText: ""
    }
  };
  _FacebookFeedsCards["default"].propTypes = {
    socialValues: _propTypes["default"].object
  };

  /***/
}, /* 503 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FacebookFeedsCards;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _RenderMedia = _interopRequireDefault(__webpack_require__(391));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function FacebookFeedsCards(props) {
    var cards = props.cards,
      videoProps = props.videoProps,
      cta = props.cta;
    var $cta = null;
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-container"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "cta"
      }, cta.name));
    }
    return cards.map(function (card) {
      var headline = card.headline,
        id = card.id,
        description = card.description;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: id,
        className: "carousel-card feeds"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "media square"
      }, (0, _RenderMedia["default"])(card, videoProps)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "lower-content"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "headline"
      }, headline), /*#__PURE__*/_react["default"].createElement("p", {
        className: "description"
      }, description), $cta));
    });
  }

  /***/
}, /* 504 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramStoriesCarousel;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _ChangeCard = _interopRequireDefault(__webpack_require__(417));
  var _useCarousel2 = _interopRequireDefault(__webpack_require__(176));
  var _socialHelpers = __webpack_require__(46);
  var _InstagramStoriesCards = _interopRequireDefault(__webpack_require__(505));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  // eslint-disable-next-line no-magic-numbers
  var ProgressBar = function ProgressBar(cards, currentCard) {
    return cards.map(function (card) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: "".concat(100 / cards.length, "%")
        },
        key: card.id,
        className: "progress-bar facebook-placeholder ".concat(currentCard === card.order ? "active" : "")
      });
    });
  };
  function InstagramStoriesCarousel(props) {
    var socialValues = props.socialValues,
      autoPlay = props.autoPlay,
      muted = props.muted,
      controls = props.controls;
    var cards = socialValues.cards,
      cta = socialValues.cta;
    var _useCarousel = (0, _useCarousel2["default"])(cards, _socialHelpers.CAROUSEL_CARD_INCREMENT),
      nextCard = _useCarousel.nextCard,
      prevCard = _useCarousel.prevCard,
      currentCard = _useCarousel.currentCard,
      left = _useCarousel.left;
    var changeCardProps = {
      cards: cards,
      currentCard: currentCard,
      prevCard: prevCard,
      nextCard: nextCard
    };
    var videoProps = {
      autoPlay: autoPlay,
      muted: muted,
      controls: controls
    };
    var $cta = null;
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-container"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-up",
        className: "chevron-up"
      }), ";", /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name)));
    }
    function RenderCards() {
      if (cards.length >= _socialHelpers.MIN_CAROUSEL_CARDS_LENGTH) {
        return /*#__PURE__*/_react["default"].createElement(_InstagramStoriesCards["default"], {
          cards: cards,
          videoProps: videoProps
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Please add at least 2 carousel cards"
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 story vertical instagram carousel"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress-bar-container"
    }, ProgressBar(cards, currentCard)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fal fa-times",
      className: "close"
    })), /*#__PURE__*/_react["default"].createElement(_ChangeCard["default"], changeCardProps), /*#__PURE__*/_react["default"].createElement("div", {
      className: "carousel-container",
      style: {
        left: left
      }
    }, RenderCards()), $cta);
  }
  InstagramStoriesCarousel.displayName = "InstagramStoriesCarousel";
  InstagramStoriesCarousel.defaultProps = {
    socialValues: {
      cards: []
    }
  };
  InstagramStoriesCarousel.propTypes = {
    socialValues: _propTypes["default"].object
  };

  /***/
}, /* 505 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = InstagramStoriesCards;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _RenderMedia = _interopRequireDefault(__webpack_require__(391));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function InstagramStoriesCards(props) {
    var cards = props.cards,
      videoProps = props.videoProps;
    return cards.map(function (card) {
      var id = card.id;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: id,
        className: "carousel-card story instagram"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "media square"
      }, (0, _RenderMedia["default"])(card, videoProps)));
    });
  }

  /***/
}, /* 506 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FacebookStoriesCarousel;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _FacebookStoriesCards = _interopRequireDefault(__webpack_require__(507));
  var _useCarousel2 = _interopRequireDefault(__webpack_require__(176));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _socialHelpers = __webpack_require__(46);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function FacebookStoriesCarousel(props) {
    var socialValues = props.socialValues;
    var cards = socialValues.cards;
    var _useCarousel = (0, _useCarousel2["default"])(cards, _socialHelpers.CAROUSEL_CARD_INCREMENT),
      nextCard = _useCarousel.nextCard,
      prevCard = _useCarousel.prevCard,
      currentCard = _useCarousel.currentCard,
      left = _useCarousel.left;
    var filteredCards = cards.filter(function (card) {
      return card.type === "image" && card.image;
    });

    //TODO- move to separate component?
    function changeCard() {
      if (!filteredCards.length) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-right",
        className: "chevron-right ".concat(currentCard === (filteredCards === null || filteredCards === void 0 ? void 0 : filteredCards.length) - 1 ? "hidden" : ""),
        onClick: nextCard
      }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-left",
        className: "chevron-left ".concat(currentCard === 0 ? "hidden" : ""),
        onClick: prevCard
      }));
    }
    function RenderCards() {
      if (filteredCards.length < _socialHelpers.MIN_CAROUSEL_CARDS_LENGTH) {
        return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
          message: "Please add at least 2 'image' type carousel cards"
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_FacebookStoriesCards["default"], {
        filteredCards: filteredCards,
        cta: socialValues === null || socialValues === void 0 ? void 0 : socialValues.cta
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-preview-v2 story vertical carousel"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress-bar facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "facebook-header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oval facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-150 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle-100 facebook-placeholder"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fa fa-ellipsis-h",
      className: "ellipsis"
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fal fa-times",
      className: "close"
    })), changeCard(), /*#__PURE__*/_react["default"].createElement("div", {
      className: "carousel-container",
      style: {
        left: left
      }
    }, RenderCards()));
  }
  FacebookStoriesCarousel.displayName = "FacebookStoriesCarousel";
  FacebookStoriesCarousel.defaultProps = {
    socialValues: {
      cards: []
    }
  };
  FacebookStoriesCarousel.propTypes = {
    socialValues: _propTypes["default"].object
  };

  /***/
}, /* 507 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = FacebookStoriesCards;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function FacebookStoriesCards(props) {
    var filteredCards = props.filteredCards,
      cta = props.cta;
    var $cta;
    if (cta !== null && cta !== void 0 && cta.name) {
      $cta = /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-container"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "fa fa-chevron-up",
        className: "chevron-up"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "cta-label title-case text-overflow-ellipse"
      }, /*#__PURE__*/_react["default"].createElement("span", null, cta.name)));
    }
    return filteredCards.map(function (card) {
      var image = card.image,
        id = card.id;
      var $image = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Image Asset"
      });
      if (image !== null && image !== void 0 && image.src) {
        $image = /*#__PURE__*/_react["default"].createElement("img", {
          src: image.src,
          alt: image.name
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "carousel-card",
        key: id
      }, $image, $cta);
    });
  }

  /***/
}, /* 508 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = YtMobileCarousel;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function YtMobileCarouselCards(props) {
    var cards = props.cards,
      placementType = props.placementType;

    // eslint-disable-next-line no-magic-numbers
    if ((cards === null || cards === void 0 ? void 0 : cards.length) < 2) {
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Please add at least 2 carousel cards"
      });
    }
    return cards === null || cards === void 0 ? void 0 : cards.map(function (card) {
      var images = card.images,
        headline = card.headline,
        landingPage = card.landingPage,
        id = card.id,
        cta = card.cta;
      var selectedImage = images.find(function (image) {
        return image.aspectRatio === placementType;
      });
      var media;
      if (!(selectedImage !== null && selectedImage !== void 0 && selectedImage.src)) {
        media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
          className: "google-disc yt-carousel-img",
          message: "Missing Image"
        });
      } else {
        media = /*#__PURE__*/_react["default"].createElement("img", {
          className: "google-disc yt-carousel-img",
          src: selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.src,
          alt: selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.name
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: id,
        className: "slide"
      }, media, /*#__PURE__*/_react["default"].createElement("div", {
        className: "landing-page"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: landingPage || ""
      }, cta === null || cta === void 0 ? void 0 : cta.name)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "headline"
      }, headline || "Missing Headline"));
    });
  }
  function YtMobileCarousel(props) {
    var socialValues = props.socialValues,
      placementType = props.placementType,
      logo = socialValues.logo,
      headline = socialValues.headline,
      description = socialValues.description,
      businessName = socialValues.businessName,
      cards = socialValues.cards;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "google-discovery-header"
    }, logo !== null && logo !== void 0 && logo.src ? /*#__PURE__*/_react["default"].createElement("img", {
      className: "circle logo w-44 h-44",
      src: logo.src,
      alt: logo === null || logo === void 0 ? void 0 : logo.name
    }) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-44 h-44"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangles"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle rectangle-150 w-150 h-10"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle rectangle-90 w-90 h-10"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "carousel-container"
    }, /*#__PURE__*/_react["default"].createElement(YtMobileCarouselCards, {
      cards: cards,
      placementType: placementType
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-content carousel"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "headline"
    }, headline || "Missing Headline"), /*#__PURE__*/_react["default"].createElement("p", {
      className: "description"
    }, description || "Missing Description"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "ad-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "ad"
    }, "Ad"), /*#__PURE__*/_react["default"].createElement("p", {
      className: "business-name"
    }, businessName || "Missing Business Name"))));
  }
  YtMobileCarousel.displayName = "YtMobileCarousel";
  YtMobileCarousel.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  YtMobileCarousel.propTypes = {
    socialValues: _propTypes["default"].shape({
      cards: _propTypes["default"].arrayOf(_propTypes["default"].object),
      logo: _propTypes["default"].object,
      headline: _propTypes["default"].string,
      description: _propTypes["default"].string,
      businessName: _propTypes["default"].string
    }),
    placementType: _propTypes["default"].string
  };

  /***/
}, /* 509 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = VerticalCarousel;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _useCarousel2 = _interopRequireDefault(__webpack_require__(176));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function VerticalCarouselContent(props) {
    var cards = props.cards,
      placementType = props.placementType;
    return cards.map(function (card) {
      var images = card.images,
        id = card.id;
      var selectedImage = images.find(function (image) {
        return image.aspectRatio === placementType;
      });
      var media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Missing Image"
      });
      if (selectedImage !== null && selectedImage !== void 0 && selectedImage.src) {
        media = /*#__PURE__*/_react["default"].createElement("img", {
          className: "google-disc vertical-carousel-img",
          src: selectedImage.src,
          alt: selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.name
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: id,
        className: "slide"
      }, media);
    });
  }
  function VerticalCarousel(props) {
    var socialValues = props.socialValues,
      placementType = props.placementType,
      logo = socialValues.logo,
      cards = socialValues.cards,
      headline = socialValues.headline,
      description = socialValues.description,
      businessName = socialValues.businessName,
      minCardsLength = 2,
      cardIncrement = 315; //includes margin

    var _useCarousel = (0, _useCarousel2["default"])(cards, cardIncrement),
      nextCard = _useCarousel.nextCard,
      prevCard = _useCarousel.prevCard,
      selectCard = _useCarousel.selectCard,
      left = _useCarousel.left,
      currentCard = _useCarousel.currentCard;

    //TODO extract to socialHelpers also used in linkedin
    function directionalArrows() {
      if ((cards === null || cards === void 0 ? void 0 : cards.length) < minCardsLength) {
        return;
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        onClick: function onClick() {
          return nextCard();
        },
        className: "direction-btn next ".concat(currentCard === cards.length - 1 ? "hidden" : ""),
        name: "far fa-chevron-right"
      }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        onClick: function onClick() {
          return prevCard();
        },
        className: "direction-btn prev ".concat(currentCard === 0 ? "hidden" : ""),
        name: "far fa-chevron-left"
      }));
    }
    function paginator(cards) {
      var numOfCards = cards === null || cards === void 0 ? void 0 : cards.map(function (card) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          onClick: function onClick() {
            return selectCard(card);
          },
          key: card.id,
          className: "card-indicator ".concat(card.order === currentCard ? "active" : "")
        });
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "paginator"
      }, numOfCards);
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, directionalArrows(), /*#__PURE__*/_react["default"].createElement("div", {
      className: "google-discovery-header"
    }, logo !== null && logo !== void 0 && logo.src ? /*#__PURE__*/_react["default"].createElement("img", {
      className: "circle logo",
      src: logo.src
    }) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-16 h-16"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangles"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "rectangle rectangle-150 w-150 h-10"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "google-disc media-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "carousel-container",
      style: {
        left: left
      }
    }, /*#__PURE__*/_react["default"].createElement(VerticalCarouselContent, {
      selectCard: selectCard,
      currentCard: currentCard,
      cards: cards,
      placementType: placementType
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "carousel lower-content"
    }, paginator(cards), /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-container"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "headline"
    }, headline || "Missing Headline"), "\xA0|\xA0", /*#__PURE__*/_react["default"].createElement("span", {
      className: "description"
    }, description || "Missing Description")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "ad"
    }, "Ad \u2022 ", /*#__PURE__*/_react["default"].createElement("span", {
      className: "business-name"
    }, businessName || "Missing Business Name"))))));
  }
  VerticalCarousel.displayName = "VerticalCarousel";
  VerticalCarousel.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  VerticalCarousel.propTypes = {
    socialValues: _propTypes["default"].shape({
      cards: _propTypes["default"].arrayOf(_propTypes["default"].object),
      logo: _propTypes["default"].object,
      headline: _propTypes["default"].string,
      description: _propTypes["default"].string,
      businessName: _propTypes["default"].string
    }),
    placementType: _propTypes["default"].string
  };

  /***/
}, /* 510 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = GoogleDemandGenVideo;
  exports.filteredVids = filteredVids;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  var _socialHelpers = __webpack_require__(46);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function filteredVids(videos, placementType) {
    var _videos$filter;
    return (videos === null || videos === void 0 ? void 0 : (_videos$filter = videos.filter) === null || _videos$filter === void 0 ? void 0 : _videos$filter.call(videos, function (vid) {
      return vid.aspectRatio === placementType;
    })) || [];
  }
  function GoogleDemandGenVideo(props) {
    var _values$video2, _values$video3, _values$longHeadline, _values$description;
    var socialValues = props.socialValues,
      placementType = props.placementType;
    var businessName = socialValues.businessName,
      longHeadlines = socialValues.longHeadlines,
      descriptions = socialValues.descriptions,
      logos = socialValues.logos,
      cta = socialValues.cta,
      videos = socialValues.videos;
    var selectedVids = (0, _react.useMemo)(function () {
      return filteredVids(videos, placementType);
    }, [videos, placementType]);
    var _useState = (0, _react.useState)({
        longHeadline: (0, _socialHelpers.getRandomArrayItem)(longHeadlines),
        description: (0, _socialHelpers.getRandomArrayItem)(descriptions),
        video: (0, _socialHelpers.getRandomArrayItem)(selectedVids)
      }),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];
    (0, _react.useEffect)(function () {
      var _values$video;
      if (((_values$video = values.video) === null || _values$video === void 0 ? void 0 : _values$video.aspectRatio) !== placementType) {
        setValues(_objectSpread(_objectSpread({}, values), {}, {
          video: (0, _socialHelpers.getRandomArrayItem)(selectedVids)
        }));
      }
    }, [placementType]);
    var $video = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
      message: "Missing Video",
      className: (_values$video2 = values.video) === null || _values$video2 === void 0 ? void 0 : _values$video2.aspectRatio
    });
    if ((_values$video3 = values.video) !== null && _values$video3 !== void 0 && _values$video3.src) {
      $video = /*#__PURE__*/_react["default"].createElement("video", {
        autoPlay: true
      }, /*#__PURE__*/_react["default"].createElement("source", {
        src: values.video.src,
        alt: values.video.src
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "google-discovery-preview video"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-container"
    }, $video), /*#__PURE__*/_react["default"].createElement("div", {
      className: "lower-content video"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "long-headline"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "circle w-30 h-30"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: logos === null || logos === void 0 ? void 0 : logos.src,
      alt: logos === null || logos === void 0 ? void 0 : logos.src,
      className: !logos.src ? "missing-img" : ""
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "headline-text"
    }, /*#__PURE__*/_react["default"].createElement("p", null, ((_values$longHeadline = values.longHeadline) === null || _values$longHeadline === void 0 ? void 0 : _values$longHeadline.name) || "Missing Headline"), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: "fas fa-ellipsis-vertical"
    }))), /*#__PURE__*/_react["default"].createElement("p", {
      className: "description"
    }, ((_values$description = values.description) === null || _values$description === void 0 ? void 0 : _values$description.name) || "Missing Description"), /*#__PURE__*/_react["default"].createElement("p", {
      className: "business-name"
    }, /*#__PURE__*/_react["default"].createElement("span", null, "Ad"), "\xA0", businessName || "Missing Business Name"), cta !== null && cta !== void 0 && cta.name ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "cta"
    }, cta.name) : null));
  }
  GoogleDemandGenVideo.displayName = "GoogleDemandGenVideo";
  GoogleDemandGenVideo.defaultProps = {
    socialValues: {},
    placementType: ""
  };
  GoogleDemandGenVideo.propTypes = {
    placementType: _propTypes["default"].string,
    socialValues: _propTypes["default"].shape({
      businessName: _propTypes["default"].string,
      landingPage: _propTypes["default"].string,
      mobileLandingPage: _propTypes["default"].string,
      thumbnails: _propTypes["default"].arrayOf(_propTypes["default"].object),
      headlines: _propTypes["default"].arrayOf(_propTypes["default"].object),
      longHeadlines: _propTypes["default"].arrayOf(_propTypes["default"].object),
      logos: _propTypes["default"].object,
      descriptions: _propTypes["default"].arrayOf(_propTypes["default"].object),
      cta: _propTypes["default"].object,
      videos: _propTypes["default"].arrayOf(_propTypes["default"].object)
    })
  };

  /***/
}, /* 511 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = LinkedInCarouselCards;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function LinkedInCarouselCards(props) {
    var cards = props.cards;
    var minCardsLength = 2;
    if ((cards === null || cards === void 0 ? void 0 : cards.length) < minCardsLength) {
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Please add at least 2 carousel cards"
      });
    }
    var media;
    function LinkedInMedia(card) {
      var image = card.image,
        type = card.type;
      if (type === "image") {
        media = /*#__PURE__*/_react["default"].createElement("img", {
          className: "card-media",
          src: image === null || image === void 0 ? void 0 : image.src,
          alt: image === null || image === void 0 ? void 0 : image.name
        });
      }
      if (!(image !== null && image !== void 0 && image.src)) {
        media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
          className: "card-media",
          message: "Missing ".concat(type)
        });
      }
      return media;
    }
    return cards === null || cards === void 0 ? void 0 : cards.map(function (card) {
      var headline = card.headline,
        order = card.order;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: order,
        className: "carousel-card"
      }, LinkedInMedia(card), /*#__PURE__*/_react["default"].createElement("div", {
        className: "lower-container"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "headline"
      }, headline)));
    });
  }
  LinkedInCarouselCards.displayName = "LinkedInCarouselCards";
  LinkedInCarouselCards.defaultProps = {
    cards: []
  };

  /***/
}, /* 512 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = PinterestCarouselCards;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = __webpack_require__(0);
  var _MissingMedia = _interopRequireDefault(__webpack_require__(19));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function PinterestCarouselCards(props) {
    var cards = props.cards;
    var minCardsLength = 2;
    var noCards = (cards === null || cards === void 0 ? void 0 : cards.length) < minCardsLength;
    if (noCards) {
      return /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], {
        message: "Please add at least 2 carousel cards"
      });
    }
    return cards === null || cards === void 0 ? void 0 : cards.map(function (card) {
      var image = card.image,
        landingPage = card.landingPage,
        order = card.order;
      var media = /*#__PURE__*/_react["default"].createElement(_MissingMedia["default"], null);
      if (image && image.src) {
        media = /*#__PURE__*/_react["default"].createElement("img", {
          src: image.src,
          alt: image.name
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: order,
        className: "pinterest-main-content"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "overlay"
      }), media, /*#__PURE__*/_react["default"].createElement("span", {
        className: "save"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "action-container"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "landing-page"
      }, /*#__PURE__*/_react["default"].createElement("strong", null, landingPage || '[Missing Landing Page]')), /*#__PURE__*/_react["default"].createElement("span", {
        className: "download circle w-32 h-32"
      })));
    });
  }
  PinterestCarouselCards.displayName = "PinterestCarouselCards";
  PinterestCarouselCards.propTypes = {
    cards: _propTypes.PropTypes.array
  };
  PinterestCarouselCards.defaultProps = {
    cards: []
  };

  /***/
}, /* 513 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.TheSaga = exports.SESSION_HANDLERS = exports.SESSION_ACTIONS = exports.IT = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames = _interopRequireDefault(__webpack_require__(6));
  var _reactAriaModal = _interopRequireDefault(__webpack_require__(212));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _ModalHeader = _interopRequireDefault(__webpack_require__(141));
  var _ModalFooter = _interopRequireDefault(__webpack_require__(142));
  var _Button = _interopRequireDefault(__webpack_require__(61));
  __webpack_require__(548);
  var _SESSION_HANDLERS, _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var ONE_SECOND = 1000,
    MIN = 60,
    SOON = 10;
  var SessionModal = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    _inherits(SessionModal, _React$Component);
    var _super = _createSuper(SessionModal);
    function SessionModal(props) {
      var _this;
      _classCallCheck(this, SessionModal);
      _this = _super.call(this, props);
      _this.state = {
        timeLeft: props.timerLength
      };
      return _this;
    }
    _createClass(SessionModal, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var me = this;
        me._theSenate = setInterval(function () {
          if (me.state.timeLeft < 0) {
            clearInterval(me._theSenate);
          }
          me.setState({
            timeLeft: me.state.timeLeft - 1
          });
        }, ONE_SECOND);
      }
    }, {
      key: "_renderCountdown",
      value: function _renderCountdown() {
        var props = this.props,
          state = this.state,
          mins = 0,
          secs = 0;
        if (props.type === "expired") {
          return null;
        }
        mins = Math.floor(state.timeLeft / MIN);
        secs = state.timeLeft % MIN;
        if (secs < SOON) {
          secs = "0".concat(secs);
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "countdown-container"
        }, /*#__PURE__*/_react["default"].createElement("p", null, "You will be logged out in:"), /*#__PURE__*/_react["default"].createElement("strong", {
          className: "time-remaining"
        }, "".concat(mins, ":").concat(secs)));
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
          classes = _defineProperty({
            "session-modal": true,
            "c-modal": true,
            "u-modal-responsive": true
          }, props.className, true),
          $desc = props.desc,
          $text = props.continueText;
        if (props.type === "expired") {
          $desc = props.expiredDesc;
          $text = props.expiredContinueText;
          classes["is-expired"] = true;
        }
        if (typeof $desc === "string") {
          $desc = $desc.replace("$$TIME$$", props.length);
        }
        return /*#__PURE__*/_react["default"].createElement(_reactAriaModal["default"], _extends({
          onExit: props.onClose,
          title: props.title,
          titleText: props.title,
          dialogClass: (0, _classnames["default"])(classes),
          underlayClickExits: false,
          verticallyCenter: true
        }, props.extraModalProps), /*#__PURE__*/_react["default"].createElement(_ModalHeader["default"], {
          title: props.title,
          onClose: props.onClose,
          xClose: false,
          allowFullScreen: false
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "c-modal__content c-modal__content--footer session-modal-content"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "message"
        }, $desc), this._renderCountdown()), /*#__PURE__*/_react["default"].createElement(_ModalFooter["default"], {
          className: "session-buttons"
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          theme: "blue",
          onClick: props.onContinue
        }, $text)));
      }
    }]);
    return SessionModal;
  }(_react["default"].Component), _defineProperty(_class2, "defaultProps", {
    timerLength: 300,
    //5 minutes
    title: "Session Timeout",
    length: 60,
    //60 minutes timeout length

    desc: "Your user session is about to expire.  For data security, we log users out after $$TIME$$ minutes of inactivity.  Click continue to stay logged in.",
    expiredDesc: "Your user session has expired.  For data security we log users out after $$TIME$$ minutes of inactivity.  To continue working please log back in.",
    continueText: "Continue Working",
    expiredContinueText: "Log In",
    className: ""

    // type:"countdown",
    // onContinue:null,
    // onLogout:null,
  }), _defineProperty(_class2, "propTypes", {
    /** Length of time for the countdown timer */
    timerLength: _propTypes["default"].number,
    /** Title of the modal */
    title: _propTypes["default"].string,
    /** Length of time before the user get's logged out (used in descriptions) */
    length: _propTypes["default"].number,
    /** The type of modal to show*/
    type: _propTypes["default"].oneOf(["countdown", "expired"]).isRequired,
    /** Extra Classname for the component */
    className: _propTypes["default"].string,
    /** Description to put above the countdown */
    desc: _propTypes["default"].node,
    /** Message to display when the modal changes to the logged out version */
    expiredDesc: _propTypes["default"].node,
    /** Text to display in the button to continue working */
    continueText: _propTypes["default"].string,
    /** Text to display in the button when the session is expired */
    exporedContinueText: _propTypes["default"].string,
    /** Function to call when the user clicks on the Continue Work button */
    onContinue: _propTypes["default"].func.isRequired,
    onLogout: _propTypes["default"].func
  }), _class2), _applyDecoratedDescriptor(_class.prototype, "_renderCountdown", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "_renderCountdown"), _class.prototype), _class);
  exports["default"] = SessionModal;
  //30minutes as miliseconds: 30 * 60 * 1000
  var TIMEOUT = 1800000;
  // 5minutes as mililseconds
  var EPISODE_2 = 300000;
  var SESSION_ACTIONS = {
    ALMOST_LOGGED_OUT: "ALMOST_LOGGED_OUT",
    LOGGED_OUT: "LOGGED_OUT",
    RESET: "RESET"
  };
  exports.SESSION_ACTIONS = SESSION_ACTIONS;
  var ALMOST = {
    type: SESSION_ACTIONS.ALMOST_LOGGED_OUT,
    meta: {
      tracking: {
        type: "event",
        eventAction: "Logged out",
        eventLabel: "Warning Message"
      }
    }
  };
  var GONE = {
    type: SESSION_ACTIONS.LOGGED_OUT,
    meta: {
      tracking: {
        type: "event",
        eventAction: "Logged out",
        eventLabel: "No time left"
      }
    }
  };
  var IS_THAT_LEGAL = null,
    I_WILL_MAKE_IT_LEGAL = null;
  var TheSaga = /*#__PURE__*/function () {
    function TheSaga() {
      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TIMEOUT;
      var countdown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EPISODE_2;
      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      _classCallCheck(this, TheSaga);
      this.timeout = timeout;
      this.countdown = countdown;
      if (timeout - countdown - offset < 0) {
        this.offset = 0;
        console.warn("Offset of ".concat(offset, " would put timeout below 0 seconds, not applying"));
      } else {
        this.offset = offset;
      }
    }
    _createClass(TheSaga, [{
      key: "completes",
      value: function completes(dispatch) {
        dispatch(GONE);
        this._theCloneWars();
      }
    }, {
      key: "_theCloneWars",
      value: function _theCloneWars() {
        clearTimeout(IS_THAT_LEGAL);
        clearTimeout(I_WILL_MAKE_IT_LEGAL);
      }
    }, {
      key: "_order66",
      value: function _order66(dispatch) {
        try {
          this._theCloneWars();
          dispatch({
            type: SESSION_ACTIONS.RESET
          });
        } catch (err) {
          /* istanbul ignore next */
          console.log("Timeouts don't exist");
          /* istanbul ignore next */
          console.info(err);
        }
      }
    }, {
      key: "begins",
      value: function begins(dispatch) {
        if (!dispatch) {
          throw Error("Dispatch not defined");
        }
        this._order66(dispatch);
        IS_THAT_LEGAL = setTimeout(function () {
          dispatch(ALMOST);
        }, this.timeout - this.countdown - this.offset);
        I_WILL_MAKE_IT_LEGAL = setTimeout(function () {
          dispatch(GONE);
        }, this.timeout - this.offset);
      }
    }]);
    return TheSaga;
  }();
  exports.TheSaga = TheSaga;
  var SESSION_HANDLERS = (_SESSION_HANDLERS = {}, _defineProperty(_SESSION_HANDLERS, SESSION_ACTIONS.RESET, _reborn), _defineProperty(_SESSION_HANDLERS, SESSION_ACTIONS.ALMOST_LOGGED_OUT, _begun), _defineProperty(_SESSION_HANDLERS, SESSION_ACTIONS.LOGGED_OUT, _done), _SESSION_HANDLERS);
  exports.SESSION_HANDLERS = SESSION_HANDLERS;
  function _reborn(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      type: null
    });
  }
  function _begun(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      type: "countdown"
    });
  }
  function _done(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      type: "expired"
    });
  }
  var IT = {
    type: null
  };
  exports.IT = IT;

  /***/
}, /* 514 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.itsOver = itsOver;
  exports.onMessage = onMessage;
  exports.sendMessage = sendMessage;
  exports.theHighGround = theHighGround;
  /**
   * The High Ground
   */

  var BC = null,
    ownerName = null,
    DEBUG_ON = false;
  function theHighGround() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "mustafar";
    var isDebug = arguments.length > 1 ? arguments[1] : undefined;
    DEBUG_ON = isDebug;
    DEBUG_ON && console.log("Starting up BroadcastChannel");
    BC = new BroadcastChannel(name);
    ownerName = Math.floor(Math.random() * 100);
    DEBUG_ON && console.log("BroadcastChannel Opened");
  }
  function sendMessage(message) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "continue";
    var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    try {
      DEBUG_ON && console.log("Sending message", message, type);
      BC.postMessage({
        time: Date(),
        type: type,
        ownerName: ownerName,
        info: message
      });
    } catch (err) {
      console.error("Unable to send message");
      console.error(err);
    }
    if (next) {
      try {
        window.theSaga.begins(next);
      } catch (err) {
        console.error("Unable to begin episode 1");
        console.error(err);
      }
    }
    return BC;
  }
  function onMessage(doSomething) {
    try {
      BC.onmessage = doSomething;
    } catch (err) {
      console.error("Unable to receive message");
      console.error(err);
    }
  }
  function itsOver() {
    DEBUG_ON && console.log("You were my brother, ".concat(BC.name, ". I loved you."));
    BC.close();
  }

  /***/
}, /* 515 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = CheckboxFilter;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _CheckboxList = __webpack_require__(167);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function CheckboxFilter(props) {
    return /*#__PURE__*/_react["default"].createElement(_CheckboxList.CheckboxList, props);
  }

  /***/
}, /* 516 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _Input = _interopRequireDefault(__webpack_require__(87));
  var _functions = __webpack_require__(33);
  var _excluded = ["items", "filterLevel", "userLocale"];
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var StringFilter = /*#__PURE__*/function (_React$Component) {
    _inherits(StringFilter, _React$Component);
    var _super = _createSuper(StringFilter);
    function StringFilter() {
      _classCallCheck(this, StringFilter);
      return _super.apply(this, arguments);
    }
    _createClass(StringFilter, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          items = _this$props.items,
          filterLevel = _this$props.filterLevel,
          userLocale = _this$props.userLocale,
          restProps = _objectWithoutProperties(_this$props, _excluded);
        return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
          icon: "search",
          iconPos: "left"
        }, restProps, {
          onChange: this.props.onChange
        }));
      }
    }]);
    return StringFilter;
  }(_react["default"].Component);
  exports["default"] = StringFilter;
  _defineProperty(StringFilter, "defaultProps", {
    type: "search",
    onChange: _functions.noop
  });

  /***/
}, /* 517 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = RangeFilter;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _rcSlider = __webpack_require__(613);
  var _numeral = _interopRequireDefault(__webpack_require__(604));
  var _functions = __webpack_require__(33);
  var _excluded = ["dragging", "index"];
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function RangeFilter(props) {
    var begin = 0,
      end = 0,
      selectedVals = [].concat(props.value);
    if (props.value[0]) {
      begin = (0, _numeral["default"])(props.value[0]).format('0,0');
    } else {
      selectedVals[0] = props.min;
    }
    if (props.value[1]) {
      end = (0, _numeral["default"])(props.value[1]).format('0,0');
    } else {
      selectedVals[1] = props.max;
    }
    if (/file size/gi.test(props.name)) {
      begin = (0, _functions.formatBytes)(props.value[0]);
      end = (0, _functions.formatBytes)(props.value[1]);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "range-filter-wrapper"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "range-filter-value"
    }, "From ", begin, " to ", end), /*#__PURE__*/_react["default"].createElement(_rcSlider.Range, _extends({}, props, {
      value: selectedVals
    })));
  }
  RangeFilter.defaultProps = {
    min: 0,
    max: 1000,
    step: 1,
    count: 1,
    dots: false,
    handle: function handle(props) {
      var dragging = props.dragging,
        index = props.index,
        restProps = _objectWithoutProperties(props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_rcSlider.Handle, _extends({}, restProps, {
        key: index,
        className: "c-tooltip c-tooltip--top rc-slider-handle rc-slider-handle-2",
        "aria-label": props.value
      }));
    }
  };

  /***/
}, /* 518 */
/***/function (module, exports, __webpack_require__) {
  module.exports = !__webpack_require__(396) && !__webpack_require__(430)(function () {
    return Object.defineProperty(__webpack_require__(519)('div'), 'a', {
      get: function () {
        return 7;
      }
    }).a != 7;
  });

  /***/
}, /* 519 */
/***/function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(429);
  var document = __webpack_require__(394).document;
  // typeof document.createElement is 'object' in old IE
  var is = isObject(document) && isObject(document.createElement);
  module.exports = function (it) {
    return is ? document.createElement(it) : {};
  };

  /***/
}, /* 520 */
/***/function (module, exports, __webpack_require__) {
  var has = __webpack_require__(412);
  var toIObject = __webpack_require__(413);
  var arrayIndexOf = __webpack_require__(556)(false);
  var IE_PROTO = __webpack_require__(480)('IE_PROTO');
  module.exports = function (object, names) {
    var O = toIObject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while (names.length > i) if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
    return result;
  };

  /***/
}, /* 521 */
/***/function (module, exports, __webpack_require__) {
  // fallback for non-array-like ES3 and non-enumerable old V8 strings
  var cof = __webpack_require__(477);
  // eslint-disable-next-line no-prototype-builtins
  module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return cof(it) == 'String' ? it.split('') : Object(it);
  };

  /***/
}, /* 522 */
/***/function (module, exports, __webpack_require__) {
  // 7.1.15 ToLength
  var toInteger = __webpack_require__(479);
  var min = Math.min;
  module.exports = function (it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };

  /***/
}, /* 523 */
/***/function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(558),
    __esModule: true
  };

  /***/
}, /* 524 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var $at = __webpack_require__(562)(true);

  // 21.1.3.27 String.prototype[@@iterator]()
  __webpack_require__(525)(String, 'String', function (iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
    // 21.1.5.2.1 %StringIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
      value: undefined,
      done: true
    };
    point = $at(O, index);
    this._i += point.length;
    return {
      value: point,
      done: false
    };
  });

  /***/
}, /* 525 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var LIBRARY = __webpack_require__(464);
  var $export = __webpack_require__(393);
  var redefine = __webpack_require__(526);
  var hide = __webpack_require__(427);
  var Iterators = __webpack_require__(459);
  var $iterCreate = __webpack_require__(563);
  var setToStringTag = __webpack_require__(485);
  var getPrototypeOf = __webpack_require__(527);
  var ITERATOR = __webpack_require__(249)('iterator');
  var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
  var FF_ITERATOR = '@@iterator';
  var KEYS = 'keys';
  var VALUES = 'values';
  var returnThis = function () {
    return this;
  };
  module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $iterCreate(Constructor, NAME, next);
    var getMethod = function (kind) {
      if (!BUGGY && kind in proto) return proto[kind];
      switch (kind) {
        case KEYS:
          return function keys() {
            return new Constructor(this, kind);
          };
        case VALUES:
          return function values() {
            return new Constructor(this, kind);
          };
      }
      return function entries() {
        return new Constructor(this, kind);
      };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
      IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
      if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
        // Set @@toStringTag to native iterators
        setToStringTag(IteratorPrototype, TAG, true);
        // fix for some old engines
        if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
      }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== VALUES) {
      VALUES_BUG = true;
      $default = function values() {
        return $native.call(this);
      };
    }
    // Define iterator
    if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
      hide(proto, ITERATOR, $default);
    }
    // Plug for library
    Iterators[NAME] = $default;
    Iterators[TAG] = returnThis;
    if (DEFAULT) {
      methods = {
        values: DEF_VALUES ? $default : getMethod(VALUES),
        keys: IS_SET ? $default : getMethod(KEYS),
        entries: $entries
      };
      if (FORCED) for (key in methods) {
        if (!(key in proto)) redefine(proto, key, methods[key]);
      } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
  };

  /***/
}, /* 526 */
/***/function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(427);

  /***/
}, /* 527 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
  var has = __webpack_require__(412);
  var toObject = __webpack_require__(458);
  var IE_PROTO = __webpack_require__(480)('IE_PROTO');
  var ObjectProto = Object.prototype;
  module.exports = Object.getPrototypeOf || function (O) {
    O = toObject(O);
    if (has(O, IE_PROTO)) return O[IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
      return O.constructor.prototype;
    }
    return O instanceof Object ? ObjectProto : null;
  };

  /***/
}, /* 528 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
  var $keys = __webpack_require__(520);
  var hiddenKeys = __webpack_require__(482).concat('length', 'prototype');
  exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $keys(O, hiddenKeys);
  };

  /***/
}, /* 529 */
/***/function (module, exports, __webpack_require__) {
  // most Object methods by ES6 should accept primitives
  var $export = __webpack_require__(393);
  var core = __webpack_require__(238);
  var fails = __webpack_require__(430);
  module.exports = function (KEY, exec) {
    var fn = (core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $export($export.S + $export.F * fails(function () {
      fn(1);
    }), 'Object', exp);
  };

  /***/
}, /* 530 */
/***/function (module, exports) {
  module.exports = function (arr, obj) {
    if (arr.indexOf) return arr.indexOf(obj);
    for (var i = 0; i < arr.length; ++i) {
      if (arr[i] === obj) return i;
    }
    return -1;
  };

  /***/
}, /* 531 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = DateRangeFilter;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _Dates = _interopRequireDefault(__webpack_require__(168));
  var _constants = __webpack_require__(59);
  var _excluded = ["additionalProps", "placeholderText", "userLocale"];
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function DateRangeFilter(props) {
    var _props$additionalProp = props.additionalProps,
      additionalProps = _props$additionalProp === void 0 ? {} : _props$additionalProp,
      _props$placeholderTex = props.placeholderText,
      placeholderText = _props$placeholderTex === void 0 ? "Enter Date" : _props$placeholderTex,
      userLocale = props.userLocale,
      dProps = _objectWithoutProperties(props, _excluded),
      shouldUseUKFormat = userLocale && !/en-us/gi.test(userLocale),
      dateProps = _objectSpread(_objectSpread(_objectSpread({
        startProps: {},
        endProps: {}
      }, dProps), additionalProps), {}, {
        dateFormat: shouldUseUKFormat ? _constants.DATE_FORMAT.ukMulti : _constants.DATE_FORMAT.usMulti
      }),
      defaultStartDate = dateProps.startProps.openToDate || null,
      defaultEndDate = dateProps.endProps.openToDate || null;
    dateProps.startProps.placeholderText = placeholderText;
    dateProps.endProps.placeholderText = placeholderText;
    if (!dateProps.value && (defaultStartDate || defaultEndDate)) {
      dateProps.value = {
        startDate: defaultStartDate,
        endDate: defaultEndDate
      };
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "date-range-filter-wrapper"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "date-range-filter-label"
    }, "Date Range"), /*#__PURE__*/_react["default"].createElement(_Dates["default"], dateProps));
  }

  /***/
}, /* 532 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.CellFilter = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _FilterModalLauncher = _interopRequireDefault(__webpack_require__(489));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  // This is a class instead of a function because FilterModalLauncher uses a ref and if it is a function the console errors with:
  // "Stateless function components cannot be given refs. Attempts to access this ref will fail."
  var CellFilter = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(CellFilter, _React$PureComponent);
    var _super = _createSuper(CellFilter);
    function CellFilter() {
      _classCallCheck(this, CellFilter);
      return _super.apply(this, arguments);
    }
    _createClass(CellFilter, [{
      key: "render",
      value: function render() {
        var enabledFilter = this.props.isFiltered ? "filter-enabled" : "";
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(enabledFilter, " filter-container")
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          className: "filter-icon",
          name: "filter"
        }));
      }
    }]);
    return CellFilter;
  }(_react["default"].PureComponent);
  exports.CellFilter = CellFilter;
  var _default = (0, _FilterModalLauncher["default"])(CellFilter);
  exports["default"] = _default;

  /***/
}, /* 533 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = LinkAction;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _reactContextmenu = __webpack_require__(109);
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _functions = __webpack_require__(33);
  var _useTooltipRebuild = __webpack_require__(610);
  var _SimpleErrorBoundry = _interopRequireDefault(__webpack_require__(467));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function LinkAction(props) {
    var icon = props.icon,
      name = props.name,
      useMenuItem = props.useMenuItem,
      tooltipContent = props.tooltipContent,
      isMultiLine = props.isMultiLine,
      onClick = props.onClick,
      path = props.path,
      disabledClass = props.disabledClass,
      isExternal = props.isExternal;
    (0, _useTooltipRebuild.useTooltipRebuild)(props);
    var $menuItemContent = null,
      isExternalClass = isExternal ? "is-external" : "";
    function _onClick(evt) {
      evt.preventDefault();
      // evt.stopPropagation();
      onClick(props);
    }
    $menuItemContent = /*#__PURE__*/_react["default"].createElement("a", {
      href: path,
      target: "_blank",
      className: disabledClass,
      onClick: _onClick
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "link-action-item action-item ".concat(isExternalClass),
      "data-multiline": isMultiLine,
      "data-tip": tooltipContent
    }, icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      className: "action-icon",
      name: icon
    }), name && /*#__PURE__*/_react["default"].createElement("span", {
      className: "action-name"
    }, name), isExternal && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      className: "external-icon",
      name: 'fas fa-external-link-alt'
    })));
    if (useMenuItem) {
      return /*#__PURE__*/_react["default"].createElement(_reactContextmenu.MenuItem, null, $menuItemContent);
    }
    return $menuItemContent;
  }
  LinkAction.displayName = "LinkAction";
  LinkAction.propTypes = {
    text: _propTypes["default"].string,
    icon: _propTypes["default"].string,
    path: _propTypes["default"].string.isRequired,
    useMenuItem: _propTypes["default"].bool,
    isExternal: _propTypes["default"].bool,
    onClick: _propTypes["default"].func,
    tooltipContent: _propTypes["default"].string
  };
  LinkAction.defaultProps = {
    text: "",
    icon: "",
    path: "",
    useMenuItem: true,
    isExternal: false,
    onClick: _functions.noop,
    tooltipContent: null
  };

  /***/
}, /* 534 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = BasicAction;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _reactContextmenu = __webpack_require__(109);
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _functions = __webpack_require__(33);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function BasicAction(props) {
    var icon = props.icon,
      tooltipContent = props.tooltipContent,
      isMultiLine = props.isMultiLine,
      name = props.name,
      _onClick = props.onClick,
      dependentValues = props.dependentValues,
      divider = props.divider;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, divider ? /*#__PURE__*/_react["default"].createElement(_reactContextmenu.MenuItem, {
      divider: true
    }) : null, /*#__PURE__*/_react["default"].createElement(_reactContextmenu.MenuItem, {
      onClick: function onClick() {
        return _onClick(dependentValues);
      }
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "action-item",
      "data-multiline": isMultiLine,
      "data-tip": tooltipContent
    }, icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      className: "action-icon",
      name: icon
    }), name && /*#__PURE__*/_react["default"].createElement("span", {
      className: "action-name"
    }, name)))));
  }
  BasicAction.displayName = "BasicAction";
  BasicAction.propTypes = {
    icon: _propTypes["default"].string.isRequired,
    toolTipContent: _propTypes["default"].string,
    name: _propTypes["default"].string,
    handleClick: _propTypes["default"].func,
    divider: _propTypes["default"].bool,
    isMultiLine: _propTypes["default"].bool
  };
  BasicAction.defaultProps = {
    icon: "",
    toolTipContent: "",
    isMultiLine: false,
    divider: false,
    name: "",
    onClick: _functions.noop
  };

  /***/
}, /* 535 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports['default'] = addEventListener;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  var _EventObject = __webpack_require__(593);
  var _EventObject2 = _interopRequireDefault(_EventObject);
  function addEventListener(target, eventType, callback, option) {
    function wrapCallback(e) {
      var ne = new _EventObject2['default'](e);
      callback.call(target, ne);
    }
    if (target.addEventListener) {
      var _ret = function () {
        var useCapture = false;
        if (typeof option === 'object') {
          useCapture = option.capture || false;
        } else if (typeof option === 'boolean') {
          useCapture = option;
        }
        target.addEventListener(eventType, wrapCallback, option || false);
        return {
          v: {
            remove: function remove() {
              target.removeEventListener(eventType, wrapCallback, useCapture);
            }
          }
        };
      }();
      if (typeof _ret === 'object') return _ret.v;
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, wrapCallback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, wrapCallback);
        }
      };
    }
  }
  module.exports = exports['default'];

  /***/
}, /* 536 */
/***/function (module, exports) {
  //

  module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) {
      return !!ret;
    }
    if (objA === objB) {
      return true;
    }
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
      return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
      return false;
    }
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for (var idx = 0; idx < keysA.length; idx++) {
      var key = keysA[idx];
      if (!bHasOwnProperty(key)) {
        return false;
      }
      var valueA = objA[key];
      var valueB = objB[key];
      ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
      if (ret === false || ret === void 0 && valueA !== valueB) {
        return false;
      }
    }
    return true;
  };

  /***/
}, /* 537 */
/***/function (module, exports, __webpack_require__) {
  /**
   * Module dependencies.
   */

  try {
    var index = __webpack_require__(530);
  } catch (err) {
    var index = __webpack_require__(530);
  }

  /**
   * Whitespace regexp.
   */

  var re = /\s+/;

  /**
   * toString reference.
   */

  var toString = Object.prototype.toString;

  /**
   * Wrap `el` in a `ClassList`.
   *
   * @param {Element} el
   * @return {ClassList}
   * @api public
   */

  module.exports = function (el) {
    return new ClassList(el);
  };

  /**
   * Initialize a new ClassList for `el`.
   *
   * @param {Element} el
   * @api private
   */

  function ClassList(el) {
    if (!el || !el.nodeType) {
      throw new Error('A DOM element reference is required');
    }
    this.el = el;
    this.list = el.classList;
  }

  /**
   * Add class `name` if not already present.
   *
   * @param {String} name
   * @return {ClassList}
   * @api public
   */

  ClassList.prototype.add = function (name) {
    // classList
    if (this.list) {
      this.list.add(name);
      return this;
    }

    // fallback
    var arr = this.array();
    var i = index(arr, name);
    if (!~i) arr.push(name);
    this.el.className = arr.join(' ');
    return this;
  };

  /**
   * Remove class `name` when present, or
   * pass a regular expression to remove
   * any which match.
   *
   * @param {String|RegExp} name
   * @return {ClassList}
   * @api public
   */

  ClassList.prototype.remove = function (name) {
    if ('[object RegExp]' == toString.call(name)) {
      return this.removeMatching(name);
    }

    // classList
    if (this.list) {
      this.list.remove(name);
      return this;
    }

    // fallback
    var arr = this.array();
    var i = index(arr, name);
    if (~i) arr.splice(i, 1);
    this.el.className = arr.join(' ');
    return this;
  };

  /**
   * Remove all classes matching `re`.
   *
   * @param {RegExp} re
   * @return {ClassList}
   * @api private
   */

  ClassList.prototype.removeMatching = function (re) {
    var arr = this.array();
    for (var i = 0; i < arr.length; i++) {
      if (re.test(arr[i])) {
        this.remove(arr[i]);
      }
    }
    return this;
  };

  /**
   * Toggle class `name`, can force state via `force`.
   *
   * For browsers that support classList, but do not support `force` yet,
   * the mistake will be detected and corrected.
   *
   * @param {String} name
   * @param {Boolean} force
   * @return {ClassList}
   * @api public
   */

  ClassList.prototype.toggle = function (name, force) {
    // classList
    if (this.list) {
      if ("undefined" !== typeof force) {
        if (force !== this.list.toggle(name, force)) {
          this.list.toggle(name); // toggle again to correct
        }
      } else {
        this.list.toggle(name);
      }
      return this;
    }

    // fallback
    if ("undefined" !== typeof force) {
      if (!force) {
        this.remove(name);
      } else {
        this.add(name);
      }
    } else {
      if (this.has(name)) {
        this.remove(name);
      } else {
        this.add(name);
      }
    }
    return this;
  };

  /**
   * Return an array of classes.
   *
   * @return {Array}
   * @api public
   */

  ClassList.prototype.array = function () {
    var className = this.el.getAttribute('class') || '';
    var str = className.replace(/^\s+|\s+$/g, '');
    var arr = str.split(re);
    if ('' === arr[0]) arr.shift();
    return arr;
  };

  /**
   * Check if class `name` is present.
   *
   * @param {String} name
   * @return {ClassList}
   * @api public
   */

  ClassList.prototype.has = ClassList.prototype.contains = function (name) {
    return this.list ? this.list.contains(name) : !!~index(this.array(), name);
  };

  /***/
}, /* 538 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "AD_TYPES", {
    enumerable: true,
    get: function get() {
      return _constants2.AD_TYPES;
    }
  });
  Object.defineProperty(exports, "AD_TYPES_BY_LABEL", {
    enumerable: true,
    get: function get() {
      return _constants2.AD_TYPES_BY_LABEL;
    }
  });
  exports.Account = void 0;
  Object.defineProperty(exports, "ActionMenuCell", {
    enumerable: true,
    get: function get() {
      return _ActionMenuCell["default"];
    }
  });
  Object.defineProperty(exports, "ActionsCell", {
    enumerable: true,
    get: function get() {
      return _MoreActions["default"];
    }
  });
  Object.defineProperty(exports, "ActionsComponent", {
    enumerable: true,
    get: function get() {
      return _MoreActions.ActionsComponent;
    }
  });
  Object.defineProperty(exports, "AppHeader", {
    enumerable: true,
    get: function get() {
      return _AppHeader["default"];
    }
  });
  Object.defineProperty(exports, "AppHelp", {
    enumerable: true,
    get: function get() {
      return _AppHeader.HelpItem;
    }
  });
  Object.defineProperty(exports, "BasicAction", {
    enumerable: true,
    get: function get() {
      return _BasicAction["default"];
    }
  });
  Object.defineProperty(exports, "Blade", {
    enumerable: true,
    get: function get() {
      return _Blade["default"];
    }
  });
  Object.defineProperty(exports, "BladeInfo", {
    enumerable: true,
    get: function get() {
      return _Blade.BLADE_REDUX;
    }
  });
  Object.defineProperty(exports, "BreadcrumbBar", {
    enumerable: true,
    get: function get() {
      return _BreadcrumbBar["default"];
    }
  });
  Object.defineProperty(exports, "Button", {
    enumerable: true,
    get: function get() {
      return _Button["default"];
    }
  });
  Object.defineProperty(exports, "Card", {
    enumerable: true,
    get: function get() {
      return _Card["default"];
    }
  });
  Object.defineProperty(exports, "CellFilter", {
    enumerable: true,
    get: function get() {
      return _CellFilter["default"];
    }
  });
  Object.defineProperty(exports, "Checkbox", {
    enumerable: true,
    get: function get() {
      return _Checkbox["default"];
    }
  });
  Object.defineProperty(exports, "CheckboxFilter", {
    enumerable: true,
    get: function get() {
      return _CheckboxFilter["default"];
    }
  });
  Object.defineProperty(exports, "CheckboxList", {
    enumerable: true,
    get: function get() {
      return _CheckboxList["default"];
    }
  });
  exports.Constants = exports.Confirm = void 0;
  Object.defineProperty(exports, "ControlWrapper", {
    enumerable: true,
    get: function get() {
      return _ControlWrapper["default"];
    }
  });
  Object.defineProperty(exports, "CreativeLabels", {
    enumerable: true,
    get: function get() {
      return _CreativeLabels["default"];
    }
  });
  Object.defineProperty(exports, "DataGrid", {
    enumerable: true,
    get: function get() {
      return _DataGrid["default"];
    }
  });
  Object.defineProperty(exports, "DateFilter", {
    enumerable: true,
    get: function get() {
      return _DateFilter["default"];
    }
  });
  Object.defineProperty(exports, "Dates", {
    enumerable: true,
    get: function get() {
      return _Dates["default"];
    }
  });
  exports.Dictionaries = void 0;
  Object.defineProperty(exports, "Dimensions", {
    enumerable: true,
    get: function get() {
      return _Dimensions["default"];
    }
  });
  Object.defineProperty(exports, "EmptyItem", {
    enumerable: true,
    get: function get() {
      return _EmptyItem["default"];
    }
  });
  Object.defineProperty(exports, "EnhancedTooltip", {
    enumerable: true,
    get: function get() {
      return _EnhancedTooltip["default"];
    }
  });
  Object.defineProperty(exports, "ErrorBanner", {
    enumerable: true,
    get: function get() {
      return _ErrorBanner["default"];
    }
  });
  Object.defineProperty(exports, "FacebookCarousel", {
    enumerable: true,
    get: function get() {
      return _FacebookCarousel["default"];
    }
  });
  Object.defineProperty(exports, "FacebookImage", {
    enumerable: true,
    get: function get() {
      return _FacebookImage["default"];
    }
  });
  Object.defineProperty(exports, "FacebookVideo", {
    enumerable: true,
    get: function get() {
      return _FacebookVideo["default"];
    }
  });
  Object.defineProperty(exports, "FileImport", {
    enumerable: true,
    get: function get() {
      return _FileImport["default"];
    }
  });
  Object.defineProperty(exports, "FilterModalLauncher", {
    enumerable: true,
    get: function get() {
      return _FilterModalLauncher["default"];
    }
  });
  Object.defineProperty(exports, "FilterTag", {
    enumerable: true,
    get: function get() {
      return _FilterTag["default"];
    }
  });
  exports.Form = void 0;
  Object.defineProperty(exports, "FormFooter", {
    enumerable: true,
    get: function get() {
      return _FormFooter["default"];
    }
  });
  exports.Functions = void 0;
  Object.defineProperty(exports, "GoogleDiscovery", {
    enumerable: true,
    get: function get() {
      return _GoogleDiscovery["default"];
    }
  });
  Object.defineProperty(exports, "GoogleDiscoveryCarousel", {
    enumerable: true,
    get: function get() {
      return _GoogleDiscoveryCarousel["default"];
    }
  });
  Object.defineProperty(exports, "Header", {
    enumerable: true,
    get: function get() {
      return _Header["default"];
    }
  });
  Object.defineProperty(exports, "HeaderFilter", {
    enumerable: true,
    get: function get() {
      return _HeaderFilter["default"];
    }
  });
  Object.defineProperty(exports, "HighGround", {
    enumerable: true,
    get: function get() {
      return _HighGround["default"];
    }
  });
  Object.defineProperty(exports, "Icon", {
    enumerable: true,
    get: function get() {
      return _Icon["default"];
    }
  });
  Object.defineProperty(exports, "IconMap", {
    enumerable: true,
    get: function get() {
      return _Icons["default"];
    }
  });
  Object.defineProperty(exports, "Input", {
    enumerable: true,
    get: function get() {
      return _Input["default"];
    }
  });
  exports.Layout = void 0;
  Object.defineProperty(exports, "LinkAction", {
    enumerable: true,
    get: function get() {
      return _LinkAction["default"];
    }
  });
  Object.defineProperty(exports, "LinkedInCarousel", {
    enumerable: true,
    get: function get() {
      return _LinkedInCarousel["default"];
    }
  });
  Object.defineProperty(exports, "LinkedInImage", {
    enumerable: true,
    get: function get() {
      return _LinkedInImage["default"];
    }
  });
  Object.defineProperty(exports, "LinkedInVideo", {
    enumerable: true,
    get: function get() {
      return _LinkedInVideo["default"];
    }
  });
  Object.defineProperty(exports, "Modal", {
    enumerable: true,
    get: function get() {
      return _Blade["default"];
    }
  });
  Object.defineProperty(exports, "ModalFooter", {
    enumerable: true,
    get: function get() {
      return _ModalFooter["default"];
    }
  });
  Object.defineProperty(exports, "ModalHeader", {
    enumerable: true,
    get: function get() {
      return _ModalHeader["default"];
    }
  });
  Object.defineProperty(exports, "MoreActions", {
    enumerable: true,
    get: function get() {
      return _MoreActions.MoreActions;
    }
  });
  Object.defineProperty(exports, "MultiSelectWithList", {
    enumerable: true,
    get: function get() {
      return _MultiSelectWithList["default"];
    }
  });
  Object.defineProperty(exports, "Navbar", {
    enumerable: true,
    get: function get() {
      return _Navbar["default"];
    }
  });
  Object.defineProperty(exports, "NewCard", {
    enumerable: true,
    get: function get() {
      return _NewCard["default"];
    }
  });
  Object.defineProperty(exports, "NotificationController", {
    enumerable: true,
    get: function get() {
      return _NotificationController["default"];
    }
  });
  Object.defineProperty(exports, "NotificationItem", {
    enumerable: true,
    get: function get() {
      return _NotificationItem["default"];
    }
  });
  Object.defineProperty(exports, "PageHeader", {
    enumerable: true,
    get: function get() {
      return _PageHeader["default"];
    }
  });
  Object.defineProperty(exports, "Pager", {
    enumerable: true,
    get: function get() {
      return _Pager["default"];
    }
  });
  Object.defineProperty(exports, "PinterestCarousel", {
    enumerable: true,
    get: function get() {
      return _PinterestCarousel["default"];
    }
  });
  Object.defineProperty(exports, "PinterestImage", {
    enumerable: true,
    get: function get() {
      return _PinterestImage["default"];
    }
  });
  Object.defineProperty(exports, "PinterestVideo", {
    enumerable: true,
    get: function get() {
      return _PinterestVideo["default"];
    }
  });
  Object.defineProperty(exports, "PreviewError", {
    enumerable: true,
    get: function get() {
      return _PreviewError["default"];
    }
  });
  Object.defineProperty(exports, "ProgressIndicator", {
    enumerable: true,
    get: function get() {
      return _ProgressIndicator["default"];
    }
  });
  Object.defineProperty(exports, "PropValidators", {
    enumerable: true,
    get: function get() {
      return _SharedPropTypes["default"];
    }
  });
  Object.defineProperty(exports, "RangeFilter", {
    enumerable: true,
    get: function get() {
      return _RangeFilter["default"];
    }
  });
  exports.ReactDataGridAddons = exports.ReactDataGrid = void 0;
  Object.defineProperty(exports, "ReduxControls", {
    enumerable: true,
    get: function get() {
      return _form.ReduxControls;
    }
  });
  Object.defineProperty(exports, "Rhombicon", {
    enumerable: true,
    get: function get() {
      return _Icon["default"];
    }
  });
  Object.defineProperty(exports, "RowController", {
    enumerable: true,
    get: function get() {
      return _RowController["default"];
    }
  });
  Object.defineProperty(exports, "Search", {
    enumerable: true,
    get: function get() {
      return _Search["default"];
    }
  });
  Object.defineProperty(exports, "Select", {
    enumerable: true,
    get: function get() {
      return _Select["default"];
    }
  });
  exports.SessionModal = exports.Session = void 0;
  Object.defineProperty(exports, "SnapchatImage", {
    enumerable: true,
    get: function get() {
      return _SnapchatImage["default"];
    }
  });
  Object.defineProperty(exports, "SnapchatVideo", {
    enumerable: true,
    get: function get() {
      return _SnapchatVideo["default"];
    }
  });
  exports.SocialHelpers = void 0;
  Object.defineProperty(exports, "SocialPreview", {
    enumerable: true,
    get: function get() {
      return _SocialPreview["default"];
    }
  });
  Object.defineProperty(exports, "StatusIcon", {
    enumerable: true,
    get: function get() {
      return _StatusIcon["default"];
    }
  });
  Object.defineProperty(exports, "StringFilter", {
    enumerable: true,
    get: function get() {
      return _StringFilter["default"];
    }
  });
  Object.defineProperty(exports, "Tabs", {
    enumerable: true,
    get: function get() {
      return _Tabs["default"];
    }
  });
  Object.defineProperty(exports, "Tag", {
    enumerable: true,
    get: function get() {
      return _Tag["default"];
    }
  });
  Object.defineProperty(exports, "TagGroup", {
    enumerable: true,
    get: function get() {
      return _TagGroup["default"];
    }
  });
  exports.TheHighGround = void 0;
  Object.defineProperty(exports, "TimePicker", {
    enumerable: true,
    get: function get() {
      return _TimePicker["default"];
    }
  });
  Object.defineProperty(exports, "Toggle", {
    enumerable: true,
    get: function get() {
      return _Toggle["default"];
    }
  });
  Object.defineProperty(exports, "ToggleFilter", {
    enumerable: true,
    get: function get() {
      return _ToggleFilter["default"];
    }
  });
  Object.defineProperty(exports, "Toolbar", {
    enumerable: true,
    get: function get() {
      return _Toolbar["default"];
    }
  });
  Object.defineProperty(exports, "Tooltip", {
    enumerable: true,
    get: function get() {
      return _Tooltip["default"];
    }
  });
  Object.defineProperty(exports, "TwitterImage", {
    enumerable: true,
    get: function get() {
      return _TwitterImage["default"];
    }
  });
  Object.defineProperty(exports, "TwitterVideo", {
    enumerable: true,
    get: function get() {
      return _TwitterVideo["default"];
    }
  });
  exports.Utils = void 0;
  Object.defineProperty(exports, "YouTubeDiscovery", {
    enumerable: true,
    get: function get() {
      return _YouTubeDiscovery["default"];
    }
  });
  Object.defineProperty(exports, "YouTubeInStream", {
    enumerable: true,
    get: function get() {
      return _YouTubeInStream["default"];
    }
  });
  Object.defineProperty(exports, "debounce", {
    enumerable: true,
    get: function get() {
      return _Debounce.debounce;
    }
  });
  exports["default"] = void 0;
  Object.defineProperty(exports, "formatBytes", {
    enumerable: true,
    get: function get() {
      return _functions2.formatBytes;
    }
  });
  Object.defineProperty(exports, "genSelectOpts", {
    enumerable: true,
    get: function get() {
      return _functions2.genSelectOpts;
    }
  });
  exports.hooks = void 0;
  Object.defineProperty(exports, "navigateBack", {
    enumerable: true,
    get: function get() {
      return _functions2.navigateBack;
    }
  });
  Object.defineProperty(exports, "tagGroupFormatter", {
    enumerable: true,
    get: function get() {
      return _TagGroupFormatter["default"];
    }
  });
  Object.defineProperty(exports, "throttle", {
    enumerable: true,
    get: function get() {
      return _Debounce.throttle;
    }
  });
  var _Header = _interopRequireDefault(__webpack_require__(419));
  var _Navbar = _interopRequireDefault(__webpack_require__(420));
  var _Pager = _interopRequireDefault(__webpack_require__(421));
  var _Tag = _interopRequireDefault(__webpack_require__(166));
  var _ToggleFilter = _interopRequireDefault(__webpack_require__(539));
  var _Toolbar = _interopRequireDefault(__webpack_require__(422));
  var _Tooltip = _interopRequireDefault(__webpack_require__(40));
  var _EnhancedTooltip = _interopRequireDefault(__webpack_require__(58));
  var _ProgressIndicator = _interopRequireDefault(__webpack_require__(242));
  var _EmptyItem = _interopRequireDefault(__webpack_require__(423));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _StatusIcon = _interopRequireDefault(__webpack_require__(542));
  var _MoreActions = _interopRequireWildcard(__webpack_require__(111));
  var _AppHeader = _interopRequireWildcard(__webpack_require__(424));
  var _PageHeader = _interopRequireDefault(__webpack_require__(545));
  var _ErrorBanner = _interopRequireDefault(__webpack_require__(546));
  var _BreadcrumbBar = _interopRequireDefault(__webpack_require__(547));
  var SessionStuff = _interopRequireWildcard(__webpack_require__(513));
  var _HighGround = _interopRequireDefault(__webpack_require__(550));
  var TheHighGround = _interopRequireWildcard(__webpack_require__(514));
  exports.TheHighGround = TheHighGround;
  var _DataGrid = _interopRequireDefault(__webpack_require__(392));
  var _CheckboxFilter = _interopRequireDefault(__webpack_require__(515));
  var _StringFilter = _interopRequireDefault(__webpack_require__(516));
  var _RangeFilter = _interopRequireDefault(__webpack_require__(517));
  var _DateFilter = _interopRequireDefault(__webpack_require__(531));
  var _FilterModalLauncher = _interopRequireDefault(__webpack_require__(489));
  var _FilterTag = _interopRequireDefault(__webpack_require__(606));
  var _HeaderFilter = _interopRequireDefault(__webpack_require__(607));
  var _CellFilter = _interopRequireDefault(__webpack_require__(532));
  var _ActionMenuCell = _interopRequireDefault(__webpack_require__(608));
  var _LinkAction = _interopRequireDefault(__webpack_require__(533));
  var _BasicAction = _interopRequireDefault(__webpack_require__(534));
  var _ControlWrapper = _interopRequireDefault(__webpack_require__(29));
  var _Button = _interopRequireDefault(__webpack_require__(61));
  var _Checkbox = _interopRequireDefault(__webpack_require__(99));
  var _CheckboxList = _interopRequireDefault(__webpack_require__(167));
  var _Dates = _interopRequireDefault(__webpack_require__(168));
  var _Dimensions = _interopRequireDefault(__webpack_require__(397));
  var _FormFooter = _interopRequireDefault(__webpack_require__(398));
  var _Input = _interopRequireDefault(__webpack_require__(87));
  var _form = __webpack_require__(114);
  var _RowController = _interopRequireDefault(__webpack_require__(170));
  var _Search = _interopRequireDefault(__webpack_require__(113));
  var _Select = _interopRequireDefault(__webpack_require__(64));
  var _TagGroup = _interopRequireDefault(__webpack_require__(172));
  var _Toggle = _interopRequireDefault(__webpack_require__(171));
  var _TimePicker = _interopRequireDefault(__webpack_require__(183));
  var _MultiSelectWithList = _interopRequireDefault(__webpack_require__(184));
  var _FileImport = _interopRequireDefault(__webpack_require__(399));
  var _Card = _interopRequireDefault(__webpack_require__(400));
  var _CreativeLabels = _interopRequireDefault(__webpack_require__(492));
  var _NewCard = _interopRequireDefault(__webpack_require__(245));
  var _ModalFooter = _interopRequireDefault(__webpack_require__(142));
  var _ModalHeader = _interopRequireDefault(__webpack_require__(141));
  var _NotificationController = _interopRequireDefault(__webpack_require__(401));
  var _NotificationItem = _interopRequireDefault(__webpack_require__(240));
  var _Tabs = _interopRequireDefault(__webpack_require__(402));
  var _Blade = _interopRequireWildcard(__webpack_require__(494));
  var _SocialPreview = _interopRequireDefault(__webpack_require__(495));
  var _PreviewError = _interopRequireDefault(__webpack_require__(445));
  var _FacebookImage = _interopRequireDefault(__webpack_require__(433));
  var _FacebookVideo = _interopRequireDefault(__webpack_require__(434));
  var _FacebookCarousel = _interopRequireDefault(__webpack_require__(468));
  var _GoogleDiscovery = _interopRequireDefault(__webpack_require__(469));
  var _GoogleDiscoveryCarousel = _interopRequireDefault(__webpack_require__(470));
  var _LinkedInImage = _interopRequireDefault(__webpack_require__(435));
  var _LinkedInVideo = _interopRequireDefault(__webpack_require__(436));
  var _LinkedInCarousel = _interopRequireDefault(__webpack_require__(471));
  var _PinterestImage = _interopRequireDefault(__webpack_require__(437));
  var _PinterestVideo = _interopRequireDefault(__webpack_require__(438));
  var _PinterestCarousel = _interopRequireDefault(__webpack_require__(472));
  var _SnapchatImage = _interopRequireDefault(__webpack_require__(439));
  var _SnapchatVideo = _interopRequireDefault(__webpack_require__(440));
  var _TwitterImage = _interopRequireDefault(__webpack_require__(441));
  var _TwitterVideo = _interopRequireDefault(__webpack_require__(442));
  var _YouTubeDiscovery = _interopRequireDefault(__webpack_require__(443));
  var _YouTubeInStream = _interopRequireDefault(__webpack_require__(444));
  var RDG = _interopRequireWildcard(__webpack_require__(244));
  exports.ReactDataGrid = RDG;
  var RDA = _interopRequireWildcard(__webpack_require__(431));
  exports.ReactDataGridAddons = RDA;
  var Constants = _interopRequireWildcard(__webpack_require__(59));
  exports.Constants = Constants;
  var Functions = _interopRequireWildcard(__webpack_require__(33));
  exports.Functions = Functions;
  var _Debounce = __webpack_require__(403);
  var _TagGroupFormatter = _interopRequireDefault(__webpack_require__(404));
  var _functions2 = __webpack_require__(33);
  var _constants2 = __webpack_require__(59);
  var _Icons = _interopRequireDefault(__webpack_require__(34));
  var _SharedPropTypes = _interopRequireDefault(__webpack_require__(27));
  var SocialHelpers = _interopRequireWildcard(__webpack_require__(46));
  exports.SocialHelpers = SocialHelpers;
  var Dictionaries = _interopRequireWildcard(__webpack_require__(138));
  exports.Dictionaries = Dictionaries;
  var _ConfirmModal = _interopRequireWildcard(__webpack_require__(432));
  var _AccountModal = _interopRequireWildcard(__webpack_require__(426));
  var _useClickOutsideHandler = _interopRequireDefault(__webpack_require__(425));
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var Form = {
      ControlWrapper: _ControlWrapper["default"],
      Button: _Button["default"],
      Checkbox: _Checkbox["default"],
      CheckboxList: _CheckboxList["default"],
      Dates: _Dates["default"],
      Dimensions: _Dimensions["default"],
      FormFooter: _FormFooter["default"],
      Input: _Input["default"],
      ReduxControls: _form.ReduxControls,
      RowController: _RowController["default"],
      Search: _Search["default"],
      Select: _Select["default"],
      TagGroup: _TagGroup["default"],
      Toggle: _Toggle["default"],
      TimePicker: _TimePicker["default"],
      MultiSelectWithList: _MultiSelectWithList["default"],
      FileImport: _FileImport["default"]
    },
    Layout = {
      Card: _Card["default"],
      CreativeLabels: _CreativeLabels["default"],
      NewCard: _NewCard["default"],
      Modal: _Blade["default"],
      ModalFooter: _ModalFooter["default"],
      ModalHeader: _ModalHeader["default"],
      NotificationController: _NotificationController["default"],
      NotificationItem: _NotificationItem["default"],
      Tabs: _Tabs["default"],
      Blade: _Blade["default"],
      ErrorBanner: _ErrorBanner["default"],
      BreadcrumbBar: _BreadcrumbBar["default"]
    },
    Utils = {
      debounce: _Debounce.debounce,
      throttle: _Debounce.throttle,
      tagGroupFormatter: _TagGroupFormatter["default"],
      navigateBack: _functions2.navigateBack
    },
    SES = {
      TheSaga: SessionStuff.TheSaga,
      actions: SessionStuff.SESSION_ACTIONS,
      initialState: SessionStuff.IT,
      handler: SessionStuff.SESSION_HANDLERS,
      TheHighGround: TheHighGround
    },
    SesModal = SessionStuff["default"],
    Confirm = _objectSpread({
      ConfirmModal: _ConfirmModal["default"]
    }, _ConfirmModal.CONFIRM_REDUX),
    Rhombus = {
      version: "$$trackingVersion",
      Form: Form,
      Layout: Layout,
      Utils: Utils,
      DataGrid: _DataGrid["default"],
      Header: _Header["default"],
      AppHeader: _AppHeader["default"],
      AppHelp: _AppHeader.HelpItem,
      Navbar: _Navbar["default"],
      Pager: _Pager["default"],
      SessionModal: SessionStuff["default"],
      HighGround: _HighGround["default"],
      ProgressIndicator: _ProgressIndicator["default"],
      EmptyItem: _EmptyItem["default"],
      Tag: _Tag["default"],
      ToggleFilter: _ToggleFilter["default"],
      Toolbar: _Toolbar["default"],
      Tooltip: _Tooltip["default"],
      MoreActions: _MoreActions.MoreActions,
      ActionsComponent: _MoreActions.ActionsComponent,
      Icon: _Icon["default"],
      StatusIcon: _StatusIcon["default"],
      // For backwards compatible - map Rhombicon to Icon
      Rhombicon: _Icon["default"],
      IconMap: _Icons["default"]
    },
    hooks = {
      useClickOutsideHandler: _useClickOutsideHandler["default"]
    };

  //not sure why we can't just do export Form;
  exports.hooks = hooks;
  exports.Confirm = Confirm;
  exports.SessionModal = SesModal;
  exports.Session = SES;
  exports.Utils = Utils;
  exports.Layout = Layout;
  exports.Form = Form;
  var Account = _objectSpread({
    AccountModal: _AccountModal["default"]
  }, _AccountModal.ACCOUNT_REDUX);
  exports.Account = Account;
  var _default = Rhombus;
  exports["default"] = _default;

  /***/
}, /* 539 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ToggleFilter;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _Tooltip = _interopRequireDefault(__webpack_require__(40));
  __webpack_require__(540);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ToggleFilter(props) {
    var $icons = {};
    $icons = props.values.map(function (v, i) {
      var value = v.value || v.name,
        isActive = props.selectedView.indexOf(value) >= 0 ? "is-active" : "",
        title = props.itemTitle ? props.itemTitle(isActive, v) : "Toggle ".concat(v.name, " view"),
        isDisabled = props.disabled ? "is-disabled" : "",
        liProps = {
          title: title,
          className: "flex-center cursor-pointer toggle-icon ".concat(isActive, " ").concat(isDisabled)
        };
      if (!props.disabled) {
        liProps.onClick = function () {
          return props.onViewChange(v.value || v.name, !isActive);
        };
      }
      var $icon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: v.icon
      });
      var $text = props.iconsOnly ? null : /*#__PURE__*/_react["default"].createElement("span", {
        className: "view-name"
      }, v.name);
      if (props.showTooltips) {
        return /*#__PURE__*/_react["default"].createElement("li", _extends({
          key: v.name
        }, liProps), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          description: "Toggle ".concat(v.name, " View"),
          direction: "top"
        }, $icon, $text));
      } else {
        return /*#__PURE__*/_react["default"].createElement("li", _extends({
          key: v.name
        }, liProps), $icon, $text);
      }
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "toggle-filter-icons flex-center ".concat(props.className)
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: "view-changer"
    }, $icons));
  }
  ToggleFilter.defaultProps = {
    className: "",
    values: [],
    selectedView: [],
    onViewChange: function onViewChange() {},
    itemTitle: null,
    disabled: false,
    iconsOnly: false,
    showTooltips: false
  };
  ToggleFilter.propTypes = {
    /** Optional class(es) for customizing css */
    className: _propTypes["default"].string,
    /** Array of config objects for setting the content of the buttons */
    values: _propTypes["default"].array.isRequired,
    /** Currently selected value(s) */
    selectedView: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]).isRequired,
    /** Callback function for when a button is toggled */
    onViewChange: _propTypes["default"].func.isRequired,
    /** Removes text from buttons, showing icons only */
    iconsOnly: _propTypes["default"].bool,
    /** Enable tooltip messages on hover */
    showTooltips: _propTypes["default"].bool,
    /** Function for customizing button title based on item name and whether or not it is active */
    itemTitle: _propTypes["default"].func,
    /** Disables the entire component */
    disabled: _propTypes["default"].bool
  };

  /***/
}, /* 540 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(541);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 541 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "\n.toggle-filter-icons .view-changer {\n\tdisplay: inline-flex;\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n.toggle-filter-icons .view-changer li {\n\tborder-radius: 0;\n\theight: 26px;\n\tbackground-color: #fff;\n\tborder: solid 1px #d6d8da;\n\tcolor: #5e666b;\n\tpadding: 0 7px;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\ttransition: 0.35s ease;\n}\n.toggle-filter-icons .view-changer .is-disabled {\n\tcursor: not-allowed;\n\topacity: 0.5;\n}\n.toggle-filter-icons .toggle-icon .ft-ic {\n\tcolor: #5e666b;\n\tfont-size: 13px;\n}\n.toggle-filter-icons .view-changer li.is-active {\n\tbackground-color: #5e666b;\n\tcolor: #fff;\n}\n.toggle-filter-icons .view-changer li:not(.is-disabled):hover {\n\tbackground-color: rgba(100, 122, 137, 0.5);\n\tcolor: #5e666b;\n\tbackground-color: #d6d8da;\n}\n.toggle-filter-icons .view-changer li.is-active .ft-ic { color: #fff; }\n\n.toggle-filter-icons .view-changer li:first-child {\n\tborder-radius: 3px 0 0 3px;\n}\n.toggle-filter-icons .view-changer li:last-child {\n\tborder-radius: 0 3px 3px 0;\n}\n.toggle-filter-icons .view-changer li:only-child {\n\tborder-radius:3px;\n\tborder:1px solid #d6d8da;\n}\n.toggle-filter-icons .view-changer .view-name { margin-left: 5px; }\n\n.toggle-filter-icons .view-changer li:not(:last-child){ border-right: 0; }", "", {
    "version": 3,
    "sources": ["ToggleFilter.css"],
    "names": [],
    "mappings": ";AACA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;AACA;CACC,gBAAgB;CAChB,YAAY;CACZ,sBAAsB;CACtB,yBAAyB;CACzB,cAAc;CACd,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,sBAAsB;AACvB;AACA;CACC,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,cAAc;CACd,eAAe;AAChB;AACA;CACC,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,0CAA0C;CAC1C,cAAc;CACd,yBAAyB;AAC1B;AACA,yDAAyD,WAAW,EAAE;;AAEtE;CACC,0BAA0B;AAC3B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,iBAAiB;CACjB,wBAAwB;AACzB;AACA,gDAAgD,gBAAgB,EAAE;;AAElE,wDAAwD,eAAe,EAAE",
    "file": "ToggleFilter.css",
    "sourcesContent": ["\n.toggle-filter-icons .view-changer {\n\tdisplay: inline-flex;\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n.toggle-filter-icons .view-changer li {\n\tborder-radius: 0;\n\theight: 26px;\n\tbackground-color: #fff;\n\tborder: solid 1px #d6d8da;\n\tcolor: #5e666b;\n\tpadding: 0 7px;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\ttransition: 0.35s ease;\n}\n.toggle-filter-icons .view-changer .is-disabled {\n\tcursor: not-allowed;\n\topacity: 0.5;\n}\n.toggle-filter-icons .toggle-icon .ft-ic {\n\tcolor: #5e666b;\n\tfont-size: 13px;\n}\n.toggle-filter-icons .view-changer li.is-active {\n\tbackground-color: #5e666b;\n\tcolor: #fff;\n}\n.toggle-filter-icons .view-changer li:not(.is-disabled):hover {\n\tbackground-color: rgba(100, 122, 137, 0.5);\n\tcolor: #5e666b;\n\tbackground-color: #d6d8da;\n}\n.toggle-filter-icons .view-changer li.is-active .ft-ic { color: #fff; }\n\n.toggle-filter-icons .view-changer li:first-child {\n\tborder-radius: 3px 0 0 3px;\n}\n.toggle-filter-icons .view-changer li:last-child {\n\tborder-radius: 0 3px 3px 0;\n}\n.toggle-filter-icons .view-changer li:only-child {\n\tborder-radius:3px;\n\tborder:1px solid #d6d8da;\n}\n.toggle-filter-icons .view-changer .view-name { margin-left: 5px; }\n\n.toggle-filter-icons .view-changer li:not(:last-child){ border-right: 0; }"]
  }]);

  /***/
}, /* 542 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = StatusIcon;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  __webpack_require__(543);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  /**
   * Status Icon
   */

  function StatusIcon(props) {
    var status = props.status,
      iconStatus = iconStatus = status.toLowerCase().replace(/\s/gi, "-");
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "status-icon status-".concat(iconStatus, "-div")
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      name: iconStatus,
      title: status,
      className: "status-".concat(iconStatus)
    }));
  }
  StatusIcon.defaultProps = {
    status: "active"
  };
  StatusIcon.propTypes = {
    status: _propTypes["default"].string.isRequired
  };

  /***/
}, /* 543 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(544);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 544 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "/**\n * Status Icon Styles\n */\n.status-icon {\n\n}\n.campaign-name-cell .status-icon .ft-ic,\n.name-cell .status-icon .ft-ic { font-size: 10px; }\n\n.status-icon .status-generating,\n.status-icon .status-in-queue {\n\tcolor: #909090;\n\tanimation: rotateInACircle 2s linear infinite;\n}\n\n.status-icon .status-approved,\n.status-icon .status-active,\n.status-icon .status-live { color: #52bc68; }\n\n.status-icon .status-unsubmitted { color:#f69d00 }\n.status-icon .status-available { color: #52bc68; }\n\n.status-icon .status-draft { color: #9b9b9b; }\n.status-icon .status-is-closed { color: #000; }\n\n.status-icon .status-stopped { color: #858c90; }\n.status-icon .status-error { color: #d0021b; }\n", "", {
    "version": 3,
    "sources": ["StatusIcon.css"],
    "names": [],
    "mappings": "AAAA;;EAEE;AACF;;AAEA;AACA;iCACiC,eAAe,EAAE;;AAElD;;CAEC,cAAc;CACd,6CAA6C;AAC9C;;AAEA;;4BAE4B,cAAc,EAAE;;AAE5C,mCAAmC,cAAc;AACjD,iCAAiC,cAAc,EAAE;;AAEjD,6BAA6B,cAAc,EAAE;AAC7C,iCAAiC,WAAW,EAAE;;AAE9C,+BAA+B,cAAc,EAAE;AAC/C,6BAA6B,cAAc,EAAE",
    "file": "StatusIcon.css",
    "sourcesContent": ["/**\n * Status Icon Styles\n */\n.status-icon {\n\n}\n.campaign-name-cell .status-icon .ft-ic,\n.name-cell .status-icon .ft-ic { font-size: 10px; }\n\n.status-icon .status-generating,\n.status-icon .status-in-queue {\n\tcolor: #909090;\n\tanimation: rotateInACircle 2s linear infinite;\n}\n\n.status-icon .status-approved,\n.status-icon .status-active,\n.status-icon .status-live { color: #52bc68; }\n\n.status-icon .status-unsubmitted { color:#f69d00 }\n.status-icon .status-available { color: #52bc68; }\n\n.status-icon .status-draft { color: #9b9b9b; }\n.status-icon .status-is-closed { color: #000; }\n\n.status-icon .status-stopped { color: #858c90; }\n.status-icon .status-error { color: #d0021b; }\n"]
  }]);

  /***/
}, /* 545 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = PageHeader;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function PageHeader(props) {
    var title = props.title;
    if (!title || title.length === 0) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "c-page-header ".concat(props.isSticky ? "is-sticky" : "")
    }, title);
  }
  PageHeader.defaultProps = {
    isSticky: true
  };
  PageHeader.propTypes = {
    /* The text to display on the screen */
    title: _propTypes["default"].string.isRequired,
    /* Should the component remain sticky to the top of the screen */
    isSticky: _propTypes["default"].bool
  };

  /***/
}, /* 546 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _classnames2 = _interopRequireDefault(__webpack_require__(6));
  var _autobindDecorator = _interopRequireDefault(__webpack_require__(18));
  var _Icon = _interopRequireDefault(__webpack_require__(8));
  var _class, _class2;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }
    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
      Object.defineProperty(target, property, desc);
      desc = null;
    }
    return desc;
  }
  var uniqueId = 0;
  var ErrorBanner = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    _inherits(ErrorBanner, _React$Component);
    var _super = _createSuper(ErrorBanner);
    function ErrorBanner() {
      _classCallCheck(this, ErrorBanner);
      return _super.apply(this, arguments);
    }
    _createClass(ErrorBanner, [{
      key: "getErrorKey",
      value: function getErrorKey() {
        uniqueId += 1;
        return "".concat(this.props.type, "-error-key-").concat(uniqueId);
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;
        var _this$props = this.props,
          messages = _this$props.messages,
          title = _this$props.title,
          bannerType = _this$props.bannerType,
          shouldDisplay = _this$props.shouldDisplay,
          hasMessages = messages && messages.length > 0,
          wrapperClass = (0, _classnames2["default"])(_defineProperty({
            "error-banner-container": true,
            "error-banner-no-messages": !hasMessages
          }, bannerType, true));
        if (!shouldDisplay) {
          return null;
        }
        var $messages;
        if (hasMessages) {
          $messages = /*#__PURE__*/_react["default"].createElement("div", {
            className: "error-banner-content"
          }, /*#__PURE__*/_react["default"].createElement("ul", null, messages.map(function (message) {
            return /*#__PURE__*/_react["default"].createElement("li", {
              key: _this.getErrorKey()
            }, /*#__PURE__*/_react["default"].createElement("span", {
              className: "error-banner-message"
            }, message));
          })));
        }
        var icon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          name: "errorT"
        });
        if (bannerType === 'success') {
          icon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            name: "success"
          });
        } else if (bannerType === 'info') {
          icon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            name: "infoC"
          });
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: wrapperClass
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "error-banner-header"
        }, icon, title), $messages);
      }
    }]);
    return ErrorBanner;
  }(_react["default"].Component), _defineProperty(_class2, "propTypes", {
    messages: _propTypes["default"].arrayOf(_propTypes["default"].node),
    title: _propTypes["default"].string,
    type: _propTypes["default"].string,
    bannerType: _propTypes["default"].oneOf(["info", "success", "error", "warn"])
  }), _defineProperty(_class2, "defaultProps", {
    title: "Oops, looks like something went wrong!",
    type: "campaign",
    bannerType: "error",
    shouldDisplay: true // Set to true by default to allow Error Banners with only a title to render
  }), _class2), _applyDecoratedDescriptor(_class.prototype, "getErrorKey", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getErrorKey"), _class.prototype), _class);
  exports["default"] = ErrorBanner;

  /***/
}, /* 547 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = BreadcrumbBar;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function TransitionSVG(_ref) {
    var index = _ref.index,
      currentStep = _ref.currentStep,
      numSteps = _ref.numSteps;
    if (index === numSteps - 1) {
      return null;
    }
    var isLeftActive = index === currentStep;
    var isRightActive = index === currentStep - 1;
    return /*#__PURE__*/_react["default"].createElement("svg", {
      viewBox: "0 0 18 45"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      className: "transition ".concat(isLeftActive ? "active" : ""),
      d: " M 0 0 L 0 45 L 16 22.5 "
    }), /*#__PURE__*/_react["default"].createElement("path", {
      className: "transition ".concat(isRightActive ? "active" : ""),
      d: " M 2 0 L 18 22.5 L 2 45 L 18 45 L 18 0 "
    }), /*#__PURE__*/_react["default"].createElement("path", {
      className: "transition-chevron",
      d: " M 0 -2 L 16 22.5 L 0 47 "
    }));
  }
  function BreadcrumbBar(_ref2) {
    var _ref2$stepNames = _ref2.stepNames,
      stepNames = _ref2$stepNames === void 0 ? ["..."] : _ref2$stepNames,
      _ref2$currentStep = _ref2.currentStep,
      currentStep = _ref2$currentStep === void 0 ? 0 : _ref2$currentStep;
    var numSteps = stepNames.length;
    var segments = stepNames.map(function (name, index) {
      var isDone = index < currentStep;
      var active = index === currentStep ? "active" : "";
      var done = isDone ? "done" : "";
      var displayNumber = isDone ? /*#__PURE__*/_react["default"].createElement("i", {
        className: "fas fa-check"
      }) : index + 1;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: name
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "step ".concat(active, " ").concat(done)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "step-number"
      }, displayNumber), name), /*#__PURE__*/_react["default"].createElement(TransitionSVG, {
        index: index,
        currentStep: currentStep,
        numSteps: numSteps
      }));
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "breadcrumb-bar"
    }, segments);
  }
  BreadcrumbBar.displayName = "BreadcrumbBar";
  BreadcrumbBar.propTypes = {
    /** the names of the breadcrumbs */
    stepNames: _propTypes["default"].arrayOf(_propTypes["default"].string),
    /** what step in the breadcrumbs are we on? */
    currentStep: _propTypes["default"].number
  };

  /***/
}, /* 548 */
/***/function (module, exports, __webpack_require__) {
  // style-loader: Adds some css to the DOM by adding a <style> tag

  // load the styles
  var content = __webpack_require__(549);
  if (typeof content === 'string') content = [[module.i, content, '']];
  // add the styles to the DOM
  var update = __webpack_require__(24)(content, {});
  // Hot Module Replacement
  if (false) {}

  /***/
}, /* 549 */
/***/function (module, exports, __webpack_require__) {
  exports = module.exports = __webpack_require__(23)(true);
  // Module
  exports.push([module.i, "\n.session-modal .session-modal-content {\n\tmax-width: 700px;\n\tpadding: 30px;\n\t/* height: 340px; */\n}\n.session-modal { height: 390px; }\n.session-modal.is-expired { height: 230px; }\n\n.session-modal .message {\n\twidth: 75%;\n\ttext-align: center;\n\tmargin: 0 auto 27px;\n}\n.session-modal.is-expired .message { margin-bottom: 0; }\n\n.countdown-container {\n\tborder-radius: 3px;\n\tbackground-color: #eaebec;\n\tfont-size: 14px;\n\tcolor: #374047;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-direction: column;\n\theight: 130px;\n}\n.countdown-container p { margin: 0; }\n.countdown-container .time-remaining { font-size: 36px; }\n\n.session-modal .session-buttons .c-actions-bar { justify-content: flex-end; }\n", "", {
    "version": 3,
    "sources": ["SessionModal.css"],
    "names": [],
    "mappings": ";AACA;CACC,gBAAgB;CAChB,aAAa;CACb,mBAAmB;AACpB;AACA,iBAAiB,aAAa,EAAE;AAChC,4BAA4B,aAAa,EAAE;;AAE3C;CACC,UAAU;CACV,kBAAkB;CAClB,mBAAmB;AACpB;AACA,qCAAqC,gBAAgB,EAAE;;AAEvD;CACC,kBAAkB;CAClB,yBAAyB;CACzB,eAAe;CACf,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;CACtB,aAAa;AACd;AACA,yBAAyB,SAAS,EAAE;AACpC,uCAAuC,eAAe,EAAE;;AAExD,iDAAiD,yBAAyB,EAAE",
    "file": "SessionModal.css",
    "sourcesContent": ["\n.session-modal .session-modal-content {\n\tmax-width: 700px;\n\tpadding: 30px;\n\t/* height: 340px; */\n}\n.session-modal { height: 390px; }\n.session-modal.is-expired { height: 230px; }\n\n.session-modal .message {\n\twidth: 75%;\n\ttext-align: center;\n\tmargin: 0 auto 27px;\n}\n.session-modal.is-expired .message { margin-bottom: 0; }\n\n.countdown-container {\n\tborder-radius: 3px;\n\tbackground-color: #eaebec;\n\tfont-size: 14px;\n\tcolor: #374047;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-direction: column;\n\theight: 130px;\n}\n.countdown-container p { margin: 0; }\n.countdown-container .time-remaining { font-size: 36px; }\n\n.session-modal .session-buttons .c-actions-bar { justify-content: flex-end; }\n"]
  }]);

  /***/
}, /* 550 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = HighGround;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _SessionModal = _interopRequireWildcard(__webpack_require__(513));
  var _functions = __webpack_require__(33);
  var _TheHighGround = __webpack_require__(514);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  var ONE_MIN_MILI = 60 * 1000;
  function HighGround(_ref) {
    var dispatch = _ref.dispatch,
      onContinue = _ref.onContinue,
      sessionType = _ref.sessionType,
      sessionLength = _ref.sessionLength,
      channelName = _ref.channelName,
      countdown = _ref.countdown,
      offset = _ref.offset,
      isDebug = _ref.isDebug;
    var modalProps = {
      type: sessionType,
      length: sessionLength,
      onContinue: onContinue,
      extraModalProps: {
        underlayStyle: {
          zIndex: 1060
        }
      }
    };
    (0, _react.useEffect)(function () {
      if (sessionType === "countdown") {
        isDebug && console.log("Counting down");
      } else if (sessionType === "expired") {
        window.theSaga.completes(dispatch);
        (0, _TheHighGround.itsOver)();
      }
    }, [sessionType]);
    (0, _react.useEffect)(function () {
      /**
       * Session Length and Countdown are in minutes
       * setTimeout() and setInterval() are in miliseconds
       *
       * Multiple the minutes by:
       * * 60 (seconds in a minute)
       * * 1000 (miliseconds in a second)
       *
       */
      window.theSaga = new _SessionModal.TheSaga(sessionLength * ONE_MIN_MILI, countdown * ONE_MIN_MILI, offset);
      (0, _TheHighGround.theHighGround)(channelName, isDebug);
      window.theSaga.begins(dispatch);
      (0, _TheHighGround.onMessage)(function (mess) {
        if (mess.data.type === "continue") {
          isDebug && console.log("It's an older code sir, but it checks out", mess);
          window.theSaga.begins(dispatch);
        } else {
          isDebug && console.log("We had a reactor leak", mess);
          window.theSaga.completes(dispatch);
        }
      });
      return function () {
        (0, _TheHighGround.itsOver)();
      };
    }, []);
    if (!sessionType || sessionType === null) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    }
    if (/expired/gi.test(sessionType)) {
      modalProps.title = "Session Expired";
    }
    return /*#__PURE__*/_react["default"].createElement(_SessionModal["default"], modalProps);
  }
  HighGround.displayName = "HighGround";
  HighGround.defaultProps = {
    isDebug: false,
    sessionLength: 30,
    countdown: 5,
    offset: 0,
    onContinue: _functions.noop,
    dispatch: _functions.noop,
    sessionType: null,
    channelName: undefined
  };
  HighGround.propTypes = {
    /** Show console.log messages */
    isDebug: _propTypes["default"].bool,
    /** Length of time (in minutes) for the Session  */
    sessionLength: _propTypes["default"].number,
    /** Length of time (in minutes) before the confirm modal shows up */
    countdown: _propTypes["default"].number,
    /** Offset property for TheSaga */
    offset: _propTypes["default"].number,
    /** What should we dispatch when we click "Continue".  95% of the time, this will be a dispatch() to the reloadUser() method */
    onContinue: _propTypes["default"].func.isRequired,
    /** Redux dispatch() function.  It's easier to just pass this in than worry about wrapping it correctly */
    dispatch: _propTypes["default"].func.isRequired,
    /** What is the current session type - none|coundtodn|expired */
    sessionType: _propTypes["default"].oneOf([null, "countdown", "expired"]),
    /** Channel name passed to TheHighGround */
    channelName: _propTypes["default"].string
  };

  /***/
}, /* 551 */
/***/function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(552),
    __esModule: true
  };

  /***/
}, /* 552 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(553);
  module.exports = __webpack_require__(238).Object.assign;

  /***/
}, /* 553 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.3.1 Object.assign(target, source)
  var $export = __webpack_require__(393);
  $export($export.S + $export.F, 'Object', {
    assign: __webpack_require__(555)
  });

  /***/
}, /* 554 */
/***/function (module, exports) {
  module.exports = function (it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
  };

  /***/
}, /* 555 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  // 19.1.2.1 Object.assign(target, source, ...)
  var DESCRIPTORS = __webpack_require__(396);
  var getKeys = __webpack_require__(463);
  var gOPS = __webpack_require__(483);
  var pIE = __webpack_require__(466);
  var toObject = __webpack_require__(458);
  var IObject = __webpack_require__(521);
  var $assign = Object.assign;

  // should work with symbols and should have deterministic property order (V8 bug)
  module.exports = !$assign || __webpack_require__(430)(function () {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) {
      B[k] = k;
    });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
  }) ? function assign(target, source) {
    // eslint-disable-line no-unused-vars
    var T = toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = gOPS.f;
    var isEnum = pIE.f;
    while (aLen > index) {
      var S = IObject(arguments[index++]);
      var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
      var length = keys.length;
      var j = 0;
      var key;
      while (length > j) {
        key = keys[j++];
        if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
      }
    }
    return T;
  } : $assign;

  /***/
}, /* 556 */
/***/function (module, exports, __webpack_require__) {
  // false -> Array#indexOf
  // true  -> Array#includes
  var toIObject = __webpack_require__(413);
  var toLength = __webpack_require__(522);
  var toAbsoluteIndex = __webpack_require__(557);
  module.exports = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = toIObject($this);
      var length = toLength(O.length);
      var index = toAbsoluteIndex(fromIndex, length);
      var value;
      // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare
      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++];
        // eslint-disable-next-line no-self-compare
        if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
      } else for (; length > index; index++) if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
      return !IS_INCLUDES && -1;
    };
  };

  /***/
}, /* 557 */
/***/function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(479);
  var max = Math.max;
  var min = Math.min;
  module.exports = function (index, length) {
    index = toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
  };

  /***/
}, /* 558 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(559);
  var $Object = __webpack_require__(238).Object;
  module.exports = function defineProperty(it, key, desc) {
    return $Object.defineProperty(it, key, desc);
  };

  /***/
}, /* 559 */
/***/function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(393);
  // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
  $export($export.S + $export.F * !__webpack_require__(396), 'Object', {
    defineProperty: __webpack_require__(395).f
  });

  /***/
}, /* 560 */
/***/function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(561),
    __esModule: true
  };

  /***/
}, /* 561 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(524);
  __webpack_require__(566);
  module.exports = __webpack_require__(486).f('iterator');

  /***/
}, /* 562 */
/***/function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(479);
  var defined = __webpack_require__(478);
  // true  -> String#at
  // false -> String#codePointAt
  module.exports = function (TO_STRING) {
    return function (that, pos) {
      var s = String(defined(that));
      var i = toInteger(pos);
      var l = s.length;
      var a, b;
      if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };

  /***/
}, /* 563 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var create = __webpack_require__(484);
  var descriptor = __webpack_require__(457);
  var setToStringTag = __webpack_require__(485);
  var IteratorPrototype = {};

  // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
  __webpack_require__(427)(IteratorPrototype, __webpack_require__(249)('iterator'), function () {
    return this;
  });
  module.exports = function (Constructor, NAME, next) {
    Constructor.prototype = create(IteratorPrototype, {
      next: descriptor(1, next)
    });
    setToStringTag(Constructor, NAME + ' Iterator');
  };

  /***/
}, /* 564 */
/***/function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(395);
  var anObject = __webpack_require__(428);
  var getKeys = __webpack_require__(463);
  module.exports = __webpack_require__(396) ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = getKeys(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while (length > i) dP.f(O, P = keys[i++], Properties[P]);
    return O;
  };

  /***/
}, /* 565 */
/***/function (module, exports, __webpack_require__) {
  var document = __webpack_require__(394).document;
  module.exports = document && document.documentElement;

  /***/
}, /* 566 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(567);
  var global = __webpack_require__(394);
  var hide = __webpack_require__(427);
  var Iterators = __webpack_require__(459);
  var TO_STRING_TAG = __webpack_require__(249)('toStringTag');
  var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');
  for (var i = 0; i < DOMIterables.length; i++) {
    var NAME = DOMIterables[i];
    var Collection = global[NAME];
    var proto = Collection && Collection.prototype;
    if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = Iterators.Array;
  }

  /***/
}, /* 567 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var addToUnscopables = __webpack_require__(568);
  var step = __webpack_require__(569);
  var Iterators = __webpack_require__(459);
  var toIObject = __webpack_require__(413);

  // 22.1.3.4 Array.prototype.entries()
  // 22.1.3.13 Array.prototype.keys()
  // 22.1.3.29 Array.prototype.values()
  // 22.1.3.30 Array.prototype[@@iterator]()
  module.exports = __webpack_require__(525)(Array, 'Array', function (iterated, kind) {
    this._t = toIObject(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
    // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
  }, function () {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
      this._t = undefined;
      return step(1);
    }
    if (kind == 'keys') return step(0, index);
    if (kind == 'values') return step(0, O[index]);
    return step(0, [index, O[index]]);
  }, 'values');

  // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
  Iterators.Arguments = Iterators.Array;
  addToUnscopables('keys');
  addToUnscopables('values');
  addToUnscopables('entries');

  /***/
}, /* 568 */
/***/function (module, exports) {
  module.exports = function () {/* empty */};

  /***/
}, /* 569 */
/***/function (module, exports) {
  module.exports = function (done, value) {
    return {
      value: value,
      done: !!done
    };
  };

  /***/
}, /* 570 */
/***/function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(571),
    __esModule: true
  };

  /***/
}, /* 571 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(572);
  __webpack_require__(577);
  __webpack_require__(578);
  __webpack_require__(579);
  module.exports = __webpack_require__(238).Symbol;

  /***/
}, /* 572 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  // ECMAScript 6 symbols shim
  var global = __webpack_require__(394);
  var has = __webpack_require__(412);
  var DESCRIPTORS = __webpack_require__(396);
  var $export = __webpack_require__(393);
  var redefine = __webpack_require__(526);
  var META = __webpack_require__(573).KEY;
  var $fails = __webpack_require__(430);
  var shared = __webpack_require__(481);
  var setToStringTag = __webpack_require__(485);
  var uid = __webpack_require__(465);
  var wks = __webpack_require__(249);
  var wksExt = __webpack_require__(486);
  var wksDefine = __webpack_require__(487);
  var enumKeys = __webpack_require__(574);
  var isArray = __webpack_require__(575);
  var anObject = __webpack_require__(428);
  var isObject = __webpack_require__(429);
  var toObject = __webpack_require__(458);
  var toIObject = __webpack_require__(413);
  var toPrimitive = __webpack_require__(476);
  var createDesc = __webpack_require__(457);
  var _create = __webpack_require__(484);
  var gOPNExt = __webpack_require__(576);
  var $GOPD = __webpack_require__(488);
  var $GOPS = __webpack_require__(483);
  var $DP = __webpack_require__(395);
  var $keys = __webpack_require__(463);
  var gOPD = $GOPD.f;
  var dP = $DP.f;
  var gOPN = gOPNExt.f;
  var $Symbol = global.Symbol;
  var $JSON = global.JSON;
  var _stringify = $JSON && $JSON.stringify;
  var PROTOTYPE = 'prototype';
  var HIDDEN = wks('_hidden');
  var TO_PRIMITIVE = wks('toPrimitive');
  var isEnum = {}.propertyIsEnumerable;
  var SymbolRegistry = shared('symbol-registry');
  var AllSymbols = shared('symbols');
  var OPSymbols = shared('op-symbols');
  var ObjectProto = Object[PROTOTYPE];
  var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
  var QObject = global.QObject;
  // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
  var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

  // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
  var setSymbolDesc = DESCRIPTORS && $fails(function () {
    return _create(dP({}, 'a', {
      get: function () {
        return dP(this, 'a', {
          value: 7
        }).a;
      }
    })).a != 7;
  }) ? function (it, key, D) {
    var protoDesc = gOPD(ObjectProto, key);
    if (protoDesc) delete ObjectProto[key];
    dP(it, key, D);
    if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
  } : dP;
  var wrap = function (tag) {
    var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
    sym._k = tag;
    return sym;
  };
  var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
    return typeof it == 'symbol';
  } : function (it) {
    return it instanceof $Symbol;
  };
  var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
    anObject(it);
    key = toPrimitive(key, true);
    anObject(D);
    if (has(AllSymbols, key)) {
      if (!D.enumerable) {
        if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
        D = _create(D, {
          enumerable: createDesc(0, false)
        });
      }
      return setSymbolDesc(it, key, D);
    }
    return dP(it, key, D);
  };
  var $defineProperties = function defineProperties(it, P) {
    anObject(it);
    var keys = enumKeys(P = toIObject(P));
    var i = 0;
    var l = keys.length;
    var key;
    while (l > i) $defineProperty(it, key = keys[i++], P[key]);
    return it;
  };
  var $create = function create(it, P) {
    return P === undefined ? _create(it) : $defineProperties(_create(it), P);
  };
  var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key = toPrimitive(key, true));
    if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };
  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = toIObject(it);
    key = toPrimitive(key, true);
    if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
    var D = gOPD(it, key);
    if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
    return D;
  };
  var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN(toIObject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
      if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
    }
    return result;
  };
  var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto;
    var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
      if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
    }
    return result;
  };

  // 19.4.1.1 Symbol([description])
  if (!USE_NATIVE) {
    $Symbol = function Symbol() {
      if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
      var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
      var $set = function (value) {
        if (this === ObjectProto) $set.call(OPSymbols, value);
        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, createDesc(1, value));
      };
      if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
        configurable: true,
        set: $set
      });
      return wrap(tag);
    };
    redefine($Symbol[PROTOTYPE], 'toString', function toString() {
      return this._k;
    });
    $GOPD.f = $getOwnPropertyDescriptor;
    $DP.f = $defineProperty;
    __webpack_require__(528).f = gOPNExt.f = $getOwnPropertyNames;
    __webpack_require__(466).f = $propertyIsEnumerable;
    $GOPS.f = $getOwnPropertySymbols;
    if (DESCRIPTORS && !__webpack_require__(464)) {
      redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }
    wksExt.f = function (name) {
      return wrap(wks(name));
    };
  }
  $export($export.G + $export.W + $export.F * !USE_NATIVE, {
    Symbol: $Symbol
  });
  for (var es6Symbols =
    // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
    'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) wks(es6Symbols[j++]);
  for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
  $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function (key) {
      return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
      if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
      for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
    },
    useSetter: function () {
      setter = true;
    },
    useSimple: function () {
      setter = false;
    }
  });
  $export($export.S + $export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
  });

  // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
  // https://bugs.chromium.org/p/v8/issues/detail?id=3443
  var FAILS_ON_PRIMITIVES = $fails(function () {
    $GOPS.f(1);
  });
  $export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
      return $GOPS.f(toObject(it));
    }
  });

  // 24.3.2 JSON.stringify(value [, replacer [, space]])
  $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
    var S = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return _stringify([S]) != '[null]' || _stringify({
      a: S
    }) != '{}' || _stringify(Object(S)) != '{}';
  })), 'JSON', {
    stringify: function stringify(it) {
      var args = [it];
      var i = 1;
      var replacer, $replacer;
      while (arguments.length > i) args.push(arguments[i++]);
      $replacer = replacer = args[1];
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return _stringify.apply($JSON, args);
    }
  });

  // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
  $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(427)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
  // 19.4.3.5 Symbol.prototype[@@toStringTag]
  setToStringTag($Symbol, 'Symbol');
  // 20.2.1.9 Math[@@toStringTag]
  setToStringTag(Math, 'Math', true);
  // 24.3.3 JSON[@@toStringTag]
  setToStringTag(global.JSON, 'JSON', true);

  /***/
}, /* 573 */
/***/function (module, exports, __webpack_require__) {
  var META = __webpack_require__(465)('meta');
  var isObject = __webpack_require__(429);
  var has = __webpack_require__(412);
  var setDesc = __webpack_require__(395).f;
  var id = 0;
  var isExtensible = Object.isExtensible || function () {
    return true;
  };
  var FREEZE = !__webpack_require__(430)(function () {
    return isExtensible(Object.preventExtensions({}));
  });
  var setMeta = function (it) {
    setDesc(it, META, {
      value: {
        i: 'O' + ++id,
        // object ID
        w: {} // weak collections IDs
      }
    });
  };

  var fastKey = function (it, create) {
    // return primitive with prefix
    if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F';
      // not necessary to add metadata
      if (!create) return 'E';
      // add missing metadata
      setMeta(it);
      // return object ID
    }
    return it[META].i;
  };
  var getWeak = function (it, create) {
    if (!has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true;
      // not necessary to add metadata
      if (!create) return false;
      // add missing metadata
      setMeta(it);
      // return hash weak collections IDs
    }
    return it[META].w;
  };
  // add metadata on freeze-family methods calling
  var onFreeze = function (it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
    return it;
  };
  var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
  };

  /***/
}, /* 574 */
/***/function (module, exports, __webpack_require__) {
  // all enumerable object keys, includes symbols
  var getKeys = __webpack_require__(463);
  var gOPS = __webpack_require__(483);
  var pIE = __webpack_require__(466);
  module.exports = function (it) {
    var result = getKeys(it);
    var getSymbols = gOPS.f;
    if (getSymbols) {
      var symbols = getSymbols(it);
      var isEnum = pIE.f;
      var i = 0;
      var key;
      while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
  };

  /***/
}, /* 575 */
/***/function (module, exports, __webpack_require__) {
  // 7.2.2 IsArray(argument)
  var cof = __webpack_require__(477);
  module.exports = Array.isArray || function isArray(arg) {
    return cof(arg) == 'Array';
  };

  /***/
}, /* 576 */
/***/function (module, exports, __webpack_require__) {
  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
  var toIObject = __webpack_require__(413);
  var gOPN = __webpack_require__(528).f;
  var toString = {}.toString;
  var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
  var getWindowNames = function (it) {
    try {
      return gOPN(it);
    } catch (e) {
      return windowNames.slice();
    }
  };
  module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
  };

  /***/
}, /* 577 */
/***/function (module, exports) {

  /***/}, /* 578 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(487)('asyncIterator');

  /***/
}, /* 579 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(487)('observable');

  /***/
}, /* 580 */
/***/function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(581),
    __esModule: true
  };

  /***/
}, /* 581 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(582);
  module.exports = __webpack_require__(238).Object.setPrototypeOf;

  /***/
}, /* 582 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.3.19 Object.setPrototypeOf(O, proto)
  var $export = __webpack_require__(393);
  $export($export.S, 'Object', {
    setPrototypeOf: __webpack_require__(583).set
  });

  /***/
}, /* 583 */
/***/function (module, exports, __webpack_require__) {
  // Works with __proto__ only. Old v8 can't work with null proto objects.
  /* eslint-disable no-proto */
  var isObject = __webpack_require__(429);
  var anObject = __webpack_require__(428);
  var check = function (O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
  };
  module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ?
    // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(475)(Function.call, __webpack_require__(488).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) {
        buggy = true;
      }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
    check: check
  };

  /***/
}, /* 584 */
/***/function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(585),
    __esModule: true
  };

  /***/
}, /* 585 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(586);
  var $Object = __webpack_require__(238).Object;
  module.exports = function create(P, D) {
    return $Object.create(P, D);
  };

  /***/
}, /* 586 */
/***/function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(393);
  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  $export($export.S, 'Object', {
    create: __webpack_require__(484)
  });

  /***/
}, /* 587 */
/***/function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(588),
    __esModule: true
  };

  /***/
}, /* 588 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(589);
  module.exports = __webpack_require__(238).Object.getPrototypeOf;

  /***/
}, /* 589 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.2.9 Object.getPrototypeOf(O)
  var toObject = __webpack_require__(458);
  var $getPrototypeOf = __webpack_require__(527);
  __webpack_require__(529)('getPrototypeOf', function () {
    return function getPrototypeOf(it) {
      return $getPrototypeOf(toObject(it));
    };
  });

  /***/
}, /* 590 */
/***/function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(591),
    __esModule: true
  };

  /***/
}, /* 591 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(592);
  var $Object = __webpack_require__(238).Object;
  module.exports = function getOwnPropertyDescriptor(it, key) {
    return $Object.getOwnPropertyDescriptor(it, key);
  };

  /***/
}, /* 592 */
/***/function (module, exports, __webpack_require__) {
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  var toIObject = __webpack_require__(413);
  var $getOwnPropertyDescriptor = __webpack_require__(488).f;
  __webpack_require__(529)('getOwnPropertyDescriptor', function () {
    return function getOwnPropertyDescriptor(it, key) {
      return $getOwnPropertyDescriptor(toIObject(it), key);
    };
  });

  /***/
}, /* 593 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /**
   * @ignore
   * event object for dom
   * @author yiminghe@gmail.com
   */
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  var _EventBaseObject = __webpack_require__(594);
  var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
  var _objectAssign = __webpack_require__(17);
  var _objectAssign2 = _interopRequireDefault(_objectAssign);
  var TRUE = true;
  var FALSE = false;
  var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
  function isNullOrUndefined(w) {
    return w === null || w === undefined;
  }
  var eventNormalizers = [{
    reg: /^key/,
    props: ['char', 'charCode', 'key', 'keyCode', 'which'],
    fix: function fix(event, nativeEvent) {
      if (isNullOrUndefined(event.which)) {
        event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
      }

      // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
      if (event.metaKey === undefined) {
        event.metaKey = event.ctrlKey;
      }
    }
  }, {
    reg: /^touch/,
    props: ['touches', 'changedTouches', 'targetTouches']
  }, {
    reg: /^hashchange$/,
    props: ['newURL', 'oldURL']
  }, {
    reg: /^gesturechange$/i,
    props: ['rotation', 'scale']
  }, {
    reg: /^(mousewheel|DOMMouseScroll)$/,
    props: [],
    fix: function fix(event, nativeEvent) {
      var deltaX = undefined;
      var deltaY = undefined;
      var delta = undefined;
      var wheelDelta = nativeEvent.wheelDelta;
      var axis = nativeEvent.axis;
      var wheelDeltaY = nativeEvent.wheelDeltaY;
      var wheelDeltaX = nativeEvent.wheelDeltaX;
      var detail = nativeEvent.detail;

      // ie/webkit
      if (wheelDelta) {
        delta = wheelDelta / 120;
      }

      // gecko
      if (detail) {
        // press control e.detail == 1 else e.detail == 3
        delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
      }

      // Gecko
      if (axis !== undefined) {
        if (axis === event.HORIZONTAL_AXIS) {
          deltaY = 0;
          deltaX = 0 - delta;
        } else if (axis === event.VERTICAL_AXIS) {
          deltaX = 0;
          deltaY = delta;
        }
      }

      // Webkit
      if (wheelDeltaY !== undefined) {
        deltaY = wheelDeltaY / 120;
      }
      if (wheelDeltaX !== undefined) {
        deltaX = -1 * wheelDeltaX / 120;
      }

      // 默认 deltaY (ie)
      if (!deltaX && !deltaY) {
        deltaY = delta;
      }
      if (deltaX !== undefined) {
        /**
         * deltaX of mousewheel event
         * @property deltaX
         * @member Event.DomEvent.Object
         */
        event.deltaX = deltaX;
      }
      if (deltaY !== undefined) {
        /**
         * deltaY of mousewheel event
         * @property deltaY
         * @member Event.DomEvent.Object
         */
        event.deltaY = deltaY;
      }
      if (delta !== undefined) {
        /**
         * delta of mousewheel event
         * @property delta
         * @member Event.DomEvent.Object
         */
        event.delta = delta;
      }
    }
  }, {
    reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
    props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
    fix: function fix(event, nativeEvent) {
      var eventDoc = undefined;
      var doc = undefined;
      var body = undefined;
      var target = event.target;
      var button = nativeEvent.button;

      // Calculate pageX/Y if missing and clientX/Y available
      if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
        eventDoc = target.ownerDocument || document;
        doc = eventDoc.documentElement;
        body = eventDoc.body;
        event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
        event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
      }

      // which for click: 1 === left; 2 === middle; 3 === right
      // do not use button
      if (!event.which && button !== undefined) {
        if (button & 1) {
          event.which = 1;
        } else if (button & 2) {
          event.which = 3;
        } else if (button & 4) {
          event.which = 2;
        } else {
          event.which = 0;
        }
      }

      // add relatedTarget, if necessary
      if (!event.relatedTarget && event.fromElement) {
        event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
      }
      return event;
    }
  }];
  function retTrue() {
    return TRUE;
  }
  function retFalse() {
    return FALSE;
  }
  function DomEventObject(nativeEvent) {
    var type = nativeEvent.type;
    var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
    _EventBaseObject2['default'].call(this);
    this.nativeEvent = nativeEvent;

    // in case dom event has been mark as default prevented by lower dom node
    var isDefaultPrevented = retFalse;
    if ('defaultPrevented' in nativeEvent) {
      isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
    } else if ('getPreventDefault' in nativeEvent) {
      // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
      isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
    } else if ('returnValue' in nativeEvent) {
      isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
    }
    this.isDefaultPrevented = isDefaultPrevented;
    var fixFns = [];
    var fixFn = undefined;
    var l = undefined;
    var prop = undefined;
    var props = commonProps.concat();
    eventNormalizers.forEach(function (normalizer) {
      if (type.match(normalizer.reg)) {
        props = props.concat(normalizer.props);
        if (normalizer.fix) {
          fixFns.push(normalizer.fix);
        }
      }
    });
    l = props.length;

    // clone properties of the original event object
    while (l) {
      prop = props[--l];
      this[prop] = nativeEvent[prop];
    }

    // fix target property, if necessary
    if (!this.target && isNative) {
      this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
    }

    // check if target is a text node (safari)
    if (this.target && this.target.nodeType === 3) {
      this.target = this.target.parentNode;
    }
    l = fixFns.length;
    while (l) {
      fixFn = fixFns[--l];
      fixFn(this, nativeEvent);
    }
    this.timeStamp = nativeEvent.timeStamp || Date.now();
  }
  var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
  (0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
    constructor: DomEventObject,
    preventDefault: function preventDefault() {
      var e = this.nativeEvent;

      // if preventDefault exists run it on the original event
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        // otherwise set the returnValue property of the original event to FALSE (IE)
        e.returnValue = FALSE;
      }
      EventBaseObjectProto.preventDefault.call(this);
    },
    stopPropagation: function stopPropagation() {
      var e = this.nativeEvent;

      // if stopPropagation exists run it on the original event
      if (e.stopPropagation) {
        e.stopPropagation();
      } else {
        // otherwise set the cancelBubble property of the original event to TRUE (IE)
        e.cancelBubble = TRUE;
      }
      EventBaseObjectProto.stopPropagation.call(this);
    }
  });
  exports['default'] = DomEventObject;
  module.exports = exports['default'];

  /***/
}, /* 594 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /**
   * @ignore
   * base event object for custom and dom event.
   * @author yiminghe@gmail.com
   */
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  function returnFalse() {
    return false;
  }
  function returnTrue() {
    return true;
  }
  function EventBaseObject() {
    this.timeStamp = Date.now();
    this.target = undefined;
    this.currentTarget = undefined;
  }
  EventBaseObject.prototype = {
    isEventObject: 1,
    constructor: EventBaseObject,
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,
    preventDefault: function preventDefault() {
      this.isDefaultPrevented = returnTrue;
    },
    stopPropagation: function stopPropagation() {
      this.isPropagationStopped = returnTrue;
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      this.isImmediatePropagationStopped = returnTrue;
      // fixed 1.2
      // call stopPropagation implicitly
      this.stopPropagation();
    },
    halt: function halt(immediate) {
      if (immediate) {
        this.stopImmediatePropagation();
      } else {
        this.stopPropagation();
      }
      this.preventDefault();
    }
  };
  exports["default"] = EventBaseObject;
  module.exports = exports["default"];

  /***/
}, /* 595 */
/***/function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(596),
    __esModule: true
  };

  /***/
}, /* 596 */
/***/function (module, exports, __webpack_require__) {
  __webpack_require__(524);
  __webpack_require__(597);
  module.exports = __webpack_require__(238).Array.from;

  /***/
}, /* 597 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var ctx = __webpack_require__(475);
  var $export = __webpack_require__(393);
  var toObject = __webpack_require__(458);
  var call = __webpack_require__(598);
  var isArrayIter = __webpack_require__(599);
  var toLength = __webpack_require__(522);
  var createProperty = __webpack_require__(600);
  var getIterFn = __webpack_require__(601);
  $export($export.S + $export.F * !__webpack_require__(603)(function (iter) {
    Array.from(iter);
  }), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
      var O = toObject(arrayLike);
      var C = typeof this == 'function' ? this : Array;
      var aLen = arguments.length;
      var mapfn = aLen > 1 ? arguments[1] : undefined;
      var mapping = mapfn !== undefined;
      var index = 0;
      var iterFn = getIterFn(O);
      var length, result, step, iterator;
      if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
      // if object isn't iterable or it's array with default iterator - use simple case
      if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
        for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
          createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
        }
      } else {
        length = toLength(O.length);
        for (result = new C(length); length > index; index++) {
          createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
      }
      result.length = index;
      return result;
    }
  });

  /***/
}, /* 598 */
/***/function (module, exports, __webpack_require__) {
  // call something on iterator step with safe closing on error
  var anObject = __webpack_require__(428);
  module.exports = function (iterator, fn, value, entries) {
    try {
      return entries ? fn(anObject(value)[0], value[1]) : fn(value);
      // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
      var ret = iterator['return'];
      if (ret !== undefined) anObject(ret.call(iterator));
      throw e;
    }
  };

  /***/
}, /* 599 */
/***/function (module, exports, __webpack_require__) {
  // check on default Array iterator
  var Iterators = __webpack_require__(459);
  var ITERATOR = __webpack_require__(249)('iterator');
  var ArrayProto = Array.prototype;
  module.exports = function (it) {
    return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
  };

  /***/
}, /* 600 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  var $defineProperty = __webpack_require__(395);
  var createDesc = __webpack_require__(457);
  module.exports = function (object, index, value) {
    if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
  };

  /***/
}, /* 601 */
/***/function (module, exports, __webpack_require__) {
  var classof = __webpack_require__(602);
  var ITERATOR = __webpack_require__(249)('iterator');
  var Iterators = __webpack_require__(459);
  module.exports = __webpack_require__(238).getIteratorMethod = function (it) {
    if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
  };

  /***/
}, /* 602 */
/***/function (module, exports, __webpack_require__) {
  // getting tag from 19.1.3.6 Object.prototype.toString()
  var cof = __webpack_require__(477);
  var TAG = __webpack_require__(249)('toStringTag');
  // ES3 wrong here
  var ARG = cof(function () {
    return arguments;
  }()) == 'Arguments';

  // fallback for IE11 Script Access Denied error
  var tryGet = function (it, key) {
    try {
      return it[key];
    } catch (e) {/* empty */}
  };
  module.exports = function (it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
  };

  /***/
}, /* 603 */
/***/function (module, exports, __webpack_require__) {
  var ITERATOR = __webpack_require__(249)('iterator');
  var SAFE_CLOSING = false;
  try {
    var riter = [7][ITERATOR]();
    riter['return'] = function () {
      SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from(riter, function () {
      throw 2;
    });
  } catch (e) {/* empty */}
  module.exports = function (exec, skipClosing) {
    if (!skipClosing && !SAFE_CLOSING) return false;
    var safe = false;
    try {
      var arr = [7];
      var iter = arr[ITERATOR]();
      iter.next = function () {
        return {
          done: safe = true
        };
      };
      arr[ITERATOR] = function () {
        return iter;
      };
      exec(arr);
    } catch (e) {/* empty */}
    return safe;
  };

  /***/
}, /* 604 */
/***/function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /*! @preserve
                                                                     * numeral.js
                                                                     * version : 2.0.6
                                                                     * author : Adam Draper
                                                                     * license : MIT
                                                                     * http://adamwdraper.github.com/Numeral-js/
                                                                     */

  (function (global, factory) {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
  })(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
      _,
      VERSION = '2.0.6',
      formats = {},
      locales = {},
      defaults = {
        currentLocale: 'en',
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: '0,0',
        scalePercentBy100: true
      },
      options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
      };

    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
      this._input = input;
      this._value = number;
    }
    numeral = function (input) {
      var value, kind, unformatFunction, regexp;
      if (numeral.isNumeral(input)) {
        value = input.value();
      } else if (input === 0 || typeof input === 'undefined') {
        value = 0;
      } else if (input === null || _.isNaN(input)) {
        value = null;
      } else if (typeof input === 'string') {
        if (options.zeroFormat && input === options.zeroFormat) {
          value = 0;
        } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
          value = null;
        } else {
          for (kind in formats) {
            regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
            if (regexp && input.match(regexp)) {
              unformatFunction = formats[kind].unformat;
              break;
            }
          }
          unformatFunction = unformatFunction || numeral._.stringToNumber;
          value = unformatFunction(input);
        }
      } else {
        value = Number(input) || null;
      }
      return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function (obj) {
      return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function (value, format, roundingFunction) {
        var locale = locales[numeral.options.currentLocale],
          negP = false,
          optDec = false,
          leadingCount = 0,
          abbr = '',
          trillion = 1000000000000,
          billion = 1000000000,
          million = 1000000,
          thousand = 1000,
          decimal = '',
          neg = false,
          abbrForce,
          // force abbreviation
          abs,
          min,
          max,
          power,
          int,
          precision,
          signed,
          thousands,
          output;

        // make sure we never format a null value
        value = value || 0;
        abs = Math.abs(value);

        // see if we should use parentheses for negative number or if we should prefix with a sign
        // if both are present we default to parentheses
        if (numeral._.includes(format, '(')) {
          negP = true;
          format = format.replace(/[\(|\)]/g, '');
        } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
          signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
          format = format.replace(/[\+|\-]/g, '');
        }

        // see if abbreviation is wanted
        if (numeral._.includes(format, 'a')) {
          abbrForce = format.match(/a(k|m|b|t)?/);
          abbrForce = abbrForce ? abbrForce[1] : false;

          // check for space before abbreviation
          if (numeral._.includes(format, ' a')) {
            abbr = ' ';
          }
          format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
          if (abs >= trillion && !abbrForce || abbrForce === 't') {
            // trillion
            abbr += locale.abbreviations.trillion;
            value = value / trillion;
          } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
            // billion
            abbr += locale.abbreviations.billion;
            value = value / billion;
          } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
            // million
            abbr += locale.abbreviations.million;
            value = value / million;
          } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
            // thousand
            abbr += locale.abbreviations.thousand;
            value = value / thousand;
          }
        }

        // check for optional decimals
        if (numeral._.includes(format, '[.]')) {
          optDec = true;
          format = format.replace('[.]', '.');
        }

        // break number and format
        int = value.toString().split('.')[0];
        precision = format.split('.')[1];
        thousands = format.indexOf(',');
        leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
        if (precision) {
          if (numeral._.includes(precision, '[')) {
            precision = precision.replace(']', '');
            precision = precision.split('[');
            decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
          } else {
            decimal = numeral._.toFixed(value, precision.length, roundingFunction);
          }
          int = decimal.split('.')[0];
          if (numeral._.includes(decimal, '.')) {
            decimal = locale.delimiters.decimal + decimal.split('.')[1];
          } else {
            decimal = '';
          }
          if (optDec && Number(decimal.slice(1)) === 0) {
            decimal = '';
          }
        } else {
          int = numeral._.toFixed(value, 0, roundingFunction);
        }

        // check abbreviation again after rounding
        if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
          int = String(Number(int) / 1000);
          switch (abbr) {
            case locale.abbreviations.thousand:
              abbr = locale.abbreviations.million;
              break;
            case locale.abbreviations.million:
              abbr = locale.abbreviations.billion;
              break;
            case locale.abbreviations.billion:
              abbr = locale.abbreviations.trillion;
              break;
          }
        }

        // format number
        if (numeral._.includes(int, '-')) {
          int = int.slice(1);
          neg = true;
        }
        if (int.length < leadingCount) {
          for (var i = leadingCount - int.length; i > 0; i--) {
            int = '0' + int;
          }
        }
        if (thousands > -1) {
          int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
        }
        if (format.indexOf('.') === 0) {
          int = '';
        }
        output = int + decimal + (abbr ? abbr : '');
        if (negP) {
          output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
        } else {
          if (signed >= 0) {
            output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
          } else if (neg) {
            output = '-' + output;
          }
        }
        return output;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function (string) {
        var locale = locales[options.currentLocale],
          stringOriginal = string,
          abbreviations = {
            thousand: 3,
            million: 6,
            billion: 9,
            trillion: 12
          },
          abbreviation,
          value,
          i,
          regexp;
        if (options.zeroFormat && string === options.zeroFormat) {
          value = 0;
        } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
          value = null;
        } else {
          value = 1;
          if (locale.delimiters.decimal !== '.') {
            string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
          }
          for (abbreviation in abbreviations) {
            regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
            if (stringOriginal.match(regexp)) {
              value *= Math.pow(10, abbreviations[abbreviation]);
              break;
            }
          }

          // check for negative number
          value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

          // remove non numbers
          string = string.replace(/[^0-9\.]+/g, '');
          value *= Number(string);
        }
        return value;
      },
      isNaN: function (value) {
        return typeof value === 'number' && isNaN(value);
      },
      includes: function (string, search) {
        return string.indexOf(search) !== -1;
      },
      insert: function (string, subString, start) {
        return string.slice(0, start) + subString + string.slice(start);
      },
      reduce: function (array, callback /*, initialValue*/) {
        if (this === null) {
          throw new TypeError('Array.prototype.reduce called on null or undefined');
        }
        if (typeof callback !== 'function') {
          throw new TypeError(callback + ' is not a function');
        }
        var t = Object(array),
          len = t.length >>> 0,
          k = 0,
          value;
        if (arguments.length === 3) {
          value = arguments[2];
        } else {
          while (k < len && !(k in t)) {
            k++;
          }
          if (k >= len) {
            throw new TypeError('Reduce of empty array with no initial value');
          }
          value = t[k++];
        }
        for (; k < len; k++) {
          if (k in t) {
            value = callback(value, t[k], k, t);
          }
        }
        return value;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function (x) {
        var parts = x.toString().split('.');
        return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function () {
        var args = Array.prototype.slice.call(arguments);
        return args.reduce(function (accum, next) {
          var mn = _.multiplier(next);
          return accum > mn ? accum : mn;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function (value, maxDecimals, roundingFunction, optionals) {
        var splitValue = value.toString().split('.'),
          minDecimals = maxDecimals - (optionals || 0),
          boundedPrecision,
          optionalsRegExp,
          power,
          output;

        // Use the smallest precision value possible to avoid errors from floating point representation
        if (splitValue.length === 2) {
          boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
        } else {
          boundedPrecision = minDecimals;
        }
        power = Math.pow(10, boundedPrecision);

        // Multiply up by precision, round accurately, then divide and use native toFixed():
        output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
        if (optionals > maxDecimals - boundedPrecision) {
          optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
          output = output.replace(optionalsRegExp, '');
        }
        return output;
      }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function (key) {
      if (key) {
        options.currentLocale = key.toLowerCase();
      }
      return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function (key) {
      if (!key) {
        return locales[options.currentLocale];
      }
      key = key.toLowerCase();
      if (!locales[key]) {
        throw new Error('Unknown locale : ' + key);
      }
      return locales[key];
    };
    numeral.reset = function () {
      for (var property in defaults) {
        options[property] = defaults[property];
      }
    };
    numeral.zeroFormat = function (format) {
      options.zeroFormat = typeof format === 'string' ? format : null;
    };
    numeral.nullFormat = function (format) {
      options.nullFormat = typeof format === 'string' ? format : null;
    };
    numeral.defaultFormat = function (format) {
      options.defaultFormat = typeof format === 'string' ? format : '0.0';
    };
    numeral.register = function (type, name, format) {
      name = name.toLowerCase();
      if (this[type + 's'][name]) {
        throw new TypeError(name + ' ' + type + ' already registered.');
      }
      this[type + 's'][name] = format;
      return format;
    };
    numeral.validate = function (val, culture) {
      var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;

      //coerce val to string
      if (typeof val !== 'string') {
        val += '';
        if (console.warn) {
          console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
        }
      }

      //trim whitespaces from either sides
      val = val.trim();

      //if val is just digits return true
      if (!!val.match(/^\d+$/)) {
        return true;
      }

      //if val is empty return false
      if (val === '') {
        return false;
      }

      //get the decimal and thousands separator from numeral.localeData
      try {
        //check if the culture is understood by numeral. if not, default it to current locale
        localeData = numeral.localeData(culture);
      } catch (e) {
        localeData = numeral.localeData(numeral.locale());
      }

      //setup the delimiters and currency symbol based on culture/locale
      _currSymbol = localeData.currency.symbol;
      _abbrObj = localeData.abbreviations;
      _decimalSep = localeData.delimiters.decimal;
      if (localeData.delimiters.thousands === '.') {
        _thousandSep = '\\.';
      } else {
        _thousandSep = localeData.delimiters.thousands;
      }

      // validating currency symbol
      temp = val.match(/^[^\d]+/);
      if (temp !== null) {
        val = val.substr(1);
        if (temp[0] !== _currSymbol) {
          return false;
        }
      }

      //validating abbreviation symbol
      temp = val.match(/[^\d]+$/);
      if (temp !== null) {
        val = val.slice(0, -1);
        if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
          return false;
        }
      }
      _thousandRegEx = new RegExp(_thousandSep + '{2}');
      if (!val.match(/[^\d.,]/g)) {
        _valArray = val.split(_decimalSep);
        if (_valArray.length > 2) {
          return false;
        } else {
          if (_valArray.length < 2) {
            return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
          } else {
            if (_valArray[0].length === 1) {
              return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
            } else {
              return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
            }
          }
        }
      }
      return false;
    };

    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
      clone: function () {
        return numeral(this);
      },
      format: function (inputString, roundingFunction) {
        var value = this._value,
          format = inputString || options.defaultFormat,
          kind,
          output,
          formatFunction;

        // make sure we have a roundingFunction
        roundingFunction = roundingFunction || Math.round;

        // format based on value
        if (value === 0 && options.zeroFormat !== null) {
          output = options.zeroFormat;
        } else if (value === null && options.nullFormat !== null) {
          output = options.nullFormat;
        } else {
          for (kind in formats) {
            if (format.match(formats[kind].regexps.format)) {
              formatFunction = formats[kind].format;
              break;
            }
          }
          formatFunction = formatFunction || numeral._.numberToFormat;
          output = formatFunction(value, format, roundingFunction);
        }
        return output;
      },
      value: function () {
        return this._value;
      },
      input: function () {
        return this._input;
      },
      set: function (value) {
        this._value = Number(value);
        return this;
      },
      add: function (value) {
        var corrFactor = _.correctionFactor.call(null, this._value, value);
        function cback(accum, curr, currI, O) {
          return accum + Math.round(corrFactor * curr);
        }
        this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
        return this;
      },
      subtract: function (value) {
        var corrFactor = _.correctionFactor.call(null, this._value, value);
        function cback(accum, curr, currI, O) {
          return accum - Math.round(corrFactor * curr);
        }
        this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
        return this;
      },
      multiply: function (value) {
        function cback(accum, curr, currI, O) {
          var corrFactor = _.correctionFactor(accum, curr);
          return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
        }
        this._value = _.reduce([this._value, value], cback, 1);
        return this;
      },
      divide: function (value) {
        function cback(accum, curr, currI, O) {
          var corrFactor = _.correctionFactor(accum, curr);
          return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
        }
        this._value = _.reduce([this._value, value], cback);
        return this;
      },
      difference: function (value) {
        return Math.abs(numeral(this._value).subtract(value).value());
      }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
      delimiters: {
        thousands: ',',
        decimal: '.'
      },
      abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
      },
      ordinal: function (number) {
        var b = number % 10;
        return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
      },
      currency: {
        symbol: '$'
      }
    });
    (function () {
      numeral.register('format', 'bps', {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function (value, format, roundingFunction) {
          var space = numeral._.includes(format, ' BPS') ? ' ' : '',
            output;
          value = value * 10000;

          // check for space before BPS
          format = format.replace(/\s?BPS/, '');
          output = numeral._.numberToFormat(value, format, roundingFunction);
          if (numeral._.includes(output, ')')) {
            output = output.split('');
            output.splice(-1, 0, space + 'BPS');
            output = output.join('');
          } else {
            output = output + space + 'BPS';
          }
          return output;
        },
        unformat: function (string) {
          return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
        }
      });
    })();
    (function () {
      var decimal = {
          base: 1000,
          suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
          base: 1024,
          suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };
      var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function (item) {
        return decimal.suffixes.indexOf(item) < 0;
      }));
      var unformatRegex = allSuffixes.join('|');
      // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
      unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
      numeral.register('format', 'bytes', {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(unformatRegex)
        },
        format: function (value, format, roundingFunction) {
          var output,
            bytes = numeral._.includes(format, 'ib') ? binary : decimal,
            suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
            power,
            min,
            max;

          // check for space before
          format = format.replace(/\s?i?b/, '');
          for (power = 0; power <= bytes.suffixes.length; power++) {
            min = Math.pow(bytes.base, power);
            max = Math.pow(bytes.base, power + 1);
            if (value === null || value === 0 || value >= min && value < max) {
              suffix += bytes.suffixes[power];
              if (min > 0) {
                value = value / min;
              }
              break;
            }
          }
          output = numeral._.numberToFormat(value, format, roundingFunction);
          return output + suffix;
        },
        unformat: function (string) {
          var value = numeral._.stringToNumber(string),
            power,
            bytesMultiplier;
          if (value) {
            for (power = decimal.suffixes.length - 1; power >= 0; power--) {
              if (numeral._.includes(string, decimal.suffixes[power])) {
                bytesMultiplier = Math.pow(decimal.base, power);
                break;
              }
              if (numeral._.includes(string, binary.suffixes[power])) {
                bytesMultiplier = Math.pow(binary.base, power);
                break;
              }
            }
            value *= bytesMultiplier || 1;
          }
          return value;
        }
      });
    })();
    (function () {
      numeral.register('format', 'currency', {
        regexps: {
          format: /(\$)/
        },
        format: function (value, format, roundingFunction) {
          var locale = numeral.locales[numeral.options.currentLocale],
            symbols = {
              before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
              after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
            },
            output,
            symbol,
            i;

          // strip format of spaces and $
          format = format.replace(/\s?\$\s?/, '');

          // format the number
          output = numeral._.numberToFormat(value, format, roundingFunction);

          // update the before and after based on value
          if (value >= 0) {
            symbols.before = symbols.before.replace(/[\-\(]/, '');
            symbols.after = symbols.after.replace(/[\-\)]/, '');
          } else if (value < 0 && !numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '(')) {
            symbols.before = '-' + symbols.before;
          }

          // loop through each before symbol
          for (i = 0; i < symbols.before.length; i++) {
            symbol = symbols.before[i];
            switch (symbol) {
              case '$':
                output = numeral._.insert(output, locale.currency.symbol, i);
                break;
              case ' ':
                output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                break;
            }
          }

          // loop through each after symbol
          for (i = symbols.after.length - 1; i >= 0; i--) {
            symbol = symbols.after[i];
            switch (symbol) {
              case '$':
                output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                break;
              case ' ':
                output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                break;
            }
          }
          return output;
        }
      });
    })();
    (function () {
      numeral.register('format', 'exponential', {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function (value, format, roundingFunction) {
          var output,
            exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
            parts = exponential.split('e');
          format = format.replace(/e[\+|\-]{1}0/, '');
          output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
          return output + 'e' + parts[1];
        },
        unformat: function (string) {
          var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
            value = Number(parts[0]),
            power = Number(parts[1]);
          power = numeral._.includes(string, 'e-') ? power *= -1 : power;
          function cback(accum, curr, currI, O) {
            var corrFactor = numeral._.correctionFactor(accum, curr),
              num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
            return num;
          }
          return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
      });
    })();
    (function () {
      numeral.register('format', 'ordinal', {
        regexps: {
          format: /(o)/
        },
        format: function (value, format, roundingFunction) {
          var locale = numeral.locales[numeral.options.currentLocale],
            output,
            ordinal = numeral._.includes(format, ' o') ? ' ' : '';

          // check for space before
          format = format.replace(/\s?o/, '');
          ordinal += locale.ordinal(value);
          output = numeral._.numberToFormat(value, format, roundingFunction);
          return output + ordinal;
        }
      });
    })();
    (function () {
      numeral.register('format', 'percentage', {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function (value, format, roundingFunction) {
          var space = numeral._.includes(format, ' %') ? ' ' : '',
            output;
          if (numeral.options.scalePercentBy100) {
            value = value * 100;
          }

          // check for space before %
          format = format.replace(/\s?\%/, '');
          output = numeral._.numberToFormat(value, format, roundingFunction);
          if (numeral._.includes(output, ')')) {
            output = output.split('');
            output.splice(-1, 0, space + '%');
            output = output.join('');
          } else {
            output = output + space + '%';
          }
          return output;
        },
        unformat: function (string) {
          var number = numeral._.stringToNumber(string);
          if (numeral.options.scalePercentBy100) {
            return number * 0.01;
          }
          return number;
        }
      });
    })();
    (function () {
      numeral.register('format', 'time', {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function (value, format, roundingFunction) {
          var hours = Math.floor(value / 60 / 60),
            minutes = Math.floor((value - hours * 60 * 60) / 60),
            seconds = Math.round(value - hours * 60 * 60 - minutes * 60);
          return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function (string) {
          var timeArray = string.split(':'),
            seconds = 0;

          // turn hours and minutes into seconds and add them all up
          if (timeArray.length === 3) {
            // hours
            seconds = seconds + Number(timeArray[0]) * 60 * 60;
            // minutes
            seconds = seconds + Number(timeArray[1]) * 60;
            // seconds
            seconds = seconds + Number(timeArray[2]);
          } else if (timeArray.length === 2) {
            // minutes
            seconds = seconds + Number(timeArray[0]) * 60;
            // seconds
            seconds = seconds + Number(timeArray[1]);
          }
          return Number(seconds);
        }
      });
    })();
    return numeral;
  });

  /***/
}, /* 605 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "CheckboxFilter", {
    enumerable: true,
    get: function get() {
      return _CheckboxFilter["default"];
    }
  });
  Object.defineProperty(exports, "DateFilter", {
    enumerable: true,
    get: function get() {
      return _DateFilter["default"];
    }
  });
  Object.defineProperty(exports, "RangeFilter", {
    enumerable: true,
    get: function get() {
      return _RangeFilter["default"];
    }
  });
  Object.defineProperty(exports, "StringFilter", {
    enumerable: true,
    get: function get() {
      return _StringFilter["default"];
    }
  });
  var _CheckboxFilter = _interopRequireDefault(__webpack_require__(515));
  var _DateFilter = _interopRequireDefault(__webpack_require__(531));
  var _RangeFilter = _interopRequireDefault(__webpack_require__(517));
  var _StringFilter = _interopRequireDefault(__webpack_require__(516));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  /***/
}, /* 606 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = exports.FilterTag = void 0;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _FilterModalLauncher = _interopRequireDefault(__webpack_require__(489));
  var _Tag = _interopRequireDefault(__webpack_require__(166));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  // This is a class instead of a function because FilterModalLauncher uses a ref and if it is a function the console errors with:
  // "Stateless function components cannot be given refs. Attempts to access this ref will fail."
  var FilterTag = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(FilterTag, _React$PureComponent);
    var _super = _createSuper(FilterTag);
    function FilterTag() {
      _classCallCheck(this, FilterTag);
      return _super.apply(this, arguments);
    }
    _createClass(FilterTag, [{
      key: "render",
      value: function render() {
        var props = this.props;
        return /*#__PURE__*/_react["default"].createElement(_Tag["default"], {
          allowRemove: true,
          allowClick: true,
          value: props.label,
          onRemove: function onRemove(e) {
            props.onRemove(props.column, props.values);
          },
          filterOptions: props.filterOptions
        });
      }
    }]);
    return FilterTag;
  }(_react["default"].PureComponent);
  exports.FilterTag = FilterTag;
  var _default = (0, _FilterModalLauncher["default"])(FilterTag);
  exports["default"] = _default;

  /***/
}, /* 607 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _functions = __webpack_require__(33);
  var _CellFilter = _interopRequireDefault(__webpack_require__(532));
  var _excluded = ["filterType", "filterOptions", "selected", "name"];
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var HeaderFilter = /*#__PURE__*/function (_PureComponent) {
    _inherits(HeaderFilter, _PureComponent);
    var _super = _createSuper(HeaderFilter);
    function HeaderFilter() {
      _classCallCheck(this, HeaderFilter);
      return _super.apply(this, arguments);
    }
    _createClass(HeaderFilter, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          filterType = _this$props.filterType,
          filterOptions = _this$props.filterOptions,
          selected = _this$props.selected,
          name = _this$props.name,
          props = _objectWithoutProperties(_this$props, _excluded),
          filterProps = {
            name: name,
            filterType: filterType,
            selected: selected,
            applyLabel: props.applyLabel,
            isFiltered: !!selected,
            column: props.columnKey,
            onChange: props.onFilterChange,
            onReset: props.onClearFilter,
            userLocale: props.userLocale,
            shouldPauseFocusTrap: props.shouldPauseFocusTrap,
            className: props.className,
            title: props.title,
            filterOptions: _objectSpread(_objectSpread({}, filterOptions), {}, {
              name: name,
              filterLevel: props.filterLevel
            })
          },
          $cellFilter = null,
          canFilter = true;
        if (filterType === "Checkbox") {
          filterProps.filterOptions.items = props.items.map(function (v) {
            var clabel = v;
            if (_typeof(v) === "object") {
              return v;
            }
            if (typeof v === "boolean") {
              clabel = v ? "Yes" : "No";
            }
            return {
              name: clabel.toString(),
              value: v.toString(),
              label: clabel.toString()
            };
          });
        } else {
          filterProps.filterOptions.items = props.items;
        }

        // Nothing needs to be changed for String filtering, selected options need to be formatted correctly for non-String filtering
        switch (filterType) {
          case "Checkbox":
            if (!!selected) {
              filterProps.filterOptions.selected = _toConsumableArray(selected);
            }
            // Checkbox Filtering should be disabled if there's 1 or less items in the list
            canFilter = props.items && props.items.length > 1;
            break;
          case "Date":
            if (!!selected) {
              filterProps.filterOptions.selected = _objectSpread({}, selected);
            } else {
              filterProps.filterOptions.additionalProps = props.additionalProps;
            }
            break;
          case "Range":
            if (!!selected) {
              filterProps.filterOptions.selected = _toConsumableArray(selected);
            }
            // Range Filtering should be disabled if the min & max are the same value
            canFilter = props.items && props.items.min !== props.items.max;
            break;
        }
        if (canFilter) {
          $cellFilter = /*#__PURE__*/_react["default"].createElement(_CellFilter["default"], filterProps);
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "header-cell filter-cell flex-center"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "cell-name"
        }, name), $cellFilter);
      }
    }]);
    return HeaderFilter;
  }(_react.PureComponent);
  exports["default"] = HeaderFilter;
  _defineProperty(HeaderFilter, "defaultProps", {
    filterOptions: {},
    items: [],
    filterType: "",
    filterLevel: "",
    selected: null,
    name: "",
    additionalProps: {},
    userLocale: "",
    onFilterChange: _functions.noop,
    onClearFilter: _functions.noop,
    shouldPauseFocusTrap: false
  });

  /***/
}, /* 608 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ActionMenuCell;
  var _react = _interopRequireDefault(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _ActionMenuItem = _interopRequireDefault(__webpack_require__(609));
  var _functions = __webpack_require__(33);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function ActionMenuCell(props) {
    var actionMenus = props.actionMenus,
      value = props.value,
      dependentValues = props.dependentValues,
      className = props.className;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "action-menu2-group ".concat(className)
    }, actionMenus(props).map(function (menu, idx) {
      var iconName = menu.iconName,
        name = menu.name,
        actions = menu.actions;
      return /*#__PURE__*/_react["default"].createElement(_ActionMenuItem["default"], {
        key: name,
        className: menu.className || "",
        iconName: iconName,
        value: "".concat(idx, "-").concat(name, "-").concat(value),
        actions: actions,
        dependentValues: dependentValues
      });
    }));
  }
  ActionMenuCell.displayName = "ActionMenuCell";
  ActionMenuCell.propTypes = {
    name: _propTypes["default"].string.isRequired,
    className: _propTypes["default"].string
  };
  ActionMenuCell.defaultProps = {
    name: "",
    className: "",
    value: "",
    dependentValues: {},
    actionMenus: []
  };

  /***/
}, /* 609 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = ActionMenuItem;
  var _react = _interopRequireWildcard(__webpack_require__(1));
  var _propTypes = _interopRequireDefault(__webpack_require__(0));
  var _reactContextmenu = __webpack_require__(109);
  var _Portal = _interopRequireDefault(__webpack_require__(490));
  var _Trigger = _interopRequireDefault(__webpack_require__(491));
  var _SimpleErrorBoundry = _interopRequireDefault(__webpack_require__(467));
  var _LinkAction = _interopRequireDefault(__webpack_require__(533));
  var _BasicAction = _interopRequireDefault(__webpack_require__(534));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
      return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  var typeMap = {
    basic: _BasicAction["default"],
    link: _LinkAction["default"]
  };
  function yesDisplay() {
    return true;
  }
  function ActionMenuItem(props) {
    var iconName = props.iconName,
      value = props.value,
      actions = props.actions,
      className = props.className;
    var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMenuShowing = _useState2[0],
      setIsMenuShowing = _useState2[1];
    var $content = [],
      isOpenClass = "";
    if (isMenuShowing) {
      isOpenClass = "is-menu-open";
      $content = actions.map(function (action) {
        var Component = action.Component,
          key = action.key,
          _action$type = action.type,
          type = _action$type === void 0 ? "basic" : _action$type,
          _action$shouldDisplay = action.shouldDisplay,
          shouldDisplay = _action$shouldDisplay === void 0 ? yesDisplay : _action$shouldDisplay;
        if (!shouldDisplay()) {
          return null;
        }
        if (Component) {
          return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, action, {
            key: key
          }));
        }
        var ActionType = typeMap[type];
        return /*#__PURE__*/_react["default"].createElement(_SimpleErrorBoundry["default"], {
          key: key
        }, /*#__PURE__*/_react["default"].createElement(ActionType, action));
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "action-menu2 action-bubble ".concat(className, " ").concat(isOpenClass)
    }, /*#__PURE__*/_react["default"].createElement(_Trigger["default"], {
      iconName: iconName,
      id: value
    }), /*#__PURE__*/_react["default"].createElement(_Portal["default"], null, /*#__PURE__*/_react["default"].createElement(_reactContextmenu.ContextMenu, {
      id: value,
      onShow: function onShow() {
        return setIsMenuShowing(true);
      },
      onHide: function onHide() {
        return setIsMenuShowing(false);
      },
      className: "action-menu-list2"
    }, $content)));
  }
  ActionMenuItem.displayName = "ActionMenuItem";
  ActionMenuItem.defaultProps = {
    iconName: "",
    className: "",
    value: "",
    actions: []
  };
  ActionMenuItem.propTypes = {
    actions: _propTypes["default"].array
  };

  /***/
}, /* 610 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.useTooltipRebuild = useTooltipRebuild;
  var _react = __webpack_require__(1);
  var _reactTooltip = _interopRequireDefault(__webpack_require__(60));
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function useTooltipRebuild() {
    for (var _len = arguments.length, dependencyArray = new Array(_len), _key = 0; _key < _len; _key++) {
      dependencyArray[_key] = arguments[_key];
    }
    (0, _react.useEffect)(function () {
      _reactTooltip["default"].rebuild();
      return function () {
        return _reactTooltip["default"].hide();
      };
    }, dependencyArray);
  }

  /***/
},,, /* 613 */
/***/function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  // ESM COMPAT FLAG
  __webpack_require__.r(__webpack_exports__);

  // EXPORTS
  __webpack_require__.d(__webpack_exports__, "Range", function () {
    return (/* reexport */es_Range
    );
  });
  __webpack_require__.d(__webpack_exports__, "Handle", function () {
    return (/* reexport */es_Handle
    );
  });
  __webpack_require__.d(__webpack_exports__, "createSliderWithTooltip", function () {
    return (/* reexport */createSliderWithTooltip
    );
  });

  // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
  var helpers_extends = __webpack_require__(69);
  var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

  // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
  var classCallCheck = __webpack_require__(90);
  var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

  // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
  var createClass = __webpack_require__(177);
  var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

  // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
  var possibleConstructorReturn = __webpack_require__(86);
  var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

  // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
  var inherits = __webpack_require__(91);
  var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

  // EXTERNAL MODULE: external "react"
  var external_react_ = __webpack_require__(1);
  var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

  // EXTERNAL MODULE: external "prop-types"
  var external_prop_types_ = __webpack_require__(0);
  var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

  // EXTERNAL MODULE: ./node_modules/warning/warning.js
  var warning = __webpack_require__(83);
  var warning_default = /*#__PURE__*/__webpack_require__.n(warning);

  // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
  var defineProperty = __webpack_require__(73);
  var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

  // CONCATENATED MODULE: ./node_modules/rc-slider/es/common/Track.js

  /* eslint-disable react/prop-types */

  var Track_Track = function Track(props) {
    var _ref, _ref2;
    var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style,
      reverse = props.reverse;
    var positonStyle = vertical ? (_ref = {}, defineProperty_default()(_ref, reverse ? 'top' : 'bottom', offset + '%'), defineProperty_default()(_ref, reverse ? 'bottom' : 'top', 'auto'), defineProperty_default()(_ref, 'height', length + '%'), _ref) : (_ref2 = {}, defineProperty_default()(_ref2, reverse ? 'right' : 'left', offset + '%'), defineProperty_default()(_ref2, reverse ? 'left' : 'right', 'auto'), defineProperty_default()(_ref2, 'width', length + '%'), _ref2);
    var elStyle = extends_default()({}, style, positonStyle);
    return included ? external_react_default.a.createElement('div', {
      className: className,
      style: elStyle
    }) : null;
  };

  /* harmony default export */
  var common_Track = Track_Track;
  // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
  var objectWithoutProperties = __webpack_require__(248);
  var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

  // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/get.js
  var get = __webpack_require__(474);
  var get_default = /*#__PURE__*/__webpack_require__.n(get);

  // EXTERNAL MODULE: ./node_modules/add-dom-event-listener/lib/index.js
  var lib = __webpack_require__(535);
  var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

  // EXTERNAL MODULE: external "react-dom"
  var external_react_dom_ = __webpack_require__(15);
  var external_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_react_dom_);

  // CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/addEventListener.js

  function addEventListenerWrap(target, eventType, cb, option) {
    /* eslint camelcase: 2 */
    var callback = external_react_dom_default.a.unstable_batchedUpdates ? function run(e) {
      external_react_dom_default.a.unstable_batchedUpdates(cb, e);
    } : cb;
    return lib_default()(target, eventType, callback, option);
  }
  // EXTERNAL MODULE: ./node_modules/classnames/index.js
  var classnames = __webpack_require__(6);
  var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

  // CONCATENATED MODULE: ./node_modules/rc-slider/es/common/Steps.js

  var Steps_calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
    warning_default()(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
    var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
      return a - b;
    });
    if (dots && step) {
      for (var i = min; i <= max; i += step) {
        if (points.indexOf(i) === -1) {
          points.push(i);
        }
      }
    }
    return points;
  };
  var Steps_Steps = function Steps(_ref) {
    var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;
    var range = max - min;
    var elements = Steps_calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
      var _classNames;
      var offset = Math.abs(point - min) / range * 100 + '%';
      var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
      var style = vertical ? extends_default()({}, dotStyle, defineProperty_default()({}, reverse ? 'top' : 'bottom', offset)) : extends_default()({}, dotStyle, defineProperty_default()({}, reverse ? 'right' : 'left', offset));
      if (isActived) {
        style = extends_default()({}, style, activeDotStyle);
      }
      var pointClassName = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-dot', true), defineProperty_default()(_classNames, prefixCls + '-dot-active', isActived), defineProperty_default()(_classNames, prefixCls + '-dot-reverse', reverse), _classNames));
      return external_react_default.a.createElement('span', {
        className: pointClassName,
        style: style,
        key: point
      });
    });
    return external_react_default.a.createElement('div', {
      className: prefixCls + '-step'
    }, elements);
  };
  Steps_Steps.propTypes = {
    prefixCls: external_prop_types_default.a.string,
    activeDotStyle: external_prop_types_default.a.object,
    dotStyle: external_prop_types_default.a.object,
    min: external_prop_types_default.a.number,
    max: external_prop_types_default.a.number,
    upperBound: external_prop_types_default.a.number,
    lowerBound: external_prop_types_default.a.number,
    included: external_prop_types_default.a.bool,
    dots: external_prop_types_default.a.bool,
    step: external_prop_types_default.a.number,
    marks: external_prop_types_default.a.object,
    vertical: external_prop_types_default.a.bool,
    reverse: external_prop_types_default.a.bool
  };

  /* harmony default export */
  var common_Steps = Steps_Steps;
  // CONCATENATED MODULE: ./node_modules/rc-slider/es/common/Marks.js

  var Marks_Marks = function Marks(_ref) {
    var className = _ref.className,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min,
      onClickLabel = _ref.onClickLabel;
    var marksKeys = Object.keys(marks);
    var range = max - min;
    var elements = marksKeys.map(parseFloat).sort(function (a, b) {
      return a - b;
    }).map(function (point) {
      var _classNames;
      var markPoint = marks[point];
      var markPointIsObject = typeof markPoint === 'object' && !external_react_default.a.isValidElement(markPoint);
      var markLabel = markPointIsObject ? markPoint.label : markPoint;
      if (!markLabel && markLabel !== 0) {
        return null;
      }
      var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
      var markClassName = classnames_default()((_classNames = {}, defineProperty_default()(_classNames, className + '-text', true), defineProperty_default()(_classNames, className + '-text-active', isActive), _classNames));
      var bottomStyle = defineProperty_default()({
        marginBottom: '-50%'
      }, reverse ? 'top' : 'bottom', (point - min) / range * 100 + '%');
      var leftStyle = defineProperty_default()({
        transform: 'translateX(-50%)',
        msTransform: 'translateX(-50%)'
      }, reverse ? 'right' : 'left', reverse ? (point - min / 4) / range * 100 + '%' : (point - min) / range * 100 + '%');
      var style = vertical ? bottomStyle : leftStyle;
      var markStyle = markPointIsObject ? extends_default()({}, style, markPoint.style) : style;
      return external_react_default.a.createElement('span', {
        className: markClassName,
        style: markStyle,
        key: point,
        onMouseDown: function onMouseDown(e) {
          return onClickLabel(e, point);
        },
        onTouchStart: function onTouchStart(e) {
          return onClickLabel(e, point);
        }
      }, markLabel);
    });
    return external_react_default.a.createElement('div', {
      className: className
    }, elements);
  };
  Marks_Marks.propTypes = {
    className: external_prop_types_default.a.string,
    vertical: external_prop_types_default.a.bool,
    reverse: external_prop_types_default.a.bool,
    marks: external_prop_types_default.a.object,
    included: external_prop_types_default.a.bool,
    upperBound: external_prop_types_default.a.number,
    lowerBound: external_prop_types_default.a.number,
    max: external_prop_types_default.a.number,
    min: external_prop_types_default.a.number,
    onClickLabel: external_prop_types_default.a.func
  };

  /* harmony default export */
  var common_Marks = Marks_Marks;
  // CONCATENATED MODULE: ./node_modules/rc-slider/es/Handle.js

  var Handle_Handle = function (_React$Component) {
    inherits_default()(Handle, _React$Component);
    function Handle() {
      var _ref;
      var _temp, _this, _ret;
      classCallCheck_default()(this, Handle);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        clickFocused: false
      }, _this.setHandleRef = function (node) {
        _this.handle = node;
      }, _this.handleMouseUp = function () {
        if (document.activeElement === _this.handle) {
          _this.setClickFocus(true);
        }
      }, _this.handleMouseDown = function () {
        // fix https://github.com/ant-design/ant-design/issues/15324
        _this.focus();
      }, _this.handleBlur = function () {
        _this.setClickFocus(false);
      }, _this.handleKeyDown = function () {
        _this.setClickFocus(false);
      }, _temp), possibleConstructorReturn_default()(_this, _ret);
    }
    createClass_default()(Handle, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // mouseup won't trigger if mouse moved out of handle,
        // so we listen on document here.
        this.onMouseUpListener = addEventListenerWrap(document, 'mouseup', this.handleMouseUp);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.onMouseUpListener) {
          this.onMouseUpListener.remove();
        }
      }
    }, {
      key: 'setClickFocus',
      value: function setClickFocus(focused) {
        this.setState({
          clickFocused: focused
        });
      }
    }, {
      key: 'clickFocus',
      value: function clickFocus() {
        this.setClickFocus(true);
        this.focus();
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.handle.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.handle.blur();
      }
    }, {
      key: 'render',
      value: function render() {
        var _ref2, _ref3;
        var _props = this.props,
          prefixCls = _props.prefixCls,
          vertical = _props.vertical,
          reverse = _props.reverse,
          offset = _props.offset,
          style = _props.style,
          disabled = _props.disabled,
          min = _props.min,
          max = _props.max,
          value = _props.value,
          tabIndex = _props.tabIndex,
          restProps = objectWithoutProperties_default()(_props, ['prefixCls', 'vertical', 'reverse', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);
        var className = classnames_default()(this.props.className, defineProperty_default()({}, prefixCls + '-handle-click-focused', this.state.clickFocused));
        var positionStyle = vertical ? (_ref2 = {}, defineProperty_default()(_ref2, reverse ? 'top' : 'bottom', offset + '%'), defineProperty_default()(_ref2, reverse ? 'bottom' : 'top', 'auto'), defineProperty_default()(_ref2, 'transform', 'translateY(+50%)'), _ref2) : (_ref3 = {}, defineProperty_default()(_ref3, reverse ? 'right' : 'left', offset + '%'), defineProperty_default()(_ref3, reverse ? 'left' : 'right', 'auto'), defineProperty_default()(_ref3, 'transform', 'translateX(' + (reverse ? '+' : '-') + '50%)'), _ref3);
        var elStyle = extends_default()({}, style, positionStyle);
        var _tabIndex = tabIndex || 0;
        if (disabled || tabIndex === null) {
          _tabIndex = null;
        }
        return external_react_default.a.createElement('div', extends_default()({
          ref: this.setHandleRef,
          tabIndex: _tabIndex
        }, restProps, {
          className: className,
          style: elStyle,
          onBlur: this.handleBlur,
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleMouseDown

          // aria attribute
          ,
          role: 'slider',
          'aria-valuemin': min,
          'aria-valuemax': max,
          'aria-valuenow': value,
          'aria-disabled': !!disabled
        }));
      }
    }]);
    return Handle;
  }(external_react_default.a.Component);

  /* harmony default export */
  var es_Handle = Handle_Handle;
  Handle_Handle.propTypes = {
    prefixCls: external_prop_types_default.a.string,
    className: external_prop_types_default.a.string,
    vertical: external_prop_types_default.a.bool,
    offset: external_prop_types_default.a.number,
    style: external_prop_types_default.a.object,
    disabled: external_prop_types_default.a.bool,
    min: external_prop_types_default.a.number,
    max: external_prop_types_default.a.number,
    value: external_prop_types_default.a.number,
    tabIndex: external_prop_types_default.a.number,
    reverse: external_prop_types_default.a.bool
  };
  // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
  var toConsumableArray = __webpack_require__(446);
  var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

  // CONCATENATED MODULE: ./node_modules/rc-util/es/KeyCode.js
  /**
   * @ignore
   * some key-codes definition and utils from closure-library
   * @author yiminghe@gmail.com
   */
  var KeyCode = {
    /**
     * MAC_ENTER
     */
    MAC_ENTER: 3,
    /**
     * BACKSPACE
     */
    BACKSPACE: 8,
    /**
     * TAB
     */
    TAB: 9,
    /**
     * NUMLOCK on FF/Safari Mac
     */
    NUM_CENTER: 12,
    /**
     * ENTER
     */
    ENTER: 13,
    /**
     * SHIFT
     */
    SHIFT: 16,
    /**
     * CTRL
     */
    CTRL: 17,
    /**
     * ALT
     */
    ALT: 18,
    /**
     * PAUSE
     */
    PAUSE: 19,
    /**
     * CAPS_LOCK
     */
    CAPS_LOCK: 20,
    /**
     * ESC
     */
    ESC: 27,
    /**
     * SPACE
     */
    SPACE: 32,
    /**
     * PAGE_UP
     */
    PAGE_UP: 33,
    /**
     * PAGE_DOWN
     */
    PAGE_DOWN: 34,
    /**
     * END
     */
    END: 35,
    /**
     * HOME
     */
    HOME: 36,
    /**
     * LEFT
     */
    LEFT: 37,
    /**
     * UP
     */
    UP: 38,
    /**
     * RIGHT
     */
    RIGHT: 39,
    /**
     * DOWN
     */
    DOWN: 40,
    /**
     * PRINT_SCREEN
     */
    PRINT_SCREEN: 44,
    /**
     * INSERT
     */
    INSERT: 45,
    /**
     * DELETE
     */
    DELETE: 46,
    /**
     * ZERO
     */
    ZERO: 48,
    /**
     * ONE
     */
    ONE: 49,
    /**
     * TWO
     */
    TWO: 50,
    /**
     * THREE
     */
    THREE: 51,
    /**
     * FOUR
     */
    FOUR: 52,
    /**
     * FIVE
     */
    FIVE: 53,
    /**
     * SIX
     */
    SIX: 54,
    /**
     * SEVEN
     */
    SEVEN: 55,
    /**
     * EIGHT
     */
    EIGHT: 56,
    /**
     * NINE
     */
    NINE: 57,
    /**
     * QUESTION_MARK
     */
    QUESTION_MARK: 63,
    /**
     * A
     */
    A: 65,
    /**
     * B
     */
    B: 66,
    /**
     * C
     */
    C: 67,
    /**
     * D
     */
    D: 68,
    /**
     * E
     */
    E: 69,
    /**
     * F
     */
    F: 70,
    /**
     * G
     */
    G: 71,
    /**
     * H
     */
    H: 72,
    /**
     * I
     */
    I: 73,
    /**
     * J
     */
    J: 74,
    /**
     * K
     */
    K: 75,
    /**
     * L
     */
    L: 76,
    /**
     * M
     */
    M: 77,
    /**
     * N
     */
    N: 78,
    /**
     * O
     */
    O: 79,
    /**
     * P
     */
    P: 80,
    /**
     * Q
     */
    Q: 81,
    /**
     * R
     */
    R: 82,
    /**
     * S
     */
    S: 83,
    /**
     * T
     */
    T: 84,
    /**
     * U
     */
    U: 85,
    /**
     * V
     */
    V: 86,
    /**
     * W
     */
    W: 87,
    /**
     * X
     */
    X: 88,
    /**
     * Y
     */
    Y: 89,
    /**
     * Z
     */
    Z: 90,
    /**
     * META
     */
    META: 91,
    /**
     * WIN_KEY_RIGHT
     */
    WIN_KEY_RIGHT: 92,
    /**
     * CONTEXT_MENU
     */
    CONTEXT_MENU: 93,
    /**
     * NUM_ZERO
     */
    NUM_ZERO: 96,
    /**
     * NUM_ONE
     */
    NUM_ONE: 97,
    /**
     * NUM_TWO
     */
    NUM_TWO: 98,
    /**
     * NUM_THREE
     */
    NUM_THREE: 99,
    /**
     * NUM_FOUR
     */
    NUM_FOUR: 100,
    /**
     * NUM_FIVE
     */
    NUM_FIVE: 101,
    /**
     * NUM_SIX
     */
    NUM_SIX: 102,
    /**
     * NUM_SEVEN
     */
    NUM_SEVEN: 103,
    /**
     * NUM_EIGHT
     */
    NUM_EIGHT: 104,
    /**
     * NUM_NINE
     */
    NUM_NINE: 105,
    /**
     * NUM_MULTIPLY
     */
    NUM_MULTIPLY: 106,
    /**
     * NUM_PLUS
     */
    NUM_PLUS: 107,
    /**
     * NUM_MINUS
     */
    NUM_MINUS: 109,
    /**
     * NUM_PERIOD
     */
    NUM_PERIOD: 110,
    /**
     * NUM_DIVISION
     */
    NUM_DIVISION: 111,
    /**
     * F1
     */
    F1: 112,
    /**
     * F2
     */
    F2: 113,
    /**
     * F3
     */
    F3: 114,
    /**
     * F4
     */
    F4: 115,
    /**
     * F5
     */
    F5: 116,
    /**
     * F6
     */
    F6: 117,
    /**
     * F7
     */
    F7: 118,
    /**
     * F8
     */
    F8: 119,
    /**
     * F9
     */
    F9: 120,
    /**
     * F10
     */
    F10: 121,
    /**
     * F11
     */
    F11: 122,
    /**
     * F12
     */
    F12: 123,
    /**
     * NUMLOCK
     */
    NUMLOCK: 144,
    /**
     * SEMICOLON
     */
    SEMICOLON: 186,
    /**
     * DASH
     */
    DASH: 189,
    /**
     * EQUALS
     */
    EQUALS: 187,
    /**
     * COMMA
     */
    COMMA: 188,
    /**
     * PERIOD
     */
    PERIOD: 190,
    /**
     * SLASH
     */
    SLASH: 191,
    /**
     * APOSTROPHE
     */
    APOSTROPHE: 192,
    /**
     * SINGLE_QUOTE
     */
    SINGLE_QUOTE: 222,
    /**
     * OPEN_SQUARE_BRACKET
     */
    OPEN_SQUARE_BRACKET: 219,
    /**
     * BACKSLASH
     */
    BACKSLASH: 220,
    /**
     * CLOSE_SQUARE_BRACKET
     */
    CLOSE_SQUARE_BRACKET: 221,
    /**
     * WIN_KEY
     */
    WIN_KEY: 224,
    /**
     * MAC_FF_META
     */
    MAC_FF_META: 224,
    /**
     * WIN_IME
     */
    WIN_IME: 229,
    // ======================== Function ========================

    /**
     * whether text and modified key is entered at the same time.
     */
    isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
      var keyCode = e.keyCode;
      if (e.altKey && !e.ctrlKey || e.metaKey ||
      // Function keys don't generate text
      keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
        return false;
      } // The following keys are quite harmless, even in combination with
      // CTRL, ALT or SHIFT.

      switch (keyCode) {
        case KeyCode.ALT:
        case KeyCode.CAPS_LOCK:
        case KeyCode.CONTEXT_MENU:
        case KeyCode.CTRL:
        case KeyCode.DOWN:
        case KeyCode.END:
        case KeyCode.ESC:
        case KeyCode.HOME:
        case KeyCode.INSERT:
        case KeyCode.LEFT:
        case KeyCode.MAC_FF_META:
        case KeyCode.META:
        case KeyCode.NUMLOCK:
        case KeyCode.NUM_CENTER:
        case KeyCode.PAGE_DOWN:
        case KeyCode.PAGE_UP:
        case KeyCode.PAUSE:
        case KeyCode.PRINT_SCREEN:
        case KeyCode.RIGHT:
        case KeyCode.SHIFT:
        case KeyCode.UP:
        case KeyCode.WIN_KEY:
        case KeyCode.WIN_KEY_RIGHT:
          return false;
        default:
          return true;
      }
    },
    /**
     * whether character is entered.
     */
    isCharacterKey: function isCharacterKey(keyCode) {
      if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
        return true;
      }
      if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
        return true;
      }
      if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
        return true;
      } // Safari sends zero key code for non-latin characters.

      if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
        return true;
      }
      switch (keyCode) {
        case KeyCode.SPACE:
        case KeyCode.QUESTION_MARK:
        case KeyCode.NUM_PLUS:
        case KeyCode.NUM_MINUS:
        case KeyCode.NUM_PERIOD:
        case KeyCode.NUM_DIVISION:
        case KeyCode.SEMICOLON:
        case KeyCode.DASH:
        case KeyCode.EQUALS:
        case KeyCode.COMMA:
        case KeyCode.PERIOD:
        case KeyCode.SLASH:
        case KeyCode.APOSTROPHE:
        case KeyCode.SINGLE_QUOTE:
        case KeyCode.OPEN_SQUARE_BRACKET:
        case KeyCode.BACKSLASH:
        case KeyCode.CLOSE_SQUARE_BRACKET:
          return true;
        default:
          return false;
      }
    }
  };
  /* harmony default export */
  var es_KeyCode = KeyCode;
  // CONCATENATED MODULE: ./node_modules/rc-slider/es/utils.js

  function isEventFromHandle(e, handles) {
    try {
      return Object.keys(handles).some(function (key) {
        return e.target === Object(external_react_dom_["findDOMNode"])(handles[key]);
      });
    } catch (error) {
      return false;
    }
  }
  function isValueOutOfRange(value, _ref) {
    var min = _ref.min,
      max = _ref.max;
    return value < min || value > max;
  }
  function isNotTouchEvent(e) {
    return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
  }
  function getClosestPoint(val, _ref2) {
    var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min,
      max = _ref2.max;
    var points = Object.keys(marks).map(parseFloat);
    if (step !== null) {
      var maxSteps = Math.floor((max - min) / step);
      var steps = Math.min((val - min) / step, maxSteps);
      var closestStep = Math.round(steps) * step + min;
      points.push(closestStep);
    }
    var diffs = points.map(function (point) {
      return Math.abs(val - point);
    });
    return points[diffs.indexOf(Math.min.apply(Math, toConsumableArray_default()(diffs)))];
  }
  function getPrecision(step) {
    var stepString = step.toString();
    var precision = 0;
    if (stepString.indexOf('.') >= 0) {
      precision = stepString.length - stepString.indexOf('.') - 1;
    }
    return precision;
  }
  function getMousePosition(vertical, e) {
    return vertical ? e.clientY : e.pageX;
  }
  function getTouchPosition(vertical, e) {
    return vertical ? e.touches[0].clientY : e.touches[0].pageX;
  }
  function getHandleCenterPosition(vertical, handle) {
    var coords = handle.getBoundingClientRect();
    return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
  }
  function ensureValueInRange(val, _ref3) {
    var max = _ref3.max,
      min = _ref3.min;
    if (val <= min) {
      return min;
    }
    if (val >= max) {
      return max;
    }
    return val;
  }
  function ensureValuePrecision(val, props) {
    var step = props.step;
    var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line
    return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
  }
  function pauseEvent(e) {
    e.stopPropagation();
    e.preventDefault();
  }
  function calculateNextValue(func, value, props) {
    var operations = {
      increase: function increase(a, b) {
        return a + b;
      },
      decrease: function decrease(a, b) {
        return a - b;
      }
    };
    var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
    var keyToGet = Object.keys(props.marks)[indexToGet];
    if (props.step) {
      return operations[func](value, props.step);
    } else if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
      return props.marks[keyToGet];
    }
    return value;
  }
  function getKeyboardValueMutator(e, vertical, reverse) {
    var increase = 'increase';
    var decrease = 'decrease';
    var method = increase;
    switch (e.keyCode) {
      case es_KeyCode.UP:
        method = vertical && reverse ? decrease : increase;
        break;
      case es_KeyCode.RIGHT:
        method = !vertical && reverse ? decrease : increase;
        break;
      case es_KeyCode.DOWN:
        method = vertical && reverse ? increase : decrease;
        break;
      case es_KeyCode.LEFT:
        method = !vertical && reverse ? increase : decrease;
        break;
      case es_KeyCode.END:
        return function (value, props) {
          return props.max;
        };
      case es_KeyCode.HOME:
        return function (value, props) {
          return props.min;
        };
      case es_KeyCode.PAGE_UP:
        return function (value, props) {
          return value + props.step * 2;
        };
      case es_KeyCode.PAGE_DOWN:
        return function (value, props) {
          return value - props.step * 2;
        };
      default:
        return undefined;
    }
    return function (value, props) {
      return calculateNextValue(method, value, props);
    };
  }
  // CONCATENATED MODULE: ./node_modules/rc-slider/es/common/createSlider.js

  function noop() {}
  function createSlider(Component) {
    var _class, _temp;
    return _temp = _class = function (_Component) {
      inherits_default()(ComponentEnhancer, _Component);
      function ComponentEnhancer(props) {
        classCallCheck_default()(this, ComponentEnhancer);
        var _this = possibleConstructorReturn_default()(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));
        _this.onMouseDown = function (e) {
          if (e.button !== 0) {
            return;
          }
          var isVertical = _this.props.vertical;
          var position = getMousePosition(isVertical, e);
          if (!isEventFromHandle(e, _this.handlesRefs)) {
            _this.dragOffset = 0;
          } else {
            var handlePosition = getHandleCenterPosition(isVertical, e.target);
            _this.dragOffset = position - handlePosition;
            position = handlePosition;
          }
          _this.removeDocumentEvents();
          _this.onStart(position);
          _this.addDocumentMouseEvents();
        };
        _this.onTouchStart = function (e) {
          if (isNotTouchEvent(e)) return;
          var isVertical = _this.props.vertical;
          var position = getTouchPosition(isVertical, e);
          if (!isEventFromHandle(e, _this.handlesRefs)) {
            _this.dragOffset = 0;
          } else {
            var handlePosition = getHandleCenterPosition(isVertical, e.target);
            _this.dragOffset = position - handlePosition;
            position = handlePosition;
          }
          _this.onStart(position);
          _this.addDocumentTouchEvents();
          pauseEvent(e);
        };
        _this.onFocus = function (e) {
          var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            vertical = _this$props.vertical;
          if (isEventFromHandle(e, _this.handlesRefs)) {
            var handlePosition = getHandleCenterPosition(vertical, e.target);
            _this.dragOffset = 0;
            _this.onStart(handlePosition);
            pauseEvent(e);
            if (onFocus) {
              onFocus(e);
            }
          }
        };
        _this.onBlur = function (e) {
          var onBlur = _this.props.onBlur;
          _this.onEnd();
          if (onBlur) {
            onBlur(e);
          }
        };
        _this.onMouseUp = function () {
          if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
            _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
          }
        };
        _this.onMouseMove = function (e) {
          if (!_this.sliderRef) {
            _this.onEnd();
            return;
          }
          var position = getMousePosition(_this.props.vertical, e);
          _this.onMove(e, position - _this.dragOffset);
        };
        _this.onTouchMove = function (e) {
          if (isNotTouchEvent(e) || !_this.sliderRef) {
            _this.onEnd();
            return;
          }
          var position = getTouchPosition(_this.props.vertical, e);
          _this.onMove(e, position - _this.dragOffset);
        };
        _this.onKeyDown = function (e) {
          if (_this.sliderRef && isEventFromHandle(e, _this.handlesRefs)) {
            _this.onKeyboard(e);
          }
        };
        _this.onClickMarkLabel = function (e, value) {
          e.stopPropagation();
          _this.onChange({
            value: value
          });
          _this.setState({
            value: value
          }, function () {
            return _this.onEnd(true);
          });
        };
        _this.saveSlider = function (slider) {
          _this.sliderRef = slider;
        };
        var step = props.step,
          max = props.max,
          min = props.min;
        var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
        warning_default()(step && Math.floor(step) === step ? isPointDiffEven : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
        _this.handlesRefs = {};
        return _this;
      }
      createClass_default()(ComponentEnhancer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          // Snapshot testing cannot handle refs, so be sure to null-check this.
          this.document = this.sliderRef && this.sliderRef.ownerDocument;
          var _props = this.props,
            autoFocus = _props.autoFocus,
            disabled = _props.disabled;
          if (autoFocus && !disabled) {
            this.focus();
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (get_default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) get_default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
          this.removeDocumentEvents();
        }
      }, {
        key: 'getSliderStart',
        value: function getSliderStart() {
          var slider = this.sliderRef;
          var _props2 = this.props,
            vertical = _props2.vertical,
            reverse = _props2.reverse;
          var rect = slider.getBoundingClientRect();
          if (vertical) {
            return reverse ? rect.bottom : rect.top;
          }
          return window.pageXOffset + (reverse ? rect.right : rect.left);
        }
      }, {
        key: 'getSliderLength',
        value: function getSliderLength() {
          var slider = this.sliderRef;
          if (!slider) {
            return 0;
          }
          var coords = slider.getBoundingClientRect();
          return this.props.vertical ? coords.height : coords.width;
        }
      }, {
        key: 'addDocumentTouchEvents',
        value: function addDocumentTouchEvents() {
          // just work for Chrome iOS Safari and Android Browser
          this.onTouchMoveListener = addEventListenerWrap(this.document, 'touchmove', this.onTouchMove);
          this.onTouchUpListener = addEventListenerWrap(this.document, 'touchend', this.onEnd);
        }
      }, {
        key: 'addDocumentMouseEvents',
        value: function addDocumentMouseEvents() {
          this.onMouseMoveListener = addEventListenerWrap(this.document, 'mousemove', this.onMouseMove);
          this.onMouseUpListener = addEventListenerWrap(this.document, 'mouseup', this.onEnd);
        }
      }, {
        key: 'removeDocumentEvents',
        value: function removeDocumentEvents() {
          /* eslint-disable no-unused-expressions */
          this.onTouchMoveListener && this.onTouchMoveListener.remove();
          this.onTouchUpListener && this.onTouchUpListener.remove();
          this.onMouseMoveListener && this.onMouseMoveListener.remove();
          this.onMouseUpListener && this.onMouseUpListener.remove();
          /* eslint-enable no-unused-expressions */
        }
      }, {
        key: 'focus',
        value: function focus() {
          if (!this.props.disabled) {
            this.handlesRefs[0].focus();
          }
        }
      }, {
        key: 'blur',
        value: function blur() {
          var _this2 = this;
          if (!this.props.disabled) {
            Object.keys(this.handlesRefs).forEach(function (key) {
              if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
                _this2.handlesRefs[key].blur();
              }
            });
          }
        }
      }, {
        key: 'calcValue',
        value: function calcValue(offset) {
          var _props3 = this.props,
            vertical = _props3.vertical,
            min = _props3.min,
            max = _props3.max;
          var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
          var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
          return value;
        }
      }, {
        key: 'calcValueByPos',
        value: function calcValueByPos(position) {
          var sign = this.props.reverse ? -1 : +1;
          var pixelOffset = sign * (position - this.getSliderStart());
          var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
          return nextValue;
        }
      }, {
        key: 'calcOffset',
        value: function calcOffset(value) {
          var _props4 = this.props,
            min = _props4.min,
            max = _props4.max;
          var ratio = (value - min) / (max - min);
          return ratio * 100;
        }
      }, {
        key: 'saveHandle',
        value: function saveHandle(index, handle) {
          this.handlesRefs[index] = handle;
        }
      }, {
        key: 'render',
        value: function render() {
          var _classNames;
          var _props5 = this.props,
            prefixCls = _props5.prefixCls,
            className = _props5.className,
            marks = _props5.marks,
            dots = _props5.dots,
            step = _props5.step,
            included = _props5.included,
            disabled = _props5.disabled,
            vertical = _props5.vertical,
            reverse = _props5.reverse,
            min = _props5.min,
            max = _props5.max,
            children = _props5.children,
            maximumTrackStyle = _props5.maximumTrackStyle,
            style = _props5.style,
            railStyle = _props5.railStyle,
            dotStyle = _props5.dotStyle,
            activeDotStyle = _props5.activeDotStyle;
          var _get$call = get_default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;
          var sliderClassName = classnames_default()(prefixCls, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), defineProperty_default()(_classNames, prefixCls + '-disabled', disabled), defineProperty_default()(_classNames, prefixCls + '-vertical', vertical), defineProperty_default()(_classNames, className, className), _classNames));
          return external_react_default.a.createElement('div', {
            ref: this.saveSlider,
            className: sliderClassName,
            onTouchStart: disabled ? noop : this.onTouchStart,
            onMouseDown: disabled ? noop : this.onMouseDown,
            onMouseUp: disabled ? noop : this.onMouseUp,
            onKeyDown: disabled ? noop : this.onKeyDown,
            onFocus: disabled ? noop : this.onFocus,
            onBlur: disabled ? noop : this.onBlur,
            style: style
          }, external_react_default.a.createElement('div', {
            className: prefixCls + '-rail',
            style: extends_default()({}, maximumTrackStyle, railStyle)
          }), tracks, external_react_default.a.createElement(common_Steps, {
            prefixCls: prefixCls,
            vertical: vertical,
            reverse: reverse,
            marks: marks,
            dots: dots,
            step: step,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            dotStyle: dotStyle,
            activeDotStyle: activeDotStyle
          }), handles, external_react_default.a.createElement(common_Marks, {
            className: prefixCls + '-mark',
            onClickLabel: disabled ? noop : this.onClickMarkLabel,
            vertical: vertical,
            marks: marks,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            reverse: reverse
          }), children);
        }
      }]);
      return ComponentEnhancer;
    }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = extends_default()({}, Component.propTypes, {
      min: external_prop_types_default.a.number,
      max: external_prop_types_default.a.number,
      step: external_prop_types_default.a.number,
      marks: external_prop_types_default.a.object,
      included: external_prop_types_default.a.bool,
      className: external_prop_types_default.a.string,
      prefixCls: external_prop_types_default.a.string,
      disabled: external_prop_types_default.a.bool,
      children: external_prop_types_default.a.any,
      onBeforeChange: external_prop_types_default.a.func,
      onChange: external_prop_types_default.a.func,
      onAfterChange: external_prop_types_default.a.func,
      handle: external_prop_types_default.a.func,
      dots: external_prop_types_default.a.bool,
      vertical: external_prop_types_default.a.bool,
      style: external_prop_types_default.a.object,
      reverse: external_prop_types_default.a.bool,
      minimumTrackStyle: external_prop_types_default.a.object,
      // just for compatibility, will be deperecate
      maximumTrackStyle: external_prop_types_default.a.object,
      // just for compatibility, will be deperecate
      handleStyle: external_prop_types_default.a.oneOfType([external_prop_types_default.a.object, external_prop_types_default.a.arrayOf(external_prop_types_default.a.object)]),
      trackStyle: external_prop_types_default.a.oneOfType([external_prop_types_default.a.object, external_prop_types_default.a.arrayOf(external_prop_types_default.a.object)]),
      railStyle: external_prop_types_default.a.object,
      dotStyle: external_prop_types_default.a.object,
      activeDotStyle: external_prop_types_default.a.object,
      autoFocus: external_prop_types_default.a.bool,
      onFocus: external_prop_types_default.a.func,
      onBlur: external_prop_types_default.a.func
    }), _class.defaultProps = extends_default()({}, Component.defaultProps, {
      prefixCls: 'rc-slider',
      className: '',
      min: 0,
      max: 100,
      step: 1,
      marks: {},
      handle: function handle(_ref) {
        var index = _ref.index,
          restProps = objectWithoutProperties_default()(_ref, ['index']);
        delete restProps.dragging;
        if (restProps.value === null) {
          return null;
        }
        return external_react_default.a.createElement(es_Handle, extends_default()({}, restProps, {
          key: index
        }));
      },
      onBeforeChange: noop,
      onChange: noop,
      onAfterChange: noop,
      included: true,
      disabled: false,
      dots: false,
      vertical: false,
      reverse: false,
      trackStyle: [{}],
      handleStyle: [{}],
      railStyle: {},
      dotStyle: {},
      activeDotStyle: {}
    }), _temp;
  }
  // CONCATENATED MODULE: ./node_modules/rc-slider/es/Slider.js

  /* eslint-disable react/prop-types */

  var Slider_Slider = function (_React$Component) {
    inherits_default()(Slider, _React$Component);
    function Slider(props) {
      classCallCheck_default()(this, Slider);
      var _this = possibleConstructorReturn_default()(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
      _this.onEnd = function (force) {
        var dragging = _this.state.dragging;
        _this.removeDocumentEvents();
        if (dragging || force) {
          _this.props.onAfterChange(_this.getValue());
        }
        _this.setState({
          dragging: false
        });
      };
      var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
      var value = props.value !== undefined ? props.value : defaultValue;
      _this.state = {
        value: _this.trimAlignValue(value),
        dragging: false
      };
      warning_default()(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
      warning_default()(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
      return _this;
    }
    createClass_default()(Slider, [{
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
          return;
        }
        var _props = this.props,
          value = _props.value,
          onChange = _props.onChange;
        var theValue = value !== undefined ? value : prevState.value;
        var nextValue = this.trimAlignValue(theValue, this.props);
        if (nextValue !== prevState.value) {
          // eslint-disable-next-line
          this.setState({
            value: nextValue
          });
          if (isValueOutOfRange(theValue, this.props)) {
            onChange(nextValue);
          }
        }
      }
    }, {
      key: 'onChange',
      value: function onChange(state) {
        var props = this.props;
        var isNotControlled = !('value' in props);
        var nextState = state.value > this.props.max ? extends_default()({}, state, {
          value: this.props.max
        }) : state;
        if (isNotControlled) {
          this.setState(nextState);
        }
        var changedValue = nextState.value;
        props.onChange(changedValue);
      }
    }, {
      key: 'onStart',
      value: function onStart(position) {
        this.setState({
          dragging: true
        });
        var props = this.props;
        var prevValue = this.getValue();
        props.onBeforeChange(prevValue);
        var value = this.calcValueByPos(position);
        this.startValue = value;
        this.startPosition = position;
        if (value === prevValue) return;
        this.prevMovedHandleIndex = 0;
        this.onChange({
          value: value
        });
      }
    }, {
      key: 'onMove',
      value: function onMove(e, position) {
        pauseEvent(e);
        var oldValue = this.state.value;
        var value = this.calcValueByPos(position);
        if (value === oldValue) return;
        this.onChange({
          value: value
        });
      }
    }, {
      key: 'onKeyboard',
      value: function onKeyboard(e) {
        var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;
        var valueMutator = getKeyboardValueMutator(e, vertical, reverse);
        if (valueMutator) {
          pauseEvent(e);
          var state = this.state;
          var oldValue = state.value;
          var mutatedValue = valueMutator(oldValue, this.props);
          var value = this.trimAlignValue(mutatedValue);
          if (value === oldValue) return;
          this.onChange({
            value: value
          });
          this.props.onAfterChange(value);
          this.onEnd();
        }
      }
    }, {
      key: 'getValue',
      value: function getValue() {
        return this.state.value;
      }
    }, {
      key: 'getLowerBound',
      value: function getLowerBound() {
        return this.props.min;
      }
    }, {
      key: 'getUpperBound',
      value: function getUpperBound() {
        return this.state.value;
      }
    }, {
      key: 'trimAlignValue',
      value: function trimAlignValue(v) {
        var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (v === null) {
          return null;
        }
        var mergedProps = extends_default()({}, this.props, nextProps);
        var val = ensureValueInRange(v, mergedProps);
        return ensureValuePrecision(val, mergedProps);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;
        var _props3 = this.props,
          prefixCls = _props3.prefixCls,
          vertical = _props3.vertical,
          included = _props3.included,
          disabled = _props3.disabled,
          minimumTrackStyle = _props3.minimumTrackStyle,
          trackStyle = _props3.trackStyle,
          handleStyle = _props3.handleStyle,
          tabIndex = _props3.tabIndex,
          min = _props3.min,
          max = _props3.max,
          reverse = _props3.reverse,
          handleGenerator = _props3.handle;
        var _state = this.state,
          value = _state.value,
          dragging = _state.dragging;
        var offset = this.calcOffset(value);
        var handle = handleGenerator({
          className: prefixCls + '-handle',
          prefixCls: prefixCls,
          vertical: vertical,
          offset: offset,
          value: value,
          dragging: dragging,
          disabled: disabled,
          min: min,
          max: max,
          reverse: reverse,
          index: 0,
          tabIndex: tabIndex,
          style: handleStyle[0] || handleStyle,
          ref: function ref(h) {
            return _this2.saveHandle(0, h);
          }
        });
        var _trackStyle = trackStyle[0] || trackStyle;
        var track = external_react_default.a.createElement(common_Track, {
          className: prefixCls + '-track',
          vertical: vertical,
          included: included,
          offset: 0,
          reverse: reverse,
          length: offset,
          style: extends_default()({}, minimumTrackStyle, _trackStyle)
        });
        return {
          tracks: track,
          handles: handle
        };
      }
    }]);
    return Slider;
  }(external_react_default.a.Component);
  Slider_Slider.propTypes = {
    defaultValue: external_prop_types_default.a.number,
    value: external_prop_types_default.a.number,
    disabled: external_prop_types_default.a.bool,
    autoFocus: external_prop_types_default.a.bool,
    tabIndex: external_prop_types_default.a.number,
    reverse: external_prop_types_default.a.bool,
    min: external_prop_types_default.a.number,
    max: external_prop_types_default.a.number
  };

  /* harmony default export */
  var es_Slider = createSlider(Slider_Slider);
  // EXTERNAL MODULE: ./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
  var react_lifecycles_compat_es = __webpack_require__(169);

  // EXTERNAL MODULE: ./node_modules/shallowequal/index.js
  var shallowequal = __webpack_require__(536);
  var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);

  // CONCATENATED MODULE: ./node_modules/rc-slider/es/Range.js

  /* eslint-disable react/prop-types */

  var Range_trimAlignValue = function _trimAlignValue(_ref) {
    var value = _ref.value,
      handle = _ref.handle,
      bounds = _ref.bounds,
      props = _ref.props;
    var allowCross = props.allowCross,
      pushable = props.pushable;
    var thershold = Number(pushable);
    var valInRange = ensureValueInRange(value, props);
    var valNotConflict = valInRange;
    if (!allowCross && handle != null && bounds !== undefined) {
      if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
        valNotConflict = bounds[handle - 1] + thershold;
      }
      if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
        valNotConflict = bounds[handle + 1] - thershold;
      }
    }
    return ensureValuePrecision(valNotConflict, props);
  };
  var Range_Range = function (_React$Component) {
    inherits_default()(Range, _React$Component);
    function Range(props) {
      classCallCheck_default()(this, Range);
      var _this = possibleConstructorReturn_default()(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));
      _this.onEnd = function (force) {
        var handle = _this.state.handle;
        _this.removeDocumentEvents();
        if (handle !== null || force) {
          _this.props.onAfterChange(_this.getValue());
        }
        _this.setState({
          handle: null
        });
      };
      var count = props.count,
        min = props.min,
        max = props.max;
      var initialValue = Array.apply(undefined, toConsumableArray_default()(Array(count + 1))).map(function () {
        return min;
      });
      var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
      var value = props.value !== undefined ? props.value : defaultValue;
      var bounds = value.map(function (v, i) {
        return Range_trimAlignValue({
          value: v,
          handle: i,
          props: props
        });
      });
      var recent = bounds[0] === max ? 0 : bounds.length - 1;
      _this.state = {
        handle: null,
        recent: recent,
        bounds: bounds
      };
      return _this;
    }
    createClass_default()(Range, [{
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var _this2 = this;
        if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
          return;
        }
        if (this.props.min === prevProps.min && this.props.max === prevProps.max && shallowequal_default()(this.props.value, prevProps.value)) {
          return;
        }
        var _props = this.props,
          onChange = _props.onChange,
          value = _props.value;
        var currentValue = value || prevState.bounds;
        if (currentValue.some(function (v) {
          return isValueOutOfRange(v, _this2.props);
        })) {
          var newValues = currentValue.map(function (v) {
            return ensureValueInRange(v, _this2.props);
          });
          onChange(newValues);
        }
      }
    }, {
      key: 'onChange',
      value: function onChange(state) {
        var props = this.props;
        var isNotControlled = !('value' in props);
        if (isNotControlled) {
          this.setState(state);
        } else {
          var controlledState = {};
          ['handle', 'recent'].forEach(function (item) {
            if (state[item] !== undefined) {
              controlledState[item] = state[item];
            }
          });
          if (Object.keys(controlledState).length) {
            this.setState(controlledState);
          }
        }
        var data = extends_default()({}, this.state, state);
        var changedValue = data.bounds;
        props.onChange(changedValue);
      }
    }, {
      key: 'onStart',
      value: function onStart(position) {
        var props = this.props;
        var state = this.state;
        var bounds = this.getValue();
        props.onBeforeChange(bounds);
        var value = this.calcValueByPos(position);
        this.startValue = value;
        this.startPosition = position;
        var closestBound = this.getClosestBound(value);
        this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
        this.setState({
          handle: this.prevMovedHandleIndex,
          recent: this.prevMovedHandleIndex
        });
        var prevValue = bounds[this.prevMovedHandleIndex];
        if (value === prevValue) return;
        var nextBounds = [].concat(toConsumableArray_default()(state.bounds));
        nextBounds[this.prevMovedHandleIndex] = value;
        this.onChange({
          bounds: nextBounds
        });
      }
    }, {
      key: 'onMove',
      value: function onMove(e, position) {
        pauseEvent(e);
        var state = this.state;
        var value = this.calcValueByPos(position);
        var oldValue = state.bounds[state.handle];
        if (value === oldValue) return;
        this.moveTo(value);
      }
    }, {
      key: 'onKeyboard',
      value: function onKeyboard(e) {
        var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;
        var valueMutator = getKeyboardValueMutator(e, vertical, reverse);
        if (valueMutator) {
          pauseEvent(e);
          var state = this.state,
            props = this.props;
          var bounds = state.bounds,
            handle = state.handle;
          var oldValue = bounds[handle === null ? state.recent : handle];
          var mutatedValue = valueMutator(oldValue, props);
          var value = Range_trimAlignValue({
            value: mutatedValue,
            handle: handle,
            bounds: state.bounds,
            props: props
          });
          if (value === oldValue) return;
          var isFromKeyboardEvent = true;
          this.moveTo(value, isFromKeyboardEvent);
        }
      }
    }, {
      key: 'getValue',
      value: function getValue() {
        return this.state.bounds;
      }
    }, {
      key: 'getClosestBound',
      value: function getClosestBound(value) {
        var bounds = this.state.bounds;
        var closestBound = 0;
        for (var i = 1; i < bounds.length - 1; ++i) {
          if (value >= bounds[i]) {
            closestBound = i;
          }
        }
        if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
          closestBound += 1;
        }
        return closestBound;
      }
    }, {
      key: 'getBoundNeedMoving',
      value: function getBoundNeedMoving(value, closestBound) {
        var _state = this.state,
          bounds = _state.bounds,
          recent = _state.recent;
        var boundNeedMoving = closestBound;
        var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
        if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
          boundNeedMoving = recent;
        }
        if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
          boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
        }
        return boundNeedMoving;
      }
    }, {
      key: 'getLowerBound',
      value: function getLowerBound() {
        return this.state.bounds[0];
      }
    }, {
      key: 'getUpperBound',
      value: function getUpperBound() {
        var bounds = this.state.bounds;
        return bounds[bounds.length - 1];
      }

      /**
       * Returns an array of possible slider points, taking into account both
       * `marks` and `step`. The result is cached.
       */
    }, {
      key: 'getPoints',
      value: function getPoints() {
        var _props3 = this.props,
          marks = _props3.marks,
          step = _props3.step,
          min = _props3.min,
          max = _props3.max;
        var cache = this._getPointsCache;
        if (!cache || cache.marks !== marks || cache.step !== step) {
          var pointsObject = extends_default()({}, marks);
          if (step !== null) {
            for (var point = min; point <= max; point += step) {
              pointsObject[point] = point;
            }
          }
          var points = Object.keys(pointsObject).map(parseFloat);
          points.sort(function (a, b) {
            return a - b;
          });
          this._getPointsCache = {
            marks: marks,
            step: step,
            points: points
          };
        }
        return this._getPointsCache.points;
      }
    }, {
      key: 'moveTo',
      value: function moveTo(value, isFromKeyboardEvent) {
        var _this3 = this;
        var state = this.state,
          props = this.props;
        var nextBounds = [].concat(toConsumableArray_default()(state.bounds));
        var handle = state.handle === null ? state.recent : state.handle;
        nextBounds[handle] = value;
        var nextHandle = handle;
        if (props.pushable !== false) {
          this.pushSurroundingHandles(nextBounds, nextHandle);
        } else if (props.allowCross) {
          nextBounds.sort(function (a, b) {
            return a - b;
          });
          nextHandle = nextBounds.indexOf(value);
        }
        this.onChange({
          recent: nextHandle,
          handle: nextHandle,
          bounds: nextBounds
        });
        if (isFromKeyboardEvent) {
          // known problem: because setState is async,
          // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
          // cause onBeforeChange and onAfterChange receive wrong value.
          // here use setState callback to hack，but not elegant
          this.props.onAfterChange(nextBounds);
          this.setState({}, function () {
            _this3.handlesRefs[nextHandle].focus();
          });
          this.onEnd();
        }
      }
    }, {
      key: 'pushSurroundingHandles',
      value: function pushSurroundingHandles(bounds, handle) {
        var value = bounds[handle];
        var threshold = this.props.pushable;
        threshold = Number(threshold);
        var direction = 0;
        if (bounds[handle + 1] - value < threshold) {
          direction = +1; // push to right
        }

        if (value - bounds[handle - 1] < threshold) {
          direction = -1; // push to left
        }

        if (direction === 0) {
          return;
        }
        var nextHandle = handle + direction;
        var diffToNext = direction * (bounds[nextHandle] - value);
        if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
          // revert to original value if pushing is impossible
          bounds[handle] = bounds[nextHandle] - direction * threshold;
        }
      }
    }, {
      key: 'pushHandle',
      value: function pushHandle(bounds, handle, direction, amount) {
        var originalValue = bounds[handle];
        var currentValue = bounds[handle];
        while (direction * (currentValue - originalValue) < amount) {
          if (!this.pushHandleOnePoint(bounds, handle, direction)) {
            // can't push handle enough to create the needed `amount` gap, so we
            // revert its position to the original value
            bounds[handle] = originalValue;
            return false;
          }
          currentValue = bounds[handle];
        }
        // the handle was pushed enough to create the needed `amount` gap
        return true;
      }
    }, {
      key: 'pushHandleOnePoint',
      value: function pushHandleOnePoint(bounds, handle, direction) {
        var points = this.getPoints();
        var pointIndex = points.indexOf(bounds[handle]);
        var nextPointIndex = pointIndex + direction;
        if (nextPointIndex >= points.length || nextPointIndex < 0) {
          // reached the minimum or maximum available point, can't push anymore
          return false;
        }
        var nextHandle = handle + direction;
        var nextValue = points[nextPointIndex];
        var threshold = this.props.pushable;
        var diffToNext = direction * (bounds[nextHandle] - nextValue);
        if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
          // couldn't push next handle, so we won't push this one either
          return false;
        }
        // push the handle
        bounds[handle] = nextValue;
        return true;
      }
    }, {
      key: 'trimAlignValue',
      value: function trimAlignValue(value) {
        var _state2 = this.state,
          handle = _state2.handle,
          bounds = _state2.bounds;
        return Range_trimAlignValue({
          value: value,
          handle: handle,
          bounds: bounds,
          props: this.props
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;
        var _state3 = this.state,
          handle = _state3.handle,
          bounds = _state3.bounds;
        var _props4 = this.props,
          prefixCls = _props4.prefixCls,
          vertical = _props4.vertical,
          included = _props4.included,
          disabled = _props4.disabled,
          min = _props4.min,
          max = _props4.max,
          reverse = _props4.reverse,
          handleGenerator = _props4.handle,
          trackStyle = _props4.trackStyle,
          handleStyle = _props4.handleStyle,
          tabIndex = _props4.tabIndex;
        var offsets = bounds.map(function (v) {
          return _this4.calcOffset(v);
        });
        var handleClassName = prefixCls + '-handle';
        var handles = bounds.map(function (v, i) {
          var _classNames;
          var _tabIndex = tabIndex[i] || 0;
          if (disabled || tabIndex[i] === null) {
            _tabIndex = null;
          }
          return handleGenerator({
            className: classnames_default()((_classNames = {}, defineProperty_default()(_classNames, handleClassName, true), defineProperty_default()(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
            prefixCls: prefixCls,
            vertical: vertical,
            offset: offsets[i],
            value: v,
            dragging: handle === i,
            index: i,
            tabIndex: _tabIndex,
            min: min,
            max: max,
            reverse: reverse,
            disabled: disabled,
            style: handleStyle[i],
            ref: function ref(h) {
              return _this4.saveHandle(i, h);
            }
          });
        });
        var tracks = bounds.slice(0, -1).map(function (_, index) {
          var _classNames2;
          var i = index + 1;
          var trackClassName = classnames_default()((_classNames2 = {}, defineProperty_default()(_classNames2, prefixCls + '-track', true), defineProperty_default()(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
          return external_react_default.a.createElement(common_Track, {
            className: trackClassName,
            vertical: vertical,
            reverse: reverse,
            included: included,
            offset: offsets[i - 1],
            length: offsets[i] - offsets[i - 1],
            style: trackStyle[index],
            key: i
          });
        });
        return {
          tracks: tracks,
          handles: handles
        };
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(props, state) {
        if ('value' in props || 'min' in props || 'max' in props) {
          var value = props.value || state.bounds;
          var nextBounds = value.map(function (v, i) {
            return Range_trimAlignValue({
              value: v,
              handle: i,
              bounds: state.bounds,
              props: props
            });
          });
          if (nextBounds.length === state.bounds.length && nextBounds.every(function (v, i) {
            return v === state.bounds[i];
          })) {
            return null;
          }
          return extends_default()({}, state, {
            bounds: nextBounds
          });
        }
        return null;
      }
    }]);
    return Range;
  }(external_react_default.a.Component);
  Range_Range.displayName = 'Range';
  Range_Range.propTypes = {
    autoFocus: external_prop_types_default.a.bool,
    defaultValue: external_prop_types_default.a.arrayOf(external_prop_types_default.a.number),
    value: external_prop_types_default.a.arrayOf(external_prop_types_default.a.number),
    count: external_prop_types_default.a.number,
    pushable: external_prop_types_default.a.oneOfType([external_prop_types_default.a.bool, external_prop_types_default.a.number]),
    allowCross: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    reverse: external_prop_types_default.a.bool,
    tabIndex: external_prop_types_default.a.arrayOf(external_prop_types_default.a.number),
    min: external_prop_types_default.a.number,
    max: external_prop_types_default.a.number
  };
  Range_Range.defaultProps = {
    count: 1,
    allowCross: true,
    pushable: false,
    tabIndex: []
  };
  Object(react_lifecycles_compat_es["polyfill"])(Range_Range);

  /* harmony default export */
  var es_Range = createSlider(Range_Range);
  // CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/contains.js
  function contains(root, n) {
    var node = n;
    while (node) {
      if (node === root) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }
  // CONCATENATED MODULE: ./node_modules/rc-util/es/ContainerRender.js
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  var ContainerRender_ContainerRender = /*#__PURE__*/function (_React$Component) {
    _inherits(ContainerRender, _React$Component);
    var _super = _createSuper(ContainerRender);
    function ContainerRender() {
      var _this;
      _classCallCheck(this, ContainerRender);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.removeContainer = function () {
        if (_this.container) {
          external_react_dom_default.a.unmountComponentAtNode(_this.container);
          _this.container.parentNode.removeChild(_this.container);
          _this.container = null;
        }
      };
      _this.renderComponent = function (props, ready) {
        var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;
        if (visible || parent._component || forceRender) {
          if (!_this.container) {
            _this.container = getContainer();
          }
          external_react_dom_default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
            if (ready) {
              ready.call(this);
            }
          });
        }
      };
      return _this;
    }
    _createClass(ContainerRender, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.autoMount) {
          this.renderComponent();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (this.props.autoMount) {
          this.renderComponent();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.props.autoDestroy) {
          this.removeContainer();
        }
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children({
          renderComponent: this.renderComponent,
          removeContainer: this.removeContainer
        });
      }
    }]);
    return ContainerRender;
  }(external_react_default.a.Component);
  ContainerRender_ContainerRender.propTypes = {
    autoMount: external_prop_types_default.a.bool,
    autoDestroy: external_prop_types_default.a.bool,
    visible: external_prop_types_default.a.bool,
    forceRender: external_prop_types_default.a.bool,
    parent: external_prop_types_default.a.any,
    getComponent: external_prop_types_default.a.func.isRequired,
    getContainer: external_prop_types_default.a.func.isRequired,
    children: external_prop_types_default.a.func.isRequired
  };
  ContainerRender_ContainerRender.defaultProps = {
    autoMount: true,
    autoDestroy: true,
    forceRender: false
  };

  // CONCATENATED MODULE: ./node_modules/rc-util/es/Portal.js
  function Portal_typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      Portal_typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      Portal_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return Portal_typeof(obj);
  }
  function Portal_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function Portal_defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function Portal_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) Portal_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) Portal_defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function Portal_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Portal_setPrototypeOf(subClass, superClass);
  }
  function Portal_setPrototypeOf(o, p) {
    Portal_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return Portal_setPrototypeOf(o, p);
  }
  function Portal_createSuper(Derived) {
    var hasNativeReflectConstruct = Portal_isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = Portal_getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = Portal_getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return Portal_possibleConstructorReturn(this, result);
    };
  }
  function Portal_possibleConstructorReturn(self, call) {
    if (call && (Portal_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }
    return Portal_assertThisInitialized(self);
  }
  function Portal_assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function Portal_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function Portal_getPrototypeOf(o) {
    Portal_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Portal_getPrototypeOf(o);
  }
  var Portal_Portal = /*#__PURE__*/function (_React$Component) {
    Portal_inherits(Portal, _React$Component);
    var _super = Portal_createSuper(Portal);
    function Portal() {
      Portal_classCallCheck(this, Portal);
      return _super.apply(this, arguments);
    }
    Portal_createClass(Portal, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.createContainer();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var didUpdate = this.props.didUpdate;
        if (didUpdate) {
          didUpdate(prevProps);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.removeContainer();
      }
    }, {
      key: "createContainer",
      value: function createContainer() {
        this._container = this.props.getContainer();
        this.forceUpdate();
      }
    }, {
      key: "removeContainer",
      value: function removeContainer() {
        if (this._container) {
          this._container.parentNode.removeChild(this._container);
        }
      }
    }, {
      key: "render",
      value: function render() {
        if (this._container) {
          return external_react_dom_default.a.createPortal(this.props.children, this._container);
        }
        return null;
      }
    }]);
    return Portal;
  }(external_react_default.a.Component);
  Portal_Portal.propTypes = {
    getContainer: external_prop_types_default.a.func.isRequired,
    children: external_prop_types_default.a.node.isRequired,
    didUpdate: external_prop_types_default.a.func
  };

  // CONCATENATED MODULE: ./node_modules/rc-trigger/es/utils.js

  function isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) {
      return a1[0] === a2[0];
    }
    return a1[0] === a2[0] && a1[1] === a2[1];
  }
  function getAlignFromPlacement(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return extends_default()({}, baseAlign, align);
  }
  function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    for (var placement in builtinPlacements) {
      if (builtinPlacements.hasOwnProperty(placement)) {
        if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
          return prefixCls + '-placement-' + placement;
        }
      }
    }
    return '';
  }
  function saveRef(name, component) {
    this[name] = component;
  }
  // CONCATENATED MODULE: ./node_modules/dom-align/dist-web/index.js
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function dist_web_typeof(obj) {
    "@babel/helpers - typeof";

    return dist_web_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, dist_web_typeof(obj);
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var vendorPrefix;
  var jsCssMap = {
    Webkit: '-webkit-',
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-'
  };
  function getVendorPrefix() {
    if (vendorPrefix !== undefined) {
      return vendorPrefix;
    }
    vendorPrefix = '';
    var style = document.createElement('p').style;
    var testProp = 'Transform';
    for (var key in jsCssMap) {
      if (key + testProp in style) {
        vendorPrefix = key;
      }
    }
    return vendorPrefix;
  }
  function getTransitionName() {
    return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
  }
  function getTransformName() {
    return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
  }
  function setTransitionProperty(node, value) {
    var name = getTransitionName();
    if (name) {
      node.style[name] = value;
      if (name !== 'transitionProperty') {
        node.style.transitionProperty = value;
      }
    }
  }
  function setTransform(node, value) {
    var name = getTransformName();
    if (name) {
      node.style[name] = value;
      if (name !== 'transform') {
        node.style.transform = value;
      }
    }
  }
  function getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[getTransitionName()];
  }
  function getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
    if (transform && transform !== 'none') {
      var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
      return {
        x: parseFloat(matrix[12] || matrix[4], 0),
        y: parseFloat(matrix[13] || matrix[5], 0)
      };
    }
    return {
      x: 0,
      y: 0
    };
  }
  var matrix2d = /matrix\((.*)\)/;
  var matrix3d = /matrix3d\((.*)\)/;
  function setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
    if (transform && transform !== 'none') {
      var arr;
      var match2d = transform.match(matrix2d);
      if (match2d) {
        match2d = match2d[1];
        arr = match2d.split(',').map(function (item) {
          return parseFloat(item, 10);
        });
        arr[4] = xy.x;
        arr[5] = xy.y;
        setTransform(node, "matrix(".concat(arr.join(','), ")"));
      } else {
        var match3d = transform.match(matrix3d)[1];
        arr = match3d.split(',').map(function (item) {
          return parseFloat(item, 10);
        });
        arr[12] = xy.x;
        arr[13] = xy.y;
        setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
      }
    } else {
      setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
    }
  }
  var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
  var getComputedStyleX;

  // https://stackoverflow.com/a/3485654/3040605
  function forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = 'none';
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
  }
  function css(el, name, v) {
    var value = v;
    if (dist_web_typeof(name) === 'object') {
      for (var i in name) {
        if (name.hasOwnProperty(i)) {
          css(el, i, name[i]);
        }
      }
      return undefined;
    }
    if (typeof value !== 'undefined') {
      if (typeof value === 'number') {
        value = "".concat(value, "px");
      }
      el.style[name] = value;
      return undefined;
    }
    return getComputedStyleX(el, name);
  }
  function getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();

    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

    x = Math.floor(box.left);
    y = Math.floor(box.top);

    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.

    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.

    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
      left: x,
      top: y
    };
  }
  function getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
      var d = w.document;
      // ie6,7,8 standard mode
      ret = d.documentElement[method];
      if (typeof ret !== 'number') {
        // quirks mode
        ret = d.body[method];
      }
    }
    return ret;
  }
  function getScrollLeft(w) {
    return getScroll(w);
  }
  function getScrollTop(w) {
    return getScroll(w, true);
  }
  function getOffset(el) {
    var pos = getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += getScrollLeft(w);
    pos.top += getScrollTop(w);
    return pos;
  }

  /**
   * A crude way of determining if an object is a window
   * @member util
   */
  function isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */
    return obj !== null && obj !== undefined && obj == obj.window;
  }
  function getDocument(node) {
    if (isWindow(node)) {
      return node.document;
    }
    if (node.nodeType === 9) {
      return node;
    }
    return node.ownerDocument;
  }
  function _getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = '';
    var d = getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) {
      val = computedStyle.getPropertyValue(name) || computedStyle[name];
    }
    return val;
  }
  var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
  var RE_POS = /^(top|right|bottom|left)$/;
  var CURRENT_STYLE = 'currentStyle';
  var RUNTIME_STYLE = 'runtimeStyle';
  var LEFT = 'left';
  var PX = 'px';
  function _getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
      // Remember the original values
      var style = elem.style;
      var left = style[LEFT];
      var rsLeft = elem[RUNTIME_STYLE][LEFT];

      // prevent flashing of content
      elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

      // Put in the new values to get a computed value out
      style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
      ret = style.pixelLeft + PX;

      // Revert the changed values
      style[LEFT] = left;
      elem[RUNTIME_STYLE][LEFT] = rsLeft;
    }
    return ret === '' ? 'auto' : ret;
  }
  if (typeof window !== 'undefined') {
    getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
  }
  function getOffsetDirection(dir, option) {
    if (dir === 'left') {
      return option.useCssRight ? 'right' : dir;
    }
    return option.useCssBottom ? 'bottom' : dir;
  }
  function oppositeOffsetDirection(dir) {
    if (dir === 'left') {
      return 'right';
    } else if (dir === 'right') {
      return 'left';
    } else if (dir === 'top') {
      return 'bottom';
    } else if (dir === 'bottom') {
      return 'top';
    }
  }

  // 设置 elem 相对 elem.ownerDocument 的坐标
  function setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if (css(elem, 'position') === 'static') {
      elem.style.position = 'relative';
    }
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = getOffsetDirection('left', option);
    var verticalProperty = getOffsetDirection('top', option);
    var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== 'left') {
      presetH = 999;
    }
    if (verticalProperty !== 'top') {
      presetV = 999;
    }
    var originalTransition = '';
    var originalOffset = getOffset(elem);
    if ('left' in offset || 'top' in offset) {
      originalTransition = getTransitionProperty(elem) || '';
      setTransitionProperty(elem, 'none');
    }
    if ('left' in offset) {
      elem.style[oppositeHorizontalProperty] = '';
      elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ('top' in offset) {
      elem.style[oppositeVerticalProperty] = '';
      elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    forceRelayout(elem);
    var old = getOffset(elem);
    var originalStyle = {};
    for (var key in offset) {
      if (offset.hasOwnProperty(key)) {
        var dir = getOffsetDirection(key, option);
        var preset = key === 'left' ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) {
          originalStyle[dir] = preset + off;
        } else {
          originalStyle[dir] = preset - off;
        }
      }
    }
    css(elem, originalStyle);
    // force relayout
    forceRelayout(elem);
    if ('left' in offset || 'top' in offset) {
      setTransitionProperty(elem, originalTransition);
    }
    var ret = {};
    for (var _key in offset) {
      if (offset.hasOwnProperty(_key)) {
        var _dir = getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) {
          ret[_dir] = originalStyle[_dir] + _off;
        } else {
          ret[_dir] = originalStyle[_dir] - _off;
        }
      }
    }
    css(elem, ret);
  }
  function setTransform$1(elem, offset) {
    var originalOffset = getOffset(elem);
    var originalXY = getTransformXY(elem);
    var resultXY = {
      x: originalXY.x,
      y: originalXY.y
    };
    if ('left' in offset) {
      resultXY.x = originalXY.x + offset.left - originalOffset.left;
    }
    if ('top' in offset) {
      resultXY.y = originalXY.y + offset.top - originalOffset.top;
    }
    setTransformXY(elem, resultXY);
  }
  function setOffset(elem, offset, option) {
    if (option.ignoreShake) {
      var oriOffset = getOffset(elem);
      var oLeft = oriOffset.left.toFixed(0);
      var oTop = oriOffset.top.toFixed(0);
      var tLeft = offset.left.toFixed(0);
      var tTop = offset.top.toFixed(0);
      if (oLeft === tLeft && oTop === tTop) {
        return;
      }
    }
    if (option.useCssRight || option.useCssBottom) {
      setLeftTop(elem, offset, option);
    } else if (option.useCssTransform && getTransformName() in document.body.style) {
      setTransform$1(elem, offset);
    } else {
      setLeftTop(elem, offset, option);
    }
  }
  function each(arr, fn) {
    for (var i = 0; i < arr.length; i++) {
      fn(arr[i]);
    }
  }
  function isBorderBoxFn(elem) {
    return getComputedStyleX(elem, 'boxSizing') === 'border-box';
  }
  var BOX_MODELS = ['margin', 'border', 'padding'];
  var CONTENT_INDEX = -1;
  var PADDING_INDEX = 2;
  var BORDER_INDEX = 1;
  var MARGIN_INDEX = 0;
  function swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;

    // Remember the old values, and insert the new ones
    for (name in options) {
      if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
      }
    }
    callback.call(elem);

    // Revert the old values
    for (name in options) {
      if (options.hasOwnProperty(name)) {
        style[name] = old[name];
      }
    }
  }
  function getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for (j = 0; j < props.length; j++) {
      prop = props[j];
      if (prop) {
        for (i = 0; i < which.length; i++) {
          var cssProp = void 0;
          if (prop === 'border') {
            cssProp = "".concat(prop).concat(which[i], "Width");
          } else {
            cssProp = prop + which[i];
          }
          value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
        }
      }
    }
    return value;
  }
  var domUtils = {
    getParent: function getParent(element) {
      var parent = element;
      do {
        if (parent.nodeType === 11 && parent.host) {
          parent = parent.host;
        } else {
          parent = parent.parentNode;
        }
      } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
      return parent;
    }
  };
  each(['Width', 'Height'], function (name) {
    domUtils["doc".concat(name)] = function (refWin) {
      var d = refWin.document;
      return Math.max(
      // firefox chrome documentElement.scrollHeight< body.scrollHeight
      // ie standard mode : documentElement.scrollHeight> body.scrollHeight
      d.documentElement["scroll".concat(name)],
      // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
    };
    domUtils["viewport".concat(name)] = function (win) {
      // pc browser includes scrollbar in window.innerWidth
      var prop = "client".concat(name);
      var doc = win.document;
      var body = doc.body;
      var documentElement = doc.documentElement;
      var documentElementProp = documentElement[prop];
      // 标准模式取 documentElement
      // backcompat 取 body
      return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
    };
  });

  /*
   得到元素的大小信息
   @param elem
   @param name
   @param {String} [extra]  'padding' : (css width) + padding
   'border' : (css width) + padding + border
   'margin' : (css width) + padding + border + margin
   */
  function getWH(elem, name, ex) {
    var extra = ex;
    if (isWindow(elem)) {
      return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
    } else if (elem.nodeType === 9) {
      return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
    }
    var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
    var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
      borderBoxValue = undefined;
      // Fall back to computed then un computed css if necessary
      cssBoxValue = getComputedStyleX(elem, name);
      if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
        cssBoxValue = elem.style[name] || 0;
      }
      // Normalize '', auto, and prepare for extra
      cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) {
      extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
    }
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === CONTENT_INDEX) {
      if (borderBoxValueOrIsBorderBox) {
        return val - getPBMWidth(elem, ['border', 'padding'], which);
      }
      return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
      if (extra === BORDER_INDEX) {
        return val;
      }
      return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
    }
    return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
  }
  var cssShow = {
    position: 'absolute',
    visibility: 'hidden',
    display: 'block'
  };

  // fix #119 : https://github.com/kissyteam/kissy/issues/119
  function getWHIgnoreDisplay() {
    for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) {
      val = getWH.apply(undefined, args);
    } else {
      swap(elem, cssShow, function () {
        val = getWH.apply(undefined, args);
      });
    }
    return val;
  }
  each(['width', 'height'], function (name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    domUtils["outer".concat(first)] = function (el, includeMargin) {
      return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
    };
    var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
    domUtils[name] = function (elem, v) {
      var val = v;
      if (val !== undefined) {
        if (elem) {
          var isBorderBox = isBorderBoxFn(elem);
          if (isBorderBox) {
            val += getPBMWidth(elem, ['padding', 'border'], which);
          }
          return css(elem, name, val);
        }
        return undefined;
      }
      return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
    };
  });
  function mix(to, from) {
    for (var i in from) {
      if (from.hasOwnProperty(i)) {
        to[i] = from[i];
      }
    }
    return to;
  }
  var utils = {
    getWindow: function getWindow(node) {
      if (node && node.document && node.setTimeout) {
        return node;
      }
      var doc = node.ownerDocument || node;
      return doc.defaultView || doc.parentWindow;
    },
    getDocument: getDocument,
    offset: function offset(el, value, option) {
      if (typeof value !== 'undefined') {
        setOffset(el, value, option || {});
      } else {
        return getOffset(el);
      }
    },
    isWindow: isWindow,
    each: each,
    css: css,
    clone: function clone(obj) {
      var i;
      var ret = {};
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret[i] = obj[i];
        }
      }
      var overflow = obj.overflow;
      if (overflow) {
        for (i in obj) {
          if (obj.hasOwnProperty(i)) {
            ret.overflow[i] = obj.overflow[i];
          }
        }
      }
      return ret;
    },
    mix: mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
      return getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
      return getScrollTop(w);
    },
    merge: function merge() {
      var ret = {};
      for (var i = 0; i < arguments.length; i++) {
        utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
      }
      return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
  };
  mix(utils, domUtils);

  /**
   * 得到会导致元素显示不全的祖先元素
   */
  var getParent = utils.getParent;
  function getOffsetParent(element) {
    if (utils.isWindow(element) || element.nodeType === 9) {
      return null;
    }
    // ie 这个也不是完全可行
    /*
     <div style="width: 50px;height: 100px;overflow: hidden">
     <div style="width: 50px;height: 100px;position: relative;" id="d6">
     元素 6 高 100px 宽 50px<br/>
     </div>
     </div>
     */
    // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = utils.css(element, 'position');
    var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
    if (!skipStatic) {
      return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
    }
    for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
      positionStyle = utils.css(parent, 'position');
      if (positionStyle !== 'static') {
        return parent;
      }
    }
    return null;
  }
  var getParent$1 = utils.getParent;
  function isAncestorFixed(element) {
    if (utils.isWindow(element) || element.nodeType === 9) {
      return false;
    }
    var doc = utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for (parent = getParent$1(element);
    // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
      var positionStyle = utils.css(parent, 'position');
      if (positionStyle === 'fixed') {
        return true;
      }
    }
    return false;
  }

  /**
   * 获得元素的显示部分的区域
   */
  function getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
      left: 0,
      right: Infinity,
      top: 0,
      bottom: Infinity
    };
    var el = getOffsetParent(element);
    var doc = utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;

    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while (el) {
      // clientWidth is zero for inline block elements in ie.
      if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
      // body may have overflow set on it, yet we still get the entire
      // viewport. In some browsers, el.offsetParent may be
      // document.documentElement, so check for that too.
      el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
        var pos = utils.offset(el);
        // add border
        pos.left += el.clientLeft;
        pos.top += el.clientTop;
        visibleRect.top = Math.max(visibleRect.top, pos.top);
        visibleRect.right = Math.min(visibleRect.right,
        // consider area without scrollBar
        pos.left + el.clientWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
        visibleRect.left = Math.max(visibleRect.left, pos.left);
      } else if (el === body || el === documentElement) {
        break;
      }
      el = getOffsetParent(el);
    }

    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!utils.isWindow(element) && element.nodeType !== 9) {
      originalPosition = element.style.position;
      var position = utils.css(element, 'position');
      if (position === 'absolute') {
        element.style.position = 'fixed';
      }
    }
    var scrollX = utils.getWindowScrollLeft(win);
    var scrollY = utils.getWindowScrollTop(win);
    var viewportWidth = utils.viewportWidth(win);
    var viewportHeight = utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;

    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === 'hidden') {
      documentWidth = win.innerWidth;
    }
    if (bodyStyle.overflowY === 'hidden') {
      documentHeight = win.innerHeight;
    }

    // Reset element position after calculate the visible area
    if (element.style) {
      element.style.position = originalPosition;
    }
    if (alwaysByViewport || isAncestorFixed(element)) {
      // Clip by viewport's size.
      visibleRect.left = Math.max(visibleRect.left, scrollX);
      visibleRect.top = Math.max(visibleRect.top, scrollY);
      visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
      // Clip by document's size.
      var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
      visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
      var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
      visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
  }
  function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = utils.clone(elFuturePos);
    var size = {
      width: elRegion.width,
      height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) {
      pos.left = visibleRect.left;
    }

    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
      size.width -= pos.left + size.width - visibleRect.right;
    }

    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
      // 保证左边界和可视区域左边界对齐
      pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    }

    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) {
      pos.top = visibleRect.top;
    }

    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
      size.height -= pos.top + size.height - visibleRect.bottom;
    }

    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
      // 保证上边界和可视区域上边界对齐
      pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    }
    return utils.mix(pos, size);
  }
  function getRegion(node) {
    var offset;
    var w;
    var h;
    if (!utils.isWindow(node) && node.nodeType !== 9) {
      offset = utils.offset(node);
      w = utils.outerWidth(node);
      h = utils.outerHeight(node);
    } else {
      var win = utils.getWindow(node);
      offset = {
        left: utils.getWindowScrollLeft(win),
        top: utils.getWindowScrollTop(win)
      };
      w = utils.viewportWidth(win);
      h = utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
  }

  /**
   * 获取 node 上的 align 对齐点 相对于页面的坐标
   */

  function getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === 'c') {
      y += h / 2;
    } else if (V === 'b') {
      y += h;
    }
    if (H === 'c') {
      x += w / 2;
    } else if (H === 'r') {
      x += w;
    }
    return {
      left: x,
      top: y
    };
  }
  function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = getAlignOffset(refNodeRegion, points[1]);
    var p2 = getAlignOffset(elRegion, points[0]);
    var diff = [p2.left - p1.left, p2.top - p1.top];
    return {
      left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
      top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
  }

  /**
   * align dom node flexibly
   * @author yiminghe@gmail.com
   */

  // http://yiminghe.iteye.com/blog/1124720

  function isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
  }
  function isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
  }
  function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
  }
  function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
  }
  function flip(points, reg, map) {
    var ret = [];
    utils.each(points, function (p) {
      ret.push(p.replace(reg, function (m) {
        return map[m];
      }));
    });
    return ret;
  }
  function flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
  }
  function convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) {
      n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    } else {
      n = parseInt(str, 10);
    }
    return n || 0;
  }
  function normalizeOffset(offset, el) {
    offset[0] = convertOffset(offset[0], el.width);
    offset[1] = convertOffset(offset[1], el.height);
  }

  /**
   * @param el
   * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
   * @param align
   */
  function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [0, 0];
    var targetOffset = align.targetOffset || [0, 0];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = getRegion(source);
    // 将 offset 转换成数值，支持百分比
    normalizeOffset(offset, elRegion);
    normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = utils.merge(elRegion, elFuturePos);

    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
      if (overflow.adjustX) {
        // 如果横向不能放下
        if (isFailX(elFuturePos, elRegion, visibleRect)) {
          // 对齐位置反下
          var newPoints = flip(points, /[lr]/gi, {
            l: 'r',
            r: 'l'
          });
          // 偏移量也反下
          var newOffset = flipOffset(offset, 0);
          var newTargetOffset = flipOffset(targetOffset, 0);
          var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
          if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
            fail = 1;
            points = newPoints;
            offset = newOffset;
            targetOffset = newTargetOffset;
          }
        }
      }
      if (overflow.adjustY) {
        // 如果纵向不能放下
        if (isFailY(elFuturePos, elRegion, visibleRect)) {
          // 对齐位置反下
          var _newPoints = flip(points, /[tb]/gi, {
            t: 'b',
            b: 't'
          });
          // 偏移量也反下
          var _newOffset = flipOffset(offset, 1);
          var _newTargetOffset = flipOffset(targetOffset, 1);
          var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
          if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
            fail = 1;
            points = _newPoints;
            offset = _newOffset;
            targetOffset = _newTargetOffset;
          }
        }
      }

      // 如果失败，重新计算当前节点将要被放置的位置
      if (fail) {
        elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
        utils.mix(newElRegion, elFuturePos);
      }
      var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
      var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
      // 检查反下后的位置是否可以放下了，如果仍然放不下：
      // 1. 复原修改过的定位参数
      if (isStillFailX || isStillFailY) {
        var _newPoints2 = points;

        // 重置对应部分的翻转逻辑
        if (isStillFailX) {
          _newPoints2 = flip(points, /[lr]/gi, {
            l: 'r',
            r: 'l'
          });
        }
        if (isStillFailY) {
          _newPoints2 = flip(points, /[tb]/gi, {
            t: 'b',
            b: 't'
          });
        }
        points = _newPoints2;
        offset = align.offset || [0, 0];
        targetOffset = align.targetOffset || [0, 0];
      }
      // 2. 只有指定了可以调整当前方向才调整
      newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
      newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

      // 确实要调整，甚至可能会调整高度宽度
      if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
        newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
      }
    }

    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) {
      utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
    }
    if (newElRegion.height !== elRegion.height) {
      utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
    }

    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    utils.offset(source, {
      left: newElRegion.left,
      top: newElRegion.top
    }, {
      useCssRight: align.useCssRight,
      useCssBottom: align.useCssBottom,
      useCssTransform: align.useCssTransform,
      ignoreShake: align.ignoreShake
    });
    return {
      points: points,
      offset: offset,
      targetOffset: targetOffset,
      overflow: newOverflowCfg
    };
  }
  /**
   *  2012-04-26 yiminghe@gmail.com
   *   - 优化智能对齐算法
   *   - 慎用 resizeXX
   *
   *  2011-07-13 yiminghe@gmail.com note:
   *   - 增加智能对齐，以及大小调整选项
   **/

  function isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
  }
  function alignElement(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = getRegion(target);
    var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
  }
  alignElement.__getOffsetParent = getOffsetParent;
  alignElement.__getVisibleRectForElement = getVisibleRectForElement;

  /**
   * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
   * If client position provided, will internal convert to page position.
   */

  function dist_web_alignPoint(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = utils.getWindowScrollLeft(win);
    var scrollY = utils.getWindowScrollTop(win);
    var viewportWidth = utils.viewportWidth(win);
    var viewportHeight = utils.viewportHeight(win);
    if ('pageX' in tgtPoint) {
      pageX = tgtPoint.pageX;
    } else {
      pageX = scrollX + tgtPoint.clientX;
    }
    if ('pageY' in tgtPoint) {
      pageY = tgtPoint.pageY;
    } else {
      pageY = scrollY + tgtPoint.clientY;
    }
    var tgtRegion = {
      left: pageX,
      top: pageY,
      width: 0,
      height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

    // Provide default target point
    var points = [align.points[0], 'cc'];
    return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
      points: points
    }), pointInView);
  }

  /* harmony default export */
  var dist_web = alignElement;

  // CONCATENATED MODULE: ./node_modules/rc-align/es/util.js

  function buffer(fn, ms) {
    var timer = void 0;
    function clear() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }
    function bufferFn() {
      clear();
      timer = setTimeout(fn, ms);
    }
    bufferFn.clear = clear;
    return bufferFn;
  }
  function isSamePoint(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ('pageX' in next && 'pageY' in next) {
      return prev.pageX === next.pageX && prev.pageY === next.pageY;
    }
    if ('clientX' in next && 'clientY' in next) {
      return prev.clientX === next.clientX && prev.clientY === next.clientY;
    }
    return false;
  }
  function util_isWindow(obj) {
    return obj && typeof obj === 'object' && obj.window === obj;
  }
  function isSimilarValue(val1, val2) {
    var int1 = Math.floor(val1);
    var int2 = Math.floor(val2);
    return Math.abs(int1 - int2) <= 1;
  }
  function restoreFocus(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && contains(container, activeElement)) {
      activeElement.focus();
    }
  }
  // CONCATENATED MODULE: ./node_modules/rc-align/es/Align.js

  function getElement(func) {
    if (typeof func !== 'function' || !func) return null;
    return func();
  }
  function getPoint(point) {
    if (typeof point !== 'object' || !point) return null;
    return point;
  }
  var Align_Align = function (_Component) {
    inherits_default()(Align, _Component);
    function Align() {
      var _ref;
      var _temp, _this, _ret;
      classCallCheck_default()(this, Align);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
        var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;
        if (!disabled && target) {
          var source = external_react_dom_default.a.findDOMNode(_this);
          var result = void 0;
          var element = getElement(target);
          var point = getPoint(target);

          // IE lose focus after element realign
          // We should record activeElement and restore later
          var activeElement = document.activeElement;
          if (element) {
            result = alignElement(source, element, align);
          } else if (point) {
            result = dist_web_alignPoint(source, point, align);
          }
          restoreFocus(activeElement, source);
          if (onAlign) {
            onAlign(source, result);
          }
        }
      }, _temp), possibleConstructorReturn_default()(_this, _ret);
    }
    createClass_default()(Align, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var props = this.props;
        // if parent ref not attached .... use document.getElementById
        this.forceAlign();
        if (!props.disabled && props.monitorWindowResize) {
          this.startMonitorWindowResize();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var reAlign = false;
        var props = this.props;
        if (!props.disabled) {
          var source = external_react_dom_default.a.findDOMNode(this);
          var sourceRect = source ? source.getBoundingClientRect() : null;
          if (prevProps.disabled) {
            reAlign = true;
          } else {
            var lastElement = getElement(prevProps.target);
            var currentElement = getElement(props.target);
            var lastPoint = getPoint(prevProps.target);
            var currentPoint = getPoint(props.target);
            if (util_isWindow(lastElement) && util_isWindow(currentElement)) {
              // Skip if is window
              reAlign = false;
            } else if (lastElement !== currentElement ||
            // Element change
            lastElement && !currentElement && currentPoint ||
            // Change from element to point
            lastPoint && currentPoint && currentElement ||
            // Change from point to element
            currentPoint && !isSamePoint(lastPoint, currentPoint)) {
              reAlign = true;
            }

            // If source element size changed
            var preRect = this.sourceRect || {};
            if (!reAlign && source && (!isSimilarValue(preRect.width, sourceRect.width) || !isSimilarValue(preRect.height, sourceRect.height))) {
              reAlign = true;
            }
          }
          this.sourceRect = sourceRect;
        }
        if (reAlign) {
          this.forceAlign();
        }
        if (props.monitorWindowResize && !props.disabled) {
          this.startMonitorWindowResize();
        } else {
          this.stopMonitorWindowResize();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.stopMonitorWindowResize();
      }
    }, {
      key: 'startMonitorWindowResize',
      value: function startMonitorWindowResize() {
        if (!this.resizeHandler) {
          this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime);
          this.resizeHandler = addEventListenerWrap(window, 'resize', this.bufferMonitor);
        }
      }
    }, {
      key: 'stopMonitorWindowResize',
      value: function stopMonitorWindowResize() {
        if (this.resizeHandler) {
          this.bufferMonitor.clear();
          this.resizeHandler.remove();
          this.resizeHandler = null;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;
        var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;
        var child = external_react_default.a.Children.only(children);
        if (childrenProps) {
          var newProps = {};
          var propList = Object.keys(childrenProps);
          propList.forEach(function (prop) {
            newProps[prop] = _this2.props[childrenProps[prop]];
          });
          return external_react_default.a.cloneElement(child, newProps);
        }
        return child;
      }
    }]);
    return Align;
  }(external_react_["Component"]);
  Align_Align.propTypes = {
    childrenProps: external_prop_types_default.a.object,
    align: external_prop_types_default.a.object.isRequired,
    target: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.shape({
      clientX: external_prop_types_default.a.number,
      clientY: external_prop_types_default.a.number,
      pageX: external_prop_types_default.a.number,
      pageY: external_prop_types_default.a.number
    })]),
    onAlign: external_prop_types_default.a.func,
    monitorBufferTime: external_prop_types_default.a.number,
    monitorWindowResize: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    children: external_prop_types_default.a.any
  };
  Align_Align.defaultProps = {
    target: function target() {
      return window;
    },
    monitorBufferTime: 50,
    monitorWindowResize: false,
    disabled: false
  };

  /* harmony default export */
  var es_Align = Align_Align;
  // CONCATENATED MODULE: ./node_modules/rc-align/es/index.js
  // export this package's api

  /* harmony default export */
  var es = es_Align;
  // CONCATENATED MODULE: ./node_modules/rc-util/es/unsafeLifecyclesPolyfill.js

  var unsafeLifecyclesPolyfill_unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) {
      throw new Error('Can only polyfill class components');
    } // only handle componentWillReceiveProps

    if (typeof prototype.componentWillReceiveProps !== 'function') {
      return Component;
    } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
    // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler

    if (!external_react_default.a.Profiler) {
      return Component;
    } // Here polyfill get started

    prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
    delete prototype.componentWillReceiveProps;
    return Component;
  };

  /* harmony default export */
  var es_unsafeLifecyclesPolyfill = unsafeLifecyclesPolyfill_unsafeLifecyclesPolyfill;
  // CONCATENATED MODULE: ./node_modules/rc-animate/es/ChildrenUtils.js

  function toArrayChildren(children) {
    var ret = [];
    external_react_default.a.Children.forEach(children, function (child) {
      ret.push(child);
    });
    return ret;
  }
  function findChildInChildrenByKey(children, key) {
    var ret = null;
    if (children) {
      children.forEach(function (child) {
        if (ret) {
          return;
        }
        if (child && child.key === key) {
          ret = child;
        }
      });
    }
    return ret;
  }
  function findShownChildInChildrenByKey(children, key, showProp) {
    var ret = null;
    if (children) {
      children.forEach(function (child) {
        if (child && child.key === key && child.props[showProp]) {
          if (ret) {
            throw new Error('two child with same key for <rc-animate> children');
          }
          ret = child;
        }
      });
    }
    return ret;
  }
  function findHiddenChildInChildrenByKey(children, key, showProp) {
    var found = 0;
    if (children) {
      children.forEach(function (child) {
        if (found) {
          return;
        }
        found = child && child.key === key && !child.props[showProp];
      });
    }
    return found;
  }
  function isSameChildren(c1, c2, showProp) {
    var same = c1.length === c2.length;
    if (same) {
      c1.forEach(function (child, index) {
        var child2 = c2[index];
        if (child && child2) {
          if (child && !child2 || !child && child2) {
            same = false;
          } else if (child.key !== child2.key) {
            same = false;
          } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
            same = false;
          }
        }
      });
    }
    return same;
  }
  function mergeChildren(prev, next) {
    var ret = [];

    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextChildrenPending = {};
    var pendingChildren = [];
    prev.forEach(function (child) {
      if (child && findChildInChildrenByKey(next, child.key)) {
        if (pendingChildren.length) {
          nextChildrenPending[child.key] = pendingChildren;
          pendingChildren = [];
        }
      } else {
        pendingChildren.push(child);
      }
    });
    next.forEach(function (child) {
      if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
        ret = ret.concat(nextChildrenPending[child.key]);
      }
      ret.push(child);
    });
    ret = ret.concat(pendingChildren);
    return ret;
  }
  // EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
  var helpers_typeof = __webpack_require__(473);
  var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

  // CONCATENATED MODULE: ./node_modules/css-animation/es/Event.js
  var START_EVENT_NAME_MAP = {
    transitionstart: {
      transition: 'transitionstart',
      WebkitTransition: 'webkitTransitionStart',
      MozTransition: 'mozTransitionStart',
      OTransition: 'oTransitionStart',
      msTransition: 'MSTransitionStart'
    },
    animationstart: {
      animation: 'animationstart',
      WebkitAnimation: 'webkitAnimationStart',
      MozAnimation: 'mozAnimationStart',
      OAnimation: 'oAnimationStart',
      msAnimation: 'MSAnimationStart'
    }
  };
  var END_EVENT_NAME_MAP = {
    transitionend: {
      transition: 'transitionend',
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'mozTransitionEnd',
      OTransition: 'oTransitionEnd',
      msTransition: 'MSTransitionEnd'
    },
    animationend: {
      animation: 'animationend',
      WebkitAnimation: 'webkitAnimationEnd',
      MozAnimation: 'mozAnimationEnd',
      OAnimation: 'oAnimationEnd',
      msAnimation: 'MSAnimationEnd'
    }
  };
  var startEvents = [];
  var endEvents = [];
  function detectEvents() {
    var testEl = document.createElement('div');
    var style = testEl.style;
    if (!('AnimationEvent' in window)) {
      delete START_EVENT_NAME_MAP.animationstart.animation;
      delete END_EVENT_NAME_MAP.animationend.animation;
    }
    if (!('TransitionEvent' in window)) {
      delete START_EVENT_NAME_MAP.transitionstart.transition;
      delete END_EVENT_NAME_MAP.transitionend.transition;
    }
    function process(EVENT_NAME_MAP, events) {
      for (var baseEventName in EVENT_NAME_MAP) {
        if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
          var baseEvents = EVENT_NAME_MAP[baseEventName];
          for (var styleName in baseEvents) {
            if (styleName in style) {
              events.push(baseEvents[styleName]);
              break;
            }
          }
        }
      }
    }
    process(START_EVENT_NAME_MAP, startEvents);
    process(END_EVENT_NAME_MAP, endEvents);
  }
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    detectEvents();
  }
  function addEventListener(node, eventName, eventListener) {
    node.addEventListener(eventName, eventListener, false);
  }
  function removeEventListener(node, eventName, eventListener) {
    node.removeEventListener(eventName, eventListener, false);
  }
  var TransitionEvents = {
    // Start events
    startEvents: startEvents,
    addStartEventListener: function addStartEventListener(node, eventListener) {
      if (startEvents.length === 0) {
        window.setTimeout(eventListener, 0);
        return;
      }
      startEvents.forEach(function (startEvent) {
        addEventListener(node, startEvent, eventListener);
      });
    },
    removeStartEventListener: function removeStartEventListener(node, eventListener) {
      if (startEvents.length === 0) {
        return;
      }
      startEvents.forEach(function (startEvent) {
        removeEventListener(node, startEvent, eventListener);
      });
    },
    // End events
    endEvents: endEvents,
    addEndEventListener: function addEndEventListener(node, eventListener) {
      if (endEvents.length === 0) {
        window.setTimeout(eventListener, 0);
        return;
      }
      endEvents.forEach(function (endEvent) {
        addEventListener(node, endEvent, eventListener);
      });
    },
    removeEndEventListener: function removeEndEventListener(node, eventListener) {
      if (endEvents.length === 0) {
        return;
      }
      endEvents.forEach(function (endEvent) {
        removeEventListener(node, endEvent, eventListener);
      });
    }
  };

  /* harmony default export */
  var Event = TransitionEvents;
  // EXTERNAL MODULE: ./node_modules/component-classes/index.js
  var component_classes = __webpack_require__(537);
  var component_classes_default = /*#__PURE__*/__webpack_require__.n(component_classes);

  // CONCATENATED MODULE: ./node_modules/css-animation/es/index.js

  var isCssAnimationSupported = Event.endEvents.length !== 0;
  var capitalPrefixes = ['Webkit', 'Moz', 'O',
  // ms is special .... !
  'ms'];
  var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
  function getStyleProperty(node, name) {
    // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
    var style = window.getComputedStyle(node, null);
    var ret = '';
    for (var i = 0; i < prefixes.length; i++) {
      ret = style.getPropertyValue(prefixes[i] + name);
      if (ret) {
        break;
      }
    }
    return ret;
  }
  function fixBrowserByTimeout(node) {
    if (isCssAnimationSupported) {
      var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
      var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
      var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
      var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
      var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
      // sometimes, browser bug
      node.rcEndAnimTimeout = setTimeout(function () {
        node.rcEndAnimTimeout = null;
        if (node.rcEndListener) {
          node.rcEndListener();
        }
      }, time * 1000 + 200);
    }
  }
  function clearBrowserBugTimeout(node) {
    if (node.rcEndAnimTimeout) {
      clearTimeout(node.rcEndAnimTimeout);
      node.rcEndAnimTimeout = null;
    }
  }
  var es_cssAnimation = function cssAnimation(node, transitionName, endCallback) {
    var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : typeof_default()(transitionName)) === 'object';
    var className = nameIsObj ? transitionName.name : transitionName;
    var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
    var end = endCallback;
    var start = void 0;
    var active = void 0;
    var nodeClasses = component_classes_default()(node);
    if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
      end = endCallback.end;
      start = endCallback.start;
      active = endCallback.active;
    }
    if (node.rcEndListener) {
      node.rcEndListener();
    }
    node.rcEndListener = function (e) {
      if (e && e.target !== node) {
        return;
      }
      if (node.rcAnimTimeout) {
        clearTimeout(node.rcAnimTimeout);
        node.rcAnimTimeout = null;
      }
      clearBrowserBugTimeout(node);
      nodeClasses.remove(className);
      nodeClasses.remove(activeClassName);
      Event.removeEndEventListener(node, node.rcEndListener);
      node.rcEndListener = null;

      // Usually this optional end is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (end) {
        end();
      }
    };
    Event.addEndEventListener(node, node.rcEndListener);
    if (start) {
      start();
    }
    nodeClasses.add(className);
    node.rcAnimTimeout = setTimeout(function () {
      node.rcAnimTimeout = null;
      nodeClasses.add(activeClassName);
      if (active) {
        setTimeout(active, 0);
      }
      fixBrowserByTimeout(node);
      // 30ms for firefox
    }, 30);
    return {
      stop: function stop() {
        if (node.rcEndListener) {
          node.rcEndListener();
        }
      }
    };
  };
  es_cssAnimation.style = function (node, style, callback) {
    if (node.rcEndListener) {
      node.rcEndListener();
    }
    node.rcEndListener = function (e) {
      if (e && e.target !== node) {
        return;
      }
      if (node.rcAnimTimeout) {
        clearTimeout(node.rcAnimTimeout);
        node.rcAnimTimeout = null;
      }
      clearBrowserBugTimeout(node);
      Event.removeEndEventListener(node, node.rcEndListener);
      node.rcEndListener = null;

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (callback) {
        callback();
      }
    };
    Event.addEndEventListener(node, node.rcEndListener);
    node.rcAnimTimeout = setTimeout(function () {
      for (var s in style) {
        if (style.hasOwnProperty(s)) {
          node.style[s] = style[s];
        }
      }
      node.rcAnimTimeout = null;
      fixBrowserByTimeout(node);
    }, 0);
  };
  es_cssAnimation.setTransition = function (node, p, value) {
    var property = p;
    var v = value;
    if (value === undefined) {
      v = property;
      property = '';
    }
    property = property || '';
    capitalPrefixes.forEach(function (prefix) {
      node.style[prefix + 'Transition' + property] = v;
    });
  };
  es_cssAnimation.isCssAnimationSupported = isCssAnimationSupported;

  /* harmony default export */
  var css_animation_es = es_cssAnimation;
  // CONCATENATED MODULE: ./node_modules/rc-animate/es/util/animate.js
  var util = {
    isAppearSupported: function isAppearSupported(props) {
      return props.transitionName && props.transitionAppear || props.animation.appear;
    },
    isEnterSupported: function isEnterSupported(props) {
      return props.transitionName && props.transitionEnter || props.animation.enter;
    },
    isLeaveSupported: function isLeaveSupported(props) {
      return props.transitionName && props.transitionLeave || props.animation.leave;
    },
    allowAppearCallback: function allowAppearCallback(props) {
      return props.transitionAppear || props.animation.appear;
    },
    allowEnterCallback: function allowEnterCallback(props) {
      return props.transitionEnter || props.animation.enter;
    },
    allowLeaveCallback: function allowLeaveCallback(props) {
      return props.transitionLeave || props.animation.leave;
    }
  };
  /* harmony default export */
  var animate = util;
  // CONCATENATED MODULE: ./node_modules/rc-animate/es/AnimateChild.js

  var transitionMap = {
    enter: 'transitionEnter',
    appear: 'transitionAppear',
    leave: 'transitionLeave'
  };
  var AnimateChild_AnimateChild = function (_React$Component) {
    inherits_default()(AnimateChild, _React$Component);
    function AnimateChild() {
      classCallCheck_default()(this, AnimateChild);
      return possibleConstructorReturn_default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
    }
    createClass_default()(AnimateChild, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.stop();
      }
    }, {
      key: 'componentWillEnter',
      value: function componentWillEnter(done) {
        if (animate.isEnterSupported(this.props)) {
          this.transition('enter', done);
        } else {
          done();
        }
      }
    }, {
      key: 'componentWillAppear',
      value: function componentWillAppear(done) {
        if (animate.isAppearSupported(this.props)) {
          this.transition('appear', done);
        } else {
          done();
        }
      }
    }, {
      key: 'componentWillLeave',
      value: function componentWillLeave(done) {
        if (animate.isLeaveSupported(this.props)) {
          this.transition('leave', done);
        } else {
          // always sync, do not interupt with react component life cycle
          // update hidden -> animate hidden ->
          // didUpdate -> animate leave -> unmount (if animate is none)
          done();
        }
      }
    }, {
      key: 'transition',
      value: function transition(animationType, finishCallback) {
        var _this2 = this;
        var node = external_react_dom_default.a.findDOMNode(this);
        var props = this.props;
        var transitionName = props.transitionName;
        var nameIsObj = typeof transitionName === 'object';
        this.stop();
        var end = function end() {
          _this2.stopper = null;
          finishCallback();
        };
        if ((isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
          var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
          var activeName = name + '-active';
          if (nameIsObj && transitionName[animationType + 'Active']) {
            activeName = transitionName[animationType + 'Active'];
          }
          this.stopper = css_animation_es(node, {
            name: name,
            active: activeName
          }, end);
        } else {
          this.stopper = props.animation[animationType](node, end);
        }
      }
    }, {
      key: 'stop',
      value: function stop() {
        var stopper = this.stopper;
        if (stopper) {
          this.stopper = null;
          stopper.stop();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return this.props.children;
      }
    }]);
    return AnimateChild;
  }(external_react_default.a.Component);
  AnimateChild_AnimateChild.propTypes = {
    children: external_prop_types_default.a.any,
    animation: external_prop_types_default.a.any,
    transitionName: external_prop_types_default.a.any
  };
  /* harmony default export */
  var es_AnimateChild = AnimateChild_AnimateChild;
  // CONCATENATED MODULE: ./node_modules/rc-animate/es/Animate.js

  var defaultKey = 'rc_animate_' + Date.now();
  function getChildrenFromProps(props) {
    var children = props.children;
    if (external_react_default.a.isValidElement(children)) {
      if (!children.key) {
        return external_react_default.a.cloneElement(children, {
          key: defaultKey
        });
      }
    }
    return children;
  }
  function Animate_noop() {}
  var Animate_Animate = function (_React$Component) {
    inherits_default()(Animate, _React$Component);

    // eslint-disable-line

    function Animate(props) {
      classCallCheck_default()(this, Animate);
      var _this = possibleConstructorReturn_default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
      Animate_initialiseProps.call(_this);
      _this.currentlyAnimatingKeys = {};
      _this.keysToEnter = [];
      _this.keysToLeave = [];
      _this.state = {
        children: toArrayChildren(getChildrenFromProps(props))
      };
      _this.childrenRefs = {};
      return _this;
    }
    createClass_default()(Animate, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;
        var showProp = this.props.showProp;
        var children = this.state.children;
        if (showProp) {
          children = children.filter(function (child) {
            return !!child.props[showProp];
          });
        }
        children.forEach(function (child) {
          if (child) {
            _this2.performAppear(child.key);
          }
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this3 = this;
        this.nextProps = nextProps;
        var nextChildren = toArrayChildren(getChildrenFromProps(nextProps));
        var props = this.props;
        // exclusive needs immediate response
        if (props.exclusive) {
          Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
            _this3.stop(key);
          });
        }
        var showProp = props.showProp;
        var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
        // last props children if exclusive
        var currentChildren = props.exclusive ? toArrayChildren(getChildrenFromProps(props)) : this.state.children;
        // in case destroy in showProp mode
        var newChildren = [];
        if (showProp) {
          currentChildren.forEach(function (currentChild) {
            var nextChild = currentChild && findChildInChildrenByKey(nextChildren, currentChild.key);
            var newChild = void 0;
            if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
              newChild = external_react_default.a.cloneElement(nextChild || currentChild, defineProperty_default()({}, showProp, true));
            } else {
              newChild = nextChild;
            }
            if (newChild) {
              newChildren.push(newChild);
            }
          });
          nextChildren.forEach(function (nextChild) {
            if (!nextChild || !findChildInChildrenByKey(currentChildren, nextChild.key)) {
              newChildren.push(nextChild);
            }
          });
        } else {
          newChildren = mergeChildren(currentChildren, nextChildren);
        }

        // need render to avoid update
        this.setState({
          children: newChildren
        });
        nextChildren.forEach(function (child) {
          var key = child && child.key;
          if (child && currentlyAnimatingKeys[key]) {
            return;
          }
          var hasPrev = child && findChildInChildrenByKey(currentChildren, key);
          if (showProp) {
            var showInNext = child.props[showProp];
            if (hasPrev) {
              var showInNow = findShownChildInChildrenByKey(currentChildren, key, showProp);
              if (!showInNow && showInNext) {
                _this3.keysToEnter.push(key);
              }
            } else if (showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (!hasPrev) {
            _this3.keysToEnter.push(key);
          }
        });
        currentChildren.forEach(function (child) {
          var key = child && child.key;
          if (child && currentlyAnimatingKeys[key]) {
            return;
          }
          var hasNext = child && findChildInChildrenByKey(nextChildren, key);
          if (showProp) {
            var showInNow = child.props[showProp];
            if (hasNext) {
              var showInNext = findShownChildInChildrenByKey(nextChildren, key, showProp);
              if (!showInNext && showInNow) {
                _this3.keysToLeave.push(key);
              }
            } else if (showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (!hasNext) {
            _this3.keysToLeave.push(key);
          }
        });
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        var keysToEnter = this.keysToEnter;
        this.keysToEnter = [];
        keysToEnter.forEach(this.performEnter);
        var keysToLeave = this.keysToLeave;
        this.keysToLeave = [];
        keysToLeave.forEach(this.performLeave);
      }
    }, {
      key: 'isValidChildByKey',
      value: function isValidChildByKey(currentChildren, key) {
        var showProp = this.props.showProp;
        if (showProp) {
          return findShownChildInChildrenByKey(currentChildren, key, showProp);
        }
        return findChildInChildrenByKey(currentChildren, key);
      }
    }, {
      key: 'stop',
      value: function stop(key) {
        delete this.currentlyAnimatingKeys[key];
        var component = this.childrenRefs[key];
        if (component) {
          component.stop();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;
        var props = this.props;
        this.nextProps = props;
        var stateChildren = this.state.children;
        var children = null;
        if (stateChildren) {
          children = stateChildren.map(function (child) {
            if (child === null || child === undefined) {
              return child;
            }
            if (!child.key) {
              throw new Error('must set key for <rc-animate> children');
            }
            return external_react_default.a.createElement(es_AnimateChild, {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            }, child);
          });
        }
        var Component = props.component;
        if (Component) {
          var passedProps = props;
          if (typeof Component === 'string') {
            passedProps = extends_default()({
              className: props.className,
              style: props.style
            }, props.componentProps);
          }
          return external_react_default.a.createElement(Component, passedProps, children);
        }
        return children[0] || null;
      }
    }]);
    return Animate;
  }(external_react_default.a.Component);
  Animate_Animate.isAnimate = true;
  Animate_Animate.propTypes = {
    className: external_prop_types_default.a.string,
    style: external_prop_types_default.a.object,
    component: external_prop_types_default.a.any,
    componentProps: external_prop_types_default.a.object,
    animation: external_prop_types_default.a.object,
    transitionName: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object]),
    transitionEnter: external_prop_types_default.a.bool,
    transitionAppear: external_prop_types_default.a.bool,
    exclusive: external_prop_types_default.a.bool,
    transitionLeave: external_prop_types_default.a.bool,
    onEnd: external_prop_types_default.a.func,
    onEnter: external_prop_types_default.a.func,
    onLeave: external_prop_types_default.a.func,
    onAppear: external_prop_types_default.a.func,
    showProp: external_prop_types_default.a.string,
    children: external_prop_types_default.a.node
  };
  Animate_Animate.defaultProps = {
    animation: {},
    component: 'span',
    componentProps: {},
    transitionEnter: true,
    transitionLeave: true,
    transitionAppear: false,
    onEnd: Animate_noop,
    onEnter: Animate_noop,
    onLeave: Animate_noop,
    onAppear: Animate_noop
  };
  var Animate_initialiseProps = function _initialiseProps() {
    var _this5 = this;
    this.performEnter = function (key) {
      // may already remove by exclusive
      if (_this5.childrenRefs[key]) {
        _this5.currentlyAnimatingKeys[key] = true;
        _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
      }
    };
    this.performAppear = function (key) {
      if (_this5.childrenRefs[key]) {
        _this5.currentlyAnimatingKeys[key] = true;
        _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
      }
    };
    this.handleDoneAdding = function (key, type) {
      var props = _this5.props;
      delete _this5.currentlyAnimatingKeys[key];
      // if update on exclusive mode, skip check
      if (props.exclusive && props !== _this5.nextProps) {
        return;
      }
      var currentChildren = toArrayChildren(getChildrenFromProps(props));
      if (!_this5.isValidChildByKey(currentChildren, key)) {
        // exclusive will not need this
        _this5.performLeave(key);
      } else if (type === 'appear') {
        if (animate.allowAppearCallback(props)) {
          props.onAppear(key);
          props.onEnd(key, true);
        }
      } else if (animate.allowEnterCallback(props)) {
        props.onEnter(key);
        props.onEnd(key, true);
      }
    };
    this.performLeave = function (key) {
      // may already remove by exclusive
      if (_this5.childrenRefs[key]) {
        _this5.currentlyAnimatingKeys[key] = true;
        _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
      }
    };
    this.handleDoneLeaving = function (key) {
      var props = _this5.props;
      delete _this5.currentlyAnimatingKeys[key];
      // if update on exclusive mode, skip check
      if (props.exclusive && props !== _this5.nextProps) {
        return;
      }
      var currentChildren = toArrayChildren(getChildrenFromProps(props));
      // in case state change is too fast
      if (_this5.isValidChildByKey(currentChildren, key)) {
        _this5.performEnter(key);
      } else {
        var end = function end() {
          if (animate.allowLeaveCallback(props)) {
            props.onLeave(key);
            props.onEnd(key, false);
          }
        };
        if (!isSameChildren(_this5.state.children, currentChildren, props.showProp)) {
          _this5.setState({
            children: currentChildren
          }, end);
        } else {
          end();
        }
      }
    };
  };

  /* harmony default export */
  var es_Animate = es_unsafeLifecyclesPolyfill(Animate_Animate);
  // CONCATENATED MODULE: ./node_modules/rc-trigger/es/LazyRenderBox.js

  var LazyRenderBox_LazyRenderBox = function (_Component) {
    inherits_default()(LazyRenderBox, _Component);
    function LazyRenderBox() {
      classCallCheck_default()(this, LazyRenderBox);
      return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }
    LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return nextProps.hiddenClassName || nextProps.visible;
    };
    LazyRenderBox.prototype.render = function render() {
      var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = objectWithoutProperties_default()(_props, ['hiddenClassName', 'visible']);
      if (hiddenClassName || external_react_default.a.Children.count(props.children) > 1) {
        if (!visible && hiddenClassName) {
          props.className += ' ' + hiddenClassName;
        }
        return external_react_default.a.createElement('div', props);
      }
      return external_react_default.a.Children.only(props.children);
    };
    return LazyRenderBox;
  }(external_react_["Component"]);
  LazyRenderBox_LazyRenderBox.propTypes = {
    children: external_prop_types_default.a.any,
    className: external_prop_types_default.a.string,
    visible: external_prop_types_default.a.bool,
    hiddenClassName: external_prop_types_default.a.string
  };

  /* harmony default export */
  var es_LazyRenderBox = LazyRenderBox_LazyRenderBox;
  // CONCATENATED MODULE: ./node_modules/rc-trigger/es/PopupInner.js

  var PopupInner_PopupInner = function (_Component) {
    inherits_default()(PopupInner, _Component);
    function PopupInner() {
      classCallCheck_default()(this, PopupInner);
      return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }
    PopupInner.prototype.render = function render() {
      var props = this.props;
      var className = props.className;
      if (!props.visible) {
        className += ' ' + props.hiddenClassName;
      }
      return external_react_default.a.createElement('div', {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      }, external_react_default.a.createElement(es_LazyRenderBox, {
        className: props.prefixCls + '-content',
        visible: props.visible
      }, props.children));
    };
    return PopupInner;
  }(external_react_["Component"]);
  PopupInner_PopupInner.propTypes = {
    hiddenClassName: external_prop_types_default.a.string,
    className: external_prop_types_default.a.string,
    prefixCls: external_prop_types_default.a.string,
    onMouseEnter: external_prop_types_default.a.func,
    onMouseLeave: external_prop_types_default.a.func,
    onMouseDown: external_prop_types_default.a.func,
    onTouchStart: external_prop_types_default.a.func,
    children: external_prop_types_default.a.any
  };

  /* harmony default export */
  var es_PopupInner = PopupInner_PopupInner;
  // CONCATENATED MODULE: ./node_modules/rc-trigger/es/Popup.js

  var Popup_Popup = function (_Component) {
    inherits_default()(Popup, _Component);
    function Popup(props) {
      classCallCheck_default()(this, Popup);
      var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));
      Popup_initialiseProps.call(_this);
      _this.state = {
        // Used for stretch
        stretchChecked: false,
        targetWidth: undefined,
        targetHeight: undefined
      };
      _this.savePopupRef = saveRef.bind(_this, 'popupInstance');
      _this.saveAlignRef = saveRef.bind(_this, 'alignInstance');
      return _this;
    }
    Popup.prototype.componentDidMount = function componentDidMount() {
      this.rootNode = this.getPopupDomNode();
      this.setStretchSize();
    };
    Popup.prototype.componentDidUpdate = function componentDidUpdate() {
      this.setStretchSize();
    };

    // Record size if stretch needed

    Popup.prototype.getPopupDomNode = function getPopupDomNode() {
      return external_react_dom_default.a.findDOMNode(this.popupInstance);
    };

    // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align

    Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
      var props = this.props;
      var transitionName = props.maskTransitionName;
      var animation = props.maskAnimation;
      if (!transitionName && animation) {
        transitionName = props.prefixCls + '-' + animation;
      }
      return transitionName;
    };
    Popup.prototype.getTransitionName = function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    };
    Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
      return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
    };
    Popup.prototype.getPopupElement = function getPopupElement() {
      var _this2 = this;
      var savePopupRef = this.savePopupRef;
      var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
      var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;
      var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
      var hiddenClassName = prefixCls + '-hidden';
      if (!visible) {
        this.currentAlignClassName = null;
      }
      var sizeStyle = {};
      if (stretch) {
        // Stretch with target
        if (stretch.indexOf('height') !== -1) {
          sizeStyle.height = targetHeight;
        } else if (stretch.indexOf('minHeight') !== -1) {
          sizeStyle.minHeight = targetHeight;
        }
        if (stretch.indexOf('width') !== -1) {
          sizeStyle.width = targetWidth;
        } else if (stretch.indexOf('minWidth') !== -1) {
          sizeStyle.minWidth = targetWidth;
        }

        // Delay force align to makes ui smooth
        if (!stretchChecked) {
          sizeStyle.visibility = 'hidden';
          setTimeout(function () {
            if (_this2.alignInstance) {
              _this2.alignInstance.forceAlign();
            }
          }, 0);
        }
      }
      var newStyle = extends_default()({}, sizeStyle, style, this.getZIndexStyle());
      var popupInnerProps = {
        className: className,
        prefixCls: prefixCls,
        ref: savePopupRef,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseDown,
        onTouchStart: onTouchStart,
        style: newStyle
      };
      if (destroyPopupOnHide) {
        return external_react_default.a.createElement(es_Animate, {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        }, visible ? external_react_default.a.createElement(es, {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          align: align,
          onAlign: this.onAlign
        }, external_react_default.a.createElement(es_PopupInner, extends_default()({
          visible: true
        }, popupInnerProps), children)) : null);
      }
      return external_react_default.a.createElement(es_Animate, {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      }, external_react_default.a.createElement(es, {
        target: this.getAlignTarget(),
        key: 'popup',
        ref: this.saveAlignRef,
        monitorWindowResize: true,
        xVisible: visible,
        childrenProps: {
          visible: 'xVisible'
        },
        disabled: !visible,
        align: align,
        onAlign: this.onAlign
      }, external_react_default.a.createElement(es_PopupInner, extends_default()({
        hiddenClassName: hiddenClassName
      }, popupInnerProps), children)));
    };
    Popup.prototype.getZIndexStyle = function getZIndexStyle() {
      var style = {};
      var props = this.props;
      if (props.zIndex !== undefined) {
        style.zIndex = props.zIndex;
      }
      return style;
    };
    Popup.prototype.getMaskElement = function getMaskElement() {
      var props = this.props;
      var maskElement = void 0;
      if (props.mask) {
        var maskTransition = this.getMaskTransitionName();
        maskElement = external_react_default.a.createElement(es_LazyRenderBox, {
          style: this.getZIndexStyle(),
          key: 'mask',
          className: props.prefixCls + '-mask',
          hiddenClassName: props.prefixCls + '-mask-hidden',
          visible: props.visible
        });
        if (maskTransition) {
          maskElement = external_react_default.a.createElement(es_Animate, {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          }, maskElement);
        }
      }
      return maskElement;
    };
    Popup.prototype.render = function render() {
      return external_react_default.a.createElement('div', null, this.getMaskElement(), this.getPopupElement());
    };
    return Popup;
  }(external_react_["Component"]);
  Popup_Popup.propTypes = {
    visible: external_prop_types_default.a.bool,
    style: external_prop_types_default.a.object,
    getClassNameFromAlign: external_prop_types_default.a.func,
    onAlign: external_prop_types_default.a.func,
    getRootDomNode: external_prop_types_default.a.func,
    align: external_prop_types_default.a.any,
    destroyPopupOnHide: external_prop_types_default.a.bool,
    className: external_prop_types_default.a.string,
    prefixCls: external_prop_types_default.a.string,
    onMouseEnter: external_prop_types_default.a.func,
    onMouseLeave: external_prop_types_default.a.func,
    onMouseDown: external_prop_types_default.a.func,
    onTouchStart: external_prop_types_default.a.func,
    stretch: external_prop_types_default.a.string,
    children: external_prop_types_default.a.node,
    point: external_prop_types_default.a.shape({
      pageX: external_prop_types_default.a.number,
      pageY: external_prop_types_default.a.number
    })
  };
  var Popup_initialiseProps = function _initialiseProps() {
    var _this3 = this;
    this.onAlign = function (popupDomNode, align) {
      var props = _this3.props;
      var currentAlignClassName = props.getClassNameFromAlign(align);
      // FIX: https://github.com/react-component/trigger/issues/56
      // FIX: https://github.com/react-component/tooltip/issues/79
      if (_this3.currentAlignClassName !== currentAlignClassName) {
        _this3.currentAlignClassName = currentAlignClassName;
        popupDomNode.className = _this3.getClassName(currentAlignClassName);
      }
      props.onAlign(popupDomNode, align);
    };
    this.setStretchSize = function () {
      var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
      var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;
      if (!stretch || !visible) {
        if (stretchChecked) {
          _this3.setState({
            stretchChecked: false
          });
        }
        return;
      }
      var $ele = getRootDomNode();
      if (!$ele) return;
      var height = $ele.offsetHeight;
      var width = $ele.offsetWidth;
      if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
        _this3.setState({
          stretchChecked: true,
          targetHeight: height,
          targetWidth: width
        });
      }
    };
    this.getTargetElement = function () {
      return _this3.props.getRootDomNode();
    };
    this.getAlignTarget = function () {
      var point = _this3.props.point;
      if (point) {
        return point;
      }
      return _this3.getTargetElement;
    };
  };

  /* harmony default export */
  var es_Popup = Popup_Popup;
  // CONCATENATED MODULE: ./node_modules/rc-trigger/es/index.js

  function es_noop() {}
  function returnEmptyString() {
    return '';
  }
  function returnDocument() {
    return window.document;
  }
  var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
  var IS_REACT_16 = !!external_react_dom_["createPortal"];
  var contextTypes = {
    rcTrigger: external_prop_types_default.a.shape({
      onPopupMouseDown: external_prop_types_default.a.func
    })
  };
  var es_Trigger = function (_React$Component) {
    inherits_default()(Trigger, _React$Component);
    function Trigger(props) {
      classCallCheck_default()(this, Trigger);
      var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));
      es_initialiseProps.call(_this);
      var popupVisible = void 0;
      if ('popupVisible' in props) {
        popupVisible = !!props.popupVisible;
      } else {
        popupVisible = !!props.defaultPopupVisible;
      }
      _this.state = {
        prevPopupVisible: popupVisible,
        popupVisible: popupVisible
      };
      ALL_HANDLERS.forEach(function (h) {
        _this['fire' + h] = function (e) {
          _this.fireEvents(h, e);
        };
      });
      return _this;
    }
    Trigger.prototype.getChildContext = function getChildContext() {
      return {
        rcTrigger: {
          onPopupMouseDown: this.onPopupMouseDown
        }
      };
    };
    Trigger.prototype.componentDidMount = function componentDidMount() {
      this.componentDidUpdate({}, {
        popupVisible: this.state.popupVisible
      });
    };
    Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
      var props = this.props;
      var state = this.state;
      var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
        if (prevState.popupVisible !== state.popupVisible) {
          props.afterPopupVisibleChange(state.popupVisible);
        }
      };
      if (!IS_REACT_16) {
        this.renderComponent(null, triggerAfterPopupVisibleChange);
      }

      // We must listen to `mousedown` or `touchstart`, edge case:
      // https://github.com/ant-design/ant-design/issues/5804
      // https://github.com/react-component/calendar/issues/250
      // https://github.com/react-component/trigger/issues/50
      if (state.popupVisible) {
        var currentDocument = void 0;
        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
          currentDocument = props.getDocument();
          this.clickOutsideHandler = addEventListenerWrap(currentDocument, 'mousedown', this.onDocumentClick);
        }
        // always hide on mobile
        if (!this.touchOutsideHandler) {
          currentDocument = currentDocument || props.getDocument();
          this.touchOutsideHandler = addEventListenerWrap(currentDocument, 'touchstart', this.onDocumentClick);
        }
        // close popup when trigger type contains 'onContextMenu' and document is scrolling.
        if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
          currentDocument = currentDocument || props.getDocument();
          this.contextMenuOutsideHandler1 = addEventListenerWrap(currentDocument, 'scroll', this.onContextMenuClose);
        }
        // close popup when trigger type contains 'onContextMenu' and window is blur.
        if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
          this.contextMenuOutsideHandler2 = addEventListenerWrap(window, 'blur', this.onContextMenuClose);
        }
        return;
      }
      this.clearOutsideHandler();
    };
    Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
      this.clearDelayTimer();
      this.clearOutsideHandler();
      clearTimeout(this.mouseDownTimeout);
    };
    Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
      var popupVisible = _ref.popupVisible;
      var newState = {};
      if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
        newState.popupVisible = popupVisible;
        newState.prevPopupVisible = prevState.popupVisible;
      }
      return newState;
    };
    Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
      // for test
      if (this._component && this._component.getPopupDomNode) {
        return this._component.getPopupDomNode();
      }
      return null;
    };
    Trigger.prototype.getPopupAlign = function getPopupAlign() {
      var props = this.props;
      var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;
      if (popupPlacement && builtinPlacements) {
        return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
      }
      return popupAlign;
    };

    /**
     * @param popupVisible    Show or not the popup element
     * @param event           SyntheticEvent, used for `pointAlign`
     */
    Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
      var alignPoint = this.props.alignPoint;
      var prevPopupVisible = this.state.popupVisible;
      this.clearDelayTimer();
      if (prevPopupVisible !== popupVisible) {
        if (!('popupVisible' in this.props)) {
          this.setState({
            popupVisible: popupVisible,
            prevPopupVisible: prevPopupVisible
          });
        }
        this.props.onPopupVisibleChange(popupVisible);
      }

      // Always record the point position since mouseEnterDelay will delay the show
      if (alignPoint && event) {
        this.setPoint(event);
      }
    };
    Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
      var _this2 = this;
      var delay = delayS * 1000;
      this.clearDelayTimer();
      if (delay) {
        var point = event ? {
          pageX: event.pageX,
          pageY: event.pageY
        } : null;
        this.delayTimer = setTimeout(function () {
          _this2.setPopupVisible(visible, point);
          _this2.clearDelayTimer();
        }, delay);
      } else {
        this.setPopupVisible(visible, event);
      }
    };
    Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
      if (this.delayTimer) {
        clearTimeout(this.delayTimer);
        this.delayTimer = null;
      }
    };
    Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
      if (this.clickOutsideHandler) {
        this.clickOutsideHandler.remove();
        this.clickOutsideHandler = null;
      }
      if (this.contextMenuOutsideHandler1) {
        this.contextMenuOutsideHandler1.remove();
        this.contextMenuOutsideHandler1 = null;
      }
      if (this.contextMenuOutsideHandler2) {
        this.contextMenuOutsideHandler2.remove();
        this.contextMenuOutsideHandler2 = null;
      }
      if (this.touchOutsideHandler) {
        this.touchOutsideHandler.remove();
        this.touchOutsideHandler = null;
      }
    };
    Trigger.prototype.createTwoChains = function createTwoChains(event) {
      var childPros = this.props.children.props;
      var props = this.props;
      if (childPros[event] && props[event]) {
        return this['fire' + event];
      }
      return childPros[event] || props[event];
    };
    Trigger.prototype.isClickToShow = function isClickToShow() {
      var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;
      return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
    };
    Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
      var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;
      return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
    };
    Trigger.prototype.isClickToHide = function isClickToHide() {
      var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;
      return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
    };
    Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
      var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;
      return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
    };
    Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
      var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;
      return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
    };
    Trigger.prototype.isFocusToShow = function isFocusToShow() {
      var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;
      return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
    };
    Trigger.prototype.isBlurToHide = function isBlurToHide() {
      var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;
      return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
    };
    Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
      if (this.state.popupVisible && this._component && this._component.alignInstance) {
        this._component.alignInstance.forceAlign();
      }
    };
    Trigger.prototype.fireEvents = function fireEvents(type, e) {
      var childCallback = this.props.children.props[type];
      if (childCallback) {
        childCallback(e);
      }
      var callback = this.props[type];
      if (callback) {
        callback(e);
      }
    };
    Trigger.prototype.close = function close() {
      this.setPopupVisible(false);
    };
    Trigger.prototype.render = function render() {
      var _this3 = this;
      var popupVisible = this.state.popupVisible;
      var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;
      var child = external_react_default.a.Children.only(children);
      var newChildProps = {
        key: 'trigger'
      };
      if (this.isContextMenuToShow()) {
        newChildProps.onContextMenu = this.onContextMenu;
      } else {
        newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
      }
      if (this.isClickToHide() || this.isClickToShow()) {
        newChildProps.onClick = this.onClick;
        newChildProps.onMouseDown = this.onMouseDown;
        newChildProps.onTouchStart = this.onTouchStart;
      } else {
        newChildProps.onClick = this.createTwoChains('onClick');
        newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
        newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
      }
      if (this.isMouseEnterToShow()) {
        newChildProps.onMouseEnter = this.onMouseEnter;
        if (alignPoint) {
          newChildProps.onMouseMove = this.onMouseMove;
        }
      } else {
        newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
      }
      if (this.isMouseLeaveToHide()) {
        newChildProps.onMouseLeave = this.onMouseLeave;
      } else {
        newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
      }
      if (this.isFocusToShow() || this.isBlurToHide()) {
        newChildProps.onFocus = this.onFocus;
        newChildProps.onBlur = this.onBlur;
      } else {
        newChildProps.onFocus = this.createTwoChains('onFocus');
        newChildProps.onBlur = this.createTwoChains('onBlur');
      }
      var childrenClassName = classnames_default()(child && child.props && child.props.className, className);
      if (childrenClassName) {
        newChildProps.className = childrenClassName;
      }
      var trigger = external_react_default.a.cloneElement(child, newChildProps);
      if (!IS_REACT_16) {
        return external_react_default.a.createElement(ContainerRender_ContainerRender, {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        }, function (_ref2) {
          var renderComponent = _ref2.renderComponent;
          _this3.renderComponent = renderComponent;
          return trigger;
        });
      }
      var portal = void 0;
      // prevent unmounting after it's rendered
      if (popupVisible || this._component || forceRender) {
        portal = external_react_default.a.createElement(Portal_Portal, {
          key: 'portal',
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        }, this.getComponent());
      }
      return [trigger, portal];
    };
    return Trigger;
  }(external_react_default.a.Component);
  es_Trigger.propTypes = {
    children: external_prop_types_default.a.any,
    action: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.arrayOf(external_prop_types_default.a.string)]),
    showAction: external_prop_types_default.a.any,
    hideAction: external_prop_types_default.a.any,
    getPopupClassNameFromAlign: external_prop_types_default.a.any,
    onPopupVisibleChange: external_prop_types_default.a.func,
    afterPopupVisibleChange: external_prop_types_default.a.func,
    popup: external_prop_types_default.a.oneOfType([external_prop_types_default.a.node, external_prop_types_default.a.func]).isRequired,
    popupStyle: external_prop_types_default.a.object,
    prefixCls: external_prop_types_default.a.string,
    popupClassName: external_prop_types_default.a.string,
    className: external_prop_types_default.a.string,
    popupPlacement: external_prop_types_default.a.string,
    builtinPlacements: external_prop_types_default.a.object,
    popupTransitionName: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object]),
    popupAnimation: external_prop_types_default.a.any,
    mouseEnterDelay: external_prop_types_default.a.number,
    mouseLeaveDelay: external_prop_types_default.a.number,
    zIndex: external_prop_types_default.a.number,
    focusDelay: external_prop_types_default.a.number,
    blurDelay: external_prop_types_default.a.number,
    getPopupContainer: external_prop_types_default.a.func,
    getDocument: external_prop_types_default.a.func,
    forceRender: external_prop_types_default.a.bool,
    destroyPopupOnHide: external_prop_types_default.a.bool,
    mask: external_prop_types_default.a.bool,
    maskClosable: external_prop_types_default.a.bool,
    onPopupAlign: external_prop_types_default.a.func,
    popupAlign: external_prop_types_default.a.object,
    popupVisible: external_prop_types_default.a.bool,
    defaultPopupVisible: external_prop_types_default.a.bool,
    maskTransitionName: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object]),
    maskAnimation: external_prop_types_default.a.string,
    stretch: external_prop_types_default.a.string,
    alignPoint: external_prop_types_default.a.bool // Maybe we can support user pass position in the future
  };

  es_Trigger.contextTypes = contextTypes;
  es_Trigger.childContextTypes = contextTypes;
  es_Trigger.defaultProps = {
    prefixCls: 'rc-trigger-popup',
    getPopupClassNameFromAlign: returnEmptyString,
    getDocument: returnDocument,
    onPopupVisibleChange: es_noop,
    afterPopupVisibleChange: es_noop,
    onPopupAlign: es_noop,
    popupClassName: '',
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: false,
    popupAlign: {},
    defaultPopupVisible: false,
    mask: false,
    maskClosable: true,
    action: [],
    showAction: [],
    hideAction: []
  };
  var es_initialiseProps = function _initialiseProps() {
    var _this4 = this;
    this.onMouseEnter = function (e) {
      var mouseEnterDelay = _this4.props.mouseEnterDelay;
      _this4.fireEvents('onMouseEnter', e);
      _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
    };
    this.onMouseMove = function (e) {
      _this4.fireEvents('onMouseMove', e);
      _this4.setPoint(e);
    };
    this.onMouseLeave = function (e) {
      _this4.fireEvents('onMouseLeave', e);
      _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
    };
    this.onPopupMouseEnter = function () {
      _this4.clearDelayTimer();
    };
    this.onPopupMouseLeave = function (e) {
      // https://github.com/react-component/trigger/pull/13
      // react bug?
      if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && contains(_this4._component.getPopupDomNode(), e.relatedTarget)) {
        return;
      }
      _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
    };
    this.onFocus = function (e) {
      _this4.fireEvents('onFocus', e);
      // incase focusin and focusout
      _this4.clearDelayTimer();
      if (_this4.isFocusToShow()) {
        _this4.focusTime = Date.now();
        _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
      }
    };
    this.onMouseDown = function (e) {
      _this4.fireEvents('onMouseDown', e);
      _this4.preClickTime = Date.now();
    };
    this.onTouchStart = function (e) {
      _this4.fireEvents('onTouchStart', e);
      _this4.preTouchTime = Date.now();
    };
    this.onBlur = function (e) {
      _this4.fireEvents('onBlur', e);
      _this4.clearDelayTimer();
      if (_this4.isBlurToHide()) {
        _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
      }
    };
    this.onContextMenu = function (e) {
      e.preventDefault();
      _this4.fireEvents('onContextMenu', e);
      _this4.setPopupVisible(true, e);
    };
    this.onContextMenuClose = function () {
      if (_this4.isContextMenuToShow()) {
        _this4.close();
      }
    };
    this.onClick = function (event) {
      _this4.fireEvents('onClick', event);
      // focus will trigger click
      if (_this4.focusTime) {
        var preTime = void 0;
        if (_this4.preClickTime && _this4.preTouchTime) {
          preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
        } else if (_this4.preClickTime) {
          preTime = _this4.preClickTime;
        } else if (_this4.preTouchTime) {
          preTime = _this4.preTouchTime;
        }
        if (Math.abs(preTime - _this4.focusTime) < 20) {
          return;
        }
        _this4.focusTime = 0;
      }
      _this4.preClickTime = 0;
      _this4.preTouchTime = 0;

      // Only prevent default when all the action is click.
      // https://github.com/ant-design/ant-design/issues/17043
      // https://github.com/ant-design/ant-design/issues/17291
      if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
        event.preventDefault();
      }
      var nextVisible = !_this4.state.popupVisible;
      if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
        _this4.setPopupVisible(!_this4.state.popupVisible, event);
      }
    };
    this.onPopupMouseDown = function () {
      var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;
      _this4.hasPopupMouseDown = true;
      clearTimeout(_this4.mouseDownTimeout);
      _this4.mouseDownTimeout = setTimeout(function () {
        _this4.hasPopupMouseDown = false;
      }, 0);
      if (rcTrigger.onPopupMouseDown) {
        rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
      }
    };
    this.onDocumentClick = function (event) {
      if (_this4.props.mask && !_this4.props.maskClosable) {
        return;
      }
      var target = event.target;
      var root = Object(external_react_dom_["findDOMNode"])(_this4);
      if (!contains(root, target) && !_this4.hasPopupMouseDown) {
        _this4.close();
      }
    };
    this.getRootDomNode = function () {
      return Object(external_react_dom_["findDOMNode"])(_this4);
    };
    this.getPopupClassNameFromAlign = function (align) {
      var className = [];
      var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;
      if (popupPlacement && builtinPlacements) {
        className.push(getAlignPopupClassName(builtinPlacements, prefixCls, align, alignPoint));
      }
      if (getPopupClassNameFromAlign) {
        className.push(getPopupClassNameFromAlign(align));
      }
      return className.join(' ');
    };
    this.getComponent = function () {
      var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
      var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;
      var align = _this4.getPopupAlign();
      var mouseProps = {};
      if (_this4.isMouseEnterToShow()) {
        mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
      }
      if (_this4.isMouseLeaveToHide()) {
        mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
      }
      mouseProps.onMouseDown = _this4.onPopupMouseDown;
      mouseProps.onTouchStart = _this4.onPopupMouseDown;
      return external_react_default.a.createElement(es_Popup, extends_default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }), typeof popup === 'function' ? popup() : popup);
    };
    this.getContainer = function () {
      var props = _this4.props;
      var popupContainer = document.createElement('div');
      // Make sure default popup container will never cause scrollbar appearing
      // https://github.com/react-component/trigger/issues/41
      popupContainer.style.position = 'absolute';
      popupContainer.style.top = '0';
      popupContainer.style.left = '0';
      popupContainer.style.width = '100%';
      var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(external_react_dom_["findDOMNode"])(_this4)) : props.getDocument().body;
      mountNode.appendChild(popupContainer);
      return popupContainer;
    };
    this.setPoint = function (point) {
      var alignPoint = _this4.props.alignPoint;
      if (!alignPoint || !point) return;
      _this4.setState({
        point: {
          pageX: point.pageX,
          pageY: point.pageY
        }
      });
    };
    this.handlePortalUpdate = function () {
      if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
        _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
      }
    };
    this.savePopup = function (node) {
      _this4._component = node;
    };
  };
  Object(react_lifecycles_compat_es["polyfill"])(es_Trigger);

  /* harmony default export */
  var rc_trigger_es = es_Trigger;
  // CONCATENATED MODULE: ./node_modules/rc-tooltip/es/placements.js
  var autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
  };
  var targetOffset = [0, 0];
  var placements = {
    left: {
      points: ['cr', 'cl'],
      overflow: autoAdjustOverflow,
      offset: [-4, 0],
      targetOffset: targetOffset
    },
    right: {
      points: ['cl', 'cr'],
      overflow: autoAdjustOverflow,
      offset: [4, 0],
      targetOffset: targetOffset
    },
    top: {
      points: ['bc', 'tc'],
      overflow: autoAdjustOverflow,
      offset: [0, -4],
      targetOffset: targetOffset
    },
    bottom: {
      points: ['tc', 'bc'],
      overflow: autoAdjustOverflow,
      offset: [0, 4],
      targetOffset: targetOffset
    },
    topLeft: {
      points: ['bl', 'tl'],
      overflow: autoAdjustOverflow,
      offset: [0, -4],
      targetOffset: targetOffset
    },
    leftTop: {
      points: ['tr', 'tl'],
      overflow: autoAdjustOverflow,
      offset: [-4, 0],
      targetOffset: targetOffset
    },
    topRight: {
      points: ['br', 'tr'],
      overflow: autoAdjustOverflow,
      offset: [0, -4],
      targetOffset: targetOffset
    },
    rightTop: {
      points: ['tl', 'tr'],
      overflow: autoAdjustOverflow,
      offset: [4, 0],
      targetOffset: targetOffset
    },
    bottomRight: {
      points: ['tr', 'br'],
      overflow: autoAdjustOverflow,
      offset: [0, 4],
      targetOffset: targetOffset
    },
    rightBottom: {
      points: ['bl', 'br'],
      overflow: autoAdjustOverflow,
      offset: [4, 0],
      targetOffset: targetOffset
    },
    bottomLeft: {
      points: ['tl', 'bl'],
      overflow: autoAdjustOverflow,
      offset: [0, 4],
      targetOffset: targetOffset
    },
    leftBottom: {
      points: ['br', 'bl'],
      overflow: autoAdjustOverflow,
      offset: [-4, 0],
      targetOffset: targetOffset
    }
  };

  /* harmony default export */
  var es_placements = placements;
  // CONCATENATED MODULE: ./node_modules/rc-tooltip/es/Content.js

  var Content_Content = function (_React$Component) {
    inherits_default()(Content, _React$Component);
    function Content() {
      classCallCheck_default()(this, Content);
      return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
    }
    Content.prototype.componentDidUpdate = function componentDidUpdate() {
      var trigger = this.props.trigger;
      if (trigger) {
        trigger.forcePopupAlign();
      }
    };
    Content.prototype.render = function render() {
      var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;
      return external_react_default.a.createElement('div', {
        className: prefixCls + '-inner',
        id: id,
        role: 'tooltip'
      }, typeof overlay === 'function' ? overlay() : overlay);
    };
    return Content;
  }(external_react_default.a.Component);
  Content_Content.propTypes = {
    prefixCls: external_prop_types_default.a.string,
    overlay: external_prop_types_default.a.oneOfType([external_prop_types_default.a.node, external_prop_types_default.a.func]).isRequired,
    id: external_prop_types_default.a.string,
    trigger: external_prop_types_default.a.any
  };
  /* harmony default export */
  var es_Content = Content_Content;
  // CONCATENATED MODULE: ./node_modules/rc-tooltip/es/Tooltip.js

  var Tooltip_Tooltip = function (_Component) {
    inherits_default()(Tooltip, _Component);
    function Tooltip() {
      var _temp, _this, _ret;
      classCallCheck_default()(this, Tooltip);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
        var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;
        return [external_react_default.a.createElement('div', {
          className: prefixCls + '-arrow',
          key: 'arrow'
        }, arrowContent), external_react_default.a.createElement(es_Content, {
          key: 'content',
          trigger: _this.trigger,
          prefixCls: prefixCls,
          id: id,
          overlay: overlay
        })];
      }, _this.saveTrigger = function (node) {
        _this.trigger = node;
      }, _temp), possibleConstructorReturn_default()(_this, _ret);
    }
    Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
      return this.trigger.getPopupDomNode();
    };
    Tooltip.prototype.render = function render() {
      var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = objectWithoutProperties_default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
      var extraProps = extends_default()({}, restProps);
      if ('visible' in this.props) {
        extraProps.popupVisible = this.props.visible;
      }
      return external_react_default.a.createElement(rc_trigger_es, extends_default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: placements,
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps), children);
    };
    return Tooltip;
  }(external_react_["Component"]);
  Tooltip_Tooltip.propTypes = {
    trigger: external_prop_types_default.a.any,
    children: external_prop_types_default.a.any,
    defaultVisible: external_prop_types_default.a.bool,
    visible: external_prop_types_default.a.bool,
    placement: external_prop_types_default.a.string,
    transitionName: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.object]),
    animation: external_prop_types_default.a.any,
    onVisibleChange: external_prop_types_default.a.func,
    afterVisibleChange: external_prop_types_default.a.func,
    overlay: external_prop_types_default.a.oneOfType([external_prop_types_default.a.node, external_prop_types_default.a.func]).isRequired,
    overlayStyle: external_prop_types_default.a.object,
    overlayClassName: external_prop_types_default.a.string,
    prefixCls: external_prop_types_default.a.string,
    mouseEnterDelay: external_prop_types_default.a.number,
    mouseLeaveDelay: external_prop_types_default.a.number,
    getTooltipContainer: external_prop_types_default.a.func,
    destroyTooltipOnHide: external_prop_types_default.a.bool,
    align: external_prop_types_default.a.object,
    arrowContent: external_prop_types_default.a.any,
    id: external_prop_types_default.a.string
  };
  Tooltip_Tooltip.defaultProps = {
    prefixCls: 'rc-tooltip',
    mouseEnterDelay: 0,
    destroyTooltipOnHide: false,
    mouseLeaveDelay: 0.1,
    align: {},
    placement: 'right',
    trigger: ['hover'],
    arrowContent: null
  };

  /* harmony default export */
  var es_Tooltip = Tooltip_Tooltip;
  // CONCATENATED MODULE: ./node_modules/rc-tooltip/es/index.js

  /* harmony default export */
  var rc_tooltip_es = es_Tooltip;
  // CONCATENATED MODULE: ./node_modules/rc-slider/es/createSliderWithTooltip.js

  function createSliderWithTooltip(Component) {
    var _class, _temp2;
    return _temp2 = _class = function (_React$Component) {
      inherits_default()(ComponentWrapper, _React$Component);
      function ComponentWrapper() {
        var _ref;
        var _temp, _this, _ret;
        classCallCheck_default()(this, ComponentWrapper);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          visibles: {}
        }, _this.handleTooltipVisibleChange = function (index, visible) {
          _this.setState(function (prevState) {
            return {
              visibles: extends_default()({}, prevState.visibles, defineProperty_default()({}, index, visible))
            };
          });
        }, _this.handleWithTooltip = function (_ref2) {
          var value = _ref2.value,
            dragging = _ref2.dragging,
            index = _ref2.index,
            disabled = _ref2.disabled,
            restProps = objectWithoutProperties_default()(_ref2, ['value', 'dragging', 'index', 'disabled']);
          var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle;
          var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === undefined ? 'rc-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === undefined ? 'top' : _tipProps$placement,
            _tipProps$visible = tipProps.visible,
            visible = _tipProps$visible === undefined ? false : _tipProps$visible,
            restTooltipProps = objectWithoutProperties_default()(tipProps, ['prefixCls', 'overlay', 'placement', 'visible']);
          var handleStyleWithIndex = void 0;
          if (Array.isArray(handleStyle)) {
            handleStyleWithIndex = handleStyle[index] || handleStyle[0];
          } else {
            handleStyleWithIndex = handleStyle;
          }
          return external_react_default.a.createElement(rc_tooltip_es, extends_default()({}, restTooltipProps, {
            prefixCls: prefixCls,
            overlay: overlay,
            placement: placement,
            visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
            key: index
          }), external_react_default.a.createElement(es_Handle, extends_default()({}, restProps, {
            style: extends_default()({}, handleStyleWithIndex),
            value: value,
            onMouseEnter: function onMouseEnter() {
              return _this.handleTooltipVisibleChange(index, true);
            },
            onMouseLeave: function onMouseLeave() {
              return _this.handleTooltipVisibleChange(index, false);
            }
          })));
        }, _temp), possibleConstructorReturn_default()(_this, _ret);
      }
      createClass_default()(ComponentWrapper, [{
        key: 'render',
        value: function render() {
          return external_react_default.a.createElement(Component, extends_default()({}, this.props, {
            handle: this.handleWithTooltip
          }));
        }
      }]);
      return ComponentWrapper;
    }(external_react_default.a.Component), _class.propTypes = {
      tipFormatter: external_prop_types_default.a.func,
      handleStyle: external_prop_types_default.a.oneOfType([external_prop_types_default.a.object, external_prop_types_default.a.arrayOf(external_prop_types_default.a.object)]),
      tipProps: external_prop_types_default.a.object
    }, _class.defaultProps = {
      tipFormatter: function tipFormatter(value) {
        return value;
      },
      handleStyle: [{}],
      tipProps: {}
    }, _temp2;
  }
  // CONCATENATED MODULE: ./node_modules/rc-slider/es/index.js

  es_Slider.Range = es_Range;
  es_Slider.Handle = es_Handle;
  es_Slider.createSliderWithTooltip = createSliderWithTooltip;
  /* harmony default export */
  var rc_slider_es = __webpack_exports__["default"] = es_Slider;

  /***/
}
/******/]);